(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Coveo__temporary"] = factory();
	else
		root["Coveo__temporary"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/js/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(2));
	__export(__webpack_require__(29));
	__export(__webpack_require__(35));
	__export(__webpack_require__(38));
	__export(__webpack_require__(53));
	__export(__webpack_require__(73));
	__export(__webpack_require__(89));
	__export(__webpack_require__(93));
	__export(__webpack_require__(121));
	// UI
	var CoreHelpers_1 = __webpack_require__(123);
	exports.CoreHelpers = CoreHelpers_1.CoreHelpers;
	var SearchInterface_1 = __webpack_require__(97);
	exports.SearchInterface = SearchInterface_1.SearchInterface;
	exports.StandaloneSearchInterface = SearchInterface_1.StandaloneSearchInterface;
	var Aggregate_1 = __webpack_require__(130);
	exports.Aggregate = Aggregate_1.Aggregate;
	var Analytics_1 = __webpack_require__(111);
	exports.Analytics = Analytics_1.Analytics;
	var PendingSearchEvent_1 = __webpack_require__(113);
	exports.PendingSearchEvent = PendingSearchEvent_1.PendingSearchEvent;
	var PendingSearchAsYouTypeSearchEvent_1 = __webpack_require__(115);
	exports.PendingSearchAsYouTypeSearchEvent = PendingSearchAsYouTypeSearchEvent_1.PendingSearchAsYouTypeSearchEvent;
	var AnalyticsActionListMeta_1 = __webpack_require__(110);
	exports.analyticsActionCauseList = AnalyticsActionListMeta_1.analyticsActionCauseList;
	var NoopAnalyticsClient_1 = __webpack_require__(105);
	exports.NoopAnalyticsClient = NoopAnalyticsClient_1.NoopAnalyticsClient;
	var LiveAnalyticsClient_1 = __webpack_require__(112);
	exports.LiveAnalyticsClient = LiveAnalyticsClient_1.LiveAnalyticsClient;
	var RecommendationAnalyticsClient_1 = __webpack_require__(119);
	exports.RecommendationAnalyticsClient = RecommendationAnalyticsClient_1.RecommendationAnalyticsClient;
	var MultiAnalyticsClient_1 = __webpack_require__(116);
	exports.MultiAnalyticsClient = MultiAnalyticsClient_1.MultiAnalyticsClient;
	var Querybox_1 = __webpack_require__(131);
	exports.Querybox = Querybox_1.Querybox;
	var SearchButton_1 = __webpack_require__(133);
	exports.SearchButton = SearchButton_1.SearchButton;
	var Searchbox_1 = __webpack_require__(134);
	exports.Searchbox = Searchbox_1.Searchbox;
	var Breadcrumb_1 = __webpack_require__(140);
	exports.Breadcrumb = Breadcrumb_1.Breadcrumb;
	var Facet_1 = __webpack_require__(141);
	exports.Facet = Facet_1.Facet;
	var FacetHeader_1 = __webpack_require__(153);
	exports.FacetHeader = FacetHeader_1.FacetHeader;
	var FacetSearchValuesList_1 = __webpack_require__(156);
	exports.FacetSearchValuesList = FacetSearchValuesList_1.FacetSearchValuesList;
	var FacetSettings_1 = __webpack_require__(150);
	exports.FacetSettings = FacetSettings_1.FacetSettings;
	var FacetSort_1 = __webpack_require__(151);
	exports.FacetSort = FacetSort_1.FacetSort;
	var FacetUtils_1 = __webpack_require__(82);
	exports.FacetUtils = FacetUtils_1.FacetUtils;
	var FacetValueElement_1 = __webpack_require__(145);
	exports.FacetValueElement = FacetValueElement_1.FacetValueElement;
	var FacetValues_1 = __webpack_require__(142);
	exports.FacetValue = FacetValues_1.FacetValue;
	exports.FacetValues = FacetValues_1.FacetValues;
	var ValueElementRenderer_1 = __webpack_require__(147);
	exports.ValueElementRenderer = ValueElementRenderer_1.ValueElementRenderer;
	var FacetSearch_1 = __webpack_require__(143);
	exports.FacetSearch = FacetSearch_1.FacetSearch;
	var FacetSearchParameters_1 = __webpack_require__(81);
	exports.FacetSearchParameters = FacetSearchParameters_1.FacetSearchParameters;
	var Slider_1 = __webpack_require__(164);
	exports.Slider = Slider_1.Slider;
	var FacetSlider_1 = __webpack_require__(163);
	exports.FacetSlider = FacetSlider_1.FacetSlider;
	var FacetRange_1 = __webpack_require__(174);
	exports.FacetRange = FacetRange_1.FacetRange;
	var Pager_1 = __webpack_require__(175);
	exports.Pager = Pager_1.Pager;
	var ResultsPerPage_1 = __webpack_require__(176);
	exports.ResultsPerPage = ResultsPerPage_1.ResultsPerPage;
	var ResultList_1 = __webpack_require__(128);
	exports.ResultList = ResultList_1.ResultList;
	var DefaultRecommendationTemplate_1 = __webpack_require__(129);
	exports.DefaultRecommendationTemplate = DefaultRecommendationTemplate_1.DefaultRecommendationTemplate;
	var Excerpt_1 = __webpack_require__(177);
	exports.Excerpt = Excerpt_1.Excerpt;
	var ResultLink_1 = __webpack_require__(178);
	exports.ResultLink = ResultLink_1.ResultLink;
	var Icon_1 = __webpack_require__(124);
	exports.Icon = Icon_1.Icon;
	var Thumbnail_1 = __webpack_require__(179);
	exports.Thumbnail = Thumbnail_1.Thumbnail;
	var PrintableUri_1 = __webpack_require__(182);
	exports.PrintableUri = PrintableUri_1.PrintableUri;
	var Quickview_1 = __webpack_require__(125);
	exports.Quickview = Quickview_1.Quickview;
	var DidYouMean_1 = __webpack_require__(183);
	exports.DidYouMean = DidYouMean_1.DidYouMean;
	var ErrorReport_1 = __webpack_require__(184);
	exports.ErrorReport = ErrorReport_1.ErrorReport;
	var ExportToExcel_1 = __webpack_require__(185);
	exports.ExportToExcel = ExportToExcel_1.ExportToExcel;
	var Folding_1 = __webpack_require__(186);
	exports.Folding = Folding_1.Folding;
	var HiddenQuery_1 = __webpack_require__(188);
	exports.HiddenQuery = HiddenQuery_1.HiddenQuery;
	var HierarchicalFacet_1 = __webpack_require__(189);
	exports.HierarchicalFacet = HierarchicalFacet_1.HierarchicalFacet;
	var Matrix_1 = __webpack_require__(199);
	exports.Matrix = Matrix_1.Matrix;
	var QuickviewDocument_1 = __webpack_require__(127);
	exports.QuickviewDocument = QuickviewDocument_1.QuickviewDocument;
	var YouTubeThumbnail_1 = __webpack_require__(202);
	exports.YouTubeThumbnail = YouTubeThumbnail_1.YouTubeThumbnail;
	var ResultAttachments_1 = __webpack_require__(203);
	exports.ResultAttachments = ResultAttachments_1.ResultAttachments;
	var ResultFolding_1 = __webpack_require__(205);
	exports.ResultFolding = ResultFolding_1.ResultFolding;
	var FieldTable_1 = __webpack_require__(180);
	exports.FieldTable = FieldTable_1.FieldTable;
	var FieldValue_1 = __webpack_require__(181);
	exports.FieldValue = FieldValue_1.FieldValue;
	var Badge_1 = __webpack_require__(207);
	exports.Badge = Badge_1.Badge;
	var ResultRating_1 = __webpack_require__(208);
	exports.ResultRating = ResultRating_1.ResultRating;
	var PreferencesPanel_1 = __webpack_require__(209);
	exports.PreferencesPanel = PreferencesPanel_1.PreferencesPanel;
	var ResultsFiltersPreferences_1 = __webpack_require__(210);
	exports.ResultsFiltersPreferences = ResultsFiltersPreferences_1.ResultsFiltersPreferences;
	var Tab_1 = __webpack_require__(161);
	exports.Tab = Tab_1.Tab;
	var Omnibox_1 = __webpack_require__(135);
	exports.Omnibox = Omnibox_1.Omnibox;
	var QueryDuration_1 = __webpack_require__(212);
	exports.QueryDuration = QueryDuration_1.QueryDuration;
	var QuerySummary_1 = __webpack_require__(213);
	exports.QuerySummary = QuerySummary_1.QuerySummary;
	var Debug_1 = __webpack_require__(106);
	exports.Debug = Debug_1.Debug;
	var Settings_1 = __webpack_require__(215);
	exports.Settings = Settings_1.Settings;
	var ShareQuery_1 = __webpack_require__(216);
	exports.ShareQuery = ShareQuery_1.ShareQuery;
	var Sort_1 = __webpack_require__(217);
	exports.Sort = Sort_1.Sort;
	var SortCriteria_1 = __webpack_require__(187);
	exports.SortCriteria = SortCriteria_1.SortCriteria;
	var Triggers_1 = __webpack_require__(218);
	exports.Triggers = Triggers_1.Triggers;
	var Recommendation_1 = __webpack_require__(117);
	exports.Recommendation = Recommendation_1.Recommendation;
	var RecommendationQuery_1 = __webpack_require__(219);
	exports.RecommendationQuery = RecommendationQuery_1.RecommendationQuery;
	var TemplateLoader_1 = __webpack_require__(220);
	exports.TemplateLoader = TemplateLoader_1.TemplateLoader;
	var Template_1 = __webpack_require__(100);
	exports.Template = Template_1.Template;
	var SuggestionForOmnibox_1 = __webpack_require__(221);
	exports.SuggestionForOmnibox = SuggestionForOmnibox_1.SuggestionForOmnibox;
	var AnalyticsSuggestions_1 = __webpack_require__(222);
	exports.AnalyticsSuggestions = AnalyticsSuggestions_1.AnalyticsSuggestions;
	var FieldSuggestions_1 = __webpack_require__(223);
	exports.FieldSuggestions = FieldSuggestions_1.FieldSuggestions;
	var AuthenticationProvider_1 = __webpack_require__(224);
	exports.AuthenticationProvider = AuthenticationProvider_1.AuthenticationProvider;
	var ResultTagging_1 = __webpack_require__(225);
	exports.ResultTagging = ResultTagging_1.ResultTagging;
	var ResultsPreferences_1 = __webpack_require__(226);
	exports.ResultsPreferences = ResultsPreferences_1.ResultsPreferences;
	var PipelineContext_1 = __webpack_require__(227);
	exports.PipelineContext = PipelineContext_1.PipelineContext;
	exports.context = PipelineContext_1.context;
	var OmniboxResultList_1 = __webpack_require__(228);
	exports.OmniboxResultList = OmniboxResultList_1.OmniboxResultList;
	var CurrentTab_1 = __webpack_require__(229);
	exports.CurrentTab = CurrentTab_1.CurrentTab;
	var QueryboxQueryParameters_1 = __webpack_require__(132);
	exports.QueryboxQueryParameters = QueryboxQueryParameters_1.QueryboxQueryParameters;
	var ImageResultList_1 = __webpack_require__(230);
	exports.ImageResultList = ImageResultList_1.ImageResultList;
	var CoveoJQuery_1 = __webpack_require__(120);
	exports.$ = CoveoJQuery_1.jQueryInstance;
	var CoveoUnderscore_1 = __webpack_require__(231);
	exports._ = CoveoUnderscore_1.underscoreInstance;
	var AdvancedSearch_1 = __webpack_require__(232);
	exports.AdvancedSearch = AdvancedSearch_1.AdvancedSearch;
	var NumericSpinner_1 = __webpack_require__(245);
	exports.NumericSpinner = NumericSpinner_1.NumericSpinner;
	var DatePicker_1 = __webpack_require__(247);
	exports.DatePicker = DatePicker_1.DatePicker;
	var Dropdown_1 = __webpack_require__(244);
	exports.Dropdown = Dropdown_1.Dropdown;
	var TextInput_1 = __webpack_require__(236);
	exports.TextInput = TextInput_1.TextInput;
	var RadioButton_1 = __webpack_require__(242);
	exports.RadioButton = RadioButton_1.RadioButton;
	var FollowItem_1 = __webpack_require__(364);
	exports.FollowItem = FollowItem_1.FollowItem;
	var SearchAlerts_1 = __webpack_require__(366);
	exports.SearchAlerts = SearchAlerts_1.SearchAlerts;
	var SearchAlertsMessage_1 = __webpack_require__(367);
	exports.SearchAlertsMessage = SearchAlertsMessage_1.SearchAlertsMessage;
	var Text_1 = __webpack_require__(368);
	exports.Text = Text_1.Text;
	var FoldingForThread_1 = __webpack_require__(369);
	exports.FoldingForThread = FoldingForThread_1.FoldingForThread;
	var ChatterLikedBy_1 = __webpack_require__(370);
	exports.ChatterLikedBy = ChatterLikedBy_1.ChatterLikedBy;
	var ChatterPostAttachment_1 = __webpack_require__(372);
	exports.ChatterPostAttachment = ChatterPostAttachment_1.ChatterPostAttachment;
	var ChatterPostedBy_1 = __webpack_require__(373);
	exports.ChatterPostedBy = ChatterPostedBy_1.ChatterPostedBy;
	var ChatterTopic_1 = __webpack_require__(374);
	exports.ChatterTopic = ChatterTopic_1.ChatterTopic;
	var ChatterUtils_1 = __webpack_require__(371);
	exports.ChatterUtils = ChatterUtils_1.ChatterUtils;
	var Logo_1 = __webpack_require__(375);
	exports.Logo = Logo_1.Logo;
	var SwapVar_1 = __webpack_require__(376);
	SwapVar_1.swapVar(this);


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	var DefaultLanguage_1 = __webpack_require__(3);
	DefaultLanguage_1.defaultLanguage();
	var DefaultLanguage_2 = __webpack_require__(3);
	exports.setLanguageAfterPageLoaded = DefaultLanguage_2.setLanguageAfterPageLoaded;
	var PromisesShim_1 = __webpack_require__(6);
	PromisesShim_1.shim();
	var CustomEventPolyfill_1 = __webpack_require__(10);
	CustomEventPolyfill_1.customEventPolyfill();
	// MISC
	var Version_1 = __webpack_require__(11);
	exports.version = Version_1.version;
	var SearchEndpoint_1 = __webpack_require__(12);
	exports.SearchEndpoint = SearchEndpoint_1.SearchEndpoint;
	__export(__webpack_require__(25));


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var Globalize = __webpack_require__(4);
	var merge = function (obj1, obj2) {
	    var obj3 = {};
	    for (var attrname in obj1) {
	        obj3[attrname] = obj1[attrname];
	    }
	    for (var attrname in obj2) {
	        obj3[attrname] = obj2[attrname];
	    }
	    return obj3;
	};
	var dict = {
	    "Unknown": "Unknown",
	    "And": "AND",
	    "Authenticating": "Authenticating {0}...",
	    "Clear": "Clear {0}",
	    "CompleteQuery": "Complete Query",
	    "Exclude": "Exclude {0}",
	    "EnterTag": "Add Tag",
	    "Next": "Next",
	    "Last": "Last",
	    "Link": "Link",
	    "Or": "OR",
	    "Previous": "Previous",
	    "QueryDidntMatchAnyDocuments": "Your query did not match any documents.",
	    "QueryException": "Your query has an error: {0}.",
	    "Me": "Me",
	    "Remove": "Remove",
	    "Search": "Search",
	    "SearchFor": "Search for {0}",
	    "ShareQuery": "Share Query",
	    "Preferences": "Preferences",
	    "LinkOpeningSettings": "Link Opening Settings",
	    "Reauthenticate": "Reauthenticate {0}",
	    "ResultsFilteringExpression": "Results Filtering Expressions",
	    "FiltersInYourPreferences": "Filters in your preferences",
	    "Create": "Create",
	    "SearchIn": "Search in {0}",
	    "Seconds": "in {0} second<pl>s</pl>",
	    "ShowingResultsOf": "Result<pl>s</pl> {0}<pl>-{1}</pl> of {2}",
	    "SwitchTo": "Switch to {0}",
	    "Unexclude": "Unexclude {0}",
	    "ClearAllFilters": "Clear All Filters",
	    "SkipLogin": "Skip login",
	    "LoginInProgress": "Login in progress, please wait ...",
	    "Login": "Log In",
	    "GetStarted": "Get Started",
	    "More": "More",
	    "NMore": "{0} more...",
	    "Less": "Fewer",
	    "Settings": "Settings",
	    "Score": "Score",
	    "ScoreDescription": "The score is computed from the number of occurrences as well as from the position in the result set.",
	    "Occurrences": "Occurrences",
	    "OccurrencesDescription": "Sort by number of occurrences, with values having the highest number appearing first.",
	    "Label": "Label",
	    "Of": "of",
	    "LabelDescription": "Sort alphabetically on the field values.",
	    "Value": "Value",
	    "ValueDescription": "Sort on the values of the first computed field",
	    "AlphaAscending": "Value Ascending",
	    "AlphaDescending": "Value Descending",
	    "ChiSquare": "Chi Square",
	    "Nosort": "No Sort",
	    "RelativeFrequency": "Relative Frequency",
	    "RelativeFrequencyDescription": "Sort based on the relative frequency of values. Less common values will appear higher.",
	    "DateDistribution": "Date distribution",
	    "Custom": "Custom",
	    "CustomDescription": "Sort based on a custom order",
	    "ComputedField": "Computed Field",
	    "Ascending": "Ascending",
	    "Descending": "Descending",
	    "noResultFor": "No results for {0}",
	    "autoCorrectedQueryTo": "Query was automatically corrected to {0}",
	    "didYouMean": "Did you mean: {0}",
	    "SuggestedResults": "Suggested Results",
	    "SuggestedQueries": "Suggested Queries",
	    "MostRelevantItems": "Most relevant items:",
	    "AllItems": "All items:",
	    "ShowLess": "Show less",
	    "ShowMore": "Show more",
	    "HideFacet": "Hide Facet",
	    "ShowFacet": "Show Facet",
	    "AndOthers": "and {0} other<pl>s</pl>",
	    "Others": "{0} other<pl>s</pl>",
	    "MostRelevantPosts": "Most Relevant Posts:",
	    "CompleteThread": "Complete Thread:",
	    "ShowCompleteThread": "Show Complete Thread",
	    "ShowOnlyTopMatchingPosts": "Show Only Top Matching Posts",
	    "MostRelevantReplies": "Most Relevant Replies:",
	    "AllConversation": "All Conversation:",
	    "ShowAllConversation": "Show All Conversation",
	    "ShowAllReplies": "Show All Replies",
	    "ShowOnlyMostRelevantReplies": "Show Only Most Relevant Replies",
	    "Close": "Close",
	    "Open": "Open",
	    "OpenInOutlookWhenPossible": "Open in Outlook (when possible)",
	    "AlwaysOpenInNewWindow": "Always open results in new window",
	    "Quickview": "Quick View",
	    "NoQuickview": "The Quick View for this document is unavailable",
	    "ErrorReport": "Error Report",
	    "OopsError": "Something went wrong.",
	    "ProblemPersists": "If the problem persists contact the administrator.",
	    "GoBack": "Go Back",
	    "Reset": "Reset",
	    "Retry": "Retry",
	    "MoreInfo": "More Information",
	    "Username": "Username",
	    "Password": "Password",
	    "PostedBy": "Posted by",
	    "CannotConnect": "Cannot connect to the server address.",
	    "BadUserPass": "Password does not match with username.",
	    "PleaseEnterYourCredentials": "Please enter your credentials for {0}.",
	    "PleaseEnterYourSearchPage": "Please enter your search page URL",
	    "Collapse": "Collapse",
	    "Collapsable": "Collapsible",
	    "Expand": "Expand",
	    "Today": "Today",
	    "Yesterday": "Yesterday",
	    "Tomorrow": "Tomorrow",
	    "Duration": "Duration: {0}",
	    "IndexDuration": "Index Duration: {0}",
	    "ProxyDuration": "Proxy Duration: {0}",
	    "ClientDuration": "Client Duration: {0}",
	    "Unavailable": "Unavailable",
	    "Reply": "Reply",
	    "ReplyAll": "Reply All",
	    "Forward": "Forward",
	    "From": "From",
	    "Caption": "Caption",
	    "Expression": "Expression",
	    "Tab": "Tab",
	    "Tabs": "Tabs",
	    "EnterExpressionName": "Enter expression name",
	    "EnterExpressionToFilterWith": "Enter expression to filter results with",
	    "SelectTab": "Select Tab",
	    "SelectAll": "Select All",
	    "PageUrl": "Search page URL",
	    "ErrorSavingToDevice": "Error while saving the information to your device",
	    "ErrorReadingFromDevice": "Error while reading the information from your device",
	    "AppIntro": "Speak with a product specialist who can answer your questions about Coveo and help you decide which Coveo solution is right for you. Or, try a live demo !",
	    "TryDemo": "Try the demo",
	    "ContactUs": "Contact us",
	    "NewToCoveo": "New to Coveo?",
	    "LetUsHelpGetStarted": "Let us help you get started",
	    "LikesThis": "{0} like<sn>s</sn> this.",
	    "CannotConnectSearchPage": "Cannot connect to your search page",
	    "AreYouSureDeleteFilter": "Are you sure you want to delete the filter {0} with the expression {1}",
	    "OnlineHelp": "Online Help",
	    "Done": "Done",
	    "SaveFacetState": "Save this facet state",
	    "ClearFacetState": "Clear facet state",
	    "DisplayingTheOnlyMessage": "Displaying the only message in this conversation",
	    "NoNetworkConnection": "No network connection",
	    "UnknownConnection": "Unknown connection",
	    "EthernetConnection": "Ethernet connection",
	    "WiFi": "WiFi connection",
	    "CELL": "Cellular connection",
	    "CELL_2G": "Cellular 2G connection",
	    "CELL_3G": "Cellular 3G connection",
	    "CELL_4G": "Cellular 4G connection",
	    "Relevance": "Relevance",
	    "Date": "Date",
	    "Amount": "Amount",
	    "QueryExceptionNoException": "No exception",
	    "QueryExceptionInvalidSyntax": "Invalid syntax",
	    "QueryExceptionInvalidCustomField": "Invalid custom field",
	    "QueryExceptionInvalidDate": "Invalid date",
	    "QueryExceptionInvalidExactPhrase": "Invalid exact phrase",
	    "QueryExceptionInvalidDateOp": "Invalid date operator",
	    "QueryExceptionInvalidNear": "Invalid NEAR operator",
	    "QueryExceptionInvalidWeightedNear": "Invalid weighted NEAR",
	    "QueryExceptionInvalidTerm": "Invalid term",
	    "QueryExceptionTooManyTerms": "Too many terms",
	    "QueryExceptionWildcardTooGeneral": "Wildcard too general",
	    "QueryExceptionInvalidSortField": "Invalid sort field",
	    "QueryExceptionInvalidSmallStringOp": "Invalid small string operator",
	    "QueryExceptionRequestedResultsMax": "Requested results maximum",
	    "QueryExceptionAggregatedMirrorDead": "Aggregated mirror is offline",
	    "QueryExceptionAggregatedMirrorQueryTimeOut": "Aggregated mirror query timeout",
	    "QueryExceptionAggregatedMirrorInvalidBuildNumber": "Aggregated mirror invalid build number",
	    "QueryExceptionAggregatedMirrorCannotConnect": "Aggregated mirror cannot connect",
	    "QueryExceptionNotEnoughLeadingCharsWildcard": "Not enough leading character wildcard",
	    "QueryExceptionSecurityInverterNotFound": "Security inverter not found",
	    "QueryExceptionSecurityInverterAccessDenied": "Security inverter access denied",
	    "QueryExceptionAggregatedMirrorCannotImpersonate": "Aggregated mirror cannot impersonate",
	    "QueryExceptionUnexpected": "Unexpected",
	    "QueryExceptionAccessDenied": "Access denied",
	    "QueryExceptionSuperUserTokenInvalid": "Super user token invalid",
	    "QueryExceptionSuperUserTokenExpired": "Super user token is expired",
	    "QueryExceptionLicenseQueriesExpired": "Queries license expired",
	    "QueryExceptionLicenseSuperUserTokenNotSupported": "License super user token not supported",
	    "QueryExceptionInvalidSession": "Invalid session",
	    "QueryExceptionInvalidDocument": "Invalid document",
	    "QueryExceptionSearchDisabled": "Search disabled",
	    "FileType": "File type",
	    "ShowAttachment": "Show attachment",
	    "OnFeed": "on {0}'s feed.",
	    "Author": "Author",
	    "NoTitle": "No title",
	    "CurrentSelections": "Current selections",
	    "AllContent": "All content",
	    "CancelLastAction": "Cancel last action",
	    "SearchTips": "Search tips",
	    "CheckSpelling": "Check the spelling of your keywords.",
	    "TryUsingFewerKeywords": "Try using fewer, different or more general keywords.",
	    "SelectFewerFilters": "Select fewer filters to broaden your search.",
	    "Document": "Document",
	    "Time": "Time",
	    "StartDate": "Start Date",
	    "StartTime": "Start Time",
	    "DurationTitle": "Duration",
	    "UserQuery": "User query",
	    "ShowUserActions": "Show User Actions",
	    "NoData": "No data available",
	    "EventType": "Event type",
	    "GoToFullSearch": "Full search",
	    "GoToEdition": "Customize Panel",
	    "RemoveContext": "Remove context",
	    "BoxAttachToCase": "Attach to case",
	    "AttachToCase": "Attach to case",
	    "Attach": "Attach",
	    "Attached": "Attached",
	    "Detach": "Detach",
	    "Details": "Details",
	    "AdditionalFilters": "Additional filters",
	    "SelectNonContextualSearch": "Remove the context from the current record to broaden your search",
	    "CopyPasteToSupport": "Copy paste this message to Coveo Support team for more information.",
	    "FollowQueryDescription": "Alert me for changes to the search results of this query.",
	    "SearchAlerts_Panel": "Manage Alerts",
	    "SearchAlerts_PanelDescription": "View and manage your search alerts.",
	    "SearchAlerts_PanelNoSearchAlerts": "You have no subscriptions.",
	    "SearchAlerts_Fail": "The Search Alerts service is currently unavailable.",
	    "SearchAlerts_Type": "Type",
	    "SearchAlerts_Content": "Content",
	    "SearchAlerts_Actions": "Action",
	    "EmptyQuery": "&lt;empty&gt;",
	    "SearchAlerts_Type_followQuery": "Query",
	    "SearchAlerts_Type_followDocument": "Item",
	    "SearchAlerts_unFollowing": "Stop Following",
	    "SearchAlerts_follow": "Follow",
	    "SearchAlerts_followed": "Followed",
	    "SearchAlerts_followQuery": "Follow Query",
	    "Subscription_StopFollowingQuery": "Stop Following Query",
	    "SearchAlerts_Frequency": "When",
	    "SubscriptionsManageSubscriptions": "Manage Alerts",
	    "SubscriptionsMessageFollowQuery": "You will receive alerts when the query <b>{0}</b> returns new or updated items.",
	    "SubscriptionsMessageFollow": "You will receive alerts for changes to the item <b>{0}</b>.",
	    "Expiration": "Expiration",
	    "Monthly": "Monthly",
	    "Daily": "Daily",
	    "Monday": "Monday",
	    "Tuesday": "Tuesday",
	    "Wednesday": "Wednesday",
	    "Thursday": "Thursday",
	    "Friday": "Friday",
	    "Saturday": "Saturday",
	    "Sunday": "Sunday",
	    "StartTypingCaseForSuggestions": "Describe your problem to see possible solutions",
	    "ExportToExcel": "Export to Excel",
	    "ExportToExcelDescription": "Export search results to Excel",
	    "CaseCreationNoResults": "No recommended solutions were found",
	    "SortBy": "Sort by",
	    "BoxCreateArticle": "Create Article",
	    "Facets": "Facets",
	    "AdvancedSearch": "Advanced Search",
	    "Keywords": "Keywords",
	    "AllTheseWords": "All these words",
	    "ExactPhrase": "This exact phrase",
	    "AnyOfTheseWords": "Any of these words",
	    "NoneOfTheseWords": "None of these words",
	    "Anytime": "Anytime",
	    "InTheLast": "In the last",
	    "Days": "days",
	    "Months": "months",
	    "Between": "Between",
	    "Language": "Language",
	    "Size": "Size",
	    "AtLeast": "at least",
	    "AtMost": "at most",
	    "Contains": "contains",
	    "DoesNotContain": "does not contain",
	    "Matches": "matches",
	    "Bytes": "bytes",
	    "objecttype_people": "People",
	    "objecttype_message": "Message",
	    "objecttype_feed": "RSS Feed",
	    "objecttype_thread": "Thread",
	    "objecttype_file": "File",
	    "objecttype_board": "",
	    "objecttype_category": "",
	    "objecttype_account": "Account",
	    "objecttype_campaign": "Campaign",
	    "objecttype_case": "Case",
	    "objecttype_contact": "Contact",
	    "objecttype_contract": "Contract",
	    "objecttype_event": "Event",
	    "objecttype_lead": "Lead",
	    "objecttype_solution": "Solution",
	    "objecttype_task": "Task",
	    "objecttype_user": "User",
	    "objecttype_attachment": "Attachment",
	    "objecttype_casecomment": "Case Comment",
	    "objecttype_opportunity": "Opportunity",
	    "objecttype_feeditem": "Chatter",
	    "objecttype_feedcomment": "Chatter",
	    "objecttype_note": "Note",
	    "objecttype_product": "Product",
	    "objecttype_partner": "Partner",
	    "objecttype_kbdocumentation": "Documentation",
	    "objecttype_kbtechnicalarticle": "Documentation",
	    "objecttype_kbsolution": "Solution",
	    "objecttype_kbknowledgearticle": "Knowledge Article",
	    "objecttype_kbattachment": "Attachment",
	    "filetype_html": "HTML File",
	    "filetype_wiki": "Wiki",
	    "filetype_webscraperwebpage": "Web page",
	    "filetype_image": "Image",
	    "filetype_folder": "Folder",
	    "filetype_txt": "Text",
	    "filetype_zip": "Zip File",
	    "filetype_pdf": "PDF File",
	    "filetype_xml": "XML File",
	    "filetype_doc": "Document",
	    "filetype_xls": "Spreadsheet Document",
	    "filetype_ppt": "Presentation Document",
	    "filetype_video": "Video",
	    "filetype_youtube": "YouTube video",
	    "filetype_saleforceitem": "Salesforce",
	    "filetype_exchangemessage": "Message",
	    "filetype_exchangeappointment": "Appointment",
	    "filetype_exchangenote": "Note",
	    "filetype_exchangetask": "Task",
	    "filetype_exchangeperson": "Exchange user",
	    "filetype_activedirperson": "Active Directory user",
	    "filetype_exchangeactivity": "Activity",
	    "filetype_exchangecalendarmessage": "Calendar message",
	    "filetype_exchangedocument": "Exchange document",
	    "filetype_exchangerssfeed": "RSS Feed",
	    "filetype_exchangejunkmessage": "Junk email",
	    "filetype_exchangeofficecom": "Communications",
	    "filetype_lithiummessage": "Message",
	    "filetype_lithiumthread": "Thread",
	    "filetype_lithiumboard": "Board",
	    "filetype_lithiumcategory": "Category",
	    "filetype_lithiumcommunity": "Community",
	    "filetype_spportal": "Portal",
	    "filetype_spsite": "Site",
	    "filetype_spuserprofile": "SharePoint User",
	    "filetype_sparea": "Area",
	    "filetype_spannouncement": "Announcement",
	    "filetype_spannouncementlist": "Announcements",
	    "filetype_spcontact": "Contact",
	    "filetype_spcontactlist": "Contacts",
	    "filetype_spcustomlist": "Custom Lists",
	    "filetype_spdiscussionboard": "Discussion Board",
	    "filetype_spdiscussionboardlist": "Discussion Boards",
	    "filetype_spdocumentlibrarylist": "Document Library",
	    "filetype_spevent": "Event",
	    "filetype_speventlist": "Events",
	    "filetype_spformlibrarylist": "Form Library",
	    "filetype_spissue": "Issue",
	    "filetype_spissuelist": "Issues",
	    "filetype_splink": "Link",
	    "filetype_splinklist": "Links",
	    "filetype_sppicturelibrarylist": "Picture Library",
	    "filetype_spsurvey": "Survey",
	    "filetype_spsurveylist": "Surveys",
	    "filetype_sptask": "Task",
	    "filetype_sptasklist": "Tasks",
	    "filetype_spagenda": "Agenda",
	    "filetype_spagendalist": "Agendas",
	    "filetype_spattendee": "Attendee",
	    "filetype_spattendeelist": "Attendees",
	    "filetype_spcustomgridlist": "Custom Grids",
	    "filetype_spdecision": "Decision",
	    "filetype_spdecisionlist": "Decisions",
	    "filetype_spobjective": "Objective",
	    "filetype_spobjectivelist": "Objectives",
	    "filetype_sptextbox": "Textbox",
	    "filetype_sptextboxlist": "Textbox list",
	    "filetype_spthingstobring": "Thing To Bring",
	    "filetype_spthingstobringlist": "Things To Bring",
	    "filetype_sparealisting": "Area Listing",
	    "filetype_spmeetingserie": "Meeting series",
	    "filetype_spmeetingserielist": "Meeting Series List",
	    "filetype_spsitedirectory": "Site Directory Item",
	    "filetype_spsitedirectorylist": "Site Directory",
	    "filetype_spdatasource": "Data Source",
	    "filetype_spdatasourcelist": "Data Source List",
	    "filetype_splisttemplatecataloglist": "List Template Catalog List",
	    "filetype_spwebpartcataloglist": "WebPart catalog list",
	    "filetype_spwebtemplatecataloglist": "Web Template Catalog List",
	    "filetype_spworkspacepagelist": "Workspace Page List",
	    "filetype_spunknownlist": "Custom List",
	    "filetype_spadministratortask": "Administrator Task",
	    "filetype_spadministratortasklist": "Administrator Tasks",
	    "filetype_spareadocumentlibrarylist": "Area Document Library",
	    "filetype_spblogcategory": "Blog Category",
	    "filetype_spblogcategorylist": "Blog Category",
	    "filetype_spblogcomment": "Blog Comment",
	    "filetype_spblogcommentlist": "Blog Comments",
	    "filetype_spblogpost": "Blog Post",
	    "filetype_spblogpostlist": "Blog Posts",
	    "filetype_spdataconnectionlibrarylist": "Data Connection Library",
	    "filetype_spdistributiongroup": "Distribution Group",
	    "filetype_spdistributiongrouplist": "Distribution Groups",
	    "filetype_spipfslist": "InfoPath Form Servers",
	    "filetype_spkeyperformanceindicator": "Key Performance Indicator",
	    "filetype_spkeyperformanceindicatorlist": "Key Performance Indicators",
	    "filetype_splanguagesandtranslator": "Languages and Translator",
	    "filetype_splanguagesandtranslatorlist": "Languages and Translators",
	    "filetype_spmasterpagescataloglist": "Master Pages Library",
	    "filetype_spnocodeworkflowlibrarylist": "No Code Workflow Library",
	    "filetype_spprojecttask": "Project Task",
	    "filetype_spprojecttasklist": "Project Tasks",
	    "filetype_sppublishingpageslibrarylist": "Page Library",
	    "filetype_spreportdocumentlibrarylist": "Report Document Library",
	    "filetype_spreportlibrarylist": "Report Library",
	    "filetype_spslidelibrarylist": "Slide Library",
	    "filetype_sptab": "Tabs",
	    "filetype_sptablist": "Tabs List",
	    "filetype_sptranslationmanagementlibrarylist": "Translation Management Library",
	    "filetype_spuserinformation": "User Information",
	    "filetype_spuserinformationlist": "User Information List",
	    "filetype_spwikipagelibrarylist": "Wiki Page Library",
	    "filetype_spworkflowhistory": "Workflow History",
	    "filetype_spworkflowhistorylist": "Workflow Histories",
	    "filetype_spworkflowprocess": "Custom Workflow Process",
	    "filetype_spworkflowprocesslist": "Custom Workflow Processes",
	    "filetype_sppublishingimageslibrarylist": "Publishing Image Library",
	    "filetype_spcirculation": "Circulation",
	    "filetype_spcirculationlist": "Circulations",
	    "filetype_spdashboardslibrarylist": "Dashboard Library",
	    "filetype_spdataconnectionforperformancepointlibrarylist": "Data Connection for Performance Point Library",
	    "filetype_sphealthreport": "Health Report",
	    "filetype_sphealthreportlist": "Health Reports",
	    "filetype_sphealthrule": "Health Rule",
	    "filetype_sphealthrulelist": "Health Rules",
	    "filetype_spimedictionary": "IME Dictionary",
	    "filetype_spimedictionarylist": "IME Dictionaries",
	    "filetype_spperformancepointcontent": "Performance Point Content",
	    "filetype_spperformancepointcontentlist": "Performance Point Contents",
	    "filetype_spphonecallmemo": "Phone Call Memo",
	    "filetype_spphonecallmemolist": "Phone Call Memos",
	    "filetype_sprecordlibrarylist": "Record Library",
	    "filetype_spresource": "Resource",
	    "filetype_spresourcelist": "Resources",
	    "filetype_spprocessdiagramslibrarylist": "Process Diagram Library",
	    "filetype_spsitethemeslibrarylist": "Site Theme Library",
	    "filetype_spsolutionslibrarylist": "Solution Library",
	    "filetype_spwfpublibrarylist": "WFPUB Library",
	    "filetype_spwhereabout": "Whereabout",
	    "filetype_spwhereaboutlist": "Whereabouts",
	    "filetype_spdocumentlink": "Link to a Document",
	    "filetype_spdocumentset": "Document Set",
	    "filetype_spmicrofeedpost": "Microfeed Post",
	    "filetype_spmicrofeedlist": "Microfeed",
	    "filetype_splistfolder": "List Folder",
	    "filetype_youtubevideo": "YouTube video",
	    "filetype_youtubeplaylistitem": "YouTube playlist item",
	};
	function defaultLanguage() {
	    if (window['$'] != undefined && window['$'].fn != undefined && window['$'].fn.jquery != undefined) {
	        $(function () {
	            var locales = String["locales"] || (String["locales"] = {});
	            locales["en"] = merge(locales["en"], dict);
	            String["toLocaleString"].call(this, { "en": dict });
	            String["locale"] = "en";
	            String["defaultLocale"] = "en";
	            Globalize.culture("en");
	        });
	    }
	    else {
	        document.addEventListener('DOMContentLoaded', function (event) {
	            var locales = String["locales"] || (String["locales"] = {});
	            locales["en"] = merge(locales["en"], dict);
	            String["toLocaleString"].call(this, { "en": dict });
	            String["locale"] = "en";
	            String["defaultLocale"] = "en";
	            Globalize.culture("en");
	        });
	    }
	}
	exports.defaultLanguage = defaultLanguage;
	function setLanguageAfterPageLoaded() {
	    var locales = String["locales"] || (String["locales"] = {});
	    locales["en"] = merge(locales["en"], dict);
	    String["toLocaleString"].call(this, { "en": dict });
	    String["locale"] = "en";
	    String["defaultLocale"] = "en";
	    Globalize.culture("en");
	}
	exports.setLanguageAfterPageLoaded = setLanguageAfterPageLoaded;


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["Globalize"] = __webpack_require__(5);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	/*! globalize - v0.1.1 - 2013-04-30
	* https://github.com/jquery/globalize
	* Copyright 2013 ; Licensed MIT */
	var Globalize = (function(e,r){var t,n,a,s,u,l,i,c,o,f,d,p,h,g,b,m,y,M,v,k,z,F,A,x;t=function(e){return new t.prototype.init(e)}, true?module.exports=t:e.Globalize=t,t.cultures={},t.prototype={constructor:t,init:function(e){return this.cultures=t.cultures,this.cultureSelector=e,this}},t.prototype.init.prototype=t.prototype,t.cultures["default"]={name:"en",englishName:"English",nativeName:"English",isRTL:!1,language:"en",numberFormat:{pattern:["-n"],decimals:2,",":",",".":".",groupSizes:[3],"+":"+","-":"-",NaN:"NaN",negativeInfinity:"-Infinity",positiveInfinity:"Infinity",percent:{pattern:["-n %","n %"],decimals:2,groupSizes:[3],",":",",".":".",symbol:"%"},currency:{pattern:["($n)","$n"],decimals:2,groupSizes:[3],",":",",".":".",symbol:"$"}},calendars:{standard:{name:"Gregorian_USEnglish","/":"/",":":":",firstDay:0,days:{names:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],namesAbbr:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],namesShort:["Su","Mo","Tu","We","Th","Fr","Sa"]},months:{names:["January","February","March","April","May","June","July","August","September","October","November","December",""],namesAbbr:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec",""]},AM:["AM","am","AM"],PM:["PM","pm","PM"],eras:[{name:"A.D.",start:null,offset:0}],twoDigitYearMax:2029,patterns:{d:"M/d/yyyy",D:"dddd, MMMM dd, yyyy",t:"h:mm tt",T:"h:mm:ss tt",f:"dddd, MMMM dd, yyyy h:mm tt",F:"dddd, MMMM dd, yyyy h:mm:ss tt",M:"MMMM dd",Y:"yyyy MMMM",S:"yyyy'-'MM'-'dd'T'HH':'mm':'ss"}}},messages:{}},t.cultures["default"].calendar=t.cultures["default"].calendars.standard,t.cultures.en=t.cultures["default"],t.cultureSelector="en",n=/^0x[a-f0-9]+$/i,a=/^[+\-]?infinity$/i,s=/^[+\-]?\d*\.?\d*(e[+\-]?\d+)?$/,u=/^\s+|\s+$/g,l=function(e,r){if(e.indexOf)return e.indexOf(r);for(var t=0,n=e.length;n>t;t++)if(e[t]===r)return t;return-1},i=function(e,r){return e.substr(e.length-r.length)===r},c=function(){var e,t,n,a,s,u,l=arguments[0]||{},i=1,p=arguments.length,h=!1;for("boolean"==typeof l&&(h=l,l=arguments[1]||{},i=2),"object"==typeof l||f(l)||(l={});p>i;i++)if(null!=(e=arguments[i]))for(t in e)n=l[t],a=e[t],l!==a&&(h&&a&&(d(a)||(s=o(a)))?(s?(s=!1,u=n&&o(n)?n:[]):u=n&&d(n)?n:{},l[t]=c(h,u,a)):a!==r&&(l[t]=a));return l},o=Array.isArray||function(e){return"[object Array]"===Object.prototype.toString.call(e)},f=function(e){return"[object Function]"===Object.prototype.toString.call(e)},d=function(e){return"[object Object]"===Object.prototype.toString.call(e)},p=function(e,r){return 0===e.indexOf(r)},h=function(e){return(e+"").replace(u,"")},g=function(e){return isNaN(e)?0/0:Math[0>e?"ceil":"floor"](e)},b=function(e,r,t){var n;for(n=e.length;r>n;n+=1)e=t?"0"+e:e+"0";return e},m=function(e,r){for(var t=0,n=!1,a=0,s=e.length;s>a;a++){var u=e.charAt(a);switch(u){case"'":n?r.push("'"):t++,n=!1;break;case"\\":n&&r.push("\\"),n=!n;break;default:r.push(u),n=!1}}return t},y=function(e,r){r=r||"F";var t,n=e.patterns,a=r.length;if(1===a){if(t=n[r],!t)throw"Invalid date format string '"+r+"'.";r=t}else 2===a&&"%"===r.charAt(0)&&(r=r.charAt(1));return r},M=function(e,r,t){function n(e,r){var t,n=e+"";return r>1&&r>n.length?(t=v[r-2]+n,t.substr(t.length-r,r)):t=n}function a(){return h||g?h:(h=A.test(r),g=!0,h)}function s(e,r){if(b)return b[r];switch(r){case 0:return e.getFullYear();case 1:return e.getMonth();case 2:return e.getDate();default:throw"Invalid part value "+r}}var u,l=t.calendar,i=l.convert;if(!r||!r.length||"i"===r){if(t&&t.name.length)if(i)u=M(e,l.patterns.F,t);else{var c=new Date(e.getTime()),o=z(e,l.eras);c.setFullYear(F(e,l,o)),u=c.toLocaleString()}else u=""+e;return u}var f=l.eras,d="s"===r;r=y(l,r),u=[];var p,h,g,b,v=["0","00","000"],A=/([^d]|^)(d|dd)([^d]|$)/g,x=0,I=k();for(!d&&i&&(b=i.fromGregorian(e));;){var S=I.lastIndex,w=I.exec(r),C=r.slice(S,w?w.index:r.length);if(x+=m(C,u),!w)break;if(x%2)u.push(w[0]);else{var D=w[0],H=D.length;switch(D){case"ddd":case"dddd":var O=3===H?l.days.namesAbbr:l.days.names;u.push(O[e.getDay()]);break;case"d":case"dd":h=!0,u.push(n(s(e,2),H));break;case"MMM":case"MMMM":var N=s(e,1);u.push(l.monthsGenitive&&a()?l.monthsGenitive[3===H?"namesAbbr":"names"][N]:l.months[3===H?"namesAbbr":"names"][N]);break;case"M":case"MM":u.push(n(s(e,1)+1,H));break;case"y":case"yy":case"yyyy":N=b?b[0]:F(e,l,z(e,f),d),4>H&&(N%=100),u.push(n(N,H));break;case"h":case"hh":p=e.getHours()%12,0===p&&(p=12),u.push(n(p,H));break;case"H":case"HH":u.push(n(e.getHours(),H));break;case"m":case"mm":u.push(n(e.getMinutes(),H));break;case"s":case"ss":u.push(n(e.getSeconds(),H));break;case"t":case"tt":N=12>e.getHours()?l.AM?l.AM[0]:" ":l.PM?l.PM[0]:" ",u.push(1===H?N.charAt(0):N);break;case"f":case"ff":case"fff":u.push(n(e.getMilliseconds(),3).substr(0,H));break;case"z":case"zz":p=e.getTimezoneOffset()/60,u.push((0>=p?"+":"-")+n(Math.floor(Math.abs(p)),H));break;case"zzz":p=e.getTimezoneOffset()/60,u.push((0>=p?"+":"-")+n(Math.floor(Math.abs(p)),2)+":"+n(Math.abs(e.getTimezoneOffset()%60),2));break;case"g":case"gg":l.eras&&u.push(l.eras[z(e,f)].name);break;case"/":u.push(l["/"]);break;default:throw"Invalid date format pattern '"+D+"'."}}}return u.join("")},function(){var e;e=function(e,r,t){var n=t.groupSizes,a=n[0],s=1,u=Math.pow(10,r),l=Math.round(e*u)/u;isFinite(l)||(l=e),e=l;var i=e+"",c="",o=i.split(/e/i),f=o.length>1?parseInt(o[1],10):0;i=o[0],o=i.split("."),i=o[0],c=o.length>1?o[1]:"",f>0?(c=b(c,f,!1),i+=c.slice(0,f),c=c.substr(f)):0>f&&(f=-f,i=b(i,f+1,!0),c=i.slice(-f,i.length)+c,i=i.slice(0,-f)),c=r>0?t["."]+(c.length>r?c.slice(0,r):b(c,r)):"";for(var d=i.length-1,p=t[","],h="";d>=0;){if(0===a||a>d)return i.slice(0,d+1)+(h.length?p+h+c:c);h=i.slice(d-a+1,d+1)+(h.length?p+h:""),d-=a,n.length>s&&(a=n[s],s++)}return i.slice(0,d+1)+p+h+c},v=function(r,t,n){if(!isFinite(r))return 1/0===r?n.numberFormat.positiveInfinity:r===-1/0?n.numberFormat.negativeInfinity:n.numberFormat.NaN;if(!t||"i"===t)return n.name.length?r.toLocaleString():""+r;t=t||"D";var a,s=n.numberFormat,u=Math.abs(r),l=-1;t.length>1&&(l=parseInt(t.slice(1),10));var i,c=t.charAt(0).toUpperCase();switch(c){case"D":a="n",u=g(u),-1!==l&&(u=b(""+u,l,!0)),0>r&&(u="-"+u);break;case"N":i=s;case"C":i=i||s.currency;case"P":i=i||s.percent,a=0>r?i.pattern[0]:i.pattern[1]||"n",-1===l&&(l=i.decimals),u=e(u*("P"===c?100:1),l,i);break;default:throw"Bad number format specifier: "+c}for(var o=/n|\$|-|%/g,f="";;){var d=o.lastIndex,p=o.exec(a);if(f+=a.slice(d,p?p.index:a.length),!p)break;switch(p[0]){case"n":f+=u;break;case"$":f+=s.currency.symbol;break;case"-":/[1-9]/.test(u)&&(f+=s["-"]);break;case"%":f+=s.percent.symbol}}return f}}(),k=function(){return/\/|dddd|ddd|dd|d|MMMM|MMM|MM|M|yyyy|yy|y|hh|h|HH|H|mm|m|ss|s|tt|t|fff|ff|f|zzz|zz|z|gg|g/g},z=function(e,r){if(!r)return 0;for(var t,n=e.getTime(),a=0,s=r.length;s>a;a++)if(t=r[a].start,null===t||n>=t)return a;return 0},F=function(e,r,t,n){var a=e.getFullYear();return!n&&r.eras&&(a-=r.eras[t].offset),a},function(){var e,r,t,n,a,s,u;e=function(e,r){if(100>r){var t=new Date,n=z(t),a=F(t,e,n),s=e.twoDigitYearMax;s="string"==typeof s?(new Date).getFullYear()%100+parseInt(s,10):s,r+=a-a%100,r>s&&(r-=100)}return r},r=function(e,r,t){var n,a=e.days,i=e._upperDays;return i||(e._upperDays=i=[u(a.names),u(a.namesAbbr),u(a.namesShort)]),r=s(r),t?(n=l(i[1],r),-1===n&&(n=l(i[2],r))):n=l(i[0],r),n},t=function(e,r,t){var n=e.months,a=e.monthsGenitive||e.months,i=e._upperMonths,c=e._upperMonthsGen;i||(e._upperMonths=i=[u(n.names),u(n.namesAbbr)],e._upperMonthsGen=c=[u(a.names),u(a.namesAbbr)]),r=s(r);var o=l(t?i[1]:i[0],r);return 0>o&&(o=l(t?c[1]:c[0],r)),o},n=function(e,r){var t=e._parseRegExp;if(t){var n=t[r];if(n)return n}else e._parseRegExp=t={};for(var a,s=y(e,r).replace(/([\^\$\.\*\+\?\|\[\]\(\)\{\}])/g,"\\\\$1"),u=["^"],l=[],i=0,c=0,o=k();null!==(a=o.exec(s));){var f=s.slice(i,a.index);if(i=o.lastIndex,c+=m(f,u),c%2)u.push(a[0]);else{var d,p=a[0],h=p.length;switch(p){case"dddd":case"ddd":case"MMMM":case"MMM":case"gg":case"g":d="(\\D+)";break;case"tt":case"t":d="(\\D*)";break;case"yyyy":case"fff":case"ff":case"f":d="(\\d{"+h+"})";break;case"dd":case"d":case"MM":case"M":case"yy":case"y":case"HH":case"H":case"hh":case"h":case"mm":case"m":case"ss":case"s":d="(\\d\\d?)";break;case"zzz":d="([+-]?\\d\\d?:\\d{2})";break;case"zz":case"z":d="([+-]?\\d\\d?)";break;case"/":d="(\\/)";break;default:throw"Invalid date format pattern '"+p+"'."}d&&u.push(d),l.push(a[0])}}m(s.slice(i),u),u.push("$");var g=u.join("").replace(/\s+/g,"\\s+"),b={regExp:g,groups:l};return t[r]=b},a=function(e,r,t){return r>e||e>t},s=function(e){return e.split("\u00a0").join(" ").toUpperCase()},u=function(e){for(var r=[],t=0,n=e.length;n>t;t++)r[t]=s(e[t]);return r},A=function(s,u,l){s=h(s);var i=l.calendar,c=n(i,u),o=RegExp(c.regExp).exec(s);if(null===o)return null;for(var f,d=c.groups,g=null,b=null,m=null,y=null,M=null,v=0,k=0,z=0,F=0,A=null,x=!1,I=0,S=d.length;S>I;I++){var w=o[I+1];if(w){var C=d[I],D=C.length,H=parseInt(w,10);switch(C){case"dd":case"d":if(y=H,a(y,1,31))return null;break;case"MMM":case"MMMM":if(m=t(i,w,3===D),a(m,0,11))return null;break;case"M":case"MM":if(m=H-1,a(m,0,11))return null;break;case"y":case"yy":case"yyyy":if(b=4>D?e(i,H):H,a(b,0,9999))return null;break;case"h":case"hh":if(v=H,12===v&&(v=0),a(v,0,11))return null;break;case"H":case"HH":if(v=H,a(v,0,23))return null;break;case"m":case"mm":if(k=H,a(k,0,59))return null;break;case"s":case"ss":if(z=H,a(z,0,59))return null;break;case"tt":case"t":if(x=i.PM&&(w===i.PM[0]||w===i.PM[1]||w===i.PM[2]),!x&&(!i.AM||w!==i.AM[0]&&w!==i.AM[1]&&w!==i.AM[2]))return null;break;case"f":case"ff":case"fff":if(F=H*Math.pow(10,3-D),a(F,0,999))return null;break;case"ddd":case"dddd":if(M=r(i,w,3===D),a(M,0,6))return null;break;case"zzz":var O=w.split(/:/);if(2!==O.length)return null;if(f=parseInt(O[0],10),a(f,-12,13))return null;var N=parseInt(O[1],10);if(a(N,0,59))return null;A=60*f+(p(w,"-")?-N:N);break;case"z":case"zz":if(f=H,a(f,-12,13))return null;A=60*f;break;case"g":case"gg":var T=w;if(!T||!i.eras)return null;T=h(T.toLowerCase());for(var j=0,$=i.eras.length;$>j;j++)if(T===i.eras[j].name.toLowerCase()){g=j;break}if(null===g)return null}}}var P,G=new Date,E=i.convert;if(P=E?E.fromGregorian(G)[0]:G.getFullYear(),null===b?b=P:i.eras&&(b+=i.eras[g||0].offset),null===m&&(m=0),null===y&&(y=1),E){if(G=E.toGregorian(b,m,y),null===G)return null}else{if(G.setFullYear(b,m,y),G.getDate()!==y)return null;if(null!==M&&G.getDay()!==M)return null}if(x&&12>v&&(v+=12),G.setHours(v,k,z,F),null!==A){var Y=G.getMinutes()-(A+G.getTimezoneOffset());G.setHours(G.getHours()+parseInt(Y/60,10),Y%60)}return G}}(),x=function(e,r,t){var n,a=r["-"],s=r["+"];switch(t){case"n -":a=" "+a,s=" "+s;case"n-":i(e,a)?n=["-",e.substr(0,e.length-a.length)]:i(e,s)&&(n=["+",e.substr(0,e.length-s.length)]);break;case"- n":a+=" ",s+=" ";case"-n":p(e,a)?n=["-",e.substr(a.length)]:p(e,s)&&(n=["+",e.substr(s.length)]);break;case"(n)":p(e,"(")&&i(e,")")&&(n=["-",e.substr(1,e.length-2)])}return n||["",e]},t.prototype.findClosestCulture=function(e){return t.findClosestCulture.call(this,e)},t.prototype.format=function(e,r,n){return t.format.call(this,e,r,n)},t.prototype.localize=function(e,r){return t.localize.call(this,e,r)},t.prototype.parseInt=function(e,r,n){return t.parseInt.call(this,e,r,n)},t.prototype.parseFloat=function(e,r,n){return t.parseFloat.call(this,e,r,n)},t.prototype.culture=function(e){return t.culture.call(this,e)},t.addCultureInfo=function(e,r,t){var n={},a=!1;"string"!=typeof e?(t=e,e=this.culture().name,n=this.cultures[e]):"string"!=typeof r?(t=r,a=null==this.cultures[e],n=this.cultures[e]||this.cultures["default"]):(a=!0,n=this.cultures[r]),this.cultures[e]=c(!0,{},n,t),a&&(this.cultures[e].calendar=this.cultures[e].calendars.standard)},t.findClosestCulture=function(e){var r;if(!e)return this.findClosestCulture(this.cultureSelector)||this.cultures["default"];if("string"==typeof e&&(e=e.split(",")),o(e)){var t,n,a=this.cultures,s=e,u=s.length,l=[];for(n=0;u>n;n++){e=h(s[n]);var i,c=e.split(";");t=h(c[0]),1===c.length?i=1:(e=h(c[1]),0===e.indexOf("q=")?(e=e.substr(2),i=parseFloat(e),i=isNaN(i)?0:i):i=1),l.push({lang:t,pri:i})}for(l.sort(function(e,r){return e.pri<r.pri?1:e.pri>r.pri?-1:0}),n=0;u>n;n++)if(t=l[n].lang,r=a[t])return r;for(n=0;u>n;n++)for(t=l[n].lang;;){var f=t.lastIndexOf("-");if(-1===f)break;if(t=t.substr(0,f),r=a[t])return r}for(n=0;u>n;n++){t=l[n].lang;for(var d in a){var p=a[d];if(p.language===t)return p}}}else if("object"==typeof e)return e;return r||null},t.format=function(e,r,t){var n=this.findClosestCulture(t);return e instanceof Date?e=M(e,r,n):"number"==typeof e&&(e=v(e,r,n)),e},t.localize=function(e,r){return this.findClosestCulture(r).messages[e]||this.cultures["default"].messages[e]},t.parseDate=function(e,r,t){t=this.findClosestCulture(t);var n,a,s;if(r){if("string"==typeof r&&(r=[r]),r.length)for(var u=0,l=r.length;l>u;u++){var i=r[u];if(i&&(n=A(e,i,t)))break}}else{s=t.calendar.patterns;for(a in s)if(n=A(e,s[a],t))break}return n||null},t.parseInt=function(e,r,n){return g(t.parseFloat(e,r,n))},t.parseFloat=function(e,r,t){"number"!=typeof r&&(t=r,r=10);var u=this.findClosestCulture(t),l=0/0,i=u.numberFormat;if(e.indexOf(u.numberFormat.currency.symbol)>-1&&(e=e.replace(u.numberFormat.currency.symbol,""),e=e.replace(u.numberFormat.currency["."],u.numberFormat["."])),e.indexOf(u.numberFormat.percent.symbol)>-1&&(e=e.replace(u.numberFormat.percent.symbol,"")),e=e.replace(/ /g,""),a.test(e))l=parseFloat(e);else if(!r&&n.test(e))l=parseInt(e,16);else{var c=x(e,i,i.pattern[0]),o=c[0],f=c[1];""===o&&"(n)"!==i.pattern[0]&&(c=x(e,i,"(n)"),o=c[0],f=c[1]),""===o&&"-n"!==i.pattern[0]&&(c=x(e,i,"-n"),o=c[0],f=c[1]),o=o||"+";var d,p,h=f.indexOf("e");0>h&&(h=f.indexOf("E")),0>h?(p=f,d=null):(p=f.substr(0,h),d=f.substr(h+1));var g,b,m=i["."],y=p.indexOf(m);0>y?(g=p,b=null):(g=p.substr(0,y),b=p.substr(y+m.length));var M=i[","];g=g.split(M).join("");var v=M.replace(/\u00A0/g," ");M!==v&&(g=g.split(v).join(""));var k=o+g;if(null!==b&&(k+="."+b),null!==d){var z=x(d,i,"-n");k+="e"+(z[0]||"+")+z[1]}s.test(k)&&(l=parseFloat(k))}return l},t.culture=function(e){return e!==r&&(this.cultureSelector=e),this.findClosestCulture(e)||this.cultures["default"]}; return Globalize;}(this));

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var es6_promise_1 = __webpack_require__(7);
	function shim() {
	    es6_promise_1.Promise.prototype['finally'] = function finallyPolyfill(callback) {
	        var constructor = this.constructor;
	        return this.then(function (value) {
	            return constructor.resolve(callback()).then(function () {
	                return value;
	            });
	        }, function (reason) {
	            return constructor.resolve(callback()).then(function () {
	                throw reason;
	            });
	        });
	    };
	    var rethrowError = function (self) {
	        self.then(null, function (err) {
	            setTimeout(function () {
	                throw err;
	            }, 0);
	        });
	    };
	    if (typeof es6_promise_1.Promise.prototype['done'] !== 'function') {
	        es6_promise_1.Promise.prototype['done'] = function (onFulfilled, onRejected) {
	            var self = arguments.length ? this.then.apply(this, arguments) : this;
	            rethrowError(self);
	            return this;
	        };
	    }
	    if (typeof es6_promise_1.Promise.prototype['fail'] !== 'function') {
	        es6_promise_1.Promise.prototype['fail'] = function (onFulfilled, onRejected) {
	            var self = arguments.length ? this.catch.apply(this, arguments) : this;
	            rethrowError(self);
	            return this;
	        };
	    }
	}
	exports.shim = shim;


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(process, global) {/*!
	 * @overview es6-promise - a tiny implementation of Promises/A+.
	 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
	 * @license   Licensed under MIT license
	 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
	 * @version   3.3.1
	 */
	
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.ES6Promise = factory());
	}(this, (function () { 'use strict';
	
	function objectOrFunction(x) {
	  return typeof x === 'function' || typeof x === 'object' && x !== null;
	}
	
	function isFunction(x) {
	  return typeof x === 'function';
	}
	
	var _isArray = undefined;
	if (!Array.isArray) {
	  _isArray = function (x) {
	    return Object.prototype.toString.call(x) === '[object Array]';
	  };
	} else {
	  _isArray = Array.isArray;
	}
	
	var isArray = _isArray;
	
	var len = 0;
	var vertxNext = undefined;
	var customSchedulerFn = undefined;
	
	var asap = function asap(callback, arg) {
	  queue[len] = callback;
	  queue[len + 1] = arg;
	  len += 2;
	  if (len === 2) {
	    // If len is 2, that means that we need to schedule an async flush.
	    // If additional callbacks are queued before the queue is flushed, they
	    // will be processed by this flush that we are scheduling.
	    if (customSchedulerFn) {
	      customSchedulerFn(flush);
	    } else {
	      scheduleFlush();
	    }
	  }
	};
	
	function setScheduler(scheduleFn) {
	  customSchedulerFn = scheduleFn;
	}
	
	function setAsap(asapFn) {
	  asap = asapFn;
	}
	
	var browserWindow = typeof window !== 'undefined' ? window : undefined;
	var browserGlobal = browserWindow || {};
	var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
	var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && ({}).toString.call(process) === '[object process]';
	
	// test for web worker but not in IE10
	var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';
	
	// node
	function useNextTick() {
	  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
	  // see https://github.com/cujojs/when/issues/410 for details
	  return function () {
	    return process.nextTick(flush);
	  };
	}
	
	// vertx
	function useVertxTimer() {
	  return function () {
	    vertxNext(flush);
	  };
	}
	
	function useMutationObserver() {
	  var iterations = 0;
	  var observer = new BrowserMutationObserver(flush);
	  var node = document.createTextNode('');
	  observer.observe(node, { characterData: true });
	
	  return function () {
	    node.data = iterations = ++iterations % 2;
	  };
	}
	
	// web worker
	function useMessageChannel() {
	  var channel = new MessageChannel();
	  channel.port1.onmessage = flush;
	  return function () {
	    return channel.port2.postMessage(0);
	  };
	}
	
	function useSetTimeout() {
	  // Store setTimeout reference so es6-promise will be unaffected by
	  // other code modifying setTimeout (like sinon.useFakeTimers())
	  var globalSetTimeout = setTimeout;
	  return function () {
	    return globalSetTimeout(flush, 1);
	  };
	}
	
	var queue = new Array(1000);
	function flush() {
	  for (var i = 0; i < len; i += 2) {
	    var callback = queue[i];
	    var arg = queue[i + 1];
	
	    callback(arg);
	
	    queue[i] = undefined;
	    queue[i + 1] = undefined;
	  }
	
	  len = 0;
	}
	
	function attemptVertx() {
	  try {
	    var r = require;
	    var vertx = __webpack_require__(9);
	    vertxNext = vertx.runOnLoop || vertx.runOnContext;
	    return useVertxTimer();
	  } catch (e) {
	    return useSetTimeout();
	  }
	}
	
	var scheduleFlush = undefined;
	// Decide what async method to use to triggering processing of queued callbacks:
	if (isNode) {
	  scheduleFlush = useNextTick();
	} else if (BrowserMutationObserver) {
	  scheduleFlush = useMutationObserver();
	} else if (isWorker) {
	  scheduleFlush = useMessageChannel();
	} else if (browserWindow === undefined && "function" === 'function') {
	  scheduleFlush = attemptVertx();
	} else {
	  scheduleFlush = useSetTimeout();
	}
	
	function then(onFulfillment, onRejection) {
	  var _arguments = arguments;
	
	  var parent = this;
	
	  var child = new this.constructor(noop);
	
	  if (child[PROMISE_ID] === undefined) {
	    makePromise(child);
	  }
	
	  var _state = parent._state;
	
	  if (_state) {
	    (function () {
	      var callback = _arguments[_state - 1];
	      asap(function () {
	        return invokeCallback(_state, child, callback, parent._result);
	      });
	    })();
	  } else {
	    subscribe(parent, child, onFulfillment, onRejection);
	  }
	
	  return child;
	}
	
	/**
	  `Promise.resolve` returns a promise that will become resolved with the
	  passed `value`. It is shorthand for the following:
	
	  ```javascript
	  let promise = new Promise(function(resolve, reject){
	    resolve(1);
	  });
	
	  promise.then(function(value){
	    // value === 1
	  });
	  ```
	
	  Instead of writing the above, your code now simply becomes the following:
	
	  ```javascript
	  let promise = Promise.resolve(1);
	
	  promise.then(function(value){
	    // value === 1
	  });
	  ```
	
	  @method resolve
	  @static
	  @param {Any} value value that the returned promise will be resolved with
	  Useful for tooling.
	  @return {Promise} a promise that will become fulfilled with the given
	  `value`
	*/
	function resolve(object) {
	  /*jshint validthis:true */
	  var Constructor = this;
	
	  if (object && typeof object === 'object' && object.constructor === Constructor) {
	    return object;
	  }
	
	  var promise = new Constructor(noop);
	  _resolve(promise, object);
	  return promise;
	}
	
	var PROMISE_ID = Math.random().toString(36).substring(16);
	
	function noop() {}
	
	var PENDING = void 0;
	var FULFILLED = 1;
	var REJECTED = 2;
	
	var GET_THEN_ERROR = new ErrorObject();
	
	function selfFulfillment() {
	  return new TypeError("You cannot resolve a promise with itself");
	}
	
	function cannotReturnOwn() {
	  return new TypeError('A promises callback cannot return that same promise.');
	}
	
	function getThen(promise) {
	  try {
	    return promise.then;
	  } catch (error) {
	    GET_THEN_ERROR.error = error;
	    return GET_THEN_ERROR;
	  }
	}
	
	function tryThen(then, value, fulfillmentHandler, rejectionHandler) {
	  try {
	    then.call(value, fulfillmentHandler, rejectionHandler);
	  } catch (e) {
	    return e;
	  }
	}
	
	function handleForeignThenable(promise, thenable, then) {
	  asap(function (promise) {
	    var sealed = false;
	    var error = tryThen(then, thenable, function (value) {
	      if (sealed) {
	        return;
	      }
	      sealed = true;
	      if (thenable !== value) {
	        _resolve(promise, value);
	      } else {
	        fulfill(promise, value);
	      }
	    }, function (reason) {
	      if (sealed) {
	        return;
	      }
	      sealed = true;
	
	      _reject(promise, reason);
	    }, 'Settle: ' + (promise._label || ' unknown promise'));
	
	    if (!sealed && error) {
	      sealed = true;
	      _reject(promise, error);
	    }
	  }, promise);
	}
	
	function handleOwnThenable(promise, thenable) {
	  if (thenable._state === FULFILLED) {
	    fulfill(promise, thenable._result);
	  } else if (thenable._state === REJECTED) {
	    _reject(promise, thenable._result);
	  } else {
	    subscribe(thenable, undefined, function (value) {
	      return _resolve(promise, value);
	    }, function (reason) {
	      return _reject(promise, reason);
	    });
	  }
	}
	
	function handleMaybeThenable(promise, maybeThenable, then$$) {
	  if (maybeThenable.constructor === promise.constructor && then$$ === then && maybeThenable.constructor.resolve === resolve) {
	    handleOwnThenable(promise, maybeThenable);
	  } else {
	    if (then$$ === GET_THEN_ERROR) {
	      _reject(promise, GET_THEN_ERROR.error);
	    } else if (then$$ === undefined) {
	      fulfill(promise, maybeThenable);
	    } else if (isFunction(then$$)) {
	      handleForeignThenable(promise, maybeThenable, then$$);
	    } else {
	      fulfill(promise, maybeThenable);
	    }
	  }
	}
	
	function _resolve(promise, value) {
	  if (promise === value) {
	    _reject(promise, selfFulfillment());
	  } else if (objectOrFunction(value)) {
	    handleMaybeThenable(promise, value, getThen(value));
	  } else {
	    fulfill(promise, value);
	  }
	}
	
	function publishRejection(promise) {
	  if (promise._onerror) {
	    promise._onerror(promise._result);
	  }
	
	  publish(promise);
	}
	
	function fulfill(promise, value) {
	  if (promise._state !== PENDING) {
	    return;
	  }
	
	  promise._result = value;
	  promise._state = FULFILLED;
	
	  if (promise._subscribers.length !== 0) {
	    asap(publish, promise);
	  }
	}
	
	function _reject(promise, reason) {
	  if (promise._state !== PENDING) {
	    return;
	  }
	  promise._state = REJECTED;
	  promise._result = reason;
	
	  asap(publishRejection, promise);
	}
	
	function subscribe(parent, child, onFulfillment, onRejection) {
	  var _subscribers = parent._subscribers;
	  var length = _subscribers.length;
	
	  parent._onerror = null;
	
	  _subscribers[length] = child;
	  _subscribers[length + FULFILLED] = onFulfillment;
	  _subscribers[length + REJECTED] = onRejection;
	
	  if (length === 0 && parent._state) {
	    asap(publish, parent);
	  }
	}
	
	function publish(promise) {
	  var subscribers = promise._subscribers;
	  var settled = promise._state;
	
	  if (subscribers.length === 0) {
	    return;
	  }
	
	  var child = undefined,
	      callback = undefined,
	      detail = promise._result;
	
	  for (var i = 0; i < subscribers.length; i += 3) {
	    child = subscribers[i];
	    callback = subscribers[i + settled];
	
	    if (child) {
	      invokeCallback(settled, child, callback, detail);
	    } else {
	      callback(detail);
	    }
	  }
	
	  promise._subscribers.length = 0;
	}
	
	function ErrorObject() {
	  this.error = null;
	}
	
	var TRY_CATCH_ERROR = new ErrorObject();
	
	function tryCatch(callback, detail) {
	  try {
	    return callback(detail);
	  } catch (e) {
	    TRY_CATCH_ERROR.error = e;
	    return TRY_CATCH_ERROR;
	  }
	}
	
	function invokeCallback(settled, promise, callback, detail) {
	  var hasCallback = isFunction(callback),
	      value = undefined,
	      error = undefined,
	      succeeded = undefined,
	      failed = undefined;
	
	  if (hasCallback) {
	    value = tryCatch(callback, detail);
	
	    if (value === TRY_CATCH_ERROR) {
	      failed = true;
	      error = value.error;
	      value = null;
	    } else {
	      succeeded = true;
	    }
	
	    if (promise === value) {
	      _reject(promise, cannotReturnOwn());
	      return;
	    }
	  } else {
	    value = detail;
	    succeeded = true;
	  }
	
	  if (promise._state !== PENDING) {
	    // noop
	  } else if (hasCallback && succeeded) {
	      _resolve(promise, value);
	    } else if (failed) {
	      _reject(promise, error);
	    } else if (settled === FULFILLED) {
	      fulfill(promise, value);
	    } else if (settled === REJECTED) {
	      _reject(promise, value);
	    }
	}
	
	function initializePromise(promise, resolver) {
	  try {
	    resolver(function resolvePromise(value) {
	      _resolve(promise, value);
	    }, function rejectPromise(reason) {
	      _reject(promise, reason);
	    });
	  } catch (e) {
	    _reject(promise, e);
	  }
	}
	
	var id = 0;
	function nextId() {
	  return id++;
	}
	
	function makePromise(promise) {
	  promise[PROMISE_ID] = id++;
	  promise._state = undefined;
	  promise._result = undefined;
	  promise._subscribers = [];
	}
	
	function Enumerator(Constructor, input) {
	  this._instanceConstructor = Constructor;
	  this.promise = new Constructor(noop);
	
	  if (!this.promise[PROMISE_ID]) {
	    makePromise(this.promise);
	  }
	
	  if (isArray(input)) {
	    this._input = input;
	    this.length = input.length;
	    this._remaining = input.length;
	
	    this._result = new Array(this.length);
	
	    if (this.length === 0) {
	      fulfill(this.promise, this._result);
	    } else {
	      this.length = this.length || 0;
	      this._enumerate();
	      if (this._remaining === 0) {
	        fulfill(this.promise, this._result);
	      }
	    }
	  } else {
	    _reject(this.promise, validationError());
	  }
	}
	
	function validationError() {
	  return new Error('Array Methods must be provided an Array');
	};
	
	Enumerator.prototype._enumerate = function () {
	  var length = this.length;
	  var _input = this._input;
	
	  for (var i = 0; this._state === PENDING && i < length; i++) {
	    this._eachEntry(_input[i], i);
	  }
	};
	
	Enumerator.prototype._eachEntry = function (entry, i) {
	  var c = this._instanceConstructor;
	  var resolve$$ = c.resolve;
	
	  if (resolve$$ === resolve) {
	    var _then = getThen(entry);
	
	    if (_then === then && entry._state !== PENDING) {
	      this._settledAt(entry._state, i, entry._result);
	    } else if (typeof _then !== 'function') {
	      this._remaining--;
	      this._result[i] = entry;
	    } else if (c === Promise) {
	      var promise = new c(noop);
	      handleMaybeThenable(promise, entry, _then);
	      this._willSettleAt(promise, i);
	    } else {
	      this._willSettleAt(new c(function (resolve$$) {
	        return resolve$$(entry);
	      }), i);
	    }
	  } else {
	    this._willSettleAt(resolve$$(entry), i);
	  }
	};
	
	Enumerator.prototype._settledAt = function (state, i, value) {
	  var promise = this.promise;
	
	  if (promise._state === PENDING) {
	    this._remaining--;
	
	    if (state === REJECTED) {
	      _reject(promise, value);
	    } else {
	      this._result[i] = value;
	    }
	  }
	
	  if (this._remaining === 0) {
	    fulfill(promise, this._result);
	  }
	};
	
	Enumerator.prototype._willSettleAt = function (promise, i) {
	  var enumerator = this;
	
	  subscribe(promise, undefined, function (value) {
	    return enumerator._settledAt(FULFILLED, i, value);
	  }, function (reason) {
	    return enumerator._settledAt(REJECTED, i, reason);
	  });
	};
	
	/**
	  `Promise.all` accepts an array of promises, and returns a new promise which
	  is fulfilled with an array of fulfillment values for the passed promises, or
	  rejected with the reason of the first passed promise to be rejected. It casts all
	  elements of the passed iterable to promises as it runs this algorithm.
	
	  Example:
	
	  ```javascript
	  let promise1 = resolve(1);
	  let promise2 = resolve(2);
	  let promise3 = resolve(3);
	  let promises = [ promise1, promise2, promise3 ];
	
	  Promise.all(promises).then(function(array){
	    // The array here would be [ 1, 2, 3 ];
	  });
	  ```
	
	  If any of the `promises` given to `all` are rejected, the first promise
	  that is rejected will be given as an argument to the returned promises's
	  rejection handler. For example:
	
	  Example:
	
	  ```javascript
	  let promise1 = resolve(1);
	  let promise2 = reject(new Error("2"));
	  let promise3 = reject(new Error("3"));
	  let promises = [ promise1, promise2, promise3 ];
	
	  Promise.all(promises).then(function(array){
	    // Code here never runs because there are rejected promises!
	  }, function(error) {
	    // error.message === "2"
	  });
	  ```
	
	  @method all
	  @static
	  @param {Array} entries array of promises
	  @param {String} label optional string for labeling the promise.
	  Useful for tooling.
	  @return {Promise} promise that is fulfilled when all `promises` have been
	  fulfilled, or rejected if any of them become rejected.
	  @static
	*/
	function all(entries) {
	  return new Enumerator(this, entries).promise;
	}
	
	/**
	  `Promise.race` returns a new promise which is settled in the same way as the
	  first passed promise to settle.
	
	  Example:
	
	  ```javascript
	  let promise1 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 1');
	    }, 200);
	  });
	
	  let promise2 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 2');
	    }, 100);
	  });
	
	  Promise.race([promise1, promise2]).then(function(result){
	    // result === 'promise 2' because it was resolved before promise1
	    // was resolved.
	  });
	  ```
	
	  `Promise.race` is deterministic in that only the state of the first
	  settled promise matters. For example, even if other promises given to the
	  `promises` array argument are resolved, but the first settled promise has
	  become rejected before the other promises became fulfilled, the returned
	  promise will become rejected:
	
	  ```javascript
	  let promise1 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 1');
	    }, 200);
	  });
	
	  let promise2 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      reject(new Error('promise 2'));
	    }, 100);
	  });
	
	  Promise.race([promise1, promise2]).then(function(result){
	    // Code here never runs
	  }, function(reason){
	    // reason.message === 'promise 2' because promise 2 became rejected before
	    // promise 1 became fulfilled
	  });
	  ```
	
	  An example real-world use case is implementing timeouts:
	
	  ```javascript
	  Promise.race([ajax('foo.json'), timeout(5000)])
	  ```
	
	  @method race
	  @static
	  @param {Array} promises array of promises to observe
	  Useful for tooling.
	  @return {Promise} a promise which settles in the same way as the first passed
	  promise to settle.
	*/
	function race(entries) {
	  /*jshint validthis:true */
	  var Constructor = this;
	
	  if (!isArray(entries)) {
	    return new Constructor(function (_, reject) {
	      return reject(new TypeError('You must pass an array to race.'));
	    });
	  } else {
	    return new Constructor(function (resolve, reject) {
	      var length = entries.length;
	      for (var i = 0; i < length; i++) {
	        Constructor.resolve(entries[i]).then(resolve, reject);
	      }
	    });
	  }
	}
	
	/**
	  `Promise.reject` returns a promise rejected with the passed `reason`.
	  It is shorthand for the following:
	
	  ```javascript
	  let promise = new Promise(function(resolve, reject){
	    reject(new Error('WHOOPS'));
	  });
	
	  promise.then(function(value){
	    // Code here doesn't run because the promise is rejected!
	  }, function(reason){
	    // reason.message === 'WHOOPS'
	  });
	  ```
	
	  Instead of writing the above, your code now simply becomes the following:
	
	  ```javascript
	  let promise = Promise.reject(new Error('WHOOPS'));
	
	  promise.then(function(value){
	    // Code here doesn't run because the promise is rejected!
	  }, function(reason){
	    // reason.message === 'WHOOPS'
	  });
	  ```
	
	  @method reject
	  @static
	  @param {Any} reason value that the returned promise will be rejected with.
	  Useful for tooling.
	  @return {Promise} a promise rejected with the given `reason`.
	*/
	function reject(reason) {
	  /*jshint validthis:true */
	  var Constructor = this;
	  var promise = new Constructor(noop);
	  _reject(promise, reason);
	  return promise;
	}
	
	function needsResolver() {
	  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
	}
	
	function needsNew() {
	  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
	}
	
	/**
	  Promise objects represent the eventual result of an asynchronous operation. The
	  primary way of interacting with a promise is through its `then` method, which
	  registers callbacks to receive either a promise's eventual value or the reason
	  why the promise cannot be fulfilled.
	
	  Terminology
	  -----------
	
	  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
	  - `thenable` is an object or function that defines a `then` method.
	  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
	  - `exception` is a value that is thrown using the throw statement.
	  - `reason` is a value that indicates why a promise was rejected.
	  - `settled` the final resting state of a promise, fulfilled or rejected.
	
	  A promise can be in one of three states: pending, fulfilled, or rejected.
	
	  Promises that are fulfilled have a fulfillment value and are in the fulfilled
	  state.  Promises that are rejected have a rejection reason and are in the
	  rejected state.  A fulfillment value is never a thenable.
	
	  Promises can also be said to *resolve* a value.  If this value is also a
	  promise, then the original promise's settled state will match the value's
	  settled state.  So a promise that *resolves* a promise that rejects will
	  itself reject, and a promise that *resolves* a promise that fulfills will
	  itself fulfill.
	
	
	  Basic Usage:
	  ------------
	
	  ```js
	  let promise = new Promise(function(resolve, reject) {
	    // on success
	    resolve(value);
	
	    // on failure
	    reject(reason);
	  });
	
	  promise.then(function(value) {
	    // on fulfillment
	  }, function(reason) {
	    // on rejection
	  });
	  ```
	
	  Advanced Usage:
	  ---------------
	
	  Promises shine when abstracting away asynchronous interactions such as
	  `XMLHttpRequest`s.
	
	  ```js
	  function getJSON(url) {
	    return new Promise(function(resolve, reject){
	      let xhr = new XMLHttpRequest();
	
	      xhr.open('GET', url);
	      xhr.onreadystatechange = handler;
	      xhr.responseType = 'json';
	      xhr.setRequestHeader('Accept', 'application/json');
	      xhr.send();
	
	      function handler() {
	        if (this.readyState === this.DONE) {
	          if (this.status === 200) {
	            resolve(this.response);
	          } else {
	            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
	          }
	        }
	      };
	    });
	  }
	
	  getJSON('/posts.json').then(function(json) {
	    // on fulfillment
	  }, function(reason) {
	    // on rejection
	  });
	  ```
	
	  Unlike callbacks, promises are great composable primitives.
	
	  ```js
	  Promise.all([
	    getJSON('/posts'),
	    getJSON('/comments')
	  ]).then(function(values){
	    values[0] // => postsJSON
	    values[1] // => commentsJSON
	
	    return values;
	  });
	  ```
	
	  @class Promise
	  @param {function} resolver
	  Useful for tooling.
	  @constructor
	*/
	function Promise(resolver) {
	  this[PROMISE_ID] = nextId();
	  this._result = this._state = undefined;
	  this._subscribers = [];
	
	  if (noop !== resolver) {
	    typeof resolver !== 'function' && needsResolver();
	    this instanceof Promise ? initializePromise(this, resolver) : needsNew();
	  }
	}
	
	Promise.all = all;
	Promise.race = race;
	Promise.resolve = resolve;
	Promise.reject = reject;
	Promise._setScheduler = setScheduler;
	Promise._setAsap = setAsap;
	Promise._asap = asap;
	
	Promise.prototype = {
	  constructor: Promise,
	
	  /**
	    The primary way of interacting with a promise is through its `then` method,
	    which registers callbacks to receive either a promise's eventual value or the
	    reason why the promise cannot be fulfilled.
	  
	    ```js
	    findUser().then(function(user){
	      // user is available
	    }, function(reason){
	      // user is unavailable, and you are given the reason why
	    });
	    ```
	  
	    Chaining
	    --------
	  
	    The return value of `then` is itself a promise.  This second, 'downstream'
	    promise is resolved with the return value of the first promise's fulfillment
	    or rejection handler, or rejected if the handler throws an exception.
	  
	    ```js
	    findUser().then(function (user) {
	      return user.name;
	    }, function (reason) {
	      return 'default name';
	    }).then(function (userName) {
	      // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
	      // will be `'default name'`
	    });
	  
	    findUser().then(function (user) {
	      throw new Error('Found user, but still unhappy');
	    }, function (reason) {
	      throw new Error('`findUser` rejected and we're unhappy');
	    }).then(function (value) {
	      // never reached
	    }, function (reason) {
	      // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
	      // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
	    });
	    ```
	    If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
	  
	    ```js
	    findUser().then(function (user) {
	      throw new PedagogicalException('Upstream error');
	    }).then(function (value) {
	      // never reached
	    }).then(function (value) {
	      // never reached
	    }, function (reason) {
	      // The `PedgagocialException` is propagated all the way down to here
	    });
	    ```
	  
	    Assimilation
	    ------------
	  
	    Sometimes the value you want to propagate to a downstream promise can only be
	    retrieved asynchronously. This can be achieved by returning a promise in the
	    fulfillment or rejection handler. The downstream promise will then be pending
	    until the returned promise is settled. This is called *assimilation*.
	  
	    ```js
	    findUser().then(function (user) {
	      return findCommentsByAuthor(user);
	    }).then(function (comments) {
	      // The user's comments are now available
	    });
	    ```
	  
	    If the assimliated promise rejects, then the downstream promise will also reject.
	  
	    ```js
	    findUser().then(function (user) {
	      return findCommentsByAuthor(user);
	    }).then(function (comments) {
	      // If `findCommentsByAuthor` fulfills, we'll have the value here
	    }, function (reason) {
	      // If `findCommentsByAuthor` rejects, we'll have the reason here
	    });
	    ```
	  
	    Simple Example
	    --------------
	  
	    Synchronous Example
	  
	    ```javascript
	    let result;
	  
	    try {
	      result = findResult();
	      // success
	    } catch(reason) {
	      // failure
	    }
	    ```
	  
	    Errback Example
	  
	    ```js
	    findResult(function(result, err){
	      if (err) {
	        // failure
	      } else {
	        // success
	      }
	    });
	    ```
	  
	    Promise Example;
	  
	    ```javascript
	    findResult().then(function(result){
	      // success
	    }, function(reason){
	      // failure
	    });
	    ```
	  
	    Advanced Example
	    --------------
	  
	    Synchronous Example
	  
	    ```javascript
	    let author, books;
	  
	    try {
	      author = findAuthor();
	      books  = findBooksByAuthor(author);
	      // success
	    } catch(reason) {
	      // failure
	    }
	    ```
	  
	    Errback Example
	  
	    ```js
	  
	    function foundBooks(books) {
	  
	    }
	  
	    function failure(reason) {
	  
	    }
	  
	    findAuthor(function(author, err){
	      if (err) {
	        failure(err);
	        // failure
	      } else {
	        try {
	          findBoooksByAuthor(author, function(books, err) {
	            if (err) {
	              failure(err);
	            } else {
	              try {
	                foundBooks(books);
	              } catch(reason) {
	                failure(reason);
	              }
	            }
	          });
	        } catch(error) {
	          failure(err);
	        }
	        // success
	      }
	    });
	    ```
	  
	    Promise Example;
	  
	    ```javascript
	    findAuthor().
	      then(findBooksByAuthor).
	      then(function(books){
	        // found books
	    }).catch(function(reason){
	      // something went wrong
	    });
	    ```
	  
	    @method then
	    @param {Function} onFulfilled
	    @param {Function} onRejected
	    Useful for tooling.
	    @return {Promise}
	  */
	  then: then,
	
	  /**
	    `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
	    as the catch block of a try/catch statement.
	  
	    ```js
	    function findAuthor(){
	      throw new Error('couldn't find that author');
	    }
	  
	    // synchronous
	    try {
	      findAuthor();
	    } catch(reason) {
	      // something went wrong
	    }
	  
	    // async with promises
	    findAuthor().catch(function(reason){
	      // something went wrong
	    });
	    ```
	  
	    @method catch
	    @param {Function} onRejection
	    Useful for tooling.
	    @return {Promise}
	  */
	  'catch': function _catch(onRejection) {
	    return this.then(null, onRejection);
	  }
	};
	
	function polyfill() {
	    var local = undefined;
	
	    if (typeof global !== 'undefined') {
	        local = global;
	    } else if (typeof self !== 'undefined') {
	        local = self;
	    } else {
	        try {
	            local = Function('return this')();
	        } catch (e) {
	            throw new Error('polyfill failed because global object is unavailable in this environment');
	        }
	    }
	
	    var P = local.Promise;
	
	    if (P) {
	        var promiseToString = null;
	        try {
	            promiseToString = Object.prototype.toString.call(P.resolve());
	        } catch (e) {
	            // silently ignored
	        }
	
	        if (promiseToString === '[object Promise]' && !P.cast) {
	            return;
	        }
	    }
	
	    local.Promise = Promise;
	}
	
	polyfill();
	// Strange compat..
	Promise.polyfill = polyfill;
	Promise.Promise = Promise;
	
	return Promise;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8), (function() { return this; }())))

/***/ },
/* 8 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 9 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 10 */
/***/ function(module, exports) {

	"use strict";
	// CustomEvent polyfill from MDN
	// https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#Polyfill
	function customEventPolyfill() {
	    // window.CustomEvent is missing from the definitions
	    if (typeof window.CustomEvent === 'function') {
	        return;
	    }
	    var CustomEvent = function (event, params) {
	        params = params || { bubbles: false, cancelable: false, detail: undefined };
	        var customEvent = document.createEvent('CustomEvent');
	        customEvent.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
	        return customEvent;
	    };
	    // window.Event is specific to IE
	    CustomEvent.prototype = window.Event.prototype;
	    window.CustomEvent = CustomEvent;
	}
	exports.customEventPolyfill = customEventPolyfill;


/***/ },
/* 11 */
/***/ function(module, exports) {

	"use strict";
	exports.version = {
	    'lib': '1.1550.11',
	    'product': '1.1550.11',
	    'supportedApiVersion': 2
	};


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var EndpointCaller_1 = __webpack_require__(15);
	var Logger_1 = __webpack_require__(16);
	var Assert_1 = __webpack_require__(17);
	var Version_1 = __webpack_require__(11);
	var AjaxError_1 = __webpack_require__(21);
	var MissingAuthenticationError_1 = __webpack_require__(22);
	var QueryUtils_1 = __webpack_require__(23);
	var QueryError_1 = __webpack_require__(24);
	var Utils_1 = __webpack_require__(18);
	var es6_promise_1 = __webpack_require__(7);
	var DefaultSearchEndpointOptions = (function () {
	    function DefaultSearchEndpointOptions() {
	        this.version = 'v2';
	        this.queryStringArguments = {};
	        this.anonymous = false;
	        this.isGuestUser = false;
	    }
	    return DefaultSearchEndpointOptions;
	}());
	exports.DefaultSearchEndpointOptions = DefaultSearchEndpointOptions;
	/**
	 * A search endpoint allows to execute letious actions against the Coveo Search API and index.<br/>
	 * For example, you can search, list field values, get the quickview content for a document, etc.<br/>
	 * Any actions that you execute using this class will not trigger a full query cycle for the Coveo components.<br/>
	 * This is because this class will not trigger any query events directly.<br/>
	 * If you wish to execute a query that all components will react to (and trigger the corresponding query events), use the {@link QueryController}
	 */
	var SearchEndpoint = (function () {
	    /**
	     * Create a new SearchEndpoint.<br/>
	     * Will use a set of sane default options, and merge them with the options parameter.<br/>
	     * Will create an {@link EndpointCaller} and use it to communicate with the endpoint internally
	     * @param options
	     */
	    function SearchEndpoint(options) {
	        var _this = this;
	        this.options = options;
	        Assert_1.Assert.exists(options);
	        Assert_1.Assert.exists(options.restUri);
	        // For backward compatibility, we set anonymous to true when an access token
	        // is specified on a page loaded through the filesystem. This causes withCredentials
	        // to NOT be set, allowing those pages to work with non Windows/Basic/Cookie
	        // authentication. If anonymous is explicitly set to false, we'll use withCredentials.
	        var defaultOptions = new DefaultSearchEndpointOptions();
	        defaultOptions.anonymous = window.location.href.indexOf('file://') == 0 && Utils_1.Utils.isNonEmptyString(options.accessToken);
	        this.options = _.extend({}, defaultOptions, options);
	        // Forward any debug=1 query argument to the REST API to ease debugging
	        if (SearchEndpoint.isDebugArgumentPresent()) {
	            this.options.queryStringArguments['debug'] = 1;
	        }
	        this.onUnload = function () {
	            _this.handleUnload();
	        };
	        window.addEventListener('beforeunload', this.onUnload);
	        this.logger = new Logger_1.Logger(this);
	        this.createEndpointCaller();
	    }
	    /**
	     * Configure an endpoint that will point to a Coveo Cloud index, which contains a set of public sources with no security on them.<br/>
	     * Used for demo purposes and ease of setup.
	     * @param otherOptions A set of additional options to use when configuring this endpoint
	     */
	    SearchEndpoint.configureSampleEndpoint = function (otherOptions) {
	        if (SearchEndpoint.isUseLocalArgumentPresent()) {
	            // This is a handy flag to quickly test a local search API and alerts
	            SearchEndpoint.endpoints['default'] = new SearchEndpoint(_.extend({
	                restUri: 'http://localhost:8100/rest/search',
	                searchAlertsUri: 'http://localhost:8088/rest/search/alerts/'
	            }, otherOptions));
	        }
	        else {
	            // This OAuth token points to the organization used for samples.
	            // It contains a set of harmless content sources.
	            SearchEndpoint.endpoints['default'] = new SearchEndpoint(_.extend({
	                restUri: 'https://cloudplatform.coveo.com/rest/search',
	                accessToken: '52d806a2-0f64-4390-a3f2-e0f41a4a73ec'
	            }, otherOptions));
	        }
	    };
	    /**
	     * Configure an endpoint that will point to a Coveo Cloud index V2, which contains a set of public sources with no security on them.<br/>
	     * Used for demo purposes and ease of setup.
	     * @param otherOptions A set of additional options to use when configuring this endpoint
	     */
	    SearchEndpoint.configureSampleEndpointV2 = function (optionsOPtions) {
	        SearchEndpoint.endpoints['default'] = new SearchEndpoint(_.extend({
	            restUri: 'https://platform.cloud.coveo.com/rest/search',
	            accessToken: 'xx564559b1-0045-48e1-953c-3addd1ee4457',
	            queryStringArguments: {
	                organizationID: 'searchuisamples'
	            }
	        }));
	    };
	    /**
	     * Configure an endpoint to a Coveo Cloud index.
	     * @param organization The organization id of your Coveo cloud index
	     * @param token The token to use to execute query. If null, you will most probably need to login when querying.
	     * @param uri The uri of your cloud Search API. By default, will point to the production environment
	     * @param otherOptions A set of additional options to use when configuring this endpoint
	     */
	    SearchEndpoint.configureCloudEndpoint = function (organization, token, uri, otherOptions) {
	        if (uri === void 0) { uri = 'https://cloudplatform.coveo.com/rest/search'; }
	        var options = {
	            restUri: uri,
	            accessToken: token,
	            queryStringArguments: { organizationId: organization }
	        };
	        var merged = SearchEndpoint.mergeConfigOptions(options, otherOptions);
	        SearchEndpoint.endpoints['default'] = new SearchEndpoint(SearchEndpoint.removeUndefinedConfigOption(merged));
	    };
	    SearchEndpoint.configureCloudV2Endpoint = function (organization, token, uri, otherOptions) {
	        if (uri === void 0) { uri = 'https://platform.cloud.coveo.com/rest/search'; }
	        return SearchEndpoint.configureCloudEndpoint(organization, token, uri, otherOptions);
	    };
	    /**
	     * Configure an endpoint to a Coveo on premise index.
	     * @param uri The uri of your Coveo Search API endpoint. eg : http://myserver:8080/rest/search
	     * @param token The token to use to execute query. If null, you will most probably need to login when querying (unless the search api is configured using advanced auth options, like windows auth or claims)
	     * @param otherOptions A set of additional options to use when configuring this endpoint
	     */
	    SearchEndpoint.configureOnPremiseEndpoint = function (uri, token, otherOptions) {
	        var merged = SearchEndpoint.mergeConfigOptions({
	            restUri: uri,
	            accessToken: token
	        }, otherOptions);
	        SearchEndpoint.endpoints['default'] = new SearchEndpoint(SearchEndpoint.removeUndefinedConfigOption(merged));
	    };
	    SearchEndpoint.removeUndefinedConfigOption = function (config) {
	        _.each(_.keys(config), function (key) {
	            if (config[key] == undefined) {
	                delete config[key];
	            }
	        });
	        return config;
	    };
	    SearchEndpoint.mergeConfigOptions = function (first, second) {
	        first = SearchEndpoint.removeUndefinedConfigOption(first);
	        second = SearchEndpoint.removeUndefinedConfigOption(second);
	        return _.extend({}, first, second);
	    };
	    SearchEndpoint.prototype.reset = function () {
	        this.createEndpointCaller();
	    };
	    /**
	     * Set a function which will allow external code to modify all endpoint call parameters before they are sent by the browser.
	     *
	     * Used in very specific scenario where the network infrastructure require special request headers to be added or removed, for example.
	     * @param requestModifier
	     */
	    SearchEndpoint.prototype.setRequestModifier = function (requestModifier) {
	        this.caller.options.requestModifier = requestModifier;
	    };
	    /**
	     * Return the base uri of the endpoint to perform search
	     * @returns {string}
	     */
	    SearchEndpoint.prototype.getBaseUri = function () {
	        return this.buildBaseUri('');
	    };
	    /**
	     * Return the base uri of the endpoint for search alert
	     * @returns {string}
	     */
	    SearchEndpoint.prototype.getBaseAlertsUri = function () {
	        return this.buildSearchAlertsUri('');
	    };
	    /**
	     * Get the uri that can be used to authenticate against the given provider
	     * @param provider The provider name
	     * @param returnUri The uri at which to return after the authentication is completed
	     * @param message The message for authentication
	     * @param callOptions Additional set of options to use for this call.
	     * @param callParams Options injected by the applied decorators.
	     * @returns {string}
	     */
	    SearchEndpoint.prototype.getAuthenticationProviderUri = function (provider, returnUri, message, callOptions, callParams) {
	        var queryString = this.buildBaseQueryString(callOptions);
	        callParams.queryString = callParams.queryString.concat(queryString);
	        callParams.url += provider + '?';
	        if (Utils_1.Utils.isNonEmptyString(returnUri)) {
	            callParams.url += 'redirectUri=' + encodeURIComponent(returnUri) + '&';
	        }
	        else if (Utils_1.Utils.isNonEmptyString(message)) {
	            callParams.url += 'message=' + encodeURIComponent(message) + '&';
	        }
	        callParams.url += callParams.queryString.join('&');
	        return callParams.url;
	    };
	    /**
	     * is the search endpoint using jsonp internally to communicate with Search API
	     * @returns {boolean}
	     */
	    SearchEndpoint.prototype.isJsonp = function () {
	        return this.caller.useJsonp;
	    };
	    /**
	     * Perform a search on the index and returns a Promise of {@link IQueryResults}.<br/>
	     * Will modify the query results slightly, by adding additional information on each results (an id, the state object, etc.)
	     * @param query The query to execute. Typically, the query object is built using a {@link QueryBuilder}
	     * @param callOptions Additional set of options to use for this call.
	     * @param callParams Options injected by the applied decorators.
	     * @returns {Promise<IQueryResults>}
	     */
	    SearchEndpoint.prototype.search = function (query, callOptions, callParams) {
	        var _this = this;
	        Assert_1.Assert.exists(query);
	        callParams.requestData = query;
	        this.logger.info('Performing REST query', query);
	        return this.performOneCall(callParams, callOptions).then(function (results) {
	            _this.logger.info('REST query successful', results, query);
	            // Version check
	            // If the SearchAPI doesn't give us any apiVersion info, we assume version 1 (before apiVersion was implemented)
	            if (results.apiVersion == null) {
	                results.apiVersion = 1;
	            }
	            if (results.apiVersion < Version_1.version.supportedApiVersion) {
	                _this.logger.error('Please update your REST Search API');
	            }
	            // If the server specified no search ID generated one using the client-side
	            // GUID generator. We prefer server generated guids to allow tracking a query
	            // all the way from the analytics to the logs.
	            if (Utils_1.Utils.isNullOrEmptyString(results.searchUid)) {
	                results.searchUid = QueryUtils_1.QueryUtils.createGuid();
	            }
	            QueryUtils_1.QueryUtils.setIndexAndUidOnQueryResults(query, results, results.searchUid, results.pipeline, results.splitTestRun);
	            QueryUtils_1.QueryUtils.setTermsToHighlightOnQueryResults(query, results);
	            return results;
	        });
	    };
	    /**
	     * Get a link/uri to download a set of results, for a given query, to an xlsx format.<br/>
	     * Note : This does not download automatically the documents, merely provide an url at which to download them.
	     * @param query The query for which to get the xlsx documents
	     * @param numberOfResults The number of results that should be downloaded
	     * @param callOptions Additional set of options to use for this call.
	     * @param callParams Options injected by the applied decorators.
	     * @returns {string}
	     */
	    SearchEndpoint.prototype.getExportToExcelLink = function (query, numberOfResults, callOptions, callParams) {
	        var queryString = this.buildBaseQueryString(callOptions);
	        callParams.queryString = callParams.queryString.concat(queryString);
	        queryString = this.buildCompleteQueryString(null, query);
	        callParams.queryString = callParams.queryString.concat(queryString);
	        if (numberOfResults != null) {
	            callParams.queryString.push('numberOfResults=' + numberOfResults);
	        }
	        callParams.queryString.push('format=xlsx');
	        return callParams.url + '?' + callParams.queryString.join('&');
	    };
	    /**
	     * Get the raw datastream for a given document. This is typically used to get a thumbnail for a document.<br/>
	     * Return an array buffer : <br/>
	     * eg : let rawBinary = String.fromCharCode.apply(null, new Uint8Array(response));<br/>
	     * img.setAttribute('src', 'data:image/png;base64,' + btoa(rawBinary));
	     * @param documentUniqueId Typically the {@link IQueryResult.uniqueId} on each result
	     * @param dataStreamType Normally : '$Thumbnail'
	     * @param callOptions Additional set of options to use for this call.
	     * @param callParams Options injected by the applied decorators.
	     * @returns {Promise<TResult>|Promise<U>}
	     */
	    SearchEndpoint.prototype.getRawDataStream = function (documentUniqueId, dataStreamType, callOptions, callParams) {
	        var _this = this;
	        Assert_1.Assert.exists(documentUniqueId);
	        var queryString = this.buildViewAsHtmlQueryString(documentUniqueId, callOptions);
	        callParams.queryString = callParams.queryString.concat(queryString);
	        this.logger.info('Performing REST query for datastream ' + dataStreamType + ' on document uniqueID' + documentUniqueId);
	        callParams.queryString.push('dataStream=' + dataStreamType);
	        return this.performOneCall(callParams).then(function (results) {
	            _this.logger.info('REST query successful', results, documentUniqueId);
	            return results;
	        });
	    };
	    /**
	     * Return an url that will allow to see the datastream for a given document. This is typically used to get a thumbnail for a document.<br/>
	     * @param documentUniqueID Typically the {@link IQueryResult.uniqueId} on each result
	     * @param dataStreamType Normally : '$Thumbnail'
	     * @param callOptions Additional set of options to use for this call.
	     * @param callParams Options injected by the applied decorators.
	     * @returns {string}
	     */
	    SearchEndpoint.prototype.getViewAsDatastreamUri = function (documentUniqueID, dataStreamType, callOptions, callParams) {
	        callOptions = _.extend({}, callOptions);
	        var queryString = this.buildBaseQueryString(callOptions);
	        callParams.queryString = callParams.queryString.concat(queryString);
	        queryString = this.buildViewAsHtmlQueryString(documentUniqueID, callOptions);
	        callParams.queryString = callParams.queryString.concat(queryString);
	        queryString = this.buildCompleteQueryString(callOptions.query, callOptions.queryObject);
	        callParams.queryString = callParams.queryString.concat(queryString);
	        return callParams.url + '?' + callParams.queryString.join('&') + '&dataStream=' + encodeURIComponent(dataStreamType);
	    };
	    /**
	     * Return a single document, using it's uniqueId
	     * @param documentUniqueID Typically the {@link IQueryResult.uniqueId} on each result
	     * @param callOptions Additional set of options to use for this call.
	     * @param callParams Options injected by the applied decorators.
	     * @returns {Promise<IQueryResult>}
	     */
	    SearchEndpoint.prototype.getDocument = function (documentUniqueID, callOptions, callParams) {
	        var queryString = this.buildViewAsHtmlQueryString(documentUniqueID, callOptions);
	        callParams.queryString = callParams.queryString.concat(queryString);
	        return this.performOneCall(callParams);
	    };
	    /**
	     * Return the content for a single document, as text.<br/>
	     * Think : quickview
	     * @param documentUniqueID Typically the {@link IQueryResult.uniqueId} on each result
	     * @param callOptions Additional set of options to use for this call.
	     * @param callParams Options injected by the applied decorators.
	     * @returns {Promise<string>}
	     */
	    SearchEndpoint.prototype.getDocumentText = function (documentUniqueID, callOptions, callParams) {
	        var queryString = this.buildViewAsHtmlQueryString(documentUniqueID, callOptions);
	        callParams.queryString = callParams.queryString.concat(queryString);
	        return this.performOneCall(callParams)
	            .then(function (data) {
	            return data.content;
	        });
	    };
	    /**
	     * Return the content for a single document, as an HTMLDocument.<br/>
	     * Think : quickview
	     * @param documentUniqueID Typically the {@link IQueryResult.uniqueId} on each result
	     * @param callOptions Additional set of options to use for this call.
	     * @param callParams Options injected by the applied decorators.
	     * @returns {Promise<HTMLDocument>}
	     */
	    SearchEndpoint.prototype.getDocumentHtml = function (documentUniqueID, callOptions, callParams) {
	        callOptions = _.extend({}, callOptions);
	        var queryString = this.buildViewAsHtmlQueryString(documentUniqueID, callOptions);
	        callParams.queryString = callParams.queryString.concat(queryString);
	        callParams.requestData = callOptions.queryObject || { q: callOptions.query };
	        return this.performOneCall(callParams);
	    };
	    /**
	     * Return an url that will allow to see a single document content, as HTML.<br/>
	     * Think : quickview
	     * @param documentUniqueID Typically the {@link IQueryResult.uniqueId} on each result
	     * @param callOptions Additional set of options to use for this call.
	     * @param callParams Options injected by the applied decorators.
	     * @returns {string}
	     */
	    SearchEndpoint.prototype.getViewAsHtmlUri = function (documentUniqueID, callOptions, callParams) {
	        var queryString = this.buildBaseQueryString(callOptions);
	        callParams.queryString = callParams.queryString.concat(queryString);
	        queryString = this.buildViewAsHtmlQueryString(documentUniqueID, callOptions);
	        callParams.queryString = callParams.queryString.concat(queryString);
	        callParams.queryString = _.uniq(callParams.queryString);
	        return callParams.url + '?' + callParams.queryString.join('&');
	    };
	    SearchEndpoint.prototype.batchFieldValues = function (request, callOptions, callParams) {
	        var _this = this;
	        Assert_1.Assert.exists(request);
	        return this.performOneCall(callParams)
	            .then(function (data) {
	            _this.logger.info('REST list field values successful', data.values, request);
	            return data.values;
	        });
	    };
	    /**
	     * List the possible values for a given request
	     * @param request The request for which to list the possible field values
	     * @param callOptions Additional set of options to use for this call.
	     * @param callParams Options injected by the applied decorators.
	     * @returns {Promise<TResult>|Promise<U>}
	     */
	    SearchEndpoint.prototype.listFieldValues = function (request, callOptions, callParams) {
	        var _this = this;
	        Assert_1.Assert.exists(request);
	        callParams.requestData = request;
	        this.logger.info('Listing field values', request);
	        return this.performOneCall(callParams)
	            .then(function (data) {
	            _this.logger.info('REST list field values successful', data.values, request);
	            return data.values;
	        });
	    };
	    /**
	     * List all fields for the index, and return an array of their description
	     * @param callOptions Additional set of options to use for this call.
	     * @param callParams Options injected by the applied decorators.
	     * @returns {Promise<TResult>|Promise<U>}
	     */
	    SearchEndpoint.prototype.listFields = function (callOptions, callParams) {
	        this.logger.info('Listing fields');
	        return this.performOneCall(callParams).then(function (data) {
	            return data.fields;
	        });
	    };
	    /**
	     * List all available query extensions for the search endpoint
	     * @param callOptions Additional set of options to use for this call.
	     * @param callParams Options injected by the applied decorators.
	     * @returns {Promise<IExtension[]>}
	     */
	    SearchEndpoint.prototype.extensions = function (callOptions, callParams) {
	        this.logger.info('Listing extensions');
	        return this.performOneCall(callParams);
	    };
	    /**
	     * Allow to rate a single document in the index (granted that collaborative rating is enabled on your index)
	     * @param ratingRequest Document id and rating
	     * @param callOptions Additional set of options to use for this call.
	     * @param callParams Options injected by the applied decorators.
	     * @returns {Promise<boolean>|Promise<T>}
	     */
	    SearchEndpoint.prototype.rateDocument = function (ratingRequest, callOptions, callParams) {
	        this.logger.info('Rating a document', ratingRequest);
	        callParams.requestData = ratingRequest;
	        return this.performOneCall(callParams).then(function () {
	            return true;
	        });
	    };
	    /**
	     * Allow to tag a single document
	     * @param taggingRequest Document id and tag action to perform
	     * @param callOptions Additional set of options to use for this call.
	     * @param callParams Options injected by the applied decorators.
	     * @returns {Promise<boolean>|Promise<T>}
	     */
	    SearchEndpoint.prototype.tagDocument = function (taggingRequest, callOptions, callParams) {
	        this.logger.info('Tagging a document', taggingRequest);
	        callParams.requestData = taggingRequest;
	        return this.performOneCall(callParams).then(function () {
	            return true;
	        });
	    };
	    /**
	     * Return a list of reveal query suggestions, based on the given request
	     * @param request query and number of suggestions to return
	     * @param callOptions Additional set of options to use for this call.
	     * @param callParams Options injected by the applied decorators.
	     * @returns {Promise<IRevealQuerySuggestResponse>}
	     */
	    SearchEndpoint.prototype.getRevealQuerySuggest = function (request, callOptions, callParams) {
	        this.logger.info('Get Reveal Query Suggest', request);
	        callParams.requestData = request;
	        return this.performOneCall(callParams);
	    };
	    /**
	     * Allow to follow a document or a query on the search alerts service
	     * @param request
	     * @param callOptions Additional set of options to use for this call.
	     * @param callParams Options injected by the applied decorators.
	     * @returns {Promise<ISubscription>}
	     */
	    SearchEndpoint.prototype.follow = function (request, callOptions, callParams) {
	        callParams.requestData = request;
	        this.logger.info('Following a document or a query', request);
	        return this.performOneCall(callParams);
	    };
	    /**
	     * Return a Promise of array of current subscriptions
	     * @param page The page of the subsctiptions
	     * @param callOptions Additional set of options to use for this call.
	     * @param callParams Options injected by the applied decorators.
	     * @returns {any}
	     */
	    SearchEndpoint.prototype.listSubscriptions = function (page, callOptions, callParams) {
	        var _this = this;
	        if (this.options.isGuestUser) {
	            return new es6_promise_1.Promise(function (resolve, reject) {
	                reject();
	            });
	        }
	        if (this.currentListSubscriptions == null) {
	            callParams.queryString.push('page=' + (page || 0));
	            this.currentListSubscriptions = this.performOneCall(callParams);
	            this.currentListSubscriptions.then(function (data) {
	                _this.currentListSubscriptions = null;
	                return data;
	            }).catch(function (e) {
	                // Trap 503 error, as the listSubscription call is called on every page initialization
	                // to check for current subscriptions. By default, the search alert service is not enabled for most organization
	                // Don't want to pollute the console with un-needed noise and confusion
	                if (e.status != 503) {
	                    throw e;
	                }
	            });
	        }
	        return this.currentListSubscriptions;
	    };
	    /**
	     * Update a subscription with new parameters
	     * @param subscription The subscription to update with new parameters
	     * @param callOptions Additional set of options to use for this call.
	     * @param callParams Options injected by the applied decorators.
	     * @returns {Promise<ISubscription>}
	     */
	    SearchEndpoint.prototype.updateSubscription = function (subscription, callOptions, callParams) {
	        callParams.requestData = subscription;
	        this.logger.info('Updating a subscription', subscription);
	        callParams.url += subscription.id;
	        return this.performOneCall(callParams);
	    };
	    /**
	     * Delete a subscription
	     * @param subscription The subscription to delete
	     * @param callOptions Additional set of options to use for this call.
	     * @param callParams Options injected by the applied decorators.
	     * @returns {Promise<ISubscription>}
	     */
	    SearchEndpoint.prototype.deleteSubscription = function (subscription, callOptions, callParams) {
	        callParams.url += subscription.id;
	        return this.performOneCall(callParams);
	    };
	    SearchEndpoint.prototype.logError = function (sentryLog, callOptions, callParams) {
	        callParams.requestData = sentryLog;
	        return this.performOneCall(callParams, callOptions)
	            .then(function () {
	            return true;
	        })
	            .catch(function () {
	            return false;
	        });
	    };
	    SearchEndpoint.prototype.nuke = function () {
	        window.removeEventListener('beforeunload', this.onUnload);
	    };
	    SearchEndpoint.prototype.createEndpointCaller = function () {
	        this.caller = new EndpointCaller_1.EndpointCaller(this.options);
	    };
	    SearchEndpoint.isDebugArgumentPresent = function () {
	        return /[?&]debug=1([&]|$)/.test(window.location.search);
	    };
	    SearchEndpoint.isUseLocalArgumentPresent = function () {
	        return /[?&]useLocal=1([&]|$)/.test(window.location.search);
	    };
	    SearchEndpoint.prototype.handleUnload = function () {
	        this.isRedirecting = true;
	    };
	    SearchEndpoint.prototype.buildBaseUri = function (path) {
	        Assert_1.Assert.isString(path);
	        var uri = this.options.restUri;
	        uri = this.removeTrailingSlash(uri);
	        if (Utils_1.Utils.isNonEmptyString(this.options.version)) {
	            uri += '/' + this.options.version;
	        }
	        uri += path;
	        return uri;
	    };
	    SearchEndpoint.prototype.buildSearchAlertsUri = function (path) {
	        Assert_1.Assert.isString(path);
	        var uri = this.options.searchAlertsUri || this.options.restUri + '/alerts';
	        if (uri == null) {
	            return null;
	        }
	        uri = this.removeTrailingSlash(uri);
	        uri += path;
	        return uri;
	    };
	    // see https://github.com/palantir/tslint/issues/1421
	    // tslint:disable-next-line:no-unused-variable
	    SearchEndpoint.prototype.buildAccessToken = function (tokenKey) {
	        var queryString = [];
	        if (Utils_1.Utils.isNonEmptyString(this.options.accessToken)) {
	            queryString.push(tokenKey + '=' + encodeURIComponent(this.options.accessToken));
	        }
	        return queryString;
	    };
	    SearchEndpoint.prototype.buildBaseQueryString = function (callOptions) {
	        callOptions = _.extend({}, callOptions);
	        var queryString = [];
	        for (var name_1 in this.options.queryStringArguments) {
	            queryString.push(name_1 + '=' + encodeURIComponent(this.options.queryStringArguments[name_1]));
	        }
	        if (callOptions && _.isArray(callOptions.authentication) && callOptions.authentication.length != 0) {
	            queryString.push('authentication=' + callOptions.authentication.join(','));
	        }
	        return queryString;
	    };
	    SearchEndpoint.prototype.buildCompleteQueryString = function (query, queryObject) {
	        // In an ideal parallel reality, the entire query used in the 'search' call is used here.
	        // In this reality however, we must support GET calls (ex: GET /html) for CORS/JSONP/IE reasons.
	        // Therefore, we cherry-pick parts of the query to include in a 'query string' instead of a body payload.
	        var queryString = [];
	        if (queryObject) {
	            _.each(['q', 'aq', 'cq', 'dq', 'searchHub', 'tab', 'language', 'pipeline', 'lowercaseOperators'], function (key) {
	                if (queryObject[key]) {
	                    queryString.push(key + '=' + encodeURIComponent(queryObject[key]));
	                }
	            });
	            _.each(queryObject.context, function (value, key) {
	                queryString.push('context[' + key + ']=' + encodeURIComponent(value));
	            });
	        }
	        else if (query) {
	            queryString.push('q=' + encodeURIComponent(query));
	        }
	        return queryString;
	    };
	    SearchEndpoint.prototype.buildViewAsHtmlQueryString = function (uniqueId, callOptions) {
	        callOptions = _.extend({}, callOptions);
	        var queryString = this.buildBaseQueryString(callOptions);
	        queryString.push('uniqueId=' + encodeURIComponent(uniqueId));
	        if (callOptions.query || callOptions.queryObject) {
	            queryString.push('enableNavigation=true');
	        }
	        if (callOptions.requestedOutputSize) {
	            queryString.push('requestedOutputSize=' + encodeURIComponent(callOptions.requestedOutputSize.toString()));
	        }
	        if (callOptions.contentType) {
	            queryString.push('contentType=' + encodeURIComponent(callOptions.contentType));
	        }
	        return queryString;
	    };
	    SearchEndpoint.prototype.performOneCall = function (params, callOptions, autoRenewToken) {
	        var _this = this;
	        if (autoRenewToken === void 0) { autoRenewToken = true; }
	        var queryString = this.buildBaseQueryString(callOptions);
	        params.queryString = params.queryString.concat(queryString);
	        params.queryString = _.uniq(params.queryString);
	        return this.caller.call(params)
	            .then(function (response) {
	            if (response.data && response.data.clientDuration) {
	                response.data.clientDuration = response.duration;
	            }
	            return response.data;
	        }).catch(function (error) {
	            if (autoRenewToken && _this.canRenewAccessToken() && _this.isAccessTokenExpiredStatus(error.statusCode)) {
	                _this.renewAccessToken()
	                    .then(function () {
	                    return _this.performOneCall(params, callOptions, autoRenewToken);
	                })
	                    .catch(function () {
	                    return es6_promise_1.Promise.reject(_this.handleErrorResponse(error));
	                });
	            }
	            else if (error.statusCode == 0 && _this.isRedirecting) {
	                // The page is getting redirected
	                // Set timeout on return with empty string, since it does not really matter
	                _.defer(function () {
	                    return '';
	                });
	            }
	            else {
	                return es6_promise_1.Promise.reject(_this.handleErrorResponse(error));
	            }
	        });
	    };
	    SearchEndpoint.prototype.handleErrorResponse = function (errorResponse) {
	        if (this.isMissingAuthenticationProviderStatus(errorResponse.statusCode)) {
	            return new MissingAuthenticationError_1.MissingAuthenticationError(errorResponse.data['provider']);
	        }
	        else if (errorResponse.data && errorResponse.data.message && errorResponse.data.type) {
	            return new QueryError_1.QueryError(errorResponse);
	        }
	        else if (errorResponse.data && errorResponse.data.message) {
	            return new AjaxError_1.AjaxError("Request Error : " + errorResponse.data.message, errorResponse.statusCode);
	        }
	        else {
	            return new AjaxError_1.AjaxError('Request Error', errorResponse.statusCode);
	        }
	    };
	    SearchEndpoint.prototype.canRenewAccessToken = function () {
	        return Utils_1.Utils.isNonEmptyString(this.options.accessToken) && _.isFunction(this.options.renewAccessToken);
	    };
	    SearchEndpoint.prototype.renewAccessToken = function () {
	        var _this = this;
	        this.logger.info('Renewing expired access token');
	        return this.options.renewAccessToken().then(function (token) {
	            Assert_1.Assert.isNonEmptyString(token);
	            _this.options.accessToken = token;
	            _this.createEndpointCaller();
	            return token;
	        })
	            .catch(function (e) {
	            _this.logger.error('Failed to renew access token', e);
	            return e;
	        });
	    };
	    SearchEndpoint.prototype.removeTrailingSlash = function (uri) {
	        if (this.hasTrailingSlash(uri)) {
	            uri = uri.substr(0, uri.length - 1);
	        }
	        return uri;
	    };
	    SearchEndpoint.prototype.hasTrailingSlash = function (uri) {
	        return uri.charAt(uri.length - 1) == '/';
	    };
	    SearchEndpoint.prototype.isMissingAuthenticationProviderStatus = function (status) {
	        return status == 402;
	    };
	    SearchEndpoint.prototype.isAccessTokenExpiredStatus = function (status) {
	        return status == 419;
	    };
	    /**
	     * A map of all the initialized endpoint.<br/>
	     * eg : Coveo.SearchEndpoint.endpoints['default'] will return the default endpoint that was created at initialization
	     * @type {{}}
	     */
	    SearchEndpoint.endpoints = {};
	    __decorate([
	        path('/login/'),
	        accessTokenInUrl()
	    ], SearchEndpoint.prototype, "getAuthenticationProviderUri", null);
	    __decorate([
	        path('/'),
	        method('POST'),
	        responseType('text')
	    ], SearchEndpoint.prototype, "search", null);
	    __decorate([
	        path('/'),
	        accessTokenInUrl()
	    ], SearchEndpoint.prototype, "getExportToExcelLink", null);
	    __decorate([
	        path('/datastream'),
	        accessTokenInUrl(),
	        method('GET'),
	        responseType('arraybuffer')
	    ], SearchEndpoint.prototype, "getRawDataStream", null);
	    __decorate([
	        path('/datastream'),
	        accessTokenInUrl()
	    ], SearchEndpoint.prototype, "getViewAsDatastreamUri", null);
	    __decorate([
	        path('/document'),
	        method('GET'),
	        responseType('text')
	    ], SearchEndpoint.prototype, "getDocument", null);
	    __decorate([
	        path('/text'),
	        method('GET'),
	        responseType('text')
	    ], SearchEndpoint.prototype, "getDocumentText", null);
	    __decorate([
	        path('/html'),
	        method('POST'),
	        responseType('document')
	    ], SearchEndpoint.prototype, "getDocumentHtml", null);
	    __decorate([
	        path('/html'),
	        accessTokenInUrl()
	    ], SearchEndpoint.prototype, "getViewAsHtmlUri", null);
	    __decorate([
	        path('/values'),
	        method('POST'),
	        responseType('text')
	    ], SearchEndpoint.prototype, "batchFieldValues", null);
	    __decorate([
	        path('/values'),
	        method('POST'),
	        responseType('text')
	    ], SearchEndpoint.prototype, "listFieldValues", null);
	    __decorate([
	        path('/fields'),
	        method('GET'),
	        responseType('text')
	    ], SearchEndpoint.prototype, "listFields", null);
	    __decorate([
	        path('/extensions'),
	        method('GET'),
	        responseType('text')
	    ], SearchEndpoint.prototype, "extensions", null);
	    __decorate([
	        path('/rating'),
	        method('POST'),
	        responseType('text')
	    ], SearchEndpoint.prototype, "rateDocument", null);
	    __decorate([
	        path('/tag'),
	        method('POST'),
	        responseType('text')
	    ], SearchEndpoint.prototype, "tagDocument", null);
	    __decorate([
	        path('/querySuggest'),
	        method('GET'),
	        responseType('text')
	    ], SearchEndpoint.prototype, "getRevealQuerySuggest", null);
	    __decorate([
	        alertsPath('/subscriptions'),
	        accessTokenInUrl('accessToken'),
	        method('POST'),
	        requestDataType('application/json'),
	        responseType('text')
	    ], SearchEndpoint.prototype, "follow", null);
	    __decorate([
	        alertsPath('/subscriptions'),
	        accessTokenInUrl('accessToken'),
	        method('GET'),
	        requestDataType('application/json'),
	        responseType('text')
	    ], SearchEndpoint.prototype, "listSubscriptions", null);
	    __decorate([
	        alertsPath('/subscriptions/'),
	        accessTokenInUrl('accessToken'),
	        method('PUT'),
	        requestDataType('application/json'),
	        responseType('text')
	    ], SearchEndpoint.prototype, "updateSubscription", null);
	    __decorate([
	        alertsPath('/subscriptions/'),
	        accessTokenInUrl('accessToken'),
	        method('DELETE'),
	        requestDataType('application/json'),
	        responseType('text')
	    ], SearchEndpoint.prototype, "deleteSubscription", null);
	    __decorate([
	        path('/log'),
	        method('POST')
	    ], SearchEndpoint.prototype, "logError", null);
	    return SearchEndpoint;
	}());
	exports.SearchEndpoint = SearchEndpoint;
	/**
	 * It's taken for granted that methods using decorators have :
	 * {@link IEndpointCallOptions} as their second to last parameter
	 * {@link IEndpointCallParameters} as their last parameter
	 * The default parameters for each member of the injected {@link IEndpointCallParameters} are the following:
	 * url: '',
	 * queryString: [],
	 * requestData: {},
	 * requestDataType: undefined,
	 * method: '',
	 * responseType: '',
	 * errorsAsSuccess: false
	 */
	/**
	 * Add the base url
	 * @param path The path to append to the url
	 */
	function path(path) {
	    return function (target, key, descriptor) {
	        var originalMethod = descriptor.value;
	        var nbParams = target[key].prototype.constructor.length;
	        descriptor.value = function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i - 0] = arguments[_i];
	            }
	            var uri = this.buildBaseUri(path);
	            if (args[nbParams - 1]) {
	                args[nbParams - 1].url = uri;
	            }
	            else {
	                var params = {
	                    url: uri,
	                    queryString: [],
	                    requestData: {},
	                    method: '',
	                    responseType: '',
	                    errorsAsSuccess: false
	                };
	                args[nbParams - 1] = params;
	            }
	            var result = originalMethod.apply(this, args);
	            return result;
	        };
	        return descriptor;
	    };
	}
	/**
	 * Add the alert url
	 * @param path The path to append to the url
	 */
	function alertsPath(path) {
	    return function (target, key, descriptor) {
	        var originalMethod = descriptor.value;
	        var nbParams = target[key].prototype.constructor.length;
	        descriptor.value = function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i - 0] = arguments[_i];
	            }
	            var uri = this.buildSearchAlertsUri(path);
	            if (args[nbParams - 1]) {
	                args[nbParams - 1].url = uri;
	            }
	            else {
	                var params = {
	                    url: uri,
	                    queryString: [],
	                    requestData: {},
	                    method: '',
	                    responseType: '',
	                    errorsAsSuccess: false
	                };
	                args[nbParams - 1] = params;
	            }
	            var result = originalMethod.apply(this, args);
	            return result;
	        };
	        return descriptor;
	    };
	}
	/**
	 * Set the request data type
	 * @param type The type to set
	 */
	function requestDataType(type) {
	    return function (target, key, descriptor) {
	        var originalMethod = descriptor.value;
	        var nbParams = target[key].prototype.constructor.length;
	        descriptor.value = function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i - 0] = arguments[_i];
	            }
	            if (args[nbParams - 1]) {
	                args[nbParams - 1].requestDataType = type;
	            }
	            else {
	                var params = {
	                    url: '',
	                    queryString: [],
	                    requestData: {},
	                    requestDataType: type,
	                    method: '',
	                    responseType: '',
	                    errorsAsSuccess: false
	                };
	                args[nbParams - 1] = params;
	            }
	            var result = originalMethod.apply(this, args);
	            return result;
	        };
	        return descriptor;
	    };
	}
	/**
	 * Set the request data type
	 * @param met The type to set
	 */
	function method(met) {
	    return function (target, key, descriptor) {
	        var originalMethod = descriptor.value;
	        var nbParams = target[key].prototype.constructor.length;
	        descriptor.value = function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i - 0] = arguments[_i];
	            }
	            if (args[nbParams - 1]) {
	                args[nbParams - 1].method = met;
	            }
	            else {
	                var params = {
	                    url: '',
	                    queryString: [],
	                    requestData: {},
	                    method: met,
	                    responseType: '',
	                    errorsAsSuccess: false
	                };
	                args[nbParams - 1] = params;
	            }
	            var result = originalMethod.apply(this, args);
	            return result;
	        };
	        return descriptor;
	    };
	}
	/**
	 * Set the response type
	 * @param resp The response type to set
	 */
	function responseType(resp) {
	    return function (target, key, descriptor) {
	        var originalMethod = descriptor.value;
	        var nbParams = target[key].prototype.constructor.length;
	        descriptor.value = function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i - 0] = arguments[_i];
	            }
	            if (args[nbParams - 1]) {
	                args[nbParams - 1].responseType = resp;
	            }
	            else {
	                var params = {
	                    url: '',
	                    queryString: [],
	                    requestData: {},
	                    method: '',
	                    responseType: resp,
	                    errorsAsSuccess: false
	                };
	                args[nbParams - 1] = params;
	            }
	            var result = originalMethod.apply(this, args);
	            return result;
	        };
	        return descriptor;
	    };
	}
	/**
	 * Add the accessToken to the query string arguments
	 */
	function accessTokenInUrl(tokenKey) {
	    if (tokenKey === void 0) { tokenKey = 'access_token'; }
	    return function (target, key, descriptor) {
	        var originalMethod = descriptor.value;
	        var nbParams = target[key].prototype.constructor.length;
	        descriptor.value = function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i - 0] = arguments[_i];
	            }
	            var queryString = this.buildAccessToken(tokenKey);
	            if (args[nbParams - 1]) {
	                args[nbParams - 1].queryString = args[nbParams - 1].queryString.concat(queryString);
	            }
	            else {
	                var params = {
	                    url: '',
	                    queryString: queryString,
	                    requestData: {},
	                    method: '',
	                    responseType: '',
	                    errorsAsSuccess: false
	                };
	                args[nbParams - 1] = params;
	            }
	            var result = originalMethod.apply(this, args);
	            return result;
	        };
	        return descriptor;
	    };
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
	//     http://underscorejs.org
	//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	//     Underscore may be freely distributed under the MIT license.
	(function(){function n(n){function t(t,r,e,u,i,o){for(;i>=0&&o>i;i+=n){var a=u?u[i]:i;e=r(e,t[a],a,t)}return e}return function(r,e,u,i){e=b(e,i,4);var o=!k(r)&&m.keys(r),a=(o||r).length,c=n>0?0:a-1;return arguments.length<3&&(u=r[o?o[c]:c],c+=n),t(r,e,u,o,c,a)}}function t(n){return function(t,r,e){r=x(r,e);for(var u=O(t),i=n>0?0:u-1;i>=0&&u>i;i+=n)if(r(t[i],i,t))return i;return-1}}function r(n,t,r){return function(e,u,i){var o=0,a=O(e);if("number"==typeof i)n>0?o=i>=0?i:Math.max(i+a,o):a=i>=0?Math.min(i+1,a):i+a+1;else if(r&&i&&a)return i=r(e,u),e[i]===u?i:-1;if(u!==u)return i=t(l.call(e,o,a),m.isNaN),i>=0?i+o:-1;for(i=n>0?o:a-1;i>=0&&a>i;i+=n)if(e[i]===u)return i;return-1}}function e(n,t){var r=I.length,e=n.constructor,u=m.isFunction(e)&&e.prototype||a,i="constructor";for(m.has(n,i)&&!m.contains(t,i)&&t.push(i);r--;)i=I[r],i in n&&n[i]!==u[i]&&!m.contains(t,i)&&t.push(i)}var u=this,i=u._,o=Array.prototype,a=Object.prototype,c=Function.prototype,f=o.push,l=o.slice,s=a.toString,p=a.hasOwnProperty,h=Array.isArray,v=Object.keys,g=c.bind,y=Object.create,d=function(){},m=function(n){return n instanceof m?n:this instanceof m?void(this._wrapped=n):new m(n)}; true?("undefined"!=typeof module&&module.exports&&(exports=module.exports=m),exports._=m):u._=m,m.VERSION="1.8.3";var b=function(n,t,r){if(t===void 0)return n;switch(null==r?3:r){case 1:return function(r){return n.call(t,r)};case 2:return function(r,e){return n.call(t,r,e)};case 3:return function(r,e,u){return n.call(t,r,e,u)};case 4:return function(r,e,u,i){return n.call(t,r,e,u,i)}}return function(){return n.apply(t,arguments)}},x=function(n,t,r){return null==n?m.identity:m.isFunction(n)?b(n,t,r):m.isObject(n)?m.matcher(n):m.property(n)};m.iteratee=function(n,t){return x(n,t,1/0)};var _=function(n,t){return function(r){var e=arguments.length;if(2>e||null==r)return r;for(var u=1;e>u;u++)for(var i=arguments[u],o=n(i),a=o.length,c=0;a>c;c++){var f=o[c];t&&r[f]!==void 0||(r[f]=i[f])}return r}},j=function(n){if(!m.isObject(n))return{};if(y)return y(n);d.prototype=n;var t=new d;return d.prototype=null,t},w=function(n){return function(t){return null==t?void 0:t[n]}},A=Math.pow(2,53)-1,O=w("length"),k=function(n){var t=O(n);return"number"==typeof t&&t>=0&&A>=t};m.each=m.forEach=function(n,t,r){t=b(t,r);var e,u;if(k(n))for(e=0,u=n.length;u>e;e++)t(n[e],e,n);else{var i=m.keys(n);for(e=0,u=i.length;u>e;e++)t(n[i[e]],i[e],n)}return n},m.map=m.collect=function(n,t,r){t=x(t,r);for(var e=!k(n)&&m.keys(n),u=(e||n).length,i=Array(u),o=0;u>o;o++){var a=e?e[o]:o;i[o]=t(n[a],a,n)}return i},m.reduce=m.foldl=m.inject=n(1),m.reduceRight=m.foldr=n(-1),m.find=m.detect=function(n,t,r){var e;return e=k(n)?m.findIndex(n,t,r):m.findKey(n,t,r),e!==void 0&&e!==-1?n[e]:void 0},m.filter=m.select=function(n,t,r){var e=[];return t=x(t,r),m.each(n,function(n,r,u){t(n,r,u)&&e.push(n)}),e},m.reject=function(n,t,r){return m.filter(n,m.negate(x(t)),r)},m.every=m.all=function(n,t,r){t=x(t,r);for(var e=!k(n)&&m.keys(n),u=(e||n).length,i=0;u>i;i++){var o=e?e[i]:i;if(!t(n[o],o,n))return!1}return!0},m.some=m.any=function(n,t,r){t=x(t,r);for(var e=!k(n)&&m.keys(n),u=(e||n).length,i=0;u>i;i++){var o=e?e[i]:i;if(t(n[o],o,n))return!0}return!1},m.contains=m.includes=m.include=function(n,t,r,e){return k(n)||(n=m.values(n)),("number"!=typeof r||e)&&(r=0),m.indexOf(n,t,r)>=0},m.invoke=function(n,t){var r=l.call(arguments,2),e=m.isFunction(t);return m.map(n,function(n){var u=e?t:n[t];return null==u?u:u.apply(n,r)})},m.pluck=function(n,t){return m.map(n,m.property(t))},m.where=function(n,t){return m.filter(n,m.matcher(t))},m.findWhere=function(n,t){return m.find(n,m.matcher(t))},m.max=function(n,t,r){var e,u,i=-1/0,o=-1/0;if(null==t&&null!=n){n=k(n)?n:m.values(n);for(var a=0,c=n.length;c>a;a++)e=n[a],e>i&&(i=e)}else t=x(t,r),m.each(n,function(n,r,e){u=t(n,r,e),(u>o||u===-1/0&&i===-1/0)&&(i=n,o=u)});return i},m.min=function(n,t,r){var e,u,i=1/0,o=1/0;if(null==t&&null!=n){n=k(n)?n:m.values(n);for(var a=0,c=n.length;c>a;a++)e=n[a],i>e&&(i=e)}else t=x(t,r),m.each(n,function(n,r,e){u=t(n,r,e),(o>u||1/0===u&&1/0===i)&&(i=n,o=u)});return i},m.shuffle=function(n){for(var t,r=k(n)?n:m.values(n),e=r.length,u=Array(e),i=0;e>i;i++)t=m.random(0,i),t!==i&&(u[i]=u[t]),u[t]=r[i];return u},m.sample=function(n,t,r){return null==t||r?(k(n)||(n=m.values(n)),n[m.random(n.length-1)]):m.shuffle(n).slice(0,Math.max(0,t))},m.sortBy=function(n,t,r){return t=x(t,r),m.pluck(m.map(n,function(n,r,e){return{value:n,index:r,criteria:t(n,r,e)}}).sort(function(n,t){var r=n.criteria,e=t.criteria;if(r!==e){if(r>e||r===void 0)return 1;if(e>r||e===void 0)return-1}return n.index-t.index}),"value")};var F=function(n){return function(t,r,e){var u={};return r=x(r,e),m.each(t,function(e,i){var o=r(e,i,t);n(u,e,o)}),u}};m.groupBy=F(function(n,t,r){m.has(n,r)?n[r].push(t):n[r]=[t]}),m.indexBy=F(function(n,t,r){n[r]=t}),m.countBy=F(function(n,t,r){m.has(n,r)?n[r]++:n[r]=1}),m.toArray=function(n){return n?m.isArray(n)?l.call(n):k(n)?m.map(n,m.identity):m.values(n):[]},m.size=function(n){return null==n?0:k(n)?n.length:m.keys(n).length},m.partition=function(n,t,r){t=x(t,r);var e=[],u=[];return m.each(n,function(n,r,i){(t(n,r,i)?e:u).push(n)}),[e,u]},m.first=m.head=m.take=function(n,t,r){return null==n?void 0:null==t||r?n[0]:m.initial(n,n.length-t)},m.initial=function(n,t,r){return l.call(n,0,Math.max(0,n.length-(null==t||r?1:t)))},m.last=function(n,t,r){return null==n?void 0:null==t||r?n[n.length-1]:m.rest(n,Math.max(0,n.length-t))},m.rest=m.tail=m.drop=function(n,t,r){return l.call(n,null==t||r?1:t)},m.compact=function(n){return m.filter(n,m.identity)};var S=function(n,t,r,e){for(var u=[],i=0,o=e||0,a=O(n);a>o;o++){var c=n[o];if(k(c)&&(m.isArray(c)||m.isArguments(c))){t||(c=S(c,t,r));var f=0,l=c.length;for(u.length+=l;l>f;)u[i++]=c[f++]}else r||(u[i++]=c)}return u};m.flatten=function(n,t){return S(n,t,!1)},m.without=function(n){return m.difference(n,l.call(arguments,1))},m.uniq=m.unique=function(n,t,r,e){m.isBoolean(t)||(e=r,r=t,t=!1),null!=r&&(r=x(r,e));for(var u=[],i=[],o=0,a=O(n);a>o;o++){var c=n[o],f=r?r(c,o,n):c;t?(o&&i===f||u.push(c),i=f):r?m.contains(i,f)||(i.push(f),u.push(c)):m.contains(u,c)||u.push(c)}return u},m.union=function(){return m.uniq(S(arguments,!0,!0))},m.intersection=function(n){for(var t=[],r=arguments.length,e=0,u=O(n);u>e;e++){var i=n[e];if(!m.contains(t,i)){for(var o=1;r>o&&m.contains(arguments[o],i);o++);o===r&&t.push(i)}}return t},m.difference=function(n){var t=S(arguments,!0,!0,1);return m.filter(n,function(n){return!m.contains(t,n)})},m.zip=function(){return m.unzip(arguments)},m.unzip=function(n){for(var t=n&&m.max(n,O).length||0,r=Array(t),e=0;t>e;e++)r[e]=m.pluck(n,e);return r},m.object=function(n,t){for(var r={},e=0,u=O(n);u>e;e++)t?r[n[e]]=t[e]:r[n[e][0]]=n[e][1];return r},m.findIndex=t(1),m.findLastIndex=t(-1),m.sortedIndex=function(n,t,r,e){r=x(r,e,1);for(var u=r(t),i=0,o=O(n);o>i;){var a=Math.floor((i+o)/2);r(n[a])<u?i=a+1:o=a}return i},m.indexOf=r(1,m.findIndex,m.sortedIndex),m.lastIndexOf=r(-1,m.findLastIndex),m.range=function(n,t,r){null==t&&(t=n||0,n=0),r=r||1;for(var e=Math.max(Math.ceil((t-n)/r),0),u=Array(e),i=0;e>i;i++,n+=r)u[i]=n;return u};var E=function(n,t,r,e,u){if(!(e instanceof t))return n.apply(r,u);var i=j(n.prototype),o=n.apply(i,u);return m.isObject(o)?o:i};m.bind=function(n,t){if(g&&n.bind===g)return g.apply(n,l.call(arguments,1));if(!m.isFunction(n))throw new TypeError("Bind must be called on a function");var r=l.call(arguments,2),e=function(){return E(n,e,t,this,r.concat(l.call(arguments)))};return e},m.partial=function(n){var t=l.call(arguments,1),r=function(){for(var e=0,u=t.length,i=Array(u),o=0;u>o;o++)i[o]=t[o]===m?arguments[e++]:t[o];for(;e<arguments.length;)i.push(arguments[e++]);return E(n,r,this,this,i)};return r},m.bindAll=function(n){var t,r,e=arguments.length;if(1>=e)throw new Error("bindAll must be passed function names");for(t=1;e>t;t++)r=arguments[t],n[r]=m.bind(n[r],n);return n},m.memoize=function(n,t){var r=function(e){var u=r.cache,i=""+(t?t.apply(this,arguments):e);return m.has(u,i)||(u[i]=n.apply(this,arguments)),u[i]};return r.cache={},r},m.delay=function(n,t){var r=l.call(arguments,2);return setTimeout(function(){return n.apply(null,r)},t)},m.defer=m.partial(m.delay,m,1),m.throttle=function(n,t,r){var e,u,i,o=null,a=0;r||(r={});var c=function(){a=r.leading===!1?0:m.now(),o=null,i=n.apply(e,u),o||(e=u=null)};return function(){var f=m.now();a||r.leading!==!1||(a=f);var l=t-(f-a);return e=this,u=arguments,0>=l||l>t?(o&&(clearTimeout(o),o=null),a=f,i=n.apply(e,u),o||(e=u=null)):o||r.trailing===!1||(o=setTimeout(c,l)),i}},m.debounce=function(n,t,r){var e,u,i,o,a,c=function(){var f=m.now()-o;t>f&&f>=0?e=setTimeout(c,t-f):(e=null,r||(a=n.apply(i,u),e||(i=u=null)))};return function(){i=this,u=arguments,o=m.now();var f=r&&!e;return e||(e=setTimeout(c,t)),f&&(a=n.apply(i,u),i=u=null),a}},m.wrap=function(n,t){return m.partial(t,n)},m.negate=function(n){return function(){return!n.apply(this,arguments)}},m.compose=function(){var n=arguments,t=n.length-1;return function(){for(var r=t,e=n[t].apply(this,arguments);r--;)e=n[r].call(this,e);return e}},m.after=function(n,t){return function(){return--n<1?t.apply(this,arguments):void 0}},m.before=function(n,t){var r;return function(){return--n>0&&(r=t.apply(this,arguments)),1>=n&&(t=null),r}},m.once=m.partial(m.before,2);var M=!{toString:null}.propertyIsEnumerable("toString"),I=["valueOf","isPrototypeOf","toString","propertyIsEnumerable","hasOwnProperty","toLocaleString"];m.keys=function(n){if(!m.isObject(n))return[];if(v)return v(n);var t=[];for(var r in n)m.has(n,r)&&t.push(r);return M&&e(n,t),t},m.allKeys=function(n){if(!m.isObject(n))return[];var t=[];for(var r in n)t.push(r);return M&&e(n,t),t},m.values=function(n){for(var t=m.keys(n),r=t.length,e=Array(r),u=0;r>u;u++)e[u]=n[t[u]];return e},m.mapObject=function(n,t,r){t=x(t,r);for(var e,u=m.keys(n),i=u.length,o={},a=0;i>a;a++)e=u[a],o[e]=t(n[e],e,n);return o},m.pairs=function(n){for(var t=m.keys(n),r=t.length,e=Array(r),u=0;r>u;u++)e[u]=[t[u],n[t[u]]];return e},m.invert=function(n){for(var t={},r=m.keys(n),e=0,u=r.length;u>e;e++)t[n[r[e]]]=r[e];return t},m.functions=m.methods=function(n){var t=[];for(var r in n)m.isFunction(n[r])&&t.push(r);return t.sort()},m.extend=_(m.allKeys),m.extendOwn=m.assign=_(m.keys),m.findKey=function(n,t,r){t=x(t,r);for(var e,u=m.keys(n),i=0,o=u.length;o>i;i++)if(e=u[i],t(n[e],e,n))return e},m.pick=function(n,t,r){var e,u,i={},o=n;if(null==o)return i;m.isFunction(t)?(u=m.allKeys(o),e=b(t,r)):(u=S(arguments,!1,!1,1),e=function(n,t,r){return t in r},o=Object(o));for(var a=0,c=u.length;c>a;a++){var f=u[a],l=o[f];e(l,f,o)&&(i[f]=l)}return i},m.omit=function(n,t,r){if(m.isFunction(t))t=m.negate(t);else{var e=m.map(S(arguments,!1,!1,1),String);t=function(n,t){return!m.contains(e,t)}}return m.pick(n,t,r)},m.defaults=_(m.allKeys,!0),m.create=function(n,t){var r=j(n);return t&&m.extendOwn(r,t),r},m.clone=function(n){return m.isObject(n)?m.isArray(n)?n.slice():m.extend({},n):n},m.tap=function(n,t){return t(n),n},m.isMatch=function(n,t){var r=m.keys(t),e=r.length;if(null==n)return!e;for(var u=Object(n),i=0;e>i;i++){var o=r[i];if(t[o]!==u[o]||!(o in u))return!1}return!0};var N=function(n,t,r,e){if(n===t)return 0!==n||1/n===1/t;if(null==n||null==t)return n===t;n instanceof m&&(n=n._wrapped),t instanceof m&&(t=t._wrapped);var u=s.call(n);if(u!==s.call(t))return!1;switch(u){case"[object RegExp]":case"[object String]":return""+n==""+t;case"[object Number]":return+n!==+n?+t!==+t:0===+n?1/+n===1/t:+n===+t;case"[object Date]":case"[object Boolean]":return+n===+t}var i="[object Array]"===u;if(!i){if("object"!=typeof n||"object"!=typeof t)return!1;var o=n.constructor,a=t.constructor;if(o!==a&&!(m.isFunction(o)&&o instanceof o&&m.isFunction(a)&&a instanceof a)&&"constructor"in n&&"constructor"in t)return!1}r=r||[],e=e||[];for(var c=r.length;c--;)if(r[c]===n)return e[c]===t;if(r.push(n),e.push(t),i){if(c=n.length,c!==t.length)return!1;for(;c--;)if(!N(n[c],t[c],r,e))return!1}else{var f,l=m.keys(n);if(c=l.length,m.keys(t).length!==c)return!1;for(;c--;)if(f=l[c],!m.has(t,f)||!N(n[f],t[f],r,e))return!1}return r.pop(),e.pop(),!0};m.isEqual=function(n,t){return N(n,t)},m.isEmpty=function(n){return null==n?!0:k(n)&&(m.isArray(n)||m.isString(n)||m.isArguments(n))?0===n.length:0===m.keys(n).length},m.isElement=function(n){return!(!n||1!==n.nodeType)},m.isArray=h||function(n){return"[object Array]"===s.call(n)},m.isObject=function(n){var t=typeof n;return"function"===t||"object"===t&&!!n},m.each(["Arguments","Function","String","Number","Date","RegExp","Error"],function(n){m["is"+n]=function(t){return s.call(t)==="[object "+n+"]"}}),m.isArguments(arguments)||(m.isArguments=function(n){return m.has(n,"callee")}),"function"!=typeof/./&&"object"!=typeof Int8Array&&(m.isFunction=function(n){return"function"==typeof n||!1}),m.isFinite=function(n){return isFinite(n)&&!isNaN(parseFloat(n))},m.isNaN=function(n){return m.isNumber(n)&&n!==+n},m.isBoolean=function(n){return n===!0||n===!1||"[object Boolean]"===s.call(n)},m.isNull=function(n){return null===n},m.isUndefined=function(n){return n===void 0},m.has=function(n,t){return null!=n&&p.call(n,t)},m.noConflict=function(){return u._=i,this},m.identity=function(n){return n},m.constant=function(n){return function(){return n}},m.noop=function(){},m.property=w,m.propertyOf=function(n){return null==n?function(){}:function(t){return n[t]}},m.matcher=m.matches=function(n){return n=m.extendOwn({},n),function(t){return m.isMatch(t,n)}},m.times=function(n,t,r){var e=Array(Math.max(0,n));t=b(t,r,1);for(var u=0;n>u;u++)e[u]=t(u);return e},m.random=function(n,t){return null==t&&(t=n,n=0),n+Math.floor(Math.random()*(t-n+1))},m.now=Date.now||function(){return(new Date).getTime()};var B={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#x27;","`":"&#x60;"},T=m.invert(B),R=function(n){var t=function(t){return n[t]},r="(?:"+m.keys(n).join("|")+")",e=RegExp(r),u=RegExp(r,"g");return function(n){return n=null==n?"":""+n,e.test(n)?n.replace(u,t):n}};m.escape=R(B),m.unescape=R(T),m.result=function(n,t,r){var e=null==n?void 0:n[t];return e===void 0&&(e=r),m.isFunction(e)?e.call(n):e};var q=0;m.uniqueId=function(n){var t=++q+"";return n?n+t:t},m.templateSettings={evaluate:/<%([\s\S]+?)%>/g,interpolate:/<%=([\s\S]+?)%>/g,escape:/<%-([\s\S]+?)%>/g};var K=/(.)^/,z={"'":"'","\\":"\\","\r":"r","\n":"n","\u2028":"u2028","\u2029":"u2029"},D=/\\|'|\r|\n|\u2028|\u2029/g,L=function(n){return"\\"+z[n]};m.template=function(n,t,r){!t&&r&&(t=r),t=m.defaults({},t,m.templateSettings);var e=RegExp([(t.escape||K).source,(t.interpolate||K).source,(t.evaluate||K).source].join("|")+"|$","g"),u=0,i="__p+='";n.replace(e,function(t,r,e,o,a){return i+=n.slice(u,a).replace(D,L),u=a+t.length,r?i+="'+\n((__t=("+r+"))==null?'':_.escape(__t))+\n'":e?i+="'+\n((__t=("+e+"))==null?'':__t)+\n'":o&&(i+="';\n"+o+"\n__p+='"),t}),i+="';\n",t.variable||(i="with(obj||{}){\n"+i+"}\n"),i="var __t,__p='',__j=Array.prototype.join,"+"print=function(){__p+=__j.call(arguments,'');};\n"+i+"return __p;\n";try{var o=new Function(t.variable||"obj","_",i)}catch(a){throw a.source=i,a}var c=function(n){return o.call(this,n,m)},f=t.variable||"obj";return c.source="function("+f+"){\n"+i+"}",c},m.chain=function(n){var t=m(n);return t._chain=!0,t};var P=function(n,t){return n._chain?m(t).chain():t};m.mixin=function(n){m.each(m.functions(n),function(t){var r=m[t]=n[t];m.prototype[t]=function(){var n=[this._wrapped];return f.apply(n,arguments),P(this,r.apply(m,n))}})},m.mixin(m),m.each(["pop","push","reverse","shift","sort","splice","unshift"],function(n){var t=o[n];m.prototype[n]=function(){var r=this._wrapped;return t.apply(r,arguments),"shift"!==n&&"splice"!==n||0!==r.length||delete r[0],P(this,r)}}),m.each(["concat","join","slice"],function(n){var t=o[n];m.prototype[n]=function(){return P(this,t.apply(this._wrapped,arguments))}}),m.prototype.value=function(){return this._wrapped},m.prototype.valueOf=m.prototype.toJSON=m.prototype.value,m.prototype.toString=function(){return""+this._wrapped},"function"=="function"&&__webpack_require__(14)&&!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(){return m}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}).call(this);
	


/***/ },
/* 14 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var Logger_1 = __webpack_require__(16);
	var Assert_1 = __webpack_require__(17);
	var TimeSpanUtils_1 = __webpack_require__(19);
	var DeviceUtils_1 = __webpack_require__(20);
	var Utils_1 = __webpack_require__(18);
	var es6_promise_1 = __webpack_require__(7);
	// In ie8, XMLHttpRequest has no status property, so let's use this enum instead
	var XMLHttpRequestStatus;
	(function (XMLHttpRequestStatus) {
	    XMLHttpRequestStatus[XMLHttpRequestStatus["OPENED"] = XMLHttpRequest.OPENED || 1] = "OPENED";
	    XMLHttpRequestStatus[XMLHttpRequestStatus["HEADERS_RECEIVED"] = XMLHttpRequest.HEADERS_RECEIVED || 2] = "HEADERS_RECEIVED";
	    XMLHttpRequestStatus[XMLHttpRequestStatus["DONE"] = XMLHttpRequest.DONE || 4] = "DONE";
	})(XMLHttpRequestStatus || (XMLHttpRequestStatus = {}));
	/**
	 * This class is in charge of calling an endpoint (eg: a {@link SearchEndpoint}).
	 *
	 * This means it's only uses to execute an XMLHttpRequest (for example), massage the response and check if there are errors.
	 *
	 * Will execute the call and return a Promise.
	 *
	 * Call using one of those options :
	 *
	 * * XMLHttpRequest for recent browser that support CORS, or if the endpoint is on the same origin.
	 * * XDomainRequest for older IE browser that do not support CORS.
	 * * Jsonp if all else fails, or is explicitly enabled.
	 */
	var EndpointCaller = (function () {
	    /**
	     * Create a new EndpointCaller.
	     * @param options Specify the authentication that will be used for this endpoint. Not needed if the endpoint is public and has no authentication
	     */
	    function EndpointCaller(options) {
	        if (options === void 0) { options = {}; }
	        this.options = options;
	        /**
	         * Set this property to true to enable Jsonp call to the endpoint.<br/>
	         * Be aware that jsonp is "easier" to setup endpoint wise, but has a lot of drawback and limitation for the client code.<br/>
	         * Default to false.
	         * @type {boolean}
	         */
	        this.useJsonp = false;
	        this.logger = new Logger_1.Logger(this);
	    }
	    /**
	     * Generic call to the endpoint using the provided {@link IEndpointCallParameters}.<br/>
	     * Internally, will decide which method to use to call the endpoint :<br/>
	     * -- XMLHttpRequest for recent browser that support CORS, or if the endpoint is on the same origin.<br/>
	     * -- XDomainRequest for older IE browser that do not support CORS.<br/>
	     * -- Jsonp if all else fails, or is explicitly enabled.
	     * @param params The parameters to use for the call
	     * @returns {any} A promise of the given type
	     */
	    EndpointCaller.prototype.call = function (params) {
	        var requestInfo = {
	            url: params.url,
	            queryString: params.errorsAsSuccess ? params.queryString.concat(['errorsAsSuccess=1']) : params.queryString,
	            requestData: params.requestData,
	            requestDataType: params.requestDataType || 'application/x-www-form-urlencoded; charset="UTF-8"',
	            begun: new Date(),
	            method: params.method
	        };
	        requestInfo.headers = this.buildRequestHeaders(requestInfo);
	        if (_.isFunction(this.options.requestModifier)) {
	            requestInfo = this.options.requestModifier(requestInfo);
	        }
	        this.logger.trace('Performing REST request', requestInfo);
	        var urlObject = this.parseURL(requestInfo.url);
	        // In IE8, hostname and port return "" when we are on the same domain.
	        var isLocalHost = (window.location.hostname === urlObject.hostname) || (urlObject.hostname === '');
	        var currentPort = (window.location.port != '' ? window.location.port : (window.location.protocol == 'https:' ? '443' : '80'));
	        var isSamePort = currentPort == urlObject.port;
	        var isCrossOrigin = !(isLocalHost && isSamePort);
	        if (!this.useJsonp) {
	            if (this.isCORSSupported() || !isCrossOrigin) {
	                return this.callUsingXMLHttpRequest(requestInfo, params.responseType);
	            }
	            else if (this.isXDomainRequestSupported()) {
	                return this.callUsingXDomainRequest(requestInfo);
	            }
	            else {
	                return this.callUsingAjaxJsonP(requestInfo);
	            }
	        }
	        else {
	            return this.callUsingAjaxJsonP(requestInfo);
	        }
	    };
	    /**
	     * Call the endpoint using XMLHttpRequest. Used internally by {@link EndpointCaller.call}.<br/>
	     * Will try internally to handle error if it can.<br/>
	     * Promise will otherwise fail with the error type.
	     * @param requestInfo The info about the request
	     * @param responseType The responseType. Default to text. https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/responseType
	     * @returns {Promise<T>|Promise}
	     */
	    EndpointCaller.prototype.callUsingXMLHttpRequest = function (requestInfo, responseType) {
	        var _this = this;
	        if (responseType === void 0) { responseType = 'text'; }
	        return new es6_promise_1.Promise(function (resolve, reject) {
	            var xmlHttpRequest = new XMLHttpRequest();
	            // Beware, most stuff must be set on the event that says the request is OPENED.
	            // Otherwise it'll bork on some browsers. Gotta love standards.
	            // This sent variable allowed to remove the second call of onreadystatechange with the state OPENED in IE11
	            var sent = false;
	            xmlHttpRequest.onreadystatechange = function (ev) {
	                if (xmlHttpRequest.readyState == XMLHttpRequestStatus.OPENED && !sent) {
	                    sent = true;
	                    xmlHttpRequest.withCredentials = true;
	                    _.each(requestInfo.headers, function (headerValue, headerKey) {
	                        xmlHttpRequest.setRequestHeader(headerKey, headerValue);
	                    });
	                    if (requestInfo.method == 'GET') {
	                        xmlHttpRequest.send();
	                    }
	                    else if (requestInfo.requestDataType.indexOf('application/json') === 0) {
	                        xmlHttpRequest.send(JSON.stringify(requestInfo.requestData));
	                    }
	                    else {
	                        xmlHttpRequest.send(_this.convertJsonToFormBody(requestInfo.requestData));
	                    }
	                }
	                else if (xmlHttpRequest.readyState == XMLHttpRequestStatus.HEADERS_RECEIVED) {
	                    var status = xmlHttpRequest.status;
	                    if (_this.isSuccessHttpStatus(status)) {
	                        xmlHttpRequest.responseType = responseType;
	                    }
	                    else {
	                        xmlHttpRequest.responseType = 'text';
	                    }
	                }
	                else if (xmlHttpRequest.readyState == XMLHttpRequestStatus.DONE) {
	                    var status = xmlHttpRequest.status;
	                    var data;
	                    switch (responseType) {
	                        case 'json':
	                            data = xmlHttpRequest.response;
	                            // Work around a bug in IE11 where responseType jsonis not supported : the response comes back as a plain string
	                            // Force the json parse manually
	                            if (responseType == 'json' && DeviceUtils_1.DeviceUtils.getDeviceName() == 'IE') {
	                                try {
	                                    data = JSON.parse(data);
	                                }
	                                catch (e) {
	                                }
	                            }
	                            break;
	                        case 'text':
	                            data = _this.tryParseResponseText(xmlHttpRequest.responseText, xmlHttpRequest.getResponseHeader('Content-Type'));
	                            break;
	                        default:
	                            data = xmlHttpRequest.response;
	                            break;
	                    }
	                    if (data == undefined) {
	                        data = _this.tryParseResponseText(xmlHttpRequest.responseText, xmlHttpRequest.getResponseHeader('Content-Type'));
	                    }
	                    if (_this.isSuccessHttpStatus(status)) {
	                        _this.handleSuccessfulResponseThatMightBeAnError(requestInfo, data, resolve, reject);
	                    }
	                    else {
	                        _this.handleError(requestInfo, xmlHttpRequest.status, data, reject);
	                    }
	                }
	            };
	            var queryString = requestInfo.queryString;
	            if (requestInfo.method == 'GET') {
	                queryString = queryString.concat(_this.convertJsonToQueryString(requestInfo.requestData));
	            }
	            xmlHttpRequest.open(requestInfo.method, _this.combineUrlAndQueryString(requestInfo.url, queryString));
	        });
	    };
	    /**
	     * Call the endpoint using XDomainRequest https://msdn.microsoft.com/en-us/library/cc288060(v=vs.85).aspx<br/>
	     * Used for IE8/9
	     * @param requestInfo The info about the request
	     * @returns {Promise<T>|Promise}
	     */
	    EndpointCaller.prototype.callUsingXDomainRequest = function (requestInfo) {
	        var _this = this;
	        return new es6_promise_1.Promise(function (resolve, reject) {
	            var queryString = requestInfo.queryString.concat([]);
	            // XDomainRequest don't support including stuff in the header, so we must
	            // put the access token in the query string if we have one.
	            if (_this.options.accessToken) {
	                queryString.push('access_token=' + encodeURIComponent(_this.options.accessToken));
	            }
	            var xDomainRequest = new XDomainRequest();
	            if (requestInfo.method == 'GET') {
	                queryString = queryString.concat(_this.convertJsonToQueryString(requestInfo.requestData));
	            }
	            xDomainRequest.open(requestInfo.method, _this.combineUrlAndQueryString(requestInfo.url, queryString));
	            xDomainRequest.onload = function () {
	                var data = _this.tryParseResponseText(xDomainRequest.responseText, xDomainRequest.contentType);
	                _this.handleSuccessfulResponseThatMightBeAnError(requestInfo, data, resolve, reject);
	            };
	            xDomainRequest.onerror = function () {
	                var data = _this.tryParseResponseText(xDomainRequest.responseText, xDomainRequest.contentType);
	                _this.handleError(requestInfo, 0, data, reject);
	            };
	            // We must set those functions otherwise it will sometime fail in IE
	            xDomainRequest.ontimeout = function () { return _this.logger.error('Request timeout', xDomainRequest, requestInfo.requestData); };
	            xDomainRequest.onprogress = function () { return _this.logger.trace('Request progress', xDomainRequest, requestInfo.requestData); };
	            // We must open the request in a separate thread, for obscure reasons
	            _.defer(function () {
	                if (requestInfo.method == 'GET') {
	                    xDomainRequest.send();
	                }
	                else {
	                    xDomainRequest.send(_this.convertJsonToFormBody(requestInfo.requestData));
	                }
	            });
	        });
	    };
	    /**
	     * Call the endpoint using Jsonp https://en.wikipedia.org/wiki/JSONP<br/>
	     * Should be used for dev only, or for very special setup as using jsonp has a lot of drawbacks.
	     * @param requestInfo The info about the request
	     * @returns {Promise<T>|Promise}
	     */
	    EndpointCaller.prototype.callUsingAjaxJsonP = function (requestInfo) {
	        var _this = this;
	        return new es6_promise_1.Promise(function (resolve, reject) {
	            var queryString = requestInfo.queryString.concat(_this.convertJsonToQueryString(requestInfo.requestData));
	            // JSONP don't support including stuff in the header, so we must
	            // put the access token in the query string if we have one.
	            if (_this.options.accessToken) {
	                queryString.push('access_token=' + encodeURIComponent(_this.options.accessToken));
	            }
	            queryString.push('callback=?');
	            $['jsonp']({
	                url: _this.combineUrlAndQueryString(requestInfo.url, queryString),
	                success: function (data) { return _this.handleSuccessfulResponseThatMightBeAnError(requestInfo, data, resolve, reject); },
	                error: function () { return _this.handleError(requestInfo, 0, undefined, reject); }
	            });
	        });
	    };
	    EndpointCaller.prototype.parseURL = function (url) {
	        var urlObject = document.createElement('a');
	        urlObject.href = url;
	        return urlObject;
	    };
	    EndpointCaller.prototype.convertJsonToQueryString = function (json) {
	        Assert_1.Assert.exists(json);
	        var result = [];
	        _.each(json, function (value, key) {
	            if (value != null) {
	                if (_.isObject(value)) {
	                    result.push(key + '=' + encodeURIComponent(JSON.stringify(value)));
	                }
	                else {
	                    result.push(key + '=' + encodeURIComponent(value.toString()));
	                }
	            }
	        });
	        return result;
	    };
	    EndpointCaller.prototype.convertJsonToFormBody = function (json) {
	        return this.convertJsonToQueryString(json).join('&');
	    };
	    EndpointCaller.prototype.handleSuccessfulResponseThatMightBeAnError = function (requestInfo, data, success, error) {
	        if (this.isErrorResponseBody(data)) {
	            this.handleError(requestInfo, data.statusCode, data, error);
	        }
	        else {
	            this.handleSuccess(requestInfo, data, success);
	        }
	    };
	    EndpointCaller.prototype.handleSuccess = function (requestInfo, data, success) {
	        var querySuccess = {
	            duration: TimeSpanUtils_1.TimeSpan.fromDates(requestInfo.begun, new Date()).getMilliseconds(),
	            data: data
	        };
	        this.logger.trace('REST request successful', data, requestInfo);
	        success(querySuccess);
	    };
	    EndpointCaller.prototype.handleError = function (requestInfo, status, data, error) {
	        var queryError = {
	            statusCode: status,
	            data: data
	        };
	        this.logger.error('REST request failed', status, data, requestInfo);
	        error(queryError);
	    };
	    EndpointCaller.prototype.combineUrlAndQueryString = function (url, queryString) {
	        var questionMark = '?';
	        if (url.match(/\?$/)) {
	            questionMark = '';
	        }
	        return url + (queryString.length > 0 ? questionMark + queryString.join('&') : '');
	    };
	    EndpointCaller.prototype.isXDomainRequestSupported = function () {
	        return 'XDomainRequest' in window;
	    };
	    EndpointCaller.prototype.isCORSSupported = function () {
	        return 'withCredentials' in new XMLHttpRequest();
	    };
	    EndpointCaller.prototype.isSuccessHttpStatus = function (status) {
	        return status >= 200 && status < 300 || status === 304;
	    };
	    EndpointCaller.prototype.tryParseResponseText = function (json, contentType) {
	        if (contentType != null && contentType.indexOf('application/json') != -1) {
	            if (Utils_1.Utils.isNonEmptyString(json)) {
	                try {
	                    return JSON.parse(json);
	                }
	                catch (ex) {
	                    return undefined;
	                }
	            }
	            else {
	                return undefined;
	            }
	        }
	        else {
	            return json;
	        }
	    };
	    EndpointCaller.prototype.isErrorResponseBody = function (data) {
	        if (data && data.statusCode) {
	            return !this.isSuccessHttpStatus(data.statusCode);
	        }
	        else {
	            return false;
	        }
	    };
	    EndpointCaller.prototype.buildRequestHeaders = function (requestInfo) {
	        var headers = {};
	        if (this.options.accessToken) {
	            headers['Authorization'] = "Bearer " + this.options.accessToken;
	        }
	        else if (this.options.username && this.options.password) {
	            headers['Authorization'] = "Basic " + btoa(this.options.username + ':' + this.options.password);
	        }
	        if (requestInfo.method == 'GET') {
	            return headers;
	        }
	        if (requestInfo.requestDataType.indexOf('application/json') === 0) {
	            headers['Content-Type'] = 'application/json; charset="UTF-8"';
	        }
	        else {
	            headers['Content-Type'] = 'application/x-www-form-urlencoded; charset="UTF-8"';
	        }
	        return headers;
	    };
	    return EndpointCaller;
	}());
	exports.EndpointCaller = EndpointCaller;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 16 */
/***/ function(module, exports) {

	"use strict";
	// Ensure that we're not going to get console is undefined error in IE8-9
	if (!window['console']) {
	    console = {
	        log: function () {
	        },
	        debug: function () {
	        },
	        info: function () {
	        },
	        warn: function () {
	        },
	        error: function () {
	        },
	        assert: function () {
	        },
	        clear: function () {
	        },
	        count: function () {
	        },
	        dir: function () {
	        },
	        dirxml: function () {
	        },
	        group: function () {
	        },
	        groupCollapsed: function () {
	        },
	        groupEnd: function () {
	        },
	        msIsIndependentlyComposed: function (element) {
	        },
	        profile: function () {
	        },
	        profileEnd: function () {
	        },
	        select: function () {
	        },
	        time: function () {
	        },
	        timeEnd: function () {
	        },
	        trace: function () {
	        }
	    };
	}
	var Logger = (function () {
	    function Logger(owner) {
	        this.owner = owner;
	    }
	    Logger.prototype.trace = function () {
	        var stuff = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            stuff[_i - 0] = arguments[_i];
	        }
	        if (Logger.level <= Logger.TRACE) {
	            this.log('TRACE', stuff);
	        }
	    };
	    Logger.prototype.debug = function () {
	        var stuff = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            stuff[_i - 0] = arguments[_i];
	        }
	        if (Logger.level <= Logger.DEBUG) {
	            this.log('DEBUG', stuff);
	        }
	    };
	    Logger.prototype.info = function () {
	        var stuff = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            stuff[_i - 0] = arguments[_i];
	        }
	        if (Logger.level <= Logger.INFO) {
	            this.log('INFO', stuff);
	        }
	    };
	    Logger.prototype.warn = function () {
	        var stuff = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            stuff[_i - 0] = arguments[_i];
	        }
	        if (Logger.level <= Logger.WARN) {
	            this.log('WARN', stuff);
	        }
	    };
	    Logger.prototype.error = function () {
	        var stuff = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            stuff[_i - 0] = arguments[_i];
	        }
	        if (Logger.level <= Logger.ERROR) {
	            this.log('ERROR', stuff);
	        }
	    };
	    Logger.prototype.log = function (level, stuff) {
	        if (window['console'] && console.log) {
	            console.log([level, this.owner].concat(stuff));
	            if (Logger.executionTime) {
	                console.timeEnd('Execution time');
	                console.time('Execution time');
	            }
	        }
	    };
	    Logger.enable = function () {
	        Logger.level = Logger.TRACE;
	    };
	    Logger.disable = function () {
	        Logger.level = Logger.NOTHING;
	    };
	    Logger.TRACE = 1;
	    Logger.DEBUG = 2;
	    Logger.INFO = 3;
	    Logger.WARN = 4;
	    Logger.ERROR = 5;
	    Logger.NOTHING = 6;
	    Logger.level = Logger.INFO;
	    Logger.executionTime = false;
	    return Logger;
	}());
	exports.Logger = Logger;


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var Logger_1 = __webpack_require__(16);
	var Utils_1 = __webpack_require__(18);
	var Assert = (function () {
	    function Assert() {
	    }
	    Assert.fail = function (message) {
	        Assert.failureHandler(message);
	    };
	    Assert.check = function (condition, message) {
	        if (!condition) {
	            Assert.fail(message);
	        }
	    };
	    Assert.isUndefined = function (obj) {
	        Assert.check(Utils_1.Utils.isUndefined(obj), 'Value should be undefined.');
	    };
	    Assert.isNotUndefined = function (obj) {
	        Assert.check(!Utils_1.Utils.isUndefined(obj), 'Value should not be undefined.');
	    };
	    Assert.isNull = function (obj) {
	        Assert.check(Utils_1.Utils.isNull(obj), 'Value should be null.');
	    };
	    Assert.isNotNull = function (obj) {
	        Assert.check(!Utils_1.Utils.isNull(obj), 'Value should not be null.');
	    };
	    Assert.exists = function (obj) {
	        Assert.check(!Utils_1.Utils.isNullOrUndefined(obj), 'Value should not be null or undefined');
	    };
	    Assert.doesNotExists = function (obj) {
	        Assert.check(Utils_1.Utils.isNullOrUndefined(obj), 'Value should be null or undefined');
	    };
	    Assert.isString = function (obj) {
	        Assert.check(_.isString(obj), 'Value should be a string.');
	    };
	    Assert.stringStartsWith = function (str, start) {
	        Assert.isNonEmptyString(str);
	        Assert.isNonEmptyString(start);
	        Assert.check(str.indexOf(start) == 0, 'Value should start with ' + start);
	    };
	    Assert.isNonEmptyString = function (str) {
	        Assert.check(Utils_1.Utils.isNonEmptyString(str), 'Value should be a non-empty string.');
	    };
	    Assert.isNumber = function (obj) {
	        Assert.check(_.isNumber(obj), 'Value should be a number.');
	    };
	    Assert.isLargerThan = function (expected, actual) {
	        Assert.check(actual > expected, 'Value ' + actual + ' should be larger than ' + expected);
	    };
	    Assert.isLargerOrEqualsThan = function (expected, actual) {
	        Assert.check(actual >= expected, 'Value ' + actual + ' should be larger or equal than ' + expected);
	    };
	    Assert.isSmallerThan = function (expected, actual) {
	        Assert.check(actual < expected, 'Value ' + actual + ' should be smaller than ' + expected);
	    };
	    Assert.isSmallerOrEqualsThan = function (expected, actual) {
	        Assert.check(actual <= expected, 'Value ' + actual + ' should be smaller or equal than ' + expected);
	    };
	    Assert.logger = new Logger_1.Logger('Assert');
	    Assert.failureHandler = function (message) {
	        Assert.logger.error('Assertion Failed!', message);
	        if (window['console'] && console.trace) {
	            console.trace();
	        }
	        if (Utils_1.Utils.isNonEmptyString(message)) {
	            throw new PreconditionFailedException(message);
	        }
	        else {
	            throw new PreconditionFailedException('Assertion Failed!');
	        }
	    };
	    return Assert;
	}());
	exports.Assert = Assert;
	var PreconditionFailedException = (function () {
	    function PreconditionFailedException(message) {
	        this.message = message;
	    }
	    PreconditionFailedException.prototype.toString = function () {
	        return this.message;
	    };
	    return PreconditionFailedException;
	}());
	exports.PreconditionFailedException = PreconditionFailedException;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var isCoveoFieldRegex = /^@[a-zA-Z0-9_\.]+$/;
	var Utils = (function () {
	    function Utils() {
	    }
	    Utils.isUndefined = function (obj) {
	        return typeof obj == 'undefined';
	    };
	    Utils.isNull = function (obj) {
	        return obj === null;
	    };
	    Utils.isNullOrUndefined = function (obj) {
	        return Utils.isUndefined(obj) || Utils.isNull(obj);
	    };
	    Utils.exists = function (obj) {
	        return !Utils.isNullOrUndefined(obj);
	    };
	    Utils.toNotNullString = function (str) {
	        return _.isString(str) ? str : '';
	    };
	    Utils.anyTypeToString = function (value) {
	        return value ? value.toString() : '';
	    };
	    Utils.isNullOrEmptyString = function (str) {
	        return Utils.isNullOrUndefined(str) || !Utils.isNonEmptyString(str);
	    };
	    Utils.isNonEmptyString = function (str) {
	        return _.isString(str) && str !== '';
	    };
	    Utils.isEmptyString = function (str) {
	        return !Utils.isNonEmptyString(str);
	    };
	    Utils.stringStartsWith = function (str, startWith) {
	        return str.slice(0, startWith.length) == startWith;
	    };
	    Utils.isNonEmptyArray = function (obj) {
	        return _.isArray(obj) && obj.length > 0;
	    };
	    Utils.isEmptyArray = function (obj) {
	        return !Utils.isNonEmptyArray(obj);
	    };
	    Utils.isHtmlElement = function (obj) {
	        if (window['HTMLElement'] != undefined) {
	            return obj instanceof HTMLElement;
	        }
	        else {
	            return obj && obj.nodeType && obj.nodeType == 1;
	        }
	    };
	    Utils.parseIntIfNotUndefined = function (str) {
	        if (Utils.isNonEmptyString(str)) {
	            return parseInt(str, 10);
	        }
	        else {
	            return undefined;
	        }
	    };
	    Utils.parseFloatIfNotUndefined = function (str) {
	        if (Utils.isNonEmptyString(str)) {
	            return parseFloat(str);
	        }
	        else {
	            return undefined;
	        }
	    };
	    Utils.round = function (num, decimals) {
	        return Math.round(num * Math.pow(10, decimals)) / Math.pow(10, decimals);
	    };
	    Utils.parseBooleanIfNotUndefined = function (str) {
	        if (Utils.isNonEmptyString(str)) {
	            switch (str.toLowerCase()) {
	                case 'true':
	                case '1':
	                case 'yes':
	                    return true;
	                case 'false':
	                case '0':
	                case 'no':
	                    return false;
	                default:
	                    return undefined;
	            }
	        }
	        else {
	            return undefined;
	        }
	    };
	    Utils.trim = function (value) {
	        if (value == null) {
	            return null;
	        }
	        return value.replace(/^\s+|\s+$/g, '');
	    };
	    Utils.encodeHTMLEntities = function (rawStr) {
	        var ret = [];
	        for (var i = rawStr.length - 1; i >= 0; i--) {
	            if (/^[a-z0-9]/i.test(rawStr[i])) {
	                ret.unshift(rawStr[i]);
	            }
	            else {
	                ret.unshift(['&#', rawStr.charCodeAt(i), ';'].join(''));
	            }
	        }
	        return ret.join('');
	    };
	    Utils.decodeHTMLEntities = function (rawString) {
	        return rawString.replace(/&#(\d+);/g, function (match, dec) {
	            return String.fromCharCode(dec);
	        });
	    };
	    Utils.arrayEqual = function (array1, array2, sameOrder) {
	        if (sameOrder === void 0) { sameOrder = true; }
	        if (sameOrder) {
	            return _.isEqual(array1, array2);
	        }
	        else {
	            var arrays_1 = [array1, array2];
	            return _.all(arrays_1, function (array) {
	                return array.length == arrays_1[0].length && _.difference(array, arrays_1[0]).length == 0;
	            });
	        }
	    };
	    Utils.objectEqual = function (obj1, obj2) {
	        return _.isEqual(obj1, obj2);
	    };
	    Utils.isCoveoField = function (field) {
	        return isCoveoFieldRegex.test(field);
	    };
	    Utils.escapeRegexCharacter = function (str) {
	        var ret = str.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
	        return ret;
	    };
	    Utils.getCaseInsensitiveProperty = function (object, name) {
	        // First try using a fast case-sensitive lookup
	        var value = object[name];
	        // Then try a fast case-sensitive lookup with lowercase name
	        if (value == null) {
	            var lowerCaseName_1 = name.toLowerCase();
	            value = object[lowerCaseName_1];
	            // Then try a slow scanning of all the properties
	            if (value == null) {
	                var matchingKey = _.find(_.keys(object), function (key) { return key.toLowerCase() == lowerCaseName_1; });
	                if (matchingKey != null) {
	                    value = object[matchingKey];
	                }
	            }
	        }
	        return value;
	    };
	    Utils.getFieldValue = function (result, name) {
	        // Be as forgiving as possible about the field name, since we expect
	        // user provided values.
	        if (name == null) {
	            return undefined;
	        }
	        name = Utils.trim(name);
	        if (name[0] == '@') {
	            name = name.substr(1);
	        }
	        if (name == '') {
	            return undefined;
	        }
	        // At this point the name should be well formed
	        if (!Utils.isCoveoField('@' + name)) {
	            throw "Not a valid field : " + name;
	        }
	        // Handle namespace field values of the form sf.Foo.Bar
	        var parts = name.split('.').reverse();
	        var obj = result.raw;
	        while (parts.length > 1) {
	            obj = Utils.getCaseInsensitiveProperty(obj, parts.pop());
	            if (Utils.isUndefined(obj)) {
	                return undefined;
	            }
	        }
	        var value = Utils.getCaseInsensitiveProperty(obj, parts[0]);
	        // If still nothing, look at the root of the result
	        if (value == null) {
	            value = Utils.getCaseInsensitiveProperty(result, name);
	        }
	        return value;
	    };
	    Utils.throttle = function (func, wait, options, context, args) {
	        if (options === void 0) { options = {}; }
	        var result;
	        var timeout = null;
	        var previous = 0;
	        var later = function () {
	            previous = options.leading === false ? 0 : new Date().getTime();
	            timeout = null;
	            result = func.apply(context, args);
	        };
	        return function () {
	            var now = new Date().getTime();
	            if (!previous && options.leading === false) {
	                previous = now;
	            }
	            var remaining = wait - (now - previous);
	            context = this;
	            args = arguments;
	            if (remaining <= 0) {
	                clearTimeout(timeout);
	                timeout = null;
	                previous = now;
	                result = func.apply(context, args);
	            }
	            else if (!timeout && options.trailing !== false) {
	                timeout = setTimeout(later, remaining);
	            }
	            return result;
	        };
	    };
	    Utils.extendDeep = function (target, src) {
	        if (!target) {
	            target = {};
	        }
	        var isArray = _.isArray(src);
	        var toReturn = isArray && [] || {};
	        if (isArray) {
	            target = target || [];
	            toReturn = toReturn['concat'](target);
	            _.each(src, function (e, i, obj) {
	                if (typeof target[i] === 'undefined') {
	                    toReturn[i] = e;
	                }
	                else if (typeof e === 'object') {
	                    toReturn[i] = Utils.extendDeep(target[i], e);
	                }
	                else {
	                    if (target.indexOf(e) === -1) {
	                        toReturn['push'](e);
	                    }
	                }
	            });
	        }
	        else {
	            if (target && typeof target === 'object') {
	                _.each(_.keys(target), function (key) {
	                    toReturn[key] = target[key];
	                });
	            }
	            _.each(_.keys(src), function (key) {
	                if (typeof src[key] !== 'object' || !src[key]) {
	                    toReturn[key] = src[key];
	                }
	                else {
	                    if (!target[key]) {
	                        toReturn[key] = src[key];
	                    }
	                    else {
	                        toReturn[key] = Utils.extendDeep(target[key], src[key]);
	                    }
	                }
	            });
	        }
	        return toReturn;
	    };
	    Utils.getQueryStringValue = function (key, queryString) {
	        if (queryString === void 0) { queryString = window.location.search; }
	        return queryString.replace(new RegExp('^(?:.*[&\\?]' + key.replace(/[\.\+\*]/g, '\\$&') + '(?:\\=([^&]*))?)?.*$', 'i'), '$1');
	    };
	    Utils.isValidUrl = function (str) {
	        var regexp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
	        return regexp.test(str);
	    };
	    Utils.debounce = function (func, wait) {
	        var timeout;
	        var stackTraceTimeout;
	        return function () {
	            var _this = this;
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i - 0] = arguments[_i];
	            }
	            if (timeout == null) {
	                timeout = setTimeout(function () {
	                    timeout = null;
	                }, wait);
	                stackTraceTimeout = setTimeout(function () {
	                    func.apply(_this, args);
	                    stackTraceTimeout = null;
	                });
	            }
	            else if (stackTraceTimeout == null) {
	                clearTimeout(timeout);
	                timeout = setTimeout(function () {
	                    func.apply(_this, args);
	                    timeout = null;
	                }, wait);
	            }
	        };
	    };
	    Utils.readCookie = function (name) {
	        var nameEQ = name + '=';
	        var ca = document.cookie.split(';');
	        for (var i = 0; i < ca.length; i++) {
	            var c = ca[i];
	            while (c.charAt(0) == ' ') {
	                c = c.substring(1, c.length);
	            }
	            if (c.indexOf(nameEQ) == 0) {
	                return c.substring(nameEQ.length, c.length);
	            }
	        }
	        return null;
	    };
	    Utils.toDashCase = function (camelCased) {
	        return camelCased.replace(/([a-z][A-Z])/g, function (g) { return g[0] + '-' + g[1].toLowerCase(); });
	    };
	    // Based on http://stackoverflow.com/a/8412989
	    Utils.parseXml = function (xml) {
	        if (typeof DOMParser != 'undefined') {
	            return (new DOMParser()).parseFromString(xml, 'text/xml');
	        }
	        else if (typeof ActiveXObject != 'undefined' && new ActiveXObject('Microsoft.XMLDOM')) {
	            var xmlDoc = new ActiveXObject('Microsoft.XMLDOM');
	            xmlDoc.async = 'false';
	            xmlDoc.loadXML(xml);
	            return xmlDoc;
	        }
	        else {
	            throw new Error('No XML parser found');
	        }
	    };
	    Utils.copyObject = function (target, src) {
	        var _this = this;
	        _.each(_.keys(src), function (key) {
	            if (typeof src[key] !== 'object' || !src[key]) {
	                target[key] = src[key];
	            }
	            else if (!target[key]) {
	                target[key] = src[key];
	            }
	            else {
	                _this.copyObject(target[key], src[key]);
	            }
	        });
	    };
	    Utils.copyObjectAttributes = function (target, src, attributes) {
	        var _this = this;
	        _.each(_.keys(src), function (key) {
	            if (_.contains(attributes, key)) {
	                if (typeof src[key] !== 'object' || !src[key]) {
	                    target[key] = src[key];
	                }
	                else if (!target[key]) {
	                    target[key] = src[key];
	                }
	                else {
	                    _this.copyObject(target[key], src[key]);
	                }
	            }
	        });
	    };
	    return Utils;
	}());
	exports.Utils = Utils;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var Assert_1 = __webpack_require__(17);
	var TimeSpan = (function () {
	    function TimeSpan(time, isMilliseconds) {
	        if (isMilliseconds === void 0) { isMilliseconds = true; }
	        if (isMilliseconds) {
	            this.milliseconds = time;
	        }
	        else {
	            this.milliseconds = time * 1000;
	        }
	    }
	    TimeSpan.prototype.getMilliseconds = function () {
	        return this.milliseconds;
	    };
	    TimeSpan.prototype.getSeconds = function () {
	        return this.getMilliseconds() / 1000;
	    };
	    TimeSpan.prototype.getMinutes = function () {
	        return this.getSeconds() / 60;
	    };
	    TimeSpan.prototype.getHours = function () {
	        return this.getMinutes() / 60;
	    };
	    TimeSpan.prototype.getDays = function () {
	        return this.getHours() / 24;
	    };
	    TimeSpan.prototype.getWeeks = function () {
	        return this.getDays() / 7;
	    };
	    TimeSpan.prototype.getHHMMSS = function () {
	        var hours = Math.floor(this.getHours());
	        var minutes = Math.floor(this.getMinutes()) % 60;
	        var seconds = Math.floor(this.getSeconds()) % 60;
	        var hoursString, minutesString, secondsString;
	        if (hours == 0) {
	            hoursString = '';
	        }
	        else {
	            hoursString = hours < 10 ? '0' + hours.toString() : hours.toString();
	        }
	        minutesString = minutes < 10 ? '0' + minutes.toString() : minutes.toString();
	        secondsString = seconds < 10 ? '0' + seconds.toString() : seconds.toString();
	        var hhmmss = (hoursString != '' ? hoursString + ':' : '') + minutesString + ':' + secondsString;
	        return hhmmss;
	    };
	    TimeSpan.fromDates = function (from, to) {
	        Assert_1.Assert.exists(from);
	        Assert_1.Assert.exists(to);
	        return new TimeSpan(to.valueOf() - from.valueOf());
	    };
	    return TimeSpan;
	}());
	exports.TimeSpan = TimeSpan;


/***/ },
/* 20 */
/***/ function(module, exports) {

	"use strict";
	// Not sure about this : In year 2033 who's to say that this list won't be 50 pages long !
	var mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	var DeviceUtils = (function () {
	    function DeviceUtils() {
	    }
	    DeviceUtils.getDeviceName = function () {
	        var userAgent = navigator.userAgent;
	        if (userAgent.match(/Android/i)) {
	            return 'Android';
	        }
	        if (userAgent.match(/BlackBerry/i)) {
	            return 'BlackBerry';
	        }
	        if (userAgent.match(/iPhone/i)) {
	            return 'iPhone';
	        }
	        if (userAgent.match(/iPad/i)) {
	            return 'iPad';
	        }
	        if (userAgent.match(/iPod/i)) {
	            return 'iPod';
	        }
	        if (userAgent.match(/Opera Mini/i)) {
	            return 'Opera Mini';
	        }
	        if (userAgent.match(/IEMobile/i)) {
	            return 'IE Mobile';
	        }
	        if (userAgent.match(/Chrome/i)) {
	            return 'Chrome';
	        }
	        if (userAgent.match(/MSIE/i) || userAgent.match(/Trident/i)) {
	            return 'IE';
	        }
	        if (userAgent.match(/Opera/i)) {
	            return 'Opera';
	        }
	        if (userAgent.match(/Firefox/i)) {
	            return 'Firefox';
	        }
	        if (userAgent.match(/Safari/i)) {
	            return 'Safari';
	        }
	        return 'Others';
	    };
	    DeviceUtils.isAndroid = function () {
	        return DeviceUtils.getDeviceName() == 'Android';
	    };
	    DeviceUtils.isIos = function () {
	        var deviceName = DeviceUtils.getDeviceName();
	        return deviceName == 'iPhone' || deviceName == 'iPad' || deviceName == 'iPod';
	    };
	    DeviceUtils.isIE8or9 = function () {
	        var myNav = navigator.userAgent.toLowerCase();
	        if (myNav.indexOf('msie') == -1) {
	            return false;
	        }
	        return parseInt(myNav.split('msie')[1]) < 10;
	    };
	    DeviceUtils.isMobileDevice = function () {
	        return mobile;
	    };
	    DeviceUtils.isSmallScreenWidth = function () {
	        if (window['clientWidth'] != null && window['clientWidth'] <= 480) {
	            return true;
	        }
	        return document.body.clientWidth <= 480;
	    };
	    DeviceUtils.isSmallScreenHeight = function () {
	        return document.body.clientHeight <= 640;
	    };
	    return DeviceUtils;
	}());
	exports.DeviceUtils = DeviceUtils;


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var Assert_1 = __webpack_require__(17);
	var AjaxError = (function () {
	    function AjaxError(message, status) {
	        this.message = message;
	        this.status = status;
	        Assert_1.Assert.exists(message);
	        Assert_1.Assert.exists(status);
	        this.name = this.type = 'Ajax Error (status: ' + status + ')';
	    }
	    return AjaxError;
	}());
	exports.AjaxError = AjaxError;


/***/ },
/* 22 */
/***/ function(module, exports) {

	"use strict";
	var MissingAuthenticationError = (function () {
	    function MissingAuthenticationError(provider) {
	        this.provider = provider;
	        this.isMissingAuthentication = true;
	        this.name = this.type = this.message = "Missing Authentication (provider: " + provider + ")";
	    }
	    return MissingAuthenticationError;
	}());
	exports.MissingAuthenticationError = MissingAuthenticationError;


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var Assert_1 = __webpack_require__(17);
	var Utils_1 = __webpack_require__(18);
	var QueryUtils = (function () {
	    function QueryUtils() {
	    }
	    QueryUtils.createGuid = function () {
	        return (typeof (crypto) != 'undefined' && typeof (crypto.getRandomValues) != 'undefined') ? QueryUtils.generateWithCrypto() : QueryUtils.generateWithRandom();
	    };
	    // This method is a fallback as it's generate a lot of collisions in Chrome.
	    QueryUtils.generateWithRandom = function () {
	        // http://stackoverflow.com/a/2117523
	        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
	            return v.toString(16);
	        });
	    };
	    QueryUtils.generateWithCrypto = function () {
	        var buf = new Uint16Array(8);
	        crypto.getRandomValues(buf);
	        var S4 = function (num) {
	            var ret = num.toString(16);
	            while (ret.length < 4) {
	                ret = '0' + ret;
	            }
	            return ret;
	        };
	        return (S4(buf[0]) + S4(buf[1]) + '-' + S4(buf[2]) + '-' + S4(buf[3]) + '-' + S4(buf[4]) + '-' + S4(buf[5]) + S4(buf[6]) + S4(buf[7]));
	    };
	    QueryUtils.setStateObjectOnQueryResults = function (state, results) {
	        QueryUtils.setPropertyOnResults(results, 'state', state);
	    };
	    QueryUtils.setStateObjectOnQueryResult = function (state, result) {
	        QueryUtils.setPropertyOnResult(result, 'state', state);
	    };
	    QueryUtils.setIndexAndUidOnQueryResults = function (query, results, queryUid, pipeline, splitTestRun) {
	        Assert_1.Assert.exists(query);
	        Assert_1.Assert.exists(results);
	        var index = query.firstResult;
	        QueryUtils.setPropertyOnResults(results, 'queryUid', queryUid);
	        QueryUtils.setPropertyOnResults(results, 'pipeline', pipeline);
	        QueryUtils.setPropertyOnResults(results, 'splitTestRun', splitTestRun);
	        QueryUtils.setPropertyOnResults(results, 'index', index, function () { return ++index; });
	    };
	    QueryUtils.setTermsToHighlightOnQueryResults = function (query, results) {
	        QueryUtils.setPropertyOnResults(results, 'termsToHighlight', results.termsToHighlight);
	        QueryUtils.setPropertyOnResults(results, 'phrasesToHighlight', results.phrasesToHighlight);
	    };
	    QueryUtils.splitFlags = function (flags, delimiter) {
	        if (delimiter === void 0) { delimiter = ';'; }
	        Assert_1.Assert.exists(flags);
	        return flags.split(delimiter);
	    };
	    QueryUtils.isAttachment = function (result) {
	        return _.contains(QueryUtils.splitFlags(result.flags), 'IsAttachment');
	    };
	    QueryUtils.containsAttachment = function (result) {
	        return _.contains(QueryUtils.splitFlags(result.flags), 'ContainsAttachment');
	    };
	    QueryUtils.hasHTMLVersion = function (result) {
	        return _.contains(QueryUtils.splitFlags(result.flags), 'HasHtmlVersion');
	    };
	    QueryUtils.hasThumbnail = function (result) {
	        return _.contains(QueryUtils.splitFlags(result.flags), 'HasThumbnail');
	    };
	    QueryUtils.hasExcerpt = function (result) {
	        return result.excerpt != undefined && result.excerpt != '';
	    };
	    QueryUtils.quoteAndEscapeIfNeeded = function (str) {
	        Assert_1.Assert.isString(str);
	        return QueryUtils.isAtomicString(str) || (QueryUtils.isRangeString(str) || QueryUtils.isRangeWithoutOuterBoundsString(str)) ? str : QueryUtils.quoteAndEscape(str);
	    };
	    QueryUtils.quoteAndEscape = function (str) {
	        Assert_1.Assert.isString(str);
	        return "\"" + QueryUtils.escapeString(str) + "\"";
	    };
	    QueryUtils.escapeString = function (str) {
	        Assert_1.Assert.isString(str);
	        return str.replace(/"/g, ' ');
	    };
	    QueryUtils.isAtomicString = function (str) {
	        Assert_1.Assert.isString(str);
	        return /^\d+(\.\d+)?$|^[\d\w]+$/.test(str);
	    };
	    QueryUtils.isRangeString = function (str) {
	        Assert_1.Assert.isString(str);
	        return /^\d+(\.\d+)?\.\.\d+(\.\d+)?$|^\d{4}\/\d{2}\/\d{2}@\d{2}:\d{2}:\d{2}\.\.\d{4}\/\d{2}\/\d{2}@\d{2}:\d{2}:\d{2}$/.test(str);
	    };
	    QueryUtils.isRangeWithoutOuterBoundsString = function (str) {
	        Assert_1.Assert.isString(str);
	        return /^\d+(\.\d+)?$|^\d{4}\/\d{2}\/\d{2}@\d{2}:\d{2}:\d{2}$/.test(str);
	    };
	    QueryUtils.buildFieldExpression = function (field, operator, values) {
	        Assert_1.Assert.isNonEmptyString(field);
	        Assert_1.Assert.stringStartsWith(field, '@');
	        Assert_1.Assert.isNonEmptyString(operator);
	        Assert_1.Assert.isLargerOrEqualsThan(1, values.length);
	        if (values.length == 1) {
	            return field + operator + QueryUtils.quoteAndEscapeIfNeeded(values[0]);
	        }
	        else {
	            return field + operator + '(' + _.map(values, function (str) { return QueryUtils.quoteAndEscapeIfNeeded(str); }).join(',') + ')';
	        }
	    };
	    QueryUtils.buildFieldNotEqualExpression = function (field, values) {
	        Assert_1.Assert.isNonEmptyString(field);
	        Assert_1.Assert.stringStartsWith(field, '@');
	        Assert_1.Assert.isLargerOrEqualsThan(1, values.length);
	        var filter;
	        if (values.length == 1) {
	            filter = field + '==' + QueryUtils.quoteAndEscapeIfNeeded(values[0]);
	        }
	        else {
	            filter = field + '==' + '(' + _.map(values, function (str) { return QueryUtils.quoteAndEscapeIfNeeded(str); }).join(',') + ')';
	        }
	        return '(NOT ' + filter + ')';
	    };
	    QueryUtils.mergeQueryString = function (url, queryString) {
	        var queryStringPosition = url.indexOf('?');
	        if (queryStringPosition != -1) {
	            url += '&' + queryString;
	        }
	        else {
	            url += '?' + queryString;
	        }
	        return url;
	    };
	    QueryUtils.mergePath = function (url, path) {
	        var urlSplit = url.split('?');
	        return urlSplit[0] + path + '?' + (urlSplit[1] || '');
	    };
	    QueryUtils.setPropertyOnResults = function (results, property, value, afterOneLoop) {
	        _.each(results.results, function (result) {
	            QueryUtils.setPropertyOnResult(result, property, value);
	            value = afterOneLoop ? afterOneLoop() : value;
	        });
	    };
	    QueryUtils.setPropertyOnResult = function (result, property, value) {
	        result[property] = value;
	        _.each(result.childResults, function (child) {
	            child[property] = value;
	        });
	        if (!Utils_1.Utils.isNullOrUndefined(result.parentResult)) {
	            result.parentResult[property] = value;
	        }
	    };
	    // http://stackoverflow.com/a/11582513
	    QueryUtils.getUrlParameter = function (name) {
	        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [, ''])[1].replace(/\+/g, '%20')) || null;
	    };
	    QueryUtils.isStratusAgnosticField = function (fieldToVerify, fieldToMatch) {
	        var checkForSystem = /^(@?)(sys)?(.*)/i;
	        var matchFieldToVerify = checkForSystem.exec(fieldToVerify);
	        var matchFieldToMatch = checkForSystem.exec(fieldToMatch);
	        if (matchFieldToVerify && matchFieldToMatch) {
	            return (matchFieldToVerify[1] + matchFieldToVerify[3]).toLowerCase() == (matchFieldToMatch[1] + matchFieldToMatch[3]).toLowerCase();
	        }
	        return false;
	    };
	    return QueryUtils;
	}());
	exports.QueryUtils = QueryUtils;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var Assert_1 = __webpack_require__(17);
	var QueryError = (function () {
	    function QueryError(errorResponse) {
	        this.status = errorResponse.statusCode;
	        this.message = errorResponse.data.message;
	        this.name = this.type = errorResponse.data.type;
	        this.queryExecutionReport = errorResponse.data.executionReport;
	        Assert_1.Assert.isNumber(this.status);
	        Assert_1.Assert.isNonEmptyString(this.message);
	        Assert_1.Assert.isNonEmptyString(this.type);
	    }
	    return QueryError;
	}());
	exports.QueryError = QueryError;


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	exports.ModalBox = __webpack_require__(26);
	exports.MagicBox = __webpack_require__(27);
	exports.LocaleString = __webpack_require__(28);


/***/ },
/* 26 */
/***/ function(module, exports) {

	var Coveo;!function(e){var o;!function(e){function o(e,o){void 0===o&&(o={});var n=o.body||document.body;n.className?n.className.indexOf("coveo-modalBox-opened")==-1&&(n.className+=" coveo-modalBox-opened"):n.className="coveo-modalBox-opened";var c=document.createElement("div");c.className="coveo-modalBox",n.appendChild(c),o.fullscreen===!0&&(c.className+=" coveo-fullscreen");var d=document.createElement("div");d.className="coveo-overlay",c.appendChild(d);var s=document.createElement("div");if(s.className="coveo-wrapper",c.appendChild(s),null!=o.title){var r=document.createElement("div");r.className="coveo-title",s.appendChild(r),r.innerHTML=o.title,o.titleClose===!0&&r.addEventListener("click",function(){return v()})}e.className+=" coveo-body",s.appendChild(e);var i,v=function(e,t){void 0===e&&(e=0),void 0===t&&(t=!1);var d=null==o.validation||o.validation(e);if(d!==!1||t){c.parentElement&&c.parentElement.removeChild(c);var s=l.indexOf(v);return s>=0&&l.splice(s,1),null==n.querySelector(".coveo-modalBox")&&a(n,"coveo-modalBox-opened"),!0}return!1},u=function(e,o){var n=document.createElement("div");n.className="coveo-button",n.textContent=e,n.addEventListener("click",function(){return v(o)}),i.appendChild(n)};return null!=o.buttons&&(i=document.createElement("div"),i.className="coveo-buttons",s.appendChild(i),o.buttons&t.OK&&u("Ok",t.OK),o.buttons&t.APPLY&&u("Apply",t.APPLY),o.buttons&t.YES&&u("Yes",t.YES),o.buttons&t.NO&&u("No",t.NO),o.buttons&t.CANCEL&&u("Cancel",t.CANCEL)),l.push(v),o.overlayClose===!0&&d.addEventListener("click",function(e){return v()}),null!=o.className&&(c.className+=" "+o.className),{modalBox:c,overlay:d,wrapper:s,buttons:i,content:e,close:v}}function n(e){void 0===e&&(e=!1);for(var o=0;l.length>o;){var n=l[o](0,e);n||o++}}function a(e,o){e.className=e.className.replace(new RegExp("(^|\\s)"+o+"(\\s|\\b)","g"),"$1")}!function(e){e[e.OK=1]="OK",e[e.APPLY=2]="APPLY",e[e.YES=4]="YES",e[e.NO=8]="NO",e[e.CANCEL=16]="CANCEL"}(e.BUTTON||(e.BUTTON={}));var t=e.BUTTON,l=[];e.open=o,e.close=n}(o=e.ModalBox||(e.ModalBox={}))}(Coveo||(Coveo={}));
	
	/*** EXPORTS FROM exports-loader ***/
	module.exports = Coveo.ModalBox;

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var __extends=this&&this.__extends||function(t,e){function n(){this.constructor=t}for(var s in e)e.hasOwnProperty(s)&&(t[s]=e[s]);t.prototype=null===e?Object.create(e):(n.prototype=e.prototype,new n)},Coveo;!function(t){var e;!function(t){var e=function(){function e(t,e,n){var s=this;this.expression=e,this.input=n,_.isString(t)?this.value=t:_.isArray(t)&&(this.subResults=t,_.forEach(this.subResults,function(t){t.parent=s}))}return e.prototype.isSuccess=function(){return null!=this.value||null!=this.subResults&&_.all(this.subResults,function(t){return t.isSuccess()})},e.prototype.path=function(t){var e=null!=this.parent&&this.parent!=t?this.parent.path(t):[];return e.push(this),e},e.prototype.findParent=function(t){for(var e=this,n=_.isString(t)?function(e){return t==e.expression.id}:t;null!=e&&!n(e);)e=e.parent;return e},e.prototype.find=function(t){var e=_.isString(t)?function(e){return t==e.expression.id}:t;if(e(this))return this;if(this.subResults)for(var n=0;n<this.subResults.length;n++){var s=this.subResults[n].find(e);if(s)return s}return null},e.prototype.findAll=function(t){var e=[],n=_.isString(t)?function(e){return t==e.expression.id}:t;return n(this)&&e.push(this),this.subResults&&(e=_.reduce(this.subResults,function(t,e){return t.concat(e.findAll(n))},e)),e},e.prototype.resultAt=function(t,e){if(t<0||t>this.getLength())return[];if(null!=e){if(_.isString(e)){if(e==this.expression.id)return[this]}else if(e(this))return[this]}else{var n=null==this.value&&null==this.subResults?this.input:this.value;if(null!=n)return[this]}if(null!=this.subResults){for(var s=[],i=0;i<this.subResults.length;i++){var o=this.subResults[i];if(s=s.concat(o.resultAt(t,e)),t-=o.getLength(),t<0)break}return s}return[]},e.prototype.getExpect=function(){return null==this.value&&null==this.subResults?[this]:null!=this.subResults?_.reduce(this.subResults,function(t,e){return t.concat(e.getExpect())},[]):[]},e.prototype.getBestExpect=function(){var t=this.getExpect(),e=_.groupBy(t,function(t){return t.input}),n=_.last(_.keys(e).sort(function(t,e){return e.length-t.length})),s=e[n],e=_.groupBy(s,function(t){return t.expression.id});return _.map(e,function(t){return _.chain(t).map(function(t){return{path:t.path().length,result:t}}).sortBy("path").pluck("result").first().value()})},e.prototype.getHumanReadableExpect=function(){var t=this.getBestExpect(),e=t.length>0?_.last(t).input:"";return"Expected "+_.map(t,function(t){return t.getHumanReadable()}).join(" or ")+" but "+(e.length>0?JSON.stringify(e[0]):"end of input")+" found."},e.prototype.before=function(){if(null==this.parent)return"";var t=_.indexOf(this.parent.subResults,this);return this.parent.before()+_.chain(this.parent.subResults).first(t).map(function(t){return t.toString()}).join("").value()},e.prototype.after=function(){if(null==this.parent)return"";var t=_.indexOf(this.parent.subResults,this);return _.chain(this.parent.subResults).last(this.parent.subResults.length-t-1).map(function(t){return t.toString()}).join("").value()+this.parent.after()},e.prototype.getLength=function(){return null!=this.value?this.value.length:null!=this.subResults?_.reduce(this.subResults,function(t,e){return t+e.getLength()},0):this.input.length},e.prototype.toHtmlElement=function(){var t=document.createElement("span"),e=null!=this.expression?this.expression.id:null;if(null!=e){var n=document.createAttribute("data-id");n.value=e,t.setAttributeNode(n)}var s=document.createAttribute("data-success");if(s.value=this.isSuccess().toString(),t.setAttributeNode(s),null!=this.value){t.appendChild(document.createTextNode(this.value));var i=document.createAttribute("data-value");i.value=this.value,t.setAttributeNode(i)}else if(null!=this.subResults)_.each(this.subResults,function(e){t.appendChild(e.toHtmlElement())});else{t.appendChild(document.createTextNode(this.input));var o=document.createAttribute("data-input");o.value=this.input,t.setAttributeNode(o),t.className="magic-box-error"+(this.input.length>0?"":" magic-box-error-empty")}return t.result=this,t},e.prototype.clean=function(t){if(null!=t||!this.isSuccess()){t=t||_.last(this.getBestExpect()).path(this);var n=_.first(t);if(null!=n){var s=_.indexOf(this.subResults,n),i=s==-1?[]:_.map(_.first(this.subResults,s),function(t){return t.clean()});return i.push(n.clean(_.rest(t))),new e(i,this.expression,this.input)}return new e(null,this.expression,this.input)}return null!=this.value?new e(this.value,this.expression,this.input):null!=this.subResults?new e(_.map(this.subResults,function(t){return t.clean()}),this.expression,this.input):void 0},e.prototype.clone=function(){return null!=this.value?new e(this.value,this.expression,this.input):null!=this.subResults?new e(_.map(this.subResults,function(t){return t.clone()}),this.expression,this.input):new e(null,this.expression,this.input)},e.prototype.toString=function(){return null!=this.value?this.value:null!=this.subResults?_.map(this.subResults,function(t){return t.toString()}).join(""):this.input},e.prototype.getHumanReadable=function(){return this.expression instanceof t.ExpressionConstant?JSON.stringify(this.expression.value):this.expression.id},e}();t.Result=e}(e=t.MagicBox||(t.MagicBox={}))}(Coveo||(Coveo={}));var Coveo;!function(t){var e;!function(t){var e=function(e){function n(n){e.call(this,[n],t.ExpressionEndOfInput,n.input);var s=new t.Result(null,t.ExpressionEndOfInput,n.input.substr(n.getLength()));s.parent=this,this.subResults.push(s)}return __extends(n,e),n}(t.Result);t.EndOfInputResult=e}(e=t.MagicBox||(t.MagicBox={}))}(Coveo||(Coveo={}));var Coveo;!function(t){var e;!function(t){var e=function(e){function n(t,n,s,i){var o=this;e.call(this,null!=t?[t]:null,n,s),this.result=t,this.expression=n,this.input=s,this.failAttempt=i,_.forEach(this.failAttempt,function(t){t.parent=o})}return __extends(n,e),n.prototype.getExpect=function(){var t=this,e=[];return null!=this.result&&(e=this.result.getExpect()),e=_.reduce(this.failAttempt,function(t,e){return t.concat(e.getExpect())},e),e.length>0&&_.all(e,function(e){return e.input==t.input})?[this]:e},n.prototype.clean=function(e){if(null!=e||!this.isSuccess()){e=_.rest(e||_.last(this.getBestExpect()).path(this));var n=_.first(e);return null==n?new t.Result(null,this.expression,this.input):new t.Result([n.clean(_.rest(e))],this.expression,this.input)}return new t.Result(_.map(this.result.subResults,function(t){return t.clean()}),this.expression,this.input)},n}(t.Result);t.OptionResult=e}(e=t.MagicBox||(t.MagicBox={}))}(Coveo||(Coveo={}));var Coveo;!function(t){var e;!function(t){var e=function(e){function n(t,n,s,i){e.call(this,t,n,s),this.results=t,this.expression=n,this.input=s,_.last(t)!=i&&(this.failAttempt=i,null!=this.failAttempt&&(this.failAttempt.parent=this))}return __extends(n,e),n.prototype.getExpect=function(){var t=e.prototype.getExpect.call(this);return null!=this.failAttempt?t.concat(this.failAttempt.getExpect()):t},n.prototype.clean=function(n){if(null!=this.failAttempt&&(null!=n||!this.isSuccess())){n=n||_.last(this.getBestExpect()).path(this);var s=_.first(n);if(null!=s&&s==this.failAttempt){var i=_.last(this.subResults),o=_.map(null!=i&&i.isSuccess()?this.subResults:_.initial(this.subResults),function(t){return t.clean()});return o.push(s.clean(_.rest(n))),new t.Result(o,this.expression,this.input)}}return e.prototype.clean.call(this,n)},n}(t.Result);t.RefResult=e}(e=t.MagicBox||(t.MagicBox={}))}(Coveo||(Coveo={}));var Coveo;!function(t){var e;!function(t){var e=function(){function e(t,e){this.value=t,this.id=e}return e.prototype.parse=function(e,n){var s=0==e.indexOf(this.value),i=new t.Result(s?this.value:null,this,e);return s&&n&&e.length>this.value.length?new t.EndOfInputResult(i):i},e.prototype.toString=function(){return this.value},e}();t.ExpressionConstant=e}(e=t.MagicBox||(t.MagicBox={}))}(Coveo||(Coveo={}));var Coveo;!function(t){var e;!function(t){t.ExpressionEndOfInput={id:"end of input",parse:null}}(e=t.MagicBox||(t.MagicBox={}))}(Coveo||(Coveo={}));var Coveo;!function(t){var e;!function(t){var e=function(){function t(t,e,n){this.func=t,this.id=e,this.grammar=n}return t.prototype.parse=function(t,e){return this.func(t,e,this)},t.prototype.toString=function(){return this.id},t}();t.ExpressionFunction=e}(e=t.MagicBox||(t.MagicBox={}))}(Coveo||(Coveo={}));var Coveo;!function(t){var e;!function(t){var e=function(){function e(t,e){if(this.parts=t,this.id=e,0==t.length)throw JSON.stringify(e)+" should have at least 1 parts"}return e.prototype.parse=function(e,n){for(var s,i=[],o=e,r=0;r<this.parts.length;r++){var u=this.parts[r];if(s=u.parse(o,n&&r==this.parts.length-1),i.push(s),!s.isSuccess())break;o=o.substr(s.getLength())}return new t.Result(i,this,e)},e.prototype.toString=function(){return this.id},e}();t.ExpressionList=e}(e=t.MagicBox||(t.MagicBox={}))}(Coveo||(Coveo={}));var Coveo;!function(t){var e;!function(t){var e=function(){function e(t,e){this.parts=t,this.id=e}return e.prototype.parse=function(e,n){for(var s=[],i=0;i<this.parts.length;i++){var o=this.parts[i].parse(e,n);if(o.isSuccess())return new t.OptionResult(o,this,e,s);s.push(o)}return new t.OptionResult(null,this,e,s)},e.prototype.toString=function(){return this.id},e}();t.ExpressionOptions=e}(e=t.MagicBox||(t.MagicBox={}))}(Coveo||(Coveo={}));var Coveo;!function(t){var e;!function(t){var e=function(){function e(t,e,n,s){this.ref=t,this.occurrence=e,this.id=n,this.grammar=s}return e.prototype.parse=function(t,e){var n=this.grammar.getExpression(this.ref);if(null==n)throw"Expression not found:"+this.ref;return"?"==this.occurrence||null==this.occurrence?this.parseOnce(t,e,n):this.parseMany(t,e,n)},e.prototype.parseOnce=function(e,n,s){var i=s.parse(e,n),o=i.isSuccess();return o||"?"!=this.occurrence?new t.RefResult([i],this,e,o?null:i):n?0==e.length?new t.RefResult([],this,e,i):_.all(i.getBestExpect(),function(e){return e.expression==t.ExpressionEndOfInput})?new t.RefResult([new t.Result(null,t.ExpressionEndOfInput,e)],this,e,i):i:new t.RefResult([],this,e,null)},e.prototype.parseMany=function(e,n,s){var i,o,r=[],u=e;do i=s.parse(u,!1),o=i.isSuccess(),o&&(r.push(i),u=u.substr(i.getLength()));while(o&&i.input!=u);var a=_.isNumber(this.occurrence)?this.occurrence:"+"==this.occurrence?1:0;if(r.length<a)r.push(i);else if(n)if(r.length>0){var l=_.last(r);i=s.parse(l.input,!0),i.isSuccess()?r[r.length-1]=i:(r.push(new t.Result(null,t.ExpressionEndOfInput,l.input.substr(l.getLength()))),i=s.parse(l.input.substr(l.getLength()),!0))}else if(0!=e.length){var c=new t.Result(null,t.ExpressionEndOfInput,e);return new t.RefResult([c],this,e,i)}return new t.RefResult(r,this,e,i)},e.prototype.toString=function(){return this.id},e}();t.ExpressionRef=e}(e=t.MagicBox||(t.MagicBox={}))}(Coveo||(Coveo={}));var Coveo;!function(t){var e;!function(t){var e=function(){function e(t,e,n){this.value=t,this.id=e}return e.prototype.parse=function(e,n){var s=e.match(this.value);null!=s&&0!=s.index&&(s=null);var i=new t.Result(null!=s?s[0]:null,this,e);return i.isSuccess()&&n&&e.length>i.value.length?new t.EndOfInputResult(i):i},e.prototype.toString=function(){return this.id},e}();t.ExpressionRegExp=e}(e=t.MagicBox||(t.MagicBox={}))}(Coveo||(Coveo={}));var Coveo;!function(t){var e;!function(t){var e=function(){function e(e,n){void 0===n&&(n={}),this.expressions={},this.start=new t.ExpressionRef(e,null,"start",this),this.addExpressions(n)}return e.prototype.addExpressions=function(t){var e=this;_.each(t,function(t,n){e.addExpression(n,t)})},e.prototype.addExpression=function(t,n){if(t in this.expressions)throw"Grammar already contain the id:"+t;this.expressions[t]=e.buildExpression(n,t,this)},e.prototype.getExpression=function(t){return this.expressions[t]},e.prototype.parse=function(t){return this.start.parse(t,!0)},e.buildExpression=function(e,n,s){var i=typeof e;if("undefined"==i)throw"Invalid Expression: "+e;if(_.isString(e))return this.buildStringExpression(e,n,s);if(_.isArray(e))return new t.ExpressionOptions(_.map(e,function(e,i){return new t.ExpressionRef(e,null,n+"_"+i,s)}),n);if(_.isRegExp(e))return new t.ExpressionRegExp(e,n,s);if(_.isFunction(e))return new t.ExpressionFunction(e,n,s);throw"Invalid Expression: "+e},e.buildStringExpression=function(n,s,i){var o=e.stringMatch(n,e.spliter),r=_.map(o,function(e,n){if(e[1]){var o=e[1],r=e[3]?Number(e[3]):e[2]||null;return new t.ExpressionRef(o,r,s+"_"+n,i)}return new t.ExpressionConstant(e[4],s+"_"+n)});if(1==r.length){var u=r[0];return u.id=s,u}return new t.ExpressionList(r,s)},e.stringMatch=function(t,e){for(var n,s=[],i=new RegExp(e.source,"g");null!==(n=i.exec(t));)s.push(n);return s},e.spliter=/\[(\w+)(\*|\+|\?|\{([1-9][0-9]*)\})?\]|(.[^\[]*)/,e}();t.Grammar=e}(e=t.MagicBox||(t.MagicBox={}))}(Coveo||(Coveo={}));var Coveo;!function(t){var e;!function(t){var e=function(){function e(t,e,n){this.element=t,this.onchange=e,this.magicBox=n,this.hasFocus=!1,this.underlay=document.createElement("div"),this.underlay.className="magic-box-underlay",t.appendChild(this.underlay),this.highlightContainer=document.createElement("span"),this.highlightContainer.className="magic-box-highlight-container",this.underlay.appendChild(this.highlightContainer),this.ghostTextContainer=document.createElement("span"),this.ghostTextContainer.className="magic-box-ghost-text",this.underlay.appendChild(this.ghostTextContainer),this.input=document.createElement("input"),this.input.spellcheck=!1,this.input.setAttribute("form","coveo-dummy-form"),t.appendChild(this.input),this.setupHandler()}return e.prototype.updateInput=function(){this.input.value!=this.result.input&&(this.input.value=this.result.input)},e.prototype.updateHighlight=function(){this.highlightContainer.innerHTML="",this.highlightContainer.appendChild(this.result.toHtmlElement())},e.prototype.updateWordCompletion=function(){this.ghostTextContainer.innerHTML="",null!=this.wordCompletion&&this.ghostTextContainer.appendChild(document.createTextNode(this.wordCompletion.substr(this.result.input.length)))},e.prototype.updateScroll=function(e){var n=this;void 0===e&&(e=!0);var s=function(){n.underlay.clientWidth<n.underlay.scrollWidth&&(n.underlay.style.visibility="hidden",n.underlay.scrollLeft=n.input.scrollLeft,n.underlay.scrollTop=n.input.scrollTop,n.underlay.style.visibility="visible"),n.updateScrollDefer=null,n.hasFocus&&n.updateScroll()};e?null==this.updateScrollDefer&&(this.updateScrollDefer=t.requestAnimationFrame(s)):s()},e.prototype.setResult=function(t,e){this.result=t,this.updateInput(),this.updateHighlight(),_.isUndefined(e)&&null!=this.wordCompletion&&0==this.wordCompletion.indexOf(this.result.input)?this.updateWordCompletion():this.setWordCompletion(e),this.updateScroll()},e.prototype.setWordCompletion=function(t){null!=t&&0!=t.toLowerCase().indexOf(this.result.input.toLowerCase())&&(t=null),this.wordCompletion=t,this.updateWordCompletion(),this.updateScroll()},e.prototype.setCursor=function(t){if(this.input.focus(),this.input.createTextRange){var e=this.input.createTextRange();e.move("character",t),e.select()}else null!=this.input.selectionStart&&(this.input.focus(),this.input.setSelectionRange(t,t))},e.prototype.getCursor=function(){return this.input.selectionStart},e.prototype.setupHandler=function(){var t=this;this.input.onblur=function(){t.hasFocus=!1,setTimeout(function(){t.hasFocus||t.onblur&&t.onblur()},300),t.updateScroll()},this.input.onfocus=function(){t.hasFocus||(t.hasFocus=!0,t.updateScroll(),t.onfocus&&t.onfocus())},this.input.onkeydown=function(e){t.keydown(e)},this.input.onkeyup=function(e){t.keyup(e)},this.input.onclick=function(){t.onchangecursor()},this.input.select=function(){t.onchangecursor()},this.input.oncut=function(){setTimeout(function(){t.onInputChange()})},this.input.onpaste=function(){setTimeout(function(){t.onInputChange()})}},e.prototype.focus=function(){var t=this;this.hasFocus=!0,setTimeout(function(){t.input.focus()})},e.prototype.blur=function(){this.hasFocus&&this.input.blur()},e.prototype.keydown=function(e){var n=this;switch(e.keyCode||e.which){case 9:this.magicBox.hasSuggestions()&&e.preventDefault();break;default:e.stopPropagation(),null==this.onkeydown||this.onkeydown(e.keyCode||e.which)?t.requestAnimationFrame(function(){n.onInputChange()}):e.preventDefault()}},e.prototype.keyup=function(t){switch(t.keyCode||t.which){case 9:this.tabPress();break;case 37:case 39:this.onchangecursor();break;default:null==this.onkeydown||this.onkeyup(t.keyCode||t.which)?this.onInputChange():t.preventDefault()}},e.prototype.tabPress=function(){null!=this.wordCompletion&&(this.input.value=this.wordCompletion,this.ontabpress&&this.ontabpress(),this.onchange(this.wordCompletion,!0))},e.prototype.onInputChange=function(){this.result.input!=this.input.value&&this.onchange(this.input.value,!1)},e.prototype.getValue=function(){return this.input.value},e.prototype.getWordCompletion=function(){return this.wordCompletion},e}();t.InputManager=e}(e=t.MagicBox||(t.MagicBox={}))}(Coveo||(Coveo={}));var Coveo;!function(t){var e;!function(t){var e=function(){function e(e,n){var s=this;this.element=e,this.options=_.defaults(n,{selectableClass:"magic-box-suggestion",selectedClass:"magic-box-selected"}),void 0==this.options.timeout&&(this.options.timeout=500),this.hasSuggestions=!1,this.element.onmouseover=function(e){if(t.$$(e.target).hasClass(s.options.selectableClass)){for(var n=s.element.getElementsByClassName(s.options.selectedClass),i=0;i<n.length;i++){var o=n.item(i);t.$$(o).removeClass(s.options.selectedClass)}t.$$(e.target).addClass(s.options.selectedClass)}},this.element.onmouseout=function(e){t.$$(e.target).hasClass(s.options.selectableClass)&&t.$$(e.target).removeClass(s.options.selectedClass)}}return e.prototype.moveDown=function(){var e=this.element.getElementsByClassName(this.options.selectedClass).item(0),n=this.element.getElementsByClassName(this.options.selectableClass),s=-1;if(null!=e){t.$$(e).removeClass(this.options.selectedClass);for(var i=0;i<n.length;i++)if(e==n.item(i)){s=i;break}s=s==-1?0:s+1}else s=0;return e=n.item(s),null!=e&&t.$$(e).addClass(this.options.selectedClass),e&&e.suggestion},e.prototype.moveUp=function(){var e=this.element.getElementsByClassName(this.options.selectedClass).item(0),n=this.element.getElementsByClassName(this.options.selectableClass),s=-1;if(null!=e){t.$$(e).removeClass(this.options.selectedClass);for(var i=0;i<n.length;i++)if(e==n.item(i)){s=i;break}s=s==-1?n.length-1:s-1}else s=n.length-1;return e=n.item(s),null!=e&&t.$$(e).addClass(this.options.selectedClass),e&&e.suggestion},e.prototype.select=function(){var e=this.element.getElementsByClassName(this.options.selectedClass).item(0);return null!=e&&t.$$(e).trigger("keyboardSelect"),e},e.prototype.mergeSuggestions=function(t,e){var n,s=this,i=[];t=_.compact(t);var o=this.pendingSuggestion=new Promise(function(e,r){_.each(t,function(t){var e=!1;setTimeout(function(){e=!0},s.options.timeout),t.then(function(t){!e&&t&&(i=i.concat(t))})});var u=function(){n&&clearTimeout(n),0==i.length?e([]):o==s.pendingSuggestion||null==s.pendingSuggestion?e(i.sort(function(t,e){return e.index-t.index})):r("new request queued")};0==t.length&&u(),void 0==t&&u(),n=setTimeout(function(){u()},s.options.timeout),Promise.all(t).then(function(){return u()})});o.then(function(t){return e&&e(t),s.updateSuggestions(t),t})["catch"](function(){return null})},e.prototype.updateSuggestions=function(e){var n=this;this.element.innerHTML="",this.element.className="magic-box-suggestions",_.each(e,function(e){var s=e.dom;if(s){t.$$(s).removeClass(n.options.selectedClass);var i=t.$$(s).find("."+n.options.selectableClass);t.$$(i).removeClass(n.options.selectedClass)}else{if(s=document.createElement("div"),s.className="magic-box-suggestion",null!=e.html)s.innerHTML=e.html;else if(null!=e.text)s.appendChild(document.createTextNode(e.text));else if(null!=e.separator){s.className="magic-box-suggestion-seperator";var o=document.createElement("div");o.className="magic-box-suggestion-seperator-label",o.appendChild(document.createTextNode(e.separator)),s.appendChild(o)}t.$$(s).on("click",function(){e.onSelect()}),t.$$(s).on("keyboardSelect",function(){e.onSelect()}),t.$$(s).addClass(n.options.selectableClass)}s.suggestion=e,n.element.appendChild(s)}),e.length>0?(t.$$(this.element).addClass("magic-box-hasSuggestion"),this.hasSuggestions=!0):(t.$$(this.element).removeClass("magic-box-hasSuggestion"),this.hasSuggestions=!1)},e}();t.SuggestionsManager=e}(e=t.MagicBox||(t.MagicBox={}))}(Coveo||(Coveo={}));var Coveo;!function(t){var e;!function(t){var e;!function(e){function n(t){return t.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g,"\\$&")}function s(t,e,s,o,r){if(void 0===s&&(s=!1),void 0===o&&(o="magic-box-hightlight"),void 0===r&&(r=""),0==e.length)return t;var u=n(e),a="("+u+")|(.*?(?="+u+")|.+)",l=new RegExp(a,s?"gi":"g");return t.replace(l,function(t,e,n){return i(null!=e?o:r,t)})}var i=function(t,e){return'<span class="'+t+'">'+_.escape(e)+"</span>"};e.highlightText=s;var o=function(){function e(t){this.el=t}return e.prototype.text=function(t){return t?void(void 0!=this.el.innerText?this.el.innerText=t:void 0!=this.el.textContent&&(this.el.textContent=t)):this.el.innerText||this.el.textContent},e.prototype.nodeListToArray=function(t){for(var e=t.length,n=new Array(e);e--;)n[e]=t.item(e);return n},e.prototype.empty=function(){for(;this.el.firstChild;)this.el.removeChild(this.el.firstChild)},e.prototype.show=function(){this.el.style.display="visible"},e.prototype.hide=function(){this.el.style.display="none"},e.prototype.toggle=function(t){void 0===t?"visible"==this.el.style.display?this.hide():this.show():t?this.show():this.hide()},e.prototype.find=function(t){return this.el.querySelector(t)},e.prototype.is=function(t){return this.el.tagName.toLowerCase()==t.toLowerCase()||(!("."!=t[0]||!this.hasClass(t.substr(1)))||"#"==t[0]&&this.el.getAttribute("id")==t.substr(1))},e.prototype.closest=function(e){for(var n=this.el,s=!1;!s&&(t.$$(n).hasClass(e)&&(s=!0),"body"!=n.tagName.toLowerCase())&&null!=n.parentElement;)s||(n=n.parentElement);if(s)return n},e.prototype.findAll=function(t){return this.nodeListToArray(this.el.querySelectorAll(t))},e.prototype.findClass=function(t){return"getElementsByClassName"in this.el?this.nodeListToArray(this.el.getElementsByClassName(t)):this.nodeListToArray(this.el.querySelectorAll("."+t))},e.prototype.findId=function(t){return document.getElementById(t)},e.prototype.addClass=function(t){this.hasClass(t)||(this.el.className?this.el.className+=" "+t:this.el.className=t)},e.prototype.removeClass=function(t){this.el.className=this.el.className.replace(new RegExp("(^|\\s)"+t+"(\\s|\\b)","g"),"$1")},e.prototype.toggleClass=function(t,e){e?this.addClass(t):this.removeClass(t)},e.prototype.getClass=function(){return this.el.className.match(e.CLASS_NAME_REGEX)||[]},e.prototype.hasClass=function(t){return _.contains(this.getClass(),t)},e.prototype.detach=function(){this.el.parentElement&&this.el.parentElement.removeChild(this.el)},e.prototype.on=function(t,n){var s=this;if(_.isArray(t))_.each(t,function(t){s.on(t,n)});else{var i=this.getJQuery();if(i)i(this.el).on(t,n);else if(this.el.addEventListener){var o=function(t){n(t,t.detail)};e.handlers.push({eventHandle:n,fn:o}),this.el.addEventListener(t,o,!1)}else this.el.on&&this.el.on("on"+t,n)}},e.prototype.one=function(t,e){var n=this;if(_.isArray(t))_.each(t,function(t){n.one(t,e)});else{var s=function(i){return n.off(t,s),e(i)};this.on(t,s)}},e.prototype.off=function(t,n){var s=this;if(_.isArray(t))_.each(t,function(t){s.off(t,n)});else{var i=this.getJQuery();if(i)i(this.el).off(t,n);else if(this.el.removeEventListener){var o=0,r=_.find(e.handlers,function(t,e){if(t.eventHandle==n)return o=e,!0});r&&(this.el.removeEventListener(t,r.fn,!1),e.handlers.splice(o,1))}else this.el.off&&this.el.off("on"+t,n)}},e.prototype.trigger=function(t,e){var n=this.getJQuery();if(n)n(this.el).trigger(t,e);else if(void 0!==CustomEvent){var s=new CustomEvent(t,{detail:e,bubbles:!0});this.el.dispatchEvent(s)}},e.prototype.isEmpty=function(){return e.ONLY_WHITE_SPACE_REGEX.test(this.el.innerHTML)},e.prototype.isDescendant=function(t){for(var e=this.el.parentNode;null!=e;){if(e==t)return!0;e=e.parentNode}return!1},e.prototype.getJQuery=function(){return void 0!=window.jQuery&&window.jQuery},e.CLASS_NAME_REGEX=/-?[_a-zA-Z]+[_a-zA-Z0-9-]*/g,e.ONLY_WHITE_SPACE_REGEX=/^\s*$/,e.handlers=[],e}();e.Dom=o}(e=t.Utils||(t.Utils={}))}(e=t.MagicBox||(t.MagicBox={}))}(Coveo||(Coveo={}));var Coveo;!function(t){var e;!function(t){t.$$=function(e){return new t.Utils.Dom(e)}}(e=t.MagicBox||(t.MagicBox={}))}(Coveo||(Coveo={}));var Coveo;!function(t){var e;!function(t){var e;!function(e){function n(t,e,n,s){_.each(s.expressions,function(e){_.contains(t,e)||t.push(e)}),_.each(s.basicExpressions,function(t){_.contains(e,t)||e.push(t)}),_.each(s.grammars,function(t,e){if(e in n){if(!_.isArray(n[e])||!_.isArray(t))throw _.each(t,function(t){n[e].push(t)}),"Can not merge "+e+"("+new String(t)+" => "+new String(n[e])+")";_.each(t,function(t){n[e].push(t)})}else n[e]=t})}function s(){for(var t=[],e=0;e<arguments.length;e++)t[e-0]=arguments[e];for(var s=[],i=[],o={Start:["Expressions","Empty"],Expressions:"[OptionalSpaces][Expression][ExpressionsList*][OptionalSpaces]",ExpressionsList:"[Spaces][Expression]",Expression:s,BasicExpression:i,OptionalSpaces:/ */,Spaces:/ +/,Empty:/(?!.)/},r=0;r<t.length;r++)n(s,i,o,t[r]),_.each(t[r].include,function(e){_.contains(t,e)||t.push(e)});return s.push("BasicExpression"),{start:"Start",expressions:o}}function i(){for(var e=[],n=0;n<arguments.length;n++)e[n-0]=arguments[n];var i=s.apply(this,e);return new t.Grammar(i.start,i.expressions)}e.Expressions=s,e.ExpressionsGrammar=i}(e=t.Grammars||(t.Grammars={}))}(e=t.MagicBox||(t.MagicBox={}))}(Coveo||(Coveo={}));var Coveo;!function(t){var e;!function(t){var e;!function(e){e.notWordStart=" ()[],$@'\"",e.notInWord=" ()[],:",e.Basic={basicExpressions:["Word","DoubleQuoted"],grammars:{DoubleQuoted:'"[NotDoubleQuote]"',NotDoubleQuote:/[^"]*/,SingleQuoted:"'[NotSingleQuote]'",NotSingleQuote:/[^']*/,Number:/[0-9]+/,Word:function(n,s,i){var o=new RegExp("[^"+e.notWordStart.replace(/(.)/g,"\\$1")+"][^"+e.notInWord.replace(/(.)/g,"\\$1")+"]*"),r=n.match(o);null!=r&&0!=r.index&&(r=null);var u=new t.Result(null!=r?r[0]:null,i,n);return u.isSuccess()&&s&&n.length>u.value.length?new t.EndOfInputResult(u):u}}}}(e=t.Grammars||(t.Grammars={}))}(e=t.MagicBox||(t.MagicBox={}))}(Coveo||(Coveo={}));var Coveo;!function(t){var e;!function(t){var e;!function(t){t.SubExpression={basicExpressions:["SubExpression"],grammars:{SubExpression:"([Expressions])"}}}(e=t.Grammars||(t.Grammars={}))}(e=t.MagicBox||(t.MagicBox={}))}(Coveo||(Coveo={}));var Coveo;!function(t){var e;!function(t){var e;!function(t){t.Date={grammars:{Date:"[DateYear]/[DateMonth]/[DateDay]",DateYear:/([0-9]{4})/,DateMonth:/(1[0-2]|0?[1-9])/,DateDay:/([1-2][0-9]|3[0-1]|0?[1-9])/,DateRange:"[Date][Spaces?]..[Spaces?][Date]",DateRelative:["DateRelativeNegative","DateRelativeTerm"],DateRelativeTerm:/now|today|yesterday/,DateRelativeNegative:"[DateRelativeTerm][DateRelativeNegativeRef]",DateRelativeNegativeRef:/([\-\+][0-9]+(s|m|h|d|mo|y))/},include:[t.Basic]}}(e=t.Grammars||(t.Grammars={}))}(e=t.MagicBox||(t.MagicBox={}))}(Coveo||(Coveo={}));var Coveo;!function(t){var e;!function(t){var e;!function(t){t.Field={basicExpressions:["FieldSimpleQuery","FieldQuery","Field"],grammars:{FieldQuery:"[Field][OptionalSpaces][FieldQueryOperation]",FieldQueryOperation:["FieldQueryValue","FieldQueryNumeric"],FieldQueryValue:"[FieldOperator][OptionalSpaces][FieldValue]",FieldQueryNumeric:"[FieldOperatorNumeric][OptionalSpaces][FieldValueNumeric]",FieldSimpleQuery:"[FieldName]:[OptionalSpaces][FieldValue]",Field:"@[FieldName]",FieldName:/[a-zA-Z][a-zA-Z0-9\.\_]*/,FieldOperator:/==|=|<>/,FieldOperatorNumeric:/<=|>=|<|>/,FieldValue:["DateRange","NumberRange","DateRelative","Date","Number","FieldValueList","FieldValueString"],FieldValueNumeric:["DateRelative","Date","Number"],FieldValueString:["DoubleQuoted","FieldValueNotQuoted"],FieldValueList:"([FieldValueString][FieldValueStringList*])",FieldValueStringList:"[FieldValueSeparator][FieldValueString]",FieldValueSeparator:/ *, */,FieldValueNotQuoted:/[^ \(\),]+/,NumberRange:"[Number][Spaces?]..[Spaces?][Number]"},include:[t.Date,t.Basic]}}(e=t.Grammars||(t.Grammars={}))}(e=t.MagicBox||(t.MagicBox={}))}(Coveo||(Coveo={}));var Coveo;!function(t){var e;!function(t){var e;!function(t){t.QueryExtension={basicExpressions:["QueryExtension"],grammars:{QueryExtension:"$[QueryExtensionName]([QueryExtensionArguments])",QueryExtensionName:/\w+/,QueryExtensionArguments:"[QueryExtensionArgumentList*][QueryExtensionArgument]",QueryExtensionArgumentList:"[QueryExtensionArgument][Spaces?],[Spaces?]",QueryExtensionArgument:"[QueryExtensionArgumentName]:[Spaces?][QueryExtensionArgumentValue]",QueryExtensionArgumentName:/\w+/,QueryExtensionArgumentValue:["SingleQuoted","Expressions"]},include:[t.Basic]}}(e=t.Grammars||(t.Grammars={}))}(e=t.MagicBox||(t.MagicBox={}))}(Coveo||(Coveo={}));var Coveo;!function(t){var e;!function(t){var e;!function(t){t.NestedQuery={basicExpressions:["NestedQuery"],grammars:{NestedQuery:"[[NestedField][OptionalSpaces][Expressions]]",NestedField:"[[Field]]",FieldValue:["NestedQuery"]},include:[t.Field]}}(e=t.Grammars||(t.Grammars={}))}(e=t.MagicBox||(t.MagicBox={}))}(Coveo||(Coveo={}));var Coveo;!function(t){var e;!function(t){var e;!function(t){t.Complete={include:[t.NestedQuery,t.QueryExtension,t.SubExpression,t.Field,t.Basic]}}(e=t.Grammars||(t.Grammars={}))}(e=t.MagicBox||(t.MagicBox={}))}(Coveo||(Coveo={}));var Coveo;!function(t){var e;!function(t){function e(t,e,n){return new s(t,e,n)}function n(t){return"requestAnimationFrame"in window?window.requestAnimationFrame(t):setTimeout(t)}var s=function(){function e(e,n,s){var i=this;void 0===s&&(s={}),this.element=e,this.grammar=n,this.options=s,this.lastSuggestions=[],_.isUndefined(this.options.inline)&&(this.options.inline=!1),t.$$(e).addClass("magic-box"),this.options.inline&&t.$$(e).addClass("magic-box-inline"),this.result=this.grammar.parse(""),this.displayedResult=this.result.clean(),this.clearDom=document.createElement("div"),this.clearDom.className="magic-box-clear",this.element.appendChild(this.clearDom);var o=document.createElement("div");o.className="magic-box-icon",this.clearDom.appendChild(o);var r=document.createElement("div");r.className="magic-box-input",e.appendChild(r),this.inputManager=new t.InputManager(r,function(t,e){e?(i.setText(t),i.onselect&&i.onselect(i.getFirstSuggestionText())):(i.setText(t),i.showSuggestion(),i.onchange&&i.onchange())},this),this.inputManager.ontabpress=function(){i.ontabpress&&i.ontabpress()},this.inputManager.setResult(this.displayedResult);var u=document.createElement("div");u.className="magic-box-suggestions",this.element.appendChild(u),this.suggestionsManager=new t.SuggestionsManager(u,{selectableClass:this.options.selectableSuggestionClass,selectedClass:this.options.selectedSuggestionClass,timeout:this.options.suggestionTimeout}),this.setupHandler()}return e.prototype.getResult=function(){return this.result},e.prototype.getDisplayedResult=function(){return this.displayedResult},e.prototype.setText=function(e){t.$$(this.element).toggleClass("magic-box-notEmpty",e.length>0),this.result=this.grammar.parse(e),this.displayedResult=this.result.clean(),this.inputManager.setResult(this.displayedResult)},e.prototype.setCursor=function(t){this.inputManager.setCursor(t)},e.prototype.getCursor=function(){return this.inputManager.getCursor()},e.prototype.resultAtCursor=function(t){return this.displayedResult.resultAt(this.getCursor(),t)},e.prototype.setupHandler=function(){var e=this;this.inputManager.onblur=function(){t.$$(e.element).removeClass("magic-box-hasFocus"),e.onblur&&e.onblur(),e.options.inline||e.clearSuggestion()},this.inputManager.onfocus=function(){t.$$(e.element).addClass("magic-box-hasFocus"),e.showSuggestion(),e.onfocus&&e.onfocus();
	},this.inputManager.onkeydown=function(t){if(38==t||40==t)return!1;if(13==t){var n=e.suggestionsManager.select();return null==n&&e.onsubmit&&e.onsubmit(),!1}return 27==t&&e.clearSuggestion(),!0},this.inputManager.onchangecursor=function(){e.showSuggestion()},this.inputManager.onkeyup=function(t){if(38==t)e.onmove&&e.onmove(),e.focusOnSuggestion(e.suggestionsManager.moveUp()),e.onchange&&e.onchange();else{if(40!=t)return!0;e.onmove&&e.onmove(),e.focusOnSuggestion(e.suggestionsManager.moveDown()),e.onchange&&e.onchange()}return!1},this.clearDom.onclick=function(){e.clear()}},e.prototype.showSuggestion=function(){var t=this;this.suggestionsManager.mergeSuggestions(null!=this.getSuggestions?this.getSuggestions():[],function(e){t.updateSuggestion(e)})},e.prototype.updateSuggestion=function(t){var e=this;this.lastSuggestions=t;var n=this.getFirstSuggestionText();this.inputManager.setWordCompletion(n&&n.text),this.onsuggestions&&this.onsuggestions(t),_.each(t,function(t){null==t.onSelect&&null!=t.text&&(t.onSelect=function(){e.setText(t.text),e.onselect&&e.onselect(t)})})},e.prototype.focus=function(){t.$$(this.element).addClass("magic-box-hasFocus"),this.inputManager.focus()},e.prototype.blur=function(){this.inputManager.blur()},e.prototype.clearSuggestion=function(){var t=this;this.suggestionsManager.mergeSuggestions([],function(e){t.updateSuggestion(e)}),this.inputManager.setWordCompletion(null)},e.prototype.focusOnSuggestion=function(t){null==t||null==t.text?(t=this.getFirstSuggestionText(),this.inputManager.setResult(this.displayedResult,t&&t.text)):this.inputManager.setResult(this.grammar.parse(t.text).clean(),t.text)},e.prototype.getFirstSuggestionText=function(){return _.find(this.lastSuggestions,function(t){return null!=t.text})},e.prototype.getText=function(){return this.inputManager.getValue()},e.prototype.getWordCompletion=function(){return this.inputManager.getWordCompletion()},e.prototype.clear=function(){this.setText(""),this.showSuggestion(),this.focus(),this.onclear&&this.onclear()},e.prototype.hasSuggestions=function(){return this.suggestionsManager.hasSuggestions},e}();t.Instance=s,t.create=e,t.requestAnimationFrame=n}(e=t.MagicBox||(t.MagicBox={}))}(Coveo||(Coveo={}));
	
	/*** EXPORTS FROM exports-loader ***/
	module.exports = Coveo.MagicBox;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 28 */
/***/ function(module, exports) {

	!function(){"use strict";var t,e,n="undefined",r="string",i=self.navigator,o=String,a=Object.prototype.hasOwnProperty,l={},u={},s=!1,f=!0,c=/^\s*application\/(?:vnd\.oftn\.|x-)?l10n\+json\s*(?:$|;)/i,p="locale",g="defaultLocale",h="toLocaleString",y="toLowerCase",v=Array.prototype.indexOf||function(t){for(var e=this.length,n=0;e>n;n++)if(n in this&&this[n]===t)return n;return-1},d=function(e){var n=new t;return n.open("GET",e,s),n.send(null),200!==n.status?(setTimeout(function(){var t=new Error("Unable to load localization data: "+e);throw t.name="Localization Error",t},0),{}):JSON.parse(n.responseText)},m=o[h]=function(t){if(arguments.length>0&&"number"!=typeof t)if(typeof t===r)m(d(t));else if(t===s)u={};else{var e,n,i;for(e in t)if(a.call(t,e)){if(n=t[e],e=e[y](),e in u&&n!==s||(u[e]={}),n===s)continue;if(typeof n===r){if(0!==o[p][y]().indexOf(e)){e in l||(l[e]=[]),l[e].push(n);continue}n=d(n)}for(i in n)a.call(n,i)&&(u[e][i]=n[i])}}return Function.prototype[h].apply(o,arguments)},w=function(t){for(var e,n=l[t],r=0,i=n.length;i>r;r++)e={},e[t]=d(n[r]),m(e);delete l[t]},b=o.prototype[h]=function(){var t,n=e,r=o[n?g:p],i=r[y]().split("-"),a=i.length,c=this.valueOf();e=s;do if(t=i.slice(0,a).join("-"),t in l&&w(t),t in u&&c in u[t])return u[t][c];while(a-->1);return!n&&o[g]?(e=f,b.call(c)):c};if(typeof XMLHttpRequest===n&&typeof ActiveXObject!==n){var L=ActiveXObject;t=function(){try{return new L("Msxml2.XMLHTTP.6.0")}catch(t){}try{return new L("Msxml2.XMLHTTP.3.0")}catch(e){}try{return new L("Msxml2.XMLHTTP")}catch(n){}throw new Error("XMLHttpRequest not supported by this browser.")}}else t=XMLHttpRequest;if(o[g]=o[g]||"",o[p]=i&&(i.language||i.userLanguage)||"",typeof document!==n)for(var T,M=document.getElementsByTagName("link"),O=M.length;O--;){var X=M[O],x=(X.getAttribute("rel")||"")[y]().split(/\s+/);c.test(X.type)&&(-1!==v.call(x,"localizations")?m(X.getAttribute("href")):-1!==v.call(x,"localization")&&(T={},T[(X.getAttribute("hreflang")||"")[y]()]=X.getAttribute("href"),m(T)))}}();
	
	/*** EXPORTS FROM exports-loader ***/
	module.exports = window.String.toLocaleString;

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var Assert_1 = __webpack_require__(17);
	exports.Assert = Assert_1.Assert;
	var Cache_1 = __webpack_require__(30);
	exports.Cache = Cache_1.Cache;
	var Defer_1 = __webpack_require__(31);
	exports.Defer = Defer_1.Defer;
	var L10N_1 = __webpack_require__(32);
	exports.L10N = L10N_1.L10N;
	var Logger_1 = __webpack_require__(16);
	exports.Logger = Logger_1.Logger;
	var Options_1 = __webpack_require__(33);
	exports.Options = Options_1.Options;
	var Strings_1 = __webpack_require__(34);
	exports.l = Strings_1.l;


/***/ },
/* 30 */
/***/ function(module, exports) {

	"use strict";
	var Cache = (function () {
	    function Cache(onEmpty) {
	        this.onEmpty = onEmpty;
	        this.cache = [];
	    }
	    Cache.prototype.get = function () {
	        if (this.cache.length == 0) {
	            return this.onEmpty();
	        }
	        else {
	            return this.cache.pop();
	        }
	    };
	    Cache.prototype.push = function (value) {
	        this.cache.push(value);
	    };
	    return Cache;
	}());
	exports.Cache = Cache;


/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var Defer = (function () {
	    function Defer() {
	    }
	    Defer.defer = function (code) {
	        Defer.functions.push(code);
	        Defer.arm();
	    };
	    Defer.flush = function () {
	        while (Defer.popOne()) {
	        }
	    };
	    Defer.arm = function () {
	        _.defer(function () {
	            if (Defer.popOne()) {
	                Defer.arm();
	            }
	        });
	    };
	    Defer.popOne = function () {
	        if (Defer.functions.length > 0) {
	            var fun = Defer.functions[0];
	            Defer.functions = _.rest(Defer.functions);
	            fun();
	            return Defer.functions.length > 0;
	        }
	        else {
	            return false;
	        }
	    };
	    Defer.functions = [];
	    return Defer;
	}());
	exports.Defer = Defer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var ExternalModulesShim_1 = __webpack_require__(25);
	String.toLocaleString = ExternalModulesShim_1.LocaleString;
	var pluralRegex = /<pl>(((?!<\/pl>).)*)<\/pl>/g;
	var singularRegex = /<sn>(((?!<\/sn>).)*)<\/sn>/g;
	exports.L10N = {
	    format: function (key) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        var value = key.toLocaleString();
	        if (args.length > 0) {
	            var last = _.last(args);
	            // Last argument is either the count or a boolean forcing plural (true) or singular (false)
	            if (_.isBoolean(last) || _.isNumber(last)) {
	                args.pop();
	                value = exports.L10N.formatPlSn(value, last);
	            }
	            _.each(args, function (arg, i) { return value = value.replace("{" + i + "}", arg); });
	        }
	        return value;
	    },
	    formatPlSn: function (value, count) {
	        var isPlural = _.isBoolean(count) ? count : count > 1;
	        if (isPlural) {
	            value = value.replace(pluralRegex, '$1').replace(singularRegex, '');
	        }
	        else {
	            value = value.replace(pluralRegex, '').replace(singularRegex, '$1');
	        }
	        return value;
	    }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var Utils_1 = __webpack_require__(18);
	var Options = (function () {
	    function Options() {
	    }
	    Options.prototype.merge = function (provided) {
	        return _.extend({}, this, provided);
	    };
	    Options.prototype.mergeDeep = function (provided) {
	        return _.extend({}, Utils_1.Utils.extendDeep(this, provided));
	    };
	    return Options;
	}());
	exports.Options = Options;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var L10N_1 = __webpack_require__(32);
	function l() {
	    var params = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        params[_i - 0] = arguments[_i];
	    }
	    return L10N_1.L10N.format.apply(this, arguments);
	}
	exports.l = l;
	;


/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var AnalyticsEndpoint_1 = __webpack_require__(36);
	exports.AnalyticsEndpoint = AnalyticsEndpoint_1.AnalyticsEndpoint;
	var EndpointCaller_1 = __webpack_require__(15);
	exports.EndpointCaller = EndpointCaller_1.EndpointCaller;
	var QueryError_1 = __webpack_require__(24);
	exports.QueryError = QueryError_1.QueryError;


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var Logger_1 = __webpack_require__(16);
	var EndpointCaller_1 = __webpack_require__(15);
	var Assert_1 = __webpack_require__(17);
	var QueryUtils_1 = __webpack_require__(23);
	var CookieUtils_1 = __webpack_require__(37);
	var es6_promise_1 = __webpack_require__(7);
	var AnalyticsEndpoint = (function () {
	    function AnalyticsEndpoint(options) {
	        this.options = options;
	        this.logger = new Logger_1.Logger(this);
	        var endpointCallerOptions = {
	            accessToken: (this.options.token && this.options.token != '') ? this.options.token : null
	        };
	        this.endpointCaller = new EndpointCaller_1.EndpointCaller(endpointCallerOptions);
	        this.organization = options.organization;
	    }
	    AnalyticsEndpoint.prototype.getCurrentVisitId = function () {
	        return this.visitId;
	    };
	    AnalyticsEndpoint.prototype.getCurrentVisitIdPromise = function () {
	        var _this = this;
	        return new es6_promise_1.Promise(function (resolve, reject) {
	            if (_this.getCurrentVisitId()) {
	                resolve(_this.getCurrentVisitId());
	            }
	            else {
	                var url = _this.buildAnalyticsUrl('/analytics/visit');
	                _this.getFromService(url, {})
	                    .then(function (response) {
	                    _this.visitId = response.id;
	                    resolve(_this.visitId);
	                })
	                    .catch(function (response) {
	                    reject(response);
	                });
	            }
	        });
	    };
	    AnalyticsEndpoint.prototype.sendSearchEvents = function (searchEvents) {
	        if (searchEvents.length > 0) {
	            this.logger.info('Logging analytics search events', searchEvents);
	            return this.sendToService(searchEvents, 'searches', 'searchEvents');
	        }
	    };
	    AnalyticsEndpoint.prototype.sendDocumentViewEvent = function (documentViewEvent) {
	        Assert_1.Assert.exists(documentViewEvent);
	        this.logger.info('Logging analytics document view', documentViewEvent);
	        return this.sendToService(documentViewEvent, 'click', 'clickEvent');
	    };
	    AnalyticsEndpoint.prototype.sendCustomEvent = function (customEvent) {
	        Assert_1.Assert.exists(customEvent);
	        this.logger.info('Logging analytics custom event', customEvent);
	        return this.sendToService(customEvent, 'custom', 'customEvent');
	    };
	    AnalyticsEndpoint.prototype.getTopQueries = function (params) {
	        var url = this.buildAnalyticsUrl('/stats/topQueries');
	        return this.getFromService(url, params);
	    };
	    AnalyticsEndpoint.prototype.sendToService = function (data, path, paramName) {
	        var _this = this;
	        var url = QueryUtils_1.QueryUtils.mergePath(this.options.serviceUrl, '/rest/' + (AnalyticsEndpoint.CUSTOM_ANALYTICS_VERSION || AnalyticsEndpoint.DEFAULT_ANALYTICS_VERSION) + '/analytics/' + path);
	        var queryString = [];
	        if (this.organization) {
	            queryString.push('org=' + this.organization);
	        }
	        if (CookieUtils_1.Cookie.get('visitorId')) {
	            queryString.push('visitor=' + encodeURIComponent(CookieUtils_1.Cookie.get('visitorId')));
	        }
	        // We use pendingRequest because we don't want to have 2 request to analytics at the same time.
	        // Otherwise the cookie visitId won't be set correctly.
	        if (AnalyticsEndpoint.pendingRequest == null) {
	            AnalyticsEndpoint.pendingRequest = this.endpointCaller.call({
	                errorsAsSuccess: false,
	                method: 'POST',
	                queryString: queryString,
	                requestData: data,
	                url: url,
	                responseType: 'text',
	                requestDataType: 'application/json'
	            }).then(function (res) {
	                return _this.handleAnalyticsEventResponse(res.data);
	            }).finally(function () {
	                AnalyticsEndpoint.pendingRequest = null;
	            });
	            return AnalyticsEndpoint.pendingRequest;
	        }
	        else {
	            return AnalyticsEndpoint.pendingRequest.finally(function () {
	                return _this.sendToService(data, path, paramName);
	            });
	        }
	    };
	    AnalyticsEndpoint.prototype.getFromService = function (url, params) {
	        var paramsToSend = (this.options.token && this.options.token != '') ? _.extend({ 'access_token': this.options.token }, params) : params;
	        return this.endpointCaller.call({
	            errorsAsSuccess: false,
	            method: 'GET',
	            queryString: this.options.organization ? ['org=' + encodeURIComponent(this.options.organization)] : [],
	            requestData: paramsToSend,
	            responseType: 'json',
	            url: url
	        }).then(function (res) {
	            return res.data;
	        });
	    };
	    AnalyticsEndpoint.prototype.handleAnalyticsEventResponse = function (response) {
	        var visitId;
	        var visitorId;
	        if (response['visitId']) {
	            visitId = response['visitId'];
	            visitorId = response['visitorId'];
	        }
	        else if (response['searchEventResponses']) {
	            visitId = _.first(response['searchEventResponses']).visitId;
	            visitorId = _.first(response['searchEventResponses']).visitorId;
	        }
	        if (visitId) {
	            this.visitId = visitId;
	        }
	        if (visitorId) {
	            CookieUtils_1.Cookie.set('visitorId', visitorId, AnalyticsEndpoint.VISITOR_COOKIE_TIME);
	        }
	        return response;
	    };
	    AnalyticsEndpoint.prototype.buildAnalyticsUrl = function (path) {
	        return this.options.serviceUrl + '/rest/' + (AnalyticsEndpoint.CUSTOM_ANALYTICS_VERSION || AnalyticsEndpoint.DEFAULT_ANALYTICS_VERSION) + path;
	    };
	    AnalyticsEndpoint.DEFAULT_ANALYTICS_URI = 'https://usageanalytics.coveo.com';
	    AnalyticsEndpoint.DEFAULT_ANALYTICS_VERSION = 'v15';
	    AnalyticsEndpoint.CUSTOM_ANALYTICS_VERSION = undefined;
	    AnalyticsEndpoint.VISITOR_COOKIE_TIME = 10000 * 24 * 60 * 60 * 1000;
	    return AnalyticsEndpoint;
	}());
	exports.AnalyticsEndpoint = AnalyticsEndpoint;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 37 */
/***/ function(module, exports) {

	"use strict";
	// Code originally taken from : https://developers.livechatinc.com/blog/setting-cookies-to-subdomains-in-javascript/
	var Cookie = (function () {
	    function Cookie() {
	    }
	    Cookie.set = function (name, value, expiration) {
	        var domain, domainParts, date, expires, host;
	        if (expiration) {
	            date = new Date();
	            date.setTime(date.getTime() + expiration);
	            expires = '; expires=' + date.toGMTString();
	        }
	        else {
	            expires = '';
	        }
	        host = location.hostname;
	        if (host.split('.').length === 1) {
	            // no '.' in a domain - it's localhost or something similar
	            document.cookie = this.prefix + name + '=' + value + expires + '; path=/';
	        }
	        else {
	            // Remember the cookie on all subdomains.
	            //
	            // Start with trying to set cookie to the top domain.
	            // (example: if user is on foo.com, try to set
	            //  cookie to domain '.com')
	            //
	            // If the cookie will not be set, it means '.com'
	            // is a top level domain and we need to
	            // set the cookie to '.foo.com'
	            domainParts = host.split('.');
	            domainParts.shift();
	            domain = '.' + domainParts.join('.');
	            document.cookie = this.prefix + name + '=' + value + expires + '; path=/; domain=' + domain;
	            // check if cookie was successfuly set to the given domain
	            // (otherwise it was a Top-Level Domain)
	            if (Cookie.get(name) == null || Cookie.get(name) != value) {
	                // append '.' to current domain
	                domain = '.' + host;
	                document.cookie = this.prefix + name + '=' + value + expires + '; path=/; domain=' + domain;
	            }
	        }
	    };
	    Cookie.get = function (name) {
	        var nameEQ = this.prefix + name + '=';
	        var ca = document.cookie.split(';');
	        for (var i = 0; i < ca.length; i++) {
	            var c = ca[i];
	            while (c.charAt(0) == ' ') {
	                c = c.substring(1, c.length);
	            }
	            if (c.indexOf(nameEQ) == 0) {
	                return c.substring(nameEQ.length, c.length);
	            }
	        }
	        return null;
	    };
	    Cookie.erase = function (name) {
	        Cookie.set(name, '', -1);
	    };
	    Cookie.prefix = 'coveo_';
	    return Cookie;
	}());
	exports.Cookie = Cookie;


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var AdvancedSearchEvents_1 = __webpack_require__(39);
	exports.AdvancedSearchEvents = AdvancedSearchEvents_1.AdvancedSearchEvents;
	var AnalyticsEvents_1 = __webpack_require__(40);
	exports.AnalyticsEvents = AnalyticsEvents_1.AnalyticsEvents;
	var BreadcrumbEvents_1 = __webpack_require__(41);
	exports.BreadcrumbEvents = BreadcrumbEvents_1.BreadcrumbEvents;
	var DebugEvents_1 = __webpack_require__(42);
	exports.DebugEvents = DebugEvents_1.DebugEvents;
	var ImageResultListEvents_1 = __webpack_require__(43);
	exports.ImageResultListEvents = ImageResultListEvents_1.ImageResultListEvents;
	var InitializationEvents_1 = __webpack_require__(44);
	exports.InitializationEvents = InitializationEvents_1.InitializationEvents;
	var OmniboxEvents_1 = __webpack_require__(45);
	exports.OmniboxEvents = OmniboxEvents_1.OmniboxEvents;
	var PreferencesPanelEvents_1 = __webpack_require__(46);
	exports.PreferencesPanelEvents = PreferencesPanelEvents_1.PreferencesPanelEvents;
	var QueryEvents_1 = __webpack_require__(47);
	exports.QueryEvents = QueryEvents_1.QueryEvents;
	var ResultListEvents_1 = __webpack_require__(48);
	exports.ResultListEvents = ResultListEvents_1.ResultListEvents;
	var SearchAlertEvents_1 = __webpack_require__(49);
	exports.SearchAlertsEvents = SearchAlertEvents_1.SearchAlertsEvents;
	var SettingsEvents_1 = __webpack_require__(50);
	exports.SettingsEvents = SettingsEvents_1.SettingsEvents;
	var SliderEvents_1 = __webpack_require__(51);
	exports.SliderEvents = SliderEvents_1.SliderEvents;
	var StandaloneSearchInterfaceEvents_1 = __webpack_require__(52);
	exports.StandaloneSearchInterfaceEvents = StandaloneSearchInterfaceEvents_1.StandaloneSearchInterfaceEvents;


/***/ },
/* 39 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * This static class is there to contains the different string definition for all the events related to the {@link AdvancedSearch} component.
	 */
	var AdvancedSearchEvents = (function () {
	    function AdvancedSearchEvents() {
	    }
	    /**
	     * Triggered when the advanced search component is being built.
	     *
	     * Allows external code to add new sections in the advanced search panel.
	     *
	     * All handlers bound will receive {@link IBuildingAdvancedSearchEventArgs} as an argument
	     * @type {string}
	     */
	    AdvancedSearchEvents.buildingAdvancedSearch = 'buildingAdvancedSearch';
	    AdvancedSearchEvents.executeAdvancedSearch = 'executeAdvancedSearch';
	    return AdvancedSearchEvents;
	}());
	exports.AdvancedSearchEvents = AdvancedSearchEvents;


/***/ },
/* 40 */
/***/ function(module, exports) {

	"use strict";
	var AnalyticsEvents = (function () {
	    function AnalyticsEvents() {
	    }
	    AnalyticsEvents.searchEvent = 'analyticsSearchEvent';
	    AnalyticsEvents.documentViewEvent = 'analyticsDocumentViewEvent';
	    AnalyticsEvents.customEvent = 'analyticsCustomEvent';
	    AnalyticsEvents.changeAnalyticsCustomData = 'changeAnalyticsCustomData';
	    return AnalyticsEvents;
	}());
	exports.AnalyticsEvents = AnalyticsEvents;


/***/ },
/* 41 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * This static class is there to contains the different string definition for all the events related to {@link Breadcrumb}.
	 */
	var BreadcrumbEvents = (function () {
	    function BreadcrumbEvents() {
	    }
	    /**
	     * Triggered when the breadcrumb needs to update its content. External code can use this event to provide bits of HTML that should be included in the breadcrumb.
	     *
	     * All handlers bound to this event will receive a {@link IPopulateBreadcrumbEventArgs} as an argument.
	     */
	    BreadcrumbEvents.populateBreadcrumb = 'populateBreadcrumb';
	    /**
	     * Triggered when the user clicks the Clear All button in the breadcrumb. When this event is raised, every filter that is included in the breadcrumb should be removed.
	     *
	     * This event does not provide custom event data.
	     */
	    BreadcrumbEvents.clearBreadcrumb = 'clearBreadcrumb';
	    BreadcrumbEvents.redrawBreadcrumb = 'redrawBreadcrumb';
	    return BreadcrumbEvents;
	}());
	exports.BreadcrumbEvents = BreadcrumbEvents;


/***/ },
/* 42 */
/***/ function(module, exports) {

	"use strict";
	var DebugEvents = (function () {
	    function DebugEvents() {
	    }
	    DebugEvents.showDebugPanel = 'showDebugPanel';
	    return DebugEvents;
	}());
	exports.DebugEvents = DebugEvents;


/***/ },
/* 43 */
/***/ function(module, exports) {

	"use strict";
	var ImageResultListEvents = (function () {
	    function ImageResultListEvents() {
	    }
	    ImageResultListEvents.imageResultsLayoutComplete = 'imageResultsLayoutComplete';
	    return ImageResultListEvents;
	}());
	exports.ImageResultListEvents = ImageResultListEvents;


/***/ },
/* 44 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * This static class is there to contain the different string definitions for all the events related to initialization.
	 *
	 * Note that these events will only be triggered when the {@link init} function is called.
	 *
	 * This means these events are normally called only once when the search interface is initialized.
	 */
	var InitializationEvents = (function () {
	    function InitializationEvents() {
	    }
	    /**
	     * This event is triggered right before each components inside the search interface get initialized (eg: Before the constructor of each component is executed).
	     *
	     * The string value is `beforeInitialization`.
	     * @type {string}
	     */
	    InitializationEvents.beforeInitialization = 'beforeInitialization';
	    /**
	     * Triggered after the components are initialized (eg: After the constructor of each component is executed)
	     * but before their state is set from the hash portion of the URL (e.g., http://mysearchinterface#q=myQuery ).
	     *
	     * This is also before the first query is launched (if the {@link SearchInterface.options.autoTriggerQuery} is `true`).
	     *
	     * The string value is `afterComponentsInitialization`.
	     * @type {string}
	     */
	    InitializationEvents.afterComponentsInitialization = 'afterComponentsInitialization';
	    /**
	     * Triggered right before the state from the URL (e.g., http://mysearchinterface#q=myQuery ) gets applied in the interface.
	     *
	     * This will typically only be useful if the {@link SearchInterface.options.enableHistory} is set to `true`.
	     *
	     * The string value is `restoreHistoryState`.
	     * @type {string}
	     */
	    InitializationEvents.restoreHistoryState = 'restoreHistoryState';
	    /**
	     * Triggered right after the UI is fully initialized.
	     *
	     * Concretely this means that the constructor of each component has been executed, and that the state coming for the URL (e.g., http://mysearchinterface#q=myquery) has been applied.
	     *
	     * It is triggered *before* the first query is launched, and if the {@link SearchInterface.options.autoTriggerQuery} is `true`.
	     *
	     * The string value is `afterInitialization`.
	     * @type {string}
	     */
	    InitializationEvents.afterInitialization = 'afterInitialization';
	    /**
	     * This is triggered when the UI needs to be dynamically removed so that components can unbind any internal handlers they might have set globally on the window or the document.
	     *
	     * After this event has been executed, the search interface can be dynamically removed and all handlers can be considered cleanly removed.
	     *
	     * The string value is `nuke`.
	     * @type {string}
	     */
	    InitializationEvents.nuke = 'nuke';
	    return InitializationEvents;
	}());
	exports.InitializationEvents = InitializationEvents;


/***/ },
/* 45 */
/***/ function(module, exports) {

	"use strict";
	var OmniboxEvents = (function () {
	    function OmniboxEvents() {
	    }
	    OmniboxEvents.populateOmnibox = 'populateOmnibox';
	    OmniboxEvents.openOmnibox = 'openOmnibox';
	    OmniboxEvents.closeOmnibox = 'closeOmnibox';
	    OmniboxEvents.populateOmniboxSuggestions = 'populateOmniboxSuggestions';
	    OmniboxEvents.omniboxPreprocessResultForQuery = 'omniboxPreprocessResultForQuery';
	    return OmniboxEvents;
	}());
	exports.OmniboxEvents = OmniboxEvents;


/***/ },
/* 46 */
/***/ function(module, exports) {

	"use strict";
	var PreferencesPanelEvents = (function () {
	    function PreferencesPanelEvents() {
	    }
	    PreferencesPanelEvents.savePreferences = 'savePreferences';
	    PreferencesPanelEvents.exitPreferencesWithoutSave = 'exitPreferencesWithoutSave';
	    return PreferencesPanelEvents;
	}());
	exports.PreferencesPanelEvents = PreferencesPanelEvents;


/***/ },
/* 47 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * This static class is there to contains the different string definition for all the events related to query.
	 *
	 * Note that these events will only be triggered when the {@link QueryController.executeQuery} method is used, either directly or by using {@link executeQuery}
	 */
	var QueryEvents = (function () {
	    function QueryEvents() {
	    }
	    /**
	     * Triggered when a new query is launched.
	     *
	     * All bound handlers will receive {@link INewQueryEventArgs} as an argument.
	     *
	     * The string value is `newQuery`.
	     * @type {string}
	     */
	    QueryEvents.newQuery = 'newQuery';
	    /**
	     * Triggered when the query is being built.
	     *
	     * This is typically where all components will contribute their part to the {@link IQuery} using the {@link QueryBuilder}.
	     *
	     * All bound handlers will receive {@link IBuildingQueryEventArgs} as an argument.
	     *
	     * The string value is `buildingQuery`.
	     * @type {string}
	     */
	    QueryEvents.buildingQuery = 'buildingQuery';
	    /**
	     * Triggered when the query is done being built.
	     *
	     * This is typically where the facet will add it's {@link IGroupByRequest} to the {@link IQuery}.
	     *
	     * All bound handlers will receive {@link IDoneBuildingQueryEventArgs} as an argument.
	     *
	     * The string value is `doneBuildingQuery`.
	     * @type {string}
	     */
	    QueryEvents.doneBuildingQuery = 'doneBuildingQuery';
	    /**
	     * Triggered when the query is being executed on the Search API.
	     *
	     * All bound handlers will receive {@link IDuringQueryEventArgs} as an argument.
	     *
	     * The string value is `duringQuery`.
	     * @type {string}
	     */
	    QueryEvents.duringQuery = 'duringQuery';
	    /**
	     * Triggered when more results are being fetched on the Search API (think : infinite scrolling, or pager).
	     *
	     * All bound handlers will receive {@link IDuringQueryEventArgs} as an argument.
	     *
	     * The string value is `duringFetchMoreQuery`.
	     * @type {string}
	     */
	    QueryEvents.duringFetchMoreQuery = 'duringFetchMoreQuery';
	    /**
	     * Triggered when a query successfully returns from the Search API.
	     *
	     * All bound handlers will receive {@link IQuerySuccessEventArgs} as an argument.
	     *
	     * The string value is `querySuccess`.
	     * @type {string}
	     */
	    QueryEvents.querySuccess = 'querySuccess';
	    /**
	     * Triggered when a more results were successfully returned from the Search API. (think : infinite scrolling, or pager).
	     *
	     * All bound handlers will receive {@link IFetchMoreSuccessEventArgs} as an argument.
	     *
	     * The string value is `fetchMoreSuccess`.
	     * @type {string}
	     */
	    QueryEvents.fetchMoreSuccess = 'fetchMoreSuccess';
	    /**
	     * Triggered after the main query success event has finished executing.
	     *
	     * This is typically where facets will process the {@link IGroupByResult} and render themselves.
	     *
	     * All bound handlers will receive {@link IQuerySuccessEventArgs} as an argument.
	     *
	     * The string value is `deferredQuerySuccess`.
	     * @type {string}
	     */
	    QueryEvents.deferredQuerySuccess = 'deferredQuerySuccess';
	    /**
	     * Triggered when there was an error executing a query on the Search API.
	     *
	     * All bound handlers will receive {@link IQueryErrorEventArgs} as an argument.
	     *
	     * The string value is `queryError`.
	     * @type {string}
	     */
	    QueryEvents.queryError = 'queryError';
	    /**
	     * Triggered before the {@link QueryEvents.querySuccess} event.
	     *
	     * This allows external code to modify the results before rendering them.
	     *
	     * For example, the {@link Folding} component might use this event to construct a coherent parent child relationship between query results.
	     *
	     * All bound handlers will receive {@link IPreprocessResultsEventArgs} as an argument.
	     *
	     * The string value is `preprocessResults`.
	     * @type {string}
	     */
	    QueryEvents.preprocessResults = 'preprocessResults';
	    /**
	     * Triggered before the {@link QueryEvents.fetchMoreSuccess} event.
	     *
	     * This allows external code to modify the results before rendering them.
	     *
	     * For example, the {@link Folding} component might use this event to construct a coherent parent child relationship between query results.
	     *
	     * All bound handlers will receive {@link IPreprocessResultsEventArgs} as an argument.
	     *
	     * The string value is `preprocessMoreResults`.
	     * @type {string}
	     */
	    QueryEvents.preprocessMoreResults = 'preprocessMoreResults';
	    /**
	     * Triggered when there is no result for a particular query.
	     *
	     * All bound handlers will receive {@link INoResultsEventArgs} as an argument.
	     *
	     * The string value is `noResults`.
	     * @type {string}
	     */
	    QueryEvents.noResults = 'noResults';
	    QueryEvents.buildingCallOptions = 'buildingCallOptions';
	    return QueryEvents;
	}());
	exports.QueryEvents = QueryEvents;


/***/ },
/* 48 */
/***/ function(module, exports) {

	"use strict";
	var ResultListEvents = (function () {
	    function ResultListEvents() {
	    }
	    ResultListEvents.newResultsDisplayed = 'newResultsDisplayed';
	    ResultListEvents.newResultDisplayed = 'newResultDisplayed';
	    ResultListEvents.openQuickview = 'openQuickview';
	    return ResultListEvents;
	}());
	exports.ResultListEvents = ResultListEvents;


/***/ },
/* 49 */
/***/ function(module, exports) {

	"use strict";
	var SearchAlertsEvents = (function () {
	    function SearchAlertsEvents() {
	    }
	    SearchAlertsEvents.searchAlertsCreated = 'searchAlertsCreated';
	    SearchAlertsEvents.searchAlertsDeleted = 'searchAlertsDeleted';
	    SearchAlertsEvents.searchAlertsFail = 'searchAlertsFail';
	    SearchAlertsEvents.searchAlertsPopulateMessage = 'searchAlertsPopulateMessage';
	    return SearchAlertsEvents;
	}());
	exports.SearchAlertsEvents = SearchAlertsEvents;


/***/ },
/* 50 */
/***/ function(module, exports) {

	"use strict";
	var SettingsEvents = (function () {
	    function SettingsEvents() {
	    }
	    SettingsEvents.settingsPopulateMenu = 'settingsPopulateMenu';
	    return SettingsEvents;
	}());
	exports.SettingsEvents = SettingsEvents;


/***/ },
/* 51 */
/***/ function(module, exports) {

	"use strict";
	var SliderEvents = (function () {
	    function SliderEvents() {
	    }
	    SliderEvents.startSlide = 'startSlide';
	    SliderEvents.duringSlide = 'duringSlide';
	    SliderEvents.endSlide = 'endSlide';
	    SliderEvents.graphValueSelected = 'graphValueSelected';
	    return SliderEvents;
	}());
	exports.SliderEvents = SliderEvents;


/***/ },
/* 52 */
/***/ function(module, exports) {

	"use strict";
	var StandaloneSearchInterfaceEvents = (function () {
	    function StandaloneSearchInterfaceEvents() {
	    }
	    StandaloneSearchInterfaceEvents.beforeRedirect = 'beforeRedirect';
	    return StandaloneSearchInterfaceEvents;
	}());
	exports.StandaloneSearchInterfaceEvents = StandaloneSearchInterfaceEvents;


/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ColorUtils_1 = __webpack_require__(54);
	exports.ColorUtils = ColorUtils_1.ColorUtils;
	var CookieUtils_1 = __webpack_require__(37);
	exports.Cookie = CookieUtils_1.Cookie;
	var CurrencyUtils_1 = __webpack_require__(55);
	exports.CurrencyUtils = CurrencyUtils_1.CurrencyUtils;
	var DateUtils_1 = __webpack_require__(56);
	exports.DateUtils = DateUtils_1.DateUtils;
	var DeviceUtils_1 = __webpack_require__(20);
	exports.DeviceUtils = DeviceUtils_1.DeviceUtils;
	var Dom_1 = __webpack_require__(57);
	exports.Dom = Dom_1.Dom;
	exports.$$ = Dom_1.$$;
	var DomUtils_1 = __webpack_require__(59);
	exports.DomUtils = DomUtils_1.DomUtils;
	var EmailActionsUtils_1 = __webpack_require__(62);
	exports.EmailActionsUtils = EmailActionsUtils_1.EmailActionsUtils;
	var EmailUtils_1 = __webpack_require__(63);
	exports.EmailUtils = EmailUtils_1.EmailUtils;
	var FeatureDetectionUtils_1 = __webpack_require__(64);
	exports.FeatureDetectionUtils = FeatureDetectionUtils_1.FeatureDetectionUtils;
	var HashUtils_1 = __webpack_require__(65);
	exports.HashUtils = HashUtils_1.HashUtils;
	var HighlightUtils_1 = __webpack_require__(66);
	exports.HighlightUtils = HighlightUtils_1.HighlightUtils;
	exports.StringAndHoles = HighlightUtils_1.StringAndHoles;
	var HtmlUtils_1 = __webpack_require__(67);
	exports.HTMLUtils = HtmlUtils_1.HTMLUtils;
	var KeyboardUtils_1 = __webpack_require__(68);
	exports.KEYBOARD = KeyboardUtils_1.KEYBOARD;
	exports.KeyboardUtils = KeyboardUtils_1.KeyboardUtils;
	var LocalStorageUtils_1 = __webpack_require__(69);
	exports.LocalStorageUtils = LocalStorageUtils_1.LocalStorageUtils;
	var OSUtils_1 = __webpack_require__(70);
	exports.OSUtils = OSUtils_1.OSUtils;
	exports.OS_NAME = OSUtils_1.OS_NAME;
	var PopupUtils_1 = __webpack_require__(71);
	exports.PopupUtils = PopupUtils_1.PopupUtils;
	var QueryUtils_1 = __webpack_require__(23);
	exports.QueryUtils = QueryUtils_1.QueryUtils;
	var StreamHighlightUtils_1 = __webpack_require__(72);
	exports.StreamHighlightUtils = StreamHighlightUtils_1.StreamHighlightUtils;
	var StringUtils_1 = __webpack_require__(61);
	exports.StringUtils = StringUtils_1.StringUtils;
	var TimeSpanUtils_1 = __webpack_require__(19);
	exports.TimeSpan = TimeSpanUtils_1.TimeSpan;
	var Utils_1 = __webpack_require__(18);
	exports.Utils = Utils_1.Utils;


/***/ },
/* 54 */
/***/ function(module, exports) {

	"use strict";
	var ColorUtils = (function () {
	    function ColorUtils() {
	    }
	    ColorUtils.hsvToRgb = function (h, s, v) {
	        var r, g, b;
	        var i = Math.floor(h * 6);
	        var f = h * 6 - i;
	        var p = v * (1 - s);
	        var q = v * (1 - f * s);
	        var t = v * (1 - (1 - f) * s);
	        switch (i % 6) {
	            case 0:
	                r = v, g = t, b = p;
	                break;
	            case 1:
	                r = q, g = v, b = p;
	                break;
	            case 2:
	                r = p, g = v, b = t;
	                break;
	            case 3:
	                r = p, g = q, b = v;
	                break;
	            case 4:
	                r = t, g = p, b = v;
	                break;
	            case 5:
	                r = v, g = p, b = q;
	                break;
	        }
	        return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
	    };
	    ColorUtils.rgbToHsv = function (r, g, b) {
	        r = r / 255, g = g / 255, b = b / 255;
	        var max = Math.max(r, g, b), min = Math.min(r, g, b);
	        var h, s, v = max;
	        var d = max - min;
	        s = max == 0 ? 0 : d / max;
	        if (max == min) {
	            h = 0; // achromatic
	        }
	        else {
	            switch (max) {
	                case r:
	                    h = (g - b) / d + (g < b ? 6 : 0);
	                    break;
	                case g:
	                    h = (b - r) / d + 2;
	                    break;
	                case b:
	                    h = (r - g) / d + 4;
	                    break;
	            }
	            h /= 6;
	        }
	        return [h, s, v];
	    };
	    return ColorUtils;
	}());
	exports.ColorUtils = ColorUtils;


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Assert_1 = __webpack_require__(17);
	var Options_1 = __webpack_require__(33);
	var Utils_1 = __webpack_require__(18);
	var Globalize = __webpack_require__(4);
	var DefaultCurrencyToStringOptions = (function (_super) {
	    __extends(DefaultCurrencyToStringOptions, _super);
	    function DefaultCurrencyToStringOptions() {
	        _super.apply(this, arguments);
	        this.decimals = 0;
	    }
	    return DefaultCurrencyToStringOptions;
	}(Options_1.Options));
	var CurrencyUtils = (function () {
	    function CurrencyUtils() {
	    }
	    CurrencyUtils.currencyToString = function (value, options) {
	        if (Utils_1.Utils.isNullOrUndefined(value)) {
	            return '';
	        }
	        value = Number(value);
	        Assert_1.Assert.isNumber(value);
	        options = new DefaultCurrencyToStringOptions().merge(options);
	        var currency = Globalize.culture().numberFormat.currency;
	        var backup = currency.symbol;
	        if (Utils_1.Utils.isNonEmptyString(options.symbol)) {
	            currency.symbol = options.symbol;
	        }
	        var str = Globalize.format(value, 'c' + options.decimals.toString());
	        currency.symbol = backup;
	        return str;
	    };
	    return CurrencyUtils;
	}());
	exports.CurrencyUtils = CurrencyUtils;


/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Options_1 = __webpack_require__(33);
	var Utils_1 = __webpack_require__(18);
	var Strings_1 = __webpack_require__(34);
	var TimeSpanUtils_1 = __webpack_require__(19);
	var Globalize = __webpack_require__(4);
	var DefaultDateToStringOptions = (function (_super) {
	    __extends(DefaultDateToStringOptions, _super);
	    function DefaultDateToStringOptions() {
	        _super.apply(this, arguments);
	        this.now = new Date();
	        this.useTodayYesterdayAndTomorrow = true;
	        this.useWeekdayIfThisWeek = true;
	        this.omitYearIfCurrentOne = true;
	        this.useLongDateFormat = false;
	        this.includeTimeIfToday = true;
	        this.includeTimeIfThisWeek = true;
	        this.alwaysIncludeTime = false;
	        this.predefinedFormat = undefined;
	    }
	    return DefaultDateToStringOptions;
	}(Options_1.Options));
	var DateUtils = (function () {
	    function DateUtils() {
	    }
	    DateUtils.convertFromJsonDateIfNeeded = function (date) {
	        if (_.isDate(date)) {
	            return date;
	        }
	        else if (date !== null && !isNaN(Number(date))) {
	            return new Date(Number(date));
	        }
	        else if (_.isString(date)) {
	            return new Date(date.replace('@', ' '));
	        }
	        else {
	            return undefined;
	        }
	    };
	    DateUtils.dateForQuery = function (date) {
	        return date.getFullYear() + '/' + DateUtils.padNumber((date.getMonth() + 1).toString()) + '/' + DateUtils.padNumber(date.getDate().toString());
	    };
	    DateUtils.padNumber = function (num, length) {
	        if (length === void 0) { length = 2; }
	        while (num.length < length) {
	            num = '0' + num;
	        }
	        return num;
	    };
	    DateUtils.keepOnlyDatePart = function (date) {
	        return new Date(date.getFullYear(), date.getMonth(), date.getDate());
	    };
	    DateUtils.offsetDateByDays = function (date, offset) {
	        var newDate = new Date(date.valueOf());
	        newDate.setDate(newDate.getDate() + offset);
	        return newDate;
	    };
	    DateUtils.dateToString = function (d, options) {
	        if (Utils_1.Utils.isNullOrUndefined(d)) {
	            return '';
	        }
	        options = new DefaultDateToStringOptions().merge(options);
	        var dateOnly = DateUtils.keepOnlyDatePart(d);
	        if (options.predefinedFormat) {
	            return Globalize.format(dateOnly, options.predefinedFormat);
	        }
	        var today = DateUtils.keepOnlyDatePart(options.now);
	        if (options.useTodayYesterdayAndTomorrow) {
	            if (dateOnly.valueOf() == today.valueOf()) {
	                return Strings_1.l('Today');
	            }
	            var tomorrow = DateUtils.offsetDateByDays(today, 1);
	            if (dateOnly.valueOf() == tomorrow.valueOf()) {
	                return Strings_1.l('Tomorrow');
	            }
	            var yesterday = DateUtils.offsetDateByDays(today, -1);
	            if (dateOnly.valueOf() == yesterday.valueOf()) {
	                return Strings_1.l('Yesterday');
	            }
	        }
	        var isThisWeek = Math.abs(TimeSpanUtils_1.TimeSpan.fromDates(dateOnly, today).getDays()) < 7;
	        if (options.useWeekdayIfThisWeek && isThisWeek) {
	            if (dateOnly.valueOf() > today.valueOf()) {
	                return Strings_1.l('Next') + ' ' + Globalize.format(dateOnly, 'dddd');
	            }
	            else {
	                return Strings_1.l('Last') + ' ' + Globalize.format(dateOnly, 'dddd');
	            }
	        }
	        if (options.omitYearIfCurrentOne && dateOnly.getFullYear() === today.getFullYear()) {
	            return Globalize.format(dateOnly, 'M');
	        }
	        if (options.useLongDateFormat) {
	            return Globalize.format(dateOnly, 'D');
	        }
	        return Globalize.format(dateOnly, 'd');
	    };
	    DateUtils.timeToString = function (date, options) {
	        if (Utils_1.Utils.isNullOrUndefined(date)) {
	            return '';
	        }
	        return Globalize.format(date, 't');
	    };
	    DateUtils.dateTimeToString = function (date, options) {
	        if (Utils_1.Utils.isNullOrUndefined(date)) {
	            return '';
	        }
	        options = new DefaultDateToStringOptions().merge(options);
	        var today = DateUtils.keepOnlyDatePart(options.now);
	        var isThisWeek = Math.abs(TimeSpanUtils_1.TimeSpan.fromDates(date, today).getDays()) < 7;
	        var datePart = DateUtils.dateToString(date, options);
	        var dateWithoutTime = DateUtils.keepOnlyDatePart(date);
	        if (options.alwaysIncludeTime || (options.includeTimeIfThisWeek && isThisWeek) || (options.includeTimeIfToday && dateWithoutTime.valueOf() == today.valueOf())) {
	            return datePart + ', ' + DateUtils.timeToString(date);
	        }
	        else {
	            return datePart;
	        }
	    };
	    DateUtils.monthToString = function (month) {
	        var date = new Date(1980, month);
	        return Globalize.format(date, 'MMMM');
	    };
	    DateUtils.isValid = function (date) {
	        if (date instanceof Date) {
	            return !isNaN(date.getTime());
	        }
	        return false;
	    };
	    DateUtils.timeBetween = function (from, to) {
	        if (Utils_1.Utils.isNullOrUndefined(from) || Utils_1.Utils.isNullOrUndefined(to)) {
	            return '';
	        }
	        return ('0' + ((to.getTime() - from.getTime()) / (1000 * 60 * 60)).toFixed()).slice(-2) +
	            ':' + ('0' + ((to.getTime() - from.getTime()) % (1000 * 60 * 60) / (1000 * 60)).toFixed()).slice(-2) +
	            ':' + ('0' + ((to.getTime() - from.getTime()) % (1000 * 60) / (1000)).toFixed()).slice(-2);
	    };
	    return DateUtils;
	}());
	exports.DateUtils = DateUtils;
	// Shim for IE8 Date.toISOString
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString
	if (!Date.prototype.toISOString) {
	    (function () {
	        function pad(nber) {
	            if (nber < 10) {
	                return '0' + nber;
	            }
	            return nber;
	        }
	        Date.prototype.toISOString = function () {
	            return this.getUTCFullYear() +
	                '-' + pad(this.getUTCMonth() + 1) +
	                '-' + pad(this.getUTCDate()) +
	                'T' + pad(this.getUTCHours()) +
	                ':' + pad(this.getUTCMinutes()) +
	                ':' + pad(this.getUTCSeconds()) +
	                '.' + (this.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) +
	                'Z';
	        };
	    }());
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var Utils_1 = __webpack_require__(18);
	var JQueryutils_1 = __webpack_require__(58);
	var Assert_1 = __webpack_require__(17);
	var Logger_1 = __webpack_require__(16);
	/**
	 * This is essentially an helper class for dom manipulation.<br/>
	 * This is intended to provide some basic functionality normally offered by jQuery.<br/>
	 * To minimize the multiple jQuery conflict we have while integrating in various system, we implemented the very small subset that the framework needs.<br/>
	 * See {@link $$}, which is a function that wraps this class constructor, for less verbose code.
	 */
	var Dom = (function () {
	    /**
	     * Create a new Dom object with the given HTMLElement
	     * @param el The HTMLElement to wrap in a Dom object
	     */
	    function Dom(el) {
	        Assert_1.Assert.exists(el);
	        this.el = el;
	    }
	    /**
	     * Helper function to quickly create an HTMLElement
	     * @param type The type of the element (e.g. div, span)
	     * @param props The props (id, className, attributes) of the element<br/>
	     * Can be either specified in dashed-case strings ('my-attribute') or camelCased keys (myAttribute),
	     * the latter of which will automatically get replaced to dash-case.
	     * @param innerHTML The contents of the new HTMLElement, either in string form or as another HTMLElement
	     */
	    Dom.createElement = function (type, props) {
	        var children = [];
	        for (var _i = 2; _i < arguments.length; _i++) {
	            children[_i - 2] = arguments[_i];
	        }
	        var elem = document.createElement(type);
	        for (var key in props) {
	            if (key === 'className') {
	                elem.className = props['className'];
	            }
	            else {
	                var attr = key.indexOf('-') !== -1 ? key : Utils_1.Utils.toDashCase(key);
	                elem.setAttribute(attr, props[key]);
	            }
	        }
	        _.each(children, function (child) {
	            if (child instanceof HTMLElement) {
	                elem.appendChild(child);
	            }
	            else if (_.isString(child)) {
	                elem.innerHTML += child;
	            }
	            else if (child instanceof Dom) {
	                elem.appendChild(child.el);
	            }
	        });
	        return elem;
	    };
	    /**
	     * Adds the element to the children of the current element
	     * @param element The element to append
	     * @returns {string}
	     */
	    Dom.prototype.append = function (element) {
	        this.el.appendChild(element);
	    };
	    /**
	     * Get the css value of the specified property.<br/>
	     * @param property The property
	     * @returns {string}
	     */
	    Dom.prototype.css = function (property) {
	        if (this.el.style[property]) {
	            return this.el.style[property];
	        }
	        return window.getComputedStyle(this.el).getPropertyValue(property);
	    };
	    /**
	     * Get or set the text content of the HTMLElement.<br/>
	     * @param txt Optional. If given, this will set the text content of the element. If not, will return the text content.
	     * @returns {string}
	     */
	    Dom.prototype.text = function (txt) {
	        if (Utils_1.Utils.isUndefined(txt)) {
	            return this.el.innerText || this.el.textContent;
	        }
	        else {
	            if (this.el.innerText != undefined) {
	                this.el.innerText = txt;
	            }
	            else if (this.el.textContent != undefined) {
	                this.el.textContent = txt;
	            }
	        }
	    };
	    /**
	     * Performant way to transform a NodeList to an array of HTMLElement, for manipulation<br/>
	     * http://jsperf.com/nodelist-to-array/72
	     * @param nodeList a {NodeList} to convert to an array
	     * @returns {HTMLElement[]}
	     */
	    Dom.prototype.nodeListToArray = function (nodeList) {
	        var i = nodeList.length;
	        var arr = new Array(i);
	        while (i--) {
	            arr[i] = nodeList.item(i);
	        }
	        return arr;
	    };
	    /**
	     * Empty (remove all child) from the element;
	     */
	    Dom.prototype.empty = function () {
	        while (this.el.firstChild) {
	            this.el.removeChild(this.el.firstChild);
	        }
	    };
	    /**
	     * Empty the element and all childs from the dom;
	     */
	    Dom.prototype.remove = function () {
	        this.el.parentNode.removeChild(this.el);
	    };
	    /**
	     * Show the element;
	     */
	    Dom.prototype.show = function () {
	        this.el.style.display = 'block';
	    };
	    /**
	     * Hide the element;
	     */
	    Dom.prototype.hide = function () {
	        this.el.style.display = 'none';
	    };
	    /**
	     * Toggle the element visibility.<br/>
	     * Optional visible parameter, if specified will set the element visibility
	     * @param visible Optional parameter to display or hide the element
	     */
	    Dom.prototype.toggle = function (visible) {
	        if (visible === undefined) {
	            if (this.el.style.display == 'block') {
	                this.hide();
	            }
	            else {
	                this.show();
	            }
	        }
	        else {
	            if (visible) {
	                this.show();
	            }
	            else {
	                this.hide();
	            }
	        }
	    };
	    /**
	     * Returns the value of the specified attribute.
	     * @param name The name of the attribute
	     */
	    Dom.prototype.getAttribute = function (name) {
	        return this.el.getAttribute(name);
	    };
	    /**
	     * Sets the value of the specified attribute.
	     * @param name The name of the attribute
	     * @param value The value to set
	     */
	    Dom.prototype.setAttribute = function (name, value) {
	        this.el.setAttribute(name, value);
	    };
	    /**
	     * Find a child element, given a CSS selector
	     * @param selector A CSS selector, can be a .className or #id
	     * @returns {HTMLElement}
	     */
	    Dom.prototype.find = function (selector) {
	        return this.el.querySelector(selector);
	    };
	    /**
	     * Check if the element match the selector.<br/>
	     * The selector can be a class, an id or a tag.<br/>
	     * Eg : .is('.foo') or .is('#foo') or .is('div').
	     */
	    Dom.prototype.is = function (selector) {
	        if (this.el.tagName.toLowerCase() == selector.toLowerCase()) {
	            return true;
	        }
	        if (selector[0] == '.') {
	            if (this.hasClass(selector.substr(1))) {
	                return true;
	            }
	        }
	        if (selector[0] == '#') {
	            if (this.el.getAttribute('id') == selector.substr(1)) {
	                return true;
	            }
	        }
	        return false;
	    };
	    /**
	     * Get the first element that matches the classname by testing the element itself and traversing up through its ancestors in the DOM tree.
	     *
	     * Stops at the body of the document
	     * @param className A CSS classname
	     */
	    Dom.prototype.closest = function (className) {
	        return this.traverseAncestorForClass(this.el, className);
	    };
	    /**
	     * Get the first element that matches the classname by testing the element itself and traversing up through its ancestors in the DOM tree.
	     *
	     * Stops at the body of the document
	     * @returns {any}
	     */
	    Dom.prototype.parent = function (className) {
	        if (this.el.parentElement == undefined) {
	            return undefined;
	        }
	        return this.traverseAncestorForClass(this.el.parentElement, className);
	    };
	    /**
	     *  Get all the ancestors of the current element that match the given className
	     *
	     *  Return an empty array if none found.
	     * @param className
	     * @returns {HTMLElement[]}
	     */
	    Dom.prototype.parents = function (className) {
	        var parentsFound = [];
	        var parentFound = this.parent(className);
	        while (parentFound) {
	            parentsFound.push(parentFound);
	            parentFound = new Dom(parentFound).parent(className);
	        }
	        return parentsFound;
	    };
	    /**
	     * Return all children
	     * @returns {HTMLElement[]}
	     */
	    Dom.prototype.children = function () {
	        return this.nodeListToArray(this.el.children);
	    };
	    /**
	     * Return all siblings
	     * @returns {HTMLElement[]}
	     */
	    Dom.prototype.siblings = function (selector) {
	        var sibs = [];
	        var currentElement = this.el.parentNode.firstChild;
	        for (; currentElement; currentElement = currentElement.nextSibling) {
	            if (currentElement != this.el) {
	                if (this.matches(currentElement, selector) || !selector) {
	                    sibs.push(currentElement);
	                }
	            }
	        }
	        return sibs;
	    };
	    Dom.prototype.matches = function (element, selector) {
	        var all = document.querySelectorAll(selector);
	        for (var i = 0; i < all.length; i++) {
	            if (all[i] === element) {
	                return true;
	            }
	        }
	        return false;
	    };
	    /**
	     * Find all children that match the given CSS selector
	     * @param selector A CSS selector, can be a .className
	     * @returns {HTMLElement[]}
	     */
	    Dom.prototype.findAll = function (selector) {
	        return this.nodeListToArray(this.el.querySelectorAll(selector));
	    };
	    /**
	     * Find the child elements using a className
	     * @param className Class of the childs elements to find
	     * @returns {HTMLElement[]}
	     */
	    Dom.prototype.findClass = function (className) {
	        if ('getElementsByClassName' in this.el) {
	            return this.nodeListToArray(this.el.getElementsByClassName(className));
	        }
	        // For ie 8
	        return this.nodeListToArray(this.el.querySelectorAll('.' + className));
	    };
	    /**
	     * Find an element using an ID
	     * @param id ID of the element to find
	     * @returns {HTMLElement}
	     */
	    Dom.prototype.findId = function (id) {
	        return document.getElementById(id);
	    };
	    Dom.prototype.addClass = function (className) {
	        var _this = this;
	        if (_.isArray(className)) {
	            _.each(className, function (name) {
	                _this.addClass(name);
	            });
	        }
	        else {
	            if (!this.hasClass(className)) {
	                if (this.el.className) {
	                    this.el.className += ' ' + className;
	                }
	                else {
	                    this.el.className = className;
	                }
	            }
	        }
	    };
	    /**
	     * Remove the class on the element. Works even if the element does not possess the class.
	     * @param className Classname to remove on the the element
	     */
	    Dom.prototype.removeClass = function (className) {
	        this.el.className = this.el.className.replace(new RegExp("(^|\\s)" + className + "(\\s|\\b)", 'g'), '$1').trim();
	    };
	    /**
	     * Toggle the class on the element.
	     * @param className Classname to toggle
	     * @swtch If true, add the class regardless and if false, remove the class
	     */
	    Dom.prototype.toggleClass = function (className, swtch) {
	        if (Utils_1.Utils.isNullOrUndefined(swtch)) {
	            if (this.hasClass(className)) {
	                this.removeClass(className);
	            }
	            else {
	                this.addClass(className);
	            }
	        }
	        else {
	            if (swtch) {
	                this.addClass(className);
	            }
	            else {
	                this.removeClass(className);
	            }
	        }
	    };
	    /**
	     * Sets the inner html of the element
	     * @param html The html to set
	     */
	    Dom.prototype.setHtml = function (html) {
	        this.el.innerHTML = html;
	    };
	    /**
	     * Return an array with all the classname on the element. Empty array if the element has not classname
	     * @returns {any|Array}
	     */
	    Dom.prototype.getClass = function () {
	        return this.el.className.match(Dom.CLASS_NAME_REGEX) || [];
	    };
	    /**
	     * Check if the element has the given class name
	     * @param className Classname to verify
	     * @returns {boolean}
	     */
	    Dom.prototype.hasClass = function (className) {
	        return _.contains(this.getClass(), className);
	    };
	    /**
	     * Detach the element from the DOM.
	     */
	    Dom.prototype.detach = function () {
	        this.el.parentElement && this.el.parentElement.removeChild(this.el);
	    };
	    /**
	     * Insert the current node after the given reference node
	     * @param refNode
	     */
	    Dom.prototype.insertAfter = function (refNode) {
	        refNode.parentNode && refNode.parentNode.insertBefore(this.el, refNode.nextSibling);
	    };
	    /**
	     * Insert the current node before the given reference node
	     * @param refNode
	     */
	    Dom.prototype.insertBefore = function (refNode) {
	        refNode.parentNode && refNode.parentNode.insertBefore(this.el, refNode);
	    };
	    /**
	     * Insert the given node as the first child of the current node
	     * @param toPrepend
	     */
	    Dom.prototype.prepend = function (toPrepend) {
	        if (this.el.firstChild) {
	            new Dom(toPrepend).insertBefore(this.el.firstChild);
	        }
	        else {
	            this.el.appendChild(toPrepend);
	        }
	    };
	    Dom.prototype.on = function (type, eventHandle) {
	        var _this = this;
	        if (_.isArray(type)) {
	            _.each(type, function (t) {
	                _this.on(t, eventHandle);
	            });
	        }
	        else {
	            var jq = JQueryutils_1.JQueryUtils.getJQuery();
	            if (jq) {
	                jq(this.el).on(type, eventHandle);
	            }
	            else if (this.el.addEventListener) {
	                var fn = function (e) {
	                    eventHandle(e, e.detail);
	                };
	                Dom.handlers.push({
	                    eventHandle: eventHandle,
	                    fn: fn
	                });
	                this.el.addEventListener(type, fn, false);
	            }
	            else if (this.el['on']) {
	                this.el['on']('on' + type, eventHandle);
	            }
	        }
	    };
	    Dom.prototype.one = function (type, eventHandle) {
	        var _this = this;
	        if (_.isArray(type)) {
	            _.each(type, function (t) {
	                _this.one(t, eventHandle);
	            });
	        }
	        else {
	            var once = function (e, args) {
	                _this.off(type, once);
	                return eventHandle(e, args);
	            };
	            this.on(type, once);
	        }
	    };
	    Dom.prototype.off = function (type, eventHandle) {
	        var _this = this;
	        if (_.isArray(type)) {
	            _.each(type, function (t) {
	                _this.off(t, eventHandle);
	            });
	        }
	        else {
	            var jq = JQueryutils_1.JQueryUtils.getJQuery();
	            if (jq) {
	                jq(this.el).off(type, eventHandle);
	            }
	            else if (this.el.removeEventListener) {
	                var idx = 0;
	                var found = _.find(Dom.handlers, function (handlerObj, i) {
	                    if (handlerObj.eventHandle == eventHandle) {
	                        idx = i;
	                        return true;
	                    }
	                });
	                if (found) {
	                    this.el.removeEventListener(type, found.fn, false);
	                    Dom.handlers.splice(idx, 1);
	                }
	            }
	            else if (this.el['off']) {
	                this.el['off']('on' + type, eventHandle);
	            }
	        }
	    };
	    /**
	     * Trigger an event on the element.
	     * @param type The event type to trigger
	     * @param data
	     */
	    Dom.prototype.trigger = function (type, data) {
	        var jq = JQueryutils_1.JQueryUtils.getJQuery();
	        if (jq) {
	            jq(this.el).trigger(type, data);
	        }
	        else if (CustomEvent !== undefined) {
	            var event = new CustomEvent(type, { detail: data, bubbles: true });
	            this.el.dispatchEvent(event);
	        }
	        else {
	            // TODO Support for older browser ?
	            new Logger_1.Logger(this).error('CANNOT TRIGGER EVENT FOR OLDER BROWSER');
	        }
	    };
	    /**
	     * Check if the element is "empty" (has no innerHTML content). Whitespace is considered empty</br>
	     * @returns {boolean}
	     */
	    Dom.prototype.isEmpty = function () {
	        return Dom.ONLY_WHITE_SPACE_REGEX.test(this.el.innerHTML);
	    };
	    /**
	     * Check if the element is a descendant of parent
	     * @param other
	     */
	    Dom.prototype.isDescendant = function (parent) {
	        var node = this.el.parentNode;
	        while (node != null) {
	            if (node == parent) {
	                return true;
	            }
	            node = node.parentNode;
	        }
	        return false;
	    };
	    /**
	     * Replace the current element with the other element, then detach the current element
	     * @param otherElem
	     */
	    Dom.prototype.replaceWith = function (otherElem) {
	        var parent = this.el.parentNode;
	        if (parent) {
	            new Dom(otherElem).insertAfter(this.el);
	        }
	        this.detach();
	    };
	    // based on http://api.jquery.com/position/
	    /**
	     * Return the position relative to the offset parent.
	     */
	    Dom.prototype.position = function () {
	        var offsetParent = this.offsetParent();
	        var parentOffset = { top: 0, left: 0 };
	        var offset = this.offset();
	        if (!$$(offsetParent).is('html')) {
	            parentOffset = $$(offsetParent).offset();
	        }
	        var borderTopWidth = parseInt($$(offsetParent).css('borderTopWidth'));
	        var borderLeftWidth = parseInt($$(offsetParent).css('borderLeftWidth'));
	        borderTopWidth = isNaN(borderTopWidth) ? 0 : borderTopWidth;
	        borderLeftWidth = isNaN(borderLeftWidth) ? 0 : borderLeftWidth;
	        parentOffset = {
	            top: parentOffset.top + borderTopWidth,
	            left: parentOffset.left + borderLeftWidth
	        };
	        var marginTop = parseInt(this.css('marginTop'));
	        var marginLeft = parseInt(this.css('marginLeft'));
	        marginTop = isNaN(marginTop) ? 0 : marginTop;
	        marginLeft = isNaN(marginLeft) ? 0 : marginLeft;
	        return {
	            top: offset.top - parentOffset.top - marginTop,
	            left: offset.left - parentOffset.left - marginLeft
	        };
	    };
	    // based on https://api.jquery.com/offsetParent/
	    /**
	     * Returns the offset parent. The offset parent is the closest parent that is positioned.
	     * An element is positioned when its position property is not 'static', which is the default.
	     */
	    Dom.prototype.offsetParent = function () {
	        var offsetParent = this.el.offsetParent;
	        while (offsetParent instanceof HTMLElement && $$(offsetParent).css('position') === 'static') {
	            // Will break out if it stumbles upon an non-HTMLElement and return documentElement
	            offsetParent = offsetParent.offsetParent;
	        }
	        if (!(offsetParent instanceof HTMLElement)) {
	            return document.documentElement;
	        }
	        return offsetParent;
	    };
	    // based on http://api.jquery.com/offset/
	    /**
	     * Return the position relative to the document.
	     */
	    Dom.prototype.offset = function () {
	        // In <=IE11, calling getBoundingClientRect on a disconnected node throws an error
	        if (!this.el.getClientRects().length) {
	            return { top: 0, left: 0 };
	        }
	        var rect = this.el.getBoundingClientRect();
	        if (rect.width || rect.height) {
	            var doc = this.el.ownerDocument;
	            var docElem = doc.documentElement;
	            return {
	                top: rect.top + window.pageYOffset - docElem.clientTop,
	                left: rect.left + window.pageXOffset - docElem.clientLeft
	            };
	        }
	        return rect;
	    };
	    /**
	     * Returns the offset width of the element
	     */
	    Dom.prototype.width = function () {
	        return this.el.offsetWidth;
	    };
	    /**
	     * Returns the offset height of the element
	     */
	    Dom.prototype.height = function () {
	        return this.el.offsetHeight;
	    };
	    Dom.prototype.traverseAncestorForClass = function (current, className) {
	        if (current === void 0) { current = this.el; }
	        if (className.indexOf('.') == 0) {
	            className = className.substr(1);
	        }
	        var found = false;
	        while (!found) {
	            if ($$(current).hasClass(className)) {
	                found = true;
	            }
	            if (current.tagName.toLowerCase() == 'body') {
	                break;
	            }
	            if (current.parentElement == null) {
	                break;
	            }
	            if (!found) {
	                current = current.parentElement;
	            }
	        }
	        if (found) {
	            return current;
	        }
	        return undefined;
	    };
	    Dom.CLASS_NAME_REGEX = /-?[_a-zA-Z]+[_a-zA-Z0-9-]*/g;
	    Dom.ONLY_WHITE_SPACE_REGEX = /^\s*$/;
	    Dom.handlers = [];
	    return Dom;
	}());
	exports.Dom = Dom;
	var Win = (function () {
	    function Win(win) {
	        this.win = win;
	    }
	    Win.prototype.height = function () {
	        return this.win.innerHeight;
	    };
	    Win.prototype.width = function () {
	        return this.win.innerWidth;
	    };
	    return Win;
	}());
	exports.Win = Win;
	var Doc = (function () {
	    function Doc(doc) {
	        this.doc = doc;
	    }
	    Doc.prototype.height = function () {
	        var body = this.doc.body;
	        return Math.max(body.scrollHeight, body.offsetHeight);
	    };
	    Doc.prototype.width = function () {
	        var body = this.doc.body;
	        return Math.max(body.scrollWidth, body.offsetWidth);
	    };
	    return Doc;
	}());
	exports.Doc = Doc;
	function $$() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i - 0] = arguments[_i];
	    }
	    if (args.length === 1 && args[0] instanceof Dom) {
	        return args[0];
	    }
	    else if (args.length === 1 && (!_.isString(args[0]))) {
	        return new Dom(args[0]);
	    }
	    else {
	        return new Dom(Dom.createElement.apply(Dom, args));
	    }
	}
	exports.$$ = $$;
	function htmlToDom(html) {
	    var parsedHtml = document.createElement('div');
	    parsedHtml.innerHTML = html;
	    // If the template has a single root element, we return it directly. Otherwise
	    // we'll have to wrap this thing in a div as ResultList expects a single element.
	    if (parsedHtml.children.length == 1) {
	        return parsedHtml.children.item(0);
	    }
	    return parsedHtml;
	}
	exports.htmlToDom = htmlToDom;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 58 */
/***/ function(module, exports) {

	"use strict";
	var JQueryUtils = (function () {
	    function JQueryUtils() {
	    }
	    JQueryUtils.getJQuery = function () {
	        if (window && window['Coveo'] && window['Coveo']['$']) {
	            return window['Coveo']['$'];
	        }
	        return false;
	    };
	    JQueryUtils.isInstanceOfJQuery = function (obj) {
	        var jq = this.getJQuery();
	        if (jq) {
	            return obj instanceof jq;
	        }
	        return false;
	    };
	    JQueryUtils.isInstanceOfJqueryEvent = function (obj) {
	        var jq = this.getJQuery();
	        if (jq) {
	            return obj instanceof jq.Event;
	        }
	        return false;
	    };
	    return JQueryUtils;
	}());
	exports.JQueryUtils = JQueryUtils;


/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var Dom_1 = __webpack_require__(57);
	var DateUtils_1 = __webpack_require__(56);
	var FileTypes_1 = __webpack_require__(60);
	var Utils_1 = __webpack_require__(18);
	var StringUtils_1 = __webpack_require__(61);
	var DomUtils = (function () {
	    function DomUtils() {
	    }
	    DomUtils.getPopUpCloseButton = function (captionForClose, captionForReminder) {
	        var container = document.createElement('span');
	        var closeButton = document.createElement('span');
	        Dom_1.$$(closeButton).addClass('coveo-close-button');
	        container.appendChild(closeButton);
	        var iconClose = document.createElement('span');
	        Dom_1.$$(iconClose).addClass('coveo-icon');
	        Dom_1.$$(iconClose).addClass('coveo-sprites-quickview-close');
	        closeButton.appendChild(iconClose);
	        Dom_1.$$(closeButton).text(captionForClose);
	        var closeReminder = document.createElement('span');
	        Dom_1.$$(closeReminder).addClass('coveo-pop-up-reminder');
	        Dom_1.$$(closeReminder).text(captionForReminder);
	        container.appendChild(closeReminder);
	        return container.outerHTML;
	    };
	    DomUtils.getBasicLoadingAnimation = function () {
	        var loadDotClass = 'coveo-loading-dot';
	        var dom = document.createElement('div');
	        dom.className = 'coveo-first-loading-animation';
	        dom.innerHTML = "<div class='coveo-logo' ></div>\n    <div class='coveo-loading-container'>\n      <div class='" + loadDotClass + "'></div>\n      <div class='" + loadDotClass + "'></div>\n      <div class='" + loadDotClass + "'></div>\n      <div class='" + loadDotClass + "'></div>\n    </div>";
	        return dom;
	    };
	    DomUtils.highlightElement = function (initialString, valueToSearch) {
	        var regex = new RegExp(Utils_1.Utils.escapeRegexCharacter(valueToSearch), 'i');
	        var firstChar = initialString.search(regex);
	        var lastChar = firstChar + valueToSearch.length;
	        return StringUtils_1.StringUtils.htmlEncode(initialString.slice(0, firstChar)) + "<span class='coveo-highlight'>" + StringUtils_1.StringUtils.htmlEncode(initialString.slice(firstChar, lastChar)) + "</span>" + StringUtils_1.StringUtils.htmlEncode(initialString.slice(lastChar));
	    };
	    DomUtils.getLoadingSpinner = function () {
	        var loading = Dom_1.$$('div');
	        loading.addClass('coveo-loading-spinner');
	        return loading.el;
	    };
	    DomUtils.getModalBoxHeader = function (title) {
	        var header = Dom_1.$$('div');
	        header.el.innerHTML = "<div class='coveo-modalbox-right-header'>\n        <span class='coveo-modalbox-close-button'>\n          <span class='coveo-icon coveo-sprites-common-clear'></span>\n        </span>\n      </div>\n      <div class='coveo-modalbox-left-header'>\n        <span class='coveo-modalbox-pop-up-reminder'> " + (title || '') + "</span>\n      </div>";
	        return header;
	    };
	    DomUtils.getQuickviewHeader = function (result, options, bindings) {
	        var date = '';
	        if (options.showDate) {
	            date = DateUtils_1.DateUtils.dateTimeToString(new Date(result.raw.date));
	        }
	        var fileType = FileTypes_1.FileTypes.get(result);
	        var header = Dom_1.$$('div');
	        header.el.innerHTML = "<div class='coveo-quickview-right-header'>\n        <span class='coveo-quickview-time'>" + date + "</span>\n        <span class='coveo-quickview-close-button'>\n          <span class='coveo-icon coveo-sprites-common-clear'></span>\n        </span>\n      </div>\n      <div class='coveo-quickview-left-header'>\n        <span class='coveo-quickview-icon coveo-small " + fileType.icon + "'></span>\n        <span class='coveo-quickview-pop-up-reminder'> " + (options.title || '') + "</span>\n      </div>";
	        new Coveo[Coveo['Salesforce'] ? 'SalesforceResultLink' : 'ResultLink'](header.find('.coveo-quickview-pop-up-reminder'), undefined, bindings, result);
	        return header;
	    };
	    return DomUtils;
	}());
	exports.DomUtils = DomUtils;


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var Utils_1 = __webpack_require__(18);
	var Strings_1 = __webpack_require__(34);
	var Assert_1 = __webpack_require__(17);
	// On-demand mapping of file types to captions. Used by facets, but I don't
	// really like this. Maybe a dedicated filetype facet would be better? Hmm...
	var fileTypeCaptions;
	var FileTypes = (function () {
	    function FileTypes() {
	    }
	    FileTypes.get = function (result) {
	        var objecttype = result.raw.objecttype;
	        var filetype = result.raw.filetype;
	        // When @objecttype is File we fallback on @filetype for icons and such
	        if (Utils_1.Utils.isNonEmptyString(objecttype) && objecttype.toLowerCase() != 'file') {
	            return FileTypes.getObjectType(objecttype);
	        }
	        else if (Utils_1.Utils.isNonEmptyString(filetype)) {
	            return FileTypes.getFileType(filetype);
	        }
	        else {
	            return {
	                // This will render a default icon. Really it should not happen.
	                icon: 'coveo-icon filetype',
	                caption: Strings_1.l('Unknown')
	            };
	        }
	    };
	    FileTypes.getObjectType = function (objecttype) {
	        // We must use lowercase filetypes because that's how the CSS classes
	        // are generated (they are case sensitive, alas).
	        objecttype = objecttype.toLowerCase();
	        // Most object types have a set of localized strings in the main dictionary
	        var localizedString = Strings_1.l('objecttype_' + objecttype);
	        return {
	            'icon': 'coveo-icon objecttype ' + objecttype,
	            caption: localizedString != 'objecttype_' + objecttype ? localizedString : objecttype
	        };
	    };
	    FileTypes.getFileType = function (filetype) {
	        // We must use lowercase filetypes because that's how the CSS classes
	        // are generated (they are case sensitive, alas).
	        filetype = filetype.toLowerCase();
	        // Sometimes, filetype begins with a period (typically means the index has
	        // no idea and uses the file extension as a filetype).
	        if (filetype[0] == '.') {
	            filetype = filetype.substring(1);
	        }
	        // Most filetypes have a set of localized strings in the main dictionary
	        var localizedString = Strings_1.l('filetype_' + filetype);
	        return {
	            'icon': 'coveo-icon filetype ' + filetype,
	            caption: localizedString != 'filetype_' + filetype ? localizedString : filetype
	        };
	    };
	    FileTypes.getFileTypeCaptions = function () {
	        if (fileTypeCaptions == undefined) {
	            fileTypeCaptions = {};
	            var strings = String['locales'][String['locale'].toLowerCase()];
	            Assert_1.Assert.isNotUndefined(strings);
	            _.each(_.keys(strings), function (key) {
	                if (key.indexOf('filetype_') == 0) {
	                    fileTypeCaptions[key.substr('filetype_'.length)] = key.toLocaleString();
	                }
	                else if (key.indexOf('objecttype_') == 0) {
	                    fileTypeCaptions[key.substr('objecttype_'.length)] = key.toLocaleString();
	                }
	            });
	        }
	        return fileTypeCaptions;
	    };
	    return FileTypes;
	}());
	exports.FileTypes = FileTypes;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var Assert_1 = __webpack_require__(17);
	var Dom_1 = __webpack_require__(57);
	var StringUtils = (function () {
	    function StringUtils() {
	    }
	    StringUtils.javascriptEncode = function (value) {
	        Assert_1.Assert.isString(value);
	        value = value.replace(/\\/g, '\\\\');
	        value = value.replace(/'/g, '\\\'');
	        value = value.replace(/"/g, '\\"');
	        return value;
	    };
	    StringUtils.htmlEncode = function (value) {
	        Assert_1.Assert.isString(value);
	        var div = Dom_1.$$('div');
	        div.text(value);
	        return div.el.innerHTML;
	    };
	    StringUtils.splice = function (value, index, remove, toAdd) {
	        return value.slice(0, index) + toAdd + value.slice(index + Math.abs(remove));
	    };
	    StringUtils.removeMiddle = function (value, length, toAdd) {
	        if (value.length < length) {
	            return value;
	        }
	        var toRemove = value.length - length;
	        var index = Math.floor(length / 2);
	        return StringUtils.splice(value, index, toRemove, toAdd);
	    };
	    StringUtils.regexEncode = function (value) {
	        Assert_1.Assert.isString(value);
	        return value.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
	    };
	    StringUtils.stringToRegex = function (value, ignoreAccent) {
	        if (ignoreAccent === void 0) { ignoreAccent = false; }
	        Assert_1.Assert.isString(value);
	        var encoded = StringUtils.regexEncode(value);
	        if (ignoreAccent) {
	            return _.map(encoded, function (char) {
	                var regexp = _.find(StringUtils.accented, function (regexp) { return char.match(regexp) != null; });
	                if (regexp) {
	                    return regexp.source;
	                }
	                return char;
	            }).join('');
	        }
	        return encoded;
	    };
	    StringUtils.wildcardsToRegex = function (value, ignoreAccent) {
	        if (ignoreAccent === void 0) { ignoreAccent = false; }
	        Assert_1.Assert.isString(value);
	        var encoded = StringUtils.stringToRegex(value, ignoreAccent);
	        encoded = encoded.replace(/\\\*/, '.*');
	        encoded = encoded.replace(/\\\?/, '.');
	        return encoded;
	    };
	    StringUtils.getHighlights = function (strToSearch, regexToFind, dataHighlightGroupTerm) {
	        var match, indexes = [];
	        while (match = regexToFind.exec(strToSearch)) {
	            var desiredMatch = match[2];
	            var undesiredMatch = match[1];
	            var offset = match.index + undesiredMatch.length;
	            indexes.push({ offset: offset, length: desiredMatch.length, dataHighlightGroupTerm: dataHighlightGroupTerm });
	            if (!regexToFind.global) {
	                break;
	            }
	        }
	        return _.isEmpty(indexes) ? undefined : indexes;
	    };
	    StringUtils.encodeCarriageReturn = function (strToEncode) {
	        Assert_1.Assert.isString(strToEncode);
	        return strToEncode.replace(/\n/g, '<br/>');
	    };
	    StringUtils.equalsCaseInsensitive = function (str1, str2) {
	        return str1.toLowerCase() == str2.toLowerCase();
	    };
	    StringUtils.match = function (value, regex) {
	        var results = [];
	        var arr;
	        while ((arr = regex.exec(value)) !== null) {
	            results.push(arr);
	        }
	        return results;
	    };
	    StringUtils.hashCode = function (str) {
	        var hash = 0;
	        var len = str.length;
	        for (var i = 0; i < len; i++) {
	            var char = str.charCodeAt(i);
	            hash = ((hash << 5) - hash) + char;
	            hash = hash & hash; // Convert to 32bit integer
	        }
	        return hash.toString(16);
	    };
	    // http://stackoverflow.com/a/25575009
	    StringUtils.removePunctuation = function (str) {
	        var punctRE = /[\u2000-\u206F\u2E00-\u2E7F\\'!"#\$%&\(\)\*\+,\-\.\/:;<=>\?@\[\]\^_`\{\|\}~]/g;
	        var spaceRE = /\s+/g;
	        return str.replace(punctRE, '').replace(spaceRE, ' ');
	    };
	    StringUtils.accented = {
	        'A': /[Aa\xaa\xc0-\xc5\xe0-\xe5\u0100-\u0105\u01cd\u01ce\u0200-\u0203\u0226\u0227\u1d2c\u1d43\u1e00\u1e01\u1e9a\u1ea0-\u1ea3\u2090\u2100\u2101\u213b\u249c\u24b6\u24d0\u3371-\u3374\u3380-\u3384\u3388\u3389\u33a9-\u33af\u33c2\u33ca\u33df\u33ff\uff21\uff41]/g,
	        'B': /[Bb\u1d2e\u1d47\u1e02-\u1e07\u212c\u249d\u24b7\u24d1\u3374\u3385-\u3387\u33c3\u33c8\u33d4\u33dd\uff22\uff42]/g,
	        'C': /[Cc\xc7\xe7\u0106-\u010d\u1d9c\u2100\u2102\u2103\u2105\u2106\u212d\u216d\u217d\u249e\u24b8\u24d2\u3376\u3388\u3389\u339d\u33a0\u33a4\u33c4-\u33c7\uff23\uff43]/g,
	        'D': /[Dd\u010e\u010f\u01c4-\u01c6\u01f1-\u01f3\u1d30\u1d48\u1e0a-\u1e13\u2145\u2146\u216e\u217e\u249f\u24b9\u24d3\u32cf\u3372\u3377-\u3379\u3397\u33ad-\u33af\u33c5\u33c8\uff24\uff44]/g,
	        'E': /[Ee\xc8-\xcb\xe8-\xeb\u0112-\u011b\u0204-\u0207\u0228\u0229\u1d31\u1d49\u1e18-\u1e1b\u1eb8-\u1ebd\u2091\u2121\u212f\u2130\u2147\u24a0\u24ba\u24d4\u3250\u32cd\u32ce\uff25\uff45]/g,
	        'F': /[Ff\u1da0\u1e1e\u1e1f\u2109\u2131\u213b\u24a1\u24bb\u24d5\u338a-\u338c\u3399\ufb00-\ufb04\uff26\uff46]/g,
	        'G': /[Gg\u011c-\u0123\u01e6\u01e7\u01f4\u01f5\u1d33\u1d4d\u1e20\u1e21\u210a\u24a2\u24bc\u24d6\u32cc\u32cd\u3387\u338d-\u338f\u3393\u33ac\u33c6\u33c9\u33d2\u33ff\uff27\uff47]/g,
	        'H': /[Hh\u0124\u0125\u021e\u021f\u02b0\u1d34\u1e22-\u1e2b\u1e96\u210b-\u210e\u24a3\u24bd\u24d7\u32cc\u3371\u3390-\u3394\u33ca\u33cb\u33d7\uff28\uff48]/g,
	        'I': /[Ii\xcc-\xcf\xec-\xef\u0128-\u0130\u0132\u0133\u01cf\u01d0\u0208-\u020b\u1d35\u1d62\u1e2c\u1e2d\u1ec8-\u1ecb\u2071\u2110\u2111\u2139\u2148\u2160-\u2163\u2165-\u2168\u216a\u216b\u2170-\u2173\u2175-\u2178\u217a\u217b\u24a4\u24be\u24d8\u337a\u33cc\u33d5\ufb01\ufb03\uff29\uff49]/g,
	        'J': /[Jj\u0132-\u0135\u01c7-\u01cc\u01f0\u02b2\u1d36\u2149\u24a5\u24bf\u24d9\u2c7c\uff2a\uff4a]/g,
	        'K': /[Kk\u0136\u0137\u01e8\u01e9\u1d37\u1d4f\u1e30-\u1e35\u212a\u24a6\u24c0\u24da\u3384\u3385\u3389\u338f\u3391\u3398\u339e\u33a2\u33a6\u33aa\u33b8\u33be\u33c0\u33c6\u33cd-\u33cf\uff2b\uff4b]/g,
	        'L': /[Ll\u0139-\u0140\u01c7-\u01c9\u02e1\u1d38\u1e36\u1e37\u1e3a-\u1e3d\u2112\u2113\u2121\u216c\u217c\u24a7\u24c1\u24db\u32cf\u3388\u3389\u33d0-\u33d3\u33d5\u33d6\u33ff\ufb02\ufb04\uff2c\uff4c]/g,
	        'M': /[Mm\u1d39\u1d50\u1e3e-\u1e43\u2120\u2122\u2133\u216f\u217f\u24a8\u24c2\u24dc\u3377-\u3379\u3383\u3386\u338e\u3392\u3396\u3399-\u33a8\u33ab\u33b3\u33b7\u33b9\u33bd\u33bf\u33c1\u33c2\u33ce\u33d0\u33d4-\u33d6\u33d8\u33d9\u33de\u33df\uff2d\uff4d]/g,
	        'N': /[Nn\xd1\xf1\u0143-\u0149\u01ca-\u01cc\u01f8\u01f9\u1d3a\u1e44-\u1e4b\u207f\u2115\u2116\u24a9\u24c3\u24dd\u3381\u338b\u339a\u33b1\u33b5\u33bb\u33cc\u33d1\uff2e\uff4e]/g,
	        'O': /[Oo\xba\xd2-\xd6\xf2-\xf6\u014c-\u0151\u01a0\u01a1\u01d1\u01d2\u01ea\u01eb\u020c-\u020f\u022e\u022f\u1d3c\u1d52\u1ecc-\u1ecf\u2092\u2105\u2116\u2134\u24aa\u24c4\u24de\u3375\u33c7\u33d2\u33d6\uff2f\uff4f]/g,
	        'P': /[Pp\u1d3e\u1d56\u1e54-\u1e57\u2119\u24ab\u24c5\u24df\u3250\u3371\u3376\u3380\u338a\u33a9-\u33ac\u33b0\u33b4\u33ba\u33cb\u33d7-\u33da\uff30\uff50]/g,
	        'Q': /[Qq\u211a\u24ac\u24c6\u24e0\u33c3\uff31\uff51]/g,
	        'R': /[Rr\u0154-\u0159\u0210-\u0213\u02b3\u1d3f\u1d63\u1e58-\u1e5b\u1e5e\u1e5f\u20a8\u211b-\u211d\u24ad\u24c7\u24e1\u32cd\u3374\u33ad-\u33af\u33da\u33db\uff32\uff52]/g,
	        'S': /[Ss\u015a-\u0161\u017f\u0218\u0219\u02e2\u1e60-\u1e63\u20a8\u2101\u2120\u24ae\u24c8\u24e2\u33a7\u33a8\u33ae-\u33b3\u33db\u33dc\ufb06\uff33\uff53]/g,
	        'T': /[Tt\u0162-\u0165\u021a\u021b\u1d40\u1d57\u1e6a-\u1e71\u1e97\u2121\u2122\u24af\u24c9\u24e3\u3250\u32cf\u3394\u33cf\ufb05\ufb06\uff34\uff54]/g,
	        'U': /[Uu\xd9-\xdc\xf9-\xfc\u0168-\u0173\u01af\u01b0\u01d3\u01d4\u0214-\u0217\u1d41\u1d58\u1d64\u1e72-\u1e77\u1ee4-\u1ee7\u2106\u24b0\u24ca\u24e4\u3373\u337a\uff35\uff55]/g,
	        'V': /[Vv\u1d5b\u1d65\u1e7c-\u1e7f\u2163-\u2167\u2173-\u2177\u24b1\u24cb\u24e5\u2c7d\u32ce\u3375\u33b4-\u33b9\u33dc\u33de\uff36\uff56]/g,
	        'W': /[Ww\u0174\u0175\u02b7\u1d42\u1e80-\u1e89\u1e98\u24b2\u24cc\u24e6\u33ba-\u33bf\u33dd\uff37\uff57]/g,
	        'X': /[Xx\u02e3\u1e8a-\u1e8d\u2093\u213b\u2168-\u216b\u2178-\u217b\u24b3\u24cd\u24e7\u33d3\uff38\uff58]/g,
	        'Y': /[Yy\xdd\xfd\xff\u0176-\u0178\u0232\u0233\u02b8\u1e8e\u1e8f\u1e99\u1ef2-\u1ef9\u24b4\u24ce\u24e8\u33c9\uff39\uff59]/g,
	        'Z': /[Zz\u0179-\u017e\u01f1-\u01f3\u1dbb\u1e90-\u1e95\u2124\u2128\u24b5\u24cf\u24e9\u3390-\u3394\uff3a\uff5a]/g
	    };
	    return StringUtils;
	}());
	exports.StringUtils = StringUtils;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var Strings_1 = __webpack_require__(34);
	var EmailActionsUtils = (function () {
	    function EmailActionsUtils() {
	    }
	    EmailActionsUtils.buildMailToString = function (options) {
	        var mailTo = options.to ? 'mailto:' + encodeURIComponent(options.to) : 'mailto:';
	        var parameters = EmailActionsUtils.buildMailToParametersString(options.subject, options.cc, options.bcc, options.body, mailTo);
	        if (parameters) {
	            mailTo += '?' + parameters;
	        }
	        return mailTo;
	    };
	    EmailActionsUtils.buildMailToParametersString = function (subject, cc, bcc, body, mailTo) {
	        var parametersArray = [];
	        if (subject) {
	            parametersArray.push(EmailActionsUtils.buildMailToParameter('subject', subject));
	        }
	        if (cc) {
	            parametersArray.push(EmailActionsUtils.buildMailToParameter('cc', cc));
	        }
	        if (bcc) {
	            parametersArray.push(EmailActionsUtils.buildMailToParameter('bcc', bcc));
	        }
	        if (body) {
	            var shortenBody = EmailActionsUtils.getShortenBody(body, mailTo + '?' + parametersArray.join('&'));
	            if (shortenBody) {
	                parametersArray.push(EmailActionsUtils.buildMailToParameter('body', shortenBody));
	            }
	        }
	        return parametersArray.join('&');
	    };
	    EmailActionsUtils.getShortenBody = function (body, mailTo) {
	        var shortenBody = body;
	        if (mailTo.length < MailTo.maxLength) {
	            var maxBodyLength = MailTo.maxLength - mailTo.length - '&body='.length;
	            shortenBody = EmailActionsUtils.shortenString(body, maxBodyLength);
	        }
	        return shortenBody;
	    };
	    EmailActionsUtils.buildMailToParameter = function (name, param) {
	        return param ? encodeURIComponent(name) + '=' + encodeURIComponent(param) : '';
	    };
	    EmailActionsUtils.shortenString = function (str, maxLength, encodeShortenBodyIndication) {
	        if (encodeShortenBodyIndication === void 0) { encodeShortenBodyIndication = false; }
	        /* There is a size limit on mailto url,
	         * Depending on the browser, the mailto will not open if too large. */
	        var shortenBodyIndicator = encodeShortenBodyIndication ? encodeURIComponent(MailTo.shortenBodyIndicator) : MailTo.shortenBodyIndicator;
	        maxLength = maxLength - MailTo.shortenBodyIndicator.length;
	        var sliced = str.length > maxLength ? true : false;
	        var shortenStr = str.substring(0, maxLength);
	        shortenStr += sliced ? shortenBodyIndicator : '';
	        return shortenStr;
	    };
	    EmailActionsUtils.appendShortenBodyToMailToString = function (mailTo, body) {
	        var shortenBody = EmailActionsUtils.getShortenBody(body, mailTo);
	        return mailTo.indexOf('?') >= 0 ? mailTo + '&body=' + shortenBody : mailTo + '?body=' + shortenBody;
	    };
	    EmailActionsUtils.removeCurrentUserEmailFromString = function (currentUserEmail, str) {
	        if (str && currentUserEmail) {
	            return _.filter(str.split(';'), function (email) {
	                return email.indexOf(currentUserEmail) == -1;
	            }).join(';');
	        }
	        else {
	            return str;
	        }
	    };
	    EmailActionsUtils.buildReplyMailToFromResult = function (result, currentUserEmail) {
	        return new MailTo({
	            currentUserEmail: currentUserEmail,
	            originalFrom: result.raw.from,
	            to: result.raw.from,
	            subject: result.raw.conversationsubject,
	        });
	    };
	    EmailActionsUtils.buildReplyAllMailToFromResult = function (result, currentUserEmail) {
	        return new MailTo({
	            currentUserEmail: currentUserEmail,
	            originalFrom: result.raw.from,
	            to: result.raw.from + ';' + result.raw.to,
	            subject: result.raw.conversationsubject,
	            cc: result.raw.cc,
	        });
	    };
	    EmailActionsUtils.buildForwardMailToFromResult = function (result, currentUserEmail) {
	        return new MailTo({
	            currentUserEmail: currentUserEmail,
	            originalFrom: result.raw.from,
	            subject: result.raw.conversationsubject,
	        });
	    };
	    EmailActionsUtils.encodeMailToBody = function (body) {
	        var linesArray = body.split('\n');
	        _.each(linesArray, function (line, index) {
	            linesArray[index] = encodeURIComponent(linesArray[index]);
	        });
	        return linesArray.join(MailTo.enter);
	    };
	    return EmailActionsUtils;
	}());
	exports.EmailActionsUtils = EmailActionsUtils;
	var DefaultMailToOptions = (function () {
	    function DefaultMailToOptions() {
	        this.currentUserEmail = '';
	        this.originalFrom = '';
	        this.to = '';
	        this.subject = '';
	        this.cc = '';
	        this.bcc = '';
	        this.body = '';
	    }
	    return DefaultMailToOptions;
	}());
	exports.DefaultMailToOptions = DefaultMailToOptions;
	var MailTo = (function () {
	    function MailTo(options) {
	        this.options = options;
	        this.bodyHeader = '';
	        this.options = _.extend(new DefaultMailToOptions(), options);
	        this.removeCurrentUserFromParameters();
	        if (this.options.originalFrom) {
	            this.bodyHeader = this.options.bodyIsHTML ? '<p><br/><br/><br/>' + Strings_1.l('From') + ': ' + this.options.originalFrom + '<hr></p>' :
	                '\n\n\n' + Strings_1.l('From') + ': ' + this.options.originalFrom + '\n_________________________________\n';
	        }
	    }
	    MailTo.prototype.removeCurrentUserFromParameters = function () {
	        this.options.to = EmailActionsUtils.removeCurrentUserEmailFromString(this.options.currentUserEmail, this.options.to);
	        this.options.cc = EmailActionsUtils.removeCurrentUserEmailFromString(this.options.currentUserEmail, this.options.cc);
	        this.options.bcc = EmailActionsUtils.removeCurrentUserEmailFromString(this.options.currentUserEmail, this.options.bcc);
	    };
	    MailTo.prototype.open = function () {
	        this.ensureValueIsSet();
	        window.location.href = this.value;
	    };
	    MailTo.prototype.ensureValueIsSet = function () {
	        if (!this.value) {
	            this.setValue();
	        }
	        else if (!this.valueBodyIsSet()) {
	            this.setValueBody();
	        }
	    };
	    MailTo.prototype.setValue = function () {
	        this.value = EmailActionsUtils.buildMailToString(this.options);
	        if (this.value && !this.valueBodyIsSet()) {
	            this.setValueBody();
	        }
	    };
	    MailTo.prototype.setValueBody = function () {
	        this.value = EmailActionsUtils.appendShortenBodyToMailToString(this.value, this.body);
	    };
	    MailTo.prototype.setMailToBodyFromText = function (text) {
	        if (text === void 0) { text = ''; }
	        this.body = text;
	    };
	    MailTo.prototype.valueBodyIsSet = function () {
	        return this.value.indexOf('body=') >= 0;
	    };
	    MailTo.prototype.bodyIsSet = function () {
	        return this.body ? true : false;
	    };
	    MailTo.enter = '%0D%0A'; // \r\n
	    MailTo.shortenBodyIndicator = '\r\n\r\n...';
	    // Arbitrary numbers :
	    MailTo.maxLength = 1000;
	    return MailTo;
	}());
	exports.MailTo = MailTo;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var Utils_1 = __webpack_require__(18);
	var Strings_1 = __webpack_require__(34);
	var EmailUtils = (function () {
	    function EmailUtils() {
	    }
	    EmailUtils.splitSemicolonSeparatedListOfEmailAddresses = function (addresses) {
	        var addressesAsList = addresses.split(/\s*;\s*/);
	        return _.filter(addressesAsList, function (s) {
	            return Utils_1.Utils.exists(s) && Utils_1.Utils.isNonEmptyString(Utils_1.Utils.trim(s));
	        });
	    };
	    EmailUtils.emailAddressesToHyperlinks = function (addresses, companyDomain, me, lengthLimit, truncateName) {
	        if (lengthLimit === void 0) { lengthLimit = 2; }
	        if (truncateName === void 0) { truncateName = false; }
	        addresses = _.filter(addresses, function (s) {
	            return Utils_1.Utils.exists(s) && Utils_1.Utils.isNonEmptyString(Utils_1.Utils.trim(s));
	        });
	        var hyperlinks = _.map(addresses, function (item) {
	            var emailArray = EmailUtils.parseEmail(item);
	            var email = emailArray[1];
	            var name = emailArray[0];
	            if (Utils_1.Utils.exists(me) && email == me) {
	                name = Strings_1.l('Me');
	            }
	            if (truncateName) {
	                var split = name.split(' ');
	                if (!Utils_1.Utils.isNullOrUndefined(split[1])) {
	                    name = split[0] + ' ' + split[1].substring(0, 1) + '.';
	                }
	            }
	            var domainIndex = email.indexOf('@') >= 0 ? email.indexOf('@') + 1 : 0;
	            var domain = email.substr(domainIndex);
	            if (Utils_1.Utils.exists(companyDomain) && domain != companyDomain) {
	                name += ' (' + domain + ')';
	            }
	            return '<a title="' + item.replace(/'/g, '&quot;') + 'href="mailto:' + encodeURI(email) + '">' + name + '</a>';
	        });
	        var excess = hyperlinks.length - lengthLimit;
	        var andOthers = excess > 0 ? EmailUtils.buildEmailAddressesAndOthers(_.last(hyperlinks, excess)) : '';
	        return _.first(hyperlinks, lengthLimit).join(', ') + andOthers;
	    };
	    EmailUtils.buildEmailAddressesAndOthers = function (excessHyperLinks) {
	        return '<span class="coveo-emails-excess-collapsed coveo-active" onclick="Coveo.TemplateHelpers.getHelper(\'excessEmailToggle\')(this);"> ' + Strings_1.l('AndOthers', excessHyperLinks.length.toString(), excessHyperLinks.length) + '</span>' +
	            '<span class="coveo-emails-excess-expanded"> , ' + excessHyperLinks.join(' , ') + '</span>';
	    };
	    EmailUtils.parseEmail = function (email) {
	        var name;
	        var match = email.match(/^\s*(.*)\s+<(.*)>$/);
	        if (match != null) {
	            name = match[1];
	            if (/^'.*'|'.*'$/.test(name)) {
	                name = name.substr(1, name.length - 2);
	            }
	            email = match[2];
	        }
	        else {
	            name = email;
	            email = email;
	        }
	        return [name, email];
	    };
	    return EmailUtils;
	}());
	exports.EmailUtils = EmailUtils;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 64 */
/***/ function(module, exports) {

	"use strict";
	var FeatureDetectionUtils = (function () {
	    function FeatureDetectionUtils() {
	    }
	    FeatureDetectionUtils.supportSVG = function () {
	        return document.implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#BasicStructure', '1.1');
	    };
	    return FeatureDetectionUtils;
	}());
	exports.FeatureDetectionUtils = FeatureDetectionUtils;


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var Assert_1 = __webpack_require__(17);
	var Utils_1 = __webpack_require__(18);
	var HashUtils = (function () {
	    function HashUtils() {
	    }
	    HashUtils.getHash = function (w) {
	        if (w === void 0) { w = window; }
	        Assert_1.Assert.exists(w);
	        // window.location.hash returns the DECODED hash on Firefox (it's a well known bug),
	        // so any & in values will be already unescaped. This breaks our value splitting.
	        // The following trick works on all browsers.
	        var ret = '#' + (w.location.href.split('#')[1] || '');
	        return HashUtils.getAjaxcrawlableHash(ret);
	    };
	    HashUtils.getValue = function (value, toParse) {
	        Assert_1.Assert.isNonEmptyString(value);
	        Assert_1.Assert.exists(toParse);
	        toParse = HashUtils.getAjaxcrawlableHash(toParse);
	        var paramValue = HashUtils.getRawValue(value, toParse);
	        if (paramValue != undefined) {
	            paramValue = HashUtils.getValueDependingOnType(paramValue);
	        }
	        return paramValue;
	    };
	    HashUtils.encodeValues = function (values) {
	        var hash = [];
	        _.each(values, function (valueToEncode, key, obj) {
	            var encodedValue = '';
	            if (Utils_1.Utils.isNonEmptyArray(valueToEncode)) {
	                encodedValue = HashUtils.encodeArray(valueToEncode);
	            }
	            else if (_.isObject(valueToEncode) && Utils_1.Utils.isNonEmptyArray(_.keys(valueToEncode))) {
	                encodedValue = HashUtils.encodeObject(valueToEncode);
	            }
	            else {
	                encodedValue = encodeURIComponent(valueToEncode.toString());
	            }
	            if (encodedValue != '') {
	                hash.push(key + '=' + encodedValue);
	            }
	        });
	        return hash.join('&');
	    };
	    HashUtils.getAjaxcrawlableHash = function (hash) {
	        if (hash[1] != undefined && hash[1] == '!') {
	            return hash.substring(0, 1) + hash.substring(2);
	        }
	        else {
	            return hash;
	        }
	    };
	    HashUtils.getRawValue = function (value, toParse) {
	        Assert_1.Assert.exists(value);
	        Assert_1.Assert.exists(toParse);
	        Assert_1.Assert.check(toParse.indexOf('#') == 0 || toParse == '');
	        var toParseArray = toParse.substr(1).split('&');
	        var paramPos = 0;
	        var loop = true;
	        var paramValue = undefined;
	        while (loop) {
	            var paramValuePair = toParseArray[paramPos].split('=');
	            if (paramValuePair[0] == value) {
	                loop = false;
	                paramValue = paramValuePair[1];
	            }
	            else {
	                paramPos++;
	                if (paramPos >= toParseArray.length) {
	                    paramPos = undefined;
	                    loop = false;
	                }
	            }
	        }
	        return paramValue;
	    };
	    HashUtils.getValueDependingOnType = function (paramValue) {
	        var type = HashUtils.getValueType(paramValue);
	        var returnValue;
	        if (type == 'object') {
	            returnValue = HashUtils.decodeObject(paramValue);
	        }
	        else if (type == 'array') {
	            returnValue = HashUtils.decodeArray(paramValue);
	        }
	        else {
	            returnValue = decodeURIComponent(paramValue);
	        }
	        return returnValue;
	    };
	    HashUtils.getValueType = function (paramValue) {
	        if (HashUtils.isObject(paramValue)) {
	            return 'object';
	        }
	        else if (HashUtils.isArray(paramValue)) {
	            return 'array';
	        }
	        else {
	            return 'other';
	        }
	    };
	    HashUtils.isArrayStartNotEncoded = function (value) {
	        return value.substr(0, 1) == HashUtils.DELIMITER.arrayStart;
	    };
	    HashUtils.isArrayStartEncoded = function (value) {
	        return value.indexOf(encodeURIComponent(HashUtils.DELIMITER.arrayStart)) == 0;
	    };
	    HashUtils.isArrayEndNotEncoded = function (value) {
	        return value.substr(value.length - 1);
	    };
	    HashUtils.isArrayEndEncoded = function (value) {
	        return value.indexOf(encodeURIComponent(HashUtils.DELIMITER.arrayEnd)) == value.length - encodeURIComponent(HashUtils.DELIMITER.arrayEnd).length;
	    };
	    HashUtils.isObjectStartNotEncoded = function (value) {
	        return value.substr(0, 1) == HashUtils.DELIMITER.objectStart;
	    };
	    HashUtils.isObjectStartEncoded = function (value) {
	        return value.indexOf(encodeURIComponent(HashUtils.DELIMITER.objectStart)) == 0;
	    };
	    HashUtils.isObjectEndNotEncoded = function (value) {
	        return value.substr(value.length - 1) == HashUtils.DELIMITER.objectEnd;
	    };
	    HashUtils.isObjectEndEncoded = function (value) {
	        return value.indexOf(encodeURIComponent(HashUtils.DELIMITER.objectEnd)) == value.length - encodeURIComponent(HashUtils.DELIMITER.objectEnd).length;
	    };
	    HashUtils.isObject = function (value) {
	        var isObjectStart = HashUtils.isObjectStartNotEncoded(value) || HashUtils.isObjectStartEncoded(value);
	        var isObjectEnd = HashUtils.isObjectEndNotEncoded(value) || HashUtils.isObjectEndEncoded(value);
	        return isObjectStart && isObjectEnd;
	    };
	    HashUtils.isArray = function (value) {
	        var isArrayStart = HashUtils.isArrayStartNotEncoded(value) || HashUtils.isArrayStartEncoded(value);
	        var isArrayEnd = HashUtils.isArrayEndNotEncoded(value) || HashUtils.isArrayEndEncoded(value);
	        return isArrayStart && isArrayEnd;
	    };
	    HashUtils.encodeArray = function (array) {
	        var arrayReturn = _.map(array, function (value) {
	            return encodeURIComponent(value);
	        });
	        return HashUtils.DELIMITER.arrayStart + arrayReturn.join(',') + HashUtils.DELIMITER.arrayEnd;
	    };
	    HashUtils.encodeObject = function (obj) {
	        var _this = this;
	        var retArray = _.map(obj, function (val, key, obj) {
	            return "\"" + encodeURIComponent(key) + "\":" + _this.encodeValue(val);
	        });
	        return HashUtils.DELIMITER.objectStart + retArray.join(' , ') + HashUtils.DELIMITER.objectEnd;
	    };
	    HashUtils.encodeValue = function (val) {
	        var encodedValue = '';
	        if (_.isArray(val)) {
	            encodedValue = HashUtils.encodeArray(val);
	        }
	        else if (_.isObject(val)) {
	            encodedValue = HashUtils.encodeObject(val);
	        }
	        else if (_.isNumber(val) || _.isBoolean(val)) {
	            encodedValue = encodeURIComponent(val);
	        }
	        else {
	            encodedValue = '"' + encodeURIComponent(val) + '"';
	        }
	        return encodedValue;
	    };
	    HashUtils.decodeObject = function (obj) {
	        if (HashUtils.isObjectStartEncoded(obj) && HashUtils.isObjectEndEncoded(obj)) {
	            obj = obj.replace(/encodeURIComponent(HashUtils.Delimiter.objectStart)/, HashUtils.DELIMITER.objectStart);
	            obj = obj.replace(encodeURIComponent(HashUtils.DELIMITER.objectEnd), HashUtils.DELIMITER.objectEnd);
	        }
	        return JSON.parse(decodeURIComponent(obj));
	    };
	    HashUtils.decodeArray = function (value) {
	        if (HashUtils.isArrayStartEncoded(value) && HashUtils.isArrayEndEncoded(value)) {
	            value = value.replace(encodeURIComponent(HashUtils.DELIMITER.arrayStart), HashUtils.DELIMITER.arrayStart);
	            value = value.replace(encodeURIComponent(HashUtils.DELIMITER.arrayEnd), HashUtils.DELIMITER.arrayEnd);
	        }
	        value = value.substr(1);
	        value = value.substr(0, value.length - 1);
	        var array = value.split(',');
	        return _.map(array, function (val) {
	            return decodeURIComponent(val);
	        });
	    };
	    HashUtils.DELIMITER = {
	        'objectStart': '{',
	        'objectEnd': '}',
	        'arrayStart': '[',
	        'arrayEnd': ']',
	        'objectStartRegExp': '^{',
	        'objectEndRegExp': '}+$',
	        'arrayStartRegExp': '^[',
	        'arrayEndRegExp': ']+$'
	    };
	    return HashUtils;
	}());
	exports.HashUtils = HashUtils;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var Utils_1 = __webpack_require__(18);
	var Assert_1 = __webpack_require__(17);
	var StringAndHoles = (function () {
	    function StringAndHoles() {
	    }
	    StringAndHoles.replace = function (str, find, replace) {
	        var strAndHoles = new StringAndHoles();
	        if (Utils_1.Utils.isNullOrEmptyString(str)) {
	            return strAndHoles;
	        }
	        var index = str.lastIndexOf(find);
	        if (index == -1) {
	            strAndHoles.value = str;
	            return strAndHoles;
	        }
	        var holes = [];
	        while (index >= 0) {
	            var hole = {
	                begin: index,
	                size: find.length,
	                replacementSize: replace.length
	            };
	            holes.push(hole);
	            str = str.slice(0, index) + replace + str.slice(index + find.length);
	            index = str.lastIndexOf(find);
	        }
	        strAndHoles.holes = holes;
	        strAndHoles.value = str;
	        return strAndHoles;
	    };
	    /**
	     * Shorten the passed path intelligently (path-aware).
	     * Works with *local paths* and *network paths*
	     * @param uriOrig The path to shorten
	     * @param length The length to which the path will be shortened.
	     */
	    StringAndHoles.shortenPath = function (uriOrig, length) {
	        var uri = uriOrig;
	        var strAndHoles = new StringAndHoles();
	        if (Utils_1.Utils.isNullOrEmptyString(uri) || (uri.length <= length)) {
	            strAndHoles.value = uri;
	            return strAndHoles;
	        }
	        var holes = [];
	        var first = -1;
	        if (Utils_1.Utils.stringStartsWith(uri, '\\\\')) {
	            first = uri.indexOf('\\', first + 2);
	        }
	        else {
	            first = uri.indexOf('\\');
	        }
	        if (first !== -1) {
	            var removed = 0;
	            var next = uri.indexOf('\\', first + 1);
	            while (next !== -1 && uri.length - removed + StringAndHoles.SHORTEN_END.length > length) {
	                removed = next - first - 1;
	                next = uri.indexOf('\\', next + 1);
	            }
	            if (removed > 0) {
	                uri = uri.slice(0, first + 1) + StringAndHoles.SHORTEN_END + uri.slice(removed);
	                var hole = {
	                    begin: first + 1,
	                    size: removed - StringAndHoles.SHORTEN_END.length,
	                    replacementSize: StringAndHoles.SHORTEN_END.length
	                };
	                holes.push(hole);
	            }
	        }
	        if (uri.length > length) {
	            var over = uri.length - length + StringAndHoles.SHORTEN_END.length;
	            var start = uri.length - over;
	            uri = uri.slice(0, start) + StringAndHoles.SHORTEN_END;
	            var hole = {
	                begin: start,
	                size: over,
	                replacementSize: StringAndHoles.SHORTEN_END.length
	            };
	            holes.push(hole);
	        }
	        strAndHoles.holes = holes;
	        strAndHoles.value = uri;
	        return strAndHoles;
	    };
	    /**
	     * Shorten the passed string.
	     * @param toShortenOrig The string to shorten
	     * @param length The length to which the string will be shortened.
	     * @param toAppend The string to append at the end (usually, it is set to '...')
	     */
	    StringAndHoles.shortenString = function (toShortenOrig, length, toAppend) {
	        if (length === void 0) { length = 200; }
	        var toShorten = toShortenOrig;
	        toAppend = Utils_1.Utils.toNotNullString(toAppend);
	        var strAndHoles = new StringAndHoles();
	        if (Utils_1.Utils.isNullOrEmptyString(toShorten) || length <= toAppend.length) {
	            strAndHoles.value = toShorten;
	            return strAndHoles;
	        }
	        if (toShorten.length <= length) {
	            strAndHoles.value = toShorten;
	            return strAndHoles;
	        }
	        var str = toShorten;
	        length = length - toAppend.length;
	        str = str.slice(0, length);
	        if (toShorten.charAt(str.length) !== ' ') {
	            var pos = str.lastIndexOf(' ');
	            if (pos !== -1 && str.length - pos < StringAndHoles.WORD_SHORTER) {
	                str = str.slice(0, pos);
	            }
	        }
	        var holes = [];
	        holes[0] = {
	            begin: str.length,
	            size: toShorten.length - str.length,
	            replacementSize: toAppend.length
	        };
	        str += toAppend;
	        strAndHoles.value = str;
	        strAndHoles.holes = holes;
	        return strAndHoles;
	    };
	    /**
	     * Shorten the passed URI intelligently (path-aware).
	     * @param toShortenOrig The URI to shorten
	     * @param length The length to which the URI will be shortened.
	     */
	    StringAndHoles.shortenUri = function (uri, length) {
	        var strAndHoles = new StringAndHoles();
	        if (Utils_1.Utils.isNullOrEmptyString(uri) || (uri.length <= length)) {
	            strAndHoles.value = uri;
	            return strAndHoles;
	        }
	        var holes = [];
	        var first = uri.indexOf('//');
	        if (first !== -1) {
	            first = uri.indexOf('/', first + 2);
	        }
	        if (first !== -1) {
	            var removed = 0;
	            var next = uri.indexOf('/', first + 1);
	            while (next !== -1 && uri.length - removed + StringAndHoles.SHORTEN_END.length > length) {
	                removed = next - first - 1;
	                next = uri.indexOf('/', next + 1);
	            }
	            if (removed > 0) {
	                uri = uri.slice(0, first + 1) + StringAndHoles.SHORTEN_END + uri.slice(first + 1 + removed);
	                var hole = {
	                    begin: first + 1,
	                    size: removed,
	                    replacementSize: StringAndHoles.SHORTEN_END.length
	                };
	                holes.push(hole);
	            }
	        }
	        if (uri.length > length) {
	            var over = uri.length - length + StringAndHoles.SHORTEN_END.length;
	            var start = uri.length - over;
	            uri = uri.slice(0, start) + StringAndHoles.SHORTEN_END;
	            var hole = {
	                begin: start,
	                size: over,
	                replacementSize: StringAndHoles.SHORTEN_END.length
	            };
	            holes.push(hole);
	        }
	        strAndHoles.holes = holes;
	        strAndHoles.value = uri;
	        return strAndHoles;
	    };
	    StringAndHoles.SHORTEN_END = '...';
	    StringAndHoles.WORD_SHORTER = 10;
	    return StringAndHoles;
	}());
	exports.StringAndHoles = StringAndHoles;
	var HighlightUtils = (function () {
	    function HighlightUtils() {
	    }
	    /**
	     * Highlight the passed string using specified highlights and holes.
	     * @param content The string to highlight items in.
	     * @param highlights The highlighted positions to highlight in the string.
	     * @param holes Possible holes which are used to skip highlighting.
	     * @param cssClass The css class to use on the highlighting `span`.
	     */
	    HighlightUtils.highlightString = function (content, highlights, holes, cssClass) {
	        Assert_1.Assert.isNotUndefined(highlights);
	        Assert_1.Assert.isNotNull(highlights);
	        Assert_1.Assert.isNonEmptyString(cssClass);
	        if (Utils_1.Utils.isNullOrEmptyString(content)) {
	            return content;
	        }
	        var last = 0;
	        var maxIndex = content.length;
	        var highlighted = '';
	        for (var i = 0; i < highlights.length; i++) {
	            var highlight = highlights[i];
	            var start = highlight.offset;
	            var end = start + highlight.length;
	            if (holes !== null) {
	                var skip = false;
	                for (var j = 0; j < holes.length; j++) {
	                    var hole = holes[j];
	                    var holeBegin = hole.begin;
	                    var holeEnd = holeBegin + hole.size;
	                    if (start < holeBegin && end >= holeBegin && end < holeEnd) {
	                        end = holeBegin;
	                    }
	                    else if (start >= holeBegin && end < holeEnd) {
	                        skip = true;
	                        break;
	                    }
	                    else if (start >= holeBegin && start < holeEnd && end >= holeEnd) {
	                        start = holeBegin + hole.replacementSize;
	                        end -= hole.size - hole.replacementSize;
	                    }
	                    else if (start < holeBegin && end >= holeEnd) {
	                        end -= hole.size - hole.replacementSize;
	                    }
	                    else if (start >= holeEnd) {
	                        var offset = hole.size - hole.replacementSize;
	                        start -= offset;
	                        end -= offset;
	                    }
	                }
	                if (skip || start === end) {
	                    continue;
	                }
	            }
	            if (end > maxIndex) {
	                break;
	            }
	            highlighted += _.escape(content.slice(last, start));
	            highlighted += "<span class=\"" + cssClass + "\"";
	            if (highlight.dataHighlightGroup) {
	                highlighted += " data-highlight-group=\"" + highlight.dataHighlightGroup.toString() + "\"";
	            }
	            if (highlight.dataHighlightGroupTerm) {
	                highlighted += " data-highlight-group-term=\"" + highlight.dataHighlightGroupTerm + "\"";
	            }
	            highlighted += '>';
	            highlighted += _.escape(content.slice(start, end));
	            highlighted += '</span>';
	            last = end;
	        }
	        if (last != maxIndex) {
	            highlighted += _.escape(content.slice(last));
	        }
	        return highlighted;
	    };
	    return HighlightUtils;
	}());
	exports.HighlightUtils = HighlightUtils;
	function highlightString(value, search) {
	    var hightlightTemplate = _.template('<% var i = 0; var lowercaseValue = value.toLowerCase(); while(i < value.length) { %>' +
	        '<% var index = lowercaseValue.indexOf(search, i); if(index != -1) { %>' +
	        '<% if(i != index){ %> <span><%- value.substr(i, index) %></span><% } %>' +
	        '<span class="coveo-hightlight"><%- value.substr(index, search.length) %></span>' +
	        '<% i = index + search.length %></span>' +
	        '<% } else { %>' +
	        '<span><%- value.substr(i) %></span>' +
	        '<% i = value.length; %>' +
	        '<% } %>' +
	        '<% } %>');
	    if (_.isEmpty(search)) {
	        return value;
	    }
	    return hightlightTemplate({ value: value, search: search.toLowerCase() });
	}
	exports.highlightString = highlightString;
	;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var DeviceUtils_1 = __webpack_require__(20);
	var HTMLUtils = (function () {
	    function HTMLUtils() {
	    }
	    HTMLUtils.buildAttributeString = function (options) {
	        var ret = [];
	        _.each(options, function (val, key, obj) {
	            if (val != undefined) {
	                ret.push(key + '=' + JSON.stringify(val.toString()));
	            }
	        });
	        return ret.join(' ');
	    };
	    return HTMLUtils;
	}());
	exports.HTMLUtils = HTMLUtils;
	var AnchorUtils = (function () {
	    function AnchorUtils() {
	    }
	    AnchorUtils.buildAnchor = function (href, options) {
	        var text;
	        if (!options || !options.text) {
	            text = href;
	        }
	        else {
	            text = options.text;
	            options.text = undefined;
	        }
	        return "<a href='" + href + " " + HTMLUtils.buildAttributeString(options) + " '>" + text + "</a>";
	    };
	    return AnchorUtils;
	}());
	exports.AnchorUtils = AnchorUtils;
	var ImageUtils = (function () {
	    function ImageUtils() {
	    }
	    ImageUtils.buildImage = function (src, options) {
	        var ret = '<img ';
	        ret += src ? "src='" + src + "' " : '';
	        ret += HTMLUtils.buildAttributeString(options) + '/>';
	        return ret;
	    };
	    ImageUtils.selectImageFromResult = function (result) {
	        return document.querySelector("img[data-coveo-uri-hash=" + result.raw['urihash'] + "]");
	    };
	    ImageUtils.buildImageWithDirectSrcAttribute = function (endpoint, result) {
	        var image = new Image();
	        var dataStreamUri = endpoint.getViewAsDatastreamUri(result.uniqueId, '$Thumbnail$', { contentType: 'image/png' });
	        image.onload = function () {
	            ImageUtils.selectImageFromResult(result).setAttribute('src', dataStreamUri);
	        };
	        image.src = dataStreamUri;
	    };
	    ImageUtils.buildImageWithBase64SrcAttribute = function (endpoint, result) {
	        endpoint.getRawDataStream(result.uniqueId, '$Thumbnail$')
	            .then(function (response) {
	            var rawBinary = String.fromCharCode.apply(null, new Uint8Array(response));
	            ImageUtils.selectImageFromResult(result).setAttribute('src', 'data:image/png;base64, ' + btoa(rawBinary));
	        })
	            .catch(function () {
	            ImageUtils.selectImageFromResult(result).remove();
	        });
	    };
	    ImageUtils.buildImageFromResult = function (result, endpoint, options) {
	        options = options ? options : {};
	        var img = ImageUtils.buildImage(undefined, _.extend(options, { 'data-coveo-uri-hash': result.raw['urihash'] }));
	        if (endpoint.isJsonp() || DeviceUtils_1.DeviceUtils.isIE8or9()) {
	            // For jsonp and IE8-9 (XDomain) we can't GET/POST for binary data. We are limited to only setting the src attribute directly on the img.
	            ImageUtils.buildImageWithDirectSrcAttribute(endpoint, result);
	        }
	        else {
	            // Base 64 img allows us to GET/POST the image as raw binary, so that we can also pass the credential of the user
	            // Useful for phonegap.
	            ImageUtils.buildImageWithBase64SrcAttribute(endpoint, result);
	        }
	        return img;
	    };
	    return ImageUtils;
	}());
	exports.ImageUtils = ImageUtils;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var Utils_1 = __webpack_require__(18);
	(function (KEYBOARD) {
	    KEYBOARD[KEYBOARD["BACKSPACE"] = 8] = "BACKSPACE";
	    KEYBOARD[KEYBOARD["TAB"] = 9] = "TAB";
	    KEYBOARD[KEYBOARD["ENTER"] = 13] = "ENTER";
	    KEYBOARD[KEYBOARD["SHIFT"] = 16] = "SHIFT";
	    KEYBOARD[KEYBOARD["CTRL"] = 17] = "CTRL";
	    KEYBOARD[KEYBOARD["ALT"] = 18] = "ALT";
	    KEYBOARD[KEYBOARD["ESCAPE"] = 27] = "ESCAPE";
	    KEYBOARD[KEYBOARD["SPACEBAR"] = 32] = "SPACEBAR";
	    KEYBOARD[KEYBOARD["PAGE_UP"] = 33] = "PAGE_UP";
	    KEYBOARD[KEYBOARD["PAGE_DOWN"] = 34] = "PAGE_DOWN";
	    KEYBOARD[KEYBOARD["HOME"] = 36] = "HOME";
	    KEYBOARD[KEYBOARD["LEFT_ARROW"] = 37] = "LEFT_ARROW";
	    KEYBOARD[KEYBOARD["UP_ARROW"] = 38] = "UP_ARROW";
	    KEYBOARD[KEYBOARD["RIGHT_ARROW"] = 39] = "RIGHT_ARROW";
	    KEYBOARD[KEYBOARD["DOWN_ARROW"] = 40] = "DOWN_ARROW";
	    KEYBOARD[KEYBOARD["INSERT"] = 45] = "INSERT";
	    KEYBOARD[KEYBOARD["DELETE"] = 46] = "DELETE";
	})(exports.KEYBOARD || (exports.KEYBOARD = {}));
	var KEYBOARD = exports.KEYBOARD;
	var KeyboardUtils = (function () {
	    function KeyboardUtils() {
	    }
	    KeyboardUtils.keysEqual = function (key, code) {
	        if (!Utils_1.Utils.isNullOrUndefined(key.keyCode)) {
	            return key.keyCode == code;
	        }
	        else if (!Utils_1.Utils.isNullOrUndefined(key.which)) {
	            return key.which == code;
	        }
	        return false;
	    };
	    KeyboardUtils.isAllowedKeyForOmnibox = function (e) {
	        var keycode = e.keyCode;
	        var valid = (KeyboardUtils.isNumberKeyPushed(keycode)) ||
	            (keycode == 32 || keycode == 13) ||
	            (KeyboardUtils.isLetterKeyPushed(keycode)) ||
	            (keycode > 95 && keycode < 112) ||
	            (keycode > 185 && keycode < 193) ||
	            (keycode > 218 && keycode < 223) ||
	            (keycode == KEYBOARD.BACKSPACE || keycode == KEYBOARD.DELETE) ||
	            (KeyboardUtils.isArrowKeyPushed(keycode));
	        return valid;
	    };
	    KeyboardUtils.isAllowedKeyForSearchAsYouType = function (e) {
	        return KeyboardUtils.isAllowedKeyForOmnibox(e) && !KeyboardUtils.isArrowKeyPushed(e.keyCode);
	    };
	    KeyboardUtils.isDeleteOrBackspace = function (e) {
	        return KeyboardUtils.keysEqual(e, KEYBOARD.BACKSPACE) || KeyboardUtils.keysEqual(e, KEYBOARD.DELETE);
	    };
	    KeyboardUtils.isArrowKeyPushed = function (keycode) {
	        return keycode == KEYBOARD.LEFT_ARROW ||
	            keycode == KEYBOARD.UP_ARROW ||
	            keycode == KEYBOARD.RIGHT_ARROW ||
	            keycode == KEYBOARD.DOWN_ARROW;
	    };
	    KeyboardUtils.isNumberKeyPushed = function (keycode) {
	        return keycode > 47 && keycode < 58;
	    };
	    KeyboardUtils.isLetterKeyPushed = function (keycode) {
	        return keycode > 64 && keycode < 91;
	    };
	    // Return a keyboard event listener that only executes the function if certain keys are pressed.
	    KeyboardUtils.keypressAction = function (keyCode, action) {
	        return function (e) {
	            var data = [];
	            for (var _i = 1; _i < arguments.length; _i++) {
	                data[_i - 1] = arguments[_i];
	            }
	            var eventCode = (e.charCode || e.keyCode);
	            if (_.isArray(keyCode) && _.contains(keyCode, eventCode)) {
	                action(e);
	            }
	            else if (eventCode === keyCode) {
	                action(e);
	            }
	            return false;
	        };
	    };
	    return KeyboardUtils;
	}());
	exports.KeyboardUtils = KeyboardUtils;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 69 */
/***/ function(module, exports) {

	"use strict";
	var localStorage = window.localStorage;
	var LocalStorageUtils = (function () {
	    function LocalStorageUtils(id) {
	        this.id = id;
	    }
	    LocalStorageUtils.prototype.save = function (data) {
	        try {
	            if (localStorage != null) {
	                localStorage.setItem(this.getLocalStorageKey(), JSON.stringify(data));
	            }
	        }
	        catch (error) {
	        }
	    };
	    LocalStorageUtils.prototype.load = function () {
	        try {
	            if (localStorage == null) {
	                return null;
	            }
	            var value = localStorage.getItem(this.getLocalStorageKey());
	            return value && JSON.parse(value);
	        }
	        catch (error) {
	            return null;
	        }
	    };
	    LocalStorageUtils.prototype.remove = function (key) {
	        try {
	            if (localStorage != null) {
	                if (key == undefined) {
	                    localStorage.removeItem(this.getLocalStorageKey());
	                }
	                else {
	                    var oldObj = this.load();
	                    delete oldObj[key];
	                    this.save(oldObj);
	                }
	            }
	        }
	        catch (error) {
	        }
	    };
	    LocalStorageUtils.prototype.getLocalStorageKey = function () {
	        return 'coveo-' + this.id;
	    };
	    return LocalStorageUtils;
	}());
	exports.LocalStorageUtils = LocalStorageUtils;


/***/ },
/* 70 */
/***/ function(module, exports) {

	"use strict";
	(function (OS_NAME) {
	    OS_NAME[OS_NAME["WINDOWS"] = 0] = "WINDOWS";
	    OS_NAME[OS_NAME["MACOSX"] = 1] = "MACOSX";
	    OS_NAME[OS_NAME["UNIX"] = 2] = "UNIX";
	    OS_NAME[OS_NAME["LINUX"] = 3] = "LINUX";
	    OS_NAME[OS_NAME["UNKNOWN"] = 4] = "UNKNOWN";
	})(exports.OS_NAME || (exports.OS_NAME = {}));
	var OS_NAME = exports.OS_NAME;
	var OSUtils = (function () {
	    function OSUtils() {
	    }
	    OSUtils.get = function (nav) {
	        if (nav === void 0) { nav = navigator; }
	        var osName;
	        if (nav.appVersion.indexOf('Win') != -1) {
	            osName = OS_NAME.WINDOWS;
	        }
	        else if (nav.appVersion.indexOf('Mac') != -1) {
	            osName = OS_NAME.MACOSX;
	        }
	        else if (nav.appVersion.indexOf('X11') != -1) {
	            osName = OS_NAME.UNIX;
	        }
	        else if (nav.appVersion.indexOf('Linux') != -1) {
	            osName = OS_NAME.LINUX;
	        }
	        else {
	            osName = OS_NAME.UNKNOWN;
	        }
	        return osName;
	    };
	    return OSUtils;
	}());
	exports.OSUtils = OSUtils;


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var Dom_1 = __webpack_require__(57);
	(function (VerticalAlignment) {
	    VerticalAlignment[VerticalAlignment["TOP"] = 0] = "TOP";
	    VerticalAlignment[VerticalAlignment["MIDDLE"] = 1] = "MIDDLE";
	    VerticalAlignment[VerticalAlignment["BOTTOM"] = 2] = "BOTTOM";
	    VerticalAlignment[VerticalAlignment["INNERTOP"] = 3] = "INNERTOP";
	    VerticalAlignment[VerticalAlignment["INNERBOTTOM"] = 4] = "INNERBOTTOM";
	})(exports.VerticalAlignment || (exports.VerticalAlignment = {}));
	var VerticalAlignment = exports.VerticalAlignment;
	(function (HorizontalAlignment) {
	    HorizontalAlignment[HorizontalAlignment["LEFT"] = 0] = "LEFT";
	    HorizontalAlignment[HorizontalAlignment["CENTER"] = 1] = "CENTER";
	    HorizontalAlignment[HorizontalAlignment["RIGHT"] = 2] = "RIGHT";
	    HorizontalAlignment[HorizontalAlignment["INNERLEFT"] = 3] = "INNERLEFT";
	    HorizontalAlignment[HorizontalAlignment["INNERRIGHT"] = 4] = "INNERRIGHT";
	})(exports.HorizontalAlignment || (exports.HorizontalAlignment = {}));
	var HorizontalAlignment = exports.HorizontalAlignment;
	var PopupUtils = (function () {
	    function PopupUtils() {
	    }
	    PopupUtils.positionPopup = function (popUp, nextTo, boundary, desiredPosition, appendTo, checkForBoundary) {
	        if (checkForBoundary === void 0) { checkForBoundary = 0; }
	        popUp.style.position = 'absolute';
	        if (appendTo) {
	            Dom_1.$$(appendTo).append(popUp);
	        }
	        desiredPosition.verticalOffset = desiredPosition.verticalOffset ? desiredPosition.verticalOffset : 0;
	        desiredPosition.horizontalOffset = desiredPosition.horizontalOffset ? desiredPosition.horizontalOffset : 0;
	        var popUpPosition = Dom_1.$$(nextTo).offset();
	        PopupUtils.basicVerticalAlignment(popUpPosition, popUp, nextTo, desiredPosition);
	        PopupUtils.basicHorizontalAlignment(popUpPosition, popUp, nextTo, desiredPosition);
	        PopupUtils.finalAdjustement(Dom_1.$$(popUp).offset(), popUpPosition, popUp, desiredPosition);
	        var popUpBoundary = PopupUtils.getBoundary(popUp);
	        var boundaryPosition = PopupUtils.getBoundary(boundary);
	        if (checkForBoundary < 2) {
	            var checkBoundary = PopupUtils.checkForOutOfBoundary(popUpBoundary, boundaryPosition);
	            if (checkBoundary.horizontal != 'ok' && desiredPosition.horizontalClip === true) {
	                var width = popUp.offsetWidth;
	                if (popUpBoundary.left < boundaryPosition.left) {
	                    width -= boundaryPosition.left - popUpBoundary.left;
	                }
	                if (popUpBoundary.right > boundaryPosition.right) {
	                    width -= popUpBoundary.right - boundaryPosition.right;
	                }
	                popUp.style.width = width + 'px';
	                checkBoundary.horizontal = 'ok';
	            }
	            if (checkBoundary.vertical != 'ok' || checkBoundary.horizontal != 'ok') {
	                var newDesiredPosition = PopupUtils.alignInsideBoundary(desiredPosition, checkBoundary);
	                PopupUtils.positionPopup(popUp, nextTo, boundary, newDesiredPosition, appendTo, checkForBoundary + 1);
	            }
	        }
	    };
	    PopupUtils.finalAdjustement = function (popUpOffSet, popUpPosition, popUp, desiredPosition) {
	        var position = Dom_1.$$(popUp).position();
	        popUp.style.top = (position.top + desiredPosition.verticalOffset) - (popUpOffSet.top - popUpPosition.top) + 'px';
	        popUp.style.left = (position.left + desiredPosition.horizontalOffset) - (popUpOffSet.left - popUpPosition.left) + 'px';
	    };
	    PopupUtils.basicVerticalAlignment = function (popUpPosition, popUp, nextTo, desiredPosition) {
	        switch (desiredPosition.vertical) {
	            case VerticalAlignment.TOP:
	                popUpPosition.top -= popUp.offsetHeight;
	                break;
	            case VerticalAlignment.BOTTOM:
	                popUpPosition.top += nextTo.offsetHeight;
	                break;
	            case VerticalAlignment.MIDDLE:
	                popUpPosition.top -= popUp.offsetHeight / 3;
	            case VerticalAlignment.INNERTOP:
	                break; // Nothing to do, it's the default alignment normally
	            case VerticalAlignment.INNERBOTTOM:
	                popUpPosition.top -= popUp.offsetHeight - nextTo.offsetHeight;
	                break;
	            default:
	                break;
	        }
	    };
	    PopupUtils.basicHorizontalAlignment = function (popUpPosition, popUp, nextTo, desiredPosition) {
	        switch (desiredPosition.horizontal) {
	            case HorizontalAlignment.LEFT:
	                popUpPosition.left -= popUp.offsetWidth;
	                break;
	            case HorizontalAlignment.RIGHT:
	                popUpPosition.left += nextTo.offsetWidth;
	                break;
	            case HorizontalAlignment.CENTER:
	                popUpPosition.left += PopupUtils.offSetToAlignCenter(popUp, nextTo);
	                break;
	            case HorizontalAlignment.INNERLEFT:
	                break; // Nothing to do, it's the default alignment normally
	            case HorizontalAlignment.INNERRIGHT:
	                popUpPosition.left -= popUp.offsetWidth - nextTo.offsetWidth;
	                break;
	            default:
	                break;
	        }
	    };
	    PopupUtils.alignInsideBoundary = function (oldPosition, checkBoundary) {
	        var newDesiredPosition = oldPosition;
	        if (checkBoundary.horizontal == 'left') {
	            newDesiredPosition.horizontal = HorizontalAlignment.RIGHT;
	        }
	        if (checkBoundary.horizontal == 'right') {
	            newDesiredPosition.horizontal = HorizontalAlignment.LEFT;
	        }
	        if (checkBoundary.vertical == 'top') {
	            newDesiredPosition.vertical = VerticalAlignment.BOTTOM;
	        }
	        if (checkBoundary.vertical == 'bottom') {
	            newDesiredPosition.vertical = VerticalAlignment.TOP;
	        }
	        return newDesiredPosition;
	    };
	    PopupUtils.offSetToAlignCenter = function (popUp, nextTo) {
	        return (nextTo.offsetWidth - popUp.offsetWidth) / 2;
	    };
	    PopupUtils.getBoundary = function (element) {
	        var boundaryOffset = Dom_1.$$(element).offset();
	        var toAddVertically;
	        if (element.tagName.toLowerCase() == 'body') {
	            toAddVertically = Math.max(element.scrollHeight, element.offsetHeight);
	        }
	        else if (element.tagName.toLowerCase() == 'html') {
	            toAddVertically = Math.max(element.clientHeight, element.scrollHeight, element.offsetHeight);
	        }
	        else {
	            toAddVertically = element.offsetHeight;
	        }
	        return {
	            top: boundaryOffset.top,
	            left: boundaryOffset.left,
	            right: boundaryOffset.left + element.offsetWidth,
	            bottom: boundaryOffset.top + toAddVertically
	        };
	    };
	    PopupUtils.checkForOutOfBoundary = function (popUpBoundary, boundary) {
	        var ret = {
	            vertical: 'ok',
	            horizontal: 'ok'
	        };
	        if (popUpBoundary.top < boundary.top) {
	            ret.vertical = 'top';
	        }
	        if (popUpBoundary.bottom > boundary.bottom) {
	            ret.vertical = 'bottom';
	        }
	        if (popUpBoundary.left < boundary.left) {
	            ret.horizontal = 'left';
	        }
	        if (popUpBoundary.right > boundary.right) {
	            ret.horizontal = 'right';
	        }
	        return ret;
	    };
	    return PopupUtils;
	}());
	exports.PopupUtils = PopupUtils;


/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Options_1 = __webpack_require__(33);
	var HighlightUtils_1 = __webpack_require__(66);
	var StringUtils_1 = __webpack_require__(61);
	var Utils_1 = __webpack_require__(18);
	var Dom_1 = __webpack_require__(57);
	// \u2011: http://graphemica.com/%E2%80%91
	var nonWordBoundary = '[\\.\\-\\u2011\\s~=,.\\|\\/:\'`’;_()!?]';
	var regexStart = '(' + nonWordBoundary + '|^)(';
	var DefaultStreamHighlightOptions = (function (_super) {
	    __extends(DefaultStreamHighlightOptions, _super);
	    function DefaultStreamHighlightOptions(cssClass, shorten, regexFlags) {
	        if (cssClass === void 0) { cssClass = 'coveo-highlight'; }
	        if (shorten === void 0) { shorten = 0; }
	        if (regexFlags === void 0) { regexFlags = 'gi'; }
	        _super.call(this);
	        this.cssClass = cssClass;
	        this.shorten = shorten;
	        this.regexFlags = regexFlags;
	    }
	    return DefaultStreamHighlightOptions;
	}(Options_1.Options));
	var StreamHighlightUtils = (function () {
	    function StreamHighlightUtils() {
	    }
	    StreamHighlightUtils.highlightStreamHTML = function (stream, termsToHighlight, phrasesToHighlight, options) {
	        var opts = new DefaultStreamHighlightOptions().merge(options);
	        var container = createStreamHTMLContainer(stream);
	        _.each(Dom_1.$$(container).findAll('*'), function (elem, i) {
	            var text = Dom_1.$$(elem).text();
	            elem.innerHTML = HighlightUtils_1.HighlightUtils.highlightString(text, getRestHighlightsForAllTerms(text, termsToHighlight, phrasesToHighlight, opts), [], opts.cssClass);
	        });
	        return container.innerHTML;
	    };
	    StreamHighlightUtils.highlightStreamText = function (stream, termsToHighlight, phrasesToHighlight, options) {
	        var opts = new DefaultStreamHighlightOptions().merge(options);
	        return HighlightUtils_1.HighlightUtils.highlightString(stream, getRestHighlightsForAllTerms(stream, termsToHighlight, phrasesToHighlight, opts), [], opts.cssClass);
	    };
	    return StreamHighlightUtils;
	}());
	exports.StreamHighlightUtils = StreamHighlightUtils;
	function getRestHighlightsForAllTerms(toHighlight, termsToHighlight, phrasesToHighlight, opts) {
	    var indexes = [];
	    var sortedTerms = _.keys(termsToHighlight).sort(termsSorting);
	    _.each(sortedTerms, function (term) {
	        var termsToIterate = _.compact([term].concat(termsToHighlight[term]).sort(termsSorting));
	        var regex = regexStart;
	        regex += termsToIterate.join('|') + ')(?=(?:' + nonWordBoundary + '|$)+)';
	        var indexesFound = StringUtils_1.StringUtils.getHighlights(toHighlight, new RegExp(regex, opts.regexFlags), term);
	        if (indexesFound != undefined && Utils_1.Utils.isNonEmptyArray(indexesFound)) {
	            indexes.push(indexesFound);
	        }
	    });
	    _.each(phrasesToHighlight, function (phrase, origPhrase) {
	        var split = origPhrase.split(' ');
	        var regex = regexStart;
	        _.each(split, function (origWord, i) {
	            regex += '(?:' + [origWord].concat(phrase[origWord]).join('|') + ')';
	            if (i == split.length - 1) {
	                regex += '(?=';
	            }
	            regex += nonWordBoundary;
	            if (i == split.length - 1) {
	                regex += ')';
	            }
	            if (i != split.length - 1) {
	                regex += '+';
	            }
	        });
	        regex += ')';
	        var indexesFound = StringUtils_1.StringUtils.getHighlights(toHighlight, new RegExp(regex, opts.regexFlags), origPhrase);
	        if (indexesFound != undefined && Utils_1.Utils.isNonEmptyArray(indexesFound)) {
	            indexes.push(indexesFound);
	        }
	    });
	    return _.chain(indexes)
	        .flatten()
	        .compact()
	        .uniq(function (highlight) {
	        return highlight.offset;
	    })
	        .sortBy(function (highlight) {
	        return highlight.offset;
	    })
	        .map(function (highlight) {
	        var keysFromTerms = _.keys(termsToHighlight);
	        var keysFromPhrases = _.keys(phrasesToHighlight);
	        var keys = keysFromTerms.concat(keysFromPhrases);
	        var group = _.indexOf(keys, highlight.dataHighlightGroupTerm) + 1;
	        return _.extend(highlight, { dataHighlightGroup: group });
	    })
	        .value();
	}
	function termsSorting(first, second) {
	    return first.length - second.length;
	}
	function createStreamHTMLContainer(stream) {
	    var container = Dom_1.$$('div').el;
	    container.innerHTML = stream;
	    return container;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var QueryController_1 = __webpack_require__(74);
	exports.QueryController = QueryController_1.QueryController;
	var FacetQueryController_1 = __webpack_require__(80);
	exports.FacetQueryController = FacetQueryController_1.FacetQueryController;
	var FacetRangeQueryController_1 = __webpack_require__(83);
	exports.FacetRangeQueryController = FacetRangeQueryController_1.FacetRangeQueryController;
	var FacetSliderQueryController_1 = __webpack_require__(84);
	exports.FacetSliderQueryController = FacetSliderQueryController_1.FacetSliderQueryController;
	var HierarchicalFacetQueryController_1 = __webpack_require__(85);
	exports.HierarchicalFacetQueryController = HierarchicalFacetQueryController_1.HierarchicalFacetQueryController;
	var HistoryController_1 = __webpack_require__(86);
	exports.HistoryController = HistoryController_1.HistoryController;
	var LocalStorageHistoryController_1 = __webpack_require__(88);
	exports.LocalStorageHistoryController = LocalStorageHistoryController_1.LocalStorageHistoryController;


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var RootComponent_1 = __webpack_require__(75);
	var QueryBuilder_1 = __webpack_require__(77);
	var LocalStorageUtils_1 = __webpack_require__(69);
	var Assert_1 = __webpack_require__(17);
	var SearchEndpointWithDefaultCallOptions_1 = __webpack_require__(79);
	var QueryEvents_1 = __webpack_require__(47);
	var QueryUtils_1 = __webpack_require__(23);
	var Defer_1 = __webpack_require__(31);
	var Dom_1 = __webpack_require__(57);
	var Utils_1 = __webpack_require__(18);
	var es6_promise_1 = __webpack_require__(7);
	var BaseComponent_1 = __webpack_require__(76);
	var ExternalModulesShim_1 = __webpack_require__(25);
	var DefaultQueryOptions = (function () {
	    function DefaultQueryOptions() {
	        this.searchAsYouType = false;
	        this.closeModalBox = true;
	        this.cancel = false;
	        this.logInActionsHistory = false;
	    }
	    return DefaultQueryOptions;
	}());
	/**
	 * This class is automatically instantiated and bound to the root of your search interface when you initialize the framework.<br/>
	 * It is essentially a singleton that wraps the access to the {@link SearchEndpoint} endpoint to execute query, and is in charge of triggering the different query events.<br/>
	 * This is what every component of the framework uses internally to execute query or access the endpoint.<br/>
	 * When calling <code>Coveo.executeQuery</code> this class is used.
	 */
	var QueryController = (function (_super) {
	    __extends(QueryController, _super);
	    /**
	     * Create a new query controller
	     * @param element
	     * @param options
	     */
	    function QueryController(element, options, usageAnalytics, searchInterface) {
	        _super.call(this, element, QueryController.ID);
	        this.options = options;
	        this.usageAnalytics = usageAnalytics;
	        this.searchInterface = searchInterface;
	        this.showingExecutingQueryAnimation = false;
	        this.localStorage = new LocalStorageUtils_1.LocalStorageUtils('lastQueryHash');
	        Assert_1.Assert.exists(element);
	        Assert_1.Assert.exists(options);
	        this.firstQuery = true;
	    }
	    /**
	     * Set the {@link SearchEndpoint} that the query controller should use to execute query
	     * @param endpoint
	     */
	    QueryController.prototype.setEndpoint = function (endpoint) {
	        this.overrideEndpoint = endpoint;
	        this.logger.debug('Endpoint set', endpoint);
	    };
	    /**
	     * Get the {@link SearchEndpoint} that is currently used by the query controller to execute query
	     * @returns {SearchEndpoint}
	     */
	    QueryController.prototype.getEndpoint = function () {
	        var endpoint = this.overrideEndpoint || this.options.endpoint;
	        // We must wrap the endpoint in a decorator that'll add the call options
	        // we obtain by firing the proper event. Those are used for authentication
	        // providers, and I guess other stuff later on.
	        return new SearchEndpointWithDefaultCallOptions_1.SearchEndpointWithDefaultCallOptions(endpoint, this.getCallOptions());
	    };
	    /**
	     * Return the last query that was performed by the query controller
	     * @returns {IQuery|Query}
	     */
	    QueryController.prototype.getLastQuery = function () {
	        return this.lastQuery || new QueryBuilder_1.QueryBuilder().build();
	    };
	    /**
	     * Execute a query and return a Promise of IQueryResults.<br/>
	     * This will execute the normal query flow, triggering all the necessary query events (newQuery <br/>
	     * All components present in the interface will act accordingly (modify the query and render results if needed).
	     * @param options
	     * @returns {Promise<IQueryResults>}
	     */
	    QueryController.prototype.executeQuery = function (options) {
	        var _this = this;
	        options = _.extend(new DefaultQueryOptions(), options);
	        if (options.closeModalBox) {
	            ExternalModulesShim_1.ModalBox.close(true);
	        }
	        this.logger.debug('Executing new query');
	        this.cancelAnyCurrentPendingQuery();
	        if (options.beforeExecuteQuery != null) {
	            options.beforeExecuteQuery();
	        }
	        if (!options.ignoreWarningSearchEvent) {
	            this.usageAnalytics.warnAboutSearchEvent();
	        }
	        this.showExecutingQueryAnimation();
	        var dataToSendOnNewQuery = {
	            searchAsYouType: options.searchAsYouType,
	            cancel: options.cancel,
	            origin: options.origin
	        };
	        this.newQueryEvent(dataToSendOnNewQuery);
	        if (dataToSendOnNewQuery.cancel) {
	            this.cancelQuery();
	            return;
	        }
	        var queryBuilder = this.createQueryBuilder(options);
	        // The query was canceled
	        if (!queryBuilder) {
	            return;
	        }
	        var query = queryBuilder.build();
	        if (options.logInActionsHistory) {
	            this.logQueryInActionsHistory(query, options.isFirstQuery);
	        }
	        var endpointToUse = this.getEndpoint();
	        var promise = this.currentPendingQuery = endpointToUse.search(query);
	        promise.then(function (queryResults) {
	            Assert_1.Assert.exists(queryResults);
	            var firstQuery = _this.firstQuery;
	            if (_this.firstQuery) {
	                _this.firstQuery = false;
	            }
	            // If our promise is no longer the current one, then the query
	            // has been cancel. We should do nothing here.
	            if (promise !== _this.currentPendingQuery) {
	                return;
	            }
	            _this.logger.debug('Query results received', query, queryResults);
	            var enableHistory = _this.searchInterface && _this.searchInterface.options && _this.searchInterface.options.enableHistory;
	            if ((!firstQuery || enableHistory) && _this.keepLastSearchUid(query, queryResults)) {
	                queryResults.searchUid = _this.getLastSearchUid();
	                queryResults._reusedSearchUid = true;
	                QueryUtils_1.QueryUtils.setPropertyOnResults(queryResults, 'queryUid', _this.getLastSearchUid());
	            }
	            else {
	                _this.lastQueryHash = _this.queryHash(query, queryResults);
	                _this.lastSearchUid = queryResults.searchUid;
	            }
	            _this.lastQuery = query;
	            _this.lastQueryResults = queryResults;
	            _this.currentError = null;
	            var dataToSendOnPreprocessResult = {
	                queryBuilder: queryBuilder,
	                query: query,
	                results: queryResults,
	                searchAsYouType: options.searchAsYouType
	            };
	            _this.preprocessResultsEvent(dataToSendOnPreprocessResult);
	            var dataToSendOnNoResult = {
	                queryBuilder: queryBuilder,
	                query: query,
	                results: queryResults,
	                searchAsYouType: options.searchAsYouType,
	                retryTheQuery: false
	            };
	            if (queryResults.results.length == 0) {
	                _this.noResultEvent(dataToSendOnNoResult);
	            }
	            if (dataToSendOnNoResult.retryTheQuery) {
	                // When retrying the query, we must forward the results to the deferred we
	                // initially returned, in case someone is listening on it.
	                return _this.executeQuery();
	            }
	            else {
	                _this.lastQueryBuilder = queryBuilder;
	                _this.currentPendingQuery = undefined;
	                var dataToSendOnSuccess_1 = {
	                    queryBuilder: queryBuilder,
	                    query: query,
	                    results: queryResults,
	                    searchAsYouType: options.searchAsYouType
	                };
	                _this.querySuccessEvent(dataToSendOnSuccess_1);
	                Defer_1.Defer.defer(function () {
	                    _this.deferredQuerySuccessEvent(dataToSendOnSuccess_1);
	                    _this.hideExecutingQueryAnimation();
	                });
	                return queryResults;
	            }
	        }).catch(function (error) {
	            // If our deferred is no longer the current one, then the query
	            // has been cancel. We should do nothing here.
	            if (promise !== _this.currentPendingQuery) {
	                return;
	            }
	            _this.logger.error('Query triggered an error', query, error);
	            // this.currentPendingQuery.reject(error);
	            _this.currentPendingQuery = undefined;
	            var dataToSendOnError = {
	                queryBuilder: queryBuilder,
	                endpoint: endpointToUse,
	                query: query,
	                error: error,
	                searchAsYouType: options.searchAsYouType
	            };
	            _this.lastQuery = query;
	            _this.lastQueryResults = null;
	            _this.currentError = error;
	            _this.queryError(dataToSendOnError);
	            _this.hideExecutingQueryAnimation();
	        });
	        var dataToSendDuringQuery = {
	            queryBuilder: queryBuilder,
	            query: query,
	            searchAsYouType: options.searchAsYouType,
	            promise: promise
	        };
	        this.duringQueryEvent(dataToSendDuringQuery);
	        return this.currentPendingQuery;
	    };
	    /**
	     * Using the same parameters as the last successful query, fetch another batch of results. Particularly useful for infinite scrolling, for example.
	     * @param count
	     * @returns {any}
	     */
	    QueryController.prototype.fetchMore = function (count) {
	        var _this = this;
	        if (this.currentPendingQuery != undefined) {
	            return undefined;
	        }
	        // Send all pending events (think : search as you type)
	        // This allows us to get the real search id for the results when the query returns
	        this.usageAnalytics.sendAllPendingEvents();
	        var queryBuilder = new QueryBuilder_1.QueryBuilder();
	        this.continueLastQueryBuilder(queryBuilder, count);
	        var query = queryBuilder.build();
	        var endpointToUse = this.getEndpoint();
	        var promise = this.currentPendingQuery = endpointToUse.search(query);
	        var dataToSendDuringQuery = {
	            queryBuilder: queryBuilder,
	            query: query,
	            searchAsYouType: false,
	            promise: promise
	        };
	        Dom_1.$$(this.element).trigger(QueryEvents_1.QueryEvents.duringFetchMoreQuery, dataToSendDuringQuery);
	        this.lastQueryBuilder = queryBuilder;
	        this.lastQuery = query;
	        promise.then(function (results) {
	            // We re-use the search id from the initial search here, even though the
	            // server provided us with a new one. 'Fetch mores' are considered to be
	            // the same query from an analytics point of view.
	            _this.currentPendingQuery = undefined;
	            if (_this.lastQueryResults == null) {
	                _this.lastQueryResults = results;
	            }
	            else {
	                _.forEach(results.results, function (result) {
	                    _this.lastQueryResults.results.push(result);
	                });
	            }
	            var dataToSendOnPreprocessResult = {
	                queryBuilder: queryBuilder,
	                query: query,
	                results: results,
	                searchAsYouType: false
	            };
	            _this.preprocessResultsEvent(dataToSendOnPreprocessResult);
	            QueryUtils_1.QueryUtils.setIndexAndUidOnQueryResults(query, results, _this.getLastSearchUid(), results.pipeline, results.splitTestRun);
	            var dataToSendOnFetchMoreSuccess = {
	                query: query,
	                results: results,
	                queryBuilder: queryBuilder,
	                searchAsYouType: false
	            };
	            _this.fetchMoreSuccessEvent(dataToSendOnFetchMoreSuccess);
	        });
	        return this.currentPendingQuery;
	    };
	    /**
	     * Cancel any pending query
	     */
	    QueryController.prototype.cancelQuery = function () {
	        this.cancelAnyCurrentPendingQuery();
	        this.hideExecutingQueryAnimation();
	    };
	    QueryController.prototype.deferExecuteQuery = function (options) {
	        var _this = this;
	        this.showExecutingQueryAnimation();
	        Defer_1.Defer.defer(function () { return _this.executeQuery(options); });
	    };
	    QueryController.prototype.ensureCreatedQueryBuilder = function () {
	        if (!this.createdOneQueryBuilder) {
	            this.createQueryBuilder(new DefaultQueryOptions());
	        }
	    };
	    QueryController.prototype.createQueryBuilder = function (options) {
	        Assert_1.Assert.exists(options);
	        this.createdOneQueryBuilder = true;
	        var queryBuilder = new QueryBuilder_1.QueryBuilder();
	        // Default values, components will probably override them if they exists
	        queryBuilder.language = String['locale'];
	        queryBuilder.firstResult = queryBuilder.firstResult || 0;
	        // Allow outside code to customize the query builder. We provide two events,
	        // to allow someone to have a peep at the query builder after the first phase
	        // and add some stuff depending on what was put in there. The facets are using
	        // this mechanism to generate query overrides.
	        var dataToSendDuringBuildingQuery = {
	            queryBuilder: queryBuilder,
	            searchAsYouType: options.searchAsYouType,
	            cancel: options.cancel
	        };
	        this.buildingQueryEvent(dataToSendDuringBuildingQuery);
	        var dataToSendDuringDoneBuildingQuery = {
	            queryBuilder: queryBuilder,
	            searchAsYouType: options.searchAsYouType,
	            cancel: options.cancel
	        };
	        this.doneBuildingQueryEvent(dataToSendDuringDoneBuildingQuery);
	        if (dataToSendDuringBuildingQuery.cancel || dataToSendDuringDoneBuildingQuery.cancel) {
	            this.cancelQuery();
	            return;
	        }
	        var pipeline = this.getPipelineInUrl();
	        if (pipeline) {
	            queryBuilder.pipeline = pipeline;
	        }
	        return queryBuilder;
	    };
	    QueryController.prototype.isStandaloneSearchbox = function () {
	        return Utils_1.Utils.isNonEmptyString(this.options.searchPageUri);
	    };
	    QueryController.prototype.saveLastQuery = function () {
	        this.localStorage.save({
	            expire: new Date().getTime() + 1000 * 60 * 30,
	            hash: this.lastQueryHash,
	            uid: this.lastSearchUid
	        });
	    };
	    // This field is exposed for components rendered in the results or on-demand which
	    // need access to the entire query. For example, the QuickviewDocument need to pass
	    // the entire query to the Search API. For other components, QueryStateModel or
	    // listening to events like 'doneBuildingQuery' is the way to go.
	    QueryController.prototype.getLastQueryHash = function () {
	        if (this.lastQueryHash != null) {
	            return this.lastQueryHash;
	        }
	        this.loadLastQueryHash();
	        return this.lastQueryHash || this.queryHash(new QueryBuilder_1.QueryBuilder().build());
	    };
	    QueryController.prototype.getLastSearchUid = function () {
	        if (this.lastSearchUid != null) {
	            return this.lastSearchUid;
	        }
	        this.loadLastQueryHash();
	        return this.lastSearchUid;
	    };
	    QueryController.prototype.loadLastQueryHash = function () {
	        var lastQuery = this.localStorage.load();
	        if (lastQuery != null && new Date().getTime() <= lastQuery.expire) {
	            this.lastQueryHash = lastQuery.hash;
	            this.lastSearchUid = lastQuery.uid;
	            this.localStorage.remove();
	        }
	    };
	    QueryController.prototype.continueLastQueryBuilder = function (queryBuilder, count) {
	        _.extend(queryBuilder, this.lastQueryBuilder);
	        queryBuilder.firstResult = queryBuilder.firstResult + queryBuilder.numberOfResults;
	        queryBuilder.numberOfResults = count;
	    };
	    QueryController.prototype.getPipelineInUrl = function () {
	        return QueryUtils_1.QueryUtils.getUrlParameter('pipeline');
	    };
	    QueryController.prototype.cancelAnyCurrentPendingQuery = function () {
	        if (Utils_1.Utils.exists(this.currentPendingQuery)) {
	            this.logger.debug('Cancelling current pending query');
	            es6_promise_1.Promise.reject(this.currentPendingQuery);
	            this.currentPendingQuery = undefined;
	            return true;
	        }
	        return false;
	    };
	    QueryController.prototype.showExecutingQueryAnimation = function () {
	        if (!this.showingExecutingQueryAnimation) {
	            Dom_1.$$(this.element).addClass('coveo-executing-query');
	            this.showingExecutingQueryAnimation = true;
	        }
	    };
	    QueryController.prototype.hideExecutingQueryAnimation = function () {
	        if (this.showingExecutingQueryAnimation) {
	            Dom_1.$$(this.element).removeClass('coveo-executing-query');
	            this.showingExecutingQueryAnimation = false;
	        }
	    };
	    QueryController.prototype.keepLastSearchUid = function (query, queryResults) {
	        return this.getLastQueryHash() == this.queryHash(query, queryResults);
	    };
	    QueryController.prototype.queryHash = function (query, queryResults) {
	        var queryHash = JSON.stringify(_.omit(query, 'firstResult', 'groupBy', 'debug'));
	        if (queryResults != null) {
	            queryHash += queryResults.pipeline;
	        }
	        return queryHash;
	    };
	    QueryController.prototype.getCallOptions = function () {
	        var args = {
	            options: {
	                authentication: []
	            }
	        };
	        Dom_1.$$(this.element).trigger(QueryEvents_1.QueryEvents.buildingCallOptions, args);
	        return args.options;
	    };
	    QueryController.prototype.newQueryEvent = function (args) {
	        Dom_1.$$(this.element).trigger(QueryEvents_1.QueryEvents.newQuery, args);
	    };
	    QueryController.prototype.buildingQueryEvent = function (args) {
	        Dom_1.$$(this.element).trigger(QueryEvents_1.QueryEvents.buildingQuery, args);
	    };
	    QueryController.prototype.doneBuildingQueryEvent = function (args) {
	        Dom_1.$$(this.element).trigger(QueryEvents_1.QueryEvents.doneBuildingQuery, args);
	    };
	    QueryController.prototype.duringQueryEvent = function (args) {
	        Dom_1.$$(this.element).trigger(QueryEvents_1.QueryEvents.duringQuery, args);
	    };
	    QueryController.prototype.querySuccessEvent = function (args) {
	        Dom_1.$$(this.element).trigger(QueryEvents_1.QueryEvents.querySuccess, args);
	    };
	    QueryController.prototype.fetchMoreSuccessEvent = function (args) {
	        Dom_1.$$(this.element).trigger(QueryEvents_1.QueryEvents.fetchMoreSuccess, args);
	    };
	    QueryController.prototype.deferredQuerySuccessEvent = function (args) {
	        Dom_1.$$(this.element).trigger(QueryEvents_1.QueryEvents.deferredQuerySuccess, args);
	    };
	    QueryController.prototype.queryError = function (args) {
	        Dom_1.$$(this.element).trigger(QueryEvents_1.QueryEvents.queryError, args);
	    };
	    QueryController.prototype.preprocessResultsEvent = function (args) {
	        Dom_1.$$(this.element).trigger(QueryEvents_1.QueryEvents.preprocessResults, args);
	    };
	    QueryController.prototype.noResultEvent = function (args) {
	        Dom_1.$$(this.element).trigger(QueryEvents_1.QueryEvents.noResults, args);
	    };
	    QueryController.prototype.debugInfo = function () {
	        var _this = this;
	        var info = {
	            'query': this.lastQuery,
	        };
	        if (this.lastQueryResults != null) {
	            info.queryDuration = function () { return _this.buildQueryDurationSection(_this.lastQueryResults); };
	            info.results = function () { return _.omit(_this.lastQueryResults, 'results'); };
	        }
	        if (this.currentError != null) {
	            info.error = function () { return _this.currentError; };
	        }
	        return info;
	    };
	    QueryController.prototype.buildQueryDurationSection = function (queryResults) {
	        var dom = Dom_1.Dom.createElement('div', { className: 'coveo-debug-queryDuration' });
	        var graph = Dom_1.Dom.createElement('div', { className: 'coveo-debug-durations' });
	        var debugRef = BaseComponent_1.BaseComponent.getComponentRef('Debug');
	        dom.appendChild(graph);
	        _.forEach(debugRef.durationKeys, function (key) {
	            var duration = queryResults[key];
	            if (duration != null) {
	                graph.appendChild(Dom_1.Dom.createElement('div', {
	                    className: 'coveo-debug-duration',
	                    style: "width:" + duration + "px",
	                    'data-id': key
	                }));
	                var legend = Dom_1.Dom.createElement('div', { className: 'coveo-debug-duration-legend', 'data-id': key });
	                dom.appendChild(legend);
	                var keyDom = Dom_1.Dom.createElement('span', { className: 'coveo-debug-duration-label' });
	                keyDom.appendChild(document.createTextNode(key));
	                legend.appendChild(keyDom);
	                var durationDom = Dom_1.Dom.createElement('span', { className: 'coveo-debug-duration-value' });
	                durationDom.appendChild(document.createTextNode(duration));
	                legend.appendChild(durationDom);
	            }
	        });
	        return dom;
	    };
	    QueryController.prototype.logQueryInActionsHistory = function (query, isFirstQuery) {
	        if (typeof coveoanalytics != 'undefined') {
	            var store = new coveoanalytics.history.HistoryStore();
	            var queryElement = {
	                name: 'Query',
	                value: query.q,
	                time: JSON.stringify(new Date())
	            };
	            store.addElement(queryElement);
	        }
	    };
	    QueryController.ID = 'QueryController';
	    return QueryController;
	}(RootComponent_1.RootComponent));
	exports.QueryController = QueryController;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var BaseComponent_1 = __webpack_require__(76);
	var RootComponent = (function (_super) {
	    __extends(RootComponent, _super);
	    function RootComponent(element, type) {
	        _super.call(this, element, type);
	        this.element = element;
	        this.type = type;
	    }
	    return RootComponent;
	}(BaseComponent_1.BaseComponent));
	exports.RootComponent = RootComponent;


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var Assert_1 = __webpack_require__(17);
	var Dom_1 = __webpack_require__(57);
	var DebugEvents_1 = __webpack_require__(42);
	var Logger_1 = __webpack_require__(16);
	/**
	 * Every component in the framework ultimately inherits from this base component class.
	 */
	var BaseComponent = (function () {
	    function BaseComponent(element, type) {
	        this.element = element;
	        this.type = type;
	        /**
	         * A disabled component will not participate in the query, or listen to {@link ComponentEvents}.
	         * @type {boolean}
	         */
	        this.disabled = false;
	        Assert_1.Assert.exists(element);
	        Assert_1.Assert.isNonEmptyString(type);
	        this.logger = new Logger_1.Logger(this);
	        this.initDebugInfo();
	        BaseComponent.bindComponentToElement(element, this);
	    }
	    /**
	     * Return the debug info about this component.
	     * @returns {any}
	     */
	    BaseComponent.prototype.debugInfo = function () {
	        var info = {};
	        info[this['constructor']['ID']] = this;
	        return info;
	    };
	    /**
	     * Disable the component.
	     * Normally this means that the component will not execute handlers for the framework events (query events, for example).
	     * Component are enabled by default on creation.
	     */
	    BaseComponent.prototype.disable = function () {
	        this.disabled = true;
	    };
	    /**
	     * Enable the component.
	     * Normally this means that the component will execute handlers for the framework events (query events, for example).
	     * Components are enabled by default on creation.
	     */
	    BaseComponent.prototype.enable = function () {
	        this.disabled = false;
	    };
	    BaseComponent.prototype.initDebugInfo = function () {
	        Dom_1.$$(this.element).on('doubleclick', function (e) {
	            if (e.altKey) {
	                var debugInfo = this.debugInfo();
	                if (debugInfo != null) {
	                    $(this.root).trigger(DebugEvents_1.DebugEvents.showDebugPanel, this.debugInfo());
	                }
	            }
	        });
	    };
	    BaseComponent.bindComponentToElement = function (element, component) {
	        Assert_1.Assert.exists(element);
	        Assert_1.Assert.exists(component);
	        Assert_1.Assert.isNonEmptyString(component.type);
	        element[BaseComponent.computeCssClassNameForType(component.type)] = component;
	        Dom_1.$$(element).addClass(BaseComponent.computeCssClassNameForType(component.type));
	        BaseComponent.getBoundComponentsForElement(element).push(component);
	    };
	    BaseComponent.computeCssClassName = function (componentClass) {
	        return componentClass['className'] ? componentClass['className'] : componentClass['className'] = BaseComponent.computeCssClassNameForType(componentClass['ID']);
	    };
	    BaseComponent.computeCssClassNameForType = function (type) {
	        Assert_1.Assert.isNonEmptyString(type);
	        return 'Coveo' + type;
	    };
	    BaseComponent.computeSelectorForType = function (type) {
	        Assert_1.Assert.isNonEmptyString(type);
	        return '.' + BaseComponent.computeCssClassNameForType(type);
	    };
	    BaseComponent.getBoundComponentsForElement = function (element) {
	        Assert_1.Assert.exists(element);
	        if (element.CoveoBoundComponents == null) {
	            element.CoveoBoundComponents = [];
	        }
	        return element.CoveoBoundComponents;
	    };
	    BaseComponent.getComponentRef = function (component) {
	        return Coveo[component];
	    };
	    return BaseComponent;
	}());
	exports.BaseComponent = BaseComponent;


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var ExpressionBuilder_1 = __webpack_require__(78);
	var QueryUtils_1 = __webpack_require__(23);
	/**
	 * The QueryBuilder is used to build a {@link IQuery} that will be able to be executed using the Search API.<br/>
	 * The class exposes several members and methods that help components and external code to build up the final query that is sent to the Search API.<br/>
	 */
	var QueryBuilder = (function () {
	    function QueryBuilder() {
	        /**
	         * Used to build the basic part of the query expression.<br/>
	         * This part typically consists of user-entered content such as query keywords, etc.
	         * @type {Coveo.ExpressionBuilder}
	         */
	        this.expression = new ExpressionBuilder_1.ExpressionBuilder();
	        /**
	         * Used to build the advanced part of the query expression.<br/>
	         * This part is typically formed of filter expressions generated by components such as facets, external code, etc.
	         * @type {Coveo.ExpressionBuilder}
	         */
	        this.advancedExpression = new ExpressionBuilder_1.ExpressionBuilder();
	        /**
	         * Used to build the advanced part of the query expression.<br/>
	         * This part is similar to `advancedExpression`, but its content is interpreted as a constant expression by the index and it takes advantage of special caching features.
	         * @type {Coveo.ExpressionBuilder}
	         */
	        this.constantExpression = new ExpressionBuilder_1.ExpressionBuilder();
	        /**
	         * Used to build the disjunctive part of the query expression.<br/>
	         * When present, this part is evaluated separately from the other expressions and the matching results are merged to those matching expressions, `advancedExpression` and `constantExpression`.<br/>
	         * The final boolean expression for the query is thus (basic advanced constant) OR (disjunction).
	         * @type {Coveo.ExpressionBuilder}
	         */
	        this.disjunctionExpression = new ExpressionBuilder_1.ExpressionBuilder();
	        /**
	         * Whether to disable the special query syntax such as field references for the basic query expression (parameter q).
	         * It is equivalent to a No syntax block applied to the basic query expression.
	         * If not specified, the parameter defaults to false.
	         */
	        this.disableQuerySyntax = false;
	        /**
	         * This is the 0-based index of the first result to return.<br/>
	         * If not specified, this parameter defaults to 0.
	         */
	        this.firstResult = 0;
	        /**
	         * This is the number of results to return, starting from {@link IQuery.firstResult}.<br/>
	         * If not specified, this parameter defaults to 10.
	         */
	        this.numberOfResults = 10;
	        this.requiredFields = [];
	        this.includeRequiredFields = false;
	        /**
	         * Whether to enable query corrections on this query (see {@link DidYouMean}).
	         */
	        this.enableDidYouMean = false;
	        /**
	         * Whether to enable debug info on the query.<br/>
	         * This will return additional information on the resulting JSON response from the Search API.<br/>
	         * Mostly: execution report (a detailed breakdown of the parsed and executed query).
	         */
	        this.enableDebug = false;
	        /**
	         * This specifies the sort criterion(s) to use to sort results. If not specified, this parameter defaults to relevancy.<br/>
	         * Possible values are : <br/>
	         * -- relevancy :  This uses all the configured ranking weights as well as any specified ranking expressions to rank results.<br/>
	         * -- dateascending / datedescending Sort using the value of the `@date` field, which is typically the last modification date of an item in the index.<br/>
	         * -- qre : Sort using only the weights applied through ranking expressions. This is much like using `relevancy` except that automatic weights based on keyword proximity etc, are not computed.<br/>
	         * -- nosort : Do not sort the results. The order in which items are returned is essentially random.<br/>
	         * -- @field ascending / @field descending Sort using the value of a custom field.
	         */
	        this.sortCriteria = 'relevancy';
	        this.retrieveFirstSentences = true;
	        this.queryUid = QueryUtils_1.QueryUtils.createGuid();
	        /**
	         * This specifies an array of Query Function operation that will be executed on the results.
	         */
	        this.queryFunctions = [];
	        /**
	         * This specifies an array of Ranking Function operations that will be executed on the results.
	         */
	        this.rankingFunctions = [];
	        /**
	         * This specifies an array of Group By operations that can be performed on the query results to extract facets.
	         */
	        this.groupByRequests = [];
	        this.enableDuplicateFiltering = false;
	    }
	    /**
	     * Build the current content or state of the query builder and return a {@link IQuery}.<br/>
	     * build can be called multiple times on the same QueryBuilder.
	     * @returns {IQuery}
	     */
	    QueryBuilder.prototype.build = function () {
	        var query = {
	            q: this.expression.build(),
	            aq: this.advancedExpression.build(),
	            cq: this.constantExpression.build(),
	            dq: this.disjunctionExpression.build(),
	            searchHub: this.searchHub,
	            tab: this.tab,
	            language: this.language,
	            pipeline: this.pipeline,
	            maximumAge: this.maximumAge,
	            wildcards: this.enableWildcards,
	            questionMark: this.enableQuestionMarks,
	            lowercaseOperators: this.enableLowercaseOperators,
	            partialMatch: this.enablePartialMatch,
	            partialMatchKeywords: this.partialMatchKeywords,
	            partialMatchThreshold: this.partialMatchThreshold,
	            firstResult: this.firstResult,
	            numberOfResults: this.numberOfResults,
	            excerptLength: this.excerptLength,
	            filterField: this.filterField,
	            filterFieldRange: this.filterFieldRange,
	            parentField: this.parentField,
	            childField: this.childField,
	            fieldsToInclude: this.computeFieldsToInclude(),
	            fieldsToExclude: this.fieldsToExclude,
	            enableDidYouMean: this.enableDidYouMean,
	            sortCriteria: this.sortCriteria,
	            sortField: this.sortField,
	            queryFunctions: this.queryFunctions,
	            rankingFunctions: this.rankingFunctions,
	            groupBy: this.groupByRequests,
	            retrieveFirstSentences: this.retrieveFirstSentences,
	            timezone: this.timezone,
	            disableQuerySyntax: this.disableQuerySyntax,
	            enableDuplicateFiltering: this.enableDuplicateFiltering,
	            enableCollaborativeRating: this.enableCollaborativeRating,
	            debug: this.enableDebug,
	            context: this.context,
	            actionsHistory: this.actionsHistory,
	            recommendation: this.recommendation
	        };
	        return query;
	    };
	    /**
	     * Return only the expression(s) part(s) of the query, as a string.<br/>
	     * This means the basic, advanced and constant part in a complete expression {@link IQuery.q}, {@link IQuery.aq}, {@link IQuery.cq}.
	     * @returns {string}
	     */
	    QueryBuilder.prototype.computeCompleteExpression = function () {
	        return this.computeCompleteExpressionParts().full;
	    };
	    /**
	     * Return only the expression(s) part(s) of the query, as an object.
	     * @returns {{full: string, withoutConstant: string, constant: string}}
	     */
	    QueryBuilder.prototype.computeCompleteExpressionParts = function () {
	        var withoutConstant = ExpressionBuilder_1.ExpressionBuilder.merge(this.expression, this.advancedExpression);
	        return {
	            full: ExpressionBuilder_1.ExpressionBuilder.mergeUsingOr(ExpressionBuilder_1.ExpressionBuilder.merge(withoutConstant, this.constantExpression), this.disjunctionExpression).build(),
	            withoutConstant: ExpressionBuilder_1.ExpressionBuilder.mergeUsingOr(withoutConstant, this.disjunctionExpression).build(),
	            basic: ExpressionBuilder_1.ExpressionBuilder.mergeUsingOr(this.expression, this.disjunctionExpression).build(),
	            advanced: ExpressionBuilder_1.ExpressionBuilder.mergeUsingOr(this.advancedExpression, this.disjunctionExpression).build(),
	            constant: ExpressionBuilder_1.ExpressionBuilder.mergeUsingOr(this.constantExpression, this.disjunctionExpression).build()
	        };
	    };
	    /**
	     * Return only the expression(s) part(s) of the query, as a string, except the given expression.<br/>
	     * This is used by {@link Facet}, to build their group by request with query override.
	     * @param except
	     * @returns {string}
	     */
	    QueryBuilder.prototype.computeCompleteExpressionExcept = function (except) {
	        return this.computeCompleteExpressionPartsExcept(except).full;
	    };
	    /**
	     * Return only the expression(s) part(s) of the query, as an object, except the given expression.<br/>
	     * This is used by {@link Facet}, to build their group by request with query override.
	     * @param except
	     * @returns {{full: string, withoutConstant: string, constant: string}}
	     */
	    QueryBuilder.prototype.computeCompleteExpressionPartsExcept = function (except) {
	        var withoutConstantAndExcept = ExpressionBuilder_1.ExpressionBuilder.merge(this.expression, this.advancedExpression);
	        withoutConstantAndExcept.remove(except);
	        var basicAndExcept = new ExpressionBuilder_1.ExpressionBuilder();
	        basicAndExcept.fromExpressionBuilder(this.expression);
	        basicAndExcept.remove(except);
	        var advancedAndExcept = new ExpressionBuilder_1.ExpressionBuilder();
	        advancedAndExcept.fromExpressionBuilder(this.advancedExpression);
	        advancedAndExcept.remove(except);
	        return {
	            full: ExpressionBuilder_1.ExpressionBuilder.mergeUsingOr(ExpressionBuilder_1.ExpressionBuilder.merge(withoutConstantAndExcept, this.constantExpression), this.disjunctionExpression).build(),
	            withoutConstant: ExpressionBuilder_1.ExpressionBuilder.mergeUsingOr(withoutConstantAndExcept, this.disjunctionExpression).build(),
	            basic: ExpressionBuilder_1.ExpressionBuilder.mergeUsingOr(basicAndExcept, this.disjunctionExpression).build(),
	            advanced: ExpressionBuilder_1.ExpressionBuilder.mergeUsingOr(advancedAndExcept, this.disjunctionExpression).build(),
	            constant: ExpressionBuilder_1.ExpressionBuilder.mergeUsingOr(this.constantExpression, this.disjunctionExpression).build()
	        };
	    };
	    /**
	     * Add fields to specifically include when the results return.<br/>
	     * This can be used to accelerate the execution time of every query, as there is much less data to process if you whitelist specific fields.
	     * @param fields
	     */
	    QueryBuilder.prototype.addFieldsToInclude = function (fields) {
	        this.fieldsToInclude = _.uniq((this.fieldsToInclude || []).concat(fields));
	    };
	    QueryBuilder.prototype.addRequiredFields = function (fields) {
	        this.requiredFields = _.uniq(this.requiredFields.concat(fields));
	    };
	    /**
	     * Add fields to specifically exclude when the results return.<br/>
	     * This can be used to accelerate the execution time of every query, as there is much less data to process if you blacklist specific fields.
	     * @param fields
	     */
	    QueryBuilder.prototype.addFieldsToExclude = function (fields) {
	        this.fieldsToExclude = _.uniq((this.fieldsToInclude || []).concat(fields));
	    };
	    QueryBuilder.prototype.computeFieldsToInclude = function () {
	        if (this.includeRequiredFields || this.fieldsToInclude != null) {
	            return this.requiredFields.concat(this.fieldsToInclude || []);
	        }
	        else {
	            return null;
	        }
	    };
	    /**
	     * Add a single context key->value pair to the query.<br/>
	     * This is used by the Query pipeline in the Coveo platform.
	     * @param key
	     * @param value
	     */
	    QueryBuilder.prototype.addContextValue = function (key, value) {
	        if (this.context == null) {
	            this.context = {};
	        }
	        this.context[key] = value;
	    };
	    /**
	     * Add a context object to the query.<br/>
	     * This can contain multiple key->value.<br/>
	     * This is used by the Query pipeline in the Coveo platform.
	     * @param values
	     */
	    QueryBuilder.prototype.addContext = function (values) {
	        if (this.context == null) {
	            this.context = {};
	        }
	        _.extend(this.context, values);
	    };
	    return QueryBuilder;
	}());
	exports.QueryBuilder = QueryBuilder;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var Assert_1 = __webpack_require__(17);
	var QueryUtils_1 = __webpack_require__(23);
	/**
	 * An `ExpressionBuilder` that is mostly used by the {@link QueryBuilder}.<br/>
	 * It is used to build a single query expression.<br/>
	 * It allows combining multiple expression parts into a single string and provides utilities to generate common expression parts.
	 */
	var ExpressionBuilder = (function () {
	    function ExpressionBuilder() {
	        this.parts = []; // he he he
	        this.wrapParts = true;
	    }
	    /**
	     * Add a new part to the expression.
	     * @param expression
	     */
	    ExpressionBuilder.prototype.add = function (expression) {
	        Assert_1.Assert.isNonEmptyString(expression);
	        this.parts.push(expression);
	    };
	    /**
	     * Take another `ExpressionBuilder`, and copy it.
	     * @param expression
	     */
	    ExpressionBuilder.prototype.fromExpressionBuilder = function (expression) {
	        this.parts = this.parts.concat(expression.parts);
	    };
	    /**
	     * Add a new part to the expression, but specific for field values<br/>
	     * eg @field=(value1,value2,value3).
	     * @param field The field for which to create an expression (e.g.: @foo).
	     * @param operator The operator to use e.g.: = (equal) == (strict equal) <> (not equal).
	     * @param values The values to put in the expression.
	     */
	    ExpressionBuilder.prototype.addFieldExpression = function (field, operator, values) {
	        Assert_1.Assert.isNonEmptyString(field);
	        Assert_1.Assert.stringStartsWith(field, '@');
	        Assert_1.Assert.isNonEmptyString(operator);
	        Assert_1.Assert.isLargerOrEqualsThan(1, values.length);
	        this.add(QueryUtils_1.QueryUtils.buildFieldExpression(field, operator, values));
	    };
	    /**
	     * Add a new part to the expression, but specific for field values<br/>
	     * eg : NOT @field==(value1, value2, value3).
	     * @param field The field for which to create an expression (e.g.: @foo)
	     * @param values The values to put in the expression.
	     */
	    ExpressionBuilder.prototype.addFieldNotEqualExpression = function (field, values) {
	        Assert_1.Assert.isNonEmptyString(field);
	        Assert_1.Assert.stringStartsWith(field, '@');
	        Assert_1.Assert.isLargerOrEqualsThan(1, values.length);
	        this.add(QueryUtils_1.QueryUtils.buildFieldNotEqualExpression(field, values));
	    };
	    /**
	     * Removes an expression from the builder.
	     * @param expression
	     */
	    ExpressionBuilder.prototype.remove = function (expression) {
	        Assert_1.Assert.isNonEmptyString(expression);
	        var index = _.indexOf(this.parts, expression);
	        if (index != -1) {
	            this.parts.splice(_.indexOf(this.parts, expression), 1);
	        }
	    };
	    /**
	     * Checks if the builder is currently empty.
	     * @returns {boolean}
	     */
	    ExpressionBuilder.prototype.isEmpty = function () {
	        return this.parts.length == 0;
	    };
	    /**
	     * Builds the expression string by combining all the parts together.<br/>
	     * @param exp expression to join the different parts, default to a space.
	     * @returns {any}
	     */
	    ExpressionBuilder.prototype.build = function (exp) {
	        if (exp === void 0) { exp = ' '; }
	        if (this.parts.length == 0) {
	            return undefined;
	        }
	        else if (this.parts.length == 1) {
	            return this.parts[0];
	        }
	        else if (this.wrapParts) {
	            return '(' + this.parts.join(')' + exp + '(') + ')';
	        }
	        else {
	            return this.parts.join(exp);
	        }
	    };
	    /**
	     * Merges several `ExpressionBuilder` together.
	     * @param builders Builders that should be merged.
	     * @returns {Coveo.ExpressionBuilder}
	     */
	    ExpressionBuilder.merge = function () {
	        var builders = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            builders[_i - 0] = arguments[_i];
	        }
	        var merged = new ExpressionBuilder();
	        _.each(builders, function (builder) {
	            merged.parts = merged.parts.concat(builder.parts);
	        });
	        return merged;
	    };
	    /**
	     * Merges several `ExpressionBuilder` together, using the OR operator.
	     * @param builders Builders that should be merged.
	     * @returns {Coveo.ExpressionBuilder}
	     */
	    ExpressionBuilder.mergeUsingOr = function () {
	        var builders = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            builders[_i - 0] = arguments[_i];
	        }
	        var nonEmpty = _.filter(builders, function (b) { return !b.isEmpty(); });
	        var merged = new ExpressionBuilder();
	        if (nonEmpty.length == 1) {
	            merged.parts = [].concat(nonEmpty[0].parts);
	        }
	        else if (nonEmpty.length > 1) {
	            var parts = _.map(nonEmpty, function (b) { return b.build(); });
	            merged.add('(' + parts.join(') OR (') + ')');
	        }
	        return merged;
	    };
	    return ExpressionBuilder;
	}());
	exports.ExpressionBuilder = ExpressionBuilder;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var SearchEndpointWithDefaultCallOptions = (function () {
	    function SearchEndpointWithDefaultCallOptions(endpoint, callOptions) {
	        this.endpoint = endpoint;
	        this.callOptions = callOptions;
	        this.options = endpoint.options;
	    }
	    SearchEndpointWithDefaultCallOptions.prototype.getBaseUri = function () {
	        return this.endpoint.getBaseUri();
	    };
	    SearchEndpointWithDefaultCallOptions.prototype.getBaseAlertsUri = function () {
	        return this.endpoint.getBaseAlertsUri();
	    };
	    SearchEndpointWithDefaultCallOptions.prototype.getAuthenticationProviderUri = function (provider, returnUri, message) {
	        return this.endpoint.getAuthenticationProviderUri(provider, returnUri, message);
	    };
	    SearchEndpointWithDefaultCallOptions.prototype.isJsonp = function () {
	        return this.endpoint.isJsonp();
	    };
	    SearchEndpointWithDefaultCallOptions.prototype.search = function (query, callOptions) {
	        return this.endpoint.search(query, this.enrichCallOptions(callOptions));
	    };
	    SearchEndpointWithDefaultCallOptions.prototype.getExportToExcelLink = function (query, numberOfResults, callOptions) {
	        return this.endpoint.getExportToExcelLink(query, numberOfResults, this.enrichCallOptions(callOptions));
	    };
	    SearchEndpointWithDefaultCallOptions.prototype.tagDocument = function (taggingRequest, callOptions) {
	        return this.endpoint.tagDocument(taggingRequest, this.enrichCallOptions(taggingRequest));
	    };
	    SearchEndpointWithDefaultCallOptions.prototype.getRevealQuerySuggest = function (request, callOptions) {
	        return this.endpoint.getRevealQuerySuggest(request, this.enrichCallOptions(callOptions));
	    };
	    SearchEndpointWithDefaultCallOptions.prototype.rateDocument = function (ratingRequest, callOptions) {
	        return this.endpoint.rateDocument(ratingRequest, this.enrichCallOptions(callOptions));
	    };
	    SearchEndpointWithDefaultCallOptions.prototype.getRawDataStream = function (documentUniqueId, dataStreamType, callOptions) {
	        return this.endpoint.getRawDataStream(documentUniqueId, dataStreamType, this.enrichCallOptions(callOptions));
	    };
	    SearchEndpointWithDefaultCallOptions.prototype.getDocument = function (documentUniqueId, callOptions) {
	        return this.endpoint.getDocument(documentUniqueId, this.enrichCallOptions(callOptions));
	    };
	    SearchEndpointWithDefaultCallOptions.prototype.getDocumentText = function (documentUniqueID, callOptions) {
	        return this.endpoint.getDocumentText(documentUniqueID, this.enrichCallOptions(callOptions));
	    };
	    SearchEndpointWithDefaultCallOptions.prototype.getDocumentHtml = function (documentUniqueID, callOptions) {
	        return this.endpoint.getDocumentHtml(documentUniqueID, this.enrichCallOptions(callOptions));
	    };
	    SearchEndpointWithDefaultCallOptions.prototype.getViewAsHtmlUri = function (documentUniqueID, callOptions) {
	        return this.endpoint.getViewAsHtmlUri(documentUniqueID, this.enrichCallOptions(callOptions));
	    };
	    SearchEndpointWithDefaultCallOptions.prototype.getViewAsDatastreamUri = function (documentUniqueID, dataStreamType, callOptions) {
	        return this.endpoint.getViewAsDatastreamUri(documentUniqueID, dataStreamType, this.enrichCallOptions(callOptions));
	    };
	    SearchEndpointWithDefaultCallOptions.prototype.listFieldValues = function (request, callOptions) {
	        return this.endpoint.listFieldValues(request, this.enrichCallOptions(callOptions));
	    };
	    SearchEndpointWithDefaultCallOptions.prototype.listFields = function (callOptions) {
	        return this.endpoint.listFields(this.enrichCallOptions(callOptions));
	    };
	    SearchEndpointWithDefaultCallOptions.prototype.extensions = function (callOptions) {
	        return this.endpoint.extensions(this.enrichCallOptions(callOptions));
	    };
	    SearchEndpointWithDefaultCallOptions.prototype.follow = function (request) {
	        return this.endpoint.follow(request);
	    };
	    SearchEndpointWithDefaultCallOptions.prototype.listSubscriptions = function (page) {
	        return this.endpoint.listSubscriptions(page);
	    };
	    SearchEndpointWithDefaultCallOptions.prototype.updateSubscription = function (subscription) {
	        return this.endpoint.updateSubscription(subscription);
	    };
	    SearchEndpointWithDefaultCallOptions.prototype.deleteSubscription = function (subscription) {
	        return this.endpoint.deleteSubscription(subscription);
	    };
	    SearchEndpointWithDefaultCallOptions.prototype.logError = function (sentryLog) {
	        return this.endpoint.logError(sentryLog);
	    };
	    SearchEndpointWithDefaultCallOptions.prototype.enrichCallOptions = function (callOptions) {
	        return _.extend({}, callOptions, this.callOptions);
	    };
	    return SearchEndpointWithDefaultCallOptions;
	}());
	exports.SearchEndpointWithDefaultCallOptions = SearchEndpointWithDefaultCallOptions;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {/// <reference path='../ui/Facet/Facet.ts' />
	"use strict";
	var ExpressionBuilder_1 = __webpack_require__(78);
	var Utils_1 = __webpack_require__(18);
	var FacetSearchParameters_1 = __webpack_require__(81);
	var Assert_1 = __webpack_require__(17);
	var FacetUtils_1 = __webpack_require__(82);
	var FacetQueryController = (function () {
	    function FacetQueryController(facet) {
	        this.facet = facet;
	    }
	    /**
	     * Reset the expression for the facet search, used when a new query is triggered
	     */
	    FacetQueryController.prototype.prepareForNewQuery = function () {
	        this.lastGroupByRequestIndex = undefined;
	        this.expressionToUseForFacetSearch = undefined;
	        this.constantExpressionToUseForFacetSearch = undefined;
	    };
	    /**
	     * Compute the filter expression that the facet need to output for the query
	     * @returns {string}
	     */
	    FacetQueryController.prototype.computeOurFilterExpression = function () {
	        var _this = this;
	        var builder = new ExpressionBuilder_1.ExpressionBuilder();
	        var selected = this.facet.values.getSelected();
	        if (selected.length > 0) {
	            if (this.facet.options.useAnd) {
	                _.each(selected, function (value) {
	                    builder.addFieldExpression(_this.facet.options.field, '==', [value.value]);
	                });
	            }
	            else {
	                builder.addFieldExpression(this.facet.options.field, '==', _.map(selected, function (value) { return value.value; }));
	            }
	        }
	        var excluded = this.facet.values.getExcluded();
	        if (excluded.length > 0) {
	            builder.addFieldNotEqualExpression(this.facet.options.field, _.map(excluded, function (value) { return value.value; }));
	        }
	        if (Utils_1.Utils.isNonEmptyString(this.facet.options.additionalFilter)) {
	            builder.add(this.facet.options.additionalFilter);
	        }
	        return builder.build();
	    };
	    /**
	     * Build the group by request for the facet, and insert it in the query builder
	     * @param queryBuilder
	     */
	    FacetQueryController.prototype.putGroupByIntoQueryBuilder = function (queryBuilder) {
	        Assert_1.Assert.exists(queryBuilder);
	        var allowedValues = this.createGroupByAllowedValues();
	        var groupByRequest = this.createBasicGroupByRequest(allowedValues);
	        var queryOverrideObject = this.createGroupByQueryOverride(queryBuilder);
	        if (!Utils_1.Utils.isNullOrUndefined(queryOverrideObject)) {
	            groupByRequest.queryOverride = queryOverrideObject.basic;
	            groupByRequest.advancedQueryOverride = queryOverrideObject.advanced;
	            groupByRequest.constantQueryOverride = queryOverrideObject.constant;
	            this.expressionToUseForFacetSearch = queryOverrideObject.withoutConstant;
	            this.constantExpressionToUseForFacetSearch = queryOverrideObject.constant;
	        }
	        else {
	            var parts = queryBuilder.computeCompleteExpressionParts();
	            this.expressionToUseForFacetSearch = parts.withoutConstant;
	            if (this.expressionToUseForFacetSearch == null) {
	                this.expressionToUseForFacetSearch = '@uri';
	            }
	            this.constantExpressionToUseForFacetSearch = parts.constant;
	        }
	        this.lastGroupByRequestIndex = queryBuilder.groupByRequests.length;
	        this.lastGroupByRequest = groupByRequest;
	        queryBuilder.groupByRequests.push(groupByRequest);
	    };
	    /**
	     * Search inside the facet, using a group by request
	     * @param params
	     * @param oldLength Optional params, used by the search method to call itself recursively to fetch all required values
	     * @returns {Promise|Promise<T>}
	     */
	    FacetQueryController.prototype.search = function (params, oldLength) {
	        var _this = this;
	        if (oldLength === void 0) { oldLength = params.nbResults; }
	        return new Promise(function (resolve, reject) {
	            var onResult = function (fieldValues) {
	                var newLength = fieldValues.length;
	                fieldValues = _this.checkForFacetSearchValuesToRemove(fieldValues, params.valueToSearch);
	                if (FacetUtils_1.FacetUtils.needAnotherFacetSearch(fieldValues.length, newLength, oldLength, 5)) {
	                    // This means that we removed enough values from the returned one that we need to perform a new search with more values requested.
	                    params.nbResults += 5;
	                    return _this.search(params, fieldValues.length);
	                }
	                else {
	                    resolve(fieldValues);
	                }
	            };
	            _this.facet.getEndpoint().search(params.getQuery())
	                .then(function (queryResults) {
	                if (_this.facet.searchInterface.isNewDesign()) {
	                    // params.getQuery() will generate a query for all excluded values + some new values
	                    // there is no clean way to do a group by and remove some values
	                    // so instead we request more values than we need, and crop all the one we don't want
	                    var valuesCropped_1 = [];
	                    if (queryResults.groupByResults && queryResults.groupByResults[0]) {
	                        _.each(queryResults.groupByResults[0].values, function (v) {
	                            if (v.lookupValue) {
	                                if (!_.contains(params.alwaysExclude, v.lookupValue.toLowerCase())) {
	                                    valuesCropped_1.push(v);
	                                }
	                            }
	                            else {
	                                if (!_.contains(params.alwaysExclude, v.value.toLowerCase())) {
	                                    valuesCropped_1.push(v);
	                                }
	                            }
	                        });
	                    }
	                    onResult(_.first(valuesCropped_1, params.nbResults));
	                }
	                else {
	                    resolve(queryResults.groupByResults[0].values);
	                }
	            })
	                .catch(function (error) {
	                reject(error);
	            });
	        });
	    };
	    FacetQueryController.prototype.fetchMore = function (numberOfValuesToFetch) {
	        var params = new FacetSearchParameters_1.FacetSearchParameters(this.facet);
	        params.alwaysInclude = this.facet.options.allowedValues || _.pluck(this.facet.values.getAll(), 'value');
	        params.nbResults = numberOfValuesToFetch;
	        return this.facet.getEndpoint().search(params.getQuery());
	    };
	    FacetQueryController.prototype.searchInFacetToUpdateDelta = function (facetValues) {
	        var params = new FacetSearchParameters_1.FacetSearchParameters(this.facet);
	        var query = params.getQuery();
	        query.aq = this.computeOurFilterExpression();
	        _.each(facetValues, function (facetValue) {
	            facetValue.waitingForDelta = true;
	        });
	        query.groupBy = [this.createBasicGroupByRequest(_.map(facetValues, function (facetValue) { return facetValue.value; }))];
	        query.groupBy[0].completeFacetWithStandardValues = false;
	        return this.facet.getEndpoint().search(query);
	    };
	    FacetQueryController.prototype.createGroupByAllowedValues = function () {
	        // if you want to keep displayed values next time, take all current values as allowed values
	        // otherwise take only the selected value
	        if (this.facet.options.allowedValues != undefined) {
	            return this.facet.options.allowedValues;
	        }
	        else if (this.facet.options.customSort != undefined) {
	            // If there is a custom sort, we still need to add selectedValues to the group by
	            // Filter out duplicates with a lower case comparison on the value
	            var toCompare_1 = _.map(this.facet.options.customSort, function (val) {
	                return val.toLowerCase();
	            });
	            var filtered = _.filter(this.getAllowedValuesFromSelected(), function (value) {
	                return !_.contains(toCompare_1, value.toLowerCase());
	            });
	            return this.facet.options.customSort.concat(filtered);
	        }
	        else {
	            return this.getAllowedValuesFromSelected();
	        }
	    };
	    FacetQueryController.prototype.getAllowedValuesFromSelected = function () {
	        var toMap = [];
	        if (this.facet.options.useAnd || !this.facet.keepDisplayedValuesNextTime) {
	            var selected = this.facet.values.getSelected();
	            if (selected.length == 0) {
	                return undefined;
	            }
	            toMap = this.facet.values.getSelected();
	        }
	        else {
	            toMap = this.facet.values.getAll();
	        }
	        return _.map(toMap, function (facetValue) { return facetValue.value; });
	    };
	    FacetQueryController.prototype.createGroupByQueryOverride = function (queryBuilder) {
	        var additionalFilter = this.facet.options.additionalFilter ? this.facet.options.additionalFilter : '';
	        var queryOverrideObject = undefined;
	        if (this.facet.options.useAnd) {
	            if (Utils_1.Utils.isNonEmptyString(additionalFilter)) {
	                queryOverrideObject = queryBuilder.computeCompleteExpressionParts();
	                if (Utils_1.Utils.isEmptyString(queryOverrideObject.basic)) {
	                    queryOverrideObject.basic = '@uri';
	                }
	            }
	        }
	        else {
	            if (this.facet.values.hasSelectedOrExcludedValues()) {
	                queryOverrideObject = queryBuilder.computeCompleteExpressionPartsExcept(this.computeOurFilterExpression());
	                if (Utils_1.Utils.isEmptyString(queryOverrideObject.basic)) {
	                    queryOverrideObject.basic = '@uri';
	                }
	            }
	            else {
	                if (Utils_1.Utils.isNonEmptyString(additionalFilter)) {
	                    queryOverrideObject = queryBuilder.computeCompleteExpressionParts();
	                    if (Utils_1.Utils.isEmptyString(queryOverrideObject.basic)) {
	                        queryOverrideObject.basic = '@uri';
	                    }
	                }
	            }
	        }
	        if (queryOverrideObject) {
	            if (Utils_1.Utils.isNonEmptyString(additionalFilter)) {
	                queryOverrideObject.constant = queryOverrideObject.constant ? queryOverrideObject.constant + ' ' + additionalFilter : additionalFilter;
	            }
	        }
	        _.each(_.keys(queryOverrideObject), function (k) {
	            if (Utils_1.Utils.isEmptyString(queryOverrideObject[k]) || Utils_1.Utils.isNullOrUndefined(queryOverrideObject[k])) {
	                delete queryOverrideObject[k];
	            }
	        });
	        if (_.keys(queryOverrideObject).length == 0) {
	            queryOverrideObject = undefined;
	        }
	        return queryOverrideObject;
	    };
	    FacetQueryController.prototype.createBasicGroupByRequest = function (allowedValues, addComputedField) {
	        if (addComputedField === void 0) { addComputedField = true; }
	        var nbOfRequestedValues = this.facet.numberOfValues;
	        if (this.facet.options.customSort != null) {
	            var usedValues = _.union(_.map(this.facet.values.getSelected(), function (facetValue) { return facetValue.value; }), _.map(this.facet.values.getExcluded(), function (facetValue) { return facetValue.value; }), this.facet.options.customSort);
	            nbOfRequestedValues = Math.max(nbOfRequestedValues, usedValues.length);
	        }
	        var groupByRequest = {
	            field: this.facet.options.field,
	            maximumNumberOfValues: nbOfRequestedValues + (this.facet.options.enableMoreLess ? 1 : 0),
	            sortCriteria: this.facet.options.sortCriteria,
	            injectionDepth: this.facet.options.injectionDepth,
	            completeFacetWithStandardValues: this.facet.options.allowedValues == undefined ? true : false
	        };
	        if (this.facet.options.lookupField) {
	            groupByRequest.lookupField = this.facet.options.lookupField;
	        }
	        if (allowedValues != null) {
	            groupByRequest.allowedValues = allowedValues;
	        }
	        if (addComputedField && Utils_1.Utils.isNonEmptyString(this.facet.options.computedField)) {
	            groupByRequest.computedFields = [{
	                    field: this.facet.options.computedField,
	                    operation: this.facet.options.computedFieldOperation
	                }];
	        }
	        return groupByRequest;
	    };
	    FacetQueryController.prototype.checkForFacetSearchValuesToRemove = function (fieldValues, valueToCheckAgainst) {
	        var _this = this;
	        var regex = FacetUtils_1.FacetUtils.getRegexToUseForFacetSearch(valueToCheckAgainst, this.facet.options.facetSearchIgnoreAccents);
	        return _.filter(fieldValues, function (fieldValue) {
	            var isAllowed = _.isEmpty(_this.facet.options.allowedValues) ||
	                _.contains(_this.facet.options.allowedValues, fieldValue.value);
	            var value = _this.facet.getValueCaption(fieldValue);
	            return isAllowed && regex.test(value);
	        });
	    };
	    return FacetQueryController;
	}());
	exports.FacetQueryController = FacetQueryController;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {/// <reference path="Facet.ts" />
	"use strict";
	var Utils_1 = __webpack_require__(18);
	var FacetUtils_1 = __webpack_require__(82);
	var QueryBuilder_1 = __webpack_require__(77);
	var Dom_1 = __webpack_require__(57);
	var FacetSearchParameters = (function () {
	    function FacetSearchParameters(facet) {
	        this.facet = facet;
	        this.valueToSearch = '';
	        this.alwaysInclude = [];
	        this.alwaysExclude = [];
	        this.sortCriteria = 'occurrences';
	        this.fetchMore = false;
	        this.nbResults = facet.options.numberOfValuesInFacetSearch;
	        this.ignoreAccents = facet.options.facetSearchIgnoreAccents;
	        this.searchEvenIfEmpty = facet.searchInterface.isNewDesign();
	    }
	    FacetSearchParameters.prototype.setValueToSearch = function (value) {
	        this.valueToSearch = value;
	        if (Utils_1.Utils.isNonEmptyString(value)) {
	            this.alwaysInclude = this.alwaysInclude.concat(FacetUtils_1.FacetUtils.getValuesToUseForSearchInFacet(this.valueToSearch, this.facet));
	        }
	        return this;
	    };
	    FacetSearchParameters.prototype.excludeCurrentlyDisplayedValuesInSearch = function (searchResults) {
	        var _this = this;
	        _.each(this.getCurrentlyShowedValueInSearch(searchResults), function (v) {
	            var expandedValues = FacetUtils_1.FacetUtils.getValuesToUseForSearchInFacet(v, _this.facet);
	            _.each(expandedValues, function (expanded) {
	                _this.alwaysExclude.push(expanded);
	            });
	        });
	        _.each(this.facet.getDisplayedFacetValues(), function (v) {
	            var expandedValues = FacetUtils_1.FacetUtils.getValuesToUseForSearchInFacet(v.value, _this.facet);
	            _.each(expandedValues, function (expanded) {
	                _this.alwaysExclude.push(expanded);
	            });
	        });
	    };
	    FacetSearchParameters.prototype.getGroupByRequest = function () {
	        this.lowerCaseAll();
	        var nbResults = this.nbResults;
	        if (this.facet.searchInterface.isNewDesign()) {
	            nbResults += this.alwaysExclude.length;
	        }
	        var typedByUser = [];
	        if (this.valueToSearch) {
	            typedByUser = ['*' + this.valueToSearch + '*'];
	        }
	        var request = {
	            allowedValues: typedByUser.concat(this.alwaysInclude).concat(this.alwaysExclude),
	            maximumNumberOfValues: nbResults,
	            completeFacetWithStandardValues: this.facet.options.lookupField ? false : true,
	            field: this.facet.options.field,
	            sortCriteria: this.facet.options.sortCriteria || this.sortCriteria,
	            injectionDepth: this.facet.options.injectionDepth,
	        };
	        if (this.facet.options.lookupField) {
	            request.lookupField = this.facet.options.lookupField;
	        }
	        if (this.facet.options.computedField) {
	            request.computedFields = [{
	                    field: this.facet.options.computedField,
	                    operation: this.facet.options.computedFieldOperation
	                }];
	        }
	        return request;
	    };
	    FacetSearchParameters.prototype.getQuery = function () {
	        var lastQuery = _.clone(this.facet.queryController.getLastQuery());
	        if (!lastQuery) {
	            // There should normally always be a last query available
	            // If not, just create en empty one.
	            lastQuery = new QueryBuilder_1.QueryBuilder().build();
	        }
	        lastQuery.q = this.facet.facetQueryController.expressionToUseForFacetSearch;
	        lastQuery.cq = this.facet.facetQueryController.constantExpressionToUseForFacetSearch;
	        lastQuery.aq = null;
	        lastQuery.enableDidYouMean = false;
	        lastQuery.firstResult = 0;
	        lastQuery.numberOfResults = 0;
	        lastQuery.fieldsToInclude = [];
	        lastQuery.groupBy = [this.getGroupByRequest()];
	        return lastQuery;
	    };
	    FacetSearchParameters.prototype.getCurrentlyShowedValueInSearch = function (searchResults) {
	        return _.map(Dom_1.$$(searchResults).findAll('.coveo-facet-value-caption'), function (val) {
	            return Dom_1.$$(val).text();
	        });
	    };
	    FacetSearchParameters.prototype.lowerCaseAll = function () {
	        this.alwaysExclude = _.chain(this.alwaysExclude)
	            .map(function (v) {
	            return v.toLowerCase();
	        })
	            .uniq()
	            .value();
	        this.alwaysInclude = _.chain(this.alwaysInclude)
	            .map(function (v) {
	            return v.toLowerCase();
	        })
	            .uniq()
	            .value();
	    };
	    return FacetSearchParameters;
	}());
	exports.FacetSearchParameters = FacetSearchParameters;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var StringUtils_1 = __webpack_require__(61);
	var QueryUtils_1 = __webpack_require__(23);
	var FileTypes_1 = __webpack_require__(60);
	var DateUtils_1 = __webpack_require__(56);
	var Utils_1 = __webpack_require__(18);
	var Dom_1 = __webpack_require__(57);
	var FacetUtils = (function () {
	    function FacetUtils() {
	    }
	    FacetUtils.getRegexToUseForFacetSearch = function (value, ignoreAccent) {
	        return new RegExp(StringUtils_1.StringUtils.stringToRegex(value, ignoreAccent), 'i');
	    };
	    FacetUtils.getValuesToUseForSearchInFacet = function (original, facet) {
	        var ret = [original];
	        var regex = this.getRegexToUseForFacetSearch(original, facet.options.facetSearchIgnoreAccents);
	        if (facet.options.valueCaption) {
	            _.chain(facet.options.valueCaption)
	                .pairs()
	                .filter(function (pair) {
	                return regex.test(pair[1]);
	            })
	                .each(function (match) {
	                ret.push(match[0]);
	            });
	            if (QueryUtils_1.QueryUtils.isStratusAgnosticField(facet.options.field, '@objecttype') || QueryUtils_1.QueryUtils.isStratusAgnosticField(facet.options.field, '@filetype')) {
	                _.each(FileTypes_1.FileTypes.getFileTypeCaptions(), function (value, key) {
	                    if (!(key in facet.options.valueCaption) && regex.test(value)) {
	                        ret.push(key);
	                    }
	                });
	            }
	        }
	        else if (QueryUtils_1.QueryUtils.isStratusAgnosticField(facet.options.field, '@objecttype') || QueryUtils_1.QueryUtils.isStratusAgnosticField(facet.options.field, '@filetype')) {
	            _.each(_.filter(_.pairs(FileTypes_1.FileTypes.getFileTypeCaptions()), function (pair) {
	                return regex.test(pair[1]);
	            }), function (match) {
	                ret.push(match[0]);
	            });
	        }
	        else if (QueryUtils_1.QueryUtils.isStratusAgnosticField(facet.options.field, '@month')) {
	            _.each(_.range(1, 13), function (month) {
	                if (regex.test(DateUtils_1.DateUtils.monthToString(month - 1))) {
	                    ret.push(('0' + month.toString()).substr(-2));
	                }
	            });
	        }
	        return ret;
	    };
	    FacetUtils.buildFacetSearchPattern = function (values) {
	        values = _.map(values, function (value) {
	            return Utils_1.Utils.escapeRegexCharacter(value);
	        });
	        values[0] = '.*' + values[0] + '.*';
	        return values.join('|');
	    };
	    FacetUtils.needAnotherFacetSearch = function (currentSearchLength, newSearchLength, oldSearchLength, desiredSearchLength) {
	        // Something was removed (currentSearch < newSearch)
	        // && we might want to display more facet search result(currentSearch < desiredSearch)
	        // && the new query returned more stuff than the old one so there's still more results(currentSearchLength > oldLength)
	        return currentSearchLength < newSearchLength && currentSearchLength < desiredSearchLength && currentSearchLength > oldSearchLength;
	    };
	    FacetUtils.addNoStateCssClassToFacetValues = function (facet, container) {
	        // This takes care of adding the correct css class on each facet value checkbox (empty white box) if at least one value is selected in that facet
	        if (facet.values.getSelected().length != 0) {
	            var noStates = Dom_1.$$(container).findAll('li:not(.coveo-selected)');
	            _.each(noStates, function (noState) {
	                Dom_1.$$(noState).addClass('coveo-no-state');
	            });
	        }
	    };
	    FacetUtils.tryToGetTranslatedCaption = function (field, value) {
	        var found;
	        if (QueryUtils_1.QueryUtils.isStratusAgnosticField(field.toLowerCase(), '@filetype')) {
	            found = FileTypes_1.FileTypes.getFileTypeCaptions()[value.toLowerCase()];
	        }
	        else if (QueryUtils_1.QueryUtils.isStratusAgnosticField(field.toLowerCase(), '@month')) {
	            try {
	                var month = parseInt(value);
	                found = DateUtils_1.DateUtils.monthToString(month - 1);
	            }
	            catch (ex) {
	            }
	        }
	        return found != undefined && Utils_1.Utils.isNonEmptyString(found) ? found : value;
	    };
	    FacetUtils.clipCaptionsToAvoidOverflowingTheirContainer = function (facet, forceClip) {
	        // in new design, we don't need this : use flexbox instead (sorry IE user)
	        if (facet.getBindings && facet.getBindings().searchInterface && facet.getBindings().searchInterface.isNewDesign()) {
	            return;
	        }
	        if (!(Coveo.HierarchicalFacet && facet instanceof Coveo.HierarchicalFacet) || forceClip) {
	            facet.logger.trace('Clipping captions');
	            // force facet to show to calculate width
	            Dom_1.$$(facet.element).show();
	            var element = facet.element;
	            var captions = Dom_1.$$(element).findAll('.coveo-facet-value-caption');
	            for (var i = 0; i < captions.length; i++) {
	                if (captions[i].style.width != '') {
	                    captions[i].style.width = '';
	                }
	            }
	            var labels = Dom_1.$$(element).findAll('.coveo-facet-value-label-wrapper');
	            var labelsMaxWidth = [];
	            for (var i = 0; i < labels.length; i++) {
	                var label = labels[i];
	                var caption = Dom_1.$$(label).find('.coveo-facet-value-caption');
	                var labelWidth = label.scrollWidth;
	                var labelVisibleWidth = label.clientWidth;
	                var captionWidth = caption.scrollWidth;
	                var crop = Math.max(0, labelWidth - labelVisibleWidth);
	                if (crop) {
	                    labelsMaxWidth.push({
	                        element: caption,
	                        width: captionWidth,
	                        crop: crop,
	                        label: label
	                    });
	                }
	            }
	            // remove the specific css class
	            element.style.display = '';
	            for (var i = 0; i < labelsMaxWidth.length; i++) {
	                var labelMaxWidth = labelsMaxWidth[i];
	                labelMaxWidth.element.style.width = labelMaxWidth.width - labelMaxWidth.crop + 'px';
	                if (labelMaxWidth.crop > 0) {
	                    labelMaxWidth.label.setAttribute('title', Dom_1.$$(labelMaxWidth.element).text());
	                }
	                else {
	                    labelMaxWidth.label.setAttribute('title', null);
	                }
	            }
	        }
	    };
	    return FacetUtils;
	}());
	exports.FacetUtils = FacetUtils;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	/// <reference path="../ui/FacetRange/FacetRange.ts" />
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var FacetQueryController_1 = __webpack_require__(80);
	var Utils_1 = __webpack_require__(18);
	var FacetRangeQueryController = (function (_super) {
	    __extends(FacetRangeQueryController, _super);
	    function FacetRangeQueryController(facet) {
	        _super.call(this, facet);
	        this.facet = facet;
	    }
	    FacetRangeQueryController.prototype.createBasicGroupByRequest = function (allowedValues, addComputedField) {
	        if (addComputedField === void 0) { addComputedField = true; }
	        var groupByQuery = _super.prototype.createBasicGroupByRequest.call(this, null, addComputedField);
	        groupByQuery.allowedValues = undefined;
	        if (Utils_1.Utils.isNonEmptyArray(this.facet.options.ranges)) {
	            groupByQuery = this.buildGroupByQueryForPredefinedRanges(groupByQuery);
	        }
	        else {
	            groupByQuery = this.buildGroupByQueryForAutomaticRanges(groupByQuery);
	        }
	        return groupByQuery;
	    };
	    FacetRangeQueryController.prototype.createGroupByAllowedValues = function () {
	        return undefined;
	    };
	    FacetRangeQueryController.prototype.buildGroupByQueryForAutomaticRanges = function (groupByQuery) {
	        groupByQuery.generateAutomaticRanges = true;
	        return groupByQuery;
	    };
	    FacetRangeQueryController.prototype.buildGroupByQueryForPredefinedRanges = function (groupByQuery) {
	        groupByQuery.rangeValues = this.facet.options.ranges;
	        groupByQuery.maximumNumberOfValues = this.facet.options.ranges.length;
	        return groupByQuery;
	    };
	    return FacetRangeQueryController;
	}(FacetQueryController_1.FacetQueryController));
	exports.FacetRangeQueryController = FacetRangeQueryController;


/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {/// <reference path="../ui/FacetSlider/FacetSlider.ts" />
	"use strict";
	var QueryEvents_1 = __webpack_require__(47);
	var ExpressionBuilder_1 = __webpack_require__(78);
	var DateUtils_1 = __webpack_require__(56);
	var FacetSliderQueryController = (function () {
	    function FacetSliderQueryController(facet) {
	        var _this = this;
	        this.facet = facet;
	        this.facet.bind.onRootElement(QueryEvents_1.QueryEvents.querySuccess, function (args) { return _this.handleQuerySuccess(args); });
	    }
	    FacetSliderQueryController.prototype.prepareForNewQuery = function () {
	        this.lastGroupByRequestIndex = undefined;
	    };
	    FacetSliderQueryController.prototype.putGroupByIntoQueryBuilder = function (queryBuilder) {
	        if (this.facet.options.graph) {
	            this.putGroupByForGraphIntoQueryBuilder(queryBuilder);
	        }
	        this.putGroupByForSliderIntoQueryBuilder(queryBuilder);
	    };
	    FacetSliderQueryController.prototype.createBasicGroupByRequest = function (allowedValues, addComputedField) {
	        if (addComputedField === void 0) { addComputedField = true; }
	        var groupByQuery = {
	            field: this.facet.options.field,
	            completeFacetWithStandardValues: true
	        };
	        groupByQuery.allowedValues = undefined;
	        if (this.facet.options.graph) {
	            groupByQuery = this.buildGroupByQueryForSlider(groupByQuery);
	        }
	        else {
	            groupByQuery = this.buildGroupByQueryForAutomaticRanges(groupByQuery);
	        }
	        return groupByQuery;
	    };
	    FacetSliderQueryController.prototype.computeOurFilterExpression = function (boundary) {
	        if (boundary === void 0) { boundary = [this.facet.startOfSlider, this.facet.endOfSlider]; }
	        var builder = new ExpressionBuilder_1.ExpressionBuilder();
	        if (boundary[0] != undefined && boundary[1] != undefined) {
	            if (this.facet.options.excludeOuterBounds) {
	                this.addFilterExpressionWithOuterBoundsExcluded(boundary[0], boundary[1], builder);
	            }
	            else {
	                this.addFilterExpressionWithOuterBoundsIncluded(boundary[0], boundary[1], builder);
	            }
	        }
	        return builder.build();
	    };
	    FacetSliderQueryController.prototype.handleQuerySuccess = function (args) {
	        var _this = this;
	        if (this.facet.options && this.facet.options.graph && this.rangeValuesForGraphToUse == undefined) {
	            this.rangeValuesForGraphToUse = [];
	            var rawValues = args.results.groupByResults[this.graphGroupByQueriesIndex].values;
	            _.each(rawValues, function (rawValue) {
	                var rawSplit = rawValue.value.split('..');
	                _this.rangeValuesForGraphToUse.push({
	                    start: _this.facet.options.dateField ? _this.getISOFormat(rawSplit[0].replace('@', ' ')) : parseInt(rawSplit[0], 10),
	                    end: _this.facet.options.dateField ? _this.getISOFormat(rawSplit[1].replace('@', ' ')) : parseInt(rawSplit[1], 10)
	                });
	            });
	        }
	    };
	    FacetSliderQueryController.prototype.addFilterExpressionWithOuterBoundsIncluded = function (start, end, builder) {
	        if (start != this.facet.options.start || end != this.facet.options.end) {
	            if (this.facet.options.dateField) {
	                start = this.getFilterDateFormat(start);
	                end = this.getFilterDateFormat(end);
	            }
	            builder.addFieldExpression(this.facet.options.field, '==', [start + '..' + end]);
	        }
	    };
	    FacetSliderQueryController.prototype.addFilterExpressionWithOuterBoundsExcluded = function (start, end, builder) {
	        var startCompare = this.facet.options.start;
	        var endCompare = this.facet.options.end;
	        var startCompared = start;
	        var endCompared = end;
	        if (this.facet.options.dateField) {
	            startCompared = this.getFilterDateFormat(start);
	            endCompared = this.getFilterDateFormat(end);
	            startCompare = this.getFilterDateFormat(startCompare);
	            endCompare = this.getFilterDateFormat(endCompare);
	        }
	        else {
	            startCompared += '';
	            endCompared += '';
	            startCompare += '';
	            endCompare += '';
	        }
	        if (startCompared != startCompare && endCompared == endCompare) {
	            builder.addFieldExpression(this.facet.options.field, '>=', [startCompared]);
	        }
	        else if (startCompared == startCompare && endCompared != endCompare) {
	            builder.addFieldExpression(this.facet.options.field, '<=', [endCompared]);
	        }
	        else {
	            this.addFilterExpressionWithOuterBoundsIncluded(start, end, builder);
	        }
	    };
	    FacetSliderQueryController.prototype.buildGroupByQueryForSlider = function (groupByQuery) {
	        if (this.facet.options.start != undefined && this.facet.options.end != undefined) {
	            var start = this.facet.options.start;
	            var end = this.facet.options.end;
	            if (this.facet.options.dateField || this.facet.options.dateField) {
	                start = this.getISOFormat(start);
	                end = this.getISOFormat(end);
	            }
	            groupByQuery.rangeValues = [{
	                    start: start,
	                    end: end,
	                    endInclusive: true,
	                    label: 'Slider'
	                }];
	            return groupByQuery;
	        }
	        else {
	            return this.buildGroupByQueryForAutomaticRanges(groupByQuery);
	        }
	    };
	    FacetSliderQueryController.prototype.buildGroupByQueryForAutomaticRanges = function (groupByQuery) {
	        groupByQuery.generateAutomaticRanges = true;
	        return groupByQuery;
	    };
	    FacetSliderQueryController.prototype.putGroupByForGraphIntoQueryBuilder = function (queryBuilder) {
	        this.graphGroupByQueriesIndex = queryBuilder.groupByRequests.length;
	        var basicGroupByRequestForGraph = this.createBasicGroupByRequest();
	        if (basicGroupByRequestForGraph.rangeValues) {
	            var basicRangeRequest = basicGroupByRequestForGraph.rangeValues[0];
	            basicGroupByRequestForGraph.rangeValues = this.createRangeValuesForGraph(basicRangeRequest);
	        }
	        var filter = this.computeOurFilterExpression(this.facet.getSliderBoundaryForQuery());
	        if (filter != undefined) {
	            var queryOverrideObject = queryBuilder.computeCompleteExpressionPartsExcept(filter);
	            basicGroupByRequestForGraph.queryOverride = queryOverrideObject.basic;
	            basicGroupByRequestForGraph.advancedQueryOverride = queryOverrideObject.advanced;
	            basicGroupByRequestForGraph.constantQueryOverride = queryOverrideObject.constant;
	            if (basicGroupByRequestForGraph.queryOverride == undefined) {
	                basicGroupByRequestForGraph.queryOverride = this.facet.options.queryOverride || '@uri';
	            }
	            else {
	                basicGroupByRequestForGraph.queryOverride += (this.facet.options.queryOverride ? ' ' + this.facet.options.queryOverride : '');
	            }
	        }
	        else if (this.facet.options.queryOverride != null) {
	            var completeExpression = queryBuilder.computeCompleteExpression();
	            basicGroupByRequestForGraph.queryOverride = (completeExpression != null ? completeExpression + ' ' : '') + this.facet.options.queryOverride;
	        }
	        basicGroupByRequestForGraph.sortCriteria = 'nosort';
	        basicGroupByRequestForGraph.maximumNumberOfValues = this.facet.options.graph.steps;
	        queryBuilder.groupByRequests.push(basicGroupByRequestForGraph);
	    };
	    FacetSliderQueryController.prototype.putGroupByForSliderIntoQueryBuilder = function (queryBuilder) {
	        this.lastGroupByRequestIndex = queryBuilder.groupByRequests.length;
	        var basicGroupByRequestForSlider = this.createBasicGroupByRequest();
	        basicGroupByRequestForSlider.maximumNumberOfValues = this.facet.options.graph != null ? this.facet.options.graph.steps || 1 : 1;
	        basicGroupByRequestForSlider.queryOverride = this.facet.options.queryOverride || '@uri';
	        basicGroupByRequestForSlider.sortCriteria = 'nosort';
	        basicGroupByRequestForSlider.generateAutomaticRanges = true;
	        basicGroupByRequestForSlider.rangeValues = undefined;
	        queryBuilder.groupByRequests.push(basicGroupByRequestForSlider);
	    };
	    FacetSliderQueryController.prototype.createRangeValuesForGraph = function (basicRangeRequest) {
	        if (this.facet.options.graph.steps == undefined) {
	            this.facet.options.graph.steps = 10;
	        }
	        if (this.facet.options.dateField && isNaN(this.facet.options.start)) {
	            this.facet.options.start = new Date(this.facet.options.start).getTime();
	        }
	        if (this.facet.options.dateField && isNaN(this.facet.options.end)) {
	            this.facet.options.end = new Date(this.facet.options.end).getTime();
	        }
	        if (this.rangeValuesForGraphToUse != undefined) {
	            return this.usePrebuiltRange(basicRangeRequest);
	        }
	        else {
	            return this.buildRange(basicRangeRequest);
	        }
	    };
	    FacetSliderQueryController.prototype.usePrebuiltRange = function (basicRangeRequest) {
	        return _.map(this.rangeValuesForGraphToUse, function (value) {
	            return {
	                start: value.start,
	                end: value.end,
	                endInclusive: basicRangeRequest.endInclusive,
	                label: basicRangeRequest.label
	            };
	        });
	    };
	    FacetSliderQueryController.prototype.buildRange = function (basicRangeRequest) {
	        var _this = this;
	        var start = this.facet.options.start;
	        var oneStep = (this.facet.options.end - this.facet.options.start) / this.facet.options.graph.steps;
	        return _.map(_.range(0, this.facet.options.graph.steps, 1), function (step) {
	            var newStart = start + (step * oneStep);
	            var newEnd = start + ((step + 1) * oneStep);
	            if (_this.facet.options.dateField) {
	                newStart = _this.getISOFormat(newStart);
	                newEnd = _this.getISOFormat(newEnd);
	            }
	            return {
	                endInclusive: basicRangeRequest.endInclusive,
	                label: basicRangeRequest.label,
	                start: newStart,
	                end: newEnd
	            };
	        });
	    };
	    FacetSliderQueryController.prototype.getISOFormat = function (value) {
	        if (value) {
	            if (!isNaN(value)) {
	                value = Number(value);
	            }
	            var date = new Date(value);
	            if (!DateUtils_1.DateUtils.isValid(date)) {
	                date = new Date(this.getBrowserCompatibleFormat(value));
	                if (!DateUtils_1.DateUtils.isValid(date)) {
	                    // If we get here, we'll probably get an error further down the line when querying the index anyway ...
	                    this.facet.logger.error('Cannot parse this date format.', value, new Date(value));
	                    return undefined;
	                }
	            }
	            return date.toISOString();
	        }
	        else {
	            return undefined;
	        }
	    };
	    FacetSliderQueryController.prototype.getFilterDateFormat = function (rawValue) {
	        if (rawValue) {
	            return this.getISOFormat(rawValue).replace('T', '@').replace('.000Z', '').replace(/-/g, '/');
	        }
	        else {
	            return undefined;
	        }
	    };
	    FacetSliderQueryController.prototype.getBrowserCompatibleFormat = function (value) {
	        return value.replace('@', 'T').replace(/\//g, '-');
	    };
	    return FacetSliderQueryController;
	}());
	exports.FacetSliderQueryController = FacetSliderQueryController;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	/// <reference path="../ui/HierarchicalFacet/HierarchicalFacet.ts" />
	/// <reference path="./FacetQueryController.ts" />
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var FacetQueryController_1 = __webpack_require__(80);
	var HierarchicalFacetQueryController = (function (_super) {
	    __extends(HierarchicalFacetQueryController, _super);
	    function HierarchicalFacetQueryController(facet) {
	        _super.call(this, facet);
	        this.facet = facet;
	    }
	    return HierarchicalFacetQueryController;
	}(FacetQueryController_1.FacetQueryController));
	exports.HierarchicalFacetQueryController = HierarchicalFacetQueryController;


/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Assert_1 = __webpack_require__(17);
	var Model_1 = __webpack_require__(87);
	var InitializationEvents_1 = __webpack_require__(44);
	var Dom_1 = __webpack_require__(57);
	var HashUtils_1 = __webpack_require__(65);
	var Defer_1 = __webpack_require__(31);
	var RootComponent_1 = __webpack_require__(75);
	/**
	 * This component is instantiated automatically by the framework on the root if the {@link SearchInterface}.<br/>
	 * When the {@link SearchInterface.options.enableHistory} option is set to true, this component is instantiated.<br/>
	 * It's only job is to apply changes in the {@link QueryStateModel} to the hash in the URL, and vice versa.<br/>
	 * This component does *not* hold the state of the interface, it only represent it in the URL.
	 */
	var HistoryController = (function (_super) {
	    __extends(HistoryController, _super);
	    /**
	     * Create a new history controller
	     * @param element
	     * @param windoh For mock / test purpose.
	     * @param model
	     * @param queryController
	     */
	    function HistoryController(element, windoh, model, queryController) {
	        var _this = this;
	        _super.call(this, element, HistoryController.ID);
	        this.windoh = windoh;
	        this.model = model;
	        this.queryController = queryController;
	        this.ignoreNextHashChange = false;
	        this.initialHashChange = false;
	        this.willUpdateHash = false;
	        this.windoh = this.windoh || window;
	        Assert_1.Assert.exists(this.model);
	        Assert_1.Assert.exists(this.queryController);
	        Dom_1.$$(this.element).on(InitializationEvents_1.InitializationEvents.restoreHistoryState, function () {
	            _this.logger.trace('Restore history state. Update model');
	            _this.updateModelFromHash();
	        });
	        Dom_1.$$(this.element).on(this.model.getEventName(Model_1.Model.eventTypes.all), function () {
	            _this.logger.trace('Query model changed. Update hash');
	            _this.updateHashFromModel();
	        });
	        this.hashchange = function () {
	            _this.handleHashChange();
	        };
	        this.windoh.addEventListener('hashchange', this.hashchange);
	        Dom_1.$$(this.element).on(InitializationEvents_1.InitializationEvents.nuke, function () { return _this.handleNuke(); });
	    }
	    /**
	     * Set the given map of key value in the hash of the URL
	     * @param values
	     */
	    HistoryController.prototype.setHashValues = function (values) {
	        this.logger.trace('Update history hash');
	        var hash = '#' + HashUtils_1.HashUtils.encodeValues(values);
	        this.ignoreNextHashChange = this.windoh.location.hash != hash;
	        this.logger.trace('ignoreNextHashChange', this.ignoreNextHashChange);
	        this.logger.trace('initialHashChange', this.initialHashChange);
	        this.logger.trace('from', this.windoh.location.hash, 'to', hash);
	        if (this.initialHashChange) {
	            this.initialHashChange = false;
	            this.windoh.location.replace(hash);
	            this.logger.trace('History hash modified', hash);
	        }
	        else if (this.ignoreNextHashChange) {
	            this.windoh.location.hash = hash;
	            this.logger.trace('History hash created', hash);
	        }
	    };
	    HistoryController.prototype.handleNuke = function () {
	        this.windoh.removeEventListener('hashchange', this.hashchange);
	    };
	    HistoryController.prototype.handleHashChange = function () {
	        this.logger.trace('History hash changed');
	        if (this.ignoreNextHashChange) {
	            this.logger.trace('History hash change ignored');
	            this.ignoreNextHashChange = false;
	            return;
	        }
	        var diff = this.updateModelFromHash();
	        if (_.difference(diff, HistoryController.attributesThatDoNotTriggerQuery).length > 0) {
	            this.queryController.executeQuery();
	        }
	    };
	    HistoryController.prototype.updateHashFromModel = function () {
	        var _this = this;
	        this.logger.trace('Model -> history hash');
	        if (!this.willUpdateHash) {
	            Defer_1.Defer.defer(function () {
	                var attributes = _this.model.getAttributes();
	                _this.setHashValues(attributes);
	                _this.logger.debug('Saving state to hash', attributes);
	                _this.willUpdateHash = false;
	            });
	            this.willUpdateHash = true;
	        }
	    };
	    HistoryController.prototype.updateModelFromHash = function () {
	        var _this = this;
	        this.logger.trace('History hash -> model');
	        var toSet = {};
	        var diff = [];
	        _.each(this.model.attributes, function (value, key, obj) {
	            var valToSet = _this.getHashValue(key);
	            if (valToSet == undefined) {
	                valToSet = _this.model.defaultAttributes[key];
	            }
	            toSet[key] = valToSet;
	            if (_this.model.get(key) != valToSet) {
	                diff.push(key);
	            }
	        });
	        this.initialHashChange = true;
	        this.model.setMultiple(toSet);
	        return diff;
	    };
	    HistoryController.prototype.getHashValue = function (value) {
	        Assert_1.Assert.isNonEmptyString(value);
	        return HashUtils_1.HashUtils.getValue(value, HashUtils_1.HashUtils.getHash(this.windoh));
	    };
	    HistoryController.prototype.debugInfo = function () {
	        return {
	            'state': this.model.getAttributes()
	        };
	    };
	    HistoryController.ID = 'HistoryController';
	    HistoryController.attributesThatDoNotTriggerQuery = ['quickview'];
	    return HistoryController;
	}(RootComponent_1.RootComponent));
	exports.HistoryController = HistoryController;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Dom_1 = __webpack_require__(57);
	var Assert_1 = __webpack_require__(17);
	var Utils_1 = __webpack_require__(18);
	var BaseComponent_1 = __webpack_require__(76);
	exports.MODEL_EVENTS = {
	    PREPROCESS: 'preprocess',
	    CHANGE_ONE: 'change:',
	    CHANGE: 'change',
	    RESET: 'reset',
	    ALL: 'all'
	};
	/**
	 * A model is basically a key -> value store that trigger letious javascript event when one of the value for each of it's key changes.<br/>
	 * This is a class that is meant to be extended : the most important one probably being the {@link QueryStateModel}<br/>
	 * Component set values in this key -> value store, and listen to event triggered to react accordingly.<br/>
	 */
	var Model = (function (_super) {
	    __extends(Model, _super);
	    function Model(element, id, attributes) {
	        _super.call(this, element, id);
	        this.eventNameSpace = id;
	        this.defaultAttributes = Utils_1.Utils.extendDeep(this.defaultAttributes, attributes);
	        this.attributes = attributes;
	        this.logger.debug('Creating model');
	    }
	    Model.prototype.set = function (attribute, value, options) {
	        var toSet = {};
	        toSet[attribute] = value;
	        this.setMultiple(toSet, options);
	    };
	    Model.prototype.getAttributes = function () {
	        var _this = this;
	        var attributes = {};
	        _.each(this.attributes, function (attribute, key) {
	            if (_.isObject(attribute)) {
	                if (!Utils_1.Utils.objectEqual(attribute, _this.defaultAttributes[key])) {
	                    attributes[key] = attribute;
	                }
	            }
	            else if (attribute != _this.defaultAttributes[key]) {
	                attributes[key] = attribute;
	            }
	        });
	        return attributes;
	    };
	    Model.prototype.setMultiple = function (toSet, options) {
	        var _this = this;
	        var anythingChanged = false;
	        this.preprocessEvent(toSet);
	        _.each(toSet, function (value, attribute) {
	            if (!options || !options.customAttribute) {
	                _this.checkIfAttributeExists(attribute);
	            }
	            value = _this.parseToCorrectType(attribute, value);
	            if (!options || options.validateType) {
	                _this.validateType(attribute, value);
	            }
	            if (_this.checkIfAttributeChanged(attribute, value)) {
	                _this.attributes[attribute] = value;
	                anythingChanged = true;
	                if (options == null || !options.silent) {
	                    _this.attributeHasChangedEvent(attribute);
	                }
	            }
	        });
	        if (anythingChanged && (options == null || !options.silent)) {
	            this.attributesHasChangedEvent();
	            this.anyEvent();
	        }
	    };
	    Model.prototype.setNewDefault = function (attribute, value, options) {
	        if (!options || !options.customAttribute) {
	            this.checkIfAttributeExists(attribute);
	        }
	        this.defaultAttributes[attribute] = value;
	    };
	    Model.prototype.setDefault = function (attribute, options) {
	        this.set(attribute, this.defaultAttributes[attribute]);
	    };
	    Model.prototype.get = function (attribute) {
	        if (attribute == undefined) {
	            return this.attributes;
	        }
	        else {
	            return this.attributes[attribute];
	        }
	    };
	    Model.prototype.getDefault = function (attribute) {
	        if (attribute == undefined) {
	            return this.defaultAttributes;
	        }
	        else {
	            return this.defaultAttributes[attribute];
	        }
	    };
	    Model.prototype.reset = function () {
	        this.setMultiple(this.defaultAttributes);
	        this.modelWasResetEvent();
	    };
	    Model.prototype.registerNewAttribute = function (attribute, defaultValue) {
	        this.defaultAttributes[attribute] = defaultValue;
	        this.attributes[attribute] = defaultValue;
	    };
	    Model.prototype.getEventName = function (event) {
	        return this.eventNameSpace + ':' + event;
	    };
	    Model.prototype.attributesHasChangedEvent = function () {
	        Dom_1.$$(this.element).trigger(this.getEventName(Model.eventTypes.change), this.createAttributesChangedArgument());
	    };
	    Model.prototype.attributeHasChangedEvent = function (attr) {
	        Dom_1.$$(this.element).trigger(this.getEventName(Model.eventTypes.changeOne) + attr, this.createAttributeChangedArgument(attr));
	    };
	    Model.prototype.preprocessEvent = function (attributes) {
	        Dom_1.$$(this.element).trigger(this.getEventName(Model.eventTypes.preprocess), attributes);
	    };
	    Model.prototype.modelWasResetEvent = function () {
	        Dom_1.$$(this.element).trigger(this.getEventName(Model.eventTypes.reset), this.createModelChangedArgument());
	    };
	    Model.prototype.anyEvent = function () {
	        Dom_1.$$(this.element).trigger(this.getEventName(Model.eventTypes.all), this.createModelChangedArgument());
	    };
	    Model.prototype.createAttributeChangedArgument = function (attribute) {
	        return { attribute: attribute, value: this.attributes[attribute] };
	    };
	    Model.prototype.createAttributesChangedArgument = function () {
	        return { attributes: this.attributes };
	    };
	    Model.prototype.createModelChangedArgument = function () {
	        return { model: this };
	    };
	    Model.prototype.checkIfAttributeExists = function (attribute) {
	        Assert_1.Assert.check(_.has(this.attributes, attribute));
	    };
	    Model.prototype.validateType = function (attribute, value) {
	        if (!Utils_1.Utils.isNullOrUndefined(this.attributes[attribute]) && !Utils_1.Utils.isUndefined(value)) {
	            if (_.isNumber(this.attributes[attribute])) {
	                Assert_1.Assert.check(_.isNumber(value) && !isNaN(value), 'Non-matching type');
	            }
	            else if (_.isBoolean(this.attributes[attribute])) {
	                Assert_1.Assert.check(_.isBoolean(value) || Utils_1.Utils.parseBooleanIfNotUndefined(value) !== undefined, 'Non-matching type');
	            }
	            else {
	                if (!Utils_1.Utils.isNullOrUndefined(this.defaultAttributes[attribute])) {
	                    Assert_1.Assert.check(typeof value === typeof this.defaultAttributes[attribute], 'Non-matching type');
	                }
	            }
	        }
	    };
	    Model.prototype.parseToCorrectType = function (attribute, value) {
	        if (_.isNumber(this.attributes[attribute])) {
	            return parseInt(value, 10);
	        }
	        else if (_.isBoolean(this.attributes[attribute])) {
	            if (_.isBoolean(value)) {
	                return value;
	            }
	            else {
	                return Utils_1.Utils.parseBooleanIfNotUndefined(value);
	            }
	        }
	        return value;
	    };
	    Model.prototype.checkIfAttributeChanged = function (attribute, newValue) {
	        var oldValue = this.attributes[attribute];
	        if (_.isNumber(oldValue) || _.isString(oldValue) || _.isBoolean(oldValue)) {
	            return oldValue !== newValue;
	        }
	        if (_.isArray(oldValue)) {
	            return !Utils_1.Utils.arrayEqual(oldValue, newValue);
	        }
	        if (_.isObject(oldValue)) {
	            return !Utils_1.Utils.objectEqual(oldValue, newValue);
	        }
	        return true;
	    };
	    Model.prototype.debugInfo = function () {
	        return null;
	    };
	    // changeOne: is when one specific attribute change, change is when any attribute change
	    /**
	     * The event type that can be triggered :<br/>
	     * -- preprocess -> triggered before a value is set on an attribute, to allow to modify it before it's set.<br/>
	     * -- changeOne -> triggered when a single value change.
	     * @type {{preprocess: string, changeOne: string, change: string, reset: string, all: string}}
	     */
	    Model.eventTypes = {
	        preprocess: 'preprocess',
	        changeOne: 'change:',
	        change: 'change',
	        reset: 'reset',
	        all: 'all'
	    };
	    return Model;
	}(BaseComponent_1.BaseComponent));
	exports.Model = Model;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var LocalStorageUtils_1 = __webpack_require__(69);
	var Model_1 = __webpack_require__(87);
	var Logger_1 = __webpack_require__(16);
	var Assert_1 = __webpack_require__(17);
	var InitializationEvents_1 = __webpack_require__(44);
	var RootComponent_1 = __webpack_require__(75);
	var Dom_1 = __webpack_require__(57);
	/**
	 * This component acts like the {@link HistoryController} excepts that is saves the {@link QueryStateModel} in the local storage.<br/>
	 * This will not allow 'back' and 'forward' navigation in the history, like the standard {@link HistoryController} allows. Instead, it load the query state only on page load.<br/>
	 * To enable this component, you should set the {@link SearchInterface.options.useLocalStorageForHistory} as well as the {@link SearchInterface.options.enableHistory} options to true.
	 */
	var LocalStorageHistoryController = (function (_super) {
	    __extends(LocalStorageHistoryController, _super);
	    /**
	     * Create a new LocalStorageHistoryController instance
	     * @param element
	     * @param windoh For mock purpose
	     * @param model
	     * @param queryController
	     */
	    function LocalStorageHistoryController(element, windoh, model, queryController) {
	        var _this = this;
	        _super.call(this, element, LocalStorageHistoryController.ID);
	        this.windoh = windoh;
	        this.model = model;
	        this.queryController = queryController;
	        this.omit = [];
	        if (!windoh['localStorage']) {
	            new Logger_1.Logger(element).info('No local storage available in current browser. LocalStorageHistoryController cannot initialize itself', this);
	        }
	        else {
	            this.storage = new LocalStorageUtils_1.LocalStorageUtils(LocalStorageHistoryController.ID);
	            Assert_1.Assert.exists(this.model);
	            Assert_1.Assert.exists(this.queryController);
	            Dom_1.$$(this.element).on(InitializationEvents_1.InitializationEvents.restoreHistoryState, function () { return _this.updateModelFromLocalStorage(); });
	            Dom_1.$$(this.element).on(this.model.getEventName(Model_1.Model.eventTypes.all), function () { return _this.updateLocalStorageFromModel(); });
	        }
	    }
	    /**
	     * Specifies an array of attributes from the query state model that should not be persisted in the local storage
	     * @param attributes
	     */
	    LocalStorageHistoryController.prototype.withoutThoseAttribute = function (attributes) {
	        this.omit = attributes;
	    };
	    LocalStorageHistoryController.prototype.updateLocalStorageFromModel = function () {
	        var attributes = _.omit(this.model.getAttributes(), this.omit);
	        this.setStorageValues(attributes);
	        this.logger.debug('Saving state to localstorage', attributes);
	    };
	    LocalStorageHistoryController.prototype.updateModelFromLocalStorage = function () {
	        var _this = this;
	        var toSet = {};
	        var loadedFromStorage = this.storage.load();
	        _.each(this.model.attributes, function (value, key, obj) {
	            var valToSet = loadedFromStorage ? loadedFromStorage[key] : undefined;
	            if (valToSet == undefined) {
	                valToSet = _this.model.defaultAttributes[key];
	            }
	            toSet[key] = valToSet;
	        });
	        this.model.setMultiple(toSet);
	    };
	    LocalStorageHistoryController.prototype.setStorageValues = function (values) {
	        this.storage.save(values);
	    };
	    LocalStorageHistoryController.ID = 'LocalStorageHistoryController';
	    return LocalStorageHistoryController;
	}(RootComponent_1.RootComponent));
	exports.LocalStorageHistoryController = LocalStorageHistoryController;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var Model_1 = __webpack_require__(87);
	exports.Model = Model_1.Model;
	var QueryStateModel_1 = __webpack_require__(90);
	exports.QueryStateModel = QueryStateModel_1.QueryStateModel;
	var ComponentOptionsModel_1 = __webpack_require__(91);
	exports.ComponentOptionsModel = ComponentOptionsModel_1.ComponentOptionsModel;
	var ComponentStateModel_1 = __webpack_require__(92);
	exports.ComponentStateModel = ComponentStateModel_1.ComponentStateModel;


/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Model_1 = __webpack_require__(87);
	var Assert_1 = __webpack_require__(17);
	var Utils_1 = __webpack_require__(18);
	exports.QUERY_STATE_ATTRIBUTES = {
	    Q: 'q',
	    FIRST: 'first',
	    T: 't',
	    TG: 'tg',
	    SORT: 'sort',
	    HD: 'hd',
	    HQ: 'hq',
	    QUICKVIEW: 'quickview'
	};
	/**
	 * The QueryStateModel is a key->value store of the state of every component that can affect a query.<br/>
	 * Component set values in this key -> value store, and listen to event triggered to react accordingly.<br/>
	 * For example, when a query is launched, the searchbox will set the 'q' attribute, the pager will set the 'first' attribute, etc.<br/>
	 * At the same time, this class will trigger the associated event when a value is modified.<br/>
	 * eg : The user change the content of the searchbox, and submit a query. This will trigger the following events :<br/>
	 * -- state:change:q (because the value of 'q' changed)</br>
	 * -- state:change (because at least one value changed in the query state)<br/>
	 * Component or external code could hook handler on those events : document.addEventListener('state:change:q', handler);<br/>
	 * See : {@link Model}, as all the relevant method are exposed in the base class.<br/>
	 * Optionally, the state can be persisted to the query string to allow browser history management : See {@link HistoryController}
	 */
	var QueryStateModel = (function (_super) {
	    __extends(QueryStateModel, _super);
	    /**
	     * Create a new QueryState
	     * @param element
	     * @param attributes
	     * @param bindings
	     */
	    function QueryStateModel(element, attributes) {
	        var merged = _.extend({}, QueryStateModel.defaultAttributes, attributes);
	        _super.call(this, element, QueryStateModel.ID, merged);
	    }
	    QueryStateModel.getFacetId = function (id, include) {
	        if (include === void 0) { include = true; }
	        return 'f:' + id + (include ? '' : ':not');
	    };
	    QueryStateModel.getFacetOperator = function (id) {
	        return 'f:' + id + ':operator';
	    };
	    QueryStateModel.getFacetLookupValue = function (id) {
	        return QueryStateModel.getFacetId(id) + ':lookupvalues';
	    };
	    /**
	     * Determine if at least one facet is currently active in the interface (this means that a facet has selected or excluded values)
	     * @returns {boolean}
	     */
	    QueryStateModel.prototype.atLeastOneFacetIsActive = function () {
	        return !_.isUndefined(_.find(this.attributes, function (value, key) {
	            return key.indexOf('f:') == 0 && Utils_1.Utils.isNonEmptyArray(value) && key.indexOf(':range') < 0;
	        }));
	    };
	    QueryStateModel.prototype.set = function (attribute, value, options) {
	        this.validate(attribute, value);
	        _super.prototype.set.call(this, attribute, value, options);
	    };
	    QueryStateModel.prototype.validate = function (attribute, value) {
	        if (attribute == QueryStateModel.attributesEnum.first) {
	            Assert_1.Assert.isLargerOrEqualsThan(0, value);
	        }
	    };
	    QueryStateModel.ID = 'state';
	    QueryStateModel.defaultAttributes = {
	        q: '',
	        first: 0,
	        t: '',
	        hd: '',
	        hq: '',
	        sort: '',
	        tg: '',
	        quickview: ''
	    };
	    QueryStateModel.attributesEnum = {
	        q: 'q',
	        first: 'first',
	        t: 't',
	        sort: 'sort',
	        hd: 'hd',
	        hq: 'hq',
	        tg: 'tg',
	        quickview: 'quickview'
	    };
	    return QueryStateModel;
	}(Model_1.Model));
	exports.QueryStateModel = QueryStateModel;
	function setState(model, args) {
	    Assert_1.Assert.exists(model);
	    if (args.length == 0 || args[0] == undefined) {
	        // No args means return the model
	        return model;
	    }
	    else if (args.length == 1 && Utils_1.Utils.isNonEmptyString(args[0])) {
	        // One string arg means retrieve value from model
	        return model.get(args[0]);
	    }
	    else if (_.isObject(args[0])) {
	        // One dictionary means set multiple values
	        var toSet = args[0];
	        var options = _.extend({ customAttribute: true }, args[1]);
	        return model.setMultiple(toSet, options);
	    }
	    else if (args.length > 1) {
	        // Otherwise we're setting a value
	        var name_1 = args[0];
	        var value = args[1];
	        var options = _.extend({ customAttribute: true }, args[2]);
	        Assert_1.Assert.isNonEmptyString(name_1);
	        return model.set(name_1, value, options);
	    }
	}
	exports.setState = setState;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Model_1 = __webpack_require__(87);
	var ComponentOptionsModel = (function (_super) {
	    __extends(ComponentOptionsModel, _super);
	    function ComponentOptionsModel(element, attributes) {
	        var merged = _.extend({}, ComponentOptionsModel.defaultAttributes, attributes);
	        _super.call(this, element, ComponentOptionsModel.ID, merged);
	    }
	    ComponentOptionsModel.ID = 'ComponentOptions';
	    ComponentOptionsModel.defaultAttributes = {
	        resultLink: undefined,
	        searchHub: undefined
	    };
	    ComponentOptionsModel.attributesEnum = {
	        resultLink: 'resultLink',
	        searchHub: 'searchHub'
	    };
	    return ComponentOptionsModel;
	}(Model_1.Model));
	exports.ComponentOptionsModel = ComponentOptionsModel;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Model_1 = __webpack_require__(87);
	var ComponentStateModel = (function (_super) {
	    __extends(ComponentStateModel, _super);
	    function ComponentStateModel(element) {
	        _super.call(this, element, ComponentStateModel.ID, {});
	    }
	    ComponentStateModel.prototype.registerComponent = function (componentId, component) {
	        var currentAttribute = this.attributes[componentId];
	        if (currentAttribute == undefined) {
	            this.attributes[componentId] = [component];
	        }
	        else {
	            this.attributes[componentId].push(component);
	        }
	    };
	    ComponentStateModel.ID = 'ComponentState';
	    return ComponentStateModel;
	}(Model_1.Model));
	exports.ComponentStateModel = ComponentStateModel;


/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(94));
	var ComponentOptions_1 = __webpack_require__(98);
	exports.ComponentOptions = ComponentOptions_1.ComponentOptions;
	exports.ComponentOptionsType = ComponentOptions_1.ComponentOptionsType;
	var Component_1 = __webpack_require__(96);
	exports.Component = Component_1.Component;
	var BaseComponent_1 = __webpack_require__(76);
	exports.BaseComponent = BaseComponent_1.BaseComponent;
	var RootComponent_1 = __webpack_require__(75);
	exports.RootComponent = RootComponent_1.RootComponent;
	var QueryBuilder_1 = __webpack_require__(77);
	exports.QueryBuilder = QueryBuilder_1.QueryBuilder;
	var ExpressionBuilder_1 = __webpack_require__(78);
	exports.ExpressionBuilder = ExpressionBuilder_1.ExpressionBuilder;
	// Export Initialization under both name, for legacy reason and old code in the wild that
	// reference the old CoveoJQuery module
	var Initialization_1 = __webpack_require__(95);
	exports.Initialization = Initialization_1.Initialization;
	var Initialization_2 = __webpack_require__(95);
	exports.CoveoJQuery = Initialization_2.Initialization;
	var CoveoJQuery_1 = __webpack_require__(120);
	exports.initCoveoJQuery = CoveoJQuery_1.initCoveoJQuery;


/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var Initialization_1 = __webpack_require__(95);
	var Assert_1 = __webpack_require__(17);
	var QueryController_1 = __webpack_require__(74);
	var QueryStateModel_1 = __webpack_require__(90);
	var Analytics_1 = __webpack_require__(111);
	var InitializationEvents_1 = __webpack_require__(44);
	var Dom_1 = __webpack_require__(57);
	var Component_1 = __webpack_require__(96);
	/**
	 * Initialize the framework with a basic search interface. Calls {@link Initialization.initSearchInterface}.<br/>
	 * If using the jQuery extension, this is called using <code>$('#root').coveo('init');</code>.
	 * @param element The root of the interface to initialize.
	 * @param options JSON options for the framework (e.g.: <code>{Searchbox : {enableSearchAsYouType : true}}</code>).
	 */
	function init(element, options) {
	    if (options === void 0) { options = {}; }
	    Initialization_1.Initialization.initializeFramework(element, options, function () {
	        Initialization_1.Initialization.initSearchInterface(element, options);
	    });
	}
	exports.init = init;
	Initialization_1.Initialization.registerNamedMethod('init', function (element, options) {
	    if (options === void 0) { options = {}; }
	    init(element, options);
	});
	/**
	 * Initialize the framework with a standalone search box. Calls {@link Initialize.initStandaloneSearchInterface}.<br/>
	 * If using the jQuery extension, this is called using <code>$('#root').coveo('initSearchbox');</code>.
	 * @param element The root of the interface to initialize.
	 * @param searchPageUri The search page on which to redirect when there is a query.
	 * @param options JSON options for the framework (e.g.: <code>{Searchbox : {enableSearchAsYouType : true}}</code>).
	 */
	function initSearchbox(element, searchPageUri, options) {
	    if (options === void 0) { options = {}; }
	    Assert_1.Assert.isNonEmptyString(searchPageUri);
	    var searchInterfaceOptions = {};
	    searchInterfaceOptions.searchPageUri = searchPageUri;
	    searchInterfaceOptions.autoTriggerQuery = false;
	    searchInterfaceOptions.hideUntilFirstQuery = false;
	    searchInterfaceOptions.enableHistory = false;
	    options = _.extend({}, options, { StandaloneSearchInterface: searchInterfaceOptions });
	    Initialization_1.Initialization.initializeFramework(element, options, function () {
	        Initialization_1.Initialization.initStandaloneSearchInterface(element, options);
	    });
	}
	exports.initSearchbox = initSearchbox;
	Initialization_1.Initialization.registerNamedMethod('initSearchbox', function (element, searchPageUri, options) {
	    if (options === void 0) { options = {}; }
	    initSearchbox(element, searchPageUri, options);
	});
	/**
	 * Initialize the framework with a recommendation interface. Calls {@link Initialization.initRecommendationInterface}.<br/>
	 * If using the jQuery extension, this is called using <code>$('#root').coveo('initRecommendation');</code>.
	 * @param element The root of the interface to initialize.
	 * @param mainSearchInterface The search interface to link with the recommendation interface (see {@link Recommendation}).
	 * @param userContext The user context to pass with the query generated in the recommendation interface (see {@link Recommendation}).
	 * @param options JSON options for the framework (e.g.: <code>{Searchbox : {enableSearchAsYouType: true}}</code>).
	 */
	function initRecommendation(element, mainSearchInterface, userContext, options) {
	    if (options === void 0) { options = {}; }
	    var recommendationOptions = {};
	    recommendationOptions.mainSearchInterface = mainSearchInterface;
	    recommendationOptions.userContext = JSON.stringify(userContext);
	    recommendationOptions.enableHistory = false;
	    options = _.extend({}, options, { Recommendation: recommendationOptions });
	    Initialization_1.Initialization.initializeFramework(element, options, function () {
	        Initialization_1.Initialization.initRecommendationInterface(element, options);
	    });
	}
	exports.initRecommendation = initRecommendation;
	Initialization_1.Initialization.registerNamedMethod('initRecommendation', function (element, mainSearchInterface, userContext, options) {
	    if (userContext === void 0) { userContext = {}; }
	    if (options === void 0) { options = {}; }
	    initRecommendation(element, mainSearchInterface, userContext, options);
	});
	/**
	 * Execute a standard query. Active component in the interface will react to events/ push data in the query / handle the query success or failure as needed.<br/>
	 * It triggers a standard query flow for which the standard component will perform their expected behavior.<br/>
	 * If you wish to only perform a query on the index to retrieve results (without the component reacting), look into {@link SearchInterface} instead.<br/>
	 * Calling this method is the same as calling {@link QueryController.executeQuery}.
	 * @param element The root of the interface to initialize.
	 */
	function executeQuery(element) {
	    Assert_1.Assert.exists(element);
	    var queryController = Component_1.Component.resolveBinding(element, QueryController_1.QueryController);
	    Assert_1.Assert.exists(queryController);
	    return queryController.executeQuery();
	}
	exports.executeQuery = executeQuery;
	Initialization_1.Initialization.registerNamedMethod('executeQuery', function (element) {
	    return executeQuery(element);
	});
	/**
	 * Perform operation on the state ({@link QueryStateModel} of the interface.<br/>
	 * Get the complete {@link QueryStateModel} object: <code>Coveo.state(element)</code><br/>.
	 * Get an attribute from the {@link QueryStateModel}: <code>Coveo.state(element, 'q')</code> Can be any attribute.<br/>
	 * Set an attribute on the {@link QueryStateModel}: <code>Coveo.state(element, 'q', 'foobar')</code>. Can be any attribute.<br/>
	 * Set multiple attribute on the {@link QueryStateModel}: <code>Coveo.state(element, {'q' : 'foobar' , sort : 'relevancy'})</code>. Can be any attribute.<br/>
	 * If using the jQuery extension, this is called using <code>$('#root').coveo('state');</code>.
	 * @param element The root of the interface for which to access the {@link QueryStateModel}.
	 * @param args
	 * @returns {any}
	 */
	function state(element) {
	    var args = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        args[_i - 1] = arguments[_i];
	    }
	    Assert_1.Assert.exists(element);
	    var model = Component_1.Component.resolveBinding(element, QueryStateModel_1.QueryStateModel);
	    return QueryStateModel_1.setState(model, args);
	}
	exports.state = state;
	Initialization_1.Initialization.registerNamedMethod('state', function (element) {
	    var args = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        args[_i - 1] = arguments[_i];
	    }
	    if (args.length != 0) {
	        return state.apply(undefined, [element].concat(args));
	    }
	    else {
	        return state.apply(undefined, [element]);
	    }
	});
	/**
	 * Get the component bound on the given `HTMLElement`.
	 * @param element The `HTMLElement` for which to get the component instance.
	 * @param componentClass If multiple components are bound to a single `HTMLElement`, you need to specify which components you wish to get.
	 * @param noThrow By default, the GET method will throw if there is no component bound, or if there are multiple component and no `componentClass` is specified. This deletes the error if set to true.
	 * @returns {Component}
	 */
	function get(element, componentClass, noThrow) {
	    Assert_1.Assert.exists(element);
	    return Component_1.Component.get(element, componentClass, noThrow);
	}
	exports.get = get;
	Initialization_1.Initialization.registerNamedMethod('get', function (element, componentClass, noThrow) {
	    return get(element, componentClass, noThrow);
	});
	function result(element, noThrow) {
	    Assert_1.Assert.exists(element);
	    return Component_1.Component.getResult(element, noThrow);
	}
	exports.result = result;
	Initialization_1.Initialization.registerNamedMethod('result', function (element, noThrow) {
	    return result(element, noThrow);
	});
	function getCoveoAnalyticsClient(element) {
	    var analytics = getCoveoAnalytics(element);
	    if (analytics) {
	        return analytics.client;
	    }
	    else {
	        return undefined;
	    }
	}
	function getCoveoAnalytics(element) {
	    var analyticsElement = Dom_1.$$(element).find('.' + Component_1.Component.computeCssClassName(Analytics_1.Analytics));
	    if (analyticsElement) {
	        return Component_1.Component.get(analyticsElement);
	    }
	    else {
	        return undefined;
	    }
	}
	/**
	 * Log a custom event on the Coveo Usage Analytics service.
	 * @param element The root of the interface for which to log analytics events.
	 * @param customEventCause The cause of the event.
	 * @param metadata The metadata associated with the event (JSON key value).
	 */
	function logCustomEvent(element, customEventCause, metadata) {
	    var client = getCoveoAnalyticsClient(element);
	    if (client) {
	        client.logCustomEvent(customEventCause, metadata, element);
	    }
	}
	exports.logCustomEvent = logCustomEvent;
	Initialization_1.Initialization.registerNamedMethod('logCustomEvent', function (element, customEventCause, metadata) {
	    logCustomEvent(element, customEventCause, metadata);
	});
	/**
	 * Log a `SearchEvent` on the Coveo Usage Analytics service.
	 * @param element The root of the interface for which to log analytics events.
	 * @param searchEventCause The cause of the event.
	 * @param metadata The metadata associated with the event (JSON key value).
	 */
	function logSearchEvent(element, searchEventCause, metadata) {
	    var client = getCoveoAnalyticsClient(element);
	    if (client) {
	        client.logSearchEvent(searchEventCause, metadata);
	    }
	}
	exports.logSearchEvent = logSearchEvent;
	Initialization_1.Initialization.registerNamedMethod('logSearchEvent', function (element, searchEventCause, metadata) {
	    logSearchEvent(element, searchEventCause, metadata);
	});
	/**
	 * Log a `SearchAsYouTypeEvent` on the Coveo Usage Analytics service.<br/>
	 * It is a bit different from a standard search event, as it will wait 5 seconds before sending the final `SearchAsYouType` event.
	 * @param element The root of the interface for which to log analytics events.
	 * @param searchAsYouTypeEventCause The cause of the event.
	 * @param metadata The metadata associated with the event (JSON key value).
	 */
	function logSearchAsYouTypeEvent(element, searchAsYouTypeEventCause, metadata) {
	    var client = getCoveoAnalyticsClient(element);
	    if (client) {
	        client.logSearchAsYouType(searchAsYouTypeEventCause, metadata);
	    }
	}
	exports.logSearchAsYouTypeEvent = logSearchAsYouTypeEvent;
	Initialization_1.Initialization.registerNamedMethod('logSearchAsYouTypeEvent', function (element, searchAsYouTypeEventCause, metadata) {
	    logSearchAsYouTypeEvent(element, searchAsYouTypeEventCause, metadata);
	});
	/**
	 * Log a `ClickEvent` on the Coveo Usage Analytics service.
	 * @param element The root of the interface for which to log analytics events.
	 * @param clickEventCause The cause of the event.
	 * @param metadata The metadata associated with the event (JSON key value).
	 * @param result The result that was clicked.
	 */
	function logClickEvent(element, clickEventCause, metadata, result) {
	    var client = getCoveoAnalyticsClient(element);
	    if (client) {
	        client.logClickEvent(clickEventCause, metadata, result, element);
	    }
	}
	exports.logClickEvent = logClickEvent;
	Initialization_1.Initialization.registerNamedMethod('logClickEvent', function (element, clickEventCause, metadata, result) {
	    logClickEvent(element, clickEventCause, metadata, result);
	});
	/**
	 * Pass options to the framework, before it is initialized ({@link init}).<br/>
	 * All the options passed with this calls will be merged together on initialization.
	 * @param element The root of the interface for which you wish to set options.
	 * @param optionsToSet JSON options for the framework (e.g.: <code>{Searchbox : {enableSearchAsYouType: true}}</code>).
	 */
	function options(element, optionsToSet) {
	    if (optionsToSet === void 0) { optionsToSet = {}; }
	    Initialization_1.Initialization.registerDefaultOptions(element, optionsToSet);
	}
	exports.options = options;
	Initialization_1.Initialization.registerNamedMethod('options', function (element, optionsToSet) {
	    if (optionsToSet === void 0) { optionsToSet = {}; }
	    options(element, optionsToSet);
	});
	/**
	 * Patch the given `methodName` on an instance of a component bound to an `HTMLElement` with a new handler.
	 * @param element
	 * @param methodName
	 * @param handler
	 */
	function patch(element, methodName, handler) {
	    Initialization_1.Initialization.monkeyPatchComponentMethod(methodName, element, handler);
	}
	exports.patch = patch;
	Initialization_1.Initialization.registerNamedMethod('patch', function (element, methodName, handler) {
	    patch(element, methodName, handler);
	});
	function initBox(element) {
	    var args = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        args[_i - 1] = arguments[_i];
	    }
	    var type, options = {}, injectMarkup;
	    // This means : initBox, no type (no injection) and no options
	    if (args.length == 0) {
	        type = 'Standard';
	        injectMarkup = false;
	    }
	    else if (args.length == 1) {
	        // This mean a type (with injection) and no options
	        if (typeof args[0] == 'string') {
	            type = args[0];
	            injectMarkup = true;
	        }
	        else if (typeof args[0] == 'object') {
	            type = 'Standard';
	            injectMarkup = false;
	            options = args[0];
	        }
	        else {
	            Assert_1.Assert.fail('Invalid parameters to init a box');
	        }
	    }
	    else if (args.length == 2) {
	        type = args[0];
	        options = args[1];
	        injectMarkup = true;
	    }
	    var merged = {};
	    merged[type || 'Container'] = _.extend({}, options.SearchInterface, options[type]);
	    options = _.extend({}, options, merged);
	    Initialization_1.Initialization.initializeFramework(element, options, function () {
	        Initialization_1.Initialization.initBoxInterface(element, options, type, injectMarkup);
	    });
	}
	exports.initBox = initBox;
	Initialization_1.Initialization.registerNamedMethod('initBox', function (element) {
	    var args = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        args[_i - 1] = arguments[_i];
	    }
	    initBox(element, args);
	});
	function nuke(element) {
	    Dom_1.$$(element).trigger(InitializationEvents_1.InitializationEvents.nuke);
	}
	exports.nuke = nuke;
	Initialization_1.Initialization.registerNamedMethod('nuke', function (element) {
	    nuke(element);
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var Logger_1 = __webpack_require__(16);
	var Component_1 = __webpack_require__(96);
	var Utils_1 = __webpack_require__(18);
	var Assert_1 = __webpack_require__(17);
	var Dom_1 = __webpack_require__(57);
	var InitializationEvents_1 = __webpack_require__(44);
	var SearchInterface_1 = __webpack_require__(97);
	var QueryController_1 = __webpack_require__(74);
	var HashUtils_1 = __webpack_require__(65);
	var QueryStateModel_1 = __webpack_require__(90);
	var ComponentStateModel_1 = __webpack_require__(92);
	var ComponentOptionsModel_1 = __webpack_require__(91);
	var AnalyticsActionListMeta_1 = __webpack_require__(110);
	/**
	 * The main purpose of this class is to initialize the framework (a.k.a the code executed when calling `Coveo.init`).<br/>
	 * It's also in charge or registering the available components, as well as the method that we expost to the global Coveo scope.<br/>
	 * For example, the `Coveo.executeQuery` function will be registed in this class by the {@link QueryController}.
	 */
	var Initialization = (function () {
	    function Initialization() {
	    }
	    /**
	     * Register a new set of options for a given element.<br/>
	     * When the element is eventually initialized as a component, those options will be used / merged to create the final option set to use for this component.<br/>
	     * Note that this function should not normally be called directly, but instead using the global `Coveo.options` function
	     * @param element
	     * @param options
	     */
	    Initialization.registerDefaultOptions = function (element, options) {
	        var existing = element['CoveoDefaultOptions'] || {};
	        var updated = Utils_1.Utils.extendDeep(existing, options);
	        element['CoveoDefaultOptions'] = updated;
	    };
	    Initialization.resolveDefaultOptions = function (element, options) {
	        var optionsForThisElement = element['CoveoDefaultOptions'];
	        var optionsSoFar;
	        if (Utils_1.Utils.exists(optionsForThisElement)) {
	            optionsSoFar = Utils_1.Utils.extendDeep(optionsForThisElement, options);
	        }
	        else {
	            optionsSoFar = options;
	        }
	        if (element.parentElement) {
	            return Initialization.resolveDefaultOptions(element.parentElement, optionsSoFar);
	        }
	        else {
	            return optionsSoFar;
	        }
	    };
	    /**
	     * Register a new Component to be recognized by the framework.<br/>
	     * This essentially mean that when we call `Coveo.init`, the Initialization class will scan the DOM for known component (which have registed themselves with this call) and create a new component on each element.
	     * @param componentClass
	     */
	    Initialization.registerAutoCreateComponent = function (componentClass) {
	        Assert_1.Assert.exists(componentClass);
	        Assert_1.Assert.exists(componentClass.ID);
	        Assert_1.Assert.doesNotExists(Initialization.autoCreateComponents[componentClass.ID]);
	        Assert_1.Assert.doesNotExists(Initialization.namedMethods[componentClass.ID]);
	        Initialization.autoCreateComponents[componentClass.ID] = componentClass;
	    };
	    /**
	     * Check if a component is already registed, using it's ID (e.g. : 'Facet').
	     * @param componentClassId
	     * @returns {boolean}
	     */
	    Initialization.isComponentClassIdRegistered = function (componentClassId) {
	        return Utils_1.Utils.exists(Initialization.autoCreateComponents[componentClassId]);
	    };
	    /**
	     * Return the list of all known components (the list of ID for each component).
	     * @returns {string[]}
	     */
	    Initialization.getListOfRegisteredComponents = function () {
	        return _.keys(Initialization.autoCreateComponents);
	    };
	    /**
	     * Return the component class definition, using it's ID (e.g. : 'CoveoFacet').
	     * @param name
	     * @returns {IComponentDefinition}
	     */
	    Initialization.getRegisteredComponent = function (name) {
	        return Initialization.autoCreateComponents[name];
	    };
	    /**
	     * Initialize the framework. Note that this function should not normally be called directly, but instead using a globally registered function (e.g.: Coveo.init), or {@link Initialization.initSearchInterface} or {@link Initialization.initStandaloneSearchInterface} <br/>
	     * (e.g. : `Coveo.init` or `Coveo.initSearchbox`).
	     * @param element The element on which to initialize the interface.
	     * @param options The options for all components (eg: {Searchbox : {enableSearchAsYouType : true}}).
	     * @param initSearchInterfaceFunction The function to execute to create the {@link SearchInterface} component. Different init call will create different {@link SearchInterface}.
	     */
	    Initialization.initializeFramework = function (element, options, initSearchInterfaceFunction) {
	        Assert_1.Assert.exists(element);
	        var alreadyInitialized = Component_1.Component.get(element, QueryController_1.QueryController, true);
	        if (alreadyInitialized) {
	            this.logger.error('This DOM element has already been initialized as a search interface, skipping initialization', element);
	            return;
	        }
	        options = Initialization.resolveDefaultOptions(element, options);
	        Initialization.performInitFunctionsOption(options, InitializationEvents_1.InitializationEvents.beforeInitialization);
	        Dom_1.$$(element).trigger(InitializationEvents_1.InitializationEvents.beforeInitialization);
	        initSearchInterfaceFunction(element, options);
	        Initialization.initExternalComponents(element, options);
	        Initialization.performInitFunctionsOption(options, InitializationEvents_1.InitializationEvents.afterComponentsInitialization);
	        Dom_1.$$(element).trigger(InitializationEvents_1.InitializationEvents.afterComponentsInitialization);
	        Dom_1.$$(element).trigger(InitializationEvents_1.InitializationEvents.restoreHistoryState);
	        Initialization.performInitFunctionsOption(options, InitializationEvents_1.InitializationEvents.afterInitialization);
	        Dom_1.$$(element).trigger(InitializationEvents_1.InitializationEvents.afterInitialization);
	        var searchInterface = Component_1.Component.get(element, SearchInterface_1.SearchInterface);
	        // Elements that have the coveo-hide-until-loaded class are hidden by default.
	        // Now that we're loaded (and before the first query returns), we can remove
	        // the class. Also, we add a class that gives the opportunity for an animation
	        // to apply at startup, such as a fade-in that comes in by default.
	        var elemsHidden = Dom_1.$$(element).findAll('.coveo-hide-until-loaded');
	        _.each(elemsHidden, function (e) {
	            Dom_1.$$(e).removeClass('coveo-hide-until-loaded');
	            Dom_1.$$(e).addClass('coveo-show-after-loaded');
	        });
	        if (searchInterface.options.autoTriggerQuery) {
	            Initialization.logFirstQueryCause(searchInterface);
	            Component_1.Component.get(element, QueryController_1.QueryController).executeQuery({
	                logInActionsHistory: Coveo['Recommendation'] && searchInterface instanceof Coveo['Recommendation'],
	                isFirstQuery: true
	            });
	        }
	    };
	    /**
	     * Create a new standard search interface. This is the function executed when calling `Coveo.init`.
	     * @param element
	     * @param options
	     */
	    Initialization.initSearchInterface = function (element, options) {
	        if (options === void 0) { options = {}; }
	        options = Initialization.resolveDefaultOptions(element, options);
	        var searchInterface = new SearchInterface_1.SearchInterface(element, options.SearchInterface, options.Analytics);
	        searchInterface.options.originalOptionsObject = options;
	        var initParameters = { options: options, bindings: searchInterface.getBindings() };
	        Initialization.automaticallyCreateComponentsInside(element, initParameters);
	    };
	    /**
	     * Create a new standalone search interface (standalone search box). This is the function executed when calling `Coveo.initSearchbox`.
	     * @param element
	     * @param options
	     */
	    Initialization.initStandaloneSearchInterface = function (element, options) {
	        if (options === void 0) { options = {}; }
	        options = Initialization.resolveDefaultOptions(element, options);
	        // Set trigger query on clear to false for standalone search interface automatically
	        // Take care of not overriding any options that could have been set by external code.
	        if (!options.Querybox) {
	            options.Querybox = {};
	        }
	        if (!options.Omnibox) {
	            options.Omnibox = {};
	        }
	        if (!options.Searchbox) {
	            options.Searchbox = {};
	        }
	        if (!options.Querybox.triggerQueryOnClear || !options.Omnibox.triggerQueryOnClear || !options.Searchbox.triggerOnQueryClear) {
	            options.Querybox.triggerQueryOnClear = false;
	            options.Omnibox.triggerQueryOnClear = false;
	            options.Searchbox.triggerQueryOnClear = false;
	        }
	        var searchInterface = new SearchInterface_1.StandaloneSearchInterface(element, options.StandaloneSearchInterface, options.Analytics);
	        searchInterface.options.originalOptionsObject = options;
	        var initParameters = { options: options, bindings: searchInterface.getBindings() };
	        Initialization.automaticallyCreateComponentsInside(element, initParameters);
	    };
	    /**
	     * Create a new recommendation search interface. This is the function executed when calling `Coveo.initRecommendation`.
	     * @param element
	     * @param options
	     */
	    Initialization.initRecommendationInterface = function (element, options) {
	        if (options === void 0) { options = {}; }
	        options = Initialization.resolveDefaultOptions(element, options);
	        // Since a recommendation interface inherits from a search interface, we need to merge those if passed on init
	        var optionsForRecommendation = _.extend({}, options.SearchInterface, options.Recommendation);
	        var recommendation = new window['Coveo']['Recommendation'](element, optionsForRecommendation, options.Analytics);
	        recommendation.options.originalOptionsObject = options;
	        var initParameters = { options: options, bindings: recommendation.getBindings() };
	        Initialization.automaticallyCreateComponentsInside(element, initParameters);
	    };
	    /**
	     * Scan the element and all its children for known components. Initialize every known component found.
	     * @param element The element for which to scan it's children.
	     * @param initParameters Needed parameters to initialize all the children components.
	     * @param ignore An optional list of component ID to ignore and skip when scanning for known components.
	     */
	    Initialization.automaticallyCreateComponentsInside = function (element, initParameters, ignore) {
	        Assert_1.Assert.exists(element);
	        var codeToExecute = [];
	        for (var componentClassId in Initialization.autoCreateComponents) {
	            if (!_.contains(ignore, componentClassId)) {
	                var componentClass = Initialization.autoCreateComponents[componentClassId];
	                var classname = Component_1.Component.computeCssClassName(componentClass);
	                var elements = Dom_1.$$(element).findAll('.' + classname);
	                if (Dom_1.$$(element).hasClass(classname)) {
	                    elements.push(element);
	                }
	                if (elements.length != 0) {
	                    // Queue the code that will scan the now resolved selector to after we've
	                    // finished evaluating all selectors. This ensures that if a component
	                    // constructor adds child components under his tags, those won't get auto-
	                    // initialize by this invocation of this method. Components inserting child
	                    // components are responsible of invoking this method again if they want
	                    // child components to be auto-initialized.
	                    //
	                    // Explanation: If we don't do that, child components for which selector have
	                    // already been evaluated won't be initialized, whereas those that are next
	                    // in the list will be.
	                    codeToExecute.push(Initialization.createFunctionThatInitializesComponentOnElements(elements, componentClassId, componentClass, initParameters));
	                }
	            }
	        }
	        // Now that all selectors are executed, let's really initialize the components.
	        _.each(codeToExecute, function (code) { return code(); });
	    };
	    /**
	     * Create a new component on the given element.
	     * @param componentClassId The ID of the component to initialize (e.g. : 'CoveoFacet').
	     * @param element The HTMLElement on which to initialize.
	     * @param initParameters Needed parameters to initialize the component.
	     * @returns {Component}
	     */
	    Initialization.createComponentOfThisClassOnElement = function (componentClassId, element, initParameters) {
	        Assert_1.Assert.isNonEmptyString(componentClassId);
	        Assert_1.Assert.exists(element);
	        var componentClass = Initialization.autoCreateComponents[componentClassId];
	        Assert_1.Assert.exists(componentClass);
	        var bindings = {};
	        var options = {};
	        var result = undefined;
	        if (initParameters != undefined) {
	            _.each(initParameters.bindings, function (value, key) {
	                bindings[key] = value;
	            });
	            options = initParameters.options;
	            result = initParameters.result;
	        }
	        Initialization.logger.trace('Creating component of class ' + componentClassId, element, options);
	        return new componentClass(element, options, bindings, result);
	    };
	    /**
	     * Register a new globally available method in the Coveo namespace (e.g.: `Coveo.init`).
	     * @param methodName The method name to register.
	     * @param handler The function to execute when the method is called.
	     */
	    Initialization.registerNamedMethod = function (methodName, handler) {
	        Assert_1.Assert.isNonEmptyString(methodName);
	        Assert_1.Assert.doesNotExists(Initialization.autoCreateComponents[methodName]);
	        Assert_1.Assert.doesNotExists(Initialization.namedMethods[methodName]);
	        Assert_1.Assert.exists(handler);
	        Initialization.namedMethods[methodName] = handler;
	    };
	    /**
	     * Check if the method is already registed.
	     * @param methodName
	     * @returns {boolean}
	     */
	    Initialization.isNamedMethodRegistered = function (methodName) {
	        return Utils_1.Utils.exists(Initialization.namedMethods[methodName]);
	    };
	    /**
	     * 'Monkey patch' (replace the function with a new one) a given method on a component instance.
	     * @param methodName
	     * @param element
	     * @param handler
	     */
	    Initialization.monkeyPatchComponentMethod = function (methodName, element, handler) {
	        Assert_1.Assert.isNonEmptyString(methodName);
	        Assert_1.Assert.exists(handler);
	        var componentClass;
	        if (methodName.indexOf('.') > 0) {
	            var splitArg = methodName.split('.');
	            Assert_1.Assert.check(splitArg.length == 2, 'Invalid method name, correct syntax is CoveoComponent.methodName.');
	            componentClass = splitArg[0];
	            methodName = splitArg[1];
	        }
	        var boundComponent = Component_1.Component.get(element, componentClass);
	        Assert_1.Assert.exists(boundComponent);
	        Assert_1.Assert.exists(boundComponent[methodName]);
	        var originalMethodName = '__' + methodName;
	        if (!Utils_1.Utils.exists(boundComponent[originalMethodName])) {
	            boundComponent[originalMethodName] = boundComponent[methodName];
	        }
	        boundComponent[methodName] = handler;
	    };
	    Initialization.initBoxInterface = function (element, options, type, injectMarkup) {
	        if (options === void 0) { options = {}; }
	        if (type === void 0) { type = 'Standard'; }
	        if (injectMarkup === void 0) { injectMarkup = true; }
	        options = Initialization.resolveDefaultOptions(element, options);
	        var fromInitTypeToBoxReference = 'Box';
	        if (type != 'Standard') {
	            fromInitTypeToBoxReference += 'For' + type;
	        }
	        var boxRef = Component_1.Component.getComponentRef(fromInitTypeToBoxReference);
	        if (boxRef) {
	            new Logger_1.Logger(element).info('Initializing box of type ' + fromInitTypeToBoxReference);
	            var injectFunction = injectMarkup ? boxRef.getInjection : function () {
	            };
	            var box = new boxRef(element, options[fromInitTypeToBoxReference], options.Analytics, injectFunction, options);
	            box.options.originalOptionsObject = options;
	            var initParameters = { options: options, bindings: box.getBindings() };
	            Initialization.automaticallyCreateComponentsInside(element, initParameters);
	        }
	        else {
	            new Logger_1.Logger(element).error('Trying to initialize box of type : ' + fromInitTypeToBoxReference + ' but not found in code (not compiled)!');
	            Assert_1.Assert.fail('Cannot initialize unknown type of box');
	        }
	    };
	    Initialization.dispatchNamedMethodCall = function (methodName, element, args) {
	        Assert_1.Assert.isNonEmptyString(methodName);
	        Assert_1.Assert.exists(element);
	        var namedMethodHandler = Initialization.namedMethods[methodName];
	        Assert_1.Assert.exists(namedMethodHandler);
	        Initialization.logger.trace('Dispatching named method call of ' + methodName, element, args);
	        if (args.length != 0) {
	            return namedMethodHandler.apply(null, [element].concat(args));
	        }
	        else {
	            return namedMethodHandler.apply(null, [element]);
	        }
	    };
	    Initialization.dispatchNamedMethodCallOrComponentCreation = function (token, element, args) {
	        Assert_1.Assert.isNonEmptyString(token);
	        Assert_1.Assert.exists(element);
	        if (Initialization.isNamedMethodRegistered(token)) {
	            return Initialization.dispatchNamedMethodCall(token, element, args);
	        }
	        else if (Initialization.isComponentClassIdRegistered(token)) {
	            return Initialization.createComponentOfThisClassOnElement(token, element, args[0]);
	        }
	        else if (Initialization.isThereASingleComponentBoundToThisElement(element)) {
	            return Initialization.dispatchMethodCallOnBoundComponent(token, element, args);
	        }
	        else {
	            Assert_1.Assert.fail('No method or component named ' + token + ' are registered.');
	        }
	    };
	    Initialization.isSearchFromLink = function (searchInterface) {
	        return Utils_1.Utils.isNonEmptyString(searchInterface.getBindings().queryStateModel.get('q'));
	    };
	    Initialization.isThereASingleComponentBoundToThisElement = function (element) {
	        Assert_1.Assert.exists(element);
	        return Utils_1.Utils.exists(Component_1.Component.get(element));
	    };
	    Initialization.dispatchMethodCallOnBoundComponent = function (methodName, element, args) {
	        Assert_1.Assert.isNonEmptyString(methodName);
	        Assert_1.Assert.exists(element);
	        var boundComponent = Component_1.Component.get(element);
	        Assert_1.Assert.exists(boundComponent);
	        var method = boundComponent[methodName];
	        if (Utils_1.Utils.exists(method)) {
	            return method.apply(boundComponent, args);
	        }
	        else {
	            Assert_1.Assert.fail('No method named ' + methodName + ' exist on component ' + boundComponent.type);
	        }
	    };
	    Initialization.logFirstQueryCause = function (searchInterface) {
	        var firstQueryCause = HashUtils_1.HashUtils.getValue('firstQueryCause', HashUtils_1.HashUtils.getHash());
	        if (firstQueryCause != null) {
	            var meta = HashUtils_1.HashUtils.getValue('firstQueryMeta', HashUtils_1.HashUtils.getHash()) || {};
	            searchInterface.usageAnalytics.logSearchEvent(AnalyticsActionListMeta_1.analyticsActionCauseList[firstQueryCause], meta);
	        }
	        else {
	            if (Initialization.isSearchFromLink(searchInterface)) {
	                searchInterface.usageAnalytics.logSearchEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.searchFromLink, {});
	            }
	            else {
	                searchInterface.usageAnalytics.logSearchEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.interfaceLoad, {});
	            }
	        }
	    };
	    Initialization.performInitFunctionsOption = function (options, event) {
	        if (Utils_1.Utils.exists(options)) {
	            Initialization.performFunctions(options[event]);
	        }
	    };
	    Initialization.performFunctions = function (option) {
	        if (Utils_1.Utils.exists(option)) {
	            _.each(option, function (func) {
	                if (typeof func == 'function') {
	                    func();
	                }
	            });
	        }
	    };
	    Initialization.initExternalComponents = function (element, options) {
	        if (options && options['externalComponents']) {
	            var searchInterface = Component_1.Component.get(element, SearchInterface_1.SearchInterface);
	            var queryStateModel = Component_1.Component.get(element, QueryStateModel_1.QueryStateModel);
	            var componentStateModel = Component_1.Component.get(element, ComponentStateModel_1.ComponentStateModel);
	            var queryController = Component_1.Component.get(element, QueryController_1.QueryController);
	            var componentOptionsModel = Component_1.Component.get(element, ComponentOptionsModel_1.ComponentOptionsModel);
	            var usageAnalytics = searchInterface.usageAnalytics;
	            Assert_1.Assert.exists(searchInterface);
	            Assert_1.Assert.exists(queryStateModel);
	            Assert_1.Assert.exists(queryController);
	            Assert_1.Assert.exists(componentStateModel);
	            Assert_1.Assert.exists(usageAnalytics);
	            var initParameters_1 = {
	                options: options,
	                bindings: {
	                    searchInterface: searchInterface,
	                    queryStateModel: queryStateModel,
	                    queryController: queryController,
	                    usageAnalytics: usageAnalytics,
	                    componentStateModel: componentStateModel,
	                    componentOptionsModel: componentOptionsModel,
	                    root: element
	                }
	            };
	            _.each(options['externalComponents'], function (externalComponent) {
	                var elementToInstantiate = externalComponent;
	                if (Utils_1.Utils.isHtmlElement(elementToInstantiate)) {
	                    Initialization.automaticallyCreateComponentsInside(elementToInstantiate, initParameters_1);
	                }
	            });
	        }
	    };
	    Initialization.createFunctionThatInitializesComponentOnElements = function (elements, componentClassId, componentClass, initParameters) {
	        return function () {
	            _.each(elements, function (matchingElement) {
	                if (Component_1.Component.get(matchingElement, componentClassId) == null) {
	                    // If options were provided, lookup options for this component class and
	                    // also for the element id. Merge them and pass those to the factory method.
	                    var optionsToUse = undefined;
	                    if (Utils_1.Utils.exists(initParameters.options)) {
	                        var optionsForComponentClass = initParameters.options[componentClassId];
	                        var optionsForElementId = initParameters.options[matchingElement.id];
	                        var initOptions = initParameters.options['initOptions'] ? initParameters.options['initOptions'][componentClassId] : {};
	                        optionsToUse = Utils_1.Utils.extendDeep(optionsForElementId, initOptions);
	                        optionsToUse = Utils_1.Utils.extendDeep(optionsForComponentClass, optionsToUse);
	                    }
	                    var initParamToUse = _.extend({}, initParameters, { options: optionsToUse });
	                    Initialization.createComponentOfThisClassOnElement(componentClass['ID'], matchingElement, initParamToUse);
	                }
	            });
	        };
	    };
	    Initialization.logger = new Logger_1.Logger('Initialization');
	    Initialization.autoCreateComponents = {};
	    Initialization.namedMethods = {};
	    return Initialization;
	}());
	exports.Initialization = Initialization;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Assert_1 = __webpack_require__(17);
	var Utils_1 = __webpack_require__(18);
	var JQueryutils_1 = __webpack_require__(58);
	var Dom_1 = __webpack_require__(57);
	var QueryStateModel_1 = __webpack_require__(90);
	var ComponentStateModel_1 = __webpack_require__(92);
	var ComponentOptionsModel_1 = __webpack_require__(91);
	var QueryController_1 = __webpack_require__(74);
	var SearchInterface_1 = __webpack_require__(97);
	var NoopAnalyticsClient_1 = __webpack_require__(105);
	var BaseComponent_1 = __webpack_require__(76);
	/**
	 * The base class for every component in the framework.
	 */
	var Component = (function (_super) {
	    __extends(Component, _super);
	    /**
	     * Create a new Component. Resolve all {@link IComponentBindings} if not provided.<br/>
	     * Create a new Logger for this component.
	     * Attach the component to the {@link SearchInterface}.<br/>
	     * @param element The HTMLElement on which to create the component. Used to bind data on the element.
	     * @param type The unique identifier for this component. See : {@link IComponentDefinition.ID}. Used to generate the unique Coveo CSS class associated with every component.
	     * @param bindings The environment for every component. Optional, but omitting to provide one will impact performance.
	     */
	    function Component(element, type, bindings) {
	        var _this = this;
	        if (bindings === void 0) { bindings = {}; }
	        _super.call(this, element, type);
	        this.element = element;
	        this.type = type;
	        /**
	         * Allows the component to bind events and execute them only when it is enabled.
	         * @type {Coveo.ComponentEvents}
	         */
	        this.bind = new ComponentEvents(this);
	        this.root = bindings.root || this.resolveRoot();
	        this.queryStateModel = bindings.queryStateModel || this.resolveQueryStateModel();
	        this.componentStateModel = bindings.componentStateModel || this.resolveComponentStateModel();
	        this.queryController = bindings.queryController || this.resolveQueryController();
	        this.searchInterface = bindings.searchInterface || this.resolveSearchInterface();
	        this.usageAnalytics = bindings.usageAnalytics || this.resolveUA();
	        this.componentOptionsModel = bindings.componentOptionsModel || this.resolveComponentOptionsModel();
	        this.ensureDom = _.once(function () { return _this.createDom(); });
	        if (this.searchInterface != null) {
	            this.searchInterface.attachComponent(type, this);
	        }
	    }
	    /**
	     * Return the bindings, or environment, for the current component.
	     * @returns {IComponentBindings}
	     */
	    Component.prototype.getBindings = function () {
	        return {
	            root: this.root,
	            queryStateModel: this.queryStateModel,
	            queryController: this.queryController,
	            searchInterface: this.searchInterface,
	            componentStateModel: this.componentStateModel,
	            componentOptionsModel: this.componentOptionsModel,
	            usageAnalytics: this.usageAnalytics
	        };
	    };
	    Component.prototype.createDom = function () {
	        // By default we do nothing
	    };
	    Component.prototype.resolveSearchInterface = function () {
	        return Component.resolveBinding(this.element, SearchInterface_1.SearchInterface);
	    };
	    Component.prototype.resolveRoot = function () {
	        var resolvedSearchInterface = Component.resolveBinding(this.element, SearchInterface_1.SearchInterface);
	        return resolvedSearchInterface ? resolvedSearchInterface.element : undefined;
	    };
	    Component.prototype.resolveQueryController = function () {
	        return Component.resolveBinding(this.element, QueryController_1.QueryController);
	    };
	    Component.prototype.resolveComponentStateModel = function () {
	        return Component.resolveBinding(this.element, ComponentStateModel_1.ComponentStateModel);
	    };
	    Component.prototype.resolveQueryStateModel = function () {
	        return Component.resolveBinding(this.element, QueryStateModel_1.QueryStateModel);
	    };
	    Component.prototype.resolveComponentOptionsModel = function () {
	        return Component.resolveBinding(this.element, ComponentOptionsModel_1.ComponentOptionsModel);
	    };
	    Component.prototype.resolveUA = function () {
	        var searchInterface = this.resolveSearchInterface();
	        return (searchInterface && searchInterface.usageAnalytics) ? searchInterface.usageAnalytics : new NoopAnalyticsClient_1.NoopAnalyticsClient();
	    };
	    Component.prototype.resolveResult = function () {
	        return Component.getResult(this.element);
	    };
	    /**
	     * Get the bound component to the given HTMLElement. Throws an assert if the HTMLElement has no component bound, unless using the noThrow argument.<br/>
	     * If there is multiple component bound to the current HTMLElement, you must specify the component class.
	     * @param element HTMLElement for which to get the bound component.
	     * @param componentClass Optional component class. If the HTMLElement has multiple components bound, you must specify which one you are targeting.
	     * @param noThrow Boolean option to tell the method to not throw on error.
	     * @returns {Component}
	     */
	    Component.get = function (element, componentClass, noThrow) {
	        Assert_1.Assert.exists(element);
	        if (_.isString(componentClass)) {
	            return element[Component.computeCssClassNameForType(componentClass)];
	        }
	        else if (Utils_1.Utils.exists(componentClass)) {
	            Assert_1.Assert.exists(componentClass.ID);
	            return element[Component.computeCssClassNameForType(componentClass.ID)];
	        }
	        else {
	            // No class specified, but we support returning the bound component
	            // if there is exactly one.
	            var boundComponents = BaseComponent_1.BaseComponent.getBoundComponentsForElement(element);
	            if (!noThrow) {
	                Assert_1.Assert.check(boundComponents.length <= 1, 'More than one component is bound to this element. You need to specify the component type.');
	            }
	            return boundComponents[0];
	        }
	    };
	    Component.getResult = function (element, noThrow) {
	        if (noThrow === void 0) { noThrow = false; }
	        var resultElement = Dom_1.$$(element).closest('.CoveoResult');
	        Assert_1.Assert.check(noThrow || resultElement != undefined);
	        return resultElement['CoveoResult'];
	    };
	    Component.bindResultToElement = function (element, result) {
	        Assert_1.Assert.exists(element);
	        Assert_1.Assert.exists(result);
	        Dom_1.$$(element).addClass('CoveoResult');
	        element['CoveoResult'] = result;
	    };
	    Component.resolveBinding = function (element, componentClass) {
	        Assert_1.Assert.exists(element);
	        Assert_1.Assert.exists(componentClass);
	        Assert_1.Assert.exists(componentClass.ID);
	        // first, look down
	        var found;
	        if (Dom_1.$$(element).is('.' + Component.computeCssClassNameForType(componentClass.ID))) {
	            found = element;
	        }
	        else {
	            var findDown = Dom_1.$$(element).findClass(Component.computeCssClassNameForType(componentClass.ID));
	            if (!findDown || findDown.length == 0) {
	                var findUp = Dom_1.$$(element).closest(Component.computeCssClassNameForType(componentClass.ID));
	                if (findUp) {
	                    found = findUp;
	                }
	            }
	            else {
	                found = findDown;
	            }
	        }
	        if (found) {
	            return found[Component.computeCssClassNameForType(componentClass.ID)];
	        }
	        else {
	            return undefined;
	        }
	    };
	    Component.pointElementsToDummyForm = function (element) {
	        var inputs = Dom_1.$$(element).is('input') ? [element] : [];
	        inputs = inputs.concat(Dom_1.$$(element).findAll('input'));
	        _.each(_.compact(inputs), function (input) {
	            input.setAttribute('form', 'coveo-dummy-form');
	        });
	    };
	    return Component;
	}(BaseComponent_1.BaseComponent));
	exports.Component = Component;
	/**
	 * Used by the various Coveo Component to trigger and bind event.<br/>
	 * It adds a small logic to execute handler or triggers only when the component is "enabled".<br/>
	 * A component is disabled by calling {Component.disable}<br/>
	 * Typically, a component is disabled when it is not active in the current {Tab}.<br/>
	 * It can also be disabled by external code.<br/>
	 * The class serves as a way to not execute handler on component that are invisible and inactive in the query.
	 */
	var ComponentEvents = (function () {
	    /**
	     * Create a new `ComponentEvents` for the given {@link Component}.
	     * @param owner The {@link Component} which owns those events handler and trigger.
	     */
	    function ComponentEvents(owner) {
	        this.owner = owner;
	        Assert_1.Assert.exists(owner);
	    }
	    ComponentEvents.prototype.on = function (arg, event, handler) {
	        if (!JQueryutils_1.JQueryUtils.getJQuery() || !JQueryutils_1.JQueryUtils.isInstanceOfJQuery(arg)) {
	            var htmlEl = arg;
	            Dom_1.$$(htmlEl).on(event, this.wrapToCallIfEnabled(handler));
	        }
	        else {
	            var jq = arg;
	            jq.on(event, this.wrapToCallIfEnabled(handler));
	        }
	    };
	    ComponentEvents.prototype.one = function (arg, event, handler) {
	        if (arg instanceof HTMLElement) {
	            var htmlEl = arg;
	            Dom_1.$$(htmlEl).one(event, this.wrapToCallIfEnabled(handler));
	        }
	        else {
	            var jq = arg;
	            jq.one(event, this.wrapToCallIfEnabled(handler));
	        }
	    };
	    /**
	     * Bind on the "root" of the Component. The root is typically the {@link SearchInterface}.<br/>
	     * Bind an event using native javascript code.
	     * @param event The event for which to register an handler.
	     * @param handler The function to execute when the event is triggered.
	     */
	    ComponentEvents.prototype.onRootElement = function (event, handler) {
	        this.on(this.owner.root, event, handler);
	    };
	    /**
	     * Bind on the "root" of the Component. The root is typically the {@link SearchInterface}.<br/>
	     * Bind an event using native javascript code.
	     * The handler will execute only ONE time.
	     * @param event The event for which to register an handler.
	     * @param handler The function to execute when the event is triggered.
	     */
	    ComponentEvents.prototype.oneRootElement = function (event, handler) {
	        this.one(this.owner.root, event, handler);
	    };
	    /**
	     * Bind an event related specially to the query state model.<br/>
	     * This will build the correct string event and execute the handler only if the component is activated.
	     * @param eventType The event type for which to register an event.
	     * @param attribute The attribute for which to register an event.
	     * @param handler The handler to execute when the query state event is triggered.
	     */
	    ComponentEvents.prototype.onQueryState = function (eventType, attribute, handler) {
	        this.onRootElement(this.getQueryStateEventName(eventType, attribute), handler);
	    };
	    /**
	     * Bind an event related specially to the query state model.<br/>
	     * This will build the correct string event and execute the handler only if the component is activated.<br/>
	     * Will execute only once.
	     * @param eventType The event type for which to register an event.
	     * @param attribute The attribute for which to register an event.
	     * @param handler The handler to execute when the query state event is triggered.
	     */
	    ComponentEvents.prototype.oneQueryState = function (eventType, attribute, handler) {
	        this.oneRootElement(this.getQueryStateEventName(eventType, attribute), handler);
	    };
	    ComponentEvents.prototype.trigger = function (arg, event, args) {
	        this.wrapToCallIfEnabled(function () {
	            if (arg instanceof HTMLElement) {
	                var htmlEl = arg;
	                Dom_1.$$(htmlEl).trigger(event, args);
	            }
	            else {
	                var jq = arg;
	                jq.trigger(event, args);
	            }
	        })(args);
	    };
	    /**
	     * Execute the function only if the component is enabled.
	     * @param func The function to execute if the component is enabled.
	     * @returns {function(...[any]): *}
	     */
	    ComponentEvents.prototype.wrapToCallIfEnabled = function (func) {
	        var _this = this;
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i - 0] = arguments[_i];
	            }
	            if (!_this.owner.disabled) {
	                if (args && args[0] instanceof CustomEvent) {
	                    if (args[0].detail) {
	                        args = [args[0].detail];
	                    }
	                }
	                else if (args && JQueryutils_1.JQueryUtils.isInstanceOfJqueryEvent(args[0])) {
	                    if (args[1] != undefined) {
	                        args = [args[1]];
	                    }
	                    else {
	                        args = [];
	                    }
	                }
	                return func.apply(_this.owner, args);
	            }
	        };
	    };
	    ComponentEvents.prototype.getQueryStateEventName = function (eventType, attribute) {
	        var evtName;
	        if (eventType && attribute) {
	            evtName = this.owner.queryStateModel.getEventName(eventType + attribute);
	        }
	        else {
	            evtName = this.owner.queryStateModel.getEventName(eventType);
	        }
	        return evtName;
	    };
	    return ComponentEvents;
	}());
	exports.ComponentEvents = ComponentEvents;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var SearchEndpoint_1 = __webpack_require__(12);
	var ComponentOptions_1 = __webpack_require__(98);
	var DeviceUtils_1 = __webpack_require__(20);
	var Dom_1 = __webpack_require__(57);
	var DomUtils_1 = __webpack_require__(59);
	var Assert_1 = __webpack_require__(17);
	var QueryStateModel_1 = __webpack_require__(90);
	var ComponentStateModel_1 = __webpack_require__(92);
	var ComponentOptionsModel_1 = __webpack_require__(91);
	var QueryController_1 = __webpack_require__(74);
	var Model_1 = __webpack_require__(87);
	var QueryEvents_1 = __webpack_require__(47);
	var StandaloneSearchInterfaceEvents_1 = __webpack_require__(52);
	var HistoryController_1 = __webpack_require__(86);
	var LocalStorageHistoryController_1 = __webpack_require__(88);
	var InitializationEvents_1 = __webpack_require__(44);
	var NoopAnalyticsClient_1 = __webpack_require__(105);
	var Utils_1 = __webpack_require__(18);
	var RootComponent_1 = __webpack_require__(75);
	var BaseComponent_1 = __webpack_require__(76);
	var Debug_1 = __webpack_require__(106);
	var HashUtils_1 = __webpack_require__(65);
	var FastClick = __webpack_require__(107);
	var timezone = __webpack_require__(108);
	var SentryLogger_1 = __webpack_require__(109);
	/**
	 * This component is the root and main component of your search interface.<br/>
	 * You should place every other component inside this component.<br/>
	 * It is also on this component that you call the initialization function.<br/>
	 * Since this component is the root of your Search UI, it is recommended that you give it a unique HTML id attribute in order to reference it easily.
	 */
	var SearchInterface = (function (_super) {
	    __extends(SearchInterface, _super);
	    /**
	     * Create a new search interface. Initialize letious singleton for the interface (eg : Usage analytic, query controller, state model, etc.)<br/>
	     * Bind event related to the query.<br/>
	     * Will hide and show the loading animation, if activated.<br/>
	     * @param element The `HTMLElement` on which the element will be instantiated. This cannot be an `HTMLInputElement` for technical reasons.
	     * @param options The options for the querybox.
	     * @param analyticsOptions The options for the analytics component. Since the analytics component is normally global, it needs to be passed at initialization of the whole interface.
	     * @param _window The window object for the search interface. Used for unit tests, which can pass a mock. Default is the global window object.
	     */
	    function SearchInterface(element, options, analyticsOptions, _window) {
	        var _this = this;
	        if (_window === void 0) { _window = window; }
	        _super.call(this, element, SearchInterface.ID);
	        this.element = element;
	        this.options = options;
	        this.analyticsOptions = analyticsOptions;
	        this.isNewDesignAttribute = false;
	        if (DeviceUtils_1.DeviceUtils.isMobileDevice()) {
	            Dom_1.$$(document.body).addClass('coveo-mobile-device');
	        }
	        FastClick.attach(element);
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, SearchInterface, options);
	        Assert_1.Assert.exists(element);
	        Assert_1.Assert.exists(this.options);
	        if (this.options.hideUntilFirstQuery) {
	            this.showAndHideFirstQueryAnimation();
	        }
	        this.root = element;
	        this.queryStateModel = new QueryStateModel_1.QueryStateModel(element);
	        this.componentStateModel = new ComponentStateModel_1.ComponentStateModel(element);
	        this.componentOptionsModel = new ComponentOptionsModel_1.ComponentOptionsModel(element);
	        this.usageAnalytics = this.initializeAnalytics();
	        this.queryController = new QueryController_1.QueryController(element, this.options, this.usageAnalytics, this);
	        new SentryLogger_1.SentryLogger(this.queryController);
	        var eventName = this.queryStateModel.getEventName(Model_1.Model.eventTypes.preprocess);
	        Dom_1.$$(this.element).on(eventName, function (e, args) { return _this.handlePreprocessQueryStateModel(args); });
	        Dom_1.$$(this.element).on(QueryEvents_1.QueryEvents.buildingQuery, function (e, args) { return _this.handleBuildingQuery(args); });
	        Dom_1.$$(this.element).on(QueryEvents_1.QueryEvents.querySuccess, function (e, args) { return _this.handleQuerySuccess(args); });
	        Dom_1.$$(this.element).on(QueryEvents_1.QueryEvents.queryError, function (e, args) { return _this.handleQueryError(args); });
	        if (this.options.enableHistory) {
	            if (!this.options.useLocalStorageForHistory) {
	                new HistoryController_1.HistoryController(element, _window, this.queryStateModel, this.queryController);
	            }
	            else {
	                new LocalStorageHistoryController_1.LocalStorageHistoryController(element, _window, this.queryStateModel, this.queryController);
	            }
	        }
	        else {
	            Dom_1.$$(this.element).on(InitializationEvents_1.InitializationEvents.restoreHistoryState, function () { return _this.queryStateModel.setMultiple(_this.queryStateModel.defaultAttributes); });
	        }
	        var eventNameQuickview = this.queryStateModel.getEventName(Model_1.Model.eventTypes.changeOne + QueryStateModel_1.QueryStateModel.attributesEnum.quickview);
	        Dom_1.$$(this.element).on(eventNameQuickview, function (e, args) { return _this.handleQuickviewChanged(args); });
	        // shows the UI, since it's been hidden while loading
	        this.element.style.display = element.style.display || 'block';
	        this.setupDebugInfo();
	        this.isNewDesignAttribute = this.root.getAttribute('data-design') == 'new';
	    }
	    /**
	     * Display the first query animation.<br/>
	     * This is normally the Coveo logo with a CSS animation (which can be customized with options or CSS).
	     */
	    SearchInterface.prototype.showWaitAnimation = function () {
	        Dom_1.$$(this.options.firstLoadingAnimation).detach();
	        Dom_1.$$(this.element).addClass('coveo-waiting-for-first-query');
	        this.element.appendChild(this.options.firstLoadingAnimation);
	    };
	    /**
	     * Hide the first query animation.<br/>
	     * This is normally the Coveo logo with a CSS animation (which can be customized with options or CSS).
	     */
	    SearchInterface.prototype.hideWaitAnimation = function () {
	        Dom_1.$$(this.options.firstLoadingAnimation).detach();
	        Dom_1.$$(this.element).removeClass('coveo-waiting-for-first-query');
	    };
	    /**
	     * Attach a component to the interface. This allows the interface to easily list and traverse its component.
	     * @param type Normally a unique identifier without the Coveo prefix (e.g.: CoveoFacet -> Facet, CoveoPager -> Pager, CoveoQuerybox -> Querybox, etc.)
	     * @param component The component instance to attach.
	     */
	    SearchInterface.prototype.attachComponent = function (type, component) {
	        this.getComponents(type).push(component);
	    };
	    /**
	     * Detach a component from the interface.
	     * @param type Normally a unique identifier without the Coveo prefix (e.g.: CoveoFacet -> Facet, CoveoPager -> Pager, CoveoQuerybox -> Querybox, etc.)
	     * @param component The component instance to detach.
	     */
	    SearchInterface.prototype.detachComponent = function (type, component) {
	        var components = this.getComponents(type);
	        var index = _.indexOf(components, component);
	        if (index > -1) {
	            components.splice(index, 1);
	        }
	    };
	    /**
	     * Return the bindings, or environment, for the current component
	     * @returns {IComponentBindings}
	     */
	    SearchInterface.prototype.getBindings = function () {
	        return {
	            root: this.root,
	            queryStateModel: this.queryStateModel,
	            queryController: this.queryController,
	            searchInterface: this,
	            componentStateModel: this.componentStateModel,
	            componentOptionsModel: this.componentOptionsModel,
	            usageAnalytics: this.usageAnalytics
	        };
	    };
	    /**
	     * Get all the components for a given type
	     * @param type Normally a unique identifier without the Coveo prefix (e.g.: CoveoFacet -> Facet, CoveoPager -> Pager, CoveoQuerybox -> Querybox, etc.)
	     */
	    SearchInterface.prototype.getComponents = function (type) {
	        if (this.attachedComponents == null) {
	            this.attachedComponents = {};
	        }
	        if (!(type in this.attachedComponents)) {
	            this.attachedComponents[type] = [];
	        }
	        return this.attachedComponents[type];
	    };
	    /**
	     * Determines whether the interface is using the new design.<br/>
	     * This changes the rendering of multiple components.
	     */
	    SearchInterface.prototype.isNewDesign = function () {
	        return this.isNewDesignAttribute;
	    };
	    SearchInterface.prototype.initializeAnalytics = function () {
	        var analyticsRef = BaseComponent_1.BaseComponent.getComponentRef('Analytics');
	        if (analyticsRef) {
	            return analyticsRef.create(this.element, this.analyticsOptions);
	        }
	        return new NoopAnalyticsClient_1.NoopAnalyticsClient();
	    };
	    SearchInterface.prototype.setupDebugInfo = function () {
	        var _this = this;
	        if (this.options.enableDebugInfo) {
	            setTimeout(function () { return new Debug_1.Debug(_this.element, _this.queryController); });
	        }
	    };
	    SearchInterface.prototype.showAndHideFirstQueryAnimation = function () {
	        var _this = this;
	        this.showWaitAnimation();
	        // On first query success or error, wait for call stack to finish, then remove the animation
	        Dom_1.$$(this.element).one(QueryEvents_1.QueryEvents.querySuccess, function () {
	            _.defer(function () { return _this.hideWaitAnimation(); });
	        });
	        Dom_1.$$(this.element).one(QueryEvents_1.QueryEvents.queryError, function () {
	            _.defer(function () { return _this.hideWaitAnimation(); });
	        });
	    };
	    SearchInterface.prototype.handlePreprocessQueryStateModel = function (args) {
	        var tgFromModel = this.queryStateModel.get(QueryStateModel_1.QueryStateModel.attributesEnum.tg);
	        var tFromModel = this.queryStateModel.get(QueryStateModel_1.QueryStateModel.attributesEnum.t);
	        var tg = tgFromModel;
	        var t = tFromModel;
	        // if you want to set the tab group
	        if (args.tg !== undefined) {
	            args.tg = this.getTabGroupId(args.tg);
	            if (tg != args.tg) {
	                args.t = args.t || QueryStateModel_1.QueryStateModel.defaultAttributes.t;
	                args.sort = args.sort || QueryStateModel_1.QueryStateModel.defaultAttributes.sort;
	                tg = args.tg;
	            }
	        }
	        if (args.t !== undefined) {
	            args.t = this.getTabId(tg, args.t);
	            if (t != args.t) {
	                args.sort = args.sort || QueryStateModel_1.QueryStateModel.defaultAttributes.sort;
	                t = args.t;
	            }
	        }
	        if (args.sort !== undefined) {
	            args.sort = this.getSort(t, args.sort);
	        }
	        if (args.quickview !== undefined) {
	            args.quickview = this.getQuickview(args.quickview);
	        }
	    };
	    SearchInterface.prototype.getTabGroupId = function (tabGroupId) {
	        var tabGroupRef = BaseComponent_1.BaseComponent.getComponentRef('TabGroup');
	        if (tabGroupRef) {
	            var tabGroups = this.getComponents(tabGroupRef.ID);
	            // check if the tabgroup is correct
	            if (tabGroupId != QueryStateModel_1.QueryStateModel.defaultAttributes.tg && _.any(tabGroups, function (tabGroup) { return !tabGroup.disabled && tabGroupId == tabGroup.options.id; })) {
	                return tabGroupId;
	            }
	            // select the first tabGroup
	            if (tabGroups.length > 0) {
	                return tabGroups[0].options.id;
	            }
	        }
	        return QueryStateModel_1.QueryStateModel.defaultAttributes.tg;
	    };
	    SearchInterface.prototype.getTabId = function (tabGroupId, tabId) {
	        var tabRef = BaseComponent_1.BaseComponent.getComponentRef('Tab');
	        var tabGroupRef = BaseComponent_1.BaseComponent.getComponentRef('TabGroup');
	        if (tabRef) {
	            var tabs = this.getComponents(tabRef.ID);
	            if (tabGroupRef) {
	                // if has a tabGroup
	                if (tabGroupId != QueryStateModel_1.QueryStateModel.defaultAttributes.tg) {
	                    var tabGroups = this.getComponents(tabGroupRef.ID);
	                    var tabGroup_1 = _.find(tabGroups, function (tabGroup) { return tabGroupId == tabGroup.options.id; });
	                    // check if the tabgroup contain this tab
	                    if (tabId != QueryStateModel_1.QueryStateModel.defaultAttributes.t && _.any(tabs, function (tab) { return tabId == tab.options.id && tabGroup_1.isElementIncludedInTabGroup(tab.element); })) {
	                        return tabId;
	                    }
	                    // select the first tab in the tabGroup
	                    var tab = _.find(tabs, function (tab) { return tabGroup_1.isElementIncludedInTabGroup(tab.element); });
	                    if (tab != null) {
	                        return tab.options.id;
	                    }
	                    return QueryStateModel_1.QueryStateModel.defaultAttributes.t;
	                }
	            }
	            // check if the tab is correct
	            if (tabId != QueryStateModel_1.QueryStateModel.defaultAttributes.t && _.any(tabs, function (tab) { return tabId == tab.options.id; })) {
	                return tabId;
	            }
	            // select the first tab
	            if (tabs.length > 0) {
	                return tabs[0].options.id;
	            }
	        }
	        return QueryStateModel_1.QueryStateModel.defaultAttributes.t;
	    };
	    SearchInterface.prototype.getSort = function (tabId, sortId) {
	        var sortRef = BaseComponent_1.BaseComponent.getComponentRef('Sort');
	        if (sortRef) {
	            var sorts = this.getComponents(sortRef.ID);
	            // if has a selected tab
	            var tabRef = BaseComponent_1.BaseComponent.getComponentRef('Tab');
	            if (tabRef) {
	                if (tabId != QueryStateModel_1.QueryStateModel.defaultAttributes.t) {
	                    var tabs = this.getComponents(tabRef.ID);
	                    var tab_1 = _.find(tabs, function (tab) { return tabId == tab.options.id; });
	                    var sortCriteria = tab_1.options.sort;
	                    // check if the tab contain this sort
	                    if (sortId != QueryStateModel_1.QueryStateModel.defaultAttributes.sort && _.any(sorts, function (sort) { return tab_1.isElementIncludedInTab(sort.element) && sort.match(sortId); })) {
	                        return sortId;
	                    }
	                    else if (sortCriteria != null) {
	                        // if not and tab.options.sort is set apply it
	                        return sortCriteria.toString();
	                    }
	                    // select the first sort in the tab
	                    var sort = _.find(sorts, function (sort) { return tab_1.isElementIncludedInTab(sort.element); });
	                    if (sort != null) {
	                        return sort.options.sortCriteria[0].toString();
	                    }
	                    return QueryStateModel_1.QueryStateModel.defaultAttributes.sort;
	                }
	            }
	            // check if the sort is correct
	            if (sortId != QueryStateModel_1.QueryStateModel.defaultAttributes.sort && _.any(sorts, function (sort) { return sort.match(sortId); })) {
	                return sortId;
	            }
	            // select the first sort
	            if (sorts.length > 0) {
	                return sorts[0].options.sortCriteria[0].toString();
	            }
	        }
	        return QueryStateModel_1.QueryStateModel.defaultAttributes.sort;
	    };
	    SearchInterface.prototype.getQuickview = function (quickviewId) {
	        var quickviewRef = BaseComponent_1.BaseComponent.getComponentRef('Quickview');
	        if (quickviewRef) {
	            var quickviews = this.getComponents(quickviewRef.ID);
	            if (_.any(quickviews, function (quickview) { return quickview.getHashId() == quickviewId; })) {
	                return quickviewId;
	            }
	        }
	        return QueryStateModel_1.QueryStateModel.defaultAttributes.quickview;
	    };
	    SearchInterface.prototype.handleQuickviewChanged = function (args) {
	        var quickviewRef = BaseComponent_1.BaseComponent.getComponentRef('Quickview');
	        if (quickviewRef) {
	            var quickviews = this.getComponents(quickviewRef.ID);
	            if (args.value != '') {
	                var quickviewsPartition = _.partition(quickviews, function (quickview) { return quickview.getHashId() == args.value; });
	                if (quickviewsPartition[0].length != 0) {
	                    _.first(quickviewsPartition[0]).open();
	                    _.forEach(_.tail(quickviewsPartition[0]), function (quickview) { return quickview.close(); });
	                }
	                _.forEach(quickviewsPartition[1], function (quickview) { return quickview.close(); });
	            }
	            else {
	                _.forEach(quickviews, function (quickview) {
	                    quickview.close();
	                });
	            }
	        }
	    };
	    SearchInterface.prototype.handleBuildingQuery = function (data) {
	        if (this.options.enableDuplicateFiltering) {
	            data.queryBuilder.enableDuplicateFiltering = true;
	        }
	        if (!Utils_1.Utils.isNullOrUndefined(this.options.pipeline)) {
	            data.queryBuilder.pipeline = this.options.pipeline;
	        }
	        if (!Utils_1.Utils.isNullOrUndefined(this.options.maximumAge)) {
	            data.queryBuilder.maximumAge = this.options.maximumAge;
	        }
	        if (!Utils_1.Utils.isNullOrUndefined(this.options.resultsPerPage)) {
	            data.queryBuilder.numberOfResults = this.options.resultsPerPage;
	        }
	        if (!Utils_1.Utils.isNullOrUndefined(this.options.excerptLength)) {
	            data.queryBuilder.excerptLength = this.options.excerptLength;
	        }
	        if (Utils_1.Utils.isNonEmptyString(this.options.expression)) {
	            data.queryBuilder.advancedExpression.add(this.options.expression);
	        }
	        if (Utils_1.Utils.isNonEmptyString(this.options.filterField)) {
	            data.queryBuilder.filterField = this.options.filterField;
	        }
	        if (Utils_1.Utils.isNonEmptyString(this.options.timezone)) {
	            data.queryBuilder.timezone = this.options.timezone;
	        }
	        data.queryBuilder.enableCollaborativeRating = this.options.enableCollaborativeRating;
	        data.queryBuilder.enableDuplicateFiltering = this.options.enableDuplicateFiltering;
	    };
	    SearchInterface.prototype.handleQuerySuccess = function (data) {
	        var noResults = data.results.results.length == 0;
	        this.toggleSectionState('coveo-no-results', noResults);
	        var resultsHeader = Dom_1.$$(this.element).find('.coveo-results-header');
	        if (resultsHeader) {
	            Dom_1.$$(resultsHeader).removeClass('coveo-query-error');
	        }
	    };
	    SearchInterface.prototype.handleQueryError = function (data) {
	        this.toggleSectionState('coveo-no-results');
	        var resultsHeader = Dom_1.$$(this.element).find('.coveo-results-header');
	        if (resultsHeader) {
	            Dom_1.$$(resultsHeader).addClass('coveo-query-error');
	        }
	    };
	    SearchInterface.prototype.toggleSectionState = function (cssClass, toggle) {
	        var _this = this;
	        if (toggle === void 0) { toggle = true; }
	        var facetSection = Dom_1.$$(this.element).find('.coveo-facet-column');
	        var resultsSection = Dom_1.$$(this.element).find('.coveo-results-column');
	        var resultsHeader = Dom_1.$$(this.element).find('.coveo-results-header');
	        var facetSearchs = Dom_1.$$(this.element).findAll('.coveo-facet-search-results');
	        if (facetSection) {
	            Dom_1.$$(facetSection).toggleClass(cssClass, toggle && !this.queryStateModel.atLeastOneFacetIsActive());
	        }
	        if (resultsSection) {
	            Dom_1.$$(resultsSection).toggleClass(cssClass, toggle && !this.queryStateModel.atLeastOneFacetIsActive());
	        }
	        if (resultsHeader) {
	            Dom_1.$$(resultsHeader).toggleClass(cssClass, toggle && !this.queryStateModel.atLeastOneFacetIsActive());
	        }
	        if (facetSearchs && facetSearchs.length > 0) {
	            _.each(facetSearchs, function (facetSearch) {
	                Dom_1.$$(facetSearch).toggleClass(cssClass, toggle && !_this.queryStateModel.atLeastOneFacetIsActive());
	            });
	        }
	    };
	    SearchInterface.ID = 'SearchInterface';
	    /**
	     * The options for the search interface
	     * @componentOptions
	     */
	    SearchInterface.options = {
	        /**
	         * Specifies whether your search interface allows users to navigate in the search history using the browser back/forward buttons.<br/>
	         * When enabled, the search interface saves the state of the current query in the hash portion of the URL.<br/>
	         * For example #q=foobar.<br/>
	         * The default value is `false`.
	         */
	        enableHistory: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: false }),
	        /**
	         * Specifies whether the UI should use an automatic responsive mode (eg : The tab(s) and facet(s) being placed automatically under the search box)<br/>
	         * This can be disabled for design reasons, if it does not fit with the implementation needs.<br/>
	         * The default value is `true`
	         */
	        enableAutomaticResponsiveMode: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true }),
	        /**
	         * Specifies that you wish to use the local storage of the browser to store the state of the interface.<br/>
	         * This can be used for very specific purpose, and only if you know what you are doing.<br/>
	         * Default value is `false`.
	         */
	        useLocalStorageForHistory: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: false }),
	        /**
	         * Specifies the number of results that each page displays.<br/>
	         * Default is 10.
	         */
	        resultsPerPage: ComponentOptions_1.ComponentOptions.buildNumberOption({ defaultValue: 10, min: 0 }),
	        /**
	         * Specifies the number of characters of the excerpt to get at query time and display for each query result.<br/>
	         * This setting is global and can not be modified on a per result basis.<br/>
	         * The default value is 200.
	         */
	        excerptLength: ComponentOptions_1.ComponentOptions.buildNumberOption({ defaultValue: 200, min: 0 }),
	        /**
	         * Specifies an expression to add to each query.<br/>
	         * This should be use if you wish to add a global filter for your whole search interface that applies for all tabs.<br/>
	         * Do not use this for security concern ... (It is JavaScript after all).<br/>
	         * By default none is added.
	         */
	        expression: ComponentOptions_1.ComponentOptions.buildStringOption({ defaultValue: '' }),
	        /**
	         * Specifies the name of a field to use as a custom filter when executing the query (also referred to as 'folding').<br/>
	         * Setting this option causes the index to return only one result having any particular value inside the filter field. Any other matching result is 'folded' inside the childResults member of each JSON query result.<br/>
	         * This feature is typically used with threaded conversations to include only one top-level result per conversation. Thus, the field specified in this option typically is a value unique to each thread that is shared by all items (e.g.: posts, emails, etc.) in the thread.<br/>
	         * This is obviously an advanced feature. Instead, look into using the {@link Folding} component, which covers a lot of different use cases.<br/>
	         * By default none is added
	         */
	        filterField: ComponentOptions_1.ComponentOptions.buildStringOption({ defaultValue: '' }),
	        /**
	         * Specifies whether the interface should display a loading animation before the first query has completed successfully.<br/>
	         * Note that if you set autoTriggerQuery to false, this means that the loading animation will not go away automatically.<br/>
	         * Default is true.
	         */
	        hideUntilFirstQuery: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true }),
	        /**
	         * Specifies the animation that you wish to use for your interface.<br/>
	         * This can be a selector or an element that matches the correct CSS class.<br/>
	         * Eg : firstLoadingAnimation : '.CustomFirstLoadingAnimation' / data-first-loading-animation='.CustomFirstLoadingAnimation'.</br>
	         * Eg : &lt;element class='CoveoSearchInterface'&gt;&lt;element class='coveo-first-loading-animation'/&gt;&lt;/element&gt;<br/>
	         * By default, this will be a Coveo CSS animation (which can also be customized with CSS).
	         */
	        firstLoadingAnimation: ComponentOptions_1.ComponentOptions.buildChildHtmlElementOption({
	            childSelector: '.coveo-first-loading-animation',
	            defaultFunction: function () { return DomUtils_1.DomUtils.getBasicLoadingAnimation(); }
	        }),
	        /**
	         * Specifies whether the init function should trigger the first query automatically when the page is loaded.<br/>
	         * Note that if you set this to false, then the hideUntilFirstQuery option still applies. This means that the animation will still show until a query is triggered.<br/>
	         * Default is `true`.
	         */
	        autoTriggerQuery: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true }),
	        endpoint: ComponentOptions_1.ComponentOptions.buildCustomOption(function (endpoint) { return endpoint != null && endpoint in SearchEndpoint_1.SearchEndpoint.endpoints ? SearchEndpoint_1.SearchEndpoint.endpoints[endpoint] : null; }, { defaultFunction: function () { return SearchEndpoint_1.SearchEndpoint.endpoints['default']; } }),
	        /**
	         * Specifies the timezone in which the search interface is loaded. This allows the index to recognize some special query syntax.<br/>
	         * This must be an IANA zone info key (aka the Olson time zone database). For example : 'America/New_York'.<br/>
	         * By default, we use a library that tries to detect the timezone automatically.<br/>
	         */
	        timezone: ComponentOptions_1.ComponentOptions.buildStringOption({ defaultFunction: function () { return timezone.jstz.determine().name(); } }),
	        /**
	         * Specifies whether to enable the feature that allows users to ALT + double click on any results to get the Debug page with a detailed view of all the properties and fields for a given result.<br/>
	         * This has no security concern (as all those informations are visible to users through the browser developer console or by calling the Coveo API directly).<br/>
	         * The default value is `true`.
	         */
	        enableDebugInfo: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true }),
	        /**
	         * Specifies whether to enable the collaborative rating for the index and and include the user rating on each results to the normal index ranking.<br/>
	         * If activated, this option can be leveraged with the {@link ResultRating} component.<br/>
	         * The default value is `false`.
	         */
	        enableCollaborativeRating: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: false }),
	        /**
	         * Specifies whether to filter duplicates on the search results.<br/>
	         * When true, duplicates do not appear in search results, but they however are included in facet counts, which can be sometimes confusing for the users. This is a limitation of the index.<br/>
	         * Example: The user narrows a query to one document that has a duplicate. Only one document appears in search results, but the facet count is 2.<br/>
	         * The default value is `false`.
	         */
	        enableDuplicateFiltering: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: false }),
	        /**
	         * Specifies the name of the query pipeline to use for the queries. If not specified, the default value is default, which means the default query pipeline will be used.<br/>
	         * You can use this parameter when your index is in a Coveo Cloud organization where you created pipelines (see https://onlinehelp.coveo.com/en/cloud/creating_and_managing_query_pipelines.htm).<br/>
	         * Default value is 'default'.
	         */
	        pipeline: ComponentOptions_1.ComponentOptions.buildStringOption(),
	        /**
	         * Specifies the maximum age in milliseconds that cached query results can have in order to be used (instead of performing a new query on the index).<br/>
	         * If cached results are available but are older than the specified age, a new query will be performed on the index.<br/>
	         * On high-volume public web sites, having a larger maximum age can greatly improve query response time at the cost of result freshness.<br/>
	         * By default, the Coveo Search API will determine the cache length. This typically takes 15 minutes.
	         */
	        maximumAge: ComponentOptions_1.ComponentOptions.buildNumberOption(),
	        /**
	         * Specifies the search page you wish to navigate to when instantiating a standalone search box interface.<br/>
	         * By default this is undefined, meaning the search interface will not redirect.
	         */
	        searchPageUri: ComponentOptions_1.ComponentOptions.buildStringOption()
	    };
	    SearchInterface.SMALL_INTERFACE_CLASS_NAME = 'coveo-small-search-interface';
	    return SearchInterface;
	}(RootComponent_1.RootComponent));
	exports.SearchInterface = SearchInterface;
	var StandaloneSearchInterface = (function (_super) {
	    __extends(StandaloneSearchInterface, _super);
	    function StandaloneSearchInterface(element, options, analyticsOptions, _window) {
	        var _this = this;
	        if (_window === void 0) { _window = window; }
	        _super.call(this, element, ComponentOptions_1.ComponentOptions.initComponentOptions(element, StandaloneSearchInterface, options), analyticsOptions, _window);
	        this.element = element;
	        this.options = options;
	        this.analyticsOptions = analyticsOptions;
	        Dom_1.$$(this.root).on(QueryEvents_1.QueryEvents.newQuery, function (e, args) { return _this.handleRedirect(e, args); });
	    }
	    StandaloneSearchInterface.prototype.handleRedirect = function (e, data) {
	        var dataToSendOnBeforeRedirect = {
	            searchPageUri: this.options.searchPageUri,
	            cancel: false
	        };
	        Dom_1.$$(this.root).trigger(StandaloneSearchInterfaceEvents_1.StandaloneSearchInterfaceEvents.beforeRedirect, dataToSendOnBeforeRedirect);
	        if (dataToSendOnBeforeRedirect.cancel) {
	            return;
	        }
	        data.cancel = true;
	        if (!this.searchboxIsEmpty() || this.options.redirectIfEmpty) {
	            this.redirectToSearchPage(dataToSendOnBeforeRedirect.searchPageUri);
	        }
	    };
	    StandaloneSearchInterface.prototype.redirectToSearchPage = function (searchPage) {
	        var stateValues = this.queryStateModel.getAttributes();
	        var uaCausedBy = this.usageAnalytics.getCurrentEventCause();
	        if (uaCausedBy != null) {
	            stateValues['firstQueryCause'] = uaCausedBy;
	        }
	        var uaMeta = this.usageAnalytics.getCurrentEventMeta();
	        if (uaMeta != null) {
	            stateValues['firstQueryMeta'] = uaMeta;
	        }
	        window.location.href = searchPage + '#' + HashUtils_1.HashUtils.encodeValues(stateValues);
	    };
	    StandaloneSearchInterface.prototype.searchboxIsEmpty = function () {
	        return Utils_1.Utils.isEmptyString(this.queryStateModel.get(QueryStateModel_1.QueryStateModel.attributesEnum.q));
	    };
	    StandaloneSearchInterface.ID = 'StandaloneSearchInterface';
	    StandaloneSearchInterface.options = {
	        redirectIfEmpty: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true })
	    };
	    return StandaloneSearchInterface;
	}(SearchInterface));
	exports.StandaloneSearchInterface = StandaloneSearchInterface;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var Assert_1 = __webpack_require__(17);
	var Logger_1 = __webpack_require__(16);
	var Dom_1 = __webpack_require__(57);
	var TemplateCache_1 = __webpack_require__(99);
	var TemplateList_1 = __webpack_require__(103);
	var UnderscoreTemplate_1 = __webpack_require__(101);
	var HtmlTemplate_1 = __webpack_require__(102);
	var Utils_1 = __webpack_require__(18);
	var Strings_1 = __webpack_require__(34);
	(function (ComponentOptionsType) {
	    ComponentOptionsType[ComponentOptionsType["BOOLEAN"] = 0] = "BOOLEAN";
	    ComponentOptionsType[ComponentOptionsType["NUMBER"] = 1] = "NUMBER";
	    ComponentOptionsType[ComponentOptionsType["STRING"] = 2] = "STRING";
	    ComponentOptionsType[ComponentOptionsType["LOCALIZED_STRING"] = 3] = "LOCALIZED_STRING";
	    ComponentOptionsType[ComponentOptionsType["LIST"] = 4] = "LIST";
	    ComponentOptionsType[ComponentOptionsType["SELECTOR"] = 5] = "SELECTOR";
	    ComponentOptionsType[ComponentOptionsType["CHILD_HTML_ELEMENT"] = 6] = "CHILD_HTML_ELEMENT";
	    ComponentOptionsType[ComponentOptionsType["TEMPLATE"] = 7] = "TEMPLATE";
	    ComponentOptionsType[ComponentOptionsType["FIELD"] = 8] = "FIELD";
	    ComponentOptionsType[ComponentOptionsType["FIELDS"] = 9] = "FIELDS";
	    ComponentOptionsType[ComponentOptionsType["ICON"] = 10] = "ICON";
	    ComponentOptionsType[ComponentOptionsType["OBJECT"] = 11] = "OBJECT";
	    ComponentOptionsType[ComponentOptionsType["QUERY"] = 12] = "QUERY";
	    ComponentOptionsType[ComponentOptionsType["HELPER"] = 13] = "HELPER";
	    ComponentOptionsType[ComponentOptionsType["LONG_STRING"] = 14] = "LONG_STRING";
	    ComponentOptionsType[ComponentOptionsType["JSON"] = 15] = "JSON";
	    ComponentOptionsType[ComponentOptionsType["JAVASCRIPT"] = 16] = "JAVASCRIPT";
	    ComponentOptionsType[ComponentOptionsType["NONE"] = 17] = "NONE";
	})(exports.ComponentOptionsType || (exports.ComponentOptionsType = {}));
	var ComponentOptionsType = exports.ComponentOptionsType;
	var camelCaseToHyphenRegex = /([A-Z])|\W+(\w)/g;
	var fieldsSeperator = /\s*,\s*/;
	var localizer = /([a-zA-Z\-]+)\s*:\s*(([^,]|,\s*(?!([a-zA-Z\-]+)\s*:))+)/g;
	var ComponentOptions = (function () {
	    function ComponentOptions() {
	    }
	    ComponentOptions.buildBooleanOption = function (optionArgs) {
	        return ComponentOptions.buildOption(ComponentOptionsType.BOOLEAN, ComponentOptions.loadBooleanOption, optionArgs);
	    };
	    ComponentOptions.buildNumberOption = function (optionArgs) {
	        return ComponentOptions.buildOption(ComponentOptionsType.NUMBER, ComponentOptions.loadNumberOption, optionArgs);
	    };
	    ComponentOptions.buildStringOption = function (optionArgs) {
	        return ComponentOptions.buildOption(ComponentOptionsType.STRING, ComponentOptions.loadStringOption, optionArgs);
	    };
	    ComponentOptions.buildIconOption = function (optionArgs) {
	        return ComponentOptions.buildOption(ComponentOptionsType.ICON, ComponentOptions.loadStringOption, optionArgs);
	    };
	    ComponentOptions.buildHelperOption = function (optionArgs) {
	        return ComponentOptions.buildOption(ComponentOptionsType.HELPER, ComponentOptions.loadStringOption, optionArgs);
	    };
	    ComponentOptions.buildJsonOption = function (optionArgs) {
	        return ComponentOptions.buildOption(ComponentOptionsType.JSON, ComponentOptions.loadStringOption, optionArgs);
	    };
	    ComponentOptions.buildLocalizedStringOption = function (optionArgs) {
	        return ComponentOptions.buildOption(ComponentOptionsType.LOCALIZED_STRING, ComponentOptions.loadLocalizedStringOption, optionArgs);
	    };
	    ComponentOptions.buildFieldOption = function (optionArgs) {
	        return ComponentOptions.buildOption(ComponentOptionsType.FIELD, ComponentOptions.loadFieldOption, optionArgs);
	    };
	    ComponentOptions.buildFieldsOption = function (optionArgs) {
	        return ComponentOptions.buildOption(ComponentOptionsType.FIELDS, ComponentOptions.loadFieldsOption, optionArgs);
	    };
	    ComponentOptions.buildListOption = function (optionArgs) {
	        return ComponentOptions.buildOption(ComponentOptionsType.LIST, ComponentOptions.loadListOption, optionArgs);
	    };
	    ComponentOptions.buildSelectorOption = function (optionArgs) {
	        return ComponentOptions.buildOption(ComponentOptionsType.SELECTOR, ComponentOptions.loadSelectorOption, optionArgs);
	    };
	    ComponentOptions.buildChildHtmlElementOption = function (optionArgs) {
	        return ComponentOptions.buildOption(ComponentOptionsType.CHILD_HTML_ELEMENT, ComponentOptions.loadChildHtmlElementOption, optionArgs);
	    };
	    ComponentOptions.buildTemplateOption = function (optionArgs) {
	        return ComponentOptions.buildOption(ComponentOptionsType.TEMPLATE, ComponentOptions.loadTemplateOption, optionArgs);
	    };
	    ComponentOptions.buildCustomOption = function (converter, optionArgs) {
	        var loadOption = function (element, name, option) {
	            var stringvalue = ComponentOptions.loadStringOption(element, name, option);
	            if (!Utils_1.Utils.isNullOrEmptyString(stringvalue)) {
	                return converter(stringvalue);
	            }
	        };
	        return ComponentOptions.buildOption(ComponentOptionsType.STRING, loadOption, optionArgs);
	    };
	    ComponentOptions.buildCustomListOption = function (converter, optionArgs) {
	        var loadOption = function (element, name, option) {
	            var stringvalue = ComponentOptions.loadListOption(element, name, option);
	            return converter(stringvalue);
	        };
	        return ComponentOptions.buildOption(ComponentOptionsType.LIST, loadOption, optionArgs);
	    };
	    ComponentOptions.buildObjectOption = function (optionArgs) {
	        var loadOption = function (element, name, option) {
	            var keys = _.keys(optionArgs.subOptions);
	            var scopedOptions = {};
	            var scopedValues = {};
	            for (var i = 0; i < keys.length; i++) {
	                var key = keys[i];
	                var scopedkey = ComponentOptions.mergeCamelCase(name, key);
	                scopedOptions[scopedkey] = optionArgs.subOptions[key];
	            }
	            ComponentOptions.initOptions(element, scopedOptions, scopedValues);
	            var resultValues = {};
	            var resultFound = false;
	            for (var i = 0; i < keys.length; i++) {
	                var key = keys[i];
	                var scopedkey = ComponentOptions.mergeCamelCase(name, key);
	                if (scopedValues[scopedkey] != null) {
	                    resultValues[key] = scopedValues[scopedkey];
	                    resultFound = true;
	                }
	            }
	            return resultFound ? resultValues : null;
	        };
	        return ComponentOptions.buildOption(ComponentOptionsType.OBJECT, loadOption, optionArgs);
	    };
	    ComponentOptions.buildOption = function (type, load, optionArg) {
	        if (optionArg === void 0) { optionArg = {}; }
	        var option = optionArg;
	        option.type = type;
	        option.load = load;
	        return option;
	    };
	    ComponentOptions.attrNameFromName = function (name, optionArgs) {
	        if (optionArgs && optionArgs.attrName) {
	            return optionArgs.attrName;
	        }
	        if (name) {
	            return 'data-' + ComponentOptions.camelCaseToHyphen(name);
	        }
	        return name;
	    };
	    ComponentOptions.camelCaseToHyphen = function (name) {
	        return name.replace(camelCaseToHyphenRegex, '-$1$2').toLowerCase();
	    };
	    ComponentOptions.mergeCamelCase = function (parent, name) {
	        return parent + name.substr(0, 1).toUpperCase() + name.substr(1);
	    };
	    ComponentOptions.initComponentOptions = function (element, component, values) {
	        return ComponentOptions.initOptions(element, component.options, values, component.ID);
	    };
	    ComponentOptions.initOptions = function (element, options, values, componentID) {
	        var logger = new Logger_1.Logger(this);
	        if (values == null) {
	            values = {};
	        }
	        var names = _.keys(options);
	        for (var i = 0; i < names.length; i++) {
	            var name_1 = names[i];
	            var optionDefinition = options[name_1];
	            var value = void 0;
	            var loadFromAttribute = optionDefinition.load;
	            if (loadFromAttribute != null) {
	                value = loadFromAttribute(element, name_1, optionDefinition);
	                if (value && optionDefinition.deprecated) {
	                    logger.warn(componentID + '.' + name_1 + ' : ' + optionDefinition.deprecated);
	                }
	            }
	            if (Utils_1.Utils.isNullOrUndefined(value) && values[name_1] != undefined) {
	                value = values[name_1];
	            }
	            if (value == null && values[name_1] == undefined) {
	                if (optionDefinition.defaultValue != null) {
	                    if (optionDefinition.type == ComponentOptionsType.LIST) {
	                        value = _.extend([], optionDefinition.defaultValue);
	                    }
	                    else if (optionDefinition.type == ComponentOptionsType.OBJECT) {
	                        value = _.extend({}, optionDefinition.defaultValue);
	                    }
	                    else {
	                        value = optionDefinition.defaultValue;
	                    }
	                }
	                else if (optionDefinition.defaultFunction != null) {
	                    value = optionDefinition.defaultFunction(element);
	                }
	            }
	            if (value != null) {
	                if (optionDefinition.validator) {
	                    var isValid = optionDefinition.validator(value);
	                    if (!isValid) {
	                        logger.warn(componentID + " ." + name_1 + " has invalid value :  " + value);
	                        if (optionDefinition.required) {
	                            logger.error(componentID + " ." + name_1 + " is required and has an invalid value : " + value + ". ***THIS COMPONENT WILL NOT WORK***");
	                        }
	                        delete values[name_1];
	                        continue;
	                    }
	                }
	                if (optionDefinition.type == ComponentOptionsType.OBJECT && values[name_1] != null) {
	                    values[name_1] = _.extend(values[name_1], value);
	                }
	                else if (optionDefinition.type == ComponentOptionsType.LOCALIZED_STRING) {
	                    values[name_1] = Strings_1.l(value);
	                }
	                else {
	                    values[name_1] = value;
	                }
	            }
	        }
	        for (var i = 0; i < names.length; i++) {
	            var name_2 = names[i];
	            var optionDefinition = options[name_2];
	            if (optionDefinition.postProcessing) {
	                values[name_2] = optionDefinition.postProcessing(values[name_2], values);
	            }
	        }
	        return values;
	    };
	    ComponentOptions.loadStringOption = function (element, name, option) {
	        return element.getAttribute(ComponentOptions.attrNameFromName(name, option)) || ComponentOptions.getAttributeFromAlias(element, option);
	    };
	    ComponentOptions.loadFieldOption = function (element, name, option) {
	        var field = ComponentOptions.loadStringOption(element, name, option);
	        Assert_1.Assert.check(!Utils_1.Utils.isNonEmptyString(field) || Utils_1.Utils.isCoveoField(field), field + ' is not a valid field');
	        return field;
	    };
	    ComponentOptions.loadFieldsOption = function (element, name, option) {
	        var fieldsAttr = ComponentOptions.loadStringOption(element, name, option);
	        if (fieldsAttr == null) {
	            return null;
	        }
	        var fields = fieldsAttr.split(fieldsSeperator);
	        _.each(fields, function (field) {
	            Assert_1.Assert.check(Utils_1.Utils.isCoveoField(field), field + ' is not a valid field');
	        });
	        return fields;
	    };
	    ComponentOptions.loadLocalizedStringOption = function (element, name, option) {
	        var attributeValue = ComponentOptions.loadStringOption(element, name, option);
	        var locale = String['locale'] || String['defaultLocale'];
	        if (locale != null && attributeValue != null) {
	            var localeParts_1 = locale.toLowerCase().split('-');
	            var locales = _.map(localeParts_1, function (part, i) { return localeParts_1.slice(0, i + 1).join('-'); });
	            var localizers = attributeValue.match(localizer);
	            if (localizers != null) {
	                for (var i = 0; i < localizers.length; i++) {
	                    var groups = localizer.exec(localizers[i]);
	                    if (groups != null) {
	                        var lang = groups[1].toLowerCase();
	                        if (_.contains(locales, lang)) {
	                            return groups[2].replace(/^\s+|\s+$/g, '');
	                        }
	                    }
	                }
	            }
	            return attributeValue != null ? attributeValue.toLocaleString() : null;
	        }
	        return attributeValue;
	    };
	    ComponentOptions.loadNumberOption = function (element, name, option) {
	        var attributeValue = ComponentOptions.loadStringOption(element, name, option);
	        if (attributeValue == null) {
	            return null;
	        }
	        var numberValue = option.float === true ? Utils_1.Utils.parseFloatIfNotUndefined(attributeValue) : Utils_1.Utils.parseIntIfNotUndefined(attributeValue);
	        if (option.min != null && option.min > numberValue) {
	            numberValue = option.min;
	        }
	        if (option.max != null && option.max < numberValue) {
	            numberValue = option.max;
	        }
	        return numberValue;
	    };
	    ComponentOptions.loadBooleanOption = function (element, name, option) {
	        return Utils_1.Utils.parseBooleanIfNotUndefined(ComponentOptions.loadStringOption(element, name, option));
	    };
	    ComponentOptions.loadListOption = function (element, name, option) {
	        var separator = option.separator || /\s*,\s*/;
	        var attributeValue = ComponentOptions.loadStringOption(element, name, option);
	        return Utils_1.Utils.isNonEmptyString(attributeValue) ? attributeValue.split(separator) : null;
	    };
	    ComponentOptions.loadEnumOption = function (element, name, option, _enum) {
	        var enumAsString = ComponentOptions.loadStringOption(element, name, option);
	        return enumAsString != null ? _enum[enumAsString] : null;
	    };
	    ComponentOptions.loadSelectorOption = function (element, name, option, doc) {
	        if (doc === void 0) { doc = document; }
	        var attributeValue = ComponentOptions.loadStringOption(element, name, option);
	        return Utils_1.Utils.isNonEmptyString(attributeValue) ? doc.querySelector(attributeValue) : null;
	    };
	    ComponentOptions.loadChildHtmlElementOption = function (element, name, option, doc) {
	        if (doc === void 0) { doc = document; }
	        var htmlElement;
	        // Attribute: selector
	        var selectorAttr = option.selectorAttr || ComponentOptions.attrNameFromName(name, option) + '-selector';
	        var selector = element.getAttribute(selectorAttr) || ComponentOptions.getAttributeFromAlias(element, option);
	        if (selector != null) {
	            htmlElement = doc.body.querySelector(selector);
	        }
	        // Child
	        if (htmlElement == null) {
	            var childSelector = option.childSelector;
	            if (childSelector == null) {
	                childSelector = '.' + name;
	            }
	            htmlElement = ComponentOptions.loadChildHtmlElementFromSelector(element, childSelector);
	        }
	        return htmlElement;
	    };
	    ComponentOptions.loadChildHtmlElementFromSelector = function (element, selector) {
	        Assert_1.Assert.isNonEmptyString(selector);
	        if (Dom_1.$$(element).is(selector)) {
	            return element;
	        }
	        return Dom_1.$$(element).find(selector);
	    };
	    ComponentOptions.loadChildrenHtmlElementFromSelector = function (element, selector) {
	        Assert_1.Assert.isNonEmptyString(selector);
	        return Dom_1.$$(element).findAll(selector);
	    };
	    ComponentOptions.loadTemplateOption = function (element, name, option, doc) {
	        if (doc === void 0) { doc = document; }
	        var template;
	        // Attribute: template selector
	        var selectorAttr = option.selectorAttr || ComponentOptions.attrNameFromName(name, option) + '-selector';
	        var selector = element.getAttribute(selectorAttr) || ComponentOptions.getAttributeFromAlias(element, option);
	        if (selector != null) {
	            var templateElement = doc.querySelector(selector);
	            if (templateElement != null) {
	                template = ComponentOptions.createResultTemplateFromElement(templateElement);
	            }
	        }
	        // Attribute: template id
	        if (template == null) {
	            var idAttr = option.idAttr || ComponentOptions.attrNameFromName(name, option) + '-id';
	            var id = element.getAttribute(idAttr) || ComponentOptions.getAttributeFromAlias(element, option);
	            if (id != null) {
	                template = ComponentOptions.loadResultTemplateFromId(id);
	            }
	        }
	        // Child
	        if (template == null) {
	            var childSelector = option.childSelector;
	            if (childSelector == null) {
	                childSelector = '.' + name.replace(/([A-Z])/g, '-$1').toLowerCase();
	            }
	            template = ComponentOptions.loadChildrenResultTemplateFromSelector(element, childSelector);
	        }
	        return template;
	    };
	    ComponentOptions.loadResultTemplateFromId = function (templateId) {
	        return Utils_1.Utils.isNonEmptyString(templateId) ? TemplateCache_1.TemplateCache.getTemplate(templateId) : null;
	    };
	    ComponentOptions.loadChildrenResultTemplateFromSelector = function (element, selector) {
	        var foundElements = ComponentOptions.loadChildrenHtmlElementFromSelector(element, selector);
	        if (foundElements.length > 0) {
	            return new TemplateList_1.TemplateList(_.compact(_.map(foundElements, function (element) { return ComponentOptions.createResultTemplateFromElement(element); })));
	        }
	        return null;
	    };
	    ComponentOptions.findParentScrolling = function (element, doc) {
	        if (doc === void 0) { doc = document; }
	        while (element != doc && element != null) {
	            if (ComponentOptions.isElementScrollable(element)) {
	                if (element.tagName.toLowerCase() !== 'body') {
	                    return element;
	                }
	                return window;
	            }
	            element = element.parentElement;
	        }
	        return window;
	    };
	    ComponentOptions.isElementScrollable = function (element) {
	        return Dom_1.$$(element).css('overflow-y') == 'scroll' || element.style.overflowY == 'scroll';
	    };
	    ComponentOptions.getAttributeFromAlias = function (element, option) {
	        if (option.alias) {
	            return element.getAttribute(ComponentOptions.attrNameFromName(option.alias));
	        }
	    };
	    ComponentOptions.createResultTemplateFromElement = function (element) {
	        Assert_1.Assert.exists(element);
	        var type = element.getAttribute('type');
	        var mimeTypes = 'You must specify the type of template. Valid values are :' +
	            ' ' + UnderscoreTemplate_1.UnderscoreTemplate.mimeTypes.toString() +
	            ' ' + HtmlTemplate_1.HtmlTemplate.mimeTypes.toString();
	        Assert_1.Assert.check(Utils_1.Utils.isNonEmptyString(type), mimeTypes);
	        if (_.indexOf(UnderscoreTemplate_1.UnderscoreTemplate.mimeTypes, type) != -1) {
	            return UnderscoreTemplate_1.UnderscoreTemplate.create(element);
	        }
	        else if (_.indexOf(HtmlTemplate_1.HtmlTemplate.mimeTypes, type) != -1) {
	            return new HtmlTemplate_1.HtmlTemplate(element);
	        }
	        else {
	            Assert_1.Assert.fail('Cannot guess template type from attribute: ' + type + '. Valid values are ' + mimeTypes);
	            return undefined;
	        }
	    };
	    return ComponentOptions;
	}());
	exports.ComponentOptions = ComponentOptions;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var Template_1 = __webpack_require__(100);
	var Assert_1 = __webpack_require__(17);
	var UnderscoreTemplate_1 = __webpack_require__(101);
	var HtmlTemplate_1 = __webpack_require__(102);
	/**
	 * Holds a reference to all template available in the framework
	 */
	var TemplateCache = (function () {
	    function TemplateCache() {
	    }
	    /**
	     * Register a new template in the framework, which will be available to render any results.
	     * @param name
	     * @param template
	     * @param publicTemplate
	     * @param defaultTemplate
	     */
	    TemplateCache.registerTemplate = function (name, template, publicTemplate, defaultTemplate) {
	        if (publicTemplate === void 0) { publicTemplate = true; }
	        if (defaultTemplate === void 0) { defaultTemplate = false; }
	        Assert_1.Assert.isNonEmptyString(name);
	        Assert_1.Assert.exists(template);
	        if (!(template instanceof Template_1.Template)) {
	            template = new Template_1.Template(template);
	        }
	        if (template.name == null) {
	            template.name = name;
	        }
	        TemplateCache.templates[name] = template;
	        if (publicTemplate && !_.contains(TemplateCache.templateNames, name)) {
	            TemplateCache.templateNames.push(name);
	        }
	        if (defaultTemplate) {
	            TemplateCache.defaultTemplates[name] = template;
	        }
	    };
	    /**
	     * Return a template by its name/ID.
	     * @param name
	     * @returns {Template}
	     */
	    TemplateCache.getTemplate = function (name) {
	        Assert_1.Assert.exists(TemplateCache.templates[name]);
	        return TemplateCache.templates[name];
	    };
	    /**
	     * Get all templates currently registered in the framework.
	     * @returns {{}}
	     */
	    TemplateCache.getTemplates = function () {
	        return TemplateCache.templates;
	    };
	    /**
	     * Get all templates name currently registered in the framework.
	     * @returns {string[]}
	     */
	    TemplateCache.getTemplateNames = function () {
	        return TemplateCache.templateNames;
	    };
	    /**
	     * Get all the "default" templates in the framework.
	     * @returns {string[]}
	     */
	    TemplateCache.getDefaultTemplates = function () {
	        return _.keys(TemplateCache.defaultTemplates);
	    };
	    TemplateCache.getDefaultTemplate = function (name) {
	        Assert_1.Assert.exists(TemplateCache.defaultTemplates[name]);
	        return TemplateCache.defaultTemplates[name];
	    };
	    TemplateCache.scanAndRegisterTemplates = function () {
	        // Here we take care not to scan for templates for which the base library
	        // is not available. Case in point: someone was using the JS UI on a page
	        // that was also using Handlebars, but our code was initialized before
	        // the Handlebars library (loaded through AMD).
	        if (UnderscoreTemplate_1.UnderscoreTemplate.isLibraryAvailable()) {
	            TemplateCache.scanAndRegisterUnderscoreTemplates();
	        }
	        TemplateCache.scanAndRegisterHtmlTemplates();
	    };
	    TemplateCache.scanAndRegisterUnderscoreTemplates = function () {
	        _.each(UnderscoreTemplate_1.UnderscoreTemplate.mimeTypes, function (type) {
	            var scriptList = document.querySelectorAll("script[id][type='" + type + "']");
	            var i = scriptList.length;
	            var arr = new Array(i);
	            while (i--) {
	                arr[i] = scriptList.item(i);
	            }
	            _.each(arr, function (elem) {
	                var template = new UnderscoreTemplate_1.UnderscoreTemplate(elem);
	                TemplateCache.registerTemplate(elem.getAttribute('id'), template);
	            });
	        });
	    };
	    TemplateCache.scanAndRegisterHtmlTemplates = function () {
	        _.each(HtmlTemplate_1.HtmlTemplate.mimeTypes, function (type) {
	            var scriptList = document.querySelectorAll("script[id][type='" + type + "']");
	            var i = scriptList.length;
	            var arr = new Array(i);
	            while (i--) {
	                arr[i] = scriptList.item(i);
	            }
	            _.each(arr, function (elem) {
	                var template = new HtmlTemplate_1.HtmlTemplate(elem);
	                TemplateCache.registerTemplate(elem.getAttribute('id'), template);
	            });
	        });
	    };
	    TemplateCache.templates = {};
	    TemplateCache.templateNames = [];
	    TemplateCache.defaultTemplates = {};
	    return TemplateCache;
	}());
	exports.TemplateCache = TemplateCache;
	document.addEventListener('DOMContentLoaded', function () {
	    TemplateCache.scanAndRegisterTemplates();
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var Logger_1 = __webpack_require__(16);
	var StringUtils_1 = __webpack_require__(61);
	var Initialization_1 = __webpack_require__(95);
	var Dom_1 = __webpack_require__(57);
	var BaseComponent_1 = __webpack_require__(76);
	var Template = (function () {
	    function Template(dataToString, condition) {
	        this.dataToString = dataToString;
	        this.condition = condition;
	        this.logger = new Logger_1.Logger(this);
	    }
	    Template.getFieldFromString = function (text) {
	        var fields = _.map(StringUtils_1.StringUtils.match(text, /(?:(?!\b@)@([a-z0-9]+(?:\.[a-z0-9]+)*\b))|\braw.([a-z0-9]+)|\braw\['([^']+)'\]|\braw\['([^']+)'\]/gi), function (field) {
	            return field[1] || field[2] || field[3] || field[4] || null;
	        });
	        _.each(Initialization_1.Initialization.getListOfRegisteredComponents(), function (componentId) {
	            var componentFields = Initialization_1.Initialization.getRegisteredComponent(componentId).fields;
	            if (componentFields != null && text.indexOf(BaseComponent_1.BaseComponent.computeCssClassNameForType(componentId)) != -1) {
	                fields = fields.concat(componentFields);
	            }
	        });
	        return fields;
	    };
	    Template.prototype.instantiateToString = function (object, checkCondition) {
	        if (checkCondition === void 0) { checkCondition = true; }
	        if (this.dataToString && (!checkCondition || this.condition == null || this.condition(object))) {
	            return this.dataToString(object);
	        }
	        return null;
	    };
	    Template.prototype.instantiateToElement = function (object, checkCondition) {
	        if (checkCondition === void 0) { checkCondition = true; }
	        var html = this.instantiateToString(object, checkCondition);
	        if (html != null) {
	            var element = Dom_1.htmlToDom(html);
	            this.logger.trace('Instantiated result template', object, element);
	            element['template'] = this;
	            return element;
	        }
	        return null;
	    };
	    Template.prototype.toHtmlElement = function () {
	        return null;
	    };
	    Template.prototype.getFields = function () {
	        return [];
	    };
	    Template.prototype.getType = function () {
	        return 'Template';
	    };
	    return Template;
	}());
	exports.Template = Template;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Template_1 = __webpack_require__(100);
	var Assert_1 = __webpack_require__(17);
	var ComponentOptions_1 = __webpack_require__(98);
	var Utils_1 = __webpack_require__(18);
	var Dom_1 = __webpack_require__(57);
	_.templateSettings = {
	    evaluate: /(?:<%|{{)([\s\S]+?)(?:%>|}})/g,
	    interpolate: /(?:<%|{{)=([\s\S]+?)(?:%>|}})/g,
	    escape: /(?:<%|{{)-([\s\S]+?)(?:%>|}})/g
	};
	var UnderscoreTemplate = (function (_super) {
	    __extends(UnderscoreTemplate, _super);
	    function UnderscoreTemplate(element) {
	        var _this = this;
	        _super.call(this);
	        this.element = element;
	        Assert_1.Assert.exists(element);
	        var templateString = element.innerHTML;
	        this.template = _.template(templateString);
	        var condition = Dom_1.$$(element).getAttribute('data-condition');
	        if (condition != null) {
	            this.condition = new Function('obj', 'with(obj||{}){return ' + condition + '}');
	        }
	        this.dataToString = function (object) {
	            var extended = _.extend({}, object, UnderscoreTemplate.templateHelpers);
	            return _this.template(extended);
	        };
	        this.fields = Template_1.Template.getFieldFromString(templateString + ' ' + condition);
	        var additionalFields = ComponentOptions_1.ComponentOptions.loadFieldsOption(element, 'fields', { includeInResults: true });
	        if (additionalFields != null) {
	            // remove the @
	            this.fields = this.fields.concat(_.map(additionalFields, function (field) { return field.substr(1); }));
	        }
	    }
	    UnderscoreTemplate.prototype.toHtmlElement = function () {
	        var script = Dom_1.$$('script');
	        script.setAttribute('type', _.first(UnderscoreTemplate.mimeTypes));
	        script.setAttribute('data-condition', $(this.element).data('condition'));
	        script.text(this.element.innerHTML);
	        return script.el;
	    };
	    UnderscoreTemplate.prototype.getType = function () {
	        return 'UnderscoreTemplate';
	    };
	    UnderscoreTemplate.create = function (element) {
	        Assert_1.Assert.exists(element);
	        return new UnderscoreTemplate(element);
	    };
	    UnderscoreTemplate.fromString = function (template, condition) {
	        var script = document.createElement('script');
	        script.text = template;
	        if (condition != null) {
	            Dom_1.$$(script).setAttribute('data-condition', condition);
	        }
	        Dom_1.$$(script).setAttribute('type', UnderscoreTemplate.mimeTypes[0]);
	        return new UnderscoreTemplate(script);
	    };
	    UnderscoreTemplate.prototype.getFields = function () {
	        return this.fields;
	    };
	    UnderscoreTemplate.registerTemplateHelper = function (helperName, helper) {
	        UnderscoreTemplate.templateHelpers[helperName] = helper;
	    };
	    UnderscoreTemplate.isLibraryAvailable = function () {
	        return Utils_1.Utils.exists(window['_']);
	    };
	    UnderscoreTemplate.templateHelpers = {};
	    UnderscoreTemplate.mimeTypes = [
	        'text/underscore',
	        'text/underscore-template',
	        'text/x-underscore',
	        'text/x-underscore-template'
	    ];
	    return UnderscoreTemplate;
	}(Template_1.Template));
	exports.UnderscoreTemplate = UnderscoreTemplate;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Template_1 = __webpack_require__(100);
	var ComponentOptions_1 = __webpack_require__(98);
	var Assert_1 = __webpack_require__(17);
	var Dom_1 = __webpack_require__(57);
	var HtmlTemplate = (function (_super) {
	    __extends(HtmlTemplate, _super);
	    function HtmlTemplate(element) {
	        _super.call(this, function () {
	            return element.innerHTML;
	        });
	        this.element = element;
	        var condition = Dom_1.$$(element).getAttribute('data-condition');
	        if (condition != null) {
	            // Allows to add quotes in data-condition on the templates
	            condition = condition.toString().replace(/&quot;/g, '"');
	            this.condition = new Function('obj', 'with(obj||{}){return ' + condition + '}');
	        }
	        this.fields = Template_1.Template.getFieldFromString(element.innerHTML + ' ' + condition);
	        var additionalFields = ComponentOptions_1.ComponentOptions.loadFieldsOption(element, 'fields', { includeInResults: true });
	        if (additionalFields != null) {
	            // remove the @
	            this.fields = this.fields.concat(_.map(additionalFields, function (field) { return field.substr(1); }));
	        }
	    }
	    HtmlTemplate.prototype.toHtmlElement = function () {
	        var script = Dom_1.$$('script');
	        script.setAttribute('type', _.first(HtmlTemplate.mimeTypes));
	        script.setAttribute('data-condition', Dom_1.$$(this.element).getAttribute('data-condition'));
	        script.text(this.element.innerHTML);
	        return script.el;
	    };
	    HtmlTemplate.prototype.getType = function () {
	        return 'HtmlTemplate';
	    };
	    HtmlTemplate.prototype.getFields = function () {
	        return this.fields;
	    };
	    HtmlTemplate.create = function (element) {
	        Assert_1.Assert.exists(element);
	        return new HtmlTemplate(element);
	    };
	    HtmlTemplate.fromString = function (template, condition) {
	        var script = document.createElement('script');
	        script.text = template;
	        if (condition != null) {
	            Dom_1.$$(script).setAttribute('data-condition', condition);
	        }
	        Dom_1.$$(script).setAttribute('type', HtmlTemplate.mimeTypes[0]);
	        return new HtmlTemplate(script);
	    };
	    HtmlTemplate.mimeTypes = [
	        'text/html'
	    ];
	    return HtmlTemplate;
	}(Template_1.Template));
	exports.HtmlTemplate = HtmlTemplate;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Template_1 = __webpack_require__(100);
	var DefaultResultTemplate_1 = __webpack_require__(104);
	var TemplateList = (function (_super) {
	    __extends(TemplateList, _super);
	    function TemplateList(templates) {
	        _super.call(this);
	        this.templates = templates;
	    }
	    TemplateList.prototype.instantiateToString = function (object, checkCondition) {
	        for (var i = 0; i < this.templates.length; i++) {
	            var result = this.templates[i].instantiateToString(object, checkCondition);
	            if (result != null) {
	                return result;
	            }
	        }
	        return new DefaultResultTemplate_1.DefaultResultTemplate().instantiateToString(object);
	    };
	    TemplateList.prototype.instantiateToElement = function (object, checkCondition) {
	        if (checkCondition === void 0) { checkCondition = true; }
	        for (var i = 0; i < this.templates.length; i++) {
	            var element = this.templates[i].instantiateToElement(object, checkCondition);
	            if (element != null) {
	                return element;
	            }
	        }
	        return new DefaultResultTemplate_1.DefaultResultTemplate().instantiateToElement(object);
	    };
	    TemplateList.prototype.getFields = function () {
	        return _.reduce(this.templates, function (fields, template) { return fields.concat(template.getFields()); }, []);
	    };
	    TemplateList.prototype.getType = function () {
	        return 'TemplateList';
	    };
	    return TemplateList;
	}(Template_1.Template));
	exports.TemplateList = TemplateList;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Template_1 = __webpack_require__(100);
	var UnderscoreTemplate_1 = __webpack_require__(101);
	var TemplateCache_1 = __webpack_require__(99);
	var Assert_1 = __webpack_require__(17);
	var DefaultResultTemplate = (function (_super) {
	    __extends(DefaultResultTemplate, _super);
	    function DefaultResultTemplate() {
	        _super.call(this);
	    }
	    DefaultResultTemplate.prototype.instantiateToString = function (queryResult) {
	        Assert_1.Assert.exists(queryResult);
	        queryResult = _.extend({}, queryResult, UnderscoreTemplate_1.UnderscoreTemplate.templateHelpers);
	        var defaultTemplates = _.map(TemplateCache_1.TemplateCache.getDefaultTemplates(), function (name) { return TemplateCache_1.TemplateCache.getTemplate(name); });
	        // We want to put templates with conditions first
	        defaultTemplates.sort(function (a, b) {
	            if (a.condition == null && b.condition != null) {
	                return 1;
	            }
	            else if (a.condition != null && b.condition == null) {
	                return -1;
	            }
	            return 0;
	        });
	        for (var i = 0; i < defaultTemplates.length; i++) {
	            var result = defaultTemplates[i].instantiateToString(queryResult);
	            if (result != null) {
	                return result;
	            }
	        }
	        return _.template('<div>' +
	            '<div class="coveo-title"><a class="CoveoResultLink"><%= title?Coveo.TemplateHelpers.getHelper("highlight").call(title, titleHighlights):clickUri %></a></div>' +
	            '<% if(excerpt){ %><div class="coveo-excerpt"><%= Coveo.TemplateHelpers.getHelper("highlight").call(excerpt, excerptHighlights) %></div><% } %>' +
	            '<table class="CoveoFieldTable"><%= Coveo.TemplateHelpers.getHelper("highlight").call() %></table>' +
	            '</div>')(queryResult);
	    };
	    DefaultResultTemplate.prototype.instantiateToElement = function (queryResult) {
	        var div = document.createElement('div');
	        div.innerHTML = this.instantiateToString(queryResult);
	        return div;
	    };
	    DefaultResultTemplate.prototype.getFields = function () {
	        var defaultTemplates = _.map(TemplateCache_1.TemplateCache.getDefaultTemplates(), function (name) { return TemplateCache_1.TemplateCache.getTemplate(name); });
	        return _.flatten(_.map(defaultTemplates, function (template) { return template.getFields(); }));
	    };
	    DefaultResultTemplate.prototype.getType = function () {
	        return 'DefaultResultTemplate';
	    };
	    return DefaultResultTemplate;
	}(Template_1.Template));
	exports.DefaultResultTemplate = DefaultResultTemplate;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var es6_promise_1 = __webpack_require__(7);
	var NoopAnalyticsClient = (function () {
	    function NoopAnalyticsClient() {
	        this.isContextual = false;
	    }
	    NoopAnalyticsClient.prototype.isActivated = function () {
	        return false;
	    };
	    NoopAnalyticsClient.prototype.getCurrentEventCause = function () {
	        return null;
	    };
	    NoopAnalyticsClient.prototype.getCurrentEventMeta = function () {
	        return {};
	    };
	    NoopAnalyticsClient.prototype.logSearchEvent = function (actionCause, meta) {
	    };
	    NoopAnalyticsClient.prototype.logSearchAsYouType = function (actionCause, meta) {
	    };
	    NoopAnalyticsClient.prototype.logClickEvent = function (actionCause, meta, result, element) {
	    };
	    NoopAnalyticsClient.prototype.logCustomEvent = function (actionCause, meta, element) {
	    };
	    NoopAnalyticsClient.prototype.getTopQueries = function (params) {
	        return new es6_promise_1.Promise(function (resolve, reject) {
	            resolve([]);
	        });
	    };
	    NoopAnalyticsClient.prototype.getCurrentVisitIdPromise = function () {
	        return new es6_promise_1.Promise(function (resolve, reject) {
	            resolve(null);
	        });
	    };
	    NoopAnalyticsClient.prototype.getCurrentVisitId = function () {
	        return null;
	    };
	    NoopAnalyticsClient.prototype.sendAllPendingEvents = function () {
	    };
	    NoopAnalyticsClient.prototype.cancelAllPendingEvents = function () {
	    };
	    NoopAnalyticsClient.prototype.warnAboutSearchEvent = function () {
	    };
	    NoopAnalyticsClient.prototype.getPendingSearchEvent = function () {
	        return null;
	    };
	    return NoopAnalyticsClient;
	}());
	exports.NoopAnalyticsClient = NoopAnalyticsClient;


/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	/// <reference path="../../../node_modules/modal-box/bin/ModalBox.d.ts" />
	var ComponentOptions_1 = __webpack_require__(98);
	var LocalStorageUtils_1 = __webpack_require__(69);
	var QueryEvents_1 = __webpack_require__(47);
	var ResultListEvents_1 = __webpack_require__(48);
	var DebugEvents_1 = __webpack_require__(42);
	var Dom_1 = __webpack_require__(57);
	var StringUtils_1 = __webpack_require__(61);
	var SearchEndpoint_1 = __webpack_require__(12);
	var Template_1 = __webpack_require__(100);
	var es6_promise_1 = __webpack_require__(7);
	var RootComponent_1 = __webpack_require__(75);
	var BaseComponent_1 = __webpack_require__(76);
	var ExternalModulesShim_1 = __webpack_require__(25);
	var Globalize = __webpack_require__(4);
	var KeyboardUtils_1 = __webpack_require__(68);
	var InitializationEvents_1 = __webpack_require__(44);
	var Debug = (function (_super) {
	    __extends(Debug, _super);
	    function Debug(element, queryController, options, modalBox) {
	        var _this = this;
	        if (modalBox === void 0) { modalBox = ExternalModulesShim_1.ModalBox; }
	        _super.call(this, element, Debug.ID);
	        this.element = element;
	        this.queryController = queryController;
	        this.options = options;
	        this.modalBox = modalBox;
	        this.debug = false;
	        this.highlightRecommendation = false;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, Debug, options);
	        Dom_1.$$(this.element).on(QueryEvents_1.QueryEvents.buildingQuery, function (e, args) {
	            args.queryBuilder.enableDebug = _this.debug || args.queryBuilder.enableDebug;
	        });
	        Dom_1.$$(this.element).on(ResultListEvents_1.ResultListEvents.newResultDisplayed, function (e, args) { return _this.handleNewResultDisplayed(args); });
	        Dom_1.$$(this.element).on(DebugEvents_1.DebugEvents.showDebugPanel, function (e, args) {
	            _this.handleShowDebugPanel(args);
	        });
	        Dom_1.$$(this.element).on(InitializationEvents_1.InitializationEvents.nuke, function () {
	            _this.unbindEscapeEvent();
	        });
	        this.localStorageDebug = new LocalStorageUtils_1.LocalStorageUtils('DebugPanel');
	        this.collapsedSections = this.localStorageDebug.load() || [];
	    }
	    Debug.prototype.showDebugPanel = function (builder) {
	        var _this = this;
	        var build = builder();
	        var modalbox = this.modalBox.open(build.body, {
	            title: '',
	            className: 'coveo-debug',
	            titleClose: true,
	            overlayClose: true,
	            validation: function () {
	                _this.unbindEscapeEvent();
	                return true;
	            }
	        });
	        this.bindEscapeEvent();
	        var title = Dom_1.$$(modalbox.wrapper).find('.coveo-title');
	        var search = this.buildSearchBox(build.body);
	        var downloadLink = Dom_1.$$('a', { download: 'debug.json', 'href': this.downloadHref(build.json) }, 'Download');
	        var bodyBuilder = function (results) {
	            var build = builder();
	            downloadLink.el.setAttribute('href', _this.downloadHref(build.json));
	            return build.body;
	        };
	        title.appendChild(this.buildEnabledHighlightRecommendation());
	        title.appendChild(this.buildEnableDebugCheckbox(build.body, search, bodyBuilder));
	        title.appendChild(search);
	        title.appendChild(downloadLink.el);
	    };
	    Debug.prototype.handleEscapeEvent = function (e) {
	        if (e.keyCode == KeyboardUtils_1.KEYBOARD.ESCAPE) {
	            if (this.modalBox) {
	                this.modalBox.close();
	            }
	        }
	    };
	    Debug.prototype.bindEscapeEvent = function () {
	        this.boundEscapeKey = this.handleEscapeEvent.bind(this);
	        Dom_1.$$(document.body).on('keyup', this.boundEscapeKey);
	    };
	    Debug.prototype.unbindEscapeEvent = function () {
	        if (this.boundEscapeKey) {
	            Dom_1.$$(document.body).off('keyup', this.boundEscapeKey);
	        }
	        this.boundEscapeKey = null;
	    };
	    Debug.prototype.handleShowDebugPanel = function (info) {
	        var _this = this;
	        if (this.stackDebug == null) {
	            setTimeout(function () {
	                var stackDebug = _this.stackDebug;
	                _this.showDebugPanel(function () { return _this.buildStackPanel(stackDebug); });
	                _this.stackDebug = null;
	            });
	            this.stackDebug = {};
	        }
	        _.extend(this.stackDebug, info);
	    };
	    Debug.prototype.handleNewResultDisplayed = function (args) {
	        var _this = this;
	        if (args.item != null) {
	            if (this.highlightRecommendation && args.result.isRecommendation) {
	                Dom_1.$$(args.item).addClass('coveo-is-recommendation');
	            }
	            Dom_1.$$(args.item).on('dblclick', function (e) {
	                _this.handleResultDoubleClick(e, args);
	            });
	        }
	    };
	    Debug.prototype.handleResultDoubleClick = function (e, args) {
	        var _this = this;
	        if (e.altKey) {
	            var index_1 = args.result.index;
	            var findResult_1 = function (results) { return results != null ? _.find(results.results, function (result) { return result.index == index_1; }) : args.result; };
	            var template = args.item['template'];
	            var debugPanel = {
	                result: findResult_1,
	                fields: function (results) { return _this.buildFieldsSection(findResult_1(results)); },
	                rankingInfo: function (results) { return _this.buildRankingInfoSection(findResult_1(results)); },
	                template: this.templateToJson(template),
	            };
	            this.handleShowDebugPanel(debugPanel);
	        }
	    };
	    Debug.prototype.downloadHref = function (info) {
	        return 'data:text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(info));
	    };
	    Debug.prototype.buildStackPanel = function (stackDebug, results) {
	        var _this = this;
	        var body = Dom_1.Dom.createElement('div', { className: 'coveo-debug' });
	        var keys = _.pairs(_.keys(stackDebug));
	        keys = keys.sort(function (a, b) {
	            var indexA = _.indexOf(Debug.customOrder, a[1]);
	            var indexB = _.indexOf(Debug.customOrder, b[1]);
	            if (indexA != -1 && indexB != -1) {
	                return indexA - indexB;
	            }
	            if (indexA != -1) {
	                return -1;
	            }
	            if (indexB != -1) {
	                return 1;
	            }
	            return a[0] - b[0];
	        });
	        var json = {};
	        _.forEach(keys, function (key) {
	            var section = _this.buildSection(key[1]);
	            var build = _this.buildStackPanelSection(stackDebug[key[1]], results);
	            section.container.appendChild(build.section);
	            if (build.json != null) {
	                json[key[1]] = build.json;
	            }
	            body.appendChild(section.dom);
	        });
	        return { body: body, json: json };
	    };
	    Debug.prototype.buildStackPanelSection = function (value, results) {
	        if (value instanceof HTMLElement) {
	            return { section: value };
	        }
	        else if (_.isFunction(value)) {
	            return this.buildStackPanelSection(value(results), results);
	        }
	        var json = this.toJson(value);
	        return { section: this.buildProperty(json), json: json };
	    };
	    Debug.prototype.buildSearchBox = function (body) {
	        var _this = this;
	        var dom = Dom_1.Dom.createElement('div', { className: 'coveo-debug-search' }, '<input type=\'text\'/>');
	        dom.onclick = function (e) {
	            e.stopPropagation();
	        };
	        var lastSearch = '';
	        var input = dom.querySelector('input');
	        input.setAttribute('placeholder', 'Search in debug');
	        input.onkeyup = function (e) {
	            if (e == null || e.keyCode == 13) {
	                var value = input.value.toLowerCase();
	                if (lastSearch != value) {
	                    lastSearch = value;
	                    _this.search(value, body);
	                }
	            }
	        };
	        input.onchange = function () {
	            var value = input.value.toLowerCase();
	            if (lastSearch != value) {
	                lastSearch = value;
	                _this.search(value, body);
	            }
	        };
	        return dom;
	    };
	    Debug.prototype.search = function (value, body) {
	        var _this = this;
	        if (_.isEmpty(value)) {
	            Dom_1.$$(body).findAll('.coveo-search-match, .coveo-search-submatch').forEach(function (el) {
	                Dom_1.$$(el).removeClass('coveo-search-match, coveo-search-submatch');
	            });
	            Dom_1.$$(body).removeClass('coveo-searching');
	        }
	        else {
	            Dom_1.$$(body).addClass('coveo-searching-loading');
	            setTimeout(function () {
	                var rootProperties = Dom_1.$$(body).findAll('.coveo-section .coveo-section-container > .coveo-property');
	                _.each(rootProperties, function (element) {
	                    _this.findInProperty(element, value);
	                });
	                Dom_1.$$(body).addClass('coveo-searching');
	                Dom_1.$$(body).removeClass('coveo-searching-loading');
	            });
	        }
	    };
	    Debug.prototype.findInProperty = function (element, value) {
	        var _this = this;
	        var jElement = Dom_1.$$(element);
	        var match = element['label'].indexOf(value) != -1;
	        if (match) {
	            this.highlightSearch(element['labelDom'], value);
	        }
	        else {
	            this.removeHighlightSearch(element['labelDom']);
	        }
	        if (jElement.hasClass('coveo-property-object')) {
	            jElement.toggleClass('coveo-search-match', match);
	            var children = element['buildKeys']();
	            var submatch_1 = false;
	            _.each(children, function (child) {
	                submatch_1 = _this.findInProperty(child, value) || submatch_1;
	            });
	            jElement.toggleClass('coveo-search-submatch', submatch_1);
	            return match || submatch_1;
	        }
	        else {
	            if (element['value'].indexOf(value) != -1) {
	                this.highlightSearch(element['valueDom'], value);
	                match = true;
	            }
	            else {
	                this.removeHighlightSearch(element['valueDom']);
	            }
	            jElement.toggleClass('coveo-search-match', match);
	        }
	        return match;
	    };
	    Debug.prototype.buildEnableDebugCheckbox = function (body, search, bodyBuilder) {
	        var _this = this;
	        var dom = Dom_1.Dom.createElement('div', { className: 'coveo-enabled-debug' }, '<label>Enable query debug <input type=\'checkbox\'/></label>');
	        Dom_1.$$(dom).on('click', function (e) {
	            e.stopPropagation();
	        });
	        var checkbox = Dom_1.$$(dom).find('input');
	        if (this.debug) {
	            checkbox.setAttribute('checked', 'checked');
	        }
	        checkbox.onchange = function () {
	            _this.debug = !_this.debug;
	            Dom_1.$$(_this.element).one(QueryEvents_1.QueryEvents.querySuccess + ' ' + QueryEvents_1.QueryEvents.queryError, function (e, args) {
	                Dom_1.$$(body).removeClass('coveo-debug-loading');
	                Dom_1.$$(body).empty();
	                Dom_1.$$(bodyBuilder(args.results)).children().forEach(function (child) {
	                    body.appendChild(child);
	                });
	            });
	            _this.queryController.executeQuery({ closeModalBox: false });
	            Dom_1.$$(body).addClass('coveo-debug-loading');
	            var input = search.querySelector('input');
	            input.value = '';
	            input.onkeyup(null);
	        };
	        return dom;
	    };
	    Debug.prototype.buildEnabledHighlightRecommendation = function () {
	        var _this = this;
	        var dom = Dom_1.Dom.createElement('div', { className: 'coveo-enabled-highlight-recommendation' }, '<label>Highlight recommendation <input type=\'checkbox\'/></label>');
	        dom.onclick = function (e) {
	            e.stopPropagation();
	        };
	        var checkbox = Dom_1.$$(dom).find('input');
	        if (this.highlightRecommendation) {
	            checkbox.setAttribute('checked', 'checked');
	        }
	        checkbox.onchange = function () {
	            _this.highlightRecommendation = !_this.highlightRecommendation;
	            _this.queryController.executeQuery({ closeModalBox: false });
	        };
	        return dom;
	    };
	    Debug.prototype.buildSection = function (id) {
	        var _this = this;
	        var dom = Dom_1.Dom.createElement('div', { className: 'coveo-section coveo-' + id + '-section' });
	        var header = Dom_1.Dom.createElement('div', { className: 'coveo-section-header' });
	        Dom_1.$$(header).text(id);
	        dom.appendChild(header);
	        var container = Dom_1.Dom.createElement('div', { className: 'coveo-section-container' });
	        dom.appendChild(container);
	        if (_.contains(this.collapsedSections, id)) {
	            Dom_1.$$(dom).addClass('coveo-debug-collapsed');
	        }
	        header.onclick = function () {
	            Dom_1.$$(dom).toggleClass('coveo-debug-collapsed');
	            if (_.contains(_this.collapsedSections, id)) {
	                _this.collapsedSections = _.without(_this.collapsedSections, id);
	            }
	            else {
	                _this.collapsedSections.push(id);
	            }
	            _this.localStorageDebug.save(_this.collapsedSections);
	        };
	        return {
	            dom: dom,
	            header: header,
	            container: container
	        };
	    };
	    Debug.prototype.fetchFields = function () {
	        var _this = this;
	        if (this.fields == null) {
	            return this.queryController.getEndpoint().listFields().then(function (fields) {
	                _this.fields = {};
	                fields.forEach(function (field) {
	                    _this.fields[field.name] = field;
	                });
	                return _this.fields;
	            });
	        }
	        else {
	            return es6_promise_1.Promise.resolve(this.fields);
	        }
	    };
	    Debug.prototype.buildFieldsSection = function (result) {
	        return this.fetchFields()
	            .then(function (fieldDescriptions) {
	            var fields = {};
	            _.each(result.raw, function (value, key) {
	                var fieldDescription = fieldDescriptions['@' + key];
	                if (fieldDescription == null && key.match(/^sys/)) {
	                    fieldDescription = fieldDescriptions['@' + key.substr(3)];
	                }
	                if (fieldDescription == null) {
	                    fields['@' + key] = value;
	                }
	                else if (fieldDescription.fieldType == 'Date') {
	                    fields['@' + key] = new Date(value);
	                }
	                else if (fieldDescription.splitGroupByField) {
	                    fields['@' + key] = value.split(/\s*;\s*/);
	                }
	                else {
	                    fields['@' + key] = value;
	                }
	            });
	            return fields;
	        });
	    };
	    Debug.prototype.buildRankingInfoSection = function (result) {
	        return result.rankingInfo && this.parseRankingInfo(result.rankingInfo);
	    };
	    Debug.prototype.parseRankingInfo = function (value) {
	        var _this = this;
	        var rankingInfo = {};
	        var infos = value.match(/^(?:Document weights:\n((?:.)*?)\n)?\n(?:Terms weights:\n((?:.|\n)*))?Total weight: ([0-9]+)$/);
	        if (infos[1] != null) {
	            rankingInfo['Document weights'] = this.parseWeights(infos[1]);
	        }
	        if (infos[2] != null) {
	            var terms = StringUtils_1.StringUtils.match(infos[2], /((?:[^:]+: [0-9]+, [0-9]+; )+)\n((?:\w+: [0-9]+; )+)/g);
	            rankingInfo['Terms weights'] = _.object(_.map(terms, function (term) {
	                var words = _.object(_.map(StringUtils_1.StringUtils.match(term[1], /([^:]+): ([0-9]+), ([0-9]+); /g), function (word) {
	                    return [
	                        word[1],
	                        {
	                            Correlation: Number(word[2]),
	                            'TF-IDF': Number(word[3]),
	                        }
	                    ];
	                }));
	                var weights = _this.parseWeights(term[2]);
	                return [
	                    _.keys(words).join(', '),
	                    {
	                        terms: words,
	                        Weights: weights
	                    }];
	            }));
	        }
	        rankingInfo['Total weight'] = Number(infos[3]);
	        return rankingInfo;
	    };
	    Debug.prototype.parseWeights = function (value) {
	        var listOfWeight = value.match(/(\w+(?:\s\w+)*): ([-0-9]+)/g);
	        return _.object(_.map(listOfWeight, function (weight) {
	            var weightGroup = weight.match(/^(\w+(?:\s\w+)*): ([-0-9]+)$/);
	            return [weightGroup[1], Number(weightGroup[2])];
	        }));
	    };
	    Debug.prototype.buildProperty = function (value, label) {
	        if (value instanceof es6_promise_1.Promise) {
	            return this.buildPromise(value, label);
	        }
	        else if ((_.isArray(value) || (_.isObject(value))) && !_.isString(value)) {
	            return this.buildObjectProperty(value, label);
	        }
	        else {
	            return this.buildBasicProperty(value, label);
	        }
	    };
	    Debug.prototype.buildPromise = function (promise, label) {
	        var _this = this;
	        var dom = document.createElement('div');
	        dom.className = 'coveo-property coveo-property-promise';
	        promise.then(function (value) {
	            var resolvedDom = _this.buildProperty(value, label);
	            Dom_1.$$(dom).replaceWith(resolvedDom);
	        });
	        return dom;
	    };
	    Debug.prototype.buildObjectProperty = function (object, label) {
	        var _this = this;
	        var dom = document.createElement('div');
	        dom.className = 'coveo-property coveo-property-object';
	        var valueContainer = document.createElement('div');
	        valueContainer.className = 'coveo-property-value';
	        var keys = _.keys(object);
	        if (!_.isArray(object)) {
	            keys.sort();
	        }
	        var children;
	        var buildKeys = function () {
	            if (children == null) {
	                children = [];
	                _.each(keys, function (key) {
	                    var property = _this.buildProperty(object[key], key);
	                    if (property != null) {
	                        children.push(property);
	                        valueContainer.appendChild(property);
	                    }
	                });
	            }
	            return children;
	        };
	        dom['buildKeys'] = buildKeys;
	        if (label != null) {
	            var labelDom = document.createElement('div');
	            labelDom.className = 'coveo-property-label';
	            labelDom.appendChild(document.createTextNode(label));
	            dom['labelDom'] = labelDom;
	            dom.appendChild(labelDom);
	            if (keys.length != 0) {
	                dom.className += ' coveo-collapsible';
	                labelDom.onclick = function () {
	                    buildKeys();
	                    var className = dom.className.split(/\s+/);
	                    if (_.contains(className, 'coveo-expanded')) {
	                        className = _.without(className, 'coveo-expanded');
	                    }
	                    else {
	                        className.push('coveo-expanded');
	                    }
	                    dom.className = className.join(' ');
	                };
	            }
	        }
	        else {
	            buildKeys();
	        }
	        if (keys.length == 0) {
	            var className = _.without(dom.className.split(/\s+/), 'coveo-property-object');
	            className.push('coveo-property-basic');
	            dom.className = className.join(' ');
	            if (_.isArray(object)) {
	                valueContainer.innerHTML = '[]';
	            }
	            else {
	                valueContainer.innerHTML = '{}';
	            }
	            dom['value'] = '';
	        }
	        dom['label'] = label != null ? label.toLowerCase() : '';
	        dom.appendChild(valueContainer);
	        return dom;
	    };
	    Debug.prototype.buildBasicProperty = function (value, label) {
	        var _this = this;
	        var dom = document.createElement('div');
	        dom.className = 'coveo-property coveo-property-basic';
	        if (label != null) {
	            var labelDom = document.createElement('div');
	            labelDom.className = 'coveo-property-label';
	            labelDom.appendChild(document.createTextNode(label));
	            dom.appendChild(labelDom);
	            dom['labelDom'] = labelDom;
	        }
	        var stringValue = value != null ? value.toString() : String(value);
	        if (value != null && value['ref'] != null) {
	            value = value['ref'];
	        }
	        var valueDom = document.createElement('div');
	        valueDom.appendChild(document.createTextNode(stringValue));
	        valueDom.ondblclick = function () {
	            _this.selectElementText(valueDom);
	        };
	        dom.appendChild(valueDom);
	        dom['valueDom'] = valueDom;
	        var className = ['coveo-property-value'];
	        if (_.isString(value)) {
	            className.push('coveo-property-value-string');
	        }
	        if (_.isNull(value) || _.isUndefined(value)) {
	            className.push('coveo-property-value-null');
	        }
	        if (_.isNumber(value)) {
	            className.push('coveo-property-value-number');
	        }
	        if (_.isBoolean(value)) {
	            className.push('coveo-property-value-boolean');
	        }
	        if (_.isDate(value)) {
	            className.push('coveo-property-value-date');
	        }
	        if (_.isObject(value)) {
	            className.push('coveo-property-value-object');
	        }
	        if (_.isArray(value)) {
	            className.push('coveo-property-value-array');
	        }
	        valueDom.className = className.join(' ');
	        dom['label'] = label != null ? label.toLowerCase() : '';
	        dom['value'] = stringValue.toLowerCase();
	        return dom;
	    };
	    Debug.prototype.toJson = function (value, depth, done) {
	        var _this = this;
	        if (depth === void 0) { depth = 0; }
	        if (done === void 0) { done = []; }
	        if (value instanceof BaseComponent_1.BaseComponent || value instanceof SearchEndpoint_1.SearchEndpoint) {
	            return this.componentToJson(value, depth);
	        }
	        if (value instanceof HTMLElement) {
	            return this.htmlToJson(value);
	        }
	        if (value instanceof Template_1.Template) {
	            return this.templateToJson(value);
	        }
	        if (value instanceof es6_promise_1.Promise) {
	            return value.then(function (value) {
	                return _this.toJson(value, depth, done);
	            });
	        }
	        if (value == window) {
	            return this.toJsonRef(value);
	        }
	        if (_.isArray(value) || _.isObject(value)) {
	            if (_.contains(done, value)) {
	                return this.toJsonRef(value, '< RECURSIVE >');
	            }
	            else if (depth >= Debug.maxDepth) {
	                return this.toJsonRef(value);
	            }
	            else if (_.isArray(value)) {
	                return _.map(value, function (subValue, key) { return _this.toJson(subValue, depth + 1, done.concat([value])); });
	            }
	            else if (_.isDate(value)) {
	                return this.toJsonRef(value, Globalize.format(value, 'F'));
	            }
	            else {
	                var result_1 = {};
	                _.each(value, function (subValue, key) {
	                    result_1[key] = _this.toJson(subValue, depth + 1, done.concat([value]));
	                });
	                result_1['ref'];
	                return result_1;
	            }
	        }
	        return value;
	    };
	    Debug.prototype.toJsonRef = function (value, stringValue) {
	        stringValue = new String(stringValue || value);
	        stringValue['ref'] = value;
	        return stringValue;
	    };
	    Debug.prototype.componentToJson = function (value, depth) {
	        if (depth === void 0) { depth = 0; }
	        var options = _.keys(value['options']);
	        if (options.length > 0) {
	            return this.toJson(value['options'], depth);
	        }
	        else {
	            return this.toJsonRef(value['options'], new String('No options'));
	        }
	    };
	    Debug.prototype.htmlToJson = function (value) {
	        if (value == null) {
	            return undefined;
	        }
	        return {
	            tagName: value.tagName,
	            id: value.id,
	            classList: value.className.split(/\s+/)
	        };
	    };
	    Debug.prototype.templateToJson = function (template) {
	        if (template == null) {
	            return null;
	        }
	        var element = template['element'];
	        var templateObject = {
	            type: template.getType(),
	        };
	        if (element != null) {
	            templateObject.id = element.id;
	            templateObject.condition = element.attributes['data-condition'];
	            templateObject.content = element.innerText;
	        }
	        return templateObject;
	    };
	    Debug.prototype.selectElementText = function (el) {
	        if (window.getSelection && document.createRange) {
	            var selection = window.getSelection();
	            var range = document.createRange();
	            range.selectNodeContents(el);
	            selection.removeAllRanges();
	            selection.addRange(range);
	        }
	        else if ('createTextRange' in document.body) {
	            var textRange = document.body['createTextRange']();
	            textRange.moveToElementText(el);
	            textRange.select();
	        }
	    };
	    Debug.prototype.highlightSearch = function (element, search) {
	        if (element != null) {
	            var match = element.innerText.split(new RegExp('(?=' + StringUtils_1.StringUtils.regexEncode(search) + ')', 'gi'));
	            element.innerHTML = '';
	            match.forEach(function (value) {
	                var regex = new RegExp('(' + StringUtils_1.StringUtils.regexEncode(search) + ')', 'i');
	                var group = value.match(regex);
	                var span;
	                if (group != null) {
	                    span = Dom_1.Dom.createElement('span', { className: 'coveo-debug-highlight' });
	                    span.appendChild(document.createTextNode(group[1]));
	                    element.appendChild(span);
	                    span = Dom_1.Dom.createElement('span');
	                    span.appendChild(document.createTextNode(value.substr(group[1].length)));
	                    element.appendChild(span);
	                }
	                else {
	                    span = Dom_1.Dom.createElement('span');
	                    span.appendChild(document.createTextNode(value));
	                    element.appendChild(span);
	                }
	            });
	        }
	    };
	    Debug.prototype.removeHighlightSearch = function (element) {
	        if (element != null) {
	            element.innerHTML = element.innerText;
	        }
	    };
	    Debug.prototype.debugInfo = function () {
	        return null;
	    };
	    Debug.ID = 'Debug';
	    Debug.options = {
	        enableDebug: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: false })
	    };
	    Debug.customOrder = ['error', 'queryDuration', 'result', 'fields', 'rankingInfo', 'template', 'query', 'results', 'state'];
	    Debug.durationKeys = ['indexDuration', 'proxyDuration', 'clientDuration', 'duration'];
	    Debug.maxDepth = 10;
	    return Debug;
	}(RootComponent_1.RootComponent));
	exports.Debug = Debug;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!function(){"use strict";function t(e,o){function i(t,e){return function(){return t.apply(e,arguments)}}var r;if(o=o||{},this.trackingClick=!1,this.trackingClickStart=0,this.targetElement=null,this.touchStartX=0,this.touchStartY=0,this.lastTouchIdentifier=0,this.touchBoundary=o.touchBoundary||10,this.layer=e,this.tapDelay=o.tapDelay||200,this.tapTimeout=o.tapTimeout||700,!t.notNeeded(e)){for(var a=["onMouse","onClick","onTouchStart","onTouchMove","onTouchEnd","onTouchCancel"],c=this,s=0,u=a.length;u>s;s++)c[a[s]]=i(c[a[s]],c);n&&(e.addEventListener("mouseover",this.onMouse,!0),e.addEventListener("mousedown",this.onMouse,!0),e.addEventListener("mouseup",this.onMouse,!0)),e.addEventListener("click",this.onClick,!0),e.addEventListener("touchstart",this.onTouchStart,!1),e.addEventListener("touchmove",this.onTouchMove,!1),e.addEventListener("touchend",this.onTouchEnd,!1),e.addEventListener("touchcancel",this.onTouchCancel,!1),Event.prototype.stopImmediatePropagation||(e.removeEventListener=function(t,n,o){var i=Node.prototype.removeEventListener;"click"===t?i.call(e,t,n.hijacked||n,o):i.call(e,t,n,o)},e.addEventListener=function(t,n,o){var i=Node.prototype.addEventListener;"click"===t?i.call(e,t,n.hijacked||(n.hijacked=function(t){t.propagationStopped||n(t)}),o):i.call(e,t,n,o)}),"function"==typeof e.onclick&&(r=e.onclick,e.addEventListener("click",function(t){r(t)},!1),e.onclick=null)}}var e=navigator.userAgent.indexOf("Windows Phone")>=0,n=navigator.userAgent.indexOf("Android")>0&&!e,o=/iP(ad|hone|od)/.test(navigator.userAgent)&&!e,i=o&&/OS 4_\d(_\d)?/.test(navigator.userAgent),r=o&&/OS [6-7]_\d/.test(navigator.userAgent),a=navigator.userAgent.indexOf("BB10")>0;t.prototype.needsClick=function(t){switch(t.nodeName.toLowerCase()){case"button":case"select":case"textarea":if(t.disabled)return!0;break;case"input":if(o&&"file"===t.type||t.disabled)return!0;break;case"label":case"iframe":case"video":return!0}return/\bneedsclick\b/.test(t.className)},t.prototype.needsFocus=function(t){switch(t.nodeName.toLowerCase()){case"textarea":return!0;case"select":return!n;case"input":switch(t.type){case"button":case"checkbox":case"file":case"image":case"radio":case"submit":return!1}return!t.disabled&&!t.readOnly;default:return/\bneedsfocus\b/.test(t.className)}},t.prototype.sendClick=function(t,e){var n,o;document.activeElement&&document.activeElement!==t&&document.activeElement.blur(),o=e.changedTouches[0],n=document.createEvent("MouseEvents"),n.initMouseEvent(this.determineEventType(t),!0,!0,window,1,o.screenX,o.screenY,o.clientX,o.clientY,!1,!1,!1,!1,0,null),n.forwardedTouchEvent=!0,t.dispatchEvent(n)},t.prototype.determineEventType=function(t){return n&&"select"===t.tagName.toLowerCase()?"mousedown":"click"},t.prototype.focus=function(t){var e;o&&t.setSelectionRange&&0!==t.type.indexOf("date")&&"time"!==t.type&&"month"!==t.type?(e=t.value.length,t.setSelectionRange(e,e)):t.focus()},t.prototype.updateScrollParent=function(t){var e,n;if(e=t.fastClickScrollParent,!e||!e.contains(t)){n=t;do{if(n.scrollHeight>n.offsetHeight){e=n,t.fastClickScrollParent=n;break}n=n.parentElement}while(n)}e&&(e.fastClickLastScrollTop=e.scrollTop)},t.prototype.getTargetElementFromEventTarget=function(t){return t.nodeType===Node.TEXT_NODE?t.parentNode:t},t.prototype.onTouchStart=function(t){var e,n,r;if(t.targetTouches.length>1)return!0;if(e=this.getTargetElementFromEventTarget(t.target),n=t.targetTouches[0],o){if(r=window.getSelection(),r.rangeCount&&!r.isCollapsed)return!0;if(!i){if(n.identifier&&n.identifier===this.lastTouchIdentifier)return t.preventDefault(),!1;this.lastTouchIdentifier=n.identifier,this.updateScrollParent(e)}}return this.trackingClick=!0,this.trackingClickStart=t.timeStamp,this.targetElement=e,this.touchStartX=n.pageX,this.touchStartY=n.pageY,t.timeStamp-this.lastClickTime<this.tapDelay&&t.preventDefault(),!0},t.prototype.touchHasMoved=function(t){var e=t.changedTouches[0],n=this.touchBoundary;return Math.abs(e.pageX-this.touchStartX)>n||Math.abs(e.pageY-this.touchStartY)>n?!0:!1},t.prototype.onTouchMove=function(t){return this.trackingClick?((this.targetElement!==this.getTargetElementFromEventTarget(t.target)||this.touchHasMoved(t))&&(this.trackingClick=!1,this.targetElement=null),!0):!0},t.prototype.findControl=function(t){return void 0!==t.control?t.control:t.htmlFor?document.getElementById(t.htmlFor):t.querySelector("button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea")},t.prototype.onTouchEnd=function(t){var e,a,c,s,u,l=this.targetElement;if(!this.trackingClick)return!0;if(t.timeStamp-this.lastClickTime<this.tapDelay)return this.cancelNextClick=!0,!0;if(t.timeStamp-this.trackingClickStart>this.tapTimeout)return!0;if(this.cancelNextClick=!1,this.lastClickTime=t.timeStamp,a=this.trackingClickStart,this.trackingClick=!1,this.trackingClickStart=0,r&&(u=t.changedTouches[0],l=document.elementFromPoint(u.pageX-window.pageXOffset,u.pageY-window.pageYOffset)||l,l.fastClickScrollParent=this.targetElement.fastClickScrollParent),c=l.tagName.toLowerCase(),"label"===c){if(e=this.findControl(l)){if(this.focus(l),n)return!1;l=e}}else if(this.needsFocus(l))return t.timeStamp-a>100||o&&window.top!==window&&"input"===c?(this.targetElement=null,!1):(this.focus(l),this.sendClick(l,t),o&&"select"===c||(this.targetElement=null,t.preventDefault()),!1);return o&&!i&&(s=l.fastClickScrollParent,s&&s.fastClickLastScrollTop!==s.scrollTop)?!0:(this.needsClick(l)||(t.preventDefault(),this.sendClick(l,t)),!1)},t.prototype.onTouchCancel=function(){this.trackingClick=!1,this.targetElement=null},t.prototype.onMouse=function(t){return this.targetElement?t.forwardedTouchEvent?!0:t.cancelable?!this.needsClick(this.targetElement)||this.cancelNextClick?(t.stopImmediatePropagation?t.stopImmediatePropagation():t.propagationStopped=!0,t.stopPropagation(),t.preventDefault(),!1):!0:!0:!0},t.prototype.onClick=function(t){var e;return this.trackingClick?(this.targetElement=null,this.trackingClick=!1,!0):"submit"===t.target.type&&0===t.detail?!0:(e=this.onMouse(t),e||(this.targetElement=null),e)},t.prototype.destroy=function(){var t=this.layer;n&&(t.removeEventListener("mouseover",this.onMouse,!0),t.removeEventListener("mousedown",this.onMouse,!0),t.removeEventListener("mouseup",this.onMouse,!0)),t.removeEventListener("click",this.onClick,!0),t.removeEventListener("touchstart",this.onTouchStart,!1),t.removeEventListener("touchmove",this.onTouchMove,!1),t.removeEventListener("touchend",this.onTouchEnd,!1),t.removeEventListener("touchcancel",this.onTouchCancel,!1)},t.notNeeded=function(t){var e,o,i,r;if("undefined"==typeof window.ontouchstart)return!0;if(o=+(/Chrome\/([0-9]+)/.exec(navigator.userAgent)||[,0])[1]){if(!n)return!0;if(e=document.querySelector("meta[name=viewport]")){if(-1!==e.content.indexOf("user-scalable=no"))return!0;if(o>31&&document.documentElement.scrollWidth<=window.outerWidth)return!0}}if(a&&(i=navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/),i[1]>=10&&i[2]>=3&&(e=document.querySelector("meta[name=viewport]")))){if(-1!==e.content.indexOf("user-scalable=no"))return!0;if(document.documentElement.scrollWidth<=window.outerWidth)return!0}return"none"===t.style.msTouchAction||"manipulation"===t.style.touchAction?!0:(r=+(/Firefox\/([0-9]+)/.exec(navigator.userAgent)||[,0])[1],r>=27&&(e=document.querySelector("meta[name=viewport]"),e&&(-1!==e.content.indexOf("user-scalable=no")||document.documentElement.scrollWidth<=window.outerWidth))?!0:"none"===t.style.touchAction||"manipulation"===t.style.touchAction?!0:!1)},t.attach=function(e,n){return new t(e,n)}, true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return t}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"undefined"!=typeof module&&module.exports?(module.exports=t.attach,module.exports.FastClick=t):window.FastClick=t}();

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	(function(e){var t=function(){"use strict";var e="s",n=2011,r=function(e){var t=-e.getTimezoneOffset();return t!==null?t:0},i=function(e,t,n){var r=new Date;return e!==undefined&&r.setFullYear(e),r.setDate(n),r.setMonth(t),r},s=function(e){return r(i(e,0,2))},o=function(e){return r(i(e,5,2))},u=function(e){var t=e.getMonth()>7?o(e.getFullYear()):s(e.getFullYear()),n=r(e);return t-n!==0},a=function(){var t=s(n),r=o(n),i=t-r;return i<0?t+",1":i>0?r+",1,"+e:t+",0"},f=function(){var e=a();return new t.TimeZone(t.olson.timezones[e])},l=function(e){var t=new Date(2010,6,15,1,0,0,0),n={"America/Denver":new Date(2011,2,13,3,0,0,0),"America/Mazatlan":new Date(2011,3,3,3,0,0,0),"America/Chicago":new Date(2011,2,13,3,0,0,0),"America/Mexico_City":new Date(2011,3,3,3,0,0,0),"America/Asuncion":new Date(2012,9,7,3,0,0,0),"America/Santiago":new Date(2012,9,3,3,0,0,0),"America/Campo_Grande":new Date(2012,9,21,5,0,0,0),"America/Montevideo":new Date(2011,9,2,3,0,0,0),"America/Sao_Paulo":new Date(2011,9,16,5,0,0,0),"America/Los_Angeles":new Date(2011,2,13,8,0,0,0),"America/Santa_Isabel":new Date(2011,3,5,8,0,0,0),"America/Havana":new Date(2012,2,10,2,0,0,0),"America/New_York":new Date(2012,2,10,7,0,0,0),"Asia/Beirut":new Date(2011,2,27,1,0,0,0),"Europe/Helsinki":new Date(2011,2,27,4,0,0,0),"Europe/Istanbul":new Date(2011,2,28,5,0,0,0),"Asia/Damascus":new Date(2011,3,1,2,0,0,0),"Asia/Jerusalem":new Date(2011,3,1,6,0,0,0),"Asia/Gaza":new Date(2009,2,28,0,30,0,0),"Africa/Cairo":new Date(2009,3,25,0,30,0,0),"Pacific/Auckland":new Date(2011,8,26,7,0,0,0),"Pacific/Fiji":new Date(2010,10,29,23,0,0,0),"America/Halifax":new Date(2011,2,13,6,0,0,0),"America/Goose_Bay":new Date(2011,2,13,2,1,0,0),"America/Miquelon":new Date(2011,2,13,5,0,0,0),"America/Godthab":new Date(2011,2,27,1,0,0,0),"Europe/Moscow":t,"Asia/Yekaterinburg":t,"Asia/Omsk":t,"Asia/Krasnoyarsk":t,"Asia/Irkutsk":t,"Asia/Yakutsk":t,"Asia/Vladivostok":t,"Asia/Kamchatka":t,"Europe/Minsk":t,"Pacific/Apia":new Date(2010,10,1,1,0,0,0),"Australia/Perth":new Date(2008,10,1,1,0,0,0)};return n[e]};return{determine:f,date_is_dst:u,dst_start_for:l}}();t.TimeZone=function(e){"use strict";var n={"America/Denver":["America/Denver","America/Mazatlan"],"America/Chicago":["America/Chicago","America/Mexico_City"],"America/Santiago":["America/Santiago","America/Asuncion","America/Campo_Grande"],"America/Montevideo":["America/Montevideo","America/Sao_Paulo"],"Asia/Beirut":["Asia/Beirut","Europe/Helsinki","Europe/Istanbul","Asia/Damascus","Asia/Jerusalem","Asia/Gaza"],"Pacific/Auckland":["Pacific/Auckland","Pacific/Fiji"],"America/Los_Angeles":["America/Los_Angeles","America/Santa_Isabel"],"America/New_York":["America/Havana","America/New_York"],"America/Halifax":["America/Goose_Bay","America/Halifax"],"America/Godthab":["America/Miquelon","America/Godthab"],"Asia/Dubai":["Europe/Moscow"],"Asia/Dhaka":["Asia/Yekaterinburg"],"Asia/Jakarta":["Asia/Omsk"],"Asia/Shanghai":["Asia/Krasnoyarsk","Australia/Perth"],"Asia/Tokyo":["Asia/Irkutsk"],"Australia/Brisbane":["Asia/Yakutsk"],"Pacific/Noumea":["Asia/Vladivostok"],"Pacific/Tarawa":["Asia/Kamchatka"],"Pacific/Tongatapu":["Pacific/Apia"],"Africa/Johannesburg":["Asia/Gaza","Africa/Cairo"],"Asia/Baghdad":["Europe/Minsk"]},r=e,i=function(){var e=n[r],i=e.length,s=0,o=e[0];for(;s<i;s+=1){o=e[s];if(t.date_is_dst(t.dst_start_for(o))){r=o;return}}},s=function(){return typeof n[r]!="undefined"};return s()&&i(),{name:function(){return r}}},t.olson={},t.olson.timezones={"-720,0":"Pacific/Majuro","-660,0":"Pacific/Pago_Pago","-600,1":"America/Adak","-600,0":"Pacific/Honolulu","-570,0":"Pacific/Marquesas","-540,0":"Pacific/Gambier","-540,1":"America/Anchorage","-480,1":"America/Los_Angeles","-480,0":"Pacific/Pitcairn","-420,0":"America/Phoenix","-420,1":"America/Denver","-360,0":"America/Guatemala","-360,1":"America/Chicago","-360,1,s":"Pacific/Easter","-300,0":"America/Bogota","-300,1":"America/New_York","-270,0":"America/Caracas","-240,1":"America/Halifax","-240,0":"America/Santo_Domingo","-240,1,s":"America/Santiago","-210,1":"America/St_Johns","-180,1":"America/Godthab","-180,0":"America/Argentina/Buenos_Aires","-180,1,s":"America/Montevideo","-120,0":"America/Noronha","-120,1":"America/Noronha","-60,1":"Atlantic/Azores","-60,0":"Atlantic/Cape_Verde","0,0":"UTC","0,1":"Europe/London","60,1":"Europe/Berlin","60,0":"Africa/Lagos","60,1,s":"Africa/Windhoek","120,1":"Asia/Beirut","120,0":"Africa/Johannesburg","180,0":"Asia/Baghdad","180,1":"Europe/Moscow","210,1":"Asia/Tehran","240,0":"Asia/Dubai","240,1":"Asia/Baku","270,0":"Asia/Kabul","300,1":"Asia/Yekaterinburg","300,0":"Asia/Karachi","330,0":"Asia/Kolkata","345,0":"Asia/Kathmandu","360,0":"Asia/Dhaka","360,1":"Asia/Omsk","390,0":"Asia/Rangoon","420,1":"Asia/Krasnoyarsk","420,0":"Asia/Jakarta","480,0":"Asia/Shanghai","480,1":"Asia/Irkutsk","525,0":"Australia/Eucla","525,1,s":"Australia/Eucla","540,1":"Asia/Yakutsk","540,0":"Asia/Tokyo","570,0":"Australia/Darwin","570,1,s":"Australia/Adelaide","600,0":"Australia/Brisbane","600,1":"Asia/Vladivostok","600,1,s":"Australia/Sydney","630,1,s":"Australia/Lord_Howe","660,1":"Asia/Kamchatka","660,0":"Pacific/Noumea","690,0":"Pacific/Norfolk","720,1,s":"Pacific/Auckland","720,0":"Pacific/Tarawa","765,1,s":"Pacific/Chatham","780,0":"Pacific/Tongatapu","780,1,s":"Pacific/Apia","840,0":"Pacific/Kiritimati"}, true?exports.jstz=t:e.jstz=t})(this);

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var Logger_1 = __webpack_require__(16);
	var DeviceUtils_1 = __webpack_require__(20);
	var SentryLogger = (function () {
	    function SentryLogger(queryController, windoh) {
	        if (windoh === void 0) { windoh = window; }
	        this.queryController = queryController;
	        this.windoh = windoh;
	        this.logger = new Logger_1.Logger(this);
	        this.bindErrorHandler();
	    }
	    SentryLogger.prototype.bindErrorHandler = function () {
	        var _this = this;
	        // take care of not overriding any existing onerror handler that might be already present in the page.
	        var oldHandler = this.windoh.onerror;
	        if (_.isFunction(oldHandler)) {
	            this.windoh.onerror = function () {
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i - 0] = arguments[_i];
	                }
	                oldHandler.apply(oldHandler, args);
	                _this.handleError.apply(_this, args);
	            };
	        }
	        else {
	            this.windoh.onerror = this.handleError.bind(this);
	        }
	    };
	    SentryLogger.prototype.handleError = function (message, filename, lineno, colno, error) {
	        // try not to log irrelevant errors ...
	        if (!filename.toLowerCase().match(/coveo/) || this.windoh.location.host.toLowerCase().match(/localhost/)) {
	            return;
	        }
	        var errorInfo = {
	            message: message,
	            filename: filename,
	            line: lineno,
	            column: colno,
	            error: error.toString(),
	            errorStack: error['stack'],
	            device: DeviceUtils_1.DeviceUtils.getDeviceName()
	        };
	        var sentryLog = {
	            level: 'DEBUG',
	            title: this.windoh.location.href,
	            message: JSON.stringify(errorInfo)
	        };
	        this.queryController.getEndpoint().logError(sentryLog);
	    };
	    return SentryLogger;
	}());
	exports.SentryLogger = SentryLogger;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 110 */
/***/ function(module, exports) {

	"use strict";
	exports.analyticsActionCauseList = {
	    interfaceLoad: {
	        name: 'interfaceLoad',
	        type: 'interface'
	    },
	    interfaceChange: {
	        name: 'interfaceChange',
	        type: 'interface',
	        metaMap: { interfaceChangeTo: 1 }
	    },
	    contextRemove: {
	        name: 'contextRemove',
	        type: 'misc',
	        metaMap: { contextName: 1 }
	    },
	    didyoumeanAutomatic: {
	        name: 'didyoumeanAutomatic',
	        type: 'misc'
	    },
	    didyoumeanClick: {
	        name: 'didyoumeanClick',
	        type: 'misc'
	    },
	    resultsSort: {
	        name: 'resultsSort',
	        type: 'misc',
	        metaMap: { resultsSortBy: 1 }
	    },
	    searchboxSubmit: {
	        name: 'searchboxSubmit',
	        type: 'search box'
	    },
	    searchboxClear: {
	        name: 'searchboxClear',
	        type: 'search box'
	    },
	    searchboxAsYouType: {
	        name: 'searchboxAsYouType',
	        type: 'search box'
	    },
	    breadcrumbFacet: {
	        name: 'breadcrumbFacet',
	        type: 'breadcrumb',
	        metaMap: { facetId: 1, facetValue: 2, facetTitle: 3 }
	    },
	    breadcrumbResetAll: {
	        name: 'breadcrumbResetAll',
	        type: 'breadcrumb',
	    },
	    documentTag: {
	        name: 'documentTag',
	        type: 'document',
	        metaMap: { facetId: 1, facetValue: 2, facetTitle: 3 }
	    },
	    documentField: {
	        name: 'documentField',
	        type: 'document',
	        metaMap: { facetId: 1, facetValue: 2, facetTitle: 3 }
	    },
	    documentQuickview: {
	        name: 'documentQuickview',
	        type: 'document',
	        metaMap: { documentTitle: 1, documentURL: 2 }
	    },
	    documentOpen: {
	        name: 'documentOpen',
	        type: 'document',
	        metaMap: { documentTitle: 1, documentURL: 2 }
	    },
	    omniboxFacetSelect: {
	        name: 'omniboxFacetSelect',
	        type: 'omnibox',
	        metaMap: { facetId: 1, facetValue: 2, facetTitle: 3 }
	    },
	    omniboxFacetExclude: {
	        name: 'omniboxFacetExclude',
	        type: 'omnibox',
	        metaMap: { facetId: 1, facetValue: 2, facetTitle: 3 }
	    },
	    omniboxFacetDeselect: {
	        name: 'omniboxFacetDeselect',
	        type: 'omnibox',
	        metaMap: { facetId: 1, facetValue: 2, facetTitle: 3 }
	    },
	    omniboxFacetUnexclude: {
	        name: 'omniboxFacetUnexclude',
	        type: 'omnibox',
	        metaMap: { faceId: 1, facetValue: 2, facetTitle: 3 }
	    },
	    omniboxAnalytics: {
	        name: 'omniboxAnalytics',
	        type: 'omnibox',
	        metaMap: {
	            partialQuery: 1,
	            suggestionRanking: 2,
	            partialQueries: 3,
	            suggestions: 4
	        }
	    },
	    omniboxField: {
	        name: 'omniboxField',
	        type: 'omnibox'
	    },
	    facetClearAll: {
	        name: 'facetClearAll',
	        type: 'facet',
	        metaMap: { facetId: 1 }
	    },
	    facetSearch: {
	        name: 'facetSearch',
	        type: 'facet',
	        metaMap: { facetId: 1 }
	    },
	    facetToggle: {
	        name: 'facetToggle',
	        type: 'facet',
	        metaMap: { facetId: 1, facetOperatorBefore: 2, facetOperatorAfter: 3 }
	    },
	    facetRangeSlider: {
	        name: 'facetRangeSlider',
	        type: 'facet',
	        metaMap: { facetId: 1, facetRangeStart: 2, facetRangeEnd: 3 }
	    },
	    facetRangeGraph: {
	        name: 'facetRangeGraph',
	        type: 'facet',
	        metaMap: { facetId: 1, facetRangeStart: 2, facetRangeEnd: 3 }
	    },
	    facetSelect: {
	        name: 'facetSelect',
	        type: 'facet',
	        metaMap: { facetId: 1, facetValue: 2, facetTitle: 3 }
	    },
	    facetSelectAll: {
	        name: 'facetSelectAll',
	        type: 'facet',
	        metaMap: { facetId: 1, facetValue: 2, facetTitle: 3 }
	    },
	    facetDeselect: {
	        name: 'facetDeselect',
	        type: 'facet',
	        metaMap: { facetId: 1, facetValue: 2, facetTitle: 3 }
	    },
	    facetExclude: {
	        name: 'facetExclude',
	        type: 'facet',
	        metaMap: { facetId: 1, facetValue: 2, facetTitle: 3 }
	    },
	    facetUnexclude: {
	        name: 'facetUnexclude',
	        type: 'facet',
	        metaMap: { facetId: 1, facetValue: 2, facetTitle: 3 }
	    },
	    errorBack: {
	        name: 'errorBack',
	        type: 'errors'
	    },
	    errorClearQuery: {
	        name: 'errorClearQuery',
	        type: 'errors'
	    },
	    errorRetry: {
	        name: 'errorRetry',
	        type: 'errors'
	    },
	    noResultsBack: {
	        name: 'noResultsBack',
	        type: 'noResults'
	    },
	    expandToFullUI: {
	        name: 'expandToFullUI',
	        type: 'interface'
	    },
	    caseCreationInputChange: {
	        name: 'inputChange',
	        type: 'caseCreation'
	    },
	    caseCreationSubmitButton: {
	        name: 'submitButton',
	        type: 'caseCreation'
	    },
	    caseCreationCancelButton: {
	        name: 'cancelButton',
	        type: 'caseCreation'
	    },
	    caseCreationUnloadPage: {
	        name: 'unloadPage',
	        type: 'caseCreation'
	    },
	    casecontextAdd: {
	        name: 'casecontextAdd',
	        type: 'casecontext',
	        metaMap: { caseID: 5 }
	    },
	    casecontextRemove: {
	        name: 'casecontextRemove',
	        type: 'casecontext',
	        metaMap: { caseID: 5 }
	    },
	    preferencesChange: {
	        name: 'preferencesChange',
	        type: 'preferences',
	        metaMap: { preferenceName: 1, preferenceType: 2 }
	    },
	    getUserHistory: {
	        name: 'getUserHistory',
	        type: 'userHistory'
	    },
	    userActionDocumentClick: {
	        name: 'userActionDocumentClick',
	        type: 'userHistory'
	    },
	    caseAttach: {
	        name: 'caseAttach',
	        type: 'case',
	        metaMap: { documentTitle: 1, resultUriHash: 3, articleID: 4, caseID: 5 }
	    },
	    caseDetach: {
	        name: 'caseDetach',
	        type: 'case',
	        metaMap: { documentTitle: 1, resultUriHash: 3, articleID: 4, caseID: 5 }
	    },
	    customfiltersChange: {
	        name: 'customfiltersChange',
	        type: 'customfilters',
	        metaMap: { customFilterName: 1, customFilterType: 2, customFilterExpression: 3 }
	    },
	    pagerNumber: {
	        name: 'pagerNumber',
	        type: 'getMoreResults',
	        metaMap: { 'pagerNumber': 1 }
	    },
	    pagerNext: {
	        name: 'pagerNext',
	        type: 'getMoreResults',
	        metaMap: { 'pagerNumber': 1 }
	    },
	    pagerPrevious: {
	        name: 'pagerPrevious',
	        type: 'getMoreResults',
	        metaMap: { 'pagerNumber': 1 }
	    },
	    pagerScrolling: {
	        name: 'pagerScrolling',
	        type: 'getMoreResults'
	    },
	    pagerResize: {
	        name: 'pagerResize',
	        type: 'getMoreResults'
	    },
	    searchFromLink: {
	        name: 'searchFromLink',
	        type: 'interface'
	    },
	    triggerNotify: {
	        name: 'notify',
	        type: 'queryPipelineTriggers'
	    },
	    triggerExecute: {
	        name: 'execute',
	        type: 'queryPipelineTriggers'
	    },
	    triggerQuery: {
	        name: 'query',
	        type: 'queryPipelineTriggers'
	    },
	    triggerRedirect: {
	        name: 'redirect',
	        type: 'queryPipelineTriggers'
	    },
	    queryError: {
	        name: 'query',
	        type: 'errors',
	        metaMap: { 'query': 1, 'aq': 2, 'cq': 3, 'dq': 4, 'errorType': 5, 'errorMessage': 6 }
	    },
	    exportToExcel: {
	        name: 'exportToExcel',
	        type: 'misc'
	    },
	    recommendation: {
	        name: 'recommendation',
	        type: 'recommendation'
	    },
	    recommendationInterfaceLoad: {
	        name: 'recommendationInterfaceLoad',
	        type: 'recommendation'
	    },
	    recommendationOpen: {
	        name: 'recommendationOpen',
	        type: 'recommendation'
	    },
	    advancedSearch: {
	        name: 'advancedSearch',
	        type: 'advancedSearch'
	    }
	};


/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var AnalyticsEndpoint_1 = __webpack_require__(36);
	var SearchEndpoint_1 = __webpack_require__(12);
	var Assert_1 = __webpack_require__(17);
	var QueryEvents_1 = __webpack_require__(47);
	var ComponentOptionsModel_1 = __webpack_require__(91);
	var Dom_1 = __webpack_require__(57);
	var Model_1 = __webpack_require__(87);
	var Utils_1 = __webpack_require__(18);
	var NoopAnalyticsClient_1 = __webpack_require__(105);
	var LiveAnalyticsClient_1 = __webpack_require__(112);
	var MultiAnalyticsClient_1 = __webpack_require__(116);
	var AnalyticsActionListMeta_1 = __webpack_require__(110);
	var SearchInterface_1 = __webpack_require__(97);
	var Recommendation_1 = __webpack_require__(117);
	var RecommendationAnalyticsClient_1 = __webpack_require__(119);
	/**
	 * This component logs all user actions performed in the search interface and sends them to a REST web service exposed through the Coveo Cloud platform.<br/>
	 * You can use data to evaluate how users are interacting with the search interface, improve relevance and produce analytics dashboards in the Coveo platform.
	 *
	 * # Send Custom Events
	 * In some scenarios, you want to send custom data to the Coveo Cloud analytics (see [Coveo Cloud Usage Analytics](http://www.coveo.com/go?dest=cloudhelp&lcid=9&context=89)). The Coveo JavaScript Search Framework offers helpers to communicate with the Coveo Analytics REST API, so you do not have to write code to call the API directly.
	 *
	 * 1. First, you need to craft your custom event cause and meta.<br/>**NB: The event names must be unique.**
	 * ```
	 *   // customEventType allows to regroup similar event types together when doing reporting (e.g., search box).
	 *   var customEventCause = {name: 'customEventName', type:'customEventType'};
	 *   var metadata = {key1: "value1", key2:"value2"};
	 * ```
	 *
	 * 2. Send your custom event.
	 * ```
	 *   Coveo.logCustomEvent(document.querySelector('#search'), customEventCause, metadata);
	 *      // OR (using the jquery extension)
	 *   $('#search').coveo('logCustomEvent', customEventCause, metadata);
	 * ```
	 *
	 * 3. Send your custom search event<br/>**NB: If you want to log a `searchEvent`, be sure to always call the helper before you call `executeQuery`.**
	 * ```
	 * function myCustomButtonWasClicked() {
	 *      Coveo.logSearchEvent(document.querySelector('#search'), customEventCause, metadata);
	 *      Coveo.executeQuery(document.querySelector('#search'));
	 *      // OR (using the jquery extension)
	 *      $('#search').coveo('logSearchEvent', customEventCause, metadata);
	 *      $('#search').coveo('executeQuery');
	 * }
	 * ```
	 *
	 * 4. Send a custom `searchAsYouType` event<br/>**NB: If you want to log a `searchAsYouTypeEvent`, be sure to always call the helper before you call `executeQuery`.**
	 * ```
	 * function myCustomButtonWasClicked() {
	 *      Coveo.logSearchAsYouTypeEvent(document.querySelector('#search'), customEventCause, metadata);
	 *      Coveo.executeQuery(document.querySelector('#search'));
	 *      // OR (using the jquery extension)
	 *      $('#search').coveo('logSearchAsYouTypeEvent', customEventCause, metadata);
	 *      $('#search').coveo('executeQuery');
	 * }
	 * ```
	 *
	 * 5. Send a custom click event.
	 * ```
	 * Coveo.logClickEvent(document.querySelector('#search'), customEventCause, metadata, result);
	 * // OR (using the jQuery extension)
	 * $('#search').coveo('logClickEvent', customEventCause, metadata, result);
	 * ```
	 */
	var Analytics = (function (_super) {
	    __extends(Analytics, _super);
	    /**
	     * Create a new Analytics component. Create the {@link IAnalyticsClient}.
	     * @param element The HTMLElement on which the component will be instantiated.
	     * @param options The options for the Analytics.
	     * @param bindings The bindings that the component requires to function normally. If not set, it will automatically resolve them (with slower execution time).
	     */
	    function Analytics(element, options, bindings) {
	        var _this = this;
	        if (options === void 0) { options = {}; }
	        _super.call(this, element, Analytics.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.bindings = bindings;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, Analytics, options);
	        this.retrieveInfoFromDefaultSearchEndpoint();
	        this.initializeAnalyticsClient();
	        Assert_1.Assert.exists(this.client);
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.buildingQuery, function (data) { return _this.handleBuildingQuery(data); });
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.queryError, function (data) { return _this.handleQueryError(data); });
	        // Analytics component is a bit special: It can be higher in the dom tree than the search interface
	        // Need to resolve down to find the componentOptionsModel if we need to.
	        if (!this.componentOptionsModel) {
	            var cmpOptionElement = Dom_1.$$(element).find('.' + Component_1.Component.computeCssClassName(ComponentOptionsModel_1.ComponentOptionsModel));
	            if (cmpOptionElement) {
	                this.componentOptionsModel = cmpOptionElement[Component_1.Component.computeCssClassName(ComponentOptionsModel_1.ComponentOptionsModel)];
	            }
	        }
	        if (this.componentOptionsModel) {
	            this.componentOptionsModel.set(ComponentOptionsModel_1.ComponentOptionsModel.attributesEnum.searchHub, this.options.searchHub);
	            var event_1 = this.componentOptionsModel.getEventName(Model_1.Model.eventTypes.changeOne + ComponentOptionsModel_1.ComponentOptionsModel.attributesEnum.searchHub);
	            this.bind.onRootElement(event_1, function (args) { return _this.handleSearchHubChanged(args); });
	        }
	    }
	    /**
	     * Log a search event on the service, using a cause and a meta object.<br/>
	     * Note that the event will be sent on the service when a query successfully return, not immediately after calling this method.<br/>
	     * Normally, this should be called using the following "format": <br/>
	     * usageAnalytics.logSearchEvent<SomeMeta>({name : 'foo', type : 'bar'}, <SomeMeta>{'key':'value'});<br/>
	     * this.queryController.executeQuery();<br/>
	     * This will queue up an analytics search event. Then the query is executed. The search event will be sent to the service when the query is successfully completed.<br/>
	     * @param actionCause
	     * @param meta Can be an empty object ( {} ).
	     */
	    Analytics.prototype.logSearchEvent = function (actionCause, meta) {
	        this.client.logSearchEvent(actionCause, meta);
	    };
	    /**
	     * Log a search as you type event on the service, using a cause and a meta object.<br/>
	     * This is extremely similar to a search event, except that search as you type, by definition, will be frequently called.<br/>
	     * The `PendingSearchAsYouTypeEvent` will take care of logging only the "relevant" last event: After 5 seconds of no event logged, or after another search event is triggered somewhere else in the interface.<br/>
	     * This is to ensure that we do not needlessly log every single partial query, which would make the reporting very confusing.
	     * @param actionCause
	     * @param meta Can be an empty object ( {} ).
	     */
	    Analytics.prototype.logSearchAsYouType = function (actionCause, meta) {
	        this.client.logSearchAsYouType(actionCause, meta);
	    };
	    /**
	     * Log a custom event on the service. A custom event can be used to create customized report, or to track events which are not queries or document views.
	     * @param actionCause
	     * @param meta
	     * @param element The HTMLElement that was interacted with for this custom event.
	     */
	    Analytics.prototype.logCustomEvent = function (actionCause, meta, element) {
	        if (element === void 0) { element = this.element; }
	        this.client.logCustomEvent(actionCause, meta, element);
	    };
	    /**
	     * Log a click event. A click event can be understood as a document view.<br/>
	     * eg : Clicking on a result link of opening a quickview.<br/>
	     * This event will be logged immediately on the service.
	     * @param actionCause
	     * @param meta Can be an empty object ( {} ).
	     * @param result The result that was clicked.
	     * @param element The HTMLElement that was clicked in the interface.
	     */
	    Analytics.prototype.logClickEvent = function (actionCause, meta, result, element) {
	        if (element === void 0) { element = this.element; }
	        this.client.logClickEvent(actionCause, meta, result, element);
	    };
	    Analytics.prototype.initializeAnalyticsEndpoint = function () {
	        return new AnalyticsEndpoint_1.AnalyticsEndpoint({
	            token: this.options.token,
	            serviceUrl: this.options.endpoint,
	            organization: this.options.organization
	        });
	    };
	    Analytics.prototype.initializeAnalyticsClient = function () {
	        if (Utils_1.Utils.isNonEmptyString(this.options.endpoint)) {
	            var endpoint = this.initializeAnalyticsEndpoint();
	            var elementToInitializeClient = void 0;
	            if (this.root && this.element) {
	                if (this.root.contains(this.element)) {
	                    elementToInitializeClient = this.root;
	                }
	                else {
	                    elementToInitializeClient = this.element;
	                }
	            }
	            var isRecommendation = Dom_1.$$(this.root).hasClass(Component_1.Component.computeCssClassName(Recommendation_1.Recommendation));
	            this.instantiateAnalyticsClient(endpoint, elementToInitializeClient, isRecommendation);
	        }
	        else {
	            this.client = new NoopAnalyticsClient_1.NoopAnalyticsClient();
	        }
	    };
	    Analytics.prototype.instantiateAnalyticsClient = function (endpoint, elementToInitializeClient, isRecommendation) {
	        if (isRecommendation) {
	            this.client = new RecommendationAnalyticsClient_1.RecommendationAnalyticsClient(endpoint, elementToInitializeClient, this.options.user, this.options.userDisplayName, this.options.anonymous, this.options.splitTestRunName, this.options.splitTestRunVersion, this.options.searchHub, this.options.sendToCloud, this.getBindings());
	        }
	        else {
	            this.client = new LiveAnalyticsClient_1.LiveAnalyticsClient(endpoint, elementToInitializeClient, this.options.user, this.options.userDisplayName, this.options.anonymous, this.options.splitTestRunName, this.options.splitTestRunVersion, this.options.searchHub, this.options.sendToCloud);
	        }
	    };
	    Analytics.prototype.retrieveInfoFromDefaultSearchEndpoint = function () {
	        var defaultEndpoint = SearchEndpoint_1.SearchEndpoint.endpoints['default'];
	        if (this.options.token == null && defaultEndpoint) {
	            this.options.token = defaultEndpoint.options.accessToken;
	        }
	        if (!this.options.organization && defaultEndpoint) {
	            this.options.organization = defaultEndpoint.options.queryStringArguments['workgroup'];
	        }
	    };
	    Analytics.prototype.handleBuildingQuery = function (data) {
	        Assert_1.Assert.exists(data);
	        data.queryBuilder.searchHub = this.options.searchHub;
	    };
	    Analytics.prototype.handleSearchHubChanged = function (data) {
	        this.options.searchHub = data.value;
	    };
	    Analytics.prototype.handleQueryError = function (data) {
	        Assert_1.Assert.exists(data);
	        this.client.logCustomEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.queryError, {
	            query: data.query.q,
	            aq: data.query.aq,
	            cq: data.query.cq,
	            dq: data.query.dq,
	            errorType: data.error.type,
	            errorMessage: data.error.message
	        }, this.element);
	    };
	    Analytics.create = function (element, options, bindings) {
	        var selector = Component_1.Component.computeSelectorForType(Analytics.ID);
	        var found = [];
	        found = found.concat(Dom_1.$$(element).findAll(selector));
	        if (!(Component_1.Component.get(element, SearchInterface_1.SearchInterface) instanceof Recommendation_1.Recommendation)) {
	            found = this.ignoreElementsInsideRecommendationInterface(found);
	        }
	        found.push(Dom_1.$$(element).closest(Component_1.Component.computeCssClassName(Analytics)));
	        if (Dom_1.$$(element).is(selector)) {
	            found.push(element);
	        }
	        found = _.compact(found);
	        if (found.length == 1) {
	            return Analytics.getClient(found[0], options, bindings);
	        }
	        else if (found.length > 1) {
	            return new MultiAnalyticsClient_1.MultiAnalyticsClient(_.map(found, function (el) { return Analytics.getClient(el, options, bindings); }));
	        }
	        else {
	            return new NoopAnalyticsClient_1.NoopAnalyticsClient();
	        }
	    };
	    Analytics.ignoreElementsInsideRecommendationInterface = function (found) {
	        return _.filter(found, function (element) {
	            return Dom_1.$$(element).closest(Component_1.Component.computeCssClassName(Recommendation_1.Recommendation)) === undefined;
	        });
	    };
	    Analytics.getClient = function (element, options, bindings) {
	        // This check if an element is already initialized as an analytics component.
	        // If that's the case, return the client on that element.
	        // Otherwise, init and return.
	        var foundOnElement = Component_1.Component.get(element, Analytics, true);
	        if (foundOnElement instanceof Analytics) {
	            return foundOnElement.client;
	        }
	        else {
	            return new Analytics(element, options, bindings).client;
	        }
	    };
	    Analytics.ID = 'Analytics';
	    // NOTE: The default values for some of those options (`organization`, `endpoint`, `searchHub`) can be
	    // overridden by generated code when using hosted search pages.
	    /**
	     * Options for the component
	     * @componentOptions
	     */
	    Analytics.options = {
	        /**
	         * Specifies the name of the user for usage analytics logs.
	         */
	        user: ComponentOptions_1.ComponentOptions.buildStringOption(),
	        /**
	         * Specifies the name of the user display name for usage analytics logs.
	         */
	        userDisplayName: ComponentOptions_1.ComponentOptions.buildStringOption(),
	        /**
	         * Specifies the token used to gain access the analytics endpoint.<br/>
	         * This attribute is optional, the component will use the search token by default.
	         */
	        token: ComponentOptions_1.ComponentOptions.buildStringOption(),
	        /**
	         * Specifies the URL of the analytics logger for rare cases where it is different from the default usage analytics Coveo Cloud endpoint (https://usageanalytics.coveo.com).
	         */
	        endpoint: ComponentOptions_1.ComponentOptions.buildStringOption({ defaultValue: AnalyticsEndpoint_1.AnalyticsEndpoint.DEFAULT_ANALYTICS_URI }),
	        /**
	         * Specifies whether the search user identities are converted in a unique hash in the logged analytics data to prevent analytics reviewers and managers to identify who performs which queries.<br/>
	         * When enabled, the Coveo Analytics Platform can still properly identify sessions made by anonymous users, versus ones from users that are authenticated in some way with the site containing the search page.<br/>
	         * The default value is `false`.
	         */
	        anonymous: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: false }),
	        /**
	         * Sets the Search Hub dimension on the search events.<br/>
	         * The Search Hub dimension is typically a name that refers to a specific search page. For example, one could use the CommunitySite value to refer to a search page on a company's public community site.<br/>
	         * The default value is default.
	         */
	        searchHub: ComponentOptions_1.ComponentOptions.buildStringOption({ defaultValue: 'default' }),
	        /**
	         * Specifies the name of the split test run that the search page is a part of.<br/>
	         * This dimension can be used to perform A/B testing using different search page layouts and features, inside the Coveo Query pipeline.<br/>
	         * By default, this value is not specified and no split test run name is reported to the Coveo Analytics Platform.
	         */
	        splitTestRunName: ComponentOptions_1.ComponentOptions.buildStringOption(),
	        /**
	         * Specifies the version name for the page when a split test run is active.<br/>
	         * When reporting on A/B testing analytics data, this value specifies the test run version name that has been presented to the user.<br/>
	         * By default, this value is not specified.
	         */
	        splitTestRunVersion: ComponentOptions_1.ComponentOptions.buildStringOption(),
	        sendToCloud: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true }),
	        /**
	         * Specifies the organization bound to the access token. This is necessary when using an access token because it can be associated with more than organization.
	         * If this parameter is not specified, it will fallback on the organization used for the search endpoint.
	         */
	        organization: ComponentOptions_1.ComponentOptions.buildStringOption()
	    };
	    return Analytics;
	}(Component_1.Component));
	exports.Analytics = Analytics;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var DeviceUtils_1 = __webpack_require__(20);
	var PendingSearchEvent_1 = __webpack_require__(113);
	var PendingSearchAsYouTypeSearchEvent_1 = __webpack_require__(115);
	var Assert_1 = __webpack_require__(17);
	var Logger_1 = __webpack_require__(16);
	var AnalyticsActionListMeta_1 = __webpack_require__(110);
	var Defer_1 = __webpack_require__(31);
	var Dom_1 = __webpack_require__(57);
	var AnalyticsEvents_1 = __webpack_require__(40);
	var APIAnalyticsBuilder_1 = __webpack_require__(114);
	var QueryStateModel_1 = __webpack_require__(90);
	var Component_1 = __webpack_require__(96);
	var Version_1 = __webpack_require__(11);
	var LiveAnalyticsClient = (function () {
	    function LiveAnalyticsClient(endpoint, rootElement, userId, userDisplayName, anonymous, splitTestRunName, splitTestRunVersion, originLevel1, sendToCloud) {
	        this.endpoint = endpoint;
	        this.rootElement = rootElement;
	        this.userId = userId;
	        this.userDisplayName = userDisplayName;
	        this.anonymous = anonymous;
	        this.splitTestRunName = splitTestRunName;
	        this.splitTestRunVersion = splitTestRunVersion;
	        this.originLevel1 = originLevel1;
	        this.sendToCloud = sendToCloud;
	        this.isContextual = false;
	        this.language = String['locale'];
	        this.device = DeviceUtils_1.DeviceUtils.getDeviceName();
	        this.mobile = DeviceUtils_1.DeviceUtils.isMobileDevice();
	        Assert_1.Assert.exists(endpoint);
	        Assert_1.Assert.exists(rootElement);
	        Assert_1.Assert.isNonEmptyString(this.language);
	        Assert_1.Assert.isNonEmptyString(this.device);
	        Assert_1.Assert.isNonEmptyString(this.originLevel1);
	        this.logger = new Logger_1.Logger(this);
	    }
	    LiveAnalyticsClient.prototype.isActivated = function () {
	        return true;
	    };
	    LiveAnalyticsClient.prototype.getCurrentVisitId = function () {
	        return this.endpoint.getCurrentVisitId();
	    };
	    LiveAnalyticsClient.prototype.getCurrentVisitIdPromise = function () {
	        return this.endpoint.getCurrentVisitIdPromise();
	    };
	    LiveAnalyticsClient.prototype.getCurrentEventCause = function () {
	        if (this.pendingSearchEvent != null) {
	            return this.pendingSearchEvent.getEventCause();
	        }
	        if (this.pendingSearchAsYouTypeSearchEvent != null) {
	            return this.pendingSearchAsYouTypeSearchEvent.getEventCause();
	        }
	        return null;
	    };
	    LiveAnalyticsClient.prototype.getCurrentEventMeta = function () {
	        if (this.pendingSearchEvent != null) {
	            return this.pendingSearchEvent.getEventMeta();
	        }
	        if (this.pendingSearchAsYouTypeSearchEvent != null) {
	            return this.pendingSearchAsYouTypeSearchEvent.getEventMeta();
	        }
	        return null;
	    };
	    LiveAnalyticsClient.prototype.logSearchEvent = function (actionCause, meta) {
	        var metaObject = this.buildMetaObject(meta);
	        this.pushSearchEvent(actionCause, metaObject);
	    };
	    LiveAnalyticsClient.prototype.logSearchAsYouType = function (actionCause, meta) {
	        var metaObject = this.buildMetaObject(meta);
	        this.pushSearchAsYouTypeEvent(actionCause, metaObject);
	    };
	    LiveAnalyticsClient.prototype.logClickEvent = function (actionCause, meta, result, element) {
	        var metaObject = this.buildMetaObject(meta);
	        this.pushClickEvent(actionCause, metaObject, result, element);
	    };
	    LiveAnalyticsClient.prototype.logCustomEvent = function (actionCause, meta, element) {
	        var metaObject = this.buildMetaObject(meta);
	        this.pushCustomEvent(actionCause, metaObject, element);
	    };
	    LiveAnalyticsClient.prototype.getTopQueries = function (params) {
	        return this.endpoint.getTopQueries(params);
	    };
	    LiveAnalyticsClient.prototype.sendAllPendingEvents = function () {
	        if (this.pendingSearchAsYouTypeSearchEvent) {
	            this.pendingSearchAsYouTypeSearchEvent.sendRightNow();
	        }
	    };
	    LiveAnalyticsClient.prototype.cancelAllPendingEvents = function () {
	        if (this.pendingSearchAsYouTypeSearchEvent) {
	            this.pendingSearchAsYouTypeSearchEvent.cancel();
	            this.pendingSearchAsYouTypeSearchEvent = null;
	        }
	        if (this.pendingSearchEvent) {
	            this.pendingSearchEvent.cancel();
	            this.pendingSearchEvent = null;
	        }
	    };
	    LiveAnalyticsClient.prototype.getPendingSearchEvent = function () {
	        if (this.pendingSearchEvent) {
	            return this.pendingSearchEvent;
	        }
	        else if (this.pendingSearchAsYouTypeSearchEvent) {
	            return this.pendingSearchAsYouTypeSearchEvent;
	        }
	        return null;
	    };
	    LiveAnalyticsClient.prototype.warnAboutSearchEvent = function () {
	        if (_.isUndefined(this.pendingSearchEvent) && _.isUndefined(this.pendingSearchAsYouTypeSearchEvent)) {
	            this.logger.warn('A search was triggered, but no analytics event was logged. If you wish to have consistent analytics data, consider logging a search event using the methods provided by the framework', 'https://developers.coveo.com/x/TwA5');
	            if (window['console'] && console.trace) {
	                console.trace();
	            }
	        }
	    };
	    LiveAnalyticsClient.prototype.pushCustomEvent = function (actionCause, metaObject, element) {
	        var _this = this;
	        var customEvent = this.buildCustomEvent(actionCause, metaObject, element);
	        this.triggerChangeAnalyticsCustomData('CustomEvent', metaObject, customEvent);
	        this.checkToSendAnyPendingSearchAsYouType(actionCause);
	        Defer_1.Defer.defer(function () {
	            if (_this.sendToCloud) {
	                _this.endpoint.sendCustomEvent(customEvent);
	            }
	            Dom_1.$$(_this.rootElement).trigger(AnalyticsEvents_1.AnalyticsEvents.customEvent, { customEvent: APIAnalyticsBuilder_1.APIAnalyticsBuilder.convertCustomEventToAPI(customEvent) });
	        });
	    };
	    LiveAnalyticsClient.prototype.pushSearchEvent = function (actionCause, metaObject) {
	        var _this = this;
	        Assert_1.Assert.exists(actionCause);
	        if (this.pendingSearchEvent && this.pendingSearchEvent.getEventCause() !== actionCause.name) {
	            this.pendingSearchEvent.stopRecording();
	            this.pendingSearchEvent = null;
	        }
	        this.checkToSendAnyPendingSearchAsYouType(actionCause);
	        if (!this.pendingSearchEvent) {
	            var searchEvent = this.buildSearchEvent(actionCause, metaObject);
	            this.triggerChangeAnalyticsCustomData('SearchEvent', metaObject, searchEvent);
	            var pendingSearchEvent = this.pendingSearchEvent = new PendingSearchEvent_1.PendingSearchEvent(this.rootElement, this.endpoint, searchEvent, this.sendToCloud);
	            Defer_1.Defer.defer(function () {
	                // At this point all `duringQuery` events should have been fired, so we can forget
	                // about the pending search event. It will finish processing automatically when
	                // all the deferred that were caught terminate.
	                _this.pendingSearchEvent = undefined;
	                pendingSearchEvent.stopRecording();
	            });
	        }
	    };
	    LiveAnalyticsClient.prototype.checkToSendAnyPendingSearchAsYouType = function (actionCause) {
	        if (this.eventIsNotRelatedToSearchbox(actionCause.name)) {
	            this.sendAllPendingEvents();
	        }
	        else {
	            this.cancelAnyPendingSearchAsYouTypeEvent();
	        }
	    };
	    LiveAnalyticsClient.prototype.pushSearchAsYouTypeEvent = function (actionCause, metaObject) {
	        this.cancelAnyPendingSearchAsYouTypeEvent();
	        var searchEvent = this.buildSearchEvent(actionCause, metaObject);
	        this.triggerChangeAnalyticsCustomData('SearchEvent', metaObject, searchEvent);
	        this.pendingSearchAsYouTypeSearchEvent = new PendingSearchAsYouTypeSearchEvent_1.PendingSearchAsYouTypeSearchEvent(this.rootElement, this.endpoint, searchEvent, this.sendToCloud);
	    };
	    LiveAnalyticsClient.prototype.pushClickEvent = function (actionCause, metaObject, result, element) {
	        var _this = this;
	        var event = this.buildClickEvent(actionCause, metaObject, result, element);
	        this.checkToSendAnyPendingSearchAsYouType(actionCause);
	        this.triggerChangeAnalyticsCustomData('ClickEvent', metaObject, event, { resultData: result });
	        Assert_1.Assert.isNonEmptyString(event.searchQueryUid);
	        Assert_1.Assert.isNonEmptyString(event.collectionName);
	        Assert_1.Assert.isNonEmptyString(event.sourceName);
	        Assert_1.Assert.isNumber(event.documentPosition);
	        Defer_1.Defer.defer(function () {
	            if (_this.sendToCloud) {
	                _this.endpoint.sendDocumentViewEvent(event);
	            }
	            Dom_1.$$(_this.rootElement).trigger(AnalyticsEvents_1.AnalyticsEvents.documentViewEvent, {
	                documentViewEvent: APIAnalyticsBuilder_1.APIAnalyticsBuilder.convertDocumentViewToAPI(event)
	            });
	        });
	    };
	    LiveAnalyticsClient.prototype.buildAnalyticsEvent = function (actionCause, metaObject) {
	        return {
	            actionCause: actionCause.name,
	            actionType: actionCause.type,
	            username: this.userId,
	            userDisplayName: this.userDisplayName,
	            anonymous: this.anonymous,
	            device: this.device,
	            mobile: this.mobile,
	            language: this.language,
	            responseTime: undefined,
	            originLevel1: this.originLevel1,
	            originLevel2: this.getOriginLevel2(this.rootElement),
	            originLevel3: document.referrer,
	            customData: _.keys(metaObject).length > 0 ? metaObject : undefined,
	            userAgent: navigator.userAgent
	        };
	    };
	    LiveAnalyticsClient.prototype.buildSearchEvent = function (actionCause, metaObject) {
	        return this.merge(this.buildAnalyticsEvent(actionCause, metaObject), {
	            searchQueryUid: undefined,
	            pipeline: undefined,
	            splitTestRunName: this.splitTestRunName,
	            splitTestRunVersion: this.splitTestRunVersion,
	            queryText: undefined,
	            advancedQuery: undefined,
	            results: undefined,
	            resultsPerPage: undefined,
	            pageNumber: undefined,
	            didYouMean: undefined,
	            facets: undefined,
	            contextual: this.isContextual
	        });
	    };
	    LiveAnalyticsClient.prototype.buildClickEvent = function (actionCause, metaObject, result, element) {
	        return this.merge(this.buildAnalyticsEvent(actionCause, metaObject), {
	            searchQueryUid: result.queryUid,
	            queryPipeline: result.pipeline,
	            splitTestRunName: this.splitTestRunName || result.splitTestRun,
	            splitTestRunVersion: this.splitTestRunVersion || (result.splitTestRun != undefined ? result.pipeline : undefined),
	            documentUri: result.uri,
	            documentUriHash: result.raw['urihash'],
	            documentUrl: result.clickUri,
	            documentTitle: result.title,
	            documentCategory: result.raw['objecttype'],
	            originLevel2: this.getOriginLevel2(element),
	            collectionName: result.raw['collection'],
	            sourceName: result.raw['source'],
	            documentPosition: result.index + 1,
	            responseTime: 0,
	            viewMethod: actionCause.name,
	            rankingModifier: result.rankingModifier
	        });
	    };
	    LiveAnalyticsClient.prototype.buildCustomEvent = function (actionCause, metaObject, element) {
	        return this.merge(this.buildAnalyticsEvent(actionCause, metaObject), {
	            eventType: actionCause.type,
	            eventValue: actionCause.name,
	            originLevel2: this.getOriginLevel2(element),
	            responseTime: 0
	        });
	    };
	    LiveAnalyticsClient.prototype.getOriginLevel2 = function (element) {
	        return this.resolveActiveTabFromElement(element) || 'default';
	    };
	    LiveAnalyticsClient.prototype.buildMetaObject = function (meta) {
	        var build = _.extend({}, meta);
	        build['JSUIVersion'] = Version_1.version.lib + ';' + Version_1.version.product;
	        return build;
	    };
	    LiveAnalyticsClient.prototype.cancelAnyPendingSearchAsYouTypeEvent = function () {
	        if (this.pendingSearchAsYouTypeSearchEvent) {
	            this.pendingSearchAsYouTypeSearchEvent.cancel();
	            this.pendingSearchAsYouTypeSearchEvent = undefined;
	        }
	    };
	    LiveAnalyticsClient.prototype.resolveActiveTabFromElement = function (element) {
	        Assert_1.Assert.exists(element);
	        var queryStateModel = this.resolveQueryStateModel(element);
	        return (queryStateModel && queryStateModel.get(QueryStateModel_1.QueryStateModel.attributesEnum.t));
	    };
	    LiveAnalyticsClient.prototype.resolveQueryStateModel = function (rootElement) {
	        return Component_1.Component.resolveBinding(rootElement, QueryStateModel_1.QueryStateModel);
	    };
	    LiveAnalyticsClient.prototype.eventIsNotRelatedToSearchbox = function (event) {
	        return event !== AnalyticsActionListMeta_1.analyticsActionCauseList.searchboxSubmit.name && event !== AnalyticsActionListMeta_1.analyticsActionCauseList.searchboxClear.name;
	    };
	    LiveAnalyticsClient.prototype.triggerChangeAnalyticsCustomData = function (type, metaObject, event, data) {
	        var changeableAnalyticsDataObject = {
	            language: event.language,
	            originLevel1: event.originLevel1,
	            originLevel2: event.originLevel2,
	            originLevel3: event.originLevel3
	        };
	        // This is for backward compatibility. Before the analytics were using either numbered
	        // metas in `metaDataAsNumber` of later on named metas in `metaDataAsString`. Thus we still
	        // provide those properties in a deprecated way. Below we are moving any data that put
	        // in them to the root.
	        metaObject['metaDataAsString'] = {};
	        metaObject['metaDataAsNumber'] = {};
	        var args = _.extend({}, {
	            type: type,
	            metaObject: metaObject,
	            actionType: event.actionType,
	            actionCause: event.actionCause
	        }, changeableAnalyticsDataObject);
	        Dom_1.$$(this.rootElement).trigger(AnalyticsEvents_1.AnalyticsEvents.changeAnalyticsCustomData, args);
	        event.language = args.language;
	        event.originLevel1 = args.originLevel1;
	        event.originLevel2 = args.originLevel2;
	        event.originLevel3 = args.originLevel3;
	        event.customData = metaObject;
	        // This is for backward compatibility. Before the analytics were using either numbered
	        // metas in `metaDataAsNumber` of later on named metas in `metaDataAsString`. We are now putting
	        // them all at the root, and if I encounter the older properties I move them to the top
	        // level after issuing a warning.
	        var metaDataAsString = event.customData['metaDataAsString'];
	        if (_.keys(metaDataAsString).length > 0) {
	            this.logger.warn('Using deprecated \'metaDataAsString\' key to log custom analytics data. Custom meta should now be put at the root of the object.');
	            _.extend(event.customData, metaDataAsString);
	        }
	        delete event.customData['metaDataAsString'];
	        var metaDataAsNumber = event.customData['metaDataAsNumber'];
	        if (_.keys(metaDataAsNumber).length > 0) {
	            this.logger.warn('Using deprecated \'metaDataAsNumber\' key to log custom analytics data. Custom meta should now be put at the root of the object.');
	            _.extend(event.customData, metaDataAsNumber);
	        }
	        delete event.customData['metaDataAsNumber'];
	    };
	    LiveAnalyticsClient.prototype.merge = function (first, second) {
	        return _.extend({}, first, second);
	    };
	    return LiveAnalyticsClient;
	}());
	exports.LiveAnalyticsClient = LiveAnalyticsClient;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var QueryEvents_1 = __webpack_require__(47);
	var Assert_1 = __webpack_require__(17);
	var Dom_1 = __webpack_require__(57);
	var SearchInterface_1 = __webpack_require__(97);
	var Component_1 = __webpack_require__(96);
	var QueryController_1 = __webpack_require__(74);
	var Defer_1 = __webpack_require__(31);
	var APIAnalyticsBuilder_1 = __webpack_require__(114);
	var AnalyticsEvents_1 = __webpack_require__(40);
	var AnalyticsActionListMeta_1 = __webpack_require__(110);
	var QueryStateModel_1 = __webpack_require__(90);
	var PendingSearchEvent = (function () {
	    function PendingSearchEvent(root, endpoint, templateSearchEvent, sendToCloud) {
	        var _this = this;
	        this.root = root;
	        this.endpoint = endpoint;
	        this.templateSearchEvent = templateSearchEvent;
	        this.sendToCloud = sendToCloud;
	        this.searchPromises = [];
	        this.results = [];
	        this.cancelled = false;
	        this.finished = false;
	        this.searchEvents = [];
	        Assert_1.Assert.exists(root);
	        Assert_1.Assert.exists(endpoint);
	        Assert_1.Assert.exists(templateSearchEvent);
	        this.handler = function (evt, arg) {
	            _this.handleDuringQuery(evt, arg);
	        };
	        Dom_1.$$(root).on(QueryEvents_1.QueryEvents.duringQuery, this.handler);
	    }
	    PendingSearchEvent.prototype.getEventCause = function () {
	        return this.templateSearchEvent.actionCause;
	    };
	    PendingSearchEvent.prototype.getEventMeta = function () {
	        return this.templateSearchEvent.customData;
	    };
	    PendingSearchEvent.prototype.cancel = function () {
	        this.stopRecording();
	        this.cancelled = true;
	    };
	    PendingSearchEvent.prototype.handleDuringQuery = function (evt, args) {
	        var _this = this;
	        Assert_1.Assert.check(!this.finished);
	        Assert_1.Assert.check(!this.cancelled);
	        // When synchronizing multiple search interfaces under a single search event
	        // (think Salesforce boxes), we need to collect all search events and send them
	        // in one single batch. So we gather all events until we idle out and then we
	        // monitor those before sending the data.
	        this.searchPromises.push(args.promise);
	        // TODO: Maybe a better way to grab the search interface?
	        var eventTarget;
	        eventTarget = evt.target;
	        var searchInterface = Component_1.Component.get(eventTarget, SearchInterface_1.SearchInterface);
	        Assert_1.Assert.exists(searchInterface);
	        // TODO: Maybe a better way to grab the query controller?
	        var queryController = Component_1.Component.get(eventTarget, QueryController_1.QueryController);
	        Assert_1.Assert.exists(queryController);
	        args.promise.then(function (queryResults) {
	            Assert_1.Assert.exists(queryResults);
	            Assert_1.Assert.check(!_this.finished);
	            if (queryResults._reusedSearchUid !== true || _this.templateSearchEvent.actionCause == AnalyticsActionListMeta_1.analyticsActionCauseList.recommendation.name) {
	                var searchEvent = _.extend({}, _this.templateSearchEvent);
	                _this.fillSearchEvent(searchEvent, searchInterface, args.query, queryResults);
	                _this.searchEvents.push(searchEvent);
	                _this.results.push(queryResults);
	                return queryResults;
	            }
	        }).finally(function () {
	            var index = _.indexOf(_this.searchPromises, args.promise);
	            _this.searchPromises.splice(index, 1);
	            if (_this.searchPromises.length == 0) {
	                _this.flush();
	            }
	        });
	    };
	    PendingSearchEvent.prototype.stopRecording = function () {
	        if (this.handler) {
	            Dom_1.$$(this.root).off(QueryEvents_1.QueryEvents.duringQuery, this.handler);
	            Dom_1.$$(this.root).off(QueryEvents_1.QueryEvents.duringFetchMoreQuery, this.handler);
	            this.handler = null;
	        }
	    };
	    PendingSearchEvent.prototype.flush = function () {
	        var _this = this;
	        if (!this.cancelled) {
	            this.stopRecording();
	            this.finished = true;
	            Assert_1.Assert.check(this.searchEvents.length == this.results.length);
	            Defer_1.Defer.defer(function () {
	                if (_this.sendToCloud) {
	                    _this.endpoint.sendSearchEvents(_this.searchEvents);
	                }
	                var apiSearchEvents = _.map(_this.searchEvents, function (searchEvent) {
	                    return APIAnalyticsBuilder_1.APIAnalyticsBuilder.convertSearchEventToAPI(searchEvent);
	                });
	                Dom_1.$$(_this.root).trigger(AnalyticsEvents_1.AnalyticsEvents.searchEvent, { searchEvents: apiSearchEvents });
	            });
	        }
	    };
	    PendingSearchEvent.prototype.fillSearchEvent = function (searchEvent, searchInterface, query, queryResults) {
	        Assert_1.Assert.exists(searchEvent);
	        Assert_1.Assert.exists(searchInterface);
	        Assert_1.Assert.exists(query);
	        Assert_1.Assert.exists(queryResults);
	        var currentQuery = searchInterface.queryStateModel.get(QueryStateModel_1.QueryStateModel.attributesEnum.q);
	        searchEvent.queryPipeline = queryResults.pipeline;
	        searchEvent.splitTestRunName = searchEvent.splitTestRunName || queryResults.splitTestRun;
	        searchEvent.splitTestRunVersion = searchEvent.splitTestRunVersion || (queryResults.splitTestRun != undefined ? queryResults.pipeline : undefined);
	        searchEvent.originLevel2 = searchEvent.originLevel2 || searchInterface.queryStateModel.get('t') || 'default';
	        searchEvent.queryText = currentQuery || query.q || ''; // do not log the query sent to the server if possible; it may contain added syntax depending on options
	        searchEvent.advancedQuery = query.aq || '';
	        searchEvent.didYouMean = query.enableDidYouMean;
	        searchEvent.numberOfResults = queryResults.totalCount;
	        searchEvent.responseTime = queryResults.duration;
	        searchEvent.pageNumber = (query.firstResult / query.numberOfResults);
	        searchEvent.resultsPerPage = query.numberOfResults;
	        searchEvent.searchQueryUid = queryResults.searchUid;
	        searchEvent.queryPipeline = queryResults.pipeline;
	        // The context_${key} format is important for the Analytics backend
	        // This is what they use to recognize a custom data that will be used internally by other coveo's service.
	        // In this case, Reveal will be the consumer of this information.
	        if (query.context != undefined) {
	            _.each(query.context, function (value, key) {
	                searchEvent.customData[("context_" + key)] = value;
	            });
	        }
	    };
	    return PendingSearchEvent;
	}());
	exports.PendingSearchEvent = PendingSearchEvent;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 114 */
/***/ function(module, exports) {

	"use strict";
	var APIAnalyticsBuilder = (function () {
	    function APIAnalyticsBuilder() {
	    }
	    APIAnalyticsBuilder.convertSearchEventToAPI = function (searchEvent) {
	        var apiSearchEvent = {
	            advancedQuery: searchEvent.advancedQuery,
	            customMetadatas: searchEvent.customData,
	            device: searchEvent.device,
	            didYouMean: searchEvent.didYouMean,
	            language: searchEvent.language,
	            pageNumber: searchEvent.pageNumber,
	            queryText: searchEvent.queryText,
	            responseTime: searchEvent.responseTime,
	            numberOfResults: searchEvent.numberOfResults,
	            resultsPerPage: searchEvent.resultsPerPage,
	            searchHub: searchEvent.originLevel1,
	            searchInterface: searchEvent.originLevel2,
	            searchQueryUid: searchEvent.searchQueryUid,
	            type: searchEvent.actionType,
	            actionCause: searchEvent.actionCause,
	            queryPipeline: searchEvent.queryPipeline,
	            splitTestRunName: searchEvent.splitTestRunName,
	            splitTestRunVersion: searchEvent.splitTestRunVersion
	        };
	        return apiSearchEvent;
	    };
	    APIAnalyticsBuilder.convertDocumentViewToAPI = function (documentView) {
	        var apiDocumentView = {
	            collectionName: documentView.collectionName,
	            device: documentView.device,
	            documentPosition: documentView.documentPosition,
	            title: documentView.documentTitle,
	            documentUrl: documentView.documentUrl,
	            documentUri: documentView.documentUri,
	            documentUriHash: documentView.documentUriHash,
	            language: documentView.language,
	            responseTime: documentView.responseTime,
	            searchHub: documentView.originLevel1,
	            searchInterface: documentView.originLevel2,
	            searchQueryUid: documentView.searchQueryUid,
	            sourceName: documentView.sourceName,
	            viewMethod: documentView.viewMethod,
	            customMetadatas: documentView.customData,
	            actionCause: documentView.actionCause,
	            queryPipeline: documentView.queryPipeline,
	            splitTestRunName: documentView.splitTestRunName,
	            splitTestRunVersion: documentView.splitTestRunVersion
	        };
	        return apiDocumentView;
	    };
	    APIAnalyticsBuilder.convertCustomEventToAPI = function (customEvent) {
	        var apiCustomEvent = {
	            actionCause: customEvent.actionCause,
	            actionType: customEvent.actionType,
	            device: customEvent.device,
	            language: customEvent.language,
	            responseTime: customEvent.responseTime,
	            searchHub: customEvent.originLevel1,
	            searchInterface: customEvent.originLevel2,
	            customMetadatas: customEvent.customData
	        };
	        return apiCustomEvent;
	    };
	    return APIAnalyticsBuilder;
	}());
	exports.APIAnalyticsBuilder = APIAnalyticsBuilder;


/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PendingSearchEvent_1 = __webpack_require__(113);
	var Dom_1 = __webpack_require__(57);
	var InitializationEvents_1 = __webpack_require__(44);
	var _ = __webpack_require__(13);
	var PendingSearchAsYouTypeSearchEvent = (function (_super) {
	    __extends(PendingSearchAsYouTypeSearchEvent, _super);
	    function PendingSearchAsYouTypeSearchEvent(root, endpoint, templateSearchEvent, sendToCloud) {
	        var _this = this;
	        _super.call(this, root, endpoint, templateSearchEvent, sendToCloud);
	        this.root = root;
	        this.endpoint = endpoint;
	        this.templateSearchEvent = templateSearchEvent;
	        this.sendToCloud = sendToCloud;
	        this.delayBeforeSending = 5000;
	        this.armBatchDelay = 50;
	        this.beforeUnloadHandler = function () {
	            _this.onWindowUnload();
	        };
	        window.addEventListener('beforeunload', this.beforeUnloadHandler);
	        Dom_1.$$(root).on(InitializationEvents_1.InitializationEvents.nuke, function () { return _this.handleNuke(); });
	    }
	    PendingSearchAsYouTypeSearchEvent.prototype.handleDuringQuery = function (e, args) {
	        var _this = this;
	        var event = _.clone(e);
	        this.beforeResolve = new Promise(function (resolve) {
	            _this.toSendRightNow = function () {
	                if (!_this.isCancelledOrFinished()) {
	                    resolve(_this);
	                    _super.prototype.handleDuringQuery.call(_this, event, args);
	                }
	            };
	            _.delay(function () {
	                _this.toSendRightNow();
	            }, _this.delayBeforeSending);
	        });
	    };
	    PendingSearchAsYouTypeSearchEvent.prototype.sendRightNow = function () {
	        if (this.toSendRightNow) {
	            this.toSendRightNow();
	        }
	    };
	    PendingSearchAsYouTypeSearchEvent.prototype.modifyCustomData = function (key, newData) {
	        _.each(this.searchEvents, function (searchEvent) {
	            searchEvent.customData[key] = newData;
	        });
	        if (!this.templateSearchEvent.customData) {
	            this.templateSearchEvent.customData = {};
	        }
	        this.templateSearchEvent.customData[key] = newData;
	    };
	    PendingSearchAsYouTypeSearchEvent.prototype.modifyEventCause = function (newCause) {
	        _.each(this.searchEvents, function (searchEvent) {
	            searchEvent.actionCause = newCause.name;
	            searchEvent.actionType = newCause.type;
	        });
	        this.templateSearchEvent.actionCause = newCause.name;
	        this.templateSearchEvent.actionType = newCause.type;
	    };
	    PendingSearchAsYouTypeSearchEvent.prototype.stopRecording = function () {
	        _super.prototype.stopRecording.call(this);
	        if (this.beforeUnloadHandler) {
	            window.removeEventListener('beforeunload', this.beforeUnloadHandler);
	            this.beforeUnloadHandler = undefined;
	        }
	    };
	    PendingSearchAsYouTypeSearchEvent.prototype.handleNuke = function () {
	        window.removeEventListener('beforeunload', this.beforeUnloadHandler);
	    };
	    PendingSearchAsYouTypeSearchEvent.prototype.onWindowUnload = function () {
	        if (!this.isCancelledOrFinished()) {
	            this.armBatchDelay = 0;
	            this.sendRightNow();
	        }
	    };
	    PendingSearchAsYouTypeSearchEvent.prototype.isCancelledOrFinished = function () {
	        if (!this.cancelled) {
	            if (this.finished) {
	                this.cancel();
	                return true;
	            }
	            else {
	                return false;
	            }
	        }
	        else {
	            return true;
	        }
	    };
	    return PendingSearchAsYouTypeSearchEvent;
	}(PendingSearchEvent_1.PendingSearchEvent));
	exports.PendingSearchAsYouTypeSearchEvent = PendingSearchAsYouTypeSearchEvent;


/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var MultiAnalyticsClient = (function () {
	    function MultiAnalyticsClient(analyticsClients) {
	        if (analyticsClients === void 0) { analyticsClients = []; }
	        this.analyticsClients = analyticsClients;
	        this.isContextual = false;
	    }
	    MultiAnalyticsClient.prototype.isActivated = function () {
	        return _.some(this.analyticsClients, function (analyticsClient) { return analyticsClient.isActivated(); });
	    };
	    MultiAnalyticsClient.prototype.getCurrentEventCause = function () {
	        return _.find(_.map(this.analyticsClients, function (analyticsClient) { return analyticsClient.getCurrentEventCause(); }), function (currentEventCause) { return currentEventCause != null; });
	    };
	    MultiAnalyticsClient.prototype.getCurrentEventMeta = function () {
	        return _.find(_.map(this.analyticsClients, function (analyticsClient) { return analyticsClient.getCurrentEventMeta(); }), function (currentEventMeta) { return currentEventMeta != null; });
	    };
	    MultiAnalyticsClient.prototype.logSearchEvent = function (actionCause, meta) {
	        _.each(this.analyticsClients, function (analyticsClient) { return analyticsClient.logSearchEvent(actionCause, meta); });
	    };
	    MultiAnalyticsClient.prototype.logSearchAsYouType = function (actionCause, meta) {
	        _.each(this.analyticsClients, function (analyticsClient) { return analyticsClient.logSearchEvent(actionCause, meta); });
	    };
	    MultiAnalyticsClient.prototype.logClickEvent = function (actionCause, meta, result, element) {
	        _.each(this.analyticsClients, function (analyticsClient) { return analyticsClient.logClickEvent(actionCause, meta, result, element); });
	    };
	    MultiAnalyticsClient.prototype.logCustomEvent = function (actionCause, meta, element) {
	        _.each(this.analyticsClients, function (analyticsClient) { return analyticsClient.logCustomEvent(actionCause, meta, element); });
	    };
	    MultiAnalyticsClient.prototype.getTopQueries = function (params) {
	        var _this = this;
	        return Promise.all(_.map(this.analyticsClients, function (client) {
	            return client.getTopQueries(params);
	        }))
	            .then(function (values) {
	            return _this.mergeTopQueries(values, params.pageSize);
	        });
	    };
	    MultiAnalyticsClient.prototype.getCurrentVisitIdPromise = function () {
	        return _.first(this.analyticsClients).getCurrentVisitIdPromise();
	    };
	    MultiAnalyticsClient.prototype.getCurrentVisitId = function () {
	        return _.first(this.analyticsClients).getCurrentVisitId();
	    };
	    MultiAnalyticsClient.prototype.sendAllPendingEvents = function () {
	        _.each(this.analyticsClients, function (analyticsClient) { return analyticsClient.sendAllPendingEvents(); });
	    };
	    MultiAnalyticsClient.prototype.warnAboutSearchEvent = function () {
	        _.each(this.analyticsClients, function (analyticsClient) { return analyticsClient.warnAboutSearchEvent(); });
	    };
	    MultiAnalyticsClient.prototype.cancelAllPendingEvents = function () {
	        _.each(this.analyticsClients, function (analyticsClient) { return analyticsClient.cancelAllPendingEvents(); });
	    };
	    MultiAnalyticsClient.prototype.getPendingSearchEvent = function () {
	        return _.first(this.analyticsClients).getPendingSearchEvent();
	    };
	    MultiAnalyticsClient.prototype.mergeTopQueries = function (values, pageSize) {
	        if (pageSize === void 0) { pageSize = 5; }
	        return _.chain(values)
	            .flatten()
	            .first(pageSize)
	            .value();
	    };
	    return MultiAnalyticsClient;
	}());
	exports.MultiAnalyticsClient = MultiAnalyticsClient;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var SearchInterface_1 = __webpack_require__(97);
	var ComponentOptions_1 = __webpack_require__(98);
	var QueryEvents_1 = __webpack_require__(47);
	var OmniboxEvents_1 = __webpack_require__(45);
	var ResultListEvents_1 = __webpack_require__(48);
	var SettingsEvents_1 = __webpack_require__(50);
	var PreferencesPanelEvents_1 = __webpack_require__(46);
	var AnalyticsEvents_1 = __webpack_require__(40);
	var AnalyticsActionListMeta_1 = __webpack_require__(110);
	var BreadcrumbEvents_1 = __webpack_require__(41);
	var QuickviewEvents_1 = __webpack_require__(118);
	var QueryStateModel_1 = __webpack_require__(90);
	var Model_1 = __webpack_require__(87);
	var Utils_1 = __webpack_require__(18);
	var Dom_1 = __webpack_require__(57);
	/**
	 * This component is a {@link SearchInterface} that will display recommendations based on the user history.
	 * To get recommendations, the page view script must also be included in the page. View: https://github.com/coveo/coveo.analytics.js
	 * This component listens when the main search interface generates a query and it generates another to get the recommendations at the same time.
	 *
	 * This component can be included in another SearchInterface, but you need to initialize the recommendation component with Coveo('initRecommendation'), before
	 * the parent SearchInterface.
	 */
	var Recommendation = (function (_super) {
	    __extends(Recommendation, _super);
	    function Recommendation(element, options, analyticsOptions, _window) {
	        var _this = this;
	        if (options === void 0) { options = {}; }
	        if (analyticsOptions === void 0) { analyticsOptions = {}; }
	        if (_window === void 0) { _window = window; }
	        _super.call(this, element, ComponentOptions_1.ComponentOptions.initComponentOptions(element, Recommendation, options), analyticsOptions, _window);
	        this.element = element;
	        this.options = options;
	        this.analyticsOptions = analyticsOptions;
	        if (!this.options.id) {
	            this.generateDefaultId();
	        }
	        if (this.options.mainSearchInterface) {
	            this.bindToMainSearchInterface();
	        }
	        Dom_1.$$(this.element).on(QueryEvents_1.QueryEvents.buildingQuery, function (e, args) { return _this.handleRecommendationBuildingQuery(args); });
	        Dom_1.$$(this.element).on(QueryEvents_1.QueryEvents.querySuccess, function (e, args) { return _this.handleRecommendationQuerySuccess(args); });
	        Dom_1.$$(this.element).on(QueryEvents_1.QueryEvents.noResults, function (e, args) {
	            if (_this.options.hideIfNoResults) {
	                _this.hide();
	            }
	        });
	        Dom_1.$$(this.element).on(QueryEvents_1.QueryEvents.queryError, function (e, args) { return _this.hide(); });
	        // This is done to allow the component to be included in another search interface without triggering the parent events.
	        this.preventEventPropagation();
	    }
	    Recommendation.prototype.getId = function () {
	        return this.options.id;
	    };
	    Recommendation.prototype.hide = function () {
	        this.displayStyle = this.element.style.display;
	        Dom_1.$$(this.element).hide();
	    };
	    Recommendation.prototype.show = function () {
	        if (!this.displayStyle) {
	            this.displayStyle = this.element.style.display;
	        }
	        this.element.style.display = this.displayStyle;
	    };
	    Recommendation.prototype.bindToMainSearchInterface = function () {
	        var _this = this;
	        Dom_1.$$(this.options.mainSearchInterface).on(QueryEvents_1.QueryEvents.querySuccess, function (e, args) {
	            _this.mainInterfaceQuery = args;
	            _this.mainQuerySearchUID = args.results.searchUid;
	            _this.usageAnalytics.logSearchEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.recommendation, {});
	            _this.queryController.executeQuery();
	        });
	    };
	    Recommendation.prototype.handleRecommendationBuildingQuery = function (data) {
	        this.modifyQueryForRecommendation(data);
	        this.addRecommendationInfoInQuery(data);
	    };
	    Recommendation.prototype.handleRecommendationQuerySuccess = function (data) {
	        if (this.options.hideIfNoResults) {
	            if (data.results.totalCount === 0) {
	                this.hide();
	            }
	            else {
	                this.show();
	            }
	        }
	    };
	    Recommendation.prototype.modifyQueryForRecommendation = function (data) {
	        if (this.mainInterfaceQuery) {
	            Utils_1.Utils.copyObjectAttributes(data.queryBuilder, this.mainInterfaceQuery.queryBuilder, this.options.optionsToUse);
	        }
	    };
	    Recommendation.prototype.addRecommendationInfoInQuery = function (data) {
	        if (!_.isEmpty(this.options.userContext)) {
	            data.queryBuilder.addContext(JSON.parse(this.options.userContext));
	        }
	        if (this.options.sendActionsHistory) {
	            data.queryBuilder.actionsHistory = this.getHistory();
	        }
	        data.queryBuilder.recommendation = this.options.id;
	    };
	    Recommendation.prototype.getHistory = function () {
	        if (typeof coveoanalytics != 'undefined') {
	            var store = new coveoanalytics.history.HistoryStore();
	            return JSON.stringify(store.getHistory());
	        }
	        else {
	            return '[]';
	        }
	    };
	    Recommendation.prototype.preventEventPropagation = function () {
	        this.preventEventPropagationOn(QueryEvents_1.QueryEvents);
	        this.preventEventPropagationOn(OmniboxEvents_1.OmniboxEvents);
	        this.preventEventPropagationOn(ResultListEvents_1.ResultListEvents);
	        this.preventEventPropagationOn(SettingsEvents_1.SettingsEvents);
	        this.preventEventPropagationOn(PreferencesPanelEvents_1.PreferencesPanelEvents);
	        this.preventEventPropagationOn(AnalyticsEvents_1.AnalyticsEvents);
	        this.preventEventPropagationOn(BreadcrumbEvents_1.BreadcrumbEvents);
	        this.preventEventPropagationOn(QuickviewEvents_1.QuickviewEvents);
	        this.preventEventPropagationOn(this.getAllModelEvents());
	    };
	    Recommendation.prototype.preventEventPropagationOn = function (eventType, eventName) {
	        if (eventName === void 0) { eventName = function (event) { return event; }; }
	        for (var event_1 in eventType) {
	            Dom_1.$$(this.root).on(eventName(event_1), function (e) { return e.stopPropagation(); });
	        }
	    };
	    Recommendation.prototype.getAllModelEvents = function () {
	        var _this = this;
	        var events = {};
	        _.each(_.values(Model_1.Model.eventTypes), function (event) {
	            _.each(_.values(QueryStateModel_1.QUERY_STATE_ATTRIBUTES), function (attribute) {
	                var eventName = _this.getBindings().queryStateModel.getEventName(event + attribute);
	                events[eventName] = eventName;
	            });
	        });
	        return events;
	    };
	    Recommendation.prototype.generateDefaultId = function () {
	        var id = 'Recommendation';
	        if (Recommendation.NEXT_ID !== 1) {
	            this.logger.warn('Generating another recommendation default id', 'Consider configuring a human friendly / meaningful id for this interface');
	            id = id + '_' + Recommendation.NEXT_ID;
	        }
	        Recommendation.NEXT_ID++;
	        this.options.id = id;
	    };
	    Recommendation.ID = 'Recommendation';
	    Recommendation.NEXT_ID = 1;
	    /**
	     * The options for the recommendation component
	     * @componentOptions
	     */
	    Recommendation.options = {
	        /**
	         * Specifies the main {@link SearchInterface} to listen to.
	         */
	        mainSearchInterface: ComponentOptions_1.ComponentOptions.buildSelectorOption(),
	        /**
	         * Specifies the user context to send to Coveo analytics.
	         * It will be sent with the query alongside the user history to get the recommendations.
	         */
	        userContext: ComponentOptions_1.ComponentOptions.buildJsonOption(),
	        /**
	         * Specifies the id of the interface.
	         * It is used by the analytics to know which recommendation interface was selected.
	         * The default value is "Recommendation" for the first one and "Recommendation_{number}" where {number} depends on the number of recommendation interface with default ids in the page for the others.
	         */
	        id: ComponentOptions_1.ComponentOptions.buildStringOption(),
	        /**
	         * Specifies which options from the main {@link QueryBuilder} to use in the triggered query.
	         * Ex: <code data-options-to-use="expression, advancedExpression"></code> would add the expression and the advanced expression parts from the main query in the triggered query.
	         * The default value is undefined.
	         */
	        optionsToUse: ComponentOptions_1.ComponentOptions.buildListOption({ defaultValue: ['expression'] }),
	        /**
	         * Specifies whether or not to send the actions history along with the triggered query.
	         * Disabling this option means this component won't be able to get Reveal recommendations.
	         * However, it could be useful to display side results in a search page.
	         * The default value is true.
	         */
	        sendActionsHistory: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true }),
	        /**
	         * Hides the component if there a no results / recommendations.
	         * The default value is false.
	         */
	        hideIfNoResults: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true })
	    };
	    return Recommendation;
	}(SearchInterface_1.SearchInterface));
	exports.Recommendation = Recommendation;
	// We do not register the Recommendation component since it is done with .coveo('initRecommendation')
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 118 */
/***/ function(module, exports) {

	"use strict";
	var QuickviewEvents = (function () {
	    function QuickviewEvents() {
	    }
	    QuickviewEvents.quickviewLoaded = 'quickviewLoaded';
	    QuickviewEvents.openQuickview = 'openQuickview';
	    return QuickviewEvents;
	}());
	exports.QuickviewEvents = QuickviewEvents;


/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var LiveAnalyticsClient_1 = __webpack_require__(112);
	var AnalyticsActionListMeta_1 = __webpack_require__(110);
	var Component_1 = __webpack_require__(96);
	var SearchInterface_1 = __webpack_require__(97);
	var RecommendationAnalyticsClient = (function (_super) {
	    __extends(RecommendationAnalyticsClient, _super);
	    function RecommendationAnalyticsClient(endpoint, rootElement, userId, userDisplayName, anonymous, splitTestRunName, splitTestRunVersion, originLevel1, sendToCloud, bindings) {
	        _super.call(this, endpoint, rootElement, userId, userDisplayName, anonymous, splitTestRunName, splitTestRunVersion, originLevel1, sendToCloud);
	        this.endpoint = endpoint;
	        this.rootElement = rootElement;
	        this.userId = userId;
	        this.userDisplayName = userDisplayName;
	        this.anonymous = anonymous;
	        this.splitTestRunName = splitTestRunName;
	        this.splitTestRunVersion = splitTestRunVersion;
	        this.originLevel1 = originLevel1;
	        this.sendToCloud = sendToCloud;
	        this.bindings = bindings;
	        this.recommendation = this.bindings.searchInterface;
	    }
	    RecommendationAnalyticsClient.prototype.logSearchEvent = function (actionCause, meta) {
	        if (actionCause == AnalyticsActionListMeta_1.analyticsActionCauseList.interfaceLoad) {
	            actionCause = AnalyticsActionListMeta_1.analyticsActionCauseList.recommendationInterfaceLoad;
	        }
	        _super.prototype.logSearchEvent.call(this, actionCause, meta);
	    };
	    RecommendationAnalyticsClient.prototype.logClickEvent = function (actionCause, meta, result, element) {
	        if (actionCause == AnalyticsActionListMeta_1.analyticsActionCauseList.documentOpen) {
	            actionCause = AnalyticsActionListMeta_1.analyticsActionCauseList.recommendationOpen;
	        }
	        _super.prototype.logClickEvent.call(this, actionCause, meta, result, element);
	        if (this.recommendation.mainQuerySearchUID) {
	            // We log a second click associated with the main interface query to tell the analytics that the query was a success.
	            var mainInterface = Component_1.Component.get(this.recommendation.options.mainSearchInterface, SearchInterface_1.SearchInterface);
	            result.queryUid = this.recommendation.mainQuerySearchUID;
	            mainInterface.usageAnalytics.logClickEvent(actionCause, meta, result, element);
	        }
	    };
	    RecommendationAnalyticsClient.prototype.getOriginLevel2 = function (element) {
	        return this.recommendation.getId();
	    };
	    return RecommendationAnalyticsClient;
	}(LiveAnalyticsClient_1.LiveAnalyticsClient));
	exports.RecommendationAnalyticsClient = RecommendationAnalyticsClient;


/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var Initialization_1 = __webpack_require__(95);
	if (!initCoveoJQuery()) {
	    // Adding a check in case jQuery was added after the jsSearch
	    // Since this event listener is registered before the Coveo.init call, JQuery should always be initiated before the Coveo.init call  
	    document.addEventListener('DOMContentLoaded', function () {
	        initCoveoJQuery();
	    });
	}
	function initCoveoJQuery() {
	    if (!jQueryIsDefined()) {
	        return false;
	    }
	    exports.jQueryInstance = getJQuery();
	    if (window['Coveo'] == undefined) {
	        window['Coveo'] = {};
	    }
	    if (window['Coveo']['$'] == undefined) {
	        window['Coveo']['$'] = exports.jQueryInstance;
	    }
	    exports.jQueryInstance.fn.coveo = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i - 0] = arguments[_i];
	        }
	        var returnValue;
	        this.each(function (index, element) {
	            var returnValueForThisElement;
	            if (_.isString(args[0])) {
	                var token = args[0];
	                returnValueForThisElement = Initialization_1.Initialization.dispatchNamedMethodCallOrComponentCreation(token, element, args.slice(1));
	            }
	            else {
	                // Invoking with no method name is a shortcut for the 'get' method (from Component).
	                returnValueForThisElement = Initialization_1.Initialization.dispatchNamedMethodCall('get', element, args);
	            }
	            // Keep only the first return value we encounter
	            returnValue = returnValue || returnValueForThisElement;
	        });
	        return returnValue;
	    };
	    return true;
	}
	exports.initCoveoJQuery = initCoveoJQuery;
	function jQueryIsDefined() {
	    return jQueryDefinedOnWindow() || jQueryDefinedOnCoveoObject();
	}
	exports.jQueryIsDefined = jQueryIsDefined;
	function jQueryDefinedOnCoveoObject() {
	    return window['Coveo'] != undefined && window['Coveo']['$'] != undefined;
	}
	function jQueryDefinedOnWindow() {
	    return window['$'] != undefined && window['$'].fn != undefined && window['$'].fn.jquery != undefined;
	}
	function getJQuery() {
	    var jQueryInstance;
	    if (window['$']) {
	        jQueryInstance = window['$'];
	    }
	    else {
	        jQueryInstance = window['Coveo']['$'];
	    }
	    return jQueryInstance;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var TemplateHelpers_1 = __webpack_require__(122);
	exports.TemplateHelpers = TemplateHelpers_1.TemplateHelpers;
	var TemplateCache_1 = __webpack_require__(99);
	exports.TemplateCache = TemplateCache_1.TemplateCache;
	var HtmlTemplate_1 = __webpack_require__(102);
	exports.HtmlTemplate = HtmlTemplate_1.HtmlTemplate;
	var UnderscoreTemplate_1 = __webpack_require__(101);
	exports.UnderscoreTemplate = UnderscoreTemplate_1.UnderscoreTemplate;


/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var Assert_1 = __webpack_require__(17);
	var UnderscoreTemplate_1 = __webpack_require__(101);
	var Utils_1 = __webpack_require__(18);
	/**
	 * Allow to register and return template helpers (essentially: Utility functions that can be executed in the context of a template to render complex elements).
	 */
	var TemplateHelpers = (function () {
	    function TemplateHelpers() {
	    }
	    TemplateHelpers.registerFieldHelper = function (name, helper) {
	        TemplateHelpers.fieldHelpers.push(name);
	        TemplateHelpers.registerTemplateHelper(name, helper);
	    };
	    /**
	     * Register a new helper in the framework, that will be available inside all templates execution context.
	     * @param name
	     * @param helper
	     */
	    TemplateHelpers.registerTemplateHelper = function (name, helper) {
	        Assert_1.Assert.isNonEmptyString(name);
	        Assert_1.Assert.exists(helper);
	        TemplateHelpers.registerTemplateHelperInUnderscore(name, helper);
	        TemplateHelpers.helpers[name] = helper;
	    };
	    /**
	     * Return a template helper function
	     * @param name
	     * @returns {any}
	     */
	    TemplateHelpers.getHelper = function (name) {
	        return Utils_1.Utils.getCaseInsensitiveProperty(TemplateHelpers.helpers, name);
	    };
	    /**
	     * Get all available helpers
	     * @returns {{}}
	     */
	    TemplateHelpers.getHelpers = function () {
	        return TemplateHelpers.helpers;
	    };
	    TemplateHelpers.registerTemplateHelperInUnderscore = function (name, helper) {
	        Assert_1.Assert.isNonEmptyString(name);
	        Assert_1.Assert.exists(helper);
	        UnderscoreTemplate_1.UnderscoreTemplate.registerTemplateHelper(name, helper);
	    };
	    TemplateHelpers.helpers = {};
	    TemplateHelpers.fieldHelpers = [];
	    return TemplateHelpers;
	}());
	exports.TemplateHelpers = TemplateHelpers;


/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var TemplateHelpers_1 = __webpack_require__(122);
	var ComponentOptions_1 = __webpack_require__(98);
	var HighlightUtils_1 = __webpack_require__(66);
	var DateUtils_1 = __webpack_require__(56);
	var CurrencyUtils_1 = __webpack_require__(55);
	var HtmlUtils_1 = __webpack_require__(67);
	var Icon_1 = __webpack_require__(124);
	var Utils_1 = __webpack_require__(18);
	var StringUtils_1 = __webpack_require__(61);
	var TimeSpanUtils_1 = __webpack_require__(19);
	var EmailUtils_1 = __webpack_require__(63);
	var QueryUtils_1 = __webpack_require__(23);
	var DeviceUtils_1 = __webpack_require__(20);
	var TemplateCache_1 = __webpack_require__(99);
	var Dom_1 = __webpack_require__(57);
	var SearchEndpoint_1 = __webpack_require__(12);
	var ResultList_1 = __webpack_require__(128);
	var StreamHighlightUtils_1 = __webpack_require__(72);
	var Globalize = __webpack_require__(4);
	var Quickview_1 = __webpack_require__(125);
	var CoreHelpers = (function () {
	    function CoreHelpers() {
	    }
	    /**
	     * For backward compatibility reason, the "global" template helper should be available under the
	     * coveo namespace.
	     * @param scope
	     */
	    CoreHelpers.exportAllHelpersGlobally = function (scope) {
	        _.each(TemplateHelpers_1.TemplateHelpers.getHelpers(), function (helper, name) {
	            if (scope[name] == undefined) {
	                scope[name] = helper;
	            }
	        });
	    };
	    return CoreHelpers;
	}());
	exports.CoreHelpers = CoreHelpers;
	TemplateHelpers_1.TemplateHelpers.registerFieldHelper('javascriptEncode', function (value) {
	    return Utils_1.Utils.exists(value) ? StringUtils_1.StringUtils.javascriptEncode(value) : undefined;
	});
	TemplateHelpers_1.TemplateHelpers.registerTemplateHelper('shorten', function (content, length, highlights, cssClass) {
	    var strAndHoles = HighlightUtils_1.StringAndHoles.shortenString(content, length, '...');
	    if (Utils_1.Utils.exists(highlights)) {
	        return HighlightUtils_1.HighlightUtils.highlightString(strAndHoles.value, highlights, strAndHoles.holes, cssClass || 'highlight');
	    }
	    else {
	        return strAndHoles.value;
	    }
	});
	TemplateHelpers_1.TemplateHelpers.registerTemplateHelper('shortenPath', function (content, length, highlights, cssClass) {
	    var strAndHoles = HighlightUtils_1.StringAndHoles.shortenPath(content, length);
	    if (Utils_1.Utils.exists(highlights)) {
	        return HighlightUtils_1.HighlightUtils.highlightString(strAndHoles.value, highlights, strAndHoles.holes, cssClass || 'highlight');
	    }
	    else {
	        return strAndHoles.value;
	    }
	});
	TemplateHelpers_1.TemplateHelpers.registerTemplateHelper('shortenUri', function (content, length, highlights, cssClass) {
	    var strAndHoles = HighlightUtils_1.StringAndHoles.shortenUri(content, length);
	    if (Utils_1.Utils.exists(highlights)) {
	        return HighlightUtils_1.HighlightUtils.highlightString(strAndHoles.value, highlights, strAndHoles.holes, cssClass || 'highlight');
	    }
	    else {
	        return strAndHoles.value;
	    }
	});
	TemplateHelpers_1.TemplateHelpers.registerTemplateHelper('highlight', function (content, highlights, cssClass) {
	    if (Utils_1.Utils.exists(content)) {
	        if (Utils_1.Utils.exists(highlights)) {
	            return HighlightUtils_1.HighlightUtils.highlightString(content, highlights, null, cssClass || 'highlight');
	        }
	        else {
	            return content;
	        }
	    }
	    else {
	        return undefined;
	    }
	});
	TemplateHelpers_1.TemplateHelpers.registerTemplateHelper('highlightStreamText', function (content, termsToHighlight, phrasesToHighlight, opts) {
	    if (termsToHighlight === void 0) { termsToHighlight = resolveTermsToHighlight(); }
	    if (phrasesToHighlight === void 0) { phrasesToHighlight = resolvePhrasesToHighlight(); }
	    if (Utils_1.Utils.exists(content) && Utils_1.Utils.exists(termsToHighlight) && Utils_1.Utils.exists(phrasesToHighlight)) {
	        if (Utils_1.Utils.isNonEmptyArray(_.keys(termsToHighlight)) || Utils_1.Utils.isNonEmptyArray(_.keys(phrasesToHighlight))) {
	            return StreamHighlightUtils_1.StreamHighlightUtils.highlightStreamText(content, termsToHighlight, phrasesToHighlight, opts);
	        }
	        else {
	            return content;
	        }
	    }
	    else {
	        return undefined;
	    }
	});
	TemplateHelpers_1.TemplateHelpers.registerTemplateHelper('highlightStreamHTML', function (content, termsToHighlight, phrasesToHighlight, opts) {
	    if (termsToHighlight === void 0) { termsToHighlight = resolveTermsToHighlight(); }
	    if (phrasesToHighlight === void 0) { phrasesToHighlight = resolvePhrasesToHighlight(); }
	    if (Utils_1.Utils.exists(content) && Utils_1.Utils.exists(termsToHighlight) && Utils_1.Utils.exists(phrasesToHighlight)) {
	        if (Utils_1.Utils.isNonEmptyArray(termsToHighlight)) {
	            return StreamHighlightUtils_1.StreamHighlightUtils.highlightStreamHTML(content, termsToHighlight, phrasesToHighlight, opts);
	        }
	        else {
	            return content;
	        }
	    }
	    else {
	        return undefined;
	    }
	});
	TemplateHelpers_1.TemplateHelpers.registerFieldHelper('number', function (value, options) {
	    var numberValue = Number(value);
	    if (Utils_1.Utils.exists(value)) {
	        if (_.isString(options)) {
	            return StringUtils_1.StringUtils.htmlEncode(Globalize.format(numberValue, options));
	        }
	        else {
	            return StringUtils_1.StringUtils.htmlEncode(numberValue.toString());
	        }
	    }
	    else {
	        return undefined;
	    }
	});
	TemplateHelpers_1.TemplateHelpers.registerFieldHelper('date', function (value, options) {
	    return DateUtils_1.DateUtils.dateToString(DateUtils_1.DateUtils.convertFromJsonDateIfNeeded(value), options);
	});
	TemplateHelpers_1.TemplateHelpers.registerFieldHelper('time', function (value, options) {
	    return DateUtils_1.DateUtils.timeToString(DateUtils_1.DateUtils.convertFromJsonDateIfNeeded(value), options);
	});
	TemplateHelpers_1.TemplateHelpers.registerFieldHelper('dateTime', function (value, options) {
	    return DateUtils_1.DateUtils.dateTimeToString(DateUtils_1.DateUtils.convertFromJsonDateIfNeeded(value), options);
	});
	TemplateHelpers_1.TemplateHelpers.registerFieldHelper('emailDateTime', function (value, options) {
	    var defaultOptions = {};
	    defaultOptions.includeTimeIfThisWeek = true;
	    var optionsToUse = _.extend(options, defaultOptions);
	    return value ? DateUtils_1.DateUtils.dateTimeToString(DateUtils_1.DateUtils.convertFromJsonDateIfNeeded(value), optionsToUse) : undefined;
	});
	TemplateHelpers_1.TemplateHelpers.registerFieldHelper('currency', function (value, options) {
	    return CurrencyUtils_1.CurrencyUtils.currencyToString(value, options);
	});
	TemplateHelpers_1.TemplateHelpers.registerFieldHelper('timeSpan', function (value, options) {
	    if (options === void 0) { options = { isMilliseconds: false }; }
	    return new TimeSpanUtils_1.TimeSpan(value, options.isMilliseconds).getHHMMSS();
	});
	TemplateHelpers_1.TemplateHelpers.registerFieldHelper('email', function (value) {
	    var args = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        args[_i - 1] = arguments[_i];
	    }
	    // support old arguments (value: any, companyDomain: string, me: string, lengthLimit = 2, truncateName = false)
	    var companyDomain;
	    var me;
	    var lengthLimit;
	    var truncateName;
	    if (_.isObject(args[0])) {
	        companyDomain = args[0]['companyDomain'];
	        me = args[0]['me'];
	        lengthLimit = args[0]['lengthLimit'];
	        truncateName = args[0]['truncateName'];
	    }
	    else {
	        companyDomain = args[0];
	        me = args[1];
	        lengthLimit = args[2];
	        truncateName = args[3];
	    }
	    if (lengthLimit == undefined) {
	        lengthLimit = 2;
	    }
	    if (truncateName == undefined) {
	        truncateName = false;
	    }
	    if (_.isString(value)) {
	        var listOfAddresses = EmailUtils_1.EmailUtils.splitSemicolonSeparatedListOfEmailAddresses(value);
	        return EmailUtils_1.EmailUtils.emailAddressesToHyperlinks(listOfAddresses, companyDomain, me, lengthLimit, truncateName);
	    }
	    else if (_.isArray(value)) {
	        return EmailUtils_1.EmailUtils.emailAddressesToHyperlinks(value, companyDomain, me, lengthLimit, truncateName);
	    }
	    else {
	        return undefined;
	    }
	});
	TemplateHelpers_1.TemplateHelpers.registerTemplateHelper('excessEmailToggle', function (target) {
	    Dom_1.$$(target).removeClass('coveo-active');
	    if (Dom_1.$$(target).hasClass('coveo-emails-excess-collapsed')) {
	        _.each(Dom_1.$$(target).siblings('.coveo-emails-excess-expanded'), function (sibling) {
	            Dom_1.$$(sibling).addClass('coveo-active');
	        });
	    }
	    else if (Dom_1.$$(target).hasClass('coveo-hide-expanded')) {
	        Dom_1.$$(target.parentElement).addClass('coveo-inactive');
	        _.each(Dom_1.$$(target.parentElement).siblings('.coveo-emails-excess-collapsed'), function (sibling) {
	            Dom_1.$$(sibling).addClass('coveo-active');
	        });
	    }
	    return undefined;
	});
	TemplateHelpers_1.TemplateHelpers.registerFieldHelper('anchor', function (href, options) {
	    return HtmlUtils_1.AnchorUtils.buildAnchor(href, options);
	});
	TemplateHelpers_1.TemplateHelpers.registerFieldHelper('image', function (src, options) {
	    return HtmlUtils_1.ImageUtils.buildImage(src, options);
	});
	TemplateHelpers_1.TemplateHelpers.registerTemplateHelper('thumbnail', function (result, endpoint, options) {
	    if (result === void 0) { result = resolveQueryResult(); }
	    if (endpoint === void 0) { endpoint = 'default'; }
	    if (QueryUtils_1.QueryUtils.hasThumbnail(result)) {
	        return HtmlUtils_1.ImageUtils.buildImageFromResult(result, SearchEndpoint_1.SearchEndpoint.endpoints[endpoint], options);
	    }
	});
	TemplateHelpers_1.TemplateHelpers.registerTemplateHelper('fromFileTypeToIcon', function (result, options) {
	    if (result === void 0) { result = resolveQueryResult(); }
	    if (options === void 0) { options = {}; }
	    return Icon_1.Icon.createIcon(result, options).outerHTML;
	});
	TemplateHelpers_1.TemplateHelpers.registerTemplateHelper('attrEncode', function (value) {
	    return ('' + value) /* Forces the conversion to string. */
	        .replace(/&/g, '&amp;') /* This MUST be the 1st replacement. */
	        .replace(/'/g, '&apos;') /* The 4 other predefined entities, required. */
	        .replace(/'/g, '&quot;')
	        .replace(/</g, '&lt;')
	        .replace(/>/g, '&gt;');
	});
	TemplateHelpers_1.TemplateHelpers.registerTemplateHelper('templateFields', function (result) {
	    if (result === void 0) { result = resolveQueryResult(); }
	    var rows = [];
	    if (result.fields != null) {
	        _.forEach(result.fields, function (tableField) {
	            var tr = Dom_1.$$('tr');
	            _.forEach(tableField, function (value, key) {
	                if (_.isObject(value)) {
	                    tr.setAttribute(ComponentOptions_1.ComponentOptions.attrNameFromName(key), JSON.stringify(value));
	                }
	                else {
	                    tr.setAttribute(ComponentOptions_1.ComponentOptions.attrNameFromName(key), value);
	                }
	            });
	            return rows.push(tr.el.outerHTML);
	        });
	    }
	    return rows.join('');
	});
	TemplateHelpers_1.TemplateHelpers.registerTemplateHelper('loadTemplates', function (templatesToLoad, once) {
	    if (once === void 0) { once = true; }
	    var ret = '';
	    var data = resolveQueryResult();
	    var atLeastOneWasLoaded = false;
	    var toLoad = templatesToLoad;
	    var defaultTmpl;
	    _.each(templatesToLoad, function (value, key, obj) {
	        if (value == 'default') {
	            defaultTmpl = key;
	        }
	    });
	    if (defaultTmpl != undefined) {
	        toLoad = _.omit(templatesToLoad, defaultTmpl);
	    }
	    _.each(toLoad, function (condition, id, obj) {
	        if (!atLeastOneWasLoaded || !once) {
	            atLeastOneWasLoaded = atLeastOneWasLoaded || condition;
	            ret += TemplateHelpers_1.TemplateHelpers.getHelper('loadTemplate')(id, condition, data);
	        }
	    });
	    if (!atLeastOneWasLoaded && defaultTmpl != undefined) {
	        ret += TemplateHelpers_1.TemplateHelpers.getHelper('loadTemplate')(defaultTmpl, true, data);
	    }
	    return ret;
	});
	var byteMeasure = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB'];
	TemplateHelpers_1.TemplateHelpers.registerFieldHelper('size', function (value, options) {
	    var size = Number(value);
	    var presision = (options != null && options.presision != null ? options.presision : 2);
	    var base = (options != null && options.base != null ? options.base : 0);
	    while (size > 1024 && base + 1 < byteMeasure.length) {
	        size /= 1024;
	        base++;
	    }
	    size = Math.floor(size * Math.pow(10, presision)) / Math.pow(10, presision);
	    return size + ' ' + byteMeasure[base];
	});
	TemplateHelpers_1.TemplateHelpers.registerTemplateHelper('loadTemplate', function (id, condition, data) {
	    if (condition === void 0) { condition = true; }
	    if (Utils_1.Utils.isNullOrUndefined(data)) {
	        data = resolveQueryResult();
	    }
	    if (condition) {
	        return TemplateCache_1.TemplateCache.getTemplate(id).instantiateToString(data, false);
	    }
	    return '';
	});
	TemplateHelpers_1.TemplateHelpers.registerTemplateHelper('encodeCarriageReturn', function (data) {
	    if (Utils_1.Utils.isNullOrUndefined(data)) {
	        return undefined;
	    }
	    else {
	        return StringUtils_1.StringUtils.encodeCarriageReturn(data);
	    }
	});
	TemplateHelpers_1.TemplateHelpers.registerTemplateHelper('isMobileDevice', function () {
	    return DeviceUtils_1.DeviceUtils.isMobileDevice() ? DeviceUtils_1.DeviceUtils.getDeviceName() : null;
	});
	function resolveQueryResult() {
	    return ResultList_1.ResultList.resultCurrentlyBeingRendered || Quickview_1.Quickview.resultCurrentlyBeingRendered;
	}
	function resolveTermsToHighlight() {
	    var currentQueryResult = resolveQueryResult();
	    if (currentQueryResult) {
	        return currentQueryResult.termsToHighlight;
	    }
	}
	function resolvePhrasesToHighlight() {
	    var currentQueryResult = resolveQueryResult();
	    if (currentQueryResult) {
	        return currentQueryResult.phrasesToHighlight;
	    }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var Assert_1 = __webpack_require__(17);
	var QueryUtils_1 = __webpack_require__(23);
	var Initialization_1 = __webpack_require__(95);
	var Utils_1 = __webpack_require__(18);
	var FileTypes_1 = __webpack_require__(60);
	var Quickview_1 = __webpack_require__(125);
	var Dom_1 = __webpack_require__(57);
	/**
	 * An icon component is a Result template component which outputs the corresponding icon for a given filetype. It uses the
	 * available icons in the framework, and if no suitable one are found, it fallback on a generic icon.
	 */
	var Icon = (function (_super) {
	    __extends(Icon, _super);
	    /**
	     * Create a new Icon component
	     * @param element
	     * @param options
	     * @param bindings
	     * @param result
	     */
	    function Icon(element, options, bindings, result) {
	        _super.call(this, element, Icon.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.result = result;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, Icon, options);
	        this.result = this.result || this.resolveResult();
	        Assert_1.Assert.exists(this.result);
	        var possibleInternalQuickview = Dom_1.$$(this.element).find('.' + Component_1.Component.computeCssClassNameForType(Quickview_1.Quickview.ID));
	        if (!Utils_1.Utils.isNullOrUndefined(possibleInternalQuickview) && QueryUtils_1.QueryUtils.hasHTMLVersion(this.result)) {
	            Dom_1.$$(this.element).addClass('coveo-with-quickview');
	            Dom_1.$$(this.element).on('click', function () {
	                var qv = Component_1.Component.get(possibleInternalQuickview);
	                qv.open();
	            });
	        }
	        Icon.createIcon(this.result, this.options, element, bindings);
	    }
	    Icon.createIcon = function (result, options, element, bindings) {
	        if (options === void 0) { options = {}; }
	        if (element === void 0) { element = Dom_1.$$('div').el; }
	        var info = FileTypes_1.FileTypes.get(result);
	        info = Icon.preprocessIconInfo(options, info);
	        Dom_1.$$(element).toggleClass('coveo-small', options.small === true);
	        if (options.value != undefined) {
	            if (options.small === true) {
	                if (options.value.indexOf('-small') == -1) {
	                    info.icon += '-small';
	                }
	            }
	            if (options.small === false) {
	                if (options.value.indexOf('-small') != -1) {
	                    info.icon = info.icon.replace('-small', '');
	                }
	            }
	        }
	        Dom_1.$$(element).addClass(info.icon);
	        element.setAttribute('title', info.caption);
	        if (Icon.shouldDisplayLabel(options, bindings)) {
	            element.appendChild(Dom_1.$$('span', {
	                className: 'coveo-icon-caption-overlay'
	            }, info.caption).el);
	            Dom_1.$$(element).addClass('coveo-icon-with-caption-overlay');
	        }
	        return element;
	    };
	    Icon.shouldDisplayLabel = function (options, bindings) {
	        // Display only in new design.
	        // If withLabel is explicitely set to false, the label will never display
	        // If withLabel is explicitely set to true, the label will always display
	        // If withLabel is set to default value (not a hard true or false), the label will display based on ./core/filetypes/**.json
	        // with the property shouldDisplayLabel set on each file type/ objecttype
	        // In this case, the generated css will take care of outputting the correct css to display : block
	        return bindings && bindings.searchInterface.isNewDesign() && options.withLabel !== false;
	    };
	    Icon.preprocessIconInfo = function (options, info) {
	        if (options.labelValue != null) {
	            info.caption = options.labelValue;
	        }
	        if (options.value != null) {
	            info.icon = 'coveo-icon ' + options.value;
	        }
	        if (info.caption == null) {
	            info.caption = '';
	        }
	        if (info.icon == null) {
	            info.icon = 'coveo-icon coveo-sprites-custom';
	        }
	        return info;
	    };
	    Icon.ID = 'Icon';
	    /**
	     * The options for the component
	     * @componentOptions
	     */
	    Icon.options = {
	        /**
	         * Setting this value will tell the `Icon` component to output this value as its CSS class, instead of the auto-selected one.<br/>
	         * Default is `undefined`, and the framework will determine an icon from the result filetype.
	         */
	        value: ComponentOptions_1.ComponentOptions.buildIconOption(),
	        /**
	         * Setting this value to true will output the smaller version of the auto-generated icon.<br/>
	         * Default is `false`.
	         */
	        small: ComponentOptions_1.ComponentOptions.buildBooleanOption(),
	        /**
	         * Setting this to true will force the caption/label to appear.<br/>
	         * Setting this to false will force the caption/label to never appear.<br/>
	         * Default value is `undefined`, and the framework will determine if a label needs to be displayed.
	         */
	        withLabel: ComponentOptions_1.ComponentOptions.buildBooleanOption(),
	        /**
	         * Setting this option allow to set the label that should be displayed.<br/>
	         * Default value is `undefined`, and the framework will determine the label that will be displayed.
	         */
	        labelValue: ComponentOptions_1.ComponentOptions.buildLocalizedStringOption()
	    };
	    Icon.fields = [
	        'objecttype',
	        'filetype',
	    ];
	    return Icon;
	}(Component_1.Component));
	exports.Icon = Icon;
	Initialization_1.Initialization.registerAutoCreateComponent(Icon);


/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var DomUtils_1 = __webpack_require__(59);
	var DeviceUtils_1 = __webpack_require__(20);
	var Dom_1 = __webpack_require__(57);
	var DefaultQuickviewTemplate_1 = __webpack_require__(126);
	var ResultListEvents_1 = __webpack_require__(48);
	var StringUtils_1 = __webpack_require__(61);
	var QuickviewDocument_1 = __webpack_require__(127);
	var QueryStateModel_1 = __webpack_require__(90);
	var QuickviewEvents_1 = __webpack_require__(118);
	var Initialization_1 = __webpack_require__(95);
	var KeyboardUtils_1 = __webpack_require__(68);
	var ExternalModulesShim_1 = __webpack_require__(25);
	/**
	 * This component is meant to exist within a result template.
	 * It allows to create a button/link inside the result list that opens a modal box for a given result.
	 *
	 * Most of the time, this component will reference a {@link QuickviewDocument} in its content template.
	 *
	 * # Choosing what to display for the Quickview
	 * The Quick View uses any HTML structure you put inside its tag and uses that as the content of the dialog box. This content can thus be any element you decide, using your CSS and your structure.
	 *
	 * > Example
	 * > You can change the appearance of the Quick View link by adding HTML inside the body of the div.
	 * > You can change the content of the Quick View link by specifying a template ID.
	 *
	 * ```html
	 * <!-- This would change the appearance of the quickview button itself in the result. -->
	 * <div class="CoveoQuickview" data-template-id="TemplateId">
	 *   <span>Click here for Quickview</span>
	 * </div>
	 *
	 * <!-- This would modify the content of the quickview when it is opened in the modal box -->
	 * <script class='result-template' type='text/underscore' id='TemplateId' >
	 *   <div>
	 *     <span>This is the content that will be displayed when you open the Quick View. You can also include any other Coveo components.</span>
	 *     <table class="CoveoFieldTable">
	 *       <tr data-field="@liboardshorttitle" data-caption="Board" />
	 *       <tr data-field="@licategoryshorttitle" data-caption="Category" />
	 *       <tr data-field="@sysauthor" data-caption="Author" />
	 *     </table>
	 *   </div>
	 * </script>
	 *
	 * <!-- Note that this is all optional: Just including a <div class='CoveoQuickview'></div> will do the job most of the time, and will include a default template and default button appearance -->
	 * ```
	 */
	var Quickview = (function (_super) {
	    __extends(Quickview, _super);
	    function Quickview(element, options, bindings, result, ModalBox) {
	        var _this = this;
	        if (ModalBox === void 0) { ModalBox = ExternalModulesShim_1.ModalBox; }
	        _super.call(this, element, Quickview.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.bindings = bindings;
	        this.result = result;
	        this.ModalBox = ModalBox;
	        this.bindedHandleEscapeEvent = this.handleEscapeEvent.bind(this);
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, Quickview, options);
	        if (this.options.contentTemplate == null) {
	            this.options.contentTemplate = new DefaultQuickviewTemplate_1.DefaultQuickviewTemplate();
	        }
	        // If there is no content inside the Quickview div,
	        // we need to add something that will show up in the result template itself
	        if (/^\s*$/.test(this.element.innerHTML)) {
	            var iconForQuickview = Dom_1.$$('div');
	            iconForQuickview.addClass('coveo-icon-for-quickview');
	            if (this.searchInterface.isNewDesign()) {
	                var captionForQuickview = Dom_1.$$('div', { className: 'coveo-caption-for-quickview', tabindex: 0 }, 'Quickview'.toLocaleString()).el;
	                var div = Dom_1.$$('div');
	                div.append(iconForQuickview.el);
	                div.append(captionForQuickview);
	                Dom_1.$$(this.element).append(div.el);
	            }
	            else {
	                iconForQuickview.text('Quickview'.toLocaleString());
	                Dom_1.$$(this.element).append(iconForQuickview.el);
	            }
	        }
	        this.bindClick(result);
	        if (this.bindings.resultElement) {
	            this.bind.on(this.bindings.resultElement, ResultListEvents_1.ResultListEvents.openQuickview, function () { return _this.open(); });
	        }
	    }
	    /**
	     * Open the quickview
	     */
	    Quickview.prototype.open = function () {
	        if (this.modalbox == null) {
	            // To prevent the keyboard from opening on mobile if the search bar has focus
	            Quickview.resultCurrentlyBeingRendered = this.result;
	            Dom_1.$$(document.activeElement).trigger('blur');
	            var openerObject = this.prepareOpenQuickviewObject();
	            this.createModalBox(openerObject);
	            this.bindQuickviewEvents(openerObject);
	            this.animateAndOpen();
	            this.queryStateModel.set(QueryStateModel_1.QueryStateModel.attributesEnum.quickview, this.getHashId());
	            Quickview.resultCurrentlyBeingRendered = null;
	        }
	    };
	    /**
	     * Close the quickview
	     */
	    Quickview.prototype.close = function () {
	        if (this.modalbox != null) {
	            this.modalbox.close();
	            this.modalbox = null;
	            Dom_1.$$(document.body).off('keyup', this.bindedHandleEscapeEvent);
	        }
	    };
	    Quickview.prototype.getHashId = function () {
	        return this.result.queryUid + '.' + this.result.index + '.' + StringUtils_1.StringUtils.hashCode(this.result.uniqueId);
	    };
	    Quickview.prototype.bindClick = function (result) {
	        var _this = this;
	        if (typeof result.hasHtmlVersion == 'undefined' || result.hasHtmlVersion || this.options.alwaysShow) {
	            var clickAction = function () { return _this.open(); };
	            Dom_1.$$(this.element).on('click', clickAction);
	            this.bind.on(this.element, 'keyup', KeyboardUtils_1.KeyboardUtils.keypressAction(KeyboardUtils_1.KEYBOARD.ENTER, clickAction));
	        }
	        else {
	            this.element.style.display = 'none';
	        }
	    };
	    Quickview.prototype.bindQuickviewEvents = function (openerObject) {
	        var _this = this;
	        var closeButton = Dom_1.$$(this.modalbox.wrapper).find('.coveo-quickview-close-button');
	        Dom_1.$$(closeButton).on('click', function () {
	            _this.closeQuickview();
	            _this.close();
	        });
	        Dom_1.$$(this.modalbox.overlay).on('click', function () {
	            _this.closeQuickview();
	        });
	        Dom_1.$$(this.modalbox.content).on(QuickviewEvents_1.QuickviewEvents.quickviewLoaded, function () {
	            Dom_1.$$(openerObject.loadingAnimation).remove();
	            _this.bindIFrameEscape();
	        });
	        this.bindEscape();
	    };
	    Quickview.prototype.animateAndOpen = function () {
	        var _this = this;
	        var animationDuration = this.modalbox.wrapper.style.animationDuration;
	        var quickviewDocument = Dom_1.$$(this.modalbox.modalBox).find('.' + Component_1.Component.computeCssClassName(QuickviewDocument_1.QuickviewDocument));
	        if (quickviewDocument) {
	            if (animationDuration) {
	                var duration = /^(.+)(ms|s)$/.exec(animationDuration);
	                var durationMs = Number(duration[1]) * (duration[2] == 's' ? 1000 : 1);
	                // open the QuickviewDocument
	                setTimeout(function () {
	                    if (_this.modalbox != null) {
	                        Initialization_1.Initialization.dispatchNamedMethodCallOrComponentCreation('open', quickviewDocument, null);
	                    }
	                }, durationMs);
	            }
	            else {
	                Initialization_1.Initialization.dispatchNamedMethodCallOrComponentCreation('open', quickviewDocument, null);
	            }
	        }
	    };
	    Quickview.prototype.createModalBox = function (openerObject) {
	        var computedModalBoxContent = Dom_1.$$('div');
	        computedModalBoxContent.append(openerObject.content.el);
	        this.modalbox = this.ModalBox.open(computedModalBoxContent.el, {
	            title: DomUtils_1.DomUtils.getQuickviewHeader(this.result, {
	                showDate: this.options.showDate,
	                title: this.options.title
	            }, this.bindings).el.outerHTML,
	            className: 'coveo-quick-view',
	            validation: function () { return true; },
	            body: this.element.ownerDocument.body
	        });
	        this.setQuickviewSize();
	    };
	    Quickview.prototype.prepareOpenQuickviewObject = function () {
	        var loadingAnimation = this.options.loadingAnimation;
	        return {
	            loadingAnimation: loadingAnimation,
	            content: this.prepareQuickviewContent(loadingAnimation)
	        };
	    };
	    Quickview.prototype.prepareQuickviewContent = function (loadingAnimation) {
	        var content = Dom_1.$$(this.options.contentTemplate.instantiateToElement(this.result));
	        var initOptions = this.searchInterface.options;
	        var initParameters = {
	            options: initOptions,
	            bindings: this.getBindings(),
	            result: this.result
	        };
	        Initialization_1.Initialization.automaticallyCreateComponentsInside(content.el, initParameters);
	        if (content.find('.' + Component_1.Component.computeCssClassName(QuickviewDocument_1.QuickviewDocument)) != undefined && this.options.enableLoadingAnimation) {
	            content.prepend(loadingAnimation);
	        }
	        return content;
	    };
	    Quickview.prototype.bindEscape = function () {
	        Dom_1.$$(document.body).on('keyup', this.bindedHandleEscapeEvent);
	    };
	    Quickview.prototype.bindIFrameEscape = function () {
	        var quickviewDocument = Dom_1.$$(this.modalbox.content).find('.' + Component_1.Component.computeCssClassName(QuickviewDocument_1.QuickviewDocument));
	        quickviewDocument = Dom_1.$$(quickviewDocument).find('iframe');
	        var body = quickviewDocument.contentWindow.document.body;
	        Dom_1.$$(body).on('keyup', this.bindedHandleEscapeEvent);
	    };
	    Quickview.prototype.closeQuickview = function () {
	        this.queryStateModel.set(QueryStateModel_1.QueryStateModel.attributesEnum.quickview, '');
	    };
	    Quickview.prototype.setQuickviewSize = function () {
	        var wrapper = Dom_1.$$(Dom_1.$$(this.modalbox.modalBox).find('.coveo-wrapper'));
	        wrapper.el.style.width = this.options.size;
	        wrapper.el.style.height = this.options.size;
	        wrapper.el.style.maxWidth = this.options.size;
	        wrapper.el.style.maxHeight = this.options.size;
	    };
	    Quickview.prototype.handleEscapeEvent = function (e) {
	        if (e.keyCode == KeyboardUtils_1.KEYBOARD.ESCAPE) {
	            this.closeQuickview();
	            this.close();
	        }
	    };
	    Quickview.ID = 'Quickview';
	    Quickview.fields = [
	        'urihash',
	        'collection',
	        'source',
	        'author' // analytics
	    ];
	    /**
	     * @componentOptions
	     */
	    Quickview.options = {
	        /**
	         * Specifies whether the quickview is always shown, even when the index body for a document is empty.<br/>
	         * In such cases, the {@link Quickview.options.contentTemplate} specifies what appears in the quickview.<br/>
	         * If there is no quickview for the document, you *MUST* specify a contentTemplate otherwise the component will throw an error when opened.
	         */
	        alwaysShow: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: false }),
	        /**
	         * Specifies the title of your choice that appears at the top of the Quick View modal window.
	         */
	        title: ComponentOptions_1.ComponentOptions.buildStringOption(),
	        /**
	         * Specifies whether to show the document date in the Quick View modal window header.<br/>
	         * The default value is `true`.
	         */
	        showDate: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true }),
	        enableLoadingAnimation: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true }),
	        /**
	         * Specifies the template to use to present the Quick View content in the modal window.<br/>
	         * e.g.: <br/>
	         *     <div class="CoveoQuickview" data-template-id="TemplateId"></div>
	         *     <div class="CoveoQuickview" data-template-selector=".templateSelector"></div>
	         */
	        contentTemplate: ComponentOptions_1.ComponentOptions.buildTemplateOption({
	            selectorAttr: 'data-template-selector',
	            idAttr: 'data-template-id'
	        }),
	        loadingAnimation: ComponentOptions_1.ComponentOptions.buildOption(ComponentOptions_1.ComponentOptionsType.NONE, function (element) {
	            var loadingAnimationSelector = element.getAttribute('data-loading-animation-selector');
	            if (loadingAnimationSelector != null) {
	                var loadingAnimation = Dom_1.$$(document.documentElement).find(loadingAnimationSelector);
	                if (loadingAnimation != null) {
	                    Dom_1.$$(loadingAnimation).detach();
	                    return loadingAnimation;
	                }
	            }
	            var id = element.getAttribute('data-loading-animation-template-id');
	            if (id != null) {
	                var loadingAnimationTemplate = ComponentOptions_1.ComponentOptions.loadResultTemplateFromId(id);
	                if (loadingAnimationTemplate) {
	                    return loadingAnimationTemplate.instantiateToElement({});
	                }
	            }
	            return DomUtils_1.DomUtils.getBasicLoadingAnimation();
	        }),
	        /**
	         * Specifies the Quick View modal window size (width and height) relative to the full window.<br/>
	         * The default value is 95% on a desktop and 100% on a mobile device.
	         */
	        size: ComponentOptions_1.ComponentOptions.buildStringOption({ defaultValue: DeviceUtils_1.DeviceUtils.isMobileDevice() ? '100%' : '95%' })
	    };
	    Quickview.resultCurrentlyBeingRendered = null;
	    return Quickview;
	}(Component_1.Component));
	exports.Quickview = Quickview;
	Initialization_1.Initialization.registerAutoCreateComponent(Quickview);


/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Template_1 = __webpack_require__(100);
	var DefaultQuickviewTemplate = (function (_super) {
	    __extends(DefaultQuickviewTemplate, _super);
	    function DefaultQuickviewTemplate() {
	        _super.call(this);
	    }
	    DefaultQuickviewTemplate.prototype.instantiateToString = function (queryResult) {
	        return '<div class="coveo-quick-view-full-height"><div class="CoveoQuickviewDocument"></div></div>';
	    };
	    return DefaultQuickviewTemplate;
	}(Template_1.Template));
	exports.DefaultQuickviewTemplate = DefaultQuickviewTemplate;


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var AnalyticsActionListMeta_1 = __webpack_require__(110);
	var Assert_1 = __webpack_require__(17);
	var Dom_1 = __webpack_require__(57);
	var QuickviewEvents_1 = __webpack_require__(118);
	var DeviceUtils_1 = __webpack_require__(20);
	var Utils_1 = __webpack_require__(18);
	var ColorUtils_1 = __webpack_require__(54);
	var Initialization_1 = __webpack_require__(95);
	var Strings_1 = __webpack_require__(34);
	var HIGHLIGHT_PREFIX = 'CoveoHighlight';
	/**
	 * The QuickviewDocument component is meant to exist within Result Templates, more specifically inside a {@link Quickview} component.
	 * The sole purpose of this component is to include an iframe which will load the correct HTML version of the current document.
	 * By default, this component is included in the default template for a {@link Quickview} component.
	 */
	var QuickviewDocument = (function (_super) {
	    __extends(QuickviewDocument, _super);
	    /**
	     * Create a new instance of the component
	     * @param element
	     * @param options
	     * @param bindings
	     * @param result
	     */
	    function QuickviewDocument(element, options, bindings, result) {
	        _super.call(this, element, QuickviewDocument.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.result = result;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, QuickviewDocument, options);
	        this.result = result || this.resolveResult();
	        this.termsToHighlightWereModified = false;
	        Assert_1.Assert.exists(this.result);
	    }
	    QuickviewDocument.prototype.createDom = function () {
	        var container = Dom_1.$$('div');
	        container.addClass('coveo-quickview-document');
	        this.element.appendChild(container.el);
	        this.header = this.buildHeader();
	        this.iframe = this.buildIFrame();
	        container.append(this.header.el);
	        container.append(this.iframe.el);
	    };
	    QuickviewDocument.prototype.open = function () {
	        var _this = this;
	        this.ensureDom();
	        var documentURL = Dom_1.$$(this.element).getAttribute('href');
	        if (documentURL == undefined || documentURL == '') {
	            documentURL = this.result.clickUri;
	        }
	        this.usageAnalytics.logClickEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.documentQuickview, {
	            author: this.result.raw.author,
	            documentURL: documentURL,
	            documentTitle: this.result.title
	        }, this.result, this.queryController.element);
	        var beforeLoad = (new Date()).getTime();
	        var iframe = this.iframe.find('iframe');
	        iframe.src = 'about:blank';
	        var endpoint = this.queryController.getEndpoint();
	        var termsToHighlight = _.keys(this.result.termsToHighlight);
	        var dataToSendOnOpenQuickView = {
	            termsToHighlight: termsToHighlight
	        };
	        Dom_1.$$(this.element).trigger(QuickviewEvents_1.QuickviewEvents.openQuickview, dataToSendOnOpenQuickView);
	        this.checkIfTermsToHighlightWereModified(dataToSendOnOpenQuickView.termsToHighlight);
	        var queryObject = _.extend({}, this.getBindings().queryController.getLastQuery());
	        if (this.termsToHighlightWereModified) {
	            this.handleTermsToHighlight(dataToSendOnOpenQuickView.termsToHighlight, queryObject);
	        }
	        var callOptions = {
	            queryObject: queryObject,
	            requestedOutputSize: this.options.maximumDocumentSize
	        };
	        endpoint.getDocumentHtml(this.result.uniqueId, callOptions)
	            .then(function (html) {
	            // If the contentDocument is null at this point it means that the Quick View
	            // was closed before we've finished loading it. In this case do nothing.
	            if (iframe.contentDocument == null) {
	                return;
	            }
	            _this.renderHTMLDocument(iframe, html);
	            _this.triggerQuickviewLoaded(beforeLoad);
	        })
	            .catch(function (error) {
	            // If the contentDocument is null at this point it means that the Quick View
	            // was closed before we've finished loading it. In this case do nothing.
	            if (iframe.contentDocument == null) {
	                return;
	            }
	            if (error.status != 0) {
	                _this.renderErrorReport(iframe, error.status);
	                _this.triggerQuickviewLoaded(beforeLoad);
	            }
	            else {
	                iframe.onload = function () {
	                    _this.triggerQuickviewLoaded(beforeLoad);
	                };
	                iframe.src = endpoint.getViewAsHtmlUri(_this.result.uniqueId, callOptions);
	            }
	        });
	    };
	    QuickviewDocument.prototype.renderHTMLDocument = function (iframe, html) {
	        var _this = this;
	        iframe.onload = function () {
	            _this.computeHighlights(iframe.contentWindow);
	            // Remove white border for new Quickview
	            if (_this.isNewQuickviewDocument(iframe.contentWindow)) {
	                var body = Dom_1.$$(_this.element).closest('.coveo-body');
	                body.style.padding = '0';
	                var header = Dom_1.$$(_this.element).find('.coveo-quickview-header');
	                header.style.paddingTop = '10';
	                header.style.paddingLeft = '10';
	            }
	            if (Dom_1.$$(_this.element).find('.coveo-quickview-header').innerHTML == '') {
	                Dom_1.$$(_this.element).find('.coveo-quickview-header').style.display = 'none';
	            }
	        };
	        this.writeToIFrame(iframe, html);
	        this.wrapPreElementsInIframe(iframe);
	    };
	    QuickviewDocument.prototype.renderErrorReport = function (iframe, errorStatus) {
	        var errorString = '';
	        if (errorStatus == 400) {
	            errorString = 'NoQuickview';
	        }
	        else {
	            errorString = 'OopsError';
	        }
	        var errorMessage = "<html><body style='font-family: Arimo, 'Helvetica Neue', Helvetica, Arial, sans-serif; -webkit-text-size-adjust: none;' >" + Strings_1.l(errorString) + " </body></html>";
	        this.writeToIFrame(iframe, errorMessage);
	    };
	    QuickviewDocument.prototype.writeToIFrame = function (iframe, content) {
	        var toWrite = content;
	        // This sucks because we can't do instanceof HTMLDocument
	        // lib.d.ts declare HTMLDocument as an interface, not an actual object
	        if (typeof content == 'object') {
	            toWrite = content.getElementsByTagName('html')[0].outerHTML;
	        }
	        iframe.contentWindow.document.open();
	        iframe.contentWindow.document.write(toWrite);
	        iframe.contentWindow.document.close();
	    };
	    QuickviewDocument.prototype.wrapPreElementsInIframe = function (iframe) {
	        try {
	            var style = document.createElement('style');
	            style.type = 'text/css';
	            // This CSS forces <pre> tags used in some emails to wrap by default
	            var cssText = 'html pre { white-space: pre-wrap; white-space: -moz-pre-wrap; white-space: -pre-wrap; white-space: -o-pre-wrap; word-wrap: break-word; }';
	            // Some people react strongly when presented with their browser's default font, so let's fix that
	            cssText += 'body, html { font-family: Arimo, \'Helvetica Neue\', Helvetica, Arial, sans-serif; -webkit-text-size-adjust: none; }';
	            if (DeviceUtils_1.DeviceUtils.isIos()) {
	                // Safari on iOS forces resize iframes to fit their content, even if an explicit size
	                // is set on the iframe. Isn't that great? By chance there is a trick around it: by
	                // setting a very small size on the body and instead using min-* to set the size to
	                // 100% we're able to trick Safari from thinking it must expand the iframe. Amazed.
	                // The 'scrolling' part is required otherwise the hack doesn't work.
	                //
	                // http://stackoverflow.com/questions/23083462/how-to-get-an-iframe-to-be-responsive-in-ios-safari
	                cssText += 'body, html { height: 1px !important; min-height: 100%; overflow: scroll; }';
	                Dom_1.$$(iframe).setAttribute('scrolling', 'no');
	                // Some content is cropped on iOs if a margin is present
	                // We remove it and add one on the iframe wrapper.
	                cssText += 'body, html {margin: auto}';
	                iframe.parentElement.style.margin = '0 0 5px 5px';
	                // While we're on the topic of iOS Safari: This magic trick prevents iOS from NOT
	                // displaying the content of the iframe. If we don't do this, you'll see the body
	                // of the iframe ONLY when viewing the page in the tab switcher.  Isn't that *magical*?
	                iframe.style.position = 'relative';
	            }
	            if ('styleSheet' in style) {
	                style['styleSheet'].cssText = cssText;
	            }
	            else {
	                style.appendChild(document.createTextNode(cssText));
	            }
	            var head = iframe.contentWindow.document.head;
	            head.appendChild(style);
	        }
	        catch (e) {
	        }
	    };
	    QuickviewDocument.prototype.triggerQuickviewLoaded = function (beforeLoad) {
	        var afterLoad = (new Date()).getTime();
	        var eventArgs = { duration: afterLoad - beforeLoad };
	        Dom_1.$$(this.element).trigger(QuickviewEvents_1.QuickviewEvents.quickviewLoaded, eventArgs);
	    };
	    // An highlighted term looks like:
	    //
	    //     <span id='CoveoHighlight:X.Y.Z'>a</span>
	    //
	    // The id has 3 components:
	    // - X: the term
	    // - Y: the term occurence
	    // - Z: the term part
	    //
	    // For the 'Z' component, if the term 'foo bar' is found in multiple elements, we will see:
	    //
	    //     <span id='CoveoHighlight:1.1.1'>foo</span>
	    //     <span id='CoveoHighlight:1.1.2'>bar</span>
	    //
	    // Highlighted words can overlap, which looks like:
	    //
	    //     <span id='CoveoHighlight:1.Y.Z'>
	    //         a
	    //         <coveotaggedword id='CoveoHighlight:2.Y.Z'>b</coveotaggedword>
	    //     </span>
	    //     <span id='CoveoHighlight:2.Y.Z'>c</span>
	    //
	    // In the previous example, the words 'ab' and 'bc' are highlighted.
	    //
	    // One thing important to note is that the id of all 'coveotaggedword' for
	    // the same word AND the first 'span' for that word will have the same id.
	    //
	    // Example:
	    //
	    //     <span id='CoveoHighlight:1.1.1'>
	    //         a
	    //         <coveotaggedword id='CoveoHighlight:2.1.1'>b</coveotaggedword>
	    //     </span>
	    //     <span id='CoveoHighlight:1.1.2'>
	    //         c
	    //         <coveotaggedword id='CoveoHighlight:2.1.1'>d</coveotaggedword>
	    //     </span>
	    //     <span id='CoveoHighlight:2.1.1'>e</span>
	    //     <span id='CoveoHighlight:2.1.2'>f</span>
	    //
	    // In the previous example, the words 'abcd' and 'bcdef' are highlighted.
	    //
	    // This method is public for testing purposes.
	    QuickviewDocument.prototype.computeHighlights = function (window) {
	        var _this = this;
	        Dom_1.$$(this.header).empty();
	        this.keywordsState = [];
	        var words = {};
	        var highlightsCount = 0;
	        _.each(Dom_1.$$(window.document.body).findAll('[id^="' + HIGHLIGHT_PREFIX + '"]'), function (element, index) {
	            var idParts = _this.getHighlightIdParts(element);
	            if (idParts) {
	                var idIndexPart = idParts[1]; // X
	                var idOccurencePart = parseInt(idParts[2], 10); // Y
	                var idTermPart = parseInt(idParts[3], 10); // Z in <span id='CoveoHighlight:X.Y.Z'>a</span>
	                var word = words[idIndexPart];
	                // The 'idTermPart' check is to circumvent a bug from the index
	                // where an highlight of an empty string start with an idTermPart > 1.
	                if (word == null && idTermPart == 1) {
	                    words[idIndexPart] = word = {
	                        text: _this.getHighlightInnerText(element),
	                        count: 1,
	                        index: parseInt(idIndexPart, 10),
	                        // Here I try to be clever.
	                        // An overlaping word:
	                        // 1) always start with a 'coveotaggedword' element.
	                        // 2) then other 'coveotaggedword' elements may follow
	                        // 3) then a 'span' element may follow.
	                        //
	                        // All 1), 2) and 3) will have the same id so I consider them as
	                        // a whole having the id 0 instead of 1.
	                        termsCount: element.nodeName.toLowerCase() == 'coveotaggedword' ? 0 : 1,
	                        element: element,
	                        occurence: idOccurencePart
	                    };
	                }
	                else if (word) {
	                    if (word.occurence == idOccurencePart) {
	                        if (element.nodeName.toLowerCase() == 'coveotaggedword') {
	                            word.text += _this.getHighlightInnerText(element);
	                        }
	                        else if (word.termsCount < idTermPart) {
	                            word.text += _this.getHighlightInnerText(element);
	                            word.termsCount += 1;
	                        }
	                    }
	                    word.count = Math.max(word.count, idOccurencePart);
	                    highlightsCount += 1;
	                }
	                // See the method description to understand why this code let us
	                // create the word 'bcdef' instead of 'bdef'.
	                if (word && word.occurence == idOccurencePart && element.nodeName.toLowerCase() == 'span') {
	                    var embeddedWordParts = _this.getHightlightEmbeddedWordIdParts(element);
	                    var embeddedWord = embeddedWordParts ? words[embeddedWordParts[1]] : null;
	                    if (embeddedWord && embeddedWord.occurence == parseInt(embeddedWordParts[2], 10)) {
	                        embeddedWord.text += element.childNodes[0].nodeValue || ''; // only immediate text without children.
	                    }
	                }
	            }
	        });
	        if (highlightsCount == 0) {
	            this.header.el.style.minHeight = '0';
	        }
	        var resolvedWords = [];
	        _.each(words, function (word) {
	            // When possible, take care to find the original term from the query instead of the
	            // first highlighted version we encounter. This relies on a recent feature by the
	            // Search API, but will fallback properly on older versions.
	            word.text = _this.resolveOriginalTermFromHighlight(word.text);
	            var state = {
	                word: word,
	                color: word.element.style.backgroundColor,
	                currentIndex: 0,
	                index: word.index
	            };
	            _this.keywordsState.push(state);
	            Dom_1.$$(_this.header).append(_this.buildWordButton(state, window));
	            resolvedWords.push(word.text);
	        });
	        return resolvedWords;
	    };
	    QuickviewDocument.prototype.getHighlightIdParts = function (element) {
	        var parts = element
	            .id
	            .substr(HIGHLIGHT_PREFIX.length + 1)
	            .match(/^([0-9]+)\.([0-9]+)\.([0-9]+)$/);
	        return (parts && parts.length > 3) ? parts : null;
	    };
	    QuickviewDocument.prototype.getHighlightInnerText = function (element) {
	        if (element.nodeName.toLowerCase() == 'coveotaggedword') {
	            // only immediate text without children.
	            return element.childNodes.length >= 1 ? (element.childNodes.item(0).textContent || '') : '';
	        }
	        else {
	            return element.textContent || '';
	        }
	    };
	    QuickviewDocument.prototype.getHightlightEmbeddedWordIdParts = function (element) {
	        var embedded = element.getElementsByTagName('coveotaggedword')[0];
	        return embedded ? this.getHighlightIdParts(embedded) : null;
	    };
	    QuickviewDocument.prototype.resolveOriginalTermFromHighlight = function (highlight) {
	        var _this = this;
	        var found = highlight;
	        // Beware, terms to highlight is only set by recent search APIs.
	        if (this.result.termsToHighlight) {
	            // We look for the term expansion and we'll return the corresponding
	            // original term is one is found.
	            found = _.find(_.keys(this.result.termsToHighlight), function (originalTerm) {
	                // The expansions do NOT include the original term (makes sense), so be sure to check
	                // the original term for a match too.
	                return (originalTerm.toLowerCase() == highlight.toLowerCase()) ||
	                    (_.find(_this.result.termsToHighlight[originalTerm], function (expansion) { return expansion.toLowerCase() == highlight.toLowerCase(); }) != undefined);
	            }) || found;
	        }
	        return found;
	    };
	    QuickviewDocument.prototype.buildWordButton = function (wordState, window) {
	        var _this = this;
	        var wordHtml = Dom_1.$$('span');
	        wordHtml.addClass('coveo-term-for-quickview');
	        var quickviewName = Dom_1.$$('span');
	        quickviewName.addClass('coveo-term-for-quickview-name');
	        quickviewName.setHtml(wordState.word.text);
	        quickviewName.on('click', function () {
	            _this.navigate(wordState, false, window);
	        });
	        wordHtml.append(quickviewName.el);
	        var quickviewUpArrow = Dom_1.$$('span');
	        quickviewUpArrow.addClass('coveo-term-for-quickview-up-arrow');
	        var quickviewUpArrowIcon = Dom_1.$$('span');
	        quickviewUpArrowIcon.addClass('coveo-term-for-quickview-up-arrow-icon');
	        quickviewUpArrow.append(quickviewUpArrowIcon.el);
	        quickviewUpArrow.on('click', function () {
	            _this.navigate(wordState, true, window);
	        });
	        wordHtml.append(quickviewUpArrow.el);
	        var quickviewDownArrow = Dom_1.$$('span');
	        quickviewDownArrow.addClass('coveo-term-for-quickview-down-arrow');
	        var quickviewDownArrowIcon = Dom_1.$$('span');
	        quickviewDownArrowIcon.addClass('coveo-term-for-quickview-down-arrow-icon');
	        quickviewDownArrow.append(quickviewDownArrowIcon.el);
	        quickviewDownArrow.on('click', function () {
	            _this.navigate(wordState, false, window);
	        });
	        wordHtml.append(quickviewDownArrow.el);
	        wordHtml.el.style.backgroundColor = wordState.color;
	        wordHtml.el.style.borderColor = this.getSaturatedColor(wordState.color);
	        quickviewDownArrow.el.style.borderColor = this.getSaturatedColor(wordState.color);
	        return wordHtml.el;
	    };
	    QuickviewDocument.prototype.navigate = function (state, backward, window) {
	        var fromIndex = state.currentIndex;
	        var toIndex;
	        if (!backward) {
	            toIndex = fromIndex == state.word.count ? 1 : fromIndex + 1;
	        }
	        else {
	            toIndex = fromIndex <= 1 ? state.word.count : fromIndex - 1;
	        }
	        var scroll = this.getScrollingElement(window);
	        // Un-highlight any currently selected element
	        var current = Dom_1.$$(scroll).find('[id^="' + HIGHLIGHT_PREFIX + ':' + state.word.index + '.' + fromIndex + '"]');
	        if (current) {
	            current.style.border = '';
	        }
	        // Find and highlight the new element.
	        var element = Dom_1.$$(window.document.body).find('[id^="' + HIGHLIGHT_PREFIX + ':' + state.word.index + '.' + toIndex + '"]');
	        element.style.border = '1px dotted #333';
	        state.currentIndex = toIndex;
	        // pdf2html docs hide the non-visible frames by default, to speed up browsers.
	        // But this prevents keyword navigation from working so we must force show it. This
	        // is done by adding the 'opened' class to it (defined by pdf2html).
	        if (this.isNewQuickviewDocument(window)) {
	            var pdf = Dom_1.$$(element).closest('.pc');
	            Dom_1.$$(pdf).addClass('opened');
	        }
	        // pdf2html docs hide the non-visible frames by default, to speed up browsers.
	        // Hack for now: the new Quick View is far too complex to manually scroll
	        // to the content, so SCREW IT and use good ol' scrollIntoView. I'm planning
	        // on a page-based quick view in an upcoming hackaton anyway :)
	        //
	        // Also, mobile devices have troubles with the animation.
	        if (this.isNewQuickviewDocument(window) || DeviceUtils_1.DeviceUtils.isMobileDevice()) {
	            element.scrollIntoView();
	            // iOS on Safari might scroll the whole modal box body when we do this,
	            // so give it a nudge in the right direction.
	            var body = this.iframe.closest('.coveo-body');
	            body.scrollLeft = 0;
	            body.scrollTop = 0;
	            return;
	        }
	        // For other quick views we use a nicer animation that centers the keyword
	        this.animateScroll(scroll, element.offsetLeft - scroll.clientWidth / 2 + Dom_1.$$(element).width() / 2, element.offsetTop - scroll.clientHeight / 2 + Dom_1.$$(element).height() / 2);
	        this.animateScroll(this.iframe.el, element.offsetLeft - this.iframe.width() / 2 + Dom_1.$$(element).width() / 2, element.offsetTop - this.iframe.height() / 2 + Dom_1.$$(element).height() / 2);
	    };
	    QuickviewDocument.prototype.buildHeader = function () {
	        var header = Dom_1.$$('div');
	        header.addClass('coveo-quickview-header');
	        return header;
	    };
	    QuickviewDocument.prototype.buildIFrame = function () {
	        var iFrame = Dom_1.$$('iframe');
	        iFrame.setAttribute('sandbox', 'allow-same-origin');
	        var iFrameWrapper = Dom_1.$$('div');
	        iFrameWrapper.addClass('coveo-iframeWrapper');
	        iFrameWrapper.el.appendChild(iFrame.el);
	        return iFrameWrapper;
	    };
	    QuickviewDocument.prototype.getScrollingElement = function (iframeWindow) {
	        var found;
	        if (this.isNewQuickviewDocument(iframeWindow)) {
	            // 'New' quick views have a #page-container element generated by the pdf2html thing.
	            // This is the element we want to scroll on.
	            found = Dom_1.$$(iframeWindow.document.body).find('#page-container');
	        }
	        // If all else fails, we use the body
	        if (!found) {
	            found = Dom_1.$$(iframeWindow.document.body).el;
	        }
	        return found;
	    };
	    QuickviewDocument.prototype.isNewQuickviewDocument = function (iframeWindow) {
	        var meta = Dom_1.$$(iframeWindow.document.head).find('meta[name=\'generator\']');
	        return meta && meta.getAttribute('content') == 'pdf2htmlEX';
	    };
	    QuickviewDocument.prototype.handleTermsToHighlight = function (termsToHighlight, queryObject) {
	        var _this = this;
	        for (var term in this.result.termsToHighlight) {
	            delete this.result.termsToHighlight[term];
	        }
	        var query = '';
	        _.each(termsToHighlight, function (term) {
	            query += term + ' ';
	            _this.result.termsToHighlight[term] = new Array(term);
	        });
	        query = query.substring(0, query.length - 1);
	        queryObject.q = query;
	    };
	    QuickviewDocument.prototype.checkIfTermsToHighlightWereModified = function (termsToHighlight) {
	        if (!Utils_1.Utils.arrayEqual(termsToHighlight, _.keys(this.result.termsToHighlight))) {
	            this.termsToHighlightWereModified = true;
	        }
	    };
	    QuickviewDocument.prototype.getSaturatedColor = function (color) {
	        var r = parseInt(color.substring(4, 7));
	        var g = parseInt(color.substring(9, 12));
	        var b = parseInt(color.substring(14, 17));
	        var hsv = ColorUtils_1.ColorUtils.rgbToHsv(r, g, b);
	        hsv[1] *= 2;
	        if (hsv[1] > 1) {
	            hsv[1] = 1;
	        }
	        var rgb = ColorUtils_1.ColorUtils.hsvToRgb(hsv[0], hsv[1], hsv[2]);
	        return 'rgb(' + rgb[0].toString() + ', ' + rgb[1].toString() + ', ' + rgb[2].toString() + ')';
	    };
	    QuickviewDocument.prototype.animateScroll = function (scroll, scrollLeftValue, scrollTopValue, duration) {
	        if (duration === void 0) { duration = 100; }
	        var leftStep = Math.round((scrollLeftValue - scroll.scrollLeft) / duration);
	        var topStep = Math.round((scrollTopValue - scroll.scrollTop) / duration);
	        var interval = setInterval(function () {
	            if (duration != 0) {
	                scroll.scrollLeft += leftStep;
	                scroll.scrollTop += topStep;
	                duration -= 1;
	            }
	            else {
	                clearInterval(interval);
	            }
	        }, 1);
	    };
	    QuickviewDocument.ID = 'QuickviewDocument';
	    /**
	     * The options for the component
	     * @componentOptions
	     */
	    QuickviewDocument.options = {
	        /**
	         * Specifies the maximum document size (the preview) that should be returned by the index.
	         *
	         * By default its value is 0, and the whole preview is returned.
	         */
	        maximumDocumentSize: ComponentOptions_1.ComponentOptions.buildNumberOption({ defaultValue: 0, min: 0 }),
	    };
	    return QuickviewDocument;
	}(Component_1.Component));
	exports.QuickviewDocument = QuickviewDocument;
	Initialization_1.Initialization.registerAutoCreateComponent(QuickviewDocument);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var DefaultResultTemplate_1 = __webpack_require__(104);
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var Assert_1 = __webpack_require__(17);
	var QueryEvents_1 = __webpack_require__(47);
	var Model_1 = __webpack_require__(87);
	var QueryStateModel_1 = __webpack_require__(90);
	var QueryUtils_1 = __webpack_require__(23);
	var Dom_1 = __webpack_require__(57);
	var AnalyticsActionListMeta_1 = __webpack_require__(110);
	var Initialization_1 = __webpack_require__(95);
	var Defer_1 = __webpack_require__(31);
	var DeviceUtils_1 = __webpack_require__(20);
	var ResultListEvents_1 = __webpack_require__(48);
	var Utils_1 = __webpack_require__(18);
	var DomUtils_1 = __webpack_require__(59);
	var Recommendation_1 = __webpack_require__(117);
	var DefaultRecommendationTemplate_1 = __webpack_require__(129);
	/**
	 * This component is responsible for displaying the results of the current query using one or more result templates.<br/>
	 * It supports many additional features such as infinite scrolling.
	 *
	 * # Examples / samples
	 * This contains some quick example. Refer to result templates on developers.coveo.com for more information.
	 *
	 * ```html
	 * <!-- A very simple result list with a single underscore template.
	 * The template has no condition : It will load for all results.
	 * Every results will show the same template. -->
	 *
	 * <div class="CoveoResultList">
	 *   <script class="result-template" type="text/underscore" id='MyDefaultTemplate'>
	 *     <div>
	 *       <a class='CoveoResultLink'>Hey, click on this ! <%- title %></a>
	 *     </div>
	 *   </script>
	 * </div>
	 *
	 * <!-- 2 different template in the same result list : The first template has a condition attribute, the second one does not.
	 *
	 * The first condition will be evaluated against each result. If a result match this condition (in this case if the result.raw.objecttype property in the JSON equals MyObjectType) then the template will be rendered and the next template won't be rendered or evaluated for this result. -->
	 *
	 * If the result does not match the first template, the next one will be evaluated. Since the second one has no condition, it is always considered "true" and will load as a fallback.
	 *
	 * This process will repeat for each result that was returned by the query to the index. -->
	 *
	 * <div class="CoveoResultList">
	 *   <script class="result-template" type="text/underscore" data-condition='raw.objecttype==MyObjectType' id='MyObjectTypeTemplate'>
	 *     <div>
	 *       <a class='CoveoResultLink'>Hey, click on this ! <%- title %></a>
	 *       <div class='CoveoExcerpt'></div>
	 *       <span>This is a result for the type : <%- raw.objecttype %></span>
	 *     </div>
	 *   </script>
	 *
	 *   <script class="result-template" type="text/underscore">
	 *     <div>
	 *       <a class='CoveoResultLink'>Hey, click on this ! <%- title %></a>
	 *     </div>
	 *   </script>
	 * </div>
	 *
	 * <!-- 2 different template in the same result list : Both have a data-condition attribute.
	 *
	 * Same as before : the condition will be evaluated against all results.
	 *
	 * Since there is no "default" template with no condition specified, the framework will fallback on the default templates included in the framework if no template match a given result. This is to ensure that all results get rendered -->
	 *
	 * <div class="CoveoResultList">
	 *   <script class="result-template" type="text/underscore" data-condition='raw.objecttype==MyObjectType' id='MyObjectTypeTemplate'>
	 *     <div>
	 *       <a class='CoveoResultLink'>Hey, click on this ! <%- title %></a>
	 *       <div class='CoveoExcerpt'></div>
	 *       <span>This is a result for the type : <%- raw.objecttype %></span>
	 *      </div>
	 *   </script>
	 *
	 *   <script class="result-template" type="text/underscore" data-condition='raw.objecttype==MySecondObjectType' id='MySecondObjectTypeTemplate'>
	 *     <div>
	 *       <span class='CoveoIcon'></span>
	 *       <a class='CoveoResultLink'></a>
	 *     </div>
	 *     <div class='CoveoExcerpt'></div>
	 *     <div class='CoveoPrintableUri'></div>
	 *   </script>
	 * </div>
	 * ```
	 */
	var ResultList = (function (_super) {
	    __extends(ResultList, _super);
	    /**
	     * Create a new ResultList.<br/>
	     * Bind various event related to queries (eg : on querySuccess -> renderResults)<br/>
	     * Bind scroll event if infinite scrolling is enabled.
	     * @param element The HTMLElement on which the element will be instantiated.
	     * @param options The options for the ResultList.
	     * @param bindings The bindings that the component requires to function normally. If not set, will automatically resolve them (With slower execution time)
	     * @param elementClassId The class that this component should instantiate. By default this will be CoveoResultList. This is used by component that extends the base ResultList
	     */
	    function ResultList(element, options, bindings, elementClassId) {
	        var _this = this;
	        if (elementClassId === void 0) { elementClassId = ResultList.ID; }
	        _super.call(this, element, elementClassId, bindings);
	        this.element = element;
	        this.options = options;
	        this.bindings = bindings;
	        this.currentlyDisplayedResults = [];
	        this.reachedTheEndOfResults = false;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, ResultList, options);
	        Assert_1.Assert.exists(element);
	        Assert_1.Assert.exists(this.options);
	        Assert_1.Assert.exists(this.options.resultContainer);
	        Assert_1.Assert.exists(this.options.resultTemplate);
	        Assert_1.Assert.exists(this.options.waitAnimationContainer);
	        Assert_1.Assert.exists(this.options.infiniteScrollContainer);
	        this.showOrHideElementsDependingOnState(false, false);
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.newQuery, function (args) { return _this.handleNewQuery(); });
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.buildingQuery, function (args) { return _this.handleBuildingQuery(args); });
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.querySuccess, function (args) { return _this.handleQuerySuccess(args); });
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.duringQuery, function (args) { return _this.handleDuringQuery(); });
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.queryError, function (args) { return _this.handleQueryError(); });
	        if (this.options.enableInfiniteScroll) {
	            this.bind.on(this.options.infiniteScrollContainer, 'scroll', function (e) { return _this.handleScrollOfResultList(); });
	        }
	        this.bind.onQueryState(Model_1.MODEL_EVENTS.CHANGE_ONE, QueryStateModel_1.QUERY_STATE_ATTRIBUTES.FIRST, function () { return _this.handlePageChanged(); });
	    }
	    /**
	     * Empty the current result list content and append the given array of HTMLElement.<br/>
	     * Can append to existing elements in the result list, or replace them.<br/>
	     * Triggers the newResultDiplayed and newResultsDisplayed event
	     * @param resultsElement
	     * @param append
	     */
	    ResultList.prototype.renderResults = function (resultsElement, append) {
	        var _this = this;
	        if (append === void 0) { append = false; }
	        if (!append) {
	            this.options.resultContainer.innerHTML = '';
	        }
	        _.each(resultsElement, function (resultElement) {
	            _this.options.resultContainer.appendChild(resultElement);
	            _this.triggerNewResultDisplayed(Component_1.Component.getResult(resultElement), resultElement);
	        });
	        this.triggerNewResultsDisplayed();
	    };
	    /**
	     * Build and return an array of HTMLElement with the given result set.
	     * @param results
	     */
	    ResultList.prototype.buildResults = function (results) {
	        var _this = this;
	        var res = [];
	        _.each(results.results, function (result) {
	            var resultElement = _this.buildResult(result);
	            if (resultElement != null) {
	                res.push(resultElement);
	            }
	        });
	        ResultList.resultCurrentlyBeingRendered = null;
	        return res;
	    };
	    /**
	     * Build and return an HTMLElement for the given result.
	     * @param result
	     * @returns {HTMLElement}
	     */
	    ResultList.prototype.buildResult = function (result) {
	        Assert_1.Assert.exists(result);
	        QueryUtils_1.QueryUtils.setStateObjectOnQueryResult(this.queryStateModel.get(), result);
	        ResultList.resultCurrentlyBeingRendered = result;
	        var resultElement = this.options.resultTemplate.instantiateToElement(result);
	        if (resultElement != null) {
	            Component_1.Component.bindResultToElement(resultElement, result);
	        }
	        this.autoCreateComponentsInsideResult(resultElement, result);
	        return resultElement;
	    };
	    /**
	     * Execute a query to fetch new results. After the query is done, render those new results.<br/>
	     * Assert that there is actually more results to display by checking that the last query returned as many results as requested.<br/>
	     * Assert that the result list is not currently fetching results
	     * @param count The number of results to fetch and display
	     */
	    ResultList.prototype.displayMoreResults = function (count) {
	        var _this = this;
	        Assert_1.Assert.isLargerOrEqualsThan(1, count);
	        if (this.isCurrentlyFetchingMoreResults()) {
	            this.logger.warn('Ignoring request to display more results since we\'re already doing so');
	            return;
	        }
	        if (!this.hasPotentiallyMoreResultsToDisplay()) {
	            this.logger.warn('Ignoring request to display more results since we know there aren\'t more to display');
	            return;
	        }
	        if (this.options.enableInfiniteScrollWaitingAnimation) {
	            this.showWaitingAnimationForInfiniteScrolling();
	        }
	        this.fetchingMoreResults = this.queryController.fetchMore(count);
	        this.fetchingMoreResults.then(function (data) {
	            Assert_1.Assert.exists(data);
	            _this.usageAnalytics.logCustomEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.pagerScrolling, {}, _this.element);
	            var results = data.results;
	            _this.reachedTheEndOfResults = count > data.results.length;
	            _this.renderResults(_this.buildResults(data), true);
	            _.each(results, function (result) {
	                _this.currentlyDisplayedResults.push(result);
	            });
	            _this.triggerNewResultsDisplayed();
	        });
	        this.fetchingMoreResults.then(function () {
	            _this.hideWaitingAnimationForInfiniteScrolling();
	            _this.fetchingMoreResults = undefined;
	            Defer_1.Defer.defer(function () { return _this.handleScrollOfResultList(); });
	        });
	    };
	    /**
	     * Get the list of currently displayed result
	     * @returns {IQueryResult[]}
	     */
	    ResultList.prototype.getDisplayedResults = function () {
	        return this.currentlyDisplayedResults;
	    };
	    /**
	     * Get the list of currently displayed result HTMLElement
	     * @returns {HTMLElement[]}
	     */
	    ResultList.prototype.getDisplayedResultsElements = function () {
	        return Dom_1.$$(this.options.resultContainer).findAll('.CoveoResult');
	    };
	    ResultList.prototype.autoCreateComponentsInsideResult = function (element, result) {
	        Assert_1.Assert.exists(element);
	        var initOptions = this.searchInterface.options.originalOptionsObject;
	        var resultComponentBindings = _.extend({}, this.getBindings(), {
	            resultElement: element
	        });
	        var initParameters = {
	            options: initOptions,
	            bindings: resultComponentBindings,
	            result: result
	        };
	        Initialization_1.Initialization.automaticallyCreateComponentsInside(element, initParameters);
	    };
	    ResultList.prototype.triggerNewResultDisplayed = function (result, resultElement) {
	        var args = {
	            result: result,
	            item: resultElement
	        };
	        Dom_1.$$(this.element).trigger(ResultListEvents_1.ResultListEvents.newResultDisplayed, args);
	    };
	    ResultList.prototype.triggerNewResultsDisplayed = function () {
	        Dom_1.$$(this.element).trigger(ResultListEvents_1.ResultListEvents.newResultsDisplayed, {});
	    };
	    ResultList.prototype.handleDuringQuery = function () {
	        this.logger.trace('Emptying the result container');
	        this.cancelFetchingMoreResultsIfNeeded();
	        this.showWaitingAnimation();
	        this.showOrHideElementsDependingOnState(false, false);
	    };
	    ResultList.prototype.handleQueryError = function () {
	        this.hideWaitingAnimation();
	        Dom_1.$$(this.options.resultContainer).empty();
	        this.currentlyDisplayedResults = [];
	    };
	    ResultList.prototype.handleQuerySuccess = function (data) {
	        Assert_1.Assert.exists(data);
	        Assert_1.Assert.exists(data.results);
	        Dom_1.$$(this.element).toggle(!this.disabled);
	        if (!this.disabled) {
	            var results = data.results;
	            this.logger.trace('Received query results from new query', results);
	            this.hideWaitingAnimation();
	            ResultList.resultCurrentlyBeingRendered = undefined;
	            this.currentlyDisplayedResults = [];
	            this.renderResults(this.buildResults(data.results));
	            this.currentlyDisplayedResults = results.results;
	            this.reachedTheEndOfResults = false;
	            this.showOrHideElementsDependingOnState(true, this.currentlyDisplayedResults.length != 0);
	            if (this.options.enableInfiniteScroll && results.results.length == data.queryBuilder.numberOfResults) {
	                // This will check right away if we need to add more results to make the scroll container full & scrolling.
	                this.handleScrollOfResultList();
	            }
	            if (DeviceUtils_1.DeviceUtils.isMobileDevice() && this.options.mobileScrollContainer != undefined) {
	                this.options.mobileScrollContainer.scrollTop = 0;
	            }
	        }
	    };
	    ResultList.prototype.handleScrollOfResultList = function () {
	        if (this.isCurrentlyFetchingMoreResults() || !this.options.enableInfiniteScroll) {
	            return;
	        }
	        if (this.isScrollingOfResultListAlmostAtTheBottom() && this.hasPotentiallyMoreResultsToDisplay()) {
	            this.displayMoreResults(this.options.infiniteScrollPageSize);
	        }
	    };
	    ResultList.prototype.handlePageChanged = function () {
	        var _this = this;
	        this.bind.oneRootElement(QueryEvents_1.QueryEvents.querySuccess, function () {
	            if (_this.options.infiniteScrollContainer instanceof Window) {
	                var win = _this.options.infiniteScrollContainer;
	                win.scrollTo(0, 0);
	            }
	            else {
	                var el = _this.options.infiniteScrollContainer;
	                if (el.scrollIntoView) {
	                    el.scrollIntoView();
	                }
	            }
	        });
	    };
	    ResultList.prototype.handleNewQuery = function () {
	        Dom_1.$$(this.element).show();
	        ResultList.resultCurrentlyBeingRendered = undefined;
	    };
	    ResultList.prototype.handleBuildingQuery = function (args) {
	        if (this.options.fieldsToInclude != null) {
	            // remove the @
	            args.queryBuilder.addFieldsToInclude(_.map(this.options.fieldsToInclude, function (field) { return field.substr(1); }));
	        }
	        if (this.options.autoSelectFieldsToInclude) {
	            args.queryBuilder.addRequiredFields(this.getAutoSelectedFieldsToInclude());
	            args.queryBuilder.includeRequiredFields = true;
	        }
	    };
	    ResultList.prototype.getAutoSelectedFieldsToInclude = function () {
	        return _.chain(this.options.resultTemplate.getFields())
	            .compact()
	            .unique()
	            .value();
	    };
	    ResultList.prototype.isCurrentlyFetchingMoreResults = function () {
	        return Utils_1.Utils.exists(this.fetchingMoreResults);
	    };
	    ResultList.prototype.isScrollingOfResultListAlmostAtTheBottom = function () {
	        // this is in a try catch because the unit test fail otherwise (Window does not exist for phantom js in the console)
	        var isWindow;
	        try {
	            isWindow = this.options.infiniteScrollContainer instanceof Window;
	        }
	        catch (e) {
	            isWindow = false;
	        }
	        return isWindow ? this.isScrollAtBottomForWindowElement() : this.isScrollAtBottomForHtmlElement();
	    };
	    ResultList.prototype.isScrollAtBottomForWindowElement = function () {
	        var windowHeight = new Dom_1.Win(window).height();
	        var scrollTop = window.scrollY;
	        var bodyHeight = new Dom_1.Doc(document).height();
	        return bodyHeight - (windowHeight + scrollTop) < windowHeight / 2;
	    };
	    ResultList.prototype.isScrollAtBottomForHtmlElement = function () {
	        var el = this.options.infiniteScrollContainer;
	        var elementHeight = el.clientHeight;
	        var scrollHeight = el.scrollHeight;
	        var bottomPosition = el.scrollTop + elementHeight;
	        return (scrollHeight - bottomPosition) < elementHeight / 2;
	    };
	    ResultList.prototype.hasPotentiallyMoreResultsToDisplay = function () {
	        return this.currentlyDisplayedResults.length > 0 && !this.reachedTheEndOfResults;
	    };
	    ResultList.prototype.cancelFetchingMoreResultsIfNeeded = function () {
	        if (this.isCurrentlyFetchingMoreResults()) {
	            this.logger.trace('Cancelling fetching more results');
	            Promise.reject(this.fetchingMoreResults);
	            this.fetchingMoreResults = undefined;
	        }
	    };
	    ResultList.prototype.showOrHideElementsDependingOnState = function (hasQuery, hasResults) {
	        var showIfQuery = Dom_1.$$(this.element).findAll('.coveo-show-if-query');
	        var showIfNoQuery = Dom_1.$$(this.element).findAll('.coveo-show-if-no-query');
	        var showIfResults = Dom_1.$$(this.element).findAll('.coveo-show-if-results');
	        var showIfNoResults = Dom_1.$$(this.element).findAll('.coveo-show-if-no-results');
	        _.each(showIfQuery, function (s) {
	            Dom_1.$$(s).toggle(hasQuery);
	        });
	        _.each(showIfNoQuery, function (s) {
	            Dom_1.$$(s).toggle(!hasQuery);
	        });
	        _.each(showIfResults, function (s) {
	            Dom_1.$$(s).toggle(hasQuery && hasResults);
	        });
	        _.each(showIfNoResults, function (s) {
	            Dom_1.$$(s).toggle(hasQuery && !hasResults);
	        });
	    };
	    ResultList.prototype.showWaitingAnimation = function () {
	        switch (this.options.waitAnimation.toLowerCase()) {
	            case 'fade':
	                Dom_1.$$(this.options.waitAnimationContainer).addClass('coveo-fade-out');
	                break;
	            case 'spinner':
	                _.each(this.options.resultContainer.children, function (child) {
	                    Dom_1.$$(child).hide();
	                });
	                if (Dom_1.$$(this.options.waitAnimationContainer).find('.coveo-wait-animation') == undefined) {
	                    this.options.waitAnimationContainer.appendChild(DomUtils_1.DomUtils.getBasicLoadingAnimation());
	                }
	                break;
	        }
	    };
	    ResultList.prototype.hideWaitingAnimation = function () {
	        switch (this.options.waitAnimation.toLowerCase()) {
	            case 'fade':
	                Dom_1.$$(this.options.waitAnimationContainer).removeClass('coveo-fade-out');
	                break;
	            case 'spinner':
	                var spinner = Dom_1.$$(this.options.waitAnimationContainer).find('.coveo-loading-spinner');
	                if (spinner) {
	                    Dom_1.$$(spinner).detach();
	                }
	                break;
	        }
	    };
	    ResultList.prototype.showWaitingAnimationForInfiniteScrolling = function () {
	        this.options.waitAnimationContainer.appendChild(DomUtils_1.DomUtils.getLoadingSpinner());
	    };
	    ResultList.prototype.hideWaitingAnimationForInfiniteScrolling = function () {
	        var spinner = Dom_1.$$(this.options.waitAnimationContainer).find('.coveo-loading-spinner');
	        if (spinner) {
	            Dom_1.$$(spinner).detach();
	        }
	    };
	    ResultList.getDefaultTemplate = function (e) {
	        var component = Component_1.Component.get(e);
	        if (component.searchInterface instanceof Recommendation_1.Recommendation) {
	            return new DefaultRecommendationTemplate_1.DefaultRecommendationTemplate();
	        }
	        return new DefaultResultTemplate_1.DefaultResultTemplate();
	    };
	    ResultList.ID = 'ResultList';
	    /**
	     * The options for the ResultList
	     * @componentOptions
	     */
	    ResultList.options = {
	        /**
	         * Specifies the element within which the rendered templates for results are inserted.<br/>
	         * The content of this element is cleared when a new query is performed. If this option is not specified, a &lt;div&gt; element will by dynamically created in javascript and appended to the result list and used as a result container.<br/>
	         * You can change the container by specifying it's selector: Eg  data-result-container-selector="#someCssSelector"
	         */
	        resultContainer: ComponentOptions_1.ComponentOptions.buildChildHtmlElementOption({
	            defaultFunction: function (element) {
	                var d = document.createElement('div');
	                element.appendChild(d);
	                return d;
	            }
	        }),
	        resultTemplate: ComponentOptions_1.ComponentOptions.buildTemplateOption({ defaultFunction: ResultList.getDefaultTemplate }),
	        /**
	         * Specifies the type of animation to display while waiting for a new query to finish executing.<br/>
	         * Possible values are :<br/>
	         * 'fade' : Fades out the currently displayed results while the query is executing.<br/>
	         * 'spinner' : Shows a spinning animation while the query is executing.<br/>
	         * 'none' : Use no animation during queries.<br/>
	         * Default value is 'none'
	         */
	        waitAnimation: ComponentOptions_1.ComponentOptions.buildStringOption({ defaultValue: 'none' }),
	        /**
	         * Specifies the element inside which an animation is displayed while waiting for a new query to finish executing.<br/>
	         * You can change this by specifying a css selector.<br/>
	         * Eg : data-wait-animation-container-selector="#someCssSelector"
	         * By default, the animation appears in the the resultContainer.
	         */
	        waitAnimationContainer: ComponentOptions_1.ComponentOptions.buildChildHtmlElementOption({ postProcessing: function (value, options) { return value || options.resultContainer; } }),
	        /**
	         * Specifies whether the ResultList automatically retrieves an additional page of results and appends them to those already being displayed whenever the user scrolls to the end of the infiniteScrollContainer.<br/>
	         * The waitAnimation will be displayed while additional results are fetched.<br/>
	         * Default value is false
	         */
	        enableInfiniteScroll: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: false }),
	        /**
	         * When infiniteScroll is enabled, specifies the number of additional results that are fetched when the user scrolls to the bottom of the infiniteScrollContainer.<br/>
	         * Default value is 10
	         */
	        infiniteScrollPageSize: ComponentOptions_1.ComponentOptions.buildNumberOption({ defaultValue: 10, min: 1, depend: 'enableInfiniteScroll' }),
	        /**
	         * When infinite scrolling is enabled, specifies the element whose scrolling is monitored to trigger fetching of additional results.<br/>
	         * By default, the framework will try to find the first scrolling parent it encounter, starting from the ResultList itself<br/>
	         * This also means that if it encounter no parent that are scrollable (in css this means having overflow-y: scroll), then the window itself will be the scroll container
	         */
	        infiniteScrollContainer: ComponentOptions_1.ComponentOptions.buildChildHtmlElementOption({ depend: 'enableInfiniteScroll', defaultFunction: function (element) { return ComponentOptions_1.ComponentOptions.findParentScrolling(element); } }),
	        /**
	         * Specifies if the wait animation should be displayed when a query is being performed using infinite scroll.<br/>
	         * Default value is true
	         */
	        enableInfiniteScrollWaitingAnimation: ComponentOptions_1.ComponentOptions.buildBooleanOption({ depend: 'enableInfiniteScroll', defaultValue: true }),
	        mobileScrollContainer: ComponentOptions_1.ComponentOptions.buildSelectorOption({ defaultFunction: function () { return document.querySelector('.coveo-results-column'); } }),
	        /**
	         * Specifies a list of fields to include in the query.<br/>
	         * This is to ensure that fields that are not needed for the UI to function are not sent by the search API.<br/>
	         * By default, this list is empty.<br/>
	         * Note that this option has an interaction with autoSelectFieldsToInclude
	         */
	        fieldsToInclude: ComponentOptions_1.ComponentOptions.buildFieldsOption({ includeInResults: true }),
	        /**
	         * Specifies that the result list should scan it's template and discover which field it will need to render every results.<br/>
	         * This is to ensure that fields that are not needed for the UI to function are not sent by the search API.<br/>
	         * Default value is false.<br/>
	         * NB: Many interface created by the interface editor will actually explicitly set this option to true.
	         */
	        autoSelectFieldsToInclude: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: false })
	    };
	    ResultList.resultCurrentlyBeingRendered = null;
	    return ResultList;
	}(Component_1.Component));
	exports.ResultList = ResultList;
	Initialization_1.Initialization.registerAutoCreateComponent(ResultList);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Template_1 = __webpack_require__(100);
	var DefaultRecommendationTemplate = (function (_super) {
	    __extends(DefaultRecommendationTemplate, _super);
	    function DefaultRecommendationTemplate() {
	        _super.apply(this, arguments);
	    }
	    DefaultRecommendationTemplate.prototype.instantiateToString = function (object) {
	        var template = "<div class=\"coveo-result-frame\">\n        <div class=\"coveo-result-row\">\n          <div class=\"coveo-result-cell\" style=\"width:40px;text-align:center;vertical-align:middle;\">\n            <span class=\"CoveoIcon\" data-small=\"true\">\n            </span>\n          </div>\n          <div class=\"coveo-result-cell\" style=\"padding:0 0 3px 5px;vertical-align:middle\">\n            <div class=\"coveo-result-row\">\n              <div class=\"coveo-result-cell\" style=\"font-size:10pt;\">\n                <a class=\"CoveoResultLink\" style=\"display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis\">\n                </a>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>";
	        return template;
	    };
	    DefaultRecommendationTemplate.prototype.instantiateToElement = function (object) {
	        var div = document.createElement('div');
	        div.innerHTML = this.instantiateToString(object);
	        return div;
	    };
	    return DefaultRecommendationTemplate;
	}(Template_1.Template));
	exports.DefaultRecommendationTemplate = DefaultRecommendationTemplate;


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var QueryEvents_1 = __webpack_require__(47);
	var Initialization_1 = __webpack_require__(95);
	var Dom_1 = __webpack_require__(57);
	var Globalize = __webpack_require__(4);
	/**
	 * This simple component allows to display the result on an aggregate operation on the index.<br/>
	 * It hooks itself on the query to add a new group by request, then display the result.
	 */
	var Aggregate = (function (_super) {
	    __extends(Aggregate, _super);
	    /**
	     * Create a new `Aggregate` component
	     * @param element
	     * @param options
	     * @param bindings
	     */
	    function Aggregate(element, options, bindings) {
	        var _this = this;
	        _super.call(this, element, Aggregate.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, Aggregate, options);
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.buildingQuery, function (args) { return _this.handleBuildingQuery(args); });
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.querySuccess, function (args) { return _this.handleQuerySuccess(args); });
	        Dom_1.$$(this.element).hide();
	    }
	    Aggregate.prototype.handleBuildingQuery = function (args) {
	        var request = {
	            field: this.options.field,
	            maximumNumberOfValues: 0,
	            computedFields: [{
	                    field: this.options.field,
	                    operation: this.options.operation
	                }]
	        };
	        this.index = args.queryBuilder.groupByRequests.length;
	        args.queryBuilder.groupByRequests.push(request);
	    };
	    Aggregate.prototype.handleQuerySuccess = function (args) {
	        if (_.isNumber(this.index) && args.results.groupByResults.length != 0) {
	            var gbr = args.results.groupByResults[this.index];
	            var aggregate = gbr.globalComputedFieldResults[0];
	            Dom_1.$$(this.element).text(Globalize.format(aggregate, this.options.format));
	            Dom_1.$$(this.element).show();
	        }
	        else {
	            Dom_1.$$(this.element).hide();
	        }
	    };
	    Aggregate.ID = 'Aggregate';
	    /**
	     * The options for the component
	     * @componentOptions
	     */
	    Aggregate.options = {
	        /**
	         * The field on which you do the aggregate operation.
	         */
	        field: ComponentOptions_1.ComponentOptions.buildStringOption({ required: true }),
	        /**
	         * The aggregate operation to perform.<br/>
	         * The available values are:
	         * <ul>
	         *   <li>sum - Computes the sum of the computed field values.</li>
	         *   <li>average - Computes the average of the computed field values.</li>
	         *   <li>minimum - Finds the minimum value of the computed field values.</li>
	         *   <li>maximum - Finds the maximum value of the computed field values.</li>
	         * </ul><br/>
	         * The default value is sum.
	         */
	        operation: ComponentOptions_1.ComponentOptions.buildStringOption({ defaultValue: 'sum' }),
	        /**
	         * Specifies how to format the value.<br/>
	         * The formats available are defined by the Globalize library. The most common used formats are:
	         * <ul>
	         *   <li>c0 - Formats the value as a currency.</li>
	         *   <li>n0 - Formats the value as an integer.</li>
	         *   <li>n2 - Formats the value as a floating point with 2 decimal digits.</li>
	         * </ul>
	         * See : <a href='https://github.com/klaaspieter/jquery-global#globalizeformat-value-format-culture-'>Globalize</a> for more informations.<br/>
	         * Default value is `'c0`.
	         */
	        format: ComponentOptions_1.ComponentOptions.buildStringOption({ defaultValue: 'c0' })
	    };
	    return Aggregate;
	}(Component_1.Component));
	exports.Aggregate = Aggregate;
	Initialization_1.Initialization.registerAutoCreateComponent(Aggregate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Initialization_1 = __webpack_require__(95);
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var QueryEvents_1 = __webpack_require__(47);
	var Model_1 = __webpack_require__(87);
	var QueryStateModel_1 = __webpack_require__(90);
	var StandaloneSearchInterfaceEvents_1 = __webpack_require__(52);
	var AnalyticsActionListMeta_1 = __webpack_require__(110);
	var Dom_1 = __webpack_require__(57);
	var Assert_1 = __webpack_require__(17);
	var QueryboxQueryParameters_1 = __webpack_require__(132);
	/**
	 * A component that allows a user to enter a query inside an input.<br/>
	 * The component will trigger a query when submitted (the 'Enter' keypress) and log the proper analytics data.<br/>
	 * It must be instantiated on a div (and not directly on an input element): This is for styling purpose (ghost type ahead, for example).
	 */
	var Querybox = (function (_super) {
	    __extends(Querybox, _super);
	    /**
	     * Create a new Querybox.<br/>
	     * Create a new Coveo.Magicbox instance and wrap magic box method (on blur, on submit etc).<br/>
	     * Bind event on buildingQuery and on redirection (for standalone box).
	     * @param element The `HTMLElement` on which the element will be instantiated. This cannot be an `HTMLInputElement` for technical reasons.
	     * @param options The options for the querybox.
	     * @param bindings The bindings that the component requires to function normally. If not set, will automatically resolve them (with slower execution time).
	     */
	    function Querybox(element, options, bindings) {
	        var _this = this;
	        _super.call(this, element, Querybox.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.bindings = bindings;
	        if (element instanceof HTMLInputElement) {
	            this.logger.error('QueryBox can\'t be use on a HTMLInputElement');
	        }
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, Querybox, options);
	        this.magicBox = Coveo.MagicBox.create(element, new Coveo.MagicBox.Grammar('Query', {
	            Query: '[Term*][Spaces?]',
	            Term: '[Spaces?][Word]',
	            Spaces: / +/,
	            Word: /[^ ]+/
	        }), {
	            inline: true
	        });
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.buildingQuery, function (args) { return _this.handleBuildingQuery(args); });
	        this.bind.onRootElement(StandaloneSearchInterfaceEvents_1.StandaloneSearchInterfaceEvents.beforeRedirect, function () { return _this.updateQueryState(); });
	        this.bind.onQueryState(Model_1.MODEL_EVENTS.CHANGE_ONE, QueryStateModel_1.QUERY_STATE_ATTRIBUTES.Q, function (args) { return _this.handleQueryStateChanged(args); });
	        if (this.options.enableSearchAsYouType) {
	            Dom_1.$$(this.element).addClass('coveo-search-as-you-type');
	            this.magicBox.onchange = function () {
	                _this.searchAsYouType();
	            };
	        }
	        this.magicBox.onsubmit = function () {
	            _this.submit();
	        };
	        this.magicBox.onblur = function () {
	            _this.updateQueryState();
	        };
	        this.magicBox.onclear = function () {
	            _this.updateQueryState();
	            if (_this.options.triggerQueryOnClear) {
	                _this.usageAnalytics.logSearchEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.searchboxClear, {});
	                _this.triggerNewQuery(false);
	            }
	        };
	        if (this.options.autoFocus) {
	            this.magicBox.focus();
	        }
	    }
	    /**
	     * Trigger a query. The current input content will be added to the query.<br/>
	     * If the content of the input has not changed since the last submit, no new query will be triggered.
	     */
	    Querybox.prototype.submit = function () {
	        this.magicBox.clearSuggestion();
	        this.updateQueryState();
	        this.usageAnalytics.logSearchEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.searchboxSubmit, {});
	        this.triggerNewQuery(false);
	    };
	    /**
	     * Set the content of the input
	     * @param text The string to set in the input
	     */
	    Querybox.prototype.setText = function (text) {
	        this.magicBox.setText(text);
	        this.updateQueryState();
	    };
	    /**
	     * Clear the content of the input
	     */
	    Querybox.prototype.clear = function () {
	        this.magicBox.clear();
	    };
	    /**
	     * Get the current content of the input
	     * @returns {string}
	     */
	    Querybox.prototype.getText = function () {
	        return this.magicBox.getText();
	    };
	    Querybox.prototype.getResult = function () {
	        return this.magicBox.getResult();
	    };
	    Querybox.prototype.getDisplayedResult = function () {
	        return this.magicBox.getDisplayedResult();
	    };
	    Querybox.prototype.getCursor = function () {
	        return this.magicBox.getCursor();
	    };
	    Querybox.prototype.resultAtCursor = function (match) {
	        return this.magicBox.resultAtCursor(match);
	    };
	    Querybox.prototype.handleBuildingQuery = function (args) {
	        Assert_1.Assert.exists(args);
	        Assert_1.Assert.exists(args.queryBuilder);
	        this.updateQueryState();
	        this.lastQuery = this.magicBox.getText();
	        new QueryboxQueryParameters_1.QueryboxQueryParameters(this.options).addParameters(args.queryBuilder, this.lastQuery);
	    };
	    Querybox.prototype.triggerNewQuery = function (searchAsYouType) {
	        clearTimeout(this.searchAsYouTypeTimeout);
	        var text = this.magicBox.getText();
	        if (this.lastQuery != text && text != null) {
	            this.lastQuery = text;
	            this.queryController.executeQuery({
	                searchAsYouType: searchAsYouType,
	                logInActionsHistory: true
	            });
	        }
	    };
	    Querybox.prototype.updateQueryState = function () {
	        this.queryStateModel.set(QueryStateModel_1.QueryStateModel.attributesEnum.q, this.magicBox.getText());
	    };
	    Querybox.prototype.handleQueryStateChanged = function (args) {
	        Assert_1.Assert.exists(args);
	        var q = args.value;
	        if (q != this.magicBox.getText()) {
	            this.magicBox.setText(q);
	        }
	    };
	    Querybox.prototype.searchAsYouType = function () {
	        var _this = this;
	        clearTimeout(this.searchAsYouTypeTimeout);
	        this.searchAsYouTypeTimeout = setTimeout(function () {
	            _this.usageAnalytics.logSearchAsYouType(AnalyticsActionListMeta_1.analyticsActionCauseList.searchboxAsYouType, {});
	            _this.triggerNewQuery(true);
	        }, this.options.searchAsYouTypeDelay);
	    };
	    Querybox.ID = 'Querybox';
	    /**
	     * The options for the Querybox.
	     * @componentOptions
	     */
	    Querybox.options = {
	        /**
	         * Specify if search as you type should be enabled.<br/>
	         * Default to `false`.
	         */
	        enableSearchAsYouType: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: false }),
	        /**
	         * If `enableSearchAsYouType` is enabled, this option specify the delay (in ms) between a keypress and a query being triggered<br/>
	         * Default to 500 ms.
	         */
	        searchAsYouTypeDelay: ComponentOptions_1.ComponentOptions.buildNumberOption({ defaultValue: 500, min: 0 }),
	        /**
	         * Specifies whether the Coveo Platform does try to interpret special query syntax such as field references in the query entered through the query box.<br/>
	         * The default value is `true`.
	         */
	        enableQuerySyntax: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true }),
	        /**
	         * Specifies whether the Coveo Platform expands keywords containing wildcard characters (*) to the possible matching keywords to broaden the query.<br/>
	         * The default value is `false`.
	         */
	        enableWildcards: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: false }),
	        /**
	         * Specifies whether the Coveo Platform expands keywords containing question mark characters (?) to the possible matching keywords to broaden the query.<br/>
	         * The default value is `false`.
	         */
	        enableQuestionMarks: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: false }),
	        /**
	         * If true, the or and and keywords in the query box will be treated as boolean operators for the query when they are typed in lowercase.<br/>
	         * This applies for all operators<br/>
	         * Default value is `false`.
	         */
	        enableLowercaseOperators: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: false }),
	        /**
	         * Specifies whether a query containing a large number of keywords (see partialMatchKeywords) is automatically converted to a partial match expression in order to match documents containing only a subset of the keywords (see partialMatchThreshold for defining the subset).<br/>
	         * The default value is `false`.
	         */
	        enablePartialMatch: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: false }),
	        /**
	         * When partial match is enabled, specifies the minimum number of keywords that must be present in the query to activate the partial match.<br/>
	         * The default value is 5.
	         */
	        partialMatchKeywords: ComponentOptions_1.ComponentOptions.buildNumberOption({ defaultValue: 5, min: 1 }),
	        /**
	         * When partial match is enabled, specifies either an absolute or percentage value indicating the minimum number of keywords a document must contain in order to match the query.<br/>
	         * The default value is 50%.
	         */
	        partialMatchThreshold: ComponentOptions_1.ComponentOptions.buildStringOption({ defaultValue: '50%' }),
	        /**
	         * Specifies whether or not to trigger a query when the searchbox is cleared.
	         * The default value is `true`.
	         */
	        triggerQueryOnClear: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true }),
	        /**
	         *  Specifies a placeholder for input.
	         */
	        placeholder: ComponentOptions_1.ComponentOptions.buildStringOption(),
	        /**
	         * Specifies whether the `QueryBox` gets the focus and is selected on initialization.
	         * The default value is `true`.
	         */
	        autoFocus: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true })
	    };
	    return Querybox;
	}(Component_1.Component));
	exports.Querybox = Querybox;
	Initialization_1.Initialization.registerAutoCreateComponent(Querybox);


/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var QueryboxQueryParameters = (function () {
	    function QueryboxQueryParameters(options) {
	        this.options = options;
	    }
	    QueryboxQueryParameters.prototype.addParameters = function (queryBuilder, lastQuery) {
	        if (this.options.enableWildcards) {
	            queryBuilder.enableWildcards = true;
	        }
	        if (this.options.enableQuestionMarks) {
	            queryBuilder.enableQuestionMarks = true;
	        }
	        if (this.options.enableLowercaseOperators) {
	            queryBuilder.enableLowercaseOperators = true;
	        }
	        if (!_.isEmpty(lastQuery)) {
	            queryBuilder.disableQuerySyntax = !this.options.enableQuerySyntax;
	            queryBuilder.expression.add(lastQuery);
	            if (this.options.enablePartialMatch) {
	                queryBuilder.enablePartialMatch = this.options.enablePartialMatch;
	                if (this.options.partialMatchKeywords) {
	                    queryBuilder.partialMatchKeywords = this.options.partialMatchKeywords;
	                }
	                if (this.options.partialMatchThreshold) {
	                    queryBuilder.partialMatchThreshold = this.options.partialMatchThreshold;
	                }
	            }
	        }
	    };
	    return QueryboxQueryParameters;
	}());
	exports.QueryboxQueryParameters = QueryboxQueryParameters;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var Utils_1 = __webpack_require__(18);
	var Dom_1 = __webpack_require__(57);
	var Strings_1 = __webpack_require__(34);
	var AnalyticsActionListMeta_1 = __webpack_require__(110);
	var Initialization_1 = __webpack_require__(95);
	/**
	 * A component that allows user to trigger a query by clicking on it.<br/>
	 * This component will instantiate on an element and add a search icon.<br/>
	 * It will also sends an analytics event to the Coveo platform when clicked.
	 */
	var SearchButton = (function (_super) {
	    __extends(SearchButton, _super);
	    /**
	     * Create a new SearchButton on the given element with the given options.
	     * Bind a click event on the element
	     * Adds a search icon on the element
	     * @param element
	     * @param options
	     * @param bindings
	     */
	    function SearchButton(element, options, bindings) {
	        var _this = this;
	        _super.call(this, element, SearchButton.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.bind.on(element, 'click', function () { return _this.handleClick(); });
	        // Provide a magnifier icon if element contains nothing
	        if (Utils_1.Utils.trim(Dom_1.$$(this.element).text()) == '') {
	            element.innerHTML = '<span class=\'coveo-icon\'>' + Strings_1.l('Search') + '</span>';
	        }
	    }
	    /**
	     * Trigger the click handler
	     */
	    SearchButton.prototype.click = function () {
	        this.handleClick();
	    };
	    SearchButton.prototype.handleClick = function () {
	        this.logger.debug('Performing query following button click');
	        this.usageAnalytics.logSearchEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.searchboxSubmit, {});
	        this.queryController.executeQuery();
	    };
	    SearchButton.ID = 'SearchButton';
	    SearchButton.options = {};
	    return SearchButton;
	}(Component_1.Component));
	exports.SearchButton = SearchButton;
	Initialization_1.Initialization.registerAutoCreateComponent(SearchButton);


/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var Omnibox_1 = __webpack_require__(135);
	var ComponentOptions_1 = __webpack_require__(98);
	var SearchButton_1 = __webpack_require__(133);
	var Querybox_1 = __webpack_require__(131);
	var Dom_1 = __webpack_require__(57);
	var Initialization_1 = __webpack_require__(95);
	/**
	 * This component is mostly used for simplicity purpose because it creates 2 components that are very frequently used together.<br/>
	 * This component attaches itself to a div and takes care of instantiating a {@link Querybox} component or a {@link Omnibox} component, depending on the options.<br/>
	 * Add a {@link SearchButton} component if desired, and appends them to the same div.
	 */
	var Searchbox = (function (_super) {
	    __extends(Searchbox, _super);
	    /**
	     * Create a new Searchbox<br/>
	     * Create a new Coveo.Magicbox instance and wrap magic box method (on blur, on submit etc).<br/>
	     * Bind event on `buildingQuery` and on redirection (for standalone box).
	     * @param element The `HTMLElement` on which the element will be instantiated. This cannot be an `HTMLInputElement` for technical reason
	     * @param options The options for the component. Will be merged with the options from the component set directly on the `HTMLElement`.
	     * @param bindings The bindings that the component requires to function normally. If not set, will automatically resolve them (with slower execution time).
	     */
	    function Searchbox(element, options, bindings) {
	        _super.call(this, element, Searchbox.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, Searchbox, options);
	        if (this.options.inline) {
	            Dom_1.$$(element).addClass('coveo-inline');
	        }
	        if (this.options.addSearchButton) {
	            var anchor = document.createElement('a');
	            this.element.appendChild(anchor);
	            this.searchButton = new SearchButton_1.SearchButton(anchor, undefined, bindings);
	        }
	        var div = document.createElement('div');
	        this.element.appendChild(div);
	        if (this.options.enableOmnibox) {
	            this.searchbox = new Omnibox_1.Omnibox(div, this.options, bindings);
	        }
	        else {
	            this.searchbox = new Querybox_1.Querybox(div, this.options, bindings);
	        }
	    }
	    Searchbox.ID = 'Searchbox';
	    Searchbox.parent = Omnibox_1.Omnibox;
	    /**
	     * Possible options for the {@link Searchbox}
	     * @componentOptions
	     */
	    Searchbox.options = {
	        /**
	         * Specifies whether the search box instantiates a {@link SearchButton}.<br/>
	         * Default value is `true`.
	         */
	        addSearchButton: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true }),
	        /**
	         * Specifies whether the search box instantiates a {@link Omnibox} component.<br/>
	         * Otherwise, the search box instantiates a {@link Querybox} component.<br/>
	         * Default value is `false`.
	         */
	        enableOmnibox: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: false })
	    };
	    return Searchbox;
	}(Component_1.Component));
	exports.Searchbox = Searchbox;
	Searchbox.options = _.extend({}, Searchbox.options, Omnibox_1.Omnibox.options, Querybox_1.Querybox.options);
	// Only parse omnibox option if omnibox is enabled
	_.each(Searchbox.options, function (value, key) {
	    if (key in Omnibox_1.Omnibox.options && !(key in Querybox_1.Querybox.options)) {
	        Searchbox.options[key] = _.extend({ depend: 'enableOmnibox' }, value);
	    }
	});
	Initialization_1.Initialization.registerAutoCreateComponent(Searchbox);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var QueryEvents_1 = __webpack_require__(47);
	var StandaloneSearchInterfaceEvents_1 = __webpack_require__(52);
	var Model_1 = __webpack_require__(87);
	var QueryStateModel_1 = __webpack_require__(90);
	var AnalyticsActionListMeta_1 = __webpack_require__(110);
	var OmniboxEvents_1 = __webpack_require__(45);
	var Dom_1 = __webpack_require__(57);
	var Assert_1 = __webpack_require__(17);
	var QueryStateModel_2 = __webpack_require__(90);
	var Initialization_1 = __webpack_require__(95);
	var Querybox_1 = __webpack_require__(131);
	var FieldAddon_1 = __webpack_require__(136);
	var QueryExtensionAddon_1 = __webpack_require__(137);
	var RevealQuerySuggestAddon_1 = __webpack_require__(138);
	var OldOmniboxAddon_1 = __webpack_require__(139);
	var QueryboxQueryParameters_1 = __webpack_require__(132);
	var PendingSearchAsYouTypeSearchEvent_1 = __webpack_require__(115);
	var Utils_1 = __webpack_require__(18);
	var ExternalModulesShim_1 = __webpack_require__(25);
	var MINIMUM_EXECUTABLE_CONFIDENCE = 0.8;
	/**
	 * This component is very similar to the simpler {@link Querybox} component and support all the same options/behavior except for the search-as-you-type feature.<br/>
	 * In addition, it takes care of adding a type-ahead capability. The type-ahead and the suggestions it displays are customizable and extensible by any custom component.<br/>
	 * The type-ahead is configurable by activating addon which are provided OOTB (facets, analytics suggestions, Reveal suggestions, and advanced Coveo syntax suggestions).<br/>
	 * It is also possible for external code to provide suggestions.
	 */
	var Omnibox = (function (_super) {
	    __extends(Omnibox, _super);
	    /**
	     * Create a new omnibox with, enable required addons, and bind events on letious query events.
	     */
	    function Omnibox(element, options, bindings) {
	        var _this = this;
	        _super.call(this, element, Omnibox.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.partialQueries = [];
	        this.lastSuggestions = [];
	        this.movedOnce = false;
	        this.skipRevealAutoSuggest = false;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, Omnibox, options);
	        var grammar;
	        if (this.options.enableQuerySyntax) {
	            grammar = ExternalModulesShim_1.MagicBox.Grammars.Expressions(ExternalModulesShim_1.MagicBox.Grammars.Complete);
	            if (this.options.enableFieldAddon) {
	                new FieldAddon_1.FieldAddon(this);
	            }
	            if (this.options.fieldAlias != null) {
	                this.options.listOfFields = this.options.listOfFields || [];
	                this.options.listOfFields = this.options.listOfFields.concat(_.keys(this.options.fieldAlias));
	            }
	            if (this.options.enableQueryExtensionAddon) {
	                new QueryExtensionAddon_1.QueryExtensionAddon(this);
	            }
	        }
	        else {
	            grammar = { start: 'Any', expressions: { Any: /.*/ } };
	        }
	        if (this.options.enableRevealQuerySuggestAddon) {
	            new RevealQuerySuggestAddon_1.RevealQuerySuggestAddon(this);
	        }
	        new OldOmniboxAddon_1.OldOmniboxAddon(this);
	        if (this.options.grammar != null) {
	            grammar = this.options.grammar(grammar);
	        }
	        this.magicBox = ExternalModulesShim_1.MagicBox.create(element, new ExternalModulesShim_1.MagicBox.Grammar(grammar.start, grammar.expressions), {
	            inline: this.options.inline,
	            selectableSuggestionClass: 'coveo-omnibox-selectable',
	            selectedSuggestionClass: 'coveo-omnibox-selected',
	            suggestionTimeout: this.options.omniboxTimeout
	        });
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.buildingQuery, function (args) { return _this.handleBuildingQuery(args); });
	        this.bind.onRootElement(StandaloneSearchInterfaceEvents_1.StandaloneSearchInterfaceEvents.beforeRedirect, function () { return _this.handleBeforeRedirect(); });
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.querySuccess, function () { return _this.handleQuerySuccess(); });
	        this.bind.onQueryState(Model_1.MODEL_EVENTS.CHANGE_ONE, QueryStateModel_1.QUERY_STATE_ATTRIBUTES.Q, function (args) { return _this.handleQueryStateChanged(args); });
	        if (this.isRevealAutoSuggestion()) {
	            this.bind.onRootElement(QueryEvents_1.QueryEvents.duringQuery, function (args) { return _this.handleDuringQuery(args); });
	        }
	        this.setupMagicBox();
	    }
	    /**
	     * Trigger a query. The current input content will be added to the query.<br/>
	     * If the content of the input has not changed since the last submit, no new query will be triggered.
	     */
	    Omnibox.prototype.submit = function () {
	        var _this = this;
	        this.magicBox.clearSuggestion();
	        this.updateQueryState();
	        this.triggerNewQuery(false, function () {
	            _this.usageAnalytics.logSearchEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.searchboxSubmit, {});
	        });
	    };
	    /**
	     * Get the current content of the input
	     * @returns {string}
	     */
	    Omnibox.prototype.getText = function () {
	        return this.magicBox.getText();
	    };
	    /**
	     * Set the content of the input
	     * @param text The string to set in the input
	     */
	    Omnibox.prototype.setText = function (text) {
	        this.magicBox.setText(text);
	        this.updateQueryState();
	    };
	    /**
	     * Clear the content of the input
	     */
	    Omnibox.prototype.clear = function () {
	        this.magicBox.clear();
	    };
	    /**
	     * Get the `HTMLInputElement` of the omnibox
	     */
	    Omnibox.prototype.getInput = function () {
	        return this.magicBox.element.querySelector('input');
	    };
	    Omnibox.prototype.getResult = function () {
	        return this.magicBox.getResult();
	    };
	    Omnibox.prototype.getDisplayedResult = function () {
	        return this.magicBox.getDisplayedResult();
	    };
	    Omnibox.prototype.getCursor = function () {
	        return this.magicBox.getCursor();
	    };
	    Omnibox.prototype.resultAtCursor = function (match) {
	        return this.magicBox.resultAtCursor(match);
	    };
	    Omnibox.prototype.setupMagicBox = function () {
	        var _this = this;
	        this.magicBox.onmove = function () {
	            // We assume that once the user has moved it's selection, it becomes an explicit omnibox analytics event
	            if (_this.isRevealAutoSuggestion()) {
	                _this.modifyEventTo = AnalyticsActionListMeta_1.analyticsActionCauseList.omniboxAnalytics;
	            }
	            _this.movedOnce = true;
	        };
	        this.magicBox.onfocus = function () {
	            if (_this.isRevealAutoSuggestion()) {
	                // This flag is used to block the automatic query when the UI is loaded with a query (#q=foo)
	                // and then the input is focused. We want to block that query, even if it match the suggestion
	                // Only when there is an actual change in the input (user typing something) is when we want the automatic query to kick in
	                _this.skipRevealAutoSuggest = true;
	            }
	        };
	        this.magicBox.onsuggestions = function (suggestions) {
	            // If text is empty, this can mean that user selected text from the search box
	            // and hit "delete" : Reset the partial queries in this case
	            if (Utils_1.Utils.isEmptyString(_this.getText())) {
	                _this.partialQueries = [];
	            }
	            _this.movedOnce = false;
	            _this.lastSuggestions = suggestions;
	            if (_this.isRevealAutoSuggestion() && !_this.skipRevealAutoSuggest) {
	                _this.searchAsYouType();
	            }
	        };
	        if (this.options.enableSearchAsYouType) {
	            Dom_1.$$(this.element).addClass('coveo-magicbox-search-as-you-type');
	        }
	        this.magicBox.onchange = function () {
	            _this.skipRevealAutoSuggest = false;
	            var text = _this.getText();
	            if (text != undefined && text != '') {
	                if (_this.isRevealAutoSuggestion()) {
	                    if (_this.movedOnce) {
	                        _this.searchAsYouType(true);
	                    }
	                }
	                else if (_this.options.enableSearchAsYouType) {
	                    _this.searchAsYouType(true);
	                }
	            }
	            else {
	                _this.clear();
	            }
	        };
	        if (this.options.placeholder) {
	            this.magicBox.element.querySelector('input').placeholder = this.options.placeholder;
	        }
	        this.magicBox.onsubmit = function () {
	            _this.magicBox.clearSuggestion();
	            _this.updateQueryState();
	            _this.triggerNewQuery(false, function () {
	                _this.usageAnalytics.logSearchEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.searchboxSubmit, {});
	            });
	        };
	        this.magicBox.onselect = function (suggestion) {
	            var index = _.indexOf(_this.lastSuggestions, suggestion);
	            var suggestions = _.map(_this.lastSuggestions, function (suggestion) { return suggestion.text; });
	            _this.magicBox.clearSuggestion();
	            _this.updateQueryState();
	            // A bit tricky here : When it's reveal auto suggestions
	            // the mouse selection and keyboard selection acts differently :
	            // keyboard selection will automatically do the query (which will log a search as you type event -> further modified by this.modifyEventTo if needed)
	            // mouse selection will not "auto" send the query.
	            // the movedOnce variable detect the keyboard movement, and is used to differentiate mouse vs keyboard
	            if (!_this.isRevealAutoSuggestion()) {
	                _this.usageAnalytics.cancelAllPendingEvents();
	                _this.triggerNewQuery(false, function () {
	                    _this.usageAnalytics.logSearchEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.omniboxAnalytics, _this.buildCustomDataForPartialQueries(index, suggestions));
	                });
	            }
	            else if (_this.isRevealAutoSuggestion() && _this.movedOnce) {
	                _this.handleRevealAutoSuggestionWithKeyboard(index, suggestions);
	            }
	            else if (_this.isRevealAutoSuggestion() && !_this.movedOnce) {
	                _this.handleRevealAutoSuggestionsWithMouse(index, suggestions);
	            }
	            // Consider a selection like a reset of the partial queries (it's the end of a suggestion pattern)
	            if (_this.isRevealAutoSuggestion()) {
	                _this.partialQueries = [];
	            }
	        };
	        this.magicBox.onblur = function () {
	            if (_this.options.enableSearchAsYouType && !_this.options.inline) {
	                _this.setText(_this.lastQuery);
	            }
	            else {
	                _this.updateQueryState();
	            }
	            if (_this.isRevealAutoSuggestion()) {
	                _this.usageAnalytics.sendAllPendingEvents();
	            }
	        };
	        this.magicBox.onclear = function () {
	            _this.updateQueryState();
	            if (_this.options.triggerQueryOnClear) {
	                _this.triggerNewQuery(false, function () {
	                    _this.usageAnalytics.logSearchEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.searchboxClear, {});
	                });
	            }
	        };
	        if (this.options.autoFocus) {
	            this.magicBox.focus();
	        }
	        this.magicBox.getSuggestions = function () { return _this.handleSuggestions(); };
	    };
	    Omnibox.prototype.handleRevealAutoSuggestionWithKeyboard = function (index, suggestions) {
	        var _this = this;
	        if (this.searchAsYouTypeTimeout) {
	            // Here, there is currently a search as you typed queued up :
	            // Think : user typed very quickly, then very quickly selected a suggestion (without waiting for the search as you type)
	            // Cancel the search as you type query, then immediately do the query with the selection (+analytics event with the selection)
	            this.usageAnalytics.cancelAllPendingEvents();
	            clearTimeout(this.searchAsYouTypeTimeout);
	            this.searchAsYouTypeTimeout = undefined;
	            this.triggerNewQuery(false, function () {
	                _this.usageAnalytics.logSearchEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.omniboxAnalytics, _this.buildCustomDataForPartialQueries(index, suggestions));
	            });
	        }
	        else {
	            // Here, the search as you type query has returned, but the analytics event has not ye been sent.
	            // Think : user typed slowly, the query returned, and then the user selected a suggestion.
	            // Since the analytics event has not yet been sent (search as you type event have a 5 sec delay)
	            // modify the pending event, then send the newly modified analytics event immediately.
	            this.modifyEventTo = AnalyticsActionListMeta_1.analyticsActionCauseList.omniboxAnalytics;
	            this.modifyCustomDataOnPending(index, suggestions);
	            this.usageAnalytics.sendAllPendingEvents();
	        }
	    };
	    Omnibox.prototype.handleRevealAutoSuggestionsWithMouse = function (index, suggestions) {
	        var _this = this;
	        if (this.searchAsYouTypeTimeout || index != 0) {
	            // Here : the user either very quickly chose the first suggestion, and the search as you type is still queued up.
	            // OR
	            // the user chose something different then the first suggestion.
	            // Remove the search as you type if it's there, and do the query with the suggestion directly.
	            this.clearSearchAsYouType();
	            this.usageAnalytics.cancelAllPendingEvents();
	            this.triggerNewQuery(false, function () {
	                _this.usageAnalytics.logSearchEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.omniboxAnalytics, _this.buildCustomDataForPartialQueries(index, suggestions));
	            });
	        }
	        else {
	            // Here : the user either very slowly chose a suggestion, and there is no search as you typed queued up
	            // AND
	            // the user chose the first suggestion.
	            // this means the query is already returned, but the analytics event is still queued up.
	            // modify the analytics event, and send it.
	            this.modifyEventTo = AnalyticsActionListMeta_1.analyticsActionCauseList.omniboxAnalytics;
	            this.modifyCustomDataOnPending(index, suggestions);
	            this.usageAnalytics.sendAllPendingEvents();
	        }
	    };
	    Omnibox.prototype.modifyCustomDataOnPending = function (index, suggestions) {
	        var pendingEvt = this.usageAnalytics.getPendingSearchEvent();
	        if (pendingEvt instanceof PendingSearchAsYouTypeSearchEvent_1.PendingSearchAsYouTypeSearchEvent) {
	            var newCustomData_1 = this.buildCustomDataForPartialQueries(index, suggestions);
	            _.each(_.keys(newCustomData_1), function (k) {
	                pendingEvt.modifyCustomData(k, newCustomData_1[k]);
	            });
	        }
	    };
	    Omnibox.prototype.buildCustomDataForPartialQueries = function (index, suggestions) {
	        return {
	            partialQueries: this.cleanCustomData(this.partialQueries),
	            suggestionRanking: index,
	            suggestions: this.cleanCustomData(suggestions),
	            partialQuery: _.last(this.partialQueries)
	        };
	    };
	    Omnibox.prototype.cleanCustomData = function (toClean, rejectLength) {
	        if (rejectLength === void 0) { rejectLength = 256; }
	        // Filter out only consecutive values that are the identical
	        toClean = _.filter(toClean, function (partial, pos, array) {
	            return pos === 0 || partial !== array[pos - 1];
	        });
	        // Custom dimensions cannot be an array in analytics service: Send a string joined by ; instead.
	        // Need to replace ;
	        toClean = _.map(toClean, function (partial) {
	            return partial.replace(/;/g, '');
	        });
	        // Reduce right to get the last X words that adds to less then rejectLength
	        var reducedToRejectLengthOrLess = [];
	        _.reduceRight(toClean, function (memo, partial) {
	            var totalSoFar = memo + partial.length;
	            if (totalSoFar <= rejectLength) {
	                reducedToRejectLengthOrLess.push(partial);
	            }
	            return totalSoFar;
	        }, 0);
	        toClean = reducedToRejectLengthOrLess.reverse();
	        var ret = toClean.join(';');
	        // analytics service can store max 256 char in a custom event
	        // if we're over that, call cleanup again with an arbitrary 10 less char accepted
	        if (ret.length >= 256) {
	            return this.cleanCustomData(toClean, rejectLength - 10);
	        }
	        return toClean.join(';');
	    };
	    Omnibox.prototype.handleSuggestions = function () {
	        var suggestionsEventArgs = {
	            suggestions: [],
	            omnibox: this
	        };
	        this.bind.trigger(this.element, OmniboxEvents_1.OmniboxEvents.populateOmniboxSuggestions, suggestionsEventArgs);
	        var text = this.getText();
	        if (!Utils_1.Utils.isNullOrEmptyString(text)) {
	            this.partialQueries.push(text);
	        }
	        return suggestionsEventArgs.suggestions;
	    };
	    Omnibox.prototype.handleBeforeRedirect = function () {
	        this.updateQueryState();
	    };
	    Omnibox.prototype.handleBuildingQuery = function (data) {
	        var _this = this;
	        Assert_1.Assert.exists(data);
	        Assert_1.Assert.exists(data.queryBuilder);
	        this.updateQueryState();
	        this.lastQuery = this.getQuery(data.searchAsYouType);
	        var result = this.lastQuery == this.magicBox.getDisplayedResult().input ? this.magicBox.getDisplayedResult().clone() : this.magicBox.grammar.parse(this.lastQuery).clean();
	        var preprocessResultForQueryArgs = {
	            result: result
	        };
	        if (this.options.enableQuerySyntax) {
	            var notQuotedValues = preprocessResultForQueryArgs.result.findAll('FieldValueNotQuoted');
	            _.each(notQuotedValues, function (value) { return value.value = '"' + value.value.replace(/"|\u00A0/g, ' ') + '"'; });
	            if (this.options.fieldAlias) {
	                var fieldNames = preprocessResultForQueryArgs.result.findAll(function (result) { return result.expression.id == 'FieldName' && result.isSuccess(); });
	                _.each(fieldNames, function (result) {
	                    var alias = _.find(_.keys(_this.options.fieldAlias), function (alias) { return alias.toLowerCase() == result.value.toLowerCase(); });
	                    if (alias != null) {
	                        result.value = _this.options.fieldAlias[alias];
	                    }
	                });
	            }
	        }
	        this.bind.trigger(this.element, OmniboxEvents_1.OmniboxEvents.omniboxPreprocessResultForQuery, preprocessResultForQueryArgs);
	        var query = preprocessResultForQueryArgs.result.toString();
	        new QueryboxQueryParameters_1.QueryboxQueryParameters(this.options).addParameters(data.queryBuilder, query);
	    };
	    Omnibox.prototype.triggerNewQuery = function (searchAsYouType, analyticsEvent) {
	        clearTimeout(this.searchAsYouTypeTimeout);
	        var text = this.getQuery(searchAsYouType);
	        if (this.shouldExecuteQuery(searchAsYouType)) {
	            this.lastQuery = text;
	            analyticsEvent();
	            this.queryController.executeQuery({
	                searchAsYouType: searchAsYouType,
	                logInActionsHistory: true
	            });
	        }
	    };
	    Omnibox.prototype.getQuery = function (searchAsYouType) {
	        var query;
	        if (searchAsYouType) {
	            query = this.magicBox.getWordCompletion();
	            if (query == null && this.lastSuggestions != null && this.lastSuggestions.length > 0) {
	                var textSuggestion = _.find(this.lastSuggestions, function (suggestion) { return suggestion.text != null; });
	                if (textSuggestion != null) {
	                    query = textSuggestion.text;
	                }
	            }
	        }
	        return query || this.magicBox.getText();
	    };
	    Omnibox.prototype.updateQueryState = function () {
	        this.queryStateModel.set(QueryStateModel_2.QueryStateModel.attributesEnum.q, this.magicBox.getText());
	    };
	    Omnibox.prototype.handleQueryStateChanged = function (args) {
	        Assert_1.Assert.exists(args);
	        var q = args.value;
	        if (q != this.magicBox.getText()) {
	            this.magicBox.setText(q);
	        }
	    };
	    Omnibox.prototype.handleQuerySuccess = function () {
	        if (!this.isRevealAutoSuggestion()) {
	            this.partialQueries = [];
	        }
	    };
	    Omnibox.prototype.handleDuringQuery = function (args) {
	        var _this = this;
	        // When the query results returns ... (args.promise)
	        args.promise.then(function () {
	            // Get a handle on a pending search as you type (those events are delayed, not sent instantly)
	            var pendingEvent = _this.usageAnalytics.getPendingSearchEvent();
	            if (pendingEvent instanceof PendingSearchAsYouTypeSearchEvent_1.PendingSearchAsYouTypeSearchEvent) {
	                pendingEvent.beforeResolve.then(function (evt) {
	                    // Check if we need to modify the event type beforeResolving it
	                    args.promise.then(function () {
	                        if (_this.modifyEventTo) {
	                            evt.modifyEventCause(_this.modifyEventTo);
	                            _this.modifyEventTo = null;
	                        }
	                    });
	                });
	            }
	        });
	    };
	    Omnibox.prototype.searchAsYouType = function (forceExecuteQuery) {
	        var _this = this;
	        if (forceExecuteQuery === void 0) { forceExecuteQuery = false; }
	        this.clearSearchAsYouType();
	        if (this.shouldExecuteQuery(true)) {
	            this.searchAsYouTypeTimeout = setTimeout(function () {
	                if (_this.suggestionShouldTriggerQuery() || forceExecuteQuery) {
	                    var suggestions_1 = _.map(_this.lastSuggestions, function (suggestion) { return suggestion.text; });
	                    var index_1 = _.indexOf(suggestions_1, _this.magicBox.getWordCompletion());
	                    _this.triggerNewQuery(true, function () {
	                        _this.usageAnalytics.logSearchAsYouType(AnalyticsActionListMeta_1.analyticsActionCauseList.searchboxAsYouType, _this.buildCustomDataForPartialQueries(index_1, suggestions_1));
	                    });
	                    _this.clearSearchAsYouType();
	                }
	            }, this.options.searchAsYouTypeDelay);
	        }
	    };
	    Omnibox.prototype.isRevealAutoSuggestion = function () {
	        return this.options.enableSearchAsYouType && this.options.enableRevealQuerySuggestAddon;
	    };
	    Omnibox.prototype.shouldExecuteQuery = function (searchAsYouType) {
	        var text = this.getQuery(searchAsYouType);
	        return this.lastQuery != text && text != null;
	    };
	    Omnibox.prototype.suggestionShouldTriggerQuery = function (suggestions) {
	        if (suggestions === void 0) { suggestions = this.lastSuggestions; }
	        if (this.shouldExecuteQuery(true)) {
	            if (suggestions && suggestions[0]) {
	                var suggestion = suggestions[0];
	                // If we have access to a confidence level, return true if we are equal or above the minimum confidence level.
	                if (suggestion && suggestion.executableConfidence != undefined) {
	                    return suggestion.executableConfidence >= MINIMUM_EXECUTABLE_CONFIDENCE;
	                }
	                // If we don't have access to a confidence level, return true only if it "starts with" the content of the search box
	                if (suggestion.text && suggestion.text.indexOf(this.magicBox.getText()) == 0) {
	                    return true;
	                }
	            }
	        }
	        return false;
	    };
	    Omnibox.prototype.clearSearchAsYouType = function () {
	        clearTimeout(this.searchAsYouTypeTimeout);
	        this.searchAsYouTypeTimeout = undefined;
	    };
	    Omnibox.ID = 'Omnibox';
	    /**
	     * The options for the omnibox
	     * @componentOptions
	     */
	    Omnibox.options = {
	        /**
	         * Specifies that suggestions appearing in the omnibox should push the result down, instead of appearing over the results.<br/>
	         * Activate this as well a `SearchAsYouType` + Reveal suggestions for a cool effect!<br/>
	         * Default value is false
	         */
	        inline: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: false }),
	        /**
	         * Specifies whether a new query is automatically triggered whenever the user types new text inside the query box.<br/>
	         * Activate this as well a inline + Reveal suggestions for a cool effect!<br/>
	         * The default is `false`.
	         */
	        enableSearchAsYouType: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: false }),
	        /**
	         * When search as you type is enabled, specifies the delay in milliseconds before a new query is triggered when the user types new text inside the query box.<br/>
	         * The default value is 2000 milliseconds.
	         */
	        searchAsYouTypeDelay: ComponentOptions_1.ComponentOptions.buildNumberOption({
	            defaultValue: 2000,
	            min: 0,
	            depend: 'enableSearchAsYouType'
	        }),
	        /**
	         * Specifies whether the field addon should be enabled.<br/>
	         * The field addon allows the search box to highlight and complete field syntax.<br/>
	         * Default value is `false`.
	         *
	         * > Example:
	         * > You want to filter on a file type. You start typing @sysf and matching fields are proposed. You select the @sysfiletype suggestion, enter = and the available matching file types are proposed.
	         */
	        enableFieldAddon: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: false, depend: 'enableQuerySyntax' }),
	        enableSimpleFieldAddon: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: false, depend: 'enableFieldAddon' }),
	        listOfFields: ComponentOptions_1.ComponentOptions.buildFieldsOption({ depend: 'enableFieldAddon' }),
	        /**
	         * Specifies whether the Reveal query suggestions should be enabled.<br/>
	         * This implies that your integration has a proper Reveal integration configured.<br/>
	         * Default value is `false`.
	         */
	        enableRevealQuerySuggestAddon: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: false, alias: 'enableTopQueryAddon' }),
	        /**
	         * Specifies whether the query extension addon should be enabled.<br/>
	         * This allows the omnibox to complete the syntax for query extensions.<br/>
	         * Default value is `false`.
	         */
	        enableQueryExtensionAddon: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: false, depend: 'enableQuerySyntax' }),
	        /**
	         * Specifies a placeholder for input
	         */
	        placeholder: ComponentOptions_1.ComponentOptions.buildStringOption(),
	        /**
	         * Specifies a timeout before rejecting suggestions in the omnibox.<br/>
	         * Default value is 2000 (2 seconds).
	         */
	        omniboxTimeout: ComponentOptions_1.ComponentOptions.buildNumberOption({ defaultValue: 2000 })
	    };
	    return Omnibox;
	}(Component_1.Component));
	exports.Omnibox = Omnibox;
	Omnibox.options = _.extend({}, Omnibox.options, Querybox_1.Querybox.options);
	Initialization_1.Initialization.registerAutoCreateComponent(Omnibox);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var OmniboxEvents_1 = __webpack_require__(45);
	var ExternalModulesShim_1 = __webpack_require__(25);
	var FieldAddon = (function () {
	    function FieldAddon(omnibox) {
	        var _this = this;
	        this.omnibox = omnibox;
	        this.cache = {};
	        this.omnibox.bind.on(this.omnibox.element, OmniboxEvents_1.OmniboxEvents.populateOmniboxSuggestions, function (args) {
	            args.suggestions.push(_this.getSuggestion());
	        });
	    }
	    FieldAddon.prototype.getSuggestion = function () {
	        var _this = this;
	        var hash = this.getHash();
	        if (hash == null) {
	            return null;
	        }
	        var hashString = this.hashToString(hash);
	        if (this.cache[hashString] != null) {
	            return this.hashValueToSuggestion(hash, this.cache[hashString]);
	        }
	        var values;
	        if (hash.type == 'FieldName') {
	            values = this.fieldNames(hash.current);
	        }
	        if (hash.type == 'FieldValue') {
	            values = this.fieldValues(hash.field, hash.current);
	        }
	        if (hash.type == 'SimpleFieldName') {
	            values = this.simpleFieldNames(hash.current);
	        }
	        this.cache[hashString] = values;
	        values.catch(function () {
	            delete _this.cache[hashString];
	        });
	        return this.hashValueToSuggestion(hash, values);
	    };
	    FieldAddon.prototype.getHash = function () {
	        var fieldName = _.last(this.omnibox.resultAtCursor('FieldName'));
	        if (fieldName != null) {
	            fieldName = fieldName.findParent('Field') || fieldName;
	            var currentField = fieldName.toString();
	            var before = fieldName.before();
	            var after = fieldName.after();
	            return { type: 'FieldName', current: currentField, before: before, after: after };
	        }
	        var fieldValue = _.last(this.omnibox.resultAtCursor('FieldValue'));
	        if (fieldValue) {
	            var fieldQuery = fieldValue.findParent('FieldQuery') || (this.omnibox.options.enableSimpleFieldAddon && fieldValue.findParent('FieldSimpleQuery'));
	            if (fieldQuery) {
	                var field = fieldQuery.find('FieldName').toString();
	                if (this.omnibox.options.fieldAlias) {
	                    if (field in this.omnibox.options.fieldAlias) {
	                        field = this.omnibox.options.fieldAlias[field];
	                    }
	                }
	                var value = fieldValue.toString();
	                var before = fieldValue.before();
	                var after = fieldValue.after();
	                return { type: 'FieldValue', field: field, current: value, before: before, after: after };
	            }
	        }
	        if (this.omnibox.options.enableSimpleFieldAddon) {
	            var word = _.last(this.omnibox.resultAtCursor('Word'));
	            if (word != null) {
	                var currentField = word.toString();
	                var before = word.before();
	                var after = word.after();
	                return { type: 'SimpleFieldName', current: currentField, before: before, after: after };
	            }
	        }
	    };
	    FieldAddon.prototype.hashToString = function (hash) {
	        if (hash == null) {
	            return null;
	        }
	        return hash.type + hash.current + (hash.field || '');
	    };
	    FieldAddon.prototype.hashValueToSuggestion = function (hash, promise) {
	        return promise.then(function (values) {
	            var suggestions = _.map(values, function (value, i) {
	                return {
	                    text: hash.before + (hash.current.toLowerCase().indexOf(value.toLowerCase()) == 0 ? hash.current + value.substr(hash.current.length) : value) + hash.after,
	                    html: ExternalModulesShim_1.MagicBox.Utils.highlightText(value, hash.current, true),
	                    index: FieldAddon.INDEX - i / values.length
	                };
	            });
	            return suggestions;
	        });
	    };
	    FieldAddon.prototype.getFields = function () {
	        var _this = this;
	        if (this.fields == null) {
	            this.fields = new Promise(function (resolve, reject) {
	                if (_this.omnibox.options.listOfFields != null) {
	                    resolve(_this.omnibox.options.listOfFields);
	                }
	                else {
	                    var promise = _this.omnibox.queryController.getEndpoint().listFields();
	                    promise.then(function (fieldDescriptions) {
	                        var fieldNames = _.chain(fieldDescriptions)
	                            .filter(function (fieldDescription) { return fieldDescription.includeInQuery && fieldDescription.groupByField; })
	                            .map(function (fieldDescription) { return fieldDescription.name.substr(1); })
	                            .value();
	                        resolve(fieldNames);
	                    }).catch(function () {
	                        reject();
	                    });
	                }
	            });
	        }
	        return this.fields;
	    };
	    FieldAddon.prototype.fieldNames = function (current) {
	        var withAt = current.length > 0 && current[0] == '@';
	        var fieldName = withAt ? current.substr(1) : current;
	        var fieldNameLC = fieldName.toLowerCase();
	        return this.getFields().then(function (fields) {
	            var matchFields = _.chain(fields)
	                .map(function (field) {
	                return {
	                    index: field.toLowerCase().indexOf(fieldNameLC),
	                    field: withAt ? field : '@' + field
	                };
	            })
	                .filter(function (field) {
	                return field.index != -1 && field.field.length > current.length;
	            })
	                .sortBy('index')
	                .map(function (field) { return field.field; })
	                .value();
	            matchFields = _.first(matchFields, 5);
	            return matchFields;
	        });
	    };
	    FieldAddon.prototype.fieldValues = function (field, current) {
	        return this.omnibox.queryController.getEndpoint().listFieldValues({
	            pattern: '.*' + current + '.*',
	            patternType: 'RegularExpression',
	            sortCriteria: 'occurrences',
	            field: '@' + field,
	            maximumNumberOfValues: 5
	        }).then(function (values) {
	            return _.chain(values)
	                .map(function (value) {
	                return {
	                    index: value.value.toLowerCase().indexOf(current),
	                    value: value.value
	                };
	            })
	                .filter(function (value) {
	                return value.value.length > current.length;
	            })
	                .sortBy('index')
	                .map(function (value) {
	                return value.value.replace(/ /g, '\u00A0');
	            })
	                .value();
	        });
	    };
	    FieldAddon.prototype.simpleFieldNames = function (current) {
	        var fieldName = current;
	        var fieldNameLC = fieldName.toLowerCase();
	        return this.getFields().then(function (fields) {
	            var matchFields = _.chain(fields)
	                .map(function (field) {
	                return {
	                    index: field.toLowerCase().indexOf(fieldNameLC),
	                    field: field + ':'
	                };
	            })
	                .filter(function (field) {
	                return field.index != -1 && field.field.length > current.length;
	            })
	                .sortBy('index')
	                .map(function (field) { return field.field; })
	                .value();
	            matchFields = _.first(matchFields, 5);
	            return matchFields;
	        });
	    };
	    FieldAddon.INDEX = 64;
	    return FieldAddon;
	}());
	exports.FieldAddon = FieldAddon;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	///<reference path='Omnibox.ts'/>
	var OmniboxEvents_1 = __webpack_require__(45);
	var ExternalModulesShim_1 = __webpack_require__(25);
	var QueryExtensionAddon = (function () {
	    function QueryExtensionAddon(omnibox) {
	        var _this = this;
	        this.omnibox = omnibox;
	        this.cache = {};
	        this.omnibox.bind.on(this.omnibox.element, OmniboxEvents_1.OmniboxEvents.populateOmniboxSuggestions, function (args) {
	            args.suggestions.push(_this.getSuggestion());
	        });
	    }
	    QueryExtensionAddon.prototype.getSuggestion = function () {
	        var _this = this;
	        var hash = this.getHash(this.omnibox.magicBox);
	        if (hash == null) {
	            return null;
	        }
	        var hashString = this.hashToString(hash);
	        if (this.cache[hashString] != null) {
	            return this.hashValueToSuggestion(hash, this.cache[hashString]);
	        }
	        var values = (hash.type == 'QueryExtensionName' ? this.names(hash.current) : this.attributeNames(hash.name, hash.current, hash.used));
	        this.cache[hashString] = values;
	        values.catch(function () {
	            delete _this.cache[hashString];
	        });
	        return this.hashValueToSuggestion(hash, values);
	    };
	    QueryExtensionAddon.prototype.getHash = function (magicBox) {
	        var queryExtension = _.last(magicBox.resultAtCursor('QueryExtension'));
	        if (queryExtension != null) {
	            var queryExtensionArgumentResults = queryExtension.findAll('QueryExtensionArgument');
	            var current = _.last(magicBox.resultAtCursor('QueryExtensionName'));
	            if (current != null) {
	                return {
	                    type: 'QueryExtensionName',
	                    current: current.toString(),
	                    before: current.before(),
	                    after: current.after()
	                };
	            }
	            current = _.last(magicBox.resultAtCursor('QueryExtensionArgumentName'));
	            if (current != null) {
	                var used = _.chain(queryExtensionArgumentResults)
	                    .map(function (result) {
	                    var name = result.find('QueryExtensionArgumentName');
	                    return name && name.toString();
	                })
	                    .compact()
	                    .value();
	                var name = queryExtension.find('QueryExtensionName').toString();
	                return {
	                    type: 'QueryExtensionArgumentName',
	                    current: current.toString(),
	                    before: current.before(),
	                    after: current.after(),
	                    name: name,
	                    used: used
	                };
	            }
	        }
	        return null;
	    };
	    QueryExtensionAddon.prototype.hashToString = function (hash) {
	        if (hash == null) {
	            return null;
	        }
	        return [hash.type, hash.current, (hash.name || ''), (hash.used ? hash.used.join() : '')].join();
	    };
	    QueryExtensionAddon.prototype.hashValueToSuggestion = function (hash, promise) {
	        return promise.then(function (values) {
	            var suggestions = _.map(values, function (value, i) {
	                return {
	                    html: ExternalModulesShim_1.MagicBox.Utils.highlightText(value, hash.current, true),
	                    text: hash.before + value + hash.after,
	                    index: QueryExtensionAddon.INDEX - i / values.length
	                };
	            });
	            return suggestions;
	        });
	    };
	    QueryExtensionAddon.prototype.getExtensions = function () {
	        if (this.extensions == null) {
	            this.extensions = this.omnibox.queryController.getEndpoint().extensions();
	        }
	        return this.extensions;
	    };
	    QueryExtensionAddon.prototype.names = function (current) {
	        var extensionName = current.toLowerCase();
	        return this.getExtensions().then(function (extensions) {
	            var matchExtensions = _.chain(extensions)
	                .map(function (extension) {
	                return {
	                    index: extension.name.toLowerCase().indexOf(extensionName),
	                    extension: extension.name
	                };
	            })
	                .filter(function (extension) {
	                return extension.index != -1 && extension.extension.length > extensionName.length;
	            })
	                .sortBy('index')
	                .pluck('extension')
	                .value();
	            matchExtensions = _.first(matchExtensions, 5);
	            return matchExtensions;
	        });
	    };
	    QueryExtensionAddon.prototype.attributeNames = function (name, current, used) {
	        return this.getExtensions().then(function (extensions) {
	            var extension = _.find(extensions, function (extension) { return extension.name == name; });
	            if (extension == null) {
	                return [];
	            }
	            else {
	                return _.filter(_.difference(extension.argumentNames, used), function (argumentName) { return argumentName.indexOf(current) == 0; });
	            }
	        });
	    };
	    QueryExtensionAddon.prototype.hash = function () {
	        return;
	    };
	    QueryExtensionAddon.INDEX = 62;
	    return QueryExtensionAddon;
	}());
	exports.QueryExtensionAddon = QueryExtensionAddon;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var Dom_1 = __webpack_require__(57);
	var ComponentOptionsModel_1 = __webpack_require__(91);
	var OmniboxEvents_1 = __webpack_require__(45);
	var StringUtils_1 = __webpack_require__(61);
	var RevealQuerySuggestAddon = (function () {
	    function RevealQuerySuggestAddon(omnibox) {
	        var _this = this;
	        this.omnibox = omnibox;
	        this.cache = {};
	        Dom_1.$$(this.omnibox.element).on(OmniboxEvents_1.OmniboxEvents.populateOmniboxSuggestions, function (e, args) {
	            args.suggestions.push(_this.getSuggestion());
	        });
	    }
	    RevealQuerySuggestAddon.suggestiontHtml = function (suggestion) {
	        return suggestion.highlighted.replace(/\[(.*?)\]|\{(.*?)\}|\((.*?)\)/g, function (part, notMatched, matched, corrected) {
	            var className = '';
	            if (matched) {
	                className = 'coveo-omnibox-hightlight';
	            }
	            if (corrected) {
	                className = 'coveo-omnibox-hightlight2';
	            }
	            return RevealQuerySuggestAddon.suggestiontHtmlTemplate({
	                className: className,
	                text: notMatched || matched || corrected
	            });
	        });
	    };
	    RevealQuerySuggestAddon.isPartialMatch = function (suggestion) {
	        // groups : 1=notMatched, 2=matched, 3=corrected
	        var parts = StringUtils_1.StringUtils.match(suggestion.highlighted, /\[(.*?)\]|\{(.*?)\}|\((.*?)\)/g);
	        var firstFail = _.find(parts, function (part) { return part[1] != null; });
	        // if no fail found, this is a partial or a full match
	        if (firstFail == null) {
	            return true;
	        }
	        // if all right parts are notMatched, the right parts is autocomplete
	        return _.every(_.last(parts, _.indexOf(parts, firstFail) - parts.length), function (part) { return part[1] != null; });
	    };
	    RevealQuerySuggestAddon.prototype.getSuggestion = function () {
	        var _this = this;
	        var text = this.omnibox.magicBox.getText();
	        if (text.length == 0) {
	            return null;
	        }
	        if (this.cache[text] != null) {
	            return this.cache[text];
	        }
	        var promise = this.getRevealQuerySuggest(text);
	        this.cache[text] = promise;
	        promise.catch(function () {
	            delete _this.cache[text];
	        });
	        return this.cache[text];
	    };
	    RevealQuerySuggestAddon.prototype.getRevealQuerySuggest = function (text) {
	        var payload = { q: text }, language = String['locale'], searchHub = this.omnibox.getBindings().componentOptionsModel.get(ComponentOptionsModel_1.ComponentOptionsModel.attributesEnum.searchHub), pipeline = this.omnibox.getBindings().searchInterface.options.pipeline;
	        if (language) {
	            payload.language = language;
	        }
	        if (searchHub) {
	            payload.searchHub = searchHub;
	        }
	        if (pipeline) {
	            payload.pipeline = pipeline;
	        }
	        return this.omnibox.queryController.getEndpoint()
	            .getRevealQuerySuggest(payload)
	            .then(function (result) {
	            var completions = result.completions;
	            var results = _.map(completions, function (completion, i) {
	                return {
	                    html: RevealQuerySuggestAddon.suggestiontHtml(completion),
	                    text: completion.expression,
	                    index: RevealQuerySuggestAddon.INDEX - i / completions.length,
	                    partial: RevealQuerySuggestAddon.isPartialMatch(completion),
	                    executableConfidence: completion.executableConfidence
	                };
	            });
	            return results;
	        });
	    };
	    RevealQuerySuggestAddon.INDEX = 60;
	    RevealQuerySuggestAddon.suggestiontHtmlTemplate = _.template('<span<%= className? \' class="\'+className+\'"\':\'\' %>><%- text %></span>');
	    return RevealQuerySuggestAddon;
	}());
	exports.RevealQuerySuggestAddon = RevealQuerySuggestAddon;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var OmniboxEvents_1 = __webpack_require__(45);
	var Dom_1 = __webpack_require__(57);
	var Utils_1 = __webpack_require__(18);
	var OldOmniboxAddon = (function () {
	    function OldOmniboxAddon(omnibox) {
	        var _this = this;
	        this.omnibox = omnibox;
	        this.omnibox.bind.on(this.omnibox.element, OmniboxEvents_1.OmniboxEvents.populateOmniboxSuggestions, function (args) {
	            _.each(_this.getSuggestion(), function (suggestion) {
	                args.suggestions.push(suggestion);
	            });
	        });
	    }
	    OldOmniboxAddon.prototype.getSuggestion = function () {
	        var text = this.omnibox.magicBox.getText();
	        if (text.length == 0) {
	            return null;
	        }
	        if (this.lastQuery == text) {
	            return this.lastSuggestions;
	        }
	        this.lastQuery = text;
	        var eventArgs = this.buildPopulateOmniboxEventArgs();
	        Dom_1.$$(this.omnibox.element).trigger(OmniboxEvents_1.OmniboxEvents.populateOmnibox, eventArgs);
	        return this.lastSuggestions = this.rowsToSuggestions(eventArgs.rows);
	    };
	    OldOmniboxAddon.prototype.getCurrentQueryExpression = function () {
	        var cursorPos = this.omnibox.getCursor();
	        var value = this.omnibox.getText();
	        var length = value.length;
	        var start = cursorPos;
	        var end = cursorPos;
	        if (value[start] == ' ') {
	            start--;
	        }
	        while (start > 0 && value[start] != ' ') {
	            start--;
	        }
	        while (end < length && value[end] != ' ') {
	            end++;
	        }
	        return value.substring(start, end);
	    };
	    OldOmniboxAddon.prototype.getRegexToSearch = function (strValue) {
	        if (strValue == null) {
	            strValue = this.omnibox.getText();
	        }
	        return new RegExp(Utils_1.Utils.escapeRegexCharacter(strValue), 'i');
	    };
	    OldOmniboxAddon.prototype.getQueryExpressionBreakDown = function () {
	        var _this = this;
	        var ret = [];
	        var queryWords = this.omnibox.getText().split(' ');
	        _.each(queryWords, function (word) {
	            ret.push({
	                word: word,
	                regex: _this.getRegexToSearch(word)
	            });
	        });
	        return ret;
	    };
	    OldOmniboxAddon.prototype.replace = function (searchValue, newValue) {
	        this.omnibox.setText(this.omnibox.getText().replace(searchValue, newValue));
	    };
	    OldOmniboxAddon.prototype.clearCurrentExpression = function () {
	        this.replace(this.getCurrentQueryExpression(), '');
	    };
	    OldOmniboxAddon.prototype.insertAt = function (at, toInsert) {
	        var oldValue = this.omnibox.getText();
	        var newValue = [oldValue.slice(0, at), toInsert, oldValue.slice(at)].join('');
	        this.omnibox.setText(newValue);
	    };
	    OldOmniboxAddon.prototype.replaceCurrentExpression = function (newValue) {
	        this.replace(this.getCurrentQueryExpression(), newValue);
	    };
	    OldOmniboxAddon.prototype.buildPopulateOmniboxEventArgs = function () {
	        var _this = this;
	        var currentQueryExpression = this.getCurrentQueryExpression();
	        var ret = {
	            rows: [],
	            completeQueryExpression: {
	                word: this.omnibox.getText(),
	                regex: this.getRegexToSearch()
	            },
	            currentQueryExpression: {
	                word: currentQueryExpression,
	                regex: this.getRegexToSearch(currentQueryExpression)
	            },
	            allQueryExpressions: this.getQueryExpressionBreakDown(),
	            cursorPosition: this.omnibox.getCursor(),
	            clear: function () {
	                _this.omnibox.clear();
	            },
	            clearCurrentExpression: function () {
	                _this.clearCurrentExpression();
	            },
	            replace: function (searchValue, newValue) {
	                _this.replace(searchValue, newValue);
	            },
	            replaceCurrentExpression: function (newValue) {
	                _this.replaceCurrentExpression(newValue);
	            },
	            insertAt: function (at, toInsert) {
	                _this.insertAt(at, toInsert);
	            },
	            closeOmnibox: function () {
	                _this.omnibox.magicBox.blur();
	            }
	        };
	        return ret;
	    };
	    OldOmniboxAddon.prototype.rowsToSuggestions = function (rows) {
	        return _.map(rows, function (row) {
	            if (!Utils_1.Utils.isNullOrUndefined(row.element)) {
	                return new Promise(function (resolve) {
	                    resolve([{
	                            dom: row.element,
	                            index: row.zIndex
	                        }]);
	                });
	            }
	            else if (!Utils_1.Utils.isNullOrUndefined(row.deferred)) {
	                return new Promise(function (resolve) {
	                    row.deferred.then(function (row) {
	                        if (row.element != null) {
	                            resolve([{
	                                    dom: row.element,
	                                    index: row.zIndex
	                                }]);
	                        }
	                        else {
	                            resolve(null);
	                        }
	                    });
	                });
	            }
	            return null;
	        });
	    };
	    return OldOmniboxAddon;
	}());
	exports.OldOmniboxAddon = OldOmniboxAddon;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var InitializationEvents_1 = __webpack_require__(44);
	var BreadcrumbEvents_1 = __webpack_require__(41);
	var AnalyticsActionListMeta_1 = __webpack_require__(110);
	var Dom_1 = __webpack_require__(57);
	var Strings_1 = __webpack_require__(34);
	var Initialization_1 = __webpack_require__(95);
	var QueryEvents_1 = __webpack_require__(47);
	var KeyboardUtils_1 = __webpack_require__(68);
	/**
	 * This component displays a summary of the filters currently active in the query.
	 *
	 * For example, when the user selects a facet value, the value is displayed in the breadcrumbs.
	 *
	 * The active filters are obtained by the component by firing an event in the breadcrumb component.
	 *
	 * All other components having an active state can answer to this event by providing custom bits of HTML that will be displayed inside the breadcrumb.
	 *
	 * Thus, the breadcrumb can easily be extended by custom code to display information about custom state and filters.
	 *
	 * See {@link BreadcrumbEvents} for the list of events and parameters sent when a breadcrumb is populated.
	 */
	var Breadcrumb = (function (_super) {
	    __extends(Breadcrumb, _super);
	    /**
	     * Create a new breadcrumb element, bind event on `deferredQuerySuccess` to draw the breadcrumb.
	     * @param element
	     * @param options
	     * @param bindings
	     */
	    function Breadcrumb(element, options, bindings) {
	        var _this = this;
	        _super.call(this, element, Breadcrumb.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, Breadcrumb, options);
	        this.bind.oneRootElement(InitializationEvents_1.InitializationEvents.afterInitialization, function () { return _this.handleAfterInitialization(); });
	        this.bind.onRootElement(BreadcrumbEvents_1.BreadcrumbEvents.redrawBreadcrumb, function () { return _this.redrawBreadcrumb(); });
	        this.element.style.display = 'none';
	    }
	    /**
	     * Trigger the event to populate breadcrumb, which component such as {@link Facet} can populate.<br/>
	     * Will trigger an event with {@link IPopulateBreadcrumbEventArgs} object (an array) which other components or code can populate.
	     * @returns {IBreadcrumbItem[]}
	     */
	    Breadcrumb.prototype.getBreadcrumbs = function () {
	        var args = { breadcrumbs: [] };
	        this.bind.trigger(this.root, BreadcrumbEvents_1.BreadcrumbEvents.populateBreadcrumb, args);
	        this.logger.debug('Retrieved breadcrumbs', args.breadcrumbs);
	        this.lastBreadcrumbs = args.breadcrumbs;
	        return args.breadcrumbs;
	    };
	    /**
	     * Trigger the event to clear the current breadcrumbs, that {@link Facet} can populate.<br/>
	     * Trigger a new query, and log a search event.
	     */
	    Breadcrumb.prototype.clearBreadcrumbs = function () {
	        var args = {};
	        this.bind.trigger(this.root, BreadcrumbEvents_1.BreadcrumbEvents.clearBreadcrumb, args);
	        this.logger.debug('Clearing breadcrumbs');
	        this.usageAnalytics.logSearchEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.breadcrumbResetAll, {});
	        this.queryController.executeQuery();
	    };
	    /**
	     * Draw the given breadcrumbs items.
	     * @param breadcrumbs
	     */
	    Breadcrumb.prototype.drawBreadcrumb = function (breadcrumbs) {
	        var _this = this;
	        Dom_1.$$(this.element).empty();
	        if (breadcrumbs.length != 0) {
	            this.element.style.display = '';
	        }
	        else {
	            this.element.style.display = 'none';
	        }
	        var breadcrumbItems = document.createElement('div');
	        Dom_1.$$(breadcrumbItems).addClass('coveo-breadcrumb-items');
	        this.element.appendChild(breadcrumbItems);
	        _.each(breadcrumbs, function (bcrumb) {
	            var elem = bcrumb.element;
	            Dom_1.$$(elem).addClass('coveo-breadcrumb-item');
	            breadcrumbItems.appendChild(elem);
	        });
	        var clear = Dom_1.$$('div', {
	            className: 'coveo-breadcrumb-clear-all',
	            title: Strings_1.l('ClearAllFilters'),
	            tabindex: 0
	        }).el;
	        var clearIcon = Dom_1.$$('div', { className: 'coveo-icon coveo-breadcrumb-icon-clear-all' }).el;
	        clear.appendChild(clearIcon);
	        if (this.searchInterface.isNewDesign()) {
	            var clearText = document.createElement('div');
	            Dom_1.$$(clearText).text(Strings_1.l('Clear', ''));
	            clear.appendChild(clearText);
	            this.element.appendChild(clear);
	        }
	        else {
	            this.element.insertBefore(clear, this.element.firstChild);
	        }
	        var clearAction = function () { return _this.clearBreadcrumbs(); };
	        this.bind.on(clear, 'click', clearAction);
	        this.bind.on(clear, 'keyup', KeyboardUtils_1.KeyboardUtils.keypressAction(KeyboardUtils_1.KEYBOARD.ENTER, clearAction));
	    };
	    Breadcrumb.prototype.redrawBreadcrumb = function () {
	        this.lastBreadcrumbs ? this.drawBreadcrumb(this.lastBreadcrumbs) : this.drawBreadcrumb(this.getBreadcrumbs());
	    };
	    Breadcrumb.prototype.handleDeferredQuerySuccess = function () {
	        this.drawBreadcrumb(this.getBreadcrumbs());
	    };
	    Breadcrumb.prototype.handleAfterInitialization = function () {
	        var _this = this;
	        // We must bind to these events after the initialization to make sure the breadcrumb generation
	        // is made with updated components. (E.G facet, facetrange, ...)
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.deferredQuerySuccess, function () { return _this.handleDeferredQuerySuccess(); });
	    };
	    Breadcrumb.ID = 'Breadcrumb';
	    Breadcrumb.options = {};
	    return Breadcrumb;
	}(Component_1.Component));
	exports.Breadcrumb = Breadcrumb;
	Initialization_1.Initialization.registerAutoCreateComponent(Breadcrumb);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {/// <reference path="../../controllers/HierarchicalFacetQueryController.ts" />
	/// <reference path="../../controllers/FacetQueryController.ts" />
	/// <reference path="FacetSearch.ts" />
	/// <reference path="FacetSettings.ts" />
	/// <reference path="FacetSort.ts" />
	/// <reference path="FacetHeader.ts" />
	/// <reference path="BreadcrumbValueElement.ts" />
	/// <reference path="ValueElementRenderer.ts" />
	/// <reference path="FacetSearchParameters.ts" />
	/// <reference path="../HierarchicalFacet/HierarchicalFacet.ts" />
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var FacetValues_1 = __webpack_require__(142);
	var ComponentOptions_1 = __webpack_require__(98);
	var DeviceUtils_1 = __webpack_require__(20);
	var Strings_1 = __webpack_require__(34);
	var FacetQueryController_1 = __webpack_require__(80);
	var FacetSearch_1 = __webpack_require__(143);
	var FacetSettings_1 = __webpack_require__(150);
	var FacetSort_1 = __webpack_require__(151);
	var FacetValuesList_1 = __webpack_require__(152);
	var FacetHeader_1 = __webpack_require__(153);
	var FacetUtils_1 = __webpack_require__(82);
	var InitializationEvents_1 = __webpack_require__(44);
	var QueryEvents_1 = __webpack_require__(47);
	var Assert_1 = __webpack_require__(17);
	var Dom_1 = __webpack_require__(57);
	var AnalyticsActionListMeta_1 = __webpack_require__(110);
	var Utils_1 = __webpack_require__(18);
	var BreadcrumbValueElement_1 = __webpack_require__(154);
	var BreadcrumbValuesList_1 = __webpack_require__(155);
	var FacetValueElement_1 = __webpack_require__(145);
	var FacetSearchValuesList_1 = __webpack_require__(156);
	var Defer_1 = __webpack_require__(31);
	var QueryStateModel_1 = __webpack_require__(90);
	var Model_1 = __webpack_require__(87);
	var OmniboxEvents_1 = __webpack_require__(45);
	var OmniboxValueElement_1 = __webpack_require__(157);
	var OmniboxValuesList_1 = __webpack_require__(158);
	var ValueElementRenderer_1 = __webpack_require__(147);
	var FacetSearchParameters_1 = __webpack_require__(81);
	var Initialization_1 = __webpack_require__(95);
	var BreadcrumbEvents_1 = __webpack_require__(41);
	var ResponsiveFacets_1 = __webpack_require__(159);
	var KeyboardUtils_1 = __webpack_require__(68);
	var FacetValuesOrder_1 = __webpack_require__(149);
	var SearchAlertEvents_1 = __webpack_require__(49);
	/**
	 * This component displays a facet of the results for the current query. A facet consists of a list of values for a given field occurring in the results, ordered using a configurable criteria.<br/>
	 * The list of values is obtained using a {@link IGroupByRequest} operation performed at the same time as the main query.<br/>
	 * The Facet component allows the user to drill down inside results by restricting to certain field values. It also allows filtering out values, and can provide a search box to look for specific values inside larger sets.<br/>
	 * It is probably the most complex component in the Coveo UI, and as such allows many different options.
	 */
	var Facet = (function (_super) {
	    __extends(Facet, _super);
	    /**
	     * Create a new Facet component, bind multiple query events as well
	     * @param element
	     * @param options
	     * @param bindings
	     * @param facetClassId The ID to use for this facet (as Facet inherited from by other component (e.g.: {@link FacetRange}). The default value is `Facet`.
	     */
	    function Facet(element, options, bindings, facetClassId) {
	        var _this = this;
	        if (facetClassId === void 0) { facetClassId = Facet.ID; }
	        _super.call(this, element, facetClassId, bindings);
	        this.element = element;
	        this.options = options;
	        this.keepDisplayedValuesNextTime = false;
	        this.values = new FacetValues_1.FacetValues();
	        this.currentPage = 0;
	        this.firstQuery = true;
	        this.canFetchMore = true;
	        this.showingWaitAnimation = false;
	        this.listenToQueryStateChange = true;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, Facet, options);
	        if (this.options.valueCaption != null) {
	            this.options.availableSorts = _.filter(this.options.availableSorts, function (sort) { return !/^alpha.*$/.test(sort); });
	        }
	        ResponsiveFacets_1.ResponsiveFacets.init(this.root, this, this.options);
	        // Serves as a way to render facet in the omnibox in the order in which they are instantiated
	        this.omniboxZIndex = Facet.omniboxIndex;
	        Facet.omniboxIndex--;
	        this.checkForComputedFieldAndSort();
	        this.checkForValueCaptionType();
	        this.checkForCustomSort();
	        this.initFacetQueryController();
	        this.initQueryEvents();
	        this.initQueryStateEvents();
	        this.initComponentStateEvents();
	        this.initOmniboxEvents();
	        this.initBreadCrumbEvents();
	        this.initSearchAlertEvents();
	        this.updateNumberOfValues();
	        this.resize = function () {
	            if (!_this.disabled) {
	                FacetUtils_1.FacetUtils.clipCaptionsToAvoidOverflowingTheirContainer(_this);
	            }
	        };
	        window.addEventListener('resize', _.debounce(this.resize, 200));
	        this.bind.onRootElement(InitializationEvents_1.InitializationEvents.nuke, function () { return _this.handleNuke(); });
	        this.bind.oneRootElement(QueryEvents_1.QueryEvents.querySuccess, function () {
	            _this.firstQuery = false;
	        });
	    }
	    Facet.prototype.createDom = function () {
	        var _this = this;
	        this.initBottomAndTopSpacer();
	        this.buildFacetContent();
	        this.updateAppearanceDependingOnState();
	        // After the facet has been created (and before the first query is applied)
	        // Try to load a state from the setting, if it's available
	        // Execute only _.once (only the first query, or the first time the user switch to a tab that contains a newly set of active facet)
	        if (this.facetSettings && this.options.enableSettingsFacetState) {
	            var loadOnce = _.once(function () {
	                _this.facetSettings.loadSavedState.apply(_this.facetSettings);
	            });
	            this.bind.onRootElement(QueryEvents_1.QueryEvents.newQuery, loadOnce);
	        }
	    };
	    Facet.prototype.selectValue = function (value) {
	        Assert_1.Assert.exists(value);
	        this.ensureDom();
	        this.logger.info('Selecting facet value', this.facetValuesList.select(value));
	        this.facetValueHasChanged();
	    };
	    Facet.prototype.selectMultipleValues = function (values) {
	        var _this = this;
	        Assert_1.Assert.exists(values);
	        this.ensureDom();
	        _.each(values, function (value) {
	            _this.logger.info('Selecting facet value', _this.facetValuesList.select(value));
	        });
	        this.facetValueHasChanged();
	    };
	    Facet.prototype.deselectValue = function (value) {
	        Assert_1.Assert.exists(value);
	        this.ensureDom();
	        this.logger.info('Deselecting facet value', this.facetValuesList.unselect(value));
	        this.facetValueHasChanged();
	    };
	    Facet.prototype.deselectMultipleValues = function (values) {
	        var _this = this;
	        Assert_1.Assert.exists(values);
	        this.ensureDom();
	        _.each(values, function (value) {
	            _this.logger.info('Deselecting facet value', _this.facetValuesList.unselect(value));
	        });
	        this.facetValueHasChanged();
	    };
	    Facet.prototype.excludeValue = function (value) {
	        Assert_1.Assert.exists(value);
	        this.ensureDom();
	        this.logger.info('Excluding facet value', this.facetValuesList.exclude(value));
	        this.facetValueHasChanged();
	    };
	    Facet.prototype.excludeMultipleValues = function (values) {
	        var _this = this;
	        Assert_1.Assert.exists(values);
	        this.ensureDom();
	        _.each(values, function (value) {
	            _this.logger.info('Excluding facet value', _this.facetValuesList.exclude(value));
	        });
	        this.facetValueHasChanged();
	    };
	    Facet.prototype.unexcludeValue = function (value) {
	        Assert_1.Assert.exists(value);
	        this.ensureDom();
	        this.logger.info('Unexcluding facet value', this.facetValuesList.unExclude(value));
	        this.facetValueHasChanged();
	    };
	    Facet.prototype.unexcludeMultipleValues = function (values) {
	        var _this = this;
	        Assert_1.Assert.exists(values);
	        this.ensureDom();
	        _.each(values, function (value) {
	            _this.logger.info('Unexcluding facet value', _this.facetValuesList.unExclude(value));
	        });
	        this.facetValueHasChanged();
	    };
	    Facet.prototype.toggleSelectValue = function (value) {
	        Assert_1.Assert.exists(value);
	        this.ensureDom();
	        this.logger.info('Toggle select facet value', this.facetValuesList.toggleSelect(value));
	        this.facetValueHasChanged();
	    };
	    Facet.prototype.toggleExcludeValue = function (value) {
	        Assert_1.Assert.exists(value);
	        this.ensureDom();
	        this.logger.info('Toggle exclude facet value', this.facetValuesList.toggleExclude(value));
	        this.facetValueHasChanged();
	    };
	    /**
	     * Return the currently displayed values, as an array of string.
	     * @returns {any[]}
	     */
	    Facet.prototype.getDisplayedValues = function () {
	        return _.pluck(this.getDisplayedFacetValues(), 'value');
	    };
	    /**
	     * Return the currently displayed values, as an array of {@link FacetValue}.
	     * @returns {T[]}
	     */
	    Facet.prototype.getDisplayedFacetValues = function () {
	        this.ensureDom();
	        var displayed = this.facetValuesList.getAllCurrentlyDisplayed();
	        return _.map(displayed, function (value) {
	            return value.facetValue;
	        });
	    };
	    /**
	     * Return the currently selected values, as an array of string.
	     * @returns {TResult[]}
	     */
	    Facet.prototype.getSelectedValues = function () {
	        this.ensureDom();
	        return _.map(this.values.getSelected(), function (value) { return value.value; });
	    };
	    /**
	     * Return the currently excluded values, as an array of string.
	     * @returns {TResult[]}
	     */
	    Facet.prototype.getExcludedValues = function () {
	        this.ensureDom();
	        return _.map(this.values.getExcluded(), function (value) { return value.value; });
	    };
	    /**
	     * Reset the facet. This means unselect all values, unexclude all values, and redraw.
	     */
	    Facet.prototype.reset = function () {
	        this.ensureDom();
	        this.values.reset();
	        this.rebuildValueElements();
	        this.updateAppearanceDependingOnState();
	        this.updateQueryStateModel();
	    };
	    /**
	     * Switch the facet to AND mode: {@link Facet.options.useAnd}.
	     */
	    Facet.prototype.switchToAnd = function () {
	        this.ensureDom();
	        this.logger.info('Switching to AND');
	        this.facetHeader.switchToAnd();
	    };
	    /**
	     * Switch the facet to OR mode: {@link Facet.options.useAnd}.
	     */
	    Facet.prototype.switchToOr = function () {
	        this.ensureDom();
	        this.logger.info('Switching to OR');
	        this.facetHeader.switchToOr();
	    };
	    /**
	     * Return the endpoint for the facet.
	     * @returns {SearchEndpointInterface|ISearchEndpoint}
	     */
	    Facet.prototype.getEndpoint = function () {
	        return this.queryController.getEndpoint();
	    };
	    /**
	     * Change the sort parameter for the facet.<br/>
	     * See: {@link Facet.options.availableSorts} the list of possible value.<br/>
	     * Trigger a new query.
	     * @param criteria
	     */
	    Facet.prototype.updateSort = function (criteria) {
	        this.ensureDom();
	        if (this.options.sortCriteria != criteria) {
	            this.options.sortCriteria = criteria;
	            this.triggerNewQuery();
	        }
	    };
	    Facet.prototype.unfadeInactiveValuesInMainList = function () {
	        Dom_1.$$(this.element).removeClass('coveo-facet-fade');
	    };
	    Facet.prototype.fadeInactiveValuesInMainList = function (delay) {
	        Dom_1.$$(this.element).addClass('coveo-facet-fade');
	    };
	    /**
	     * Show a waiting animation in the facet header (a spinner).
	     */
	    Facet.prototype.showWaitingAnimation = function () {
	        this.ensureDom();
	        if (!this.showingWaitAnimation) {
	            // in old design : icon before the facet title needs to be hidden to show animation
	            // new design : no need to hide this icon since it's not there
	            if (!this.searchInterface.isNewDesign()) {
	                Dom_1.$$(this.headerElement).find('.coveo-icon').style.display = 'none';
	            }
	            Dom_1.$$(this.headerElement).find('.coveo-facet-header-wait-animation').style.display = '';
	            this.showingWaitAnimation = true;
	        }
	    };
	    /**
	     * Hide the waiting animation in the facet header (a spinner).
	     */
	    Facet.prototype.hideWaitingAnimation = function () {
	        this.ensureDom();
	        if (this.showingWaitAnimation) {
	            Dom_1.$$(this.headerElement).find('.coveo-icon').style.display = '';
	            Dom_1.$$(this.headerElement).find('.coveo-facet-header-wait-animation').style.display = 'none';
	            this.showingWaitAnimation = false;
	        }
	    };
	    Facet.prototype.processFacetSearchAllResultsSelected = function (facetValues) {
	        var _this = this;
	        var valuesForAnalytics = [];
	        _.each(facetValues, function (facetValue) {
	            _this.ensureFacetValueIsInList(facetValue);
	            valuesForAnalytics.push(facetValue.value);
	        });
	        // Calculate the correct number of values from the current selected/excluded values (those will stay no matter what next rendering)
	        // add the new one that will be selected (and are not already selected in the facet)
	        // The minimum number of values is the number of values set in the option
	        var valuesThatStays = this.values.getSelected().concat(this.values.getExcluded());
	        this.numberOfValues = valuesThatStays.length + _.difference(valuesThatStays, facetValues).length;
	        this.numberOfValues = Math.max(this.numberOfValues, this.options.numberOfValues);
	        // Then, we set current page as the last "full" page (math.floor)
	        // This is so there is no additional values displayed requested to fill the current page
	        // Also, when the user hit more, it will request the current page and fill it with more values
	        this.currentPage = Math.floor((this.numberOfValues - this.options.numberOfValues) / this.options.pageSize);
	        this.updateQueryStateModel();
	        this.triggerNewQuery(function () { return _this.usageAnalytics.logSearchEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.facetSelectAll, {
	            facetId: _this.options.id,
	            facetTitle: _this.options.title
	        }); });
	    };
	    Facet.prototype.pinFacetPosition = function () {
	        if (this.options.preservePosition) {
	            this.pinnedViewportPosition = this.element.getBoundingClientRect().top;
	        }
	    };
	    Facet.prototype.getValueCaption = function (facetValue) {
	        Assert_1.Assert.exists(facetValue);
	        var lookupValue = facetValue.lookupValue || facetValue.value;
	        var ret = lookupValue;
	        ret = FacetUtils_1.FacetUtils.tryToGetTranslatedCaption(this.options.field, lookupValue);
	        if (Utils_1.Utils.exists(this.options.valueCaption)) {
	            if (typeof this.options.valueCaption == 'object') {
	                ret = this.options.valueCaption[lookupValue] || ret;
	            }
	            if (typeof this.options.valueCaption == 'function') {
	                this.values.get(lookupValue);
	                ret = this.options.valueCaption.call(this, this.facetValuesList.get(lookupValue).facetValue);
	            }
	        }
	        return ret;
	    };
	    /**
	     * Show the next page of results in the facet.<br/>
	     * Trigger a query if needed, or display the already available values.
	     */
	    Facet.prototype.showMore = function () {
	        this.currentPage++;
	        this.updateNumberOfValues();
	        if (this.nbAvailableValues >= this.numberOfValues || !this.canFetchMore) {
	            this.rebuildValueElements();
	        }
	        else {
	            this.triggerMoreQuery();
	        }
	    };
	    /**
	     * Show less element in the facet (up to the original number of values).
	     */
	    Facet.prototype.showLess = function () {
	        Dom_1.$$(this.lessElement).removeClass('coveo-active');
	        this.currentPage = 0;
	        this.updateNumberOfValues();
	        Dom_1.$$(this.moreElement).addClass('coveo-active');
	        this.values.sortValuesDependingOnStatus(this.numberOfValues);
	        this.rebuildValueElements();
	    };
	    Facet.prototype.triggerNewQuery = function (beforeExecuteQuery) {
	        if (!beforeExecuteQuery) {
	            this.queryController.executeQuery({ ignoreWarningSearchEvent: true });
	        }
	        else {
	            this.queryController.executeQuery({ beforeExecuteQuery: beforeExecuteQuery });
	        }
	        this.showWaitingAnimation();
	    };
	    Facet.prototype.handleDeferredQuerySuccess = function (data) {
	        Assert_1.Assert.exists(data);
	        this.unfadeInactiveValuesInMainList();
	        this.hideWaitingAnimation();
	        this.updateVisibilityBasedOnDependsOn();
	        var groupByResult = data.results.groupByResults[this.facetQueryController.lastGroupByRequestIndex];
	        this.facetQueryController.lastGroupByResult = groupByResult;
	        if (!groupByResult) {
	            this.keepDisplayedValuesNextTime = false;
	        }
	        this.processNewGroupByResults(groupByResult);
	    };
	    Facet.prototype.handlePopulateBreadcrumb = function (args) {
	        Assert_1.Assert.exists(args);
	        if (this.values.hasSelectedOrExcludedValues()) {
	            var element = new BreadcrumbValuesList_1.BreadcrumbValueList(this, this.values.getSelected().concat(this.values.getExcluded()), BreadcrumbValueElement_1.BreadcrumbValueElement).build();
	            args.breadcrumbs.push({
	                element: element
	            });
	        }
	    };
	    Facet.prototype.handlePopulateSearchAlerts = function (args) {
	        if (this.values.hasSelectedOrExcludedValues()) {
	            args.text.push(new BreadcrumbValuesList_1.BreadcrumbValueList(this, this.values.getSelected().concat(this.values.getExcluded()), BreadcrumbValueElement_1.BreadcrumbValueElement).buildAsString());
	        }
	    };
	    Facet.prototype.initFacetQueryController = function () {
	        this.facetQueryController = new FacetQueryController_1.FacetQueryController(this);
	    };
	    Facet.prototype.initFacetValuesList = function () {
	        this.facetValuesList = new FacetValuesList_1.FacetValuesList(this, FacetValueElement_1.FacetValueElement);
	        this.element.appendChild(this.facetValuesList.build());
	    };
	    Facet.prototype.initFacetSearch = function () {
	        this.facetSearch = new FacetSearch_1.FacetSearch(this, FacetSearchValuesList_1.FacetSearchValuesList, this.root);
	        this.element.appendChild(this.facetSearch.build());
	    };
	    Facet.prototype.facetValueHasChanged = function () {
	        var _this = this;
	        this.updateQueryStateModel();
	        this.rebuildValueElements();
	        Defer_1.Defer.defer(function () {
	            _this.updateAppearanceDependingOnState();
	        });
	    };
	    Facet.prototype.updateAppearanceDependingOnState = function () {
	        Dom_1.$$(this.element).toggleClass('coveo-active', this.values.hasSelectedOrExcludedValues());
	        Dom_1.$$(this.element).toggleClass('coveo-facet-empty', !this.isAnyValueCurrentlyDisplayed());
	        Dom_1.$$(this.facetHeader.eraserElement).toggle(this.values.hasSelectedOrExcludedValues());
	    };
	    Facet.prototype.initQueryEvents = function () {
	        var _this = this;
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.duringQuery, function () { return _this.handleDuringQuery(); });
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.buildingQuery, function (args) { return _this.handleBuildingQuery(args); });
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.doneBuildingQuery, function (args) { return _this.handleDoneBuildingQuery(args); });
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.deferredQuerySuccess, function (args) { return _this.handleDeferredQuerySuccess(args); });
	    };
	    Facet.prototype.initQueryStateEvents = function () {
	        var _this = this;
	        this.includedAttributeId = QueryStateModel_1.QueryStateModel.getFacetId(this.options.id);
	        this.excludedAttributeId = QueryStateModel_1.QueryStateModel.getFacetId(this.options.id, false);
	        this.operatorAttributeId = QueryStateModel_1.QueryStateModel.getFacetOperator(this.options.id);
	        this.lookupValueAttributeId = QueryStateModel_1.QueryStateModel.getFacetLookupValue(this.options.id);
	        this.queryStateModel.registerNewAttribute(this.includedAttributeId, []);
	        this.queryStateModel.registerNewAttribute(this.excludedAttributeId, []);
	        this.queryStateModel.registerNewAttribute(this.operatorAttributeId, '');
	        this.queryStateModel.registerNewAttribute(this.lookupValueAttributeId, {});
	        this.bind.onQueryState(Model_1.MODEL_EVENTS.CHANGE, undefined, function (args) { return _this.handleQueryStateChanged(args); });
	    };
	    Facet.prototype.initComponentStateEvents = function () {
	        this.componentStateId = QueryStateModel_1.QueryStateModel.getFacetId(this.options.id);
	        this.componentStateModel.registerComponent(this.componentStateId, this);
	    };
	    Facet.prototype.initOmniboxEvents = function () {
	        var _this = this;
	        if (this.options.includeInOmnibox) {
	            this.bind.onRootElement(OmniboxEvents_1.OmniboxEvents.populateOmnibox, function (args) { return _this.handlePopulateOmnibox(args); });
	        }
	    };
	    Facet.prototype.initBreadCrumbEvents = function () {
	        var _this = this;
	        if (this.options.includeInBreadcrumb) {
	            this.bind.onRootElement(BreadcrumbEvents_1.BreadcrumbEvents.populateBreadcrumb, function (args) { return _this.handlePopulateBreadcrumb(args); });
	            this.bind.onRootElement(BreadcrumbEvents_1.BreadcrumbEvents.clearBreadcrumb, function (args) { return _this.handleClearBreadcrumb(); });
	        }
	    };
	    Facet.prototype.initSearchAlertEvents = function () {
	        var _this = this;
	        this.bind.onRootElement(SearchAlertEvents_1.SearchAlertsEvents.searchAlertsPopulateMessage, function (args) { return _this.handlePopulateSearchAlerts(args); });
	    };
	    Facet.prototype.handleOmniboxWithStaticValue = function (eventArg) {
	        var _this = this;
	        var regex = new RegExp('^' + eventArg.completeQueryExpression.regex.source, 'i');
	        var match = _.first(_.filter(this.getDisplayedValues(), function (displayedValue) {
	            var value = _this.getValueCaption(_this.facetValuesList.get(displayedValue).facetValue);
	            return regex.test(value);
	        }), this.options.numberOfValuesInOmnibox);
	        var facetValues = _.map(match, function (gotAMatch) {
	            return _this.facetValuesList.get(gotAMatch).facetValue;
	        });
	        var element = new OmniboxValuesList_1.OmniboxValuesList(this, facetValues, eventArg, OmniboxValueElement_1.OmniboxValueElement).build();
	        eventArg.rows.push({
	            element: element,
	            zIndex: this.omniboxZIndex
	        });
	    };
	    Facet.prototype.processNewGroupByResults = function (groupByResult) {
	        this.logger.trace('Displaying group by results', groupByResult);
	        if (groupByResult != undefined && groupByResult.values != undefined) {
	            this.nbAvailableValues = groupByResult.values.length;
	        }
	        var newFacetValues = new FacetValues_1.FacetValues(groupByResult);
	        this.updateValues(newFacetValues);
	        this.canFetchMore = this.numberOfValues < this.nbAvailableValues;
	        if (this.values.hasSelectedOrExcludedValues() && !this.options.useAnd && this.options.isMultiValueField) {
	            this.triggerUpdateDeltaQuery(_.filter(this.values.getAll(), function (facetValue) {
	                return !facetValue.selected && !facetValue.excluded;
	            }));
	        }
	        else if (this.values.getSelected().length > 0 && !this.options.useAnd) {
	            this.values.updateDeltaWithFilteredFacetValues(new FacetValues_1.FacetValues());
	        }
	        if (!this.values.hasSelectedOrExcludedValues() || this.options.useAnd || !this.options.isMultiValueField) {
	            this.rebuildValueElements();
	            this.updateAppearanceDependingOnState();
	            this.ensurePinnedFacetHasntMoved();
	        }
	        this.keepDisplayedValuesNextTime = false;
	    };
	    Facet.prototype.updateQueryStateModel = function () {
	        this.listenToQueryStateChange = false;
	        this.updateExcludedQueryStateModel();
	        this.updateIncludedQueryStateModel();
	        this.facetHeader.updateOperatorQueryStateModel();
	        this.updateLookupValueQueryStateModel();
	        this.listenToQueryStateChange = true;
	    };
	    Facet.prototype.rebuildValueElements = function () {
	        this.updateNumberOfValues();
	        this.facetValuesList.rebuild(this.numberOfValues);
	        if (this.shouldRenderMoreLess()) {
	            this.updateMoreLess();
	            if (this.shouldRenderFacetSearch() && this.searchInterface.isNewDesign()) {
	                this.updateSearchInNewDesign(this.nbAvailableValues > this.numberOfValues);
	            }
	        }
	        else if (this.shouldRenderFacetSearch() && this.searchInterface.isNewDesign()) {
	            this.updateSearchInNewDesign();
	        }
	    };
	    Facet.prototype.updateSearchInNewDesign = function (moreValuesAvailable) {
	        var _this = this;
	        if (moreValuesAvailable === void 0) { moreValuesAvailable = true; }
	        if (this.searchInterface.isNewDesign() && moreValuesAvailable) {
	            var renderer = new ValueElementRenderer_1.ValueElementRenderer(this, FacetValues_1.FacetValue.create(Strings_1.l('Search')));
	            var searchButton_1 = renderer.build().withNo([renderer.excludeIcon, renderer.icon]);
	            Dom_1.$$(searchButton_1.listItem).addClass('coveo-facet-search-button');
	            searchButton_1.stylishCheckbox.removeAttribute('tabindex');
	            // Mobile do not like label. Use click event
	            if (DeviceUtils_1.DeviceUtils.isMobileDevice()) {
	                Dom_1.$$(searchButton_1.label).on('click', function (e) {
	                    if (searchButton_1.checkbox.getAttribute('checked')) {
	                        searchButton_1.checkbox.removeAttribute('checked');
	                    }
	                    else {
	                        searchButton_1.checkbox.setAttribute('checked', 'checked');
	                    }
	                    Dom_1.$$(searchButton_1.checkbox).trigger('change');
	                    e.stopPropagation();
	                    e.preventDefault();
	                });
	            }
	            Dom_1.$$(searchButton_1.checkbox).on('change', function () {
	                Dom_1.$$(_this.element).addClass('coveo-facet-searching');
	                _this.facetSearch.focus();
	            });
	            this.facetValuesList.valueContainer.appendChild(searchButton_1.listItem);
	        }
	    };
	    Facet.prototype.updateMoreLess = function (lessElementIsShown, moreValuesAvailable) {
	        if (lessElementIsShown === void 0) { lessElementIsShown = this.getMinimumNumberOfValuesToDisplay() < this.numberOfValues; }
	        if (moreValuesAvailable === void 0) { moreValuesAvailable = this.nbAvailableValues > this.numberOfValues; }
	        if (lessElementIsShown) {
	            Dom_1.$$(this.lessElement).addClass('coveo-active');
	        }
	        else {
	            Dom_1.$$(this.lessElement).removeClass('coveo-active');
	        }
	        if (moreValuesAvailable) {
	            Dom_1.$$(this.moreElement).addClass('coveo-active');
	        }
	        else {
	            Dom_1.$$(this.moreElement).removeClass('coveo-active');
	        }
	        if (lessElementIsShown || moreValuesAvailable) {
	            Dom_1.$$(this.footerElement).removeClass('coveo-facet-empty');
	        }
	        else {
	            Dom_1.$$(this.footerElement).addClass('coveo-facet-empty');
	        }
	    };
	    Facet.prototype.handleClickMore = function () {
	        this.showMore();
	    };
	    Facet.prototype.handleClickLess = function () {
	        this.showLess();
	    };
	    Facet.prototype.handleNuke = function () {
	        window.removeEventListener('resize', this.resize);
	    };
	    Facet.prototype.checkForComputedFieldAndSort = function () {
	        if (this.options.sortCriteria.toLowerCase().indexOf('computedfield') != -1 && Utils_1.Utils.isNullOrUndefined(this.options.computedField)) {
	            this.logger.warn('Sort criteria is specified as ComputedField, but the facet uses no computed field. Facet will always be empty !', this);
	        }
	    };
	    Facet.prototype.checkForValueCaptionType = function () {
	        if (this.options.valueCaption && typeof this.options.valueCaption == 'function') {
	            this.options.enableFacetSearch = false;
	            this.options.includeInOmnibox = false;
	            this.logger.warn('Using a function as valueCaption is now deprecated. Use a json key value pair instead. Facet search and omnibox has been disabled for this facet', this);
	        }
	    };
	    Facet.prototype.checkForCustomSort = function () {
	        if (this.options.customSort != undefined && !_.contains(this.options.availableSorts, 'custom')) {
	            this.options.availableSorts.unshift('custom');
	        }
	        if (this.options.availableSorts[0] == 'custom') {
	            this.options.sortCriteria = 'nosort';
	        }
	    };
	    Facet.prototype.initBottomAndTopSpacer = function () {
	        var _this = this;
	        var bottomSpace = Dom_1.$$(this.options.paddingContainer).find('.coveo-bottomSpace');
	        var topSpace = Dom_1.$$(this.options.paddingContainer).find('.coveo-topSpace');
	        if (this.options.preservePosition) {
	            Dom_1.$$(this.options.paddingContainer).on('mouseleave', function () { return _this.unpinFacetPosition(); });
	            this.pinnedTopSpace = topSpace;
	            this.pinnedBottomSpace = bottomSpace;
	            if (!this.pinnedTopSpace) {
	                this.pinnedTopSpace = document.createElement('div');
	                Dom_1.$$(this.pinnedTopSpace).addClass('coveo-topSpace');
	                Dom_1.$$(this.pinnedTopSpace).insertBefore(this.options.paddingContainer.firstChild);
	            }
	            if (!this.pinnedBottomSpace) {
	                this.pinnedBottomSpace = document.createElement('div');
	                Dom_1.$$(this.pinnedBottomSpace).addClass('coveo-bottomSpace');
	                this.options.paddingContainer.appendChild(this.pinnedBottomSpace);
	            }
	        }
	    };
	    Facet.prototype.updateIncludedQueryStateModel = function () {
	        var selectedValues = {
	            included: this.getSelectedValues(),
	            title: this.includedAttributeId
	        };
	        this.queryStateModel.set(this.includedAttributeId, selectedValues.included);
	    };
	    Facet.prototype.updateExcludedQueryStateModel = function () {
	        var excludedValues = {
	            title: this.excludedAttributeId,
	            excluded: this.getExcludedValues()
	        };
	        this.queryStateModel.set(this.excludedAttributeId, excludedValues.excluded);
	    };
	    Facet.prototype.updateLookupValueQueryStateModel = function () {
	        if (this.options.lookupField) {
	            var valueToSet_1 = {};
	            _.each(this.values.getSelected().concat(this.values.getExcluded()), function (value) {
	                valueToSet_1[value.value] = value.lookupValue;
	            });
	            this.queryStateModel.set(this.lookupValueAttributeId, valueToSet_1);
	        }
	    };
	    Facet.prototype.handleQueryStateChangedOperator = function (operator) {
	        if (operator == 'and') {
	            this.switchToAnd();
	        }
	        else if (operator == 'or') {
	            this.switchToOr();
	        }
	    };
	    Facet.prototype.handleQueryStateChangedIncluded = function (includedChanged) {
	        var toUnSelect = _.difference(this.getSelectedValues(), includedChanged);
	        if (Utils_1.Utils.isNonEmptyArray(toUnSelect)) {
	            this.deselectMultipleValues(toUnSelect);
	        }
	        if (!Utils_1.Utils.arrayEqual(this.getSelectedValues(), includedChanged, false)) {
	            this.selectMultipleValues(includedChanged);
	        }
	    };
	    Facet.prototype.handleQueryStateChangedExcluded = function (excludedChanged) {
	        var toUnExclude = _.difference(this.getExcludedValues(), excludedChanged);
	        if (Utils_1.Utils.isNonEmptyArray(toUnExclude)) {
	            this.unexcludeMultipleValues(toUnExclude);
	        }
	        if (!Utils_1.Utils.arrayEqual(this.getExcludedValues(), excludedChanged, false)) {
	            this.excludeMultipleValues(excludedChanged);
	        }
	    };
	    Facet.prototype.handleLookupvalueChanged = function (lookupFieldChanged) {
	        var _this = this;
	        _.each(lookupFieldChanged, function (lookupvalue, value) {
	            _this.facetValuesList.get(decodeURIComponent(value)).facetValue.lookupValue = decodeURIComponent(lookupvalue);
	        });
	    };
	    Facet.prototype.handleQueryStateChanged = function (data) {
	        Assert_1.Assert.exists(data);
	        this.ensureDom();
	        var queryStateAttributes = data.attributes;
	        var includedChanged = queryStateAttributes[this.includedAttributeId];
	        var excludedChanged = queryStateAttributes[this.excludedAttributeId];
	        var operator = queryStateAttributes[this.operatorAttributeId];
	        var lookupValueChanged = queryStateAttributes[this.lookupValueAttributeId];
	        if (this.listenToQueryStateChange) {
	            if (!Utils_1.Utils.isNullOrEmptyString(operator)) {
	                this.handleQueryStateChangedOperator(operator);
	            }
	            if (!Utils_1.Utils.isNullOrUndefined(includedChanged)) {
	                this.handleQueryStateChangedIncluded(includedChanged);
	            }
	            if (!Utils_1.Utils.isNullOrUndefined(excludedChanged)) {
	                this.handleQueryStateChangedExcluded(excludedChanged);
	            }
	            if (!Utils_1.Utils.isNullOrUndefined(lookupValueChanged)) {
	                this.handleLookupvalueChanged(lookupValueChanged);
	            }
	        }
	    };
	    Facet.prototype.handlePopulateOmnibox = function (data) {
	        Assert_1.Assert.exists(data);
	        Assert_1.Assert.exists(data.completeQueryExpression);
	        // The omnibox calls can come in before a first query was executed (atypical, but
	        // if no query is auto-triggered on initialization). To ensure that we've got the
	        // proper filters, we ensure that at least a dumbshow query builder run occured
	        // before proceeding.
	        this.queryController.ensureCreatedQueryBuilder();
	        if (this.canFetchMore) {
	            this.handleOmniboxWithSearchInFacet(data);
	        }
	        else {
	            this.handleOmniboxWithStaticValue(data);
	        }
	    };
	    Facet.prototype.handleOmniboxWithSearchInFacet = function (eventArg) {
	        var _this = this;
	        var regex = new RegExp('^' + eventArg.completeQueryExpression.regex.source, 'i');
	        var promise = new Promise(function (resolve, reject) {
	            var searchParameters = new FacetSearchParameters_1.FacetSearchParameters(_this);
	            searchParameters.setValueToSearch(eventArg.completeQueryExpression.word);
	            searchParameters.nbResults = _this.options.numberOfValuesInOmnibox;
	            _this.facetQueryController.search(searchParameters).then(function (fieldValues) {
	                var facetValues = _.map(_.filter(fieldValues, function (fieldValue) {
	                    return regex.test(fieldValue.lookupValue);
	                }), function (fieldValue) {
	                    return _this.values.get(fieldValue.lookupValue) || FacetValues_1.FacetValue.create(fieldValue);
	                });
	                var element = new OmniboxValuesList_1.OmniboxValuesList(_this, facetValues, eventArg, OmniboxValueElement_1.OmniboxValueElement).build();
	                resolve({
	                    element: element,
	                    zIndex: _this.omniboxZIndex
	                });
	            }).catch(function () {
	                resolve({ element: undefined });
	            });
	        });
	        eventArg.rows.push({ deferred: promise });
	    };
	    Facet.prototype.handleDuringQuery = function () {
	        this.ensureDom();
	        if (!this.keepDisplayedValuesNextTime) {
	            this.fadeInactiveValuesInMainList(this.options.facetSearchDelay);
	        }
	    };
	    Facet.prototype.handleBuildingQuery = function (data) {
	        Assert_1.Assert.exists(data);
	        Assert_1.Assert.exists(data.queryBuilder);
	        this.facetQueryController.prepareForNewQuery();
	        if (this.values.hasSelectedOrExcludedValues()) {
	            var expression = this.facetQueryController.computeOurFilterExpression();
	            this.logger.trace('Putting filter in query', expression);
	            data.queryBuilder.advancedExpression.add(expression);
	        }
	    };
	    Facet.prototype.handleDoneBuildingQuery = function (data) {
	        Assert_1.Assert.exists(data);
	        Assert_1.Assert.exists(data.queryBuilder);
	        var queryBuilder = data.queryBuilder;
	        this.facetQueryController.putGroupByIntoQueryBuilder(queryBuilder);
	    };
	    Facet.prototype.handleClearBreadcrumb = function () {
	        this.reset();
	    };
	    Facet.prototype.updateValues = function (facetValues) {
	        Assert_1.Assert.exists(facetValues);
	        if (this.keepDisplayedValuesNextTime) {
	            this.values.updateCountsFromNewValues(facetValues);
	        }
	        else {
	            facetValues.importActiveValuesFromOtherList(this.values);
	            facetValues.sortValuesDependingOnStatus(this.numberOfValues);
	            this.values = facetValues;
	        }
	        this.updateNumberOfValues();
	    };
	    Facet.prototype.ensureFacetValueIsInList = function (facetValue) {
	        Assert_1.Assert.exists(facetValue);
	        if (!this.values.contains(facetValue.value)) {
	            this.values.add(facetValue);
	        }
	    };
	    Facet.prototype.isAnyValueCurrentlyDisplayed = function () {
	        return !this.values.isEmpty();
	    };
	    Facet.prototype.buildFacetContent = function () {
	        this.headerElement = this.buildHeader();
	        this.element.appendChild(this.headerElement);
	        this.initFacetValuesList();
	        if (this.shouldRenderFacetSearch()) {
	            this.initFacetSearch();
	        }
	        if (this.shouldRenderMoreLess()) {
	            this.moreElement = this.buildMore();
	            this.lessElement = this.buildLess();
	        }
	        this.footerElement = this.buildFooter();
	        this.element.appendChild(this.footerElement);
	        if (this.searchInterface.isNewDesign() && this.lessElement && this.moreElement) {
	            this.footerElement.appendChild(this.lessElement);
	            this.footerElement.appendChild(this.moreElement);
	        }
	        else if (this.moreElement && this.lessElement) {
	            this.footerElement.appendChild(this.moreElement);
	            this.footerElement.appendChild(this.lessElement);
	        }
	    };
	    Facet.prototype.buildHeader = function () {
	        var icon = this.options.headerIcon;
	        if (this.searchInterface.isNewDesign() && this.options.headerIcon == this.options.field) {
	            icon = undefined;
	        }
	        this.facetHeader = new FacetHeader_1.FacetHeader({
	            facetElement: this.element,
	            title: this.options.title,
	            icon: icon,
	            field: this.options.field,
	            enableClearElement: true,
	            enableCollapseElement: this.options.enableCollapse,
	            facet: this,
	            settingsKlass: this.options.enableSettings ? FacetSettings_1.FacetSettings : undefined,
	            sortKlass: FacetSort_1.FacetSort,
	            availableSorts: this.options.availableSorts,
	            isNewDesign: this.getBindings().searchInterface.isNewDesign()
	        });
	        var built = this.facetHeader.build();
	        this.facetSettings = this.facetHeader.settings;
	        this.facetSort = this.facetHeader.sort;
	        return built;
	    };
	    Facet.prototype.unpinFacetPosition = function () {
	        if (this.shouldFacetUnpin() && this.options.preservePosition) {
	            Dom_1.$$(this.pinnedTopSpace).addClass('coveo-with-animation');
	            Dom_1.$$(this.pinnedBottomSpace).addClass('coveo-with-animation');
	            this.pinnedTopSpace.style.height = '0px';
	            this.pinnedBottomSpace.style.height = '0px';
	            this.unpinnedViewportPosition = undefined;
	        }
	    };
	    Facet.prototype.isFacetPinned = function () {
	        return Utils_1.Utils.exists(this.pinnedViewportPosition);
	    };
	    Facet.prototype.shouldFacetUnpin = function () {
	        return Utils_1.Utils.exists(this.unpinnedViewportPosition);
	    };
	    Facet.prototype.ensurePinnedFacetHasntMoved = function () {
	        var _this = this;
	        if (this.isFacetPinned()) {
	            Assert_1.Assert.exists(this.pinnedViewportPosition);
	            Dom_1.$$(this.pinnedTopSpace).removeClass('coveo-with-animation');
	            Dom_1.$$(this.pinnedBottomSpace).removeClass('coveo-with-animation');
	            this.pinnedTopSpace.style.height = '0px';
	            this.pinnedBottomSpace.style.height = '0px';
	            // Under firefox scrolling the body doesn't work, but window does
	            // on all browser, so we substitute those here when needed.
	            var elementToScroll_1 = this.options.scrollContainer == document.body ? window : this.options.scrollContainer;
	            var currentViewportPosition_1 = this.element.getBoundingClientRect().top;
	            var offset_1 = currentViewportPosition_1 - this.pinnedViewportPosition;
	            var scrollToOffset_1 = function () {
	                if (elementToScroll_1 instanceof Window) {
	                    window.scrollTo(0, window.scrollY + offset_1);
	                }
	                else {
	                    elementToScroll_1.scrollTop = elementToScroll_1.scrollTop + offset_1;
	                }
	            };
	            // First try to adjust position by scrolling the page
	            scrollToOffset_1();
	            currentViewportPosition_1 = this.element.getBoundingClientRect().top;
	            offset_1 = currentViewportPosition_1 - this.pinnedViewportPosition;
	            // If scrolling has worked (offset == 0), we're good to go, nothing to do anymore.
	            // Otherwise try other voodoo magic.
	            if (offset_1 < 0) {
	                // This means the facet element is scrolled up in the viewport,
	                // scroll it down by adding space in the top container
	                this.pinnedTopSpace.style.height = (offset_1 * -1) + 'px';
	            }
	            else {
	                // Here, this means the facet element is scrolled down in the viewport,
	                // and there is not enough scroll space in the page / window to scroll far enough
	                // we need to add space at the bottom so that we can finally scroll there.
	                _.defer(function () {
	                    var heightBottom = 0;
	                    var attempts = 0;
	                    while (offset_1 > 0 && attempts++ < 100) {
	                        heightBottom += 100;
	                        _this.pinnedBottomSpace.style.height = heightBottom + 'px';
	                        currentViewportPosition_1 = _this.element.getBoundingClientRect().top;
	                        offset_1 = currentViewportPosition_1 - _this.pinnedViewportPosition;
	                        scrollToOffset_1();
	                    }
	                });
	            }
	            this.unpinnedViewportPosition = this.pinnedViewportPosition;
	            this.pinnedViewportPosition = null;
	        }
	    };
	    Facet.prototype.buildFooter = function () {
	        return Dom_1.$$('div', { className: 'coveo-facet-footer' }).el;
	    };
	    Facet.prototype.buildMore = function () {
	        var _this = this;
	        var more;
	        if (this.searchInterface.isNewDesign()) {
	            more = Dom_1.$$('div', { className: 'coveo-facet-more', tabindex: 0 }, Dom_1.$$('span', { className: 'coveo-icon' })).el;
	        }
	        else {
	            more = Dom_1.$$('a', { className: 'coveo-facet-more' }, Strings_1.l('More')).el;
	        }
	        var moreAction = function () { return _this.handleClickMore(); };
	        Dom_1.$$(more).on('click', moreAction);
	        Dom_1.$$(more).on('keyup', KeyboardUtils_1.KeyboardUtils.keypressAction(KeyboardUtils_1.KEYBOARD.ENTER, moreAction));
	        return more;
	    };
	    Facet.prototype.buildLess = function () {
	        var _this = this;
	        var less;
	        if (this.searchInterface.isNewDesign()) {
	            less = Dom_1.$$('div', { className: 'coveo-facet-less', tabindex: 0 }, Dom_1.$$('span', { className: 'coveo-icon' })).el;
	        }
	        else {
	            less = Dom_1.$$('a', { className: 'coveo-facet-less' }, Strings_1.l('Less')).el;
	        }
	        var lessAction = function () { return _this.handleClickLess(); };
	        Dom_1.$$(less).on('click', lessAction);
	        Dom_1.$$(less).on('keyup', KeyboardUtils_1.KeyboardUtils.keypressAction(KeyboardUtils_1.KEYBOARD.ENTER, lessAction));
	        return less;
	    };
	    Facet.prototype.triggerMoreQuery = function () {
	        var _this = this;
	        this.logger.info('Triggering new facet more query');
	        this.showWaitingAnimation();
	        // fetch 1 more value than we need, so we can see if there is more value to fetch still or if we have reached
	        // the end of the availables values
	        this.facetQueryController.fetchMore(this.numberOfValues + 1).then(function (queryResults) {
	            var facetValues = new FacetValues_1.FacetValues(queryResults.groupByResults[0]);
	            facetValues.importActiveValuesFromOtherList(_this.values);
	            facetValues.sortValuesDependingOnStatus(_this.numberOfValues);
	            _this.values = facetValues;
	            _this.nbAvailableValues = _this.values.size();
	            _this.updateNumberOfValues();
	            _this.canFetchMore = _this.numberOfValues < _this.nbAvailableValues;
	            if (_this.values.hasSelectedOrExcludedValues() && !_this.options.useAnd && _this.options.isMultiValueField) {
	                _this.triggerUpdateDeltaQuery(_.filter(_this.values.getAll(), function (facetValue) { return !facetValue.selected && !facetValue.excluded; }));
	            }
	            else {
	                if (_this.values.hasSelectedOrExcludedValues() && !_this.options.useAnd) {
	                    _this.values.updateDeltaWithFilteredFacetValues(new FacetValues_1.FacetValues());
	                    _this.hideWaitingAnimation();
	                }
	                else {
	                    _this.hideWaitingAnimation();
	                }
	                _this.rebuildValueElements();
	            }
	        }).catch(function () { return _this.hideWaitingAnimation(); });
	    };
	    Facet.prototype.triggerUpdateDeltaQuery = function (facetValues) {
	        var _this = this;
	        this.showWaitingAnimation();
	        this.facetQueryController.searchInFacetToUpdateDelta(facetValues).then(function (queryResults) {
	            var values = new FacetValues_1.FacetValues();
	            _.each(queryResults.groupByResults, function (groupByResult) {
	                _.each(groupByResult.values, function (groupByValue) {
	                    if (!values.contains(groupByValue.value)) {
	                        values.add(FacetValues_1.FacetValue.createFromGroupByValue(groupByValue));
	                    }
	                });
	            });
	            _this.values.updateDeltaWithFilteredFacetValues(values);
	            _this.rebuildValueElements();
	            _this.hideWaitingAnimation();
	        });
	    };
	    Facet.prototype.updateNumberOfValues = function () {
	        if (this.currentPage <= 0) {
	            // We're on the first page, let's reset the number of values to a minimum.
	            this.currentPage = 0;
	            this.numberOfValues = 0;
	        }
	        else {
	            // Calculate the number of value with the current page.
	            this.numberOfValues = this.options.numberOfValues + (this.currentPage * this.options.pageSize);
	        }
	        // Make sure we have at least the absolute minimum of value to display.
	        this.numberOfValues = Math.max(this.numberOfValues, this.getMinimumNumberOfValuesToDisplay());
	    };
	    Facet.prototype.getMinimumNumberOfValuesToDisplay = function () {
	        // The min value is the number of used values.
	        var minValue = this.values.getExcluded().length + this.values.getSelected().length;
	        // When using a custom sort, we have to show all values between the selected ones.
	        // Thus, we must find the last selected value after a reorder and use that value as the number of value.
	        if (this.options.customSort != null && this.facetSort != null && this.options.customSort.length > 0) {
	            var lastSelectedValueIndex_1 = -1;
	            new FacetValuesOrder_1.FacetValuesOrder(this, this.facetSort).reorderValues(this.values.getAll()).forEach(function (facetValue, index) {
	                if (facetValue.selected) {
	                    lastSelectedValueIndex_1 = index;
	                }
	            });
	            minValue = lastSelectedValueIndex_1 + 1;
	        }
	        return Math.max(minValue, this.options.numberOfValues);
	    };
	    Facet.prototype.updateVisibilityBasedOnDependsOn = function () {
	        if (Utils_1.Utils.isNonEmptyString(this.options.dependsOn)) {
	            Dom_1.$$(this.element).toggleClass('coveo-facet-dependent', !this.doesParentFacetHasSelectedValue() && !this.values.hasSelectedOrExcludedValues());
	        }
	    };
	    Facet.prototype.doesParentFacetHasSelectedValue = function () {
	        var id = QueryStateModel_1.QueryStateModel.getFacetId(this.options.dependsOn);
	        var values = this.queryStateModel.get(id);
	        return values != null && values.length != 0;
	    };
	    Facet.prototype.shouldRenderFacetSearch = function () {
	        return this.options.enableFacetSearch;
	    };
	    Facet.prototype.shouldRenderMoreLess = function () {
	        return this.options.enableMoreLess;
	    };
	    Facet.prototype.debugInfo = function () {
	        var info = {};
	        info[this['constructor']['ID']] = {
	            component: this,
	            groupByRequest: this.facetQueryController.lastGroupByRequest,
	            groupByResult: this.facetQueryController.lastGroupByResult
	        };
	        return info;
	    };
	    Facet.ID = 'Facet';
	    Facet.omniboxIndex = 50;
	    /**
	     * The possible options for a facet
	     * @componentOptions
	     */
	    Facet.options = {
	        /**
	         * Specifies the title displayed at the top of the facet.<br/>
	         * Default is the localized string for "No Title".
	         */
	        title: ComponentOptions_1.ComponentOptions.buildLocalizedStringOption({
	            defaultValue: Strings_1.l('NoTitle'),
	            section: 'Identification',
	            priority: 10
	        }),
	        /**
	         * Specifies the index field whose values will be used in the facet.<br/>
	         * This require the given field to be configured correctly in the index as a facet field.<br/>
	         * This is a required option and cannot be omitted, otherwise the facet component will not work.
	         */
	        field: ComponentOptions_1.ComponentOptions.buildFieldOption({ required: true, groupByField: true, section: 'Identification' }),
	        /**
	         * Specifies the CSS class to change the facet header icon.<br/>
	         * @deprecated This option is exposed for legacy reason, and the recommendation is to not use this option.
	         */
	        headerIcon: ComponentOptions_1.ComponentOptions.buildIconOption({ deprecated: 'This option is exposed for legacy reason, and the recommendation is to not use this option.' }),
	        /**
	         * Specifies a unique identifier for a facet. This identifier will be used to save the facet state in the url hash, for example.<br/>
	         * Optional, since the default will be the {@link Facet.options.field} option.<br/>
	         * If you have two facets with the same field on the same page, you should specify an ID for at least one of those two facets.<br/>
	         * That ID need to be unique on the page.
	         */
	        id: ComponentOptions_1.ComponentOptions.buildStringOption({
	            postProcessing: function (value, options) { return value || options.field; }
	        }),
	        /**
	         * Specifies if the field is configured in the index as a multi value field (meaning: comma separated values).<br/>
	         * Default value is false
	         */
	        isMultiValueField: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: false }),
	        /**
	         * Specifies the field whose values will be displayed in the facet.<br/>
	         * @deprecated This option is exposed for legacy reasons, and the recommendation is to not use this option.
	         */
	        lookupField: ComponentOptions_1.ComponentOptions.buildFieldOption({ deprecated: 'This option is exposed for legacy reason, and the recommendation is to not use this option.' }),
	        /**
	         * Specifies whether to show the facet settings menu or not.<br/>
	         * The default value is `true`.
	         */
	        enableSettings: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true, section: 'SettingsMenu', priority: 9 }),
	        /**
	         * Specifies if the save state menu option is available on the facet setting menu.<br/>
	         * Of course {@link Facet.options.enableSettings} needs to be true.<br/>
	         * Default value is `false`.
	         */
	        enableSettingsFacetState: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: false, depend: 'enableSettings' }),
	        /**
	         * Specifies the sort criteria options that you want to be displayed in the facet settings menu.<br/>
	         * Of course {@link Facet.options.enableSettings} needs to be true.<br/>
	         * Possible values are : `occurrences`, `score`, `alphaAscending`, `alphaDescending`, `computedfieldascending`, `computedfielddescending`, `custom`.
	         * The default value is `occurrences,score,alphaAscending,alphaDescending`.
	         */
	        availableSorts: ComponentOptions_1.ComponentOptions.buildListOption({
	            defaultValue: ['occurrences', 'score', 'alphaAscending', 'alphaDescending'],
	            values: ['Occurrences', 'Score', 'AlphaAscending', 'AlphaDescending', 'ComputedFieldAscending', 'ComputedFieldDescending', 'ChiSquare', 'NoSort'],
	            depend: 'enableSettings'
	        }),
	        /**
	         * Specifies the criteria used to sort facet values.<br/>
	         * See {@link IGroupByRequest} for the list of available values.<br/>
	         * The default value is the first value of {@link Facet.options.availableSorts} list, or 'occurrences' if there is none specified.
	         */
	        sortCriteria: ComponentOptions_1.ComponentOptions.buildStringOption({ postProcessing: function (value, options) { return value || (options.availableSorts.length > 0 ? options.availableSorts[0] : 'occurrences'); } }),
	        /**
	         * Specifies a custom order by which facet values are sorted.<br/>
	         * For example, you could use this to specify a logical order for support tickets -> customSort : ["New","Opened","Feedback","Resolved","Feedback"].<br/>
	         */
	        customSort: ComponentOptions_1.ComponentOptions.buildListOption({ section: 'Identification' }),
	        /**
	         * Specifies the maximum number of field values that will be displayed by default in the facet, before the user click **More**.<br/>
	         * The default value is 5.
	         */
	        numberOfValues: ComponentOptions_1.ComponentOptions.buildNumberOption({ defaultValue: 5, min: 0, section: 'Identification' }),
	        /**
	         * Specifies the injection depth that will be used for the group by operation.<br/>
	         * The injection depth determines how many results are scanned in the index to ensure all potential facet values are listed. Increasing this value enhances the accuracy of the listed values, at the cost of performance.<br/>
	         * The default value is 1000.
	         */
	        injectionDepth: ComponentOptions_1.ComponentOptions.buildNumberOption({ defaultValue: 1000, min: 0 }),
	        /**
	         * Specifies whether an icon is displayed next to each facet value.<br/>
	         * The default value is false.
	         * @deprecated This option is exposed for legacy reason, and the recommendation is to not use this option.
	         */
	        showIcon: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: false, deprecated: 'This option is exposed for legacy reason, and the recommendation is to not use this option.' }),
	        /**
	         * Specifies whether the filter generated when multiple values are selected uses the AND operator, meaning that only documents having all selected values matches the resulting query.<br/>
	         * By default, filters are using the OR operator, and the resulting query matches all documents with at least one of the selected values.
	         */
	        useAnd: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: false }),
	        /**
	         * Specifies whether the user is allowed to toggle between OR and AND mode, using an icon in the top right corner of the facet.<br/>
	         * The default value is `false`.
	         */
	        enableTogglingOperator: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: false, alias: 'allowTogglingOperator' }),
	        /**
	         * Specifies whether the search box for searching inside the available values will be displayed at the bottom of the facet.<br/>
	         * The default value is true.
	         */
	        enableFacetSearch: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true, section: 'FacetSearch', priority: 8 }),
	        /**
	         * Specifies the delay (in milliseconds) before a search is sent to the server when the user starts typing in the facet search box.<br/>
	         * Using a smaller value means that results will arrive faster, but it increases the chances that many of the requests sent to the server get cancelled as the user continues typing in characters.<br/>
	         * The default value is 100.
	         */
	        facetSearchDelay: ComponentOptions_1.ComponentOptions.buildNumberOption({ defaultValue: 100, min: 0, depend: 'enableFacetSearch' }),
	        /**
	         * Specifies if the accents are ignored in the facet search.<br/>
	         * The default value is `false`.
	         */
	        facetSearchIgnoreAccents: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: false, depend: 'enableFacetSearch' }),
	        /**
	         * Specifies the number of values displayed in the facet search results popup.<br/>
	         * The default value is 15.
	         */
	        numberOfValuesInFacetSearch: ComponentOptions_1.ComponentOptions.buildNumberOption({ defaultValue: 15, min: 1 }),
	        /**
	         * Specifies if the facet should push data to the {@link Breadcrumb}.<br/>
	         * The default value is `true`.
	         */
	        includeInBreadcrumb: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true }),
	        /**
	         * Specifies the maximum number of values that the facet should display in the {@link Breadcrumb}, before outputting a "See more" button.<br/>
	         * Default is 5 on desktop, 3 on mobile.
	         */
	        numberOfValuesInBreadcrumb: ComponentOptions_1.ComponentOptions.buildNumberOption({
	            defaultFunction: function () { return DeviceUtils_1.DeviceUtils.isMobileDevice() ? 3 : 5; },
	            min: 0,
	            depend: 'includeInBreadcrumb'
	        }),
	        /**
	         * Specifies if the facet should push data to the {@link Omnibox}.<br/>
	         * It can have a real negative impact on index performance.<br/>
	         * The default value is `false`.
	         * @deprecated This option is exposed for legacy reason, and the recommendation is to not use this option.
	         */
	        includeInOmnibox: ComponentOptions_1.ComponentOptions.buildBooleanOption({
	            defaultValue: false,
	            deprecated: 'This option is exposed for legacy reason, and the recommendation is to not use this option.'
	        }),
	        /**
	         * Specifies the number of values to populate the {@link Breadcrumb} with.<br/>
	         * Of course, the {@link Facet.options.includeInOmnibox} option needs to be true.<br/>
	         * It can have a real negative impact on index performance.<br/>
	         * The default value is 5 on desktop, 3 on mobile.
	         * @deprecated This option is exposed for legacy reason, and the recommendation is to not use this option.
	         */
	        numberOfValuesInOmnibox: ComponentOptions_1.ComponentOptions.buildNumberOption({
	            defaultFunction: function () { return DeviceUtils_1.DeviceUtils.isMobileDevice() ? 3 : 5; },
	            min: 0,
	            depend: 'includeInOmnibox',
	            deprecated: 'This option is exposed for legacy reason, and the recommendation is to not use this option.'
	        }),
	        /**
	         * Specifies the name of a field on which an aggregate operation should be executed for all distinct values of the facet field.<br/>
	         * The result of the operation is displayed along with the number of occurrences for each value.<br/>
	         * You can use this option to compute the sum of a field (like a money amount) for each facet value that is listed.<br/>
	         * Works in conjunction with {@link Facet.options.computedFieldOperation} , {@link Facet.options.computedFieldFormat}, {@link Facet.options.computedFieldCaption}
	         */
	        computedField: ComponentOptions_1.ComponentOptions.buildFieldOption({ section: 'ComputedField', priority: 7 }),
	        /**
	         * Specifies the type of aggregate operation to use on the {@link Facet.options.computedField}.<br/>
	         * The available values are:
	         * <ul>
	         *   <li>sum - Computes the sum of the computed field values.</li>
	         *   <li>average - Computes the average of the computed field values.</li>
	         *   <li>minimum - Finds the minimum value of the computed field values.</li>
	         *   <li>maximum - Finds the maximum value of the computed field values.</li>
	         * </ul><br/>
	         * The default value is `sum`.
	         */
	        computedFieldOperation: ComponentOptions_1.ComponentOptions.buildStringOption({ defaultValue: 'sum', section: 'ComputedField' }),
	        /**
	         * Specifies how to format the values resulting from a {@link Facet.options.computedFieldOperation}.<br/>
	         * The formats available are defined by the Globalize library. The most common used formats are:
	         * <ul>
	         *   <li>c0 - Formats the value as a currency.</li>
	         *   <li>n0 - Formats the value as an integer.</li>
	         *   <li>n2 - Formats the value as a floating point with 2 decimal digits.</li>
	         * </ul>
	         * See: <a href='https://github.com/klaaspieter/jquery-global#globalizeformat-value-format-culture-'>Globalize</a> for more informations.<br/>
	         * Default value is `'c0`.
	         */
	        computedFieldFormat: ComponentOptions_1.ComponentOptions.buildStringOption({ defaultValue: 'c0', section: 'ComputedField' }),
	        /**
	         * Specifies what will be the caption of the {@link Facet.options.computedField} in the settings menu for sort.<br/>
	         * For example, the value `Money` will be displayed as `Money Ascending` for computed field ascending.<br/>
	         * The default value is Computed Field.
	         */
	        computedFieldCaption: ComponentOptions_1.ComponentOptions.buildLocalizedStringOption({
	            defaultValue: Strings_1.l('ComputedField'),
	            section: 'ComputedField'
	        }),
	        /**
	         * Specifies whether the facet should remain stable in its current position in the viewport while the mouse is over it.<br/>
	         * Whenever values are selected in a facet, a new query is automatically performed. This new query might cause other elements in the page to be resized (typically other facets above the one being used).<br/>
	         * When this option is enabled, the facet will adjust the scroll amount of the page to ensure that it does not move relative to the mouse when the results are updated.<br/>
	         * In some cases, the facet will also add margin to the scrollContainer, if scrolling alone is not enough to preserve position.<br/>
	         * This is the option that will add a div 'coveo-topSpace' / 'coveo-bottomSpace` around the facet container.
	         * The default value is `true`.
	         */
	        preservePosition: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true }),
	        /**
	         * Specifies the parent container of the facets.<br/>
	         * Used for the {@link Facet.options.preservePosition}.<br/>
	         * The default value is `element.parentElement`.
	         */
	        paddingContainer: ComponentOptions_1.ComponentOptions.buildSelectorOption({ defaultFunction: function (element) { return element.parentElement; } }),
	        /**
	         * Specifies the HTML element (through a CSS selector) whose scroll amount the facet should adjust to preserve its position {@link Facet.options.preservePosition} when results are updated.<br/>
	         * The default value is `document.body`.
	         */
	        scrollContainer: ComponentOptions_1.ComponentOptions.buildSelectorOption({ defaultFunction: function (element) { return document.body; } }),
	        /**
	         * Specifies if the more/less button is enabled.<br/>
	         * The default value is `true`.
	         */
	        enableMoreLess: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true }),
	        /**
	         * Specifies the number of additional results to fetch when clicking on **More** in the facet search.<br/>
	         * The default value is 10.
	         */
	        pageSize: ComponentOptions_1.ComponentOptions.buildNumberOption({ defaultValue: 10, min: 1, depend: 'enableMoreLess' }),
	        /**
	         * Specifies if the facet is collapsible.<br/>
	         * The default value is `true`.
	         */
	        enableCollapse: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true, depend: 'enableSettings' }),
	        /**
	         * Specifies an explicit list of `allowedValues` in the {@link IGroupByRequest}.<br/>
	         * This will whitelist the facet content to some specific values.<br/>
	         * Example  ["File", "People"].
	         */
	        allowedValues: ComponentOptions_1.ComponentOptions.buildListOption(),
	        /**
	         * Specifies an additional query expression (query override) to add to each group by that this facet performs.<br/>
	         * See: {@link IGroupByRequest}.<br/>
	         * Example: `@date>=2014/01/01`
	         */
	        additionalFilter: ComponentOptions_1.ComponentOptions.buildStringOption(),
	        /**
	         * Specifies that the facet appears only when a value is selected in its "parent" facet.<br/>
	         * To specify the parent facet, use its {@link Facet.options.id}. Remember that be default, the ID of a facet is its {@link Facet.options.field}.<br/>
	         * Example -> dependsOn : @parentfacetField
	         */
	        dependsOn: ComponentOptions_1.ComponentOptions.buildStringOption(),
	        /**
	         * Specifies a JSON object describing a mapping of facet values to desired captions.
	         *
	         * This option can only be set in the init call of your search interface, not directly as an HTML attribute.
	         *
	         * ```
	         * // Example: using a facet for file types
	         * var myValueCaption = {  "txt": "Text files","html": "Web page", [ etc ... ]};
	         *
	         * Coveo.init(document.querySelector('#search'), {
	         *    Facet : {
	         *      valueCaption: myValueCaption
	         *    }
	         * })
	         * // Or using the jQuery extension
	         * $("#search").coveo("init", {
	         *    Facet: {
	         *      valueCaption: myValueCaption
	         *    }
	         * })
	         * ```
	         */
	        valueCaption: ComponentOptions_1.ComponentOptions.buildCustomOption(function () {
	            return null;
	        }),
	        /**
	         * Specifies if the responsive mode should be enabled on the facets. Responsive mode will make the facet dissapear and instead be
	         * availaible using a dropdown button. Responsive facets are enabled when the width of the element the search interface is bound to
	         * reaches 800 pixels. This value can be modified using {@link Facet.options.responsiveBreakpoint}.
	         *
	         * Disabling reponsive mode for one facet will disable it for all facets.
	         * Therefore, this options only needs to be set on one facet to be effective.
	         * The default value is `true`.
	         */
	        enableResponsiveMode: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true }),
	        /**
	         * Specifies the width of the search interface, in pixels, at which the facets will go into responsive mode. The responsive mode will
	         * be triggered when the width is equal or below this value. The search interface corresponds to the element with the class
	         * `CoveoSearchInterface`.
	         * The default value is `800`.
	         */
	        responsiveBreakpoint: ComponentOptions_1.ComponentOptions.buildNumberOption({ defaultValue: 800 })
	    };
	    return Facet;
	}(Component_1.Component));
	exports.Facet = Facet;
	Initialization_1.Initialization.registerAutoCreateComponent(Facet);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var Assert_1 = __webpack_require__(17);
	var Utils_1 = __webpack_require__(18);
	var Globalize = __webpack_require__(4);
	/**
	 * A class which holds information and operation available on a single facet value returned by a {@link IGroupByRequest}.<br/>
	 * This class is used extensibely in the {@link Facet} component.
	 */
	var FacetValue = (function () {
	    function FacetValue() {
	        this.selected = false;
	        this.excluded = false;
	        this.waitingForDelta = false;
	    }
	    FacetValue.prototype.reset = function () {
	        this.selected = false;
	        this.excluded = false;
	    };
	    FacetValue.prototype.updateCountsFromNewValue = function (newValue) {
	        Assert_1.Assert.exists(newValue);
	        this.occurrences = newValue.occurrences;
	        this.delta = newValue.delta;
	        this.computedField = newValue.computedField;
	    };
	    FacetValue.prototype.cloneWithZeroOccurrences = function () {
	        this.occurrences = 0;
	        this.computedField = undefined;
	        this.delta = undefined;
	        return this;
	    };
	    FacetValue.prototype.cloneWithDelta = function (count, delta) {
	        Assert_1.Assert.isLargerOrEqualsThan(0, count);
	        var clone = this.cloneWithZeroOccurrences();
	        clone.delta = delta;
	        clone.occurrences = count;
	        return clone;
	    };
	    FacetValue.prototype.getFormattedCount = function () {
	        var count = undefined;
	        if (Utils_1.Utils.exists(this.delta) && this.delta > 0) {
	            count = '+' + Globalize.format(this.delta, 'n0');
	        }
	        else {
	            if (this.occurrences > 0) {
	                count = Globalize.format(this.occurrences, 'n0');
	            }
	        }
	        return count;
	    };
	    FacetValue.prototype.getFormattedComputedField = function (format) {
	        if (this.computedField != 0) {
	            return Globalize.format(this.computedField, format);
	        }
	        else {
	            return undefined;
	        }
	    };
	    FacetValue.create = function (value) {
	        if (_.isString(value)) {
	            return FacetValue.createFromValue(value);
	        }
	        else if (_.isObject(value)) {
	            if ('computedFieldResults' in value) {
	                return FacetValue.createFromGroupByValue(value);
	            }
	            else {
	                return FacetValue.createFromFieldValue(value);
	            }
	        }
	        else {
	            throw new Error('Can\'t create value from ' + value);
	        }
	    };
	    FacetValue.createFromValue = function (value) {
	        Assert_1.Assert.isNonEmptyString(value);
	        var facetValue = new FacetValue();
	        facetValue.value = value;
	        facetValue.lookupValue = value;
	        return facetValue;
	    };
	    FacetValue.createFromGroupByValue = function (groupByValue) {
	        Assert_1.Assert.exists(groupByValue);
	        Assert_1.Assert.exists(groupByValue);
	        var facetValue = new FacetValue();
	        facetValue.value = groupByValue.value;
	        facetValue.lookupValue = Utils_1.Utils.exists(groupByValue.lookupValue) ? groupByValue.lookupValue : groupByValue.value;
	        facetValue.occurrences = groupByValue.numberOfResults;
	        facetValue.computedField = Utils_1.Utils.isNonEmptyArray(groupByValue.computedFieldResults) ? groupByValue.computedFieldResults[0] : undefined;
	        facetValue.score = groupByValue.score;
	        return facetValue;
	    };
	    FacetValue.createFromFieldValue = function (fieldValue) {
	        Assert_1.Assert.exists(fieldValue);
	        var facetValue = new FacetValue();
	        facetValue.value = fieldValue.value;
	        facetValue.lookupValue = fieldValue.lookupValue;
	        facetValue.occurrences = fieldValue.numberOfResults;
	        return facetValue;
	    };
	    return FacetValue;
	}());
	exports.FacetValue = FacetValue;
	var FacetValues = (function () {
	    function FacetValues(groupByResult) {
	        if (Utils_1.Utils.exists(groupByResult)) {
	            this.values = _.map(groupByResult.values, function (groupByValue) { return FacetValue.createFromGroupByValue(groupByValue); });
	        }
	        else {
	            this.values = [];
	        }
	    }
	    FacetValues.prototype.add = function (facetValue) {
	        Assert_1.Assert.exists(facetValue);
	        Assert_1.Assert.check(!this.contains(facetValue.value));
	        this.values.push(facetValue);
	    };
	    FacetValues.prototype.remove = function (value) {
	        Assert_1.Assert.isNonEmptyString(value);
	        value = value;
	        this.values = _.filter(this.values, function (elem) { return elem.value != value; });
	    };
	    FacetValues.prototype.size = function () {
	        return this.values.length;
	    };
	    FacetValues.prototype.isEmpty = function () {
	        return this.values.length == 0;
	    };
	    FacetValues.prototype.at = function (index) {
	        Assert_1.Assert.isLargerOrEqualsThan(0, index);
	        Assert_1.Assert.isSmallerThan(this.values.length, index);
	        return this.values[index];
	    };
	    FacetValues.prototype.get = function (value) {
	        return _.find(this.values, function (elem) { return elem.value.toLowerCase() == value.toLowerCase(); });
	    };
	    FacetValues.prototype.contains = function (value) {
	        return Utils_1.Utils.exists(this.get(value));
	    };
	    FacetValues.prototype.getAll = function () {
	        return this.values;
	    };
	    FacetValues.prototype.getSelected = function () {
	        return _.filter(this.values, function (value) { return value.selected; });
	    };
	    FacetValues.prototype.getExcluded = function () {
	        return _.filter(this.values, function (value) { return value.excluded; });
	    };
	    FacetValues.prototype.hasSelectedOrExcludedValues = function () {
	        return this.getSelected().length != 0 || this.getExcluded().length != 0;
	    };
	    FacetValues.prototype.reset = function () {
	        _.each(this.values, function (elem) { return elem.reset(); });
	    };
	    FacetValues.prototype.importActiveValuesFromOtherList = function (other) {
	        var _this = this;
	        Assert_1.Assert.exists(other);
	        _.each(other.getSelected(), function (otherValue) {
	            var myValue = _this.get(otherValue.value);
	            if (Utils_1.Utils.exists(myValue)) {
	                myValue.selected = true;
	            }
	            else {
	                _this.values.push(otherValue.cloneWithZeroOccurrences());
	            }
	        });
	        _.each(other.getExcluded(), function (otherValue) {
	            var myValue = _this.get(otherValue.value);
	            if (Utils_1.Utils.exists(myValue)) {
	                myValue.excluded = true;
	            }
	            else if (otherValue.occurrences != 0) {
	                var occurrences = otherValue.occurrences;
	                var clone = otherValue.cloneWithZeroOccurrences();
	                clone.occurrences = occurrences;
	                _this.values.push(clone);
	            }
	            else {
	                _this.values.push(otherValue.cloneWithZeroOccurrences());
	            }
	        });
	    };
	    FacetValues.prototype.updateCountsFromNewValues = function (newValues) {
	        Assert_1.Assert.exists(newValues);
	        this.values = _.map(this.values, function (myValue) {
	            var newValue = newValues.get(myValue.value);
	            if (Utils_1.Utils.exists(newValue)) {
	                myValue.updateCountsFromNewValue(newValue);
	                return myValue;
	            }
	            else {
	                return myValue.cloneWithZeroOccurrences();
	            }
	        });
	    };
	    FacetValues.prototype.updateDeltaWithFilteredFacetValues = function (filtered) {
	        Assert_1.Assert.exists(filtered);
	        _.each(this.values, function (unfilteredValue) {
	            var filteredValue = filtered.get(unfilteredValue.value);
	            unfilteredValue.waitingForDelta = false;
	            if (Utils_1.Utils.exists(filteredValue)) {
	                if (unfilteredValue.occurrences - filteredValue.occurrences > 0) {
	                    unfilteredValue.delta = unfilteredValue.occurrences - filteredValue.occurrences;
	                }
	                else {
	                    unfilteredValue.delta = null;
	                }
	            }
	            else if (!unfilteredValue.selected && !unfilteredValue.excluded) {
	                unfilteredValue.delta = unfilteredValue.occurrences;
	            }
	        });
	    };
	    FacetValues.prototype.mergeWithUnfilteredFacetValues = function (unfiltered) {
	        var _this = this;
	        Assert_1.Assert.exists(unfiltered);
	        var values = [];
	        _.each(unfiltered.values, function (unfilteredValue) {
	            var filteredValue = _this.get(unfilteredValue.value);
	            if (Utils_1.Utils.exists(filteredValue)) {
	                if (filteredValue.occurrences == unfilteredValue.occurrences) {
	                    values.push(filteredValue);
	                }
	                else {
	                    values.push(unfilteredValue.cloneWithDelta(unfilteredValue.occurrences, unfilteredValue.occurrences - filteredValue.occurrences));
	                }
	            }
	            else {
	                values.push(unfilteredValue.cloneWithDelta(unfilteredValue.occurrences, unfilteredValue.occurrences));
	            }
	        });
	        var index = 0;
	        _.each(this.values, function (value) {
	            var unfilteredValue = unfiltered.get(value.value);
	            if (!Utils_1.Utils.exists(unfilteredValue)) {
	                if (value.selected || value.excluded) {
	                    values.splice(index, 0, value);
	                    index++;
	                }
	            }
	            else {
	                for (var i = 0; i < values.length; i++) {
	                    if (values[i].value == value.value) {
	                        index = i + 1;
	                        break;
	                    }
	                }
	            }
	        });
	        this.values = values;
	    };
	    FacetValues.prototype.sortValuesDependingOnStatus = function (excludeLastIndex) {
	        this.values = _.sortBy(this.values, function (value) {
	            if (value.selected) {
	                return 1;
	            }
	            else if (value.excluded) {
	                return 3;
	            }
	            else {
	                return 2;
	            }
	        });
	        if (excludeLastIndex != null && excludeLastIndex < this.values.length) {
	            var nbExclude = this.getExcluded().length;
	            var excludes = this.values.splice(this.values.length - nbExclude, nbExclude);
	            Array.prototype.splice.apply(this.values, [excludeLastIndex - nbExclude, 0].concat(excludes));
	        }
	    };
	    return FacetValues;
	}());
	exports.FacetValues = FacetValues;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {/// <reference path="Facet.ts" />
	"use strict";
	var Facet_1 = __webpack_require__(141);
	var Dom_1 = __webpack_require__(57);
	var Utils_1 = __webpack_require__(18);
	var InitializationEvents_1 = __webpack_require__(44);
	var DeviceUtils_1 = __webpack_require__(20);
	var EventsUtils_1 = __webpack_require__(144);
	var FacetSearchParameters_1 = __webpack_require__(81);
	var AnalyticsActionListMeta_1 = __webpack_require__(110);
	var Component_1 = __webpack_require__(96);
	var DomUtils_1 = __webpack_require__(59);
	var PopupUtils_1 = __webpack_require__(71);
	var Strings_1 = __webpack_require__(34);
	var Assert_1 = __webpack_require__(17);
	var KeyboardUtils_1 = __webpack_require__(68);
	var FacetUtils_1 = __webpack_require__(82);
	var FacetValues_1 = __webpack_require__(142);
	var StringUtils_1 = __webpack_require__(61);
	var FacetValueElement_1 = __webpack_require__(145);
	var ExternalModulesShim_1 = __webpack_require__(25);
	var SearchInterface_1 = __webpack_require__(97);
	var ResponsiveComponentsUtils_1 = __webpack_require__(148);
	var FacetValuesOrder_1 = __webpack_require__(149);
	/**
	 * Used by the {@link Facet} component to render and handle the facet search part of each facet.
	 */
	var FacetSearch = (function () {
	    function FacetSearch(facet, facetSearchValuesListKlass, root) {
	        var _this = this;
	        this.facet = facet;
	        this.facetSearchValuesListKlass = facetSearchValuesListKlass;
	        this.root = root;
	        this.showingFacetSearchWaitAnimation = false;
	        this.moreValuesToFetch = true;
	        this.searchBarIsAnimating = false;
	        this.searchResults = document.createElement('ul');
	        Dom_1.$$(this.searchResults).addClass('coveo-facet-search-results');
	        this.onResize = _.debounce(function () {
	            // Mitigate issues in UT where the window in phantom js might get resized in the scope of another test.
	            // These would point to random instance of a test karma object, and not a real search interface.
	            if (_this.facet instanceof Facet_1.Facet && _this.facet.searchInterface instanceof SearchInterface_1.SearchInterface) {
	                if (_this.shouldPositionSearchResults()) {
	                    _this.positionSearchResults();
	                }
	            }
	        }, 250);
	        this.onDocumentClick = function (e) {
	            _this.handleClickElsewhere(e);
	        };
	        window.addEventListener('resize', function () { return _this.onResize(); });
	        document.addEventListener('click', function (e) { return _this.onDocumentClick(e); });
	        Dom_1.$$(facet.root).on(InitializationEvents_1.InitializationEvents.nuke, function () { return _this.handleNuke(); });
	    }
	    FacetSearch.prototype.isMobileDevice = function () {
	        return DeviceUtils_1.DeviceUtils.isMobileDevice() && !this.facet.searchInterface.isNewDesign();
	    };
	    /**
	     * Build the search component and return an `HTMLElement` which can be appended to the {@link Facet}.
	     * @returns {HTMLElement}
	     */
	    FacetSearch.prototype.build = function () {
	        if (this.isMobileDevice()) {
	            return this.buildSearchMobile();
	        }
	        else {
	            return this.buildBaseSearch();
	        }
	    };
	    /**
	     * Position the search results at the footer of the facet.
	     */
	    FacetSearch.prototype.positionSearchResults = function (nextTo) {
	        if (nextTo === void 0) { nextTo = this.search; }
	        if (this.searchResults != null) {
	            if (!this.isMobileDevice()) {
	                this.searchResults.style.display = 'block';
	                this.searchResults.style.width = this.facet.element.clientWidth - 40 + 'px';
	            }
	            if (Dom_1.$$(this.searchResults).css('display') == 'none') {
	                this.searchResults.style.display = '';
	            }
	            var searchBar = Dom_1.$$(this.search);
	            if (searchBar.css('display') == 'none' || this.searchBarIsAnimating) {
	                if (Dom_1.$$(this.searchResults).css('display') == 'none') {
	                    this.searchResults.style.display = '';
	                }
	                var self_1 = this;
	                EventsUtils_1.EventsUtils.addPrefixedEvent(this.search, 'AnimationEnd', function (evt) {
	                    PopupUtils_1.PopupUtils.positionPopup(self_1.searchResults, nextTo, self_1.root, { horizontal: PopupUtils_1.HorizontalAlignment.CENTER, vertical: PopupUtils_1.VerticalAlignment.BOTTOM });
	                    EventsUtils_1.EventsUtils.removePrefixedEvent(self_1.search, 'AnimationEnd', this);
	                });
	            }
	            else {
	                PopupUtils_1.PopupUtils.positionPopup(this.searchResults, nextTo, this.root, { horizontal: PopupUtils_1.HorizontalAlignment.CENTER, vertical: PopupUtils_1.VerticalAlignment.BOTTOM });
	            }
	        }
	    };
	    /**
	     * Dismiss the search results
	     */
	    FacetSearch.prototype.completelyDismissSearch = function () {
	        this.cancelAnyPendingSearchOperation();
	        this.facet.unfadeInactiveValuesInMainList();
	        Dom_1.$$(this.searchResults).empty();
	        this.moreValuesToFetch = true;
	        Dom_1.$$(this.search).removeClass('coveo-facet-search-no-results');
	        Dom_1.$$(this.facet.element).removeClass('coveo-facet-searching');
	        this.hideSearchResultsElement();
	        this.input.value = '';
	        Dom_1.$$(this.clear).hide();
	        this.currentlyDisplayedResults = undefined;
	    };
	    /**
	     * Trigger a new facet search, and display the results.
	     * @param params
	     */
	    FacetSearch.prototype.triggerNewFacetSearch = function (params) {
	        var _this = this;
	        this.cancelAnyPendingSearchOperation();
	        this.showFacetSearchWaitingAnimation();
	        this.facet.logger.info('Triggering new facet search');
	        this.facetSearchPromise = this.facet.facetQueryController.search(params);
	        if (this.facetSearchPromise) {
	            this.facetSearchPromise.then(function (fieldValues) {
	                _this.facet.usageAnalytics.logCustomEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.facetSearch, {
	                    facetId: _this.facet.options.id,
	                    facetTitle: _this.facet.options.title
	                }, _this.facet.root);
	                _this.facet.logger.debug('Received field values', fieldValues);
	                _this.processNewFacetSearchResults(fieldValues, params);
	                _this.hideFacetSearchWaitingAnimation();
	                _this.facetSearchPromise = undefined;
	            });
	            this.facetSearchPromise.catch(function (error) {
	                // The request might be normally cancelled if another search is triggered.
	                // In this case we do not hide the animation to prevent flicking.
	                if (Utils_1.Utils.exists(error)) {
	                    _this.facet.logger.error('Error while retrieving facet values', error);
	                    _this.hideFacetSearchWaitingAnimation();
	                }
	                _this.facetSearchPromise = undefined;
	            });
	        }
	    };
	    /**
	     * Trigger the event associated with the focus of the search input.
	     */
	    FacetSearch.prototype.focus = function () {
	        this.input.focus();
	        this.handleFacetSearchFocus();
	    };
	    FacetSearch.prototype.shouldPositionSearchResults = function () {
	        return !this.isMobileDevice() && !ResponsiveComponentsUtils_1.ResponsiveComponentsUtils.isSmallFacetActivated(Dom_1.$$(this.root))
	            && Dom_1.$$(this.facet.element).hasClass('coveo-facet-searching');
	    };
	    FacetSearch.prototype.buildBaseSearch = function () {
	        var _this = this;
	        this.search = document.createElement('div');
	        Dom_1.$$(this.search).addClass('coveo-facet-search');
	        this.magnifier = document.createElement('div');
	        Dom_1.$$(this.magnifier).addClass('coveo-facet-search-magnifier');
	        this.search.appendChild(this.magnifier);
	        this.wait = document.createElement('div');
	        Dom_1.$$(this.wait).addClass('coveo-facet-search-wait-animation');
	        this.search.appendChild(this.wait);
	        this.hideFacetSearchWaitingAnimation();
	        this.clear = document.createElement('div');
	        Dom_1.$$(this.clear).addClass('coveo-facet-search-clear');
	        this.clear.setAttribute('title', Strings_1.l('Clear', Strings_1.l('Search')));
	        this.clear.style.display = 'none';
	        this.search.appendChild(this.clear);
	        this.clearIcon = document.createElement('span');
	        Dom_1.$$(this.clearIcon).addClass('coveo-icon');
	        this.clear.appendChild(this.clearIcon);
	        this.middle = document.createElement('div');
	        Dom_1.$$(this.middle).addClass('coveo-facet-search-middle');
	        this.search.appendChild(this.middle);
	        this.input = document.createElement('input');
	        this.input.setAttribute('type', 'text');
	        this.input.setAttribute('autocapitalize', 'off');
	        this.input.setAttribute('autocorrect', 'off');
	        this.input.setAttribute('placeholder', this.facet.searchInterface.isNewDesign() ? '' : Strings_1.l('SearchIn', this.facet.options.title));
	        Dom_1.$$(this.input).addClass('coveo-facet-search-input');
	        Component_1.Component.pointElementsToDummyForm(this.input);
	        this.middle.appendChild(this.input);
	        Dom_1.$$(this.input).on('keyup', function (e) { return _this.handleFacetSearchKeyUp(e); });
	        Dom_1.$$(this.clear).on('click', function (e) { return _this.handleFacetSearchClear(); });
	        Dom_1.$$(this.input).on('focus', function (e) { return _this.handleFacetSearchFocus(); });
	        this.detectSearchBarAnimation();
	        this.root.appendChild(this.searchResults);
	        this.searchResults.style.display = 'none';
	        return this.search;
	    };
	    FacetSearch.prototype.buildSearchMobile = function () {
	        var _this = this;
	        var button = document.createElement('div');
	        Dom_1.$$(button).addClass('coveo-facet-search-button-mobile');
	        Dom_1.$$(button).text(Strings_1.l('Search'));
	        this.search = this.buildBaseSearch();
	        Dom_1.$$(button).on('click', function () {
	            var toOpen = document.createElement('div');
	            toOpen.appendChild(_this.search);
	            ExternalModulesShim_1.ModalBox.open(toOpen, {
	                title: DomUtils_1.DomUtils.getPopUpCloseButton(Strings_1.l('Close'), Strings_1.l('SearchIn', _this.facet.options.title)),
	                validation: function () {
	                    _this.completelyDismissSearch();
	                    return true;
	                },
	                className: 'coveo-mobile-facet-search',
	                titleClose: true
	            });
	            _this.input.value = '';
	            _this.input.focus();
	        });
	        return button;
	    };
	    FacetSearch.prototype.handleFacetSearchKeyUp = function (event) {
	        Assert_1.Assert.exists(event);
	        var isEmpty = this.input.value == '';
	        this.showOrHideClearElement(isEmpty);
	        if (!this.isMobileDevice()) {
	            this.handleKeyboardNavigation(event, isEmpty);
	        }
	        else {
	            this.startNewSearchTimeout(this.buildParamsForNormalSearch());
	        }
	    };
	    FacetSearch.prototype.handleNuke = function () {
	        window.removeEventListener('resize', this.onResize);
	        document.removeEventListener('click', this.onDocumentClick);
	    };
	    FacetSearch.prototype.handleFacetSearchFocus = function () {
	        if (!this.isMobileDevice()) {
	            if (this.facet.searchInterface.isNewDesign()) {
	                this.startNewSearchTimeout(this.buildParamsForExcludingCurrentlyDisplayedValues());
	            }
	            else {
	                this.startNewSearchTimeout(this.buildParamsForNormalSearch());
	            }
	        }
	    };
	    FacetSearch.prototype.handleClickElsewhere = function (event) {
	        if (this.currentlyDisplayedResults && !this.isMobileDevice() && this.search != event.target && this.searchResults != event.target) {
	            this.completelyDismissSearch();
	        }
	    };
	    FacetSearch.prototype.handleFacetSearchClear = function () {
	        this.input.value = '';
	        Dom_1.$$(this.clear).hide();
	        this.completelyDismissSearch();
	    };
	    FacetSearch.prototype.showOrHideClearElement = function (isEmpty) {
	        if (!isEmpty) {
	            Dom_1.$$(this.clear).show();
	        }
	        else {
	            Dom_1.$$(this.clear).hide();
	            Dom_1.$$(this.search).removeClass('coveo-facet-search-no-results');
	        }
	    };
	    FacetSearch.prototype.handleKeyboardNavigation = function (event, isEmpty) {
	        switch (event.which) {
	            case KeyboardUtils_1.KEYBOARD.ENTER:
	                this.keyboardNavigationEnterPressed(event, isEmpty);
	                break;
	            case KeyboardUtils_1.KEYBOARD.DELETE:
	                this.keyboardNavigationDeletePressed(event);
	                break;
	            case KeyboardUtils_1.KEYBOARD.ESCAPE:
	                this.completelyDismissSearch();
	                break;
	            case KeyboardUtils_1.KEYBOARD.DOWN_ARROW:
	                this.moveCurrentResultDown();
	                break;
	            case KeyboardUtils_1.KEYBOARD.UP_ARROW:
	                this.moveCurrentResultUp();
	                break;
	            default:
	                this.moreValuesToFetch = true;
	                this.highlightCurrentQueryWithinSearchResults();
	                this.startNewSearchTimeout(this.buildParamsForNormalSearch());
	                break;
	        }
	    };
	    FacetSearch.prototype.keyboardNavigationEnterPressed = function (event, isEmpty) {
	        if (event.shiftKey) {
	            this.triggerNewFacetSearch(this.buildParamsForNormalSearch());
	        }
	        else {
	            if (this.searchResults.style.display != 'none') {
	                this.performSelectActionOnCurrentSearchResult();
	                this.completelyDismissSearch();
	            }
	            else if (Dom_1.$$(this.search).is('.coveo-facet-search-no-results') && !isEmpty) {
	                this.selectAllValuesMatchingSearch();
	            }
	        }
	    };
	    FacetSearch.prototype.keyboardNavigationDeletePressed = function (event) {
	        if (event.shiftKey) {
	            this.performExcludeActionOnCurrentSearchResult();
	            this.completelyDismissSearch();
	            this.input.value = '';
	        }
	    };
	    FacetSearch.prototype.startNewSearchTimeout = function (params) {
	        var _this = this;
	        this.cancelAnyPendingSearchOperation();
	        this.facetSearchTimeout = setTimeout(function () {
	            var valueInInput = _this.getValueInInputForFacetSearch();
	            if (valueInInput == '') {
	                if (params.searchEvenIfEmpty) {
	                    _this.triggerNewFacetSearch(params);
	                }
	                else {
	                    _this.completelyDismissSearch();
	                }
	            }
	            else {
	                _this.triggerNewFacetSearch(params);
	            }
	        }, this.facet.options.facetSearchDelay);
	    };
	    FacetSearch.prototype.cancelAnyPendingSearchOperation = function () {
	        if (Utils_1.Utils.exists(this.facetSearchTimeout)) {
	            clearTimeout(this.facetSearchTimeout);
	            this.facetSearchTimeout = undefined;
	        }
	        if (Utils_1.Utils.exists(this.facetSearchPromise)) {
	            Promise.reject(this.facetSearchPromise).catch(function () { });
	            this.facetSearchPromise = undefined;
	        }
	        this.hideFacetSearchWaitingAnimation();
	    };
	    FacetSearch.prototype.processNewFacetSearchResults = function (fieldValues, facetSearchParameters) {
	        Assert_1.Assert.exists(fieldValues);
	        fieldValues = new FacetValuesOrder_1.FacetValuesOrder(this.facet, this.facet.facetSort).reorderValues(fieldValues);
	        if (fieldValues.length > 0) {
	            Dom_1.$$(this.search).removeClass('coveo-facet-search-no-results');
	            this.facet.fadeInactiveValuesInMainList(this.facet.options.facetSearchDelay);
	            this.rebuildSearchResults(fieldValues, facetSearchParameters);
	            if (!facetSearchParameters.fetchMore) {
	                this.showSearchResultsElement();
	            }
	            this.highlightCurrentQueryWithinSearchResults();
	            FacetUtils_1.FacetUtils.clipCaptionsToAvoidOverflowingTheirContainer(this.facet, true);
	            this.makeFirstSearchResultTheCurrentOne();
	        }
	        else {
	            if (facetSearchParameters.fetchMore) {
	                this.moreValuesToFetch = false;
	            }
	            else {
	                this.hideSearchResultsElement();
	                Dom_1.$$(this.search).addClass('coveo-facet-search-no-results');
	            }
	        }
	    };
	    FacetSearch.prototype.rebuildSearchResults = function (fieldValues, facetSearchParameters) {
	        var _this = this;
	        Assert_1.Assert.exists(fieldValues);
	        if (!facetSearchParameters.fetchMore) {
	            Dom_1.$$(this.searchResults).empty();
	        }
	        var selectAll = document.createElement('li');
	        if (Utils_1.Utils.isNonEmptyString(facetSearchParameters.valueToSearch)) {
	            Dom_1.$$(selectAll).addClass(['coveo-facet-selectable', 'coveo-facet-search-selectable', 'coveo-facet-search-select-all']);
	            Dom_1.$$(selectAll).text('SelectAll');
	            Dom_1.$$(selectAll).on('click', function () { return _this.selectAllValuesMatchingSearch(); });
	            if (!this.isMobileDevice()) {
	                this.searchResults.appendChild(selectAll);
	            }
	        }
	        var facetValues = _.map(fieldValues, function (fieldValue) {
	            return FacetValues_1.FacetValue.create(fieldValue);
	        });
	        _.each(new this.facetSearchValuesListKlass(this.facet, FacetValueElement_1.FacetValueElement).build(facetValues), function (listElement) {
	            _this.searchResults.appendChild(listElement);
	        });
	        if (this.currentlyDisplayedResults) {
	            this.currentlyDisplayedResults = this.currentlyDisplayedResults.concat(_.pluck(facetValues, 'value'));
	        }
	        else {
	            this.currentlyDisplayedResults = _.pluck(facetValues, 'value');
	        }
	        if (this.isMobileDevice()) {
	            var selectAllMobile = document.createElement('span');
	            Dom_1.$$(selectAllMobile).addClass('coveo-mobile-facet-search-select-all');
	            selectAll.appendChild(selectAllMobile);
	            this.searchResults.appendChild(selectAll);
	        }
	        _.each(Dom_1.$$(this.searchResults).findAll('.coveo-facet-selectable'), function (elem) {
	            Dom_1.$$(elem).addClass('coveo-facet-search-selectable');
	            _this.setupFacetSearchResultsEvents(elem);
	        });
	        if (this.facet.searchInterface.isNewDesign()) {
	            Dom_1.$$(this.searchResults).on('scroll', function () { return _this.handleFacetSearchResultsScroll(); });
	        }
	    };
	    FacetSearch.prototype.setupFacetSearchResultsEvents = function (elem) {
	        var _this = this;
	        Dom_1.$$(elem).on('mousemove', function () {
	            _this.makeCurrentResult(elem);
	        });
	        // Prevent closing the search results on the end of a touch drag
	        var touchDragging = false;
	        var mouseDragging = false;
	        Dom_1.$$(elem).on('mousedown', function () { return mouseDragging = false; });
	        Dom_1.$$(elem).on('mousemove', function () { return mouseDragging = true; });
	        Dom_1.$$(elem).on('touchmove', function () { return touchDragging = true; });
	        Dom_1.$$(elem).on('mouseup touchend', function () {
	            if (!touchDragging && !mouseDragging) {
	                setTimeout(function () {
	                    _this.completelyDismissSearch();
	                }, 0); // setTimeout is to give time to trigger the click event before hiding the search menu.
	            }
	            touchDragging = false;
	            mouseDragging = false;
	        });
	    };
	    FacetSearch.prototype.handleFacetSearchResultsScroll = function () {
	        if (this.facetSearchPromise || this.getValueInInputForFacetSearch() != '' || !this.moreValuesToFetch) {
	            return;
	        }
	        var elementHeight = this.searchResults.clientHeight;
	        var scrollHeight = this.searchResults.scrollHeight;
	        var bottomPosition = this.searchResults.scrollTop + elementHeight;
	        if ((scrollHeight - bottomPosition) < elementHeight / 2) {
	            this.triggerNewFacetSearch(this.buildParamsForFetchingMore());
	        }
	    };
	    FacetSearch.prototype.buildParamsForNormalSearch = function () {
	        var params = new FacetSearchParameters_1.FacetSearchParameters(this.facet);
	        params.setValueToSearch(this.getValueInInputForFacetSearch());
	        params.fetchMore = false;
	        return params;
	    };
	    FacetSearch.prototype.buildParamsForFetchingMore = function () {
	        var params = this.buildParamsForExcludingCurrentlyDisplayedValues();
	        params.fetchMore = true;
	        return params;
	    };
	    FacetSearch.prototype.buildParamsForExcludingCurrentlyDisplayedValues = function () {
	        var params = new FacetSearchParameters_1.FacetSearchParameters(this.facet);
	        params.excludeCurrentlyDisplayedValuesInSearch(this.searchResults);
	        params.setValueToSearch(this.getValueInInputForFacetSearch());
	        return params;
	    };
	    FacetSearch.prototype.showSearchResultsElement = function () {
	        this.positionSearchResults();
	    };
	    FacetSearch.prototype.hideSearchResultsElement = function () {
	        this.searchResults.style.display = 'none';
	    };
	    FacetSearch.prototype.highlightCurrentQueryWithinSearchResults = function () {
	        var _this = this;
	        var captions = Dom_1.$$(this.searchResults).findAll('.coveo-facet-value-caption');
	        _.each(captions, function (captionElement) {
	            var search = _this.getValueInInputForFacetSearch();
	            var regex = new RegExp('(' + StringUtils_1.StringUtils.wildcardsToRegex(search, _this.facet.options.facetSearchIgnoreAccents) + ')', 'ig');
	            var text = Dom_1.$$(captionElement).text();
	            var highlighted = text.replace(regex, '<span class="coveo-highlight">$1</span>');
	            captionElement.innerHTML = highlighted;
	        });
	    };
	    FacetSearch.prototype.makeFirstSearchResultTheCurrentOne = function () {
	        this.makeCurrentResult(this.getSelectables()[0]);
	    };
	    FacetSearch.prototype.makeCurrentResult = function (result) {
	        _.each(this.getSelectables(), function (selectable) {
	            Dom_1.$$(selectable).removeClass('coveo-current');
	        });
	        Dom_1.$$(result).addClass('coveo-current');
	    };
	    FacetSearch.prototype.moveCurrentResultDown = function () {
	        var current = Dom_1.$$(this.searchResults).find('.coveo-current');
	        _.each(this.getSelectables(), function (selectable) {
	            Dom_1.$$(selectable).removeClass('coveo-current');
	        });
	        var allSelectables = this.getSelectables();
	        var idx = _.indexOf(allSelectables, current);
	        if (idx < allSelectables.length - 1) {
	            Dom_1.$$(allSelectables[idx + 1]).addClass('coveo-current');
	        }
	        else {
	            Dom_1.$$(allSelectables[0]).addClass('coveo-current');
	        }
	    };
	    FacetSearch.prototype.moveCurrentResultUp = function () {
	        var current = Dom_1.$$(this.searchResults).find('.coveo-current');
	        _.each(Dom_1.$$(this.searchResults).findAll('.coveo-facet-selectable'), function (s) {
	            Dom_1.$$(s).removeClass('coveo-current');
	        });
	        var allSelectables = this.getSelectables();
	        var idx = _.indexOf(allSelectables, current);
	        if (idx > 0) {
	            Dom_1.$$(allSelectables[idx - 1]).addClass('coveo-current');
	        }
	        else {
	            Dom_1.$$(allSelectables[allSelectables.length - 1]).addClass('coveo-current');
	        }
	    };
	    FacetSearch.prototype.getSelectables = function (target) {
	        if (target === void 0) { target = this.searchResults; }
	        return Dom_1.$$(target).findAll('.coveo-facet-selectable');
	    };
	    FacetSearch.prototype.performSelectActionOnCurrentSearchResult = function () {
	        var current = Dom_1.$$(this.searchResults).find('.coveo-current');
	        Assert_1.Assert.check(current != undefined);
	        var checkbox = Dom_1.$$(current).find('input[type="checkbox"]');
	        if (checkbox != undefined) {
	            checkbox.checked = true;
	            Dom_1.$$(checkbox).trigger('change');
	        }
	        else {
	            current.click();
	        }
	    };
	    FacetSearch.prototype.performExcludeActionOnCurrentSearchResult = function () {
	        var current = $(this.searchResults).find('.coveo-current');
	        Assert_1.Assert.check(current.length == 1);
	        current.find('.coveo-facet-value-exclude').click();
	    };
	    FacetSearch.prototype.getValueInInputForFacetSearch = function () {
	        return this.input.value;
	    };
	    FacetSearch.prototype.selectAllValuesMatchingSearch = function () {
	        var _this = this;
	        this.facet.showWaitingAnimation();
	        var searchParameters = new FacetSearchParameters_1.FacetSearchParameters(this.facet);
	        searchParameters.nbResults = 1000;
	        searchParameters.setValueToSearch(this.getValueInInputForFacetSearch());
	        this.facet.facetQueryController.search(searchParameters).then(function (fieldValues) {
	            _this.completelyDismissSearch();
	            ExternalModulesShim_1.ModalBox.close(true);
	            var facetValues = _.map(fieldValues, function (fieldValue) {
	                var facetValue = _this.facet.values.get(fieldValue.value);
	                if (!Utils_1.Utils.exists(facetValue)) {
	                    facetValue = FacetValues_1.FacetValue.create(fieldValue);
	                }
	                facetValue.selected = true;
	                facetValue.excluded = false;
	                return facetValue;
	            });
	            _this.facet.processFacetSearchAllResultsSelected(facetValues);
	        });
	        this.completelyDismissSearch();
	    };
	    FacetSearch.prototype.showFacetSearchWaitingAnimation = function () {
	        Dom_1.$$(this.magnifier).hide();
	        Dom_1.$$(this.wait).show();
	        this.showingFacetSearchWaitAnimation = true;
	    };
	    FacetSearch.prototype.hideFacetSearchWaitingAnimation = function () {
	        Dom_1.$$(this.magnifier).show();
	        Dom_1.$$(this.wait).hide();
	        this.showingFacetSearchWaitAnimation = false;
	    };
	    FacetSearch.prototype.detectSearchBarAnimation = function () {
	        var _this = this;
	        EventsUtils_1.EventsUtils.addPrefixedEvent(this.search, 'AnimationStart', function (event) {
	            if (event.animationName == 'grow') {
	                _this.searchBarIsAnimating = true;
	            }
	        });
	        EventsUtils_1.EventsUtils.addPrefixedEvent(this.search, 'AnimationEnd', function (event) {
	            if (event.animationName == 'grow') {
	                _this.searchBarIsAnimating = false;
	            }
	        });
	    };
	    return FacetSearch;
	}());
	exports.FacetSearch = FacetSearch;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var EventsUtils = (function () {
	    function EventsUtils() {
	    }
	    // eventName must be in PascalCase
	    EventsUtils.addPrefixedEvent = function (element, pascalCaseEventName, callback) {
	        _.each(this.prefixes, function (prefix) {
	            if (prefix == '') {
	                pascalCaseEventName = pascalCaseEventName.toLowerCase();
	            }
	            element.addEventListener(prefix + pascalCaseEventName, callback, false);
	        });
	    };
	    // eventName must be in PascalCase
	    EventsUtils.removePrefixedEvent = function (element, pascalCaseEventName, callback) {
	        _.each(this.prefixes, function (prefix) {
	            if (prefix == '') {
	                pascalCaseEventName = pascalCaseEventName.toLowerCase();
	            }
	            element.removeEventListener(prefix + pascalCaseEventName, callback, false);
	        });
	    };
	    EventsUtils.prefixes = ['webkit', 'moz', 'MS', 'o', ''];
	    return EventsUtils;
	}());
	exports.EventsUtils = EventsUtils;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	/// <reference path="Facet.ts" />
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var QueryEvents_1 = __webpack_require__(47);
	var Dom_1 = __webpack_require__(57);
	var ValueElement_1 = __webpack_require__(146);
	var FacetValueElement = (function (_super) {
	    __extends(FacetValueElement, _super);
	    function FacetValueElement(facet, facetValue, keepDisplayedValueNextTime) {
	        var _this = this;
	        _super.call(this, facet, facetValue);
	        this.facet = facet;
	        this.facetValue = facetValue;
	        this.keepDisplayedValueNextTime = keepDisplayedValueNextTime;
	        this.firstQuery = true;
	        // The analytics code expect a first query to be made to link the user action with a query UID
	        Dom_1.$$(facet.root).one(QueryEvents_1.QueryEvents.querySuccess, function () {
	            _this.firstQuery = false;
	        });
	    }
	    FacetValueElement.prototype.bindEvent = function () {
	        _super.prototype.bindEvent.call(this, { displayNextTime: this.keepDisplayedValueNextTime, pinFacet: this.facet.options.preservePosition });
	    };
	    return FacetValueElement;
	}(ValueElement_1.ValueElement));
	exports.FacetValueElement = FacetValueElement;


/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ValueElementRenderer_1 = __webpack_require__(147);
	var Utils_1 = __webpack_require__(18);
	var AnalyticsActionListMeta_1 = __webpack_require__(110);
	var Dom_1 = __webpack_require__(57);
	var DeviceUtils_1 = __webpack_require__(20);
	var Defer_1 = __webpack_require__(31);
	var ExternalModulesShim_1 = __webpack_require__(25);
	var KeyboardUtils_1 = __webpack_require__(68);
	var ValueElement = (function () {
	    function ValueElement(facet, facetValue, onSelect, onExclude) {
	        this.facet = facet;
	        this.facetValue = facetValue;
	        this.onSelect = onSelect;
	        this.onExclude = onExclude;
	    }
	    ValueElement.prototype.build = function () {
	        this.renderer = new ValueElementRenderer_1.ValueElementRenderer(this.facet, this.facetValue).build();
	        this.bindEvent({ displayNextTime: true, pinFacet: this.facet.options.preservePosition });
	        return this;
	    };
	    ValueElement.prototype.bindEvent = function (eventBindings) {
	        if (!Utils_1.Utils.isNullOrUndefined(eventBindings.omniboxObject)) {
	            this.isOmnibox = true;
	        }
	        else {
	            this.isOmnibox = false;
	        }
	        this.handleEventForCheckboxChange(eventBindings);
	        if (this.facetValue.excluded) {
	            this.handleEventForExcludedValueElement(eventBindings);
	        }
	        else {
	            this.handleEventForValueElement(eventBindings);
	        }
	    };
	    ValueElement.prototype.select = function () {
	        this.facetValue.selected = true;
	        this.facetValue.excluded = false;
	        this.renderer.setCssClassOnListValueElement();
	    };
	    ValueElement.prototype.unselect = function () {
	        this.facetValue.selected = false;
	        this.facetValue.excluded = false;
	        this.renderer.setCssClassOnListValueElement();
	    };
	    ValueElement.prototype.exclude = function () {
	        this.facetValue.selected = false;
	        this.facetValue.excluded = true;
	        this.renderer.setCssClassOnListValueElement();
	    };
	    ValueElement.prototype.unexclude = function () {
	        this.facetValue.selected = false;
	        this.facetValue.excluded = false;
	        this.renderer.setCssClassOnListValueElement();
	    };
	    ValueElement.prototype.handleSelectValue = function (eventBindings) {
	        var _this = this;
	        this.facet.keepDisplayedValuesNextTime = eventBindings.displayNextTime && !this.facet.options.useAnd;
	        var actionCause;
	        if (this.facetValue.excluded) {
	            actionCause = this.isOmnibox ? AnalyticsActionListMeta_1.analyticsActionCauseList.omniboxFacetUnexclude : AnalyticsActionListMeta_1.analyticsActionCauseList.facetUnexclude;
	            this.facet.unexcludeValue(this.facetValue);
	        }
	        else {
	            if (this.facetValue.selected) {
	                actionCause = this.isOmnibox ? AnalyticsActionListMeta_1.analyticsActionCauseList.omniboxFacetDeselect : AnalyticsActionListMeta_1.analyticsActionCauseList.facetDeselect;
	            }
	            else {
	                actionCause = this.isOmnibox ? AnalyticsActionListMeta_1.analyticsActionCauseList.omniboxFacetSelect : AnalyticsActionListMeta_1.analyticsActionCauseList.facetSelect;
	            }
	            this.facet.toggleSelectValue(this.facetValue);
	        }
	        if (this.onSelect) {
	            this.facet.triggerNewQuery(function () { return _this.onSelect(_this, actionCause); });
	        }
	        else {
	            this.facet.triggerNewQuery(function () { return _this.facet.usageAnalytics.logSearchEvent(actionCause, _this.getAnalyticsFacetMeta()); });
	        }
	    };
	    ValueElement.prototype.handleExcludeClick = function (eventBindings) {
	        var _this = this;
	        this.facet.keepDisplayedValuesNextTime = eventBindings.displayNextTime && !this.facet.options.useAnd;
	        var actionCause;
	        if (this.facetValue.excluded) {
	            actionCause = this.isOmnibox ? AnalyticsActionListMeta_1.analyticsActionCauseList.omniboxFacetUnexclude : AnalyticsActionListMeta_1.analyticsActionCauseList.facetUnexclude;
	        }
	        else {
	            actionCause = this.isOmnibox ? AnalyticsActionListMeta_1.analyticsActionCauseList.omniboxFacetExclude : AnalyticsActionListMeta_1.analyticsActionCauseList.facetExclude;
	        }
	        this.facet.toggleExcludeValue(this.facetValue);
	        if (this.onExclude) {
	            this.facet.triggerNewQuery(function () { return _this.onExclude(_this, actionCause); });
	        }
	        else {
	            this.facet.triggerNewQuery(function () { return _this.facet.usageAnalytics.logSearchEvent(actionCause, _this.getAnalyticsFacetMeta()); });
	        }
	    };
	    ValueElement.prototype.handleEventForExcludedValueElement = function (eventBindings) {
	        var _this = this;
	        var clickEvent = function (event) {
	            if (eventBindings.pinFacet) {
	                _this.facet.pinFacetPosition();
	            }
	            if (eventBindings.omniboxObject) {
	                _this.omniboxCloseEvent(eventBindings.omniboxObject);
	            }
	            _this.handleSelectValue(eventBindings);
	            return false;
	        };
	        Dom_1.$$(this.renderer.label).on('click', function (e) {
	            e.stopPropagation();
	            clickEvent(e);
	        });
	        Dom_1.$$(this.renderer.stylishCheckbox).on('keydown', KeyboardUtils_1.KeyboardUtils.keypressAction([
	            KeyboardUtils_1.KEYBOARD.SPACEBAR,
	            KeyboardUtils_1.KEYBOARD.ENTER
	        ], clickEvent));
	    };
	    ValueElement.prototype.handleEventForValueElement = function (eventBindings) {
	        var _this = this;
	        var excludeAction = function (event) {
	            if (eventBindings.omniboxObject) {
	                _this.omniboxCloseEvent(eventBindings.omniboxObject);
	            }
	            event.stopPropagation();
	            event.preventDefault();
	            _this.handleExcludeClick(eventBindings);
	            return false;
	        };
	        Dom_1.$$(this.renderer.excludeIcon).on('click', excludeAction);
	        Dom_1.$$(this.renderer.excludeIcon).on('keydown', KeyboardUtils_1.KeyboardUtils.keypressAction([
	            KeyboardUtils_1.KEYBOARD.SPACEBAR,
	            KeyboardUtils_1.KEYBOARD.ENTER
	        ], excludeAction));
	        var selectAction = function (event) {
	            if (eventBindings.pinFacet) {
	                _this.facet.pinFacetPosition();
	            }
	            event.preventDefault();
	            Dom_1.$$(_this.renderer.checkbox).trigger('change');
	            return false;
	        };
	        Dom_1.$$(this.renderer.label).on('click', selectAction);
	        Dom_1.$$(this.renderer.stylishCheckbox).on('keydown', KeyboardUtils_1.KeyboardUtils.keypressAction([
	            KeyboardUtils_1.KEYBOARD.SPACEBAR,
	            KeyboardUtils_1.KEYBOARD.ENTER
	        ], selectAction));
	    };
	    ValueElement.prototype.handleEventForCheckboxChange = function (eventBindings) {
	        var _this = this;
	        Dom_1.$$(this.renderer.checkbox).on('change', function () {
	            if (eventBindings.omniboxObject) {
	                _this.omniboxCloseEvent(eventBindings.omniboxObject);
	            }
	            _this.handleSelectValue(eventBindings);
	            if (DeviceUtils_1.DeviceUtils.isMobileDevice() && !_this.facet.searchInterface.isNewDesign() && _this.facet.options.enableFacetSearch) {
	                Defer_1.Defer.defer(function () {
	                    ExternalModulesShim_1.ModalBox.close(true);
	                    _this.facet.facetSearch.completelyDismissSearch();
	                });
	            }
	        });
	    };
	    ValueElement.prototype.omniboxCloseEvent = function (eventArg) {
	        eventArg.closeOmnibox();
	        eventArg.clear();
	    };
	    ValueElement.prototype.getAnalyticsFacetMeta = function () {
	        return {
	            facetId: this.facet.options.id,
	            facetValue: this.facetValue.value,
	            facetTitle: this.facet.options.title
	        };
	    };
	    return ValueElement;
	}());
	exports.ValueElement = ValueElement;


/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var Dom_1 = __webpack_require__(57);
	var Utils_1 = __webpack_require__(18);
	var Strings_1 = __webpack_require__(34);
	var Component_1 = __webpack_require__(96);
	var ValueElementRenderer = (function () {
	    function ValueElementRenderer(facet, facetValue) {
	        this.facet = facet;
	        this.facetValue = facetValue;
	    }
	    ValueElementRenderer.prototype.withNo = function (element) {
	        if (_.isArray(element)) {
	            _.each(element, function (e) {
	                if (e) {
	                    Dom_1.$$(e).detach();
	                }
	            });
	        }
	        else {
	            if (element) {
	                Dom_1.$$(element).detach();
	            }
	        }
	        return this;
	    };
	    ValueElementRenderer.prototype.build = function () {
	        var _this = this;
	        this.listItem = Dom_1.$$('li', {
	            className: 'coveo-facet-value coveo-facet-selectable'
	        }).el;
	        this.listItem.setAttribute('data-value', this.facetValue.value);
	        if (!this.facet.searchInterface.isNewDesign()) {
	            this.excludeIcon = this.buildExcludeIcon();
	            this.listItem.appendChild(this.excludeIcon);
	        }
	        this.label = Dom_1.$$('label', {
	            className: 'coveo-facet-value-label'
	        }).el;
	        this.listItem.appendChild(this.label);
	        if (this.facet.searchInterface.isNewDesign()) {
	            this.excludeIcon = this.buildExcludeIcon();
	            this.listItem.appendChild(this.excludeIcon);
	            Dom_1.$$(this.excludeIcon).on('mouseover', function () {
	                Dom_1.$$(_this.listItem).addClass('coveo-facet-value-will-exclude');
	            });
	            Dom_1.$$(this.excludeIcon).on('mouseout', function () {
	                Dom_1.$$(_this.listItem).removeClass('coveo-facet-value-will-exclude');
	            });
	        }
	        if (Utils_1.Utils.exists(this.facetValue.computedField)) {
	            this.computedField = this.buildValueComputedField();
	            if (this.computedField) {
	                this.label.appendChild(this.computedField);
	            }
	            Dom_1.$$(this.label).addClass('coveo-with-computed-field');
	        }
	        var labelDiv = Dom_1.$$('div', {
	            className: 'coveo-facet-value-label-wrapper'
	        }).el;
	        this.label.appendChild(labelDiv);
	        this.checkbox = this.buildValueCheckbox();
	        labelDiv.appendChild(this.checkbox);
	        this.stylishCheckbox = this.buildValueStylishCheckbox();
	        labelDiv.appendChild(this.stylishCheckbox);
	        if (this.facet.options.showIcon && !this.facet.searchInterface.isNewDesign()) {
	            this.icon = this.buildValueIcon();
	            labelDiv.appendChild(this.icon);
	        }
	        if (this.facet.searchInterface.isNewDesign()) {
	            this.valueCount = this.buildValueCount();
	            if (this.valueCount) {
	                labelDiv.appendChild(this.valueCount);
	            }
	            this.valueCaption = this.buildValueCaption();
	            labelDiv.appendChild(this.valueCaption);
	        }
	        else {
	            this.valueCaption = this.buildValueCaption();
	            labelDiv.appendChild(this.valueCaption);
	            this.valueCount = this.buildValueCount();
	            if (this.valueCount) {
	                labelDiv.appendChild(this.valueCount);
	            }
	        }
	        this.setCssClassOnListValueElement();
	        return this;
	    };
	    ValueElementRenderer.prototype.setCssClassOnListValueElement = function () {
	        Dom_1.$$(this.listItem).toggleClass('coveo-selected', this.facetValue.selected);
	        Dom_1.$$(this.listItem).toggleClass('coveo-excluded', this.facetValue.excluded);
	    };
	    ValueElementRenderer.prototype.buildExcludeIcon = function () {
	        var excludeIcon = Dom_1.$$('div', {
	            title: Strings_1.l('Exclude', this.facet.getValueCaption(this.facetValue)),
	            className: 'coveo-facet-value-exclude',
	            tabindex: 0
	        }).el;
	        this.addFocusAndBlurEventListeners(excludeIcon);
	        if (this.facet.searchInterface.isNewDesign()) {
	            excludeIcon.appendChild(Dom_1.$$('span', {
	                className: 'coveo-icon'
	            }).el);
	        }
	        if (Utils_1.Utils.exists(this.facetValue.computedField)) {
	            Dom_1.$$(excludeIcon).addClass('coveo-facet-value-exclude-with-computed-field');
	        }
	        return excludeIcon;
	    };
	    ValueElementRenderer.prototype.buildValueComputedField = function () {
	        var computedField = this.facetValue.getFormattedComputedField(this.facet.options.computedFieldFormat);
	        if (Utils_1.Utils.isNonEmptyString(computedField)) {
	            var elem = Dom_1.$$('span', {
	                className: 'coveo-facet-value-computed-field'
	            }).el;
	            Dom_1.$$(elem).text(computedField);
	            return elem;
	        }
	        else {
	            return undefined;
	        }
	    };
	    ValueElementRenderer.prototype.buildValueCheckbox = function () {
	        var checkbox = Dom_1.$$('input', {
	            type: 'checkbox'
	        }).el;
	        if (this.facetValue.selected) {
	            checkbox.setAttribute('checked', 'checked');
	        }
	        else {
	            checkbox.removeAttribute('checked');
	        }
	        if (this.facetValue.excluded) {
	            checkbox.setAttribute('disabled', 'disabled');
	        }
	        else {
	            checkbox.removeAttribute('disabled');
	        }
	        Component_1.Component.pointElementsToDummyForm(checkbox);
	        return checkbox;
	    };
	    ValueElementRenderer.prototype.buildValueStylishCheckbox = function () {
	        var checkbox = Dom_1.$$('div', {
	            className: 'coveo-facet-value-checkbox',
	            tabindex: 0
	        }, Dom_1.$$('span')).el;
	        this.addFocusAndBlurEventListeners(checkbox);
	        return checkbox;
	    };
	    ValueElementRenderer.prototype.buildValueIcon = function () {
	        var icon = this.getValueIcon();
	        if (Utils_1.Utils.exists(icon)) {
	            return Dom_1.$$('img', {
	                className: 'coveo-facet-value-icon coveo-icon',
	                src: this.getValueIcon()
	            }).el;
	        }
	        else {
	            return this.buildValueIconFromSprite();
	        }
	    };
	    ValueElementRenderer.prototype.getValueIcon = function () {
	        if (Utils_1.Utils.exists(this.facet.options.valueIcon)) {
	            return this.facet.options.valueIcon(this.facetValue);
	        }
	        else {
	            return undefined;
	        }
	    };
	    ValueElementRenderer.prototype.buildValueIconFromSprite = function () {
	        return Dom_1.$$('div', {
	            className: 'coveo-facet-value-icon coveo-icon ' + this.facet.options.field.substr(1) + ' ' + this.facetValue.value
	        }).el;
	    };
	    ValueElementRenderer.prototype.buildValueCaption = function () {
	        var caption = this.facet.getValueCaption(this.facetValue);
	        var valueCaption = Dom_1.$$('span', {
	            className: 'coveo-facet-value-caption',
	            title: caption
	        }).el;
	        Dom_1.$$(valueCaption).text(caption);
	        return valueCaption;
	    };
	    ValueElementRenderer.prototype.buildValueCount = function () {
	        var count = this.facetValue.getFormattedCount();
	        if (Utils_1.Utils.isNonEmptyString(count)) {
	            var countElement = Dom_1.$$('span', {
	                className: 'coveo-facet-value-count'
	            }).el;
	            Dom_1.$$(countElement).text(count);
	            return countElement;
	        }
	        else {
	            return undefined;
	        }
	    };
	    ValueElementRenderer.prototype.addFocusAndBlurEventListeners = function (elem) {
	        var _this = this;
	        Dom_1.$$(elem).on('focus', function () { return Dom_1.$$(_this.listItem).addClass('coveo-focused'); });
	        Dom_1.$$(elem).on('blur', function () { return Dom_1.$$(_this.listItem).removeClass('coveo-focused'); });
	    };
	    return ValueElementRenderer;
	}());
	exports.ValueElementRenderer = ValueElementRenderer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 148 */
/***/ function(module, exports) {

	"use strict";
	var ResponsiveComponentsUtils = (function () {
	    function ResponsiveComponentsUtils() {
	    }
	    ResponsiveComponentsUtils.isSmallTabsActivated = function (root) {
	        return root.hasClass(this.smallTabsClassName);
	    };
	    ResponsiveComponentsUtils.isSmallFacetActivated = function (root) {
	        return root.hasClass(this.smallFacetClassName);
	    };
	    ResponsiveComponentsUtils.activateSmallTabs = function (root) {
	        root.addClass(this.smallTabsClassName);
	    };
	    ResponsiveComponentsUtils.deactivateSmallTabs = function (root) {
	        root.removeClass(this.smallTabsClassName);
	    };
	    ResponsiveComponentsUtils.activateSmallFacet = function (root) {
	        root.addClass(this.smallFacetClassName);
	    };
	    ResponsiveComponentsUtils.deactivateSmallFacet = function (root) {
	        root.removeClass(this.smallFacetClassName);
	    };
	    ResponsiveComponentsUtils.smallTabsClassName = 'coveo-small-tabs';
	    ResponsiveComponentsUtils.smallFacetClassName = 'coveo-small-facets';
	    ResponsiveComponentsUtils.MEDIUM_MOBILE_WIDTH = 640;
	    return ResponsiveComponentsUtils;
	}());
	exports.ResponsiveComponentsUtils = ResponsiveComponentsUtils;


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var StringUtils_1 = __webpack_require__(61);
	var FacetValuesOrder = (function () {
	    function FacetValuesOrder(facet, facetSort) {
	        this.facet = facet;
	        this.facetSort = facetSort;
	    }
	    FacetValuesOrder.prototype.reorderValues = function (facetValues) {
	        if (this.facetSort) {
	            if (this.facetSort.activeSort.name == 'custom' && this.facet.options.customSort != undefined) {
	                return this.reorderValuesWithCustomOrder(facetValues);
	            }
	            else if (this.facetSort.activeSort.name.indexOf('alpha') != -1) {
	                return this.reorderValuesWithCustomCaption(facetValues);
	            }
	        }
	        return facetValues;
	    };
	    FacetValuesOrder.prototype.reorderValuesWithCustomOrder = function (facetValues) {
	        var customSortsLowercase = _.map(this.facet.options.customSort, function (customSort) { return customSort.toLowerCase(); });
	        var valueIndexPair = _.map(facetValues, function (facetValue, i) {
	            // Get the index of the current value in the custom sort array.
	            // If it's not found, put it's index to it's original value + the length of customSort so that's always after the specified custom sort order.
	            var index = _.findIndex(customSortsLowercase, function (customSort) {
	                return StringUtils_1.StringUtils.equalsCaseInsensitive(customSort, facetValue.value) || (facetValue.lookupValue != null && StringUtils_1.StringUtils.equalsCaseInsensitive(customSort, facetValue.lookupValue));
	            });
	            if (index == -1) {
	                index = i + customSortsLowercase.length;
	            }
	            return { facetValue: facetValue, index: index };
	        });
	        var sorted = _.sortBy(valueIndexPair, 'index');
	        sorted = this.facetSort.customSortDirection == 'ascending' ? sorted : sorted.reverse();
	        return _.pluck(sorted, 'facetValue');
	    };
	    FacetValuesOrder.prototype.reorderValuesWithCustomCaption = function (facetValues) {
	        var _this = this;
	        var sorted = _.sortBy(facetValues, function (facetValue) {
	            return _this.facet.getValueCaption(facetValue).toLowerCase();
	        });
	        if (this.facetSort.activeSort.name.indexOf('descending') != -1) {
	            sorted = sorted.reverse();
	        }
	        return sorted;
	    };
	    return FacetValuesOrder;
	}());
	exports.FacetValuesOrder = FacetValuesOrder;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var FacetSort_1 = __webpack_require__(151);
	var Dom_1 = __webpack_require__(57);
	var LocalStorageUtils_1 = __webpack_require__(69);
	var Utils_1 = __webpack_require__(18);
	var Strings_1 = __webpack_require__(34);
	var QueryStateModel_1 = __webpack_require__(90);
	var AnalyticsActionListMeta_1 = __webpack_require__(110);
	var DeviceUtils_1 = __webpack_require__(20);
	var PopupUtils_1 = __webpack_require__(71);
	/**
	 * Handle the rendering of the {@link Facet} settings menu (typically the ... in the facet header).
	 */
	var FacetSettings = (function (_super) {
	    __extends(FacetSettings, _super);
	    function FacetSettings(sorts, facet) {
	        _super.call(this, sorts, facet);
	        this.sorts = sorts;
	        this.facet = facet;
	        this.customSortDirectionChange = false;
	        this.enabledSortsIgnoreRenderBecauseOfPairs = [];
	        this.filterDuplicateForRendering();
	    }
	    /**
	     * Build the menu, hook click events.
	     * @returns {HTMLElement}
	     */
	    FacetSettings.prototype.build = function () {
	        var _this = this;
	        this.settingsButton = Dom_1.$$('div', {
	            className: 'coveo-facet-header-settings',
	            title: Strings_1.l('Settings'),
	        }).el;
	        this.settingsIcon = Dom_1.$$('span', { className: 'coveo-icon' }).el;
	        this.settingsButton.appendChild(this.settingsIcon);
	        this.settingsPopup = Dom_1.$$('div', { className: 'coveo-facet-settings-popup' }).el;
	        if (Utils_1.Utils.isNonEmptyArray(this.enabledSorts)) {
	            this.sortSection = this.buildSortSection();
	            if (this.enabledSortsAllowDirection()) {
	                this.directionSection = this.buildDirectionSection();
	            }
	        }
	        if (this.facet.options.enableSettingsFacetState) {
	            this.saveStateSection = this.buildSaveStateSection();
	            this.clearStateSection = this.buildClearStateSection();
	        }
	        this.hideSection = this.buildHideSection();
	        this.showSection = this.buildShowSection();
	        var appendCommon = function () {
	            _this.appendIfNotUndefined(_this.saveStateSection);
	            _this.appendIfNotUndefined(_this.clearStateSection);
	            _this.appendIfNotUndefined(_this.hideSection);
	            _this.appendIfNotUndefined(_this.showSection);
	        };
	        this.handleMouseEventOnButton(this.sortSection);
	        if (Utils_1.Utils.isNonEmptyArray(this.enabledSorts)) {
	            this.settingsPopup.appendChild(this.sortSection.element);
	            _.each(this.directionSection, function (d) {
	                _this.appendIfNotUndefined(d);
	            });
	            appendCommon();
	        }
	        else {
	            appendCommon();
	        }
	        return this.settingsButton;
	    };
	    /**
	     * Restore the facet state from local storage, and apply it in the query state model.
	     */
	    FacetSettings.prototype.loadSavedState = function () {
	        if (this.facetStateLocalStorage) {
	            // set the state from the settings only if there is nothing
	            // in the query state model for the current facet
	            var state = this.facetStateLocalStorage.load();
	            var currentStateIncluded = this.facet.queryStateModel.get(this.includedStateAttribute);
	            var currentStateExcluded = this.facet.queryStateModel.get(this.excludedStateAttribute);
	            var currentStateOperator = this.facet.queryStateModel.get(this.operatorStateAttribute);
	            if (!Utils_1.Utils.isNullOrUndefined(state)
	                && Utils_1.Utils.isEmptyArray(currentStateIncluded)
	                && Utils_1.Utils.isEmptyArray(currentStateExcluded)
	                && !Utils_1.Utils.isNonEmptyString(currentStateOperator)) {
	                var toSet = {};
	                toSet[this.includedStateAttribute] = state.included;
	                toSet[this.excludedStateAttribute] = state.excluded;
	                toSet[this.operatorStateAttribute] = state.operator;
	                this.facet.queryStateModel.setMultiple(toSet);
	                this.loadedFromSettings = toSet;
	            }
	        }
	        else {
	            this.facet.logger.info('Facet state local storage not enabled : See Facet.options.enableSettingsFacetState');
	        }
	    };
	    /**
	     * Take the current state of the facet and save it in the local storage.
	     */
	    FacetSettings.prototype.saveState = function () {
	        if (this.facetStateLocalStorage) {
	            this.facetStateLocalStorage.save({
	                included: this.facet.queryStateModel.get(this.includedStateAttribute),
	                excluded: this.facet.queryStateModel.get(this.excludedStateAttribute),
	                operator: this.facet.queryStateModel.get(this.operatorStateAttribute),
	            });
	        }
	        else {
	            this.facet.logger.info('Facet state local storage not enabled : See Facet.options.enableSettingsFacetState');
	        }
	    };
	    /**
	     * Close the settings menu
	     */
	    FacetSettings.prototype.close = function () {
	        Dom_1.$$(this.settingsPopup).detach();
	    };
	    /**
	     * Open the settings menu
	     */
	    FacetSettings.prototype.open = function () {
	        var _this = this;
	        PopupUtils_1.PopupUtils.positionPopup(this.settingsPopup, this.settingsButton, this.facet.root, this.getPopupAlignment(), this.facet.root);
	        Dom_1.$$(this.hideSection).toggle(!Dom_1.$$(this.facet.element).hasClass('coveo-facet-collapsed'));
	        Dom_1.$$(this.showSection).toggle(Dom_1.$$(this.facet.element).hasClass('coveo-facet-collapsed'));
	        if (this.facet.options.enableSettingsFacetState) {
	            Dom_1.$$(this.clearStateSection).toggle(!Utils_1.Utils.isNullOrUndefined(this.facetStateLocalStorage.load()));
	        }
	        _.each(this.enabledSorts, function (criteria, i) {
	            if (!Utils_1.Utils.isNullOrUndefined(_this.sortSection.sortItems[i])) {
	                if (_this.activeSort.name == criteria.name.toLowerCase() || _this.activeSort.relatedSort == criteria.name.toLowerCase()) {
	                    _this.selectItem(_this.sortSection.sortItems[i]);
	                }
	                else {
	                    _this.unselectItem(_this.sortSection.sortItems[i]);
	                }
	            }
	        });
	    };
	    FacetSettings.prototype.buildSortSection = function () {
	        var sortSection = this.buildSection('coveo-facet-settings-section-sort');
	        var sortSectionIcon = this.buildIcon();
	        var sortSectionItems = this.buildItems();
	        if (this.facet.searchInterface.isNewDesign()) {
	            var sortTitle = document.createElement('div');
	            Dom_1.$$(sortTitle).addClass('coveo-facet-settings-section-sort-title');
	            Dom_1.$$(sortTitle).text(Strings_1.l('SortBy') + ' :');
	            sortSectionItems.appendChild(sortTitle);
	        }
	        var sortItems = this.buildSortSectionItems();
	        _.each(sortItems, function (s) {
	            sortSectionItems.appendChild(s);
	        });
	        sortSection.appendChild(sortSectionIcon);
	        sortSection.appendChild(sortSectionItems);
	        return { element: sortSection, sortItems: sortItems };
	    };
	    FacetSettings.prototype.buildSortSectionItems = function () {
	        var _this = this;
	        var elems = _.map(this.enabledSorts, function (enabledSort) {
	            if (_.contains(_this.enabledSortsIgnoreRenderBecauseOfPairs, enabledSort)) {
	                return undefined;
	            }
	            else {
	                var elem = _this.buildItem(Strings_1.l(enabledSort.label), enabledSort.description);
	                Dom_1.$$(elem).on('click', function (e) { return _this.handleClickSortButton(e, enabledSort); });
	                return elem;
	            }
	        });
	        elems = _.compact(elems);
	        return elems;
	    };
	    FacetSettings.prototype.closePopupAndUpdateSort = function () {
	        this.close();
	        if (this.activeSort.name != 'custom') {
	            this.facet.updateSort(this.activeSort.name);
	        }
	        else {
	            this.facet.updateSort('nosort');
	            if (this.customSortDirectionChange) {
	                this.customSortDirectionChange = false;
	                this.facet.queryController.executeQuery();
	            }
	        }
	    };
	    FacetSettings.prototype.enabledSortsAllowDirection = function () {
	        return _.some(this.enabledSorts, function (facetSortDescription) {
	            return facetSortDescription.directionToggle;
	        });
	    };
	    FacetSettings.prototype.buildDirectionSection = function () {
	        var _this = this;
	        if (this.facet.searchInterface.isNewDesign()) {
	            var directionAscendingSection = this.buildAscendingOrDescendingSection('Ascending');
	            var iconAscending = this.buildIcon();
	            var iconDescending = this.buildIcon();
	            var directionItemsAscending = this.buildItems();
	            var ascending = this.buildAscendingOrDescending('Ascending');
	            directionItemsAscending.appendChild(ascending);
	            directionAscendingSection.appendChild(iconAscending);
	            directionAscendingSection.appendChild(directionItemsAscending);
	            Dom_1.$$(directionAscendingSection).on('click', function (e) { return _this.handleDirectionClick(e, 'ascending'); });
	            var directionDescendingSection = this.buildAscendingOrDescendingSection('Descending');
	            var directionItemsDescending = this.buildItems();
	            var descending = this.buildAscendingOrDescending('Descending');
	            directionItemsDescending.appendChild(descending);
	            directionDescendingSection.appendChild(iconDescending);
	            directionDescendingSection.appendChild(directionItemsDescending);
	            Dom_1.$$(directionDescendingSection).on('click', function (e) { return _this.handleDirectionClick(e, 'descending'); });
	            if (!this.activeSort.directionToggle) {
	                Dom_1.$$(directionAscendingSection).addClass('coveo-facet-settings-disabled');
	                Dom_1.$$(directionDescendingSection).addClass('coveo-facet-settings-disabled');
	            }
	            else {
	                this.selectItem(this.getItems(directionAscendingSection)[0]);
	            }
	            return [directionAscendingSection, directionDescendingSection];
	        }
	        else {
	            var directionSection = this.buildSection('coveo-facet-settings-section-direction');
	            var icon = this.buildIcon();
	            var directionItems = this.buildItems();
	            var ascending = this.buildAscendingOrDescending('Ascending');
	            Dom_1.$$(ascending).on('click', function (e) { return _this.handleDirectionClick(e, 'ascending'); });
	            var descending = this.buildAscendingOrDescending('Descending');
	            Dom_1.$$(descending).on('click', function (e) { return _this.handleDirectionClick(e, 'descending'); });
	            directionItems.appendChild(ascending);
	            directionItems.appendChild(descending);
	            directionSection.appendChild(icon);
	            directionSection.appendChild(directionItems);
	            if (!this.activeSort.directionToggle) {
	                Dom_1.$$(directionSection).addClass('coveo-facet-settings-disabled');
	            }
	            else {
	                this.selectItem(this.getCurrentDirectionItem([directionSection]));
	            }
	            return [directionSection];
	        }
	    };
	    FacetSettings.prototype.buildSaveStateSection = function () {
	        var _this = this;
	        var saveStateSection = this.buildSection('coveo-facet-settings-section-save-state');
	        var icon = this.buildIcon();
	        var saveStateItems = this.buildItems();
	        this.facetStateLocalStorage = new LocalStorageUtils_1.LocalStorageUtils('facet-state-' + this.facet.options.id);
	        this.includedStateAttribute = QueryStateModel_1.QueryStateModel.getFacetId(this.facet.options.id);
	        this.excludedStateAttribute = QueryStateModel_1.QueryStateModel.getFacetId(this.facet.options.id, false);
	        this.operatorStateAttribute = QueryStateModel_1.QueryStateModel.getFacetOperator(this.facet.options.id);
	        var saveStateItem = document.createElement('div');
	        Dom_1.$$(saveStateItem).addClass('coveo-facet-settings-item');
	        saveStateItem.setAttribute('title', _.escape(Strings_1.l('SaveFacetState')));
	        Dom_1.$$(saveStateItem).text(_.escape(Strings_1.l('SaveFacetState')));
	        saveStateItems.appendChild(saveStateItem);
	        saveStateSection.appendChild(icon);
	        saveStateSection.appendChild(saveStateItems);
	        Dom_1.$$(saveStateSection).on('click', function (e) { return _this.handleSaveStateClick(); });
	        return saveStateSection;
	    };
	    FacetSettings.prototype.buildClearStateSection = function () {
	        var _this = this;
	        var clearStateSection = this.buildSection('coveo-facet-settings-section-clear-state');
	        var icon = this.buildIcon();
	        var clearStateItems = this.buildItems();
	        var clearStateItem = this.buildItem(Strings_1.l('ClearFacetState'));
	        clearStateItems.appendChild(clearStateItem);
	        clearStateSection.appendChild(icon);
	        clearStateSection.appendChild(clearStateItems);
	        Dom_1.$$(clearStateSection).on('click', function (e) { return _this.handleClearStateClick(); });
	        return clearStateSection;
	    };
	    FacetSettings.prototype.buildHideSection = function () {
	        var _this = this;
	        var hideSection = this.buildSection('coveo-facet-settings-section-hide');
	        var icon = this.buildIcon();
	        var hideItems = this.buildItems();
	        var hideItem = this.buildItem(Strings_1.l('Collapse'));
	        hideItems.appendChild(hideItem);
	        hideSection.appendChild(icon);
	        hideSection.appendChild(hideItems);
	        Dom_1.$$(hideSection).on('click', function (e) {
	            _this.facet.facetHeader.collapseFacet();
	            _this.close();
	        });
	        return hideSection;
	    };
	    FacetSettings.prototype.buildShowSection = function () {
	        var _this = this;
	        var showSection = this.buildSection('coveo-facet-settings-section-show');
	        var icon = this.buildIcon();
	        var showItems = this.buildItems();
	        var showItem = this.buildItem(Strings_1.l('Expand'));
	        showItems.appendChild(showItem);
	        showSection.appendChild(icon);
	        showSection.appendChild(showItems);
	        Dom_1.$$(showSection).on('click', function (e) {
	            _this.facet.facetHeader.expandFacet();
	            _this.close();
	        });
	        return showSection;
	    };
	    FacetSettings.prototype.buildIcon = function () {
	        if (this.facet.searchInterface.isNewDesign()) {
	            var icon = document.createElement('div');
	            Dom_1.$$(icon).addClass('coveo-icon-container');
	            var insideIcon = document.createElement('div');
	            Dom_1.$$(insideIcon).addClass('coveo-icon');
	            icon.appendChild(insideIcon);
	            return icon;
	        }
	        else {
	            var icon = document.createElement('div');
	            Dom_1.$$(icon).addClass('coveo-icon');
	            return icon;
	        }
	    };
	    FacetSettings.prototype.buildAscendingOrDescending = function (direction) {
	        var elem = this.buildItem(Strings_1.l(direction));
	        elem.setAttribute('data-direction', direction.toLowerCase());
	        return elem;
	    };
	    FacetSettings.prototype.buildAscendingOrDescendingSection = function (direction) {
	        return this.buildSection('coveo-facet-settings-section-direction-' + direction.toLowerCase());
	    };
	    FacetSettings.prototype.buildItem = function (label, title) {
	        if (title === void 0) { title = label; }
	        return Dom_1.$$('div', {
	            className: 'coveo-facet-settings-item',
	            title: _.escape(title),
	        }, _.escape(label)).el;
	    };
	    FacetSettings.prototype.buildItems = function () {
	        var elem = document.createElement('div');
	        Dom_1.$$(elem).addClass('coveo-facet-settings-items');
	        return elem;
	    };
	    FacetSettings.prototype.buildSection = function (className) {
	        var section = document.createElement('div');
	        Dom_1.$$(section).addClass(['coveo-facet-settings-section', className]);
	        return section;
	    };
	    FacetSettings.prototype.handleClickSettingsButtons = function (event, sortSection) {
	        if (!Utils_1.Utils.isNullOrUndefined(this.settingsPopup.parentElement)) {
	            this.close();
	        }
	        else {
	            this.open();
	        }
	    };
	    FacetSettings.prototype.handleClickSortButton = function (e, enabledSort) {
	        if (this.activeSort != enabledSort && this.activeSort.relatedSort != enabledSort.name) {
	            this.activeSort = enabledSort;
	            if (enabledSort.directionToggle && _.contains(this.enabledSorts, FacetSettings.availableSorts[this.activeSort.relatedSort])) {
	                this.activateDirectionSection();
	            }
	            else {
	                this.disableDirectionSection();
	            }
	            this.selectItem(e.target);
	            this.closePopupAndUpdateSort();
	        }
	    };
	    FacetSettings.prototype.handleDirectionClick = function (e, direction) {
	        var _this = this;
	        if (!Dom_1.$$(e.target.parentElement.parentElement).hasClass('coveo-facet-settings-disabled') && this.activeSort.name.indexOf(direction) == -1) {
	            this.activeSort = FacetSettings.availableSorts[this.activeSort.relatedSort];
	            _.each(this.directionSection, function (d) {
	                _this.unselectSection(d);
	            });
	            this.selectItem(e.target);
	            if (this.activeSort.name == 'custom' && this.customSortDirection != direction) {
	                this.customSortDirection = direction;
	                this.customSortDirectionChange = true;
	            }
	            this.closePopupAndUpdateSort();
	        }
	    };
	    FacetSettings.prototype.handleSaveStateClick = function () {
	        this.saveState();
	        this.close();
	    };
	    FacetSettings.prototype.handleClearStateClick = function () {
	        var _this = this;
	        this.facetStateLocalStorage.remove();
	        this.facet.reset();
	        this.close();
	        this.facet.triggerNewQuery(function () { return _this.facet.usageAnalytics.logSearchEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.facetClearAll, {
	            facetId: _this.facet.options.id,
	            facetTitle: _this.facet.options.title
	        }); });
	    };
	    FacetSettings.prototype.handleMouseEventOnButton = function (sortSection) {
	        var _this = this;
	        var closeTimeout;
	        Dom_1.$$(this.settingsButton).on('click', function (e) { return _this.handleClickSettingsButtons(e, sortSection); });
	        var mouseLeave = function () {
	            closeTimeout = setTimeout(function () {
	                _this.close();
	            }, 300);
	        };
	        var mouseEnter = function () {
	            clearTimeout(closeTimeout);
	        };
	        Dom_1.$$(this.settingsIcon).on('mouseleave', mouseLeave);
	        Dom_1.$$(this.settingsPopup).on('mouseleave', mouseLeave);
	        Dom_1.$$(this.settingsIcon).on('mouseenter', mouseEnter);
	        Dom_1.$$(this.settingsPopup).on('mouseenter', mouseEnter);
	    };
	    FacetSettings.prototype.getCurrentDirectionItem = function (directionSection) {
	        var _this = this;
	        if (directionSection === void 0) { directionSection = this.directionSection; }
	        var found;
	        _.each(directionSection, function (direction) {
	            if (!found) {
	                found = _.find(_this.getItems(direction), function (direction) {
	                    return _this.activeSort.name.indexOf(direction.getAttribute('data-direction')) != -1;
	                });
	            }
	        });
	        if (!found) {
	            found = directionSection[0];
	        }
	        return found;
	    };
	    FacetSettings.prototype.activateDirectionSection = function () {
	        var _this = this;
	        _.each(this.directionSection, function (direction) {
	            Dom_1.$$(direction).removeClass('coveo-facet-settings-disabled');
	            _this.unselectSection(direction);
	        });
	        this.selectItem(this.getCurrentDirectionItem());
	    };
	    FacetSettings.prototype.disableDirectionSection = function () {
	        var _this = this;
	        _.each(this.directionSection, function (direction) {
	            Dom_1.$$(direction).addClass('coveo-facet-settings-disabled');
	            _this.unselectSection(direction);
	        });
	    };
	    FacetSettings.prototype.getItems = function (section) {
	        return Dom_1.$$(section).findAll('.coveo-facet-settings-item');
	    };
	    FacetSettings.prototype.unselectSection = function (section) {
	        _.each(this.getItems(section), function (i) {
	            Dom_1.$$(i).removeClass('coveo-selected');
	        });
	    };
	    FacetSettings.prototype.selectItem = function (item) {
	        Dom_1.$$(item).addClass('coveo-selected');
	    };
	    FacetSettings.prototype.unselectItem = function (item) {
	        Dom_1.$$(item).removeClass('coveo-selected');
	    };
	    FacetSettings.prototype.getPopupAlignment = function () {
	        var alignmentHorizontal = DeviceUtils_1.DeviceUtils.isMobileDevice() ? PopupUtils_1.HorizontalAlignment.CENTER : PopupUtils_1.HorizontalAlignment.INNERLEFT;
	        var alignmentVertical = PopupUtils_1.VerticalAlignment.BOTTOM;
	        return {
	            horizontal: alignmentHorizontal,
	            vertical: alignmentVertical
	        };
	    };
	    FacetSettings.prototype.filterDuplicateForRendering = function () {
	        var _this = this;
	        _.each(this.enabledSorts, function (enabledSort, i) {
	            if (enabledSort.relatedSort != null) {
	                for (var j = i + 1; j < _this.enabledSorts.length; j++) {
	                    if (_this.enabledSorts[j].name == enabledSort.relatedSort) {
	                        _this.enabledSortsIgnoreRenderBecauseOfPairs.push(_this.enabledSorts[j]);
	                        break;
	                    }
	                }
	            }
	        });
	    };
	    FacetSettings.prototype.appendIfNotUndefined = function (toAppend) {
	        if (!Utils_1.Utils.isNullOrUndefined(toAppend)) {
	            this.settingsPopup.appendChild(toAppend);
	        }
	    };
	    return FacetSettings;
	}(FacetSort_1.FacetSort));
	exports.FacetSettings = FacetSettings;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var Strings_1 = __webpack_require__(34);
	var FacetSettings_1 = __webpack_require__(150);
	var Utils_1 = __webpack_require__(18);
	var FacetSort = (function () {
	    function FacetSort(sorts, facet) {
	        var _this = this;
	        this.facet = facet;
	        this.enabledSorts = [];
	        this.customSortDirection = 'ascending';
	        _.each(sorts, function (sortToActivate) {
	            var newSortToEnable = FacetSettings_1.FacetSettings.availableSorts[sortToActivate.toLowerCase()];
	            if (newSortToEnable != undefined) {
	                _this.enabledSorts.push(newSortToEnable);
	            }
	        });
	        this.removeEnabledSortsBasedOnFacetType();
	        if (Utils_1.Utils.isNonEmptyArray(this.enabledSorts)) {
	            if (this.facet.options.sortCriteria != undefined) {
	                this.activeSort = _.find(this.enabledSorts, function (enabledSort) {
	                    return enabledSort.name == _this.facet.options.sortCriteria;
	                });
	            }
	            if (!this.activeSort) {
	                this.activeSort = this.enabledSorts[0];
	            }
	        }
	    }
	    FacetSort.prototype.removeEnabledSortsBasedOnFacetType = function () {
	        if (Coveo.FacetRange && this.facet instanceof Coveo.FacetRange) {
	            var facetRange = this.facet;
	            if (facetRange.options['slider']) {
	                this.enabledSorts = [];
	            }
	        }
	    };
	    FacetSort.availableSorts = {
	        score: {
	            label: Strings_1.l('Score'),
	            directionToggle: false,
	            description: Strings_1.l('ScoreDescription'),
	            name: 'score'
	        },
	        occurrences: {
	            label: Strings_1.l('Occurrences'),
	            directionToggle: false,
	            description: Strings_1.l('OccurrencesDescription'),
	            name: 'occurrences'
	        },
	        alphaascending: {
	            label: Strings_1.l('Label'),
	            directionToggle: true,
	            description: Strings_1.l('LabelDescription'),
	            name: 'alphaascending',
	            relatedSort: 'alphadescending'
	        },
	        alphadescending: {
	            label: Strings_1.l('Label'),
	            directionToggle: true,
	            description: Strings_1.l('LabelDescription'),
	            name: 'alphadescending',
	            relatedSort: 'alphaascending'
	        },
	        computedfieldascending: {
	            label: Strings_1.l('Value'),
	            directionToggle: true,
	            description: Strings_1.l('ValueDescription'),
	            name: 'computedfieldascending',
	            relatedSort: 'computedfielddescending'
	        },
	        computedfielddescending: {
	            label: Strings_1.l('Value'),
	            directionToggle: true,
	            description: Strings_1.l('ValueDescription'),
	            name: 'computedfielddescending',
	            relatedSort: 'computedfieldascending'
	        },
	        chisquare: {
	            label: Strings_1.l('RelativeFrequency'),
	            directionToggle: false,
	            description: Strings_1.l('RelativeFrequencyDescription'),
	            name: 'chisquare'
	        },
	        custom: {
	            label: Strings_1.l('Custom'),
	            directionToggle: true,
	            description: Strings_1.l('CustomDescription'),
	            name: 'custom',
	            relatedSort: 'custom'
	        }
	    };
	    return FacetSort;
	}());
	exports.FacetSort = FacetSort;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {/// <reference path="Facet.ts" />
	"use strict";
	var FacetValueElement_1 = __webpack_require__(145);
	var Dom_1 = __webpack_require__(57);
	var FacetValues_1 = __webpack_require__(142);
	var Utils_1 = __webpack_require__(18);
	var FacetUtils_1 = __webpack_require__(82);
	var FacetValuesOrder_1 = __webpack_require__(149);
	var FacetValuesList = (function () {
	    function FacetValuesList(facet, facetValueElementKlass) {
	        this.facet = facet;
	        this.facetValueElementKlass = facetValueElementKlass;
	        // Dictionary of values. The key is always in lowercase.
	        this.valueList = {};
	        this.currentlyDisplayed = [];
	    }
	    FacetValuesList.prototype.build = function () {
	        this.valueContainer = document.createElement('ul');
	        Dom_1.$$(this.valueContainer).addClass('coveo-facet-values');
	        return this.valueContainer;
	    };
	    FacetValuesList.prototype.getAllCurrentlyDisplayed = function () {
	        return this.currentlyDisplayed;
	    };
	    FacetValuesList.prototype.getAll = function () {
	        return _.toArray(this.valueList);
	    };
	    FacetValuesList.prototype.getAllFacetValue = function () {
	        return _.map(this.getAll(), function (v) {
	            return v.facetValue;
	        });
	    };
	    FacetValuesList.prototype.get = function (value) {
	        var getter;
	        if (value instanceof FacetValues_1.FacetValue) {
	            getter = value.value;
	        }
	        else {
	            value = Utils_1.Utils.anyTypeToString(value);
	            getter = value;
	        }
	        this.ensureFacetValueIsInList(value);
	        return this.valueList[getter.toLowerCase()];
	    };
	    FacetValuesList.prototype.select = function (value) {
	        var valueElement = this.get(value);
	        valueElement.select();
	        return valueElement;
	    };
	    FacetValuesList.prototype.unselect = function (value) {
	        var valueElement = this.get(value);
	        valueElement.unselect();
	        return valueElement;
	    };
	    FacetValuesList.prototype.exclude = function (value) {
	        var valueElement = this.get(value);
	        valueElement.exclude();
	        return valueElement;
	    };
	    FacetValuesList.prototype.unExclude = function (value) {
	        var valueElement = this.get(value);
	        valueElement.unexclude();
	        return valueElement;
	    };
	    FacetValuesList.prototype.toggleSelect = function (value) {
	        var valueElement = this.get(value);
	        if (valueElement.facetValue.selected) {
	            valueElement.unselect();
	        }
	        else {
	            valueElement.select();
	        }
	        return valueElement;
	    };
	    FacetValuesList.prototype.toggleExclude = function (value) {
	        var valueElement = this.get(value);
	        if (valueElement.facetValue.excluded) {
	            valueElement.unexclude();
	        }
	        else {
	            valueElement.exclude();
	        }
	        return valueElement;
	    };
	    FacetValuesList.prototype.rebuild = function (numberOfValues) {
	        var _this = this;
	        Dom_1.$$(this.valueContainer).empty();
	        this.currentlyDisplayed = [];
	        var allValues = this.getValuesToBuildWith();
	        var toCompare = numberOfValues;
	        _.each(allValues, function (facetValue, index, list) {
	            if (_this.facetValueShouldBeRemoved(facetValue)) {
	                _this.facet.values.remove(facetValue.value);
	                toCompare += 1;
	            }
	            else if (index < toCompare) {
	                var valueElement = new _this.facetValueElementKlass(_this.facet, facetValue, true);
	                _this.valueList[facetValue.value.toLowerCase()] = valueElement;
	                var valueListElement = valueElement.build().renderer.listItem;
	                _this.valueContainer.appendChild(valueListElement);
	                _this.currentlyDisplayed.push(valueElement);
	            }
	        });
	        FacetUtils_1.FacetUtils.addNoStateCssClassToFacetValues(this.facet, this.valueContainer);
	        FacetUtils_1.FacetUtils.clipCaptionsToAvoidOverflowingTheirContainer(this.facet);
	    };
	    FacetValuesList.prototype.getValuesToBuildWith = function () {
	        if (this.facet.facetSort) {
	            return new FacetValuesOrder_1.FacetValuesOrder(this.facet, this.facet.facetSort).reorderValues(this.facet.values.getAll());
	        }
	        else {
	            return this.facet.values.getAll();
	        }
	    };
	    FacetValuesList.prototype.facetValueShouldBeRemoved = function (facetValue) {
	        return facetValue.occurrences == 0 &&
	            (facetValue.delta == 0 || facetValue.delta == undefined) &&
	            !facetValue.selected &&
	            !facetValue.excluded &&
	            !this.facet.keepDisplayedValuesNextTime;
	    };
	    FacetValuesList.prototype.ensureFacetValueIsInList = function (value) {
	        var facetValue;
	        if (value instanceof FacetValues_1.FacetValue) {
	            facetValue = this.facet.values.get(value.value);
	            if (facetValue == null) {
	                this.facet.values.add(value);
	                facetValue = value;
	            }
	        }
	        else {
	            facetValue = this.facet.values.get(value);
	            if (facetValue == null) {
	                facetValue = FacetValues_1.FacetValue.createFromValue(value);
	                this.facet.values.add(facetValue);
	            }
	        }
	        var key = facetValue.value.toLowerCase();
	        var found = this.valueList[key];
	        if (found == undefined) {
	            found = this.valueList[key] = new FacetValueElement_1.FacetValueElement(this.facet, facetValue, true);
	            found.build();
	        }
	        else {
	            found.facetValue = facetValue;
	        }
	    };
	    return FacetValuesList;
	}());
	exports.FacetValuesList = FacetValuesList;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	/// <reference path="Facet.ts" />
	/// <reference path="FacetSettings.ts" />
	"use strict";
	var Dom_1 = __webpack_require__(57);
	var FacetUtils_1 = __webpack_require__(82);
	var Strings_1 = __webpack_require__(34);
	var AnalyticsActionListMeta_1 = __webpack_require__(110);
	var FacetHeader = (function () {
	    function FacetHeader(options) {
	        this.options = options;
	        this.element = document.createElement('div');
	        Dom_1.$$(this.element).addClass('coveo-facet-header');
	    }
	    FacetHeader.prototype.build = function () {
	        if (this.options.isNewDesign && this.options.icon != undefined) {
	            this.element.appendChild(this.buildIcon());
	        }
	        else if (!this.options.isNewDesign) {
	            this.element.appendChild(this.buildIcon());
	        }
	        if (!this.options.isNewDesign) {
	            this.element.appendChild(this.buildWaitAnimation());
	        }
	        if (this.options.settingsKlass) {
	            this.sort = this.settings = new this.options.settingsKlass(this.options.availableSorts, this.options.facet);
	            this.element.appendChild(this.settings.build());
	        }
	        else if (this.options.sortKlass) {
	            this.sort = new this.options.sortKlass(this.options.availableSorts, this.options.facet);
	        }
	        if (this.options.enableCollapseElement && !this.options.isNewDesign) {
	            this.collapseElement = this.buildCollapse();
	            this.element.appendChild(this.collapseElement);
	            this.expandElement = this.buildExpand();
	            this.element.appendChild(this.expandElement);
	        }
	        if (this.options.facet) {
	            this.operatorElement = this.buildOperatorToggle();
	            this.element.appendChild(this.operatorElement);
	            Dom_1.$$(this.operatorElement).toggle(this.options.facet.options.enableTogglingOperator);
	        }
	        this.eraserElement = this.buildEraser();
	        this.element.appendChild(this.eraserElement);
	        this.element.appendChild(this.buildTitle());
	        if (this.options.isNewDesign) {
	            this.element.appendChild(this.buildWaitAnimation());
	        }
	        return this.element;
	    };
	    FacetHeader.prototype.switchToAnd = function () {
	        if (this.options.facet) {
	            this.options.facet.options.useAnd = true;
	            this.rebuildOperatorToggle();
	            this.updateOperatorQueryStateModel();
	        }
	    };
	    FacetHeader.prototype.switchToOr = function () {
	        if (this.options.facet) {
	            this.options.facet.options.useAnd = false;
	            this.rebuildOperatorToggle();
	            this.updateOperatorQueryStateModel();
	        }
	    };
	    FacetHeader.prototype.collapseFacet = function () {
	        if (this.collapseElement && this.expandElement) {
	            Dom_1.$$(this.collapseElement).hide();
	            Dom_1.$$(this.expandElement).show();
	        }
	        Dom_1.$$(this.options.facetElement).addClass('coveo-facet-collapsed');
	    };
	    FacetHeader.prototype.expandFacet = function () {
	        if (this.collapseElement && this.expandElement) {
	            Dom_1.$$(this.expandElement).hide();
	            Dom_1.$$(this.collapseElement).show();
	        }
	        Dom_1.$$(this.options.facetElement).removeClass('coveo-facet-collapsed');
	        if (this.options.facet) {
	            FacetUtils_1.FacetUtils.clipCaptionsToAvoidOverflowingTheirContainer(this.options.facet);
	        }
	    };
	    FacetHeader.prototype.updateOperatorQueryStateModel = function () {
	        if (this.options.facet && this.options.facet.options.enableTogglingOperator) {
	            var valueToSet = '';
	            if (this.options.facet.getSelectedValues().length != 0 || this.options.facet.getExcludedValues().length != 0) {
	                valueToSet = this.options.facet.options.useAnd ? 'and' : 'or';
	            }
	            this.options.facet.queryStateModel.set(this.options.facet.operatorAttributeId, valueToSet);
	        }
	    };
	    FacetHeader.prototype.rebuildOperatorToggle = function () {
	        var newElement = this.buildOperatorToggle();
	        if (this.operatorElement) {
	            Dom_1.$$(this.operatorElement).replaceWith(newElement);
	        }
	        this.operatorElement = newElement;
	    };
	    FacetHeader.prototype.buildIcon = function () {
	        var cssClassForIcon;
	        if (this.options.icon) {
	            cssClassForIcon = 'coveo-icon-custom ' + this.options.icon;
	        }
	        else {
	            cssClassForIcon = 'coveo-icon ' + this.options.field.substr(1);
	        }
	        this.iconElement = document.createElement('div');
	        Dom_1.$$(this.iconElement).addClass(cssClassForIcon);
	        return this.iconElement;
	    };
	    FacetHeader.prototype.buildWaitAnimation = function () {
	        this.waitElement = document.createElement('div');
	        Dom_1.$$(this.waitElement).addClass('coveo-facet-header-wait-animation');
	        Dom_1.$$(this.waitElement).hide();
	        return this.waitElement;
	    };
	    FacetHeader.prototype.buildCollapse = function () {
	        var _this = this;
	        var icon = document.createElement('span');
	        Dom_1.$$(icon).addClass('coveo-icon');
	        var collapse = document.createElement('div');
	        collapse.setAttribute('title', Strings_1.l('Collapse'));
	        Dom_1.$$(collapse).addClass('coveo-facet-header-collapse');
	        collapse.appendChild(icon);
	        Dom_1.$$(collapse).on('click', function () { return _this.collapseFacet(); });
	        return collapse;
	    };
	    FacetHeader.prototype.buildExpand = function () {
	        var _this = this;
	        var icon = document.createElement('span');
	        Dom_1.$$(icon).addClass('coveo-icon');
	        var expand = document.createElement('div');
	        expand.setAttribute('title', Strings_1.l('Expand'));
	        Dom_1.$$(expand).hide();
	        Dom_1.$$(expand).addClass('coveo-facet-header-expand');
	        expand.appendChild(icon);
	        Dom_1.$$(expand).on('click', function () { return _this.expandFacet(); });
	        return expand;
	    };
	    FacetHeader.prototype.buildOperatorToggle = function () {
	        var _this = this;
	        var icon = document.createElement('span');
	        Dom_1.$$(icon).addClass(['coveo-' + (this.options.facet.options.useAnd ? 'and' : 'or'), 'coveo-icon']);
	        var toggle = document.createElement('div');
	        toggle.setAttribute('title', Strings_1.l('SwitchTo', this.options.facet.options.useAnd ? Strings_1.l('Or') : Strings_1.l('And')));
	        Dom_1.$$(toggle).addClass('coveo-facet-header-operator');
	        toggle.appendChild(icon);
	        Dom_1.$$(toggle).on('click', function () { return _this.handleOperatorClick(); });
	        return toggle;
	    };
	    FacetHeader.prototype.handleOperatorClick = function () {
	        var _this = this;
	        if (this.options.facet.options.useAnd) {
	            this.options.facet.switchToOr();
	        }
	        else {
	            this.options.facet.switchToAnd();
	        }
	        if (this.options.facet.getSelectedValues().length != 0) {
	            var operatorNow = this.options.facet.options.useAnd ? 'AND' : 'OR';
	            var operatorBefore = this.options.facet.options.useAnd ? 'OR' : 'AND';
	            this.options.facet.triggerNewQuery(function () { return _this.options.facet.usageAnalytics.logSearchEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.facetToggle, {
	                facetId: _this.options.facet.options.id,
	                facetOperatorBefore: operatorBefore,
	                facetOperatorAfter: operatorNow,
	                facetTitle: _this.options.title
	            }); });
	        }
	    };
	    FacetHeader.prototype.buildTitle = function () {
	        var title = document.createElement('div');
	        Dom_1.$$(title).text(this.options.title);
	        Dom_1.$$(title).addClass('coveo-facet-header-title');
	        return title;
	    };
	    FacetHeader.prototype.buildEraser = function () {
	        var _this = this;
	        var icon = document.createElement('span');
	        Dom_1.$$(icon).addClass('coveo-icon');
	        var eraser = document.createElement('div');
	        eraser.setAttribute('title', Strings_1.l('Clear', this.options.title));
	        eraser.appendChild(icon);
	        Dom_1.$$(eraser).addClass('coveo-facet-header-eraser');
	        Dom_1.$$(eraser).on('click', function () {
	            var cmp = _this.options.facet || _this.options.facetSlider;
	            cmp.reset();
	            cmp.usageAnalytics.logSearchEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.facetClearAll, {
	                facetId: cmp.options.id,
	                facetTitle: cmp.options.title
	            });
	            cmp.queryController.executeQuery();
	        });
	        return eraser;
	    };
	    return FacetHeader;
	}());
	exports.FacetHeader = FacetHeader;


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {/// <reference path="Facet.ts" />
	"use strict";
	var Assert_1 = __webpack_require__(17);
	var DeviceUtils_1 = __webpack_require__(20);
	var AnalyticsActionListMeta_1 = __webpack_require__(110);
	var Dom_1 = __webpack_require__(57);
	var BreadcrumbValueElement = (function () {
	    function BreadcrumbValueElement(facet, facetValue) {
	        this.facet = facet;
	        this.facetValue = facetValue;
	    }
	    BreadcrumbValueElement.prototype.build = function (tooltip) {
	        var _this = this;
	        if (tooltip === void 0) { tooltip = true; }
	        Assert_1.Assert.exists(this.facetValue);
	        var elem = DeviceUtils_1.DeviceUtils.isMobileDevice() ? Dom_1.$$('div') : Dom_1.$$('span');
	        elem.addClass('coveo-facet-breadcrumb-value');
	        elem.toggleClass('coveo-selected', this.facetValue.selected);
	        elem.toggleClass('coveo-excluded', this.facetValue.excluded);
	        elem.el.setAttribute('title', this.getBreadcrumbTooltip());
	        var caption = Dom_1.$$('span', {
	            className: 'coveo-facet-breadcrumb-caption'
	        });
	        caption.text(this.facet.getValueCaption(this.facetValue));
	        elem.el.appendChild(caption.el);
	        var clear = Dom_1.$$('span', {
	            className: 'coveo-facet-breadcrumb-clear'
	        });
	        elem.el.appendChild(clear.el);
	        var clicked = false;
	        elem.on('click', function () {
	            if (!clicked) {
	                clicked = true;
	                if (_this.facetValue.excluded) {
	                    _this.facet.unexcludeValue(_this.facetValue.value);
	                }
	                else {
	                    _this.facet.deselectValue(_this.facetValue.value);
	                }
	                _this.facet.triggerNewQuery(function () { return _this.facet.usageAnalytics.logSearchEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.breadcrumbFacet, {
	                    facetId: _this.facet.options.id,
	                    facetValue: _this.facetValue.value,
	                    facetTitle: _this.facet.options.title
	                }); });
	            }
	        });
	        return elem;
	    };
	    BreadcrumbValueElement.prototype.getBreadcrumbTooltip = function () {
	        var tooltipParts = [this.facet.getValueCaption(this.facetValue), this.facetValue.getFormattedCount(), this.facetValue.getFormattedComputedField(this.facet.options.computedFieldFormat)];
	        return _.compact(tooltipParts).join(' ');
	    };
	    return BreadcrumbValueElement;
	}());
	exports.BreadcrumbValueElement = BreadcrumbValueElement;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var DeviceUtils_1 = __webpack_require__(20);
	var Assert_1 = __webpack_require__(17);
	var Strings_1 = __webpack_require__(34);
	var Dom_1 = __webpack_require__(57);
	var Globalize = __webpack_require__(4);
	var BreadcrumbValueList = (function () {
	    function BreadcrumbValueList(facet, facetValues, breadcrumbValueElementKlass) {
	        this.facet = facet;
	        this.facetValues = facetValues;
	        this.breadcrumbValueElementKlass = breadcrumbValueElementKlass;
	        this.setExpandedAndCollapsed();
	        this.elem = Dom_1.$$('div', {
	            className: 'coveo-facet-breadcrumb'
	        }).el;
	        var title = DeviceUtils_1.DeviceUtils.isMobileDevice() ? Dom_1.$$('div') : Dom_1.$$('span');
	        title.addClass('coveo-facet-breadcrumb-title');
	        title.text(this.facet.options.title + (DeviceUtils_1.DeviceUtils.isMobileDevice() ? '' : ':'));
	        this.elem.appendChild(title.el);
	        this.valueContainer = Dom_1.$$('span', {
	            className: 'coveo-facet-breadcrumb-values'
	        }).el;
	        this.elem.appendChild(this.valueContainer);
	    }
	    BreadcrumbValueList.prototype.build = function () {
	        this.buildExpanded();
	        if (this.collapsed.length != 0) {
	            this.buildCollapsed();
	        }
	        return this.elem;
	    };
	    BreadcrumbValueList.prototype.buildAsString = function () {
	        this.build();
	        if (this.elem) {
	            return (this.facet.options.title + ": ") + _.map(Dom_1.$$(this.elem).findAll('.coveo-facet-breadcrumb-value'), function (value) {
	                return Dom_1.$$(value).text();
	            }).join(', ');
	        }
	        return '';
	    };
	    BreadcrumbValueList.prototype.buildExpanded = function () {
	        var _this = this;
	        _.each(this.expanded, function (value, index) {
	            if (index != 0 && !DeviceUtils_1.DeviceUtils.isMobileDevice() && !_this.facet.searchInterface.isNewDesign()) {
	                var separator = Dom_1.$$('span', {
	                    className: 'coveo-facet-breadcrumb-separator'
	                });
	                separator.text(', ');
	                _this.valueContainer.appendChild(separator.el);
	            }
	            var elementBreadcrumb = new _this.breadcrumbValueElementKlass(_this.facet, value).build();
	            _this.valueContainer.appendChild(elementBreadcrumb.el);
	        });
	    };
	    BreadcrumbValueList.prototype.buildCollapsed = function () {
	        var _this = this;
	        var numberOfSelected = _.filter(this.collapsed, function (value) { return value.selected; }).length;
	        var numberOfExcluded = _.filter(this.collapsed, function (value) { return value.excluded; }).length;
	        Assert_1.Assert.check(numberOfSelected + numberOfExcluded == this.collapsed.length);
	        var elem = Dom_1.$$('div', {
	            className: 'coveo-facet-breadcrumb-value'
	        });
	        if (!DeviceUtils_1.DeviceUtils.isMobileDevice() && !this.facet.searchInterface.isNewDesign()) {
	            var sep = Dom_1.$$('span', {
	                className: 'coveo-separator'
	            });
	            sep.text(', ');
	            elem.el.appendChild(sep.el);
	        }
	        if (numberOfSelected > 0) {
	            var multi = Dom_1.$$('span', {
	                className: 'coveo-facet-breadcrumb-multi-count'
	            });
	            multi.text(Strings_1.l('NMore', Globalize.format(numberOfSelected, 'n0')));
	            elem.el.appendChild(multi.el);
	            var multiIcon = Dom_1.$$('div', {
	                className: 'coveo-selected coveo-facet-breadcrumb-multi-icon'
	            });
	            elem.el.appendChild(multiIcon.el);
	        }
	        if (numberOfExcluded > 0) {
	            var multiExcluded = Dom_1.$$('span', {
	                className: 'coveo-facet-breadcrumb-multi-count'
	            });
	            multiExcluded.text(Strings_1.l('NMore', Globalize.format(numberOfExcluded, 'n0')));
	            elem.el.appendChild(multiExcluded.el);
	            var multiExcludedIcon = Dom_1.$$('div', {
	                className: 'coveo-excluded coveo-facet-breadcrumb-multi-icon'
	            });
	            elem.el.appendChild(multiExcludedIcon.el);
	        }
	        var valueElements = _.map(this.collapsed, function (facetValue) {
	            return new _this.breadcrumbValueElementKlass(_this.facet, facetValue);
	        });
	        var toolTips = _.map(valueElements, function (valueElement) {
	            return valueElement.getBreadcrumbTooltip();
	        });
	        elem.el.setAttribute('title', toolTips.join('\n'));
	        elem.on('click', function () {
	            var elements = [];
	            _.forEach(valueElements, function (valueElement) {
	                if (!DeviceUtils_1.DeviceUtils.isMobileDevice() && !_this.facet.searchInterface.isNewDesign()) {
	                    var separatorsClicked = Dom_1.$$('span', {
	                        className: 'coveo-facet-breadcrumb-separator'
	                    });
	                    separatorsClicked.text(', ');
	                    elements.push(separatorsClicked.el);
	                }
	                elements.push(valueElement.build(false).el);
	            });
	            _.each(elements, function (el) {
	                Dom_1.$$(el).insertBefore(elem.el);
	            });
	            elem.detach();
	        });
	        this.valueContainer.appendChild(elem.el);
	    };
	    BreadcrumbValueList.prototype.setExpandedAndCollapsed = function () {
	        if (this.facetValues.length > this.facet.options.numberOfValuesInBreadcrumb) {
	            this.collapsed = _.rest(this.facetValues, this.facet.options.numberOfValuesInBreadcrumb - 1);
	            this.expanded = _.first(this.facetValues, this.facet.options.numberOfValuesInBreadcrumb - 1);
	        }
	        else {
	            this.collapsed = [];
	            this.expanded = this.facetValues;
	        }
	    };
	    return BreadcrumbValueList;
	}());
	exports.BreadcrumbValueList = BreadcrumbValueList;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var FacetSearchValuesList = (function () {
	    function FacetSearchValuesList(facet, facetValueElementKlass) {
	        this.facet = facet;
	        this.facetValueElementKlass = facetValueElementKlass;
	    }
	    FacetSearchValuesList.prototype.build = function (facetValues) {
	        var _this = this;
	        var valuesToBuildWith = _.map(facetValues, function (facetValue) {
	            return _.find(_this.facet.values.getAll(), function (valueAlreadyInFacet) {
	                return valueAlreadyInFacet.value == facetValue.value;
	            }) || facetValue;
	        });
	        return _.map(valuesToBuildWith, function (facetValue) {
	            return new _this.facetValueElementKlass(_this.facet, facetValue, _this.facet.keepDisplayedValuesNextTime).build().renderer.listItem;
	        });
	    };
	    return FacetSearchValuesList;
	}());
	exports.FacetSearchValuesList = FacetSearchValuesList;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	/// <reference path="Facet.ts" />
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var ValueElement_1 = __webpack_require__(146);
	var OmniboxValueElement = (function (_super) {
	    __extends(OmniboxValueElement, _super);
	    function OmniboxValueElement(facet, facetValue, eventArg, onSelect, onExclude) {
	        _super.call(this, facet, facetValue, onSelect, onExclude);
	        this.facet = facet;
	        this.facetValue = facetValue;
	        this.eventArg = eventArg;
	    }
	    OmniboxValueElement.prototype.bindEvent = function () {
	        _super.prototype.bindEvent.call(this, { displayNextTime: false, pinFacet: false, omniboxObject: this.eventArg });
	    };
	    return OmniboxValueElement;
	}(ValueElement_1.ValueElement));
	exports.OmniboxValueElement = OmniboxValueElement;


/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var Dom_1 = __webpack_require__(57);
	var Utils_1 = __webpack_require__(18);
	var FacetUtils_1 = __webpack_require__(82);
	var OmniboxValuesList = (function () {
	    function OmniboxValuesList(facet, facetValues, omniboxObject, omniboxValueElementKlass) {
	        this.facet = facet;
	        this.facetValues = facetValues;
	        this.omniboxObject = omniboxObject;
	        this.omniboxValueElementKlass = omniboxValueElementKlass;
	    }
	    OmniboxValuesList.prototype.build = function () {
	        var _this = this;
	        var rows = [];
	        _.each(this.facetValues, function (facetValue) {
	            rows.push(_this.buildOmniboxForOneRow(facetValue, _this.omniboxObject));
	        });
	        return this.buildFinalOmniboxElement(rows);
	    };
	    OmniboxValuesList.prototype.buildOmniboxForOneRow = function (facetValue, omniboxObject) {
	        var _this = this;
	        var selectCallback = function (elem, cause) { return _this.logAnalyticsEvent(elem, cause); };
	        var excludeCallback = function (elem, cause) { return _this.logAnalyticsEvent(elem, cause); };
	        var omniboxValueElement = new this.omniboxValueElementKlass(this.facet, facetValue, omniboxObject, selectCallback, excludeCallback);
	        var omniboxRowContent = omniboxValueElement.build().renderer.listItem;
	        var regex = omniboxObject.completeQueryExpression.regex;
	        var valueToSearch = omniboxObject.completeQueryExpression.word;
	        var caption = Dom_1.$$(omniboxRowContent).find('.coveo-facet-value-caption');
	        caption.innerHTML = this.highlightOmniboxMatch(this.facet.getValueCaption(facetValue), regex, valueToSearch);
	        var omniboxRow = Dom_1.$$('div', {
	            className: 'coveo-omnibox-selectable coveo-facet-value coveo-omnibox-facet-value'
	        }).el;
	        omniboxRow.appendChild(omniboxRowContent);
	        Dom_1.$$(omniboxRow).on('keyboardSelect', function () {
	            var input = Dom_1.$$(omniboxRowContent).find('input[type=checkbox]');
	            Dom_1.$$(input).trigger('change');
	        });
	        return omniboxRow;
	    };
	    OmniboxValuesList.prototype.buildFinalOmniboxElement = function (rows) {
	        var header = this.buildOmniboxHeader();
	        if (Utils_1.Utils.isEmptyArray(rows)) {
	            return undefined;
	        }
	        else {
	            var ret = Dom_1.$$('div', {
	                className: 'coveo-omnibox-facet-value'
	            }).el;
	            ret.appendChild(header);
	            _.each(rows, function (r) {
	                ret.appendChild(r);
	            });
	            FacetUtils_1.FacetUtils.addNoStateCssClassToFacetValues(this.facet, ret);
	            return ret;
	        }
	    };
	    OmniboxValuesList.prototype.buildOmniboxHeader = function () {
	        var title = this.facet.options.title;
	        var header = Dom_1.$$('div', {
	            className: 'coveo-omnibox-facet-header'
	        }).el;
	        if (this.facet.searchInterface.isNewDesign()) {
	            Dom_1.$$(header).text(title);
	            return header;
	        }
	        else {
	            var icon = Dom_1.$$('span', {
	                className: 'coveo-icon ' + this.facet.options.field.substr(1)
	            }).el;
	            header.appendChild(icon);
	            Dom_1.$$(header).text(title);
	        }
	        return header;
	    };
	    OmniboxValuesList.prototype.highlightOmniboxMatch = function (orignalStr, regex, valueToSearch) {
	        var firstChar = orignalStr.search(regex);
	        var lastChar = firstChar + valueToSearch.length;
	        return orignalStr.slice(0, firstChar) + '<span class="coveo-highlight">' + orignalStr.slice(firstChar, lastChar) + '</span>' + orignalStr.slice(lastChar);
	    };
	    OmniboxValuesList.prototype.logAnalyticsEvent = function (elem, cause) {
	        var strippedFacetValues = _.pluck(this.facetValues, 'value');
	        elem.facet.usageAnalytics.logSearchEvent(cause, {
	            query: this.omniboxObject.completeQueryExpression.word,
	            facetId: elem.facet.options.id,
	            facetTitle: elem.facet.options.title,
	            facetValue: elem.facetValue.value,
	            suggestions: strippedFacetValues.join(';'),
	            suggestionRanking: _.indexOf(strippedFacetValues, elem.facetValue.value)
	        });
	    };
	    return OmniboxValuesList;
	}());
	exports.OmniboxValuesList = OmniboxValuesList;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var Dom_1 = __webpack_require__(57);
	var InitializationEvents_1 = __webpack_require__(44);
	var ResponsiveComponentsManager_1 = __webpack_require__(160);
	var ResponsiveComponentsUtils_1 = __webpack_require__(148);
	var EventsUtils_1 = __webpack_require__(144);
	var SearchInterface_1 = __webpack_require__(97);
	var Component_1 = __webpack_require__(96);
	var Logger_1 = __webpack_require__(16);
	var Strings_1 = __webpack_require__(34);
	var PopupUtils_1 = __webpack_require__(71);
	var Utils_1 = __webpack_require__(18);
	var Facet_1 = __webpack_require__(141);
	var FacetSlider_1 = __webpack_require__(163);
	var ResponsiveFacets = (function () {
	    function ResponsiveFacets(root, ID, options) {
	        this.root = root;
	        this.facets = [];
	        this.facetSliders = [];
	        this.ID = ID;
	        this.coveoRoot = root;
	        this.searchInterface = Component_1.Component.get(root.el, SearchInterface_1.SearchInterface, false);
	        this.buildDropdownContent();
	        this.buildDropdownHeader();
	        this.bindDropdownContentEvents();
	        this.bindDropdownHeaderEvents();
	        this.buildPopupBackground();
	        this.saveFacetsPosition();
	        this.bindNukeEvents();
	        if (Utils_1.Utils.isNullOrUndefined(options.responsiveBreakpoint)) {
	            this.breakpoint = ResponsiveFacets.ROOT_MIN_WIDTH;
	        }
	        else {
	            this.breakpoint = options.responsiveBreakpoint;
	        }
	    }
	    ResponsiveFacets.init = function (root, component, options) {
	        this.logger = new Logger_1.Logger('ResponsiveFacets');
	        if (!Dom_1.$$(root).find('.coveo-facet-column')) {
	            this.logger.info('No element with class coveo-facet-column. Responsive facets cannot be enabled');
	            return;
	        }
	        ResponsiveComponentsManager_1.ResponsiveComponentsManager.register(ResponsiveFacets, Dom_1.$$(root), Facet_1.Facet.ID, component, options);
	    };
	    ResponsiveFacets.prototype.needSmallMode = function () {
	        return this.coveoRoot.width() <= this.breakpoint;
	    };
	    ResponsiveFacets.prototype.changeToSmallMode = function () {
	        if (!Dom_1.$$(this.coveoRoot).find('.coveo-tab-section')) {
	            ResponsiveFacets.logger.info('No element with class coveo-tab-section. Responsive facets cannot be enabled');
	            return;
	        }
	        this.positionPopup();
	        this.closeDropdown();
	        this.disableFacetPreservePosition();
	        Dom_1.$$(this.coveoRoot.find('.coveo-tab-section')).el.appendChild(this.dropdownHeader.el);
	        this.dropdownContent.el.style.display = 'none';
	        ResponsiveComponentsUtils_1.ResponsiveComponentsUtils.activateSmallFacet(this.coveoRoot);
	    };
	    ResponsiveFacets.prototype.changeToLargeMode = function () {
	        this.enableFacetPreservePosition();
	        this.cleanUpDropdown();
	        this.dropdownContent.el.removeAttribute('style');
	        this.restoreFacetsPosition();
	        ResponsiveComponentsUtils_1.ResponsiveComponentsUtils.deactivateSmallFacet(this.coveoRoot);
	    };
	    ResponsiveFacets.prototype.registerComponent = function (component) {
	        if (component instanceof Facet_1.Facet) {
	            this.facets.push(component);
	        }
	        else if (component instanceof FacetSlider_1.FacetSlider) {
	            this.facetSliders.push(component);
	        }
	    };
	    ResponsiveFacets.prototype.needTabSection = function () {
	        return this.needSmallMode();
	    };
	    ResponsiveFacets.prototype.handleResizeEvent = function () {
	        if (this.needSmallMode() && !ResponsiveComponentsUtils_1.ResponsiveComponentsUtils.isSmallFacetActivated(this.coveoRoot)) {
	            this.changeToSmallMode();
	        }
	        else if (!this.needSmallMode() && ResponsiveComponentsUtils_1.ResponsiveComponentsUtils.isSmallFacetActivated(this.coveoRoot)) {
	            this.changeToLargeMode();
	        }
	        if (this.dropdownHeader.hasClass('coveo-dropdown-header-active')) {
	            this.openDropdown();
	        }
	    };
	    ResponsiveFacets.prototype.triggerFacetSliderDraw = function () {
	        _.each(this.facetSliders, function (facetSlider) { return facetSlider.drawDelayedGraphData(); });
	    };
	    ResponsiveFacets.prototype.buildDropdownContent = function () {
	        this.dropdownContent = Dom_1.$$(this.coveoRoot.find('.coveo-facet-column'));
	        var filterByContainer = Dom_1.$$('div', { className: 'coveo-facet-header-filter-by-container', style: 'display: none' });
	        var filterBy = Dom_1.$$('div', { className: 'coveo-facet-header-filter-by' });
	        filterBy.text(Strings_1.l('Filter by:'));
	        filterByContainer.append(filterBy.el);
	        this.dropdownContent.prepend(filterByContainer.el);
	    };
	    ResponsiveFacets.prototype.buildDropdownHeader = function () {
	        this.dropdownHeader = Dom_1.$$('a', { className: 'coveo-dropdown-header coveo-facet-dropdown-header' });
	        var content = Dom_1.$$('p');
	        content.text(Strings_1.l('Facets'));
	        this.dropdownHeader.el.appendChild(content.el);
	    };
	    ResponsiveFacets.prototype.bindDropdownHeaderEvents = function () {
	        var _this = this;
	        this.dropdownHeader.on('click', function () {
	            if (!_this.dropdownHeader.hasClass('coveo-dropdown-header-active')) {
	                _this.openDropdown();
	                _this.drawFacetSliderGraphs();
	            }
	            else {
	                _this.closeDropdown();
	            }
	        });
	    };
	    ResponsiveFacets.prototype.bindDropdownContentEvents = function () {
	        var _this = this;
	        this.dropdownContent.on('scroll', _.debounce(function () {
	            _.each(_this.facets, function (facet) {
	                var facetSearch = facet.facetSearch;
	                if (facetSearch && facetSearch.currentlyDisplayedResults && !_this.isFacetSearchScrolledIntoView(facetSearch.search)) {
	                    facet.facetSearch.positionSearchResults(_this.dropdownContent.el);
	                }
	                else if (facetSearch && facet.facetSearch.currentlyDisplayedResults) {
	                    facet.facetSearch.positionSearchResults();
	                }
	            });
	        }, ResponsiveFacets.DEBOUNCE_SCROLL_WAIT));
	    };
	    ResponsiveFacets.prototype.buildPopupBackground = function () {
	        var _this = this;
	        this.popupBackground = Dom_1.$$('div', { className: 'coveo-facet-dropdown-background' });
	        EventsUtils_1.EventsUtils.addPrefixedEvent(this.popupBackground.el, 'TransitionEnd', function () {
	            if (_this.popupBackground.el.style.opacity == '0') {
	                _this.popupBackground.detach();
	            }
	        });
	        this.popupBackground.on('click', function () { return _this.closeDropdown(); });
	    };
	    ResponsiveFacets.prototype.saveFacetsPosition = function () {
	        this.previousSibling = this.dropdownContent.el.previousSibling ? Dom_1.$$(this.dropdownContent.el.previousSibling) : null;
	        this.parent = Dom_1.$$(this.dropdownContent.el.parentElement);
	    };
	    ResponsiveFacets.prototype.restoreFacetsPosition = function () {
	        if (this.previousSibling) {
	            this.dropdownContent.insertAfter(this.previousSibling.el);
	        }
	        else {
	            this.parent.prepend(this.dropdownContent.el);
	        }
	    };
	    ResponsiveFacets.prototype.openDropdown = function () {
	        this.positionPopup();
	        document.documentElement.appendChild(this.popupBackground.el);
	        this.root.el.appendChild(this.popupBackground.el);
	        window.getComputedStyle(this.popupBackground.el).opacity;
	        this.popupBackground.el.style.opacity = ResponsiveFacets.TRANSPARENT_BACKGROUND_OPACITY;
	        this.triggerFacetSliderDraw();
	    };
	    ResponsiveFacets.prototype.positionPopup = function () {
	        this.dropdownHeader.el.style.zIndex = ResponsiveFacets.ACTIVE_FACET_HEADER_Z_INDEX;
	        this.dropdownContent.addClass('coveo-facet-dropdown-content');
	        this.dropdownHeader.addClass('coveo-dropdown-header-active');
	        this.dropdownContent.el.style.display = '';
	        var width = ResponsiveFacets.FACET_DROPDOWN_WIDTH_RATIO * this.coveoRoot.el.offsetWidth;
	        if (width <= ResponsiveFacets.FACET_DROPDOWN_MIN_WIDTH) {
	            width = ResponsiveFacets.FACET_DROPDOWN_MIN_WIDTH;
	        }
	        this.dropdownContent.el.style.width = width.toString() + 'px';
	        PopupUtils_1.PopupUtils.positionPopup(this.dropdownContent.el, Dom_1.$$(this.coveoRoot.find('.coveo-tab-section')).el, this.coveoRoot.el, { horizontal: PopupUtils_1.HorizontalAlignment.INNERRIGHT, vertical: PopupUtils_1.VerticalAlignment.BOTTOM }, this.coveoRoot.el);
	    };
	    ResponsiveFacets.prototype.closeDropdown = function () {
	        // Because of DOM manipulation, sometimes the animation will not trigger. Accessing the computed styles makes sure
	        // the animation will happen. Adding this here because its possible that this element has recently been manipulated.
	        window.getComputedStyle(this.popupBackground.el).opacity;
	        this.popupBackground.el.style.opacity = '0';
	        this.dropdownHeader.el.style.zIndex = '';
	        this.dropdownContent.el.style.display = 'none';
	        this.dropdownContent.removeClass('coveo-facet-dropdown-content');
	        this.dropdownHeader.removeClass('coveo-dropdown-header-active');
	        this.dismissFacetSearches();
	    };
	    ResponsiveFacets.prototype.dismissFacetSearches = function () {
	        _.each(this.facets, function (facet) {
	            if (facet.facetSearch && facet.facetSearch.currentlyDisplayedResults) {
	                facet.facetSearch.completelyDismissSearch();
	            }
	        });
	    };
	    ResponsiveFacets.prototype.cleanUpDropdown = function () {
	        this.closeDropdown();
	        this.dropdownHeader.detach();
	        this.dropdownHeader.el.style.zIndex = '';
	    };
	    ResponsiveFacets.prototype.enableFacetPreservePosition = function () {
	        _.each(this.facets, function (facet) { return facet.options.preservePosition = true; });
	    };
	    ResponsiveFacets.prototype.disableFacetPreservePosition = function () {
	        _.each(this.facets, function (facet) { return facet.options.preservePosition = false; });
	    };
	    ResponsiveFacets.prototype.bindNukeEvents = function () {
	        var _this = this;
	        Dom_1.$$(this.coveoRoot).on(InitializationEvents_1.InitializationEvents.nuke, function () {
	            Dom_1.$$(document.documentElement).off('click', _this.popupBackgroundClickListener);
	        });
	    };
	    ResponsiveFacets.prototype.drawFacetSliderGraphs = function () {
	        _.each(this.facetSliders, function (facetSlider) { return facetSlider.drawDelayedGraphData(); });
	    };
	    ResponsiveFacets.prototype.isFacetSearchScrolledIntoView = function (facetSearchElement) {
	        var facetTop = facetSearchElement.getBoundingClientRect().top;
	        var facetBottom = facetSearchElement.getBoundingClientRect().bottom;
	        var dropdownTop = this.dropdownContent.el.getBoundingClientRect().top;
	        var dropdownBottom = this.dropdownContent.el.getBoundingClientRect().bottom;
	        dropdownTop = dropdownTop >= 0 ? dropdownTop : 0;
	        return (facetTop >= dropdownTop) && (facetBottom <= dropdownBottom);
	    };
	    ResponsiveFacets.ACTIVE_FACET_HEADER_Z_INDEX = '20';
	    ResponsiveFacets.FACET_DROPDOWN_MIN_WIDTH = 280;
	    ResponsiveFacets.FACET_DROPDOWN_WIDTH_RATIO = 0.35; // Used to set the width relative to the coveo root.
	    ResponsiveFacets.TRANSPARENT_BACKGROUND_OPACITY = '0.9';
	    ResponsiveFacets.DEBOUNCE_SCROLL_WAIT = 250;
	    ResponsiveFacets.ROOT_MIN_WIDTH = 800;
	    return ResponsiveFacets;
	}());
	exports.ResponsiveFacets = ResponsiveFacets;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var Dom_1 = __webpack_require__(57);
	var InitializationEvents_1 = __webpack_require__(44);
	var Component_1 = __webpack_require__(96);
	var Tab_1 = __webpack_require__(161);
	var Facet_1 = __webpack_require__(141);
	var SearchInterface_1 = __webpack_require__(97);
	var ResponsiveComponentsUtils_1 = __webpack_require__(148);
	var Utils_1 = __webpack_require__(18);
	var ResponsiveComponentsManager = (function () {
	    function ResponsiveComponentsManager(root) {
	        var _this = this;
	        this.disabledComponents = [];
	        this.responsiveComponents = [];
	        this.createdTabSection = false;
	        this.coveoRoot = root;
	        this.searchBoxElement = this.getSearchBoxElement();
	        this.ensureTabSectionInDom();
	        this.saveTabSectionPosition();
	        this.resizeListener = _.debounce(function () {
	            if (_this.shouldSwitchToSmallMode()) {
	                _this.coveoRoot.addClass('coveo-small-interface');
	                _this.tabSection.insertAfter(_this.searchBoxElement);
	            }
	            else if (_this.shouldExitSmallMode()) {
	                _this.coveoRoot.removeClass('coveo-small-interface');
	                _this.restoreTabSectionPosition();
	            }
	            _.each(_this.responsiveComponents, function (responsiveComponent) {
	                responsiveComponent.handleResizeEvent();
	            });
	        }, 200);
	        window.addEventListener('resize', this.resizeListener);
	        this.bindNukeEvents();
	    }
	    // Register takes a class and will instantiate it after framework initialization has completed.
	    ResponsiveComponentsManager.register = function (responsiveComponentConstructor, root, ID, component, options) {
	        var _this = this;
	        if (this.shouldEnableResponsiveMode(root)) {
	            var responsiveComponentsManager = _.find(this.componentManagers, function (componentManager) { return root.el == componentManager.coveoRoot.el; });
	            if (!responsiveComponentsManager) {
	                responsiveComponentsManager = new ResponsiveComponentsManager(root);
	                this.componentManagers.push(responsiveComponentsManager);
	            }
	            if (!Utils_1.Utils.isNullOrUndefined(options.enableResponsiveMode) && !options.enableResponsiveMode) {
	                responsiveComponentsManager.disableComponent(ID);
	                return;
	            }
	            root.on(InitializationEvents_1.InitializationEvents.afterInitialization, function () {
	                var currentResponsiveComponentsManager = _.find(_this.componentManagers, function (componentManager) { return root.el == componentManager.coveoRoot.el; });
	                currentResponsiveComponentsManager.register(responsiveComponentConstructor, root, ID, component, options);
	                _this.remainingComponentInitializations--;
	                if (_this.remainingComponentInitializations == 0) {
	                    _this.resizeAllComponentsManager();
	                }
	            });
	            this.remainingComponentInitializations++;
	        }
	    };
	    ResponsiveComponentsManager.shouldEnableResponsiveMode = function (root) {
	        var searchInterface = Component_1.Component.get(root.el, SearchInterface_1.SearchInterface, true);
	        return searchInterface instanceof SearchInterface_1.SearchInterface && searchInterface.options.enableAutomaticResponsiveMode && searchInterface.isNewDesign();
	    };
	    ResponsiveComponentsManager.resizeAllComponentsManager = function () {
	        _.each(this.componentManagers, function (componentManager) {
	            componentManager.resizeListener();
	        });
	    };
	    ResponsiveComponentsManager.prototype.register = function (responsiveComponentConstructor, root, ID, component, options) {
	        if (this.isDisabled(ID)) {
	            return;
	        }
	        if (!this.isActivated(ID)) {
	            var responsiveComponent = new responsiveComponentConstructor(root, ID, options);
	            if (this.isFacet(ID)) {
	                this.responsiveFacets = responsiveComponent;
	            }
	            if (this.isTabs(ID)) {
	                this.responsiveComponents.push(responsiveComponent);
	            }
	            else {
	                // Tabs need to be rendered last, so any dropdown header(eg: facet) is already there when the responsive tabs check for overflow.
	                this.responsiveComponents.unshift(responsiveComponent);
	            }
	        }
	        if (this.isFacet(ID)) {
	            this.responsiveFacets.registerComponent(component);
	        }
	    };
	    ResponsiveComponentsManager.prototype.disableComponent = function (ID) {
	        this.disabledComponents.push(ID);
	    };
	    ResponsiveComponentsManager.prototype.isDisabled = function (ID) {
	        return _.indexOf(this.disabledComponents, ID) != -1;
	    };
	    ResponsiveComponentsManager.prototype.shouldSwitchToSmallMode = function () {
	        // If we had to create the tab section or if we reached the pixel breakpoint, we move the tab section below the search box
	        // to switch to small mode.
	        if (this.searchBoxElement && this.tabSection) {
	            var aComponentNeedsTabSection = this.needTabSection() && this.createdTabSection;
	            var reachedBreakpoint = this.coveoRoot.width() <= ResponsiveComponentsUtils_1.ResponsiveComponentsUtils.MEDIUM_MOBILE_WIDTH;
	            return aComponentNeedsTabSection || reachedBreakpoint;
	        }
	        return false;
	    };
	    ResponsiveComponentsManager.prototype.shouldExitSmallMode = function () {
	        return this.searchBoxElement && this.tabSection && this.coveoRoot.width() > ResponsiveComponentsUtils_1.ResponsiveComponentsUtils.MEDIUM_MOBILE_WIDTH;
	    };
	    ResponsiveComponentsManager.prototype.needTabSection = function () {
	        for (var i = 0; i < this.responsiveComponents.length; i++) {
	            var responsiveComponent = this.responsiveComponents[i];
	            if (responsiveComponent.needTabSection && responsiveComponent.needTabSection()) {
	                return true;
	            }
	        }
	        return false;
	    };
	    ResponsiveComponentsManager.prototype.ensureTabSectionInDom = function () {
	        var tabSection = this.coveoRoot.find('.coveo-tab-section');
	        if (tabSection) {
	            this.tabSection = Dom_1.$$(tabSection);
	        }
	        else {
	            this.tabSection = Dom_1.$$('div', { className: 'coveo-tab-section' });
	            this.createdTabSection = true;
	        }
	    };
	    ResponsiveComponentsManager.prototype.restoreTabSectionPosition = function () {
	        if (this.tabSectionPreviousSibling) {
	            this.tabSection.insertAfter(this.tabSectionPreviousSibling.el);
	        }
	        else if (this.tabSectionParent) {
	            this.tabSectionParent.prepend(this.tabSection.el);
	        }
	        else if (!this.needTabSection()) {
	            this.tabSection && this.tabSection.detach();
	        }
	    };
	    ResponsiveComponentsManager.prototype.saveTabSectionPosition = function () {
	        if (this.tabSection) {
	            this.tabSectionPreviousSibling = this.tabSection.el.previousSibling ? Dom_1.$$(this.tabSection.el.previousSibling) : null;
	            this.tabSectionParent = this.tabSection.el.parentElement ? Dom_1.$$(this.tabSection.el.parentElement) : null;
	        }
	    };
	    ResponsiveComponentsManager.prototype.isFacet = function (ID) {
	        return ID == Facet_1.Facet.ID;
	    };
	    ResponsiveComponentsManager.prototype.isTabs = function (ID) {
	        return ID == Tab_1.Tab.ID;
	    };
	    ResponsiveComponentsManager.prototype.isActivated = function (ID) {
	        return _.find(this.responsiveComponents, function (current) { return current.ID == ID; }) != undefined;
	    };
	    ResponsiveComponentsManager.prototype.getSearchBoxElement = function () {
	        var searchBoxElement = this.coveoRoot.find('.coveo-search-section');
	        if (searchBoxElement) {
	            return searchBoxElement;
	        }
	        else {
	            return this.coveoRoot.find('.CoveoSearchbox');
	        }
	    };
	    ResponsiveComponentsManager.prototype.bindNukeEvents = function () {
	        var _this = this;
	        Dom_1.$$(this.coveoRoot).on(InitializationEvents_1.InitializationEvents.nuke, function () {
	            window.removeEventListener('resize', _this.resizeListener);
	        });
	    };
	    ResponsiveComponentsManager.componentManagers = [];
	    ResponsiveComponentsManager.remainingComponentInitializations = 0;
	    return ResponsiveComponentsManager;
	}());
	exports.ResponsiveComponentsManager = ResponsiveComponentsManager;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var ResponsiveTabs_ts_1 = __webpack_require__(162);
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var Model_1 = __webpack_require__(87);
	var QueryEvents_1 = __webpack_require__(47);
	var QueryStateModel_1 = __webpack_require__(90);
	var AnalyticsActionListMeta_1 = __webpack_require__(110);
	var SearchEndpoint_1 = __webpack_require__(12);
	var Initialization_1 = __webpack_require__(95);
	var Utils_1 = __webpack_require__(18);
	var Assert_1 = __webpack_require__(17);
	var Dom_1 = __webpack_require__(57);
	var KeyboardUtils_1 = __webpack_require__(68);
	/**
	 * This component is a bar allowing users to select a search interface.
	 *
	 * The component attaches itself to an div element and is in charge of adding an advanced expression to the query and thus, modify the outgoing query in order to refine the results in relation to the selected tab.
	 *
	 * It also allows to hide and show different parts of the UI. In order to do so, each component of the UI can specify whether or not it wishes to be included or excluded from a specific tab.
	 *
	 * # Including and excluding other HTML components
	 *
	 * You can hide/show specific HTML components, based on the currently selected search tab by adding the following attributes:
	 *
	 * * `<div data-tab="foobar">` -> Include this element only in the tab with the ID 'foobar'.
	 *
	 * * `<div data-tab-not="foobar">` -> DO NOT include this element in the tab ID 'foobar'.
	 *
	 * * `<div data-tab="foobar,somethingelse">` -> Include this element only in the tab with the ID 'foobar' or 'somethingelse'.
	 *
	 * # Setting a new endpoint for a tab
	 * A tab can use a custom endpoint when performing a query. First, you need to make sure that the endpoint exists in the array of Coveo.SearchEndpoint.endpoints.
	 *
	 * ```
	 * Coveo.SearchEndpoint.endpoints["specialEndpoint"] = new Coveo.SearchEndpoint({
	 *     restUri : 'https://somewhere.com/rest/search'
	 * })
	 *
	 * [...]
	 *
	 * <div class='CoveoTab' data-endpoint='specialEndpoint'></div>
	 *
	 * ```
	 */
	var Tab = (function (_super) {
	    __extends(Tab, _super);
	    /**
	     * Create a new Tab. Bind on buildingQuery event as well as on click of the element.
	     * @param element The `HTMLElement` on which to create a new tab. Normally a div
	     * @param options
	     * @param bindings
	     */
	    function Tab(element, options, bindings) {
	        var _this = this;
	        _super.call(this, element, Tab.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.isFirstQuery = true;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, Tab, options);
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.buildingQuery, function (args) { return _this.handleBuildingQuery(args); });
	        this.bind.onQueryState(Model_1.MODEL_EVENTS.CHANGE_ONE, QueryStateModel_1.QUERY_STATE_ATTRIBUTES.T, function (args) { return _this.handleQueryStateChanged(args); });
	        var clickAction = function () { return _this.handleClick(); };
	        this.bind.on(element, 'click', clickAction);
	        this.bind.on(element, 'keyup', KeyboardUtils_1.KeyboardUtils.keypressAction(KeyboardUtils_1.KEYBOARD.ENTER, clickAction));
	        this.render();
	        ResponsiveTabs_ts_1.ResponsiveTabs.init(this.root, this, this.options);
	    }
	    /**
	     * Select the current tab.<br/>
	     * Trigger a query and log an analytics event.
	     */
	    Tab.prototype.select = function () {
	        if (!this.disabled) {
	            this.queryStateModel.setMultiple({
	                t: this.options.id,
	                sort: this.options.sort || QueryStateModel_1.QueryStateModel.defaultAttributes.sort
	            });
	            this.usageAnalytics.logSearchEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.interfaceChange, { interfaceChangeTo: this.options.id });
	            this.queryController.executeQuery();
	        }
	    };
	    /**
	     * Check if the given `HTMLElement` is included or not in this tab.
	     * @param element The element to verify.
	     * @returns {boolean}
	     */
	    Tab.prototype.isElementIncludedInTab = function (element) {
	        Assert_1.Assert.exists(element);
	        var includedTabs = this.splitListOfTabs(element.getAttribute('data-tab'));
	        var excludedTabs = this.splitListOfTabs(element.getAttribute('data-tab-not'));
	        Assert_1.Assert.check(!(includedTabs.length != 0 && excludedTabs.length != 0), 'You cannot both explicity include and exclude an element from tabs');
	        return (includedTabs.length != 0 && _.indexOf(includedTabs, this.options.id) != -1) ||
	            (excludedTabs.length != 0 && _.indexOf(excludedTabs, this.options.id) == -1) ||
	            (includedTabs.length == 0 && excludedTabs.length == 0);
	    };
	    Tab.prototype.handleClick = function () {
	        this.select();
	    };
	    Tab.prototype.render = function () {
	        var icon = this.options.icon;
	        if (Utils_1.Utils.isNonEmptyString(icon)) {
	            var iconSpan = Dom_1.$$('span').el;
	            Dom_1.$$(iconSpan).addClass(['coveo-icon', icon]);
	            this.element.insertBefore(iconSpan, this.element.firstChild);
	        }
	        var caption = this.options.caption;
	        if (Utils_1.Utils.isNonEmptyString(caption)) {
	            var captionP = document.createElement('p');
	            Dom_1.$$(captionP).text(caption);
	            this.element.appendChild(captionP);
	        }
	        this.element.setAttribute('tabindex', '0');
	    };
	    Tab.prototype.handleBuildingQuery = function (data) {
	        Assert_1.Assert.exists(data);
	        this.isFirstQuery = false;
	        if (!this.disabled && this.isSelected()) {
	            data.queryBuilder.tab = this.options.id;
	            if (Utils_1.Utils.isNonEmptyString(this.options.expression)) {
	                if (this.options.constant) {
	                    data.queryBuilder.constantExpression.add(this.options.expression);
	                }
	                else {
	                    data.queryBuilder.advancedExpression.add(this.options.expression);
	                }
	            }
	            if (this.options.enableDuplicateFiltering) {
	                data.queryBuilder.enableDuplicateFiltering = true;
	            }
	            if (this.options.pipeline != null) {
	                data.queryBuilder.pipeline = this.options.pipeline;
	            }
	            if (this.options.maximumAge != null) {
	                data.queryBuilder.maximumAge = this.options.maximumAge;
	            }
	        }
	    };
	    Tab.prototype.handleQueryStateChanged = function (data) {
	        Assert_1.Assert.exists(data);
	        if (!this.disabled && this.isSelected()) {
	            Dom_1.$$(this.element).addClass('coveo-selected');
	            this.queryController.setEndpoint(this.options.endpoint);
	            this.showAndHideAppropriateElements();
	        }
	        else {
	            Dom_1.$$(this.element).removeClass('coveo-selected');
	        }
	    };
	    Tab.prototype.isSelected = function () {
	        var activeTab = this.queryStateModel.get(QueryStateModel_1.QueryStateModel.attributesEnum.t);
	        return activeTab == this.options.id;
	    };
	    Tab.prototype.showAndHideAppropriateElements = function () {
	        var _this = this;
	        var showElements = [];
	        var hideElements = [];
	        _.each(Dom_1.$$(this.root).findAll('[data-tab],[data-tab-not]'), function (element) {
	            if (_this.isElementIncludedInTab(element)) {
	                _this.toggleAllComponentsUnder(element, true);
	                showElements.push(element);
	            }
	            else {
	                _this.toggleAllComponentsUnder(element, false);
	                hideElements.push(element);
	            }
	        });
	        Dom_1.$$(this.root).one(QueryEvents_1.QueryEvents.querySuccess, function () {
	            _.each(showElements, function (elem) { return Dom_1.$$(elem).removeClass('coveo-tab-disabled'); });
	            _.each(hideElements, function (elem) { return Dom_1.$$(elem).addClass('coveo-tab-disabled'); });
	        });
	    };
	    Tab.prototype.splitListOfTabs = function (value) {
	        if (Utils_1.Utils.exists(value)) {
	            return _.map(value.split(','), function (tab) { return Utils_1.Utils.trim(tab); });
	        }
	        else {
	            return [];
	        }
	    };
	    Tab.prototype.toggleAllComponentsUnder = function (element, enable) {
	        Assert_1.Assert.exists(element);
	        var togglePossibleComponent = function (possibleComponent) {
	            var possibleCmp = Component_1.Component.get(possibleComponent, undefined, true);
	            if (possibleCmp) {
	                if (enable) {
	                    possibleCmp.enable();
	                }
	                else {
	                    possibleCmp.disable();
	                }
	            }
	        };
	        togglePossibleComponent(element);
	        _.each(Dom_1.$$(element).findAll('*'), function (el) {
	            togglePossibleComponent(el);
	        });
	    };
	    Tab.prototype.enable = function () {
	        _super.prototype.enable.call(this);
	        this.element.style.display = '';
	    };
	    Tab.prototype.disable = function () {
	        _super.prototype.disable.call(this);
	        this.element.style.display = 'none';
	    };
	    Tab.ID = 'Tab';
	    /**
	     * The options for a Tab
	     * @componentOptions
	     */
	    Tab.options = {
	        /**
	         * The unique ID for a tab.<br/>
	         * This is mandatory and required for the tab to function properly.
	         */
	        id: ComponentOptions_1.ComponentOptions.buildStringOption({ required: true }),
	        /**
	         * The caption for the tab.<br/>
	         * This is mandatory and required for the tab to function properly.
	         */
	        caption: ComponentOptions_1.ComponentOptions.buildLocalizedStringOption({ required: true }),
	        /**
	         * Specify an icon for the tab.<br/>
	         * This options is mostly kept for legacy reason. Do not use one if not needed.
	         */
	        icon: ComponentOptions_1.ComponentOptions.buildIconOption(),
	        /**
	         * Specifies an advanced expression / filter that this tab adds to any outgoing query.<br/>
	         * eg : @objecttype==Message.<br/>
	         * This is optional, normally a "All Content" tab would not set any filter on the query.
	         */
	        expression: ComponentOptions_1.ComponentOptions.buildStringOption(),
	        /**
	         * Specifies the endpoint that a tab should point to when performing query inside that tab.<br/>
	         * This is optional, by default the tab will use the "default" endpoint.
	         */
	        endpoint: ComponentOptions_1.ComponentOptions.buildCustomOption(function (endpoint) { return endpoint != null ? SearchEndpoint_1.SearchEndpoint.endpoints[endpoint] : null; }),
	        /**
	         * Specifies the default sort when this tab is selected. A {@link Sort} component configured with the same specified parameter needs to be in the interface in order for this this option to function properly.<br/>
	         * e.g.: relevancy / date descending<br/>
	         * Optional, by default the normal {@link Sort} component behavior will operate.
	         */
	        sort: ComponentOptions_1.ComponentOptions.buildStringOption(),
	        /**
	         * Specifies whether the filter expression should be included in the constant part of the query.<br/>
	         * The constant part of the query is specially optimized by the index to execute faster, but you must be careful not to include dynamic query expressions otherwise the cache would lose its efficiency.<br/>
	         * By default, this option is set to `true`.
	         */
	        constant: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true }),
	        /**
	         * Specifies whether to filter duplicates on the search results.<br/>
	         * The default value is false.
	         */
	        enableDuplicateFiltering: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: false }),
	        /**
	         * Specifies the name of the query pipeline to use for the queries, in the Coveo platform ( Query Pipeline in the Cloud administration).<br/>
	         * If not specified, the default value is null, in which case pipeline selection conditions defined in a Coveo Cloud organization apply.
	         */
	        pipeline: ComponentOptions_1.ComponentOptions.buildStringOption(),
	        /**
	         * Specifies the maximum age in milliseconds that cached query results can have in order to be used (instead of performing a new query on the index).<br/>
	         * The cache is located in the Coveo Search API (which resides between the index and search interface).<br/>
	         * If cached results are available but are older than the specified age, a new query will be performed on the index.<br/>
	         * By default, this is left undefined and the Coveo Search API will decide the cache duration.
	         */
	        maximumAge: ComponentOptions_1.ComponentOptions.buildNumberOption(),
	        /**
	         * Specifies if the responsive mode should be enabled for the tabs. Responsive mode will make the overflowing tabs dissapear and instead
	         * be availaible using a dropdown button. Responsive tabs are enabled when tabs overflow or when the width of the search interface
	         * becomes too small.
	         *
	         * Disabling reponsive mode for one tab will disable it for all tabs.
	         * Therefore, this options only needs to be set on one tab to be effective.
	         * The default value is `true`.
	         */
	        enableResponsiveMode: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true })
	    };
	    return Tab;
	}(Component_1.Component));
	exports.Tab = Tab;
	Initialization_1.Initialization.registerAutoCreateComponent(Tab);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var Dom_1 = __webpack_require__(57);
	var InitializationEvents_1 = __webpack_require__(44);
	var PopupUtils_1 = __webpack_require__(71);
	var EventsUtils_1 = __webpack_require__(144);
	var Utils_1 = __webpack_require__(18);
	var Logger_1 = __webpack_require__(16);
	var Component_1 = __webpack_require__(96);
	var SearchInterface_1 = __webpack_require__(97);
	var Tab_1 = __webpack_require__(161);
	var ResponsiveComponentsManager_1 = __webpack_require__(160);
	var ResponsiveComponentsUtils_1 = __webpack_require__(148);
	var Strings_1 = __webpack_require__(34);
	var ResponsiveTabs = (function () {
	    function ResponsiveTabs(root, ID) {
	        this.ID = ID;
	        this.coveoRoot = root;
	        this.searchInterface = Component_1.Component.get(root.el, SearchInterface_1.SearchInterface, false);
	        this.searchBoxElement = this.getSearchBoxElement();
	        this.dropdownContent = this.buildDropdownContent();
	        this.dropdownHeader = this.buildDropdownHeader();
	        this.bindDropdownContentEvents();
	        this.bindDropdownHeaderEvents();
	        this.tabSection = Dom_1.$$(this.coveoRoot.find('.coveo-tab-section'));
	        this.manageTabSwapping();
	        this.saveTabsPosition();
	        this.bindNukeEvents();
	    }
	    ResponsiveTabs.init = function (root, component, options) {
	        this.logger = new Logger_1.Logger('ResponsiveTabs');
	        if (!Dom_1.$$(root).find('.coveo-tab-section')) {
	            this.logger.info('No element with class coveo-tab-section. Responsive tabs cannot be enabled.');
	            return;
	        }
	        ResponsiveComponentsManager_1.ResponsiveComponentsManager.register(ResponsiveTabs, Dom_1.$$(root), Tab_1.Tab.ID, component, options);
	    };
	    ResponsiveTabs.prototype.handleResizeEvent = function () {
	        if (this.needSmallMode() && !ResponsiveComponentsUtils_1.ResponsiveComponentsUtils.isSmallTabsActivated(this.coveoRoot)) {
	            this.changeToSmallMode();
	        }
	        else if (!this.needSmallMode() && ResponsiveComponentsUtils_1.ResponsiveComponentsUtils.isSmallTabsActivated(this.coveoRoot)) {
	            this.changeToLargeMode();
	        }
	        var tabs = this.getTabsInTabSection();
	        if (this.shouldAddTabsToDropdown()) {
	            this.addTabsToDropdown(tabs);
	        }
	        else if (this.shouldRemoveTabsFromDropdown()) {
	            this.removeTabsFromDropdown(tabs);
	        }
	        if (this.dropdownHeader.hasClass('coveo-dropdown-header-active')) {
	            this.positionPopup();
	        }
	    };
	    ;
	    ResponsiveTabs.prototype.needSmallMode = function () {
	        if (this.coveoRoot.width() <= ResponsiveComponentsUtils_1.ResponsiveComponentsUtils.MEDIUM_MOBILE_WIDTH) {
	            return true;
	        }
	        else if (!ResponsiveComponentsUtils_1.ResponsiveComponentsUtils.isSmallTabsActivated(this.coveoRoot)) {
	            return this.isOverflowing(this.tabSection.el);
	        }
	        else {
	            return this.isLargeFormatOverflowing();
	        }
	    };
	    ResponsiveTabs.prototype.changeToSmallMode = function () {
	        ResponsiveComponentsUtils_1.ResponsiveComponentsUtils.activateSmallTabs(this.coveoRoot);
	    };
	    ResponsiveTabs.prototype.changeToLargeMode = function () {
	        this.emptyDropdown();
	        this.cleanUpDropdown();
	        ResponsiveComponentsUtils_1.ResponsiveComponentsUtils.deactivateSmallTabs(this.coveoRoot);
	    };
	    ResponsiveTabs.prototype.shouldAddTabsToDropdown = function () {
	        return this.isOverflowing(this.tabSection.el) && ResponsiveComponentsUtils_1.ResponsiveComponentsUtils.isSmallTabsActivated(this.coveoRoot);
	    };
	    ResponsiveTabs.prototype.addTabsToDropdown = function (tabs) {
	        var currentTab;
	        if (!this.tabSection.find('.coveo-tab-dropdown-header')) {
	            var facetDropdownHeader = this.tabSection.find('.coveo-facet-dropdown-header');
	            if (facetDropdownHeader) {
	                this.dropdownHeader.insertBefore(facetDropdownHeader);
	            }
	            else {
	                this.tabSection.el.appendChild(this.dropdownHeader.el);
	            }
	        }
	        for (var i = tabs.length - 1; i >= 0; i--) {
	            currentTab = tabs[i];
	            if (Dom_1.$$(currentTab).hasClass('coveo-selected') && i > 0) {
	                currentTab = tabs[--i];
	            }
	            this.addToDropdown(currentTab);
	            if (!this.isOverflowing(this.tabSection.el)) {
	                break;
	            }
	        }
	    };
	    ResponsiveTabs.prototype.shouldRemoveTabsFromDropdown = function () {
	        return !this.isOverflowing(this.tabSection.el) && ResponsiveComponentsUtils_1.ResponsiveComponentsUtils.isSmallTabsActivated(this.coveoRoot) && !this.isDropdownEmpty();
	    };
	    ResponsiveTabs.prototype.removeTabsFromDropdown = function (tabs) {
	        var dropdownTabs = this.dropdownContent.findAll('.coveo-tab-dropdown');
	        var lastTabInSection, current;
	        if (tabs) {
	            lastTabInSection = tabs.pop();
	        }
	        while (!this.isOverflowing(this.tabSection.el) && !this.isDropdownEmpty()) {
	            current = dropdownTabs.shift();
	            this.removeFromDropdown(current);
	            this.fromDropdownToTabSection(Dom_1.$$(current), lastTabInSection);
	            lastTabInSection = _.clone(current);
	        }
	        if (this.isOverflowing(this.tabSection.el)) {
	            var tabs_1 = this.getTabsInTabSection();
	            this.addToDropdown(tabs_1.pop());
	        }
	        if (this.isDropdownEmpty()) {
	            this.cleanUpDropdown();
	        }
	    };
	    ResponsiveTabs.prototype.emptyDropdown = function () {
	        if (!this.isDropdownEmpty()) {
	            var dropdownTabs = this.dropdownContent.findAll('.coveo-tab-dropdown');
	            var tabs = this.getTabsInTabSection();
	            var lastTabInSection = void 0;
	            if (tabs) {
	                lastTabInSection = tabs.pop();
	            }
	            while (!this.isDropdownEmpty()) {
	                var current = dropdownTabs.shift();
	                this.removeFromDropdown(current);
	                Dom_1.$$(current).insertBefore(this.dropdownHeader.el);
	                this.fromDropdownToTabSection(Dom_1.$$(current), lastTabInSection);
	                lastTabInSection = _.clone(current);
	            }
	        }
	    };
	    ResponsiveTabs.prototype.isLargeFormatOverflowing = function () {
	        var virtualTabSection = Dom_1.$$(this.tabSection.el.cloneNode(true));
	        var dropdownHeader = virtualTabSection.find('.coveo-tab-dropdown-header');
	        if (dropdownHeader) {
	            virtualTabSection.el.removeChild(dropdownHeader);
	        }
	        virtualTabSection.el.style.position = 'absolute';
	        virtualTabSection.el.style.visibility = 'hidden';
	        if (!this.isDropdownEmpty()) {
	            _.each(this.dropdownContent.findAll('.CoveoTab'), function (tab) {
	                virtualTabSection.el.appendChild(tab.cloneNode(true));
	            });
	        }
	        this.coveoRoot.append(virtualTabSection.el);
	        ResponsiveComponentsUtils_1.ResponsiveComponentsUtils.deactivateSmallTabs(this.coveoRoot);
	        var isOverflowing = this.isOverflowing(virtualTabSection.el);
	        ResponsiveComponentsUtils_1.ResponsiveComponentsUtils.activateSmallTabs(this.coveoRoot);
	        virtualTabSection.detach();
	        return isOverflowing;
	    };
	    ResponsiveTabs.prototype.isOverflowing = function (el) {
	        return el.clientWidth < el.scrollWidth;
	    };
	    ResponsiveTabs.prototype.buildDropdownHeader = function () {
	        var dropdownHeader = Dom_1.$$('a', { className: 'coveo-dropdown-header coveo-tab-dropdown-header' });
	        var content = Dom_1.$$('p');
	        content.text(Strings_1.l('More'));
	        content.el.appendChild(Dom_1.$$('span', { className: 'coveo-sprites-more-tabs' }).el);
	        dropdownHeader.el.appendChild(content.el);
	        return dropdownHeader;
	    };
	    ResponsiveTabs.prototype.bindDropdownHeaderEvents = function () {
	        var _this = this;
	        this.dropdownHeader.on('click', function () {
	            if (!_this.dropdownHeader.hasClass('coveo-dropdown-header-active')) {
	                _this.positionPopup();
	                _this.dropdownHeader.addClass('coveo-dropdown-header-active');
	            }
	            else {
	                _this.closeDropdown();
	            }
	        });
	    };
	    ResponsiveTabs.prototype.buildDropdownContent = function () {
	        var dropdownContent = Dom_1.$$('div', { className: 'coveo-tab-list-container ' + SearchInterface_1.SearchInterface.SMALL_INTERFACE_CLASS_NAME });
	        var contentList = Dom_1.$$('ol', { className: 'coveo-tab-list' });
	        dropdownContent.el.appendChild(contentList.el);
	        return dropdownContent;
	    };
	    ResponsiveTabs.prototype.bindDropdownContentEvents = function () {
	        var _this = this;
	        this.documentClickListener = function (event) {
	            if (Utils_1.Utils.isHtmlElement(event.target)) {
	                var eventTarget = Dom_1.$$(event.target);
	                if (!eventTarget.closest('coveo-tab-list-container') && !eventTarget.closest('coveo-tab-dropdown-header') && !eventTarget.closest('coveo-tab-dropdown')) {
	                    _this.closeDropdown();
	                }
	            }
	        };
	        Dom_1.$$(document.documentElement).on('click', this.documentClickListener);
	    };
	    ResponsiveTabs.prototype.closeDropdown = function () {
	        this.dropdownContent.detach();
	        this.dropdownHeader.removeClass('coveo-dropdown-header-active');
	    };
	    ResponsiveTabs.prototype.addToDropdown = function (el) {
	        if (this.dropdownContent) {
	            Dom_1.$$(el).addClass('coveo-tab-dropdown');
	            var list = this.dropdownContent.find('ol');
	            var listElement = Dom_1.$$('li');
	            listElement.el.appendChild(el);
	            Dom_1.$$(list).prepend(listElement.el);
	        }
	    };
	    ResponsiveTabs.prototype.removeFromDropdown = function (el) {
	        if (this.dropdownContent) {
	            Dom_1.$$(el).removeClass('coveo-tab-dropdown');
	            Dom_1.$$(el.parentElement).detach();
	        }
	    };
	    ResponsiveTabs.prototype.cleanUpDropdown = function () {
	        this.dropdownHeader.removeClass('coveo-dropdown-header-active');
	        this.dropdownHeader.detach();
	        this.dropdownContent.detach();
	    };
	    ResponsiveTabs.prototype.isDropdownEmpty = function () {
	        if (this.dropdownContent) {
	            var tabs = this.dropdownContent.findAll('.CoveoTab');
	            return tabs.length == 0;
	        }
	        return false;
	    };
	    ResponsiveTabs.prototype.manageTabSwapping = function () {
	        var _this = this;
	        _.each(this.coveoRoot.findAll('.' + Component_1.Component.computeCssClassNameForType(this.ID)), function (tabElement) {
	            var tab = Dom_1.$$(tabElement);
	            var fadeOutFadeIn = function (event) {
	                var tabsInSection = _this.getTabsInTabSection();
	                var lastTabInSection = tabsInSection.pop();
	                var lastTabSectionSibling = lastTabInSection.previousSibling;
	                if (event.propertyName == 'opacity') {
	                    if (tab.el.style.opacity == '0') {
	                        Dom_1.$$(lastTabInSection).addClass('coveo-tab-dropdown');
	                        tab.replaceWith(lastTabInSection);
	                        tab.removeClass('coveo-tab-dropdown');
	                        _this.fromDropdownToTabSection(tab, lastTabSectionSibling);
	                        // Because of the DOM manipulation, sometimes the animation will not trigger. Accessing the computed styles makes sure
	                        // the animation will happen.
	                        window.getComputedStyle(tab.el).opacity;
	                        window.getComputedStyle(lastTabInSection).opacity;
	                        tab.el.style.opacity = lastTabInSection.style.opacity = '1';
	                    }
	                    else if (tab.el.style.opacity == '1') {
	                        _this.closeDropdown();
	                        EventsUtils_1.EventsUtils.removePrefixedEvent(tab.el, 'TransitionEnd', fadeOutFadeIn);
	                        _this.handleResizeEvent();
	                    }
	                }
	            };
	            tab.on('click', function () {
	                if (tab.hasClass('coveo-tab-dropdown')) {
	                    var tabsInSection = _this.getTabsInTabSection();
	                    var lastTabInSection = tabsInSection.pop();
	                    if (lastTabInSection) {
	                        EventsUtils_1.EventsUtils.addPrefixedEvent(tab.el, 'TransitionEnd', fadeOutFadeIn);
	                        tab.el.style.opacity = lastTabInSection.style.opacity = '0';
	                    }
	                }
	            });
	        });
	    };
	    ResponsiveTabs.prototype.getSearchBoxElement = function () {
	        var searchBoxElement = this.coveoRoot.find('.coveo-search-section');
	        if (searchBoxElement) {
	            return searchBoxElement;
	        }
	        else {
	            return this.coveoRoot.find('.CoveoSearchbox');
	        }
	    };
	    ResponsiveTabs.prototype.saveTabsPosition = function () {
	        this.previousSibling = this.tabSection.el.previousSibling ? Dom_1.$$(this.tabSection.el.previousSibling) : null;
	        this.parent = Dom_1.$$(this.tabSection.el.parentElement);
	    };
	    ResponsiveTabs.prototype.bindNukeEvents = function () {
	        var _this = this;
	        Dom_1.$$(this.coveoRoot).on(InitializationEvents_1.InitializationEvents.nuke, function () {
	            Dom_1.$$(document.documentElement).off('click', _this.documentClickListener);
	        });
	    };
	    ResponsiveTabs.prototype.positionPopup = function () {
	        PopupUtils_1.PopupUtils.positionPopup(this.dropdownContent.el, this.dropdownHeader.el, this.coveoRoot.el, { horizontal: PopupUtils_1.HorizontalAlignment.INNERLEFT, vertical: PopupUtils_1.VerticalAlignment.BOTTOM }, this.coveoRoot.el);
	    };
	    ResponsiveTabs.prototype.getTabsInTabSection = function () {
	        var _this = this;
	        var tabsInSection = [];
	        _.each(this.tabSection.el.children, function (childElement) {
	            if (Utils_1.Utils.isHtmlElement(childElement)) {
	                var child = Dom_1.$$(childElement);
	                if (!child.hasClass('coveo-tab-dropdown') && child.hasClass(Component_1.Component.computeCssClassNameForType(_this.ID))) {
	                    tabsInSection.push(child.el);
	                }
	            }
	        });
	        return tabsInSection;
	    };
	    ResponsiveTabs.prototype.fromDropdownToTabSection = function (tab, lastTabInTabSection) {
	        if (lastTabInTabSection) {
	            tab.insertAfter(lastTabInTabSection);
	        }
	        else {
	            this.tabSection.prepend(tab.el);
	        }
	    };
	    return ResponsiveTabs;
	}());
	exports.ResponsiveTabs = ResponsiveTabs;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {/// <reference path="../Facet/FacetHeader.ts" />
	/// <reference path="../../controllers/FacetSliderQueryController.ts" />
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Slider_1 = __webpack_require__(164);
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var ResponsiveFacets_1 = __webpack_require__(159);
	var FacetHeader_1 = __webpack_require__(153);
	var Strings_1 = __webpack_require__(34);
	var InitializationEvents_1 = __webpack_require__(44);
	var FeatureDetectionUtils_1 = __webpack_require__(64);
	var FacetSliderQueryController_1 = __webpack_require__(84);
	var QueryEvents_1 = __webpack_require__(47);
	var BreadcrumbEvents_1 = __webpack_require__(41);
	var Model_1 = __webpack_require__(87);
	var Dom_1 = __webpack_require__(57);
	var AnalyticsActionListMeta_1 = __webpack_require__(110);
	var QueryStateModel_1 = __webpack_require__(90);
	var SliderEvents_1 = __webpack_require__(51);
	var Assert_1 = __webpack_require__(17);
	var Utils_1 = __webpack_require__(18);
	var ResponsiveComponentsUtils_1 = __webpack_require__(148);
	var Initialization_1 = __webpack_require__(95);
	var d3 = __webpack_require__(173);
	var SearchAlertEvents_1 = __webpack_require__(49);
	/**
	 * The FacetSlider component allows to create a facet that renders a slider widget to filter on a range of numerical values
	 * rather than the classic multi-select facet with a label and a count for each values.<br/>
	 * Note that this component does *NOT* inherit from a standard {@link Facet}, and thus does not offer all the same options.
	 * Also note that many options for the slider component cannot be set as an HTML attribute on the component, and must be configured in JavaScript.
	 *
	 * ## A generic example on how to initialize a complex slider
	 * ```
	 * // Using a JSON object inside the init call. Note that the JSON object follows the options described in this page.
	 * Coveo.init(document.querySelector('#search'), {
	 *    FacetSlider: {
	 *      field: "@size",
	 *      start: 1000,
	 *      end: 5000,
	 *      rangeSlider: true,
	 *      graph: {
	 *        steps: 10
	 *      }
	 *    }
	 * })
	 *
	 * // OR using the jquery extension
	 *
	 * $('#search').coveo('init', {
	 *    FacetSlider: {
	 *      field: "@size",
	 *      start: 1000,
	 *      end: 5000,
	 *      rangeSlider: true,
	 *      graph: {
	 *        steps: 10
	 *      }
	 *    }
	 * })
	 *
	 * // Same configuration, but using attribute directly on the element instead
	 * <div class='CoveoFacetSlider' data-field='@syssize' data-start='1000' data-end='5000' data-range-slider='true' data-graph-steps='10'></div>
	 * ```
	 */
	var FacetSlider = (function (_super) {
	    __extends(FacetSlider, _super);
	    function FacetSlider(element, options, bindings) {
	        var _this = this;
	        _super.call(this, element, FacetSlider.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.isEmpty = false;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, FacetSlider, options);
	        ResponsiveFacets_1.ResponsiveFacets.init(this.root, this, this.options);
	        if (this.options.excludeOuterBounds == null) {
	            this.options.excludeOuterBounds = false;
	        }
	        if (this.options.start) {
	            this.options.start = this.options.dateField ? new Date(this.options.start.replace(/-/g, '/')).getTime() : Number(this.options.start);
	        }
	        if (this.options.end) {
	            this.options.end = this.options.dateField ? new Date(this.options.end.replace(/-/g, '/')).getTime() : Number(this.options.end);
	        }
	        if (this.hasAGraph()) {
	            if (!FeatureDetectionUtils_1.FeatureDetectionUtils.supportSVG()) {
	                this.options.graph = undefined;
	                this.logger.info('Your browser does not support SVG. Cannot add graphic to your facet range', this);
	            }
	            if (typeof d3 == 'undefined') {
	                this.options.graph = undefined;
	                this.logger.info('Cannot find the required dependencies d3.js. Cannot add graphic to your facet range', this);
	            }
	        }
	        this.facetQueryController = new FacetSliderQueryController_1.FacetSliderQueryController(this);
	        this.initQueryStateEvents();
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.newQuery, function () { return _this.handleNewQuery(); });
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.noResults, function () { return _this.handleNoresults(); });
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.deferredQuerySuccess, function (args) { return _this.handleDeferredQuerySuccess(args); });
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.buildingQuery, function (args) { return _this.handleBuildingQuery(args); });
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.doneBuildingQuery, function (args) { return _this.handleDoneBuildingQuery(args); });
	        this.bind.onRootElement(BreadcrumbEvents_1.BreadcrumbEvents.populateBreadcrumb, function (args) { return _this.handlePopulateBreadcrumb(args); });
	        this.bind.onRootElement(SearchAlertEvents_1.SearchAlertsEvents.searchAlertsPopulateMessage, function (args) { return _this.handlePopulateSearchAlerts(args); });
	        this.bind.onRootElement(BreadcrumbEvents_1.BreadcrumbEvents.clearBreadcrumb, function () { return _this.reset(); });
	        this.onResize = _.debounce(function () {
	            if (!ResponsiveComponentsUtils_1.ResponsiveComponentsUtils.isSmallFacetActivated(Dom_1.$$(_this.root)) && _this.slider) {
	                _this.slider.drawGraph();
	            }
	        }, 250);
	        window.addEventListener('resize', this.onResize);
	        Dom_1.$$(this.root).on(InitializationEvents_1.InitializationEvents.nuke, this.handleNuke);
	    }
	    FacetSlider.prototype.createDom = function () {
	        this.facetHeader = new FacetHeader_1.FacetHeader({
	            field: this.options.field,
	            facetElement: this.element,
	            title: this.options.title,
	            enableClearElement: true,
	            enableCollapseElement: true,
	            isNewDesign: this.getBindings().searchInterface.isNewDesign(),
	            facetSlider: this
	        });
	        this.element.appendChild(this.facetHeader.build());
	    };
	    /**
	     * Reset the facet (meaning that you need to set the range value as inactive).
	     */
	    FacetSlider.prototype.reset = function () {
	        if (this.slider) {
	            this.slider.initializeState();
	            this.updateQueryState();
	            this.updateAppearanceDependingOnState();
	        }
	    };
	    /**
	     * Return the current selection in the facet, as an array of number (e.g.: [start, end] ).<br/>
	     * If it is not available, return [undefined, undefined]
	     * @returns {any}
	     */
	    FacetSlider.prototype.getSelectedValues = function () {
	        if (this.startOfSlider != undefined && this.endOfSlider != undefined) {
	            return [this.startOfSlider, this.endOfSlider];
	        }
	        else {
	            return [undefined, undefined];
	        }
	    };
	    /**
	     * Set the selected values in the slider.
	     * @param values [start, end]
	     */
	    FacetSlider.prototype.setSelectedValues = function (values) {
	        this.setupSliderIfNeeded(undefined);
	        this.startOfSlider = values[0];
	        this.endOfSlider = values[1];
	        this.slider.setValues([this.startOfSlider, this.endOfSlider]);
	        this.updateAppearanceDependingOnState();
	    };
	    /**
	     * Return true if the slider is "active" (will output an expression in the query when a search is performed).
	     * @returns {boolean}
	     */
	    FacetSlider.prototype.isActive = function () {
	        return !isNaN(this.startOfSlider)
	            && !isNaN(this.endOfSlider)
	            && !isNaN(this.initialStartOfSlider)
	            && !isNaN(this.initialEndOfSlider)
	            && (this.startOfSlider != this.initialStartOfSlider || this.endOfSlider != this.initialEndOfSlider);
	    };
	    FacetSlider.prototype.getSliderBoundaryForQuery = function () {
	        var needToReturnABoundary = false;
	        if (!this.slider) {
	            needToReturnABoundary = true;
	        }
	        else if (this.slider && this.isActive()) {
	            needToReturnABoundary = true;
	        }
	        if (needToReturnABoundary) {
	            return this.generateBoundary();
	        }
	        else {
	            return undefined;
	        }
	    };
	    // There is delayed graph data if at the time the facet slider tried to draw the facet was hidden in the
	    // facet dropdown. This method will draw delayed graph data if it exists.
	    FacetSlider.prototype.drawDelayedGraphData = function () {
	        if (this.delayedGraphData != undefined) {
	            this.slider.drawGraph(this.delayedGraphData);
	        }
	    };
	    FacetSlider.prototype.handleNoresults = function () {
	        this.isEmpty = true;
	        this.updateAppearanceDependingOnState();
	    };
	    FacetSlider.prototype.handleNewQuery = function () {
	        this.isEmpty = false;
	    };
	    FacetSlider.prototype.handleRangeQueryStateChanged = function (args) {
	        this.setupSliderIfNeeded(args);
	        this.startOfSlider = args.value[0] == undefined ? this.startOfSlider : args.value[0];
	        this.endOfSlider = args.value[1] == undefined ? this.endOfSlider : args.value[1];
	        this.setSelectedValues([this.startOfSlider, this.endOfSlider]);
	    };
	    FacetSlider.prototype.handlePopulateBreadcrumb = function (args) {
	        var _this = this;
	        var populateBreadcrumb = function () {
	            if (_this.isActive()) {
	                args.breadcrumbs.push({
	                    element: _this.buildBreadcrumbFacetSlider()
	                });
	            }
	        };
	        if (this.slider) {
	            populateBreadcrumb();
	        }
	        else {
	            Dom_1.$$(this.root).one(QueryEvents_1.QueryEvents.deferredQuerySuccess, function () {
	                populateBreadcrumb();
	                Dom_1.$$(_this.root).trigger(BreadcrumbEvents_1.BreadcrumbEvents.redrawBreadcrumb);
	            });
	        }
	    };
	    FacetSlider.prototype.handlePopulateSearchAlerts = function (args) {
	        if (this.isActive()) {
	            args.text.push(Dom_1.$$(this.buildBreadcrumbFacetSlider()).text());
	        }
	    };
	    FacetSlider.prototype.buildBreadcrumbFacetSlider = function () {
	        var _this = this;
	        var elem = Dom_1.$$('div', {
	            className: 'coveo-facet-slider-breadcrumb'
	        }).el;
	        var title = Dom_1.$$('span', {
	            className: 'coveo-facet-slider-breadcrumb-title'
	        });
	        title.text(this.options.title + ': ');
	        elem.appendChild(title.el);
	        var values = Dom_1.$$('span', {
	            className: 'coveo-facet-slider-breadcrumb-values'
	        });
	        elem.appendChild(values.el);
	        var value = Dom_1.$$('span', {
	            className: 'coveo-facet-slider-breadcrumb-value'
	        });
	        value.text(this.slider.getCaption());
	        values.el.appendChild(value.el);
	        var clear = Dom_1.$$('span', {
	            className: 'coveo-facet-slider-breadcrumb-clear'
	        });
	        value.el.appendChild(clear.el);
	        value.on('click', function () {
	            _this.reset();
	            _this.usageAnalytics.logSearchEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.facetClearAll, {
	                facetId: _this.options.id,
	                facetTitle: _this.options.title
	            });
	            _this.queryController.executeQuery();
	        });
	        return elem;
	    };
	    FacetSlider.prototype.initSlider = function () {
	        this.buildSlider();
	        this.slider.initializeState([this.startOfSlider, this.endOfSlider]);
	        this.updateAppearanceDependingOnState();
	    };
	    FacetSlider.prototype.initQueryStateEvents = function () {
	        var _this = this;
	        this.rangeQueryStateAttribute = QueryStateModel_1.QueryStateModel.getFacetId(this.options.id) + ':range';
	        this.queryStateModel.registerNewAttribute(this.rangeQueryStateAttribute, [undefined, undefined]);
	        var eventName = this.queryStateModel.getEventName(Model_1.Model.eventTypes.changeOne + this.rangeQueryStateAttribute);
	        this.bind.onRootElement(eventName, function (args) {
	            _this.slider ? _this.handleRangeQueryStateChanged(args) : _this.setRangeStateSliderStillNotCreated(args);
	        });
	    };
	    FacetSlider.prototype.setRangeStateSliderStillNotCreated = function (args) {
	        this.rangeFromUrlState = this.copyValues(args.value);
	    };
	    FacetSlider.prototype.buildSlider = function () {
	        var _this = this;
	        var sliderContainer = Dom_1.$$('div', {
	            className: 'coveo-facet-values coveo-slider-container'
	        }).el;
	        if (this.hasAGraph()) {
	            Dom_1.$$(sliderContainer).addClass('coveo-with-graph');
	        }
	        var sliderDiv = Dom_1.$$('div').el;
	        this.slider = new Slider_1.Slider(sliderDiv, _.extend({}, this.options, { dateField: this.options.dateField }), this.root);
	        Dom_1.$$(sliderDiv).on(SliderEvents_1.SliderEvents.endSlide, function (e, args) {
	            _this.handleEndSlide(args);
	        });
	        Dom_1.$$(sliderDiv).on(SliderEvents_1.SliderEvents.duringSlide, function (e, args) {
	            _this.handleDuringSlide(args);
	        });
	        if (this.hasAGraph()) {
	            Dom_1.$$(sliderDiv).on(SliderEvents_1.SliderEvents.graphValueSelected, function (e, args) {
	                _this.handleGraphValueSelected(args);
	            });
	        }
	        sliderContainer.appendChild(sliderDiv);
	        this.element.appendChild(sliderContainer);
	        this.updateAppearanceDependingOnState();
	    };
	    FacetSlider.prototype.handleBuildingQuery = function (data) {
	        Assert_1.Assert.exists(data);
	        Assert_1.Assert.exists(data.queryBuilder);
	        var boundary = this.getSliderBoundaryForQuery();
	        if (boundary != undefined) {
	            this.facetQueryController.prepareForNewQuery();
	            var expression = this.facetQueryController.computeOurFilterExpression(boundary);
	            if (Utils_1.Utils.isNonEmptyString(expression)) {
	                this.logger.trace('Putting filter in query', expression);
	                data.queryBuilder.advancedExpression.add(expression);
	            }
	        }
	    };
	    FacetSlider.prototype.handleDoneBuildingQuery = function (data) {
	        var queryBuilder = data.queryBuilder;
	        this.facetQueryController.putGroupByIntoQueryBuilder(queryBuilder);
	    };
	    FacetSlider.prototype.handleDeferredQuerySuccess = function (data) {
	        this.ensureDom();
	        this.setupSliderIfNeeded(data);
	        var groupByResults = data.results.groupByResults[this.facetQueryController.lastGroupByRequestIndex];
	        if (groupByResults == undefined || groupByResults.values[0] == undefined) {
	            this.isEmpty = true;
	        }
	        this.updateAppearanceDependingOnState();
	        if (this.hasAGraph()) {
	            this.renderToSliderGraph(data);
	        }
	    };
	    FacetSlider.prototype.handleEndSlide = function (args) {
	        var values = args.slider.getValues();
	        this.startOfSlider = values[0];
	        this.endOfSlider = values[1];
	        if (this.updateQueryState(values)) {
	            this.updateAppearanceDependingOnState();
	            this.usageAnalytics.logSearchEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.facetRangeSlider, {
	                facetId: this.options.id,
	                facetRangeStart: this.startOfSlider.toString(),
	                facetRangeEnd: this.endOfSlider.toString()
	            });
	            this.queryController.executeQuery();
	        }
	    };
	    FacetSlider.prototype.handleDuringSlide = function (args) {
	        var values = args.slider.getValues();
	        this.startOfSlider = values[0];
	        this.endOfSlider = values[1];
	        this.slider.setValues([this.startOfSlider, this.endOfSlider]);
	        this.updateAppearanceDependingOnState(true);
	    };
	    FacetSlider.prototype.handleGraphValueSelected = function (args) {
	        if ((this.options.rangeSlider && this.startOfSlider != args.start) || this.endOfSlider != args.end) {
	            if (this.options.rangeSlider) {
	                this.startOfSlider = args.start;
	            }
	            this.endOfSlider = args.end;
	            this.slider.setValues([this.startOfSlider, this.endOfSlider]);
	            this.updateQueryState();
	            this.usageAnalytics.logSearchEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.facetRangeGraph, {
	                facetId: this.options.id,
	                facetRangeStart: this.startOfSlider.toString(),
	                facetRangeEnd: this.endOfSlider.toString()
	            });
	            this.queryController.executeQuery();
	        }
	    };
	    FacetSlider.prototype.updateQueryState = function (values, silent) {
	        if (values === void 0) { values = this.slider.getValues(); }
	        if (silent === void 0) { silent = false; }
	        var copyOfValues = this.copyValues(values);
	        var start = values[0] + 0.0;
	        var end = values[1] + 0.0;
	        var model = this.queryStateModel.get(this.rangeQueryStateAttribute);
	        if (model == null || copyOfValues[0] != model[0] || copyOfValues[1] != model[1]) {
	            copyOfValues[0] = start;
	            copyOfValues[1] = end;
	            this.queryStateModel.set(this.rangeQueryStateAttribute, copyOfValues, { silent: silent });
	            return true;
	        }
	        return false;
	    };
	    FacetSlider.prototype.copyValues = function (values) {
	        // Creating a copy of the values prevents an unwanted automatic update of the state while sliding
	        // That's the cleanest way I found to copy that array correctly
	        var copyOfValues = [];
	        copyOfValues[0] = Number(values[0]) + 0.0;
	        copyOfValues[1] = Number(values[1]) + 0.0;
	        return copyOfValues;
	    };
	    FacetSlider.prototype.renderToSliderGraph = function (data) {
	        var _this = this;
	        var rawGroupByResults = data.results.groupByResults[this.facetQueryController.graphGroupByQueriesIndex];
	        var graphData;
	        var totalGraphResults = 0;
	        if (rawGroupByResults) {
	            graphData = _.map(rawGroupByResults.values, function (value) {
	                totalGraphResults += value.numberOfResults;
	                var start = value.value.split('..')[0];
	                var end = value.value.split('..')[1];
	                if (!_this.options.dateField) {
	                    start = Number(start);
	                    end = Number(end);
	                }
	                else {
	                    start = new Date(start.split('@')[0]).getTime();
	                    end = new Date(end.split('@')[0]).getTime();
	                }
	                var y = value.numberOfResults;
	                return {
	                    start: start,
	                    y: y,
	                    end: end,
	                    isDate: _this.options.dateField
	                };
	            });
	        }
	        if (totalGraphResults == 0) {
	            this.isEmpty = true;
	            this.updateAppearanceDependingOnState();
	        }
	        else if (graphData != undefined && !this.isFacetDropdownHidden()) {
	            this.slider.drawGraph(graphData);
	        }
	        else if (graphData != undefined && this.isFacetDropdownHidden()) {
	            this.delayedGraphData = graphData;
	        }
	    };
	    FacetSlider.prototype.isFacetDropdownHidden = function () {
	        var facetDropdown = this.root.querySelector('.coveo-facet-column');
	        if (facetDropdown) {
	            return Dom_1.$$(facetDropdown).css('display') == 'none';
	        }
	        return false;
	    };
	    FacetSlider.prototype.generateBoundary = function () {
	        if (!this.slider) {
	            // If the slider is not initialized, the only boundary we can get is from the state.
	            return this.generateBoundaryFromState();
	        }
	        else {
	            // Else, try to get one from the slider itself. If we cant, try to return one from the state.
	            var boundary = this.generateBoundaryFromSlider();
	            if (boundary[0] == undefined && boundary[1] == undefined) {
	                return this.generateBoundaryFromState();
	            }
	            else {
	                return boundary;
	            }
	        }
	    };
	    FacetSlider.prototype.generateBoundaryFromSlider = function () {
	        var start, end;
	        if (this.startOfSlider != undefined) {
	            start = this.startOfSlider;
	        }
	        if (this.endOfSlider != undefined) {
	            end = this.endOfSlider;
	        }
	        return [start, end];
	    };
	    FacetSlider.prototype.generateBoundaryFromState = function () {
	        var start, end;
	        var startFromState = this.queryStateModel.get(this.rangeQueryStateAttribute)[0];
	        if (startFromState != undefined) {
	            start = startFromState;
	        }
	        var endFromState = this.queryStateModel.get(this.rangeQueryStateAttribute)[1];
	        if (endFromState != undefined) {
	            end = endFromState;
	        }
	        if (start != this.queryStateModel.getDefault(this.rangeQueryStateAttribute)[0] || end != this.queryStateModel.getDefault(this.rangeQueryStateAttribute)[1]) {
	            return [start, end];
	        }
	        else {
	            return [undefined, undefined];
	        }
	    };
	    FacetSlider.prototype.setupSliderIfNeeded = function (data) {
	        this.ensureDom();
	        if (Utils_1.Utils.isNullOrUndefined(this.slider)) {
	            if (!this.alreadySetBoundary()) {
	                this.trySetSliderBoundaryFromOptions();
	            }
	            if (!this.alreadySetBoundary() && data != undefined) {
	                this.trySetSliderBoundaryFromQueryResult(data);
	            }
	            this.trySetSliderBoundaryFromState();
	            this.setupSliderStateVariables();
	            var isInError = this.verifySetup();
	            if (isInError) {
	                this.logger.warn('Unable to initialize slider with current values', this);
	            }
	            else {
	                this.initSlider();
	                this.updateQueryState();
	            }
	        }
	    };
	    FacetSlider.prototype.verifySetup = function () {
	        var isInError = 0;
	        isInError += this.initialStartOfSlider == undefined ? 1 : 0;
	        isInError += isNaN(this.initialStartOfSlider) ? 1 : 0;
	        isInError += this.initialEndOfSlider == undefined ? 1 : 0;
	        isInError += isNaN(this.initialEndOfSlider) ? 1 : 0;
	        return isInError;
	    };
	    FacetSlider.prototype.setupSliderStateVariables = function () {
	        if (isNaN(this.initialStartOfSlider) || isNaN(this.initialEndOfSlider)) {
	            this.logger.warn('Cannnot initialize slider with those values : start: ' + this.initialStartOfSlider + ' end: ' + this.initialEndOfSlider);
	        }
	        else {
	            this.initialStartOfSlider = Number(this.initialStartOfSlider);
	            this.initialEndOfSlider = Number(this.initialEndOfSlider);
	            this.startOfSlider = this.startOfSlider != undefined ? Number(this.startOfSlider) : this.initialStartOfSlider;
	            this.endOfSlider = this.endOfSlider != undefined ? Number(this.endOfSlider) : this.initialEndOfSlider;
	            this.options.start = this.initialStartOfSlider;
	            this.options.end = this.initialEndOfSlider;
	            this.queryStateModel.setNewDefault(this.rangeQueryStateAttribute, [this.initialStartOfSlider, this.initialEndOfSlider]);
	        }
	    };
	    FacetSlider.prototype.alreadySetBoundary = function () {
	        return this.startOfSlider != undefined && this.endOfSlider != undefined;
	    };
	    FacetSlider.prototype.trySetSliderBoundaryFromOptions = function () {
	        if (!Utils_1.Utils.isNullOrUndefined(this.options.start)) {
	            this.setupInitialSliderStateStart(this.options.start);
	        }
	        if (!Utils_1.Utils.isNullOrUndefined(this.options.end)) {
	            this.setupInitialSliderStateEnd(this.options.end);
	        }
	    };
	    FacetSlider.prototype.trySetSliderBoundaryFromState = function () {
	        var stateValues = this.rangeFromUrlState || this.queryStateModel.get(this.rangeQueryStateAttribute);
	        if (stateValues && stateValues[0] != undefined && stateValues[1] != undefined) {
	            stateValues[0] = Number(stateValues[0]);
	            stateValues[1] = Number(stateValues[1]);
	            this.setupInitialSliderStateStart(stateValues[0]);
	            this.setupInitialSliderStateEnd(stateValues[1]);
	            this.startOfSlider = stateValues[0];
	            this.endOfSlider = stateValues[1];
	        }
	    };
	    FacetSlider.prototype.trySetSliderBoundaryFromQueryResult = function (data) {
	        var groupByResults = data.results.groupByResults[this.facetQueryController.lastGroupByRequestIndex];
	        if (groupByResults && groupByResults.values.length > 0) {
	            this.setupInitialSliderStateStart(groupByResults.values[0].value.split('..')[0]);
	            this.setupInitialSliderStateEnd(groupByResults.values[groupByResults.values.length - 1].value.split('..')[1]);
	        }
	    };
	    FacetSlider.prototype.setupInitialSliderStateStart = function (value) {
	        if (this.initialStartOfSlider == undefined) {
	            this.initialStartOfSlider = value;
	            if (this.options.dateField && isNaN(value)) {
	                this.initialStartOfSlider = new Date(value.replace('@', ' ')).getTime();
	            }
	        }
	    };
	    FacetSlider.prototype.setupInitialSliderStateEnd = function (value) {
	        if (this.initialEndOfSlider == undefined) {
	            this.initialEndOfSlider = value;
	            if (this.options.dateField && isNaN((value))) {
	                this.initialEndOfSlider = new Date(value.replace('@', ' ')).getTime();
	            }
	        }
	    };
	    FacetSlider.prototype.hasAGraph = function () {
	        return this.options.graph != undefined;
	    };
	    FacetSlider.prototype.updateAppearanceDependingOnState = function (sliding) {
	        if (sliding === void 0) { sliding = false; }
	        if (this.isEmpty && !this.isActive() && !sliding) {
	            Dom_1.$$(this.element).addClass('coveo-disabled-empty');
	        }
	        else {
	            Dom_1.$$(this.element).removeClass('coveo-disabled-empty');
	            Dom_1.$$(this.facetHeader.eraserElement).toggle(this.isActive());
	        }
	        if (!this.isActive() && !sliding) {
	            Dom_1.$$(this.element).addClass('coveo-disabled');
	        }
	        else {
	            Dom_1.$$(this.element).removeClass('coveo-disabled');
	        }
	    };
	    FacetSlider.prototype.handleNuke = function () {
	        window.removeEventListener('resize', this.onResize);
	    };
	    /**
	     * The component options
	     * @componentOptions
	     */
	    FacetSlider.options = {
	        /**
	         * The title on top of the facet component.<br/>
	         * Default value is the localized string for 'No title'.
	         */
	        title: ComponentOptions_1.ComponentOptions.buildLocalizedStringOption({ defaultValue: Strings_1.l('NoTitle') }),
	        /**
	         * Specifies whether the field for which you are requesting a range is a date field.<br/>
	         * This allows the facet to correctly build the outgoing group by request, as well as render it correctly.<br/>
	         */
	        dateField: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: false }),
	        /**
	         * Specifies the index field whose values will be use in the facet.<br/>
	         * This require the given field to be configured correctly in the index as a facet field.<br/>
	         * This is a required option and cannot be omitted, otherwise the facet component will not work.
	         */
	        field: ComponentOptions_1.ComponentOptions.buildFieldOption({ groupByField: true, required: true }),
	        /**
	         * Specifies a unique identifier for a facet. This identifier will be used to save the facet state in the URL hash, for example.<br/>
	         * Optional, since the default will be the {@link FacetSlider.options.field} option.<br/>
	         * If you have two facets with the same field on the same page, you should specify an ID for at least one of those two facets.<br/>
	         * That ID needs to be unique on the page.
	         */
	        id: ComponentOptions_1.ComponentOptions.buildStringOption({
	            postProcessing: function (value, options) { return value || options.field; }
	        }),
	        /**
	         * Specifies the format used to display values if they are dates.<br/>
	         * Default value is <code>MMM dd, yyyy</code>.
	         */
	        dateFormat: ComponentOptions_1.ComponentOptions.buildStringOption(),
	        /**
	         * Specifies the query to filter automatic minimum and maximum range of the slider.<br/>
	         * This is especially useful for date range, where the index may contain values which are not set, and thus the automatic range will return values from the year 1400 (min date from the boost C++ library).<br/>
	         * Can be used to do something like queryOverride : @date>2000/01/01 or some arbitrary date which will filter out unwanted values.
	         */
	        queryOverride: ComponentOptions_1.ComponentOptions.buildStringOption(),
	        /**
	         * Specifies the starting boundary of the slider.<br/>
	         * Dates values are rounded on the year when the field used is a date type.<br/>
	         * Optional: Takes the lowest value available in the index by default.
	         */
	        start: ComponentOptions_1.ComponentOptions.buildStringOption(),
	        /**
	         * Specifies the ending boundary of the slider.<br/>
	         * Dates values are rounded on the year when the field used is a date type.<br/>
	         * Optional: Takes the highest value available in the index by default.
	         */
	        end: ComponentOptions_1.ComponentOptions.buildStringOption(),
	        /**
	         * Specifies if you want to exclude the outer bounds of your slider in the generated query, when they are not active.<br/>
	         * Default value is `false`.
	         */
	        excludeOuterBounds: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: false }),
	        /**
	         * Specifies to how many decimal digit displayed numerical values are rounded.<br/>
	         * Optional. By default, the number rounds to 0 decimal digits.
	         */
	        rounded: ComponentOptions_1.ComponentOptions.buildNumberOption({ min: 0 }),
	        /**
	         * Specifies the number of steps that you want in your slider.<br/>
	         * For example, if your range is [ 0 , 100 ] and you specify 10 steps, then the end user is allowed to move the slider only to the values [ 0, 10, 20. 30 ... , 100 ].<br/>
	         * Optional: By default the slider will allow all values.
	         */
	        steps: ComponentOptions_1.ComponentOptions.buildNumberOption({ min: 2 }),
	        /**
	         * Specifies whether you want a slider with two buttons, or only one.<br/>
	         * Optional: By default only one button appears in the slider.
	         */
	        rangeSlider: ComponentOptions_1.ComponentOptions.buildBooleanOption(),
	        /**
	         * Specifies the caption that you want to display the field values.<br/>
	         * Available options are :
	         * <ul>
	         *   <li>enable : (data-display-as-value-enable) <code>boolean</code> : Specifies whether the caption should be displayed as a value or not. Default is <code>true</code></li>.
	         *   <li>unitSign : (data-display-as-value-unit-sign) <code>string</code> : Specifies the unit sign for this value.</li>
	         *   <li>separator : (data-display-as-value-separator) <code>string</code> : Specifies the character(s) to use as a separator in the caption. Default is `-.`</li>.
	         * </ul>
	         */
	        displayAsValue: ComponentOptions_1.ComponentOptions.buildObjectOption({
	            subOptions: {
	                enable: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true }),
	                unitSign: ComponentOptions_1.ComponentOptions.buildStringOption(),
	                separator: ComponentOptions_1.ComponentOptions.buildStringOption({ defaultValue: '-' })
	            }
	        }),
	        /**
	         * Specifies the percentage caption that you want to display the field values.<br/>
	         * Available options are :
	         * <ul>
	         *   <li>enable : (data-display-as-percent-enable) <code>boolean</code> : Specifies whether the caption should be displayed as a percentage. Default is <code>false</code></li>.
	         *   <li>separator : (data-display-as-percent-separator) <code>string</code> : Specifies the character(s) to use as a separator in the caption. Default is `-.`</li>.
	         * </ul>
	         */
	        displayAsPercent: ComponentOptions_1.ComponentOptions.buildObjectOption({
	            subOptions: {
	                enable: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: false }),
	                separator: ComponentOptions_1.ComponentOptions.buildStringOption({ defaultValue: '-' })
	            }
	        }),
	        /**
	         * Specifies that you wish to display a small graph on top of the slider.<br/>
	         * Available options are :
	         *
	         *   <li>steps: (data-graph-steps) <code>number</code> : Specifies the number of steps/columns to display in your graph. The default value is `10`</li>.
	         * </ul>
	         */
	        graph: ComponentOptions_1.ComponentOptions.buildObjectOption({
	            subOptions: {
	                steps: ComponentOptions_1.ComponentOptions.buildNumberOption({ min: 2 }),
	                animationDuration: ComponentOptions_1.ComponentOptions.buildNumberOption({ min: 0 }),
	                margin: ComponentOptions_1.ComponentOptions.buildObjectOption({
	                    subOptions: {
	                        top: ComponentOptions_1.ComponentOptions.buildNumberOption({ min: 0 }),
	                        bottom: ComponentOptions_1.ComponentOptions.buildNumberOption({ min: 0 }),
	                        left: ComponentOptions_1.ComponentOptions.buildNumberOption({ min: 0 }),
	                        right: ComponentOptions_1.ComponentOptions.buildNumberOption({ min: 0 })
	                    }
	                })
	            }
	        }),
	        /**
	         * Specifies a function that will generate the steps for the slider. The function receives the slider boundaries and must return an array of number (the steps).
	         *
	         * ```
	         * Coveo.init(document.querySelector('#search'), {
	         *    FacetSlider: {
	         *      field: "@size",
	         *      getSteps: function(start, end) {
	         *        return [0,2,4,6,8,10];
	         *      }
	         *    }
	         * })
	         *
	         * // OR using the jQuery extension
	         *
	         * $('#search').coveo('init', {
	         *    FacetSlider: {
	         *        field: "@size",
	         *        getSteps: function(start, end) {
	         *            return [0,2,4,6,8,10];
	         *        }
	         *    }
	         * })
	         * ```
	         */
	        getSteps: ComponentOptions_1.ComponentOptions.buildCustomOption(function () {
	            return null;
	        }),
	        /**
	         * Specifies a function that will generate the caption for the slider. Receives the current slider values (number[]) and must return the caption (string).
	         *
	         * ```
	         * Coveo.init(document.querySelector('#search'), {
	         *    FacetSlider: {
	         *      field: "@size",
	         *      valueCaption: function(values) {
	         *        return values[0] + " hello" + ", " + values[1] + " world";
	         *      }
	         *    }
	         * })
	         *
	         * // OR using the jQuery extension
	         *
	         * $('#search').coveo('init', {
	         *    FacetSlider: {
	         *      field: "@size",
	         *      valueCaption: function(values) {
	         *        return values[0] + " hello" + ", " + values[1] + " world";
	         *      }
	         *    }
	         * })
	         * ```
	         */
	        valueCaption: ComponentOptions_1.ComponentOptions.buildCustomOption(function () {
	            return null;
	        }),
	        /**
	         * Specifies if the responsive mode should be enabled on the facets. Responsive mode will make the facet dissapear and instead be
	         * availaible using a dropdown button. Responsive facets are enabled when the width of the element the search interface is bound to
	         * reaches 800 pixels. This value can be modified using {@link Facet..optionsresponsiveBreakpoint}.
	         * The default value is `true`.
	         */
	        enableResponsiveMode: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true }),
	        /**
	         * Specifies the width of the search interface, in pixels, at which the facets will go into responsive mode. The responsive mode will
	         * be triggered when the width is equal or below this value. The search interface corresponds to the element with the class
	         * `CoveoSearchInterface`.
	         * The default value is `800`.
	         */
	        responsiveBreakpoint: ComponentOptions_1.ComponentOptions.buildNumberOption({ defaultValue: 800 })
	    };
	    FacetSlider.ID = 'FacetSlider';
	    return FacetSlider;
	}(Component_1.Component));
	exports.FacetSlider = FacetSlider;
	Initialization_1.Initialization.registerAutoCreateComponent(FacetSlider);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var Dom_1 = __webpack_require__(57);
	var DeviceUtils_1 = __webpack_require__(20);
	var SliderEvents_1 = __webpack_require__(51);
	var Utils_1 = __webpack_require__(18);
	var d3Scale = __webpack_require__(165);
	var d3 = __webpack_require__(173);
	var Globalize = __webpack_require__(4);
	var Slider = (function () {
	    function Slider(element, options, root) {
	        var _this = this;
	        this.element = element;
	        this.options = options;
	        this.root = root;
	        this.steps = [];
	        if (this.options.dateField) {
	            this.options.start = new Date(this.options.start).getTime();
	            this.options.end = new Date(this.options.end).getTime();
	        }
	        if (this.options.rounded == undefined) {
	            this.options.rounded = 0;
	        }
	        if (this.options.steps || this.options.getSteps) {
	            this.buildSteps();
	        }
	        if (this.options.graph) {
	            this.sliderGraph = new SliderGraph(this);
	        }
	        this.sliderLine = new SliderLine(this);
	        _.each(this.sliderLine.build(), function (e) {
	            _this.element.appendChild(e);
	        });
	        if (this.options.rangeSlider) {
	            this.sliderRange = new SliderRange(this);
	            _.each(this.sliderRange.build(), function (e) {
	                _this.element.appendChild(e);
	            });
	        }
	        else {
	            this.sliderButton = new SliderButton(this, 1);
	            var btnEl = this.sliderButton.build();
	            Dom_1.$$(btnEl).addClass('coveo-no-range-button');
	            this.element.appendChild(btnEl);
	            this.sliderLine.setActiveWidth(this.sliderButton);
	        }
	        this.sliderCaption = new SliderCaption(this);
	        this.element.appendChild(this.sliderCaption.build());
	    }
	    Slider.prototype.onMoving = function () {
	        if (this.options.rangeSlider) {
	            this.sliderRange.setBoundary();
	            this.sliderLine.setActiveWidth(this.sliderRange.firstButton, this.sliderRange.secondButton);
	        }
	        else {
	            this.setButtonBoundary();
	            this.sliderLine.setActiveWidth(this.sliderButton);
	        }
	        if (this.options.graph) {
	            this.sliderGraph.draw();
	        }
	        this.displayCaption();
	    };
	    Slider.prototype.initializeState = function (values) {
	        if (values === void 0) { values = [this.options.start, this.options.end]; }
	        this.currentValues = values;
	        if (this.options.rangeSlider) {
	            this.sliderRange.initializeSliderRangeState(values);
	            this.sliderLine.setActiveWidth(this.sliderRange.firstButton, this.sliderRange.secondButton);
	        }
	        else {
	            if (values == undefined) {
	                this.sliderButton.toEnd();
	            }
	            else {
	                this.sliderButton.setValue(values[1]);
	            }
	            this.setButtonBoundary();
	            this.sliderLine.setActiveWidth(this.sliderButton);
	        }
	        this.displayCaption();
	    };
	    Slider.prototype.getPosition = function () {
	        if (this.options.rangeSlider) {
	            return this.sliderRange.getPosition();
	        }
	        else {
	            return [0, this.sliderButton.getPosition()];
	        }
	    };
	    Slider.prototype.getPercentPosition = function () {
	        if (this.options.rangeSlider) {
	            return this.sliderRange.getPercentPosition();
	        }
	        else {
	            return [0, this.sliderButton.getPercent()];
	        }
	    };
	    Slider.prototype.getValues = function () {
	        if (this.currentValues != undefined) {
	            return this.currentValues;
	        }
	        else {
	            if (this.options.rangeSlider) {
	                return this.sliderRange.getValue();
	            }
	            else {
	                return [this.options.start, this.sliderButton.getValue()];
	            }
	        }
	    };
	    Slider.prototype.getCaptionFromValue = function (values) {
	        return this.sliderCaption.getCaptionFromValues(values);
	    };
	    Slider.prototype.getCaption = function () {
	        return this.sliderCaption.getCaption();
	    };
	    Slider.prototype.setValues = function (values) {
	        if (values != undefined) {
	            values[0] = Math.max(values[0], this.options.start);
	            values[1] = Math.min(values[1], this.options.end);
	        }
	        this.currentValues = values;
	        if (this.options.rangeSlider) {
	            this.sliderRange.setValue(values);
	            this.sliderLine.setActiveWidth(this.sliderRange.firstButton, this.sliderRange.secondButton);
	        }
	        else {
	            this.sliderButton.setValue(values[1]);
	            this.sliderLine.setActiveWidth(this.sliderButton);
	        }
	        this.displayCaption();
	    };
	    Slider.prototype.drawGraph = function (data) {
	        if (this.sliderGraph) {
	            this.sliderGraph.draw(data);
	        }
	    };
	    Slider.prototype.setButtonBoundary = function () {
	        this.sliderButton.leftBoundary = 0;
	        this.sliderButton.rightBoundary = this.element.clientWidth;
	    };
	    Slider.prototype.displayCaption = function () {
	        if (this.options.valueCaption != undefined) {
	            this.sliderCaption.setFromString(this.options.valueCaption(this.getValues()));
	        }
	        else if (this.options.percentCaption != undefined) {
	            this.sliderCaption.setFromString(this.options.percentCaption(this.getPercentPosition()));
	        }
	        else if (this.options.displayAsPercent != undefined && this.options.displayAsPercent.separator != undefined && this.options.displayAsPercent.enable) {
	            this.sliderCaption.setAsPercent();
	        }
	        else {
	            this.sliderCaption.setAsValue();
	        }
	    };
	    Slider.prototype.buildSteps = function () {
	        if (this.options.getSteps) {
	            this.steps = this.options.getSteps(this.options.start, this.options.end);
	        }
	        else {
	            var oneStep = (this.options.end - this.options.start) / Math.max(1, this.options.steps);
	            if (oneStep > 0) {
	                var currentStep = this.options.start;
	                while (currentStep <= this.options.end) {
	                    this.steps.push(currentStep);
	                    currentStep += oneStep;
	                }
	            }
	            else {
	                this.steps.push(this.options.start);
	                this.steps.push(this.options.end);
	            }
	        }
	    };
	    return Slider;
	}());
	exports.Slider = Slider;
	var SliderLine = (function () {
	    function SliderLine(slider) {
	        this.slider = slider;
	    }
	    SliderLine.prototype.build = function () {
	        this.backGround = Dom_1.$$('div', {
	            className: 'coveo-slider-line coveo-background'
	        }).el;
	        this.activePart = Dom_1.$$('div', {
	            className: 'coveo-slider-line coveo-active'
	        }).el;
	        return [this.backGround, this.activePart];
	    };
	    SliderLine.prototype.setActiveWidth = function (buttonOne, buttonTwo) {
	        if (this.slider.options.rangeSlider) {
	            var width = (buttonTwo.getPercent() - buttonOne.getPercent()) * 100;
	            this.activePart.style.width = width + '%';
	            this.activePart.style.left = buttonOne.getPercent() * 100 + '%';
	            this.activePart.style.right = buttonTwo.getPercent() * 100 + '%';
	        }
	        else {
	            var width = buttonOne.getPercent() * 100;
	            this.activePart.style.width = width + '%';
	        }
	    };
	    return SliderLine;
	}());
	var SliderButton = (function () {
	    function SliderButton(slider, which) {
	        this.slider = slider;
	        this.which = which;
	        this.eventMouseDown = DeviceUtils_1.DeviceUtils.isMobileDevice() ? 'touchstart' : 'mousedown';
	        this.eventMouseMove = DeviceUtils_1.DeviceUtils.isMobileDevice() ? 'touchmove' : 'mousemove';
	        this.eventMouseUp = DeviceUtils_1.DeviceUtils.isMobileDevice() ? 'touchend' : 'mouseup';
	    }
	    SliderButton.prototype.build = function () {
	        this.element = Dom_1.$$('div', {
	            className: 'coveo-slider-button'
	        }).el;
	        this.bindEvents();
	        this.element['CoveoSliderButton'] = this;
	        return this.element;
	    };
	    SliderButton.prototype.toBeginning = function () {
	        this.element.style.left = '0%';
	    };
	    SliderButton.prototype.toEnd = function () {
	        this.element.style.left = '100%';
	    };
	    SliderButton.prototype.setValue = function (value) {
	        var percent = this.fromValueToPercent(value);
	        this.element.style.left = Math.round(percent * 100) + '%';
	    };
	    SliderButton.prototype.getPosition = function () {
	        var left = this.element.style.left;
	        if (left.indexOf('%') != -1) {
	            return (parseFloat(left) / 100) * this.slider.element.clientWidth;
	        }
	        else {
	            return parseFloat(left);
	        }
	    };
	    SliderButton.prototype.getPercent = function (position) {
	        if (position === void 0) { position = this.getPosition(); }
	        if (this.slider.element.clientWidth == 0) {
	            return 0;
	        }
	        return +(position / this.slider.element.clientWidth).toFixed(2);
	    };
	    SliderButton.prototype.getValue = function () {
	        var value = this.getPercent() * (this.slider.options.end - this.slider.options.start) + this.slider.options.start;
	        return value;
	    };
	    SliderButton.prototype.fromValueToPercent = function (value) {
	        return 1 - ((this.slider.options.end - value) / (this.slider.options.end - this.slider.options.start));
	    };
	    SliderButton.prototype.fromPositionToValue = function (position) {
	        var percent = this.getPercent(position);
	        return this.slider.options.start + (percent * (this.slider.options.end - this.slider.options.start));
	    };
	    SliderButton.prototype.fromValueToPosition = function (value) {
	        var percent = this.fromValueToPercent(value);
	        return this.slider.element.clientWidth * percent;
	    };
	    SliderButton.prototype.bindEvents = function () {
	        var _this = this;
	        Dom_1.$$(this.element).on(this.eventMouseDown, function (e) {
	            _this.handleStartSlide(e);
	        });
	        var doc = this.slider.options.document || document;
	        doc.addEventListener(this.eventMouseMove, function (e) {
	            if (_this.eventMouseMove == 'touchmove' && _this.isMouseDown) {
	                e.preventDefault();
	            }
	            _this.handleMoving(e);
	        });
	        doc.addEventListener(this.eventMouseUp, function () {
	            _this.handleEndSlide();
	        });
	    };
	    SliderButton.prototype.getUserSelect = function () {
	        if (document.body.style.msUserSelect !== undefined) {
	            return 'msUserSelect';
	        }
	        if (document.body.style.webkitUserSelect !== undefined) {
	            return 'webkitUserSelect';
	        }
	        if (document.body.style['MozUserSelect'] !== undefined) {
	            return 'MozUserSelect';
	        }
	        return 'userSelect';
	    };
	    SliderButton.prototype.handleStartSlide = function (e) {
	        var position = this.getMousePosition(e);
	        this.isMouseDown = true;
	        this.startPositionX = position.x;
	        this.lastElementLeft = (parseInt(this.element.style.left, 10) / 100) * this.slider.element.clientWidth;
	        this.origUserSelect = document.body.style[this.getUserSelect()];
	        this.origCursor = document.body.style.cursor;
	        document.body.style[this.getUserSelect()] = 'none';
	        document.body.style.cursor = 'pointer';
	        Dom_1.$$(this.element).addClass('coveo-active');
	        Dom_1.$$(this.element).trigger(SliderEvents_1.SliderEvents.startSlide, {
	            button: this,
	            slider: this.slider
	        });
	        e.stopPropagation();
	    };
	    SliderButton.prototype.handleMoving = function (e) {
	        if (this.isMouseDown) {
	            this.slider.onMoving();
	            this.updatePosition(e);
	            this.handleButtonNearEnd();
	            Dom_1.$$(this.element).trigger(SliderEvents_1.SliderEvents.duringSlide, {
	                button: this,
	                slider: this.slider
	            });
	        }
	    };
	    SliderButton.prototype.handleEndSlide = function () {
	        if (this.isMouseDown) {
	            document.body.style[this.getUserSelect()] = this.origUserSelect;
	            document.body.style.cursor = this.origCursor;
	            Dom_1.$$(this.element).removeClass('coveo-active');
	            Dom_1.$$(this.element).trigger(SliderEvents_1.SliderEvents.endSlide, {
	                button: this,
	                slider: this.slider
	            });
	        }
	        this.isMouseDown = false;
	    };
	    SliderButton.prototype.handleButtonNearEnd = function () {
	        if (this.which == 0) {
	            if (this.origZIndex == undefined) {
	                this.origZIndex = this.element.style.zIndex || '1';
	            }
	            if (this.currentPos > 90) {
	                this.element.style.zIndex = this.origZIndex + 1;
	            }
	            else {
	                this.element.style.zIndex = this.origZIndex;
	            }
	        }
	    };
	    SliderButton.prototype.getMousePosition = function (e) {
	        var posx = 0;
	        var posy = 0;
	        if (this.eventMouseMove == 'touchmove') {
	            posx = e['originalEvent']['touches'][0].pageX;
	            posy = e['originalEvent']['touches'][0].pageY;
	        }
	        else if (e.pageX || e.pageY) {
	            posx = e.pageX;
	            posy = e.pageY;
	        }
	        else if (e.clientX || e.clientY) {
	            posx = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
	            posy = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
	        }
	        return { x: posx, y: posy };
	    };
	    SliderButton.prototype.updatePosition = function (e) {
	        var pos = this.getMousePosition(e);
	        var spanX = pos.x - this.startPositionX;
	        this.currentPos = this.lastElementLeft + spanX;
	        if (this.slider.options.steps || this.slider.options.getSteps) {
	            var snapResult = this.snapToStep(spanX);
	            this.currentPos = snapResult.position;
	            var currentValue = snapResult.value;
	        }
	        this.currentPos = Math.max(this.leftBoundary, this.currentPos);
	        this.currentPos = Math.min(this.rightBoundary, this.currentPos);
	        this.currentPos = this.getPercent(this.currentPos) * 100;
	        this.currentPos = Math.min(this.currentPos, 100);
	        this.currentPos = Math.max(this.currentPos, 0);
	        this.element.style.left = Math.round(this.currentPos) + '%';
	        if (this.slider.options.steps || this.slider.options.getSteps) {
	            this.slider.currentValues[this.which] = currentValue;
	        }
	        else {
	            this.slider.currentValues[this.which] = this.getValue();
	        }
	    };
	    SliderButton.prototype.snapToStep = function (spanX) {
	        var _this = this;
	        var diffs = _.map(this.slider.steps, function (step, i) {
	            return Math.abs(_this.currentPos - _this.fromValueToPosition(_this.slider.steps[i]));
	        });
	        var diffsNext = _.map(this.slider.steps, function (step, i) {
	            return Math.abs(_this.rightBoundary - _this.fromValueToPosition(_this.slider.steps[i]));
	        });
	        var diffsPrev = _.map(this.slider.steps, function (step, i) {
	            return Math.abs(_this.leftBoundary - _this.fromValueToPosition(_this.slider.steps[i]));
	        });
	        var nearest = _.min(diffs);
	        var nearestNext = _.min(diffsNext);
	        var nearestPrevious = _.min(diffsPrev);
	        var currentStep = this.slider.steps[_.indexOf(diffs, nearest)];
	        var nextStep = this.slider.steps[_.indexOf(diffsNext, nearestNext)];
	        var previousStep = this.slider.steps[_.indexOf(diffsPrev, nearestPrevious)];
	        currentStep = Math.min(currentStep, nextStep);
	        currentStep = Math.max(currentStep, previousStep);
	        return { position: this.fromValueToPosition(currentStep), value: currentStep };
	    };
	    return SliderButton;
	}());
	exports.SliderButton = SliderButton;
	var SliderRange = (function () {
	    function SliderRange(slider) {
	        this.slider = slider;
	        this.firstButton = new SliderButton(slider, 0);
	        this.secondButton = new SliderButton(slider, 1);
	    }
	    SliderRange.prototype.build = function () {
	        var firstElem = this.firstButton.build();
	        var secondElem = this.secondButton.build();
	        Dom_1.$$(secondElem).addClass('coveo-range-button');
	        return [firstElem, secondElem];
	    };
	    SliderRange.prototype.initializeSliderRangeState = function (values) {
	        if (values == undefined) {
	            this.firstButton.toBeginning();
	            this.secondButton.toEnd();
	        }
	        else {
	            this.firstButton.setValue(values[0]);
	            this.secondButton.setValue(values[1]);
	        }
	        this.setBoundary();
	    };
	    SliderRange.prototype.setValue = function (values) {
	        this.firstButton.setValue(values[0]);
	        this.secondButton.setValue(values[1]);
	    };
	    SliderRange.prototype.setBoundary = function () {
	        this.firstButton.leftBoundary = 0;
	        this.firstButton.rightBoundary = this.secondButton.getPosition();
	        this.secondButton.leftBoundary = this.firstButton.getPosition();
	        this.secondButton.rightBoundary = this.slider.element.clientWidth;
	    };
	    SliderRange.prototype.getPosition = function () {
	        return [this.firstButton.getPosition(), this.secondButton.getPosition()];
	    };
	    SliderRange.prototype.getPercentPosition = function () {
	        return [this.firstButton.getPercent(), this.secondButton.getPercent()];
	    };
	    SliderRange.prototype.getValue = function () {
	        return [this.firstButton.getValue(), this.secondButton.getValue()];
	    };
	    return SliderRange;
	}());
	var SliderCaption = (function () {
	    function SliderCaption(slider) {
	        this.slider = slider;
	        this.separator = '-';
	        this.unitSign = '';
	        if (this.slider.options.displayAsPercent && this.slider.options.displayAsPercent.enable) {
	            this.separator = this.slider.options.displayAsPercent.separator != undefined ? this.slider.options.displayAsPercent.separator : this.separator;
	        }
	        else if (this.slider.options.displayAsValue && this.slider.options.displayAsValue.enable) {
	            this.separator = this.slider.options.displayAsValue.separator != undefined ? this.slider.options.displayAsValue.separator : this.separator;
	            this.unitSign = this.slider.options.displayAsValue.unitSign != undefined ? this.slider.options.displayAsValue.unitSign : this.unitSign;
	        }
	    }
	    SliderCaption.prototype.build = function () {
	        this.caption = Dom_1.$$('div', {
	            className: 'coveo-slider-caption'
	        }).el;
	        return this.caption;
	    };
	    SliderCaption.prototype.getCaption = function () {
	        return Dom_1.$$(this.caption).text();
	    };
	    SliderCaption.prototype.getCaptionFromValues = function (values) {
	        return this.getValueCaption(values);
	    };
	    SliderCaption.prototype.getCaptionFromValuesAsPercent = function (values) {
	        return this.getValueCaption(values);
	    };
	    SliderCaption.prototype.setAsValue = function () {
	        Dom_1.$$(this.caption).text(this.getValueCaption());
	    };
	    SliderCaption.prototype.setAsPercent = function () {
	        var values = this.slider.getPercentPosition();
	        Dom_1.$$(this.caption).text([(values[0] * 100).toFixed(this.slider.options.rounded), '%', this.separator, (values[1] * 100).toFixed(this.slider.options.rounded), '%'].join(' '));
	    };
	    SliderCaption.prototype.setFromString = function (str) {
	        Dom_1.$$(this.caption).text(str);
	    };
	    SliderCaption.prototype.getValueCaption = function (values) {
	        if (values === void 0) { values = this.slider.getValues(); }
	        var first = values[0];
	        var second = values[1];
	        if (this.slider.options.dateField) {
	            var firstAsDate = new Date(first);
	            var secondAsDate = new Date(second);
	            firstAsDate.setHours(0, 0, 0, 0);
	            secondAsDate.setHours(0, 0, 0, 0);
	            first = Globalize.format(firstAsDate, this.slider.options.dateFormat || 'MMM dd, yyyy');
	            second = Globalize.format(secondAsDate, this.slider.options.dateFormat || 'MMM dd, yyyy');
	            this.unitSign = '';
	        }
	        else {
	            first = first.toFixed(this.slider.options.rounded);
	            second = second.toFixed(this.slider.options.rounded);
	        }
	        return [first, this.unitSign, this.separator, second, this.unitSign].join(' ');
	    };
	    return SliderCaption;
	}());
	var SliderGraph = (function () {
	    function SliderGraph(slider) {
	        this.slider = slider;
	        this.svg = d3.select(slider.element).append('svg').append('g');
	        this.x = d3Scale.scaleBand();
	        this.y = d3Scale.scaleLinear();
	        this.slider.options.graph.margin = Utils_1.Utils.extendDeep({
	            top: 20,
	            right: 0,
	            left: 0,
	            bottom: 20
	        }, this.slider.options.graph.margin || {});
	        this.slider.options.graph.animationDuration = this.slider.options.graph.animationDuration || 500;
	        this.tooltip = Dom_1.$$('div', {
	            className: 'coveo-slider-tooltip'
	        }).el;
	        this.tooltip.style.display = 'none';
	        this.slider.element.appendChild(this.tooltip);
	        this.slider.options.graph.steps = this.slider.options.graph.steps || 10;
	    }
	    SliderGraph.prototype.draw = function (data) {
	        if (data === void 0) { data = this.oldData; }
	        if (data) {
	            var sliderOuterWidth = this.slider.element.offsetWidth;
	            var sliderOuterHeight = this.slider.element.offsetHeight;
	            var width = sliderOuterWidth - this.slider.options.graph.margin.left - this.slider.options.graph.margin.right;
	            var height = sliderOuterHeight - this.slider.options.graph.margin.top - this.slider.options.graph.margin.bottom;
	            this.applyTransformOnSvg(width, height);
	            this.setXAndYRange(width, height);
	            this.setXAndYDomain(data);
	            var bars = this.svg.selectAll('.coveo-bar').data(data);
	            var currentSliderValues = this.slider.getValues();
	            this.renderGraphBars(bars, width, height, currentSliderValues);
	            this.setGraphBarsTransition(bars, height, currentSliderValues);
	            this.oldData = data;
	        }
	    };
	    SliderGraph.prototype.setXAndYRange = function (width, height) {
	        this.x.range([0, width]);
	        this.x.padding(0.2);
	        this.y.range([height - this.slider.options.graph.margin.top, 0]);
	    };
	    SliderGraph.prototype.setXAndYDomain = function (data) {
	        this.padGraphWithEmptyData(data);
	        this.x.domain(_.map(data, function (d) {
	            return d.start;
	        }));
	        this.y.domain([0, d3.max(data, function (d) {
	                return d.y;
	            })]);
	    };
	    SliderGraph.prototype.padGraphWithEmptyData = function (data) {
	        var oneStepOfGraph = data[0].end - data[0].start;
	        if (oneStepOfGraph != 0) {
	            this.padBeginningOfGraphWithEmptyData(data, oneStepOfGraph);
	            this.padEndOfGraphWithEmptyData(data, oneStepOfGraph);
	        }
	    };
	    SliderGraph.prototype.padBeginningOfGraphWithEmptyData = function (data, oneStepOfGraph) {
	        if (data[0].start > this.slider.options.start) {
	            var difToFillAtStart = data[0].start - this.slider.options.start;
	            var nbOfStepsAtStart = Math.round(difToFillAtStart / oneStepOfGraph);
	            var currentStep = data[0].start;
	            for (var i = nbOfStepsAtStart; i > 0; i--) {
	                data.unshift({ start: currentStep - oneStepOfGraph, end: currentStep, y: 0 });
	                currentStep -= oneStepOfGraph;
	            }
	        }
	    };
	    SliderGraph.prototype.padEndOfGraphWithEmptyData = function (data, oneStepOfGraph) {
	        var lastDataIndex = data.length - 1;
	        if (data[lastDataIndex].end < this.slider.options.end) {
	            var diffToFillAtEnd = this.slider.options.end - data[lastDataIndex].end;
	            var nbOfStepsAtEnd = Math.round(diffToFillAtEnd / oneStepOfGraph);
	            var currentStep = data[lastDataIndex].end;
	            for (var i = 0; i < nbOfStepsAtEnd; i++) {
	                data.push({ start: currentStep, end: currentStep + oneStepOfGraph, y: 0 });
	                currentStep += oneStepOfGraph;
	            }
	        }
	    };
	    SliderGraph.prototype.applyTransformOnSvg = function (width, height) {
	        var svg = Dom_1.$$(this.slider.element).find('svg');
	        svg.setAttribute('width', width + 'px');
	        svg.setAttribute('height', height + 'px');
	        this.svg.attr('transform', 'translate(' + this.slider.options.graph.margin.left + ',' + this.slider.options.graph.margin.top + ')');
	    };
	    SliderGraph.prototype.renderGraphBars = function (bars, width, height, currentSliderValues) {
	        bars.enter().append('rect')
	            .attr('class', this.getFunctionForClass(currentSliderValues))
	            .attr('width', this.x.bandwidth())
	            .attr('height', this.getFunctionForHeight(height))
	            .attr('x', this.getFunctionForX())
	            .attr('y', this.getFunctionForY())
	            .on('click', this.getFunctionForClick())
	            .on('mouseover', this.getFunctionForMouseOver(height))
	            .on('mouseout', this.getFunctionForMouseOut());
	    };
	    SliderGraph.prototype.setGraphBarsTransition = function (bars, height, currentSliderValues) {
	        bars
	            .transition()
	            .attr('x', this.getFunctionForX())
	            .attr('width', this.x.bandwidth())
	            .attr('class', this.getFunctionForClass(currentSliderValues))
	            .transition()
	            .duration(this.slider.options.graph.animationDuration)
	            .attr('y', this.getFunctionForY())
	            .attr('height', this.getFunctionForHeight(height));
	    };
	    SliderGraph.prototype.getBarClass = function (currentSliderValues, d, i) {
	        if (d.start >= currentSliderValues[0] && d.end <= currentSliderValues[1]) {
	            return 'coveo-active';
	        }
	        else if (currentSliderValues[0] == this.slider.options.start && i == 0) {
	            return 'coveo-active';
	        }
	        else if (currentSliderValues[1] == this.slider.options.end && i == this.slider.options.graph.steps - 1) {
	            return 'coveo-active';
	        }
	        else {
	            return '';
	        }
	    };
	    SliderGraph.prototype.setTooltip = function (d, height) {
	        var caption = Dom_1.$$('span', {
	            className: 'coveo-caption'
	        });
	        caption.text(this.slider.getCaptionFromValue([d.start, d.end]));
	        var count = Dom_1.$$('span', {
	            className: 'coveo-count'
	        });
	        count.text(d.y.toString());
	        Dom_1.$$(this.tooltip).empty();
	        this.tooltip.appendChild(caption.el);
	        this.tooltip.appendChild(count.el);
	        this.tooltip.style.display = 'block';
	        this.tooltip.style.left = (this.x(d.start) - (0.2 * this.slider.options.graph.steps)) + 'px';
	        this.tooltip.style.top = (this.y(d.y) - height) + 'px';
	    };
	    SliderGraph.prototype.getFunctionForX = function () {
	        var _this = this;
	        return function (d) {
	            return _this.x(d.start);
	        };
	    };
	    SliderGraph.prototype.getFunctionForY = function () {
	        var _this = this;
	        return function (d) {
	            return _this.y(d.y);
	        };
	    };
	    SliderGraph.prototype.getFunctionForHeight = function (height) {
	        var _this = this;
	        return function (d) {
	            return height - _this.y(d.y);
	        };
	    };
	    SliderGraph.prototype.getFunctionForClass = function (currentSliderValues) {
	        var _this = this;
	        return function (d, i) {
	            return 'coveo-bar ' + _this.getBarClass(currentSliderValues, d, i);
	        };
	    };
	    SliderGraph.prototype.getFunctionForClick = function () {
	        var _this = this;
	        return function (d, i) {
	            Dom_1.$$(_this.slider.element).trigger(SliderEvents_1.SliderEvents.graphValueSelected, {
	                start: d.start,
	                end: d.end,
	                value: d.y
	            });
	        };
	    };
	    SliderGraph.prototype.getFunctionForMouseOver = function (height) {
	        var _this = this;
	        return function (d) {
	            _this.setTooltip(d, height);
	        };
	    };
	    SliderGraph.prototype.getFunctionForMouseOut = function () {
	        var _this = this;
	        return function () {
	            _this.tooltip.style.display = 'none';
	        };
	    };
	    return SliderGraph;
	}());
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-scale/ Version 1.0.4. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports, __webpack_require__(166), __webpack_require__(167), __webpack_require__(168), __webpack_require__(170), __webpack_require__(171), __webpack_require__(172), __webpack_require__(169)) :
	  typeof define === 'function' && define.amd ? define(['exports', 'd3-array', 'd3-collection', 'd3-interpolate', 'd3-format', 'd3-time', 'd3-time-format', 'd3-color'], factory) :
	  (factory((global.d3 = global.d3 || {}),global.d3,global.d3,global.d3,global.d3,global.d3,global.d3,global.d3));
	}(this, (function (exports,d3Array,d3Collection,d3Interpolate,d3Format,d3Time,d3TimeFormat,d3Color) { 'use strict';
	
	var array = Array.prototype;
	
	var map$1 = array.map;
	var slice = array.slice;
	
	var implicit = {name: "implicit"};
	
	function ordinal(range$$1) {
	  var index = d3Collection.map(),
	      domain = [],
	      unknown = implicit;
	
	  range$$1 = range$$1 == null ? [] : slice.call(range$$1);
	
	  function scale(d) {
	    var key = d + "", i = index.get(key);
	    if (!i) {
	      if (unknown !== implicit) return unknown;
	      index.set(key, i = domain.push(d));
	    }
	    return range$$1[(i - 1) % range$$1.length];
	  }
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [], index = d3Collection.map();
	    var i = -1, n = _.length, d, key;
	    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
	    return scale;
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), scale) : range$$1.slice();
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.copy = function() {
	    return ordinal()
	        .domain(domain)
	        .range(range$$1)
	        .unknown(unknown);
	  };
	
	  return scale;
	}
	
	function band() {
	  var scale = ordinal().unknown(undefined),
	      domain = scale.domain,
	      ordinalRange = scale.range,
	      range$$1 = [0, 1],
	      step,
	      bandwidth,
	      round = false,
	      paddingInner = 0,
	      paddingOuter = 0,
	      align = 0.5;
	
	  delete scale.unknown;
	
	  function rescale() {
	    var n = domain().length,
	        reverse = range$$1[1] < range$$1[0],
	        start = range$$1[reverse - 0],
	        stop = range$$1[1 - reverse];
	    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
	    if (round) step = Math.floor(step);
	    start += (stop - start - step * (n - paddingInner)) * align;
	    bandwidth = step * (1 - paddingInner);
	    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
	    var values = d3Array.range(n).map(function(i) { return start + step * i; });
	    return ordinalRange(reverse ? values.reverse() : values);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = [+_[0], +_[1]], rescale()) : range$$1.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range$$1 = [+_[0], +_[1]], round = true, rescale();
	  };
	
	  scale.bandwidth = function() {
	    return bandwidth;
	  };
	
	  scale.step = function() {
	    return step;
	  };
	
	  scale.round = function(_) {
	    return arguments.length ? (round = !!_, rescale()) : round;
	  };
	
	  scale.padding = function(_) {
	    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingInner = function(_) {
	    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingOuter = function(_) {
	    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
	  };
	
	  scale.align = function(_) {
	    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
	  };
	
	  scale.copy = function() {
	    return band()
	        .domain(domain())
	        .range(range$$1)
	        .round(round)
	        .paddingInner(paddingInner)
	        .paddingOuter(paddingOuter)
	        .align(align);
	  };
	
	  return rescale();
	}
	
	function pointish(scale) {
	  var copy = scale.copy;
	
	  scale.padding = scale.paddingOuter;
	  delete scale.paddingInner;
	  delete scale.paddingOuter;
	
	  scale.copy = function() {
	    return pointish(copy());
	  };
	
	  return scale;
	}
	
	function point() {
	  return pointish(band().paddingInner(1));
	}
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var number = function(x) {
	  return +x;
	};
	
	var unit = [0, 1];
	
	function deinterpolateLinear(a, b) {
	  return (b -= (a = +a))
	      ? function(x) { return (x - a) / b; }
	      : constant(b);
	}
	
	function deinterpolateClamp(deinterpolate) {
	  return function(a, b) {
	    var d = deinterpolate(a = +a, b = +b);
	    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
	  };
	}
	
	function reinterpolateClamp(reinterpolate) {
	  return function(a, b) {
	    var r = reinterpolate(a = +a, b = +b);
	    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
	  };
	}
	
	function bimap(domain, range$$1, deinterpolate, reinterpolate) {
	  var d0 = domain[0], d1 = domain[1], r0 = range$$1[0], r1 = range$$1[1];
	  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
	  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
	  return function(x) { return r0(d0(x)); };
	}
	
	function polymap(domain, range$$1, deinterpolate, reinterpolate) {
	  var j = Math.min(domain.length, range$$1.length) - 1,
	      d = new Array(j),
	      r = new Array(j),
	      i = -1;
	
	  // Reverse descending domains.
	  if (domain[j] < domain[0]) {
	    domain = domain.slice().reverse();
	    range$$1 = range$$1.slice().reverse();
	  }
	
	  while (++i < j) {
	    d[i] = deinterpolate(domain[i], domain[i + 1]);
	    r[i] = reinterpolate(range$$1[i], range$$1[i + 1]);
	  }
	
	  return function(x) {
	    var i = d3Array.bisect(domain, x, 1, j) - 1;
	    return r[i](d[i](x));
	  };
	}
	
	function copy(source, target) {
	  return target
	      .domain(source.domain())
	      .range(source.range())
	      .interpolate(source.interpolate())
	      .clamp(source.clamp());
	}
	
	// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
	// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
	function continuous(deinterpolate, reinterpolate) {
	  var domain = unit,
	      range$$1 = unit,
	      interpolate$$1 = d3Interpolate.interpolate,
	      clamp = false,
	      piecewise,
	      output,
	      input;
	
	  function rescale() {
	    piecewise = Math.min(domain.length, range$$1.length) > 2 ? polymap : bimap;
	    output = input = null;
	    return scale;
	  }
	
	  function scale(x) {
	    return (output || (output = piecewise(domain, range$$1, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate$$1)))(+x);
	  }
	
	  scale.invert = function(y) {
	    return (input || (input = piecewise(range$$1, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = map$1.call(_, number), rescale()) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), rescale()) : range$$1.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range$$1 = slice.call(_), interpolate$$1 = d3Interpolate.interpolateRound, rescale();
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, rescale()) : clamp;
	  };
	
	  scale.interpolate = function(_) {
	    return arguments.length ? (interpolate$$1 = _, rescale()) : interpolate$$1;
	  };
	
	  return rescale();
	}
	
	var tickFormat = function(domain, count, specifier) {
	  var start = domain[0],
	      stop = domain[domain.length - 1],
	      step = d3Array.tickStep(start, stop, count == null ? 10 : count),
	      precision;
	  specifier = d3Format.formatSpecifier(specifier == null ? ",f" : specifier);
	  switch (specifier.type) {
	    case "s": {
	      var value = Math.max(Math.abs(start), Math.abs(stop));
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionPrefix(step, value))) specifier.precision = precision;
	      return d3Format.formatPrefix(specifier, value);
	    }
	    case "":
	    case "e":
	    case "g":
	    case "p":
	    case "r": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
	      break;
	    }
	    case "f":
	    case "%": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
	      break;
	    }
	  }
	  return d3Format.format(specifier);
	};
	
	function linearish(scale) {
	  var domain = scale.domain;
	
	  scale.ticks = function(count) {
	    var d = domain();
	    return d3Array.ticks(d[0], d[d.length - 1], count == null ? 10 : count);
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return tickFormat(domain(), count, specifier);
	  };
	
	  scale.nice = function(count) {
	    var d = domain(),
	        i = d.length - 1,
	        n = count == null ? 10 : count,
	        start = d[0],
	        stop = d[i],
	        step = d3Array.tickStep(start, stop, n);
	
	    if (step) {
	      step = d3Array.tickStep(Math.floor(start / step) * step, Math.ceil(stop / step) * step, n);
	      d[0] = Math.floor(start / step) * step;
	      d[i] = Math.ceil(stop / step) * step;
	      domain(d);
	    }
	
	    return scale;
	  };
	
	  return scale;
	}
	
	function linear() {
	  var scale = continuous(deinterpolateLinear, d3Interpolate.interpolateNumber);
	
	  scale.copy = function() {
	    return copy(scale, linear());
	  };
	
	  return linearish(scale);
	}
	
	function identity() {
	  var domain = [0, 1];
	
	  function scale(x) {
	    return +x;
	  }
	
	  scale.invert = scale;
	
	  scale.domain = scale.range = function(_) {
	    return arguments.length ? (domain = map$1.call(_, number), scale) : domain.slice();
	  };
	
	  scale.copy = function() {
	    return identity().domain(domain);
	  };
	
	  return linearish(scale);
	}
	
	var nice = function(domain, interval) {
	  domain = domain.slice();
	
	  var i0 = 0,
	      i1 = domain.length - 1,
	      x0 = domain[i0],
	      x1 = domain[i1],
	      t;
	
	  if (x1 < x0) {
	    t = i0, i0 = i1, i1 = t;
	    t = x0, x0 = x1, x1 = t;
	  }
	
	  domain[i0] = interval.floor(x0);
	  domain[i1] = interval.ceil(x1);
	  return domain;
	};
	
	function deinterpolate(a, b) {
	  return (b = Math.log(b / a))
	      ? function(x) { return Math.log(x / a) / b; }
	      : constant(b);
	}
	
	function reinterpolate(a, b) {
	  return a < 0
	      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
	      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
	}
	
	function pow10(x) {
	  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
	}
	
	function powp(base) {
	  return base === 10 ? pow10
	      : base === Math.E ? Math.exp
	      : function(x) { return Math.pow(base, x); };
	}
	
	function logp(base) {
	  return base === Math.E ? Math.log
	      : base === 10 && Math.log10
	      || base === 2 && Math.log2
	      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
	}
	
	function reflect(f) {
	  return function(x) {
	    return -f(-x);
	  };
	}
	
	function log() {
	  var scale = continuous(deinterpolate, reinterpolate).domain([1, 10]),
	      domain = scale.domain,
	      base = 10,
	      logs = logp(10),
	      pows = powp(10);
	
	  function rescale() {
	    logs = logp(base), pows = powp(base);
	    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
	    return scale;
	  }
	
	  scale.base = function(_) {
	    return arguments.length ? (base = +_, rescale()) : base;
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.ticks = function(count) {
	    var d = domain(),
	        u = d[0],
	        v = d[d.length - 1],
	        r;
	
	    if (r = v < u) i = u, u = v, v = i;
	
	    var i = logs(u),
	        j = logs(v),
	        p,
	        k,
	        t,
	        n = count == null ? 10 : +count,
	        z = [];
	
	    if (!(base % 1) && j - i < n) {
	      i = Math.round(i) - 1, j = Math.round(j) + 1;
	      if (u > 0) for (; i < j; ++i) {
	        for (k = 1, p = pows(i); k < base; ++k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      } else for (; i < j; ++i) {
	        for (k = base - 1, p = pows(i); k >= 1; --k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      }
	    } else {
	      z = d3Array.ticks(i, j, Math.min(j - i, n)).map(pows);
	    }
	
	    return r ? z.reverse() : z;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
	    if (typeof specifier !== "function") specifier = d3Format.format(specifier);
	    if (count === Infinity) return specifier;
	    if (count == null) count = 10;
	    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
	    return function(d) {
	      var i = d / pows(Math.round(logs(d)));
	      if (i * base < base - 0.5) i *= base;
	      return i <= k ? specifier(d) : "";
	    };
	  };
	
	  scale.nice = function() {
	    return domain(nice(domain(), {
	      floor: function(x) { return pows(Math.floor(logs(x))); },
	      ceil: function(x) { return pows(Math.ceil(logs(x))); }
	    }));
	  };
	
	  scale.copy = function() {
	    return copy(scale, log().base(base));
	  };
	
	  return scale;
	}
	
	function raise(x, exponent) {
	  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
	}
	
	function pow() {
	  var exponent = 1,
	      scale = continuous(deinterpolate, reinterpolate),
	      domain = scale.domain;
	
	  function deinterpolate(a, b) {
	    return (b = raise(b, exponent) - (a = raise(a, exponent)))
	        ? function(x) { return (raise(x, exponent) - a) / b; }
	        : constant(b);
	  }
	
	  function reinterpolate(a, b) {
	    b = raise(b, exponent) - (a = raise(a, exponent));
	    return function(t) { return raise(a + b * t, 1 / exponent); };
	  }
	
	  scale.exponent = function(_) {
	    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
	  };
	
	  scale.copy = function() {
	    return copy(scale, pow().exponent(exponent));
	  };
	
	  return linearish(scale);
	}
	
	function sqrt() {
	  return pow().exponent(0.5);
	}
	
	function quantile$1() {
	  var domain = [],
	      range$$1 = [],
	      thresholds = [];
	
	  function rescale() {
	    var i = 0, n = Math.max(1, range$$1.length);
	    thresholds = new Array(n - 1);
	    while (++i < n) thresholds[i - 1] = d3Array.quantile(domain, i / n);
	    return scale;
	  }
	
	  function scale(x) {
	    if (!isNaN(x = +x)) return range$$1[d3Array.bisect(thresholds, x)];
	  }
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return i < 0 ? [NaN, NaN] : [
	      i > 0 ? thresholds[i - 1] : domain[0],
	      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
	    ];
	  };
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [];
	    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
	    domain.sort(d3Array.ascending);
	    return rescale();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), rescale()) : range$$1.slice();
	  };
	
	  scale.quantiles = function() {
	    return thresholds.slice();
	  };
	
	  scale.copy = function() {
	    return quantile$1()
	        .domain(domain)
	        .range(range$$1);
	  };
	
	  return scale;
	}
	
	function quantize() {
	  var x0 = 0,
	      x1 = 1,
	      n = 1,
	      domain = [0.5],
	      range$$1 = [0, 1];
	
	  function scale(x) {
	    if (x <= x) return range$$1[d3Array.bisect(domain, x, 0, n)];
	  }
	
	  function rescale() {
	    var i = -1;
	    domain = new Array(n);
	    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
	    return scale;
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (n = (range$$1 = slice.call(_)).length - 1, rescale()) : range$$1.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return i < 0 ? [NaN, NaN]
	        : i < 1 ? [x0, domain[0]]
	        : i >= n ? [domain[n - 1], x1]
	        : [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return quantize()
	        .domain([x0, x1])
	        .range(range$$1);
	  };
	
	  return linearish(scale);
	}
	
	function threshold() {
	  var domain = [0.5],
	      range$$1 = [0, 1],
	      n = 1;
	
	  function scale(x) {
	    if (x <= x) return range$$1[d3Array.bisect(domain, x, 0, n)];
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = slice.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : range$$1.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return threshold()
	        .domain(domain)
	        .range(range$$1);
	  };
	
	  return scale;
	}
	
	var durationSecond = 1000;
	var durationMinute = durationSecond * 60;
	var durationHour = durationMinute * 60;
	var durationDay = durationHour * 24;
	var durationWeek = durationDay * 7;
	var durationMonth = durationDay * 30;
	var durationYear = durationDay * 365;
	
	function date(t) {
	  return new Date(t);
	}
	
	function number$1(t) {
	  return t instanceof Date ? +t : +new Date(+t);
	}
	
	function calendar(year, month, week, day, hour, minute, second, millisecond, format$$1) {
	  var scale = continuous(deinterpolateLinear, d3Interpolate.interpolateNumber),
	      invert = scale.invert,
	      domain = scale.domain;
	
	  var formatMillisecond = format$$1(".%L"),
	      formatSecond = format$$1(":%S"),
	      formatMinute = format$$1("%I:%M"),
	      formatHour = format$$1("%I %p"),
	      formatDay = format$$1("%a %d"),
	      formatWeek = format$$1("%b %d"),
	      formatMonth = format$$1("%B"),
	      formatYear = format$$1("%Y");
	
	  var tickIntervals = [
	    [second,  1,      durationSecond],
	    [second,  5,  5 * durationSecond],
	    [second, 15, 15 * durationSecond],
	    [second, 30, 30 * durationSecond],
	    [minute,  1,      durationMinute],
	    [minute,  5,  5 * durationMinute],
	    [minute, 15, 15 * durationMinute],
	    [minute, 30, 30 * durationMinute],
	    [  hour,  1,      durationHour  ],
	    [  hour,  3,  3 * durationHour  ],
	    [  hour,  6,  6 * durationHour  ],
	    [  hour, 12, 12 * durationHour  ],
	    [   day,  1,      durationDay   ],
	    [   day,  2,  2 * durationDay   ],
	    [  week,  1,      durationWeek  ],
	    [ month,  1,      durationMonth ],
	    [ month,  3,  3 * durationMonth ],
	    [  year,  1,      durationYear  ]
	  ];
	
	  function tickFormat(date) {
	    return (second(date) < date ? formatMillisecond
	        : minute(date) < date ? formatSecond
	        : hour(date) < date ? formatMinute
	        : day(date) < date ? formatHour
	        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
	        : year(date) < date ? formatMonth
	        : formatYear)(date);
	  }
	
	  function tickInterval(interval, start, stop, step) {
	    if (interval == null) interval = 10;
	
	    // If a desired tick count is specified, pick a reasonable tick interval
	    // based on the extent of the domain and a rough estimate of tick size.
	    // Otherwise, assume interval is already a time interval and use it.
	    if (typeof interval === "number") {
	      var target = Math.abs(stop - start) / interval,
	          i = d3Array.bisector(function(i) { return i[2]; }).right(tickIntervals, target);
	      if (i === tickIntervals.length) {
	        step = d3Array.tickStep(start / durationYear, stop / durationYear, interval);
	        interval = year;
	      } else if (i) {
	        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
	        step = i[1];
	        interval = i[0];
	      } else {
	        step = d3Array.tickStep(start, stop, interval);
	        interval = millisecond;
	      }
	    }
	
	    return step == null ? interval : interval.every(step);
	  }
	
	  scale.invert = function(y) {
	    return new Date(invert(y));
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? domain(map$1.call(_, number$1)) : domain().map(date);
	  };
	
	  scale.ticks = function(interval, step) {
	    var d = domain(),
	        t0 = d[0],
	        t1 = d[d.length - 1],
	        r = t1 < t0,
	        t;
	    if (r) t = t0, t0 = t1, t1 = t;
	    t = tickInterval(interval, t0, t1, step);
	    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
	    return r ? t.reverse() : t;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return specifier == null ? tickFormat : format$$1(specifier);
	  };
	
	  scale.nice = function(interval, step) {
	    var d = domain();
	    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
	        ? domain(nice(d, interval))
	        : scale;
	  };
	
	  scale.copy = function() {
	    return copy(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format$$1));
	  };
	
	  return scale;
	}
	
	var time = function() {
	  return calendar(d3Time.timeYear, d3Time.timeMonth, d3Time.timeWeek, d3Time.timeDay, d3Time.timeHour, d3Time.timeMinute, d3Time.timeSecond, d3Time.timeMillisecond, d3TimeFormat.timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
	};
	
	var utcTime = function() {
	  return calendar(d3Time.utcYear, d3Time.utcMonth, d3Time.utcWeek, d3Time.utcDay, d3Time.utcHour, d3Time.utcMinute, d3Time.utcSecond, d3Time.utcMillisecond, d3TimeFormat.utcFormat).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
	};
	
	var colors = function(s) {
	  return s.match(/.{6}/g).map(function(x) {
	    return "#" + x;
	  });
	};
	
	var category10 = colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");
	
	var category20b = colors("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6");
	
	var category20c = colors("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9");
	
	var category20 = colors("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5");
	
	var cubehelix$1 = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(300, 0.5, 0.0), d3Color.cubehelix(-240, 0.5, 1.0));
	
	var warm = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(-100, 0.75, 0.35), d3Color.cubehelix(80, 1.50, 0.8));
	
	var cool = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(260, 0.75, 0.35), d3Color.cubehelix(80, 1.50, 0.8));
	
	var rainbow = d3Color.cubehelix();
	
	var rainbow$1 = function(t) {
	  if (t < 0 || t > 1) t -= Math.floor(t);
	  var ts = Math.abs(t - 0.5);
	  rainbow.h = 360 * t - 100;
	  rainbow.s = 1.5 - 1.5 * ts;
	  rainbow.l = 0.8 - 0.9 * ts;
	  return rainbow + "";
	};
	
	function ramp(range$$1) {
	  var n = range$$1.length;
	  return function(t) {
	    return range$$1[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
	  };
	}
	
	var viridis = ramp(colors("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
	
	var magma = ramp(colors("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
	
	var inferno = ramp(colors("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
	
	var plasma = ramp(colors("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));
	
	function sequential(interpolator) {
	  var x0 = 0,
	      x1 = 1,
	      clamp = false;
	
	  function scale(x) {
	    var t = (x - x0) / (x1 - x0);
	    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, scale) : clamp;
	  };
	
	  scale.interpolator = function(_) {
	    return arguments.length ? (interpolator = _, scale) : interpolator;
	  };
	
	  scale.copy = function() {
	    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
	  };
	
	  return linearish(scale);
	}
	
	exports.scaleBand = band;
	exports.scalePoint = point;
	exports.scaleIdentity = identity;
	exports.scaleLinear = linear;
	exports.scaleLog = log;
	exports.scaleOrdinal = ordinal;
	exports.scaleImplicit = implicit;
	exports.scalePow = pow;
	exports.scaleSqrt = sqrt;
	exports.scaleQuantile = quantile$1;
	exports.scaleQuantize = quantize;
	exports.scaleThreshold = threshold;
	exports.scaleTime = time;
	exports.scaleUtc = utcTime;
	exports.schemeCategory10 = category10;
	exports.schemeCategory20b = category20b;
	exports.schemeCategory20c = category20c;
	exports.schemeCategory20 = category20;
	exports.interpolateCubehelixDefault = cubehelix$1;
	exports.interpolateRainbow = rainbow$1;
	exports.interpolateWarm = warm;
	exports.interpolateCool = cool;
	exports.interpolateViridis = viridis;
	exports.interpolateMagma = magma;
	exports.interpolateInferno = inferno;
	exports.interpolatePlasma = plasma;
	exports.scaleSequential = sequential;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-array/ Version 1.0.2. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var ascending = function(a, b) {
	  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	};
	
	var bisector = function(compare) {
	  if (compare.length === 1) compare = ascendingComparator(compare);
	  return {
	    left: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) < 0) lo = mid + 1;
	        else hi = mid;
	      }
	      return lo;
	    },
	    right: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) > 0) hi = mid;
	        else lo = mid + 1;
	      }
	      return lo;
	    }
	  };
	};
	
	function ascendingComparator(f) {
	  return function(d, x) {
	    return ascending(f(d), x);
	  };
	}
	
	var ascendingBisect = bisector(ascending);
	var bisectRight = ascendingBisect.right;
	var bisectLeft = ascendingBisect.left;
	
	var descending = function(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	};
	
	var number = function(x) {
	  return x === null ? NaN : +x;
	};
	
	var variance = function(array, f) {
	  var n = array.length,
	      m = 0,
	      a,
	      d,
	      s = 0,
	      i = -1,
	      j = 0;
	
	  if (f == null) {
	    while (++i < n) {
	      if (!isNaN(a = number(array[i]))) {
	        d = a - m;
	        m += d / ++j;
	        s += d * (a - m);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(a = number(f(array[i], i, array)))) {
	        d = a - m;
	        m += d / ++j;
	        s += d * (a - m);
	      }
	    }
	  }
	
	  if (j > 1) return s / (j - 1);
	};
	
	var deviation = function(array, f) {
	  var v = variance(array, f);
	  return v ? Math.sqrt(v) : v;
	};
	
	var extent = function(array, f) {
	  var i = -1,
	      n = array.length,
	      a,
	      b,
	      c;
	
	  if (f == null) {
	    while (++i < n) if ((b = array[i]) != null && b >= b) { a = c = b; break; }
	    while (++i < n) if ((b = array[i]) != null) {
	      if (a > b) a = b;
	      if (c < b) c = b;
	    }
	  }
	
	  else {
	    while (++i < n) if ((b = f(array[i], i, array)) != null && b >= b) { a = c = b; break; }
	    while (++i < n) if ((b = f(array[i], i, array)) != null) {
	      if (a > b) a = b;
	      if (c < b) c = b;
	    }
	  }
	
	  return [a, c];
	};
	
	var array = Array.prototype;
	
	var slice = array.slice;
	var map = array.map;
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var identity = function(x) {
	  return x;
	};
	
	var range = function(start, stop, step) {
	  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
	
	  var i = -1,
	      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
	      range = new Array(n);
	
	  while (++i < n) {
	    range[i] = start + i * step;
	  }
	
	  return range;
	};
	
	var e10 = Math.sqrt(50);
	var e5 = Math.sqrt(10);
	var e2 = Math.sqrt(2);
	
	var ticks = function(start, stop, count) {
	  var step = tickStep(start, stop, count);
	  return range(
	    Math.ceil(start / step) * step,
	    Math.floor(stop / step) * step + step / 2, // inclusive
	    step
	  );
	};
	
	function tickStep(start, stop, count) {
	  var step0 = Math.abs(stop - start) / Math.max(0, count),
	      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
	      error = step0 / step1;
	  if (error >= e10) step1 *= 10;
	  else if (error >= e5) step1 *= 5;
	  else if (error >= e2) step1 *= 2;
	  return stop < start ? -step1 : step1;
	}
	
	var sturges = function(values) {
	  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
	};
	
	var histogram = function() {
	  var value = identity,
	      domain = extent,
	      threshold = sturges;
	
	  function histogram(data) {
	    var i,
	        n = data.length,
	        x,
	        values = new Array(n);
	
	    for (i = 0; i < n; ++i) {
	      values[i] = value(data[i], i, data);
	    }
	
	    var xz = domain(values),
	        x0 = xz[0],
	        x1 = xz[1],
	        tz = threshold(values, x0, x1);
	
	    // Convert number of thresholds into uniform thresholds.
	    if (!Array.isArray(tz)) tz = ticks(x0, x1, tz);
	
	    // Remove any thresholds outside the domain.
	    var m = tz.length;
	    while (tz[0] <= x0) tz.shift(), --m;
	    while (tz[m - 1] >= x1) tz.pop(), --m;
	
	    var bins = new Array(m + 1),
	        bin;
	
	    // Initialize bins.
	    for (i = 0; i <= m; ++i) {
	      bin = bins[i] = [];
	      bin.x0 = i > 0 ? tz[i - 1] : x0;
	      bin.x1 = i < m ? tz[i] : x1;
	    }
	
	    // Assign data to bins by value, ignoring any outside the domain.
	    for (i = 0; i < n; ++i) {
	      x = values[i];
	      if (x0 <= x && x <= x1) {
	        bins[bisectRight(tz, x, 0, m)].push(data[i]);
	      }
	    }
	
	    return bins;
	  }
	
	  histogram.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(_), histogram) : value;
	  };
	
	  histogram.domain = function(_) {
	    return arguments.length ? (domain = typeof _ === "function" ? _ : constant([_[0], _[1]]), histogram) : domain;
	  };
	
	  histogram.thresholds = function(_) {
	    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), histogram) : threshold;
	  };
	
	  return histogram;
	};
	
	var quantile = function(array, p, f) {
	  if (f == null) f = number;
	  if (!(n = array.length)) return;
	  if ((p = +p) <= 0 || n < 2) return +f(array[0], 0, array);
	  if (p >= 1) return +f(array[n - 1], n - 1, array);
	  var n,
	      h = (n - 1) * p,
	      i = Math.floor(h),
	      a = +f(array[i], i, array),
	      b = +f(array[i + 1], i + 1, array);
	  return a + (b - a) * (h - i);
	};
	
	var freedmanDiaconis = function(values, min, max) {
	  values = map.call(values, number).sort(ascending);
	  return Math.ceil((max - min) / (2 * (quantile(values, 0.75) - quantile(values, 0.25)) * Math.pow(values.length, -1 / 3)));
	};
	
	var scott = function(values, min, max) {
	  return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
	};
	
	var max = function(array, f) {
	  var i = -1,
	      n = array.length,
	      a,
	      b;
	
	  if (f == null) {
	    while (++i < n) if ((b = array[i]) != null && b >= b) { a = b; break; }
	    while (++i < n) if ((b = array[i]) != null && b > a) a = b;
	  }
	
	  else {
	    while (++i < n) if ((b = f(array[i], i, array)) != null && b >= b) { a = b; break; }
	    while (++i < n) if ((b = f(array[i], i, array)) != null && b > a) a = b;
	  }
	
	  return a;
	};
	
	var mean = function(array, f) {
	  var s = 0,
	      n = array.length,
	      a,
	      i = -1,
	      j = n;
	
	  if (f == null) {
	    while (++i < n) if (!isNaN(a = number(array[i]))) s += a; else --j;
	  }
	
	  else {
	    while (++i < n) if (!isNaN(a = number(f(array[i], i, array)))) s += a; else --j;
	  }
	
	  if (j) return s / j;
	};
	
	var median = function(array, f) {
	  var numbers = [],
	      n = array.length,
	      a,
	      i = -1;
	
	  if (f == null) {
	    while (++i < n) if (!isNaN(a = number(array[i]))) numbers.push(a);
	  }
	
	  else {
	    while (++i < n) if (!isNaN(a = number(f(array[i], i, array)))) numbers.push(a);
	  }
	
	  return quantile(numbers.sort(ascending), 0.5);
	};
	
	var merge = function(arrays) {
	  var n = arrays.length,
	      m,
	      i = -1,
	      j = 0,
	      merged,
	      array;
	
	  while (++i < n) j += arrays[i].length;
	  merged = new Array(j);
	
	  while (--n >= 0) {
	    array = arrays[n];
	    m = array.length;
	    while (--m >= 0) {
	      merged[--j] = array[m];
	    }
	  }
	
	  return merged;
	};
	
	var min = function(array, f) {
	  var i = -1,
	      n = array.length,
	      a,
	      b;
	
	  if (f == null) {
	    while (++i < n) if ((b = array[i]) != null && b >= b) { a = b; break; }
	    while (++i < n) if ((b = array[i]) != null && a > b) a = b;
	  }
	
	  else {
	    while (++i < n) if ((b = f(array[i], i, array)) != null && b >= b) { a = b; break; }
	    while (++i < n) if ((b = f(array[i], i, array)) != null && a > b) a = b;
	  }
	
	  return a;
	};
	
	var pairs = function(array) {
	  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
	  while (i < n) pairs[i] = [p, p = array[++i]];
	  return pairs;
	};
	
	var permute = function(array, indexes) {
	  var i = indexes.length, permutes = new Array(i);
	  while (i--) permutes[i] = array[indexes[i]];
	  return permutes;
	};
	
	var scan = function(array, compare) {
	  if (!(n = array.length)) return;
	  var i = 0,
	      n,
	      j = 0,
	      xi,
	      xj = array[j];
	
	  if (!compare) compare = ascending;
	
	  while (++i < n) if (compare(xi = array[i], xj) < 0 || compare(xj, xj) !== 0) xj = xi, j = i;
	
	  if (compare(xj, xj) === 0) return j;
	};
	
	var shuffle = function(array, i0, i1) {
	  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
	      t,
	      i;
	
	  while (m) {
	    i = Math.random() * m-- | 0;
	    t = array[m + i0];
	    array[m + i0] = array[i + i0];
	    array[i + i0] = t;
	  }
	
	  return array;
	};
	
	var sum = function(array, f) {
	  var s = 0,
	      n = array.length,
	      a,
	      i = -1;
	
	  if (f == null) {
	    while (++i < n) if (a = +array[i]) s += a; // Note: zero and null are equivalent.
	  }
	
	  else {
	    while (++i < n) if (a = +f(array[i], i, array)) s += a;
	  }
	
	  return s;
	};
	
	var transpose = function(matrix) {
	  if (!(n = matrix.length)) return [];
	  for (var i = -1, m = min(matrix, length), transpose = new Array(m); ++i < m;) {
	    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
	      row[j] = matrix[j][i];
	    }
	  }
	  return transpose;
	};
	
	function length(d) {
	  return d.length;
	}
	
	var zip = function() {
	  return transpose(arguments);
	};
	
	exports.bisect = bisectRight;
	exports.bisectRight = bisectRight;
	exports.bisectLeft = bisectLeft;
	exports.ascending = ascending;
	exports.bisector = bisector;
	exports.descending = descending;
	exports.deviation = deviation;
	exports.extent = extent;
	exports.histogram = histogram;
	exports.thresholdFreedmanDiaconis = freedmanDiaconis;
	exports.thresholdScott = scott;
	exports.thresholdSturges = sturges;
	exports.max = max;
	exports.mean = mean;
	exports.median = median;
	exports.merge = merge;
	exports.min = min;
	exports.pairs = pairs;
	exports.permute = permute;
	exports.quantile = quantile;
	exports.range = range;
	exports.scan = scan;
	exports.shuffle = shuffle;
	exports.sum = sum;
	exports.ticks = ticks;
	exports.tickStep = tickStep;
	exports.transpose = transpose;
	exports.variance = variance;
	exports.zip = zip;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-collection/ Version 1.0.2. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var prefix = "$";
	
	function Map() {}
	
	Map.prototype = map.prototype = {
	  constructor: Map,
	  has: function(key) {
	    return (prefix + key) in this;
	  },
	  get: function(key) {
	    return this[prefix + key];
	  },
	  set: function(key, value) {
	    this[prefix + key] = value;
	    return this;
	  },
	  remove: function(key) {
	    var property = prefix + key;
	    return property in this && delete this[property];
	  },
	  clear: function() {
	    for (var property in this) if (property[0] === prefix) delete this[property];
	  },
	  keys: function() {
	    var keys = [];
	    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
	    return keys;
	  },
	  values: function() {
	    var values = [];
	    for (var property in this) if (property[0] === prefix) values.push(this[property]);
	    return values;
	  },
	  entries: function() {
	    var entries = [];
	    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
	    return entries;
	  },
	  size: function() {
	    var size = 0;
	    for (var property in this) if (property[0] === prefix) ++size;
	    return size;
	  },
	  empty: function() {
	    for (var property in this) if (property[0] === prefix) return false;
	    return true;
	  },
	  each: function(f) {
	    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
	  }
	};
	
	function map(object, f) {
	  var map = new Map;
	
	  // Copy constructor.
	  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });
	
	  // Index array by numeric index or specified key function.
	  else if (Array.isArray(object)) {
	    var i = -1,
	        n = object.length,
	        o;
	
	    if (f == null) while (++i < n) map.set(i, object[i]);
	    else while (++i < n) map.set(f(o = object[i], i, object), o);
	  }
	
	  // Convert object to map.
	  else if (object) for (var key in object) map.set(key, object[key]);
	
	  return map;
	}
	
	var nest = function() {
	  var keys = [],
	      sortKeys = [],
	      sortValues,
	      rollup,
	      nest;
	
	  function apply(array, depth, createResult, setResult) {
	    if (depth >= keys.length) return rollup != null
	        ? rollup(array) : (sortValues != null
	        ? array.sort(sortValues)
	        : array);
	
	    var i = -1,
	        n = array.length,
	        key = keys[depth++],
	        keyValue,
	        value,
	        valuesByKey = map(),
	        values,
	        result = createResult();
	
	    while (++i < n) {
	      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
	        values.push(value);
	      } else {
	        valuesByKey.set(keyValue, [value]);
	      }
	    }
	
	    valuesByKey.each(function(values, key) {
	      setResult(result, key, apply(values, depth, createResult, setResult));
	    });
	
	    return result;
	  }
	
	  function entries(map$$1, depth) {
	    if (++depth > keys.length) return map$$1;
	    var array, sortKey = sortKeys[depth - 1];
	    if (rollup != null && depth >= keys.length) array = map$$1.entries();
	    else array = [], map$$1.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
	    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
	  }
	
	  return nest = {
	    object: function(array) { return apply(array, 0, createObject, setObject); },
	    map: function(array) { return apply(array, 0, createMap, setMap); },
	    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
	    key: function(d) { keys.push(d); return nest; },
	    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
	    sortValues: function(order) { sortValues = order; return nest; },
	    rollup: function(f) { rollup = f; return nest; }
	  };
	};
	
	function createObject() {
	  return {};
	}
	
	function setObject(object, key, value) {
	  object[key] = value;
	}
	
	function createMap() {
	  return map();
	}
	
	function setMap(map$$1, key, value) {
	  map$$1.set(key, value);
	}
	
	function Set() {}
	
	var proto = map.prototype;
	
	Set.prototype = set.prototype = {
	  constructor: Set,
	  has: proto.has,
	  add: function(value) {
	    value += "";
	    this[prefix + value] = value;
	    return this;
	  },
	  remove: proto.remove,
	  clear: proto.clear,
	  values: proto.keys,
	  size: proto.size,
	  empty: proto.empty,
	  each: proto.each
	};
	
	function set(object, f) {
	  var set = new Set;
	
	  // Copy constructor.
	  if (object instanceof Set) object.each(function(value) { set.add(value); });
	
	  // Otherwise, assume it’s an array.
	  else if (object) {
	    var i = -1, n = object.length;
	    if (f == null) while (++i < n) set.add(object[i]);
	    else while (++i < n) set.add(f(object[i], i, object));
	  }
	
	  return set;
	}
	
	var keys = function(map) {
	  var keys = [];
	  for (var key in map) keys.push(key);
	  return keys;
	};
	
	var values = function(map) {
	  var values = [];
	  for (var key in map) values.push(map[key]);
	  return values;
	};
	
	var entries = function(map) {
	  var entries = [];
	  for (var key in map) entries.push({key: key, value: map[key]});
	  return entries;
	};
	
	exports.nest = nest;
	exports.set = set;
	exports.map = map;
	exports.keys = keys;
	exports.values = values;
	exports.entries = entries;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-interpolate/ Version 1.1.2. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports, __webpack_require__(169)) :
	  typeof define === 'function' && define.amd ? define(['exports', 'd3-color'], factory) :
	  (factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Color) { 'use strict';
	
	function basis(t1, v0, v1, v2, v3) {
	  var t2 = t1 * t1, t3 = t2 * t1;
	  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
	      + (4 - 6 * t2 + 3 * t3) * v1
	      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
	      + t3 * v3) / 6;
	}
	
	var basis$1 = function(values) {
	  var n = values.length - 1;
	  return function(t) {
	    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
	        v1 = values[i],
	        v2 = values[i + 1],
	        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
	        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	};
	
	var basisClosed = function(values) {
	  var n = values.length;
	  return function(t) {
	    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
	        v0 = values[(i + n - 1) % n],
	        v1 = values[i % n],
	        v2 = values[(i + 1) % n],
	        v3 = values[(i + 2) % n];
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	};
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function linear(a, d) {
	  return function(t) {
	    return a + t * d;
	  };
	}
	
	function exponential(a, b, y) {
	  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
	    return Math.pow(a + t * b, y);
	  };
	}
	
	function hue(a, b) {
	  var d = b - a;
	  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant(isNaN(a) ? b : a);
	}
	
	function gamma(y) {
	  return (y = +y) === 1 ? nogamma : function(a, b) {
	    return b - a ? exponential(a, b, y) : constant(isNaN(a) ? b : a);
	  };
	}
	
	function nogamma(a, b) {
	  var d = b - a;
	  return d ? linear(a, d) : constant(isNaN(a) ? b : a);
	}
	
	var rgb$1 = (function rgbGamma(y) {
	  var color$$1 = gamma(y);
	
	  function rgb$$1(start, end) {
	    var r = color$$1((start = d3Color.rgb(start)).r, (end = d3Color.rgb(end)).r),
	        g = color$$1(start.g, end.g),
	        b = color$$1(start.b, end.b),
	        opacity = color$$1(start.opacity, end.opacity);
	    return function(t) {
	      start.r = r(t);
	      start.g = g(t);
	      start.b = b(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	
	  rgb$$1.gamma = rgbGamma;
	
	  return rgb$$1;
	})(1);
	
	function rgbSpline(spline) {
	  return function(colors) {
	    var n = colors.length,
	        r = new Array(n),
	        g = new Array(n),
	        b = new Array(n),
	        i, color$$1;
	    for (i = 0; i < n; ++i) {
	      color$$1 = d3Color.rgb(colors[i]);
	      r[i] = color$$1.r || 0;
	      g[i] = color$$1.g || 0;
	      b[i] = color$$1.b || 0;
	    }
	    r = spline(r);
	    g = spline(g);
	    b = spline(b);
	    color$$1.opacity = 1;
	    return function(t) {
	      color$$1.r = r(t);
	      color$$1.g = g(t);
	      color$$1.b = b(t);
	      return color$$1 + "";
	    };
	  };
	}
	
	var rgbBasis = rgbSpline(basis$1);
	var rgbBasisClosed = rgbSpline(basisClosed);
	
	var array = function(a, b) {
	  var nb = b ? b.length : 0,
	      na = a ? Math.min(nb, a.length) : 0,
	      x = new Array(nb),
	      c = new Array(nb),
	      i;
	
	  for (i = 0; i < na; ++i) x[i] = value(a[i], b[i]);
	  for (; i < nb; ++i) c[i] = b[i];
	
	  return function(t) {
	    for (i = 0; i < na; ++i) c[i] = x[i](t);
	    return c;
	  };
	};
	
	var date = function(a, b) {
	  var d = new Date;
	  return a = +a, b -= a, function(t) {
	    return d.setTime(a + b * t), d;
	  };
	};
	
	var number = function(a, b) {
	  return a = +a, b -= a, function(t) {
	    return a + b * t;
	  };
	};
	
	var object = function(a, b) {
	  var i = {},
	      c = {},
	      k;
	
	  if (a === null || typeof a !== "object") a = {};
	  if (b === null || typeof b !== "object") b = {};
	
	  for (k in b) {
	    if (k in a) {
	      i[k] = value(a[k], b[k]);
	    } else {
	      c[k] = b[k];
	    }
	  }
	
	  return function(t) {
	    for (k in i) c[k] = i[k](t);
	    return c;
	  };
	};
	
	var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g;
	var reB = new RegExp(reA.source, "g");
	
	function zero(b) {
	  return function() {
	    return b;
	  };
	}
	
	function one(b) {
	  return function(t) {
	    return b(t) + "";
	  };
	}
	
	var string = function(a, b) {
	  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
	      am, // current match in a
	      bm, // current match in b
	      bs, // string preceding current number in b, if any
	      i = -1, // index in s
	      s = [], // string constants and placeholders
	      q = []; // number interpolators
	
	  // Coerce inputs to strings.
	  a = a + "", b = b + "";
	
	  // Interpolate pairs of numbers in a & b.
	  while ((am = reA.exec(a))
	      && (bm = reB.exec(b))) {
	    if ((bs = bm.index) > bi) { // a string precedes the next number in b
	      bs = b.slice(bi, bs);
	      if (s[i]) s[i] += bs; // coalesce with previous string
	      else s[++i] = bs;
	    }
	    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
	      if (s[i]) s[i] += bm; // coalesce with previous string
	      else s[++i] = bm;
	    } else { // interpolate non-matching numbers
	      s[++i] = null;
	      q.push({i: i, x: number(am, bm)});
	    }
	    bi = reB.lastIndex;
	  }
	
	  // Add remains of b.
	  if (bi < b.length) {
	    bs = b.slice(bi);
	    if (s[i]) s[i] += bs; // coalesce with previous string
	    else s[++i] = bs;
	  }
	
	  // Special optimization for only a single match.
	  // Otherwise, interpolate each of the numbers and rejoin the string.
	  return s.length < 2 ? (q[0]
	      ? one(q[0].x)
	      : zero(b))
	      : (b = q.length, function(t) {
	          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	          return s.join("");
	        });
	};
	
	var value = function(a, b) {
	  var t = typeof b, c;
	  return b == null || t === "boolean" ? constant(b)
	      : (t === "number" ? number
	      : t === "string" ? ((c = d3Color.color(b)) ? (b = c, rgb$1) : string)
	      : b instanceof d3Color.color ? rgb$1
	      : b instanceof Date ? date
	      : Array.isArray(b) ? array
	      : isNaN(b) ? object
	      : number)(a, b);
	};
	
	var round = function(a, b) {
	  return a = +a, b -= a, function(t) {
	    return Math.round(a + b * t);
	  };
	};
	
	var degrees = 180 / Math.PI;
	
	var identity = {
	  translateX: 0,
	  translateY: 0,
	  rotate: 0,
	  skewX: 0,
	  scaleX: 1,
	  scaleY: 1
	};
	
	var decompose = function(a, b, c, d, e, f) {
	  var scaleX, scaleY, skewX;
	  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
	  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
	  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
	  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
	  return {
	    translateX: e,
	    translateY: f,
	    rotate: Math.atan2(b, a) * degrees,
	    skewX: Math.atan(skewX) * degrees,
	    scaleX: scaleX,
	    scaleY: scaleY
	  };
	};
	
	var cssNode;
	var cssRoot;
	var cssView;
	var svgNode;
	
	function parseCss(value) {
	  if (value === "none") return identity;
	  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
	  cssNode.style.transform = value;
	  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
	  cssRoot.removeChild(cssNode);
	  value = value.slice(7, -1).split(",");
	  return decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
	}
	
	function parseSvg(value) {
	  if (value == null) return identity;
	  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
	  svgNode.setAttribute("transform", value);
	  if (!(value = svgNode.transform.baseVal.consolidate())) return identity;
	  value = value.matrix;
	  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
	}
	
	function interpolateTransform(parse, pxComma, pxParen, degParen) {
	
	  function pop(s) {
	    return s.length ? s.pop() + " " : "";
	  }
	
	  function translate(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push("translate(", null, pxComma, null, pxParen);
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb || yb) {
	      s.push("translate(" + xb + pxComma + yb + pxParen);
	    }
	  }
	
	  function rotate(a, b, s, q) {
	    if (a !== b) {
	      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
	      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "rotate(" + b + degParen);
	    }
	  }
	
	  function skewX(a, b, s, q) {
	    if (a !== b) {
	      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "skewX(" + b + degParen);
	    }
	  }
	
	  function scale(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb !== 1 || yb !== 1) {
	      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
	    }
	  }
	
	  return function(a, b) {
	    var s = [], // string constants and placeholders
	        q = []; // number interpolators
	    a = parse(a), b = parse(b);
	    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
	    rotate(a.rotate, b.rotate, s, q);
	    skewX(a.skewX, b.skewX, s, q);
	    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
	    a = b = null; // gc
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  };
	}
	
	var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
	var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
	
	var rho = Math.SQRT2;
	var rho2 = 2;
	var rho4 = 4;
	var epsilon2 = 1e-12;
	
	function cosh(x) {
	  return ((x = Math.exp(x)) + 1 / x) / 2;
	}
	
	function sinh(x) {
	  return ((x = Math.exp(x)) - 1 / x) / 2;
	}
	
	function tanh(x) {
	  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	}
	
	// p0 = [ux0, uy0, w0]
	// p1 = [ux1, uy1, w1]
	var zoom = function(p0, p1) {
	  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
	      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
	      dx = ux1 - ux0,
	      dy = uy1 - uy0,
	      d2 = dx * dx + dy * dy,
	      i,
	      S;
	
	  // Special case for u0 ≅ u1.
	  if (d2 < epsilon2) {
	    S = Math.log(w1 / w0) / rho;
	    i = function(t) {
	      return [
	        ux0 + t * dx,
	        uy0 + t * dy,
	        w0 * Math.exp(rho * t * S)
	      ];
	    };
	  }
	
	  // General case.
	  else {
	    var d1 = Math.sqrt(d2),
	        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
	        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
	        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
	        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	    S = (r1 - r0) / rho;
	    i = function(t) {
	      var s = t * S,
	          coshr0 = cosh(r0),
	          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
	      return [
	        ux0 + u * dx,
	        uy0 + u * dy,
	        w0 * coshr0 / cosh(rho * s + r0)
	      ];
	    };
	  }
	
	  i.duration = S * 1000;
	
	  return i;
	};
	
	function hsl$1(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = d3Color.hsl(start)).h, (end = d3Color.hsl(end)).h),
	        s = nogamma(start.s, end.s),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.s = s(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hsl$2 = hsl$1(hue);
	var hslLong = hsl$1(nogamma);
	
	function lab$1(start, end) {
	  var l = nogamma((start = d3Color.lab(start)).l, (end = d3Color.lab(end)).l),
	      a = nogamma(start.a, end.a),
	      b = nogamma(start.b, end.b),
	      opacity = nogamma(start.opacity, end.opacity);
	  return function(t) {
	    start.l = l(t);
	    start.a = a(t);
	    start.b = b(t);
	    start.opacity = opacity(t);
	    return start + "";
	  };
	}
	
	function hcl$1(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = d3Color.hcl(start)).h, (end = d3Color.hcl(end)).h),
	        c = nogamma(start.c, end.c),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.c = c(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hcl$2 = hcl$1(hue);
	var hclLong = hcl$1(nogamma);
	
	function cubehelix$1(hue$$1) {
	  return (function cubehelixGamma(y) {
	    y = +y;
	
	    function cubehelix$$1(start, end) {
	      var h = hue$$1((start = d3Color.cubehelix(start)).h, (end = d3Color.cubehelix(end)).h),
	          s = nogamma(start.s, end.s),
	          l = nogamma(start.l, end.l),
	          opacity = nogamma(start.opacity, end.opacity);
	      return function(t) {
	        start.h = h(t);
	        start.s = s(t);
	        start.l = l(Math.pow(t, y));
	        start.opacity = opacity(t);
	        return start + "";
	      };
	    }
	
	    cubehelix$$1.gamma = cubehelixGamma;
	
	    return cubehelix$$1;
	  })(1);
	}
	
	var cubehelix$2 = cubehelix$1(hue);
	var cubehelixLong = cubehelix$1(nogamma);
	
	var quantize = function(interpolator, n) {
	  var samples = new Array(n);
	  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
	  return samples;
	};
	
	exports.interpolate = value;
	exports.interpolateArray = array;
	exports.interpolateBasis = basis$1;
	exports.interpolateBasisClosed = basisClosed;
	exports.interpolateDate = date;
	exports.interpolateNumber = number;
	exports.interpolateObject = object;
	exports.interpolateRound = round;
	exports.interpolateString = string;
	exports.interpolateTransformCss = interpolateTransformCss;
	exports.interpolateTransformSvg = interpolateTransformSvg;
	exports.interpolateZoom = zoom;
	exports.interpolateRgb = rgb$1;
	exports.interpolateRgbBasis = rgbBasis;
	exports.interpolateRgbBasisClosed = rgbBasisClosed;
	exports.interpolateHsl = hsl$2;
	exports.interpolateHslLong = hslLong;
	exports.interpolateLab = lab$1;
	exports.interpolateHcl = hcl$2;
	exports.interpolateHclLong = hclLong;
	exports.interpolateCubehelix = cubehelix$2;
	exports.interpolateCubehelixLong = cubehelixLong;
	exports.quantize = quantize;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-color/ Version 1.0.2. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var define = function(constructor, factory, prototype) {
	  constructor.prototype = factory.prototype = prototype;
	  prototype.constructor = constructor;
	};
	
	function extend(parent, definition) {
	  var prototype = Object.create(parent.prototype);
	  for (var key in definition) prototype[key] = definition[key];
	  return prototype;
	}
	
	function Color() {}
	
	var darker = 0.7;
	var brighter = 1 / darker;
	
	var reI = "\\s*([+-]?\\d+)\\s*";
	var reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*";
	var reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*";
	var reHex3 = /^#([0-9a-f]{3})$/;
	var reHex6 = /^#([0-9a-f]{6})$/;
	var reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$");
	var reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$");
	var reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$");
	var reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$");
	var reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$");
	var reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");
	
	var named = {
	  aliceblue: 0xf0f8ff,
	  antiquewhite: 0xfaebd7,
	  aqua: 0x00ffff,
	  aquamarine: 0x7fffd4,
	  azure: 0xf0ffff,
	  beige: 0xf5f5dc,
	  bisque: 0xffe4c4,
	  black: 0x000000,
	  blanchedalmond: 0xffebcd,
	  blue: 0x0000ff,
	  blueviolet: 0x8a2be2,
	  brown: 0xa52a2a,
	  burlywood: 0xdeb887,
	  cadetblue: 0x5f9ea0,
	  chartreuse: 0x7fff00,
	  chocolate: 0xd2691e,
	  coral: 0xff7f50,
	  cornflowerblue: 0x6495ed,
	  cornsilk: 0xfff8dc,
	  crimson: 0xdc143c,
	  cyan: 0x00ffff,
	  darkblue: 0x00008b,
	  darkcyan: 0x008b8b,
	  darkgoldenrod: 0xb8860b,
	  darkgray: 0xa9a9a9,
	  darkgreen: 0x006400,
	  darkgrey: 0xa9a9a9,
	  darkkhaki: 0xbdb76b,
	  darkmagenta: 0x8b008b,
	  darkolivegreen: 0x556b2f,
	  darkorange: 0xff8c00,
	  darkorchid: 0x9932cc,
	  darkred: 0x8b0000,
	  darksalmon: 0xe9967a,
	  darkseagreen: 0x8fbc8f,
	  darkslateblue: 0x483d8b,
	  darkslategray: 0x2f4f4f,
	  darkslategrey: 0x2f4f4f,
	  darkturquoise: 0x00ced1,
	  darkviolet: 0x9400d3,
	  deeppink: 0xff1493,
	  deepskyblue: 0x00bfff,
	  dimgray: 0x696969,
	  dimgrey: 0x696969,
	  dodgerblue: 0x1e90ff,
	  firebrick: 0xb22222,
	  floralwhite: 0xfffaf0,
	  forestgreen: 0x228b22,
	  fuchsia: 0xff00ff,
	  gainsboro: 0xdcdcdc,
	  ghostwhite: 0xf8f8ff,
	  gold: 0xffd700,
	  goldenrod: 0xdaa520,
	  gray: 0x808080,
	  green: 0x008000,
	  greenyellow: 0xadff2f,
	  grey: 0x808080,
	  honeydew: 0xf0fff0,
	  hotpink: 0xff69b4,
	  indianred: 0xcd5c5c,
	  indigo: 0x4b0082,
	  ivory: 0xfffff0,
	  khaki: 0xf0e68c,
	  lavender: 0xe6e6fa,
	  lavenderblush: 0xfff0f5,
	  lawngreen: 0x7cfc00,
	  lemonchiffon: 0xfffacd,
	  lightblue: 0xadd8e6,
	  lightcoral: 0xf08080,
	  lightcyan: 0xe0ffff,
	  lightgoldenrodyellow: 0xfafad2,
	  lightgray: 0xd3d3d3,
	  lightgreen: 0x90ee90,
	  lightgrey: 0xd3d3d3,
	  lightpink: 0xffb6c1,
	  lightsalmon: 0xffa07a,
	  lightseagreen: 0x20b2aa,
	  lightskyblue: 0x87cefa,
	  lightslategray: 0x778899,
	  lightslategrey: 0x778899,
	  lightsteelblue: 0xb0c4de,
	  lightyellow: 0xffffe0,
	  lime: 0x00ff00,
	  limegreen: 0x32cd32,
	  linen: 0xfaf0e6,
	  magenta: 0xff00ff,
	  maroon: 0x800000,
	  mediumaquamarine: 0x66cdaa,
	  mediumblue: 0x0000cd,
	  mediumorchid: 0xba55d3,
	  mediumpurple: 0x9370db,
	  mediumseagreen: 0x3cb371,
	  mediumslateblue: 0x7b68ee,
	  mediumspringgreen: 0x00fa9a,
	  mediumturquoise: 0x48d1cc,
	  mediumvioletred: 0xc71585,
	  midnightblue: 0x191970,
	  mintcream: 0xf5fffa,
	  mistyrose: 0xffe4e1,
	  moccasin: 0xffe4b5,
	  navajowhite: 0xffdead,
	  navy: 0x000080,
	  oldlace: 0xfdf5e6,
	  olive: 0x808000,
	  olivedrab: 0x6b8e23,
	  orange: 0xffa500,
	  orangered: 0xff4500,
	  orchid: 0xda70d6,
	  palegoldenrod: 0xeee8aa,
	  palegreen: 0x98fb98,
	  paleturquoise: 0xafeeee,
	  palevioletred: 0xdb7093,
	  papayawhip: 0xffefd5,
	  peachpuff: 0xffdab9,
	  peru: 0xcd853f,
	  pink: 0xffc0cb,
	  plum: 0xdda0dd,
	  powderblue: 0xb0e0e6,
	  purple: 0x800080,
	  rebeccapurple: 0x663399,
	  red: 0xff0000,
	  rosybrown: 0xbc8f8f,
	  royalblue: 0x4169e1,
	  saddlebrown: 0x8b4513,
	  salmon: 0xfa8072,
	  sandybrown: 0xf4a460,
	  seagreen: 0x2e8b57,
	  seashell: 0xfff5ee,
	  sienna: 0xa0522d,
	  silver: 0xc0c0c0,
	  skyblue: 0x87ceeb,
	  slateblue: 0x6a5acd,
	  slategray: 0x708090,
	  slategrey: 0x708090,
	  snow: 0xfffafa,
	  springgreen: 0x00ff7f,
	  steelblue: 0x4682b4,
	  tan: 0xd2b48c,
	  teal: 0x008080,
	  thistle: 0xd8bfd8,
	  tomato: 0xff6347,
	  turquoise: 0x40e0d0,
	  violet: 0xee82ee,
	  wheat: 0xf5deb3,
	  white: 0xffffff,
	  whitesmoke: 0xf5f5f5,
	  yellow: 0xffff00,
	  yellowgreen: 0x9acd32
	};
	
	define(Color, color, {
	  displayable: function() {
	    return this.rgb().displayable();
	  },
	  toString: function() {
	    return this.rgb() + "";
	  }
	});
	
	function color(format) {
	  var m;
	  format = (format + "").trim().toLowerCase();
	  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
	      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
	      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
	      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
	      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
	      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
	      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
	      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
	      : named.hasOwnProperty(format) ? rgbn(named[format])
	      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
	      : null;
	}
	
	function rgbn(n) {
	  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
	}
	
	function rgba(r, g, b, a) {
	  if (a <= 0) r = g = b = NaN;
	  return new Rgb(r, g, b, a);
	}
	
	function rgbConvert(o) {
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Rgb;
	  o = o.rgb();
	  return new Rgb(o.r, o.g, o.b, o.opacity);
	}
	
	function rgb(r, g, b, opacity) {
	  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
	}
	
	function Rgb(r, g, b, opacity) {
	  this.r = +r;
	  this.g = +g;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Rgb, rgb, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  rgb: function() {
	    return this;
	  },
	  displayable: function() {
	    return (0 <= this.r && this.r <= 255)
	        && (0 <= this.g && this.g <= 255)
	        && (0 <= this.b && this.b <= 255)
	        && (0 <= this.opacity && this.opacity <= 1);
	  },
	  toString: function() {
	    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
	    return (a === 1 ? "rgb(" : "rgba(")
	        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
	        + (a === 1 ? ")" : ", " + a + ")");
	  }
	}));
	
	function hsla(h, s, l, a) {
	  if (a <= 0) h = s = l = NaN;
	  else if (l <= 0 || l >= 1) h = s = NaN;
	  else if (s <= 0) h = NaN;
	  return new Hsl(h, s, l, a);
	}
	
	function hslConvert(o) {
	  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Hsl;
	  if (o instanceof Hsl) return o;
	  o = o.rgb();
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      h = NaN,
	      s = max - min,
	      l = (max + min) / 2;
	  if (s) {
	    if (r === max) h = (g - b) / s + (g < b) * 6;
	    else if (g === max) h = (b - r) / s + 2;
	    else h = (r - g) / s + 4;
	    s /= l < 0.5 ? max + min : 2 - max - min;
	    h *= 60;
	  } else {
	    s = l > 0 && l < 1 ? 0 : h;
	  }
	  return new Hsl(h, s, l, o.opacity);
	}
	
	function hsl(h, s, l, opacity) {
	  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Hsl(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hsl, hsl, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = this.h % 360 + (this.h < 0) * 360,
	        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
	        l = this.l,
	        m2 = l + (l < 0.5 ? l : 1 - l) * s,
	        m1 = 2 * l - m2;
	    return new Rgb(
	      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
	      hsl2rgb(h, m1, m2),
	      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
	      this.opacity
	    );
	  },
	  displayable: function() {
	    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
	        && (0 <= this.l && this.l <= 1)
	        && (0 <= this.opacity && this.opacity <= 1);
	  }
	}));
	
	/* From FvD 13.37, CSS Color Module Level 3 */
	function hsl2rgb(h, m1, m2) {
	  return (h < 60 ? m1 + (m2 - m1) * h / 60
	      : h < 180 ? m2
	      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
	      : m1) * 255;
	}
	
	var deg2rad = Math.PI / 180;
	var rad2deg = 180 / Math.PI;
	
	var Kn = 18;
	var Xn = 0.950470;
	var Yn = 1;
	var Zn = 1.088830;
	var t0 = 4 / 29;
	var t1 = 6 / 29;
	var t2 = 3 * t1 * t1;
	var t3 = t1 * t1 * t1;
	
	function labConvert(o) {
	  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
	  if (o instanceof Hcl) {
	    var h = o.h * deg2rad;
	    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
	  }
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var b = rgb2xyz(o.r),
	      a = rgb2xyz(o.g),
	      l = rgb2xyz(o.b),
	      x = xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / Xn),
	      y = xyz2lab((0.2126729 * b + 0.7151522 * a + 0.0721750 * l) / Yn),
	      z = xyz2lab((0.0193339 * b + 0.1191920 * a + 0.9503041 * l) / Zn);
	  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
	}
	
	function lab(l, a, b, opacity) {
	  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
	}
	
	function Lab(l, a, b, opacity) {
	  this.l = +l;
	  this.a = +a;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Lab, lab, extend(Color, {
	  brighter: function(k) {
	    return new Lab(this.l + Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  darker: function(k) {
	    return new Lab(this.l - Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  rgb: function() {
	    var y = (this.l + 16) / 116,
	        x = isNaN(this.a) ? y : y + this.a / 500,
	        z = isNaN(this.b) ? y : y - this.b / 200;
	    y = Yn * lab2xyz(y);
	    x = Xn * lab2xyz(x);
	    z = Zn * lab2xyz(z);
	    return new Rgb(
	      xyz2rgb( 3.2404542 * x - 1.5371385 * y - 0.4985314 * z), // D65 -> sRGB
	      xyz2rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z),
	      xyz2rgb( 0.0556434 * x - 0.2040259 * y + 1.0572252 * z),
	      this.opacity
	    );
	  }
	}));
	
	function xyz2lab(t) {
	  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
	}
	
	function lab2xyz(t) {
	  return t > t1 ? t * t * t : t2 * (t - t0);
	}
	
	function xyz2rgb(x) {
	  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
	}
	
	function rgb2xyz(x) {
	  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
	}
	
	function hclConvert(o) {
	  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
	  if (!(o instanceof Lab)) o = labConvert(o);
	  var h = Math.atan2(o.b, o.a) * rad2deg;
	  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
	}
	
	function hcl(h, c, l, opacity) {
	  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function Hcl(h, c, l, opacity) {
	  this.h = +h;
	  this.c = +c;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hcl, hcl, extend(Color, {
	  brighter: function(k) {
	    return new Hcl(this.h, this.c, this.l + Kn * (k == null ? 1 : k), this.opacity);
	  },
	  darker: function(k) {
	    return new Hcl(this.h, this.c, this.l - Kn * (k == null ? 1 : k), this.opacity);
	  },
	  rgb: function() {
	    return labConvert(this).rgb();
	  }
	}));
	
	var A = -0.14861;
	var B = +1.78277;
	var C = -0.29227;
	var D = -0.90649;
	var E = +1.97294;
	var ED = E * D;
	var EB = E * B;
	var BC_DA = B * C - D * A;
	
	function cubehelixConvert(o) {
	  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
	      bl = b - l,
	      k = (E * (g - l) - C * bl) / D,
	      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
	      h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
	  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
	}
	
	function cubehelix(h, s, l, opacity) {
	  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Cubehelix(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Cubehelix, cubehelix, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
	        l = +this.l,
	        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
	        cosh = Math.cos(h),
	        sinh = Math.sin(h);
	    return new Rgb(
	      255 * (l + a * (A * cosh + B * sinh)),
	      255 * (l + a * (C * cosh + D * sinh)),
	      255 * (l + a * (E * cosh)),
	      this.opacity
	    );
	  }
	}));
	
	exports.color = color;
	exports.rgb = rgb;
	exports.hsl = hsl;
	exports.lab = lab;
	exports.hcl = hcl;
	exports.cubehelix = cubehelix;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-format/ Version 1.0.2. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3 = global.d3 || {})));
	}(this, function (exports) { 'use strict';
	
	  // Computes the decimal coefficient and exponent of the specified number x with
	  // significant digits p, where x is positive and p is in [1, 21] or undefined.
	  // For example, formatDecimal(1.23) returns ["123", 0].
	  function formatDecimal(x, p) {
	    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
	    var i, coefficient = x.slice(0, i);
	
	    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
	    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
	    return [
	      coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
	      +x.slice(i + 1)
	    ];
	  }
	
	  function exponent(x) {
	    return x = formatDecimal(Math.abs(x)), x ? x[1] : NaN;
	  }
	
	  function formatGroup(grouping, thousands) {
	    return function(value, width) {
	      var i = value.length,
	          t = [],
	          j = 0,
	          g = grouping[0],
	          length = 0;
	
	      while (i > 0 && g > 0) {
	        if (length + g + 1 > width) g = Math.max(1, width - length);
	        t.push(value.substring(i -= g, i + g));
	        if ((length += g + 1) > width) break;
	        g = grouping[j = (j + 1) % grouping.length];
	      }
	
	      return t.reverse().join(thousands);
	    };
	  }
	
	  function formatDefault(x, p) {
	    x = x.toPrecision(p);
	
	    out: for (var n = x.length, i = 1, i0 = -1, i1; i < n; ++i) {
	      switch (x[i]) {
	        case ".": i0 = i1 = i; break;
	        case "0": if (i0 === 0) i0 = i; i1 = i; break;
	        case "e": break out;
	        default: if (i0 > 0) i0 = 0; break;
	      }
	    }
	
	    return i0 > 0 ? x.slice(0, i0) + x.slice(i1 + 1) : x;
	  }
	
	  var prefixExponent;
	
	  function formatPrefixAuto(x, p) {
	    var d = formatDecimal(x, p);
	    if (!d) return x + "";
	    var coefficient = d[0],
	        exponent = d[1],
	        i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
	        n = coefficient.length;
	    return i === n ? coefficient
	        : i > n ? coefficient + new Array(i - n + 1).join("0")
	        : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
	        : "0." + new Array(1 - i).join("0") + formatDecimal(x, Math.max(0, p + i - 1))[0]; // less than 1y!
	  }
	
	  function formatRounded(x, p) {
	    var d = formatDecimal(x, p);
	    if (!d) return x + "";
	    var coefficient = d[0],
	        exponent = d[1];
	    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
	        : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
	        : coefficient + new Array(exponent - coefficient.length + 2).join("0");
	  }
	
	  var formatTypes = {
	    "": formatDefault,
	    "%": function(x, p) { return (x * 100).toFixed(p); },
	    "b": function(x) { return Math.round(x).toString(2); },
	    "c": function(x) { return x + ""; },
	    "d": function(x) { return Math.round(x).toString(10); },
	    "e": function(x, p) { return x.toExponential(p); },
	    "f": function(x, p) { return x.toFixed(p); },
	    "g": function(x, p) { return x.toPrecision(p); },
	    "o": function(x) { return Math.round(x).toString(8); },
	    "p": function(x, p) { return formatRounded(x * 100, p); },
	    "r": formatRounded,
	    "s": formatPrefixAuto,
	    "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
	    "x": function(x) { return Math.round(x).toString(16); }
	  };
	
	  // [[fill]align][sign][symbol][0][width][,][.precision][type]
	  var re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;
	
	  function formatSpecifier(specifier) {
	    return new FormatSpecifier(specifier);
	  }
	
	  function FormatSpecifier(specifier) {
	    if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
	
	    var match,
	        fill = match[1] || " ",
	        align = match[2] || ">",
	        sign = match[3] || "-",
	        symbol = match[4] || "",
	        zero = !!match[5],
	        width = match[6] && +match[6],
	        comma = !!match[7],
	        precision = match[8] && +match[8].slice(1),
	        type = match[9] || "";
	
	    // The "n" type is an alias for ",g".
	    if (type === "n") comma = true, type = "g";
	
	    // Map invalid types to the default format.
	    else if (!formatTypes[type]) type = "";
	
	    // If zero fill is specified, padding goes after sign and before digits.
	    if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";
	
	    this.fill = fill;
	    this.align = align;
	    this.sign = sign;
	    this.symbol = symbol;
	    this.zero = zero;
	    this.width = width;
	    this.comma = comma;
	    this.precision = precision;
	    this.type = type;
	  }
	
	  FormatSpecifier.prototype.toString = function() {
	    return this.fill
	        + this.align
	        + this.sign
	        + this.symbol
	        + (this.zero ? "0" : "")
	        + (this.width == null ? "" : Math.max(1, this.width | 0))
	        + (this.comma ? "," : "")
	        + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
	        + this.type;
	  };
	
	  var prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];
	
	  function identity(x) {
	    return x;
	  }
	
	  function formatLocale(locale) {
	    var group = locale.grouping && locale.thousands ? formatGroup(locale.grouping, locale.thousands) : identity,
	        currency = locale.currency,
	        decimal = locale.decimal;
	
	    function newFormat(specifier) {
	      specifier = formatSpecifier(specifier);
	
	      var fill = specifier.fill,
	          align = specifier.align,
	          sign = specifier.sign,
	          symbol = specifier.symbol,
	          zero = specifier.zero,
	          width = specifier.width,
	          comma = specifier.comma,
	          precision = specifier.precision,
	          type = specifier.type;
	
	      // Compute the prefix and suffix.
	      // For SI-prefix, the suffix is lazily computed.
	      var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
	          suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? "%" : "";
	
	      // What format function should we use?
	      // Is this an integer type?
	      // Can this type generate exponential notation?
	      var formatType = formatTypes[type],
	          maybeSuffix = !type || /[defgprs%]/.test(type);
	
	      // Set the default precision if not specified,
	      // or clamp the specified precision to the supported range.
	      // For significant precision, it must be in [1, 21].
	      // For fixed precision, it must be in [0, 20].
	      precision = precision == null ? (type ? 6 : 12)
	          : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
	          : Math.max(0, Math.min(20, precision));
	
	      function format(value) {
	        var valuePrefix = prefix,
	            valueSuffix = suffix,
	            i, n, c;
	
	        if (type === "c") {
	          valueSuffix = formatType(value) + valueSuffix;
	          value = "";
	        } else {
	          value = +value;
	
	          // Convert negative to positive, and compute the prefix.
	          // Note that -0 is not less than 0, but 1 / -0 is!
	          var valueNegative = (value < 0 || 1 / value < 0) && (value *= -1, true);
	
	          // Perform the initial formatting.
	          value = formatType(value, precision);
	
	          // If the original value was negative, it may be rounded to zero during
	          // formatting; treat this as (positive) zero.
	          if (valueNegative) {
	            i = -1, n = value.length;
	            valueNegative = false;
	            while (++i < n) {
	              if (c = value.charCodeAt(i), (48 < c && c < 58)
	                  || (type === "x" && 96 < c && c < 103)
	                  || (type === "X" && 64 < c && c < 71)) {
	                valueNegative = true;
	                break;
	              }
	            }
	          }
	
	          // Compute the prefix and suffix.
	          valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
	          valueSuffix = valueSuffix + (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + (valueNegative && sign === "(" ? ")" : "");
	
	          // Break the formatted value into the integer “value” part that can be
	          // grouped, and fractional or exponential “suffix” part that is not.
	          if (maybeSuffix) {
	            i = -1, n = value.length;
	            while (++i < n) {
	              if (c = value.charCodeAt(i), 48 > c || c > 57) {
	                valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
	                value = value.slice(0, i);
	                break;
	              }
	            }
	          }
	        }
	
	        // If the fill character is not "0", grouping is applied before padding.
	        if (comma && !zero) value = group(value, Infinity);
	
	        // Compute the padding.
	        var length = valuePrefix.length + value.length + valueSuffix.length,
	            padding = length < width ? new Array(width - length + 1).join(fill) : "";
	
	        // If the fill character is "0", grouping is applied after padding.
	        if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
	
	        // Reconstruct the final output based on the desired alignment.
	        switch (align) {
	          case "<": return valuePrefix + value + valueSuffix + padding;
	          case "=": return valuePrefix + padding + value + valueSuffix;
	          case "^": return padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
	        }
	        return padding + valuePrefix + value + valueSuffix;
	      }
	
	      format.toString = function() {
	        return specifier + "";
	      };
	
	      return format;
	    }
	
	    function formatPrefix(specifier, value) {
	      var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
	          e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
	          k = Math.pow(10, -e),
	          prefix = prefixes[8 + e / 3];
	      return function(value) {
	        return f(k * value) + prefix;
	      };
	    }
	
	    return {
	      format: newFormat,
	      formatPrefix: formatPrefix
	    };
	  }
	
	  var locale;
	  defaultLocale({
	    decimal: ".",
	    thousands: ",",
	    grouping: [3],
	    currency: ["$", ""]
	  });
	
	  function defaultLocale(definition) {
	    locale = formatLocale(definition);
	    exports.format = locale.format;
	    exports.formatPrefix = locale.formatPrefix;
	    return locale;
	  }
	
	  function precisionFixed(step) {
	    return Math.max(0, -exponent(Math.abs(step)));
	  }
	
	  function precisionPrefix(step, value) {
	    return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
	  }
	
	  function precisionRound(step, max) {
	    step = Math.abs(step), max = Math.abs(max) - step;
	    return Math.max(0, exponent(max) - exponent(step)) + 1;
	  }
	
	  exports.formatDefaultLocale = defaultLocale;
	  exports.formatLocale = formatLocale;
	  exports.formatSpecifier = formatSpecifier;
	  exports.precisionFixed = precisionFixed;
	  exports.precisionPrefix = precisionPrefix;
	  exports.precisionRound = precisionRound;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	}));

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time/ Version 1.0.4. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var t0 = new Date;
	var t1 = new Date;
	
	function newInterval(floori, offseti, count, field) {
	
	  function interval(date) {
	    return floori(date = new Date(+date)), date;
	  }
	
	  interval.floor = interval;
	
	  interval.ceil = function(date) {
	    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
	  };
	
	  interval.round = function(date) {
	    var d0 = interval(date),
	        d1 = interval.ceil(date);
	    return date - d0 < d1 - date ? d0 : d1;
	  };
	
	  interval.offset = function(date, step) {
	    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
	  };
	
	  interval.range = function(start, stop, step) {
	    var range = [];
	    start = interval.ceil(start);
	    step = step == null ? 1 : Math.floor(step);
	    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
	    do range.push(new Date(+start)); while (offseti(start, step), floori(start), start < stop)
	    return range;
	  };
	
	  interval.filter = function(test) {
	    return newInterval(function(date) {
	      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
	    }, function(date, step) {
	      if (date >= date) while (--step >= 0) while (offseti(date, 1), !test(date)) {} // eslint-disable-line no-empty
	    });
	  };
	
	  if (count) {
	    interval.count = function(start, end) {
	      t0.setTime(+start), t1.setTime(+end);
	      floori(t0), floori(t1);
	      return Math.floor(count(t0, t1));
	    };
	
	    interval.every = function(step) {
	      step = Math.floor(step);
	      return !isFinite(step) || !(step > 0) ? null
	          : !(step > 1) ? interval
	          : interval.filter(field
	              ? function(d) { return field(d) % step === 0; }
	              : function(d) { return interval.count(0, d) % step === 0; });
	    };
	  }
	
	  return interval;
	}
	
	var millisecond = newInterval(function() {
	  // noop
	}, function(date, step) {
	  date.setTime(+date + step);
	}, function(start, end) {
	  return end - start;
	});
	
	// An optimized implementation for this simple case.
	millisecond.every = function(k) {
	  k = Math.floor(k);
	  if (!isFinite(k) || !(k > 0)) return null;
	  if (!(k > 1)) return millisecond;
	  return newInterval(function(date) {
	    date.setTime(Math.floor(date / k) * k);
	  }, function(date, step) {
	    date.setTime(+date + step * k);
	  }, function(start, end) {
	    return (end - start) / k;
	  });
	};
	
	var milliseconds = millisecond.range;
	
	var durationSecond = 1e3;
	var durationMinute = 6e4;
	var durationHour = 36e5;
	var durationDay = 864e5;
	var durationWeek = 6048e5;
	
	var second = newInterval(function(date) {
	  date.setTime(Math.floor(date / durationSecond) * durationSecond);
	}, function(date, step) {
	  date.setTime(+date + step * durationSecond);
	}, function(start, end) {
	  return (end - start) / durationSecond;
	}, function(date) {
	  return date.getUTCSeconds();
	});
	
	var seconds = second.range;
	
	var minute = newInterval(function(date) {
	  date.setTime(Math.floor(date / durationMinute) * durationMinute);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getMinutes();
	});
	
	var minutes = minute.range;
	
	var hour = newInterval(function(date) {
	  var offset = date.getTimezoneOffset() * durationMinute % durationHour;
	  if (offset < 0) offset += durationHour;
	  date.setTime(Math.floor((+date - offset) / durationHour) * durationHour + offset);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getHours();
	});
	
	var hours = hour.range;
	
	var day = newInterval(function(date) {
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setDate(date.getDate() + step);
	}, function(start, end) {
	  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay;
	}, function(date) {
	  return date.getDate() - 1;
	});
	
	var days = day.range;
	
	function weekday(i) {
	  return newInterval(function(date) {
	    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setDate(date.getDate() + step * 7);
	  }, function(start, end) {
	    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
	  });
	}
	
	var sunday = weekday(0);
	var monday = weekday(1);
	var tuesday = weekday(2);
	var wednesday = weekday(3);
	var thursday = weekday(4);
	var friday = weekday(5);
	var saturday = weekday(6);
	
	var sundays = sunday.range;
	var mondays = monday.range;
	var tuesdays = tuesday.range;
	var wednesdays = wednesday.range;
	var thursdays = thursday.range;
	var fridays = friday.range;
	var saturdays = saturday.range;
	
	var month = newInterval(function(date) {
	  date.setDate(1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setMonth(date.getMonth() + step);
	}, function(start, end) {
	  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
	}, function(date) {
	  return date.getMonth();
	});
	
	var months = month.range;
	
	var year = newInterval(function(date) {
	  date.setMonth(0, 1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setFullYear(date.getFullYear() + step);
	}, function(start, end) {
	  return end.getFullYear() - start.getFullYear();
	}, function(date) {
	  return date.getFullYear();
	});
	
	// An optimized implementation for this simple case.
	year.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
	    date.setMonth(0, 1);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setFullYear(date.getFullYear() + step * k);
	  });
	};
	
	var years = year.range;
	
	var utcMinute = newInterval(function(date) {
	  date.setUTCSeconds(0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getUTCMinutes();
	});
	
	var utcMinutes = utcMinute.range;
	
	var utcHour = newInterval(function(date) {
	  date.setUTCMinutes(0, 0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getUTCHours();
	});
	
	var utcHours = utcHour.range;
	
	var utcDay = newInterval(function(date) {
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCDate(date.getUTCDate() + step);
	}, function(start, end) {
	  return (end - start) / durationDay;
	}, function(date) {
	  return date.getUTCDate() - 1;
	});
	
	var utcDays = utcDay.range;
	
	function utcWeekday(i) {
	  return newInterval(function(date) {
	    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCDate(date.getUTCDate() + step * 7);
	  }, function(start, end) {
	    return (end - start) / durationWeek;
	  });
	}
	
	var utcSunday = utcWeekday(0);
	var utcMonday = utcWeekday(1);
	var utcTuesday = utcWeekday(2);
	var utcWednesday = utcWeekday(3);
	var utcThursday = utcWeekday(4);
	var utcFriday = utcWeekday(5);
	var utcSaturday = utcWeekday(6);
	
	var utcSundays = utcSunday.range;
	var utcMondays = utcMonday.range;
	var utcTuesdays = utcTuesday.range;
	var utcWednesdays = utcWednesday.range;
	var utcThursdays = utcThursday.range;
	var utcFridays = utcFriday.range;
	var utcSaturdays = utcSaturday.range;
	
	var utcMonth = newInterval(function(date) {
	  date.setUTCDate(1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCMonth(date.getUTCMonth() + step);
	}, function(start, end) {
	  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
	}, function(date) {
	  return date.getUTCMonth();
	});
	
	var utcMonths = utcMonth.range;
	
	var utcYear = newInterval(function(date) {
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCFullYear(date.getUTCFullYear() + step);
	}, function(start, end) {
	  return end.getUTCFullYear() - start.getUTCFullYear();
	}, function(date) {
	  return date.getUTCFullYear();
	});
	
	// An optimized implementation for this simple case.
	utcYear.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
	    date.setUTCMonth(0, 1);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCFullYear(date.getUTCFullYear() + step * k);
	  });
	};
	
	var utcYears = utcYear.range;
	
	exports.timeInterval = newInterval;
	exports.timeMillisecond = millisecond;
	exports.timeMilliseconds = milliseconds;
	exports.utcMillisecond = millisecond;
	exports.utcMilliseconds = milliseconds;
	exports.timeSecond = second;
	exports.timeSeconds = seconds;
	exports.utcSecond = second;
	exports.utcSeconds = seconds;
	exports.timeMinute = minute;
	exports.timeMinutes = minutes;
	exports.timeHour = hour;
	exports.timeHours = hours;
	exports.timeDay = day;
	exports.timeDays = days;
	exports.timeWeek = sunday;
	exports.timeWeeks = sundays;
	exports.timeSunday = sunday;
	exports.timeSundays = sundays;
	exports.timeMonday = monday;
	exports.timeMondays = mondays;
	exports.timeTuesday = tuesday;
	exports.timeTuesdays = tuesdays;
	exports.timeWednesday = wednesday;
	exports.timeWednesdays = wednesdays;
	exports.timeThursday = thursday;
	exports.timeThursdays = thursdays;
	exports.timeFriday = friday;
	exports.timeFridays = fridays;
	exports.timeSaturday = saturday;
	exports.timeSaturdays = saturdays;
	exports.timeMonth = month;
	exports.timeMonths = months;
	exports.timeYear = year;
	exports.timeYears = years;
	exports.utcMinute = utcMinute;
	exports.utcMinutes = utcMinutes;
	exports.utcHour = utcHour;
	exports.utcHours = utcHours;
	exports.utcDay = utcDay;
	exports.utcDays = utcDays;
	exports.utcWeek = utcSunday;
	exports.utcWeeks = utcSundays;
	exports.utcSunday = utcSunday;
	exports.utcSundays = utcSundays;
	exports.utcMonday = utcMonday;
	exports.utcMondays = utcMondays;
	exports.utcTuesday = utcTuesday;
	exports.utcTuesdays = utcTuesdays;
	exports.utcWednesday = utcWednesday;
	exports.utcWednesdays = utcWednesdays;
	exports.utcThursday = utcThursday;
	exports.utcThursdays = utcThursdays;
	exports.utcFriday = utcFriday;
	exports.utcFridays = utcFridays;
	exports.utcSaturday = utcSaturday;
	exports.utcSaturdays = utcSaturdays;
	exports.utcMonth = utcMonth;
	exports.utcMonths = utcMonths;
	exports.utcYear = utcYear;
	exports.utcYears = utcYears;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time-format/ Version 2.0.3. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports, __webpack_require__(171)) :
	  typeof define === 'function' && define.amd ? define(['exports', 'd3-time'], factory) :
	  (factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Time) { 'use strict';
	
	function localDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
	    date.setFullYear(d.y);
	    return date;
	  }
	  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
	}
	
	function utcDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
	    date.setUTCFullYear(d.y);
	    return date;
	  }
	  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
	}
	
	function newYear(y) {
	  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
	}
	
	function formatLocale(locale) {
	  var locale_dateTime = locale.dateTime,
	      locale_date = locale.date,
	      locale_time = locale.time,
	      locale_periods = locale.periods,
	      locale_weekdays = locale.days,
	      locale_shortWeekdays = locale.shortDays,
	      locale_months = locale.months,
	      locale_shortMonths = locale.shortMonths;
	
	  var periodRe = formatRe(locale_periods),
	      periodLookup = formatLookup(locale_periods),
	      weekdayRe = formatRe(locale_weekdays),
	      weekdayLookup = formatLookup(locale_weekdays),
	      shortWeekdayRe = formatRe(locale_shortWeekdays),
	      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
	      monthRe = formatRe(locale_months),
	      monthLookup = formatLookup(locale_months),
	      shortMonthRe = formatRe(locale_shortMonths),
	      shortMonthLookup = formatLookup(locale_shortMonths);
	
	  var formats = {
	    "a": formatShortWeekday,
	    "A": formatWeekday,
	    "b": formatShortMonth,
	    "B": formatMonth,
	    "c": null,
	    "d": formatDayOfMonth,
	    "e": formatDayOfMonth,
	    "H": formatHour24,
	    "I": formatHour12,
	    "j": formatDayOfYear,
	    "L": formatMilliseconds,
	    "m": formatMonthNumber,
	    "M": formatMinutes,
	    "p": formatPeriod,
	    "S": formatSeconds,
	    "U": formatWeekNumberSunday,
	    "w": formatWeekdayNumber,
	    "W": formatWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatYear,
	    "Y": formatFullYear,
	    "Z": formatZone,
	    "%": formatLiteralPercent
	  };
	
	  var utcFormats = {
	    "a": formatUTCShortWeekday,
	    "A": formatUTCWeekday,
	    "b": formatUTCShortMonth,
	    "B": formatUTCMonth,
	    "c": null,
	    "d": formatUTCDayOfMonth,
	    "e": formatUTCDayOfMonth,
	    "H": formatUTCHour24,
	    "I": formatUTCHour12,
	    "j": formatUTCDayOfYear,
	    "L": formatUTCMilliseconds,
	    "m": formatUTCMonthNumber,
	    "M": formatUTCMinutes,
	    "p": formatUTCPeriod,
	    "S": formatUTCSeconds,
	    "U": formatUTCWeekNumberSunday,
	    "w": formatUTCWeekdayNumber,
	    "W": formatUTCWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatUTCYear,
	    "Y": formatUTCFullYear,
	    "Z": formatUTCZone,
	    "%": formatLiteralPercent
	  };
	
	  var parses = {
	    "a": parseShortWeekday,
	    "A": parseWeekday,
	    "b": parseShortMonth,
	    "B": parseMonth,
	    "c": parseLocaleDateTime,
	    "d": parseDayOfMonth,
	    "e": parseDayOfMonth,
	    "H": parseHour24,
	    "I": parseHour24,
	    "j": parseDayOfYear,
	    "L": parseMilliseconds,
	    "m": parseMonthNumber,
	    "M": parseMinutes,
	    "p": parsePeriod,
	    "S": parseSeconds,
	    "U": parseWeekNumberSunday,
	    "w": parseWeekdayNumber,
	    "W": parseWeekNumberMonday,
	    "x": parseLocaleDate,
	    "X": parseLocaleTime,
	    "y": parseYear,
	    "Y": parseFullYear,
	    "Z": parseZone,
	    "%": parseLiteralPercent
	  };
	
	  // These recursive directive definitions must be deferred.
	  formats.x = newFormat(locale_date, formats);
	  formats.X = newFormat(locale_time, formats);
	  formats.c = newFormat(locale_dateTime, formats);
	  utcFormats.x = newFormat(locale_date, utcFormats);
	  utcFormats.X = newFormat(locale_time, utcFormats);
	  utcFormats.c = newFormat(locale_dateTime, utcFormats);
	
	  function newFormat(specifier, formats) {
	    return function(date) {
	      var string = [],
	          i = -1,
	          j = 0,
	          n = specifier.length,
	          c,
	          pad,
	          format;
	
	      if (!(date instanceof Date)) date = new Date(+date);
	
	      while (++i < n) {
	        if (specifier.charCodeAt(i) === 37) {
	          string.push(specifier.slice(j, i));
	          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
	          else pad = c === "e" ? " " : "0";
	          if (format = formats[c]) c = format(date, pad);
	          string.push(c);
	          j = i + 1;
	        }
	      }
	
	      string.push(specifier.slice(j, i));
	      return string.join("");
	    };
	  }
	
	  function newParse(specifier, newDate) {
	    return function(string) {
	      var d = newYear(1900),
	          i = parseSpecifier(d, specifier, string += "", 0);
	      if (i != string.length) return null;
	
	      // The am-pm flag is 0 for AM, and 1 for PM.
	      if ("p" in d) d.H = d.H % 12 + d.p * 12;
	
	      // Convert day-of-week and week-of-year to day-of-year.
	      if ("W" in d || "U" in d) {
	        if (!("w" in d)) d.w = "W" in d ? 1 : 0;
	        var day = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
	        d.m = 0;
	        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
	      }
	
	      // If a time zone is specified, all fields are interpreted as UTC and then
	      // offset according to the specified time zone.
	      if ("Z" in d) {
	        d.H += d.Z / 100 | 0;
	        d.M += d.Z % 100;
	        return utcDate(d);
	      }
	
	      // Otherwise, all fields are in local time.
	      return newDate(d);
	    };
	  }
	
	  function parseSpecifier(d, specifier, string, j) {
	    var i = 0,
	        n = specifier.length,
	        m = string.length,
	        c,
	        parse;
	
	    while (i < n) {
	      if (j >= m) return -1;
	      c = specifier.charCodeAt(i++);
	      if (c === 37) {
	        c = specifier.charAt(i++);
	        parse = parses[c in pads ? specifier.charAt(i++) : c];
	        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
	      } else if (c != string.charCodeAt(j++)) {
	        return -1;
	      }
	    }
	
	    return j;
	  }
	
	  function parsePeriod(d, string, i) {
	    var n = periodRe.exec(string.slice(i));
	    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortWeekday(d, string, i) {
	    var n = shortWeekdayRe.exec(string.slice(i));
	    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseWeekday(d, string, i) {
	    var n = weekdayRe.exec(string.slice(i));
	    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortMonth(d, string, i) {
	    var n = shortMonthRe.exec(string.slice(i));
	    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseMonth(d, string, i) {
	    var n = monthRe.exec(string.slice(i));
	    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseLocaleDateTime(d, string, i) {
	    return parseSpecifier(d, locale_dateTime, string, i);
	  }
	
	  function parseLocaleDate(d, string, i) {
	    return parseSpecifier(d, locale_date, string, i);
	  }
	
	  function parseLocaleTime(d, string, i) {
	    return parseSpecifier(d, locale_time, string, i);
	  }
	
	  function formatShortWeekday(d) {
	    return locale_shortWeekdays[d.getDay()];
	  }
	
	  function formatWeekday(d) {
	    return locale_weekdays[d.getDay()];
	  }
	
	  function formatShortMonth(d) {
	    return locale_shortMonths[d.getMonth()];
	  }
	
	  function formatMonth(d) {
	    return locale_months[d.getMonth()];
	  }
	
	  function formatPeriod(d) {
	    return locale_periods[+(d.getHours() >= 12)];
	  }
	
	  function formatUTCShortWeekday(d) {
	    return locale_shortWeekdays[d.getUTCDay()];
	  }
	
	  function formatUTCWeekday(d) {
	    return locale_weekdays[d.getUTCDay()];
	  }
	
	  function formatUTCShortMonth(d) {
	    return locale_shortMonths[d.getUTCMonth()];
	  }
	
	  function formatUTCMonth(d) {
	    return locale_months[d.getUTCMonth()];
	  }
	
	  function formatUTCPeriod(d) {
	    return locale_periods[+(d.getUTCHours() >= 12)];
	  }
	
	  return {
	    format: function(specifier) {
	      var f = newFormat(specifier += "", formats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    parse: function(specifier) {
	      var p = newParse(specifier += "", localDate);
	      p.toString = function() { return specifier; };
	      return p;
	    },
	    utcFormat: function(specifier) {
	      var f = newFormat(specifier += "", utcFormats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    utcParse: function(specifier) {
	      var p = newParse(specifier, utcDate);
	      p.toString = function() { return specifier; };
	      return p;
	    }
	  };
	}
	
	var pads = {"-": "", "_": " ", "0": "0"};
	var numberRe = /^\s*\d+/;
	var percentRe = /^%/;
	var requoteRe = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
	
	function pad(value, fill, width) {
	  var sign = value < 0 ? "-" : "",
	      string = (sign ? -value : value) + "",
	      length = string.length;
	  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	}
	
	function requote(s) {
	  return s.replace(requoteRe, "\\$&");
	}
	
	function formatRe(names) {
	  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
	}
	
	function formatLookup(names) {
	  var map = {}, i = -1, n = names.length;
	  while (++i < n) map[names[i].toLowerCase()] = i;
	  return map;
	}
	
	function parseWeekdayNumber(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.w = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.U = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.W = +n[0], i + n[0].length) : -1;
	}
	
	function parseFullYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 4));
	  return n ? (d.y = +n[0], i + n[0].length) : -1;
	}
	
	function parseYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
	}
	
	function parseZone(d, string, i) {
	  var n = /^(Z)|([+-]\d\d)(?:\:?(\d\d))?/.exec(string.slice(i, i + 6));
	  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
	}
	
	function parseMonthNumber(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
	}
	
	function parseDayOfMonth(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseDayOfYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseHour24(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.H = +n[0], i + n[0].length) : -1;
	}
	
	function parseMinutes(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.M = +n[0], i + n[0].length) : -1;
	}
	
	function parseSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.S = +n[0], i + n[0].length) : -1;
	}
	
	function parseMilliseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.L = +n[0], i + n[0].length) : -1;
	}
	
	function parseLiteralPercent(d, string, i) {
	  var n = percentRe.exec(string.slice(i, i + 1));
	  return n ? i + n[0].length : -1;
	}
	
	function formatDayOfMonth(d, p) {
	  return pad(d.getDate(), p, 2);
	}
	
	function formatHour24(d, p) {
	  return pad(d.getHours(), p, 2);
	}
	
	function formatHour12(d, p) {
	  return pad(d.getHours() % 12 || 12, p, 2);
	}
	
	function formatDayOfYear(d, p) {
	  return pad(1 + d3Time.timeDay.count(d3Time.timeYear(d), d), p, 3);
	}
	
	function formatMilliseconds(d, p) {
	  return pad(d.getMilliseconds(), p, 3);
	}
	
	function formatMonthNumber(d, p) {
	  return pad(d.getMonth() + 1, p, 2);
	}
	
	function formatMinutes(d, p) {
	  return pad(d.getMinutes(), p, 2);
	}
	
	function formatSeconds(d, p) {
	  return pad(d.getSeconds(), p, 2);
	}
	
	function formatWeekNumberSunday(d, p) {
	  return pad(d3Time.timeSunday.count(d3Time.timeYear(d), d), p, 2);
	}
	
	function formatWeekdayNumber(d) {
	  return d.getDay();
	}
	
	function formatWeekNumberMonday(d, p) {
	  return pad(d3Time.timeMonday.count(d3Time.timeYear(d), d), p, 2);
	}
	
	function formatYear(d, p) {
	  return pad(d.getFullYear() % 100, p, 2);
	}
	
	function formatFullYear(d, p) {
	  return pad(d.getFullYear() % 10000, p, 4);
	}
	
	function formatZone(d) {
	  var z = d.getTimezoneOffset();
	  return (z > 0 ? "-" : (z *= -1, "+"))
	      + pad(z / 60 | 0, "0", 2)
	      + pad(z % 60, "0", 2);
	}
	
	function formatUTCDayOfMonth(d, p) {
	  return pad(d.getUTCDate(), p, 2);
	}
	
	function formatUTCHour24(d, p) {
	  return pad(d.getUTCHours(), p, 2);
	}
	
	function formatUTCHour12(d, p) {
	  return pad(d.getUTCHours() % 12 || 12, p, 2);
	}
	
	function formatUTCDayOfYear(d, p) {
	  return pad(1 + d3Time.utcDay.count(d3Time.utcYear(d), d), p, 3);
	}
	
	function formatUTCMilliseconds(d, p) {
	  return pad(d.getUTCMilliseconds(), p, 3);
	}
	
	function formatUTCMonthNumber(d, p) {
	  return pad(d.getUTCMonth() + 1, p, 2);
	}
	
	function formatUTCMinutes(d, p) {
	  return pad(d.getUTCMinutes(), p, 2);
	}
	
	function formatUTCSeconds(d, p) {
	  return pad(d.getUTCSeconds(), p, 2);
	}
	
	function formatUTCWeekNumberSunday(d, p) {
	  return pad(d3Time.utcSunday.count(d3Time.utcYear(d), d), p, 2);
	}
	
	function formatUTCWeekdayNumber(d) {
	  return d.getUTCDay();
	}
	
	function formatUTCWeekNumberMonday(d, p) {
	  return pad(d3Time.utcMonday.count(d3Time.utcYear(d), d), p, 2);
	}
	
	function formatUTCYear(d, p) {
	  return pad(d.getUTCFullYear() % 100, p, 2);
	}
	
	function formatUTCFullYear(d, p) {
	  return pad(d.getUTCFullYear() % 10000, p, 4);
	}
	
	function formatUTCZone() {
	  return "+0000";
	}
	
	function formatLiteralPercent() {
	  return "%";
	}
	
	var locale$1;
	
	
	
	
	
	defaultLocale({
	  dateTime: "%x, %X",
	  date: "%-m/%-d/%Y",
	  time: "%-I:%M:%S %p",
	  periods: ["AM", "PM"],
	  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
	});
	
	function defaultLocale(definition) {
	  locale$1 = formatLocale(definition);
	  exports.timeFormat = locale$1.format;
	  exports.timeParse = locale$1.parse;
	  exports.utcFormat = locale$1.utcFormat;
	  exports.utcParse = locale$1.utcParse;
	  return locale$1;
	}
	
	var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
	
	function formatIsoNative(date) {
	  return date.toISOString();
	}
	
	var formatIso = Date.prototype.toISOString
	    ? formatIsoNative
	    : exports.utcFormat(isoSpecifier);
	
	function parseIsoNative(string) {
	  var date = new Date(string);
	  return isNaN(date) ? null : date;
	}
	
	var parseIso = +new Date("2000-01-01T00:00:00.000Z")
	    ? parseIsoNative
	    : exports.utcParse(isoSpecifier);
	
	exports.timeFormatDefaultLocale = defaultLocale;
	exports.timeFormatLocale = formatLocale;
	exports.isoFormat = formatIso;
	exports.isoParse = parseIso;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org Version 4.4.0. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var version = "4.4.0";
	
	var ascending = function(a, b) {
	  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	};
	
	var bisector = function(compare) {
	  if (compare.length === 1) compare = ascendingComparator(compare);
	  return {
	    left: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) < 0) lo = mid + 1;
	        else hi = mid;
	      }
	      return lo;
	    },
	    right: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) > 0) hi = mid;
	        else lo = mid + 1;
	      }
	      return lo;
	    }
	  };
	};
	
	function ascendingComparator(f) {
	  return function(d, x) {
	    return ascending(f(d), x);
	  };
	}
	
	var ascendingBisect = bisector(ascending);
	var bisectRight = ascendingBisect.right;
	var bisectLeft = ascendingBisect.left;
	
	var descending = function(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	};
	
	var number = function(x) {
	  return x === null ? NaN : +x;
	};
	
	var variance = function(array, f) {
	  var n = array.length,
	      m = 0,
	      a,
	      d,
	      s = 0,
	      i = -1,
	      j = 0;
	
	  if (f == null) {
	    while (++i < n) {
	      if (!isNaN(a = number(array[i]))) {
	        d = a - m;
	        m += d / ++j;
	        s += d * (a - m);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(a = number(f(array[i], i, array)))) {
	        d = a - m;
	        m += d / ++j;
	        s += d * (a - m);
	      }
	    }
	  }
	
	  if (j > 1) return s / (j - 1);
	};
	
	var deviation = function(array, f) {
	  var v = variance(array, f);
	  return v ? Math.sqrt(v) : v;
	};
	
	var extent = function(array, f) {
	  var i = -1,
	      n = array.length,
	      a,
	      b,
	      c;
	
	  if (f == null) {
	    while (++i < n) if ((b = array[i]) != null && b >= b) { a = c = b; break; }
	    while (++i < n) if ((b = array[i]) != null) {
	      if (a > b) a = b;
	      if (c < b) c = b;
	    }
	  }
	
	  else {
	    while (++i < n) if ((b = f(array[i], i, array)) != null && b >= b) { a = c = b; break; }
	    while (++i < n) if ((b = f(array[i], i, array)) != null) {
	      if (a > b) a = b;
	      if (c < b) c = b;
	    }
	  }
	
	  return [a, c];
	};
	
	var array = Array.prototype;
	
	var slice = array.slice;
	var map = array.map;
	
	var constant$1 = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var identity = function(x) {
	  return x;
	};
	
	var range = function(start, stop, step) {
	  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
	
	  var i = -1,
	      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
	      range = new Array(n);
	
	  while (++i < n) {
	    range[i] = start + i * step;
	  }
	
	  return range;
	};
	
	var e10 = Math.sqrt(50);
	var e5 = Math.sqrt(10);
	var e2 = Math.sqrt(2);
	
	var ticks = function(start, stop, count) {
	  var step = tickStep(start, stop, count);
	  return range(
	    Math.ceil(start / step) * step,
	    Math.floor(stop / step) * step + step / 2, // inclusive
	    step
	  );
	};
	
	function tickStep(start, stop, count) {
	  var step0 = Math.abs(stop - start) / Math.max(0, count),
	      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
	      error = step0 / step1;
	  if (error >= e10) step1 *= 10;
	  else if (error >= e5) step1 *= 5;
	  else if (error >= e2) step1 *= 2;
	  return stop < start ? -step1 : step1;
	}
	
	var sturges = function(values) {
	  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
	};
	
	var histogram = function() {
	  var value = identity,
	      domain = extent,
	      threshold = sturges;
	
	  function histogram(data) {
	    var i,
	        n = data.length,
	        x,
	        values = new Array(n);
	
	    for (i = 0; i < n; ++i) {
	      values[i] = value(data[i], i, data);
	    }
	
	    var xz = domain(values),
	        x0 = xz[0],
	        x1 = xz[1],
	        tz = threshold(values, x0, x1);
	
	    // Convert number of thresholds into uniform thresholds.
	    if (!Array.isArray(tz)) tz = ticks(x0, x1, tz);
	
	    // Remove any thresholds outside the domain.
	    var m = tz.length;
	    while (tz[0] <= x0) tz.shift(), --m;
	    while (tz[m - 1] >= x1) tz.pop(), --m;
	
	    var bins = new Array(m + 1),
	        bin;
	
	    // Initialize bins.
	    for (i = 0; i <= m; ++i) {
	      bin = bins[i] = [];
	      bin.x0 = i > 0 ? tz[i - 1] : x0;
	      bin.x1 = i < m ? tz[i] : x1;
	    }
	
	    // Assign data to bins by value, ignoring any outside the domain.
	    for (i = 0; i < n; ++i) {
	      x = values[i];
	      if (x0 <= x && x <= x1) {
	        bins[bisectRight(tz, x, 0, m)].push(data[i]);
	      }
	    }
	
	    return bins;
	  }
	
	  histogram.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant$1(_), histogram) : value;
	  };
	
	  histogram.domain = function(_) {
	    return arguments.length ? (domain = typeof _ === "function" ? _ : constant$1([_[0], _[1]]), histogram) : domain;
	  };
	
	  histogram.thresholds = function(_) {
	    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant$1(slice.call(_)) : constant$1(_), histogram) : threshold;
	  };
	
	  return histogram;
	};
	
	var threshold = function(array, p, f) {
	  if (f == null) f = number;
	  if (!(n = array.length)) return;
	  if ((p = +p) <= 0 || n < 2) return +f(array[0], 0, array);
	  if (p >= 1) return +f(array[n - 1], n - 1, array);
	  var n,
	      h = (n - 1) * p,
	      i = Math.floor(h),
	      a = +f(array[i], i, array),
	      b = +f(array[i + 1], i + 1, array);
	  return a + (b - a) * (h - i);
	};
	
	var freedmanDiaconis = function(values, min, max) {
	  values = map.call(values, number).sort(ascending);
	  return Math.ceil((max - min) / (2 * (threshold(values, 0.75) - threshold(values, 0.25)) * Math.pow(values.length, -1 / 3)));
	};
	
	var scott = function(values, min, max) {
	  return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
	};
	
	var max = function(array, f) {
	  var i = -1,
	      n = array.length,
	      a,
	      b;
	
	  if (f == null) {
	    while (++i < n) if ((b = array[i]) != null && b >= b) { a = b; break; }
	    while (++i < n) if ((b = array[i]) != null && b > a) a = b;
	  }
	
	  else {
	    while (++i < n) if ((b = f(array[i], i, array)) != null && b >= b) { a = b; break; }
	    while (++i < n) if ((b = f(array[i], i, array)) != null && b > a) a = b;
	  }
	
	  return a;
	};
	
	var mean = function(array, f) {
	  var s = 0,
	      n = array.length,
	      a,
	      i = -1,
	      j = n;
	
	  if (f == null) {
	    while (++i < n) if (!isNaN(a = number(array[i]))) s += a; else --j;
	  }
	
	  else {
	    while (++i < n) if (!isNaN(a = number(f(array[i], i, array)))) s += a; else --j;
	  }
	
	  if (j) return s / j;
	};
	
	var median = function(array, f) {
	  var numbers = [],
	      n = array.length,
	      a,
	      i = -1;
	
	  if (f == null) {
	    while (++i < n) if (!isNaN(a = number(array[i]))) numbers.push(a);
	  }
	
	  else {
	    while (++i < n) if (!isNaN(a = number(f(array[i], i, array)))) numbers.push(a);
	  }
	
	  return threshold(numbers.sort(ascending), 0.5);
	};
	
	var merge = function(arrays) {
	  var n = arrays.length,
	      m,
	      i = -1,
	      j = 0,
	      merged,
	      array;
	
	  while (++i < n) j += arrays[i].length;
	  merged = new Array(j);
	
	  while (--n >= 0) {
	    array = arrays[n];
	    m = array.length;
	    while (--m >= 0) {
	      merged[--j] = array[m];
	    }
	  }
	
	  return merged;
	};
	
	var min = function(array, f) {
	  var i = -1,
	      n = array.length,
	      a,
	      b;
	
	  if (f == null) {
	    while (++i < n) if ((b = array[i]) != null && b >= b) { a = b; break; }
	    while (++i < n) if ((b = array[i]) != null && a > b) a = b;
	  }
	
	  else {
	    while (++i < n) if ((b = f(array[i], i, array)) != null && b >= b) { a = b; break; }
	    while (++i < n) if ((b = f(array[i], i, array)) != null && a > b) a = b;
	  }
	
	  return a;
	};
	
	var pairs = function(array) {
	  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
	  while (i < n) pairs[i] = [p, p = array[++i]];
	  return pairs;
	};
	
	var permute = function(array, indexes) {
	  var i = indexes.length, permutes = new Array(i);
	  while (i--) permutes[i] = array[indexes[i]];
	  return permutes;
	};
	
	var scan = function(array, compare) {
	  if (!(n = array.length)) return;
	  var i = 0,
	      n,
	      j = 0,
	      xi,
	      xj = array[j];
	
	  if (!compare) compare = ascending;
	
	  while (++i < n) if (compare(xi = array[i], xj) < 0 || compare(xj, xj) !== 0) xj = xi, j = i;
	
	  if (compare(xj, xj) === 0) return j;
	};
	
	var shuffle = function(array, i0, i1) {
	  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
	      t,
	      i;
	
	  while (m) {
	    i = Math.random() * m-- | 0;
	    t = array[m + i0];
	    array[m + i0] = array[i + i0];
	    array[i + i0] = t;
	  }
	
	  return array;
	};
	
	var sum = function(array, f) {
	  var s = 0,
	      n = array.length,
	      a,
	      i = -1;
	
	  if (f == null) {
	    while (++i < n) if (a = +array[i]) s += a; // Note: zero and null are equivalent.
	  }
	
	  else {
	    while (++i < n) if (a = +f(array[i], i, array)) s += a;
	  }
	
	  return s;
	};
	
	var transpose = function(matrix) {
	  if (!(n = matrix.length)) return [];
	  for (var i = -1, m = min(matrix, length), transpose = new Array(m); ++i < m;) {
	    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
	      row[j] = matrix[j][i];
	    }
	  }
	  return transpose;
	};
	
	function length(d) {
	  return d.length;
	}
	
	var zip = function() {
	  return transpose(arguments);
	};
	
	var prefix = "$";
	
	function Map() {}
	
	Map.prototype = map$1.prototype = {
	  constructor: Map,
	  has: function(key) {
	    return (prefix + key) in this;
	  },
	  get: function(key) {
	    return this[prefix + key];
	  },
	  set: function(key, value) {
	    this[prefix + key] = value;
	    return this;
	  },
	  remove: function(key) {
	    var property = prefix + key;
	    return property in this && delete this[property];
	  },
	  clear: function() {
	    for (var property in this) if (property[0] === prefix) delete this[property];
	  },
	  keys: function() {
	    var keys = [];
	    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
	    return keys;
	  },
	  values: function() {
	    var values = [];
	    for (var property in this) if (property[0] === prefix) values.push(this[property]);
	    return values;
	  },
	  entries: function() {
	    var entries = [];
	    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
	    return entries;
	  },
	  size: function() {
	    var size = 0;
	    for (var property in this) if (property[0] === prefix) ++size;
	    return size;
	  },
	  empty: function() {
	    for (var property in this) if (property[0] === prefix) return false;
	    return true;
	  },
	  each: function(f) {
	    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
	  }
	};
	
	function map$1(object, f) {
	  var map = new Map;
	
	  // Copy constructor.
	  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });
	
	  // Index array by numeric index or specified key function.
	  else if (Array.isArray(object)) {
	    var i = -1,
	        n = object.length,
	        o;
	
	    if (f == null) while (++i < n) map.set(i, object[i]);
	    else while (++i < n) map.set(f(o = object[i], i, object), o);
	  }
	
	  // Convert object to map.
	  else if (object) for (var key in object) map.set(key, object[key]);
	
	  return map;
	}
	
	var nest = function() {
	  var keys = [],
	      sortKeys = [],
	      sortValues,
	      rollup,
	      nest;
	
	  function apply(array, depth, createResult, setResult) {
	    if (depth >= keys.length) return rollup != null
	        ? rollup(array) : (sortValues != null
	        ? array.sort(sortValues)
	        : array);
	
	    var i = -1,
	        n = array.length,
	        key = keys[depth++],
	        keyValue,
	        value,
	        valuesByKey = map$1(),
	        values,
	        result = createResult();
	
	    while (++i < n) {
	      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
	        values.push(value);
	      } else {
	        valuesByKey.set(keyValue, [value]);
	      }
	    }
	
	    valuesByKey.each(function(values, key) {
	      setResult(result, key, apply(values, depth, createResult, setResult));
	    });
	
	    return result;
	  }
	
	  function entries(map, depth) {
	    if (++depth > keys.length) return map;
	    var array, sortKey = sortKeys[depth - 1];
	    if (rollup != null && depth >= keys.length) array = map.entries();
	    else array = [], map.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
	    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
	  }
	
	  return nest = {
	    object: function(array) { return apply(array, 0, createObject, setObject); },
	    map: function(array) { return apply(array, 0, createMap, setMap); },
	    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
	    key: function(d) { keys.push(d); return nest; },
	    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
	    sortValues: function(order) { sortValues = order; return nest; },
	    rollup: function(f) { rollup = f; return nest; }
	  };
	};
	
	function createObject() {
	  return {};
	}
	
	function setObject(object, key, value) {
	  object[key] = value;
	}
	
	function createMap() {
	  return map$1();
	}
	
	function setMap(map, key, value) {
	  map.set(key, value);
	}
	
	function Set() {}
	
	var proto = map$1.prototype;
	
	Set.prototype = set.prototype = {
	  constructor: Set,
	  has: proto.has,
	  add: function(value) {
	    value += "";
	    this[prefix + value] = value;
	    return this;
	  },
	  remove: proto.remove,
	  clear: proto.clear,
	  values: proto.keys,
	  size: proto.size,
	  empty: proto.empty,
	  each: proto.each
	};
	
	function set(object, f) {
	  var set = new Set;
	
	  // Copy constructor.
	  if (object instanceof Set) object.each(function(value) { set.add(value); });
	
	  // Otherwise, assume it’s an array.
	  else if (object) {
	    var i = -1, n = object.length;
	    if (f == null) while (++i < n) set.add(object[i]);
	    else while (++i < n) set.add(f(object[i], i, object));
	  }
	
	  return set;
	}
	
	var keys = function(map) {
	  var keys = [];
	  for (var key in map) keys.push(key);
	  return keys;
	};
	
	var values = function(map) {
	  var values = [];
	  for (var key in map) values.push(map[key]);
	  return values;
	};
	
	var entries = function(map) {
	  var entries = [];
	  for (var key in map) entries.push({key: key, value: map[key]});
	  return entries;
	};
	
	var uniform = function(min, max) {
	  min = min == null ? 0 : +min;
	  max = max == null ? 1 : +max;
	  if (arguments.length === 1) max = min, min = 0;
	  else max -= min;
	  return function() {
	    return Math.random() * max + min;
	  };
	};
	
	var normal = function(mu, sigma) {
	  var x, r;
	  mu = mu == null ? 0 : +mu;
	  sigma = sigma == null ? 1 : +sigma;
	  return function() {
	    var y;
	
	    // If available, use the second previously-generated uniform random.
	    if (x != null) y = x, x = null;
	
	    // Otherwise, generate a new x and y.
	    else do {
	      x = Math.random() * 2 - 1;
	      y = Math.random() * 2 - 1;
	      r = x * x + y * y;
	    } while (!r || r > 1);
	
	    return mu + sigma * y * Math.sqrt(-2 * Math.log(r) / r);
	  };
	};
	
	var logNormal = function() {
	  var randomNormal = normal.apply(this, arguments);
	  return function() {
	    return Math.exp(randomNormal());
	  };
	};
	
	var irwinHall = function(n) {
	  return function() {
	    for (var sum = 0, i = 0; i < n; ++i) sum += Math.random();
	    return sum;
	  };
	};
	
	var bates = function(n) {
	  var randomIrwinHall = irwinHall(n);
	  return function() {
	    return randomIrwinHall() / n;
	  };
	};
	
	var exponential = function(lambda) {
	  return function() {
	    return -Math.log(1 - Math.random()) / lambda;
	  };
	};
	
	function linear(t) {
	  return +t;
	}
	
	function quadIn(t) {
	  return t * t;
	}
	
	function quadOut(t) {
	  return t * (2 - t);
	}
	
	function quadInOut(t) {
	  return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
	}
	
	function cubicIn(t) {
	  return t * t * t;
	}
	
	function cubicOut(t) {
	  return --t * t * t + 1;
	}
	
	function cubicInOut(t) {
	  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
	}
	
	var exponent = 3;
	
	var polyIn = (function custom(e) {
	  e = +e;
	
	  function polyIn(t) {
	    return Math.pow(t, e);
	  }
	
	  polyIn.exponent = custom;
	
	  return polyIn;
	})(exponent);
	
	var polyOut = (function custom(e) {
	  e = +e;
	
	  function polyOut(t) {
	    return 1 - Math.pow(1 - t, e);
	  }
	
	  polyOut.exponent = custom;
	
	  return polyOut;
	})(exponent);
	
	var polyInOut = (function custom(e) {
	  e = +e;
	
	  function polyInOut(t) {
	    return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
	  }
	
	  polyInOut.exponent = custom;
	
	  return polyInOut;
	})(exponent);
	
	var pi = Math.PI;
	var halfPi = pi / 2;
	
	function sinIn(t) {
	  return 1 - Math.cos(t * halfPi);
	}
	
	function sinOut(t) {
	  return Math.sin(t * halfPi);
	}
	
	function sinInOut(t) {
	  return (1 - Math.cos(pi * t)) / 2;
	}
	
	function expIn(t) {
	  return Math.pow(2, 10 * t - 10);
	}
	
	function expOut(t) {
	  return 1 - Math.pow(2, -10 * t);
	}
	
	function expInOut(t) {
	  return ((t *= 2) <= 1 ? Math.pow(2, 10 * t - 10) : 2 - Math.pow(2, 10 - 10 * t)) / 2;
	}
	
	function circleIn(t) {
	  return 1 - Math.sqrt(1 - t * t);
	}
	
	function circleOut(t) {
	  return Math.sqrt(1 - --t * t);
	}
	
	function circleInOut(t) {
	  return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
	}
	
	var b1 = 4 / 11;
	var b2 = 6 / 11;
	var b3 = 8 / 11;
	var b4 = 3 / 4;
	var b5 = 9 / 11;
	var b6 = 10 / 11;
	var b7 = 15 / 16;
	var b8 = 21 / 22;
	var b9 = 63 / 64;
	var b0 = 1 / b1 / b1;
	
	function bounceIn(t) {
	  return 1 - bounceOut(1 - t);
	}
	
	function bounceOut(t) {
	  return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
	}
	
	function bounceInOut(t) {
	  return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
	}
	
	var overshoot = 1.70158;
	
	var backIn = (function custom(s) {
	  s = +s;
	
	  function backIn(t) {
	    return t * t * ((s + 1) * t - s);
	  }
	
	  backIn.overshoot = custom;
	
	  return backIn;
	})(overshoot);
	
	var backOut = (function custom(s) {
	  s = +s;
	
	  function backOut(t) {
	    return --t * t * ((s + 1) * t + s) + 1;
	  }
	
	  backOut.overshoot = custom;
	
	  return backOut;
	})(overshoot);
	
	var backInOut = (function custom(s) {
	  s = +s;
	
	  function backInOut(t) {
	    return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
	  }
	
	  backInOut.overshoot = custom;
	
	  return backInOut;
	})(overshoot);
	
	var tau = 2 * Math.PI;
	var amplitude = 1;
	var period = 0.3;
	
	var elasticIn = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticIn(t) {
	    return a * Math.pow(2, 10 * --t) * Math.sin((s - t) / p);
	  }
	
	  elasticIn.amplitude = function(a) { return custom(a, p * tau); };
	  elasticIn.period = function(p) { return custom(a, p); };
	
	  return elasticIn;
	})(amplitude, period);
	
	var elasticOut = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticOut(t) {
	    return 1 - a * Math.pow(2, -10 * (t = +t)) * Math.sin((t + s) / p);
	  }
	
	  elasticOut.amplitude = function(a) { return custom(a, p * tau); };
	  elasticOut.period = function(p) { return custom(a, p); };
	
	  return elasticOut;
	})(amplitude, period);
	
	var elasticInOut = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticInOut(t) {
	    return ((t = t * 2 - 1) < 0
	        ? a * Math.pow(2, 10 * t) * Math.sin((s - t) / p)
	        : 2 - a * Math.pow(2, -10 * t) * Math.sin((s + t) / p)) / 2;
	  }
	
	  elasticInOut.amplitude = function(a) { return custom(a, p * tau); };
	  elasticInOut.period = function(p) { return custom(a, p); };
	
	  return elasticInOut;
	})(amplitude, period);
	
	var area = function(polygon) {
	  var i = -1,
	      n = polygon.length,
	      a,
	      b = polygon[n - 1],
	      area = 0;
	
	  while (++i < n) {
	    a = b;
	    b = polygon[i];
	    area += a[1] * b[0] - a[0] * b[1];
	  }
	
	  return area / 2;
	};
	
	var centroid = function(polygon) {
	  var i = -1,
	      n = polygon.length,
	      x = 0,
	      y = 0,
	      a,
	      b = polygon[n - 1],
	      c,
	      k = 0;
	
	  while (++i < n) {
	    a = b;
	    b = polygon[i];
	    k += c = a[0] * b[1] - b[0] * a[1];
	    x += (a[0] + b[0]) * c;
	    y += (a[1] + b[1]) * c;
	  }
	
	  return k *= 3, [x / k, y / k];
	};
	
	// Returns the 2D cross product of AB and AC vectors, i.e., the z-component of
	// the 3D cross product in a quadrant I Cartesian coordinate system (+x is
	// right, +y is up). Returns a positive value if ABC is counter-clockwise,
	// negative if clockwise, and zero if the points are collinear.
	var cross = function(a, b, c) {
	  return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
	};
	
	function lexicographicOrder(a, b) {
	  return a[0] - b[0] || a[1] - b[1];
	}
	
	// Computes the upper convex hull per the monotone chain algorithm.
	// Assumes points.length >= 3, is sorted by x, unique in y.
	// Returns an array of indices into points in left-to-right order.
	function computeUpperHullIndexes(points) {
	  var n = points.length,
	      indexes = [0, 1],
	      size = 2;
	
	  for (var i = 2; i < n; ++i) {
	    while (size > 1 && cross(points[indexes[size - 2]], points[indexes[size - 1]], points[i]) <= 0) --size;
	    indexes[size++] = i;
	  }
	
	  return indexes.slice(0, size); // remove popped points
	}
	
	var hull = function(points) {
	  if ((n = points.length) < 3) return null;
	
	  var i,
	      n,
	      sortedPoints = new Array(n),
	      flippedPoints = new Array(n);
	
	  for (i = 0; i < n; ++i) sortedPoints[i] = [+points[i][0], +points[i][1], i];
	  sortedPoints.sort(lexicographicOrder);
	  for (i = 0; i < n; ++i) flippedPoints[i] = [sortedPoints[i][0], -sortedPoints[i][1]];
	
	  var upperIndexes = computeUpperHullIndexes(sortedPoints),
	      lowerIndexes = computeUpperHullIndexes(flippedPoints);
	
	  // Construct the hull polygon, removing possible duplicate endpoints.
	  var skipLeft = lowerIndexes[0] === upperIndexes[0],
	      skipRight = lowerIndexes[lowerIndexes.length - 1] === upperIndexes[upperIndexes.length - 1],
	      hull = [];
	
	  // Add upper hull in right-to-l order.
	  // Then add lower hull in left-to-right order.
	  for (i = upperIndexes.length - 1; i >= 0; --i) hull.push(points[sortedPoints[upperIndexes[i]][2]]);
	  for (i = +skipLeft; i < lowerIndexes.length - skipRight; ++i) hull.push(points[sortedPoints[lowerIndexes[i]][2]]);
	
	  return hull;
	};
	
	var contains = function(polygon, point) {
	  var n = polygon.length,
	      p = polygon[n - 1],
	      x = point[0], y = point[1],
	      x0 = p[0], y0 = p[1],
	      x1, y1,
	      inside = false;
	
	  for (var i = 0; i < n; ++i) {
	    p = polygon[i], x1 = p[0], y1 = p[1];
	    if (((y1 > y) !== (y0 > y)) && (x < (x0 - x1) * (y - y1) / (y0 - y1) + x1)) inside = !inside;
	    x0 = x1, y0 = y1;
	  }
	
	  return inside;
	};
	
	var length$1 = function(polygon) {
	  var i = -1,
	      n = polygon.length,
	      b = polygon[n - 1],
	      xa,
	      ya,
	      xb = b[0],
	      yb = b[1],
	      perimeter = 0;
	
	  while (++i < n) {
	    xa = xb;
	    ya = yb;
	    b = polygon[i];
	    xb = b[0];
	    yb = b[1];
	    xa -= xb;
	    ya -= yb;
	    perimeter += Math.sqrt(xa * xa + ya * ya);
	  }
	
	  return perimeter;
	};
	
	var pi$1 = Math.PI;
	var tau$1 = 2 * pi$1;
	var epsilon = 1e-6;
	var tauEpsilon = tau$1 - epsilon;
	
	function Path() {
	  this._x0 = this._y0 = // start of current subpath
	  this._x1 = this._y1 = null; // end of current subpath
	  this._ = "";
	}
	
	function path() {
	  return new Path;
	}
	
	Path.prototype = path.prototype = {
	  constructor: Path,
	  moveTo: function(x, y) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
	  },
	  closePath: function() {
	    if (this._x1 !== null) {
	      this._x1 = this._x0, this._y1 = this._y0;
	      this._ += "Z";
	    }
	  },
	  lineTo: function(x, y) {
	    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  quadraticCurveTo: function(x1, y1, x, y) {
	    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
	    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  arcTo: function(x1, y1, x2, y2, r) {
	    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
	    var x0 = this._x1,
	        y0 = this._y1,
	        x21 = x2 - x1,
	        y21 = y2 - y1,
	        x01 = x0 - x1,
	        y01 = y0 - y1,
	        l01_2 = x01 * x01 + y01 * y01;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x1,y1).
	    if (this._x1 === null) {
	      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
	    else if (!(l01_2 > epsilon)) {}
	
	    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
	    // Equivalently, is (x1,y1) coincident with (x2,y2)?
	    // Or, is the radius zero? Line to (x1,y1).
	    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
	      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Otherwise, draw an arc!
	    else {
	      var x20 = x2 - x0,
	          y20 = y2 - y0,
	          l21_2 = x21 * x21 + y21 * y21,
	          l20_2 = x20 * x20 + y20 * y20,
	          l21 = Math.sqrt(l21_2),
	          l01 = Math.sqrt(l01_2),
	          l = r * Math.tan((pi$1 - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
	          t01 = l / l01,
	          t21 = l / l21;
	
	      // If the start tangent is not coincident with (x0,y0), line to.
	      if (Math.abs(t01 - 1) > epsilon) {
	        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
	      }
	
	      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
	    }
	  },
	  arc: function(x, y, r, a0, a1, ccw) {
	    x = +x, y = +y, r = +r;
	    var dx = r * Math.cos(a0),
	        dy = r * Math.sin(a0),
	        x0 = x + dx,
	        y0 = y + dy,
	        cw = 1 ^ ccw,
	        da = ccw ? a0 - a1 : a1 - a0;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x0,y0).
	    if (this._x1 === null) {
	      this._ += "M" + x0 + "," + y0;
	    }
	
	    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
	    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
	      this._ += "L" + x0 + "," + y0;
	    }
	
	    // Is this arc empty? We’re done.
	    if (!r) return;
	
	    // Is this a complete circle? Draw two arcs to complete the circle.
	    if (da > tauEpsilon) {
	      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
	    }
	
	    // Otherwise, draw an arc!
	    else {
	      if (da < 0) da = da % tau$1 + tau$1;
	      this._ += "A" + r + "," + r + ",0," + (+(da >= pi$1)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
	    }
	  },
	  rect: function(x, y, w, h) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
	  },
	  toString: function() {
	    return this._;
	  }
	};
	
	var tree_add = function(d) {
	  var x = +this._x.call(null, d),
	      y = +this._y.call(null, d);
	  return add(this.cover(x, y), x, y, d);
	};
	
	function add(tree, x, y, d) {
	  if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points
	
	  var parent,
	      node = tree._root,
	      leaf = {data: d},
	      x0 = tree._x0,
	      y0 = tree._y0,
	      x1 = tree._x1,
	      y1 = tree._y1,
	      xm,
	      ym,
	      xp,
	      yp,
	      right,
	      bottom,
	      i,
	      j;
	
	  // If the tree is empty, initialize the root as a leaf.
	  if (!node) return tree._root = leaf, tree;
	
	  // Find the existing leaf for the new point, or add it.
	  while (node.length) {
	    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
	    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
	    if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
	  }
	
	  // Is the new point is exactly coincident with the existing point?
	  xp = +tree._x.call(null, node.data);
	  yp = +tree._y.call(null, node.data);
	  if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;
	
	  // Otherwise, split the leaf node until the old and new point are separated.
	  do {
	    parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
	    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
	    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
	  } while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | (xp >= xm)));
	  return parent[j] = node, parent[i] = leaf, tree;
	}
	
	function addAll(data) {
	  var d, i, n = data.length,
	      x,
	      y,
	      xz = new Array(n),
	      yz = new Array(n),
	      x0 = Infinity,
	      y0 = Infinity,
	      x1 = -Infinity,
	      y1 = -Infinity;
	
	  // Compute the points and their extent.
	  for (i = 0; i < n; ++i) {
	    if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
	    xz[i] = x;
	    yz[i] = y;
	    if (x < x0) x0 = x;
	    if (x > x1) x1 = x;
	    if (y < y0) y0 = y;
	    if (y > y1) y1 = y;
	  }
	
	  // If there were no (valid) points, inherit the existing extent.
	  if (x1 < x0) x0 = this._x0, x1 = this._x1;
	  if (y1 < y0) y0 = this._y0, y1 = this._y1;
	
	  // Expand the tree to cover the new points.
	  this.cover(x0, y0).cover(x1, y1);
	
	  // Add the new points.
	  for (i = 0; i < n; ++i) {
	    add(this, xz[i], yz[i], data[i]);
	  }
	
	  return this;
	}
	
	var tree_cover = function(x, y) {
	  if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points
	
	  var x0 = this._x0,
	      y0 = this._y0,
	      x1 = this._x1,
	      y1 = this._y1;
	
	  // If the quadtree has no extent, initialize them.
	  // Integer extent are necessary so that if we later double the extent,
	  // the existing quadrant boundaries don’t change due to floating point error!
	  if (isNaN(x0)) {
	    x1 = (x0 = Math.floor(x)) + 1;
	    y1 = (y0 = Math.floor(y)) + 1;
	  }
	
	  // Otherwise, double repeatedly to cover.
	  else if (x0 > x || x > x1 || y0 > y || y > y1) {
	    var z = x1 - x0,
	        node = this._root,
	        parent,
	        i;
	
	    switch (i = (y < (y0 + y1) / 2) << 1 | (x < (x0 + x1) / 2)) {
	      case 0: {
	        do parent = new Array(4), parent[i] = node, node = parent;
	        while (z *= 2, x1 = x0 + z, y1 = y0 + z, x > x1 || y > y1);
	        break;
	      }
	      case 1: {
	        do parent = new Array(4), parent[i] = node, node = parent;
	        while (z *= 2, x0 = x1 - z, y1 = y0 + z, x0 > x || y > y1);
	        break;
	      }
	      case 2: {
	        do parent = new Array(4), parent[i] = node, node = parent;
	        while (z *= 2, x1 = x0 + z, y0 = y1 - z, x > x1 || y0 > y);
	        break;
	      }
	      case 3: {
	        do parent = new Array(4), parent[i] = node, node = parent;
	        while (z *= 2, x0 = x1 - z, y0 = y1 - z, x0 > x || y0 > y);
	        break;
	      }
	    }
	
	    if (this._root && this._root.length) this._root = node;
	  }
	
	  // If the quadtree covers the point already, just return.
	  else return this;
	
	  this._x0 = x0;
	  this._y0 = y0;
	  this._x1 = x1;
	  this._y1 = y1;
	  return this;
	};
	
	var tree_data = function() {
	  var data = [];
	  this.visit(function(node) {
	    if (!node.length) do data.push(node.data); while (node = node.next)
	  });
	  return data;
	};
	
	var tree_extent = function(_) {
	  return arguments.length
	      ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1])
	      : isNaN(this._x0) ? undefined : [[this._x0, this._y0], [this._x1, this._y1]];
	};
	
	var Quad = function(node, x0, y0, x1, y1) {
	  this.node = node;
	  this.x0 = x0;
	  this.y0 = y0;
	  this.x1 = x1;
	  this.y1 = y1;
	};
	
	var tree_find = function(x, y, radius) {
	  var data,
	      x0 = this._x0,
	      y0 = this._y0,
	      x1,
	      y1,
	      x2,
	      y2,
	      x3 = this._x1,
	      y3 = this._y1,
	      quads = [],
	      node = this._root,
	      q,
	      i;
	
	  if (node) quads.push(new Quad(node, x0, y0, x3, y3));
	  if (radius == null) radius = Infinity;
	  else {
	    x0 = x - radius, y0 = y - radius;
	    x3 = x + radius, y3 = y + radius;
	    radius *= radius;
	  }
	
	  while (q = quads.pop()) {
	
	    // Stop searching if this quadrant can’t contain a closer node.
	    if (!(node = q.node)
	        || (x1 = q.x0) > x3
	        || (y1 = q.y0) > y3
	        || (x2 = q.x1) < x0
	        || (y2 = q.y1) < y0) continue;
	
	    // Bisect the current quadrant.
	    if (node.length) {
	      var xm = (x1 + x2) / 2,
	          ym = (y1 + y2) / 2;
	
	      quads.push(
	        new Quad(node[3], xm, ym, x2, y2),
	        new Quad(node[2], x1, ym, xm, y2),
	        new Quad(node[1], xm, y1, x2, ym),
	        new Quad(node[0], x1, y1, xm, ym)
	      );
	
	      // Visit the closest quadrant first.
	      if (i = (y >= ym) << 1 | (x >= xm)) {
	        q = quads[quads.length - 1];
	        quads[quads.length - 1] = quads[quads.length - 1 - i];
	        quads[quads.length - 1 - i] = q;
	      }
	    }
	
	    // Visit this point. (Visiting coincident points isn’t necessary!)
	    else {
	      var dx = x - +this._x.call(null, node.data),
	          dy = y - +this._y.call(null, node.data),
	          d2 = dx * dx + dy * dy;
	      if (d2 < radius) {
	        var d = Math.sqrt(radius = d2);
	        x0 = x - d, y0 = y - d;
	        x3 = x + d, y3 = y + d;
	        data = node.data;
	      }
	    }
	  }
	
	  return data;
	};
	
	var tree_remove = function(d) {
	  if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points
	
	  var parent,
	      node = this._root,
	      retainer,
	      previous,
	      next,
	      x0 = this._x0,
	      y0 = this._y0,
	      x1 = this._x1,
	      y1 = this._y1,
	      x,
	      y,
	      xm,
	      ym,
	      right,
	      bottom,
	      i,
	      j;
	
	  // If the tree is empty, initialize the root as a leaf.
	  if (!node) return this;
	
	  // Find the leaf node for the point.
	  // While descending, also retain the deepest parent with a non-removed sibling.
	  if (node.length) while (true) {
	    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
	    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
	    if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
	    if (!node.length) break;
	    if (parent[(i + 1) & 3] || parent[(i + 2) & 3] || parent[(i + 3) & 3]) retainer = parent, j = i;
	  }
	
	  // Find the point to remove.
	  while (node.data !== d) if (!(previous = node, node = node.next)) return this;
	  if (next = node.next) delete node.next;
	
	  // If there are multiple coincident points, remove just the point.
	  if (previous) return (next ? previous.next = next : delete previous.next), this;
	
	  // If this is the root point, remove it.
	  if (!parent) return this._root = next, this;
	
	  // Remove this leaf.
	  next ? parent[i] = next : delete parent[i];
	
	  // If the parent now contains exactly one leaf, collapse superfluous parents.
	  if ((node = parent[0] || parent[1] || parent[2] || parent[3])
	      && node === (parent[3] || parent[2] || parent[1] || parent[0])
	      && !node.length) {
	    if (retainer) retainer[j] = node;
	    else this._root = node;
	  }
	
	  return this;
	};
	
	function removeAll(data) {
	  for (var i = 0, n = data.length; i < n; ++i) this.remove(data[i]);
	  return this;
	}
	
	var tree_root = function() {
	  return this._root;
	};
	
	var tree_size = function() {
	  var size = 0;
	  this.visit(function(node) {
	    if (!node.length) do ++size; while (node = node.next)
	  });
	  return size;
	};
	
	var tree_visit = function(callback) {
	  var quads = [], q, node = this._root, child, x0, y0, x1, y1;
	  if (node) quads.push(new Quad(node, this._x0, this._y0, this._x1, this._y1));
	  while (q = quads.pop()) {
	    if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
	      var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
	      if (child = node[3]) quads.push(new Quad(child, xm, ym, x1, y1));
	      if (child = node[2]) quads.push(new Quad(child, x0, ym, xm, y1));
	      if (child = node[1]) quads.push(new Quad(child, xm, y0, x1, ym));
	      if (child = node[0]) quads.push(new Quad(child, x0, y0, xm, ym));
	    }
	  }
	  return this;
	};
	
	var tree_visitAfter = function(callback) {
	  var quads = [], next = [], q;
	  if (this._root) quads.push(new Quad(this._root, this._x0, this._y0, this._x1, this._y1));
	  while (q = quads.pop()) {
	    var node = q.node;
	    if (node.length) {
	      var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
	      if (child = node[0]) quads.push(new Quad(child, x0, y0, xm, ym));
	      if (child = node[1]) quads.push(new Quad(child, xm, y0, x1, ym));
	      if (child = node[2]) quads.push(new Quad(child, x0, ym, xm, y1));
	      if (child = node[3]) quads.push(new Quad(child, xm, ym, x1, y1));
	    }
	    next.push(q);
	  }
	  while (q = next.pop()) {
	    callback(q.node, q.x0, q.y0, q.x1, q.y1);
	  }
	  return this;
	};
	
	function defaultX(d) {
	  return d[0];
	}
	
	var tree_x = function(_) {
	  return arguments.length ? (this._x = _, this) : this._x;
	};
	
	function defaultY(d) {
	  return d[1];
	}
	
	var tree_y = function(_) {
	  return arguments.length ? (this._y = _, this) : this._y;
	};
	
	function quadtree(nodes, x, y) {
	  var tree = new Quadtree(x == null ? defaultX : x, y == null ? defaultY : y, NaN, NaN, NaN, NaN);
	  return nodes == null ? tree : tree.addAll(nodes);
	}
	
	function Quadtree(x, y, x0, y0, x1, y1) {
	  this._x = x;
	  this._y = y;
	  this._x0 = x0;
	  this._y0 = y0;
	  this._x1 = x1;
	  this._y1 = y1;
	  this._root = undefined;
	}
	
	function leaf_copy(leaf) {
	  var copy = {data: leaf.data}, next = copy;
	  while (leaf = leaf.next) next = next.next = {data: leaf.data};
	  return copy;
	}
	
	var treeProto = quadtree.prototype = Quadtree.prototype;
	
	treeProto.copy = function() {
	  var copy = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1),
	      node = this._root,
	      nodes,
	      child;
	
	  if (!node) return copy;
	
	  if (!node.length) return copy._root = leaf_copy(node), copy;
	
	  nodes = [{source: node, target: copy._root = new Array(4)}];
	  while (node = nodes.pop()) {
	    for (var i = 0; i < 4; ++i) {
	      if (child = node.source[i]) {
	        if (child.length) nodes.push({source: child, target: node.target[i] = new Array(4)});
	        else node.target[i] = leaf_copy(child);
	      }
	    }
	  }
	
	  return copy;
	};
	
	treeProto.add = tree_add;
	treeProto.addAll = addAll;
	treeProto.cover = tree_cover;
	treeProto.data = tree_data;
	treeProto.extent = tree_extent;
	treeProto.find = tree_find;
	treeProto.remove = tree_remove;
	treeProto.removeAll = removeAll;
	treeProto.root = tree_root;
	treeProto.size = tree_size;
	treeProto.visit = tree_visit;
	treeProto.visitAfter = tree_visitAfter;
	treeProto.x = tree_x;
	treeProto.y = tree_y;
	
	var slice$1 = [].slice;
	
	var noabort = {};
	
	function Queue(size) {
	  if (!(size >= 1)) throw new Error;
	  this._size = size;
	  this._call =
	  this._error = null;
	  this._tasks = [];
	  this._data = [];
	  this._waiting =
	  this._active =
	  this._ended =
	  this._start = 0; // inside a synchronous task callback?
	}
	
	Queue.prototype = queue.prototype = {
	  constructor: Queue,
	  defer: function(callback) {
	    if (typeof callback !== "function" || this._call) throw new Error;
	    if (this._error != null) return this;
	    var t = slice$1.call(arguments, 1);
	    t.push(callback);
	    ++this._waiting, this._tasks.push(t);
	    poke(this);
	    return this;
	  },
	  abort: function() {
	    if (this._error == null) abort(this, new Error("abort"));
	    return this;
	  },
	  await: function(callback) {
	    if (typeof callback !== "function" || this._call) throw new Error;
	    this._call = function(error, results) { callback.apply(null, [error].concat(results)); };
	    maybeNotify(this);
	    return this;
	  },
	  awaitAll: function(callback) {
	    if (typeof callback !== "function" || this._call) throw new Error;
	    this._call = callback;
	    maybeNotify(this);
	    return this;
	  }
	};
	
	function poke(q) {
	  if (!q._start) {
	    try { start(q); } // let the current task complete
	    catch (e) {
	      if (q._tasks[q._ended + q._active - 1]) abort(q, e); // task errored synchronously
	      else if (!q._data) throw e; // await callback errored synchronously
	    }
	  }
	}
	
	function start(q) {
	  while (q._start = q._waiting && q._active < q._size) {
	    var i = q._ended + q._active,
	        t = q._tasks[i],
	        j = t.length - 1,
	        c = t[j];
	    t[j] = end(q, i);
	    --q._waiting, ++q._active;
	    t = c.apply(null, t);
	    if (!q._tasks[i]) continue; // task finished synchronously
	    q._tasks[i] = t || noabort;
	  }
	}
	
	function end(q, i) {
	  return function(e, r) {
	    if (!q._tasks[i]) return; // ignore multiple callbacks
	    --q._active, ++q._ended;
	    q._tasks[i] = null;
	    if (q._error != null) return; // ignore secondary errors
	    if (e != null) {
	      abort(q, e);
	    } else {
	      q._data[i] = r;
	      if (q._waiting) poke(q);
	      else maybeNotify(q);
	    }
	  };
	}
	
	function abort(q, e) {
	  var i = q._tasks.length, t;
	  q._error = e; // ignore active callbacks
	  q._data = undefined; // allow gc
	  q._waiting = NaN; // prevent starting
	
	  while (--i >= 0) {
	    if (t = q._tasks[i]) {
	      q._tasks[i] = null;
	      if (t.abort) {
	        try { t.abort(); }
	        catch (e) { /* ignore */ }
	      }
	    }
	  }
	
	  q._active = NaN; // allow notification
	  maybeNotify(q);
	}
	
	function maybeNotify(q) {
	  if (!q._active && q._call) {
	    var d = q._data;
	    q._data = undefined; // allow gc
	    q._call(q._error, d);
	  }
	}
	
	function queue(concurrency) {
	  return new Queue(arguments.length ? +concurrency : Infinity);
	}
	
	var constant$2 = function(x) {
	  return function constant() {
	    return x;
	  };
	};
	
	var epsilon$1 = 1e-12;
	var pi$2 = Math.PI;
	var halfPi$1 = pi$2 / 2;
	var tau$2 = 2 * pi$2;
	
	function arcInnerRadius(d) {
	  return d.innerRadius;
	}
	
	function arcOuterRadius(d) {
	  return d.outerRadius;
	}
	
	function arcStartAngle(d) {
	  return d.startAngle;
	}
	
	function arcEndAngle(d) {
	  return d.endAngle;
	}
	
	function arcPadAngle(d) {
	  return d && d.padAngle; // Note: optional!
	}
	
	function asin(x) {
	  return x >= 1 ? halfPi$1 : x <= -1 ? -halfPi$1 : Math.asin(x);
	}
	
	function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
	  var x10 = x1 - x0, y10 = y1 - y0,
	      x32 = x3 - x2, y32 = y3 - y2,
	      t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
	  return [x0 + t * x10, y0 + t * y10];
	}
	
	// Compute perpendicular offset line of length rc.
	// http://mathworld.wolfram.com/Circle-LineIntersection.html
	function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
	  var x01 = x0 - x1,
	      y01 = y0 - y1,
	      lo = (cw ? rc : -rc) / Math.sqrt(x01 * x01 + y01 * y01),
	      ox = lo * y01,
	      oy = -lo * x01,
	      x11 = x0 + ox,
	      y11 = y0 + oy,
	      x10 = x1 + ox,
	      y10 = y1 + oy,
	      x00 = (x11 + x10) / 2,
	      y00 = (y11 + y10) / 2,
	      dx = x10 - x11,
	      dy = y10 - y11,
	      d2 = dx * dx + dy * dy,
	      r = r1 - rc,
	      D = x11 * y10 - x10 * y11,
	      d = (dy < 0 ? -1 : 1) * Math.sqrt(Math.max(0, r * r * d2 - D * D)),
	      cx0 = (D * dy - dx * d) / d2,
	      cy0 = (-D * dx - dy * d) / d2,
	      cx1 = (D * dy + dx * d) / d2,
	      cy1 = (-D * dx + dy * d) / d2,
	      dx0 = cx0 - x00,
	      dy0 = cy0 - y00,
	      dx1 = cx1 - x00,
	      dy1 = cy1 - y00;
	
	  // Pick the closer of the two intersection points.
	  // TODO Is there a faster way to determine which intersection to use?
	  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	
	  return {
	    cx: cx0,
	    cy: cy0,
	    x01: -ox,
	    y01: -oy,
	    x11: cx0 * (r1 / r - 1),
	    y11: cy0 * (r1 / r - 1)
	  };
	}
	
	var arc = function() {
	  var innerRadius = arcInnerRadius,
	      outerRadius = arcOuterRadius,
	      cornerRadius = constant$2(0),
	      padRadius = null,
	      startAngle = arcStartAngle,
	      endAngle = arcEndAngle,
	      padAngle = arcPadAngle,
	      context = null;
	
	  function arc() {
	    var buffer,
	        r,
	        r0 = +innerRadius.apply(this, arguments),
	        r1 = +outerRadius.apply(this, arguments),
	        a0 = startAngle.apply(this, arguments) - halfPi$1,
	        a1 = endAngle.apply(this, arguments) - halfPi$1,
	        da = Math.abs(a1 - a0),
	        cw = a1 > a0;
	
	    if (!context) context = buffer = path();
	
	    // Ensure that the outer radius is always larger than the inner radius.
	    if (r1 < r0) r = r1, r1 = r0, r0 = r;
	
	    // Is it a point?
	    if (!(r1 > epsilon$1)) context.moveTo(0, 0);
	
	    // Or is it a circle or annulus?
	    else if (da > tau$2 - epsilon$1) {
	      context.moveTo(r1 * Math.cos(a0), r1 * Math.sin(a0));
	      context.arc(0, 0, r1, a0, a1, !cw);
	      if (r0 > epsilon$1) {
	        context.moveTo(r0 * Math.cos(a1), r0 * Math.sin(a1));
	        context.arc(0, 0, r0, a1, a0, cw);
	      }
	    }
	
	    // Or is it a circular or annular sector?
	    else {
	      var a01 = a0,
	          a11 = a1,
	          a00 = a0,
	          a10 = a1,
	          da0 = da,
	          da1 = da,
	          ap = padAngle.apply(this, arguments) / 2,
	          rp = (ap > epsilon$1) && (padRadius ? +padRadius.apply(this, arguments) : Math.sqrt(r0 * r0 + r1 * r1)),
	          rc = Math.min(Math.abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
	          rc0 = rc,
	          rc1 = rc,
	          t0,
	          t1;
	
	      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
	      if (rp > epsilon$1) {
	        var p0 = asin(rp / r0 * Math.sin(ap)),
	            p1 = asin(rp / r1 * Math.sin(ap));
	        if ((da0 -= p0 * 2) > epsilon$1) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
	        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
	        if ((da1 -= p1 * 2) > epsilon$1) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
	        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
	      }
	
	      var x01 = r1 * Math.cos(a01),
	          y01 = r1 * Math.sin(a01),
	          x10 = r0 * Math.cos(a10),
	          y10 = r0 * Math.sin(a10);
	
	      // Apply rounded corners?
	      if (rc > epsilon$1) {
	        var x11 = r1 * Math.cos(a11),
	            y11 = r1 * Math.sin(a11),
	            x00 = r0 * Math.cos(a00),
	            y00 = r0 * Math.sin(a00);
	
	        // Restrict the corner radius according to the sector angle.
	        if (da < pi$2) {
	          var oc = da0 > epsilon$1 ? intersect(x01, y01, x00, y00, x11, y11, x10, y10) : [x10, y10],
	              ax = x01 - oc[0],
	              ay = y01 - oc[1],
	              bx = x11 - oc[0],
	              by = y11 - oc[1],
	              kc = 1 / Math.sin(Math.acos((ax * bx + ay * by) / (Math.sqrt(ax * ax + ay * ay) * Math.sqrt(bx * bx + by * by))) / 2),
	              lc = Math.sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	          rc0 = Math.min(rc, (r0 - lc) / (kc - 1));
	          rc1 = Math.min(rc, (r1 - lc) / (kc + 1));
	        }
	      }
	
	      // Is the sector collapsed to a line?
	      if (!(da1 > epsilon$1)) context.moveTo(x01, y01);
	
	      // Does the sector’s outer ring have rounded corners?
	      else if (rc1 > epsilon$1) {
	        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
	        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
	
	        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, Math.atan2(t0.y01, t0.x01), Math.atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc1, Math.atan2(t0.y01, t0.x01), Math.atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r1, Math.atan2(t0.cy + t0.y11, t0.cx + t0.x11), Math.atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
	          context.arc(t1.cx, t1.cy, rc1, Math.atan2(t1.y11, t1.x11), Math.atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the outer ring just a circular arc?
	      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
	
	      // Is there no inner ring, and it’s a circular sector?
	      // Or perhaps it’s an annular sector collapsed due to padding?
	      if (!(r0 > epsilon$1) || !(da0 > epsilon$1)) context.lineTo(x10, y10);
	
	      // Does the sector’s inner ring (or point) have rounded corners?
	      else if (rc0 > epsilon$1) {
	        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
	        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
	
	        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, Math.atan2(t0.y01, t0.x01), Math.atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc0, Math.atan2(t0.y01, t0.x01), Math.atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r0, Math.atan2(t0.cy + t0.y11, t0.cx + t0.x11), Math.atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
	          context.arc(t1.cx, t1.cy, rc0, Math.atan2(t1.y11, t1.x11), Math.atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the inner ring just a circular arc?
	      else context.arc(0, 0, r0, a10, a00, cw);
	    }
	
	    context.closePath();
	
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  arc.centroid = function() {
	    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
	        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi$2 / 2;
	    return [Math.cos(a) * r, Math.sin(a) * r];
	  };
	
	  arc.innerRadius = function(_) {
	    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant$2(+_), arc) : innerRadius;
	  };
	
	  arc.outerRadius = function(_) {
	    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant$2(+_), arc) : outerRadius;
	  };
	
	  arc.cornerRadius = function(_) {
	    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant$2(+_), arc) : cornerRadius;
	  };
	
	  arc.padRadius = function(_) {
	    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant$2(+_), arc) : padRadius;
	  };
	
	  arc.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$2(+_), arc) : startAngle;
	  };
	
	  arc.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$2(+_), arc) : endAngle;
	  };
	
	  arc.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$2(+_), arc) : padAngle;
	  };
	
	  arc.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
	  };
	
	  return arc;
	};
	
	function Linear(context) {
	  this._context = context;
	}
	
	Linear.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: this._context.lineTo(x, y); break;
	    }
	  }
	};
	
	var curveLinear = function(context) {
	  return new Linear(context);
	};
	
	function x(p) {
	  return p[0];
	}
	
	function y(p) {
	  return p[1];
	}
	
	var line = function() {
	  var x$$1 = x,
	      y$$1 = y,
	      defined = constant$2(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function line(data) {
	    var i,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer;
	
	    if (context == null) output = curve(buffer = path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) output.lineStart();
	        else output.lineEnd();
	      }
	      if (defined0) output.point(+x$$1(d, i, data), +y$$1(d, i, data));
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  line.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant$2(+_), line) : x$$1;
	  };
	
	  line.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant$2(+_), line) : y$$1;
	  };
	
	  line.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant$2(!!_), line) : defined;
	  };
	
	  line.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
	  };
	
	  line.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
	  };
	
	  return line;
	};
	
	var area$1 = function() {
	  var x0 = x,
	      x1 = null,
	      y0 = constant$2(0),
	      y1 = y,
	      defined = constant$2(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function area(data) {
	    var i,
	        j,
	        k,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer,
	        x0z = new Array(n),
	        y0z = new Array(n);
	
	    if (context == null) output = curve(buffer = path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) {
	          j = i;
	          output.areaStart();
	          output.lineStart();
	        } else {
	          output.lineEnd();
	          output.lineStart();
	          for (k = i - 1; k >= j; --k) {
	            output.point(x0z[k], y0z[k]);
	          }
	          output.lineEnd();
	          output.areaEnd();
	        }
	      }
	      if (defined0) {
	        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
	        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
	      }
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  function arealine() {
	    return line().defined(defined).curve(curve).context(context);
	  }
	
	  area.x = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$2(+_), x1 = null, area) : x0;
	  };
	
	  area.x0 = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$2(+_), area) : x0;
	  };
	
	  area.x1 = function(_) {
	    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant$2(+_), area) : x1;
	  };
	
	  area.y = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$2(+_), y1 = null, area) : y0;
	  };
	
	  area.y0 = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$2(+_), area) : y0;
	  };
	
	  area.y1 = function(_) {
	    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant$2(+_), area) : y1;
	  };
	
	  area.lineX0 =
	  area.lineY0 = function() {
	    return arealine().x(x0).y(y0);
	  };
	
	  area.lineY1 = function() {
	    return arealine().x(x0).y(y1);
	  };
	
	  area.lineX1 = function() {
	    return arealine().x(x1).y(y0);
	  };
	
	  area.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant$2(!!_), area) : defined;
	  };
	
	  area.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
	  };
	
	  area.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
	  };
	
	  return area;
	};
	
	var descending$1 = function(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	};
	
	var identity$1 = function(d) {
	  return d;
	};
	
	var pie = function() {
	  var value = identity$1,
	      sortValues = descending$1,
	      sort = null,
	      startAngle = constant$2(0),
	      endAngle = constant$2(tau$2),
	      padAngle = constant$2(0);
	
	  function pie(data) {
	    var i,
	        n = data.length,
	        j,
	        k,
	        sum = 0,
	        index = new Array(n),
	        arcs = new Array(n),
	        a0 = +startAngle.apply(this, arguments),
	        da = Math.min(tau$2, Math.max(-tau$2, endAngle.apply(this, arguments) - a0)),
	        a1,
	        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
	        pa = p * (da < 0 ? -1 : 1),
	        v;
	
	    for (i = 0; i < n; ++i) {
	      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
	        sum += v;
	      }
	    }
	
	    // Optionally sort the arcs by previously-computed values or by data.
	    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
	    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });
	
	    // Compute the arcs! They are stored in the original data's order.
	    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
	      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
	        data: data[j],
	        index: i,
	        value: v,
	        startAngle: a0,
	        endAngle: a1,
	        padAngle: p
	      };
	    }
	
	    return arcs;
	  }
	
	  pie.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant$2(+_), pie) : value;
	  };
	
	  pie.sortValues = function(_) {
	    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
	  };
	
	  pie.sort = function(_) {
	    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
	  };
	
	  pie.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$2(+_), pie) : startAngle;
	  };
	
	  pie.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$2(+_), pie) : endAngle;
	  };
	
	  pie.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$2(+_), pie) : padAngle;
	  };
	
	  return pie;
	};
	
	var curveRadialLinear = curveRadial(curveLinear);
	
	function Radial(curve) {
	  this._curve = curve;
	}
	
	Radial.prototype = {
	  areaStart: function() {
	    this._curve.areaStart();
	  },
	  areaEnd: function() {
	    this._curve.areaEnd();
	  },
	  lineStart: function() {
	    this._curve.lineStart();
	  },
	  lineEnd: function() {
	    this._curve.lineEnd();
	  },
	  point: function(a, r) {
	    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
	  }
	};
	
	function curveRadial(curve) {
	
	  function radial(context) {
	    return new Radial(curve(context));
	  }
	
	  radial._curve = curve;
	
	  return radial;
	}
	
	function radialLine(l) {
	  var c = l.curve;
	
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	
	  l.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return l;
	}
	
	var radialLine$1 = function() {
	  return radialLine(line().curve(curveRadialLinear));
	};
	
	var radialArea = function() {
	  var a = area$1().curve(curveRadialLinear),
	      c = a.curve,
	      x0 = a.lineX0,
	      x1 = a.lineX1,
	      y0 = a.lineY0,
	      y1 = a.lineY1;
	
	  a.angle = a.x, delete a.x;
	  a.startAngle = a.x0, delete a.x0;
	  a.endAngle = a.x1, delete a.x1;
	  a.radius = a.y, delete a.y;
	  a.innerRadius = a.y0, delete a.y0;
	  a.outerRadius = a.y1, delete a.y1;
	  a.lineStartAngle = function() { return radialLine(x0()); }, delete a.lineX0;
	  a.lineEndAngle = function() { return radialLine(x1()); }, delete a.lineX1;
	  a.lineInnerRadius = function() { return radialLine(y0()); }, delete a.lineY0;
	  a.lineOuterRadius = function() { return radialLine(y1()); }, delete a.lineY1;
	
	  a.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return a;
	};
	
	var circle = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / pi$2);
	    context.moveTo(r, 0);
	    context.arc(0, 0, r, 0, tau$2);
	  }
	};
	
	var cross$1 = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / 5) / 2;
	    context.moveTo(-3 * r, -r);
	    context.lineTo(-r, -r);
	    context.lineTo(-r, -3 * r);
	    context.lineTo(r, -3 * r);
	    context.lineTo(r, -r);
	    context.lineTo(3 * r, -r);
	    context.lineTo(3 * r, r);
	    context.lineTo(r, r);
	    context.lineTo(r, 3 * r);
	    context.lineTo(-r, 3 * r);
	    context.lineTo(-r, r);
	    context.lineTo(-3 * r, r);
	    context.closePath();
	  }
	};
	
	var tan30 = Math.sqrt(1 / 3);
	var tan30_2 = tan30 * 2;
	
	var diamond = {
	  draw: function(context, size) {
	    var y = Math.sqrt(size / tan30_2),
	        x = y * tan30;
	    context.moveTo(0, -y);
	    context.lineTo(x, 0);
	    context.lineTo(0, y);
	    context.lineTo(-x, 0);
	    context.closePath();
	  }
	};
	
	var ka = 0.89081309152928522810;
	var kr = Math.sin(pi$2 / 10) / Math.sin(7 * pi$2 / 10);
	var kx = Math.sin(tau$2 / 10) * kr;
	var ky = -Math.cos(tau$2 / 10) * kr;
	
	var star = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size * ka),
	        x = kx * r,
	        y = ky * r;
	    context.moveTo(0, -r);
	    context.lineTo(x, y);
	    for (var i = 1; i < 5; ++i) {
	      var a = tau$2 * i / 5,
	          c = Math.cos(a),
	          s = Math.sin(a);
	      context.lineTo(s * r, -c * r);
	      context.lineTo(c * x - s * y, s * x + c * y);
	    }
	    context.closePath();
	  }
	};
	
	var square = {
	  draw: function(context, size) {
	    var w = Math.sqrt(size),
	        x = -w / 2;
	    context.rect(x, x, w, w);
	  }
	};
	
	var sqrt3 = Math.sqrt(3);
	
	var triangle = {
	  draw: function(context, size) {
	    var y = -Math.sqrt(size / (sqrt3 * 3));
	    context.moveTo(0, y * 2);
	    context.lineTo(-sqrt3 * y, -y);
	    context.lineTo(sqrt3 * y, -y);
	    context.closePath();
	  }
	};
	
	var c = -0.5;
	var s = Math.sqrt(3) / 2;
	var k = 1 / Math.sqrt(12);
	var a = (k / 2 + 1) * 3;
	
	var wye = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / a),
	        x0 = r / 2,
	        y0 = r * k,
	        x1 = x0,
	        y1 = r * k + r,
	        x2 = -x1,
	        y2 = y1;
	    context.moveTo(x0, y0);
	    context.lineTo(x1, y1);
	    context.lineTo(x2, y2);
	    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
	    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
	    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
	    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
	    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
	    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
	    context.closePath();
	  }
	};
	
	var symbols = [
	  circle,
	  cross$1,
	  diamond,
	  square,
	  star,
	  triangle,
	  wye
	];
	
	var symbol = function() {
	  var type = constant$2(circle),
	      size = constant$2(64),
	      context = null;
	
	  function symbol() {
	    var buffer;
	    if (!context) context = buffer = path();
	    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  symbol.type = function(_) {
	    return arguments.length ? (type = typeof _ === "function" ? _ : constant$2(_), symbol) : type;
	  };
	
	  symbol.size = function(_) {
	    return arguments.length ? (size = typeof _ === "function" ? _ : constant$2(+_), symbol) : size;
	  };
	
	  symbol.context = function(_) {
	    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
	  };
	
	  return symbol;
	};
	
	var noop = function() {};
	
	function point(that, x, y) {
	  that._context.bezierCurveTo(
	    (2 * that._x0 + that._x1) / 3,
	    (2 * that._y0 + that._y1) / 3,
	    (that._x0 + 2 * that._x1) / 3,
	    (that._y0 + 2 * that._y1) / 3,
	    (that._x0 + 4 * that._x1 + x) / 6,
	    (that._y0 + 4 * that._y1 + y) / 6
	  );
	}
	
	function Basis(context) {
	  this._context = context;
	}
	
	Basis.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 3: point(this, this._x1, this._y1); // proceed
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basis = function(context) {
	  return new Basis(context);
	};
	
	function BasisClosed(context) {
	  this._context = context;
	}
	
	BasisClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x2, this._y2);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
	        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x2, this._y2);
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
	      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
	      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basisClosed = function(context) {
	  return new BasisClosed(context);
	};
	
	function BasisOpen(context) {
	  this._context = context;
	}
	
	BasisOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
	      case 3: this._point = 4; // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basisOpen = function(context) {
	  return new BasisOpen(context);
	};
	
	function Bundle(context, beta) {
	  this._basis = new Basis(context);
	  this._beta = beta;
	}
	
	Bundle.prototype = {
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	    this._basis.lineStart();
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        j = x.length - 1;
	
	    if (j > 0) {
	      var x0 = x[0],
	          y0 = y[0],
	          dx = x[j] - x0,
	          dy = y[j] - y0,
	          i = -1,
	          t;
	
	      while (++i <= j) {
	        t = i / j;
	        this._basis.point(
	          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
	          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
	        );
	      }
	    }
	
	    this._x = this._y = null;
	    this._basis.lineEnd();
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	var bundle = (function custom(beta) {
	
	  function bundle(context) {
	    return beta === 1 ? new Basis(context) : new Bundle(context, beta);
	  }
	
	  bundle.beta = function(beta) {
	    return custom(+beta);
	  };
	
	  return bundle;
	})(0.85);
	
	function point$1(that, x, y) {
	  that._context.bezierCurveTo(
	    that._x1 + that._k * (that._x2 - that._x0),
	    that._y1 + that._k * (that._y2 - that._y0),
	    that._x2 + that._k * (that._x1 - x),
	    that._y2 + that._k * (that._y1 - y),
	    that._x2,
	    that._y2
	  );
	}
	
	function Cardinal(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	Cardinal.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: point$1(this, this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
	      case 2: this._point = 3; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinal = (function custom(tension) {
	
	  function cardinal(context) {
	    return new Cardinal(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function CardinalClosed(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalClosed = (function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalClosed(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function CardinalOpen(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalOpen = (function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalOpen(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function point$2(that, x, y) {
	  var x1 = that._x1,
	      y1 = that._y1,
	      x2 = that._x2,
	      y2 = that._y2;
	
	  if (that._l01_a > epsilon$1) {
	    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
	        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
	    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
	    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
	  }
	
	  if (that._l23_a > epsilon$1) {
	    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
	        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
	    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
	    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
	  }
	
	  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
	}
	
	function CatmullRom(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRom.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: this.point(this._x2, this._y2); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRom = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function CatmullRomClosed(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomClosed = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function CatmullRomOpen(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomOpen = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function LinearClosed(context) {
	  this._context = context;
	}
	
	LinearClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._point) this._context.closePath();
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    if (this._point) this._context.lineTo(x, y);
	    else this._point = 1, this._context.moveTo(x, y);
	  }
	};
	
	var linearClosed = function(context) {
	  return new LinearClosed(context);
	};
	
	function sign(x) {
	  return x < 0 ? -1 : 1;
	}
	
	// Calculate the slopes of the tangents (Hermite-type interpolation) based on
	// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
	// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
	// NOV(II), P. 443, 1990.
	function slope3(that, x2, y2) {
	  var h0 = that._x1 - that._x0,
	      h1 = x2 - that._x1,
	      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
	      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
	      p = (s0 * h1 + s1 * h0) / (h0 + h1);
	  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
	}
	
	// Calculate a one-sided slope.
	function slope2(that, t) {
	  var h = that._x1 - that._x0;
	  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
	}
	
	// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
	// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
	// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
	function point$3(that, t0, t1) {
	  var x0 = that._x0,
	      y0 = that._y0,
	      x1 = that._x1,
	      y1 = that._y1,
	      dx = (x1 - x0) / 3;
	  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
	}
	
	function MonotoneX(context) {
	  this._context = context;
	}
	
	MonotoneX.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 =
	    this._t0 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	      case 3: point$3(this, this._t0, slope2(this, this._t0)); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    var t1 = NaN;
	
	    x = +x, y = +y;
	    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; point$3(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
	      default: point$3(this, this._t0, t1 = slope3(this, x, y)); break;
	    }
	
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	    this._t0 = t1;
	  }
	};
	
	function MonotoneY(context) {
	  this._context = new ReflectContext(context);
	}
	
	(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
	  MonotoneX.prototype.point.call(this, y, x);
	};
	
	function ReflectContext(context) {
	  this._context = context;
	}
	
	ReflectContext.prototype = {
	  moveTo: function(x, y) { this._context.moveTo(y, x); },
	  closePath: function() { this._context.closePath(); },
	  lineTo: function(x, y) { this._context.lineTo(y, x); },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
	};
	
	function monotoneX(context) {
	  return new MonotoneX(context);
	}
	
	function monotoneY(context) {
	  return new MonotoneY(context);
	}
	
	function Natural(context) {
	  this._context = context;
	}
	
	Natural.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        n = x.length;
	
	    if (n) {
	      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
	      if (n === 2) {
	        this._context.lineTo(x[1], y[1]);
	      } else {
	        var px = controlPoints(x),
	            py = controlPoints(y);
	        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
	          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
	        }
	      }
	    }
	
	    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	    this._x = this._y = null;
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
	function controlPoints(x) {
	  var i,
	      n = x.length - 1,
	      m,
	      a = new Array(n),
	      b = new Array(n),
	      r = new Array(n);
	  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
	  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
	  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
	  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
	  a[n - 1] = r[n - 1] / b[n - 1];
	  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
	  b[n - 1] = (x[n] + a[n - 1]) / 2;
	  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
	  return [a, b];
	}
	
	var natural = function(context) {
	  return new Natural(context);
	};
	
	function Step(context, t) {
	  this._context = context;
	  this._t = t;
	}
	
	Step.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = this._y = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: {
	        if (this._t <= 0) {
	          this._context.lineTo(this._x, y);
	          this._context.lineTo(x, y);
	        } else {
	          var x1 = this._x * (1 - this._t) + x * this._t;
	          this._context.lineTo(x1, this._y);
	          this._context.lineTo(x1, y);
	        }
	        break;
	      }
	    }
	    this._x = x, this._y = y;
	  }
	};
	
	var step = function(context) {
	  return new Step(context, 0.5);
	};
	
	function stepBefore(context) {
	  return new Step(context, 0);
	}
	
	function stepAfter(context) {
	  return new Step(context, 1);
	}
	
	var slice$2 = Array.prototype.slice;
	
	var none = function(series, order) {
	  if (!((n = series.length) > 1)) return;
	  for (var i = 1, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
	    s0 = s1, s1 = series[order[i]];
	    for (var j = 0; j < m; ++j) {
	      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
	    }
	  }
	};
	
	var none$1 = function(series) {
	  var n = series.length, o = new Array(n);
	  while (--n >= 0) o[n] = n;
	  return o;
	};
	
	function stackValue(d, key) {
	  return d[key];
	}
	
	var stack = function() {
	  var keys = constant$2([]),
	      order = none$1,
	      offset = none,
	      value = stackValue;
	
	  function stack(data) {
	    var kz = keys.apply(this, arguments),
	        i,
	        m = data.length,
	        n = kz.length,
	        sz = new Array(n),
	        oz;
	
	    for (i = 0; i < n; ++i) {
	      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
	        si[j] = sij = [0, +value(data[j], ki, j, data)];
	        sij.data = data[j];
	      }
	      si.key = ki;
	    }
	
	    for (i = 0, oz = order(sz); i < n; ++i) {
	      sz[oz[i]].index = i;
	    }
	
	    offset(sz, oz);
	    return sz;
	  }
	
	  stack.keys = function(_) {
	    return arguments.length ? (keys = typeof _ === "function" ? _ : constant$2(slice$2.call(_)), stack) : keys;
	  };
	
	  stack.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant$2(+_), stack) : value;
	  };
	
	  stack.order = function(_) {
	    return arguments.length ? (order = _ == null ? none$1 : typeof _ === "function" ? _ : constant$2(slice$2.call(_)), stack) : order;
	  };
	
	  stack.offset = function(_) {
	    return arguments.length ? (offset = _ == null ? none : _, stack) : offset;
	  };
	
	  return stack;
	};
	
	var expand = function(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
	    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
	    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
	  }
	  none(series, order);
	};
	
	var silhouette = function(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
	    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
	    s0[j][1] += s0[j][0] = -y / 2;
	  }
	  none(series, order);
	};
	
	var wiggle = function(series, order) {
	  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
	  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
	    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
	      var si = series[order[i]],
	          sij0 = si[j][1] || 0,
	          sij1 = si[j - 1][1] || 0,
	          s3 = (sij0 - sij1) / 2;
	      for (var k = 0; k < i; ++k) {
	        var sk = series[order[k]],
	            skj0 = sk[j][1] || 0,
	            skj1 = sk[j - 1][1] || 0;
	        s3 += skj0 - skj1;
	      }
	      s1 += sij0, s2 += s3 * sij0;
	    }
	    s0[j - 1][1] += s0[j - 1][0] = y;
	    if (s1) y -= s2 / s1;
	  }
	  s0[j - 1][1] += s0[j - 1][0] = y;
	  none(series, order);
	};
	
	var ascending$1 = function(series) {
	  var sums = series.map(sum$1);
	  return none$1(series).sort(function(a, b) { return sums[a] - sums[b]; });
	};
	
	function sum$1(series) {
	  var s = 0, i = -1, n = series.length, v;
	  while (++i < n) if (v = +series[i][1]) s += v;
	  return s;
	}
	
	var descending$2 = function(series) {
	  return ascending$1(series).reverse();
	};
	
	var insideOut = function(series) {
	  var n = series.length,
	      i,
	      j,
	      sums = series.map(sum$1),
	      order = none$1(series).sort(function(a, b) { return sums[b] - sums[a]; }),
	      top = 0,
	      bottom = 0,
	      tops = [],
	      bottoms = [];
	
	  for (i = 0; i < n; ++i) {
	    j = order[i];
	    if (top < bottom) {
	      top += sums[j];
	      tops.push(j);
	    } else {
	      bottom += sums[j];
	      bottoms.push(j);
	    }
	  }
	
	  return bottoms.reverse().concat(tops);
	};
	
	var reverse = function(series) {
	  return none$1(series).reverse();
	};
	
	var define = function(constructor, factory, prototype) {
	  constructor.prototype = factory.prototype = prototype;
	  prototype.constructor = constructor;
	};
	
	function extend(parent, definition) {
	  var prototype = Object.create(parent.prototype);
	  for (var key in definition) prototype[key] = definition[key];
	  return prototype;
	}
	
	function Color() {}
	
	var darker = 0.7;
	var brighter = 1 / darker;
	
	var reI = "\\s*([+-]?\\d+)\\s*";
	var reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*";
	var reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*";
	var reHex3 = /^#([0-9a-f]{3})$/;
	var reHex6 = /^#([0-9a-f]{6})$/;
	var reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$");
	var reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$");
	var reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$");
	var reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$");
	var reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$");
	var reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");
	
	var named = {
	  aliceblue: 0xf0f8ff,
	  antiquewhite: 0xfaebd7,
	  aqua: 0x00ffff,
	  aquamarine: 0x7fffd4,
	  azure: 0xf0ffff,
	  beige: 0xf5f5dc,
	  bisque: 0xffe4c4,
	  black: 0x000000,
	  blanchedalmond: 0xffebcd,
	  blue: 0x0000ff,
	  blueviolet: 0x8a2be2,
	  brown: 0xa52a2a,
	  burlywood: 0xdeb887,
	  cadetblue: 0x5f9ea0,
	  chartreuse: 0x7fff00,
	  chocolate: 0xd2691e,
	  coral: 0xff7f50,
	  cornflowerblue: 0x6495ed,
	  cornsilk: 0xfff8dc,
	  crimson: 0xdc143c,
	  cyan: 0x00ffff,
	  darkblue: 0x00008b,
	  darkcyan: 0x008b8b,
	  darkgoldenrod: 0xb8860b,
	  darkgray: 0xa9a9a9,
	  darkgreen: 0x006400,
	  darkgrey: 0xa9a9a9,
	  darkkhaki: 0xbdb76b,
	  darkmagenta: 0x8b008b,
	  darkolivegreen: 0x556b2f,
	  darkorange: 0xff8c00,
	  darkorchid: 0x9932cc,
	  darkred: 0x8b0000,
	  darksalmon: 0xe9967a,
	  darkseagreen: 0x8fbc8f,
	  darkslateblue: 0x483d8b,
	  darkslategray: 0x2f4f4f,
	  darkslategrey: 0x2f4f4f,
	  darkturquoise: 0x00ced1,
	  darkviolet: 0x9400d3,
	  deeppink: 0xff1493,
	  deepskyblue: 0x00bfff,
	  dimgray: 0x696969,
	  dimgrey: 0x696969,
	  dodgerblue: 0x1e90ff,
	  firebrick: 0xb22222,
	  floralwhite: 0xfffaf0,
	  forestgreen: 0x228b22,
	  fuchsia: 0xff00ff,
	  gainsboro: 0xdcdcdc,
	  ghostwhite: 0xf8f8ff,
	  gold: 0xffd700,
	  goldenrod: 0xdaa520,
	  gray: 0x808080,
	  green: 0x008000,
	  greenyellow: 0xadff2f,
	  grey: 0x808080,
	  honeydew: 0xf0fff0,
	  hotpink: 0xff69b4,
	  indianred: 0xcd5c5c,
	  indigo: 0x4b0082,
	  ivory: 0xfffff0,
	  khaki: 0xf0e68c,
	  lavender: 0xe6e6fa,
	  lavenderblush: 0xfff0f5,
	  lawngreen: 0x7cfc00,
	  lemonchiffon: 0xfffacd,
	  lightblue: 0xadd8e6,
	  lightcoral: 0xf08080,
	  lightcyan: 0xe0ffff,
	  lightgoldenrodyellow: 0xfafad2,
	  lightgray: 0xd3d3d3,
	  lightgreen: 0x90ee90,
	  lightgrey: 0xd3d3d3,
	  lightpink: 0xffb6c1,
	  lightsalmon: 0xffa07a,
	  lightseagreen: 0x20b2aa,
	  lightskyblue: 0x87cefa,
	  lightslategray: 0x778899,
	  lightslategrey: 0x778899,
	  lightsteelblue: 0xb0c4de,
	  lightyellow: 0xffffe0,
	  lime: 0x00ff00,
	  limegreen: 0x32cd32,
	  linen: 0xfaf0e6,
	  magenta: 0xff00ff,
	  maroon: 0x800000,
	  mediumaquamarine: 0x66cdaa,
	  mediumblue: 0x0000cd,
	  mediumorchid: 0xba55d3,
	  mediumpurple: 0x9370db,
	  mediumseagreen: 0x3cb371,
	  mediumslateblue: 0x7b68ee,
	  mediumspringgreen: 0x00fa9a,
	  mediumturquoise: 0x48d1cc,
	  mediumvioletred: 0xc71585,
	  midnightblue: 0x191970,
	  mintcream: 0xf5fffa,
	  mistyrose: 0xffe4e1,
	  moccasin: 0xffe4b5,
	  navajowhite: 0xffdead,
	  navy: 0x000080,
	  oldlace: 0xfdf5e6,
	  olive: 0x808000,
	  olivedrab: 0x6b8e23,
	  orange: 0xffa500,
	  orangered: 0xff4500,
	  orchid: 0xda70d6,
	  palegoldenrod: 0xeee8aa,
	  palegreen: 0x98fb98,
	  paleturquoise: 0xafeeee,
	  palevioletred: 0xdb7093,
	  papayawhip: 0xffefd5,
	  peachpuff: 0xffdab9,
	  peru: 0xcd853f,
	  pink: 0xffc0cb,
	  plum: 0xdda0dd,
	  powderblue: 0xb0e0e6,
	  purple: 0x800080,
	  rebeccapurple: 0x663399,
	  red: 0xff0000,
	  rosybrown: 0xbc8f8f,
	  royalblue: 0x4169e1,
	  saddlebrown: 0x8b4513,
	  salmon: 0xfa8072,
	  sandybrown: 0xf4a460,
	  seagreen: 0x2e8b57,
	  seashell: 0xfff5ee,
	  sienna: 0xa0522d,
	  silver: 0xc0c0c0,
	  skyblue: 0x87ceeb,
	  slateblue: 0x6a5acd,
	  slategray: 0x708090,
	  slategrey: 0x708090,
	  snow: 0xfffafa,
	  springgreen: 0x00ff7f,
	  steelblue: 0x4682b4,
	  tan: 0xd2b48c,
	  teal: 0x008080,
	  thistle: 0xd8bfd8,
	  tomato: 0xff6347,
	  turquoise: 0x40e0d0,
	  violet: 0xee82ee,
	  wheat: 0xf5deb3,
	  white: 0xffffff,
	  whitesmoke: 0xf5f5f5,
	  yellow: 0xffff00,
	  yellowgreen: 0x9acd32
	};
	
	define(Color, color, {
	  displayable: function() {
	    return this.rgb().displayable();
	  },
	  toString: function() {
	    return this.rgb() + "";
	  }
	});
	
	function color(format) {
	  var m;
	  format = (format + "").trim().toLowerCase();
	  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
	      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
	      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
	      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
	      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
	      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
	      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
	      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
	      : named.hasOwnProperty(format) ? rgbn(named[format])
	      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
	      : null;
	}
	
	function rgbn(n) {
	  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
	}
	
	function rgba(r, g, b, a) {
	  if (a <= 0) r = g = b = NaN;
	  return new Rgb(r, g, b, a);
	}
	
	function rgbConvert(o) {
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Rgb;
	  o = o.rgb();
	  return new Rgb(o.r, o.g, o.b, o.opacity);
	}
	
	function rgb(r, g, b, opacity) {
	  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
	}
	
	function Rgb(r, g, b, opacity) {
	  this.r = +r;
	  this.g = +g;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Rgb, rgb, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  rgb: function() {
	    return this;
	  },
	  displayable: function() {
	    return (0 <= this.r && this.r <= 255)
	        && (0 <= this.g && this.g <= 255)
	        && (0 <= this.b && this.b <= 255)
	        && (0 <= this.opacity && this.opacity <= 1);
	  },
	  toString: function() {
	    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
	    return (a === 1 ? "rgb(" : "rgba(")
	        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
	        + (a === 1 ? ")" : ", " + a + ")");
	  }
	}));
	
	function hsla(h, s, l, a) {
	  if (a <= 0) h = s = l = NaN;
	  else if (l <= 0 || l >= 1) h = s = NaN;
	  else if (s <= 0) h = NaN;
	  return new Hsl(h, s, l, a);
	}
	
	function hslConvert(o) {
	  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Hsl;
	  if (o instanceof Hsl) return o;
	  o = o.rgb();
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      h = NaN,
	      s = max - min,
	      l = (max + min) / 2;
	  if (s) {
	    if (r === max) h = (g - b) / s + (g < b) * 6;
	    else if (g === max) h = (b - r) / s + 2;
	    else h = (r - g) / s + 4;
	    s /= l < 0.5 ? max + min : 2 - max - min;
	    h *= 60;
	  } else {
	    s = l > 0 && l < 1 ? 0 : h;
	  }
	  return new Hsl(h, s, l, o.opacity);
	}
	
	function hsl(h, s, l, opacity) {
	  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Hsl(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hsl, hsl, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = this.h % 360 + (this.h < 0) * 360,
	        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
	        l = this.l,
	        m2 = l + (l < 0.5 ? l : 1 - l) * s,
	        m1 = 2 * l - m2;
	    return new Rgb(
	      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
	      hsl2rgb(h, m1, m2),
	      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
	      this.opacity
	    );
	  },
	  displayable: function() {
	    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
	        && (0 <= this.l && this.l <= 1)
	        && (0 <= this.opacity && this.opacity <= 1);
	  }
	}));
	
	/* From FvD 13.37, CSS Color Module Level 3 */
	function hsl2rgb(h, m1, m2) {
	  return (h < 60 ? m1 + (m2 - m1) * h / 60
	      : h < 180 ? m2
	      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
	      : m1) * 255;
	}
	
	var deg2rad = Math.PI / 180;
	var rad2deg = 180 / Math.PI;
	
	var Kn = 18;
	var Xn = 0.950470;
	var Yn = 1;
	var Zn = 1.088830;
	var t0 = 4 / 29;
	var t1 = 6 / 29;
	var t2 = 3 * t1 * t1;
	var t3 = t1 * t1 * t1;
	
	function labConvert(o) {
	  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
	  if (o instanceof Hcl) {
	    var h = o.h * deg2rad;
	    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
	  }
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var b = rgb2xyz(o.r),
	      a = rgb2xyz(o.g),
	      l = rgb2xyz(o.b),
	      x = xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / Xn),
	      y = xyz2lab((0.2126729 * b + 0.7151522 * a + 0.0721750 * l) / Yn),
	      z = xyz2lab((0.0193339 * b + 0.1191920 * a + 0.9503041 * l) / Zn);
	  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
	}
	
	function lab(l, a, b, opacity) {
	  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
	}
	
	function Lab(l, a, b, opacity) {
	  this.l = +l;
	  this.a = +a;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Lab, lab, extend(Color, {
	  brighter: function(k) {
	    return new Lab(this.l + Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  darker: function(k) {
	    return new Lab(this.l - Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  rgb: function() {
	    var y = (this.l + 16) / 116,
	        x = isNaN(this.a) ? y : y + this.a / 500,
	        z = isNaN(this.b) ? y : y - this.b / 200;
	    y = Yn * lab2xyz(y);
	    x = Xn * lab2xyz(x);
	    z = Zn * lab2xyz(z);
	    return new Rgb(
	      xyz2rgb( 3.2404542 * x - 1.5371385 * y - 0.4985314 * z), // D65 -> sRGB
	      xyz2rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z),
	      xyz2rgb( 0.0556434 * x - 0.2040259 * y + 1.0572252 * z),
	      this.opacity
	    );
	  }
	}));
	
	function xyz2lab(t) {
	  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
	}
	
	function lab2xyz(t) {
	  return t > t1 ? t * t * t : t2 * (t - t0);
	}
	
	function xyz2rgb(x) {
	  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
	}
	
	function rgb2xyz(x) {
	  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
	}
	
	function hclConvert(o) {
	  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
	  if (!(o instanceof Lab)) o = labConvert(o);
	  var h = Math.atan2(o.b, o.a) * rad2deg;
	  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
	}
	
	function hcl(h, c, l, opacity) {
	  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function Hcl(h, c, l, opacity) {
	  this.h = +h;
	  this.c = +c;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hcl, hcl, extend(Color, {
	  brighter: function(k) {
	    return new Hcl(this.h, this.c, this.l + Kn * (k == null ? 1 : k), this.opacity);
	  },
	  darker: function(k) {
	    return new Hcl(this.h, this.c, this.l - Kn * (k == null ? 1 : k), this.opacity);
	  },
	  rgb: function() {
	    return labConvert(this).rgb();
	  }
	}));
	
	var A = -0.14861;
	var B = +1.78277;
	var C = -0.29227;
	var D = -0.90649;
	var E = +1.97294;
	var ED = E * D;
	var EB = E * B;
	var BC_DA = B * C - D * A;
	
	function cubehelixConvert(o) {
	  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
	      bl = b - l,
	      k = (E * (g - l) - C * bl) / D,
	      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
	      h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
	  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
	}
	
	function cubehelix(h, s, l, opacity) {
	  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Cubehelix(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Cubehelix, cubehelix, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
	        l = +this.l,
	        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
	        cosh = Math.cos(h),
	        sinh = Math.sin(h);
	    return new Rgb(
	      255 * (l + a * (A * cosh + B * sinh)),
	      255 * (l + a * (C * cosh + D * sinh)),
	      255 * (l + a * (E * cosh)),
	      this.opacity
	    );
	  }
	}));
	
	function basis$1(t1, v0, v1, v2, v3) {
	  var t2 = t1 * t1, t3 = t2 * t1;
	  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
	      + (4 - 6 * t2 + 3 * t3) * v1
	      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
	      + t3 * v3) / 6;
	}
	
	var basis$2 = function(values) {
	  var n = values.length - 1;
	  return function(t) {
	    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
	        v1 = values[i],
	        v2 = values[i + 1],
	        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
	        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
	    return basis$1((t - i / n) * n, v0, v1, v2, v3);
	  };
	};
	
	var basisClosed$1 = function(values) {
	  var n = values.length;
	  return function(t) {
	    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
	        v0 = values[(i + n - 1) % n],
	        v1 = values[i % n],
	        v2 = values[(i + 1) % n],
	        v3 = values[(i + 2) % n];
	    return basis$1((t - i / n) * n, v0, v1, v2, v3);
	  };
	};
	
	var constant$3 = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function linear$1(a, d) {
	  return function(t) {
	    return a + t * d;
	  };
	}
	
	function exponential$1(a, b, y) {
	  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
	    return Math.pow(a + t * b, y);
	  };
	}
	
	function hue(a, b) {
	  var d = b - a;
	  return d ? linear$1(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant$3(isNaN(a) ? b : a);
	}
	
	function gamma(y) {
	  return (y = +y) === 1 ? nogamma : function(a, b) {
	    return b - a ? exponential$1(a, b, y) : constant$3(isNaN(a) ? b : a);
	  };
	}
	
	function nogamma(a, b) {
	  var d = b - a;
	  return d ? linear$1(a, d) : constant$3(isNaN(a) ? b : a);
	}
	
	var interpolateRgb = (function rgbGamma(y) {
	  var color$$1 = gamma(y);
	
	  function rgb$$1(start, end) {
	    var r = color$$1((start = rgb(start)).r, (end = rgb(end)).r),
	        g = color$$1(start.g, end.g),
	        b = color$$1(start.b, end.b),
	        opacity = color$$1(start.opacity, end.opacity);
	    return function(t) {
	      start.r = r(t);
	      start.g = g(t);
	      start.b = b(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	
	  rgb$$1.gamma = rgbGamma;
	
	  return rgb$$1;
	})(1);
	
	function rgbSpline(spline) {
	  return function(colors) {
	    var n = colors.length,
	        r = new Array(n),
	        g = new Array(n),
	        b = new Array(n),
	        i, color$$1;
	    for (i = 0; i < n; ++i) {
	      color$$1 = rgb(colors[i]);
	      r[i] = color$$1.r || 0;
	      g[i] = color$$1.g || 0;
	      b[i] = color$$1.b || 0;
	    }
	    r = spline(r);
	    g = spline(g);
	    b = spline(b);
	    color$$1.opacity = 1;
	    return function(t) {
	      color$$1.r = r(t);
	      color$$1.g = g(t);
	      color$$1.b = b(t);
	      return color$$1 + "";
	    };
	  };
	}
	
	var rgbBasis = rgbSpline(basis$2);
	var rgbBasisClosed = rgbSpline(basisClosed$1);
	
	var array$1 = function(a, b) {
	  var nb = b ? b.length : 0,
	      na = a ? Math.min(nb, a.length) : 0,
	      x = new Array(nb),
	      c = new Array(nb),
	      i;
	
	  for (i = 0; i < na; ++i) x[i] = interpolate(a[i], b[i]);
	  for (; i < nb; ++i) c[i] = b[i];
	
	  return function(t) {
	    for (i = 0; i < na; ++i) c[i] = x[i](t);
	    return c;
	  };
	};
	
	var date = function(a, b) {
	  var d = new Date;
	  return a = +a, b -= a, function(t) {
	    return d.setTime(a + b * t), d;
	  };
	};
	
	var interpolateNumber = function(a, b) {
	  return a = +a, b -= a, function(t) {
	    return a + b * t;
	  };
	};
	
	var object = function(a, b) {
	  var i = {},
	      c = {},
	      k;
	
	  if (a === null || typeof a !== "object") a = {};
	  if (b === null || typeof b !== "object") b = {};
	
	  for (k in b) {
	    if (k in a) {
	      i[k] = interpolate(a[k], b[k]);
	    } else {
	      c[k] = b[k];
	    }
	  }
	
	  return function(t) {
	    for (k in i) c[k] = i[k](t);
	    return c;
	  };
	};
	
	var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g;
	var reB = new RegExp(reA.source, "g");
	
	function zero(b) {
	  return function() {
	    return b;
	  };
	}
	
	function one(b) {
	  return function(t) {
	    return b(t) + "";
	  };
	}
	
	var interpolateString = function(a, b) {
	  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
	      am, // current match in a
	      bm, // current match in b
	      bs, // string preceding current number in b, if any
	      i = -1, // index in s
	      s = [], // string constants and placeholders
	      q = []; // number interpolators
	
	  // Coerce inputs to strings.
	  a = a + "", b = b + "";
	
	  // Interpolate pairs of numbers in a & b.
	  while ((am = reA.exec(a))
	      && (bm = reB.exec(b))) {
	    if ((bs = bm.index) > bi) { // a string precedes the next number in b
	      bs = b.slice(bi, bs);
	      if (s[i]) s[i] += bs; // coalesce with previous string
	      else s[++i] = bs;
	    }
	    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
	      if (s[i]) s[i] += bm; // coalesce with previous string
	      else s[++i] = bm;
	    } else { // interpolate non-matching numbers
	      s[++i] = null;
	      q.push({i: i, x: interpolateNumber(am, bm)});
	    }
	    bi = reB.lastIndex;
	  }
	
	  // Add remains of b.
	  if (bi < b.length) {
	    bs = b.slice(bi);
	    if (s[i]) s[i] += bs; // coalesce with previous string
	    else s[++i] = bs;
	  }
	
	  // Special optimization for only a single match.
	  // Otherwise, interpolate each of the numbers and rejoin the string.
	  return s.length < 2 ? (q[0]
	      ? one(q[0].x)
	      : zero(b))
	      : (b = q.length, function(t) {
	          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	          return s.join("");
	        });
	};
	
	var interpolate = function(a, b) {
	  var t = typeof b, c;
	  return b == null || t === "boolean" ? constant$3(b)
	      : (t === "number" ? interpolateNumber
	      : t === "string" ? ((c = color(b)) ? (b = c, interpolateRgb) : interpolateString)
	      : b instanceof color ? interpolateRgb
	      : b instanceof Date ? date
	      : Array.isArray(b) ? array$1
	      : isNaN(b) ? object
	      : interpolateNumber)(a, b);
	};
	
	var interpolateRound = function(a, b) {
	  return a = +a, b -= a, function(t) {
	    return Math.round(a + b * t);
	  };
	};
	
	var degrees = 180 / Math.PI;
	
	var identity$2 = {
	  translateX: 0,
	  translateY: 0,
	  rotate: 0,
	  skewX: 0,
	  scaleX: 1,
	  scaleY: 1
	};
	
	var decompose = function(a, b, c, d, e, f) {
	  var scaleX, scaleY, skewX;
	  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
	  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
	  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
	  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
	  return {
	    translateX: e,
	    translateY: f,
	    rotate: Math.atan2(b, a) * degrees,
	    skewX: Math.atan(skewX) * degrees,
	    scaleX: scaleX,
	    scaleY: scaleY
	  };
	};
	
	var cssNode;
	var cssRoot;
	var cssView;
	var svgNode;
	
	function parseCss(value) {
	  if (value === "none") return identity$2;
	  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
	  cssNode.style.transform = value;
	  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
	  cssRoot.removeChild(cssNode);
	  value = value.slice(7, -1).split(",");
	  return decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
	}
	
	function parseSvg(value) {
	  if (value == null) return identity$2;
	  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
	  svgNode.setAttribute("transform", value);
	  if (!(value = svgNode.transform.baseVal.consolidate())) return identity$2;
	  value = value.matrix;
	  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
	}
	
	function interpolateTransform(parse, pxComma, pxParen, degParen) {
	
	  function pop(s) {
	    return s.length ? s.pop() + " " : "";
	  }
	
	  function translate(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push("translate(", null, pxComma, null, pxParen);
	      q.push({i: i - 4, x: interpolateNumber(xa, xb)}, {i: i - 2, x: interpolateNumber(ya, yb)});
	    } else if (xb || yb) {
	      s.push("translate(" + xb + pxComma + yb + pxParen);
	    }
	  }
	
	  function rotate(a, b, s, q) {
	    if (a !== b) {
	      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
	      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: interpolateNumber(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "rotate(" + b + degParen);
	    }
	  }
	
	  function skewX(a, b, s, q) {
	    if (a !== b) {
	      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: interpolateNumber(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "skewX(" + b + degParen);
	    }
	  }
	
	  function scale(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
	      q.push({i: i - 4, x: interpolateNumber(xa, xb)}, {i: i - 2, x: interpolateNumber(ya, yb)});
	    } else if (xb !== 1 || yb !== 1) {
	      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
	    }
	  }
	
	  return function(a, b) {
	    var s = [], // string constants and placeholders
	        q = []; // number interpolators
	    a = parse(a), b = parse(b);
	    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
	    rotate(a.rotate, b.rotate, s, q);
	    skewX(a.skewX, b.skewX, s, q);
	    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
	    a = b = null; // gc
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  };
	}
	
	var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
	var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
	
	var rho = Math.SQRT2;
	var rho2 = 2;
	var rho4 = 4;
	var epsilon2 = 1e-12;
	
	function cosh(x) {
	  return ((x = Math.exp(x)) + 1 / x) / 2;
	}
	
	function sinh(x) {
	  return ((x = Math.exp(x)) - 1 / x) / 2;
	}
	
	function tanh(x) {
	  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	}
	
	// p0 = [ux0, uy0, w0]
	// p1 = [ux1, uy1, w1]
	var interpolateZoom = function(p0, p1) {
	  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
	      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
	      dx = ux1 - ux0,
	      dy = uy1 - uy0,
	      d2 = dx * dx + dy * dy,
	      i,
	      S;
	
	  // Special case for u0 ≅ u1.
	  if (d2 < epsilon2) {
	    S = Math.log(w1 / w0) / rho;
	    i = function(t) {
	      return [
	        ux0 + t * dx,
	        uy0 + t * dy,
	        w0 * Math.exp(rho * t * S)
	      ];
	    };
	  }
	
	  // General case.
	  else {
	    var d1 = Math.sqrt(d2),
	        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
	        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
	        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
	        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	    S = (r1 - r0) / rho;
	    i = function(t) {
	      var s = t * S,
	          coshr0 = cosh(r0),
	          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
	      return [
	        ux0 + u * dx,
	        uy0 + u * dy,
	        w0 * coshr0 / cosh(rho * s + r0)
	      ];
	    };
	  }
	
	  i.duration = S * 1000;
	
	  return i;
	};
	
	function hsl$1(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = hsl(start)).h, (end = hsl(end)).h),
	        s = nogamma(start.s, end.s),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.s = s(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hsl$2 = hsl$1(hue);
	var hslLong = hsl$1(nogamma);
	
	function lab$1(start, end) {
	  var l = nogamma((start = lab(start)).l, (end = lab(end)).l),
	      a = nogamma(start.a, end.a),
	      b = nogamma(start.b, end.b),
	      opacity = nogamma(start.opacity, end.opacity);
	  return function(t) {
	    start.l = l(t);
	    start.a = a(t);
	    start.b = b(t);
	    start.opacity = opacity(t);
	    return start + "";
	  };
	}
	
	function hcl$1(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = hcl(start)).h, (end = hcl(end)).h),
	        c = nogamma(start.c, end.c),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.c = c(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hcl$2 = hcl$1(hue);
	var hclLong = hcl$1(nogamma);
	
	function cubehelix$1(hue$$1) {
	  return (function cubehelixGamma(y) {
	    y = +y;
	
	    function cubehelix$$1(start, end) {
	      var h = hue$$1((start = cubehelix(start)).h, (end = cubehelix(end)).h),
	          s = nogamma(start.s, end.s),
	          l = nogamma(start.l, end.l),
	          opacity = nogamma(start.opacity, end.opacity);
	      return function(t) {
	        start.h = h(t);
	        start.s = s(t);
	        start.l = l(Math.pow(t, y));
	        start.opacity = opacity(t);
	        return start + "";
	      };
	    }
	
	    cubehelix$$1.gamma = cubehelixGamma;
	
	    return cubehelix$$1;
	  })(1);
	}
	
	var cubehelix$2 = cubehelix$1(hue);
	var cubehelixLong = cubehelix$1(nogamma);
	
	var quantize = function(interpolator, n) {
	  var samples = new Array(n);
	  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
	  return samples;
	};
	
	var noop$1 = {value: function() {}};
	
	function dispatch() {
	  for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
	    if (!(t = arguments[i] + "") || (t in _)) throw new Error("illegal type: " + t);
	    _[t] = [];
	  }
	  return new Dispatch(_);
	}
	
	function Dispatch(_) {
	  this._ = _;
	}
	
	function parseTypenames(typenames, types) {
	  return typenames.trim().split(/^|\s+/).map(function(t) {
	    var name = "", i = t.indexOf(".");
	    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
	    if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
	    return {type: t, name: name};
	  });
	}
	
	Dispatch.prototype = dispatch.prototype = {
	  constructor: Dispatch,
	  on: function(typename, callback) {
	    var _ = this._,
	        T = parseTypenames(typename + "", _),
	        t,
	        i = -1,
	        n = T.length;
	
	    // If no callback was specified, return the callback of the given type and name.
	    if (arguments.length < 2) {
	      while (++i < n) if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
	      return;
	    }
	
	    // If a type was specified, set the callback for the given type and name.
	    // Otherwise, if a null callback was specified, remove callbacks of the given name.
	    if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
	    while (++i < n) {
	      if (t = (typename = T[i]).type) _[t] = set$2(_[t], typename.name, callback);
	      else if (callback == null) for (t in _) _[t] = set$2(_[t], typename.name, null);
	    }
	
	    return this;
	  },
	  copy: function() {
	    var copy = {}, _ = this._;
	    for (var t in _) copy[t] = _[t].slice();
	    return new Dispatch(copy);
	  },
	  call: function(type, that) {
	    if ((n = arguments.length - 2) > 0) for (var args = new Array(n), i = 0, n, t; i < n; ++i) args[i] = arguments[i + 2];
	    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
	    for (t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
	  },
	  apply: function(type, that, args) {
	    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
	    for (var t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
	  }
	};
	
	function get(type, name) {
	  for (var i = 0, n = type.length, c; i < n; ++i) {
	    if ((c = type[i]).name === name) {
	      return c.value;
	    }
	  }
	}
	
	function set$2(type, name, callback) {
	  for (var i = 0, n = type.length; i < n; ++i) {
	    if (type[i].name === name) {
	      type[i] = noop$1, type = type.slice(0, i).concat(type.slice(i + 1));
	      break;
	    }
	  }
	  if (callback != null) type.push({name: name, value: callback});
	  return type;
	}
	
	function objectConverter(columns) {
	  return new Function("d", "return {" + columns.map(function(name, i) {
	    return JSON.stringify(name) + ": d[" + i + "]";
	  }).join(",") + "}");
	}
	
	function customConverter(columns, f) {
	  var object = objectConverter(columns);
	  return function(row, i) {
	    return f(object(row), i, columns);
	  };
	}
	
	// Compute unique columns in order of discovery.
	function inferColumns(rows) {
	  var columnSet = Object.create(null),
	      columns = [];
	
	  rows.forEach(function(row) {
	    for (var column in row) {
	      if (!(column in columnSet)) {
	        columns.push(columnSet[column] = column);
	      }
	    }
	  });
	
	  return columns;
	}
	
	var dsv = function(delimiter) {
	  var reFormat = new RegExp("[\"" + delimiter + "\n]"),
	      delimiterCode = delimiter.charCodeAt(0);
	
	  function parse(text, f) {
	    var convert, columns, rows = parseRows(text, function(row, i) {
	      if (convert) return convert(row, i - 1);
	      columns = row, convert = f ? customConverter(row, f) : objectConverter(row);
	    });
	    rows.columns = columns;
	    return rows;
	  }
	
	  function parseRows(text, f) {
	    var EOL = {}, // sentinel value for end-of-line
	        EOF = {}, // sentinel value for end-of-file
	        rows = [], // output rows
	        N = text.length,
	        I = 0, // current character index
	        n = 0, // the current line number
	        t, // the current token
	        eol; // is the current token followed by EOL?
	
	    function token() {
	      if (I >= N) return EOF; // special case: end of file
	      if (eol) return eol = false, EOL; // special case: end of line
	
	      // special case: quotes
	      var j = I, c;
	      if (text.charCodeAt(j) === 34) {
	        var i = j;
	        while (i++ < N) {
	          if (text.charCodeAt(i) === 34) {
	            if (text.charCodeAt(i + 1) !== 34) break;
	            ++i;
	          }
	        }
	        I = i + 2;
	        c = text.charCodeAt(i + 1);
	        if (c === 13) {
	          eol = true;
	          if (text.charCodeAt(i + 2) === 10) ++I;
	        } else if (c === 10) {
	          eol = true;
	        }
	        return text.slice(j + 1, i).replace(/""/g, "\"");
	      }
	
	      // common case: find next delimiter or newline
	      while (I < N) {
	        var k = 1;
	        c = text.charCodeAt(I++);
	        if (c === 10) eol = true; // \n
	        else if (c === 13) { eol = true; if (text.charCodeAt(I) === 10) ++I, ++k; } // \r|\r\n
	        else if (c !== delimiterCode) continue;
	        return text.slice(j, I - k);
	      }
	
	      // special case: last token before EOF
	      return text.slice(j);
	    }
	
	    while ((t = token()) !== EOF) {
	      var a = [];
	      while (t !== EOL && t !== EOF) {
	        a.push(t);
	        t = token();
	      }
	      if (f && (a = f(a, n++)) == null) continue;
	      rows.push(a);
	    }
	
	    return rows;
	  }
	
	  function format(rows, columns) {
	    if (columns == null) columns = inferColumns(rows);
	    return [columns.map(formatValue).join(delimiter)].concat(rows.map(function(row) {
	      return columns.map(function(column) {
	        return formatValue(row[column]);
	      }).join(delimiter);
	    })).join("\n");
	  }
	
	  function formatRows(rows) {
	    return rows.map(formatRow).join("\n");
	  }
	
	  function formatRow(row) {
	    return row.map(formatValue).join(delimiter);
	  }
	
	  function formatValue(text) {
	    return text == null ? ""
	        : reFormat.test(text += "") ? "\"" + text.replace(/\"/g, "\"\"") + "\""
	        : text;
	  }
	
	  return {
	    parse: parse,
	    parseRows: parseRows,
	    format: format,
	    formatRows: formatRows
	  };
	};
	
	var csv = dsv(",");
	
	var csvParse = csv.parse;
	var csvParseRows = csv.parseRows;
	var csvFormat = csv.format;
	var csvFormatRows = csv.formatRows;
	
	var tsv = dsv("\t");
	
	var tsvParse = tsv.parse;
	var tsvParseRows = tsv.parseRows;
	var tsvFormat = tsv.format;
	var tsvFormatRows = tsv.formatRows;
	
	var request = function(url, callback) {
	  var request,
	      event = dispatch("beforesend", "progress", "load", "error"),
	      mimeType,
	      headers = map$1(),
	      xhr = new XMLHttpRequest,
	      user = null,
	      password = null,
	      response,
	      responseType,
	      timeout = 0;
	
	  // If IE does not support CORS, use XDomainRequest.
	  if (typeof XDomainRequest !== "undefined"
	      && !("withCredentials" in xhr)
	      && /^(http(s)?:)?\/\//.test(url)) xhr = new XDomainRequest;
	
	  "onload" in xhr
	      ? xhr.onload = xhr.onerror = xhr.ontimeout = respond
	      : xhr.onreadystatechange = function(o) { xhr.readyState > 3 && respond(o); };
	
	  function respond(o) {
	    var status = xhr.status, result;
	    if (!status && hasResponse(xhr)
	        || status >= 200 && status < 300
	        || status === 304) {
	      if (response) {
	        try {
	          result = response.call(request, xhr);
	        } catch (e) {
	          event.call("error", request, e);
	          return;
	        }
	      } else {
	        result = xhr;
	      }
	      event.call("load", request, result);
	    } else {
	      event.call("error", request, o);
	    }
	  }
	
	  xhr.onprogress = function(e) {
	    event.call("progress", request, e);
	  };
	
	  request = {
	    header: function(name, value) {
	      name = (name + "").toLowerCase();
	      if (arguments.length < 2) return headers.get(name);
	      if (value == null) headers.remove(name);
	      else headers.set(name, value + "");
	      return request;
	    },
	
	    // If mimeType is non-null and no Accept header is set, a default is used.
	    mimeType: function(value) {
	      if (!arguments.length) return mimeType;
	      mimeType = value == null ? null : value + "";
	      return request;
	    },
	
	    // Specifies what type the response value should take;
	    // for instance, arraybuffer, blob, document, or text.
	    responseType: function(value) {
	      if (!arguments.length) return responseType;
	      responseType = value;
	      return request;
	    },
	
	    timeout: function(value) {
	      if (!arguments.length) return timeout;
	      timeout = +value;
	      return request;
	    },
	
	    user: function(value) {
	      return arguments.length < 1 ? user : (user = value == null ? null : value + "", request);
	    },
	
	    password: function(value) {
	      return arguments.length < 1 ? password : (password = value == null ? null : value + "", request);
	    },
	
	    // Specify how to convert the response content to a specific type;
	    // changes the callback value on "load" events.
	    response: function(value) {
	      response = value;
	      return request;
	    },
	
	    // Alias for send("GET", …).
	    get: function(data, callback) {
	      return request.send("GET", data, callback);
	    },
	
	    // Alias for send("POST", …).
	    post: function(data, callback) {
	      return request.send("POST", data, callback);
	    },
	
	    // If callback is non-null, it will be used for error and load events.
	    send: function(method, data, callback) {
	      xhr.open(method, url, true, user, password);
	      if (mimeType != null && !headers.has("accept")) headers.set("accept", mimeType + ",*/*");
	      if (xhr.setRequestHeader) headers.each(function(value, name) { xhr.setRequestHeader(name, value); });
	      if (mimeType != null && xhr.overrideMimeType) xhr.overrideMimeType(mimeType);
	      if (responseType != null) xhr.responseType = responseType;
	      if (timeout > 0) xhr.timeout = timeout;
	      if (callback == null && typeof data === "function") callback = data, data = null;
	      if (callback != null && callback.length === 1) callback = fixCallback(callback);
	      if (callback != null) request.on("error", callback).on("load", function(xhr) { callback(null, xhr); });
	      event.call("beforesend", request, xhr);
	      xhr.send(data == null ? null : data);
	      return request;
	    },
	
	    abort: function() {
	      xhr.abort();
	      return request;
	    },
	
	    on: function() {
	      var value = event.on.apply(event, arguments);
	      return value === event ? request : value;
	    }
	  };
	
	  if (callback != null) {
	    if (typeof callback !== "function") throw new Error("invalid callback: " + callback);
	    return request.get(callback);
	  }
	
	  return request;
	};
	
	function fixCallback(callback) {
	  return function(error, xhr) {
	    callback(error == null ? xhr : null);
	  };
	}
	
	function hasResponse(xhr) {
	  var type = xhr.responseType;
	  return type && type !== "text"
	      ? xhr.response // null on error
	      : xhr.responseText; // "" on error
	}
	
	var type = function(defaultMimeType, response) {
	  return function(url, callback) {
	    var r = request(url).mimeType(defaultMimeType).response(response);
	    if (callback != null) {
	      if (typeof callback !== "function") throw new Error("invalid callback: " + callback);
	      return r.get(callback);
	    }
	    return r;
	  };
	};
	
	var html = type("text/html", function(xhr) {
	  return document.createRange().createContextualFragment(xhr.responseText);
	});
	
	var json = type("application/json", function(xhr) {
	  return JSON.parse(xhr.responseText);
	});
	
	var text = type("text/plain", function(xhr) {
	  return xhr.responseText;
	});
	
	var xml = type("application/xml", function(xhr) {
	  var xml = xhr.responseXML;
	  if (!xml) throw new Error("parse error");
	  return xml;
	});
	
	var dsv$1 = function(defaultMimeType, parse) {
	  return function(url, row, callback) {
	    if (arguments.length < 3) callback = row, row = null;
	    var r = request(url).mimeType(defaultMimeType);
	    r.row = function(_) { return arguments.length ? r.response(responseOf(parse, row = _)) : row; };
	    r.row(row);
	    return callback ? r.get(callback) : r;
	  };
	};
	
	function responseOf(parse, row) {
	  return function(request$$1) {
	    return parse(request$$1.responseText, row);
	  };
	}
	
	var csv$1 = dsv$1("text/csv", csvParse);
	
	var tsv$1 = dsv$1("text/tab-separated-values", tsvParse);
	
	var frame = 0;
	var timeout = 0;
	var interval = 0;
	var pokeDelay = 1000;
	var taskHead;
	var taskTail;
	var clockLast = 0;
	var clockNow = 0;
	var clockSkew = 0;
	var clock = typeof performance === "object" && performance.now ? performance : Date;
	var setFrame = typeof requestAnimationFrame === "function" ? requestAnimationFrame : function(f) { setTimeout(f, 17); };
	
	function now() {
	  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
	}
	
	function clearNow() {
	  clockNow = 0;
	}
	
	function Timer() {
	  this._call =
	  this._time =
	  this._next = null;
	}
	
	Timer.prototype = timer.prototype = {
	  constructor: Timer,
	  restart: function(callback, delay, time) {
	    if (typeof callback !== "function") throw new TypeError("callback is not a function");
	    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
	    if (!this._next && taskTail !== this) {
	      if (taskTail) taskTail._next = this;
	      else taskHead = this;
	      taskTail = this;
	    }
	    this._call = callback;
	    this._time = time;
	    sleep();
	  },
	  stop: function() {
	    if (this._call) {
	      this._call = null;
	      this._time = Infinity;
	      sleep();
	    }
	  }
	};
	
	function timer(callback, delay, time) {
	  var t = new Timer;
	  t.restart(callback, delay, time);
	  return t;
	}
	
	function timerFlush() {
	  now(); // Get the current time, if not already set.
	  ++frame; // Pretend we’ve set an alarm, if we haven’t already.
	  var t = taskHead, e;
	  while (t) {
	    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
	    t = t._next;
	  }
	  --frame;
	}
	
	function wake() {
	  clockNow = (clockLast = clock.now()) + clockSkew;
	  frame = timeout = 0;
	  try {
	    timerFlush();
	  } finally {
	    frame = 0;
	    nap();
	    clockNow = 0;
	  }
	}
	
	function poke$1() {
	  var now = clock.now(), delay = now - clockLast;
	  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
	}
	
	function nap() {
	  var t0, t1 = taskHead, t2, time = Infinity;
	  while (t1) {
	    if (t1._call) {
	      if (time > t1._time) time = t1._time;
	      t0 = t1, t1 = t1._next;
	    } else {
	      t2 = t1._next, t1._next = null;
	      t1 = t0 ? t0._next = t2 : taskHead = t2;
	    }
	  }
	  taskTail = t0;
	  sleep(time);
	}
	
	function sleep(time) {
	  if (frame) return; // Soonest alarm already set, or will be.
	  if (timeout) timeout = clearTimeout(timeout);
	  var delay = time - clockNow;
	  if (delay > 24) {
	    if (time < Infinity) timeout = setTimeout(wake, delay);
	    if (interval) interval = clearInterval(interval);
	  } else {
	    if (!interval) interval = setInterval(poke$1, pokeDelay);
	    frame = 1, setFrame(wake);
	  }
	}
	
	var timeout$1 = function(callback, delay, time) {
	  var t = new Timer;
	  delay = delay == null ? 0 : +delay;
	  t.restart(function(elapsed) {
	    t.stop();
	    callback(elapsed + delay);
	  }, delay, time);
	  return t;
	};
	
	var interval$1 = function(callback, delay, time) {
	  var t = new Timer, total = delay;
	  if (delay == null) return t.restart(callback, delay, time), t;
	  delay = +delay, time = time == null ? now() : +time;
	  t.restart(function tick(elapsed) {
	    elapsed += total;
	    t.restart(tick, total += delay, time);
	    callback(elapsed);
	  }, delay, time);
	  return t;
	};
	
	var t0$1 = new Date;
	var t1$1 = new Date;
	
	function newInterval(floori, offseti, count, field) {
	
	  function interval(date) {
	    return floori(date = new Date(+date)), date;
	  }
	
	  interval.floor = interval;
	
	  interval.ceil = function(date) {
	    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
	  };
	
	  interval.round = function(date) {
	    var d0 = interval(date),
	        d1 = interval.ceil(date);
	    return date - d0 < d1 - date ? d0 : d1;
	  };
	
	  interval.offset = function(date, step) {
	    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
	  };
	
	  interval.range = function(start, stop, step) {
	    var range = [];
	    start = interval.ceil(start);
	    step = step == null ? 1 : Math.floor(step);
	    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
	    do range.push(new Date(+start)); while (offseti(start, step), floori(start), start < stop)
	    return range;
	  };
	
	  interval.filter = function(test) {
	    return newInterval(function(date) {
	      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
	    }, function(date, step) {
	      if (date >= date) while (--step >= 0) while (offseti(date, 1), !test(date)) {} // eslint-disable-line no-empty
	    });
	  };
	
	  if (count) {
	    interval.count = function(start, end) {
	      t0$1.setTime(+start), t1$1.setTime(+end);
	      floori(t0$1), floori(t1$1);
	      return Math.floor(count(t0$1, t1$1));
	    };
	
	    interval.every = function(step) {
	      step = Math.floor(step);
	      return !isFinite(step) || !(step > 0) ? null
	          : !(step > 1) ? interval
	          : interval.filter(field
	              ? function(d) { return field(d) % step === 0; }
	              : function(d) { return interval.count(0, d) % step === 0; });
	    };
	  }
	
	  return interval;
	}
	
	var millisecond = newInterval(function() {
	  // noop
	}, function(date, step) {
	  date.setTime(+date + step);
	}, function(start, end) {
	  return end - start;
	});
	
	// An optimized implementation for this simple case.
	millisecond.every = function(k) {
	  k = Math.floor(k);
	  if (!isFinite(k) || !(k > 0)) return null;
	  if (!(k > 1)) return millisecond;
	  return newInterval(function(date) {
	    date.setTime(Math.floor(date / k) * k);
	  }, function(date, step) {
	    date.setTime(+date + step * k);
	  }, function(start, end) {
	    return (end - start) / k;
	  });
	};
	
	var milliseconds = millisecond.range;
	
	var durationSecond = 1e3;
	var durationMinute = 6e4;
	var durationHour = 36e5;
	var durationDay = 864e5;
	var durationWeek = 6048e5;
	
	var second = newInterval(function(date) {
	  date.setTime(Math.floor(date / durationSecond) * durationSecond);
	}, function(date, step) {
	  date.setTime(+date + step * durationSecond);
	}, function(start, end) {
	  return (end - start) / durationSecond;
	}, function(date) {
	  return date.getUTCSeconds();
	});
	
	var seconds = second.range;
	
	var minute = newInterval(function(date) {
	  date.setTime(Math.floor(date / durationMinute) * durationMinute);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getMinutes();
	});
	
	var minutes = minute.range;
	
	var hour = newInterval(function(date) {
	  var offset = date.getTimezoneOffset() * durationMinute % durationHour;
	  if (offset < 0) offset += durationHour;
	  date.setTime(Math.floor((+date - offset) / durationHour) * durationHour + offset);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getHours();
	});
	
	var hours = hour.range;
	
	var day = newInterval(function(date) {
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setDate(date.getDate() + step);
	}, function(start, end) {
	  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay;
	}, function(date) {
	  return date.getDate() - 1;
	});
	
	var days = day.range;
	
	function weekday(i) {
	  return newInterval(function(date) {
	    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setDate(date.getDate() + step * 7);
	  }, function(start, end) {
	    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
	  });
	}
	
	var sunday = weekday(0);
	var monday = weekday(1);
	var tuesday = weekday(2);
	var wednesday = weekday(3);
	var thursday = weekday(4);
	var friday = weekday(5);
	var saturday = weekday(6);
	
	var sundays = sunday.range;
	var mondays = monday.range;
	var tuesdays = tuesday.range;
	var wednesdays = wednesday.range;
	var thursdays = thursday.range;
	var fridays = friday.range;
	var saturdays = saturday.range;
	
	var month = newInterval(function(date) {
	  date.setDate(1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setMonth(date.getMonth() + step);
	}, function(start, end) {
	  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
	}, function(date) {
	  return date.getMonth();
	});
	
	var months = month.range;
	
	var year = newInterval(function(date) {
	  date.setMonth(0, 1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setFullYear(date.getFullYear() + step);
	}, function(start, end) {
	  return end.getFullYear() - start.getFullYear();
	}, function(date) {
	  return date.getFullYear();
	});
	
	// An optimized implementation for this simple case.
	year.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
	    date.setMonth(0, 1);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setFullYear(date.getFullYear() + step * k);
	  });
	};
	
	var years = year.range;
	
	var utcMinute = newInterval(function(date) {
	  date.setUTCSeconds(0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getUTCMinutes();
	});
	
	var utcMinutes = utcMinute.range;
	
	var utcHour = newInterval(function(date) {
	  date.setUTCMinutes(0, 0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getUTCHours();
	});
	
	var utcHours = utcHour.range;
	
	var utcDay = newInterval(function(date) {
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCDate(date.getUTCDate() + step);
	}, function(start, end) {
	  return (end - start) / durationDay;
	}, function(date) {
	  return date.getUTCDate() - 1;
	});
	
	var utcDays = utcDay.range;
	
	function utcWeekday(i) {
	  return newInterval(function(date) {
	    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCDate(date.getUTCDate() + step * 7);
	  }, function(start, end) {
	    return (end - start) / durationWeek;
	  });
	}
	
	var utcSunday = utcWeekday(0);
	var utcMonday = utcWeekday(1);
	var utcTuesday = utcWeekday(2);
	var utcWednesday = utcWeekday(3);
	var utcThursday = utcWeekday(4);
	var utcFriday = utcWeekday(5);
	var utcSaturday = utcWeekday(6);
	
	var utcSundays = utcSunday.range;
	var utcMondays = utcMonday.range;
	var utcTuesdays = utcTuesday.range;
	var utcWednesdays = utcWednesday.range;
	var utcThursdays = utcThursday.range;
	var utcFridays = utcFriday.range;
	var utcSaturdays = utcSaturday.range;
	
	var utcMonth = newInterval(function(date) {
	  date.setUTCDate(1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCMonth(date.getUTCMonth() + step);
	}, function(start, end) {
	  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
	}, function(date) {
	  return date.getUTCMonth();
	});
	
	var utcMonths = utcMonth.range;
	
	var utcYear = newInterval(function(date) {
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCFullYear(date.getUTCFullYear() + step);
	}, function(start, end) {
	  return end.getUTCFullYear() - start.getUTCFullYear();
	}, function(date) {
	  return date.getUTCFullYear();
	});
	
	// An optimized implementation for this simple case.
	utcYear.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
	    date.setUTCMonth(0, 1);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCFullYear(date.getUTCFullYear() + step * k);
	  });
	};
	
	var utcYears = utcYear.range;
	
	// Computes the decimal coefficient and exponent of the specified number x with
	// significant digits p, where x is positive and p is in [1, 21] or undefined.
	// For example, formatDecimal(1.23) returns ["123", 0].
	var formatDecimal = function(x, p) {
	  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
	  var i, coefficient = x.slice(0, i);
	
	  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
	  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
	  return [
	    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
	    +x.slice(i + 1)
	  ];
	};
	
	var exponent$1 = function(x) {
	  return x = formatDecimal(Math.abs(x)), x ? x[1] : NaN;
	};
	
	var formatGroup = function(grouping, thousands) {
	  return function(value, width) {
	    var i = value.length,
	        t = [],
	        j = 0,
	        g = grouping[0],
	        length = 0;
	
	    while (i > 0 && g > 0) {
	      if (length + g + 1 > width) g = Math.max(1, width - length);
	      t.push(value.substring(i -= g, i + g));
	      if ((length += g + 1) > width) break;
	      g = grouping[j = (j + 1) % grouping.length];
	    }
	
	    return t.reverse().join(thousands);
	  };
	};
	
	var formatDefault = function(x, p) {
	  x = x.toPrecision(p);
	
	  out: for (var n = x.length, i = 1, i0 = -1, i1; i < n; ++i) {
	    switch (x[i]) {
	      case ".": i0 = i1 = i; break;
	      case "0": if (i0 === 0) i0 = i; i1 = i; break;
	      case "e": break out;
	      default: if (i0 > 0) i0 = 0; break;
	    }
	  }
	
	  return i0 > 0 ? x.slice(0, i0) + x.slice(i1 + 1) : x;
	};
	
	var prefixExponent;
	
	var formatPrefixAuto = function(x, p) {
	  var d = formatDecimal(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1],
	      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
	      n = coefficient.length;
	  return i === n ? coefficient
	      : i > n ? coefficient + new Array(i - n + 1).join("0")
	      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
	      : "0." + new Array(1 - i).join("0") + formatDecimal(x, Math.max(0, p + i - 1))[0]; // less than 1y!
	};
	
	var formatRounded = function(x, p) {
	  var d = formatDecimal(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1];
	  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
	      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
	      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
	};
	
	var formatTypes = {
	  "": formatDefault,
	  "%": function(x, p) { return (x * 100).toFixed(p); },
	  "b": function(x) { return Math.round(x).toString(2); },
	  "c": function(x) { return x + ""; },
	  "d": function(x) { return Math.round(x).toString(10); },
	  "e": function(x, p) { return x.toExponential(p); },
	  "f": function(x, p) { return x.toFixed(p); },
	  "g": function(x, p) { return x.toPrecision(p); },
	  "o": function(x) { return Math.round(x).toString(8); },
	  "p": function(x, p) { return formatRounded(x * 100, p); },
	  "r": formatRounded,
	  "s": formatPrefixAuto,
	  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
	  "x": function(x) { return Math.round(x).toString(16); }
	};
	
	// [[fill]align][sign][symbol][0][width][,][.precision][type]
	var re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;
	
	var formatSpecifier = function(specifier) {
	  return new FormatSpecifier(specifier);
	};
	
	function FormatSpecifier(specifier) {
	  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
	
	  var match,
	      fill = match[1] || " ",
	      align = match[2] || ">",
	      sign = match[3] || "-",
	      symbol = match[4] || "",
	      zero = !!match[5],
	      width = match[6] && +match[6],
	      comma = !!match[7],
	      precision = match[8] && +match[8].slice(1),
	      type = match[9] || "";
	
	  // The "n" type is an alias for ",g".
	  if (type === "n") comma = true, type = "g";
	
	  // Map invalid types to the default format.
	  else if (!formatTypes[type]) type = "";
	
	  // If zero fill is specified, padding goes after sign and before digits.
	  if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";
	
	  this.fill = fill;
	  this.align = align;
	  this.sign = sign;
	  this.symbol = symbol;
	  this.zero = zero;
	  this.width = width;
	  this.comma = comma;
	  this.precision = precision;
	  this.type = type;
	}
	
	FormatSpecifier.prototype.toString = function() {
	  return this.fill
	      + this.align
	      + this.sign
	      + this.symbol
	      + (this.zero ? "0" : "")
	      + (this.width == null ? "" : Math.max(1, this.width | 0))
	      + (this.comma ? "," : "")
	      + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
	      + this.type;
	};
	
	var prefixes = ["y","z","a","f","p","n","\xB5","m","","k","M","G","T","P","E","Z","Y"];
	
	function identity$3(x) {
	  return x;
	}
	
	var formatLocale = function(locale) {
	  var group = locale.grouping && locale.thousands ? formatGroup(locale.grouping, locale.thousands) : identity$3,
	      currency = locale.currency,
	      decimal = locale.decimal;
	
	  function newFormat(specifier) {
	    specifier = formatSpecifier(specifier);
	
	    var fill = specifier.fill,
	        align = specifier.align,
	        sign = specifier.sign,
	        symbol = specifier.symbol,
	        zero = specifier.zero,
	        width = specifier.width,
	        comma = specifier.comma,
	        precision = specifier.precision,
	        type = specifier.type;
	
	    // Compute the prefix and suffix.
	    // For SI-prefix, the suffix is lazily computed.
	    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
	        suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? "%" : "";
	
	    // What format function should we use?
	    // Is this an integer type?
	    // Can this type generate exponential notation?
	    var formatType = formatTypes[type],
	        maybeSuffix = !type || /[defgprs%]/.test(type);
	
	    // Set the default precision if not specified,
	    // or clamp the specified precision to the supported range.
	    // For significant precision, it must be in [1, 21].
	    // For fixed precision, it must be in [0, 20].
	    precision = precision == null ? (type ? 6 : 12)
	        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
	        : Math.max(0, Math.min(20, precision));
	
	    function format(value) {
	      var valuePrefix = prefix,
	          valueSuffix = suffix,
	          i, n, c;
	
	      if (type === "c") {
	        valueSuffix = formatType(value) + valueSuffix;
	        value = "";
	      } else {
	        value = +value;
	
	        // Convert negative to positive, and compute the prefix.
	        // Note that -0 is not less than 0, but 1 / -0 is!
	        var valueNegative = (value < 0 || 1 / value < 0) && (value *= -1, true);
	
	        // Perform the initial formatting.
	        value = formatType(value, precision);
	
	        // If the original value was negative, it may be rounded to zero during
	        // formatting; treat this as (positive) zero.
	        if (valueNegative) {
	          i = -1, n = value.length;
	          valueNegative = false;
	          while (++i < n) {
	            if (c = value.charCodeAt(i), (48 < c && c < 58)
	                || (type === "x" && 96 < c && c < 103)
	                || (type === "X" && 64 < c && c < 71)) {
	              valueNegative = true;
	              break;
	            }
	          }
	        }
	
	        // Compute the prefix and suffix.
	        valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
	        valueSuffix = valueSuffix + (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + (valueNegative && sign === "(" ? ")" : "");
	
	        // Break the formatted value into the integer “value” part that can be
	        // grouped, and fractional or exponential “suffix” part that is not.
	        if (maybeSuffix) {
	          i = -1, n = value.length;
	          while (++i < n) {
	            if (c = value.charCodeAt(i), 48 > c || c > 57) {
	              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
	              value = value.slice(0, i);
	              break;
	            }
	          }
	        }
	      }
	
	      // If the fill character is not "0", grouping is applied before padding.
	      if (comma && !zero) value = group(value, Infinity);
	
	      // Compute the padding.
	      var length = valuePrefix.length + value.length + valueSuffix.length,
	          padding = length < width ? new Array(width - length + 1).join(fill) : "";
	
	      // If the fill character is "0", grouping is applied after padding.
	      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
	
	      // Reconstruct the final output based on the desired alignment.
	      switch (align) {
	        case "<": return valuePrefix + value + valueSuffix + padding;
	        case "=": return valuePrefix + padding + value + valueSuffix;
	        case "^": return padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
	      }
	      return padding + valuePrefix + value + valueSuffix;
	    }
	
	    format.toString = function() {
	      return specifier + "";
	    };
	
	    return format;
	  }
	
	  function formatPrefix(specifier, value) {
	    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
	        e = Math.max(-8, Math.min(8, Math.floor(exponent$1(value) / 3))) * 3,
	        k = Math.pow(10, -e),
	        prefix = prefixes[8 + e / 3];
	    return function(value) {
	      return f(k * value) + prefix;
	    };
	  }
	
	  return {
	    format: newFormat,
	    formatPrefix: formatPrefix
	  };
	};
	
	var locale$1;
	
	
	
	defaultLocale({
	  decimal: ".",
	  thousands: ",",
	  grouping: [3],
	  currency: ["$", ""]
	});
	
	function defaultLocale(definition) {
	  locale$1 = formatLocale(definition);
	  exports.format = locale$1.format;
	  exports.formatPrefix = locale$1.formatPrefix;
	  return locale$1;
	}
	
	var precisionFixed = function(step) {
	  return Math.max(0, -exponent$1(Math.abs(step)));
	};
	
	var precisionPrefix = function(step, value) {
	  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent$1(value) / 3))) * 3 - exponent$1(Math.abs(step)));
	};
	
	var precisionRound = function(step, max) {
	  step = Math.abs(step), max = Math.abs(max) - step;
	  return Math.max(0, exponent$1(max) - exponent$1(step)) + 1;
	};
	
	function localDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
	    date.setFullYear(d.y);
	    return date;
	  }
	  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
	}
	
	function utcDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
	    date.setUTCFullYear(d.y);
	    return date;
	  }
	  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
	}
	
	function newYear(y) {
	  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
	}
	
	function formatLocale$1(locale) {
	  var locale_dateTime = locale.dateTime,
	      locale_date = locale.date,
	      locale_time = locale.time,
	      locale_periods = locale.periods,
	      locale_weekdays = locale.days,
	      locale_shortWeekdays = locale.shortDays,
	      locale_months = locale.months,
	      locale_shortMonths = locale.shortMonths;
	
	  var periodRe = formatRe(locale_periods),
	      periodLookup = formatLookup(locale_periods),
	      weekdayRe = formatRe(locale_weekdays),
	      weekdayLookup = formatLookup(locale_weekdays),
	      shortWeekdayRe = formatRe(locale_shortWeekdays),
	      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
	      monthRe = formatRe(locale_months),
	      monthLookup = formatLookup(locale_months),
	      shortMonthRe = formatRe(locale_shortMonths),
	      shortMonthLookup = formatLookup(locale_shortMonths);
	
	  var formats = {
	    "a": formatShortWeekday,
	    "A": formatWeekday,
	    "b": formatShortMonth,
	    "B": formatMonth,
	    "c": null,
	    "d": formatDayOfMonth,
	    "e": formatDayOfMonth,
	    "H": formatHour24,
	    "I": formatHour12,
	    "j": formatDayOfYear,
	    "L": formatMilliseconds,
	    "m": formatMonthNumber,
	    "M": formatMinutes,
	    "p": formatPeriod,
	    "S": formatSeconds,
	    "U": formatWeekNumberSunday,
	    "w": formatWeekdayNumber,
	    "W": formatWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatYear,
	    "Y": formatFullYear,
	    "Z": formatZone,
	    "%": formatLiteralPercent
	  };
	
	  var utcFormats = {
	    "a": formatUTCShortWeekday,
	    "A": formatUTCWeekday,
	    "b": formatUTCShortMonth,
	    "B": formatUTCMonth,
	    "c": null,
	    "d": formatUTCDayOfMonth,
	    "e": formatUTCDayOfMonth,
	    "H": formatUTCHour24,
	    "I": formatUTCHour12,
	    "j": formatUTCDayOfYear,
	    "L": formatUTCMilliseconds,
	    "m": formatUTCMonthNumber,
	    "M": formatUTCMinutes,
	    "p": formatUTCPeriod,
	    "S": formatUTCSeconds,
	    "U": formatUTCWeekNumberSunday,
	    "w": formatUTCWeekdayNumber,
	    "W": formatUTCWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatUTCYear,
	    "Y": formatUTCFullYear,
	    "Z": formatUTCZone,
	    "%": formatLiteralPercent
	  };
	
	  var parses = {
	    "a": parseShortWeekday,
	    "A": parseWeekday,
	    "b": parseShortMonth,
	    "B": parseMonth,
	    "c": parseLocaleDateTime,
	    "d": parseDayOfMonth,
	    "e": parseDayOfMonth,
	    "H": parseHour24,
	    "I": parseHour24,
	    "j": parseDayOfYear,
	    "L": parseMilliseconds,
	    "m": parseMonthNumber,
	    "M": parseMinutes,
	    "p": parsePeriod,
	    "S": parseSeconds,
	    "U": parseWeekNumberSunday,
	    "w": parseWeekdayNumber,
	    "W": parseWeekNumberMonday,
	    "x": parseLocaleDate,
	    "X": parseLocaleTime,
	    "y": parseYear,
	    "Y": parseFullYear,
	    "Z": parseZone,
	    "%": parseLiteralPercent
	  };
	
	  // These recursive directive definitions must be deferred.
	  formats.x = newFormat(locale_date, formats);
	  formats.X = newFormat(locale_time, formats);
	  formats.c = newFormat(locale_dateTime, formats);
	  utcFormats.x = newFormat(locale_date, utcFormats);
	  utcFormats.X = newFormat(locale_time, utcFormats);
	  utcFormats.c = newFormat(locale_dateTime, utcFormats);
	
	  function newFormat(specifier, formats) {
	    return function(date) {
	      var string = [],
	          i = -1,
	          j = 0,
	          n = specifier.length,
	          c,
	          pad,
	          format;
	
	      if (!(date instanceof Date)) date = new Date(+date);
	
	      while (++i < n) {
	        if (specifier.charCodeAt(i) === 37) {
	          string.push(specifier.slice(j, i));
	          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
	          else pad = c === "e" ? " " : "0";
	          if (format = formats[c]) c = format(date, pad);
	          string.push(c);
	          j = i + 1;
	        }
	      }
	
	      string.push(specifier.slice(j, i));
	      return string.join("");
	    };
	  }
	
	  function newParse(specifier, newDate) {
	    return function(string) {
	      var d = newYear(1900),
	          i = parseSpecifier(d, specifier, string += "", 0);
	      if (i != string.length) return null;
	
	      // The am-pm flag is 0 for AM, and 1 for PM.
	      if ("p" in d) d.H = d.H % 12 + d.p * 12;
	
	      // Convert day-of-week and week-of-year to day-of-year.
	      if ("W" in d || "U" in d) {
	        if (!("w" in d)) d.w = "W" in d ? 1 : 0;
	        var day$$1 = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
	        d.m = 0;
	        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day$$1 + 5) % 7 : d.w + d.U * 7 - (day$$1 + 6) % 7;
	      }
	
	      // If a time zone is specified, all fields are interpreted as UTC and then
	      // offset according to the specified time zone.
	      if ("Z" in d) {
	        d.H += d.Z / 100 | 0;
	        d.M += d.Z % 100;
	        return utcDate(d);
	      }
	
	      // Otherwise, all fields are in local time.
	      return newDate(d);
	    };
	  }
	
	  function parseSpecifier(d, specifier, string, j) {
	    var i = 0,
	        n = specifier.length,
	        m = string.length,
	        c,
	        parse;
	
	    while (i < n) {
	      if (j >= m) return -1;
	      c = specifier.charCodeAt(i++);
	      if (c === 37) {
	        c = specifier.charAt(i++);
	        parse = parses[c in pads ? specifier.charAt(i++) : c];
	        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
	      } else if (c != string.charCodeAt(j++)) {
	        return -1;
	      }
	    }
	
	    return j;
	  }
	
	  function parsePeriod(d, string, i) {
	    var n = periodRe.exec(string.slice(i));
	    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortWeekday(d, string, i) {
	    var n = shortWeekdayRe.exec(string.slice(i));
	    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseWeekday(d, string, i) {
	    var n = weekdayRe.exec(string.slice(i));
	    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortMonth(d, string, i) {
	    var n = shortMonthRe.exec(string.slice(i));
	    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseMonth(d, string, i) {
	    var n = monthRe.exec(string.slice(i));
	    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseLocaleDateTime(d, string, i) {
	    return parseSpecifier(d, locale_dateTime, string, i);
	  }
	
	  function parseLocaleDate(d, string, i) {
	    return parseSpecifier(d, locale_date, string, i);
	  }
	
	  function parseLocaleTime(d, string, i) {
	    return parseSpecifier(d, locale_time, string, i);
	  }
	
	  function formatShortWeekday(d) {
	    return locale_shortWeekdays[d.getDay()];
	  }
	
	  function formatWeekday(d) {
	    return locale_weekdays[d.getDay()];
	  }
	
	  function formatShortMonth(d) {
	    return locale_shortMonths[d.getMonth()];
	  }
	
	  function formatMonth(d) {
	    return locale_months[d.getMonth()];
	  }
	
	  function formatPeriod(d) {
	    return locale_periods[+(d.getHours() >= 12)];
	  }
	
	  function formatUTCShortWeekday(d) {
	    return locale_shortWeekdays[d.getUTCDay()];
	  }
	
	  function formatUTCWeekday(d) {
	    return locale_weekdays[d.getUTCDay()];
	  }
	
	  function formatUTCShortMonth(d) {
	    return locale_shortMonths[d.getUTCMonth()];
	  }
	
	  function formatUTCMonth(d) {
	    return locale_months[d.getUTCMonth()];
	  }
	
	  function formatUTCPeriod(d) {
	    return locale_periods[+(d.getUTCHours() >= 12)];
	  }
	
	  return {
	    format: function(specifier) {
	      var f = newFormat(specifier += "", formats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    parse: function(specifier) {
	      var p = newParse(specifier += "", localDate);
	      p.toString = function() { return specifier; };
	      return p;
	    },
	    utcFormat: function(specifier) {
	      var f = newFormat(specifier += "", utcFormats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    utcParse: function(specifier) {
	      var p = newParse(specifier, utcDate);
	      p.toString = function() { return specifier; };
	      return p;
	    }
	  };
	}
	
	var pads = {"-": "", "_": " ", "0": "0"};
	var numberRe = /^\s*\d+/;
	var percentRe = /^%/;
	var requoteRe = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
	
	function pad(value, fill, width) {
	  var sign = value < 0 ? "-" : "",
	      string = (sign ? -value : value) + "",
	      length = string.length;
	  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	}
	
	function requote(s) {
	  return s.replace(requoteRe, "\\$&");
	}
	
	function formatRe(names) {
	  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
	}
	
	function formatLookup(names) {
	  var map = {}, i = -1, n = names.length;
	  while (++i < n) map[names[i].toLowerCase()] = i;
	  return map;
	}
	
	function parseWeekdayNumber(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.w = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.U = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.W = +n[0], i + n[0].length) : -1;
	}
	
	function parseFullYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 4));
	  return n ? (d.y = +n[0], i + n[0].length) : -1;
	}
	
	function parseYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
	}
	
	function parseZone(d, string, i) {
	  var n = /^(Z)|([+-]\d\d)(?:\:?(\d\d))?/.exec(string.slice(i, i + 6));
	  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
	}
	
	function parseMonthNumber(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
	}
	
	function parseDayOfMonth(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseDayOfYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseHour24(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.H = +n[0], i + n[0].length) : -1;
	}
	
	function parseMinutes(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.M = +n[0], i + n[0].length) : -1;
	}
	
	function parseSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.S = +n[0], i + n[0].length) : -1;
	}
	
	function parseMilliseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.L = +n[0], i + n[0].length) : -1;
	}
	
	function parseLiteralPercent(d, string, i) {
	  var n = percentRe.exec(string.slice(i, i + 1));
	  return n ? i + n[0].length : -1;
	}
	
	function formatDayOfMonth(d, p) {
	  return pad(d.getDate(), p, 2);
	}
	
	function formatHour24(d, p) {
	  return pad(d.getHours(), p, 2);
	}
	
	function formatHour12(d, p) {
	  return pad(d.getHours() % 12 || 12, p, 2);
	}
	
	function formatDayOfYear(d, p) {
	  return pad(1 + day.count(year(d), d), p, 3);
	}
	
	function formatMilliseconds(d, p) {
	  return pad(d.getMilliseconds(), p, 3);
	}
	
	function formatMonthNumber(d, p) {
	  return pad(d.getMonth() + 1, p, 2);
	}
	
	function formatMinutes(d, p) {
	  return pad(d.getMinutes(), p, 2);
	}
	
	function formatSeconds(d, p) {
	  return pad(d.getSeconds(), p, 2);
	}
	
	function formatWeekNumberSunday(d, p) {
	  return pad(sunday.count(year(d), d), p, 2);
	}
	
	function formatWeekdayNumber(d) {
	  return d.getDay();
	}
	
	function formatWeekNumberMonday(d, p) {
	  return pad(monday.count(year(d), d), p, 2);
	}
	
	function formatYear(d, p) {
	  return pad(d.getFullYear() % 100, p, 2);
	}
	
	function formatFullYear(d, p) {
	  return pad(d.getFullYear() % 10000, p, 4);
	}
	
	function formatZone(d) {
	  var z = d.getTimezoneOffset();
	  return (z > 0 ? "-" : (z *= -1, "+"))
	      + pad(z / 60 | 0, "0", 2)
	      + pad(z % 60, "0", 2);
	}
	
	function formatUTCDayOfMonth(d, p) {
	  return pad(d.getUTCDate(), p, 2);
	}
	
	function formatUTCHour24(d, p) {
	  return pad(d.getUTCHours(), p, 2);
	}
	
	function formatUTCHour12(d, p) {
	  return pad(d.getUTCHours() % 12 || 12, p, 2);
	}
	
	function formatUTCDayOfYear(d, p) {
	  return pad(1 + utcDay.count(utcYear(d), d), p, 3);
	}
	
	function formatUTCMilliseconds(d, p) {
	  return pad(d.getUTCMilliseconds(), p, 3);
	}
	
	function formatUTCMonthNumber(d, p) {
	  return pad(d.getUTCMonth() + 1, p, 2);
	}
	
	function formatUTCMinutes(d, p) {
	  return pad(d.getUTCMinutes(), p, 2);
	}
	
	function formatUTCSeconds(d, p) {
	  return pad(d.getUTCSeconds(), p, 2);
	}
	
	function formatUTCWeekNumberSunday(d, p) {
	  return pad(utcSunday.count(utcYear(d), d), p, 2);
	}
	
	function formatUTCWeekdayNumber(d) {
	  return d.getUTCDay();
	}
	
	function formatUTCWeekNumberMonday(d, p) {
	  return pad(utcMonday.count(utcYear(d), d), p, 2);
	}
	
	function formatUTCYear(d, p) {
	  return pad(d.getUTCFullYear() % 100, p, 2);
	}
	
	function formatUTCFullYear(d, p) {
	  return pad(d.getUTCFullYear() % 10000, p, 4);
	}
	
	function formatUTCZone() {
	  return "+0000";
	}
	
	function formatLiteralPercent() {
	  return "%";
	}
	
	var locale$2;
	
	
	
	
	
	defaultLocale$1({
	  dateTime: "%x, %X",
	  date: "%-m/%-d/%Y",
	  time: "%-I:%M:%S %p",
	  periods: ["AM", "PM"],
	  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
	});
	
	function defaultLocale$1(definition) {
	  locale$2 = formatLocale$1(definition);
	  exports.timeFormat = locale$2.format;
	  exports.timeParse = locale$2.parse;
	  exports.utcFormat = locale$2.utcFormat;
	  exports.utcParse = locale$2.utcParse;
	  return locale$2;
	}
	
	var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
	
	function formatIsoNative(date) {
	  return date.toISOString();
	}
	
	var formatIso = Date.prototype.toISOString
	    ? formatIsoNative
	    : exports.utcFormat(isoSpecifier);
	
	function parseIsoNative(string) {
	  var date = new Date(string);
	  return isNaN(date) ? null : date;
	}
	
	var parseIso = +new Date("2000-01-01T00:00:00.000Z")
	    ? parseIsoNative
	    : exports.utcParse(isoSpecifier);
	
	var array$2 = Array.prototype;
	
	var map$3 = array$2.map;
	var slice$3 = array$2.slice;
	
	var implicit = {name: "implicit"};
	
	function ordinal(range) {
	  var index = map$1(),
	      domain = [],
	      unknown = implicit;
	
	  range = range == null ? [] : slice$3.call(range);
	
	  function scale(d) {
	    var key = d + "", i = index.get(key);
	    if (!i) {
	      if (unknown !== implicit) return unknown;
	      index.set(key, i = domain.push(d));
	    }
	    return range[(i - 1) % range.length];
	  }
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [], index = map$1();
	    var i = -1, n = _.length, d, key;
	    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
	    return scale;
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range = slice$3.call(_), scale) : range.slice();
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.copy = function() {
	    return ordinal()
	        .domain(domain)
	        .range(range)
	        .unknown(unknown);
	  };
	
	  return scale;
	}
	
	function band() {
	  var scale = ordinal().unknown(undefined),
	      domain = scale.domain,
	      ordinalRange = scale.range,
	      range$$1 = [0, 1],
	      step,
	      bandwidth,
	      round = false,
	      paddingInner = 0,
	      paddingOuter = 0,
	      align = 0.5;
	
	  delete scale.unknown;
	
	  function rescale() {
	    var n = domain().length,
	        reverse = range$$1[1] < range$$1[0],
	        start = range$$1[reverse - 0],
	        stop = range$$1[1 - reverse];
	    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
	    if (round) step = Math.floor(step);
	    start += (stop - start - step * (n - paddingInner)) * align;
	    bandwidth = step * (1 - paddingInner);
	    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
	    var values = range(n).map(function(i) { return start + step * i; });
	    return ordinalRange(reverse ? values.reverse() : values);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = [+_[0], +_[1]], rescale()) : range$$1.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range$$1 = [+_[0], +_[1]], round = true, rescale();
	  };
	
	  scale.bandwidth = function() {
	    return bandwidth;
	  };
	
	  scale.step = function() {
	    return step;
	  };
	
	  scale.round = function(_) {
	    return arguments.length ? (round = !!_, rescale()) : round;
	  };
	
	  scale.padding = function(_) {
	    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingInner = function(_) {
	    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingOuter = function(_) {
	    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
	  };
	
	  scale.align = function(_) {
	    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
	  };
	
	  scale.copy = function() {
	    return band()
	        .domain(domain())
	        .range(range$$1)
	        .round(round)
	        .paddingInner(paddingInner)
	        .paddingOuter(paddingOuter)
	        .align(align);
	  };
	
	  return rescale();
	}
	
	function pointish(scale) {
	  var copy = scale.copy;
	
	  scale.padding = scale.paddingOuter;
	  delete scale.paddingInner;
	  delete scale.paddingOuter;
	
	  scale.copy = function() {
	    return pointish(copy());
	  };
	
	  return scale;
	}
	
	function point$4() {
	  return pointish(band().paddingInner(1));
	}
	
	var constant$4 = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var number$1 = function(x) {
	  return +x;
	};
	
	var unit = [0, 1];
	
	function deinterpolateLinear(a, b) {
	  return (b -= (a = +a))
	      ? function(x) { return (x - a) / b; }
	      : constant$4(b);
	}
	
	function deinterpolateClamp(deinterpolate) {
	  return function(a, b) {
	    var d = deinterpolate(a = +a, b = +b);
	    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
	  };
	}
	
	function reinterpolateClamp(reinterpolate) {
	  return function(a, b) {
	    var r = reinterpolate(a = +a, b = +b);
	    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
	  };
	}
	
	function bimap(domain, range$$1, deinterpolate, reinterpolate) {
	  var d0 = domain[0], d1 = domain[1], r0 = range$$1[0], r1 = range$$1[1];
	  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
	  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
	  return function(x) { return r0(d0(x)); };
	}
	
	function polymap(domain, range$$1, deinterpolate, reinterpolate) {
	  var j = Math.min(domain.length, range$$1.length) - 1,
	      d = new Array(j),
	      r = new Array(j),
	      i = -1;
	
	  // Reverse descending domains.
	  if (domain[j] < domain[0]) {
	    domain = domain.slice().reverse();
	    range$$1 = range$$1.slice().reverse();
	  }
	
	  while (++i < j) {
	    d[i] = deinterpolate(domain[i], domain[i + 1]);
	    r[i] = reinterpolate(range$$1[i], range$$1[i + 1]);
	  }
	
	  return function(x) {
	    var i = bisectRight(domain, x, 1, j) - 1;
	    return r[i](d[i](x));
	  };
	}
	
	function copy(source, target) {
	  return target
	      .domain(source.domain())
	      .range(source.range())
	      .interpolate(source.interpolate())
	      .clamp(source.clamp());
	}
	
	// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
	// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
	function continuous(deinterpolate, reinterpolate) {
	  var domain = unit,
	      range$$1 = unit,
	      interpolate$$1 = interpolate,
	      clamp = false,
	      piecewise,
	      output,
	      input;
	
	  function rescale() {
	    piecewise = Math.min(domain.length, range$$1.length) > 2 ? polymap : bimap;
	    output = input = null;
	    return scale;
	  }
	
	  function scale(x) {
	    return (output || (output = piecewise(domain, range$$1, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate$$1)))(+x);
	  }
	
	  scale.invert = function(y) {
	    return (input || (input = piecewise(range$$1, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = map$3.call(_, number$1), rescale()) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice$3.call(_), rescale()) : range$$1.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range$$1 = slice$3.call(_), interpolate$$1 = interpolateRound, rescale();
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, rescale()) : clamp;
	  };
	
	  scale.interpolate = function(_) {
	    return arguments.length ? (interpolate$$1 = _, rescale()) : interpolate$$1;
	  };
	
	  return rescale();
	}
	
	var tickFormat = function(domain, count, specifier) {
	  var start = domain[0],
	      stop = domain[domain.length - 1],
	      step = tickStep(start, stop, count == null ? 10 : count),
	      precision;
	  specifier = formatSpecifier(specifier == null ? ",f" : specifier);
	  switch (specifier.type) {
	    case "s": {
	      var value = Math.max(Math.abs(start), Math.abs(stop));
	      if (specifier.precision == null && !isNaN(precision = precisionPrefix(step, value))) specifier.precision = precision;
	      return exports.formatPrefix(specifier, value);
	    }
	    case "":
	    case "e":
	    case "g":
	    case "p":
	    case "r": {
	      if (specifier.precision == null && !isNaN(precision = precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
	      break;
	    }
	    case "f":
	    case "%": {
	      if (specifier.precision == null && !isNaN(precision = precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
	      break;
	    }
	  }
	  return exports.format(specifier);
	};
	
	function linearish(scale) {
	  var domain = scale.domain;
	
	  scale.ticks = function(count) {
	    var d = domain();
	    return ticks(d[0], d[d.length - 1], count == null ? 10 : count);
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return tickFormat(domain(), count, specifier);
	  };
	
	  scale.nice = function(count) {
	    var d = domain(),
	        i = d.length - 1,
	        n = count == null ? 10 : count,
	        start = d[0],
	        stop = d[i],
	        step = tickStep(start, stop, n);
	
	    if (step) {
	      step = tickStep(Math.floor(start / step) * step, Math.ceil(stop / step) * step, n);
	      d[0] = Math.floor(start / step) * step;
	      d[i] = Math.ceil(stop / step) * step;
	      domain(d);
	    }
	
	    return scale;
	  };
	
	  return scale;
	}
	
	function linear$2() {
	  var scale = continuous(deinterpolateLinear, interpolateNumber);
	
	  scale.copy = function() {
	    return copy(scale, linear$2());
	  };
	
	  return linearish(scale);
	}
	
	function identity$4() {
	  var domain = [0, 1];
	
	  function scale(x) {
	    return +x;
	  }
	
	  scale.invert = scale;
	
	  scale.domain = scale.range = function(_) {
	    return arguments.length ? (domain = map$3.call(_, number$1), scale) : domain.slice();
	  };
	
	  scale.copy = function() {
	    return identity$4().domain(domain);
	  };
	
	  return linearish(scale);
	}
	
	var nice = function(domain, interval) {
	  domain = domain.slice();
	
	  var i0 = 0,
	      i1 = domain.length - 1,
	      x0 = domain[i0],
	      x1 = domain[i1],
	      t;
	
	  if (x1 < x0) {
	    t = i0, i0 = i1, i1 = t;
	    t = x0, x0 = x1, x1 = t;
	  }
	
	  domain[i0] = interval.floor(x0);
	  domain[i1] = interval.ceil(x1);
	  return domain;
	};
	
	function deinterpolate(a, b) {
	  return (b = Math.log(b / a))
	      ? function(x) { return Math.log(x / a) / b; }
	      : constant$4(b);
	}
	
	function reinterpolate(a, b) {
	  return a < 0
	      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
	      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
	}
	
	function pow10(x) {
	  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
	}
	
	function powp(base) {
	  return base === 10 ? pow10
	      : base === Math.E ? Math.exp
	      : function(x) { return Math.pow(base, x); };
	}
	
	function logp(base) {
	  return base === Math.E ? Math.log
	      : base === 10 && Math.log10
	      || base === 2 && Math.log2
	      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
	}
	
	function reflect(f) {
	  return function(x) {
	    return -f(-x);
	  };
	}
	
	function log() {
	  var scale = continuous(deinterpolate, reinterpolate).domain([1, 10]),
	      domain = scale.domain,
	      base = 10,
	      logs = logp(10),
	      pows = powp(10);
	
	  function rescale() {
	    logs = logp(base), pows = powp(base);
	    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
	    return scale;
	  }
	
	  scale.base = function(_) {
	    return arguments.length ? (base = +_, rescale()) : base;
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.ticks = function(count) {
	    var d = domain(),
	        u = d[0],
	        v = d[d.length - 1],
	        r;
	
	    if (r = v < u) i = u, u = v, v = i;
	
	    var i = logs(u),
	        j = logs(v),
	        p,
	        k,
	        t,
	        n = count == null ? 10 : +count,
	        z = [];
	
	    if (!(base % 1) && j - i < n) {
	      i = Math.round(i) - 1, j = Math.round(j) + 1;
	      if (u > 0) for (; i < j; ++i) {
	        for (k = 1, p = pows(i); k < base; ++k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      } else for (; i < j; ++i) {
	        for (k = base - 1, p = pows(i); k >= 1; --k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      }
	    } else {
	      z = ticks(i, j, Math.min(j - i, n)).map(pows);
	    }
	
	    return r ? z.reverse() : z;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
	    if (typeof specifier !== "function") specifier = exports.format(specifier);
	    if (count === Infinity) return specifier;
	    if (count == null) count = 10;
	    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
	    return function(d) {
	      var i = d / pows(Math.round(logs(d)));
	      if (i * base < base - 0.5) i *= base;
	      return i <= k ? specifier(d) : "";
	    };
	  };
	
	  scale.nice = function() {
	    return domain(nice(domain(), {
	      floor: function(x) { return pows(Math.floor(logs(x))); },
	      ceil: function(x) { return pows(Math.ceil(logs(x))); }
	    }));
	  };
	
	  scale.copy = function() {
	    return copy(scale, log().base(base));
	  };
	
	  return scale;
	}
	
	function raise(x, exponent) {
	  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
	}
	
	function pow() {
	  var exponent = 1,
	      scale = continuous(deinterpolate, reinterpolate),
	      domain = scale.domain;
	
	  function deinterpolate(a, b) {
	    return (b = raise(b, exponent) - (a = raise(a, exponent)))
	        ? function(x) { return (raise(x, exponent) - a) / b; }
	        : constant$4(b);
	  }
	
	  function reinterpolate(a, b) {
	    b = raise(b, exponent) - (a = raise(a, exponent));
	    return function(t) { return raise(a + b * t, 1 / exponent); };
	  }
	
	  scale.exponent = function(_) {
	    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
	  };
	
	  scale.copy = function() {
	    return copy(scale, pow().exponent(exponent));
	  };
	
	  return linearish(scale);
	}
	
	function sqrt() {
	  return pow().exponent(0.5);
	}
	
	function quantile$$1() {
	  var domain = [],
	      range$$1 = [],
	      thresholds = [];
	
	  function rescale() {
	    var i = 0, n = Math.max(1, range$$1.length);
	    thresholds = new Array(n - 1);
	    while (++i < n) thresholds[i - 1] = threshold(domain, i / n);
	    return scale;
	  }
	
	  function scale(x) {
	    if (!isNaN(x = +x)) return range$$1[bisectRight(thresholds, x)];
	  }
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return i < 0 ? [NaN, NaN] : [
	      i > 0 ? thresholds[i - 1] : domain[0],
	      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
	    ];
	  };
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [];
	    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
	    domain.sort(ascending);
	    return rescale();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice$3.call(_), rescale()) : range$$1.slice();
	  };
	
	  scale.quantiles = function() {
	    return thresholds.slice();
	  };
	
	  scale.copy = function() {
	    return quantile$$1()
	        .domain(domain)
	        .range(range$$1);
	  };
	
	  return scale;
	}
	
	function quantize$1() {
	  var x0 = 0,
	      x1 = 1,
	      n = 1,
	      domain = [0.5],
	      range$$1 = [0, 1];
	
	  function scale(x) {
	    if (x <= x) return range$$1[bisectRight(domain, x, 0, n)];
	  }
	
	  function rescale() {
	    var i = -1;
	    domain = new Array(n);
	    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
	    return scale;
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (n = (range$$1 = slice$3.call(_)).length - 1, rescale()) : range$$1.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return i < 0 ? [NaN, NaN]
	        : i < 1 ? [x0, domain[0]]
	        : i >= n ? [domain[n - 1], x1]
	        : [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return quantize$1()
	        .domain([x0, x1])
	        .range(range$$1);
	  };
	
	  return linearish(scale);
	}
	
	function threshold$1() {
	  var domain = [0.5],
	      range$$1 = [0, 1],
	      n = 1;
	
	  function scale(x) {
	    if (x <= x) return range$$1[bisectRight(domain, x, 0, n)];
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = slice$3.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice$3.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : range$$1.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return threshold$1()
	        .domain(domain)
	        .range(range$$1);
	  };
	
	  return scale;
	}
	
	var durationSecond$1 = 1000;
	var durationMinute$1 = durationSecond$1 * 60;
	var durationHour$1 = durationMinute$1 * 60;
	var durationDay$1 = durationHour$1 * 24;
	var durationWeek$1 = durationDay$1 * 7;
	var durationMonth = durationDay$1 * 30;
	var durationYear = durationDay$1 * 365;
	
	function date$1(t) {
	  return new Date(t);
	}
	
	function number$2(t) {
	  return t instanceof Date ? +t : +new Date(+t);
	}
	
	function calendar(year$$1, month$$1, week, day$$1, hour$$1, minute$$1, second$$1, millisecond$$1, format) {
	  var scale = continuous(deinterpolateLinear, interpolateNumber),
	      invert = scale.invert,
	      domain = scale.domain;
	
	  var formatMillisecond = format(".%L"),
	      formatSecond = format(":%S"),
	      formatMinute = format("%I:%M"),
	      formatHour = format("%I %p"),
	      formatDay = format("%a %d"),
	      formatWeek = format("%b %d"),
	      formatMonth = format("%B"),
	      formatYear = format("%Y");
	
	  var tickIntervals = [
	    [second$$1,  1,      durationSecond$1],
	    [second$$1,  5,  5 * durationSecond$1],
	    [second$$1, 15, 15 * durationSecond$1],
	    [second$$1, 30, 30 * durationSecond$1],
	    [minute$$1,  1,      durationMinute$1],
	    [minute$$1,  5,  5 * durationMinute$1],
	    [minute$$1, 15, 15 * durationMinute$1],
	    [minute$$1, 30, 30 * durationMinute$1],
	    [  hour$$1,  1,      durationHour$1  ],
	    [  hour$$1,  3,  3 * durationHour$1  ],
	    [  hour$$1,  6,  6 * durationHour$1  ],
	    [  hour$$1, 12, 12 * durationHour$1  ],
	    [   day$$1,  1,      durationDay$1   ],
	    [   day$$1,  2,  2 * durationDay$1   ],
	    [  week,  1,      durationWeek$1  ],
	    [ month$$1,  1,      durationMonth ],
	    [ month$$1,  3,  3 * durationMonth ],
	    [  year$$1,  1,      durationYear  ]
	  ];
	
	  function tickFormat(date) {
	    return (second$$1(date) < date ? formatMillisecond
	        : minute$$1(date) < date ? formatSecond
	        : hour$$1(date) < date ? formatMinute
	        : day$$1(date) < date ? formatHour
	        : month$$1(date) < date ? (week(date) < date ? formatDay : formatWeek)
	        : year$$1(date) < date ? formatMonth
	        : formatYear)(date);
	  }
	
	  function tickInterval(interval, start, stop, step) {
	    if (interval == null) interval = 10;
	
	    // If a desired tick count is specified, pick a reasonable tick interval
	    // based on the extent of the domain and a rough estimate of tick size.
	    // Otherwise, assume interval is already a time interval and use it.
	    if (typeof interval === "number") {
	      var target = Math.abs(stop - start) / interval,
	          i = bisector(function(i) { return i[2]; }).right(tickIntervals, target);
	      if (i === tickIntervals.length) {
	        step = tickStep(start / durationYear, stop / durationYear, interval);
	        interval = year$$1;
	      } else if (i) {
	        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
	        step = i[1];
	        interval = i[0];
	      } else {
	        step = tickStep(start, stop, interval);
	        interval = millisecond$$1;
	      }
	    }
	
	    return step == null ? interval : interval.every(step);
	  }
	
	  scale.invert = function(y) {
	    return new Date(invert(y));
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? domain(map$3.call(_, number$2)) : domain().map(date$1);
	  };
	
	  scale.ticks = function(interval, step) {
	    var d = domain(),
	        t0 = d[0],
	        t1 = d[d.length - 1],
	        r = t1 < t0,
	        t;
	    if (r) t = t0, t0 = t1, t1 = t;
	    t = tickInterval(interval, t0, t1, step);
	    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
	    return r ? t.reverse() : t;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return specifier == null ? tickFormat : format(specifier);
	  };
	
	  scale.nice = function(interval, step) {
	    var d = domain();
	    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
	        ? domain(nice(d, interval))
	        : scale;
	  };
	
	  scale.copy = function() {
	    return copy(scale, calendar(year$$1, month$$1, week, day$$1, hour$$1, minute$$1, second$$1, millisecond$$1, format));
	  };
	
	  return scale;
	}
	
	var time = function() {
	  return calendar(year, month, sunday, day, hour, minute, second, millisecond, exports.timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
	};
	
	var utcTime = function() {
	  return calendar(utcYear, utcMonth, utcSunday, utcDay, utcHour, utcMinute, second, millisecond, exports.utcFormat).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
	};
	
	var colors = function(s) {
	  return s.match(/.{6}/g).map(function(x) {
	    return "#" + x;
	  });
	};
	
	var category10 = colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");
	
	var category20b = colors("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6");
	
	var category20c = colors("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9");
	
	var category20 = colors("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5");
	
	var cubehelix$3 = cubehelixLong(cubehelix(300, 0.5, 0.0), cubehelix(-240, 0.5, 1.0));
	
	var warm = cubehelixLong(cubehelix(-100, 0.75, 0.35), cubehelix(80, 1.50, 0.8));
	
	var cool = cubehelixLong(cubehelix(260, 0.75, 0.35), cubehelix(80, 1.50, 0.8));
	
	var rainbow = cubehelix();
	
	var rainbow$1 = function(t) {
	  if (t < 0 || t > 1) t -= Math.floor(t);
	  var ts = Math.abs(t - 0.5);
	  rainbow.h = 360 * t - 100;
	  rainbow.s = 1.5 - 1.5 * ts;
	  rainbow.l = 0.8 - 0.9 * ts;
	  return rainbow + "";
	};
	
	function ramp(range) {
	  var n = range.length;
	  return function(t) {
	    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
	  };
	}
	
	var viridis = ramp(colors("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
	
	var magma = ramp(colors("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
	
	var inferno = ramp(colors("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
	
	var plasma = ramp(colors("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));
	
	function sequential(interpolator) {
	  var x0 = 0,
	      x1 = 1,
	      clamp = false;
	
	  function scale(x) {
	    var t = (x - x0) / (x1 - x0);
	    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, scale) : clamp;
	  };
	
	  scale.interpolator = function(_) {
	    return arguments.length ? (interpolator = _, scale) : interpolator;
	  };
	
	  scale.copy = function() {
	    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
	  };
	
	  return linearish(scale);
	}
	
	var xhtml = "http://www.w3.org/1999/xhtml";
	
	var namespaces = {
	  svg: "http://www.w3.org/2000/svg",
	  xhtml: xhtml,
	  xlink: "http://www.w3.org/1999/xlink",
	  xml: "http://www.w3.org/XML/1998/namespace",
	  xmlns: "http://www.w3.org/2000/xmlns/"
	};
	
	var namespace = function(name) {
	  var prefix = name += "", i = prefix.indexOf(":");
	  if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
	  return namespaces.hasOwnProperty(prefix) ? {space: namespaces[prefix], local: name} : name;
	};
	
	function creatorInherit(name) {
	  return function() {
	    var document = this.ownerDocument,
	        uri = this.namespaceURI;
	    return uri === xhtml && document.documentElement.namespaceURI === xhtml
	        ? document.createElement(name)
	        : document.createElementNS(uri, name);
	  };
	}
	
	function creatorFixed(fullname) {
	  return function() {
	    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
	  };
	}
	
	var creator = function(name) {
	  var fullname = namespace(name);
	  return (fullname.local
	      ? creatorFixed
	      : creatorInherit)(fullname);
	};
	
	var nextId = 0;
	
	function local() {
	  return new Local;
	}
	
	function Local() {
	  this._ = "@" + (++nextId).toString(36);
	}
	
	Local.prototype = local.prototype = {
	  constructor: Local,
	  get: function(node) {
	    var id = this._;
	    while (!(id in node)) if (!(node = node.parentNode)) return;
	    return node[id];
	  },
	  set: function(node, value) {
	    return node[this._] = value;
	  },
	  remove: function(node) {
	    return this._ in node && delete node[this._];
	  },
	  toString: function() {
	    return this._;
	  }
	};
	
	var matcher = function(selector) {
	  return function() {
	    return this.matches(selector);
	  };
	};
	
	if (typeof document !== "undefined") {
	  var element = document.documentElement;
	  if (!element.matches) {
	    var vendorMatches = element.webkitMatchesSelector
	        || element.msMatchesSelector
	        || element.mozMatchesSelector
	        || element.oMatchesSelector;
	    matcher = function(selector) {
	      return function() {
	        return vendorMatches.call(this, selector);
	      };
	    };
	  }
	}
	
	var matcher$1 = matcher;
	
	var filterEvents = {};
	
	exports.event = null;
	
	if (typeof document !== "undefined") {
	  var element$1 = document.documentElement;
	  if (!("onmouseenter" in element$1)) {
	    filterEvents = {mouseenter: "mouseover", mouseleave: "mouseout"};
	  }
	}
	
	function filterContextListener(listener, index, group) {
	  listener = contextListener(listener, index, group);
	  return function(event) {
	    var related = event.relatedTarget;
	    if (!related || (related !== this && !(related.compareDocumentPosition(this) & 8))) {
	      listener.call(this, event);
	    }
	  };
	}
	
	function contextListener(listener, index, group) {
	  return function(event1) {
	    var event0 = exports.event; // Events can be reentrant (e.g., focus).
	    exports.event = event1;
	    try {
	      listener.call(this, this.__data__, index, group);
	    } finally {
	      exports.event = event0;
	    }
	  };
	}
	
	function parseTypenames$1(typenames) {
	  return typenames.trim().split(/^|\s+/).map(function(t) {
	    var name = "", i = t.indexOf(".");
	    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
	    return {type: t, name: name};
	  });
	}
	
	function onRemove(typename) {
	  return function() {
	    var on = this.__on;
	    if (!on) return;
	    for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
	      if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
	        this.removeEventListener(o.type, o.listener, o.capture);
	      } else {
	        on[++i] = o;
	      }
	    }
	    if (++i) on.length = i;
	    else delete this.__on;
	  };
	}
	
	function onAdd(typename, value, capture) {
	  var wrap = filterEvents.hasOwnProperty(typename.type) ? filterContextListener : contextListener;
	  return function(d, i, group) {
	    var on = this.__on, o, listener = wrap(value, i, group);
	    if (on) for (var j = 0, m = on.length; j < m; ++j) {
	      if ((o = on[j]).type === typename.type && o.name === typename.name) {
	        this.removeEventListener(o.type, o.listener, o.capture);
	        this.addEventListener(o.type, o.listener = listener, o.capture = capture);
	        o.value = value;
	        return;
	      }
	    }
	    this.addEventListener(typename.type, listener, capture);
	    o = {type: typename.type, name: typename.name, value: value, listener: listener, capture: capture};
	    if (!on) this.__on = [o];
	    else on.push(o);
	  };
	}
	
	var selection_on = function(typename, value, capture) {
	  var typenames = parseTypenames$1(typename + ""), i, n = typenames.length, t;
	
	  if (arguments.length < 2) {
	    var on = this.node().__on;
	    if (on) for (var j = 0, m = on.length, o; j < m; ++j) {
	      for (i = 0, o = on[j]; i < n; ++i) {
	        if ((t = typenames[i]).type === o.type && t.name === o.name) {
	          return o.value;
	        }
	      }
	    }
	    return;
	  }
	
	  on = value ? onAdd : onRemove;
	  if (capture == null) capture = false;
	  for (i = 0; i < n; ++i) this.each(on(typenames[i], value, capture));
	  return this;
	};
	
	function customEvent(event1, listener, that, args) {
	  var event0 = exports.event;
	  event1.sourceEvent = exports.event;
	  exports.event = event1;
	  try {
	    return listener.apply(that, args);
	  } finally {
	    exports.event = event0;
	  }
	}
	
	var sourceEvent = function() {
	  var current = exports.event, source;
	  while (source = current.sourceEvent) current = source;
	  return current;
	};
	
	var point$5 = function(node, event) {
	  var svg = node.ownerSVGElement || node;
	
	  if (svg.createSVGPoint) {
	    var point = svg.createSVGPoint();
	    point.x = event.clientX, point.y = event.clientY;
	    point = point.matrixTransform(node.getScreenCTM().inverse());
	    return [point.x, point.y];
	  }
	
	  var rect = node.getBoundingClientRect();
	  return [event.clientX - rect.left - node.clientLeft, event.clientY - rect.top - node.clientTop];
	};
	
	var mouse = function(node) {
	  var event = sourceEvent();
	  if (event.changedTouches) event = event.changedTouches[0];
	  return point$5(node, event);
	};
	
	function none$2() {}
	
	var selector = function(selector) {
	  return selector == null ? none$2 : function() {
	    return this.querySelector(selector);
	  };
	};
	
	var selection_select = function(select) {
	  if (typeof select !== "function") select = selector(select);
	
	  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
	      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
	        if ("__data__" in node) subnode.__data__ = node.__data__;
	        subgroup[i] = subnode;
	      }
	    }
	  }
	
	  return new Selection(subgroups, this._parents);
	};
	
	function empty() {
	  return [];
	}
	
	var selectorAll = function(selector) {
	  return selector == null ? empty : function() {
	    return this.querySelectorAll(selector);
	  };
	};
	
	var selection_selectAll = function(select) {
	  if (typeof select !== "function") select = selectorAll(select);
	
	  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
	      if (node = group[i]) {
	        subgroups.push(select.call(node, node.__data__, i, group));
	        parents.push(node);
	      }
	    }
	  }
	
	  return new Selection(subgroups, parents);
	};
	
	var selection_filter = function(match) {
	  if (typeof match !== "function") match = matcher$1(match);
	
	  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
	      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
	        subgroup.push(node);
	      }
	    }
	  }
	
	  return new Selection(subgroups, this._parents);
	};
	
	var sparse = function(update) {
	  return new Array(update.length);
	};
	
	var selection_enter = function() {
	  return new Selection(this._enter || this._groups.map(sparse), this._parents);
	};
	
	function EnterNode(parent, datum) {
	  this.ownerDocument = parent.ownerDocument;
	  this.namespaceURI = parent.namespaceURI;
	  this._next = null;
	  this._parent = parent;
	  this.__data__ = datum;
	}
	
	EnterNode.prototype = {
	  constructor: EnterNode,
	  appendChild: function(child) { return this._parent.insertBefore(child, this._next); },
	  insertBefore: function(child, next) { return this._parent.insertBefore(child, next); },
	  querySelector: function(selector) { return this._parent.querySelector(selector); },
	  querySelectorAll: function(selector) { return this._parent.querySelectorAll(selector); }
	};
	
	var constant$5 = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var keyPrefix = "$"; // Protect against keys like “__proto__”.
	
	function bindIndex(parent, group, enter, update, exit, data) {
	  var i = 0,
	      node,
	      groupLength = group.length,
	      dataLength = data.length;
	
	  // Put any non-null nodes that fit into update.
	  // Put any null nodes into enter.
	  // Put any remaining data into enter.
	  for (; i < dataLength; ++i) {
	    if (node = group[i]) {
	      node.__data__ = data[i];
	      update[i] = node;
	    } else {
	      enter[i] = new EnterNode(parent, data[i]);
	    }
	  }
	
	  // Put any non-null nodes that don’t fit into exit.
	  for (; i < groupLength; ++i) {
	    if (node = group[i]) {
	      exit[i] = node;
	    }
	  }
	}
	
	function bindKey(parent, group, enter, update, exit, data, key) {
	  var i,
	      node,
	      nodeByKeyValue = {},
	      groupLength = group.length,
	      dataLength = data.length,
	      keyValues = new Array(groupLength),
	      keyValue;
	
	  // Compute the key for each node.
	  // If multiple nodes have the same key, the duplicates are added to exit.
	  for (i = 0; i < groupLength; ++i) {
	    if (node = group[i]) {
	      keyValues[i] = keyValue = keyPrefix + key.call(node, node.__data__, i, group);
	      if (keyValue in nodeByKeyValue) {
	        exit[i] = node;
	      } else {
	        nodeByKeyValue[keyValue] = node;
	      }
	    }
	  }
	
	  // Compute the key for each datum.
	  // If there a node associated with this key, join and add it to update.
	  // If there is not (or the key is a duplicate), add it to enter.
	  for (i = 0; i < dataLength; ++i) {
	    keyValue = keyPrefix + key.call(parent, data[i], i, data);
	    if (node = nodeByKeyValue[keyValue]) {
	      update[i] = node;
	      node.__data__ = data[i];
	      nodeByKeyValue[keyValue] = null;
	    } else {
	      enter[i] = new EnterNode(parent, data[i]);
	    }
	  }
	
	  // Add any remaining nodes that were not bound to data to exit.
	  for (i = 0; i < groupLength; ++i) {
	    if ((node = group[i]) && (nodeByKeyValue[keyValues[i]] === node)) {
	      exit[i] = node;
	    }
	  }
	}
	
	var selection_data = function(value, key) {
	  if (!value) {
	    data = new Array(this.size()), j = -1;
	    this.each(function(d) { data[++j] = d; });
	    return data;
	  }
	
	  var bind = key ? bindKey : bindIndex,
	      parents = this._parents,
	      groups = this._groups;
	
	  if (typeof value !== "function") value = constant$5(value);
	
	  for (var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
	    var parent = parents[j],
	        group = groups[j],
	        groupLength = group.length,
	        data = value.call(parent, parent && parent.__data__, j, parents),
	        dataLength = data.length,
	        enterGroup = enter[j] = new Array(dataLength),
	        updateGroup = update[j] = new Array(dataLength),
	        exitGroup = exit[j] = new Array(groupLength);
	
	    bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
	
	    // Now connect the enter nodes to their following update node, such that
	    // appendChild can insert the materialized enter node before this node,
	    // rather than at the end of the parent node.
	    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
	      if (previous = enterGroup[i0]) {
	        if (i0 >= i1) i1 = i0 + 1;
	        while (!(next = updateGroup[i1]) && ++i1 < dataLength);
	        previous._next = next || null;
	      }
	    }
	  }
	
	  update = new Selection(update, parents);
	  update._enter = enter;
	  update._exit = exit;
	  return update;
	};
	
	var selection_exit = function() {
	  return new Selection(this._exit || this._groups.map(sparse), this._parents);
	};
	
	var selection_merge = function(selection) {
	
	  for (var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
	    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
	      if (node = group0[i] || group1[i]) {
	        merge[i] = node;
	      }
	    }
	  }
	
	  for (; j < m0; ++j) {
	    merges[j] = groups0[j];
	  }
	
	  return new Selection(merges, this._parents);
	};
	
	var selection_order = function() {
	
	  for (var groups = this._groups, j = -1, m = groups.length; ++j < m;) {
	    for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
	      if (node = group[i]) {
	        if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
	        next = node;
	      }
	    }
	  }
	
	  return this;
	};
	
	var selection_sort = function(compare) {
	  if (!compare) compare = ascending$2;
	
	  function compareNode(a, b) {
	    return a && b ? compare(a.__data__, b.__data__) : !a - !b;
	  }
	
	  for (var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
	      if (node = group[i]) {
	        sortgroup[i] = node;
	      }
	    }
	    sortgroup.sort(compareNode);
	  }
	
	  return new Selection(sortgroups, this._parents).order();
	};
	
	function ascending$2(a, b) {
	  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	}
	
	var selection_call = function() {
	  var callback = arguments[0];
	  arguments[0] = this;
	  callback.apply(null, arguments);
	  return this;
	};
	
	var selection_nodes = function() {
	  var nodes = new Array(this.size()), i = -1;
	  this.each(function() { nodes[++i] = this; });
	  return nodes;
	};
	
	var selection_node = function() {
	
	  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
	    for (var group = groups[j], i = 0, n = group.length; i < n; ++i) {
	      var node = group[i];
	      if (node) return node;
	    }
	  }
	
	  return null;
	};
	
	var selection_size = function() {
	  var size = 0;
	  this.each(function() { ++size; });
	  return size;
	};
	
	var selection_empty = function() {
	  return !this.node();
	};
	
	var selection_each = function(callback) {
	
	  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
	    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
	      if (node = group[i]) callback.call(node, node.__data__, i, group);
	    }
	  }
	
	  return this;
	};
	
	function attrRemove(name) {
	  return function() {
	    this.removeAttribute(name);
	  };
	}
	
	function attrRemoveNS(fullname) {
	  return function() {
	    this.removeAttributeNS(fullname.space, fullname.local);
	  };
	}
	
	function attrConstant(name, value) {
	  return function() {
	    this.setAttribute(name, value);
	  };
	}
	
	function attrConstantNS(fullname, value) {
	  return function() {
	    this.setAttributeNS(fullname.space, fullname.local, value);
	  };
	}
	
	function attrFunction(name, value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    if (v == null) this.removeAttribute(name);
	    else this.setAttribute(name, v);
	  };
	}
	
	function attrFunctionNS(fullname, value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
	    else this.setAttributeNS(fullname.space, fullname.local, v);
	  };
	}
	
	var selection_attr = function(name, value) {
	  var fullname = namespace(name);
	
	  if (arguments.length < 2) {
	    var node = this.node();
	    return fullname.local
	        ? node.getAttributeNS(fullname.space, fullname.local)
	        : node.getAttribute(fullname);
	  }
	
	  return this.each((value == null
	      ? (fullname.local ? attrRemoveNS : attrRemove) : (typeof value === "function"
	      ? (fullname.local ? attrFunctionNS : attrFunction)
	      : (fullname.local ? attrConstantNS : attrConstant)))(fullname, value));
	};
	
	var window = function(node) {
	  return (node.ownerDocument && node.ownerDocument.defaultView) // node is a Node
	      || (node.document && node) // node is a Window
	      || node.defaultView; // node is a Document
	};
	
	function styleRemove(name) {
	  return function() {
	    this.style.removeProperty(name);
	  };
	}
	
	function styleConstant(name, value, priority) {
	  return function() {
	    this.style.setProperty(name, value, priority);
	  };
	}
	
	function styleFunction(name, value, priority) {
	  return function() {
	    var v = value.apply(this, arguments);
	    if (v == null) this.style.removeProperty(name);
	    else this.style.setProperty(name, v, priority);
	  };
	}
	
	var selection_style = function(name, value, priority) {
	  var node;
	  return arguments.length > 1
	      ? this.each((value == null
	            ? styleRemove : typeof value === "function"
	            ? styleFunction
	            : styleConstant)(name, value, priority == null ? "" : priority))
	      : window(node = this.node())
	          .getComputedStyle(node, null)
	          .getPropertyValue(name);
	};
	
	function propertyRemove(name) {
	  return function() {
	    delete this[name];
	  };
	}
	
	function propertyConstant(name, value) {
	  return function() {
	    this[name] = value;
	  };
	}
	
	function propertyFunction(name, value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    if (v == null) delete this[name];
	    else this[name] = v;
	  };
	}
	
	var selection_property = function(name, value) {
	  return arguments.length > 1
	      ? this.each((value == null
	          ? propertyRemove : typeof value === "function"
	          ? propertyFunction
	          : propertyConstant)(name, value))
	      : this.node()[name];
	};
	
	function classArray(string) {
	  return string.trim().split(/^|\s+/);
	}
	
	function classList(node) {
	  return node.classList || new ClassList(node);
	}
	
	function ClassList(node) {
	  this._node = node;
	  this._names = classArray(node.getAttribute("class") || "");
	}
	
	ClassList.prototype = {
	  add: function(name) {
	    var i = this._names.indexOf(name);
	    if (i < 0) {
	      this._names.push(name);
	      this._node.setAttribute("class", this._names.join(" "));
	    }
	  },
	  remove: function(name) {
	    var i = this._names.indexOf(name);
	    if (i >= 0) {
	      this._names.splice(i, 1);
	      this._node.setAttribute("class", this._names.join(" "));
	    }
	  },
	  contains: function(name) {
	    return this._names.indexOf(name) >= 0;
	  }
	};
	
	function classedAdd(node, names) {
	  var list = classList(node), i = -1, n = names.length;
	  while (++i < n) list.add(names[i]);
	}
	
	function classedRemove(node, names) {
	  var list = classList(node), i = -1, n = names.length;
	  while (++i < n) list.remove(names[i]);
	}
	
	function classedTrue(names) {
	  return function() {
	    classedAdd(this, names);
	  };
	}
	
	function classedFalse(names) {
	  return function() {
	    classedRemove(this, names);
	  };
	}
	
	function classedFunction(names, value) {
	  return function() {
	    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
	  };
	}
	
	var selection_classed = function(name, value) {
	  var names = classArray(name + "");
	
	  if (arguments.length < 2) {
	    var list = classList(this.node()), i = -1, n = names.length;
	    while (++i < n) if (!list.contains(names[i])) return false;
	    return true;
	  }
	
	  return this.each((typeof value === "function"
	      ? classedFunction : value
	      ? classedTrue
	      : classedFalse)(names, value));
	};
	
	function textRemove() {
	  this.textContent = "";
	}
	
	function textConstant(value) {
	  return function() {
	    this.textContent = value;
	  };
	}
	
	function textFunction(value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    this.textContent = v == null ? "" : v;
	  };
	}
	
	var selection_text = function(value) {
	  return arguments.length
	      ? this.each(value == null
	          ? textRemove : (typeof value === "function"
	          ? textFunction
	          : textConstant)(value))
	      : this.node().textContent;
	};
	
	function htmlRemove() {
	  this.innerHTML = "";
	}
	
	function htmlConstant(value) {
	  return function() {
	    this.innerHTML = value;
	  };
	}
	
	function htmlFunction(value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    this.innerHTML = v == null ? "" : v;
	  };
	}
	
	var selection_html = function(value) {
	  return arguments.length
	      ? this.each(value == null
	          ? htmlRemove : (typeof value === "function"
	          ? htmlFunction
	          : htmlConstant)(value))
	      : this.node().innerHTML;
	};
	
	function raise$1() {
	  if (this.nextSibling) this.parentNode.appendChild(this);
	}
	
	var selection_raise = function() {
	  return this.each(raise$1);
	};
	
	function lower() {
	  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
	}
	
	var selection_lower = function() {
	  return this.each(lower);
	};
	
	var selection_append = function(name) {
	  var create = typeof name === "function" ? name : creator(name);
	  return this.select(function() {
	    return this.appendChild(create.apply(this, arguments));
	  });
	};
	
	function constantNull() {
	  return null;
	}
	
	var selection_insert = function(name, before) {
	  var create = typeof name === "function" ? name : creator(name),
	      select = before == null ? constantNull : typeof before === "function" ? before : selector(before);
	  return this.select(function() {
	    return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
	  });
	};
	
	function remove() {
	  var parent = this.parentNode;
	  if (parent) parent.removeChild(this);
	}
	
	var selection_remove = function() {
	  return this.each(remove);
	};
	
	var selection_datum = function(value) {
	  return arguments.length
	      ? this.property("__data__", value)
	      : this.node().__data__;
	};
	
	function dispatchEvent(node, type, params) {
	  var window$$1 = window(node),
	      event = window$$1.CustomEvent;
	
	  if (event) {
	    event = new event(type, params);
	  } else {
	    event = window$$1.document.createEvent("Event");
	    if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
	    else event.initEvent(type, false, false);
	  }
	
	  node.dispatchEvent(event);
	}
	
	function dispatchConstant(type, params) {
	  return function() {
	    return dispatchEvent(this, type, params);
	  };
	}
	
	function dispatchFunction(type, params) {
	  return function() {
	    return dispatchEvent(this, type, params.apply(this, arguments));
	  };
	}
	
	var selection_dispatch = function(type, params) {
	  return this.each((typeof params === "function"
	      ? dispatchFunction
	      : dispatchConstant)(type, params));
	};
	
	var root = [null];
	
	function Selection(groups, parents) {
	  this._groups = groups;
	  this._parents = parents;
	}
	
	function selection() {
	  return new Selection([[document.documentElement]], root);
	}
	
	Selection.prototype = selection.prototype = {
	  constructor: Selection,
	  select: selection_select,
	  selectAll: selection_selectAll,
	  filter: selection_filter,
	  data: selection_data,
	  enter: selection_enter,
	  exit: selection_exit,
	  merge: selection_merge,
	  order: selection_order,
	  sort: selection_sort,
	  call: selection_call,
	  nodes: selection_nodes,
	  node: selection_node,
	  size: selection_size,
	  empty: selection_empty,
	  each: selection_each,
	  attr: selection_attr,
	  style: selection_style,
	  property: selection_property,
	  classed: selection_classed,
	  text: selection_text,
	  html: selection_html,
	  raise: selection_raise,
	  lower: selection_lower,
	  append: selection_append,
	  insert: selection_insert,
	  remove: selection_remove,
	  datum: selection_datum,
	  on: selection_on,
	  dispatch: selection_dispatch
	};
	
	var select = function(selector) {
	  return typeof selector === "string"
	      ? new Selection([[document.querySelector(selector)]], [document.documentElement])
	      : new Selection([[selector]], root);
	};
	
	var selectAll = function(selector) {
	  return typeof selector === "string"
	      ? new Selection([document.querySelectorAll(selector)], [document.documentElement])
	      : new Selection([selector == null ? [] : selector], root);
	};
	
	var touch = function(node, touches, identifier) {
	  if (arguments.length < 3) identifier = touches, touches = sourceEvent().changedTouches;
	
	  for (var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i) {
	    if ((touch = touches[i]).identifier === identifier) {
	      return point$5(node, touch);
	    }
	  }
	
	  return null;
	};
	
	var touches = function(node, touches) {
	  if (touches == null) touches = sourceEvent().touches;
	
	  for (var i = 0, n = touches ? touches.length : 0, points = new Array(n); i < n; ++i) {
	    points[i] = point$5(node, touches[i]);
	  }
	
	  return points;
	};
	
	var emptyOn = dispatch("start", "end", "interrupt");
	var emptyTween = [];
	
	var CREATED = 0;
	var SCHEDULED = 1;
	var STARTING = 2;
	var STARTED = 3;
	var RUNNING = 4;
	var ENDING = 5;
	var ENDED = 6;
	
	var schedule = function(node, name, id, index, group, timing) {
	  var schedules = node.__transition;
	  if (!schedules) node.__transition = {};
	  else if (id in schedules) return;
	  create(node, id, {
	    name: name,
	    index: index, // For context during callback.
	    group: group, // For context during callback.
	    on: emptyOn,
	    tween: emptyTween,
	    time: timing.time,
	    delay: timing.delay,
	    duration: timing.duration,
	    ease: timing.ease,
	    timer: null,
	    state: CREATED
	  });
	};
	
	function init(node, id) {
	  var schedule = node.__transition;
	  if (!schedule || !(schedule = schedule[id]) || schedule.state > CREATED) throw new Error("too late");
	  return schedule;
	}
	
	function set$3(node, id) {
	  var schedule = node.__transition;
	  if (!schedule || !(schedule = schedule[id]) || schedule.state > STARTING) throw new Error("too late");
	  return schedule;
	}
	
	function get$1(node, id) {
	  var schedule = node.__transition;
	  if (!schedule || !(schedule = schedule[id])) throw new Error("too late");
	  return schedule;
	}
	
	function create(node, id, self) {
	  var schedules = node.__transition,
	      tween;
	
	  // Initialize the self timer when the transition is created.
	  // Note the actual delay is not known until the first callback!
	  schedules[id] = self;
	  self.timer = timer(schedule, 0, self.time);
	
	  function schedule(elapsed) {
	    self.state = SCHEDULED;
	    self.timer.restart(start, self.delay, self.time);
	
	    // If the elapsed delay is less than our first sleep, start immediately.
	    if (self.delay <= elapsed) start(elapsed - self.delay);
	  }
	
	  function start(elapsed) {
	    var i, j, n, o;
	
	    // If the state is not SCHEDULED, then we previously errored on start.
	    if (self.state !== SCHEDULED) return stop();
	
	    for (i in schedules) {
	      o = schedules[i];
	      if (o.name !== self.name) continue;
	
	      // While this element already has a starting transition during this frame,
	      // defer starting an interrupting transition until that transition has a
	      // chance to tick (and possibly end); see d3/d3-transition#54!
	      if (o.state === STARTED) return timeout$1(start);
	
	      // Interrupt the active transition, if any.
	      // Dispatch the interrupt event.
	      if (o.state === RUNNING) {
	        o.state = ENDED;
	        o.timer.stop();
	        o.on.call("interrupt", node, node.__data__, o.index, o.group);
	        delete schedules[i];
	      }
	
	      // Cancel any pre-empted transitions. No interrupt event is dispatched
	      // because the cancelled transitions never started. Note that this also
	      // removes this transition from the pending list!
	      else if (+i < id) {
	        o.state = ENDED;
	        o.timer.stop();
	        delete schedules[i];
	      }
	    }
	
	    // Defer the first tick to end of the current frame; see d3/d3#1576.
	    // Note the transition may be canceled after start and before the first tick!
	    // Note this must be scheduled before the start event; see d3/d3-transition#16!
	    // Assuming this is successful, subsequent callbacks go straight to tick.
	    timeout$1(function() {
	      if (self.state === STARTED) {
	        self.state = RUNNING;
	        self.timer.restart(tick, self.delay, self.time);
	        tick(elapsed);
	      }
	    });
	
	    // Dispatch the start event.
	    // Note this must be done before the tween are initialized.
	    self.state = STARTING;
	    self.on.call("start", node, node.__data__, self.index, self.group);
	    if (self.state !== STARTING) return; // interrupted
	    self.state = STARTED;
	
	    // Initialize the tween, deleting null tween.
	    tween = new Array(n = self.tween.length);
	    for (i = 0, j = -1; i < n; ++i) {
	      if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) {
	        tween[++j] = o;
	      }
	    }
	    tween.length = j + 1;
	  }
	
	  function tick(elapsed) {
	    var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = ENDING, 1),
	        i = -1,
	        n = tween.length;
	
	    while (++i < n) {
	      tween[i].call(null, t);
	    }
	
	    // Dispatch the end event.
	    if (self.state === ENDING) {
	      self.on.call("end", node, node.__data__, self.index, self.group);
	      stop();
	    }
	  }
	
	  function stop() {
	    self.state = ENDED;
	    self.timer.stop();
	    delete schedules[id];
	    for (var i in schedules) return; // eslint-disable-line no-unused-vars
	    delete node.__transition;
	  }
	}
	
	var interrupt = function(node, name) {
	  var schedules = node.__transition,
	      schedule,
	      active,
	      empty = true,
	      i;
	
	  if (!schedules) return;
	
	  name = name == null ? null : name + "";
	
	  for (i in schedules) {
	    if ((schedule = schedules[i]).name !== name) { empty = false; continue; }
	    active = schedule.state > STARTING && schedule.state < ENDING;
	    schedule.state = ENDED;
	    schedule.timer.stop();
	    if (active) schedule.on.call("interrupt", node, node.__data__, schedule.index, schedule.group);
	    delete schedules[i];
	  }
	
	  if (empty) delete node.__transition;
	};
	
	var selection_interrupt = function(name) {
	  return this.each(function() {
	    interrupt(this, name);
	  });
	};
	
	function tweenRemove(id, name) {
	  var tween0, tween1;
	  return function() {
	    var schedule = set$3(this, id),
	        tween = schedule.tween;
	
	    // If this node shared tween with the previous node,
	    // just assign the updated shared tween and we’re done!
	    // Otherwise, copy-on-write.
	    if (tween !== tween0) {
	      tween1 = tween0 = tween;
	      for (var i = 0, n = tween1.length; i < n; ++i) {
	        if (tween1[i].name === name) {
	          tween1 = tween1.slice();
	          tween1.splice(i, 1);
	          break;
	        }
	      }
	    }
	
	    schedule.tween = tween1;
	  };
	}
	
	function tweenFunction(id, name, value) {
	  var tween0, tween1;
	  if (typeof value !== "function") throw new Error;
	  return function() {
	    var schedule = set$3(this, id),
	        tween = schedule.tween;
	
	    // If this node shared tween with the previous node,
	    // just assign the updated shared tween and we’re done!
	    // Otherwise, copy-on-write.
	    if (tween !== tween0) {
	      tween1 = (tween0 = tween).slice();
	      for (var t = {name: name, value: value}, i = 0, n = tween1.length; i < n; ++i) {
	        if (tween1[i].name === name) {
	          tween1[i] = t;
	          break;
	        }
	      }
	      if (i === n) tween1.push(t);
	    }
	
	    schedule.tween = tween1;
	  };
	}
	
	var transition_tween = function(name, value) {
	  var id = this._id;
	
	  name += "";
	
	  if (arguments.length < 2) {
	    var tween = get$1(this.node(), id).tween;
	    for (var i = 0, n = tween.length, t; i < n; ++i) {
	      if ((t = tween[i]).name === name) {
	        return t.value;
	      }
	    }
	    return null;
	  }
	
	  return this.each((value == null ? tweenRemove : tweenFunction)(id, name, value));
	};
	
	function tweenValue(transition, name, value) {
	  var id = transition._id;
	
	  transition.each(function() {
	    var schedule = set$3(this, id);
	    (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
	  });
	
	  return function(node) {
	    return get$1(node, id).value[name];
	  };
	}
	
	var interpolate$1 = function(a, b) {
	  var c;
	  return (typeof b === "number" ? interpolateNumber
	      : b instanceof color ? interpolateRgb
	      : (c = color(b)) ? (b = c, interpolateRgb)
	      : interpolateString)(a, b);
	};
	
	function attrRemove$1(name) {
	  return function() {
	    this.removeAttribute(name);
	  };
	}
	
	function attrRemoveNS$1(fullname) {
	  return function() {
	    this.removeAttributeNS(fullname.space, fullname.local);
	  };
	}
	
	function attrConstant$1(name, interpolate$$1, value1) {
	  var value00,
	      interpolate0;
	  return function() {
	    var value0 = this.getAttribute(name);
	    return value0 === value1 ? null
	        : value0 === value00 ? interpolate0
	        : interpolate0 = interpolate$$1(value00 = value0, value1);
	  };
	}
	
	function attrConstantNS$1(fullname, interpolate$$1, value1) {
	  var value00,
	      interpolate0;
	  return function() {
	    var value0 = this.getAttributeNS(fullname.space, fullname.local);
	    return value0 === value1 ? null
	        : value0 === value00 ? interpolate0
	        : interpolate0 = interpolate$$1(value00 = value0, value1);
	  };
	}
	
	function attrFunction$1(name, interpolate$$1, value) {
	  var value00,
	      value10,
	      interpolate0;
	  return function() {
	    var value0, value1 = value(this);
	    if (value1 == null) return void this.removeAttribute(name);
	    value0 = this.getAttribute(name);
	    return value0 === value1 ? null
	        : value0 === value00 && value1 === value10 ? interpolate0
	        : interpolate0 = interpolate$$1(value00 = value0, value10 = value1);
	  };
	}
	
	function attrFunctionNS$1(fullname, interpolate$$1, value) {
	  var value00,
	      value10,
	      interpolate0;
	  return function() {
	    var value0, value1 = value(this);
	    if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
	    value0 = this.getAttributeNS(fullname.space, fullname.local);
	    return value0 === value1 ? null
	        : value0 === value00 && value1 === value10 ? interpolate0
	        : interpolate0 = interpolate$$1(value00 = value0, value10 = value1);
	  };
	}
	
	var transition_attr = function(name, value) {
	  var fullname = namespace(name), i = fullname === "transform" ? interpolateTransformSvg : interpolate$1;
	  return this.attrTween(name, typeof value === "function"
	      ? (fullname.local ? attrFunctionNS$1 : attrFunction$1)(fullname, i, tweenValue(this, "attr." + name, value))
	      : value == null ? (fullname.local ? attrRemoveNS$1 : attrRemove$1)(fullname)
	      : (fullname.local ? attrConstantNS$1 : attrConstant$1)(fullname, i, value));
	};
	
	function attrTweenNS(fullname, value) {
	  function tween() {
	    var node = this, i = value.apply(node, arguments);
	    return i && function(t) {
	      node.setAttributeNS(fullname.space, fullname.local, i(t));
	    };
	  }
	  tween._value = value;
	  return tween;
	}
	
	function attrTween(name, value) {
	  function tween() {
	    var node = this, i = value.apply(node, arguments);
	    return i && function(t) {
	      node.setAttribute(name, i(t));
	    };
	  }
	  tween._value = value;
	  return tween;
	}
	
	var transition_attrTween = function(name, value) {
	  var key = "attr." + name;
	  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
	  if (value == null) return this.tween(key, null);
	  if (typeof value !== "function") throw new Error;
	  var fullname = namespace(name);
	  return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
	};
	
	function delayFunction(id, value) {
	  return function() {
	    init(this, id).delay = +value.apply(this, arguments);
	  };
	}
	
	function delayConstant(id, value) {
	  return value = +value, function() {
	    init(this, id).delay = value;
	  };
	}
	
	var transition_delay = function(value) {
	  var id = this._id;
	
	  return arguments.length
	      ? this.each((typeof value === "function"
	          ? delayFunction
	          : delayConstant)(id, value))
	      : get$1(this.node(), id).delay;
	};
	
	function durationFunction(id, value) {
	  return function() {
	    set$3(this, id).duration = +value.apply(this, arguments);
	  };
	}
	
	function durationConstant(id, value) {
	  return value = +value, function() {
	    set$3(this, id).duration = value;
	  };
	}
	
	var transition_duration = function(value) {
	  var id = this._id;
	
	  return arguments.length
	      ? this.each((typeof value === "function"
	          ? durationFunction
	          : durationConstant)(id, value))
	      : get$1(this.node(), id).duration;
	};
	
	function easeConstant(id, value) {
	  if (typeof value !== "function") throw new Error;
	  return function() {
	    set$3(this, id).ease = value;
	  };
	}
	
	var transition_ease = function(value) {
	  var id = this._id;
	
	  return arguments.length
	      ? this.each(easeConstant(id, value))
	      : get$1(this.node(), id).ease;
	};
	
	var transition_filter = function(match) {
	  if (typeof match !== "function") match = matcher$1(match);
	
	  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
	      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
	        subgroup.push(node);
	      }
	    }
	  }
	
	  return new Transition(subgroups, this._parents, this._name, this._id);
	};
	
	var transition_merge = function(transition) {
	  if (transition._id !== this._id) throw new Error;
	
	  for (var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
	    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
	      if (node = group0[i] || group1[i]) {
	        merge[i] = node;
	      }
	    }
	  }
	
	  for (; j < m0; ++j) {
	    merges[j] = groups0[j];
	  }
	
	  return new Transition(merges, this._parents, this._name, this._id);
	};
	
	function start$1(name) {
	  return (name + "").trim().split(/^|\s+/).every(function(t) {
	    var i = t.indexOf(".");
	    if (i >= 0) t = t.slice(0, i);
	    return !t || t === "start";
	  });
	}
	
	function onFunction(id, name, listener) {
	  var on0, on1, sit = start$1(name) ? init : set$3;
	  return function() {
	    var schedule = sit(this, id),
	        on = schedule.on;
	
	    // If this node shared a dispatch with the previous node,
	    // just assign the updated shared dispatch and we’re done!
	    // Otherwise, copy-on-write.
	    if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
	
	    schedule.on = on1;
	  };
	}
	
	var transition_on = function(name, listener) {
	  var id = this._id;
	
	  return arguments.length < 2
	      ? get$1(this.node(), id).on.on(name)
	      : this.each(onFunction(id, name, listener));
	};
	
	function removeFunction(id) {
	  return function() {
	    var parent = this.parentNode;
	    for (var i in this.__transition) if (+i !== id) return;
	    if (parent) parent.removeChild(this);
	  };
	}
	
	var transition_remove = function() {
	  return this.on("end.remove", removeFunction(this._id));
	};
	
	var transition_select = function(select$$1) {
	  var name = this._name,
	      id = this._id;
	
	  if (typeof select$$1 !== "function") select$$1 = selector(select$$1);
	
	  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
	      if ((node = group[i]) && (subnode = select$$1.call(node, node.__data__, i, group))) {
	        if ("__data__" in node) subnode.__data__ = node.__data__;
	        subgroup[i] = subnode;
	        schedule(subgroup[i], name, id, i, subgroup, get$1(node, id));
	      }
	    }
	  }
	
	  return new Transition(subgroups, this._parents, name, id);
	};
	
	var transition_selectAll = function(select$$1) {
	  var name = this._name,
	      id = this._id;
	
	  if (typeof select$$1 !== "function") select$$1 = selectorAll(select$$1);
	
	  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
	      if (node = group[i]) {
	        for (var children = select$$1.call(node, node.__data__, i, group), child, inherit = get$1(node, id), k = 0, l = children.length; k < l; ++k) {
	          if (child = children[k]) {
	            schedule(child, name, id, k, children, inherit);
	          }
	        }
	        subgroups.push(children);
	        parents.push(node);
	      }
	    }
	  }
	
	  return new Transition(subgroups, parents, name, id);
	};
	
	var Selection$1 = selection.prototype.constructor;
	
	var transition_selection = function() {
	  return new Selection$1(this._groups, this._parents);
	};
	
	function styleRemove$1(name, interpolate$$1) {
	  var value00,
	      value10,
	      interpolate0;
	  return function() {
	    var style = window(this).getComputedStyle(this, null),
	        value0 = style.getPropertyValue(name),
	        value1 = (this.style.removeProperty(name), style.getPropertyValue(name));
	    return value0 === value1 ? null
	        : value0 === value00 && value1 === value10 ? interpolate0
	        : interpolate0 = interpolate$$1(value00 = value0, value10 = value1);
	  };
	}
	
	function styleRemoveEnd(name) {
	  return function() {
	    this.style.removeProperty(name);
	  };
	}
	
	function styleConstant$1(name, interpolate$$1, value1) {
	  var value00,
	      interpolate0;
	  return function() {
	    var value0 = window(this).getComputedStyle(this, null).getPropertyValue(name);
	    return value0 === value1 ? null
	        : value0 === value00 ? interpolate0
	        : interpolate0 = interpolate$$1(value00 = value0, value1);
	  };
	}
	
	function styleFunction$1(name, interpolate$$1, value) {
	  var value00,
	      value10,
	      interpolate0;
	  return function() {
	    var style = window(this).getComputedStyle(this, null),
	        value0 = style.getPropertyValue(name),
	        value1 = value(this);
	    if (value1 == null) value1 = (this.style.removeProperty(name), style.getPropertyValue(name));
	    return value0 === value1 ? null
	        : value0 === value00 && value1 === value10 ? interpolate0
	        : interpolate0 = interpolate$$1(value00 = value0, value10 = value1);
	  };
	}
	
	var transition_style = function(name, value, priority) {
	  var i = (name += "") === "transform" ? interpolateTransformCss : interpolate$1;
	  return value == null ? this
	          .styleTween(name, styleRemove$1(name, i))
	          .on("end.style." + name, styleRemoveEnd(name))
	      : this.styleTween(name, typeof value === "function"
	          ? styleFunction$1(name, i, tweenValue(this, "style." + name, value))
	          : styleConstant$1(name, i, value), priority);
	};
	
	function styleTween(name, value, priority) {
	  function tween() {
	    var node = this, i = value.apply(node, arguments);
	    return i && function(t) {
	      node.style.setProperty(name, i(t), priority);
	    };
	  }
	  tween._value = value;
	  return tween;
	}
	
	var transition_styleTween = function(name, value, priority) {
	  var key = "style." + (name += "");
	  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
	  if (value == null) return this.tween(key, null);
	  if (typeof value !== "function") throw new Error;
	  return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
	};
	
	function textConstant$1(value) {
	  return function() {
	    this.textContent = value;
	  };
	}
	
	function textFunction$1(value) {
	  return function() {
	    var value1 = value(this);
	    this.textContent = value1 == null ? "" : value1;
	  };
	}
	
	var transition_text = function(value) {
	  return this.tween("text", typeof value === "function"
	      ? textFunction$1(tweenValue(this, "text", value))
	      : textConstant$1(value == null ? "" : value + ""));
	};
	
	var transition_transition = function() {
	  var name = this._name,
	      id0 = this._id,
	      id1 = newId();
	
	  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
	      if (node = group[i]) {
	        var inherit = get$1(node, id0);
	        schedule(node, name, id1, i, group, {
	          time: inherit.time + inherit.delay + inherit.duration,
	          delay: 0,
	          duration: inherit.duration,
	          ease: inherit.ease
	        });
	      }
	    }
	  }
	
	  return new Transition(groups, this._parents, name, id1);
	};
	
	var id = 0;
	
	function Transition(groups, parents, name, id) {
	  this._groups = groups;
	  this._parents = parents;
	  this._name = name;
	  this._id = id;
	}
	
	function transition(name) {
	  return selection().transition(name);
	}
	
	function newId() {
	  return ++id;
	}
	
	var selection_prototype = selection.prototype;
	
	Transition.prototype = transition.prototype = {
	  constructor: Transition,
	  select: transition_select,
	  selectAll: transition_selectAll,
	  filter: transition_filter,
	  merge: transition_merge,
	  selection: transition_selection,
	  transition: transition_transition,
	  call: selection_prototype.call,
	  nodes: selection_prototype.nodes,
	  node: selection_prototype.node,
	  size: selection_prototype.size,
	  empty: selection_prototype.empty,
	  each: selection_prototype.each,
	  on: transition_on,
	  attr: transition_attr,
	  attrTween: transition_attrTween,
	  style: transition_style,
	  styleTween: transition_styleTween,
	  text: transition_text,
	  remove: transition_remove,
	  tween: transition_tween,
	  delay: transition_delay,
	  duration: transition_duration,
	  ease: transition_ease
	};
	
	var defaultTiming = {
	  time: null, // Set on use.
	  delay: 0,
	  duration: 250,
	  ease: cubicInOut
	};
	
	function inherit(node, id) {
	  var timing;
	  while (!(timing = node.__transition) || !(timing = timing[id])) {
	    if (!(node = node.parentNode)) {
	      return defaultTiming.time = now(), defaultTiming;
	    }
	  }
	  return timing;
	}
	
	var selection_transition = function(name) {
	  var id,
	      timing;
	
	  if (name instanceof Transition) {
	    id = name._id, name = name._name;
	  } else {
	    id = newId(), (timing = defaultTiming).time = now(), name = name == null ? null : name + "";
	  }
	
	  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
	      if (node = group[i]) {
	        schedule(node, name, id, i, group, timing || inherit(node, id));
	      }
	    }
	  }
	
	  return new Transition(groups, this._parents, name, id);
	};
	
	selection.prototype.interrupt = selection_interrupt;
	selection.prototype.transition = selection_transition;
	
	var root$1 = [null];
	
	var active = function(node, name) {
	  var schedules = node.__transition,
	      schedule,
	      i;
	
	  if (schedules) {
	    name = name == null ? null : name + "";
	    for (i in schedules) {
	      if ((schedule = schedules[i]).state > SCHEDULED && schedule.name === name) {
	        return new Transition([[node]], root$1, name, +i);
	      }
	    }
	  }
	
	  return null;
	};
	
	var slice$4 = Array.prototype.slice;
	
	var identity$5 = function(x) {
	  return x;
	};
	
	var top = 1;
	var right = 2;
	var bottom = 3;
	var left = 4;
	var epsilon$2 = 1e-6;
	
	function translateX(scale0, scale1, d) {
	  var x = scale0(d);
	  return "translate(" + (isFinite(x) ? x : scale1(d)) + ",0)";
	}
	
	function translateY(scale0, scale1, d) {
	  var y = scale0(d);
	  return "translate(0," + (isFinite(y) ? y : scale1(d)) + ")";
	}
	
	function center(scale) {
	  var offset = scale.bandwidth() / 2;
	  if (scale.round()) offset = Math.round(offset);
	  return function(d) {
	    return scale(d) + offset;
	  };
	}
	
	function entering() {
	  return !this.__axis;
	}
	
	function axis(orient, scale) {
	  var tickArguments = [],
	      tickValues = null,
	      tickFormat = null,
	      tickSizeInner = 6,
	      tickSizeOuter = 6,
	      tickPadding = 3;
	
	  function axis(context) {
	    var values = tickValues == null ? (scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain()) : tickValues,
	        format = tickFormat == null ? (scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : identity$5) : tickFormat,
	        spacing = Math.max(tickSizeInner, 0) + tickPadding,
	        transform = orient === top || orient === bottom ? translateX : translateY,
	        range = scale.range(),
	        range0 = range[0] + 0.5,
	        range1 = range[range.length - 1] + 0.5,
	        position = (scale.bandwidth ? center : identity$5)(scale.copy()),
	        selection = context.selection ? context.selection() : context,
	        path = selection.selectAll(".domain").data([null]),
	        tick = selection.selectAll(".tick").data(values, scale).order(),
	        tickExit = tick.exit(),
	        tickEnter = tick.enter().append("g").attr("class", "tick"),
	        line = tick.select("line"),
	        text = tick.select("text"),
	        k = orient === top || orient === left ? -1 : 1,
	        x, y = orient === left || orient === right ? (x = "x", "y") : (x = "y", "x");
	
	    path = path.merge(path.enter().insert("path", ".tick")
	        .attr("class", "domain")
	        .attr("stroke", "#000"));
	
	    tick = tick.merge(tickEnter);
	
	    line = line.merge(tickEnter.append("line")
	        .attr("stroke", "#000")
	        .attr(x + "2", k * tickSizeInner)
	        .attr(y + "1", 0.5)
	        .attr(y + "2", 0.5));
	
	    text = text.merge(tickEnter.append("text")
	        .attr("fill", "#000")
	        .attr(x, k * spacing)
	        .attr(y, 0.5)
	        .attr("dy", orient === top ? "0em" : orient === bottom ? "0.71em" : "0.32em"));
	
	    if (context !== selection) {
	      path = path.transition(context);
	      tick = tick.transition(context);
	      line = line.transition(context);
	      text = text.transition(context);
	
	      tickExit = tickExit.transition(context)
	          .attr("opacity", epsilon$2)
	          .attr("transform", function(d) { return transform(position, this.parentNode.__axis || position, d); });
	
	      tickEnter
	          .attr("opacity", epsilon$2)
	          .attr("transform", function(d) { return transform(this.parentNode.__axis || position, position, d); });
	    }
	
	    tickExit.remove();
	
	    path
	        .attr("d", orient === left || orient == right
	            ? "M" + k * tickSizeOuter + "," + range0 + "H0.5V" + range1 + "H" + k * tickSizeOuter
	            : "M" + range0 + "," + k * tickSizeOuter + "V0.5H" + range1 + "V" + k * tickSizeOuter);
	
	    tick
	        .attr("opacity", 1)
	        .attr("transform", function(d) { return transform(position, position, d); });
	
	    line
	        .attr(x + "2", k * tickSizeInner);
	
	    text
	        .attr(x, k * spacing)
	        .text(format);
	
	    selection.filter(entering)
	        .attr("fill", "none")
	        .attr("font-size", 10)
	        .attr("font-family", "sans-serif")
	        .attr("text-anchor", orient === right ? "start" : orient === left ? "end" : "middle");
	
	    selection
	        .each(function() { this.__axis = position; });
	  }
	
	  axis.scale = function(_) {
	    return arguments.length ? (scale = _, axis) : scale;
	  };
	
	  axis.ticks = function() {
	    return tickArguments = slice$4.call(arguments), axis;
	  };
	
	  axis.tickArguments = function(_) {
	    return arguments.length ? (tickArguments = _ == null ? [] : slice$4.call(_), axis) : tickArguments.slice();
	  };
	
	  axis.tickValues = function(_) {
	    return arguments.length ? (tickValues = _ == null ? null : slice$4.call(_), axis) : tickValues && tickValues.slice();
	  };
	
	  axis.tickFormat = function(_) {
	    return arguments.length ? (tickFormat = _, axis) : tickFormat;
	  };
	
	  axis.tickSize = function(_) {
	    return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
	  };
	
	  axis.tickSizeInner = function(_) {
	    return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
	  };
	
	  axis.tickSizeOuter = function(_) {
	    return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
	  };
	
	  axis.tickPadding = function(_) {
	    return arguments.length ? (tickPadding = +_, axis) : tickPadding;
	  };
	
	  return axis;
	}
	
	function axisTop(scale) {
	  return axis(top, scale);
	}
	
	function axisRight(scale) {
	  return axis(right, scale);
	}
	
	function axisBottom(scale) {
	  return axis(bottom, scale);
	}
	
	function axisLeft(scale) {
	  return axis(left, scale);
	}
	
	function defaultSeparation(a, b) {
	  return a.parent === b.parent ? 1 : 2;
	}
	
	function meanX(children) {
	  return children.reduce(meanXReduce, 0) / children.length;
	}
	
	function meanXReduce(x, c) {
	  return x + c.x;
	}
	
	function maxY(children) {
	  return 1 + children.reduce(maxYReduce, 0);
	}
	
	function maxYReduce(y, c) {
	  return Math.max(y, c.y);
	}
	
	function leafLeft(node) {
	  var children;
	  while (children = node.children) node = children[0];
	  return node;
	}
	
	function leafRight(node) {
	  var children;
	  while (children = node.children) node = children[children.length - 1];
	  return node;
	}
	
	var cluster = function() {
	  var separation = defaultSeparation,
	      dx = 1,
	      dy = 1,
	      nodeSize = false;
	
	  function cluster(root) {
	    var previousNode,
	        x = 0;
	
	    // First walk, computing the initial x & y values.
	    root.eachAfter(function(node) {
	      var children = node.children;
	      if (children) {
	        node.x = meanX(children);
	        node.y = maxY(children);
	      } else {
	        node.x = previousNode ? x += separation(node, previousNode) : 0;
	        node.y = 0;
	        previousNode = node;
	      }
	    });
	
	    var left = leafLeft(root),
	        right = leafRight(root),
	        x0 = left.x - separation(left, right) / 2,
	        x1 = right.x + separation(right, left) / 2;
	
	    // Second walk, normalizing x & y to the desired size.
	    return root.eachAfter(nodeSize ? function(node) {
	      node.x = (node.x - root.x) * dx;
	      node.y = (root.y - node.y) * dy;
	    } : function(node) {
	      node.x = (node.x - x0) / (x1 - x0) * dx;
	      node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
	    });
	  }
	
	  cluster.separation = function(x) {
	    return arguments.length ? (separation = x, cluster) : separation;
	  };
	
	  cluster.size = function(x) {
	    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? null : [dx, dy]);
	  };
	
	  cluster.nodeSize = function(x) {
	    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? [dx, dy] : null);
	  };
	
	  return cluster;
	};
	
	var node_each = function(callback) {
	  var node = this, current, next = [node], children, i, n;
	  do {
	    current = next.reverse(), next = [];
	    while (node = current.pop()) {
	      callback(node), children = node.children;
	      if (children) for (i = 0, n = children.length; i < n; ++i) {
	        next.push(children[i]);
	      }
	    }
	  } while (next.length);
	  return this;
	};
	
	var node_eachBefore = function(callback) {
	  var node = this, nodes = [node], children, i;
	  while (node = nodes.pop()) {
	    callback(node), children = node.children;
	    if (children) for (i = children.length - 1; i >= 0; --i) {
	      nodes.push(children[i]);
	    }
	  }
	  return this;
	};
	
	var node_eachAfter = function(callback) {
	  var node = this, nodes = [node], next = [], children, i, n;
	  while (node = nodes.pop()) {
	    next.push(node), children = node.children;
	    if (children) for (i = 0, n = children.length; i < n; ++i) {
	      nodes.push(children[i]);
	    }
	  }
	  while (node = next.pop()) {
	    callback(node);
	  }
	  return this;
	};
	
	var node_sum = function(value) {
	  return this.eachAfter(function(node) {
	    var sum = +value(node.data) || 0,
	        children = node.children,
	        i = children && children.length;
	    while (--i >= 0) sum += children[i].value;
	    node.value = sum;
	  });
	};
	
	var node_sort = function(compare) {
	  return this.eachBefore(function(node) {
	    if (node.children) {
	      node.children.sort(compare);
	    }
	  });
	};
	
	var node_path = function(end) {
	  var start = this,
	      ancestor = leastCommonAncestor(start, end),
	      nodes = [start];
	  while (start !== ancestor) {
	    start = start.parent;
	    nodes.push(start);
	  }
	  var k = nodes.length;
	  while (end !== ancestor) {
	    nodes.splice(k, 0, end);
	    end = end.parent;
	  }
	  return nodes;
	};
	
	function leastCommonAncestor(a, b) {
	  if (a === b) return a;
	  var aNodes = a.ancestors(),
	      bNodes = b.ancestors(),
	      c = null;
	  a = aNodes.pop();
	  b = bNodes.pop();
	  while (a === b) {
	    c = a;
	    a = aNodes.pop();
	    b = bNodes.pop();
	  }
	  return c;
	}
	
	var node_ancestors = function() {
	  var node = this, nodes = [node];
	  while (node = node.parent) {
	    nodes.push(node);
	  }
	  return nodes;
	};
	
	var node_descendants = function() {
	  var nodes = [];
	  this.each(function(node) {
	    nodes.push(node);
	  });
	  return nodes;
	};
	
	var node_leaves = function() {
	  var leaves = [];
	  this.eachBefore(function(node) {
	    if (!node.children) {
	      leaves.push(node);
	    }
	  });
	  return leaves;
	};
	
	var node_links = function() {
	  var root = this, links = [];
	  root.each(function(node) {
	    if (node !== root) { // Don’t include the root’s parent, if any.
	      links.push({source: node.parent, target: node});
	    }
	  });
	  return links;
	};
	
	function hierarchy(data, children) {
	  var root = new Node(data),
	      valued = +data.value && (root.value = data.value),
	      node,
	      nodes = [root],
	      child,
	      childs,
	      i,
	      n;
	
	  if (children == null) children = defaultChildren;
	
	  while (node = nodes.pop()) {
	    if (valued) node.value = +node.data.value;
	    if ((childs = children(node.data)) && (n = childs.length)) {
	      node.children = new Array(n);
	      for (i = n - 1; i >= 0; --i) {
	        nodes.push(child = node.children[i] = new Node(childs[i]));
	        child.parent = node;
	        child.depth = node.depth + 1;
	      }
	    }
	  }
	
	  return root.eachBefore(computeHeight);
	}
	
	function node_copy() {
	  return hierarchy(this).eachBefore(copyData);
	}
	
	function defaultChildren(d) {
	  return d.children;
	}
	
	function copyData(node) {
	  node.data = node.data.data;
	}
	
	function computeHeight(node) {
	  var height = 0;
	  do node.height = height;
	  while ((node = node.parent) && (node.height < ++height));
	}
	
	function Node(data) {
	  this.data = data;
	  this.depth =
	  this.height = 0;
	  this.parent = null;
	}
	
	Node.prototype = hierarchy.prototype = {
	  constructor: Node,
	  each: node_each,
	  eachAfter: node_eachAfter,
	  eachBefore: node_eachBefore,
	  sum: node_sum,
	  sort: node_sort,
	  path: node_path,
	  ancestors: node_ancestors,
	  descendants: node_descendants,
	  leaves: node_leaves,
	  links: node_links,
	  copy: node_copy
	};
	
	function Node$2(value) {
	  this._ = value;
	  this.next = null;
	}
	
	var shuffle$1 = function(array) {
	  var i,
	      n = (array = array.slice()).length,
	      head = null,
	      node = head;
	
	  while (n) {
	    var next = new Node$2(array[n - 1]);
	    if (node) node = node.next = next;
	    else node = head = next;
	    array[i] = array[--n];
	  }
	
	  return {
	    head: head,
	    tail: node
	  };
	};
	
	var enclose = function(circles) {
	  return encloseN(shuffle$1(circles), []);
	};
	
	function encloses(a, b) {
	  var dx = b.x - a.x,
	      dy = b.y - a.y,
	      dr = a.r - b.r;
	  return dr * dr + 1e-6 > dx * dx + dy * dy;
	}
	
	// Returns the smallest circle that contains circles L and intersects circles B.
	function encloseN(L, B) {
	  var circle,
	      l0 = null,
	      l1 = L.head,
	      l2,
	      p1;
	
	  switch (B.length) {
	    case 1: circle = enclose1(B[0]); break;
	    case 2: circle = enclose2(B[0], B[1]); break;
	    case 3: circle = enclose3(B[0], B[1], B[2]); break;
	  }
	
	  while (l1) {
	    p1 = l1._, l2 = l1.next;
	    if (!circle || !encloses(circle, p1)) {
	
	      // Temporarily truncate L before l1.
	      if (l0) L.tail = l0, l0.next = null;
	      else L.head = L.tail = null;
	
	      B.push(p1);
	      circle = encloseN(L, B); // Note: reorders L!
	      B.pop();
	
	      // Move l1 to the front of L and reconnect the truncated list L.
	      if (L.head) l1.next = L.head, L.head = l1;
	      else l1.next = null, L.head = L.tail = l1;
	      l0 = L.tail, l0.next = l2;
	
	    } else {
	      l0 = l1;
	    }
	    l1 = l2;
	  }
	
	  L.tail = l0;
	  return circle;
	}
	
	function enclose1(a) {
	  return {
	    x: a.x,
	    y: a.y,
	    r: a.r
	  };
	}
	
	function enclose2(a, b) {
	  var x1 = a.x, y1 = a.y, r1 = a.r,
	      x2 = b.x, y2 = b.y, r2 = b.r,
	      x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1,
	      l = Math.sqrt(x21 * x21 + y21 * y21);
	  return {
	    x: (x1 + x2 + x21 / l * r21) / 2,
	    y: (y1 + y2 + y21 / l * r21) / 2,
	    r: (l + r1 + r2) / 2
	  };
	}
	
	function enclose3(a, b, c) {
	  var x1 = a.x, y1 = a.y, r1 = a.r,
	      x2 = b.x, y2 = b.y, r2 = b.r,
	      x3 = c.x, y3 = c.y, r3 = c.r,
	      a2 = 2 * (x1 - x2),
	      b2 = 2 * (y1 - y2),
	      c2 = 2 * (r2 - r1),
	      d2 = x1 * x1 + y1 * y1 - r1 * r1 - x2 * x2 - y2 * y2 + r2 * r2,
	      a3 = 2 * (x1 - x3),
	      b3 = 2 * (y1 - y3),
	      c3 = 2 * (r3 - r1),
	      d3 = x1 * x1 + y1 * y1 - r1 * r1 - x3 * x3 - y3 * y3 + r3 * r3,
	      ab = a3 * b2 - a2 * b3,
	      xa = (b2 * d3 - b3 * d2) / ab - x1,
	      xb = (b3 * c2 - b2 * c3) / ab,
	      ya = (a3 * d2 - a2 * d3) / ab - y1,
	      yb = (a2 * c3 - a3 * c2) / ab,
	      A = xb * xb + yb * yb - 1,
	      B = 2 * (xa * xb + ya * yb + r1),
	      C = xa * xa + ya * ya - r1 * r1,
	      r = (-B - Math.sqrt(B * B - 4 * A * C)) / (2 * A);
	  return {
	    x: xa + xb * r + x1,
	    y: ya + yb * r + y1,
	    r: r
	  };
	}
	
	function place(a, b, c) {
	  var ax = a.x,
	      ay = a.y,
	      da = b.r + c.r,
	      db = a.r + c.r,
	      dx = b.x - ax,
	      dy = b.y - ay,
	      dc = dx * dx + dy * dy;
	  if (dc) {
	    var x = 0.5 + ((db *= db) - (da *= da)) / (2 * dc),
	        y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
	    c.x = ax + x * dx + y * dy;
	    c.y = ay + x * dy - y * dx;
	  } else {
	    c.x = ax + db;
	    c.y = ay;
	  }
	}
	
	function intersects(a, b) {
	  var dx = b.x - a.x,
	      dy = b.y - a.y,
	      dr = a.r + b.r;
	  return dr * dr > dx * dx + dy * dy;
	}
	
	function distance2(circle, x, y) {
	  var dx = circle.x - x,
	      dy = circle.y - y;
	  return dx * dx + dy * dy;
	}
	
	function Node$1(circle) {
	  this._ = circle;
	  this.next = null;
	  this.previous = null;
	}
	
	function packEnclose(circles) {
	  if (!(n = circles.length)) return 0;
	
	  var a, b, c, n;
	
	  // Place the first circle.
	  a = circles[0], a.x = 0, a.y = 0;
	  if (!(n > 1)) return a.r;
	
	  // Place the second circle.
	  b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
	  if (!(n > 2)) return a.r + b.r;
	
	  // Place the third circle.
	  place(b, a, c = circles[2]);
	
	  // Initialize the weighted centroid.
	  var aa = a.r * a.r,
	      ba = b.r * b.r,
	      ca = c.r * c.r,
	      oa = aa + ba + ca,
	      ox = aa * a.x + ba * b.x + ca * c.x,
	      oy = aa * a.y + ba * b.y + ca * c.y,
	      cx, cy, i, j, k, sj, sk;
	
	  // Initialize the front-chain using the first three circles a, b and c.
	  a = new Node$1(a), b = new Node$1(b), c = new Node$1(c);
	  a.next = c.previous = b;
	  b.next = a.previous = c;
	  c.next = b.previous = a;
	
	  // Attempt to place each remaining circle…
	  pack: for (i = 3; i < n; ++i) {
	    place(a._, b._, c = circles[i]), c = new Node$1(c);
	
	    // If there are only three elements in the front-chain…
	    if ((k = a.previous) === (j = b.next)) {
	      // If the new circle intersects the third circle,
	      // rotate the front chain to try the next position.
	      if (intersects(j._, c._)) {
	        a = b, b = j, --i;
	        continue pack;
	      }
	    }
	
	    // Find the closest intersecting circle on the front-chain, if any.
	    else {
	      sj = j._.r, sk = k._.r;
	      do {
	        if (sj <= sk) {
	          if (intersects(j._, c._)) {
	            b = j, a.next = b, b.previous = a, --i;
	            continue pack;
	          }
	          j = j.next, sj += j._.r;
	        } else {
	          if (intersects(k._, c._)) {
	            a = k, a.next = b, b.previous = a, --i;
	            continue pack;
	          }
	          k = k.previous, sk += k._.r;
	        }
	      } while (j !== k.next);
	    }
	
	    // Success! Insert the new circle c between a and b.
	    c.previous = a, c.next = b, a.next = b.previous = b = c;
	
	    // Update the weighted centroid.
	    oa += ca = c._.r * c._.r;
	    ox += ca * c._.x;
	    oy += ca * c._.y;
	
	    // Compute the new closest circle a to centroid.
	    aa = distance2(a._, cx = ox / oa, cy = oy / oa);
	    while ((c = c.next) !== b) {
	      if ((ca = distance2(c._, cx, cy)) < aa) {
	        a = c, aa = ca;
	      }
	    }
	    b = a.next;
	  }
	
	  // Compute the enclosing circle of the front chain.
	  a = [b._], c = b; while ((c = c.next) !== b) a.push(c._); c = enclose(a);
	
	  // Translate the circles to put the enclosing circle around the origin.
	  for (i = 0; i < n; ++i) a = circles[i], a.x -= c.x, a.y -= c.y;
	
	  return c.r;
	}
	
	var siblings = function(circles) {
	  packEnclose(circles);
	  return circles;
	};
	
	function optional(f) {
	  return f == null ? null : required(f);
	}
	
	function required(f) {
	  if (typeof f !== "function") throw new Error;
	  return f;
	}
	
	function constantZero() {
	  return 0;
	}
	
	var constant$6 = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function defaultRadius(d) {
	  return Math.sqrt(d.value);
	}
	
	var index = function() {
	  var radius = null,
	      dx = 1,
	      dy = 1,
	      padding = constantZero;
	
	  function pack(root) {
	    root.x = dx / 2, root.y = dy / 2;
	    if (radius) {
	      root.eachBefore(radiusLeaf(radius))
	          .eachAfter(packChildren(padding, 0.5))
	          .eachBefore(translateChild(1));
	    } else {
	      root.eachBefore(radiusLeaf(defaultRadius))
	          .eachAfter(packChildren(constantZero, 1))
	          .eachAfter(packChildren(padding, root.r / Math.min(dx, dy)))
	          .eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
	    }
	    return root;
	  }
	
	  pack.radius = function(x) {
	    return arguments.length ? (radius = optional(x), pack) : radius;
	  };
	
	  pack.size = function(x) {
	    return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [dx, dy];
	  };
	
	  pack.padding = function(x) {
	    return arguments.length ? (padding = typeof x === "function" ? x : constant$6(+x), pack) : padding;
	  };
	
	  return pack;
	};
	
	function radiusLeaf(radius) {
	  return function(node) {
	    if (!node.children) {
	      node.r = Math.max(0, +radius(node) || 0);
	    }
	  };
	}
	
	function packChildren(padding, k) {
	  return function(node) {
	    if (children = node.children) {
	      var children,
	          i,
	          n = children.length,
	          r = padding(node) * k || 0,
	          e;
	
	      if (r) for (i = 0; i < n; ++i) children[i].r += r;
	      e = packEnclose(children);
	      if (r) for (i = 0; i < n; ++i) children[i].r -= r;
	      node.r = e + r;
	    }
	  };
	}
	
	function translateChild(k) {
	  return function(node) {
	    var parent = node.parent;
	    node.r *= k;
	    if (parent) {
	      node.x = parent.x + k * node.x;
	      node.y = parent.y + k * node.y;
	    }
	  };
	}
	
	var roundNode = function(node) {
	  node.x0 = Math.round(node.x0);
	  node.y0 = Math.round(node.y0);
	  node.x1 = Math.round(node.x1);
	  node.y1 = Math.round(node.y1);
	};
	
	var treemapDice = function(parent, x0, y0, x1, y1) {
	  var nodes = parent.children,
	      node,
	      i = -1,
	      n = nodes.length,
	      k = parent.value && (x1 - x0) / parent.value;
	
	  while (++i < n) {
	    node = nodes[i], node.y0 = y0, node.y1 = y1;
	    node.x0 = x0, node.x1 = x0 += node.value * k;
	  }
	};
	
	var partition = function() {
	  var dx = 1,
	      dy = 1,
	      padding = 0,
	      round = false;
	
	  function partition(root) {
	    var n = root.height + 1;
	    root.x0 =
	    root.y0 = padding;
	    root.x1 = dx;
	    root.y1 = dy / n;
	    root.eachBefore(positionNode(dy, n));
	    if (round) root.eachBefore(roundNode);
	    return root;
	  }
	
	  function positionNode(dy, n) {
	    return function(node) {
	      if (node.children) {
	        treemapDice(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
	      }
	      var x0 = node.x0,
	          y0 = node.y0,
	          x1 = node.x1 - padding,
	          y1 = node.y1 - padding;
	      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
	      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
	      node.x0 = x0;
	      node.y0 = y0;
	      node.x1 = x1;
	      node.y1 = y1;
	    };
	  }
	
	  partition.round = function(x) {
	    return arguments.length ? (round = !!x, partition) : round;
	  };
	
	  partition.size = function(x) {
	    return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [dx, dy];
	  };
	
	  partition.padding = function(x) {
	    return arguments.length ? (padding = +x, partition) : padding;
	  };
	
	  return partition;
	};
	
	var keyPrefix$1 = "$";
	var preroot = {depth: -1};
	var ambiguous = {};
	
	function defaultId(d) {
	  return d.id;
	}
	
	function defaultParentId(d) {
	  return d.parentId;
	}
	
	var stratify = function() {
	  var id = defaultId,
	      parentId = defaultParentId;
	
	  function stratify(data) {
	    var d,
	        i,
	        n = data.length,
	        root,
	        parent,
	        node,
	        nodes = new Array(n),
	        nodeId,
	        nodeKey,
	        nodeByKey = {};
	
	    for (i = 0; i < n; ++i) {
	      d = data[i], node = nodes[i] = new Node(d);
	      if ((nodeId = id(d, i, data)) != null && (nodeId += "")) {
	        nodeKey = keyPrefix$1 + (node.id = nodeId);
	        nodeByKey[nodeKey] = nodeKey in nodeByKey ? ambiguous : node;
	      }
	    }
	
	    for (i = 0; i < n; ++i) {
	      node = nodes[i], nodeId = parentId(data[i], i, data);
	      if (nodeId == null || !(nodeId += "")) {
	        if (root) throw new Error("multiple roots");
	        root = node;
	      } else {
	        parent = nodeByKey[keyPrefix$1 + nodeId];
	        if (!parent) throw new Error("missing: " + nodeId);
	        if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
	        if (parent.children) parent.children.push(node);
	        else parent.children = [node];
	        node.parent = parent;
	      }
	    }
	
	    if (!root) throw new Error("no root");
	    root.parent = preroot;
	    root.eachBefore(function(node) { node.depth = node.parent.depth + 1; --n; }).eachBefore(computeHeight);
	    root.parent = null;
	    if (n > 0) throw new Error("cycle");
	
	    return root;
	  }
	
	  stratify.id = function(x) {
	    return arguments.length ? (id = required(x), stratify) : id;
	  };
	
	  stratify.parentId = function(x) {
	    return arguments.length ? (parentId = required(x), stratify) : parentId;
	  };
	
	  return stratify;
	};
	
	function defaultSeparation$1(a, b) {
	  return a.parent === b.parent ? 1 : 2;
	}
	
	// function radialSeparation(a, b) {
	//   return (a.parent === b.parent ? 1 : 2) / a.depth;
	// }
	
	// This function is used to traverse the left contour of a subtree (or
	// subforest). It returns the successor of v on this contour. This successor is
	// either given by the leftmost child of v or by the thread of v. The function
	// returns null if and only if v is on the highest level of its subtree.
	function nextLeft(v) {
	  var children = v.children;
	  return children ? children[0] : v.t;
	}
	
	// This function works analogously to nextLeft.
	function nextRight(v) {
	  var children = v.children;
	  return children ? children[children.length - 1] : v.t;
	}
	
	// Shifts the current subtree rooted at w+. This is done by increasing
	// prelim(w+) and mod(w+) by shift.
	function moveSubtree(wm, wp, shift) {
	  var change = shift / (wp.i - wm.i);
	  wp.c -= change;
	  wp.s += shift;
	  wm.c += change;
	  wp.z += shift;
	  wp.m += shift;
	}
	
	// All other shifts, applied to the smaller subtrees between w- and w+, are
	// performed by this function. To prepare the shifts, we have to adjust
	// change(w+), shift(w+), and change(w-).
	function executeShifts(v) {
	  var shift = 0,
	      change = 0,
	      children = v.children,
	      i = children.length,
	      w;
	  while (--i >= 0) {
	    w = children[i];
	    w.z += shift;
	    w.m += shift;
	    shift += w.s + (change += w.c);
	  }
	}
	
	// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
	// returns the specified (default) ancestor.
	function nextAncestor(vim, v, ancestor) {
	  return vim.a.parent === v.parent ? vim.a : ancestor;
	}
	
	function TreeNode(node, i) {
	  this._ = node;
	  this.parent = null;
	  this.children = null;
	  this.A = null; // default ancestor
	  this.a = this; // ancestor
	  this.z = 0; // prelim
	  this.m = 0; // mod
	  this.c = 0; // change
	  this.s = 0; // shift
	  this.t = null; // thread
	  this.i = i; // number
	}
	
	TreeNode.prototype = Object.create(Node.prototype);
	
	function treeRoot(root) {
	  var tree = new TreeNode(root, 0),
	      node,
	      nodes = [tree],
	      child,
	      children,
	      i,
	      n;
	
	  while (node = nodes.pop()) {
	    if (children = node._.children) {
	      node.children = new Array(n = children.length);
	      for (i = n - 1; i >= 0; --i) {
	        nodes.push(child = node.children[i] = new TreeNode(children[i], i));
	        child.parent = node;
	      }
	    }
	  }
	
	  (tree.parent = new TreeNode(null, 0)).children = [tree];
	  return tree;
	}
	
	// Node-link tree diagram using the Reingold-Tilford "tidy" algorithm
	var tree = function() {
	  var separation = defaultSeparation$1,
	      dx = 1,
	      dy = 1,
	      nodeSize = null;
	
	  function tree(root) {
	    var t = treeRoot(root);
	
	    // Compute the layout using Buchheim et al.’s algorithm.
	    t.eachAfter(firstWalk), t.parent.m = -t.z;
	    t.eachBefore(secondWalk);
	
	    // If a fixed node size is specified, scale x and y.
	    if (nodeSize) root.eachBefore(sizeNode);
	
	    // If a fixed tree size is specified, scale x and y based on the extent.
	    // Compute the left-most, right-most, and depth-most nodes for extents.
	    else {
	      var left = root,
	          right = root,
	          bottom = root;
	      root.eachBefore(function(node) {
	        if (node.x < left.x) left = node;
	        if (node.x > right.x) right = node;
	        if (node.depth > bottom.depth) bottom = node;
	      });
	      var s = left === right ? 1 : separation(left, right) / 2,
	          tx = s - left.x,
	          kx = dx / (right.x + s + tx),
	          ky = dy / (bottom.depth || 1);
	      root.eachBefore(function(node) {
	        node.x = (node.x + tx) * kx;
	        node.y = node.depth * ky;
	      });
	    }
	
	    return root;
	  }
	
	  // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
	  // applied recursively to the children of v, as well as the function
	  // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
	  // node v is placed to the midpoint of its outermost children.
	  function firstWalk(v) {
	    var children = v.children,
	        siblings = v.parent.children,
	        w = v.i ? siblings[v.i - 1] : null;
	    if (children) {
	      executeShifts(v);
	      var midpoint = (children[0].z + children[children.length - 1].z) / 2;
	      if (w) {
	        v.z = w.z + separation(v._, w._);
	        v.m = v.z - midpoint;
	      } else {
	        v.z = midpoint;
	      }
	    } else if (w) {
	      v.z = w.z + separation(v._, w._);
	    }
	    v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
	  }
	
	  // Computes all real x-coordinates by summing up the modifiers recursively.
	  function secondWalk(v) {
	    v._.x = v.z + v.parent.m;
	    v.m += v.parent.m;
	  }
	
	  // The core of the algorithm. Here, a new subtree is combined with the
	  // previous subtrees. Threads are used to traverse the inside and outside
	  // contours of the left and right subtree up to the highest common level. The
	  // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
	  // superscript o means outside and i means inside, the subscript - means left
	  // subtree and + means right subtree. For summing up the modifiers along the
	  // contour, we use respective variables si+, si-, so-, and so+. Whenever two
	  // nodes of the inside contours conflict, we compute the left one of the
	  // greatest uncommon ancestors using the function ANCESTOR and call MOVE
	  // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
	  // Finally, we add a new thread (if necessary).
	  function apportion(v, w, ancestor) {
	    if (w) {
	      var vip = v,
	          vop = v,
	          vim = w,
	          vom = vip.parent.children[0],
	          sip = vip.m,
	          sop = vop.m,
	          sim = vim.m,
	          som = vom.m,
	          shift;
	      while (vim = nextRight(vim), vip = nextLeft(vip), vim && vip) {
	        vom = nextLeft(vom);
	        vop = nextRight(vop);
	        vop.a = v;
	        shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
	        if (shift > 0) {
	          moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
	          sip += shift;
	          sop += shift;
	        }
	        sim += vim.m;
	        sip += vip.m;
	        som += vom.m;
	        sop += vop.m;
	      }
	      if (vim && !nextRight(vop)) {
	        vop.t = vim;
	        vop.m += sim - sop;
	      }
	      if (vip && !nextLeft(vom)) {
	        vom.t = vip;
	        vom.m += sip - som;
	        ancestor = v;
	      }
	    }
	    return ancestor;
	  }
	
	  function sizeNode(node) {
	    node.x *= dx;
	    node.y = node.depth * dy;
	  }
	
	  tree.separation = function(x) {
	    return arguments.length ? (separation = x, tree) : separation;
	  };
	
	  tree.size = function(x) {
	    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : (nodeSize ? null : [dx, dy]);
	  };
	
	  tree.nodeSize = function(x) {
	    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : (nodeSize ? [dx, dy] : null);
	  };
	
	  return tree;
	};
	
	var treemapSlice = function(parent, x0, y0, x1, y1) {
	  var nodes = parent.children,
	      node,
	      i = -1,
	      n = nodes.length,
	      k = parent.value && (y1 - y0) / parent.value;
	
	  while (++i < n) {
	    node = nodes[i], node.x0 = x0, node.x1 = x1;
	    node.y0 = y0, node.y1 = y0 += node.value * k;
	  }
	};
	
	var phi = (1 + Math.sqrt(5)) / 2;
	
	function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
	  var rows = [],
	      nodes = parent.children,
	      row,
	      nodeValue,
	      i0 = 0,
	      i1 = 0,
	      n = nodes.length,
	      dx, dy,
	      value = parent.value,
	      sumValue,
	      minValue,
	      maxValue,
	      newRatio,
	      minRatio,
	      alpha,
	      beta;
	
	  while (i0 < n) {
	    dx = x1 - x0, dy = y1 - y0;
	
	    // Find the next non-empty node.
	    do sumValue = nodes[i1++].value; while (!sumValue && i1 < n);
	    minValue = maxValue = sumValue;
	    alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
	    beta = sumValue * sumValue * alpha;
	    minRatio = Math.max(maxValue / beta, beta / minValue);
	
	    // Keep adding nodes while the aspect ratio maintains or improves.
	    for (; i1 < n; ++i1) {
	      sumValue += nodeValue = nodes[i1].value;
	      if (nodeValue < minValue) minValue = nodeValue;
	      if (nodeValue > maxValue) maxValue = nodeValue;
	      beta = sumValue * sumValue * alpha;
	      newRatio = Math.max(maxValue / beta, beta / minValue);
	      if (newRatio > minRatio) { sumValue -= nodeValue; break; }
	      minRatio = newRatio;
	    }
	
	    // Position and record the row orientation.
	    rows.push(row = {value: sumValue, dice: dx < dy, children: nodes.slice(i0, i1)});
	    if (row.dice) treemapDice(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
	    else treemapSlice(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
	    value -= sumValue, i0 = i1;
	  }
	
	  return rows;
	}
	
	var squarify = (function custom(ratio) {
	
	  function squarify(parent, x0, y0, x1, y1) {
	    squarifyRatio(ratio, parent, x0, y0, x1, y1);
	  }
	
	  squarify.ratio = function(x) {
	    return custom((x = +x) > 1 ? x : 1);
	  };
	
	  return squarify;
	})(phi);
	
	var index$1 = function() {
	  var tile = squarify,
	      round = false,
	      dx = 1,
	      dy = 1,
	      paddingStack = [0],
	      paddingInner = constantZero,
	      paddingTop = constantZero,
	      paddingRight = constantZero,
	      paddingBottom = constantZero,
	      paddingLeft = constantZero;
	
	  function treemap(root) {
	    root.x0 =
	    root.y0 = 0;
	    root.x1 = dx;
	    root.y1 = dy;
	    root.eachBefore(positionNode);
	    paddingStack = [0];
	    if (round) root.eachBefore(roundNode);
	    return root;
	  }
	
	  function positionNode(node) {
	    var p = paddingStack[node.depth],
	        x0 = node.x0 + p,
	        y0 = node.y0 + p,
	        x1 = node.x1 - p,
	        y1 = node.y1 - p;
	    if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
	    if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
	    node.x0 = x0;
	    node.y0 = y0;
	    node.x1 = x1;
	    node.y1 = y1;
	    if (node.children) {
	      p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
	      x0 += paddingLeft(node) - p;
	      y0 += paddingTop(node) - p;
	      x1 -= paddingRight(node) - p;
	      y1 -= paddingBottom(node) - p;
	      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
	      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
	      tile(node, x0, y0, x1, y1);
	    }
	  }
	
	  treemap.round = function(x) {
	    return arguments.length ? (round = !!x, treemap) : round;
	  };
	
	  treemap.size = function(x) {
	    return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [dx, dy];
	  };
	
	  treemap.tile = function(x) {
	    return arguments.length ? (tile = required(x), treemap) : tile;
	  };
	
	  treemap.padding = function(x) {
	    return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
	  };
	
	  treemap.paddingInner = function(x) {
	    return arguments.length ? (paddingInner = typeof x === "function" ? x : constant$6(+x), treemap) : paddingInner;
	  };
	
	  treemap.paddingOuter = function(x) {
	    return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
	  };
	
	  treemap.paddingTop = function(x) {
	    return arguments.length ? (paddingTop = typeof x === "function" ? x : constant$6(+x), treemap) : paddingTop;
	  };
	
	  treemap.paddingRight = function(x) {
	    return arguments.length ? (paddingRight = typeof x === "function" ? x : constant$6(+x), treemap) : paddingRight;
	  };
	
	  treemap.paddingBottom = function(x) {
	    return arguments.length ? (paddingBottom = typeof x === "function" ? x : constant$6(+x), treemap) : paddingBottom;
	  };
	
	  treemap.paddingLeft = function(x) {
	    return arguments.length ? (paddingLeft = typeof x === "function" ? x : constant$6(+x), treemap) : paddingLeft;
	  };
	
	  return treemap;
	};
	
	var binary = function(parent, x0, y0, x1, y1) {
	  var nodes = parent.children,
	      i, n = nodes.length,
	      sum, sums = new Array(n + 1);
	
	  for (sums[0] = sum = i = 0; i < n; ++i) {
	    sums[i + 1] = sum += nodes[i].value;
	  }
	
	  partition(0, n, parent.value, x0, y0, x1, y1);
	
	  function partition(i, j, value, x0, y0, x1, y1) {
	    if (i >= j - 1) {
	      var node = nodes[i];
	      node.x0 = x0, node.y0 = y0;
	      node.x1 = x1, node.y1 = y1;
	      return;
	    }
	
	    var valueOffset = sums[i],
	        valueTarget = (value / 2) + valueOffset,
	        k = i + 1,
	        hi = j - 1;
	
	    while (k < hi) {
	      var mid = k + hi >>> 1;
	      if (sums[mid] < valueTarget) k = mid + 1;
	      else hi = mid;
	    }
	
	    var valueLeft = sums[k] - valueOffset,
	        valueRight = value - valueLeft;
	
	    if ((y1 - y0) > (x1 - x0)) {
	      var yk = (y0 * valueRight + y1 * valueLeft) / value;
	      partition(i, k, valueLeft, x0, y0, x1, yk);
	      partition(k, j, valueRight, x0, yk, x1, y1);
	    } else {
	      var xk = (x0 * valueRight + x1 * valueLeft) / value;
	      partition(i, k, valueLeft, x0, y0, xk, y1);
	      partition(k, j, valueRight, xk, y0, x1, y1);
	    }
	  }
	};
	
	var sliceDice = function(parent, x0, y0, x1, y1) {
	  (parent.depth & 1 ? treemapSlice : treemapDice)(parent, x0, y0, x1, y1);
	};
	
	var resquarify = (function custom(ratio) {
	
	  function resquarify(parent, x0, y0, x1, y1) {
	    if ((rows = parent._squarify) && (rows.ratio === ratio)) {
	      var rows,
	          row,
	          nodes,
	          i,
	          j = -1,
	          n,
	          m = rows.length,
	          value = parent.value;
	
	      while (++j < m) {
	        row = rows[j], nodes = row.children;
	        for (i = row.value = 0, n = nodes.length; i < n; ++i) row.value += nodes[i].value;
	        if (row.dice) treemapDice(row, x0, y0, x1, y0 += (y1 - y0) * row.value / value);
	        else treemapSlice(row, x0, y0, x0 += (x1 - x0) * row.value / value, y1);
	        value -= row.value;
	      }
	    } else {
	      parent._squarify = rows = squarifyRatio(ratio, parent, x0, y0, x1, y1);
	      rows.ratio = ratio;
	    }
	  }
	
	  resquarify.ratio = function(x) {
	    return custom((x = +x) > 1 ? x : 1);
	  };
	
	  return resquarify;
	})(phi);
	
	var center$1 = function(x, y) {
	  var nodes;
	
	  if (x == null) x = 0;
	  if (y == null) y = 0;
	
	  function force() {
	    var i,
	        n = nodes.length,
	        node,
	        sx = 0,
	        sy = 0;
	
	    for (i = 0; i < n; ++i) {
	      node = nodes[i], sx += node.x, sy += node.y;
	    }
	
	    for (sx = sx / n - x, sy = sy / n - y, i = 0; i < n; ++i) {
	      node = nodes[i], node.x -= sx, node.y -= sy;
	    }
	  }
	
	  force.initialize = function(_) {
	    nodes = _;
	  };
	
	  force.x = function(_) {
	    return arguments.length ? (x = +_, force) : x;
	  };
	
	  force.y = function(_) {
	    return arguments.length ? (y = +_, force) : y;
	  };
	
	  return force;
	};
	
	var constant$7 = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var jiggle = function() {
	  return (Math.random() - 0.5) * 1e-6;
	};
	
	function x$1(d) {
	  return d.x + d.vx;
	}
	
	function y$1(d) {
	  return d.y + d.vy;
	}
	
	var collide = function(radius) {
	  var nodes,
	      radii,
	      strength = 1,
	      iterations = 1;
	
	  if (typeof radius !== "function") radius = constant$7(radius == null ? 1 : +radius);
	
	  function force() {
	    var i, n = nodes.length,
	        tree,
	        node,
	        xi,
	        yi,
	        ri,
	        ri2;
	
	    for (var k = 0; k < iterations; ++k) {
	      tree = quadtree(nodes, x$1, y$1).visitAfter(prepare);
	      for (i = 0; i < n; ++i) {
	        node = nodes[i];
	        ri = radii[node.index], ri2 = ri * ri;
	        xi = node.x + node.vx;
	        yi = node.y + node.vy;
	        tree.visit(apply);
	      }
	    }
	
	    function apply(quad, x0, y0, x1, y1) {
	      var data = quad.data, rj = quad.r, r = ri + rj;
	      if (data) {
	        if (data.index > node.index) {
	          var x = xi - data.x - data.vx,
	              y = yi - data.y - data.vy,
	              l = x * x + y * y;
	          if (l < r * r) {
	            if (x === 0) x = jiggle(), l += x * x;
	            if (y === 0) y = jiggle(), l += y * y;
	            l = (r - (l = Math.sqrt(l))) / l * strength;
	            node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
	            node.vy += (y *= l) * r;
	            data.vx -= x * (r = 1 - r);
	            data.vy -= y * r;
	          }
	        }
	        return;
	      }
	      return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
	    }
	  }
	
	  function prepare(quad) {
	    if (quad.data) return quad.r = radii[quad.data.index];
	    for (var i = quad.r = 0; i < 4; ++i) {
	      if (quad[i] && quad[i].r > quad.r) {
	        quad.r = quad[i].r;
	      }
	    }
	  }
	
	  function initialize() {
	    if (!nodes) return;
	    var i, n = nodes.length, node;
	    radii = new Array(n);
	    for (i = 0; i < n; ++i) node = nodes[i], radii[node.index] = +radius(node, i, nodes);
	  }
	
	  force.initialize = function(_) {
	    nodes = _;
	    initialize();
	  };
	
	  force.iterations = function(_) {
	    return arguments.length ? (iterations = +_, force) : iterations;
	  };
	
	  force.strength = function(_) {
	    return arguments.length ? (strength = +_, force) : strength;
	  };
	
	  force.radius = function(_) {
	    return arguments.length ? (radius = typeof _ === "function" ? _ : constant$7(+_), initialize(), force) : radius;
	  };
	
	  return force;
	};
	
	function index$2(d) {
	  return d.index;
	}
	
	function find(nodeById, nodeId) {
	  var node = nodeById.get(nodeId);
	  if (!node) throw new Error("missing: " + nodeId);
	  return node;
	}
	
	var link = function(links) {
	  var id = index$2,
	      strength = defaultStrength,
	      strengths,
	      distance = constant$7(30),
	      distances,
	      nodes,
	      count,
	      bias,
	      iterations = 1;
	
	  if (links == null) links = [];
	
	  function defaultStrength(link) {
	    return 1 / Math.min(count[link.source.index], count[link.target.index]);
	  }
	
	  function force(alpha) {
	    for (var k = 0, n = links.length; k < iterations; ++k) {
	      for (var i = 0, link, source, target, x, y, l, b; i < n; ++i) {
	        link = links[i], source = link.source, target = link.target;
	        x = target.x + target.vx - source.x - source.vx || jiggle();
	        y = target.y + target.vy - source.y - source.vy || jiggle();
	        l = Math.sqrt(x * x + y * y);
	        l = (l - distances[i]) / l * alpha * strengths[i];
	        x *= l, y *= l;
	        target.vx -= x * (b = bias[i]);
	        target.vy -= y * b;
	        source.vx += x * (b = 1 - b);
	        source.vy += y * b;
	      }
	    }
	  }
	
	  function initialize() {
	    if (!nodes) return;
	
	    var i,
	        n = nodes.length,
	        m = links.length,
	        nodeById = map$1(nodes, id),
	        link;
	
	    for (i = 0, count = new Array(n); i < m; ++i) {
	      link = links[i], link.index = i;
	      if (typeof link.source !== "object") link.source = find(nodeById, link.source);
	      if (typeof link.target !== "object") link.target = find(nodeById, link.target);
	      count[link.source.index] = (count[link.source.index] || 0) + 1;
	      count[link.target.index] = (count[link.target.index] || 0) + 1;
	    }
	
	    for (i = 0, bias = new Array(m); i < m; ++i) {
	      link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
	    }
	
	    strengths = new Array(m), initializeStrength();
	    distances = new Array(m), initializeDistance();
	  }
	
	  function initializeStrength() {
	    if (!nodes) return;
	
	    for (var i = 0, n = links.length; i < n; ++i) {
	      strengths[i] = +strength(links[i], i, links);
	    }
	  }
	
	  function initializeDistance() {
	    if (!nodes) return;
	
	    for (var i = 0, n = links.length; i < n; ++i) {
	      distances[i] = +distance(links[i], i, links);
	    }
	  }
	
	  force.initialize = function(_) {
	    nodes = _;
	    initialize();
	  };
	
	  force.links = function(_) {
	    return arguments.length ? (links = _, initialize(), force) : links;
	  };
	
	  force.id = function(_) {
	    return arguments.length ? (id = _, force) : id;
	  };
	
	  force.iterations = function(_) {
	    return arguments.length ? (iterations = +_, force) : iterations;
	  };
	
	  force.strength = function(_) {
	    return arguments.length ? (strength = typeof _ === "function" ? _ : constant$7(+_), initializeStrength(), force) : strength;
	  };
	
	  force.distance = function(_) {
	    return arguments.length ? (distance = typeof _ === "function" ? _ : constant$7(+_), initializeDistance(), force) : distance;
	  };
	
	  return force;
	};
	
	function x$2(d) {
	  return d.x;
	}
	
	function y$2(d) {
	  return d.y;
	}
	
	var initialRadius = 10;
	var initialAngle = Math.PI * (3 - Math.sqrt(5));
	
	var simulation = function(nodes) {
	  var simulation,
	      alpha = 1,
	      alphaMin = 0.001,
	      alphaDecay = 1 - Math.pow(alphaMin, 1 / 300),
	      alphaTarget = 0,
	      velocityDecay = 0.6,
	      forces = map$1(),
	      stepper = timer(step),
	      event = dispatch("tick", "end");
	
	  if (nodes == null) nodes = [];
	
	  function step() {
	    tick();
	    event.call("tick", simulation);
	    if (alpha < alphaMin) {
	      stepper.stop();
	      event.call("end", simulation);
	    }
	  }
	
	  function tick() {
	    var i, n = nodes.length, node;
	
	    alpha += (alphaTarget - alpha) * alphaDecay;
	
	    forces.each(function(force) {
	      force(alpha);
	    });
	
	    for (i = 0; i < n; ++i) {
	      node = nodes[i];
	      if (node.fx == null) node.x += node.vx *= velocityDecay;
	      else node.x = node.fx, node.vx = 0;
	      if (node.fy == null) node.y += node.vy *= velocityDecay;
	      else node.y = node.fy, node.vy = 0;
	    }
	  }
	
	  function initializeNodes() {
	    for (var i = 0, n = nodes.length, node; i < n; ++i) {
	      node = nodes[i], node.index = i;
	      if (isNaN(node.x) || isNaN(node.y)) {
	        var radius = initialRadius * Math.sqrt(i), angle = i * initialAngle;
	        node.x = radius * Math.cos(angle);
	        node.y = radius * Math.sin(angle);
	      }
	      if (isNaN(node.vx) || isNaN(node.vy)) {
	        node.vx = node.vy = 0;
	      }
	    }
	  }
	
	  function initializeForce(force) {
	    if (force.initialize) force.initialize(nodes);
	    return force;
	  }
	
	  initializeNodes();
	
	  return simulation = {
	    tick: tick,
	
	    restart: function() {
	      return stepper.restart(step), simulation;
	    },
	
	    stop: function() {
	      return stepper.stop(), simulation;
	    },
	
	    nodes: function(_) {
	      return arguments.length ? (nodes = _, initializeNodes(), forces.each(initializeForce), simulation) : nodes;
	    },
	
	    alpha: function(_) {
	      return arguments.length ? (alpha = +_, simulation) : alpha;
	    },
	
	    alphaMin: function(_) {
	      return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
	    },
	
	    alphaDecay: function(_) {
	      return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
	    },
	
	    alphaTarget: function(_) {
	      return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
	    },
	
	    velocityDecay: function(_) {
	      return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
	    },
	
	    force: function(name, _) {
	      return arguments.length > 1 ? ((_ == null ? forces.remove(name) : forces.set(name, initializeForce(_))), simulation) : forces.get(name);
	    },
	
	    find: function(x, y, radius) {
	      var i = 0,
	          n = nodes.length,
	          dx,
	          dy,
	          d2,
	          node,
	          closest;
	
	      if (radius == null) radius = Infinity;
	      else radius *= radius;
	
	      for (i = 0; i < n; ++i) {
	        node = nodes[i];
	        dx = x - node.x;
	        dy = y - node.y;
	        d2 = dx * dx + dy * dy;
	        if (d2 < radius) closest = node, radius = d2;
	      }
	
	      return closest;
	    },
	
	    on: function(name, _) {
	      return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
	    }
	  };
	};
	
	var manyBody = function() {
	  var nodes,
	      node,
	      alpha,
	      strength = constant$7(-30),
	      strengths,
	      distanceMin2 = 1,
	      distanceMax2 = Infinity,
	      theta2 = 0.81;
	
	  function force(_) {
	    var i, n = nodes.length, tree = quadtree(nodes, x$2, y$2).visitAfter(accumulate);
	    for (alpha = _, i = 0; i < n; ++i) node = nodes[i], tree.visit(apply);
	  }
	
	  function initialize() {
	    if (!nodes) return;
	    var i, n = nodes.length, node;
	    strengths = new Array(n);
	    for (i = 0; i < n; ++i) node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
	  }
	
	  function accumulate(quad) {
	    var strength = 0, q, c, x$$1, y$$1, i;
	
	    // For internal nodes, accumulate forces from child quadrants.
	    if (quad.length) {
	      for (x$$1 = y$$1 = i = 0; i < 4; ++i) {
	        if ((q = quad[i]) && (c = q.value)) {
	          strength += c, x$$1 += c * q.x, y$$1 += c * q.y;
	        }
	      }
	      quad.x = x$$1 / strength;
	      quad.y = y$$1 / strength;
	    }
	
	    // For leaf nodes, accumulate forces from coincident quadrants.
	    else {
	      q = quad;
	      q.x = q.data.x;
	      q.y = q.data.y;
	      do strength += strengths[q.data.index];
	      while (q = q.next);
	    }
	
	    quad.value = strength;
	  }
	
	  function apply(quad, x1, _, x2) {
	    if (!quad.value) return true;
	
	    var x$$1 = quad.x - node.x,
	        y$$1 = quad.y - node.y,
	        w = x2 - x1,
	        l = x$$1 * x$$1 + y$$1 * y$$1;
	
	    // Apply the Barnes-Hut approximation if possible.
	    // Limit forces for very close nodes; randomize direction if coincident.
	    if (w * w / theta2 < l) {
	      if (l < distanceMax2) {
	        if (x$$1 === 0) x$$1 = jiggle(), l += x$$1 * x$$1;
	        if (y$$1 === 0) y$$1 = jiggle(), l += y$$1 * y$$1;
	        if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
	        node.vx += x$$1 * quad.value * alpha / l;
	        node.vy += y$$1 * quad.value * alpha / l;
	      }
	      return true;
	    }
	
	    // Otherwise, process points directly.
	    else if (quad.length || l >= distanceMax2) return;
	
	    // Limit forces for very close nodes; randomize direction if coincident.
	    if (quad.data !== node || quad.next) {
	      if (x$$1 === 0) x$$1 = jiggle(), l += x$$1 * x$$1;
	      if (y$$1 === 0) y$$1 = jiggle(), l += y$$1 * y$$1;
	      if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
	    }
	
	    do if (quad.data !== node) {
	      w = strengths[quad.data.index] * alpha / l;
	      node.vx += x$$1 * w;
	      node.vy += y$$1 * w;
	    } while (quad = quad.next);
	  }
	
	  force.initialize = function(_) {
	    nodes = _;
	    initialize();
	  };
	
	  force.strength = function(_) {
	    return arguments.length ? (strength = typeof _ === "function" ? _ : constant$7(+_), initialize(), force) : strength;
	  };
	
	  force.distanceMin = function(_) {
	    return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
	  };
	
	  force.distanceMax = function(_) {
	    return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
	  };
	
	  force.theta = function(_) {
	    return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
	  };
	
	  return force;
	};
	
	var x$3 = function(x) {
	  var strength = constant$7(0.1),
	      nodes,
	      strengths,
	      xz;
	
	  if (typeof x !== "function") x = constant$7(x == null ? 0 : +x);
	
	  function force(alpha) {
	    for (var i = 0, n = nodes.length, node; i < n; ++i) {
	      node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
	    }
	  }
	
	  function initialize() {
	    if (!nodes) return;
	    var i, n = nodes.length;
	    strengths = new Array(n);
	    xz = new Array(n);
	    for (i = 0; i < n; ++i) {
	      strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
	    }
	  }
	
	  force.initialize = function(_) {
	    nodes = _;
	    initialize();
	  };
	
	  force.strength = function(_) {
	    return arguments.length ? (strength = typeof _ === "function" ? _ : constant$7(+_), initialize(), force) : strength;
	  };
	
	  force.x = function(_) {
	    return arguments.length ? (x = typeof _ === "function" ? _ : constant$7(+_), initialize(), force) : x;
	  };
	
	  return force;
	};
	
	var y$3 = function(y) {
	  var strength = constant$7(0.1),
	      nodes,
	      strengths,
	      yz;
	
	  if (typeof y !== "function") y = constant$7(y == null ? 0 : +y);
	
	  function force(alpha) {
	    for (var i = 0, n = nodes.length, node; i < n; ++i) {
	      node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
	    }
	  }
	
	  function initialize() {
	    if (!nodes) return;
	    var i, n = nodes.length;
	    strengths = new Array(n);
	    yz = new Array(n);
	    for (i = 0; i < n; ++i) {
	      strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
	    }
	  }
	
	  force.initialize = function(_) {
	    nodes = _;
	    initialize();
	  };
	
	  force.strength = function(_) {
	    return arguments.length ? (strength = typeof _ === "function" ? _ : constant$7(+_), initialize(), force) : strength;
	  };
	
	  force.y = function(_) {
	    return arguments.length ? (y = typeof _ === "function" ? _ : constant$7(+_), initialize(), force) : y;
	  };
	
	  return force;
	};
	
	function nopropagation() {
	  exports.event.stopImmediatePropagation();
	}
	
	var noevent = function() {
	  exports.event.preventDefault();
	  exports.event.stopImmediatePropagation();
	};
	
	var dragDisable = function(view) {
	  var root = view.document.documentElement,
	      selection$$1 = select(view).on("dragstart.drag", noevent, true);
	  if ("onselectstart" in root) {
	    selection$$1.on("selectstart.drag", noevent, true);
	  } else {
	    root.__noselect = root.style.MozUserSelect;
	    root.style.MozUserSelect = "none";
	  }
	};
	
	function yesdrag(view, noclick) {
	  var root = view.document.documentElement,
	      selection$$1 = select(view).on("dragstart.drag", null);
	  if (noclick) {
	    selection$$1.on("click.drag", noevent, true);
	    setTimeout(function() { selection$$1.on("click.drag", null); }, 0);
	  }
	  if ("onselectstart" in root) {
	    selection$$1.on("selectstart.drag", null);
	  } else {
	    root.style.MozUserSelect = root.__noselect;
	    delete root.__noselect;
	  }
	}
	
	var constant$8 = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function DragEvent(target, type, subject, id, active, x, y, dx, dy, dispatch) {
	  this.target = target;
	  this.type = type;
	  this.subject = subject;
	  this.identifier = id;
	  this.active = active;
	  this.x = x;
	  this.y = y;
	  this.dx = dx;
	  this.dy = dy;
	  this._ = dispatch;
	}
	
	DragEvent.prototype.on = function() {
	  var value = this._.on.apply(this._, arguments);
	  return value === this._ ? this : value;
	};
	
	// Ignore right-click, since that should open the context menu.
	function defaultFilter() {
	  return !exports.event.button;
	}
	
	function defaultContainer() {
	  return this.parentNode;
	}
	
	function defaultSubject(d) {
	  return d == null ? {x: exports.event.x, y: exports.event.y} : d;
	}
	
	var drag = function() {
	  var filter = defaultFilter,
	      container = defaultContainer,
	      subject = defaultSubject,
	      gestures = {},
	      listeners = dispatch("start", "drag", "end"),
	      active = 0,
	      mousemoving,
	      touchending;
	
	  function drag(selection$$1) {
	    selection$$1
	        .on("mousedown.drag", mousedowned)
	        .on("touchstart.drag", touchstarted)
	        .on("touchmove.drag", touchmoved)
	        .on("touchend.drag touchcancel.drag", touchended)
	        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
	  }
	
	  function mousedowned() {
	    if (touchending || !filter.apply(this, arguments)) return;
	    var gesture = beforestart("mouse", container.apply(this, arguments), mouse, this, arguments);
	    if (!gesture) return;
	    select(exports.event.view).on("mousemove.drag", mousemoved, true).on("mouseup.drag", mouseupped, true);
	    dragDisable(exports.event.view);
	    nopropagation();
	    mousemoving = false;
	    gesture("start");
	  }
	
	  function mousemoved() {
	    noevent();
	    mousemoving = true;
	    gestures.mouse("drag");
	  }
	
	  function mouseupped() {
	    select(exports.event.view).on("mousemove.drag mouseup.drag", null);
	    yesdrag(exports.event.view, mousemoving);
	    noevent();
	    gestures.mouse("end");
	  }
	
	  function touchstarted() {
	    if (!filter.apply(this, arguments)) return;
	    var touches$$1 = exports.event.changedTouches,
	        c = container.apply(this, arguments),
	        n = touches$$1.length, i, gesture;
	
	    for (i = 0; i < n; ++i) {
	      if (gesture = beforestart(touches$$1[i].identifier, c, touch, this, arguments)) {
	        nopropagation();
	        gesture("start");
	      }
	    }
	  }
	
	  function touchmoved() {
	    var touches$$1 = exports.event.changedTouches,
	        n = touches$$1.length, i, gesture;
	
	    for (i = 0; i < n; ++i) {
	      if (gesture = gestures[touches$$1[i].identifier]) {
	        noevent();
	        gesture("drag");
	      }
	    }
	  }
	
	  function touchended() {
	    var touches$$1 = exports.event.changedTouches,
	        n = touches$$1.length, i, gesture;
	
	    if (touchending) clearTimeout(touchending);
	    touchending = setTimeout(function() { touchending = null; }, 500); // Ghost clicks are delayed!
	    for (i = 0; i < n; ++i) {
	      if (gesture = gestures[touches$$1[i].identifier]) {
	        nopropagation();
	        gesture("end");
	      }
	    }
	  }
	
	  function beforestart(id, container, point, that, args) {
	    var p = point(container, id), s, dx, dy,
	        sublisteners = listeners.copy();
	
	    if (!customEvent(new DragEvent(drag, "beforestart", s, id, active, p[0], p[1], 0, 0, sublisteners), function() {
	      if ((exports.event.subject = s = subject.apply(that, args)) == null) return false;
	      dx = s.x - p[0] || 0;
	      dy = s.y - p[1] || 0;
	      return true;
	    })) return;
	
	    return function gesture(type) {
	      var p0 = p, n;
	      switch (type) {
	        case "start": gestures[id] = gesture, n = active++; break;
	        case "end": delete gestures[id], --active; // nobreak
	        case "drag": p = point(container, id), n = active; break;
	      }
	      customEvent(new DragEvent(drag, type, s, id, n, p[0] + dx, p[1] + dy, p[0] - p0[0], p[1] - p0[1], sublisteners), sublisteners.apply, sublisteners, [type, that, args]);
	    };
	  }
	
	  drag.filter = function(_) {
	    return arguments.length ? (filter = typeof _ === "function" ? _ : constant$8(!!_), drag) : filter;
	  };
	
	  drag.container = function(_) {
	    return arguments.length ? (container = typeof _ === "function" ? _ : constant$8(_), drag) : container;
	  };
	
	  drag.subject = function(_) {
	    return arguments.length ? (subject = typeof _ === "function" ? _ : constant$8(_), drag) : subject;
	  };
	
	  drag.on = function() {
	    var value = listeners.on.apply(listeners, arguments);
	    return value === listeners ? drag : value;
	  };
	
	  return drag;
	};
	
	var constant$9 = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function x$4(d) {
	  return d[0];
	}
	
	function y$4(d) {
	  return d[1];
	}
	
	function RedBlackTree() {
	  this._ = null; // root node
	}
	
	function RedBlackNode(node) {
	  node.U = // parent node
	  node.C = // color - true for red, false for black
	  node.L = // left node
	  node.R = // right node
	  node.P = // previous node
	  node.N = null; // next node
	}
	
	RedBlackTree.prototype = {
	  constructor: RedBlackTree,
	
	  insert: function(after, node) {
	    var parent, grandpa, uncle;
	
	    if (after) {
	      node.P = after;
	      node.N = after.N;
	      if (after.N) after.N.P = node;
	      after.N = node;
	      if (after.R) {
	        after = after.R;
	        while (after.L) after = after.L;
	        after.L = node;
	      } else {
	        after.R = node;
	      }
	      parent = after;
	    } else if (this._) {
	      after = RedBlackFirst(this._);
	      node.P = null;
	      node.N = after;
	      after.P = after.L = node;
	      parent = after;
	    } else {
	      node.P = node.N = null;
	      this._ = node;
	      parent = null;
	    }
	    node.L = node.R = null;
	    node.U = parent;
	    node.C = true;
	
	    after = node;
	    while (parent && parent.C) {
	      grandpa = parent.U;
	      if (parent === grandpa.L) {
	        uncle = grandpa.R;
	        if (uncle && uncle.C) {
	          parent.C = uncle.C = false;
	          grandpa.C = true;
	          after = grandpa;
	        } else {
	          if (after === parent.R) {
	            RedBlackRotateLeft(this, parent);
	            after = parent;
	            parent = after.U;
	          }
	          parent.C = false;
	          grandpa.C = true;
	          RedBlackRotateRight(this, grandpa);
	        }
	      } else {
	        uncle = grandpa.L;
	        if (uncle && uncle.C) {
	          parent.C = uncle.C = false;
	          grandpa.C = true;
	          after = grandpa;
	        } else {
	          if (after === parent.L) {
	            RedBlackRotateRight(this, parent);
	            after = parent;
	            parent = after.U;
	          }
	          parent.C = false;
	          grandpa.C = true;
	          RedBlackRotateLeft(this, grandpa);
	        }
	      }
	      parent = after.U;
	    }
	    this._.C = false;
	  },
	
	  remove: function(node) {
	    if (node.N) node.N.P = node.P;
	    if (node.P) node.P.N = node.N;
	    node.N = node.P = null;
	
	    var parent = node.U,
	        sibling,
	        left = node.L,
	        right = node.R,
	        next,
	        red;
	
	    if (!left) next = right;
	    else if (!right) next = left;
	    else next = RedBlackFirst(right);
	
	    if (parent) {
	      if (parent.L === node) parent.L = next;
	      else parent.R = next;
	    } else {
	      this._ = next;
	    }
	
	    if (left && right) {
	      red = next.C;
	      next.C = node.C;
	      next.L = left;
	      left.U = next;
	      if (next !== right) {
	        parent = next.U;
	        next.U = node.U;
	        node = next.R;
	        parent.L = node;
	        next.R = right;
	        right.U = next;
	      } else {
	        next.U = parent;
	        parent = next;
	        node = next.R;
	      }
	    } else {
	      red = node.C;
	      node = next;
	    }
	
	    if (node) node.U = parent;
	    if (red) return;
	    if (node && node.C) { node.C = false; return; }
	
	    do {
	      if (node === this._) break;
	      if (node === parent.L) {
	        sibling = parent.R;
	        if (sibling.C) {
	          sibling.C = false;
	          parent.C = true;
	          RedBlackRotateLeft(this, parent);
	          sibling = parent.R;
	        }
	        if ((sibling.L && sibling.L.C)
	            || (sibling.R && sibling.R.C)) {
	          if (!sibling.R || !sibling.R.C) {
	            sibling.L.C = false;
	            sibling.C = true;
	            RedBlackRotateRight(this, sibling);
	            sibling = parent.R;
	          }
	          sibling.C = parent.C;
	          parent.C = sibling.R.C = false;
	          RedBlackRotateLeft(this, parent);
	          node = this._;
	          break;
	        }
	      } else {
	        sibling = parent.L;
	        if (sibling.C) {
	          sibling.C = false;
	          parent.C = true;
	          RedBlackRotateRight(this, parent);
	          sibling = parent.L;
	        }
	        if ((sibling.L && sibling.L.C)
	          || (sibling.R && sibling.R.C)) {
	          if (!sibling.L || !sibling.L.C) {
	            sibling.R.C = false;
	            sibling.C = true;
	            RedBlackRotateLeft(this, sibling);
	            sibling = parent.L;
	          }
	          sibling.C = parent.C;
	          parent.C = sibling.L.C = false;
	          RedBlackRotateRight(this, parent);
	          node = this._;
	          break;
	        }
	      }
	      sibling.C = true;
	      node = parent;
	      parent = parent.U;
	    } while (!node.C);
	
	    if (node) node.C = false;
	  }
	};
	
	function RedBlackRotateLeft(tree, node) {
	  var p = node,
	      q = node.R,
	      parent = p.U;
	
	  if (parent) {
	    if (parent.L === p) parent.L = q;
	    else parent.R = q;
	  } else {
	    tree._ = q;
	  }
	
	  q.U = parent;
	  p.U = q;
	  p.R = q.L;
	  if (p.R) p.R.U = p;
	  q.L = p;
	}
	
	function RedBlackRotateRight(tree, node) {
	  var p = node,
	      q = node.L,
	      parent = p.U;
	
	  if (parent) {
	    if (parent.L === p) parent.L = q;
	    else parent.R = q;
	  } else {
	    tree._ = q;
	  }
	
	  q.U = parent;
	  p.U = q;
	  p.L = q.R;
	  if (p.L) p.L.U = p;
	  q.R = p;
	}
	
	function RedBlackFirst(node) {
	  while (node.L) node = node.L;
	  return node;
	}
	
	function createEdge(left, right, v0, v1) {
	  var edge = [null, null],
	      index = edges.push(edge) - 1;
	  edge.left = left;
	  edge.right = right;
	  if (v0) setEdgeEnd(edge, left, right, v0);
	  if (v1) setEdgeEnd(edge, right, left, v1);
	  cells[left.index].halfedges.push(index);
	  cells[right.index].halfedges.push(index);
	  return edge;
	}
	
	function createBorderEdge(left, v0, v1) {
	  var edge = [v0, v1];
	  edge.left = left;
	  return edge;
	}
	
	function setEdgeEnd(edge, left, right, vertex) {
	  if (!edge[0] && !edge[1]) {
	    edge[0] = vertex;
	    edge.left = left;
	    edge.right = right;
	  } else if (edge.left === right) {
	    edge[1] = vertex;
	  } else {
	    edge[0] = vertex;
	  }
	}
	
	// Liang–Barsky line clipping.
	function clipEdge(edge, x0, y0, x1, y1) {
	  var a = edge[0],
	      b = edge[1],
	      ax = a[0],
	      ay = a[1],
	      bx = b[0],
	      by = b[1],
	      t0 = 0,
	      t1 = 1,
	      dx = bx - ax,
	      dy = by - ay,
	      r;
	
	  r = x0 - ax;
	  if (!dx && r > 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dx > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = x1 - ax;
	  if (!dx && r < 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dx > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  r = y0 - ay;
	  if (!dy && r > 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dy > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = y1 - ay;
	  if (!dy && r < 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dy > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  if (!(t0 > 0) && !(t1 < 1)) return true; // TODO Better check?
	
	  if (t0 > 0) edge[0] = [ax + t0 * dx, ay + t0 * dy];
	  if (t1 < 1) edge[1] = [ax + t1 * dx, ay + t1 * dy];
	  return true;
	}
	
	function connectEdge(edge, x0, y0, x1, y1) {
	  var v1 = edge[1];
	  if (v1) return true;
	
	  var v0 = edge[0],
	      left = edge.left,
	      right = edge.right,
	      lx = left[0],
	      ly = left[1],
	      rx = right[0],
	      ry = right[1],
	      fx = (lx + rx) / 2,
	      fy = (ly + ry) / 2,
	      fm,
	      fb;
	
	  if (ry === ly) {
	    if (fx < x0 || fx >= x1) return;
	    if (lx > rx) {
	      if (!v0) v0 = [fx, y0];
	      else if (v0[1] >= y1) return;
	      v1 = [fx, y1];
	    } else {
	      if (!v0) v0 = [fx, y1];
	      else if (v0[1] < y0) return;
	      v1 = [fx, y0];
	    }
	  } else {
	    fm = (lx - rx) / (ry - ly);
	    fb = fy - fm * fx;
	    if (fm < -1 || fm > 1) {
	      if (lx > rx) {
	        if (!v0) v0 = [(y0 - fb) / fm, y0];
	        else if (v0[1] >= y1) return;
	        v1 = [(y1 - fb) / fm, y1];
	      } else {
	        if (!v0) v0 = [(y1 - fb) / fm, y1];
	        else if (v0[1] < y0) return;
	        v1 = [(y0 - fb) / fm, y0];
	      }
	    } else {
	      if (ly < ry) {
	        if (!v0) v0 = [x0, fm * x0 + fb];
	        else if (v0[0] >= x1) return;
	        v1 = [x1, fm * x1 + fb];
	      } else {
	        if (!v0) v0 = [x1, fm * x1 + fb];
	        else if (v0[0] < x0) return;
	        v1 = [x0, fm * x0 + fb];
	      }
	    }
	  }
	
	  edge[0] = v0;
	  edge[1] = v1;
	  return true;
	}
	
	function clipEdges(x0, y0, x1, y1) {
	  var i = edges.length,
	      edge;
	
	  while (i--) {
	    if (!connectEdge(edge = edges[i], x0, y0, x1, y1)
	        || !clipEdge(edge, x0, y0, x1, y1)
	        || !(Math.abs(edge[0][0] - edge[1][0]) > epsilon$3
	            || Math.abs(edge[0][1] - edge[1][1]) > epsilon$3)) {
	      delete edges[i];
	    }
	  }
	}
	
	function createCell(site) {
	  return cells[site.index] = {
	    site: site,
	    halfedges: []
	  };
	}
	
	function cellHalfedgeAngle(cell, edge) {
	  var site = cell.site,
	      va = edge.left,
	      vb = edge.right;
	  if (site === vb) vb = va, va = site;
	  if (vb) return Math.atan2(vb[1] - va[1], vb[0] - va[0]);
	  if (site === va) va = edge[1], vb = edge[0];
	  else va = edge[0], vb = edge[1];
	  return Math.atan2(va[0] - vb[0], vb[1] - va[1]);
	}
	
	function cellHalfedgeStart(cell, edge) {
	  return edge[+(edge.left !== cell.site)];
	}
	
	function cellHalfedgeEnd(cell, edge) {
	  return edge[+(edge.left === cell.site)];
	}
	
	function sortCellHalfedges() {
	  for (var i = 0, n = cells.length, cell, halfedges, j, m; i < n; ++i) {
	    if ((cell = cells[i]) && (m = (halfedges = cell.halfedges).length)) {
	      var index = new Array(m),
	          array = new Array(m);
	      for (j = 0; j < m; ++j) index[j] = j, array[j] = cellHalfedgeAngle(cell, edges[halfedges[j]]);
	      index.sort(function(i, j) { return array[j] - array[i]; });
	      for (j = 0; j < m; ++j) array[j] = halfedges[index[j]];
	      for (j = 0; j < m; ++j) halfedges[j] = array[j];
	    }
	  }
	}
	
	function clipCells(x0, y0, x1, y1) {
	  var nCells = cells.length,
	      iCell,
	      cell,
	      site,
	      iHalfedge,
	      halfedges,
	      nHalfedges,
	      start,
	      startX,
	      startY,
	      end,
	      endX,
	      endY,
	      cover = true;
	
	  for (iCell = 0; iCell < nCells; ++iCell) {
	    if (cell = cells[iCell]) {
	      site = cell.site;
	      halfedges = cell.halfedges;
	      iHalfedge = halfedges.length;
	
	      // Remove any dangling clipped edges.
	      while (iHalfedge--) {
	        if (!edges[halfedges[iHalfedge]]) {
	          halfedges.splice(iHalfedge, 1);
	        }
	      }
	
	      // Insert any border edges as necessary.
	      iHalfedge = 0, nHalfedges = halfedges.length;
	      while (iHalfedge < nHalfedges) {
	        end = cellHalfedgeEnd(cell, edges[halfedges[iHalfedge]]), endX = end[0], endY = end[1];
	        start = cellHalfedgeStart(cell, edges[halfedges[++iHalfedge % nHalfedges]]), startX = start[0], startY = start[1];
	        if (Math.abs(endX - startX) > epsilon$3 || Math.abs(endY - startY) > epsilon$3) {
	          halfedges.splice(iHalfedge, 0, edges.push(createBorderEdge(site, end,
	              Math.abs(endX - x0) < epsilon$3 && y1 - endY > epsilon$3 ? [x0, Math.abs(startX - x0) < epsilon$3 ? startY : y1]
	              : Math.abs(endY - y1) < epsilon$3 && x1 - endX > epsilon$3 ? [Math.abs(startY - y1) < epsilon$3 ? startX : x1, y1]
	              : Math.abs(endX - x1) < epsilon$3 && endY - y0 > epsilon$3 ? [x1, Math.abs(startX - x1) < epsilon$3 ? startY : y0]
	              : Math.abs(endY - y0) < epsilon$3 && endX - x0 > epsilon$3 ? [Math.abs(startY - y0) < epsilon$3 ? startX : x0, y0]
	              : null)) - 1);
	          ++nHalfedges;
	        }
	      }
	
	      if (nHalfedges) cover = false;
	    }
	  }
	
	  // If there weren’t any edges, have the closest site cover the extent.
	  // It doesn’t matter which corner of the extent we measure!
	  if (cover) {
	    var dx, dy, d2, dc = Infinity;
	
	    for (iCell = 0, cover = null; iCell < nCells; ++iCell) {
	      if (cell = cells[iCell]) {
	        site = cell.site;
	        dx = site[0] - x0;
	        dy = site[1] - y0;
	        d2 = dx * dx + dy * dy;
	        if (d2 < dc) dc = d2, cover = cell;
	      }
	    }
	
	    if (cover) {
	      var v00 = [x0, y0], v01 = [x0, y1], v11 = [x1, y1], v10 = [x1, y0];
	      cover.halfedges.push(
	        edges.push(createBorderEdge(site = cover.site, v00, v01)) - 1,
	        edges.push(createBorderEdge(site, v01, v11)) - 1,
	        edges.push(createBorderEdge(site, v11, v10)) - 1,
	        edges.push(createBorderEdge(site, v10, v00)) - 1
	      );
	    }
	  }
	
	  // Lastly delete any cells with no edges; these were entirely clipped.
	  for (iCell = 0; iCell < nCells; ++iCell) {
	    if (cell = cells[iCell]) {
	      if (!cell.halfedges.length) {
	        delete cells[iCell];
	      }
	    }
	  }
	}
	
	var circlePool = [];
	
	var firstCircle;
	
	function Circle() {
	  RedBlackNode(this);
	  this.x =
	  this.y =
	  this.arc =
	  this.site =
	  this.cy = null;
	}
	
	function attachCircle(arc) {
	  var lArc = arc.P,
	      rArc = arc.N;
	
	  if (!lArc || !rArc) return;
	
	  var lSite = lArc.site,
	      cSite = arc.site,
	      rSite = rArc.site;
	
	  if (lSite === rSite) return;
	
	  var bx = cSite[0],
	      by = cSite[1],
	      ax = lSite[0] - bx,
	      ay = lSite[1] - by,
	      cx = rSite[0] - bx,
	      cy = rSite[1] - by;
	
	  var d = 2 * (ax * cy - ay * cx);
	  if (d >= -epsilon2$1) return;
	
	  var ha = ax * ax + ay * ay,
	      hc = cx * cx + cy * cy,
	      x = (cy * ha - ay * hc) / d,
	      y = (ax * hc - cx * ha) / d;
	
	  var circle = circlePool.pop() || new Circle;
	  circle.arc = arc;
	  circle.site = cSite;
	  circle.x = x + bx;
	  circle.y = (circle.cy = y + by) + Math.sqrt(x * x + y * y); // y bottom
	
	  arc.circle = circle;
	
	  var before = null,
	      node = circles._;
	
	  while (node) {
	    if (circle.y < node.y || (circle.y === node.y && circle.x <= node.x)) {
	      if (node.L) node = node.L;
	      else { before = node.P; break; }
	    } else {
	      if (node.R) node = node.R;
	      else { before = node; break; }
	    }
	  }
	
	  circles.insert(before, circle);
	  if (!before) firstCircle = circle;
	}
	
	function detachCircle(arc) {
	  var circle = arc.circle;
	  if (circle) {
	    if (!circle.P) firstCircle = circle.N;
	    circles.remove(circle);
	    circlePool.push(circle);
	    RedBlackNode(circle);
	    arc.circle = null;
	  }
	}
	
	var beachPool = [];
	
	function Beach() {
	  RedBlackNode(this);
	  this.edge =
	  this.site =
	  this.circle = null;
	}
	
	function createBeach(site) {
	  var beach = beachPool.pop() || new Beach;
	  beach.site = site;
	  return beach;
	}
	
	function detachBeach(beach) {
	  detachCircle(beach);
	  beaches.remove(beach);
	  beachPool.push(beach);
	  RedBlackNode(beach);
	}
	
	function removeBeach(beach) {
	  var circle = beach.circle,
	      x = circle.x,
	      y = circle.cy,
	      vertex = [x, y],
	      previous = beach.P,
	      next = beach.N,
	      disappearing = [beach];
	
	  detachBeach(beach);
	
	  var lArc = previous;
	  while (lArc.circle
	      && Math.abs(x - lArc.circle.x) < epsilon$3
	      && Math.abs(y - lArc.circle.cy) < epsilon$3) {
	    previous = lArc.P;
	    disappearing.unshift(lArc);
	    detachBeach(lArc);
	    lArc = previous;
	  }
	
	  disappearing.unshift(lArc);
	  detachCircle(lArc);
	
	  var rArc = next;
	  while (rArc.circle
	      && Math.abs(x - rArc.circle.x) < epsilon$3
	      && Math.abs(y - rArc.circle.cy) < epsilon$3) {
	    next = rArc.N;
	    disappearing.push(rArc);
	    detachBeach(rArc);
	    rArc = next;
	  }
	
	  disappearing.push(rArc);
	  detachCircle(rArc);
	
	  var nArcs = disappearing.length,
	      iArc;
	  for (iArc = 1; iArc < nArcs; ++iArc) {
	    rArc = disappearing[iArc];
	    lArc = disappearing[iArc - 1];
	    setEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
	  }
	
	  lArc = disappearing[0];
	  rArc = disappearing[nArcs - 1];
	  rArc.edge = createEdge(lArc.site, rArc.site, null, vertex);
	
	  attachCircle(lArc);
	  attachCircle(rArc);
	}
	
	function addBeach(site) {
	  var x = site[0],
	      directrix = site[1],
	      lArc,
	      rArc,
	      dxl,
	      dxr,
	      node = beaches._;
	
	  while (node) {
	    dxl = leftBreakPoint(node, directrix) - x;
	    if (dxl > epsilon$3) node = node.L; else {
	      dxr = x - rightBreakPoint(node, directrix);
	      if (dxr > epsilon$3) {
	        if (!node.R) {
	          lArc = node;
	          break;
	        }
	        node = node.R;
	      } else {
	        if (dxl > -epsilon$3) {
	          lArc = node.P;
	          rArc = node;
	        } else if (dxr > -epsilon$3) {
	          lArc = node;
	          rArc = node.N;
	        } else {
	          lArc = rArc = node;
	        }
	        break;
	      }
	    }
	  }
	
	  createCell(site);
	  var newArc = createBeach(site);
	  beaches.insert(lArc, newArc);
	
	  if (!lArc && !rArc) return;
	
	  if (lArc === rArc) {
	    detachCircle(lArc);
	    rArc = createBeach(lArc.site);
	    beaches.insert(newArc, rArc);
	    newArc.edge = rArc.edge = createEdge(lArc.site, newArc.site);
	    attachCircle(lArc);
	    attachCircle(rArc);
	    return;
	  }
	
	  if (!rArc) { // && lArc
	    newArc.edge = createEdge(lArc.site, newArc.site);
	    return;
	  }
	
	  // else lArc !== rArc
	  detachCircle(lArc);
	  detachCircle(rArc);
	
	  var lSite = lArc.site,
	      ax = lSite[0],
	      ay = lSite[1],
	      bx = site[0] - ax,
	      by = site[1] - ay,
	      rSite = rArc.site,
	      cx = rSite[0] - ax,
	      cy = rSite[1] - ay,
	      d = 2 * (bx * cy - by * cx),
	      hb = bx * bx + by * by,
	      hc = cx * cx + cy * cy,
	      vertex = [(cy * hb - by * hc) / d + ax, (bx * hc - cx * hb) / d + ay];
	
	  setEdgeEnd(rArc.edge, lSite, rSite, vertex);
	  newArc.edge = createEdge(lSite, site, null, vertex);
	  rArc.edge = createEdge(site, rSite, null, vertex);
	  attachCircle(lArc);
	  attachCircle(rArc);
	}
	
	function leftBreakPoint(arc, directrix) {
	  var site = arc.site,
	      rfocx = site[0],
	      rfocy = site[1],
	      pby2 = rfocy - directrix;
	
	  if (!pby2) return rfocx;
	
	  var lArc = arc.P;
	  if (!lArc) return -Infinity;
	
	  site = lArc.site;
	  var lfocx = site[0],
	      lfocy = site[1],
	      plby2 = lfocy - directrix;
	
	  if (!plby2) return lfocx;
	
	  var hl = lfocx - rfocx,
	      aby2 = 1 / pby2 - 1 / plby2,
	      b = hl / plby2;
	
	  if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
	
	  return (rfocx + lfocx) / 2;
	}
	
	function rightBreakPoint(arc, directrix) {
	  var rArc = arc.N;
	  if (rArc) return leftBreakPoint(rArc, directrix);
	  var site = arc.site;
	  return site[1] === directrix ? site[0] : Infinity;
	}
	
	var epsilon$3 = 1e-6;
	var epsilon2$1 = 1e-12;
	var beaches;
	var cells;
	var circles;
	var edges;
	
	function triangleArea(a, b, c) {
	  return (a[0] - c[0]) * (b[1] - a[1]) - (a[0] - b[0]) * (c[1] - a[1]);
	}
	
	function lexicographic(a, b) {
	  return b[1] - a[1]
	      || b[0] - a[0];
	}
	
	function Diagram(sites, extent) {
	  var site = sites.sort(lexicographic).pop(),
	      x,
	      y,
	      circle;
	
	  edges = [];
	  cells = new Array(sites.length);
	  beaches = new RedBlackTree;
	  circles = new RedBlackTree;
	
	  while (true) {
	    circle = firstCircle;
	    if (site && (!circle || site[1] < circle.y || (site[1] === circle.y && site[0] < circle.x))) {
	      if (site[0] !== x || site[1] !== y) {
	        addBeach(site);
	        x = site[0], y = site[1];
	      }
	      site = sites.pop();
	    } else if (circle) {
	      removeBeach(circle.arc);
	    } else {
	      break;
	    }
	  }
	
	  sortCellHalfedges();
	
	  if (extent) {
	    var x0 = +extent[0][0],
	        y0 = +extent[0][1],
	        x1 = +extent[1][0],
	        y1 = +extent[1][1];
	    clipEdges(x0, y0, x1, y1);
	    clipCells(x0, y0, x1, y1);
	  }
	
	  this.edges = edges;
	  this.cells = cells;
	
	  beaches =
	  circles =
	  edges =
	  cells = null;
	}
	
	Diagram.prototype = {
	  constructor: Diagram,
	
	  polygons: function() {
	    var edges = this.edges;
	
	    return this.cells.map(function(cell) {
	      var polygon = cell.halfedges.map(function(i) { return cellHalfedgeStart(cell, edges[i]); });
	      polygon.data = cell.site.data;
	      return polygon;
	    });
	  },
	
	  triangles: function() {
	    var triangles = [],
	        edges = this.edges;
	
	    this.cells.forEach(function(cell, i) {
	      var site = cell.site,
	          halfedges = cell.halfedges,
	          j = -1,
	          m = halfedges.length,
	          s0,
	          e1 = edges[halfedges[m - 1]],
	          s1 = e1.left === site ? e1.right : e1.left;
	
	      while (++j < m) {
	        s0 = s1;
	        e1 = edges[halfedges[j]];
	        s1 = e1.left === site ? e1.right : e1.left;
	        if (s0 && s1 && i < s0.index && i < s1.index && triangleArea(site, s0, s1) < 0) {
	          triangles.push([site.data, s0.data, s1.data]);
	        }
	      }
	    });
	
	    return triangles;
	  },
	
	  links: function() {
	    return this.edges.filter(function(edge) {
	      return edge.right;
	    }).map(function(edge) {
	      return {
	        source: edge.left.data,
	        target: edge.right.data
	      };
	    });
	  },
	
	  find: function(x, y, radius) {
	    var that = this,
	        i0, i1 = that._found || 0,
	        cell = that.cells[i1] || that.cells[i1 = 0],
	        dx = x - cell.site[0],
	        dy = y - cell.site[1],
	        d2 = dx * dx + dy * dy;
	
	    do {
	      cell = that.cells[i0 = i1], i1 = null;
	      cell.halfedges.forEach(function(e) {
	        var edge = that.edges[e], v = edge.left;
	        if ((v === cell.site || !v) && !(v = edge.right)) return;
	        var vx = x - v[0],
	            vy = y - v[1],
	            v2 = vx * vx + vy * vy;
	        if (v2 < d2) d2 = v2, i1 = v.index;
	      });
	    } while (i1 !== null);
	
	    that._found = i0;
	
	    return radius == null || d2 <= radius * radius ? cell.site : null;
	  }
	};
	
	var voronoi = function() {
	  var x$$1 = x$4,
	      y$$1 = y$4,
	      extent = null;
	
	  function voronoi(data) {
	    return new Diagram(data.map(function(d, i) {
	      var s = [Math.round(x$$1(d, i, data) / epsilon$3) * epsilon$3, Math.round(y$$1(d, i, data) / epsilon$3) * epsilon$3];
	      s.index = i;
	      s.data = d;
	      return s;
	    }), extent);
	  }
	
	  voronoi.polygons = function(data) {
	    return voronoi(data).polygons();
	  };
	
	  voronoi.links = function(data) {
	    return voronoi(data).links();
	  };
	
	  voronoi.triangles = function(data) {
	    return voronoi(data).triangles();
	  };
	
	  voronoi.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant$9(+_), voronoi) : x$$1;
	  };
	
	  voronoi.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant$9(+_), voronoi) : y$$1;
	  };
	
	  voronoi.extent = function(_) {
	    return arguments.length ? (extent = _ == null ? null : [[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]], voronoi) : extent && [[extent[0][0], extent[0][1]], [extent[1][0], extent[1][1]]];
	  };
	
	  voronoi.size = function(_) {
	    return arguments.length ? (extent = _ == null ? null : [[0, 0], [+_[0], +_[1]]], voronoi) : extent && [extent[1][0] - extent[0][0], extent[1][1] - extent[0][1]];
	  };
	
	  return voronoi;
	};
	
	var constant$10 = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function ZoomEvent(target, type, transform) {
	  this.target = target;
	  this.type = type;
	  this.transform = transform;
	}
	
	function Transform(k, x, y) {
	  this.k = k;
	  this.x = x;
	  this.y = y;
	}
	
	Transform.prototype = {
	  constructor: Transform,
	  scale: function(k) {
	    return k === 1 ? this : new Transform(this.k * k, this.x, this.y);
	  },
	  translate: function(x, y) {
	    return x === 0 & y === 0 ? this : new Transform(this.k, this.x + this.k * x, this.y + this.k * y);
	  },
	  apply: function(point) {
	    return [point[0] * this.k + this.x, point[1] * this.k + this.y];
	  },
	  applyX: function(x) {
	    return x * this.k + this.x;
	  },
	  applyY: function(y) {
	    return y * this.k + this.y;
	  },
	  invert: function(location) {
	    return [(location[0] - this.x) / this.k, (location[1] - this.y) / this.k];
	  },
	  invertX: function(x) {
	    return (x - this.x) / this.k;
	  },
	  invertY: function(y) {
	    return (y - this.y) / this.k;
	  },
	  rescaleX: function(x) {
	    return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
	  },
	  rescaleY: function(y) {
	    return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
	  },
	  toString: function() {
	    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
	  }
	};
	
	var identity$6 = new Transform(1, 0, 0);
	
	transform.prototype = Transform.prototype;
	
	function transform(node) {
	  return node.__zoom || identity$6;
	}
	
	function nopropagation$1() {
	  exports.event.stopImmediatePropagation();
	}
	
	var noevent$1 = function() {
	  exports.event.preventDefault();
	  exports.event.stopImmediatePropagation();
	};
	
	// Ignore right-click, since that should open the context menu.
	function defaultFilter$1() {
	  return !exports.event.button;
	}
	
	function defaultExtent() {
	  var e = this, w, h;
	  if (e instanceof SVGElement) {
	    e = e.ownerSVGElement || e;
	    w = e.width.baseVal.value;
	    h = e.height.baseVal.value;
	  } else {
	    w = e.clientWidth;
	    h = e.clientHeight;
	  }
	  return [[0, 0], [w, h]];
	}
	
	function defaultTransform() {
	  return this.__zoom || identity$6;
	}
	
	var zoom = function() {
	  var filter = defaultFilter$1,
	      extent = defaultExtent,
	      k0 = 0,
	      k1 = Infinity,
	      x0 = -k1,
	      x1 = k1,
	      y0 = x0,
	      y1 = x1,
	      duration = 250,
	      interpolate$$1 = interpolateZoom,
	      gestures = [],
	      listeners = dispatch("start", "zoom", "end"),
	      touchstarting,
	      touchending,
	      touchDelay = 500,
	      wheelDelay = 150;
	
	  function zoom(selection$$1) {
	    selection$$1
	        .on("wheel.zoom", wheeled)
	        .on("mousedown.zoom", mousedowned)
	        .on("dblclick.zoom", dblclicked)
	        .on("touchstart.zoom", touchstarted)
	        .on("touchmove.zoom", touchmoved)
	        .on("touchend.zoom touchcancel.zoom", touchended)
	        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)")
	        .property("__zoom", defaultTransform);
	  }
	
	  zoom.transform = function(collection, transform) {
	    var selection$$1 = collection.selection ? collection.selection() : collection;
	    selection$$1.property("__zoom", defaultTransform);
	    if (collection !== selection$$1) {
	      schedule(collection, transform);
	    } else {
	      selection$$1.interrupt().each(function() {
	        gesture(this, arguments)
	            .start()
	            .zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform)
	            .end();
	      });
	    }
	  };
	
	  zoom.scaleBy = function(selection$$1, k) {
	    zoom.scaleTo(selection$$1, function() {
	      var k0 = this.__zoom.k,
	          k1 = typeof k === "function" ? k.apply(this, arguments) : k;
	      return k0 * k1;
	    });
	  };
	
	  zoom.scaleTo = function(selection$$1, k) {
	    zoom.transform(selection$$1, function() {
	      var e = extent.apply(this, arguments),
	          t0 = this.__zoom,
	          p0 = centroid(e),
	          p1 = t0.invert(p0),
	          k1 = typeof k === "function" ? k.apply(this, arguments) : k;
	      return constrain(translate(scale(t0, k1), p0, p1), e);
	    });
	  };
	
	  zoom.translateBy = function(selection$$1, x, y) {
	    zoom.transform(selection$$1, function() {
	      return constrain(this.__zoom.translate(
	        typeof x === "function" ? x.apply(this, arguments) : x,
	        typeof y === "function" ? y.apply(this, arguments) : y
	      ), extent.apply(this, arguments));
	    });
	  };
	
	  function scale(transform, k) {
	    k = Math.max(k0, Math.min(k1, k));
	    return k === transform.k ? transform : new Transform(k, transform.x, transform.y);
	  }
	
	  function translate(transform, p0, p1) {
	    var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
	    return x === transform.x && y === transform.y ? transform : new Transform(transform.k, x, y);
	  }
	
	  function constrain(transform, extent) {
	    var dx0 = transform.invertX(extent[0][0]) - x0,
	        dx1 = transform.invertX(extent[1][0]) - x1,
	        dy0 = transform.invertY(extent[0][1]) - y0,
	        dy1 = transform.invertY(extent[1][1]) - y1;
	    return transform.translate(
	      dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1),
	      dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1)
	    );
	  }
	
	  function centroid(extent) {
	    return [(+extent[0][0] + +extent[1][0]) / 2, (+extent[0][1] + +extent[1][1]) / 2];
	  }
	
	  function schedule(transition$$1, transform, center) {
	    transition$$1
	        .on("start.zoom", function() { gesture(this, arguments).start(); })
	        .on("interrupt.zoom end.zoom", function() { gesture(this, arguments).end(); })
	        .tween("zoom", function() {
	          var that = this,
	              args = arguments,
	              g = gesture(that, args),
	              e = extent.apply(that, args),
	              p = center || centroid(e),
	              w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]),
	              a = that.__zoom,
	              b = typeof transform === "function" ? transform.apply(that, args) : transform,
	              i = interpolate$$1(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
	          return function(t) {
	            if (t === 1) t = b; // Avoid rounding error on end.
	            else { var l = i(t), k = w / l[2]; t = new Transform(k, p[0] - l[0] * k, p[1] - l[1] * k); }
	            g.zoom(null, t);
	          };
	        });
	  }
	
	  function gesture(that, args) {
	    for (var i = 0, n = gestures.length, g; i < n; ++i) {
	      if ((g = gestures[i]).that === that) {
	        return g;
	      }
	    }
	    return new Gesture(that, args);
	  }
	
	  function Gesture(that, args) {
	    this.that = that;
	    this.args = args;
	    this.index = -1;
	    this.active = 0;
	    this.extent = extent.apply(that, args);
	  }
	
	  Gesture.prototype = {
	    start: function() {
	      if (++this.active === 1) {
	        this.index = gestures.push(this) - 1;
	        this.emit("start");
	      }
	      return this;
	    },
	    zoom: function(key, transform) {
	      if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
	      if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
	      if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
	      this.that.__zoom = transform;
	      this.emit("zoom");
	      return this;
	    },
	    end: function() {
	      if (--this.active === 0) {
	        gestures.splice(this.index, 1);
	        this.index = -1;
	        this.emit("end");
	      }
	      return this;
	    },
	    emit: function(type) {
	      customEvent(new ZoomEvent(zoom, type, this.that.__zoom), listeners.apply, listeners, [type, this.that, this.args]);
	    }
	  };
	
	  function wheeled() {
	    if (!filter.apply(this, arguments)) return;
	    var g = gesture(this, arguments),
	        t = this.__zoom,
	        k = Math.max(k0, Math.min(k1, t.k * Math.pow(2, -exports.event.deltaY * (exports.event.deltaMode ? 120 : 1) / 500))),
	        p = mouse(this);
	
	    // If the mouse is in the same location as before, reuse it.
	    // If there were recent wheel events, reset the wheel idle timeout.
	    if (g.wheel) {
	      if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) {
	        g.mouse[1] = t.invert(g.mouse[0] = p);
	      }
	      clearTimeout(g.wheel);
	    }
	
	    // If this wheel event won’t trigger a transform change, ignore it.
	    else if (t.k === k) return;
	
	    // Otherwise, capture the mouse point and location at the start.
	    else {
	      g.mouse = [p, t.invert(p)];
	      interrupt(this);
	      g.start();
	    }
	
	    noevent$1();
	    g.wheel = setTimeout(wheelidled, wheelDelay);
	    g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent));
	
	    function wheelidled() {
	      g.wheel = null;
	      g.end();
	    }
	  }
	
	  function mousedowned() {
	    if (touchending || !filter.apply(this, arguments)) return;
	    var g = gesture(this, arguments),
	        v = select(exports.event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true),
	        p = mouse(this);
	
	    dragDisable(exports.event.view);
	    nopropagation$1();
	    g.mouse = [p, this.__zoom.invert(p)];
	    interrupt(this);
	    g.start();
	
	    function mousemoved() {
	      noevent$1();
	      g.moved = true;
	      g.zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = mouse(g.that), g.mouse[1]), g.extent));
	    }
	
	    function mouseupped() {
	      v.on("mousemove.zoom mouseup.zoom", null);
	      yesdrag(exports.event.view, g.moved);
	      noevent$1();
	      g.end();
	    }
	  }
	
	  function dblclicked() {
	    if (!filter.apply(this, arguments)) return;
	    var t0 = this.__zoom,
	        p0 = mouse(this),
	        p1 = t0.invert(p0),
	        k1 = t0.k * (exports.event.shiftKey ? 0.5 : 2),
	        t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, arguments));
	
	    noevent$1();
	    if (duration > 0) select(this).transition().duration(duration).call(schedule, t1, p0);
	    else select(this).call(zoom.transform, t1);
	  }
	
	  function touchstarted() {
	    if (!filter.apply(this, arguments)) return;
	    var g = gesture(this, arguments),
	        touches$$1 = exports.event.changedTouches,
	        n = touches$$1.length, i, t, p;
	
	    nopropagation$1();
	    for (i = 0; i < n; ++i) {
	      t = touches$$1[i], p = touch(this, touches$$1, t.identifier);
	      p = [p, this.__zoom.invert(p), t.identifier];
	      if (!g.touch0) g.touch0 = p;
	      else if (!g.touch1) g.touch1 = p;
	    }
	
	    // If this is a dbltap, reroute to the (optional) dblclick.zoom handler.
	    if (touchstarting) {
	      touchstarting = clearTimeout(touchstarting);
	      if (!g.touch1) {
	        g.end();
	        p = select(this).on("dblclick.zoom");
	        if (p) p.apply(this, arguments);
	        return;
	      }
	    }
	
	    if (exports.event.touches.length === n) {
	      touchstarting = setTimeout(function() { touchstarting = null; }, touchDelay);
	      interrupt(this);
	      g.start();
	    }
	  }
	
	  function touchmoved() {
	    var g = gesture(this, arguments),
	        touches$$1 = exports.event.changedTouches,
	        n = touches$$1.length, i, t, p, l;
	
	    noevent$1();
	    if (touchstarting) touchstarting = clearTimeout(touchstarting);
	    for (i = 0; i < n; ++i) {
	      t = touches$$1[i], p = touch(this, touches$$1, t.identifier);
	      if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
	      else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
	    }
	    t = g.that.__zoom;
	    if (g.touch1) {
	      var p0 = g.touch0[0], l0 = g.touch0[1],
	          p1 = g.touch1[0], l1 = g.touch1[1],
	          dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp,
	          dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
	      t = scale(t, Math.sqrt(dp / dl));
	      p = [(p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2];
	      l = [(l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2];
	    }
	    else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
	    else return;
	    g.zoom("touch", constrain(translate(t, p, l), g.extent));
	  }
	
	  function touchended() {
	    var g = gesture(this, arguments),
	        touches$$1 = exports.event.changedTouches,
	        n = touches$$1.length, i, t;
	
	    nopropagation$1();
	    if (touchending) clearTimeout(touchending);
	    touchending = setTimeout(function() { touchending = null; }, touchDelay);
	    for (i = 0; i < n; ++i) {
	      t = touches$$1[i];
	      if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
	      else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
	    }
	    if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
	    if (!g.touch0) g.end();
	  }
	
	  zoom.filter = function(_) {
	    return arguments.length ? (filter = typeof _ === "function" ? _ : constant$10(!!_), zoom) : filter;
	  };
	
	  zoom.extent = function(_) {
	    return arguments.length ? (extent = typeof _ === "function" ? _ : constant$10([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), zoom) : extent;
	  };
	
	  zoom.scaleExtent = function(_) {
	    return arguments.length ? (k0 = +_[0], k1 = +_[1], zoom) : [k0, k1];
	  };
	
	  zoom.translateExtent = function(_) {
	    return arguments.length ? (x0 = +_[0][0], x1 = +_[1][0], y0 = +_[0][1], y1 = +_[1][1], zoom) : [[x0, y0], [x1, y1]];
	  };
	
	  zoom.duration = function(_) {
	    return arguments.length ? (duration = +_, zoom) : duration;
	  };
	
	  zoom.interpolate = function(_) {
	    return arguments.length ? (interpolate$$1 = _, zoom) : interpolate$$1;
	  };
	
	  zoom.on = function() {
	    var value = listeners.on.apply(listeners, arguments);
	    return value === listeners ? zoom : value;
	  };
	
	  return zoom;
	};
	
	var constant$11 = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var BrushEvent = function(target, type, selection) {
	  this.target = target;
	  this.type = type;
	  this.selection = selection;
	};
	
	function nopropagation$2() {
	  exports.event.stopImmediatePropagation();
	}
	
	var noevent$2 = function() {
	  exports.event.preventDefault();
	  exports.event.stopImmediatePropagation();
	};
	
	var MODE_DRAG = {name: "drag"};
	var MODE_SPACE = {name: "space"};
	var MODE_HANDLE = {name: "handle"};
	var MODE_CENTER = {name: "center"};
	
	var X = {
	  name: "x",
	  handles: ["e", "w"].map(type$1),
	  input: function(x, e) { return x && [[x[0], e[0][1]], [x[1], e[1][1]]]; },
	  output: function(xy) { return xy && [xy[0][0], xy[1][0]]; }
	};
	
	var Y = {
	  name: "y",
	  handles: ["n", "s"].map(type$1),
	  input: function(y, e) { return y && [[e[0][0], y[0]], [e[1][0], y[1]]]; },
	  output: function(xy) { return xy && [xy[0][1], xy[1][1]]; }
	};
	
	var XY = {
	  name: "xy",
	  handles: ["n", "e", "s", "w", "nw", "ne", "se", "sw"].map(type$1),
	  input: function(xy) { return xy; },
	  output: function(xy) { return xy; }
	};
	
	var cursors = {
	  overlay: "crosshair",
	  selection: "move",
	  n: "ns-resize",
	  e: "ew-resize",
	  s: "ns-resize",
	  w: "ew-resize",
	  nw: "nwse-resize",
	  ne: "nesw-resize",
	  se: "nwse-resize",
	  sw: "nesw-resize"
	};
	
	var flipX = {
	  e: "w",
	  w: "e",
	  nw: "ne",
	  ne: "nw",
	  se: "sw",
	  sw: "se"
	};
	
	var flipY = {
	  n: "s",
	  s: "n",
	  nw: "sw",
	  ne: "se",
	  se: "ne",
	  sw: "nw"
	};
	
	var signsX = {
	  overlay: +1,
	  selection: +1,
	  n: null,
	  e: +1,
	  s: null,
	  w: -1,
	  nw: -1,
	  ne: +1,
	  se: +1,
	  sw: -1
	};
	
	var signsY = {
	  overlay: +1,
	  selection: +1,
	  n: -1,
	  e: null,
	  s: +1,
	  w: null,
	  nw: -1,
	  ne: -1,
	  se: +1,
	  sw: +1
	};
	
	function type$1(t) {
	  return {type: t};
	}
	
	// Ignore right-click, since that should open the context menu.
	function defaultFilter$2() {
	  return !exports.event.button;
	}
	
	function defaultExtent$1() {
	  var svg = this.ownerSVGElement || this;
	  return [[0, 0], [svg.width.baseVal.value, svg.height.baseVal.value]];
	}
	
	// Like d3.local, but with the name “__brush” rather than auto-generated.
	function local$1(node) {
	  while (!node.__brush) if (!(node = node.parentNode)) return;
	  return node.__brush;
	}
	
	function empty$1(extent) {
	  return extent[0][0] === extent[1][0]
	      || extent[0][1] === extent[1][1];
	}
	
	function brushSelection(node) {
	  var state = node.__brush;
	  return state ? state.dim.output(state.selection) : null;
	}
	
	function brushX() {
	  return brush$1(X);
	}
	
	function brushY() {
	  return brush$1(Y);
	}
	
	var brush = function() {
	  return brush$1(XY);
	};
	
	function brush$1(dim) {
	  var extent = defaultExtent$1,
	      filter = defaultFilter$2,
	      listeners = dispatch(brush, "start", "brush", "end"),
	      handleSize = 6,
	      touchending;
	
	  function brush(group) {
	    var overlay = group
	        .property("__brush", initialize)
	      .selectAll(".overlay")
	      .data([type$1("overlay")]);
	
	    overlay.enter().append("rect")
	        .attr("class", "overlay")
	        .attr("pointer-events", "all")
	        .attr("cursor", cursors.overlay)
	      .merge(overlay)
	        .each(function() {
	          var extent = local$1(this).extent;
	          select(this)
	              .attr("x", extent[0][0])
	              .attr("y", extent[0][1])
	              .attr("width", extent[1][0] - extent[0][0])
	              .attr("height", extent[1][1] - extent[0][1]);
	        });
	
	    group.selectAll(".selection")
	      .data([type$1("selection")])
	      .enter().append("rect")
	        .attr("class", "selection")
	        .attr("cursor", cursors.selection)
	        .attr("fill", "#777")
	        .attr("fill-opacity", 0.3)
	        .attr("stroke", "#fff")
	        .attr("shape-rendering", "crispEdges");
	
	    var handle = group.selectAll(".handle")
	      .data(dim.handles, function(d) { return d.type; });
	
	    handle.exit().remove();
	
	    handle.enter().append("rect")
	        .attr("class", function(d) { return "handle handle--" + d.type; })
	        .attr("cursor", function(d) { return cursors[d.type]; });
	
	    group
	        .each(redraw)
	        .attr("fill", "none")
	        .attr("pointer-events", "all")
	        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)")
	        .on("mousedown.brush touchstart.brush", started);
	  }
	
	  brush.move = function(group, selection$$1) {
	    if (group.selection) {
	      group
	          .on("start.brush", function() { emitter(this, arguments).beforestart().start(); })
	          .on("interrupt.brush end.brush", function() { emitter(this, arguments).end(); })
	          .tween("brush", function() {
	            var that = this,
	                state = that.__brush,
	                emit = emitter(that, arguments),
	                selection0 = state.selection,
	                selection1 = dim.input(typeof selection$$1 === "function" ? selection$$1.apply(this, arguments) : selection$$1, state.extent),
	                i = interpolate(selection0, selection1);
	
	            function tween(t) {
	              state.selection = t === 1 && empty$1(selection1) ? null : i(t);
	              redraw.call(that);
	              emit.brush();
	            }
	
	            return selection0 && selection1 ? tween : tween(1);
	          });
	    } else {
	      group
	          .each(function() {
	            var that = this,
	                args = arguments,
	                state = that.__brush,
	                selection1 = dim.input(typeof selection$$1 === "function" ? selection$$1.apply(that, args) : selection$$1, state.extent),
	                emit = emitter(that, args).beforestart();
	
	            interrupt(that);
	            state.selection = selection1 == null || empty$1(selection1) ? null : selection1;
	            redraw.call(that);
	            emit.start().brush().end();
	          });
	    }
	  };
	
	  function redraw() {
	    var group = select(this),
	        selection$$1 = local$1(this).selection;
	
	    if (selection$$1) {
	      group.selectAll(".selection")
	          .style("display", null)
	          .attr("x", selection$$1[0][0])
	          .attr("y", selection$$1[0][1])
	          .attr("width", selection$$1[1][0] - selection$$1[0][0])
	          .attr("height", selection$$1[1][1] - selection$$1[0][1]);
	
	      group.selectAll(".handle")
	          .style("display", null)
	          .attr("x", function(d) { return d.type[d.type.length - 1] === "e" ? selection$$1[1][0] - handleSize / 2 : selection$$1[0][0] - handleSize / 2; })
	          .attr("y", function(d) { return d.type[0] === "s" ? selection$$1[1][1] - handleSize / 2 : selection$$1[0][1] - handleSize / 2; })
	          .attr("width", function(d) { return d.type === "n" || d.type === "s" ? selection$$1[1][0] - selection$$1[0][0] + handleSize : handleSize; })
	          .attr("height", function(d) { return d.type === "e" || d.type === "w" ? selection$$1[1][1] - selection$$1[0][1] + handleSize : handleSize; });
	    }
	
	    else {
	      group.selectAll(".selection,.handle")
	          .style("display", "none")
	          .attr("x", null)
	          .attr("y", null)
	          .attr("width", null)
	          .attr("height", null);
	    }
	  }
	
	  function emitter(that, args) {
	    return that.__brush.emitter || new Emitter(that, args);
	  }
	
	  function Emitter(that, args) {
	    this.that = that;
	    this.args = args;
	    this.state = that.__brush;
	    this.active = 0;
	  }
	
	  Emitter.prototype = {
	    beforestart: function() {
	      if (++this.active === 1) this.state.emitter = this, this.starting = true;
	      return this;
	    },
	    start: function() {
	      if (this.starting) this.starting = false, this.emit("start");
	      return this;
	    },
	    brush: function() {
	      this.emit("brush");
	      return this;
	    },
	    end: function() {
	      if (--this.active === 0) delete this.state.emitter, this.emit("end");
	      return this;
	    },
	    emit: function(type) {
	      customEvent(new BrushEvent(brush, type, dim.output(this.state.selection)), listeners.apply, listeners, [type, this.that, this.args]);
	    }
	  };
	
	  function started() {
	    if (exports.event.touches) { if (exports.event.changedTouches.length < exports.event.touches.length) return noevent$2(); }
	    else if (touchending) return;
	    if (!filter.apply(this, arguments)) return;
	
	    var that = this,
	        type = exports.event.target.__data__.type,
	        mode = (exports.event.metaKey ? type = "overlay" : type) === "selection" ? MODE_DRAG : (exports.event.altKey ? MODE_CENTER : MODE_HANDLE),
	        signX = dim === Y ? null : signsX[type],
	        signY = dim === X ? null : signsY[type],
	        state = local$1(that),
	        extent = state.extent,
	        selection$$1 = state.selection,
	        W = extent[0][0], w0, w1,
	        N = extent[0][1], n0, n1,
	        E = extent[1][0], e0, e1,
	        S = extent[1][1], s0, s1,
	        dx,
	        dy,
	        moving,
	        shifting = signX && signY && exports.event.shiftKey,
	        lockX,
	        lockY,
	        point0 = mouse(that),
	        point = point0,
	        emit = emitter(that, arguments).beforestart();
	
	    if (type === "overlay") {
	      state.selection = selection$$1 = [
	        [w0 = dim === Y ? W : point0[0], n0 = dim === X ? N : point0[1]],
	        [e0 = dim === Y ? E : w0, s0 = dim === X ? S : n0]
	      ];
	    } else {
	      w0 = selection$$1[0][0];
	      n0 = selection$$1[0][1];
	      e0 = selection$$1[1][0];
	      s0 = selection$$1[1][1];
	    }
	
	    w1 = w0;
	    n1 = n0;
	    e1 = e0;
	    s1 = s0;
	
	    var group = select(that)
	        .attr("pointer-events", "none");
	
	    var overlay = group.selectAll(".overlay")
	        .attr("cursor", cursors[type]);
	
	    if (exports.event.touches) {
	      group
	          .on("touchmove.brush", moved, true)
	          .on("touchend.brush touchcancel.brush", ended, true);
	    } else {
	      var view = select(exports.event.view)
	          .on("keydown.brush", keydowned, true)
	          .on("keyup.brush", keyupped, true)
	          .on("mousemove.brush", moved, true)
	          .on("mouseup.brush", ended, true);
	
	      dragDisable(exports.event.view);
	    }
	
	    nopropagation$2();
	    interrupt(that);
	    redraw.call(that);
	    emit.start();
	
	    function moved() {
	      var point1 = mouse(that);
	      if (shifting && !lockX && !lockY) {
	        if (Math.abs(point1[0] - point[0]) > Math.abs(point1[1] - point[1])) lockY = true;
	        else lockX = true;
	      }
	      point = point1;
	      moving = true;
	      noevent$2();
	      move();
	    }
	
	    function move() {
	      var t;
	
	      dx = point[0] - point0[0];
	      dy = point[1] - point0[1];
	
	      switch (mode) {
	        case MODE_SPACE:
	        case MODE_DRAG: {
	          if (signX) dx = Math.max(W - w0, Math.min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
	          if (signY) dy = Math.max(N - n0, Math.min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
	          break;
	        }
	        case MODE_HANDLE: {
	          if (signX < 0) dx = Math.max(W - w0, Math.min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
	          else if (signX > 0) dx = Math.max(W - e0, Math.min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
	          if (signY < 0) dy = Math.max(N - n0, Math.min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
	          else if (signY > 0) dy = Math.max(N - s0, Math.min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
	          break;
	        }
	        case MODE_CENTER: {
	          if (signX) w1 = Math.max(W, Math.min(E, w0 - dx * signX)), e1 = Math.max(W, Math.min(E, e0 + dx * signX));
	          if (signY) n1 = Math.max(N, Math.min(S, n0 - dy * signY)), s1 = Math.max(N, Math.min(S, s0 + dy * signY));
	          break;
	        }
	      }
	
	      if (e1 < w1) {
	        signX *= -1;
	        t = w0, w0 = e0, e0 = t;
	        t = w1, w1 = e1, e1 = t;
	        if (type in flipX) overlay.attr("cursor", cursors[type = flipX[type]]);
	      }
	
	      if (s1 < n1) {
	        signY *= -1;
	        t = n0, n0 = s0, s0 = t;
	        t = n1, n1 = s1, s1 = t;
	        if (type in flipY) overlay.attr("cursor", cursors[type = flipY[type]]);
	      }
	
	      if (state.selection) selection$$1 = state.selection; // May be set by brush.move!
	      if (lockX) w1 = selection$$1[0][0], e1 = selection$$1[1][0];
	      if (lockY) n1 = selection$$1[0][1], s1 = selection$$1[1][1];
	
	      if (selection$$1[0][0] !== w1
	          || selection$$1[0][1] !== n1
	          || selection$$1[1][0] !== e1
	          || selection$$1[1][1] !== s1) {
	        state.selection = [[w1, n1], [e1, s1]];
	        redraw.call(that);
	        emit.brush();
	      }
	    }
	
	    function ended() {
	      nopropagation$2();
	      if (exports.event.touches) {
	        if (exports.event.touches.length) return;
	        if (touchending) clearTimeout(touchending);
	        touchending = setTimeout(function() { touchending = null; }, 500); // Ghost clicks are delayed!
	        group.on("touchmove.brush touchend.brush touchcancel.brush", null);
	      } else {
	        yesdrag(exports.event.view, moving);
	        view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
	      }
	      group.attr("pointer-events", "all");
	      overlay.attr("cursor", cursors.overlay);
	      if (state.selection) selection$$1 = state.selection; // May be set by brush.move (on start)!
	      if (empty$1(selection$$1)) state.selection = null, redraw.call(that);
	      emit.end();
	    }
	
	    function keydowned() {
	      switch (exports.event.keyCode) {
	        case 16: { // SHIFT
	          shifting = signX && signY;
	          break;
	        }
	        case 18: { // ALT
	          if (mode === MODE_HANDLE) {
	            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
	            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
	            mode = MODE_CENTER;
	            move();
	          }
	          break;
	        }
	        case 32: { // SPACE; takes priority over ALT
	          if (mode === MODE_HANDLE || mode === MODE_CENTER) {
	            if (signX < 0) e0 = e1 - dx; else if (signX > 0) w0 = w1 - dx;
	            if (signY < 0) s0 = s1 - dy; else if (signY > 0) n0 = n1 - dy;
	            mode = MODE_SPACE;
	            overlay.attr("cursor", cursors.selection);
	            move();
	          }
	          break;
	        }
	        default: return;
	      }
	      noevent$2();
	    }
	
	    function keyupped() {
	      switch (exports.event.keyCode) {
	        case 16: { // SHIFT
	          if (shifting) {
	            lockX = lockY = shifting = false;
	            move();
	          }
	          break;
	        }
	        case 18: { // ALT
	          if (mode === MODE_CENTER) {
	            if (signX < 0) e0 = e1; else if (signX > 0) w0 = w1;
	            if (signY < 0) s0 = s1; else if (signY > 0) n0 = n1;
	            mode = MODE_HANDLE;
	            move();
	          }
	          break;
	        }
	        case 32: { // SPACE
	          if (mode === MODE_SPACE) {
	            if (exports.event.altKey) {
	              if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
	              if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
	              mode = MODE_CENTER;
	            } else {
	              if (signX < 0) e0 = e1; else if (signX > 0) w0 = w1;
	              if (signY < 0) s0 = s1; else if (signY > 0) n0 = n1;
	              mode = MODE_HANDLE;
	            }
	            overlay.attr("cursor", cursors[type]);
	            move();
	          }
	          break;
	        }
	        default: return;
	      }
	      noevent$2();
	    }
	  }
	
	  function initialize() {
	    var state = this.__brush || {selection: null};
	    state.extent = extent.apply(this, arguments);
	    state.dim = dim;
	    return state;
	  }
	
	  brush.extent = function(_) {
	    return arguments.length ? (extent = typeof _ === "function" ? _ : constant$11([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), brush) : extent;
	  };
	
	  brush.filter = function(_) {
	    return arguments.length ? (filter = typeof _ === "function" ? _ : constant$11(!!_), brush) : filter;
	  };
	
	  brush.handleSize = function(_) {
	    return arguments.length ? (handleSize = +_, brush) : handleSize;
	  };
	
	  brush.on = function() {
	    var value = listeners.on.apply(listeners, arguments);
	    return value === listeners ? brush : value;
	  };
	
	  return brush;
	}
	
	var cos = Math.cos;
	var sin = Math.sin;
	var pi$3 = Math.PI;
	var halfPi$2 = pi$3 / 2;
	var tau$3 = pi$3 * 2;
	var max$1 = Math.max;
	
	function compareValue(compare) {
	  return function(a, b) {
	    return compare(
	      a.source.value + a.target.value,
	      b.source.value + b.target.value
	    );
	  };
	}
	
	var chord = function() {
	  var padAngle = 0,
	      sortGroups = null,
	      sortSubgroups = null,
	      sortChords = null;
	
	  function chord(matrix) {
	    var n = matrix.length,
	        groupSums = [],
	        groupIndex = range(n),
	        subgroupIndex = [],
	        chords = [],
	        groups = chords.groups = new Array(n),
	        subgroups = new Array(n * n),
	        k,
	        x,
	        x0,
	        dx,
	        i,
	        j;
	
	    // Compute the sum.
	    k = 0, i = -1; while (++i < n) {
	      x = 0, j = -1; while (++j < n) {
	        x += matrix[i][j];
	      }
	      groupSums.push(x);
	      subgroupIndex.push(range(n));
	      k += x;
	    }
	
	    // Sort groups…
	    if (sortGroups) groupIndex.sort(function(a, b) {
	      return sortGroups(groupSums[a], groupSums[b]);
	    });
	
	    // Sort subgroups…
	    if (sortSubgroups) subgroupIndex.forEach(function(d, i) {
	      d.sort(function(a, b) {
	        return sortSubgroups(matrix[i][a], matrix[i][b]);
	      });
	    });
	
	    // Convert the sum to scaling factor for [0, 2pi].
	    // TODO Allow start and end angle to be specified?
	    // TODO Allow padding to be specified as percentage?
	    k = max$1(0, tau$3 - padAngle * n) / k;
	    dx = k ? padAngle : tau$3 / n;
	
	    // Compute the start and end angle for each group and subgroup.
	    // Note: Opera has a bug reordering object literal properties!
	    x = 0, i = -1; while (++i < n) {
	      x0 = x, j = -1; while (++j < n) {
	        var di = groupIndex[i],
	            dj = subgroupIndex[di][j],
	            v = matrix[di][dj],
	            a0 = x,
	            a1 = x += v * k;
	        subgroups[dj * n + di] = {
	          index: di,
	          subindex: dj,
	          startAngle: a0,
	          endAngle: a1,
	          value: v
	        };
	      }
	      groups[di] = {
	        index: di,
	        startAngle: x0,
	        endAngle: x,
	        value: groupSums[di]
	      };
	      x += dx;
	    }
	
	    // Generate chords for each (non-empty) subgroup-subgroup link.
	    i = -1; while (++i < n) {
	      j = i - 1; while (++j < n) {
	        var source = subgroups[j * n + i],
	            target = subgroups[i * n + j];
	        if (source.value || target.value) {
	          chords.push(source.value < target.value
	              ? {source: target, target: source}
	              : {source: source, target: target});
	        }
	      }
	    }
	
	    return sortChords ? chords.sort(sortChords) : chords;
	  }
	
	  chord.padAngle = function(_) {
	    return arguments.length ? (padAngle = max$1(0, _), chord) : padAngle;
	  };
	
	  chord.sortGroups = function(_) {
	    return arguments.length ? (sortGroups = _, chord) : sortGroups;
	  };
	
	  chord.sortSubgroups = function(_) {
	    return arguments.length ? (sortSubgroups = _, chord) : sortSubgroups;
	  };
	
	  chord.sortChords = function(_) {
	    return arguments.length ? (_ == null ? sortChords = null : (sortChords = compareValue(_))._ = _, chord) : sortChords && sortChords._;
	  };
	
	  return chord;
	};
	
	var slice$5 = Array.prototype.slice;
	
	var constant$12 = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function defaultSource(d) {
	  return d.source;
	}
	
	function defaultTarget(d) {
	  return d.target;
	}
	
	function defaultRadius$1(d) {
	  return d.radius;
	}
	
	function defaultStartAngle(d) {
	  return d.startAngle;
	}
	
	function defaultEndAngle(d) {
	  return d.endAngle;
	}
	
	var ribbon = function() {
	  var source = defaultSource,
	      target = defaultTarget,
	      radius = defaultRadius$1,
	      startAngle = defaultStartAngle,
	      endAngle = defaultEndAngle,
	      context = null;
	
	  function ribbon() {
	    var buffer,
	        argv = slice$5.call(arguments),
	        s = source.apply(this, argv),
	        t = target.apply(this, argv),
	        sr = +radius.apply(this, (argv[0] = s, argv)),
	        sa0 = startAngle.apply(this, argv) - halfPi$2,
	        sa1 = endAngle.apply(this, argv) - halfPi$2,
	        sx0 = sr * cos(sa0),
	        sy0 = sr * sin(sa0),
	        tr = +radius.apply(this, (argv[0] = t, argv)),
	        ta0 = startAngle.apply(this, argv) - halfPi$2,
	        ta1 = endAngle.apply(this, argv) - halfPi$2;
	
	    if (!context) context = buffer = path();
	
	    context.moveTo(sx0, sy0);
	    context.arc(0, 0, sr, sa0, sa1);
	    if (sa0 !== ta0 || sa1 !== ta1) { // TODO sr !== tr?
	      context.quadraticCurveTo(0, 0, tr * cos(ta0), tr * sin(ta0));
	      context.arc(0, 0, tr, ta0, ta1);
	    }
	    context.quadraticCurveTo(0, 0, sx0, sy0);
	    context.closePath();
	
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  ribbon.radius = function(_) {
	    return arguments.length ? (radius = typeof _ === "function" ? _ : constant$12(+_), ribbon) : radius;
	  };
	
	  ribbon.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$12(+_), ribbon) : startAngle;
	  };
	
	  ribbon.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$12(+_), ribbon) : endAngle;
	  };
	
	  ribbon.source = function(_) {
	    return arguments.length ? (source = _, ribbon) : source;
	  };
	
	  ribbon.target = function(_) {
	    return arguments.length ? (target = _, ribbon) : target;
	  };
	
	  ribbon.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), ribbon) : context;
	  };
	
	  return ribbon;
	};
	
	// Adds floating point numbers with twice the normal precision.
	// Reference: J. R. Shewchuk, Adaptive Precision Floating-Point Arithmetic and
	// Fast Robust Geometric Predicates, Discrete & Computational Geometry 18(3)
	// 305–363 (1997).
	// Code adapted from GeographicLib by Charles F. F. Karney,
	// http://geographiclib.sourceforge.net/
	
	var adder = function() {
	  return new Adder;
	};
	
	function Adder() {
	  this.reset();
	}
	
	Adder.prototype = {
	  constructor: Adder,
	  reset: function() {
	    this.s = // rounded value
	    this.t = 0; // exact error
	  },
	  add: function(y) {
	    add$1(temp, y, this.t);
	    add$1(this, temp.s, this.s);
	    if (this.s) this.t += temp.t;
	    else this.s = temp.t;
	  },
	  valueOf: function() {
	    return this.s;
	  }
	};
	
	var temp = new Adder;
	
	function add$1(adder, a, b) {
	  var x = adder.s = a + b,
	      bv = x - a,
	      av = x - bv;
	  adder.t = (a - av) + (b - bv);
	}
	
	var epsilon$4 = 1e-6;
	var epsilon2$2 = 1e-12;
	var pi$4 = Math.PI;
	var halfPi$3 = pi$4 / 2;
	var quarterPi = pi$4 / 4;
	var tau$4 = pi$4 * 2;
	
	var degrees$1 = 180 / pi$4;
	var radians = pi$4 / 180;
	
	var abs = Math.abs;
	var atan = Math.atan;
	var atan2 = Math.atan2;
	var cos$1 = Math.cos;
	var ceil = Math.ceil;
	var exp = Math.exp;
	
	var log$1 = Math.log;
	var pow$1 = Math.pow;
	var sin$1 = Math.sin;
	var sign$1 = Math.sign || function(x) { return x > 0 ? 1 : x < 0 ? -1 : 0; };
	var sqrt$1 = Math.sqrt;
	var tan = Math.tan;
	
	function acos(x) {
	  return x > 1 ? 0 : x < -1 ? pi$4 : Math.acos(x);
	}
	
	function asin$1(x) {
	  return x > 1 ? halfPi$3 : x < -1 ? -halfPi$3 : Math.asin(x);
	}
	
	function haversin(x) {
	  return (x = sin$1(x / 2)) * x;
	}
	
	function noop$2() {}
	
	function streamGeometry(geometry, stream) {
	  if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) {
	    streamGeometryType[geometry.type](geometry, stream);
	  }
	}
	
	var streamObjectType = {
	  Feature: function(feature, stream) {
	    streamGeometry(feature.geometry, stream);
	  },
	  FeatureCollection: function(object, stream) {
	    var features = object.features, i = -1, n = features.length;
	    while (++i < n) streamGeometry(features[i].geometry, stream);
	  }
	};
	
	var streamGeometryType = {
	  Sphere: function(object, stream) {
	    stream.sphere();
	  },
	  Point: function(object, stream) {
	    object = object.coordinates;
	    stream.point(object[0], object[1], object[2]);
	  },
	  MultiPoint: function(object, stream) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) object = coordinates[i], stream.point(object[0], object[1], object[2]);
	  },
	  LineString: function(object, stream) {
	    streamLine(object.coordinates, stream, 0);
	  },
	  MultiLineString: function(object, stream) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) streamLine(coordinates[i], stream, 0);
	  },
	  Polygon: function(object, stream) {
	    streamPolygon(object.coordinates, stream);
	  },
	  MultiPolygon: function(object, stream) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) streamPolygon(coordinates[i], stream);
	  },
	  GeometryCollection: function(object, stream) {
	    var geometries = object.geometries, i = -1, n = geometries.length;
	    while (++i < n) streamGeometry(geometries[i], stream);
	  }
	};
	
	function streamLine(coordinates, stream, closed) {
	  var i = -1, n = coordinates.length - closed, coordinate;
	  stream.lineStart();
	  while (++i < n) coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
	  stream.lineEnd();
	}
	
	function streamPolygon(coordinates, stream) {
	  var i = -1, n = coordinates.length;
	  stream.polygonStart();
	  while (++i < n) streamLine(coordinates[i], stream, 1);
	  stream.polygonEnd();
	}
	
	var geoStream = function(object, stream) {
	  if (object && streamObjectType.hasOwnProperty(object.type)) {
	    streamObjectType[object.type](object, stream);
	  } else {
	    streamGeometry(object, stream);
	  }
	};
	
	var areaRingSum = adder();
	
	var areaSum = adder();
	var lambda00;
	var phi00;
	var lambda0;
	var cosPhi0;
	var sinPhi0;
	
	var areaStream = {
	  point: noop$2,
	  lineStart: noop$2,
	  lineEnd: noop$2,
	  polygonStart: function() {
	    areaRingSum.reset();
	    areaStream.lineStart = areaRingStart;
	    areaStream.lineEnd = areaRingEnd;
	  },
	  polygonEnd: function() {
	    var areaRing = +areaRingSum;
	    areaSum.add(areaRing < 0 ? tau$4 + areaRing : areaRing);
	    this.lineStart = this.lineEnd = this.point = noop$2;
	  },
	  sphere: function() {
	    areaSum.add(tau$4);
	  }
	};
	
	function areaRingStart() {
	  areaStream.point = areaPointFirst;
	}
	
	function areaRingEnd() {
	  areaPoint(lambda00, phi00);
	}
	
	function areaPointFirst(lambda, phi) {
	  areaStream.point = areaPoint;
	  lambda00 = lambda, phi00 = phi;
	  lambda *= radians, phi *= radians;
	  lambda0 = lambda, cosPhi0 = cos$1(phi = phi / 2 + quarterPi), sinPhi0 = sin$1(phi);
	}
	
	function areaPoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  phi = phi / 2 + quarterPi; // half the angular distance from south pole
	
	  // Spherical excess E for a spherical triangle with vertices: south pole,
	  // previous point, current point.  Uses a formula derived from Cagnoli’s
	  // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
	  var dLambda = lambda - lambda0,
	      sdLambda = dLambda >= 0 ? 1 : -1,
	      adLambda = sdLambda * dLambda,
	      cosPhi = cos$1(phi),
	      sinPhi = sin$1(phi),
	      k = sinPhi0 * sinPhi,
	      u = cosPhi0 * cosPhi + k * cos$1(adLambda),
	      v = k * sdLambda * sin$1(adLambda);
	  areaRingSum.add(atan2(v, u));
	
	  // Advance the previous points.
	  lambda0 = lambda, cosPhi0 = cosPhi, sinPhi0 = sinPhi;
	}
	
	var area$2 = function(object) {
	  areaSum.reset();
	  geoStream(object, areaStream);
	  return areaSum * 2;
	};
	
	function spherical(cartesian) {
	  return [atan2(cartesian[1], cartesian[0]), asin$1(cartesian[2])];
	}
	
	function cartesian(spherical) {
	  var lambda = spherical[0], phi = spherical[1], cosPhi = cos$1(phi);
	  return [cosPhi * cos$1(lambda), cosPhi * sin$1(lambda), sin$1(phi)];
	}
	
	function cartesianDot(a, b) {
	  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
	}
	
	function cartesianCross(a, b) {
	  return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
	}
	
	// TODO return a
	function cartesianAddInPlace(a, b) {
	  a[0] += b[0], a[1] += b[1], a[2] += b[2];
	}
	
	function cartesianScale(vector, k) {
	  return [vector[0] * k, vector[1] * k, vector[2] * k];
	}
	
	// TODO return d
	function cartesianNormalizeInPlace(d) {
	  var l = sqrt$1(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
	  d[0] /= l, d[1] /= l, d[2] /= l;
	}
	
	var lambda0$1;
	var phi0;
	var lambda1;
	var phi1;
	var lambda2;
	var lambda00$1;
	var phi00$1;
	var p0;
	var deltaSum = adder();
	var ranges;
	var range$1;
	
	var boundsStream = {
	  point: boundsPoint,
	  lineStart: boundsLineStart,
	  lineEnd: boundsLineEnd,
	  polygonStart: function() {
	    boundsStream.point = boundsRingPoint;
	    boundsStream.lineStart = boundsRingStart;
	    boundsStream.lineEnd = boundsRingEnd;
	    deltaSum.reset();
	    areaStream.polygonStart();
	  },
	  polygonEnd: function() {
	    areaStream.polygonEnd();
	    boundsStream.point = boundsPoint;
	    boundsStream.lineStart = boundsLineStart;
	    boundsStream.lineEnd = boundsLineEnd;
	    if (areaRingSum < 0) lambda0$1 = -(lambda1 = 180), phi0 = -(phi1 = 90);
	    else if (deltaSum > epsilon$4) phi1 = 90;
	    else if (deltaSum < -epsilon$4) phi0 = -90;
	    range$1[0] = lambda0$1, range$1[1] = lambda1;
	  }
	};
	
	function boundsPoint(lambda, phi) {
	  ranges.push(range$1 = [lambda0$1 = lambda, lambda1 = lambda]);
	  if (phi < phi0) phi0 = phi;
	  if (phi > phi1) phi1 = phi;
	}
	
	function linePoint(lambda, phi) {
	  var p = cartesian([lambda * radians, phi * radians]);
	  if (p0) {
	    var normal = cartesianCross(p0, p),
	        equatorial = [normal[1], -normal[0], 0],
	        inflection = cartesianCross(equatorial, normal);
	    cartesianNormalizeInPlace(inflection);
	    inflection = spherical(inflection);
	    var delta = lambda - lambda2,
	        sign$$1 = delta > 0 ? 1 : -1,
	        lambdai = inflection[0] * degrees$1 * sign$$1,
	        phii,
	        antimeridian = abs(delta) > 180;
	    if (antimeridian ^ (sign$$1 * lambda2 < lambdai && lambdai < sign$$1 * lambda)) {
	      phii = inflection[1] * degrees$1;
	      if (phii > phi1) phi1 = phii;
	    } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign$$1 * lambda2 < lambdai && lambdai < sign$$1 * lambda)) {
	      phii = -inflection[1] * degrees$1;
	      if (phii < phi0) phi0 = phii;
	    } else {
	      if (phi < phi0) phi0 = phi;
	      if (phi > phi1) phi1 = phi;
	    }
	    if (antimeridian) {
	      if (lambda < lambda2) {
	        if (angle(lambda0$1, lambda) > angle(lambda0$1, lambda1)) lambda1 = lambda;
	      } else {
	        if (angle(lambda, lambda1) > angle(lambda0$1, lambda1)) lambda0$1 = lambda;
	      }
	    } else {
	      if (lambda1 >= lambda0$1) {
	        if (lambda < lambda0$1) lambda0$1 = lambda;
	        if (lambda > lambda1) lambda1 = lambda;
	      } else {
	        if (lambda > lambda2) {
	          if (angle(lambda0$1, lambda) > angle(lambda0$1, lambda1)) lambda1 = lambda;
	        } else {
	          if (angle(lambda, lambda1) > angle(lambda0$1, lambda1)) lambda0$1 = lambda;
	        }
	      }
	    }
	  } else {
	    boundsPoint(lambda, phi);
	  }
	  p0 = p, lambda2 = lambda;
	}
	
	function boundsLineStart() {
	  boundsStream.point = linePoint;
	}
	
	function boundsLineEnd() {
	  range$1[0] = lambda0$1, range$1[1] = lambda1;
	  boundsStream.point = boundsPoint;
	  p0 = null;
	}
	
	function boundsRingPoint(lambda, phi) {
	  if (p0) {
	    var delta = lambda - lambda2;
	    deltaSum.add(abs(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
	  } else {
	    lambda00$1 = lambda, phi00$1 = phi;
	  }
	  areaStream.point(lambda, phi);
	  linePoint(lambda, phi);
	}
	
	function boundsRingStart() {
	  areaStream.lineStart();
	}
	
	function boundsRingEnd() {
	  boundsRingPoint(lambda00$1, phi00$1);
	  areaStream.lineEnd();
	  if (abs(deltaSum) > epsilon$4) lambda0$1 = -(lambda1 = 180);
	  range$1[0] = lambda0$1, range$1[1] = lambda1;
	  p0 = null;
	}
	
	// Finds the left-right distance between two longitudes.
	// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
	// the distance between ±180° to be 360°.
	function angle(lambda0, lambda1) {
	  return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
	}
	
	function rangeCompare(a, b) {
	  return a[0] - b[0];
	}
	
	function rangeContains(range, x) {
	  return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
	}
	
	var bounds = function(feature) {
	  var i, n, a, b, merged, deltaMax, delta;
	
	  phi1 = lambda1 = -(lambda0$1 = phi0 = Infinity);
	  ranges = [];
	  geoStream(feature, boundsStream);
	
	  // First, sort ranges by their minimum longitudes.
	  if (n = ranges.length) {
	    ranges.sort(rangeCompare);
	
	    // Then, merge any ranges that overlap.
	    for (i = 1, a = ranges[0], merged = [a]; i < n; ++i) {
	      b = ranges[i];
	      if (rangeContains(a, b[0]) || rangeContains(a, b[1])) {
	        if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
	        if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
	      } else {
	        merged.push(a = b);
	      }
	    }
	
	    // Finally, find the largest gap between the merged ranges.
	    // The final bounding box will be the inverse of this gap.
	    for (deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i) {
	      b = merged[i];
	      if ((delta = angle(a[1], b[0])) > deltaMax) deltaMax = delta, lambda0$1 = b[0], lambda1 = a[1];
	    }
	  }
	
	  ranges = range$1 = null;
	
	  return lambda0$1 === Infinity || phi0 === Infinity
	      ? [[NaN, NaN], [NaN, NaN]]
	      : [[lambda0$1, phi0], [lambda1, phi1]];
	};
	
	var W0;
	var W1;
	var X0;
	var Y0;
	var Z0;
	var X1;
	var Y1;
	var Z1;
	var X2;
	var Y2;
	var Z2;
	var lambda00$2;
	var phi00$2;
	var x0;
	var y0;
	var z0; // previous point
	
	var centroidStream = {
	  sphere: noop$2,
	  point: centroidPoint,
	  lineStart: centroidLineStart,
	  lineEnd: centroidLineEnd,
	  polygonStart: function() {
	    centroidStream.lineStart = centroidRingStart;
	    centroidStream.lineEnd = centroidRingEnd;
	  },
	  polygonEnd: function() {
	    centroidStream.lineStart = centroidLineStart;
	    centroidStream.lineEnd = centroidLineEnd;
	  }
	};
	
	// Arithmetic mean of Cartesian vectors.
	function centroidPoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var cosPhi = cos$1(phi);
	  centroidPointCartesian(cosPhi * cos$1(lambda), cosPhi * sin$1(lambda), sin$1(phi));
	}
	
	function centroidPointCartesian(x, y, z) {
	  ++W0;
	  X0 += (x - X0) / W0;
	  Y0 += (y - Y0) / W0;
	  Z0 += (z - Z0) / W0;
	}
	
	function centroidLineStart() {
	  centroidStream.point = centroidLinePointFirst;
	}
	
	function centroidLinePointFirst(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var cosPhi = cos$1(phi);
	  x0 = cosPhi * cos$1(lambda);
	  y0 = cosPhi * sin$1(lambda);
	  z0 = sin$1(phi);
	  centroidStream.point = centroidLinePoint;
	  centroidPointCartesian(x0, y0, z0);
	}
	
	function centroidLinePoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var cosPhi = cos$1(phi),
	      x = cosPhi * cos$1(lambda),
	      y = cosPhi * sin$1(lambda),
	      z = sin$1(phi),
	      w = atan2(sqrt$1((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
	  W1 += w;
	  X1 += w * (x0 + (x0 = x));
	  Y1 += w * (y0 + (y0 = y));
	  Z1 += w * (z0 + (z0 = z));
	  centroidPointCartesian(x0, y0, z0);
	}
	
	function centroidLineEnd() {
	  centroidStream.point = centroidPoint;
	}
	
	// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
	// J. Applied Mechanics 42, 239 (1975).
	function centroidRingStart() {
	  centroidStream.point = centroidRingPointFirst;
	}
	
	function centroidRingEnd() {
	  centroidRingPoint(lambda00$2, phi00$2);
	  centroidStream.point = centroidPoint;
	}
	
	function centroidRingPointFirst(lambda, phi) {
	  lambda00$2 = lambda, phi00$2 = phi;
	  lambda *= radians, phi *= radians;
	  centroidStream.point = centroidRingPoint;
	  var cosPhi = cos$1(phi);
	  x0 = cosPhi * cos$1(lambda);
	  y0 = cosPhi * sin$1(lambda);
	  z0 = sin$1(phi);
	  centroidPointCartesian(x0, y0, z0);
	}
	
	function centroidRingPoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var cosPhi = cos$1(phi),
	      x = cosPhi * cos$1(lambda),
	      y = cosPhi * sin$1(lambda),
	      z = sin$1(phi),
	      cx = y0 * z - z0 * y,
	      cy = z0 * x - x0 * z,
	      cz = x0 * y - y0 * x,
	      m = sqrt$1(cx * cx + cy * cy + cz * cz),
	      u = x0 * x + y0 * y + z0 * z,
	      v = m && -acos(u) / m, // area weight
	      w = atan2(m, u); // line weight
	  X2 += v * cx;
	  Y2 += v * cy;
	  Z2 += v * cz;
	  W1 += w;
	  X1 += w * (x0 + (x0 = x));
	  Y1 += w * (y0 + (y0 = y));
	  Z1 += w * (z0 + (z0 = z));
	  centroidPointCartesian(x0, y0, z0);
	}
	
	var centroid$1 = function(object) {
	  W0 = W1 =
	  X0 = Y0 = Z0 =
	  X1 = Y1 = Z1 =
	  X2 = Y2 = Z2 = 0;
	  geoStream(object, centroidStream);
	
	  var x = X2,
	      y = Y2,
	      z = Z2,
	      m = x * x + y * y + z * z;
	
	  // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
	  if (m < epsilon2$2) {
	    x = X1, y = Y1, z = Z1;
	    // If the feature has zero length, fall back to arithmetic mean of point vectors.
	    if (W1 < epsilon$4) x = X0, y = Y0, z = Z0;
	    m = x * x + y * y + z * z;
	    // If the feature still has an undefined ccentroid, then return.
	    if (m < epsilon2$2) return [NaN, NaN];
	  }
	
	  return [atan2(y, x) * degrees$1, asin$1(z / sqrt$1(m)) * degrees$1];
	};
	
	var constant$13 = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var compose = function(a, b) {
	
	  function compose(x, y) {
	    return x = a(x, y), b(x[0], x[1]);
	  }
	
	  if (a.invert && b.invert) compose.invert = function(x, y) {
	    return x = b.invert(x, y), x && a.invert(x[0], x[1]);
	  };
	
	  return compose;
	};
	
	function rotationIdentity(lambda, phi) {
	  return [lambda > pi$4 ? lambda - tau$4 : lambda < -pi$4 ? lambda + tau$4 : lambda, phi];
	}
	
	rotationIdentity.invert = rotationIdentity;
	
	function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
	  return (deltaLambda %= tau$4) ? (deltaPhi || deltaGamma ? compose(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma))
	    : rotationLambda(deltaLambda))
	    : (deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma)
	    : rotationIdentity);
	}
	
	function forwardRotationLambda(deltaLambda) {
	  return function(lambda, phi) {
	    return lambda += deltaLambda, [lambda > pi$4 ? lambda - tau$4 : lambda < -pi$4 ? lambda + tau$4 : lambda, phi];
	  };
	}
	
	function rotationLambda(deltaLambda) {
	  var rotation = forwardRotationLambda(deltaLambda);
	  rotation.invert = forwardRotationLambda(-deltaLambda);
	  return rotation;
	}
	
	function rotationPhiGamma(deltaPhi, deltaGamma) {
	  var cosDeltaPhi = cos$1(deltaPhi),
	      sinDeltaPhi = sin$1(deltaPhi),
	      cosDeltaGamma = cos$1(deltaGamma),
	      sinDeltaGamma = sin$1(deltaGamma);
	
	  function rotation(lambda, phi) {
	    var cosPhi = cos$1(phi),
	        x = cos$1(lambda) * cosPhi,
	        y = sin$1(lambda) * cosPhi,
	        z = sin$1(phi),
	        k = z * cosDeltaPhi + x * sinDeltaPhi;
	    return [
	      atan2(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
	      asin$1(k * cosDeltaGamma + y * sinDeltaGamma)
	    ];
	  }
	
	  rotation.invert = function(lambda, phi) {
	    var cosPhi = cos$1(phi),
	        x = cos$1(lambda) * cosPhi,
	        y = sin$1(lambda) * cosPhi,
	        z = sin$1(phi),
	        k = z * cosDeltaGamma - y * sinDeltaGamma;
	    return [
	      atan2(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
	      asin$1(k * cosDeltaPhi - x * sinDeltaPhi)
	    ];
	  };
	
	  return rotation;
	}
	
	var rotation = function(rotate) {
	  rotate = rotateRadians(rotate[0] * radians, rotate[1] * radians, rotate.length > 2 ? rotate[2] * radians : 0);
	
	  function forward(coordinates) {
	    coordinates = rotate(coordinates[0] * radians, coordinates[1] * radians);
	    return coordinates[0] *= degrees$1, coordinates[1] *= degrees$1, coordinates;
	  }
	
	  forward.invert = function(coordinates) {
	    coordinates = rotate.invert(coordinates[0] * radians, coordinates[1] * radians);
	    return coordinates[0] *= degrees$1, coordinates[1] *= degrees$1, coordinates;
	  };
	
	  return forward;
	};
	
	// Generates a circle centered at [0°, 0°], with a given radius and precision.
	function circleStream(stream, radius, delta, direction, t0, t1) {
	  if (!delta) return;
	  var cosRadius = cos$1(radius),
	      sinRadius = sin$1(radius),
	      step = direction * delta;
	  if (t0 == null) {
	    t0 = radius + direction * tau$4;
	    t1 = radius - step / 2;
	  } else {
	    t0 = circleRadius(cosRadius, t0);
	    t1 = circleRadius(cosRadius, t1);
	    if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * tau$4;
	  }
	  for (var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step) {
	    point = spherical([cosRadius, -sinRadius * cos$1(t), -sinRadius * sin$1(t)]);
	    stream.point(point[0], point[1]);
	  }
	}
	
	// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
	function circleRadius(cosRadius, point) {
	  point = cartesian(point), point[0] -= cosRadius;
	  cartesianNormalizeInPlace(point);
	  var radius = acos(-point[1]);
	  return ((-point[2] < 0 ? -radius : radius) + tau$4 - epsilon$4) % tau$4;
	}
	
	var circle$1 = function() {
	  var center = constant$13([0, 0]),
	      radius = constant$13(90),
	      precision = constant$13(6),
	      ring,
	      rotate,
	      stream = {point: point};
	
	  function point(x, y) {
	    ring.push(x = rotate(x, y));
	    x[0] *= degrees$1, x[1] *= degrees$1;
	  }
	
	  function circle() {
	    var c = center.apply(this, arguments),
	        r = radius.apply(this, arguments) * radians,
	        p = precision.apply(this, arguments) * radians;
	    ring = [];
	    rotate = rotateRadians(-c[0] * radians, -c[1] * radians, 0).invert;
	    circleStream(stream, r, p, 1);
	    c = {type: "Polygon", coordinates: [ring]};
	    ring = rotate = null;
	    return c;
	  }
	
	  circle.center = function(_) {
	    return arguments.length ? (center = typeof _ === "function" ? _ : constant$13([+_[0], +_[1]]), circle) : center;
	  };
	
	  circle.radius = function(_) {
	    return arguments.length ? (radius = typeof _ === "function" ? _ : constant$13(+_), circle) : radius;
	  };
	
	  circle.precision = function(_) {
	    return arguments.length ? (precision = typeof _ === "function" ? _ : constant$13(+_), circle) : precision;
	  };
	
	  return circle;
	};
	
	var clipBuffer = function() {
	  var lines = [],
	      line;
	  return {
	    point: function(x, y) {
	      line.push([x, y]);
	    },
	    lineStart: function() {
	      lines.push(line = []);
	    },
	    lineEnd: noop$2,
	    rejoin: function() {
	      if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
	    },
	    result: function() {
	      var result = lines;
	      lines = [];
	      line = null;
	      return result;
	    }
	  };
	};
	
	var clipLine = function(a, b, x0, y0, x1, y1) {
	  var ax = a[0],
	      ay = a[1],
	      bx = b[0],
	      by = b[1],
	      t0 = 0,
	      t1 = 1,
	      dx = bx - ax,
	      dy = by - ay,
	      r;
	
	  r = x0 - ax;
	  if (!dx && r > 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dx > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = x1 - ax;
	  if (!dx && r < 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dx > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  r = y0 - ay;
	  if (!dy && r > 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dy > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = y1 - ay;
	  if (!dy && r < 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dy > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
	  if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
	  return true;
	};
	
	var pointEqual = function(a, b) {
	  return abs(a[0] - b[0]) < epsilon$4 && abs(a[1] - b[1]) < epsilon$4;
	};
	
	function Intersection(point, points, other, entry) {
	  this.x = point;
	  this.z = points;
	  this.o = other; // another intersection
	  this.e = entry; // is an entry?
	  this.v = false; // visited
	  this.n = this.p = null; // next & previous
	}
	
	// A generalized polygon clipping algorithm: given a polygon that has been cut
	// into its visible line segments, and rejoins the segments by interpolating
	// along the clip edge.
	var clipPolygon = function(segments, compareIntersection, startInside, interpolate, stream) {
	  var subject = [],
	      clip = [],
	      i,
	      n;
	
	  segments.forEach(function(segment) {
	    if ((n = segment.length - 1) <= 0) return;
	    var n, p0 = segment[0], p1 = segment[n], x;
	
	    // If the first and last points of a segment are coincident, then treat as a
	    // closed ring. TODO if all rings are closed, then the winding order of the
	    // exterior ring should be checked.
	    if (pointEqual(p0, p1)) {
	      stream.lineStart();
	      for (i = 0; i < n; ++i) stream.point((p0 = segment[i])[0], p0[1]);
	      stream.lineEnd();
	      return;
	    }
	
	    subject.push(x = new Intersection(p0, segment, null, true));
	    clip.push(x.o = new Intersection(p0, null, x, false));
	    subject.push(x = new Intersection(p1, segment, null, false));
	    clip.push(x.o = new Intersection(p1, null, x, true));
	  });
	
	  if (!subject.length) return;
	
	  clip.sort(compareIntersection);
	  link$1(subject);
	  link$1(clip);
	
	  for (i = 0, n = clip.length; i < n; ++i) {
	    clip[i].e = startInside = !startInside;
	  }
	
	  var start = subject[0],
	      points,
	      point;
	
	  while (1) {
	    // Find first unvisited intersection.
	    var current = start,
	        isSubject = true;
	    while (current.v) if ((current = current.n) === start) return;
	    points = current.z;
	    stream.lineStart();
	    do {
	      current.v = current.o.v = true;
	      if (current.e) {
	        if (isSubject) {
	          for (i = 0, n = points.length; i < n; ++i) stream.point((point = points[i])[0], point[1]);
	        } else {
	          interpolate(current.x, current.n.x, 1, stream);
	        }
	        current = current.n;
	      } else {
	        if (isSubject) {
	          points = current.p.z;
	          for (i = points.length - 1; i >= 0; --i) stream.point((point = points[i])[0], point[1]);
	        } else {
	          interpolate(current.x, current.p.x, -1, stream);
	        }
	        current = current.p;
	      }
	      current = current.o;
	      points = current.z;
	      isSubject = !isSubject;
	    } while (!current.v);
	    stream.lineEnd();
	  }
	};
	
	function link$1(array) {
	  if (!(n = array.length)) return;
	  var n,
	      i = 0,
	      a = array[0],
	      b;
	  while (++i < n) {
	    a.n = b = array[i];
	    b.p = a;
	    a = b;
	  }
	  a.n = b = array[0];
	  b.p = a;
	}
	
	var clipMax = 1e9;
	var clipMin = -clipMax;
	
	// TODO Use d3-polygon’s polygonContains here for the ring check?
	// TODO Eliminate duplicate buffering in clipBuffer and polygon.push?
	
	function clipExtent(x0, y0, x1, y1) {
	
	  function visible(x, y) {
	    return x0 <= x && x <= x1 && y0 <= y && y <= y1;
	  }
	
	  function interpolate(from, to, direction, stream) {
	    var a = 0, a1 = 0;
	    if (from == null
	        || (a = corner(from, direction)) !== (a1 = corner(to, direction))
	        || comparePoint(from, to) < 0 ^ direction > 0) {
	      do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
	      while ((a = (a + direction + 4) % 4) !== a1);
	    } else {
	      stream.point(to[0], to[1]);
	    }
	  }
	
	  function corner(p, direction) {
	    return abs(p[0] - x0) < epsilon$4 ? direction > 0 ? 0 : 3
	        : abs(p[0] - x1) < epsilon$4 ? direction > 0 ? 2 : 1
	        : abs(p[1] - y0) < epsilon$4 ? direction > 0 ? 1 : 0
	        : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
	  }
	
	  function compareIntersection(a, b) {
	    return comparePoint(a.x, b.x);
	  }
	
	  function comparePoint(a, b) {
	    var ca = corner(a, 1),
	        cb = corner(b, 1);
	    return ca !== cb ? ca - cb
	        : ca === 0 ? b[1] - a[1]
	        : ca === 1 ? a[0] - b[0]
	        : ca === 2 ? a[1] - b[1]
	        : b[0] - a[0];
	  }
	
	  return function(stream) {
	    var activeStream = stream,
	        bufferStream = clipBuffer(),
	        segments,
	        polygon,
	        ring,
	        x__, y__, v__, // first point
	        x_, y_, v_, // previous point
	        first,
	        clean;
	
	    var clipStream = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: polygonStart,
	      polygonEnd: polygonEnd
	    };
	
	    function point(x, y) {
	      if (visible(x, y)) activeStream.point(x, y);
	    }
	
	    function polygonInside() {
	      var winding = 0;
	
	      for (var i = 0, n = polygon.length; i < n; ++i) {
	        for (var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j) {
	          a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
	          if (a1 <= y1) { if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding; }
	          else { if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding; }
	        }
	      }
	
	      return winding;
	    }
	
	    // Buffer geometry within a polygon and then clip it en masse.
	    function polygonStart() {
	      activeStream = bufferStream, segments = [], polygon = [], clean = true;
	    }
	
	    function polygonEnd() {
	      var startInside = polygonInside(),
	          cleanInside = clean && startInside,
	          visible = (segments = merge(segments)).length;
	      if (cleanInside || visible) {
	        stream.polygonStart();
	        if (cleanInside) {
	          stream.lineStart();
	          interpolate(null, null, 1, stream);
	          stream.lineEnd();
	        }
	        if (visible) {
	          clipPolygon(segments, compareIntersection, startInside, interpolate, stream);
	        }
	        stream.polygonEnd();
	      }
	      activeStream = stream, segments = polygon = ring = null;
	    }
	
	    function lineStart() {
	      clipStream.point = linePoint;
	      if (polygon) polygon.push(ring = []);
	      first = true;
	      v_ = false;
	      x_ = y_ = NaN;
	    }
	
	    // TODO rather than special-case polygons, simply handle them separately.
	    // Ideally, coincident intersection points should be jittered to avoid
	    // clipping issues.
	    function lineEnd() {
	      if (segments) {
	        linePoint(x__, y__);
	        if (v__ && v_) bufferStream.rejoin();
	        segments.push(bufferStream.result());
	      }
	      clipStream.point = point;
	      if (v_) activeStream.lineEnd();
	    }
	
	    function linePoint(x, y) {
	      var v = visible(x, y);
	      if (polygon) ring.push([x, y]);
	      if (first) {
	        x__ = x, y__ = y, v__ = v;
	        first = false;
	        if (v) {
	          activeStream.lineStart();
	          activeStream.point(x, y);
	        }
	      } else {
	        if (v && v_) activeStream.point(x, y);
	        else {
	          var a = [x_ = Math.max(clipMin, Math.min(clipMax, x_)), y_ = Math.max(clipMin, Math.min(clipMax, y_))],
	              b = [x = Math.max(clipMin, Math.min(clipMax, x)), y = Math.max(clipMin, Math.min(clipMax, y))];
	          if (clipLine(a, b, x0, y0, x1, y1)) {
	            if (!v_) {
	              activeStream.lineStart();
	              activeStream.point(a[0], a[1]);
	            }
	            activeStream.point(b[0], b[1]);
	            if (!v) activeStream.lineEnd();
	            clean = false;
	          } else if (v) {
	            activeStream.lineStart();
	            activeStream.point(x, y);
	            clean = false;
	          }
	        }
	      }
	      x_ = x, y_ = y, v_ = v;
	    }
	
	    return clipStream;
	  };
	}
	
	var extent$1 = function() {
	  var x0 = 0,
	      y0 = 0,
	      x1 = 960,
	      y1 = 500,
	      cache,
	      cacheStream,
	      clip;
	
	  return clip = {
	    stream: function(stream) {
	      return cache && cacheStream === stream ? cache : cache = clipExtent(x0, y0, x1, y1)(cacheStream = stream);
	    },
	    extent: function(_) {
	      return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [[x0, y0], [x1, y1]];
	    }
	  };
	};
	
	var lengthSum = adder();
	var lambda0$2;
	var sinPhi0$1;
	var cosPhi0$1;
	
	var lengthStream = {
	  sphere: noop$2,
	  point: noop$2,
	  lineStart: lengthLineStart,
	  lineEnd: noop$2,
	  polygonStart: noop$2,
	  polygonEnd: noop$2
	};
	
	function lengthLineStart() {
	  lengthStream.point = lengthPointFirst;
	  lengthStream.lineEnd = lengthLineEnd;
	}
	
	function lengthLineEnd() {
	  lengthStream.point = lengthStream.lineEnd = noop$2;
	}
	
	function lengthPointFirst(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  lambda0$2 = lambda, sinPhi0$1 = sin$1(phi), cosPhi0$1 = cos$1(phi);
	  lengthStream.point = lengthPoint;
	}
	
	function lengthPoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var sinPhi = sin$1(phi),
	      cosPhi = cos$1(phi),
	      delta = abs(lambda - lambda0$2),
	      cosDelta = cos$1(delta),
	      sinDelta = sin$1(delta),
	      x = cosPhi * sinDelta,
	      y = cosPhi0$1 * sinPhi - sinPhi0$1 * cosPhi * cosDelta,
	      z = sinPhi0$1 * sinPhi + cosPhi0$1 * cosPhi * cosDelta;
	  lengthSum.add(atan2(sqrt$1(x * x + y * y), z));
	  lambda0$2 = lambda, sinPhi0$1 = sinPhi, cosPhi0$1 = cosPhi;
	}
	
	var length$2 = function(object) {
	  lengthSum.reset();
	  geoStream(object, lengthStream);
	  return +lengthSum;
	};
	
	var coordinates = [null, null];
	var object$1 = {type: "LineString", coordinates: coordinates};
	
	var distance = function(a, b) {
	  coordinates[0] = a;
	  coordinates[1] = b;
	  return length$2(object$1);
	};
	
	function graticuleX(y0, y1, dy) {
	  var y = range(y0, y1 - epsilon$4, dy).concat(y1);
	  return function(x) { return y.map(function(y) { return [x, y]; }); };
	}
	
	function graticuleY(x0, x1, dx) {
	  var x = range(x0, x1 - epsilon$4, dx).concat(x1);
	  return function(y) { return x.map(function(x) { return [x, y]; }); };
	}
	
	function graticule() {
	  var x1, x0, X1, X0,
	      y1, y0, Y1, Y0,
	      dx = 10, dy = dx, DX = 90, DY = 360,
	      x, y, X, Y,
	      precision = 2.5;
	
	  function graticule() {
	    return {type: "MultiLineString", coordinates: lines()};
	  }
	
	  function lines() {
	    return range(ceil(X0 / DX) * DX, X1, DX).map(X)
	        .concat(range(ceil(Y0 / DY) * DY, Y1, DY).map(Y))
	        .concat(range(ceil(x0 / dx) * dx, x1, dx).filter(function(x) { return abs(x % DX) > epsilon$4; }).map(x))
	        .concat(range(ceil(y0 / dy) * dy, y1, dy).filter(function(y) { return abs(y % DY) > epsilon$4; }).map(y));
	  }
	
	  graticule.lines = function() {
	    return lines().map(function(coordinates) { return {type: "LineString", coordinates: coordinates}; });
	  };
	
	  graticule.outline = function() {
	    return {
	      type: "Polygon",
	      coordinates: [
	        X(X0).concat(
	        Y(Y1).slice(1),
	        X(X1).reverse().slice(1),
	        Y(Y0).reverse().slice(1))
	      ]
	    };
	  };
	
	  graticule.extent = function(_) {
	    if (!arguments.length) return graticule.extentMinor();
	    return graticule.extentMajor(_).extentMinor(_);
	  };
	
	  graticule.extentMajor = function(_) {
	    if (!arguments.length) return [[X0, Y0], [X1, Y1]];
	    X0 = +_[0][0], X1 = +_[1][0];
	    Y0 = +_[0][1], Y1 = +_[1][1];
	    if (X0 > X1) _ = X0, X0 = X1, X1 = _;
	    if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
	    return graticule.precision(precision);
	  };
	
	  graticule.extentMinor = function(_) {
	    if (!arguments.length) return [[x0, y0], [x1, y1]];
	    x0 = +_[0][0], x1 = +_[1][0];
	    y0 = +_[0][1], y1 = +_[1][1];
	    if (x0 > x1) _ = x0, x0 = x1, x1 = _;
	    if (y0 > y1) _ = y0, y0 = y1, y1 = _;
	    return graticule.precision(precision);
	  };
	
	  graticule.step = function(_) {
	    if (!arguments.length) return graticule.stepMinor();
	    return graticule.stepMajor(_).stepMinor(_);
	  };
	
	  graticule.stepMajor = function(_) {
	    if (!arguments.length) return [DX, DY];
	    DX = +_[0], DY = +_[1];
	    return graticule;
	  };
	
	  graticule.stepMinor = function(_) {
	    if (!arguments.length) return [dx, dy];
	    dx = +_[0], dy = +_[1];
	    return graticule;
	  };
	
	  graticule.precision = function(_) {
	    if (!arguments.length) return precision;
	    precision = +_;
	    x = graticuleX(y0, y1, 90);
	    y = graticuleY(x0, x1, precision);
	    X = graticuleX(Y0, Y1, 90);
	    Y = graticuleY(X0, X1, precision);
	    return graticule;
	  };
	
	  return graticule
	      .extentMajor([[-180, -90 + epsilon$4], [180, 90 - epsilon$4]])
	      .extentMinor([[-180, -80 - epsilon$4], [180, 80 + epsilon$4]]);
	}
	
	function graticule10() {
	  return graticule()();
	}
	
	var interpolate$2 = function(a, b) {
	  var x0 = a[0] * radians,
	      y0 = a[1] * radians,
	      x1 = b[0] * radians,
	      y1 = b[1] * radians,
	      cy0 = cos$1(y0),
	      sy0 = sin$1(y0),
	      cy1 = cos$1(y1),
	      sy1 = sin$1(y1),
	      kx0 = cy0 * cos$1(x0),
	      ky0 = cy0 * sin$1(x0),
	      kx1 = cy1 * cos$1(x1),
	      ky1 = cy1 * sin$1(x1),
	      d = 2 * asin$1(sqrt$1(haversin(y1 - y0) + cy0 * cy1 * haversin(x1 - x0))),
	      k = sin$1(d);
	
	  var interpolate = d ? function(t) {
	    var B = sin$1(t *= d) / k,
	        A = sin$1(d - t) / k,
	        x = A * kx0 + B * kx1,
	        y = A * ky0 + B * ky1,
	        z = A * sy0 + B * sy1;
	    return [
	      atan2(y, x) * degrees$1,
	      atan2(z, sqrt$1(x * x + y * y)) * degrees$1
	    ];
	  } : function() {
	    return [x0 * degrees$1, y0 * degrees$1];
	  };
	
	  interpolate.distance = d;
	
	  return interpolate;
	};
	
	var identity$7 = function(x) {
	  return x;
	};
	
	var areaSum$1 = adder();
	var areaRingSum$1 = adder();
	var x00;
	var y00;
	var x0$1;
	var y0$1;
	
	var areaStream$1 = {
	  point: noop$2,
	  lineStart: noop$2,
	  lineEnd: noop$2,
	  polygonStart: function() {
	    areaStream$1.lineStart = areaRingStart$1;
	    areaStream$1.lineEnd = areaRingEnd$1;
	  },
	  polygonEnd: function() {
	    areaStream$1.lineStart = areaStream$1.lineEnd = areaStream$1.point = noop$2;
	    areaSum$1.add(abs(areaRingSum$1));
	    areaRingSum$1.reset();
	  },
	  result: function() {
	    var area = areaSum$1 / 2;
	    areaSum$1.reset();
	    return area;
	  }
	};
	
	function areaRingStart$1() {
	  areaStream$1.point = areaPointFirst$1;
	}
	
	function areaPointFirst$1(x, y) {
	  areaStream$1.point = areaPoint$1;
	  x00 = x0$1 = x, y00 = y0$1 = y;
	}
	
	function areaPoint$1(x, y) {
	  areaRingSum$1.add(y0$1 * x - x0$1 * y);
	  x0$1 = x, y0$1 = y;
	}
	
	function areaRingEnd$1() {
	  areaPoint$1(x00, y00);
	}
	
	var x0$2 = Infinity;
	var y0$2 = x0$2;
	var x1 = -x0$2;
	var y1 = x1;
	
	var boundsStream$1 = {
	  point: boundsPoint$1,
	  lineStart: noop$2,
	  lineEnd: noop$2,
	  polygonStart: noop$2,
	  polygonEnd: noop$2,
	  result: function() {
	    var bounds = [[x0$2, y0$2], [x1, y1]];
	    x1 = y1 = -(y0$2 = x0$2 = Infinity);
	    return bounds;
	  }
	};
	
	function boundsPoint$1(x, y) {
	  if (x < x0$2) x0$2 = x;
	  if (x > x1) x1 = x;
	  if (y < y0$2) y0$2 = y;
	  if (y > y1) y1 = y;
	}
	
	// TODO Enforce positive area for exterior, negative area for interior?
	
	var X0$1 = 0;
	var Y0$1 = 0;
	var Z0$1 = 0;
	var X1$1 = 0;
	var Y1$1 = 0;
	var Z1$1 = 0;
	var X2$1 = 0;
	var Y2$1 = 0;
	var Z2$1 = 0;
	var x00$1;
	var y00$1;
	var x0$3;
	var y0$3;
	
	var centroidStream$1 = {
	  point: centroidPoint$1,
	  lineStart: centroidLineStart$1,
	  lineEnd: centroidLineEnd$1,
	  polygonStart: function() {
	    centroidStream$1.lineStart = centroidRingStart$1;
	    centroidStream$1.lineEnd = centroidRingEnd$1;
	  },
	  polygonEnd: function() {
	    centroidStream$1.point = centroidPoint$1;
	    centroidStream$1.lineStart = centroidLineStart$1;
	    centroidStream$1.lineEnd = centroidLineEnd$1;
	  },
	  result: function() {
	    var centroid = Z2$1 ? [X2$1 / Z2$1, Y2$1 / Z2$1]
	        : Z1$1 ? [X1$1 / Z1$1, Y1$1 / Z1$1]
	        : Z0$1 ? [X0$1 / Z0$1, Y0$1 / Z0$1]
	        : [NaN, NaN];
	    X0$1 = Y0$1 = Z0$1 =
	    X1$1 = Y1$1 = Z1$1 =
	    X2$1 = Y2$1 = Z2$1 = 0;
	    return centroid;
	  }
	};
	
	function centroidPoint$1(x, y) {
	  X0$1 += x;
	  Y0$1 += y;
	  ++Z0$1;
	}
	
	function centroidLineStart$1() {
	  centroidStream$1.point = centroidPointFirstLine;
	}
	
	function centroidPointFirstLine(x, y) {
	  centroidStream$1.point = centroidPointLine;
	  centroidPoint$1(x0$3 = x, y0$3 = y);
	}
	
	function centroidPointLine(x, y) {
	  var dx = x - x0$3, dy = y - y0$3, z = sqrt$1(dx * dx + dy * dy);
	  X1$1 += z * (x0$3 + x) / 2;
	  Y1$1 += z * (y0$3 + y) / 2;
	  Z1$1 += z;
	  centroidPoint$1(x0$3 = x, y0$3 = y);
	}
	
	function centroidLineEnd$1() {
	  centroidStream$1.point = centroidPoint$1;
	}
	
	function centroidRingStart$1() {
	  centroidStream$1.point = centroidPointFirstRing;
	}
	
	function centroidRingEnd$1() {
	  centroidPointRing(x00$1, y00$1);
	}
	
	function centroidPointFirstRing(x, y) {
	  centroidStream$1.point = centroidPointRing;
	  centroidPoint$1(x00$1 = x0$3 = x, y00$1 = y0$3 = y);
	}
	
	function centroidPointRing(x, y) {
	  var dx = x - x0$3,
	      dy = y - y0$3,
	      z = sqrt$1(dx * dx + dy * dy);
	
	  X1$1 += z * (x0$3 + x) / 2;
	  Y1$1 += z * (y0$3 + y) / 2;
	  Z1$1 += z;
	
	  z = y0$3 * x - x0$3 * y;
	  X2$1 += z * (x0$3 + x);
	  Y2$1 += z * (y0$3 + y);
	  Z2$1 += z * 3;
	  centroidPoint$1(x0$3 = x, y0$3 = y);
	}
	
	function PathContext(context) {
	  this._context = context;
	}
	
	PathContext.prototype = {
	  _radius: 4.5,
	  pointRadius: function(_) {
	    return this._radius = _, this;
	  },
	  polygonStart: function() {
	    this._line = 0;
	  },
	  polygonEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line === 0) this._context.closePath();
	    this._point = NaN;
	  },
	  point: function(x, y) {
	    switch (this._point) {
	      case 0: {
	        this._context.moveTo(x, y);
	        this._point = 1;
	        break;
	      }
	      case 1: {
	        this._context.lineTo(x, y);
	        break;
	      }
	      default: {
	        this._context.moveTo(x + this._radius, y);
	        this._context.arc(x, y, this._radius, 0, tau$4);
	        break;
	      }
	    }
	  },
	  result: noop$2
	};
	
	function PathString() {
	  this._string = [];
	}
	
	PathString.prototype = {
	  _circle: circle$2(4.5),
	  pointRadius: function(_) {
	    return this._circle = circle$2(_), this;
	  },
	  polygonStart: function() {
	    this._line = 0;
	  },
	  polygonEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line === 0) this._string.push("Z");
	    this._point = NaN;
	  },
	  point: function(x, y) {
	    switch (this._point) {
	      case 0: {
	        this._string.push("M", x, ",", y);
	        this._point = 1;
	        break;
	      }
	      case 1: {
	        this._string.push("L", x, ",", y);
	        break;
	      }
	      default: {
	        this._string.push("M", x, ",", y, this._circle);
	        break;
	      }
	    }
	  },
	  result: function() {
	    if (this._string.length) {
	      var result = this._string.join("");
	      this._string = [];
	      return result;
	    }
	  }
	};
	
	function circle$2(radius) {
	  return "m0," + radius
	      + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius
	      + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius
	      + "z";
	}
	
	var index$3 = function(projection, context) {
	  var pointRadius = 4.5,
	      projectionStream,
	      contextStream;
	
	  function path(object) {
	    if (object) {
	      if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
	      geoStream(object, projectionStream(contextStream));
	    }
	    return contextStream.result();
	  }
	
	  path.area = function(object) {
	    geoStream(object, projectionStream(areaStream$1));
	    return areaStream$1.result();
	  };
	
	  path.bounds = function(object) {
	    geoStream(object, projectionStream(boundsStream$1));
	    return boundsStream$1.result();
	  };
	
	  path.centroid = function(object) {
	    geoStream(object, projectionStream(centroidStream$1));
	    return centroidStream$1.result();
	  };
	
	  path.projection = function(_) {
	    return arguments.length ? (projectionStream = _ == null ? (projection = null, identity$7) : (projection = _).stream, path) : projection;
	  };
	
	  path.context = function(_) {
	    if (!arguments.length) return context;
	    contextStream = _ == null ? (context = null, new PathString) : new PathContext(context = _);
	    if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
	    return path;
	  };
	
	  path.pointRadius = function(_) {
	    if (!arguments.length) return pointRadius;
	    pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
	    return path;
	  };
	
	  return path.projection(projection).context(context);
	};
	
	var sum$2 = adder();
	
	var polygonContains = function(polygon, point) {
	  var lambda = point[0],
	      phi = point[1],
	      normal = [sin$1(lambda), -cos$1(lambda), 0],
	      angle = 0,
	      winding = 0;
	
	  sum$2.reset();
	
	  for (var i = 0, n = polygon.length; i < n; ++i) {
	    if (!(m = (ring = polygon[i]).length)) continue;
	    var ring,
	        m,
	        point0 = ring[m - 1],
	        lambda0 = point0[0],
	        phi0 = point0[1] / 2 + quarterPi,
	        sinPhi0 = sin$1(phi0),
	        cosPhi0 = cos$1(phi0);
	
	    for (var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1) {
	      var point1 = ring[j],
	          lambda1 = point1[0],
	          phi1 = point1[1] / 2 + quarterPi,
	          sinPhi1 = sin$1(phi1),
	          cosPhi1 = cos$1(phi1),
	          delta = lambda1 - lambda0,
	          sign$$1 = delta >= 0 ? 1 : -1,
	          absDelta = sign$$1 * delta,
	          antimeridian = absDelta > pi$4,
	          k = sinPhi0 * sinPhi1;
	
	      sum$2.add(atan2(k * sign$$1 * sin$1(absDelta), cosPhi0 * cosPhi1 + k * cos$1(absDelta)));
	      angle += antimeridian ? delta + sign$$1 * tau$4 : delta;
	
	      // Are the longitudes either side of the point’s meridian (lambda),
	      // and are the latitudes smaller than the parallel (phi)?
	      if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
	        var arc = cartesianCross(cartesian(point0), cartesian(point1));
	        cartesianNormalizeInPlace(arc);
	        var intersection = cartesianCross(normal, arc);
	        cartesianNormalizeInPlace(intersection);
	        var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * asin$1(intersection[2]);
	        if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) {
	          winding += antimeridian ^ delta >= 0 ? 1 : -1;
	        }
	      }
	    }
	  }
	
	  // First, determine whether the South pole is inside or outside:
	  //
	  // It is inside if:
	  // * the polygon winds around it in a clockwise direction.
	  // * the polygon does not (cumulatively) wind around it, but has a negative
	  //   (counter-clockwise) area.
	  //
	  // Second, count the (signed) number of times a segment crosses a lambda
	  // from the point to the South pole.  If it is zero, then the point is the
	  // same side as the South pole.
	
	  return (angle < -epsilon$4 || angle < epsilon$4 && sum$2 < -epsilon$4) ^ (winding & 1);
	};
	
	var clip = function(pointVisible, clipLine, interpolate, start) {
	  return function(rotate, sink) {
	    var line = clipLine(sink),
	        rotatedStart = rotate.invert(start[0], start[1]),
	        ringBuffer = clipBuffer(),
	        ringSink = clipLine(ringBuffer),
	        polygonStarted = false,
	        polygon,
	        segments,
	        ring;
	
	    var clip = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        clip.point = pointRing;
	        clip.lineStart = ringStart;
	        clip.lineEnd = ringEnd;
	        segments = [];
	        polygon = [];
	      },
	      polygonEnd: function() {
	        clip.point = point;
	        clip.lineStart = lineStart;
	        clip.lineEnd = lineEnd;
	        segments = merge(segments);
	        var startInside = polygonContains(polygon, rotatedStart);
	        if (segments.length) {
	          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
	          clipPolygon(segments, compareIntersection, startInside, interpolate, sink);
	        } else if (startInside) {
	          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
	          sink.lineStart();
	          interpolate(null, null, 1, sink);
	          sink.lineEnd();
	        }
	        if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
	        segments = polygon = null;
	      },
	      sphere: function() {
	        sink.polygonStart();
	        sink.lineStart();
	        interpolate(null, null, 1, sink);
	        sink.lineEnd();
	        sink.polygonEnd();
	      }
	    };
	
	    function point(lambda, phi) {
	      var point = rotate(lambda, phi);
	      if (pointVisible(lambda = point[0], phi = point[1])) sink.point(lambda, phi);
	    }
	
	    function pointLine(lambda, phi) {
	      var point = rotate(lambda, phi);
	      line.point(point[0], point[1]);
	    }
	
	    function lineStart() {
	      clip.point = pointLine;
	      line.lineStart();
	    }
	
	    function lineEnd() {
	      clip.point = point;
	      line.lineEnd();
	    }
	
	    function pointRing(lambda, phi) {
	      ring.push([lambda, phi]);
	      var point = rotate(lambda, phi);
	      ringSink.point(point[0], point[1]);
	    }
	
	    function ringStart() {
	      ringSink.lineStart();
	      ring = [];
	    }
	
	    function ringEnd() {
	      pointRing(ring[0][0], ring[0][1]);
	      ringSink.lineEnd();
	
	      var clean = ringSink.clean(),
	          ringSegments = ringBuffer.result(),
	          i, n = ringSegments.length, m,
	          segment,
	          point;
	
	      ring.pop();
	      polygon.push(ring);
	      ring = null;
	
	      if (!n) return;
	
	      // No intersections.
	      if (clean & 1) {
	        segment = ringSegments[0];
	        if ((m = segment.length - 1) > 0) {
	          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
	          sink.lineStart();
	          for (i = 0; i < m; ++i) sink.point((point = segment[i])[0], point[1]);
	          sink.lineEnd();
	        }
	        return;
	      }
	
	      // Rejoin connected segments.
	      // TODO reuse ringBuffer.rejoin()?
	      if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
	
	      segments.push(ringSegments.filter(validSegment));
	    }
	
	    return clip;
	  };
	};
	
	function validSegment(segment) {
	  return segment.length > 1;
	}
	
	// Intersections are sorted along the clip edge. For both antimeridian cutting
	// and circle clipping, the same comparison is used.
	function compareIntersection(a, b) {
	  return ((a = a.x)[0] < 0 ? a[1] - halfPi$3 - epsilon$4 : halfPi$3 - a[1])
	       - ((b = b.x)[0] < 0 ? b[1] - halfPi$3 - epsilon$4 : halfPi$3 - b[1]);
	}
	
	var clipAntimeridian = clip(
	  function() { return true; },
	  clipAntimeridianLine,
	  clipAntimeridianInterpolate,
	  [-pi$4, -halfPi$3]
	);
	
	// Takes a line and cuts into visible segments. Return values: 0 - there were
	// intersections or the line was empty; 1 - no intersections; 2 - there were
	// intersections, and the first and last segments should be rejoined.
	function clipAntimeridianLine(stream) {
	  var lambda0 = NaN,
	      phi0 = NaN,
	      sign0 = NaN,
	      clean; // no intersections
	
	  return {
	    lineStart: function() {
	      stream.lineStart();
	      clean = 1;
	    },
	    point: function(lambda1, phi1) {
	      var sign1 = lambda1 > 0 ? pi$4 : -pi$4,
	          delta = abs(lambda1 - lambda0);
	      if (abs(delta - pi$4) < epsilon$4) { // line crosses a pole
	        stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? halfPi$3 : -halfPi$3);
	        stream.point(sign0, phi0);
	        stream.lineEnd();
	        stream.lineStart();
	        stream.point(sign1, phi0);
	        stream.point(lambda1, phi0);
	        clean = 0;
	      } else if (sign0 !== sign1 && delta >= pi$4) { // line crosses antimeridian
	        if (abs(lambda0 - sign0) < epsilon$4) lambda0 -= sign0 * epsilon$4; // handle degeneracies
	        if (abs(lambda1 - sign1) < epsilon$4) lambda1 -= sign1 * epsilon$4;
	        phi0 = clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
	        stream.point(sign0, phi0);
	        stream.lineEnd();
	        stream.lineStart();
	        stream.point(sign1, phi0);
	        clean = 0;
	      }
	      stream.point(lambda0 = lambda1, phi0 = phi1);
	      sign0 = sign1;
	    },
	    lineEnd: function() {
	      stream.lineEnd();
	      lambda0 = phi0 = NaN;
	    },
	    clean: function() {
	      return 2 - clean; // if intersections, rejoin first and last segments
	    }
	  };
	}
	
	function clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
	  var cosPhi0,
	      cosPhi1,
	      sinLambda0Lambda1 = sin$1(lambda0 - lambda1);
	  return abs(sinLambda0Lambda1) > epsilon$4
	      ? atan((sin$1(phi0) * (cosPhi1 = cos$1(phi1)) * sin$1(lambda1)
	          - sin$1(phi1) * (cosPhi0 = cos$1(phi0)) * sin$1(lambda0))
	          / (cosPhi0 * cosPhi1 * sinLambda0Lambda1))
	      : (phi0 + phi1) / 2;
	}
	
	function clipAntimeridianInterpolate(from, to, direction, stream) {
	  var phi;
	  if (from == null) {
	    phi = direction * halfPi$3;
	    stream.point(-pi$4, phi);
	    stream.point(0, phi);
	    stream.point(pi$4, phi);
	    stream.point(pi$4, 0);
	    stream.point(pi$4, -phi);
	    stream.point(0, -phi);
	    stream.point(-pi$4, -phi);
	    stream.point(-pi$4, 0);
	    stream.point(-pi$4, phi);
	  } else if (abs(from[0] - to[0]) > epsilon$4) {
	    var lambda = from[0] < to[0] ? pi$4 : -pi$4;
	    phi = direction * lambda / 2;
	    stream.point(-lambda, phi);
	    stream.point(0, phi);
	    stream.point(lambda, phi);
	  } else {
	    stream.point(to[0], to[1]);
	  }
	}
	
	var clipCircle = function(radius, delta) {
	  var cr = cos$1(radius),
	      smallRadius = cr > 0,
	      notHemisphere = abs(cr) > epsilon$4; // TODO optimise for this common case
	
	  function interpolate(from, to, direction, stream) {
	    circleStream(stream, radius, delta, direction, from, to);
	  }
	
	  function visible(lambda, phi) {
	    return cos$1(lambda) * cos$1(phi) > cr;
	  }
	
	  // Takes a line and cuts into visible segments. Return values used for polygon
	  // clipping: 0 - there were intersections or the line was empty; 1 - no
	  // intersections 2 - there were intersections, and the first and last segments
	  // should be rejoined.
	  function clipLine(stream) {
	    var point0, // previous point
	        c0, // code for previous point
	        v0, // visibility of previous point
	        v00, // visibility of first point
	        clean; // no intersections
	    return {
	      lineStart: function() {
	        v00 = v0 = false;
	        clean = 1;
	      },
	      point: function(lambda, phi) {
	        var point1 = [lambda, phi],
	            point2,
	            v = visible(lambda, phi),
	            c = smallRadius
	              ? v ? 0 : code(lambda, phi)
	              : v ? code(lambda + (lambda < 0 ? pi$4 : -pi$4), phi) : 0;
	        if (!point0 && (v00 = v0 = v)) stream.lineStart();
	        // Handle degeneracies.
	        // TODO ignore if not clipping polygons.
	        if (v !== v0) {
	          point2 = intersect(point0, point1);
	          if (pointEqual(point0, point2) || pointEqual(point1, point2)) {
	            point1[0] += epsilon$4;
	            point1[1] += epsilon$4;
	            v = visible(point1[0], point1[1]);
	          }
	        }
	        if (v !== v0) {
	          clean = 0;
	          if (v) {
	            // outside going in
	            stream.lineStart();
	            point2 = intersect(point1, point0);
	            stream.point(point2[0], point2[1]);
	          } else {
	            // inside going out
	            point2 = intersect(point0, point1);
	            stream.point(point2[0], point2[1]);
	            stream.lineEnd();
	          }
	          point0 = point2;
	        } else if (notHemisphere && point0 && smallRadius ^ v) {
	          var t;
	          // If the codes for two points are different, or are both zero,
	          // and there this segment intersects with the small circle.
	          if (!(c & c0) && (t = intersect(point1, point0, true))) {
	            clean = 0;
	            if (smallRadius) {
	              stream.lineStart();
	              stream.point(t[0][0], t[0][1]);
	              stream.point(t[1][0], t[1][1]);
	              stream.lineEnd();
	            } else {
	              stream.point(t[1][0], t[1][1]);
	              stream.lineEnd();
	              stream.lineStart();
	              stream.point(t[0][0], t[0][1]);
	            }
	          }
	        }
	        if (v && (!point0 || !pointEqual(point0, point1))) {
	          stream.point(point1[0], point1[1]);
	        }
	        point0 = point1, v0 = v, c0 = c;
	      },
	      lineEnd: function() {
	        if (v0) stream.lineEnd();
	        point0 = null;
	      },
	      // Rejoin first and last segments if there were intersections and the first
	      // and last points were visible.
	      clean: function() {
	        return clean | ((v00 && v0) << 1);
	      }
	    };
	  }
	
	  // Intersects the great circle between a and b with the clip circle.
	  function intersect(a, b, two) {
	    var pa = cartesian(a),
	        pb = cartesian(b);
	
	    // We have two planes, n1.p = d1 and n2.p = d2.
	    // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
	    var n1 = [1, 0, 0], // normal
	        n2 = cartesianCross(pa, pb),
	        n2n2 = cartesianDot(n2, n2),
	        n1n2 = n2[0], // cartesianDot(n1, n2),
	        determinant = n2n2 - n1n2 * n1n2;
	
	    // Two polar points.
	    if (!determinant) return !two && a;
	
	    var c1 =  cr * n2n2 / determinant,
	        c2 = -cr * n1n2 / determinant,
	        n1xn2 = cartesianCross(n1, n2),
	        A = cartesianScale(n1, c1),
	        B = cartesianScale(n2, c2);
	    cartesianAddInPlace(A, B);
	
	    // Solve |p(t)|^2 = 1.
	    var u = n1xn2,
	        w = cartesianDot(A, u),
	        uu = cartesianDot(u, u),
	        t2 = w * w - uu * (cartesianDot(A, A) - 1);
	
	    if (t2 < 0) return;
	
	    var t = sqrt$1(t2),
	        q = cartesianScale(u, (-w - t) / uu);
	    cartesianAddInPlace(q, A);
	    q = spherical(q);
	
	    if (!two) return q;
	
	    // Two intersection points.
	    var lambda0 = a[0],
	        lambda1 = b[0],
	        phi0 = a[1],
	        phi1 = b[1],
	        z;
	
	    if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;
	
	    var delta = lambda1 - lambda0,
	        polar = abs(delta - pi$4) < epsilon$4,
	        meridian = polar || delta < epsilon$4;
	
	    if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;
	
	    // Check that the first point is between a and b.
	    if (meridian
	        ? polar
	          ? phi0 + phi1 > 0 ^ q[1] < (abs(q[0] - lambda0) < epsilon$4 ? phi0 : phi1)
	          : phi0 <= q[1] && q[1] <= phi1
	        : delta > pi$4 ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
	      var q1 = cartesianScale(u, (-w + t) / uu);
	      cartesianAddInPlace(q1, A);
	      return [q, spherical(q1)];
	    }
	  }
	
	  // Generates a 4-bit vector representing the location of a point relative to
	  // the small circle's bounding box.
	  function code(lambda, phi) {
	    var r = smallRadius ? radius : pi$4 - radius,
	        code = 0;
	    if (lambda < -r) code |= 1; // left
	    else if (lambda > r) code |= 2; // right
	    if (phi < -r) code |= 4; // below
	    else if (phi > r) code |= 8; // above
	    return code;
	  }
	
	  return clip(visible, clipLine, interpolate, smallRadius ? [0, -radius] : [-pi$4, radius - pi$4]);
	};
	
	var transform$1 = function(methods) {
	  return {
	    stream: transformer(methods)
	  };
	};
	
	function transformer(methods) {
	  return function(stream) {
	    var s = new TransformStream;
	    for (var key in methods) s[key] = methods[key];
	    s.stream = stream;
	    return s;
	  };
	}
	
	function TransformStream() {}
	
	TransformStream.prototype = {
	  constructor: TransformStream,
	  point: function(x, y) { this.stream.point(x, y); },
	  sphere: function() { this.stream.sphere(); },
	  lineStart: function() { this.stream.lineStart(); },
	  lineEnd: function() { this.stream.lineEnd(); },
	  polygonStart: function() { this.stream.polygonStart(); },
	  polygonEnd: function() { this.stream.polygonEnd(); }
	};
	
	function fitExtent(projection, extent, object) {
	  var w = extent[1][0] - extent[0][0],
	      h = extent[1][1] - extent[0][1],
	      clip = projection.clipExtent && projection.clipExtent();
	
	  projection
	      .scale(150)
	      .translate([0, 0]);
	
	  if (clip != null) projection.clipExtent(null);
	
	  geoStream(object, projection.stream(boundsStream$1));
	
	  var b = boundsStream$1.result(),
	      k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])),
	      x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2,
	      y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
	
	  if (clip != null) projection.clipExtent(clip);
	
	  return projection
	      .scale(k * 150)
	      .translate([x, y]);
	}
	
	function fitSize(projection, size, object) {
	  return fitExtent(projection, [[0, 0], size], object);
	}
	
	var maxDepth = 16;
	var cosMinDistance = cos$1(30 * radians); // cos(minimum angular distance)
	
	var resample = function(project, delta2) {
	  return +delta2 ? resample$1(project, delta2) : resampleNone(project);
	};
	
	function resampleNone(project) {
	  return transformer({
	    point: function(x, y) {
	      x = project(x, y);
	      this.stream.point(x[0], x[1]);
	    }
	  });
	}
	
	function resample$1(project, delta2) {
	
	  function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
	    var dx = x1 - x0,
	        dy = y1 - y0,
	        d2 = dx * dx + dy * dy;
	    if (d2 > 4 * delta2 && depth--) {
	      var a = a0 + a1,
	          b = b0 + b1,
	          c = c0 + c1,
	          m = sqrt$1(a * a + b * b + c * c),
	          phi2 = asin$1(c /= m),
	          lambda2 = abs(abs(c) - 1) < epsilon$4 || abs(lambda0 - lambda1) < epsilon$4 ? (lambda0 + lambda1) / 2 : atan2(b, a),
	          p = project(lambda2, phi2),
	          x2 = p[0],
	          y2 = p[1],
	          dx2 = x2 - x0,
	          dy2 = y2 - y0,
	          dz = dy * dx2 - dx * dy2;
	      if (dz * dz / d2 > delta2 // perpendicular projected distance
	          || abs((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
	          || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) { // angular distance
	        resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
	        stream.point(x2, y2);
	        resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
	      }
	    }
	  }
	  return function(stream) {
	    var lambda00, x00, y00, a00, b00, c00, // first point
	        lambda0, x0, y0, a0, b0, c0; // previous point
	
	    var resampleStream = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: function() { stream.polygonStart(); resampleStream.lineStart = ringStart; },
	      polygonEnd: function() { stream.polygonEnd(); resampleStream.lineStart = lineStart; }
	    };
	
	    function point(x, y) {
	      x = project(x, y);
	      stream.point(x[0], x[1]);
	    }
	
	    function lineStart() {
	      x0 = NaN;
	      resampleStream.point = linePoint;
	      stream.lineStart();
	    }
	
	    function linePoint(lambda, phi) {
	      var c = cartesian([lambda, phi]), p = project(lambda, phi);
	      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
	      stream.point(x0, y0);
	    }
	
	    function lineEnd() {
	      resampleStream.point = point;
	      stream.lineEnd();
	    }
	
	    function ringStart() {
	      lineStart();
	      resampleStream.point = ringPoint;
	      resampleStream.lineEnd = ringEnd;
	    }
	
	    function ringPoint(lambda, phi) {
	      linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
	      resampleStream.point = linePoint;
	    }
	
	    function ringEnd() {
	      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, maxDepth, stream);
	      resampleStream.lineEnd = lineEnd;
	      lineEnd();
	    }
	
	    return resampleStream;
	  };
	}
	
	var transformRadians = transformer({
	  point: function(x, y) {
	    this.stream.point(x * radians, y * radians);
	  }
	});
	
	function projection(project) {
	  return projectionMutator(function() { return project; })();
	}
	
	function projectionMutator(projectAt) {
	  var project,
	      k = 150, // scale
	      x = 480, y = 250, // translate
	      dx, dy, lambda = 0, phi = 0, // center
	      deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, projectRotate, // rotate
	      theta = null, preclip = clipAntimeridian, // clip angle
	      x0 = null, y0, x1, y1, postclip = identity$7, // clip extent
	      delta2 = 0.5, projectResample = resample(projectTransform, delta2), // precision
	      cache,
	      cacheStream;
	
	  function projection(point) {
	    point = projectRotate(point[0] * radians, point[1] * radians);
	    return [point[0] * k + dx, dy - point[1] * k];
	  }
	
	  function invert(point) {
	    point = projectRotate.invert((point[0] - dx) / k, (dy - point[1]) / k);
	    return point && [point[0] * degrees$1, point[1] * degrees$1];
	  }
	
	  function projectTransform(x, y) {
	    return x = project(x, y), [x[0] * k + dx, dy - x[1] * k];
	  }
	
	  projection.stream = function(stream) {
	    return cache && cacheStream === stream ? cache : cache = transformRadians(preclip(rotate, projectResample(postclip(cacheStream = stream))));
	  };
	
	  projection.clipAngle = function(_) {
	    return arguments.length ? (preclip = +_ ? clipCircle(theta = _ * radians, 6 * radians) : (theta = null, clipAntimeridian), reset()) : theta * degrees$1;
	  };
	
	  projection.clipExtent = function(_) {
	    return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, identity$7) : clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
	  };
	
	  projection.scale = function(_) {
	    return arguments.length ? (k = +_, recenter()) : k;
	  };
	
	  projection.translate = function(_) {
	    return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [x, y];
	  };
	
	  projection.center = function(_) {
	    return arguments.length ? (lambda = _[0] % 360 * radians, phi = _[1] % 360 * radians, recenter()) : [lambda * degrees$1, phi * degrees$1];
	  };
	
	  projection.rotate = function(_) {
	    return arguments.length ? (deltaLambda = _[0] % 360 * radians, deltaPhi = _[1] % 360 * radians, deltaGamma = _.length > 2 ? _[2] % 360 * radians : 0, recenter()) : [deltaLambda * degrees$1, deltaPhi * degrees$1, deltaGamma * degrees$1];
	  };
	
	  projection.precision = function(_) {
	    return arguments.length ? (projectResample = resample(projectTransform, delta2 = _ * _), reset()) : sqrt$1(delta2);
	  };
	
	  projection.fitExtent = function(extent, object) {
	    return fitExtent(projection, extent, object);
	  };
	
	  projection.fitSize = function(size, object) {
	    return fitSize(projection, size, object);
	  };
	
	  function recenter() {
	    projectRotate = compose(rotate = rotateRadians(deltaLambda, deltaPhi, deltaGamma), project);
	    var center = project(lambda, phi);
	    dx = x - center[0] * k;
	    dy = y + center[1] * k;
	    return reset();
	  }
	
	  function reset() {
	    cache = cacheStream = null;
	    return projection;
	  }
	
	  return function() {
	    project = projectAt.apply(this, arguments);
	    projection.invert = project.invert && invert;
	    return recenter();
	  };
	}
	
	function conicProjection(projectAt) {
	  var phi0 = 0,
	      phi1 = pi$4 / 3,
	      m = projectionMutator(projectAt),
	      p = m(phi0, phi1);
	
	  p.parallels = function(_) {
	    return arguments.length ? m(phi0 = _[0] * radians, phi1 = _[1] * radians) : [phi0 * degrees$1, phi1 * degrees$1];
	  };
	
	  return p;
	}
	
	function cylindricalEqualAreaRaw(phi0) {
	  var cosPhi0 = cos$1(phi0);
	
	  function forward(lambda, phi) {
	    return [lambda * cosPhi0, sin$1(phi) / cosPhi0];
	  }
	
	  forward.invert = function(x, y) {
	    return [x / cosPhi0, asin$1(y * cosPhi0)];
	  };
	
	  return forward;
	}
	
	function conicEqualAreaRaw(y0, y1) {
	  var sy0 = sin$1(y0), n = (sy0 + sin$1(y1)) / 2;
	
	  // Are the parallels symmetrical around the Equator?
	  if (abs(n) < epsilon$4) return cylindricalEqualAreaRaw(y0);
	
	  var c = 1 + sy0 * (2 * n - sy0), r0 = sqrt$1(c) / n;
	
	  function project(x, y) {
	    var r = sqrt$1(c - 2 * n * sin$1(y)) / n;
	    return [r * sin$1(x *= n), r0 - r * cos$1(x)];
	  }
	
	  project.invert = function(x, y) {
	    var r0y = r0 - y;
	    return [atan2(x, abs(r0y)) / n * sign$1(r0y), asin$1((c - (x * x + r0y * r0y) * n * n) / (2 * n))];
	  };
	
	  return project;
	}
	
	var conicEqualArea = function() {
	  return conicProjection(conicEqualAreaRaw)
	      .scale(155.424)
	      .center([0, 33.6442]);
	};
	
	var albers = function() {
	  return conicEqualArea()
	      .parallels([29.5, 45.5])
	      .scale(1070)
	      .translate([480, 250])
	      .rotate([96, 0])
	      .center([-0.6, 38.7]);
	};
	
	// The projections must have mutually exclusive clip regions on the sphere,
	// as this will avoid emitting interleaving lines and polygons.
	function multiplex(streams) {
	  var n = streams.length;
	  return {
	    point: function(x, y) { var i = -1; while (++i < n) streams[i].point(x, y); },
	    sphere: function() { var i = -1; while (++i < n) streams[i].sphere(); },
	    lineStart: function() { var i = -1; while (++i < n) streams[i].lineStart(); },
	    lineEnd: function() { var i = -1; while (++i < n) streams[i].lineEnd(); },
	    polygonStart: function() { var i = -1; while (++i < n) streams[i].polygonStart(); },
	    polygonEnd: function() { var i = -1; while (++i < n) streams[i].polygonEnd(); }
	  };
	}
	
	// A composite projection for the United States, configured by default for
	// 960×500. The projection also works quite well at 960×600 if you change the
	// scale to 1285 and adjust the translate accordingly. The set of standard
	// parallels for each region comes from USGS, which is published here:
	// http://egsc.usgs.gov/isb/pubs/MapProjections/projections.html#albers
	var albersUsa = function() {
	  var cache,
	      cacheStream,
	      lower48 = albers(), lower48Point,
	      alaska = conicEqualArea().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]), alaskaPoint, // EPSG:3338
	      hawaii = conicEqualArea().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]), hawaiiPoint, // ESRI:102007
	      point, pointStream = {point: function(x, y) { point = [x, y]; }};
	
	  function albersUsa(coordinates) {
	    var x = coordinates[0], y = coordinates[1];
	    return point = null,
	        (lower48Point.point(x, y), point)
	        || (alaskaPoint.point(x, y), point)
	        || (hawaiiPoint.point(x, y), point);
	  }
	
	  albersUsa.invert = function(coordinates) {
	    var k = lower48.scale(),
	        t = lower48.translate(),
	        x = (coordinates[0] - t[0]) / k,
	        y = (coordinates[1] - t[1]) / k;
	    return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska
	        : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii
	        : lower48).invert(coordinates);
	  };
	
	  albersUsa.stream = function(stream) {
	    return cache && cacheStream === stream ? cache : cache = multiplex([lower48.stream(cacheStream = stream), alaska.stream(stream), hawaii.stream(stream)]);
	  };
	
	  albersUsa.precision = function(_) {
	    if (!arguments.length) return lower48.precision();
	    lower48.precision(_), alaska.precision(_), hawaii.precision(_);
	    return reset();
	  };
	
	  albersUsa.scale = function(_) {
	    if (!arguments.length) return lower48.scale();
	    lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
	    return albersUsa.translate(lower48.translate());
	  };
	
	  albersUsa.translate = function(_) {
	    if (!arguments.length) return lower48.translate();
	    var k = lower48.scale(), x = +_[0], y = +_[1];
	
	    lower48Point = lower48
	        .translate(_)
	        .clipExtent([[x - 0.455 * k, y - 0.238 * k], [x + 0.455 * k, y + 0.238 * k]])
	        .stream(pointStream);
	
	    alaskaPoint = alaska
	        .translate([x - 0.307 * k, y + 0.201 * k])
	        .clipExtent([[x - 0.425 * k + epsilon$4, y + 0.120 * k + epsilon$4], [x - 0.214 * k - epsilon$4, y + 0.234 * k - epsilon$4]])
	        .stream(pointStream);
	
	    hawaiiPoint = hawaii
	        .translate([x - 0.205 * k, y + 0.212 * k])
	        .clipExtent([[x - 0.214 * k + epsilon$4, y + 0.166 * k + epsilon$4], [x - 0.115 * k - epsilon$4, y + 0.234 * k - epsilon$4]])
	        .stream(pointStream);
	
	    return reset();
	  };
	
	  albersUsa.fitExtent = function(extent, object) {
	    return fitExtent(albersUsa, extent, object);
	  };
	
	  albersUsa.fitSize = function(size, object) {
	    return fitSize(albersUsa, size, object);
	  };
	
	  function reset() {
	    cache = cacheStream = null;
	    return albersUsa;
	  }
	
	  return albersUsa.scale(1070);
	};
	
	function azimuthalRaw(scale) {
	  return function(x, y) {
	    var cx = cos$1(x),
	        cy = cos$1(y),
	        k = scale(cx * cy);
	    return [
	      k * cy * sin$1(x),
	      k * sin$1(y)
	    ];
	  }
	}
	
	function azimuthalInvert(angle) {
	  return function(x, y) {
	    var z = sqrt$1(x * x + y * y),
	        c = angle(z),
	        sc = sin$1(c),
	        cc = cos$1(c);
	    return [
	      atan2(x * sc, z * cc),
	      asin$1(z && y * sc / z)
	    ];
	  }
	}
	
	var azimuthalEqualAreaRaw = azimuthalRaw(function(cxcy) {
	  return sqrt$1(2 / (1 + cxcy));
	});
	
	azimuthalEqualAreaRaw.invert = azimuthalInvert(function(z) {
	  return 2 * asin$1(z / 2);
	});
	
	var azimuthalEqualArea = function() {
	  return projection(azimuthalEqualAreaRaw)
	      .scale(124.75)
	      .clipAngle(180 - 1e-3);
	};
	
	var azimuthalEquidistantRaw = azimuthalRaw(function(c) {
	  return (c = acos(c)) && c / sin$1(c);
	});
	
	azimuthalEquidistantRaw.invert = azimuthalInvert(function(z) {
	  return z;
	});
	
	var azimuthalEquidistant = function() {
	  return projection(azimuthalEquidistantRaw)
	      .scale(79.4188)
	      .clipAngle(180 - 1e-3);
	};
	
	function mercatorRaw(lambda, phi) {
	  return [lambda, log$1(tan((halfPi$3 + phi) / 2))];
	}
	
	mercatorRaw.invert = function(x, y) {
	  return [x, 2 * atan(exp(y)) - halfPi$3];
	};
	
	var mercator = function() {
	  return mercatorProjection(mercatorRaw)
	      .scale(961 / tau$4);
	};
	
	function mercatorProjection(project) {
	  var m = projection(project),
	      scale = m.scale,
	      translate = m.translate,
	      clipExtent = m.clipExtent,
	      clipAuto;
	
	  m.scale = function(_) {
	    return arguments.length ? (scale(_), clipAuto && m.clipExtent(null), m) : scale();
	  };
	
	  m.translate = function(_) {
	    return arguments.length ? (translate(_), clipAuto && m.clipExtent(null), m) : translate();
	  };
	
	  m.clipExtent = function(_) {
	    if (!arguments.length) return clipAuto ? null : clipExtent();
	    if (clipAuto = _ == null) {
	      var k = pi$4 * scale(),
	          t = translate();
	      _ = [[t[0] - k, t[1] - k], [t[0] + k, t[1] + k]];
	    }
	    clipExtent(_);
	    return m;
	  };
	
	  return m.clipExtent(null);
	}
	
	function tany(y) {
	  return tan((halfPi$3 + y) / 2);
	}
	
	function conicConformalRaw(y0, y1) {
	  var cy0 = cos$1(y0),
	      n = y0 === y1 ? sin$1(y0) : log$1(cy0 / cos$1(y1)) / log$1(tany(y1) / tany(y0)),
	      f = cy0 * pow$1(tany(y0), n) / n;
	
	  if (!n) return mercatorRaw;
	
	  function project(x, y) {
	    if (f > 0) { if (y < -halfPi$3 + epsilon$4) y = -halfPi$3 + epsilon$4; }
	    else { if (y > halfPi$3 - epsilon$4) y = halfPi$3 - epsilon$4; }
	    var r = f / pow$1(tany(y), n);
	    return [r * sin$1(n * x), f - r * cos$1(n * x)];
	  }
	
	  project.invert = function(x, y) {
	    var fy = f - y, r = sign$1(n) * sqrt$1(x * x + fy * fy);
	    return [atan2(x, abs(fy)) / n * sign$1(fy), 2 * atan(pow$1(f / r, 1 / n)) - halfPi$3];
	  };
	
	  return project;
	}
	
	var conicConformal = function() {
	  return conicProjection(conicConformalRaw)
	      .scale(109.5)
	      .parallels([30, 30]);
	};
	
	function equirectangularRaw(lambda, phi) {
	  return [lambda, phi];
	}
	
	equirectangularRaw.invert = equirectangularRaw;
	
	var equirectangular = function() {
	  return projection(equirectangularRaw)
	      .scale(152.63);
	};
	
	function conicEquidistantRaw(y0, y1) {
	  var cy0 = cos$1(y0),
	      n = y0 === y1 ? sin$1(y0) : (cy0 - cos$1(y1)) / (y1 - y0),
	      g = cy0 / n + y0;
	
	  if (abs(n) < epsilon$4) return equirectangularRaw;
	
	  function project(x, y) {
	    var gy = g - y, nx = n * x;
	    return [gy * sin$1(nx), g - gy * cos$1(nx)];
	  }
	
	  project.invert = function(x, y) {
	    var gy = g - y;
	    return [atan2(x, abs(gy)) / n * sign$1(gy), g - sign$1(n) * sqrt$1(x * x + gy * gy)];
	  };
	
	  return project;
	}
	
	var conicEquidistant = function() {
	  return conicProjection(conicEquidistantRaw)
	      .scale(131.154)
	      .center([0, 13.9389]);
	};
	
	function gnomonicRaw(x, y) {
	  var cy = cos$1(y), k = cos$1(x) * cy;
	  return [cy * sin$1(x) / k, sin$1(y) / k];
	}
	
	gnomonicRaw.invert = azimuthalInvert(atan);
	
	var gnomonic = function() {
	  return projection(gnomonicRaw)
	      .scale(144.049)
	      .clipAngle(60);
	};
	
	function scaleTranslate(kx, ky, tx, ty) {
	  return kx === 1 && ky === 1 && tx === 0 && ty === 0 ? identity$7 : transformer({
	    point: function(x, y) {
	      this.stream.point(x * kx + tx, y * ky + ty);
	    }
	  });
	}
	
	var identity$8 = function() {
	  var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, transform = identity$7, // scale, translate and reflect
	      x0 = null, y0, x1, y1, clip = identity$7, // clip extent
	      cache,
	      cacheStream,
	      projection;
	
	  function reset() {
	    cache = cacheStream = null;
	    return projection;
	  }
	
	  return projection = {
	    stream: function(stream) {
	      return cache && cacheStream === stream ? cache : cache = transform(clip(cacheStream = stream));
	    },
	    clipExtent: function(_) {
	      return arguments.length ? (clip = _ == null ? (x0 = y0 = x1 = y1 = null, identity$7) : clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
	    },
	    scale: function(_) {
	      return arguments.length ? (transform = scaleTranslate((k = +_) * sx, k * sy, tx, ty), reset()) : k;
	    },
	    translate: function(_) {
	      return arguments.length ? (transform = scaleTranslate(k * sx, k * sy, tx = +_[0], ty = +_[1]), reset()) : [tx, ty];
	    },
	    reflectX: function(_) {
	      return arguments.length ? (transform = scaleTranslate(k * (sx = _ ? -1 : 1), k * sy, tx, ty), reset()) : sx < 0;
	    },
	    reflectY: function(_) {
	      return arguments.length ? (transform = scaleTranslate(k * sx, k * (sy = _ ? -1 : 1), tx, ty), reset()) : sy < 0;
	    },
	    fitExtent: function(extent, object) {
	      return fitExtent(projection, extent, object);
	    },
	    fitSize: function(size, object) {
	      return fitSize(projection, size, object);
	    }
	  };
	};
	
	function orthographicRaw(x, y) {
	  return [cos$1(y) * sin$1(x), sin$1(y)];
	}
	
	orthographicRaw.invert = azimuthalInvert(asin$1);
	
	var orthographic = function() {
	  return projection(orthographicRaw)
	      .scale(249.5)
	      .clipAngle(90 + epsilon$4);
	};
	
	function stereographicRaw(x, y) {
	  var cy = cos$1(y), k = 1 + cos$1(x) * cy;
	  return [cy * sin$1(x) / k, sin$1(y) / k];
	}
	
	stereographicRaw.invert = azimuthalInvert(function(z) {
	  return 2 * atan(z);
	});
	
	var stereographic = function() {
	  return projection(stereographicRaw)
	      .scale(250)
	      .clipAngle(142);
	};
	
	function transverseMercatorRaw(lambda, phi) {
	  return [log$1(tan((halfPi$3 + phi) / 2)), -lambda];
	}
	
	transverseMercatorRaw.invert = function(x, y) {
	  return [-y, 2 * atan(exp(x)) - halfPi$3];
	};
	
	var transverseMercator = function() {
	  var m = mercatorProjection(transverseMercatorRaw),
	      center = m.center,
	      rotate = m.rotate;
	
	  m.center = function(_) {
	    return arguments.length ? center([-_[1], _[0]]) : (_ = center(), [_[1], -_[0]]);
	  };
	
	  m.rotate = function(_) {
	    return arguments.length ? rotate([_[0], _[1], _.length > 2 ? _[2] + 90 : 90]) : (_ = rotate(), [_[0], _[1], _[2] - 90]);
	  };
	
	  return rotate([0, 0, 90])
	      .scale(159.155);
	};
	
	exports.version = version;
	exports.bisect = bisectRight;
	exports.bisectRight = bisectRight;
	exports.bisectLeft = bisectLeft;
	exports.ascending = ascending;
	exports.bisector = bisector;
	exports.descending = descending;
	exports.deviation = deviation;
	exports.extent = extent;
	exports.histogram = histogram;
	exports.thresholdFreedmanDiaconis = freedmanDiaconis;
	exports.thresholdScott = scott;
	exports.thresholdSturges = sturges;
	exports.max = max;
	exports.mean = mean;
	exports.median = median;
	exports.merge = merge;
	exports.min = min;
	exports.pairs = pairs;
	exports.permute = permute;
	exports.quantile = threshold;
	exports.range = range;
	exports.scan = scan;
	exports.shuffle = shuffle;
	exports.sum = sum;
	exports.ticks = ticks;
	exports.tickStep = tickStep;
	exports.transpose = transpose;
	exports.variance = variance;
	exports.zip = zip;
	exports.entries = entries;
	exports.keys = keys;
	exports.values = values;
	exports.map = map$1;
	exports.set = set;
	exports.nest = nest;
	exports.randomUniform = uniform;
	exports.randomNormal = normal;
	exports.randomLogNormal = logNormal;
	exports.randomBates = bates;
	exports.randomIrwinHall = irwinHall;
	exports.randomExponential = exponential;
	exports.easeLinear = linear;
	exports.easeQuad = quadInOut;
	exports.easeQuadIn = quadIn;
	exports.easeQuadOut = quadOut;
	exports.easeQuadInOut = quadInOut;
	exports.easeCubic = cubicInOut;
	exports.easeCubicIn = cubicIn;
	exports.easeCubicOut = cubicOut;
	exports.easeCubicInOut = cubicInOut;
	exports.easePoly = polyInOut;
	exports.easePolyIn = polyIn;
	exports.easePolyOut = polyOut;
	exports.easePolyInOut = polyInOut;
	exports.easeSin = sinInOut;
	exports.easeSinIn = sinIn;
	exports.easeSinOut = sinOut;
	exports.easeSinInOut = sinInOut;
	exports.easeExp = expInOut;
	exports.easeExpIn = expIn;
	exports.easeExpOut = expOut;
	exports.easeExpInOut = expInOut;
	exports.easeCircle = circleInOut;
	exports.easeCircleIn = circleIn;
	exports.easeCircleOut = circleOut;
	exports.easeCircleInOut = circleInOut;
	exports.easeBounce = bounceOut;
	exports.easeBounceIn = bounceIn;
	exports.easeBounceOut = bounceOut;
	exports.easeBounceInOut = bounceInOut;
	exports.easeBack = backInOut;
	exports.easeBackIn = backIn;
	exports.easeBackOut = backOut;
	exports.easeBackInOut = backInOut;
	exports.easeElastic = elasticOut;
	exports.easeElasticIn = elasticIn;
	exports.easeElasticOut = elasticOut;
	exports.easeElasticInOut = elasticInOut;
	exports.polygonArea = area;
	exports.polygonCentroid = centroid;
	exports.polygonHull = hull;
	exports.polygonContains = contains;
	exports.polygonLength = length$1;
	exports.path = path;
	exports.quadtree = quadtree;
	exports.queue = queue;
	exports.arc = arc;
	exports.area = area$1;
	exports.line = line;
	exports.pie = pie;
	exports.radialArea = radialArea;
	exports.radialLine = radialLine$1;
	exports.symbol = symbol;
	exports.symbols = symbols;
	exports.symbolCircle = circle;
	exports.symbolCross = cross$1;
	exports.symbolDiamond = diamond;
	exports.symbolSquare = square;
	exports.symbolStar = star;
	exports.symbolTriangle = triangle;
	exports.symbolWye = wye;
	exports.curveBasisClosed = basisClosed;
	exports.curveBasisOpen = basisOpen;
	exports.curveBasis = basis;
	exports.curveBundle = bundle;
	exports.curveCardinalClosed = cardinalClosed;
	exports.curveCardinalOpen = cardinalOpen;
	exports.curveCardinal = cardinal;
	exports.curveCatmullRomClosed = catmullRomClosed;
	exports.curveCatmullRomOpen = catmullRomOpen;
	exports.curveCatmullRom = catmullRom;
	exports.curveLinearClosed = linearClosed;
	exports.curveLinear = curveLinear;
	exports.curveMonotoneX = monotoneX;
	exports.curveMonotoneY = monotoneY;
	exports.curveNatural = natural;
	exports.curveStep = step;
	exports.curveStepAfter = stepAfter;
	exports.curveStepBefore = stepBefore;
	exports.stack = stack;
	exports.stackOffsetExpand = expand;
	exports.stackOffsetNone = none;
	exports.stackOffsetSilhouette = silhouette;
	exports.stackOffsetWiggle = wiggle;
	exports.stackOrderAscending = ascending$1;
	exports.stackOrderDescending = descending$2;
	exports.stackOrderInsideOut = insideOut;
	exports.stackOrderNone = none$1;
	exports.stackOrderReverse = reverse;
	exports.color = color;
	exports.rgb = rgb;
	exports.hsl = hsl;
	exports.lab = lab;
	exports.hcl = hcl;
	exports.cubehelix = cubehelix;
	exports.interpolate = interpolate;
	exports.interpolateArray = array$1;
	exports.interpolateDate = date;
	exports.interpolateNumber = interpolateNumber;
	exports.interpolateObject = object;
	exports.interpolateRound = interpolateRound;
	exports.interpolateString = interpolateString;
	exports.interpolateTransformCss = interpolateTransformCss;
	exports.interpolateTransformSvg = interpolateTransformSvg;
	exports.interpolateZoom = interpolateZoom;
	exports.interpolateRgb = interpolateRgb;
	exports.interpolateRgbBasis = rgbBasis;
	exports.interpolateRgbBasisClosed = rgbBasisClosed;
	exports.interpolateHsl = hsl$2;
	exports.interpolateHslLong = hslLong;
	exports.interpolateLab = lab$1;
	exports.interpolateHcl = hcl$2;
	exports.interpolateHclLong = hclLong;
	exports.interpolateCubehelix = cubehelix$2;
	exports.interpolateCubehelixLong = cubehelixLong;
	exports.interpolateBasis = basis$2;
	exports.interpolateBasisClosed = basisClosed$1;
	exports.quantize = quantize;
	exports.dispatch = dispatch;
	exports.dsvFormat = dsv;
	exports.csvParse = csvParse;
	exports.csvParseRows = csvParseRows;
	exports.csvFormat = csvFormat;
	exports.csvFormatRows = csvFormatRows;
	exports.tsvParse = tsvParse;
	exports.tsvParseRows = tsvParseRows;
	exports.tsvFormat = tsvFormat;
	exports.tsvFormatRows = tsvFormatRows;
	exports.request = request;
	exports.html = html;
	exports.json = json;
	exports.text = text;
	exports.xml = xml;
	exports.csv = csv$1;
	exports.tsv = tsv$1;
	exports.now = now;
	exports.timer = timer;
	exports.timerFlush = timerFlush;
	exports.timeout = timeout$1;
	exports.interval = interval$1;
	exports.timeInterval = newInterval;
	exports.timeMillisecond = millisecond;
	exports.timeMilliseconds = milliseconds;
	exports.timeSecond = second;
	exports.timeSeconds = seconds;
	exports.timeMinute = minute;
	exports.timeMinutes = minutes;
	exports.timeHour = hour;
	exports.timeHours = hours;
	exports.timeDay = day;
	exports.timeDays = days;
	exports.timeWeek = sunday;
	exports.timeWeeks = sundays;
	exports.timeSunday = sunday;
	exports.timeSundays = sundays;
	exports.timeMonday = monday;
	exports.timeMondays = mondays;
	exports.timeTuesday = tuesday;
	exports.timeTuesdays = tuesdays;
	exports.timeWednesday = wednesday;
	exports.timeWednesdays = wednesdays;
	exports.timeThursday = thursday;
	exports.timeThursdays = thursdays;
	exports.timeFriday = friday;
	exports.timeFridays = fridays;
	exports.timeSaturday = saturday;
	exports.timeSaturdays = saturdays;
	exports.timeMonth = month;
	exports.timeMonths = months;
	exports.timeYear = year;
	exports.timeYears = years;
	exports.utcMillisecond = millisecond;
	exports.utcMilliseconds = milliseconds;
	exports.utcSecond = second;
	exports.utcSeconds = seconds;
	exports.utcMinute = utcMinute;
	exports.utcMinutes = utcMinutes;
	exports.utcHour = utcHour;
	exports.utcHours = utcHours;
	exports.utcDay = utcDay;
	exports.utcDays = utcDays;
	exports.utcWeek = utcSunday;
	exports.utcWeeks = utcSundays;
	exports.utcSunday = utcSunday;
	exports.utcSundays = utcSundays;
	exports.utcMonday = utcMonday;
	exports.utcMondays = utcMondays;
	exports.utcTuesday = utcTuesday;
	exports.utcTuesdays = utcTuesdays;
	exports.utcWednesday = utcWednesday;
	exports.utcWednesdays = utcWednesdays;
	exports.utcThursday = utcThursday;
	exports.utcThursdays = utcThursdays;
	exports.utcFriday = utcFriday;
	exports.utcFridays = utcFridays;
	exports.utcSaturday = utcSaturday;
	exports.utcSaturdays = utcSaturdays;
	exports.utcMonth = utcMonth;
	exports.utcMonths = utcMonths;
	exports.utcYear = utcYear;
	exports.utcYears = utcYears;
	exports.formatLocale = formatLocale;
	exports.formatDefaultLocale = defaultLocale;
	exports.formatSpecifier = formatSpecifier;
	exports.precisionFixed = precisionFixed;
	exports.precisionPrefix = precisionPrefix;
	exports.precisionRound = precisionRound;
	exports.isoFormat = formatIso;
	exports.isoParse = parseIso;
	exports.timeFormatLocale = formatLocale$1;
	exports.timeFormatDefaultLocale = defaultLocale$1;
	exports.scaleBand = band;
	exports.scalePoint = point$4;
	exports.scaleIdentity = identity$4;
	exports.scaleLinear = linear$2;
	exports.scaleLog = log;
	exports.scaleOrdinal = ordinal;
	exports.scaleImplicit = implicit;
	exports.scalePow = pow;
	exports.scaleSqrt = sqrt;
	exports.scaleQuantile = quantile$$1;
	exports.scaleQuantize = quantize$1;
	exports.scaleThreshold = threshold$1;
	exports.scaleTime = time;
	exports.scaleUtc = utcTime;
	exports.schemeCategory10 = category10;
	exports.schemeCategory20b = category20b;
	exports.schemeCategory20c = category20c;
	exports.schemeCategory20 = category20;
	exports.scaleSequential = sequential;
	exports.interpolateCubehelixDefault = cubehelix$3;
	exports.interpolateRainbow = rainbow$1;
	exports.interpolateWarm = warm;
	exports.interpolateCool = cool;
	exports.interpolateViridis = viridis;
	exports.interpolateMagma = magma;
	exports.interpolateInferno = inferno;
	exports.interpolatePlasma = plasma;
	exports.creator = creator;
	exports.customEvent = customEvent;
	exports.local = local;
	exports.matcher = matcher$1;
	exports.mouse = mouse;
	exports.namespace = namespace;
	exports.namespaces = namespaces;
	exports.select = select;
	exports.selectAll = selectAll;
	exports.selection = selection;
	exports.selector = selector;
	exports.selectorAll = selectorAll;
	exports.touch = touch;
	exports.touches = touches;
	exports.window = window;
	exports.active = active;
	exports.interrupt = interrupt;
	exports.transition = transition;
	exports.axisTop = axisTop;
	exports.axisRight = axisRight;
	exports.axisBottom = axisBottom;
	exports.axisLeft = axisLeft;
	exports.cluster = cluster;
	exports.hierarchy = hierarchy;
	exports.pack = index;
	exports.packSiblings = siblings;
	exports.packEnclose = enclose;
	exports.partition = partition;
	exports.stratify = stratify;
	exports.tree = tree;
	exports.treemap = index$1;
	exports.treemapBinary = binary;
	exports.treemapDice = treemapDice;
	exports.treemapSlice = treemapSlice;
	exports.treemapSliceDice = sliceDice;
	exports.treemapSquarify = squarify;
	exports.treemapResquarify = resquarify;
	exports.forceCenter = center$1;
	exports.forceCollide = collide;
	exports.forceLink = link;
	exports.forceManyBody = manyBody;
	exports.forceSimulation = simulation;
	exports.forceX = x$3;
	exports.forceY = y$3;
	exports.drag = drag;
	exports.dragDisable = dragDisable;
	exports.dragEnable = yesdrag;
	exports.voronoi = voronoi;
	exports.zoom = zoom;
	exports.zoomIdentity = identity$6;
	exports.zoomTransform = transform;
	exports.brush = brush;
	exports.brushX = brushX;
	exports.brushY = brushY;
	exports.brushSelection = brushSelection;
	exports.chord = chord;
	exports.ribbon = ribbon;
	exports.geoAlbers = albers;
	exports.geoAlbersUsa = albersUsa;
	exports.geoArea = area$2;
	exports.geoAzimuthalEqualArea = azimuthalEqualArea;
	exports.geoAzimuthalEqualAreaRaw = azimuthalEqualAreaRaw;
	exports.geoAzimuthalEquidistant = azimuthalEquidistant;
	exports.geoAzimuthalEquidistantRaw = azimuthalEquidistantRaw;
	exports.geoBounds = bounds;
	exports.geoCentroid = centroid$1;
	exports.geoCircle = circle$1;
	exports.geoClipExtent = extent$1;
	exports.geoConicConformal = conicConformal;
	exports.geoConicConformalRaw = conicConformalRaw;
	exports.geoConicEqualArea = conicEqualArea;
	exports.geoConicEqualAreaRaw = conicEqualAreaRaw;
	exports.geoConicEquidistant = conicEquidistant;
	exports.geoConicEquidistantRaw = conicEquidistantRaw;
	exports.geoDistance = distance;
	exports.geoEquirectangular = equirectangular;
	exports.geoEquirectangularRaw = equirectangularRaw;
	exports.geoGnomonic = gnomonic;
	exports.geoGnomonicRaw = gnomonicRaw;
	exports.geoGraticule = graticule;
	exports.geoGraticule10 = graticule10;
	exports.geoIdentity = identity$8;
	exports.geoInterpolate = interpolate$2;
	exports.geoLength = length$2;
	exports.geoMercator = mercator;
	exports.geoMercatorRaw = mercatorRaw;
	exports.geoOrthographic = orthographic;
	exports.geoOrthographicRaw = orthographicRaw;
	exports.geoPath = index$3;
	exports.geoProjection = projection;
	exports.geoProjectionMutator = projectionMutator;
	exports.geoRotation = rotation;
	exports.geoStereographic = stereographic;
	exports.geoStereographicRaw = stereographicRaw;
	exports.geoStream = geoStream;
	exports.geoTransform = transform$1;
	exports.geoTransverseMercator = transverseMercator;
	exports.geoTransverseMercatorRaw = transverseMercatorRaw;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	/// <reference path='../Facet/Facet.ts' />
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Facet_1 = __webpack_require__(141);
	var ComponentOptions_1 = __webpack_require__(98);
	var Utils_1 = __webpack_require__(18);
	var TemplateHelpers_1 = __webpack_require__(122);
	var DateUtils_1 = __webpack_require__(56);
	var FacetRangeQueryController_1 = __webpack_require__(83);
	var Initialization_1 = __webpack_require__(95);
	var Globalize = __webpack_require__(4);
	/**
	 * This component displays a facet with values expressed as ranges. These ranges are computed from the results of the current query. This component inherits from the Facet component.
	 */
	var FacetRange = (function (_super) {
	    __extends(FacetRange, _super);
	    function FacetRange(element, options, bindings) {
	        _super.call(this, element, ComponentOptions_1.ComponentOptions.initComponentOptions(element, FacetRange, options), bindings, FacetRange.ID);
	        this.element = element;
	        this.options.enableFacetSearch = false;
	        this.options.enableSettings = false;
	        this.options.includeInOmnibox = false;
	        this.options.enableMoreLess = false;
	    }
	    FacetRange.prototype.getValueCaption = function (facetValue) {
	        var ret = _super.prototype.getValueCaption.call(this, facetValue);
	        if (Utils_1.Utils.exists(this.options.valueCaption) && typeof this.options.valueCaption == 'string') {
	            var startEnd = /^(.*)\.\.(.*)$/.exec(facetValue.value);
	            if (startEnd != null) {
	                var helper = TemplateHelpers_1.TemplateHelpers.getHelper(this.options.valueCaption);
	                if (helper != null) {
	                    ret = helper.call(this, startEnd[1]) + ' - ' + helper.call(this, startEnd[2]);
	                }
	                else {
	                    var start = startEnd[1].match(/^[\+\-]?[0-9]+(\.[0-9]+)?$/) ? Number(startEnd[1]) : DateUtils_1.DateUtils.convertFromJsonDateIfNeeded(startEnd[1]);
	                    var end = startEnd[2].match(/^[\+\-]?[0-9]+(\.[0-9]+)?$/) ? Number(startEnd[2]) : DateUtils_1.DateUtils.convertFromJsonDateIfNeeded(startEnd[2]);
	                    ret = Globalize.format(start, this.options.valueCaption) + ' - ' + Globalize.format(end, this.options.valueCaption);
	                }
	            }
	        }
	        return ret;
	    };
	    FacetRange.prototype.initFacetQueryController = function () {
	        this.facetQueryController = new FacetRangeQueryController_1.FacetRangeQueryController(this);
	    };
	    FacetRange.prototype.processNewGroupByResults = function (groupByResult) {
	        var _this = this;
	        if (groupByResult != null) {
	            if (this.options.ranges == null && (!this.keepDisplayedValuesNextTime || this.values.hasSelectedOrExcludedValues())) {
	                this.keepDisplayedValuesNextTime = false;
	                groupByResult.values.sort(function (valueA, valueB) {
	                    var startEndA = valueA.value.split('..');
	                    var startEndB = valueB.value.split('..');
	                    if (_this.options.dateField) {
	                        return Date.parse(startEndA[0]) - Date.parse(startEndB[0]);
	                    }
	                    return Number(startEndA[0]) - Number(startEndB[0]);
	                });
	            }
	        }
	        _super.prototype.processNewGroupByResults.call(this, groupByResult);
	    };
	    FacetRange.ID = 'FacetRange';
	    FacetRange.parent = Facet_1.Facet;
	    /**
	     * The options for the component
	     * @componentOptions
	     */
	    FacetRange.options = {
	        /**
	         * Specifies whether the field for which you are requesting a range is a date field to allow the facet to correctly build the outgoing group by request.
	         *
	         * Default value is `false`.
	         */
	        dateField: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: false }),
	        /**
	         * Specifies an array of ranges to use as facet values. If it is not set, it will be automatically generated by the index.
	         *
	         * This option can only be set in the init call of your interface, not directly as an HTML attribute.
	         *
	         * ```
	         * var myRanges = [{
	         *      start: 0,
	         *      end: 100,
	         *      label: "0 - 100",
	         *      endInclusive: false
	         *    }, {
	         *      start: 100,
	         *      end: 200,
	         *      label: "100 - 200",
	         *      endInclusive: false
	         *    }, {
	         *      start: 200,
	         *      end: 300,
	         *      label: "200 - 300",
	         *      endInclusive: false
	         * }]
	         *
	         *
	         * Coveo.init(document.querySelector('#search'), {
	         *    FacetRange : {
	         *        ranges : myRanges
	         *    }
	         * })
	         *
	         * // Or using the jquery extension
	         *
	         * $("#search").coveo("init", {
	         *    FacetRange : {
	         *        ranges : myRanges
	         *    }
	         * })
	         * ```
	         */
	        ranges: ComponentOptions_1.ComponentOptions.buildCustomOption(function () {
	            return null;
	        })
	    };
	    return FacetRange;
	}(Facet_1.Facet));
	exports.FacetRange = FacetRange;
	Initialization_1.Initialization.registerAutoCreateComponent(FacetRange);


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var DeviceUtils_1 = __webpack_require__(20);
	var QueryEvents_1 = __webpack_require__(47);
	var Model_1 = __webpack_require__(87);
	var QueryStateModel_1 = __webpack_require__(90);
	var QueryStateModel_2 = __webpack_require__(90);
	var AnalyticsActionListMeta_1 = __webpack_require__(110);
	var Initialization_1 = __webpack_require__(95);
	var Assert_1 = __webpack_require__(17);
	var Strings_1 = __webpack_require__(34);
	var Dom_1 = __webpack_require__(57);
	var KeyboardUtils_1 = __webpack_require__(68);
	/**
	 * This component attaches itself to a div and allows users to navigate through the different result pages.<br/>
	 * It takes care of triggering a query with the correct range whenever a user selects a page or uses the navigation buttons (**Previous**, **Next**).
	 */
	var Pager = (function (_super) {
	    __extends(Pager, _super);
	    /**
	     * Create a new Pager. Bind multiple query events (new query, building query, query success).<br/>
	     * Render itself on every query success.
	     * @param element HTMLElement on which to instantiate the page (Normally : a div)
	     * @param options
	     * @param bindings
	     */
	    function Pager(element, options, bindings) {
	        var _this = this;
	        _super.call(this, element, Pager.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.listenToQueryStateChange = true;
	        this.ignoreNextQuerySuccess = false;
	        // The normal behavior of this component is to reset to page 1 when a new
	        // query is performed by other components (i.e. not pagers).
	        //
	        // This behavior is overridden when the 'first' state is
	        // programmatically modified.
	        this.needToReset = true;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, Pager, options);
	        this.currentPage = 1;
	        if (this.options.maxNumberOfPages == null) {
	            this.options.maxNumberOfPages = 1000 /
	                (this.queryController.options.resultsPerPage > 0 ? this.queryController.options.resultsPerPage : 10);
	        }
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.newQuery, function (args) { return _this.handleNewQuery(args); });
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.buildingQuery, function (args) { return _this.handleBuildingQuery(args); });
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.querySuccess, function (args) { return _this.handleQuerySuccess(args); });
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.queryError, function () { return _this.handleQueryError(); });
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.noResults, function (args) { return _this.handleNoResults(args); });
	        this.bind.onQueryState(Model_1.MODEL_EVENTS.CHANGE_ONE, QueryStateModel_2.QUERY_STATE_ATTRIBUTES.FIRST, function (data) { return _this.handleQueryStateModelChanged(data); });
	        this.list = document.createElement('ul');
	        Dom_1.$$(this.list).addClass('coveo-pager-list');
	        element.appendChild(this.list);
	    }
	    /**
	     * Set the current page, and execute a query.<br/>
	     * Log the required analytics event (pagerNumber by default).
	     * @param pageNumber
	     * @param analyticCause
	     */
	    Pager.prototype.setPage = function (pageNumber, analyticCause) {
	        if (analyticCause === void 0) { analyticCause = AnalyticsActionListMeta_1.analyticsActionCauseList.pagerNumber; }
	        Assert_1.Assert.exists(pageNumber);
	        this.currentPage = Math.max(Math.min(pageNumber, 1000), 1);
	        this.updateQueryStateModel(this.getFirstResultNumber(this.currentPage));
	        this.usageAnalytics.logCustomEvent(analyticCause, { pagerNumber: this.currentPage }, this.element);
	        this.queryController.executeQuery({
	            ignoreWarningSearchEvent: true,
	            keepLastSearchUid: true,
	            origin: this
	        });
	    };
	    /**
	     * Go to the previous page, and execute a query.<br/>
	     * Log the required analytics event (pagerPrevious).
	     */
	    Pager.prototype.previousPage = function () {
	        this.setPage(this.currentPage - 1, AnalyticsActionListMeta_1.analyticsActionCauseList.pagerPrevious);
	    };
	    /**
	     * Go to the next page, and execute a query.<br/>
	     * Log the required analytics event (pagerNext).
	     */
	    Pager.prototype.nextPage = function () {
	        this.setPage(this.currentPage + 1, AnalyticsActionListMeta_1.analyticsActionCauseList.pagerNext);
	    };
	    Pager.prototype.handleNewQuery = function (data) {
	        var triggeredByPager = data && data.origin && data.origin.type == Pager.ID;
	        if (this.needToReset && !triggeredByPager) {
	            this.currentPage = 1;
	            this.updateQueryStateModel(this.getFirstResultNumber(this.currentPage));
	        }
	        this.needToReset = true;
	    };
	    Pager.prototype.updateQueryStateModel = function (attrValue) {
	        this.listenToQueryStateChange = false;
	        this.queryStateModel.set(QueryStateModel_1.QueryStateModel.attributesEnum.first, attrValue);
	        this.listenToQueryStateChange = true;
	    };
	    Pager.prototype.handleQueryError = function () {
	        this.reset();
	    };
	    Pager.prototype.handleQuerySuccess = function (data) {
	        var _this = this;
	        this.reset();
	        if (this.ignoreNextQuerySuccess) {
	            this.ignoreNextQuerySuccess = false;
	        }
	        else {
	            Assert_1.Assert.isNotUndefined(data);
	            var firstResult = data.query.firstResult;
	            var count = data.results.totalCountFiltered;
	            var pagerBoundary = this.computePagerBoundary(firstResult, count);
	            this.currentPage = pagerBoundary.currentPage;
	            if (pagerBoundary.end - pagerBoundary.start > 0) {
	                var _loop_1 = function() {
	                    listItemValue = document.createElement('a');
	                    Dom_1.$$(listItemValue).addClass(['coveo-pager-list-item-text', 'coveo-pager-anchor']);
	                    Dom_1.$$(listItemValue).text(i.toString(10));
	                    var listItem = Dom_1.$$('li', { className: 'coveo-pager-list-item', tabindex: 0 }).el;
	                    if (i == this_1.currentPage) {
	                        Dom_1.$$(listItem).addClass('coveo-active');
	                    }
	                    (function (pageNumber) {
	                        var clickAction = function () { return _this.handleClickPage(pageNumber); };
	                        Dom_1.$$(listItem).on('click', clickAction);
	                        Dom_1.$$(listItem).on('keyup', KeyboardUtils_1.KeyboardUtils.keypressAction(KeyboardUtils_1.KEYBOARD.ENTER, clickAction));
	                    })(i);
	                    listItem.appendChild(listItemValue);
	                    this_1.list.appendChild(listItem);
	                };
	                var this_1 = this;
	                var listItemValue;
	                for (var i = pagerBoundary.start; i <= pagerBoundary.end; i++) {
	                    _loop_1();
	                }
	                if (this.options.enableNavigationButton && pagerBoundary.lastResultPage > 1) {
	                    this.renderNavigationButton(pagerBoundary, this.list);
	                }
	            }
	        }
	    };
	    Pager.prototype.handleNoResults = function (data) {
	        var lastValidPage = this.computePagerBoundary(data.results.totalCountFiltered, data.results.totalCount).lastResultPage;
	        if (this.currentPage > lastValidPage) {
	            this.ignoreNextQuerySuccess = true;
	            this.setPage(lastValidPage);
	        }
	    };
	    Pager.prototype.reset = function () {
	        Dom_1.$$(this.list).empty();
	    };
	    Pager.prototype.handleBuildingQuery = function (data) {
	        Assert_1.Assert.exists(data);
	        var eventArgs = this.getQueryEventArgs();
	        data.queryBuilder.firstResult = eventArgs.first;
	        data.queryBuilder.numberOfResults = eventArgs.count;
	    };
	    Pager.prototype.computePagerBoundary = function (firstResult, totalCount) {
	        var resultPerPage = this.queryController.options.resultsPerPage;
	        var currentPage = Math.floor(firstResult / resultPerPage) + 1;
	        var lastPageNumber = Math.min(Math.ceil(totalCount / resultPerPage), this.options.maxNumberOfPages);
	        lastPageNumber = Math.max(lastPageNumber, 1);
	        var halfLength = Math.floor(this.options.numberOfPages / 2);
	        var firstPageNumber = currentPage - halfLength;
	        firstPageNumber = Math.max(firstPageNumber, 1);
	        var endPageNumber = firstPageNumber + this.options.numberOfPages - 1;
	        endPageNumber = Math.min(endPageNumber, lastPageNumber);
	        return {
	            start: firstPageNumber,
	            end: endPageNumber,
	            lastResultPage: lastPageNumber,
	            currentPage: currentPage
	        };
	    };
	    Pager.prototype.renderNavigationButton = function (pagerBoundary, list) {
	        var _this = this;
	        if (this.currentPage > 1) {
	            var previous = document.createElement('li');
	            Dom_1.$$(previous).addClass(['coveo-pager-previous', 'coveo-pager-anchor', 'coveo-pager-list-item']);
	            var buttonLink = document.createElement('a');
	            var buttonImg = document.createElement('span');
	            buttonLink.appendChild(buttonImg);
	            buttonLink.setAttribute('title', Strings_1.l('Previous'));
	            previous.appendChild(buttonLink);
	            Dom_1.$$(previous).on('click', function () { return _this.handleClickPrevious(); });
	            this.list.insertBefore(previous, this.list.firstChild);
	        }
	        if (this.currentPage < pagerBoundary.lastResultPage) {
	            var next = document.createElement('li');
	            Dom_1.$$(next).addClass(['coveo-pager-next', 'coveo-pager-anchor', 'coveo-pager-list-item']);
	            var buttonLink = document.createElement('a');
	            var buttonImg = document.createElement('span');
	            buttonLink.appendChild(buttonImg);
	            buttonLink.setAttribute('title', Strings_1.l('Next'));
	            next.appendChild(buttonLink);
	            Dom_1.$$(next).on('click', function () { return _this.handleClickNext(); });
	            this.list.appendChild(next);
	        }
	    };
	    Pager.prototype.handleQueryStateModelChanged = function (data) {
	        if (!this.listenToQueryStateChange) {
	            return;
	        }
	        Assert_1.Assert.exists(data);
	        this.needToReset = false;
	        var firstResult = data.value;
	        this.currentPage = this.fromFirstResultsToPageNumber(firstResult);
	    };
	    Pager.prototype.handleClickPage = function (pageNumber) {
	        Assert_1.Assert.exists(pageNumber);
	        this.setPage(pageNumber);
	    };
	    Pager.prototype.handleClickPrevious = function () {
	        this.previousPage();
	    };
	    Pager.prototype.handleClickNext = function () {
	        this.nextPage();
	    };
	    Pager.prototype.fromFirstResultsToPageNumber = function (firstResult) {
	        return (firstResult / this.queryController.options.resultsPerPage) + 1;
	    };
	    Pager.prototype.getFirstResultNumber = function (pageNumber) {
	        if (pageNumber === void 0) { pageNumber = this.currentPage; }
	        return (pageNumber - 1) * this.queryController.options.resultsPerPage;
	    };
	    Pager.prototype.getQueryEventArgs = function () {
	        return {
	            count: this.queryController.options.resultsPerPage,
	            first: this.getFirstResultNumber()
	        };
	    };
	    Pager.ID = 'Pager';
	    /**
	     * The options for the Pager
	     * @componentOptions
	     */
	    Pager.options = {
	        /**
	         * Specifies how many page links to display in the pager.<br/>
	         * The default value is 5 pages on desktop, 3 on mobile.
	         */
	        numberOfPages: ComponentOptions_1.ComponentOptions.buildNumberOption({
	            defaultFunction: function () {
	                if (DeviceUtils_1.DeviceUtils.isMobileDevice()) {
	                    return 3;
	                }
	                else {
	                    return 5;
	                }
	            },
	            min: 1
	        }),
	        /**
	         * Specifies whether the **Previous** and **Next** buttons appear at each end of the pager when appropriate.<br/>
	         * The default value is `true`.
	         */
	        enableNavigationButton: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true }),
	        /**
	         * Specifies the maximum number of pages that will be displayed if enough results are available.<br/>
	         * The default value is 100 pages.<br/>
	         * This property is typically set when the default number of accessible results from the index has been changed from its default value of 1000. (So 10 per page X 100 maximumNumberOfPage)
	         */
	        maxNumberOfPages: ComponentOptions_1.ComponentOptions.buildNumberOption({ defaultValue: undefined })
	    };
	    return Pager;
	}(Component_1.Component));
	exports.Pager = Pager;
	Initialization_1.Initialization.registerAutoCreateComponent(Pager);


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var Initialization_1 = __webpack_require__(95);
	var QueryEvents_1 = __webpack_require__(47);
	var AnalyticsActionListMeta_1 = __webpack_require__(110);
	var Assert_1 = __webpack_require__(17);
	var Dom_1 = __webpack_require__(57);
	var KeyboardUtils_1 = __webpack_require__(68);
	/**
	 * This component attaches itself to a div and allows users to choose the number of results displayed per page.<br/>
	 */
	var ResultsPerPage = (function (_super) {
	    __extends(ResultsPerPage, _super);
	    /**
	     * Create a new ResultsPerPage<br/>
	     * Render itself on every query success.
	     * @param element HTMLElement on which to instantiate the page (Normally : a div).
	     * @param options
	     * @param bindings
	     */
	    function ResultsPerPage(element, options, bindings) {
	        var _this = this;
	        _super.call(this, element, ResultsPerPage.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, ResultsPerPage, options);
	        this.currentResultsPerPage = this.getInitialChoice();
	        this.queryController.options.resultsPerPage = this.currentResultsPerPage;
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.querySuccess, function (args) { return _this.handleQuerySuccess(args); });
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.queryError, function () { return _this.handleQueryError(); });
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.noResults, function (args) { return _this.handleNoResults(); });
	        this.initComponent(element);
	    }
	    /**
	     * Set the current number of results per page, and execute a query.<br/>
	     * Log the required analytics event (pagerResize by default).
	     * @param resultsPerPage
	     * @param analyticCause
	     */
	    ResultsPerPage.prototype.setResultsPerPage = function (resultsPerPage, analyticCause) {
	        if (analyticCause === void 0) { analyticCause = AnalyticsActionListMeta_1.analyticsActionCauseList.pagerResize; }
	        Assert_1.Assert.exists(resultsPerPage);
	        Assert_1.Assert.check(this.options.choicesDisplayed.indexOf(resultsPerPage) != -1, 'The specified number of results is not available in the options.');
	        this.currentResultsPerPage = resultsPerPage;
	        this.queryController.options.resultsPerPage = this.currentResultsPerPage;
	        this.usageAnalytics.logCustomEvent(analyticCause, { currentResultsPerPage: this.currentResultsPerPage }, this.element);
	        this.queryController.executeQuery({
	            ignoreWarningSearchEvent: true,
	            keepLastSearchUid: true,
	            origin: this
	        });
	    };
	    ResultsPerPage.prototype.getInitialChoice = function () {
	        var initialChoice = this.options.choicesDisplayed[0];
	        if (this.options.initialChoice !== undefined) {
	            if (this.options.choicesDisplayed.indexOf(this.options.initialChoice) > -1) {
	                initialChoice = this.options.initialChoice;
	            }
	            else {
	                this.logger.warn('The initial number of results is not within the choices displayed. Consider setting a value that can be selected. The first choice will be selected instead.');
	            }
	        }
	        return initialChoice;
	    };
	    ResultsPerPage.prototype.initComponent = function (element) {
	        this.span = Dom_1.$$('span', {
	            className: 'coveo-results-per-page-text'
	        }, 'Results per page').el;
	        element.appendChild(this.span);
	        this.list = Dom_1.$$('ul', {
	            className: 'coveo-results-per-page-list'
	        }).el;
	        element.appendChild(this.list);
	    };
	    ResultsPerPage.prototype.render = function () {
	        var _this = this;
	        Dom_1.$$(this.span).removeClass('coveo-results-per-page-no-results');
	        var numResultsList = this.options.choicesDisplayed;
	        var _loop_1 = function() {
	            var listItem = Dom_1.$$('li', {
	                className: 'coveo-results-per-page-list-item',
	                tabindex: 0
	            });
	            if (numResultsList[i] == this_1.currentResultsPerPage) {
	                listItem.addClass('coveo-active');
	            }
	            (function (resultsPerPage) {
	                var clickAction = function () { return _this.handleClickPage(numResultsList[resultsPerPage]); };
	                listItem.on('click', clickAction);
	                listItem.on('keyup', KeyboardUtils_1.KeyboardUtils.keypressAction(KeyboardUtils_1.KEYBOARD.ENTER, clickAction));
	            })(i);
	            listItem.el.appendChild(Dom_1.$$('a', {
	                className: 'coveo-results-per-page-list-item-text'
	            }, numResultsList[i].toString()).el);
	            this_1.list.appendChild(listItem.el);
	        };
	        var this_1 = this;
	        for (var i = 0; i < numResultsList.length; i++) {
	            _loop_1();
	        }
	    };
	    ResultsPerPage.prototype.handleQueryError = function () {
	        this.reset();
	    };
	    ResultsPerPage.prototype.handleNoResults = function () {
	        this.reset();
	    };
	    ResultsPerPage.prototype.handleQuerySuccess = function (data) {
	        if (data.results.results.length != 0) {
	            this.reset();
	            this.render();
	        }
	    };
	    ResultsPerPage.prototype.handleClickPage = function (resultsPerPage) {
	        Assert_1.Assert.exists(resultsPerPage);
	        this.setResultsPerPage(resultsPerPage);
	    };
	    ResultsPerPage.prototype.reset = function () {
	        Dom_1.$$(this.span).addClass('coveo-results-per-page-no-results');
	        Dom_1.$$(this.list).empty();
	    };
	    ResultsPerPage.ID = 'ResultsPerPage';
	    /**
	     * The options for the ResultsPerPage
	     * @componentOptions
	     */
	    ResultsPerPage.options = {
	        /**
	         * Specifies the possible values of the number of results to display per page.<br/>
	         * The default value is 10, 25, 50, 100.
	         */
	        choicesDisplayed: ComponentOptions_1.ComponentOptions.buildCustomListOption(function (list) {
	            var values = _.map(list, function (value) {
	                return parseInt(value, 10);
	            });
	            return values.length == 0 ? null : values;
	        }, { defaultValue: [10, 25, 50, 100] }),
	        /**
	         * Specifies the default value for the number of results to display per page.<br/>
	         * The default value is the first value of the choicesDisplayed parameter.
	         */
	        initialChoice: ComponentOptions_1.ComponentOptions.buildNumberOption()
	    };
	    return ResultsPerPage;
	}(Component_1.Component));
	exports.ResultsPerPage = ResultsPerPage;
	Initialization_1.Initialization.registerAutoCreateComponent(ResultsPerPage);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var Assert_1 = __webpack_require__(17);
	var HighlightUtils_1 = __webpack_require__(66);
	var Initialization_1 = __webpack_require__(95);
	/**
	 * This component, located in a result template, is used to render the document excerpt,
	 * as well as highlighting searched **keywords** using the appropriate template helpers.
	 */
	var Excerpt = (function (_super) {
	    __extends(Excerpt, _super);
	    /**
	     * Create a new Excerpt component
	     * @param element
	     * @param options
	     * @param bindings
	     * @param result
	     */
	    function Excerpt(element, options, bindings, result) {
	        _super.call(this, element, Excerpt.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.bindings = bindings;
	        this.result = result;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, Excerpt, options);
	        this.result = this.result || this.resolveResult();
	        Assert_1.Assert.exists(this.result);
	        this.element.innerHTML = HighlightUtils_1.HighlightUtils.highlightString(this.result.excerpt, this.result.excerptHighlights, null, 'coveo-highlight');
	    }
	    Excerpt.ID = 'Excerpt';
	    return Excerpt;
	}(Component_1.Component));
	exports.Excerpt = Excerpt;
	Initialization_1.Initialization.registerAutoCreateComponent(Excerpt);


/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var ComponentOptionsModel_1 = __webpack_require__(91);
	var AnalyticsActionListMeta_1 = __webpack_require__(110);
	var ResultListEvents_1 = __webpack_require__(48);
	var HighlightUtils_1 = __webpack_require__(66);
	var DeviceUtils_1 = __webpack_require__(20);
	var OSUtils_1 = __webpack_require__(70);
	var Initialization_1 = __webpack_require__(95);
	var QueryUtils_1 = __webpack_require__(23);
	var Assert_1 = __webpack_require__(17);
	var Utils_1 = __webpack_require__(18);
	var Defer_1 = __webpack_require__(31);
	var Dom_1 = __webpack_require__(57);
	/**
	 * This component is intended to be placed inside a result template, which itself is used inside a {@link ResultList} component.
	 * The ResultLink component automatically transforms a search result title into a clickable link that points to the original document.
	 */
	var ResultLink = (function (_super) {
	    __extends(ResultLink, _super);
	    function ResultLink(element, options, bindings, result, os) {
	        var _this = this;
	        _super.call(this, element, ResultLink.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.bindings = bindings;
	        this.result = result;
	        this.os = os;
	        this.logOpenDocument = _.debounce(function () {
	            _this.queryController.saveLastQuery();
	            var documentURL = Dom_1.$$(_this.element).getAttribute('href');
	            if (documentURL == undefined || documentURL == '') {
	                documentURL = _this.result.clickUri;
	            }
	            _this.usageAnalytics.logClickEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.documentOpen, {
	                documentURL: documentURL,
	                documentTitle: _this.result.title,
	                author: _this.result.raw.author
	            }, _this.result, _this.root);
	            Defer_1.Defer.flush();
	        }, 1500, true);
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, ResultLink, options);
	        this.options = _.extend({}, this.options, this.componentOptionsModel.get(ComponentOptionsModel_1.ComponentOptionsModel.attributesEnum.resultLink));
	        this.result = result || this.resolveResult();
	        if (this.options.openQuickview == null) {
	            this.options.openQuickview = result.raw['connectortype'] == 'ExchangeCrawler' && DeviceUtils_1.DeviceUtils.isMobileDevice();
	        }
	        this.element.setAttribute('tabindex', '0');
	        Assert_1.Assert.exists(this.componentOptionsModel);
	        Assert_1.Assert.exists(this.result);
	        if (!this.quickviewShouldBeOpened()) {
	            // We assume that anytime the contextual menu is opened on a result link
	            // this is do "open in a new tab" or something similar.
	            // This is not 100% accurate, but we estimate it to be the lesser of 2 evils (not logging anything)
	            Dom_1.$$(element).on('contextmenu', function () {
	                _this.logOpenDocument();
	            });
	            Dom_1.$$(element).on('click', function () {
	                _this.logOpenDocument();
	            });
	        }
	        if (/^\s*$/.test(this.element.innerHTML)) {
	            this.element.innerHTML = this.result.title ? HighlightUtils_1.HighlightUtils.highlightString(this.result.title, this.result.titleHighlights, null, 'coveo-highlight') : this.result.clickUri;
	        }
	        this.bindEventToOpen();
	    }
	    ResultLink.prototype.bindEventToOpen = function () {
	        return this.bindOnClickIfNotUndefined() || this.bindOpenQuickviewIfNotUndefined() || this.setHrefIfNotAlready() || this.openLinkThatIsNotAnAnchor();
	    };
	    ResultLink.prototype.bindOnClickIfNotUndefined = function () {
	        var _this = this;
	        if (this.options.onClick != undefined) {
	            Dom_1.$$(this.element).on('click', function (e) {
	                _this.options.onClick.call(_this, e, _this.result);
	            });
	            return true;
	        }
	        else {
	            return false;
	        }
	    };
	    ResultLink.prototype.bindOpenQuickviewIfNotUndefined = function () {
	        var _this = this;
	        if (this.quickviewShouldBeOpened()) {
	            Dom_1.$$(this.element).on('click', function (e) {
	                e.preventDefault();
	                Dom_1.$$(_this.bindings.resultElement).trigger(ResultListEvents_1.ResultListEvents.openQuickview);
	            });
	            return true;
	        }
	        else {
	            return false;
	        }
	    };
	    ResultLink.prototype.openLinkThatIsNotAnAnchor = function () {
	        var _this = this;
	        if (!this.elementIsAnAnchor()) {
	            Dom_1.$$(this.element).on('click', function (ev) {
	                if (_this.options.alwaysOpenInNewWindow) {
	                    if (_this.options.openInOutlook) {
	                        _this.openLinkInOutlook();
	                    }
	                    else {
	                        _this.openLinkInNewWindow();
	                    }
	                }
	                else {
	                    _this.openLink();
	                }
	            });
	            return true;
	        }
	        return false;
	    };
	    /**
	     * Opens the result
	     */
	    ResultLink.prototype.openLink = function () {
	        window.location.href = this.getResultUri();
	    };
	    /**
	     * Opens the result in a new window
	     */
	    ResultLink.prototype.openLinkInNewWindow = function () {
	        window.open(this.getResultUri(), '_blank');
	    };
	    /**
	     * Opens the result in outlook if the result has an outlook field.
	     */
	    ResultLink.prototype.openLinkInOutlook = function () {
	        if (this.hasOutlookField()) {
	            this.openLink();
	        }
	    };
	    ResultLink.prototype.setHrefIfNotAlready = function () {
	        // Do not erase any value put in href by the template, etc. Allows
	        // using custom click urls while still keeping analytics recording
	        // and other behavior brought by the component.
	        if (this.elementIsAnAnchor() && !Utils_1.Utils.isNonEmptyString(Dom_1.$$(this.element).getAttribute('href'))) {
	            Dom_1.$$(this.element).setAttribute('href', this.getResultUri());
	            if (this.options.alwaysOpenInNewWindow && !(this.options.openInOutlook && this.hasOutlookField())) {
	                Dom_1.$$(this.element).setAttribute('target', '_blank');
	            }
	            return true;
	        }
	        else {
	            return false;
	        }
	    };
	    ResultLink.prototype.getResultUri = function () {
	        if (this.options.hrefTemplate) {
	            return this.parseHrefTemplate();
	        }
	        if (this.options.field == undefined && this.options.openInOutlook) {
	            this.setField();
	        }
	        if (this.options.field != undefined) {
	            return Utils_1.Utils.getFieldValue(this.result, this.options.field);
	        }
	        else {
	            return this.result.clickUri;
	        }
	    };
	    ResultLink.prototype.elementIsAnAnchor = function () {
	        return this.element.tagName == 'A';
	    };
	    ResultLink.prototype.setField = function () {
	        var os = Utils_1.Utils.exists(this.os) ? this.os : OSUtils_1.OSUtils.get();
	        if (os == OSUtils_1.OS_NAME.MACOSX && this.hasOutlookField()) {
	            this.options.field = '@outlookformacuri';
	        }
	        else if (os == OSUtils_1.OS_NAME.WINDOWS && this.hasOutlookField()) {
	            this.options.field = '@outlookuri';
	        }
	    };
	    ResultLink.prototype.hasOutlookField = function () {
	        var os = Utils_1.Utils.exists(this.os) ? this.os : OSUtils_1.OSUtils.get();
	        if (os == OSUtils_1.OS_NAME.MACOSX && this.result.raw['outlookformacuri'] != undefined) {
	            return true;
	        }
	        else if (os == OSUtils_1.OS_NAME.WINDOWS && this.result.raw['outlookuri'] != undefined) {
	            return true;
	        }
	        return false;
	    };
	    ResultLink.prototype.isUriThatMustBeOpenedInQuickview = function () {
	        return this.result.clickUri.toLowerCase().indexOf('ldap://') == 0;
	    };
	    ResultLink.prototype.quickviewShouldBeOpened = function () {
	        return (this.options.openQuickview || this.isUriThatMustBeOpenedInQuickview()) && QueryUtils_1.QueryUtils.hasHTMLVersion(this.result);
	    };
	    ResultLink.prototype.parseHrefTemplate = function () {
	        var _this = this;
	        return this.options.hrefTemplate.replace(/\$\{(.*?)\}/g, function (value) {
	            var key = value.substring(2, value.length - 1);
	            var newValue = _this.readFromObject(_this.result, key);
	            if (!newValue) {
	                newValue = _this.readFromObject(window, key);
	            }
	            return newValue || value;
	        });
	    };
	    ResultLink.prototype.readFromObject = function (object, key) {
	        if (object && key.indexOf('.') !== -1) {
	            var newKey = key.substring(key.indexOf('.') + 1);
	            key = key.substring(0, key.indexOf('.'));
	            return this.readFromObject(object[key], newKey);
	        }
	        return object ? object[key] : undefined;
	    };
	    ResultLink.ID = 'ResultLink';
	    /**
	     * The options for the ResultLink
	     * @componentOptions
	     */
	    ResultLink.options = {
	        /**
	         * Specifies the field that the result link uses to output its href.
	         * By default, the clickUri available on the document is used, but you can override this with this option.
	         * Tip:
	         * When you do not include a field option, in your result template, you can include an href attribute on the ResultLink element.
	         *
	         * When present, the href attribute value overrides the clickUri that is otherwise taken by default.
	         *
	         * Specifying an href attribute is useful when you want to build the result link using a custom script or by concatenating the content of two or more variables.
	         *
	         * ```html
	         * <!-- In the following result template the link is provided by the custom getMyKBUri() function. -->
	         * <script id="KnowledgeArticle" type="text/underscore">
	         *    <div class='CoveoIcon>'></div>
	         *    <a class="CoveoResultLink" href="<%=getMyKBUri(raw)%>"></a>
	         *    <div class="CoveoExcerpt"></div>
	         * </script>
	         * ```
	         */
	        field: ComponentOptions_1.ComponentOptions.buildFieldOption(),
	        /**
	         * Specifies whether the result link tries to open in Microsoft Outlook. This is normally intended for ResultLink related to Microsoft Exchange emails.
	         * Default value is false.
	         */
	        openInOutlook: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: false }),
	        /**
	         * Specifies whether the result link should open in the Quick View rather than loading through the original URL.
	         * Default value is false.
	         */
	        openQuickview: ComponentOptions_1.ComponentOptions.buildBooleanOption(),
	        /**
	         * Specifies whether the result link always opens in a new window ( <a target='_blank' /> ).
	         * Default is false
	         */
	        alwaysOpenInNewWindow: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: false }),
	        /**
	         * Specifies a template string to use to generate the href.
	         *
	         * It is possible to reference fields from the associated result:
	         *
	         * Ex: `${clickUri}?id=${title}` will generate something like `http://uri.com?id=documentTitle`
	         *
	         * Or from the global scope:
	         *
	         * Ex: `${window.location.hostname}/{Foo.Bar}` will generate something like `localhost/fooBar`
	         *
	         * This option will override the field option.
	         *
	         * Default is `undefined`
	         */
	        hrefTemplate: ComponentOptions_1.ComponentOptions.buildStringOption(),
	        /**
	         * Binds an event handler function that is executed when the component link is clicked. The handler function takes an EventObject and a {@link IQueryResult} as its parameters.
	         *
	         * Overriding the default behavior of the onClick event allows to execute specific code instead.
	         *
	         * ```javascript
	         * // Example: using a ResultLink to open the original document in a special way instead of the normal browser behavior
	         *
	         * Coveo.init(document.querySelector('#search'), {
	         *   ResultLink : {
	         *        onClick : function(e, result){
	         *          e.preventDefault();
	         *          // Custom code to execute with the URI and title of the document
	         *          openUriInASpecialTab(result.clickUri, result.title)
	         *        }
	         *    }
	         * })
	         *
	         * // OR using the jquery extension
	         *
	         * $("#search").coveo('init' , {
	         *    ResultLink : {
	         *        onClick : function(e, result){
	         *          e.preventDefault();
	         *          // Custom code to execute with the URI and title of the document
	         *          openUriInASpecialTab(result.clickUri, result.title)
	         *        }
	         *    }
	         * });
	         * ```
	         */
	        onClick: ComponentOptions_1.ComponentOptions.buildCustomOption(function () {
	            return null;
	        })
	    };
	    ResultLink.fields = [
	        'outlookformacuri',
	        'outlookuri',
	        'connectortype',
	        'urihash',
	        'collection',
	        'source',
	        'author' // analytics
	    ];
	    return ResultLink;
	}(Component_1.Component));
	exports.ResultLink = ResultLink;
	Initialization_1.Initialization.registerAutoCreateComponent(ResultLink);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var ResultLink_1 = __webpack_require__(178);
	var QueryUtils_1 = __webpack_require__(23);
	var DeviceUtils_1 = __webpack_require__(20);
	var Initialization_1 = __webpack_require__(95);
	var Dom_1 = __webpack_require__(57);
	var FieldTable_1 = __webpack_require__(180);
	var RegisteredNamedMethods_1 = __webpack_require__(94);
	/**
	 * This component automatically fetches the thumbnail of the result object
	 * and formats an HTML image tag (<code>img</code>) with it.
	 */
	var Thumbnail = (function (_super) {
	    __extends(Thumbnail, _super);
	    /**
	     * Create a new Thumbnail component
	     * @param element
	     * @param options
	     * @param bindings
	     * @param result
	     */
	    function Thumbnail(element, options, bindings, result) {
	        _super.call(this, element, Thumbnail.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.bindings = bindings;
	        this.result = result;
	        this.options = ComponentOptions_1.ComponentOptions.initOptions(element, Thumbnail.options, options);
	        if (this.options.clickable) {
	            new ResultLink_1.ResultLink(this.element, this.options, this.bindings, this.result);
	        }
	        if (this.element.tagName.toLowerCase() != 'img') {
	            this.img = Dom_1.$$('img').el;
	            this.element.appendChild(this.img);
	        }
	        else {
	            this.img = this.element;
	        }
	        // We need to set src to a blank image right away to avoid the image from
	        // changing size once it's loaded. Also, doing this prevents a border from
	        // appearing on some browsers when there is no thumbnail. I've found no other
	        // way to get rid of it...
	        this.img.setAttribute('src', 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==');
	        if (QueryUtils_1.QueryUtils.hasThumbnail(result)) {
	            this.buildThumbnailImage();
	        }
	        else {
	            this.setEmptyThumbnailClass();
	        }
	    }
	    Thumbnail.prototype.buildThumbnailImage = function () {
	        var endpoint = this.bindings.queryController.getEndpoint();
	        if (endpoint.isJsonp() || DeviceUtils_1.DeviceUtils.isIE8or9()) {
	            // For jsonp and IE8-9 (XDomain) we can't GET/POST for binary data. We are limited
	            // to only setting the src attribute directly on the img.
	            this.buildImageWithDirectSrcAttribute(endpoint);
	        }
	        else {
	            // Base 64 img allows us to GET/POST the image as raw binary, so that we can also
	            // pass the credential of the user. Useful for phonegap among others.
	            this.buildImageWithBase64SrcAttribute(endpoint);
	        }
	    };
	    Thumbnail.prototype.buildImageWithDirectSrcAttribute = function (endpoint) {
	        var dataStreamUri = endpoint.getViewAsDatastreamUri(this.result.uniqueId, '$Thumbnail$', { contentType: 'image/png' });
	        this.img.setAttribute('src', dataStreamUri);
	        this.resizeContainingFieldTable();
	    };
	    Thumbnail.prototype.buildImageWithBase64SrcAttribute = function (endpoint) {
	        var _this = this;
	        endpoint.getRawDataStream(this.result.uniqueId, '$Thumbnail$')
	            .then(function (response) {
	            var rawBinary = String.fromCharCode.apply(null, new Uint8Array(response));
	            _this.img.setAttribute('src', 'data:image/png;base64, ' + btoa(rawBinary));
	            _this.resizeContainingFieldTable();
	        })
	            .catch(function () {
	            _this.setEmptyThumbnailClass();
	        });
	    };
	    Thumbnail.prototype.resizeContainingFieldTable = function () {
	        var closestFieldTableElement = Dom_1.$$(this.element).closest(Component_1.Component.computeCssClassName(FieldTable_1.FieldTable));
	        if (closestFieldTableElement != null) {
	            var fieldTable = RegisteredNamedMethods_1.get(closestFieldTableElement);
	            fieldTable.updateToggleHeight();
	        }
	    };
	    Thumbnail.prototype.setEmptyThumbnailClass = function () {
	        Dom_1.$$(this.img).addClass(this.options.noThumbnailClass);
	    };
	    Thumbnail.ID = 'Thumbnail';
	    /**
	     * Options for the Thumbnail
	     * @componentOptions
	     */
	    Thumbnail.options = {
	        /**
	         * Specifies the CSS class to use on the thumbnail image tag when a result
	         * has no thumbnail in the index.<br/>
	         * Default value: <code>coveo-no-thumbnail</code>
	         */
	        noThumbnailClass: ComponentOptions_1.ComponentOptions.buildStringOption({ defaultValue: 'coveo-no-thumbnail' }),
	        /**
	         * Specifies if a clickable {@link ResultLink} is to be created around the Thumbnail.<br/>
	         * Uses all the same options as as {@link ResultLink} except <code>field</code><br/>
	         * Default value is <code>false</code>
	         */
	        clickable: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: false })
	    };
	    Thumbnail.parent = ResultLink_1.ResultLink;
	    Thumbnail.fields = [
	        'outlookformacuri',
	        'outlookuri',
	        'connectortype',
	        'urihash',
	        'collection',
	        'source' //        ⎭
	    ];
	    return Thumbnail;
	}(Component_1.Component));
	exports.Thumbnail = Thumbnail;
	Initialization_1.Initialization.registerAutoCreateComponent(Thumbnail);


/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var QueryUtils_1 = __webpack_require__(23);
	var Initialization_1 = __webpack_require__(95);
	var FieldValue_1 = __webpack_require__(181);
	var Dom_1 = __webpack_require__(57);
	var KeyboardUtils_1 = __webpack_require__(68);
	/**
	 * This component is used to display a set of {@link FieldValue} components in a table which
	 * can be optionally expanded and minimized.<br/>
	 * Automatically, it will take care of not displaying empty field values.
	 *
	 * # Examples
	 *
	 * ```
	 * // This is the FieldTable component itself, which holds a list of table rows.
	 * // Each row is a `FieldValue` component
	 * <table class='CoveoFieldTable'>
	 *    // Items
	 *    <tr data-field='@sysdate' data-caption='Date' data-helper='dateTime' />
	 *    <tr data-field='@sysauthor' data-caption='Author' />
	 *    <tr data-field='@clickuri' data-html-value='true' data-caption='URL' data-helper='anchor' data-helper-options='{text: \"<%= raw.syssource %>\" , target:\"_blank\"}'>
	 * </table>
	 * ```
	 */
	var FieldTable = (function (_super) {
	    __extends(FieldTable, _super);
	    /**
	     * Create a new FieldTable
	     * @param element
	     * @param options
	     * @param bindings
	     * @param result
	     */
	    function FieldTable(element, options, bindings, result) {
	        _super.call(this, element, ValueRow.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.result = result;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, FieldTable, options);
	        var rows = Dom_1.$$(this.element).findAll('tr[data-field]');
	        _.each(rows, function (e) {
	            new ValueRow(e, {}, bindings, result);
	        });
	        if (Dom_1.$$(this.element).find('tr') == null) {
	            Dom_1.$$(element).detach();
	        }
	        if (this.isTogglable()) {
	            this.toggleContainer = Dom_1.$$('div', { className: 'coveo-field-table-toggle-container' }).el;
	            this.buildToggle();
	            Dom_1.$$(this.toggleContainer).insertBefore(this.element);
	            this.toggleContainer.appendChild(this.element);
	        }
	        else {
	            this.isExpanded = true;
	        }
	    }
	    /**
	     * Toggle between expanding and minimizing the `FieldTable`.
	     * @param anim Specifies whether to show a sliding animation when toggling.
	     */
	    FieldTable.prototype.toggle = function (anim) {
	        if (anim === void 0) { anim = false; }
	        if (this.isTogglable()) {
	            this.isExpanded = !this.isExpanded;
	            this.isExpanded ? this.expand(anim) : this.minimize(anim);
	        }
	    };
	    /**
	     * Expand (show) the FieldTable
	     * @param anim Specifies whether to show a sliding animation when opening
	     */
	    FieldTable.prototype.expand = function (anim) {
	        if (anim === void 0) { anim = false; }
	        if (this.isTogglable()) {
	            this.isExpanded = true;
	            this.toggleCaption.textContent = this.options.expandedTitle;
	            Dom_1.$$(this.toggleIcon).addClass('coveo-opened');
	            Dom_1.$$(this.toggleButtonInsideTable).addClass('coveo-opened');
	            anim ? this.slideToggle(true) : this.slideToggle(true, false);
	        }
	    };
	    /**
	     * Minimize (collapse) the FieldTable
	     * @param anim Specifies whether to show a sliding animation when collapsing
	     */
	    FieldTable.prototype.minimize = function (anim) {
	        if (anim === void 0) { anim = false; }
	        if (this.isTogglable()) {
	            this.isExpanded = false;
	            this.toggleCaption.textContent = this.options.minimizedTitle;
	            Dom_1.$$(this.toggleIcon).removeClass('coveo-opened');
	            Dom_1.$$(this.toggleButtonInsideTable).removeClass('coveo-opened');
	            anim ? this.slideToggle(false) : this.slideToggle(false, false);
	        }
	    };
	    /**
	     * Update the toggle height if the content was dynamically resized so that the open and close animation can
	     * match the new content size.
	     */
	    FieldTable.prototype.updateToggleHeight = function () {
	        this.updateToggleContainerHeight();
	        this.isExpanded ? this.expand() : this.minimize();
	    };
	    FieldTable.prototype.isTogglable = function () {
	        if (this.searchInterface.isNewDesign() && this.options.allowMinimization) {
	            return true;
	        }
	        this.logger.info('Cannot open or close the field table with older design', this);
	        return false;
	    };
	    FieldTable.prototype.buildToggle = function () {
	        var _this = this;
	        this.toggleIcon = Dom_1.$$('span', { className: 'coveo-field-table-toggle-icon' }).el;
	        this.toggleCaption = Dom_1.$$('span', { className: 'coveo-field-table-toggle-caption', tabindex: 0 }).el;
	        this.toggleButton = Dom_1.$$('div', { className: 'coveo-field-table-toggle' }).el;
	        this.toggleButton.appendChild(this.toggleCaption);
	        this.toggleButton.appendChild(this.toggleIcon);
	        Dom_1.$$(this.toggleButton).insertBefore(this.element);
	        this.toggleButtonInsideTable = Dom_1.$$('span', { className: 'coveo-field-table-toggle-icon-up coveo-field-table-toggle' }).el;
	        this.element.appendChild(this.toggleButtonInsideTable);
	        if (this.options.minimizedByDefault === true) {
	            this.isExpanded = false;
	        }
	        else if (this.options.minimizedByDefault === false) {
	            this.isExpanded = true;
	        }
	        else {
	            this.isExpanded = !QueryUtils_1.QueryUtils.hasExcerpt(this.result);
	        }
	        setTimeout(function () {
	            _this.updateToggleHeight();
	        }); // Wait until toggleContainer.scrollHeight is computed.
	        var toggleAction = function () { return _this.toggle(true); };
	        Dom_1.$$(this.toggleButton).on('click', toggleAction);
	        Dom_1.$$(this.toggleButtonInsideTable).on('click', toggleAction);
	        Dom_1.$$(this.toggleButton).on('keyup', KeyboardUtils_1.KeyboardUtils.keypressAction(KeyboardUtils_1.KEYBOARD.ENTER, toggleAction));
	    };
	    FieldTable.prototype.slideToggle = function (visible, anim) {
	        if (visible === void 0) { visible = true; }
	        if (anim === void 0) { anim = true; }
	        if (!anim) {
	            Dom_1.$$(this.toggleContainer).addClass('coveo-no-transition');
	        }
	        if (visible) {
	            this.toggleContainer.style.display = 'block';
	            this.toggleContainer.style.height = this.toggleContainerHeight + 'px';
	        }
	        else {
	            this.toggleContainer.style.height = this.toggleContainerHeight + 'px';
	            this.toggleContainer.style.height = '0';
	        }
	        if (!anim) {
	            this.toggleContainer.offsetHeight; // Force reflow
	            Dom_1.$$(this.toggleContainer).removeClass('coveo-no-transition');
	        }
	    };
	    FieldTable.prototype.updateToggleContainerHeight = function () {
	        this.toggleContainerHeight = this.toggleContainer.scrollHeight;
	    };
	    FieldTable.ID = 'FieldTable';
	    /**
	     * The options for the component
	     * @componentOptions
	     */
	    FieldTable.options = {
	        /**
	         * Specifies whether to allow the minimization (collapsing) of the FieldTable or not.<br/>
	         * This creates a 'minimize' and 'expand' link above the table.
	         */
	        allowMinimization: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true }),
	        /**
	         * Specifies the caption to show on the minimize link (when the table is expanded).<br/>
	         * By default, it is set to the localized version of "Details".
	         */
	        expandedTitle: ComponentOptions_1.ComponentOptions.buildLocalizedStringOption({ defaultValue: 'Details', depend: 'allowMinimization' }),
	        /**
	         * Specifies the caption to show on the expand link (when the table is minimized).<br/>
	         * By default, it is set to the localized version of "Details".
	         */
	        minimizedTitle: ComponentOptions_1.ComponentOptions.buildLocalizedStringOption({ defaultValue: 'Details', depend: 'allowMinimization' }),
	        /**
	         * Specifies whether the table is minimized by default.
	         */
	        minimizedByDefault: ComponentOptions_1.ComponentOptions.buildBooleanOption({ depend: 'allowMinimization' })
	    };
	    return FieldTable;
	}(Component_1.Component));
	exports.FieldTable = FieldTable;
	Initialization_1.Initialization.registerAutoCreateComponent(FieldTable);
	var ValueRow = (function (_super) {
	    __extends(ValueRow, _super);
	    function ValueRow(element, options, bindings, result) {
	        _super.call(this, element, options, bindings, result, ValueRow.ID);
	        this.element = element;
	        this.options = options;
	        this.result = result;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, ValueRow, options);
	        var caption = Dom_1.$$('th').el;
	        caption.appendChild(document.createTextNode(this.options.caption.toLocaleString()));
	        this.element.insertBefore(caption, this.getValueContainer());
	    }
	    ValueRow.prototype.getValueContainer = function () {
	        if (this.valueContainer == null) {
	            this.valueContainer = document.createElement('td');
	            this.element.appendChild(this.valueContainer);
	        }
	        return this.valueContainer;
	    };
	    ValueRow.ID = 'ValueRow';
	    ValueRow.options = {
	        caption: ComponentOptions_1.ComponentOptions.buildStringOption({ postProcessing: function (value, options) { return value || options.field.substr(1); } })
	    };
	    ValueRow.parent = FieldValue_1.FieldValue;
	    return ValueRow;
	}(FieldValue_1.FieldValue));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var Initialization_1 = __webpack_require__(95);
	var TemplateHelpers_1 = __webpack_require__(122);
	var Assert_1 = __webpack_require__(17);
	var DateUtils_1 = __webpack_require__(56);
	var QueryStateModel_1 = __webpack_require__(90);
	var AnalyticsActionListMeta_1 = __webpack_require__(110);
	var Utils_1 = __webpack_require__(18);
	var Dom_1 = __webpack_require__(57);
	function showOnlyWithHelper(helpers, options) {
	    if (options == null) {
	        options = {};
	    }
	    options.helpers = helpers;
	    return options;
	}
	/**
	 * This component can be used as part of a result template to display the value of a field
	 * associated with the current search result.<br/>
	 * This component is usually located inside a {@link FieldTable}.<br/>
	 * A common use of this component is to display a specific field value, when that field also
	 * happens to be a facet. When the field value is clicked on, the corresponding facet is activated.
	 */
	var FieldValue = (function (_super) {
	    __extends(FieldValue, _super);
	    /**
	     * Build a new FieldValue
	     * @param element
	     * @param options
	     * @param bindings
	     * @param result
	     */
	    function FieldValue(element, options, bindings, result, fieldValueClassId) {
	        if (fieldValueClassId === void 0) { fieldValueClassId = FieldValue.ID; }
	        _super.call(this, element, fieldValueClassId, bindings);
	        this.element = element;
	        this.options = options;
	        this.result = result;
	        this.options = ComponentOptions_1.ComponentOptions.initOptions(element, FieldValue.simpleOptions, options);
	        if (this.options.helper != null) {
	            this.options = ComponentOptions_1.ComponentOptions.initOptions(element, FieldValue.helperOptions, this.options);
	        }
	        this.result = this.result || this.resolveResult();
	        Assert_1.Assert.exists(this.result);
	        var loadedValueFromComponent = this.getValue();
	        if (loadedValueFromComponent == null) {
	            // Completely remove the element to ease stuff such as adding separators in CSS
	            if (this.element.parentElement != null) {
	                this.element.parentElement.removeChild(this.element);
	            }
	        }
	        else {
	            var values = void 0;
	            if (_.isArray(loadedValueFromComponent)) {
	                values = loadedValueFromComponent;
	            }
	            else if (this.options.splitValues) {
	                if (_.isString(loadedValueFromComponent)) {
	                    values = _.map(loadedValueFromComponent.split(this.options.separator), function (v) {
	                        return v.trim();
	                    });
	                }
	            }
	            else {
	                loadedValueFromComponent = loadedValueFromComponent.toString();
	                values = [loadedValueFromComponent];
	            }
	            this.appendValuesToDom(values);
	        }
	    }
	    /**
	     * Get the current field value from the current result.<br/>
	     * Returns <code>null</code> if value is an <code>Object</code>.
	     */
	    FieldValue.prototype.getValue = function () {
	        var value = Utils_1.Utils.getFieldValue(this.result, this.options.field);
	        if (!_.isArray(value) && _.isObject(value)) {
	            value = null;
	        }
	        return value;
	    };
	    /**
	     * Render the passed value string with all of the component options.<br/>
	     * Returns a <code>HTMLElement</code> containing the rendered value.
	     */
	    FieldValue.prototype.renderOneValue = function (value) {
	        var element = Dom_1.$$('span').el;
	        var toRender = value;
	        if (this.options.helper) {
	            toRender = TemplateHelpers_1.TemplateHelpers.getHelper(this.options.helper).call(this, value, this.getHelperOptions());
	            var fullDateStr = this.getFullDate(value, this.options.helper);
	            if (fullDateStr) {
	                element.setAttribute('title', fullDateStr);
	            }
	        }
	        if (this.options.htmlValue) {
	            element.innerHTML = toRender;
	        }
	        else {
	            element.appendChild(document.createTextNode(toRender));
	        }
	        this.bindEventOnValue(element, value);
	        return element;
	    };
	    FieldValue.prototype.getValueContainer = function () {
	        return this.element;
	    };
	    FieldValue.prototype.getHelperOptions = function () {
	        var inlineOptions = ComponentOptions_1.ComponentOptions.loadStringOption(this.element, 'helperOptions', {});
	        if (Utils_1.Utils.isNonEmptyString(inlineOptions)) {
	            return _.extend({}, this.options.helperOptions, eval('(' + inlineOptions + ')'));
	        }
	        return this.options.helperOptions;
	    };
	    FieldValue.prototype.getFullDate = function (date, helper) {
	        var fullDateOptions = {
	            useLongDateFormat: true,
	            useTodayYesterdayAndTomorrow: false,
	            useWeekdayIfThisWeek: false,
	            omitYearIfCurrentOne: false
	        };
	        if (helper == 'date') {
	            return DateUtils_1.DateUtils.dateToString(new Date(parseInt(date)), fullDateOptions);
	        }
	        else if (helper == 'dateTime' || helper == 'emailDateTime') {
	            return DateUtils_1.DateUtils.dateTimeToString(new Date(parseInt(date)), fullDateOptions);
	        }
	        return '';
	    };
	    FieldValue.prototype.appendValuesToDom = function (values) {
	        var _this = this;
	        _.each(values, function (value, index) {
	            if (value != undefined) {
	                _this.getValueContainer().appendChild(_this.renderOneValue(value));
	                if (index !== values.length - 1) {
	                    _this.getValueContainer().appendChild(document.createTextNode(_this.options.displaySeparator));
	                }
	            }
	        });
	    };
	    FieldValue.prototype.bindEventOnValue = function (element, value) {
	        var _this = this;
	        var facetAttributeName = QueryStateModel_1.QueryStateModel.getFacetId(this.options.facet);
	        var facets = _.filter(this.componentStateModel.get(facetAttributeName), function (facet) { return !facet.disabled; });
	        var atLeastOneFacetIsEnabled = facets.length > 0;
	        if (atLeastOneFacetIsEnabled) {
	            var selected_1 = _.find(facets, function (facet) {
	                var facetValue = facet.values.get(value);
	                return facetValue && facetValue.selected;
	            });
	            Dom_1.$$(element).on('click', function () {
	                if (selected_1 != null) {
	                    _.each(facets, function (facet) { return facet.deselectValue(value); });
	                }
	                else {
	                    _.each(facets, function (facet) { return facet.selectValue(value); });
	                }
	                _this.queryController.deferExecuteQuery({
	                    beforeExecuteQuery: function () { return _this.usageAnalytics.logSearchEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.documentField, {
	                        facetId: _this.options.facet,
	                        facetValue: value.toLowerCase()
	                    }); }
	                });
	            });
	            if (selected_1) {
	                Dom_1.$$(element).addClass('coveo-selected');
	            }
	            Dom_1.$$(element).addClass('coveo-clickable');
	        }
	    };
	    FieldValue.ID = 'FieldValue';
	    /**
	     * The options for the component
	     * @componentOptions
	     */
	    FieldValue.options = {
	        /**
	         * Specifies the field to be displayed by the FieldValue.<br/>
	         * This field is required.
	         */
	        field: ComponentOptions_1.ComponentOptions.buildFieldOption({ defaultValue: '@field', required: true }),
	        /**
	         * Specifies the facet to be toggled when the component is clicked On.<br/>
	         * When no value is specified, the value of the <code>field</code> option is used.<br/>
	         * If the facet ID is custom (e.g. not the same name as its field), you must specify
	         * manually this option in order to link the correct facet.
	         */
	        facet: ComponentOptions_1.ComponentOptions.buildStringOption({ postProcessing: function (value, options) { return value || options.field; } }),
	        /**
	         * Specifies if the content to display is an HTML element.<br/>
	         * The default value is <code>false</code>.
	         */
	        htmlValue: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: false }),
	        /**
	         * Specifies if the field value is to be split at each {@link FieldValue.options.separator}.
	         * This is useful for splitting groups by a facet field.<br/>
	         * The values displayed are split by the {@link FieldValue.options.displaySeparator}.<br/>
	         * The default value is <code>false</code>.
	         */
	        splitValues: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: false }),
	        /**
	         * Specifies the string used to split multi-value fields from the index.
	         * The default value is <code>;</code>.
	         */
	        separator: ComponentOptions_1.ComponentOptions.buildStringOption({ defaultValue: ';' }),
	        /**
	         * Specifies the string used to display multi-value fields in the UI.
	         * It is inserted between the displayed values.
	         * The default value is <code>, </code>.
	         */
	        displaySeparator: ComponentOptions_1.ComponentOptions.buildStringOption({ defaultValue: ', ' }),
	        /**
	         * Specifies the helper to be used by the `FieldValue` to display its content.<br/>
	         * A few helpers exist by default (see {@link ICoreHelpers}), and new ones can be
	         * custom-created (see {@link TemplateHelpers}).
	         */
	        helper: ComponentOptions_1.ComponentOptions.buildHelperOption(),
	        /**
	         * Specifies the options to call on the specified helper.<br/>
	         */
	        helperOptions: ComponentOptions_1.ComponentOptions.buildObjectOption({
	            subOptions: {
	                text: ComponentOptions_1.ComponentOptions.buildStringOption(showOnlyWithHelper(['anchor'])),
	                target: ComponentOptions_1.ComponentOptions.buildStringOption(showOnlyWithHelper(['anchor'])),
	                'class': ComponentOptions_1.ComponentOptions.buildStringOption(showOnlyWithHelper(['anchor'])),
	                decimals: ComponentOptions_1.ComponentOptions.buildNumberOption(showOnlyWithHelper(['currency'], { min: 0 })),
	                symbol: ComponentOptions_1.ComponentOptions.buildStringOption(showOnlyWithHelper(['currency'])),
	                useTodayYesterdayAndTomorrow: ComponentOptions_1.ComponentOptions.buildBooleanOption(showOnlyWithHelper(['date', 'dateTime', 'emailDateTime', 'time'], { defaultValue: true })),
	                useWeekdayIfThisWeek: ComponentOptions_1.ComponentOptions.buildBooleanOption(showOnlyWithHelper(['date', 'dateTime', 'emailDateTime', 'time'], { defaultValue: true })),
	                omitYearIfCurrentOne: ComponentOptions_1.ComponentOptions.buildBooleanOption(showOnlyWithHelper(['date', 'dateTime', 'emailDateTime', 'time'], { defaultValue: true })),
	                useLongDateFormat: ComponentOptions_1.ComponentOptions.buildBooleanOption(showOnlyWithHelper(['date', 'dateTime', 'emailDateTime', 'time'], { defaultValue: false })),
	                includeTimeIfToday: ComponentOptions_1.ComponentOptions.buildBooleanOption(showOnlyWithHelper(['date', 'dateTime', 'emailDateTime', 'time'], { defaultValue: true })),
	                includeTimeIfThisWeek: ComponentOptions_1.ComponentOptions.buildBooleanOption(showOnlyWithHelper(['date', 'dateTime', 'emailDateTime', 'time'], { defaultValue: true })),
	                alwaysIncludeTime: ComponentOptions_1.ComponentOptions.buildBooleanOption(showOnlyWithHelper(['date', 'dateTime', 'emailDateTime', 'time'], { defaultValue: false })),
	                predefinedFormat: ComponentOptions_1.ComponentOptions.buildStringOption(showOnlyWithHelper(['date', 'dateTime', 'emailDateTime', 'time'])),
	                companyDomain: ComponentOptions_1.ComponentOptions.buildStringOption(showOnlyWithHelper(['email'])),
	                lengthLimit: ComponentOptions_1.ComponentOptions.buildNumberOption(showOnlyWithHelper(['email'], { min: 1 })),
	                truncateName: ComponentOptions_1.ComponentOptions.buildBooleanOption(showOnlyWithHelper(['email'])),
	                alt: ComponentOptions_1.ComponentOptions.buildStringOption(showOnlyWithHelper(['image'])),
	                height: ComponentOptions_1.ComponentOptions.buildStringOption(showOnlyWithHelper(['image'])),
	                width: ComponentOptions_1.ComponentOptions.buildStringOption(showOnlyWithHelper(['image'])),
	                presision: ComponentOptions_1.ComponentOptions.buildNumberOption(showOnlyWithHelper(['size'], { min: 0, defaultValue: 2 })),
	                base: ComponentOptions_1.ComponentOptions.buildNumberOption(showOnlyWithHelper(['size'], { min: 0, defaultValue: 0 })),
	                isMilliseconds: ComponentOptions_1.ComponentOptions.buildBooleanOption(showOnlyWithHelper(['timeSpan'])),
	            }
	        })
	    };
	    FieldValue.simpleOptions = _.omit(FieldValue.options, 'helperOptions');
	    FieldValue.helperOptions = {
	        helperOptions: FieldValue.options.helperOptions
	    };
	    return FieldValue;
	}(Component_1.Component));
	exports.FieldValue = FieldValue;
	Initialization_1.Initialization.registerAutoCreateComponent(FieldValue);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var HighlightUtils_1 = __webpack_require__(66);
	var Initialization_1 = __webpack_require__(95);
	var AnalyticsActionListMeta_1 = __webpack_require__(110);
	var Utils_1 = __webpack_require__(18);
	var Dom_1 = __webpack_require__(57);
	/**
	 * This component is meant to be used inside a result template to display the URI or path to access a result.
	 */
	var PrintableUri = (function (_super) {
	    __extends(PrintableUri, _super);
	    /**
	     * Create a new PrintableUri
	     * @param element
	     * @param options
	     * @param bindings
	     * @param result
	     */
	    function PrintableUri(element, options, bindings, result) {
	        _super.call(this, element, PrintableUri.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.result = result;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, PrintableUri, options);
	        var parentsXml = result.raw.parents;
	        if (parentsXml) {
	            this.renderParentsXml(element, parentsXml);
	        }
	        else {
	            this.renderUri(element, result);
	        }
	    }
	    PrintableUri.prototype.renderParentsXml = function (element, parentsXml) {
	        var xmlDoc = Utils_1.Utils.parseXml(parentsXml);
	        var parents = xmlDoc.getElementsByTagName('parent');
	        var tokens = [];
	        var seperators = [];
	        for (var i = 0; i < parents.length; i++) {
	            if (i > 0) {
	                var seperator = this.buildSeperator();
	                seperators.push(seperator);
	                element.appendChild(seperator);
	            }
	            var parent_1 = parents.item(i);
	            var token = this.buildHtmlToken(parent_1.getAttribute('name'), parent_1.getAttribute('uri'));
	            tokens.push(token);
	            element.appendChild(token);
	        }
	        if (tokens.length > 1) {
	            var ellipsis_1 = this.buildEllipsis();
	            element.insertBefore(ellipsis_1, seperators[0]);
	            var ellipsisSeperator = this.buildSeperator();
	            element.insertBefore(ellipsisSeperator, ellipsis_1);
	            var contentWidth = 0;
	            var tokensWidth = [];
	            for (var i = 0; i < tokens.length; i++) {
	                tokensWidth[i] = tokens[i].offsetWidth;
	                contentWidth += tokensWidth[i];
	            }
	            var seperatorWidth = seperators[0].offsetWidth;
	            var ellipsisWidth = ellipsis_1.offsetWidth;
	            var availableWidth = element.offsetWidth;
	            if (availableWidth <= contentWidth) {
	                contentWidth += ellipsisWidth + seperatorWidth;
	                var hidden_1 = [];
	                var i = 1;
	                while (i < tokens.length && availableWidth <= contentWidth) {
	                    element.removeChild(tokens[i]);
	                    element.removeChild(seperators[i - 1]);
	                    if (i > 1) {
	                        hidden_1.push(seperators[i - 1]);
	                    }
	                    hidden_1.push(tokens[i]);
	                    contentWidth -= tokensWidth[i] + seperatorWidth;
	                    i++;
	                }
	                ellipsis_1.onclick = function () {
	                    for (var i_1 = 0; i_1 < hidden_1.length; i_1++) {
	                        element.insertBefore(hidden_1[i_1], ellipsis_1);
	                    }
	                    element.removeChild(ellipsis_1);
	                };
	            }
	            else {
	                element.removeChild(ellipsis_1);
	                element.removeChild(ellipsisSeperator);
	            }
	        }
	    };
	    PrintableUri.prototype.renderUri = function (element, result) {
	        this.uri = result.clickUri;
	        var stringAndHoles;
	        if (result.printableUri.indexOf('\\') == -1) {
	            stringAndHoles = HighlightUtils_1.StringAndHoles.shortenUri(result.printableUri, Dom_1.$$(element).width() / 7);
	        }
	        else {
	            stringAndHoles = HighlightUtils_1.StringAndHoles.shortenPath(result.printableUri, Dom_1.$$(element).width() / 7);
	        }
	        var uri = HighlightUtils_1.HighlightUtils.highlightString(stringAndHoles.value, result.printableUriHighlights, stringAndHoles.holes, 'coveo-highlight');
	        var link = Dom_1.$$('a');
	        link.setAttribute('title', result.printableUri);
	        link.addClass('coveo-printable-uri');
	        link.setHtml(uri);
	        link.setAttribute('href', result.clickUri);
	        this.bindLogOpenDocument(link.el);
	        element.appendChild(link.el);
	    };
	    PrintableUri.prototype.buildSeperator = function () {
	        var seperator = document.createElement('span');
	        seperator.innerText = '>';
	        seperator.className = 'coveo-printable-uri-separator';
	        return seperator;
	    };
	    PrintableUri.prototype.buildEllipsis = function () {
	        var ellipsis = document.createElement('span');
	        ellipsis.innerText = '...';
	        ellipsis.className = 'coveo-printable-uri';
	        return ellipsis;
	    };
	    PrintableUri.prototype.buildHtmlToken = function (name, uri) {
	        var modifiedName = name.charAt(0).toUpperCase() + name.slice(1);
	        var link = document.createElement('a');
	        this.bindLogOpenDocument(link);
	        link.href = uri;
	        this.uri = uri;
	        link.className = 'coveo-printable-uri';
	        link.appendChild(document.createTextNode(modifiedName));
	        return link;
	    };
	    PrintableUri.prototype.bindLogOpenDocument = function (link) {
	        var _this = this;
	        Dom_1.$$(link).on(['mousedown', 'touchend'], function (e) {
	            var url = Dom_1.$$(e.srcElement).getAttribute('href');
	            var title = Dom_1.$$(e.srcElement).text();
	            _this.usageAnalytics.logClickEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.documentOpen, {
	                documentURL: url,
	                documentTitle: title,
	                author: _this.result.raw.author
	            }, _this.result, _this.root);
	        });
	    };
	    PrintableUri.ID = 'PrintableUri';
	    PrintableUri.options = {};
	    PrintableUri.fields = [
	        'parents'
	    ];
	    return PrintableUri;
	}(Component_1.Component));
	exports.PrintableUri = PrintableUri;
	Initialization_1.Initialization.registerAutoCreateComponent(PrintableUri);


/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var Assert_1 = __webpack_require__(17);
	var QueryEvents_1 = __webpack_require__(47);
	var Dom_1 = __webpack_require__(57);
	var QueryStateModel_1 = __webpack_require__(90);
	var Initialization_1 = __webpack_require__(95);
	var StringUtils_1 = __webpack_require__(61);
	var Utils_1 = __webpack_require__(18);
	var AnalyticsActionListMeta_1 = __webpack_require__(110);
	var Strings_1 = __webpack_require__(34);
	/**
	 * This component is responsible for displaying query corrections. If this component is in the page
	 * and the query returns no results, but finds a possible query correction, the component either
	 * suggests the correction or automatically triggers a new query with the suggested term.
	 */
	var DidYouMean = (function (_super) {
	    __extends(DidYouMean, _super);
	    /**
	     * Create a new DidYouMean component
	     * @param element
	     * @param options
	     * @param bindings
	     */
	    function DidYouMean(element, options, bindings) {
	        _super.call(this, element, DidYouMean.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.bindings = bindings;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, DidYouMean, options);
	        Assert_1.Assert.exists(element);
	        Assert_1.Assert.exists(this.options);
	        this.hideNext = true;
	        this.correctedTerm = null;
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.buildingQuery, this.handlePrepareQueryBuilder);
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.querySuccess, this.handleProcessNewQueryResults);
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.noResults, this.handleNoResults);
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.newQuery, this.handleNewQuery);
	        Dom_1.$$(this.element).hide();
	    }
	    /**
	     * Execute a query with the corrected term. <br/>
	     * Will throw an exception if the corrected term has not been initialized.
	     */
	    DidYouMean.prototype.doQueryWithCorrectedTerm = function () {
	        var _this = this;
	        Assert_1.Assert.exists(this.correctedTerm);
	        this.queryStateModel.set(QueryStateModel_1.QueryStateModel.attributesEnum.q, this.correctedTerm);
	        this.queryController.deferExecuteQuery({
	            beforeExecuteQuery: function () { return _this.usageAnalytics.logSearchEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.didyoumeanClick, {}); }
	        });
	    };
	    DidYouMean.prototype.handleNewQuery = function () {
	        if (this.hideNext) {
	            Dom_1.$$(this.element).empty();
	            Dom_1.$$(this.element).hide();
	            this.correctedTerm = null;
	        }
	        else {
	            this.hideNext = true;
	        }
	    };
	    DidYouMean.prototype.handlePrepareQueryBuilder = function (data) {
	        Assert_1.Assert.exists(data);
	        data.queryBuilder.enableDidYouMean = true;
	    };
	    DidYouMean.prototype.handleNoResults = function (data) {
	        // We do not auto-correct on search-as-you-type queries
	        if (Utils_1.Utils.isNonEmptyArray(data.results.queryCorrections) && !data.searchAsYouType && this.options.enableAutoCorrection) {
	            var originalQuery = this.queryStateModel.get(QueryStateModel_1.QueryStateModel.attributesEnum.q);
	            this.correctedTerm = data.results.queryCorrections[0].correctedQuery;
	            var correctedSentence = this.buildCorrectedSentence(data.results.queryCorrections[0]);
	            this.queryStateModel.set(QueryStateModel_1.QueryStateModel.attributesEnum.q, data.results.queryCorrections[0].correctedQuery);
	            data.retryTheQuery = true;
	            this.hideNext = false;
	            var noResultsFor = Dom_1.$$('div', { className: 'coveo-did-you-mean-no-results-for' }).el;
	            noResultsFor.innerHTML = Strings_1.l('noResultFor', '<span class="coveo-highlight coveo-did-you-mean-highlight">' + StringUtils_1.StringUtils.htmlEncode(originalQuery) + '</span>');
	            this.element.appendChild(noResultsFor);
	            var automaticCorrect = Dom_1.$$('div', { className: 'coveo-did-you-mean-automatic-correct' }).el;
	            automaticCorrect.innerHTML = Strings_1.l('autoCorrectedQueryTo', '<span class="coveo-highlight">' + correctedSentence + '</span>');
	            this.element.appendChild(automaticCorrect);
	            Dom_1.$$(this.element).show();
	            this.usageAnalytics.logSearchEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.didyoumeanAutomatic, {});
	        }
	    };
	    DidYouMean.prototype.handleProcessNewQueryResults = function (data) {
	        var _this = this;
	        Assert_1.Assert.exists(data);
	        Assert_1.Assert.exists(data.results);
	        var results = data.results;
	        this.logger.trace('Received query results from new query', results);
	        if (Utils_1.Utils.isNonEmptyArray(results.queryCorrections)) {
	            var correctedSentence = this.buildCorrectedSentence(results.queryCorrections[0]);
	            this.correctedTerm = results.queryCorrections[0].correctedQuery;
	            var didYouMean = Dom_1.$$('div', { className: 'coveo-did-you-mean-suggestion' }, Strings_1.l('didYouMean', '')).el;
	            this.element.appendChild(didYouMean);
	            var searchTerm = Dom_1.$$('a', {}, correctedSentence).el;
	            didYouMean.appendChild(searchTerm);
	            Dom_1.$$(searchTerm).on('click', function () {
	                _this.doQueryWithCorrectedTerm();
	            });
	            Dom_1.$$(this.element).show();
	        }
	    };
	    DidYouMean.prototype.buildCorrectedSentence = function (correction) {
	        var toReturn = [];
	        var tagStart = '<span class=\'coveo-did-you-mean-word-correction\'>';
	        var tagEnd = '</span>';
	        var currentOffset = 0;
	        _.each(correction.wordCorrections, function (wordCorrection) {
	            toReturn.push(StringUtils_1.StringUtils.htmlEncode(correction.correctedQuery.slice(currentOffset, wordCorrection.offset)));
	            currentOffset = wordCorrection.offset;
	            toReturn.push(tagStart);
	            toReturn.push(StringUtils_1.StringUtils.htmlEncode(correction.correctedQuery.slice(currentOffset, wordCorrection.length + currentOffset)));
	            toReturn.push(tagEnd);
	            currentOffset = wordCorrection.offset + wordCorrection.length;
	        });
	        toReturn.push(StringUtils_1.StringUtils.htmlEncode(correction.correctedQuery.slice(currentOffset)));
	        return toReturn.join('');
	    };
	    DidYouMean.ID = 'DidYouMean';
	    /**
	     * The options for the component
	     * @componentOptions
	     */
	    DidYouMean.options = {
	        /**
	         * This option allows the `DidYouMean` component to automatically trigger a new query
	         * when there are no results and a correction is available.<br/>
	         * The default value is <code>true</code>.
	         */
	        enableAutoCorrection: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true }),
	    };
	    return DidYouMean;
	}(Component_1.Component));
	exports.DidYouMean = DidYouMean;
	Initialization_1.Initialization.registerAutoCreateComponent(DidYouMean);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var Dom_1 = __webpack_require__(57);
	var QueryEvents_1 = __webpack_require__(47);
	var AnalyticsActionListMeta_1 = __webpack_require__(110);
	var Strings_1 = __webpack_require__(34);
	var Assert_1 = __webpack_require__(17);
	var Initialization_1 = __webpack_require__(95);
	/**
	 * This component takes care of handling fatal error when doing a query on the index / Search API.<br/>
	 * For example, it will display a message when the service responds with something like a 401 or 503.<br/>
	 * It will also render a small text area with the JSON content of the error response, for debugging purpose.
	 */
	var ErrorReport = (function (_super) {
	    __extends(ErrorReport, _super);
	    /**
	     * Create a new ErrorReport component
	     * @param element
	     * @param options
	     * @param bindings
	     */
	    function ErrorReport(element, options, bindings) {
	        var _this = this;
	        _super.call(this, element, ErrorReport.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, ErrorReport, options);
	        var title = Dom_1.$$('div', { className: 'coveo-error-report-title' }, '<h3></h3><h4></h4>');
	        this.element.appendChild(title.el);
	        var optionsElement = Dom_1.$$('div', { className: 'coveo-error-report-options' });
	        optionsElement.el.appendChild(this.buildPrevious());
	        optionsElement.el.appendChild(this.buildReset());
	        optionsElement.el.appendChild(this.buildRetry());
	        this.message = Dom_1.$$('div', {
	            className: 'coveo-error-report-message'
	        });
	        this.element.appendChild(optionsElement.el);
	        this.element.appendChild(this.message.el);
	        Dom_1.$$(this.element).hide();
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.newQuery, function () { return _this.handleNewQuery(); });
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.queryError, function (data) { return _this.handleQueryError(data); });
	    }
	    /**
	     * Do the "back" action in the browser.
	     */
	    ErrorReport.prototype.back = function () {
	        this.usageAnalytics.logCustomEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.errorBack, {}, this.root);
	        this.usageAnalytics.logSearchEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.errorBack, {});
	        history.back();
	    };
	    /**
	     * Reset the current state of the query to 'empty', and trigger a new query.
	     */
	    ErrorReport.prototype.reset = function () {
	        this.queryStateModel.reset();
	        this.usageAnalytics.logSearchEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.errorClearQuery, {});
	        this.usageAnalytics.logCustomEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.errorClearQuery, {}, this.root);
	        this.queryController.executeQuery();
	    };
	    /**
	     * Retry the same query, in case of a temporary service error.
	     */
	    ErrorReport.prototype.retry = function () {
	        this.usageAnalytics.logSearchEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.errorRetry, {});
	        this.usageAnalytics.logCustomEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.errorRetry, {}, this.root);
	        this.queryController.executeQuery();
	    };
	    ErrorReport.prototype.setErrorTitle = function () {
	        var errorTitle = {
	            h3: Strings_1.l('OopsError'),
	            h4: Strings_1.l('ProblemPersists')
	        };
	        var h3 = Dom_1.$$(this.element).find('h3');
	        var h4 = Dom_1.$$(this.element).find('h4');
	        if (h3 && h4) {
	            Dom_1.$$(h3).text(errorTitle.h3);
	            Dom_1.$$(h4).text(errorTitle.h4);
	        }
	    };
	    ErrorReport.prototype.buildPrevious = function () {
	        var _this = this;
	        var previous = Dom_1.$$('span', { className: 'coveo-error-report-previous' }, Strings_1.l('GoBack'));
	        previous.on('click', function () { return _this.back(); });
	        return previous.el;
	    };
	    ErrorReport.prototype.buildReset = function () {
	        var _this = this;
	        var reset = Dom_1.$$('span', {
	            className: 'coveo-error-report-clear'
	        }, Strings_1.l('Reset'));
	        reset.on('click', function () { return _this.reset(); });
	        return reset.el;
	    };
	    ErrorReport.prototype.buildRetry = function () {
	        var _this = this;
	        var retry = Dom_1.$$('span', {
	            className: 'coveo-error-report-retry'
	        }, Strings_1.l('Retry'));
	        retry.on('click', function () { return _this.retry(); });
	        return retry.el;
	    };
	    ErrorReport.prototype.handleNewQuery = function () {
	        Dom_1.$$(this.element).hide();
	        if (this.closePopup != null) {
	            this.closePopup();
	        }
	    };
	    ErrorReport.prototype.handleQueryError = function (data) {
	        var _this = this;
	        Assert_1.Assert.exists(data);
	        Assert_1.Assert.exists(data.error);
	        // Do not display the panel if the error is for missing authentication. The
	        // appropriate authentication provider should take care of redirecting.
	        if (data.error.isMissingAuthentication) {
	            return;
	        }
	        this.message.empty();
	        this.setErrorTitle();
	        if (this.options.showDetailedError) {
	            var moreInfo_1 = Dom_1.$$('span', {
	                className: 'coveo-error-report-more-info'
	            }, Strings_1.l('MoreInfo'));
	            moreInfo_1.on('click', function () {
	                moreInfo_1.empty();
	                _this.message.el.appendChild(_this.buildErrorInfo(data.error));
	            });
	            this.message.el.appendChild(moreInfo_1.el);
	        }
	        Dom_1.$$(this.element).show();
	    };
	    ErrorReport.prototype.buildErrorInfo = function (data) {
	        var errorInfo = Dom_1.$$('div', {
	            className: 'coveo-error-info'
	        });
	        var textArea = Dom_1.$$('textarea', undefined, JSON.stringify(data, null, 2));
	        errorInfo.el.appendChild(textArea.el);
	        var infoLabel = Dom_1.$$('div', {
	            className: 'coveo-error-info-label'
	        }, Strings_1.l('CopyPasteToSupport'));
	        errorInfo.el.appendChild(infoLabel.el);
	        return errorInfo.el;
	    };
	    ErrorReport.ID = 'ErrorReport';
	    /**
	     * The options for the component
	     * @componentOptions
	     */
	    ErrorReport.options = {
	        /**
	         * Display the detailed error message as a JSON in a text content area.<br/>
	         * The default value is <code>true</code>.
	         */
	        showDetailedError: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true })
	    };
	    return ErrorReport;
	}(Component_1.Component));
	exports.ErrorReport = ErrorReport;
	Initialization_1.Initialization.registerAutoCreateComponent(ErrorReport);


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var SettingsEvents_1 = __webpack_require__(50);
	var AnalyticsActionListMeta_1 = __webpack_require__(110);
	var Initialization_1 = __webpack_require__(95);
	var Strings_1 = __webpack_require__(34);
	/**
	 * This component allows users to export the current search results in a Microsoft Excel (.xlsx) format.
	 * It populates the {@link Settings} component menu.
	 */
	var ExportToExcel = (function (_super) {
	    __extends(ExportToExcel, _super);
	    /**
	     * Create a new ExportToExcel component
	     * @param element
	     * @param options
	     * @param bindings
	     * @param _window The global Window object (used to download the Excel link).
	     */
	    function ExportToExcel(element, options, bindings, _window) {
	        var _this = this;
	        _super.call(this, element, ExportToExcel.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.bindings = bindings;
	        this._window = _window;
	        this._window = this._window || window;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, ExportToExcel, options);
	        this.bind.onRootElement(SettingsEvents_1.SettingsEvents.settingsPopulateMenu, function (args) {
	            args.menuData.push({
	                text: Strings_1.l('ExportToExcel'),
	                className: 'coveo-export-to-excel',
	                tooltip: Strings_1.l('ExportToExcelDescription'),
	                onOpen: function () { return _this.download(); }
	            });
	        });
	    }
	    /**
	     * Download the Excel representation of the current query.
	     */
	    ExportToExcel.prototype.download = function () {
	        var query = this.queryController.getLastQuery();
	        if (query) {
	            query = _.omit(query, 'numberOfResults');
	            this.logger.debug('Performing query following \'Export to Excel\' click');
	            var endpoint = this.queryController.getEndpoint();
	            this.usageAnalytics.logCustomEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.exportToExcel, {}, this.element);
	            this._window.location.replace(endpoint.getExportToExcelLink(query, this.options.numberOfResults));
	        }
	    };
	    ExportToExcel.create = function (element, options, root) {
	        return new ExportToExcel(element, options, root);
	    };
	    ExportToExcel.ID = 'ExportToExcel';
	    /**
	     * The options for the component
	     * @componentOptions
	     */
	    ExportToExcel.options = {
	        /**
	         * The number of results included in the exported Excel file.<br/>
	         * The default value of <code>100</code> makes the generation and the download of the resulting Excel file
	         * last about 1 second.<br/>
	         * Increasing this value will exponentially increase the time needed to create the Excel file.<br/>
	         * It is not recommended to go above the default index limit of 1000 search results.
	         */
	        numberOfResults: ComponentOptions_1.ComponentOptions.buildNumberOption({ defaultValue: 100, min: 1 })
	    };
	    return ExportToExcel;
	}(Component_1.Component));
	exports.ExportToExcel = ExportToExcel;
	Initialization_1.Initialization.registerAutoCreateComponent(ExportToExcel);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var SortCriteria_1 = __webpack_require__(187);
	var ComponentOptions_1 = __webpack_require__(98);
	var Utils_1 = __webpack_require__(18);
	var Assert_1 = __webpack_require__(17);
	var QueryEvents_1 = __webpack_require__(47);
	var Initialization_1 = __webpack_require__(95);
	var Dom_1 = __webpack_require__(57);
	var QueryBuilder_1 = __webpack_require__(77);
	/**
	 * This component is used to display search results that share a common field hierarchically.
	 * It is typically used to display email conversations and message board threads.
	 * The different messages in a given conversation typically have a unique conversation ID.
	 * Given that this ID is indexed in a field, you can use it to fold search results
	 */
	var Folding = (function (_super) {
	    __extends(Folding, _super);
	    /**
	     * Create a new Folding component
	     * @param element
	     * @param options
	     * @param bindings
	     */
	    function Folding(element, options, bindings) {
	        _super.call(this, element, Folding.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, Folding, options);
	        Assert_1.Assert.check(Utils_1.Utils.isCoveoField(this.options.field), this.options.field + ' is not a valid field');
	        Assert_1.Assert.exists(this.options.maximumExpandedResults);
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.buildingQuery, this.handleBuildingQuery);
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.preprocessResults, this.handlepreprocessResults);
	    }
	    // From a list of results, return a list of results and their attachments
	    // We use parentResult to build a tree of result
	    Folding.foldWithParent = function (queryResults) {
	        var rootNode = {
	            score: Number.NEGATIVE_INFINITY,
	            children: [],
	            result: {
	                raw: false
	            }
	        };
	        _.each(queryResults, function (queryResult, i) {
	            var resultNode = Folding.findUniqueId(rootNode.children, queryResult.uniqueId);
	            // If he have no parent or is parent is him self, add it to the root
	            if (queryResult.parentResult == null || queryResult.parentResult.uniqueId == queryResult.uniqueId) {
	                // Add it only if he do not exist
	                if (resultNode == null) {
	                    resultNode = {
	                        result: queryResult,
	                        score: i,
	                        children: []
	                    };
	                    rootNode.children.push(resultNode);
	                    resultNode.parent = rootNode;
	                }
	            }
	            else {
	                // If the resultNode already exist
	                if (resultNode != null) {
	                    resultNode.score = Math.min(i, resultNode.score);
	                    // Remove himself from his parent because it will be added in his parent. This allowed to remove duplicate.
	                    resultNode.parent.children = _.without(resultNode.parent.children, resultNode);
	                }
	                else {
	                    resultNode = {
	                        result: queryResult,
	                        score: i,
	                        children: []
	                    };
	                }
	                var parentResult = Folding.findUniqueId(rootNode.children, queryResult.parentResult.uniqueId);
	                // If the parent does not already exist, create it and add it the root
	                if (parentResult == null) {
	                    parentResult = {
	                        result: queryResult.parentResult,
	                        score: Number.POSITIVE_INFINITY,
	                        children: []
	                    };
	                    rootNode.children.push(parentResult);
	                    parentResult.parent = rootNode;
	                }
	                // Add the resultNode to parent
	                parentResult.children.push(resultNode);
	                resultNode.parent = parentResult;
	                var parent_1 = parentResult;
	                while (parent_1 != null && resultNode.score < parent_1.score) {
	                    parent_1.score = resultNode.score;
	                    parent_1 = parent_1.parent;
	                }
	            }
	        });
	        var rootResult = Folding.resultNodeToQueryResult(rootNode);
	        // Remove the root from all results
	        _.each(rootResult.attachments, function (attachment) { return attachment.parentResult = null; });
	        return rootResult.attachments;
	    };
	    // 99.9% of the folding case will be alright with those default functions.
	    // Otherwise use the options getResult and getMoreResults
	    Folding.defaultGetResult = function (result) {
	        var results = result.childResults || [];
	        // Add the top result at the top of the list
	        results.unshift(result);
	        // Empty childResults just to make it more clean
	        result.childResults = [];
	        // Fold those results
	        results = Folding.foldWithParent(results);
	        // The first result is the top one
	        var topResult = results.shift();
	        // All other the results are childResults
	        topResult.childResults = results;
	        return topResult;
	    };
	    Folding.defaultGetMoreResults = function (results) {
	        // The result are flat, just do the fold
	        return Folding.foldWithParent(results);
	    };
	    // Convert ResultNode to QueryResult
	    Folding.resultNodeToQueryResult = function (resultNode) {
	        var result = resultNode.result;
	        result.attachments = _.map(_.sortBy(resultNode.children, 'score'), Folding.resultNodeToQueryResult);
	        result.parentResult = resultNode.parent != null ? resultNode.parent.result : null;
	        return result;
	    };
	    Folding.findUniqueId = function (resultNodes, uniqueId) {
	        for (var i = 0; i < resultNodes.length; i++) {
	            if (resultNodes[i].result.uniqueId == uniqueId) {
	                return resultNodes[i];
	            }
	            var resultNode = Folding.findUniqueId(resultNodes[i].children, uniqueId);
	            if (resultNode != null) {
	                return resultNode;
	            }
	        }
	        return null;
	    };
	    Folding.prototype.handleBuildingQuery = function (data) {
	        Assert_1.Assert.exists(data);
	        if (!this.disabled) {
	            data.queryBuilder.childField = this.options.childField;
	            data.queryBuilder.parentField = this.options.parentField;
	            data.queryBuilder.filterField = this.options.field;
	            data.queryBuilder.filterFieldRange = this.options.range;
	            data.queryBuilder.requiredFields.push(this.options.field);
	            if (this.options.childField != null) {
	                data.queryBuilder.requiredFields.push(this.options.childField);
	            }
	            if (this.options.parentField != null) {
	                data.queryBuilder.requiredFields.push(this.options.parentField);
	            }
	        }
	    };
	    Folding.prototype.handlepreprocessResults = function (data) {
	        Assert_1.Assert.exists(data);
	        Assert_1.Assert.check(!data.results._folded, 'Two folding component are active at the same time for the same tab. Can\'t process result !');
	        data.results._folded = true;
	        var queryResults = data.results;
	        var getResult = this.options.getResult || Folding.defaultGetResult;
	        queryResults.results = _.map(queryResults.results, getResult);
	        this.addLoadMoreHandler(queryResults.results, data.query);
	    };
	    Folding.prototype.addLoadMoreHandler = function (results, originalQuery) {
	        var _this = this;
	        return _.map(results, function (result) {
	            if (_this.options.enableExpand && !Utils_1.Utils.isNullOrUndefined(Utils_1.Utils.getFieldValue(result, _this.options.field))) {
	                result.moreResults = function () {
	                    return _this.moreResults(result, originalQuery);
	                };
	            }
	            return result;
	        });
	    };
	    Folding.prototype.moreResults = function (result, originalQuery) {
	        var _this = this;
	        var query = new QueryBuilder_1.QueryBuilder();
	        query.numberOfResults = this.options.maximumExpandedResults;
	        var fieldValue = Utils_1.Utils.getFieldValue(result, this.options.field);
	        if (Utils_1.Utils.isNonEmptyString(fieldValue)) {
	            query.advancedExpression.addFieldExpression(this.options.field, '=', [fieldValue]);
	        }
	        if (Utils_1.Utils.isNonEmptyString(originalQuery.q)) {
	            // We add keywords to get the highlight and we add @uri to get all results
	            query.expression.add('(' + originalQuery.q + ') OR @uri');
	        }
	        if (Utils_1.Utils.isNonEmptyString(this.options.expandExpression)) {
	            query.constantExpression.add(this.options.expandExpression);
	        }
	        if (this.options.parentField != null) {
	            query.parentField = this.options.parentField;
	        }
	        if (this.options.childField != null) {
	            query.childField = this.options.childField;
	        }
	        if (this.options.rearrange) {
	            this.options.rearrange.putInQueryBuilder(query);
	        }
	        else {
	            query.sortCriteria = originalQuery.sortCriteria;
	            query.sortField = originalQuery.sortField;
	        }
	        var builtQuery = query.build();
	        return this.queryController.getEndpoint().search(builtQuery)
	            .then(function (results) {
	            _this.handlePreprocessMoreResults(results);
	            return results.results;
	        });
	    };
	    Folding.prototype.handlePreprocessMoreResults = function (queryResults) {
	        var getResults = this.options.getMoreResults || Folding.defaultGetMoreResults;
	        queryResults.results = getResults(queryResults.results);
	        Dom_1.$$(this.element).trigger(QueryEvents_1.QueryEvents.preprocessMoreResults, {
	            results: queryResults
	        });
	    };
	    Folding.ID = 'Folding';
	    /**
	     * The options for the component
	     * @componentOptions
	     */
	    Folding.options = {
	        /**
	         * The name of the field on which the folding is done.<br/>
	         * This option is required.
	         */
	        field: ComponentOptions_1.ComponentOptions.buildFieldOption({ required: true }),
	        /**
	         * Specifies the field that determines that a result is a child of another top result.<br/>
	         * The default value is `@topparentid`.
	         */
	        childField: ComponentOptions_1.ComponentOptions.buildFieldOption({ defaultValue: '@topparentid' }),
	        /**
	         * Specifies the field that determines if a result is a top result containing other child results.<br/>
	         * The default value is `@syscontainsattachment`.
	         */
	        parentField: ComponentOptions_1.ComponentOptions.buildFieldOption({ defaultValue: '@containsattachment' }),
	        /**
	         * The number of child results to fold.
	         *
	         * The default value is 2.
	         *
	         * The minimum value is 0.
	         *
	         * > Example:
	         * > For an email thread with 20 messages in total, using the default value means that a maximum of 2 child messages are loaded and displayed under the original message (unless the whole conversation is expanded via the use of a Show all conversation button).
	         */
	        range: ComponentOptions_1.ComponentOptions.buildNumberOption({ defaultValue: 2, min: 0 }),
	        /**
	         * Specifies the top result and its related child results, following the sort criteria format
	         * (`date ascending`, `@somefield ascending`, etc.)
	         *
	         * The default value is `none`, which means that results are displayed in the order that the index returned them.
	         *
	         * > Example:
	         * > If you specify date descending, the component re-arranges an email conversation so that the newest email is always the top result. Doing the opposite would allow the original email to always be the top result since it is also the oldest.
	         */
	        rearrange: ComponentOptions_1.ComponentOptions.buildCustomOption(function (value) { return Utils_1.Utils.isNonEmptyString(value) ? SortCriteria_1.SortCriteria.parse(value) : null; }),
	        /**
	         * Specifies whether to add a callback function on the top result, allowing to make an additional query.
	         * to load all the conversation of a given thread.
	         *
	         * Concretely, the {@link ResultFolding} component uses this for its <b>Load full conversation</b> option.
	         *
	         * The default value is `true`.
	         */
	        enableExpand: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true }),
	        /**
	         * Specifies a customized constant expression to send when querying the expanded results.
	         */
	        expandExpression: ComponentOptions_1.ComponentOptions.buildStringOption({ depend: 'enableExpand' }),
	        /**
	         * Specifies the maximum number of expanded results.
	         *
	         * The default value is 100.
	         *
	         * The minimum value is 1.
	         */
	        maximumExpandedResults: ComponentOptions_1.ComponentOptions.buildNumberOption({ defaultValue: 100, min: 1, depend: 'enableExpand' }),
	        /**
	         * This function manages folding individually for each result.
	         *
	         * The default value (which is implemented in Coveo.Folding.defaultGetResult):
	         *
	         * ```
	         * var results = result.childResults || [];
	         * // Add the top result at the top of the list
	         * results.unshift(result);
	         * // Empty childResults just to clean it
	         * result.childResults = [];
	         * // Fold those results
	         * results = Coveo.Folding.foldWithParent(results);
	         * // The first result is the top one
	         * var topResult = results.shift();
	         * // All other results are childResults
	         * topResult.childResults = results;
	         * return topResult;
	         * ```
	         *
	         * You can preprocess all the result with this option:
	         * ```
	         * Coveo.init(document.querySelector('#search'), {
	         *    Folding: {
	         *      getResult: function(result) {
	         *        result = Coveo.Folding.defaultGetResult(result);
	         *        // Your code here
	         *      }
	         *    }
	         * })
	         *
	         * // OR using the jQuery extension
	         *
	         * Coveo.$('#search').coveo('init', {
	         *    Folding: {
	         *      getResult: function(result) {
	         *        result = Coveo.Folding.defaultGetResult(result);
	         *        // Your code here
	         *      }
	         *    }
	         * });
	         * ```
	         */
	        getResult: ComponentOptions_1.ComponentOptions.buildCustomOption(function () {
	            return null;
	        }),
	        /**
	         * This function manages folding of all results.
	         *
	         * The default value (Coveo.Folding.defaultGetMoreResults):
	         *
	         * ```
	         * Coveo.Folding.defaultGetMoreResults = function(results) {
	         *    // The results are flat, just do the folding
	         *    return Coveo.Folding.foldWithParent(results);
	         * }
	         * ```
	         *
	         */
	        getMoreResults: ComponentOptions_1.ComponentOptions.buildCustomOption(function () {
	            return null;
	        })
	    };
	    return Folding;
	}(Component_1.Component));
	exports.Folding = Folding;
	Initialization_1.Initialization.registerAutoCreateComponent(Folding);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var Assert_1 = __webpack_require__(17);
	var Utils_1 = __webpack_require__(18);
	var SortCriteria = (function () {
	    /**
	     * Create a new SortCriteria
	     * @param sort The sort criteria (e.g.: relevancy, date)
	     * @param direction The direction by which to sort (e.g.: ascending, descending)
	     */
	    function SortCriteria(sort, direction) {
	        if (direction === void 0) { direction = ''; }
	        this.sort = sort;
	        this.direction = direction;
	        Assert_1.Assert.isNonEmptyString(sort);
	        Assert_1.Assert.check(_.contains(SortCriteria.validSorts, sort) || SortCriteria.sortIsField(sort));
	        if (SortCriteria.sortNeedsDirection(sort)) {
	            Assert_1.Assert.check(_.contains(SortCriteria.validDirections, direction));
	        }
	        else {
	            Assert_1.Assert.check(direction == '');
	        }
	    }
	    /**
	     * Return a new SortCriteria from a string
	     * @param criteria The string from which to create the SortCriteria
	     */
	    SortCriteria.parse = function (criteria) {
	        Assert_1.Assert.isNonEmptyString(criteria);
	        var split = criteria.match(/\S+/g);
	        return new SortCriteria(split[0], split[1]);
	    };
	    /**
	     * Put the sort criteria in the passed queryBuilder
	     * @param queryBuilder The queryBuilder in which to put the sort criteria.
	     */
	    SortCriteria.prototype.putInQueryBuilder = function (queryBuilder) {
	        Assert_1.Assert.exists(queryBuilder);
	        if (SortCriteria.sortIsField(this.sort)) {
	            queryBuilder.sortCriteria = 'field' + this.direction;
	            queryBuilder.sortField = this.sort;
	        }
	        else if (this.direction != '') {
	            queryBuilder.sortCriteria = this.sort + this.direction;
	        }
	        else {
	            queryBuilder.sortCriteria = this.sort;
	        }
	    };
	    /**
	     * Gets the value of the sort criteria from a single {@link IQueryResult}.<br/>
	     * For example, if the sort criteria is 'relevancy', it will return the value of the 'relevancy' field from result.
	     * @param result The {@link IQueryResult} from which to get the value.
	     */
	    SortCriteria.prototype.getValueFromResult = function (result) {
	        Assert_1.Assert.exists(result);
	        if (SortCriteria.sortIsField(this.sort)) {
	            return Utils_1.Utils.getFieldValue(result, this.sort);
	        }
	        else if (this.sort == 'date') {
	            return result.raw['date'];
	        }
	        else {
	            Assert_1.Assert.fail('Cannot retrieve value: ' + this.sort);
	        }
	    };
	    /**
	     * Returns a string representation of the sort criteria (e.g.: 'date ascending').
	     */
	    SortCriteria.prototype.toString = function () {
	        if (Utils_1.Utils.isNonEmptyString(this.direction)) {
	            return this.sort + ' ' + this.direction;
	        }
	        else {
	            return this.sort;
	        }
	    };
	    /**
	     * Checks if the SortCriteria is equal to another.
	     * @param criteria The SortCriteria to compare with
	     */
	    SortCriteria.prototype.equals = function (criteria) {
	        Assert_1.Assert.exists(criteria);
	        return criteria.sort == this.sort && criteria.direction == this.direction;
	    };
	    SortCriteria.sortIsField = function (criteria) {
	        return criteria.charAt(0) == '@';
	    };
	    SortCriteria.sortNeedsDirection = function (sort) {
	        return _.contains(SortCriteria.sortsNeedingDirection, sort) || SortCriteria.sortIsField(sort);
	    };
	    SortCriteria.validSorts = ['relevancy', 'date', 'qre'];
	    SortCriteria.sortsNeedingDirection = ['date'];
	    SortCriteria.validDirections = ['ascending', 'descending'];
	    return SortCriteria;
	}());
	exports.SortCriteria = SortCriteria;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var Strings_1 = __webpack_require__(34);
	var QueryEvents_1 = __webpack_require__(47);
	var BreadcrumbEvents_1 = __webpack_require__(41);
	var AnalyticsActionListMeta_1 = __webpack_require__(110);
	var QueryStateModel_1 = __webpack_require__(90);
	var Dom_1 = __webpack_require__(57);
	var Utils_1 = __webpack_require__(18);
	var Initialization_1 = __webpack_require__(95);
	var Assert_1 = __webpack_require__(17);
	/**
	 * This component job is to handle an 'hidden' query parameter.<br/>
	 * Concretely, this means that a search interface loaded with #hq=foo&hd=bar will add 'foo' as an expression to the query ('hq'=> hidden query) and render 'bar' in the {@link Breadcrumb}.<br/>
	 */
	var HiddenQuery = (function (_super) {
	    __extends(HiddenQuery, _super);
	    /**
	     * Create a new HiddenQuery component, which bind multiple events (building query as well as {@link Breadcrumb} events).
	     * @param element
	     * @param options
	     * @param bindings
	     */
	    function HiddenQuery(element, options, bindings) {
	        var _this = this;
	        _super.call(this, element, HiddenQuery.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, HiddenQuery, options);
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.buildingQuery, function (args) { return _this.handleBuildingQuery(args); });
	        this.bind.onRootElement(BreadcrumbEvents_1.BreadcrumbEvents.populateBreadcrumb, function (args) { return _this.handlePopulateBreadcrumb(args); });
	        this.bind.onRootElement(BreadcrumbEvents_1.BreadcrumbEvents.clearBreadcrumb, function () { return _this.setStateEmpty(); });
	    }
	    /**
	     * Clear any hd or hq set in the {@link QueryStateModel}, log an analytics event and trigger a new query.
	     */
	    HiddenQuery.prototype.clear = function () {
	        this.setStateEmpty();
	        var hiddenDescriptionRemoved = this.getDescription();
	        this.usageAnalytics.logSearchEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.contextRemove, { contextName: hiddenDescriptionRemoved });
	        this.queryController.executeQuery();
	    };
	    HiddenQuery.prototype.setStateEmpty = function () {
	        this.queryStateModel.set(QueryStateModel_1.QUERY_STATE_ATTRIBUTES.HD, '');
	        this.queryStateModel.set(QueryStateModel_1.QUERY_STATE_ATTRIBUTES.HQ, '');
	    };
	    HiddenQuery.prototype.handleBuildingQuery = function (data) {
	        Assert_1.Assert.exists(data);
	        var hiddenQuery = this.queryStateModel.get(QueryStateModel_1.QUERY_STATE_ATTRIBUTES.HQ);
	        if (Utils_1.Utils.isNonEmptyString(hiddenQuery)) {
	            data.queryBuilder.advancedExpression.add(hiddenQuery);
	        }
	    };
	    HiddenQuery.prototype.handlePopulateBreadcrumb = function (args) {
	        var _this = this;
	        var description = this.getDescription();
	        if (!_.isEmpty(description) && !_.isEmpty(this.queryStateModel.get(QueryStateModel_1.QUERY_STATE_ATTRIBUTES.HQ))) {
	            var elem = document.createElement('div');
	            Dom_1.$$(elem).addClass('coveo-hidden-query-breadcrumb');
	            var title = document.createElement('span');
	            Dom_1.$$(title).addClass('coveo-hidden-query-breadcrumb-title');
	            Dom_1.$$(title).text(this.options.title);
	            elem.appendChild(title);
	            var values = document.createElement('span');
	            Dom_1.$$(values).addClass('coveo-hidden-query-breadcrumb-values');
	            elem.appendChild(values);
	            var value = document.createElement('span');
	            Dom_1.$$(value).addClass('coveo-hidden-query-breadcrumb-value');
	            Dom_1.$$(value).text(description);
	            values.appendChild(value);
	            var clear = document.createElement('span');
	            Dom_1.$$(clear).addClass('coveo-hidden-query-breadcrumb-clear');
	            elem.appendChild(clear);
	            Dom_1.$$(elem).on('click', function () { return _this.clear(); });
	            args.breadcrumbs.push({
	                element: elem
	            });
	        }
	    };
	    HiddenQuery.prototype.getDescription = function () {
	        var description = this.queryStateModel.get(QueryStateModel_1.QueryStateModel.attributesEnum.hd);
	        if (_.isEmpty(description)) {
	            description = this.queryStateModel.get(QueryStateModel_1.QueryStateModel.attributesEnum.hq);
	        }
	        if (!_.isEmpty(description)) {
	            if (description.length > this.options.maximumDescriptionLength) {
	                description = description.slice(0, this.options.maximumDescriptionLength) + ' ...';
	            }
	        }
	        return description;
	    };
	    HiddenQuery.ID = 'HiddenQuery';
	    /**
	     * Possible options for the `HiddenQuery` component
	     * @componentOptions
	     */
	    HiddenQuery.options = {
	        /**
	         * Specifies a maximum character length for a description.<br/>
	         * After this length, the component will slice the descrption and add [...].<br/>
	         * Default value is 100.
	         */
	        maximumDescriptionLength: ComponentOptions_1.ComponentOptions.buildNumberOption({ min: 0, defaultValue: 100 }),
	        /**
	         * Specifies a title that will appear in the {@link Breadcrumb} when it is populated by the `HiddenQuery` component.<br/>
	         * By default, it is a localized string for 'Additional filters :'
	         */
	        title: ComponentOptions_1.ComponentOptions.buildLocalizedStringOption({ defaultValue: Strings_1.l('AdditionalFilters') + ' : ' })
	    };
	    return HiddenQuery;
	}(Component_1.Component));
	exports.HiddenQuery = HiddenQuery;
	Initialization_1.Initialization.registerAutoCreateComponent(HiddenQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {/// <reference path="../../controllers/HierarchicalFacetQueryController.ts" />
	/// <reference path="HierarchicalFacetValuesList.ts" />
	/// <reference path="HierarchicalFacetSearch.ts" />
	/// <reference path="HierarchicalBreadcrumbValuesList.ts" />
	/// <reference path="HierarchicalFacetValueElement.ts" />
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var FacetValues_1 = __webpack_require__(142);
	var Facet_1 = __webpack_require__(141);
	var ComponentOptions_1 = __webpack_require__(98);
	var HierarchicalFacetValuesList_1 = __webpack_require__(190);
	var HierarchicalFacetQueryController_1 = __webpack_require__(85);
	var Utils_1 = __webpack_require__(18);
	var Dom_1 = __webpack_require__(57);
	var Defer_1 = __webpack_require__(31);
	var HierarchicalFacetSearchValuesList_1 = __webpack_require__(191);
	var HierarchicalFacetSearch_1 = __webpack_require__(193);
	var HierarchicalBreadcrumbValuesList_1 = __webpack_require__(194);
	var Assert_1 = __webpack_require__(17);
	var OmniboxHierarchicalValuesList_1 = __webpack_require__(196);
	var HierarchicalFacetValueElement_1 = __webpack_require__(198);
	var Initialization_1 = __webpack_require__(95);
	/**
	 * This component inherits all of its options and behavior from the normal {@link Facet} component, but is meant to be used for hierarchical values.<br/>
	 * The `HierarchicalFacet` component could be used to display files in a file system, or categories for documents in a hierarchy.<br/>
	 * This facet require a group by field with a special format in order to work correctly.<br/>
	 * Let's say we have the following files indexed on a filesystem:
	 * ```
	 * C:\
	 *    folder1\
	 *        text1.txt
	 *    folder2\
	 *      folder3\
	 *        text2.txt
	 * ```
	 * The document `text1.txt` would need to have a field with the following format:<br/>
	 * `@field : c; c|folder1;`<br/>
	 * The document `text2.txt` would have a field with the following format:<br/>
	 * `@field: c; c|folder2; c|folder2|folder3;`<br/>
	 * The | character allows the facet to build its hierarchy (`folder3` inside `folder2` inside `c`).<br/>
	 * Since both documents contain the `c` value, selecting that value in the facet would return both documents.<br/>
	 * Selecting the `folder3` value in the facet would only return the `text2.txt` document.
	 */
	var HierarchicalFacet = (function (_super) {
	    __extends(HierarchicalFacet, _super);
	    /**
	     * Create a new instance of the Hierarchical component
	     * @param element
	     * @param options
	     * @param bindings
	     */
	    function HierarchicalFacet(element, options, bindings) {
	        _super.call(this, element, options, bindings, HierarchicalFacet.ID);
	        this.element = element;
	        this.bindings = bindings;
	        this.firstPlacement = true;
	        this.correctLevels = [];
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, HierarchicalFacet, this.options);
	        this.numberOfValuesToShow = this.originalNumberOfValuesToShow = (this.options.numberOfValues || 5);
	        this.numberOfValues = Math.max(this.options.numberOfValues, 10000);
	        this.options.injectionDepth = Math.max(this.options.injectionDepth, 10000);
	        this.logger.info('Hierarchy facet : Set number of values very high in order to build hierarchy', this.numberOfValues, this);
	        this.logger.info('Hierarchy facet : Set injection depth very high in order to build hierarchy', this.options.injectionDepth);
	    }
	    HierarchicalFacet.prototype.selectValue = function (value, selectChilds) {
	        if (selectChilds === void 0) { selectChilds = !this.options.useAnd; }
	        this.ensureDom();
	        this.ensureValueHierarchyExists([value]);
	        var valueHierarchy = this.getValueFromHierarchy(value);
	        if (selectChilds) {
	            this.selectChilds(valueHierarchy, valueHierarchy.childs);
	        }
	        this.flagParentForSelection(valueHierarchy);
	        _super.prototype.selectValue.call(this, value);
	    };
	    HierarchicalFacet.prototype.selectMultipleValues = function (values, selectChilds) {
	        var _this = this;
	        if (selectChilds === void 0) { selectChilds = !this.options.useAnd; }
	        this.ensureDom();
	        this.ensureValueHierarchyExists(values);
	        _.each(values, function (value) {
	            var valueHierarchy = _this.getValueFromHierarchy(value);
	            _this.flagParentForSelection(valueHierarchy);
	            if (selectChilds) {
	                _.each(valueHierarchy.childs, function (child) {
	                    _this.selectValue(child.facetValue);
	                });
	            }
	        });
	        _super.prototype.selectMultipleValues.call(this, values);
	    };
	    HierarchicalFacet.prototype.deselectValue = function (value, deselectChilds) {
	        var _this = this;
	        if (deselectChilds === void 0) { deselectChilds = true; }
	        this.ensureDom();
	        this.ensureValueHierarchyExists([value]);
	        var valueHierarchy = this.getValueFromHierarchy(value);
	        if (deselectChilds) {
	            var hasChilds = valueHierarchy.childs != undefined;
	            if (hasChilds) {
	                var activeChilds = _.filter(valueHierarchy.childs, function (child) {
	                    var valueToCompare = _this.getFacetValueFromHierarchy(child.facetValue);
	                    return valueToCompare.selected || valueToCompare.excluded;
	                });
	                valueHierarchy.hasChildSelected = false;
	                if (activeChilds.length == valueHierarchy.childs.length) {
	                    this.deselectChilds(valueHierarchy, valueHierarchy.childs);
	                }
	            }
	        }
	        this.deselectParent(valueHierarchy.parent);
	        this.unflagParentForSelection(valueHierarchy);
	        _super.prototype.deselectValue.call(this, value);
	    };
	    HierarchicalFacet.prototype.excludeValue = function (value, excludeChilds) {
	        if (excludeChilds === void 0) { excludeChilds = !this.options.useAnd; }
	        this.ensureDom();
	        this.ensureValueHierarchyExists([value]);
	        var valueHierarchy = this.getValueFromHierarchy(value);
	        if (excludeChilds) {
	            this.excludeChilds(valueHierarchy.childs);
	        }
	        else {
	            this.deselectChilds(valueHierarchy, valueHierarchy.childs);
	            this.close(valueHierarchy);
	        }
	        this.flagParentForSelection(valueHierarchy);
	        _super.prototype.excludeValue.call(this, value);
	    };
	    HierarchicalFacet.prototype.unexcludeValue = function (value, unexludeChilds) {
	        if (unexludeChilds === void 0) { unexludeChilds = !this.options.useAnd; }
	        this.ensureDom();
	        this.ensureValueHierarchyExists([value]);
	        var valueHierarchy = this.getValueFromHierarchy(value);
	        if (unexludeChilds) {
	            this.unexcludeChilds(valueHierarchy.childs);
	        }
	        this.unflagParentForSelection(valueHierarchy);
	        _super.prototype.unexcludeValue.call(this, value);
	    };
	    HierarchicalFacet.prototype.deselectMultipleValues = function (values, deselectChilds) {
	        var _this = this;
	        if (deselectChilds === void 0) { deselectChilds = !this.options.useAnd; }
	        this.ensureDom();
	        this.ensureValueHierarchyExists(values);
	        _.each(values, function (value) {
	            var valueHierarchy = _this.getValueFromHierarchy(value);
	            valueHierarchy.hasChildSelected = false;
	            _this.unflagParentForSelection(valueHierarchy);
	            if (deselectChilds) {
	                _.each(valueHierarchy.childs, function (child) {
	                    var childInHierarchy = _this.getValueFromHierarchy(child.facetValue);
	                    childInHierarchy.hasChildSelected = false;
	                    _this.deselectValue(child.facetValue);
	                });
	            }
	        });
	        _super.prototype.deselectMultipleValues.call(this, values);
	    };
	    HierarchicalFacet.prototype.toggleSelectValue = function (value) {
	        this.ensureDom();
	        this.ensureValueHierarchyExists([value]);
	        if (this.getFacetValueFromHierarchy(value).selected == false) {
	            this.selectValue(value);
	        }
	        else {
	            this.deselectValue(value);
	        }
	    };
	    HierarchicalFacet.prototype.toggleExcludeValue = function (value) {
	        this.ensureDom();
	        this.ensureValueHierarchyExists([value]);
	        if (this.getFacetValueFromHierarchy(value).excluded == false) {
	            this.excludeValue(value);
	        }
	        else {
	            this.unexcludeValue(value);
	        }
	    };
	    HierarchicalFacet.prototype.getValueCaption = function (facetValue) {
	        var stringValue = this.getSelf(facetValue);
	        var ret = stringValue;
	        if (Utils_1.Utils.exists(this.options.valueCaption)) {
	            if (typeof this.options.valueCaption == 'object') {
	                ret = this.options.valueCaption[stringValue] || ret;
	            }
	            if (typeof this.options.valueCaption == 'function') {
	                ret = this.options.valueCaption.call(this, facetValue);
	            }
	        }
	        return ret;
	    };
	    /**
	     * Get the currently displayed values in the facet.
	     * @returns {any[]}
	     */
	    HierarchicalFacet.prototype.getDisplayedValues = function () {
	        var _this = this;
	        var displayed = _.filter(this.values.getAll(), function (v) {
	            var valFromHierarchy = _this.getValueFromHierarchy(v);
	            if (valFromHierarchy) {
	                var elem = _this.getElementFromFacetValueList(v);
	                return !Dom_1.$$(elem).hasClass('coveo-inactive');
	            }
	            return false;
	        });
	        return _.pluck(displayed, 'value');
	    };
	    /**
	     * Update the sort criteria for the facet.
	     * @param criteria
	     */
	    HierarchicalFacet.prototype.updateSort = function (criteria) {
	        this.firstPlacement = true;
	        _super.prototype.updateSort.call(this, criteria);
	    };
	    HierarchicalFacet.prototype.open = function (value) {
	        var getter;
	        if (_.isString(value)) {
	            getter = this.getValueHierarchy(value);
	        }
	        else if (value instanceof FacetValues_1.FacetValue) {
	            getter = this.getValueHierarchy(value.value);
	        }
	        else {
	            getter = value;
	        }
	        if (getter != undefined) {
	            Dom_1.$$(this.getElementFromFacetValueList(getter.facetValue.value)).addClass('coveo-open');
	            this.showChilds(getter.childs);
	            if (getter.parent != undefined) {
	                this.open(this.getValueHierarchy(getter.facetValue.value).parent);
	            }
	            this.getValueHierarchy(getter.facetValue.value).keepOpened = true;
	        }
	    };
	    HierarchicalFacet.prototype.close = function (value) {
	        var _this = this;
	        var getter;
	        if (_.isString(value)) {
	            getter = this.getValueHierarchy(value);
	        }
	        else if (value instanceof FacetValues_1.FacetValue) {
	            getter = this.getValueHierarchy(value.value);
	        }
	        else {
	            getter = value;
	        }
	        if (getter != undefined) {
	            Dom_1.$$(this.getElementFromFacetValueList(getter.facetValue)).removeClass('coveo-open');
	            this.hideChilds(getter.childs);
	            _.each(getter.childs, function (child) {
	                _this.close(_this.getValueHierarchy(child.facetValue.value));
	            });
	            this.getValueHierarchy(getter.facetValue.value).keepOpened = false;
	        }
	    };
	    /**
	     * Reset the facet state
	     */
	    HierarchicalFacet.prototype.reset = function () {
	        var _this = this;
	        _.each(this.getAllValueHierarchy(), function (valueHierarchy) {
	            valueHierarchy.hasChildSelected = false;
	        });
	        // Need to close all values, otherwise we might end up with orphan(s)
	        // if a parent value, after reset, is no longer visible.
	        _.each(this.getAllValueHierarchy(), function (valueHierarchy) {
	            _this.close(valueHierarchy);
	        });
	        _super.prototype.reset.call(this);
	    };
	    HierarchicalFacet.prototype.processFacetSearchAllResultsSelected = function (facetValues) {
	        this.selectMultipleValues(facetValues);
	        this.triggerNewQuery();
	    };
	    HierarchicalFacet.prototype.updateSearchInNewDesign = function (moreValuesAvailable) {
	        if (moreValuesAvailable === void 0) { moreValuesAvailable = true; }
	        // We always want to show search for hierarchical facet :
	        // It's useful since child values are folded under their parent most of the time
	        _super.prototype.updateSearchInNewDesign.call(this, true);
	    };
	    HierarchicalFacet.prototype.facetValueHasChanged = function () {
	        var _this = this;
	        this.updateQueryStateModel();
	        Defer_1.Defer.defer(function () {
	            _this.updateAppearanceDependingOnState();
	        });
	    };
	    HierarchicalFacet.prototype.initFacetQueryController = function () {
	        this.facetQueryController = new HierarchicalFacetQueryController_1.HierarchicalFacetQueryController(this);
	    };
	    HierarchicalFacet.prototype.initFacetSearch = function () {
	        this.facetSearch = new HierarchicalFacetSearch_1.HierarchicalFacetSearch(this, HierarchicalFacetSearchValuesList_1.HierarchicalFacetSearchValuesList, this.root);
	        this.element.appendChild(this.facetSearch.build());
	    };
	    HierarchicalFacet.prototype.handleDeferredQuerySuccess = function (data) {
	        this.updateAppearanceDependingOnState();
	        _super.prototype.handleDeferredQuerySuccess.call(this, data);
	    };
	    HierarchicalFacet.prototype.handlePopulateSearchAlerts = function (args) {
	        if (this.values.hasSelectedOrExcludedValues()) {
	            args.text.push(new HierarchicalBreadcrumbValuesList_1.HierarchicalBreadcrumbValuesList(this, this.values.getSelected().concat(this.values.getExcluded()), this.getAllValueHierarchy()).buildAsString());
	        }
	    };
	    HierarchicalFacet.prototype.handlePopulateBreadcrumb = function (args) {
	        Assert_1.Assert.exists(args);
	        if (this.values.hasSelectedOrExcludedValues()) {
	            var element = new HierarchicalBreadcrumbValuesList_1.HierarchicalBreadcrumbValuesList(this, this.values.getSelected().concat(this.values.getExcluded()), this.getAllValueHierarchy()).build();
	            args.breadcrumbs.push({
	                element: element
	            });
	        }
	    };
	    HierarchicalFacet.prototype.handleOmniboxWithStaticValue = function (eventArg) {
	        var _this = this;
	        var regex = eventArg.completeQueryExpression.regex;
	        var match = _.first(_.filter(this.getAllValueHierarchy(), function (existingValue) {
	            return regex.test(_this.getValueCaption(existingValue.facetValue));
	        }), this.options.numberOfValuesInOmnibox);
	        var facetValues = _.compact(_.map(match, function (gotAMatch) {
	            var fromList = _this.getFromFacetValueList(gotAMatch.facetValue);
	            return fromList ? fromList.facetValue : undefined;
	        }));
	        var element = new OmniboxHierarchicalValuesList_1.OmniboxHierarchicalValuesList(this, facetValues, eventArg).build();
	        eventArg.rows.push({
	            element: element,
	            zIndex: this.omniboxZIndex
	        });
	    };
	    HierarchicalFacet.prototype.rebuildValueElements = function () {
	        this.numberOfValues = Math.max(this.numberOfValues, 10000);
	        this.processHierarchy();
	        this.setValueListContent();
	        _super.prototype.rebuildValueElements.call(this);
	        this.buildParentChildRelationship();
	        this.checkForOrphans();
	        this.crop();
	    };
	    HierarchicalFacet.prototype.initFacetValuesList = function () {
	        this.facetValuesList = new HierarchicalFacetValuesList_1.HierarchicalFacetValuesList(this, HierarchicalFacetValueElement_1.HierarchicalFacetValueElement);
	        this.element.appendChild(this.facetValuesList.build());
	    };
	    HierarchicalFacet.prototype.updateMoreLess = function () {
	        var moreValuesAvailable = this.numberOfValuesToShow < this.topLevelHierarchy.length;
	        var lessIsShown = this.numberOfValuesToShow > this.originalNumberOfValuesToShow;
	        _super.prototype.updateMoreLess.call(this, lessIsShown, moreValuesAvailable);
	    };
	    HierarchicalFacet.prototype.handleClickMore = function () {
	        this.numberOfValuesToShow += this.originalNumberOfValuesToShow;
	        this.numberOfValuesToShow = Math.min(this.numberOfValuesToShow, this.values.size());
	        this.crop();
	        this.updateMoreLess();
	    };
	    HierarchicalFacet.prototype.handleClickLess = function () {
	        this.numberOfValuesToShow = this.originalNumberOfValuesToShow;
	        this.crop();
	        this.updateMoreLess();
	    };
	    HierarchicalFacet.prototype.updateNumberOfValues = function () {
	        this.numberOfValues = Math.max(this.numberOfValues, 10000);
	    };
	    HierarchicalFacet.prototype.ensureValueHierarchyExists = function (facetValues) {
	        var _this = this;
	        if (facetValues[0] && typeof facetValues[0] == 'string') {
	            facetValues = _.map(facetValues, function (value) {
	                return FacetValues_1.FacetValue.createFromValue(value);
	            });
	        }
	        var atLeastOneDoesNotExists = false;
	        _.each(facetValues, function (facetValue) {
	            if (_this.getValueHierarchy(facetValue.value) == undefined) {
	                atLeastOneDoesNotExists = true;
	            }
	        });
	        if (atLeastOneDoesNotExists) {
	            this.processHierarchy(facetValues);
	        }
	    };
	    HierarchicalFacet.prototype.crop = function () {
	        var _this = this;
	        // Partition the top level or the facet to only operate on the values that are not selected or excluded
	        var partition = _.partition(this.topLevelHierarchy, function (hierarchy) {
	            return hierarchy.facetValue.selected || hierarchy.facetValue.excluded;
	        });
	        // Hide and show the partitionned top level values, depending on the numberOfValuesToShow
	        var numberOfValuesLeft = this.numberOfValuesToShow - partition[0].length;
	        _.each(_.last(partition[1], partition[1].length - numberOfValuesLeft), function (toHide) {
	            _this.hideFacetValue(toHide);
	            _this.hideChilds(toHide.childs);
	        });
	        _.each(_.first(partition[1], numberOfValuesLeft), function (toShow) {
	            _this.showFacetValue(toShow);
	        });
	    };
	    HierarchicalFacet.prototype.placeChildsUnderTheirParent = function (hierarchy, hierarchyElement) {
	        var _this = this;
	        _.each(hierarchy.childs.reverse(), function (child) {
	            if (_this.getValueHierarchy(child.facetValue.value)) {
	                var childElement = _this.getElementFromFacetValueList(child.facetValue);
	                Dom_1.$$(childElement).insertAfter(hierarchyElement);
	            }
	        });
	        if (hierarchy.keepOpened) {
	            this.open(hierarchy);
	            this.showChilds(hierarchy.childs);
	        }
	        else {
	            this.hideChilds(hierarchy.childs);
	        }
	    };
	    HierarchicalFacet.prototype.addCssClassToParentAndChilds = function (hierarchy, hierarchyElement) {
	        var _this = this;
	        Dom_1.$$(hierarchyElement).addClass('coveo-has-childs');
	        if (hierarchy.hasChildSelected) {
	            Dom_1.$$(hierarchyElement).addClass('coveo-has-childs-selected');
	        }
	        var openAndCloseChilds = Dom_1.$$('div', {
	            className: 'coveo-has-childs-toggle'
	        }).el;
	        Dom_1.$$(openAndCloseChilds).on('click', function () {
	            Dom_1.$$(hierarchyElement).hasClass('coveo-open') ? _this.close(hierarchy) : _this.open(hierarchy);
	        });
	        Dom_1.$$(hierarchyElement).prepend(openAndCloseChilds);
	    };
	    HierarchicalFacet.prototype.buildParentChildRelationship = function () {
	        var _this = this;
	        var sorted = _.chain(this.getAllValueHierarchy())
	            .toArray()
	            .sortBy('level')
	            .value();
	        _.each(sorted, function (hierarchy) {
	            var hierarchyElement = _this.getElementFromFacetValueList(hierarchy.facetValue);
	            if (Utils_1.Utils.isNonEmptyArray(hierarchy.childs)) {
	                _this.placeChildsUnderTheirParent(hierarchy, hierarchyElement);
	                _this.addCssClassToParentAndChilds(hierarchy, hierarchyElement);
	            }
	            else {
	                Dom_1.$$(hierarchyElement).addClass('coveo-no-childs');
	            }
	            hierarchyElement.style.marginLeft = (_this.options.marginByLevel * (hierarchy.level - _this.options.levelStart)) + 'px';
	        });
	    };
	    HierarchicalFacet.prototype.setValueListContent = function () {
	        var _this = this;
	        this.facetValuesList.hierarchyFacetValues = _.map(this.correctLevels, function (hierarchy) {
	            if (!_this.values.contains(hierarchy.facetValue.value)) {
	                hierarchy.facetValue.occurrences = 0;
	                _this.values.add(hierarchy.facetValue);
	            }
	            return hierarchy.facetValue;
	        });
	    };
	    HierarchicalFacet.prototype.createHierarchy = function (valuesToBuildWith) {
	        var _this = this;
	        var flatHierarchy = _.map(valuesToBuildWith, function (value) {
	            var parent = _this.getParent(value);
	            var self = value.lookupValue || value.value;
	            return {
	                facetValue: value,
	                level: _this.getLevel(value),
	                parent: parent,
	                self: self
	            };
	        });
	        this.setInHierarchy(flatHierarchy);
	        _.each(this.getAllValueHierarchy(), function (valueHierarchy) {
	            if (valueHierarchy.facetValue.selected) {
	                _this.flagParentForSelection(valueHierarchy);
	            }
	        });
	        return flatHierarchy;
	    };
	    HierarchicalFacet.prototype.processHierarchy = function (facetValues) {
	        var _this = this;
	        if (facetValues === void 0) { facetValues = this.values.getAll(); }
	        _.each(this.getAllValueHierarchy(), function (hierarchy) {
	            if (_this.values.get(hierarchy.facetValue.value) == undefined) {
	                _this.deleteValueHierarchy(_this.getLookupOrValue(hierarchy.facetValue));
	            }
	        });
	        this.createHierarchy(facetValues);
	    };
	    HierarchicalFacet.prototype.setInHierarchy = function (flatHierarchy) {
	        var _this = this;
	        this.correctLevels = _.filter(flatHierarchy, function (hierarchy) {
	            var isCorrectMinimumLevel = _this.options.levelStart == undefined || hierarchy.level >= _this.options.levelStart;
	            var isCorrectMaximumLevel = _this.options.levelEnd == undefined || hierarchy.level < _this.options.levelEnd;
	            return isCorrectMinimumLevel && isCorrectMaximumLevel;
	        });
	        _.each(this.correctLevels, function (hierarchy) {
	            var childs = _.map(_.filter(_this.correctLevels, function (possibleChild) {
	                return possibleChild.parent != null && possibleChild.parent.toLowerCase() == hierarchy.self.toLowerCase();
	            }), function (child) {
	                return {
	                    facetValue: child.facetValue,
	                    level: child.level,
	                    keepOpened: false,
	                    hasChildSelected: false
	                };
	            });
	            var parent = hierarchy.parent != null ? _.find(_this.correctLevels, function (possibleParent) {
	                return possibleParent.self.toLowerCase() == hierarchy.parent.toLowerCase();
	            }) : null;
	            var hierarchyThatAlreadyExists = _this.getValueHierarchy(hierarchy.facetValue.value);
	            var hierarchyThatAlreadyExistsAtParent;
	            if (parent) {
	                hierarchyThatAlreadyExistsAtParent = _this.getValueHierarchy(parent.facetValue.value);
	            }
	            _this.setValueHierarchy(hierarchy.facetValue.value, {
	                childs: childs,
	                parent: parent == undefined ? undefined : {
	                    facetValue: parent.facetValue,
	                    level: parent.level,
	                    keepOpened: hierarchyThatAlreadyExistsAtParent ? hierarchyThatAlreadyExistsAtParent.keepOpened : false,
	                    hasChildSelected: hierarchyThatAlreadyExistsAtParent ? hierarchyThatAlreadyExistsAtParent.hasChildSelected : false,
	                    originalPosition: hierarchyThatAlreadyExistsAtParent ? hierarchyThatAlreadyExistsAtParent.originalPosition : undefined,
	                },
	                facetValue: hierarchy.facetValue,
	                level: hierarchy.level,
	                keepOpened: hierarchyThatAlreadyExists ? hierarchyThatAlreadyExists.keepOpened : false,
	                hasChildSelected: hierarchyThatAlreadyExists ? hierarchyThatAlreadyExists.hasChildSelected : false,
	                originalPosition: hierarchyThatAlreadyExists ? hierarchyThatAlreadyExists.originalPosition : undefined
	            });
	        });
	        this.topLevelHierarchy = _.chain(this.values.getAll())
	            .filter(function (value) {
	            var fromHierarchy = _this.getValueFromHierarchy(value);
	            if (fromHierarchy) {
	                return fromHierarchy.level == (_this.options.levelStart || 0);
	            }
	            else {
	                return false;
	            }
	        })
	            .map(function (value) {
	            return _this.getValueFromHierarchy(value);
	        })
	            .value();
	    };
	    HierarchicalFacet.prototype.getParent = function (value) {
	        var lastIndexOfDelimiting = this.getLookupOrValue(value).lastIndexOf(this.options.delimitingCharacter);
	        if (lastIndexOfDelimiting != -1) {
	            return this.getLookupOrValue(value).substring(0, lastIndexOfDelimiting);
	        }
	        return undefined;
	    };
	    HierarchicalFacet.prototype.getSelf = function (value) {
	        var parent = this.getParent(value);
	        if (parent == undefined) {
	            return this.getLookupOrValue(value);
	        }
	        else {
	            var indexOfParent = this.getLookupOrValue(value).indexOf(parent);
	            return this.getLookupOrValue(value).substring(indexOfParent + parent.length + 1);
	        }
	    };
	    HierarchicalFacet.prototype.showFacetValue = function (value) {
	        Dom_1.$$(this.getElementFromFacetValueList(value.facetValue.value)).removeClass('coveo-inactive');
	    };
	    HierarchicalFacet.prototype.hideFacetValue = function (value) {
	        Dom_1.$$(this.getElementFromFacetValueList(value.facetValue.value)).addClass('coveo-inactive');
	    };
	    HierarchicalFacet.prototype.hideChilds = function (children) {
	        var _this = this;
	        _.each(children, function (child) {
	            _this.hideFacetValue(child);
	        });
	    };
	    HierarchicalFacet.prototype.showChilds = function (children) {
	        var _this = this;
	        _.each(children, function (child) {
	            _this.showFacetValue(child);
	        });
	    };
	    HierarchicalFacet.prototype.selectChilds = function (parent, children) {
	        this.flagParentForSelection(parent);
	        this.selectMultipleValues(_.map(children, function (child) {
	            return child.facetValue;
	        }));
	    };
	    HierarchicalFacet.prototype.deselectChilds = function (parent, children) {
	        parent.hasChildSelected = false;
	        this.deselectMultipleValues(_.map(children, function (child) {
	            return child.facetValue;
	        }));
	    };
	    HierarchicalFacet.prototype.excludeChilds = function (children) {
	        this.excludeMultipleValues(_.map(children, function (child) {
	            return child.facetValue;
	        }));
	    };
	    HierarchicalFacet.prototype.unexcludeChilds = function (children) {
	        this.unexcludeMultipleValues(_.map(children, function (child) {
	            return child.facetValue;
	        }));
	    };
	    HierarchicalFacet.prototype.selectParent = function (parent) {
	        if (parent != undefined) {
	            this.selectValue(parent.facetValue);
	            if (parent.parent) {
	                this.selectParent(this.getValueHierarchy(parent.parent.facetValue.value));
	            }
	        }
	    };
	    HierarchicalFacet.prototype.deselectParent = function (parent) {
	        if (parent != undefined) {
	            this.deselectValue(parent.facetValue, false);
	        }
	    };
	    HierarchicalFacet.prototype.flagParentForSelection = function (valueHierarchy) {
	        var parent = valueHierarchy.parent;
	        while (parent) {
	            var parentInHierarchy = this.getValueHierarchy(parent.facetValue.value);
	            parentInHierarchy.hasChildSelected = true;
	            parent = parentInHierarchy.parent;
	        }
	    };
	    HierarchicalFacet.prototype.unflagParentForSelection = function (valueHierarchy) {
	        var _this = this;
	        var parent = valueHierarchy.parent;
	        while (parent) {
	            var parentInHierarchy = this.getValueHierarchy(parent.facetValue.value);
	            var otherSelectedChilds = _.filter(parentInHierarchy.childs, function (child) {
	                var childInHierarchy = _this.getValueHierarchy(child.facetValue.value);
	                if (childInHierarchy != undefined) {
	                    return childInHierarchy.facetValue.value != valueHierarchy.facetValue.value
	                        && (childInHierarchy.facetValue.selected || childInHierarchy.facetValue.excluded || childInHierarchy.hasChildSelected);
	                }
	            });
	            if (otherSelectedChilds.length == 0) {
	                parentInHierarchy.hasChildSelected = false;
	            }
	            parent = parentInHierarchy.parent;
	        }
	    };
	    HierarchicalFacet.prototype.getValueFromHierarchy = function (value) {
	        var getter = value instanceof FacetValues_1.FacetValue ? value.value : value;
	        return this.getValueHierarchy(getter);
	    };
	    HierarchicalFacet.prototype.getFacetValueFromHierarchy = function (value) {
	        return this.getValueFromHierarchy(value).facetValue;
	    };
	    HierarchicalFacet.prototype.getLookupOrValue = function (value) {
	        return value.lookupValue || value.value;
	    };
	    HierarchicalFacet.prototype.getElementFromFacetValueList = function (value) {
	        var ret = this.getFromFacetValueList(value);
	        if (ret) {
	            return ret.renderer.listItem;
	        }
	        else {
	            return Dom_1.$$('div').el;
	        }
	    };
	    HierarchicalFacet.prototype.getFromFacetValueList = function (value) {
	        var fromHierarchy = this.getValueFromHierarchy(value);
	        if (fromHierarchy != undefined) {
	            return this.facetValuesList.get(value);
	        }
	        else {
	            return undefined;
	        }
	    };
	    HierarchicalFacet.prototype.getLevel = function (value) {
	        return value.value.split(this.options.delimitingCharacter).length - 1;
	    };
	    HierarchicalFacet.prototype.getAllValueHierarchy = function () {
	        if (this.valueHierarchy == null) {
	            this.valueHierarchy = {};
	        }
	        return this.valueHierarchy;
	    };
	    HierarchicalFacet.prototype.deleteValueHierarchy = function (key) {
	        if (this.valueHierarchy != null) {
	            delete this.valueHierarchy[key.toLowerCase()];
	        }
	    };
	    HierarchicalFacet.prototype.getValueHierarchy = function (key) {
	        if (this.valueHierarchy == null) {
	            return undefined;
	        }
	        return this.valueHierarchy[key.toLowerCase()];
	    };
	    HierarchicalFacet.prototype.setValueHierarchy = function (key, value) {
	        if (this.valueHierarchy == null) {
	            this.valueHierarchy = {};
	        }
	        this.valueHierarchy[key.toLowerCase()] = value;
	    };
	    HierarchicalFacet.prototype.checkForOrphans = function () {
	        var _this = this;
	        _.each(this.valueHierarchy, function (v) {
	            if (_this.getLevel(v.facetValue) != _this.options.levelStart) {
	                if (_this.getValueHierarchy(_this.getParent(v.facetValue)) == undefined) {
	                    _this.logger.error("Orphan value found in HierarchicalFacet : " + v.facetValue.value, "Needed : " + _this.getParent(v.facetValue) + " but not found");
	                    _this.logger.warn("Removing incoherent facet value : " + v.facetValue.value);
	                    _this.hideFacetValue(v);
	                }
	            }
	        });
	    };
	    HierarchicalFacet.ID = 'HierarchicalFacet';
	    /**
	     * The options for the component
	     * @componentOptions
	     */
	    HierarchicalFacet.options = {
	        /**
	         * The character that allows to specify the hierarchy dependency.<br/>
	         * The default value is `|`.<br/>
	         * For example, if your field has the following values: @field: c; c>folder2; c>folder2>folder3; Then your delimiting character would be `>`.
	         */
	        delimitingCharacter: ComponentOptions_1.ComponentOptions.buildStringOption({ defaultValue: '|' }),
	        /**
	         * Specifies at which level (0 based index) of the hierarchy you want your facet to start displaying its values.<br/>
	         * The default value is `0`.<br/>
	         * Using this example:
	         * ```
	         * C:\
	         *    folder1\
	         *        text1.txt
	         *    folder2\
	         *      folder3\
	         *        text2.txt
	         * ```
	         * Setting levelStart to 1 would only display folder1 and folder2, and omit c:
	         */
	        levelStart: ComponentOptions_1.ComponentOptions.buildNumberOption({ defaultValue: 0, min: 0 }),
	        /**
	         * Specifies at which level (0 based index) of the hierarchy you want your facet to stop displaying its values.<br/>
	         * The default value is undefined, meaning it will render all levels.
	         */
	        levelEnd: ComponentOptions_1.ComponentOptions.buildNumberOption({ min: 0 }),
	        /**
	         * Specifies the margin, in pixel, between each level, when they are expanded.<br/>
	         * Default value is `10`.
	         */
	        marginByLevel: ComponentOptions_1.ComponentOptions.buildNumberOption({ defaultValue: 10, min: 0 })
	    };
	    HierarchicalFacet.parent = Facet_1.Facet;
	    return HierarchicalFacet;
	}(Facet_1.Facet));
	exports.HierarchicalFacet = HierarchicalFacet;
	Initialization_1.Initialization.registerAutoCreateComponent(HierarchicalFacet);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	/// <reference path="HierarchicalFacet.ts" />
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var FacetValuesList_1 = __webpack_require__(152);
	var HierarchicalFacetValuesList = (function (_super) {
	    __extends(HierarchicalFacetValuesList, _super);
	    function HierarchicalFacetValuesList(facet, facetValueElementKlass) {
	        _super.call(this, facet, facetValueElementKlass);
	        this.facet = facet;
	        this.facetValueElementKlass = facetValueElementKlass;
	    }
	    HierarchicalFacetValuesList.prototype.getValuesToBuildWith = function () {
	        return this.hierarchyFacetValues;
	    };
	    return HierarchicalFacetValuesList;
	}(FacetValuesList_1.FacetValuesList));
	exports.HierarchicalFacetValuesList = HierarchicalFacetValuesList;


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	/// <reference path="../Facet/Facet.ts" />
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var FacetSearchValuesList_1 = __webpack_require__(156);
	var HierarchicalFacetSearchValueElement_1 = __webpack_require__(192);
	var HierarchicalFacetSearchValuesList = (function (_super) {
	    __extends(HierarchicalFacetSearchValuesList, _super);
	    function HierarchicalFacetSearchValuesList(facet) {
	        _super.call(this, facet, HierarchicalFacetSearchValueElement_1.HierarchicalFacetSearchValueElement);
	        this.facet = facet;
	    }
	    return HierarchicalFacetSearchValuesList;
	}(FacetSearchValuesList_1.FacetSearchValuesList));
	exports.HierarchicalFacetSearchValuesList = HierarchicalFacetSearchValuesList;


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var FacetValueElement_1 = __webpack_require__(145);
	var HierarchicalFacetSearchValueElement = (function (_super) {
	    __extends(HierarchicalFacetSearchValueElement, _super);
	    function HierarchicalFacetSearchValueElement(facet, facetValue, keepDisplayedValueNextTime) {
	        _super.call(this, facet, facetValue, keepDisplayedValueNextTime);
	        this.facet = facet;
	        this.facetValue = facetValue;
	        this.keepDisplayedValueNextTime = keepDisplayedValueNextTime;
	    }
	    HierarchicalFacetSearchValueElement.prototype._handleSelectValue = function (eventBindings) {
	        this.facet.open(this.facetValue);
	        _super.prototype.handleSelectValue.call(this, eventBindings);
	    };
	    HierarchicalFacetSearchValueElement.prototype._handleExcludeClick = function (eventBindings) {
	        this.facet.open(this.facetValue);
	        _super.prototype.handleExcludeClick.call(this, eventBindings);
	    };
	    return HierarchicalFacetSearchValueElement;
	}(FacetValueElement_1.FacetValueElement));
	exports.HierarchicalFacetSearchValueElement = HierarchicalFacetSearchValueElement;


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {/// <reference path="HierarchicalFacet.ts" />
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var FacetSearch_1 = __webpack_require__(143);
	var FacetSearchParameters_1 = __webpack_require__(81);
	var FacetValues_1 = __webpack_require__(142);
	var Utils_1 = __webpack_require__(18);
	var ExternalModulesShim_1 = __webpack_require__(25);
	var HierarchicalFacetSearch = (function (_super) {
	    __extends(HierarchicalFacetSearch, _super);
	    function HierarchicalFacetSearch(facet, facetSearchValuesListKlass, root) {
	        _super.call(this, facet, facetSearchValuesListKlass, root);
	        this.facet = facet;
	        this.facetSearchValuesListKlass = facetSearchValuesListKlass;
	    }
	    HierarchicalFacetSearch.prototype.buildParamsForExcludingCurrentlyDisplayedValues = function () {
	        var params = _super.prototype.buildParamsForExcludingCurrentlyDisplayedValues.call(this);
	        params.alwaysExclude = this.facet.getDisplayedValues();
	        if (this.facet.facetSearch.currentlyDisplayedResults) {
	            params.alwaysExclude = params.alwaysExclude.concat(this.facet.facetSearch.currentlyDisplayedResults);
	        }
	        return params;
	    };
	    HierarchicalFacetSearch.prototype.selectAllValuesMatchingSearch = function () {
	        var _this = this;
	        this.facet.showWaitingAnimation();
	        var searchParameters = new FacetSearchParameters_1.FacetSearchParameters(this.facet);
	        searchParameters.nbResults = this.facet.numberOfValues;
	        searchParameters.alwaysInclude = this.facet.getDisplayedValues();
	        searchParameters.setValueToSearch(this.getValueInInputForFacetSearch());
	        this.facet.facetQueryController.search(searchParameters).then(function (fieldValues) {
	            _this.completelyDismissSearch();
	            ExternalModulesShim_1.ModalBox.close(true);
	            var facetValues = _this.getFacetValues(fieldValues);
	            _this.facet.processFacetSearchAllResultsSelected(facetValues);
	        });
	        this.completelyDismissSearch();
	    };
	    HierarchicalFacetSearch.prototype.getFacetValues = function (fieldValues) {
	        var _this = this;
	        var values = [];
	        _.each(fieldValues, function (fieldValue) {
	            var hierarchy = _this.facet.getValueFromHierarchy(fieldValue.value);
	            values.push(_this.createFacetValuesFromHierarchy(hierarchy));
	        });
	        return _.flatten(values);
	    };
	    HierarchicalFacetSearch.prototype.createFacetValuesFromHierarchy = function (hierarchy) {
	        var _this = this;
	        var values = [];
	        var fieldValue = hierarchy.facetValue.value;
	        var facetValue = this.facet.values.get(fieldValue);
	        if (!Utils_1.Utils.exists(facetValue)) {
	            facetValue = FacetValues_1.FacetValue.create(fieldValue);
	        }
	        facetValue.selected = true;
	        facetValue.excluded = false;
	        values.push(facetValue);
	        var childs = hierarchy.childs;
	        _.each(childs, function (child) {
	            var childHierarchy = _this.facet.getValueFromHierarchy(child.facetValue.value);
	            values.push(_this.createFacetValuesFromHierarchy(childHierarchy));
	        });
	        return values;
	    };
	    return HierarchicalFacetSearch;
	}(FacetSearch_1.FacetSearch));
	exports.HierarchicalFacetSearch = HierarchicalFacetSearch;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {/// <reference path="HierarchicalFacet.ts" />
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var BreadcrumbValuesList_1 = __webpack_require__(155);
	var HierarchicalBreadcrumbValueElement_1 = __webpack_require__(195);
	var Dom_1 = __webpack_require__(57);
	var HierarchicalBreadcrumbValuesList = (function (_super) {
	    __extends(HierarchicalBreadcrumbValuesList, _super);
	    function HierarchicalBreadcrumbValuesList(facet, facetValues, valueHierarchy) {
	        _super.call(this, facet, facetValues, HierarchicalBreadcrumbValueElement_1.HierarchicalBreadcrumbValueElement);
	        this.facet = facet;
	        this.facetValues = facetValues;
	        this.valueHierarchy = valueHierarchy;
	    }
	    HierarchicalBreadcrumbValuesList.prototype.buildAsString = function () {
	        this.build();
	        if (this.elem) {
	            var joined = (this.facet.options.title + ": ") + _.map(Dom_1.$$(this.elem).findAll('.coveo-facet-breadcrumb-value'), function (value) {
	                _.each(Dom_1.$$(value).findAll('.coveo-hierarchical-breadcrumb-separator'), function (separator) {
	                    // small right black triangle
	                    Dom_1.$$(separator).text('\u25B8');
	                });
	                return Dom_1.$$(value).text();
	            }).join(', ');
	            return joined;
	        }
	        return '';
	    };
	    return HierarchicalBreadcrumbValuesList;
	}(BreadcrumbValuesList_1.BreadcrumbValueList));
	exports.HierarchicalBreadcrumbValuesList = HierarchicalBreadcrumbValuesList;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var BreadcrumbValueElement_1 = __webpack_require__(154);
	var HierarchicalBreadcrumbValueElement = (function (_super) {
	    __extends(HierarchicalBreadcrumbValueElement, _super);
	    function HierarchicalBreadcrumbValueElement(facet, facetValue) {
	        _super.call(this, facet, facetValue);
	        this.facet = facet;
	        this.facetValue = facetValue;
	    }
	    HierarchicalBreadcrumbValueElement.prototype.build = function () {
	        var build = _super.prototype.build.call(this);
	        build.addClass('coveo-hierarchical-facet-value');
	        var caption = build.find('.coveo-facet-breadcrumb-caption');
	        var values = this.facetValue.value.split(this.facet.options.delimitingCharacter);
	        values = _.map(values, function (v) {
	            return _.escape(v);
	        });
	        caption.innerHTML = values.join('<span class=\'coveo-hierarchical-breadcrumb-separator\'></span>');
	        return build;
	    };
	    return HierarchicalBreadcrumbValueElement;
	}(BreadcrumbValueElement_1.BreadcrumbValueElement));
	exports.HierarchicalBreadcrumbValueElement = HierarchicalBreadcrumbValueElement;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	/// <reference path="../HierarchicalFacet/HierarchicalFacet.ts" />
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OmniboxValuesList_1 = __webpack_require__(158);
	var OmniboxHierarchicalValueElement_1 = __webpack_require__(197);
	var OmniboxHierarchicalValuesList = (function (_super) {
	    __extends(OmniboxHierarchicalValuesList, _super);
	    function OmniboxHierarchicalValuesList(facet, facetValues, omniboxObject) {
	        _super.call(this, facet, facetValues, omniboxObject, OmniboxHierarchicalValueElement_1.OmniboxHierarchicalValueElement);
	        this.facet = facet;
	        this.facetValues = facetValues;
	        this.omniboxObject = omniboxObject;
	    }
	    return OmniboxHierarchicalValuesList;
	}(OmniboxValuesList_1.OmniboxValuesList));
	exports.OmniboxHierarchicalValuesList = OmniboxHierarchicalValuesList;


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	/// <reference path="HierarchicalFacet.ts" />
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OmniboxValueElement_1 = __webpack_require__(157);
	var OmniboxHierarchicalValueElement = (function (_super) {
	    __extends(OmniboxHierarchicalValueElement, _super);
	    function OmniboxHierarchicalValueElement(facet, facetValue, eventArg) {
	        _super.call(this, facet, facetValue, eventArg);
	        this.facet = facet;
	        this.facetValue = facetValue;
	        this.eventArg = eventArg;
	    }
	    OmniboxHierarchicalValueElement.prototype._handleSelectValue = function (eventBindings) {
	        this.facet.open(this.facetValue);
	        _super.prototype.handleSelectValue.call(this, eventBindings);
	    };
	    OmniboxHierarchicalValueElement.prototype._handleExcludeClick = function (eventBindings) {
	        this.facet.open(this.facetValue);
	        _super.prototype.handleExcludeClick.call(this, eventBindings);
	    };
	    return OmniboxHierarchicalValueElement;
	}(OmniboxValueElement_1.OmniboxValueElement));
	exports.OmniboxHierarchicalValueElement = OmniboxHierarchicalValueElement;


/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	/// <reference path="HierarchicalFacet.ts" />
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var FacetValueElement_1 = __webpack_require__(145);
	var HierarchicalFacetValueElement = (function (_super) {
	    __extends(HierarchicalFacetValueElement, _super);
	    function HierarchicalFacetValueElement(facet, facetValue, keepDisplayedValueNextTime) {
	        _super.call(this, facet, facetValue, keepDisplayedValueNextTime);
	        this.facet = facet;
	        this.facetValue = facetValue;
	        this.keepDisplayedValueNextTime = keepDisplayedValueNextTime;
	    }
	    return HierarchicalFacetValueElement;
	}(FacetValueElement_1.FacetValueElement));
	exports.HierarchicalFacetValueElement = HierarchicalFacetValueElement;


/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var Cell_1 = __webpack_require__(200);
	var DefaultMatrixResultPreviewTemplate_1 = __webpack_require__(201);
	var Dom_1 = __webpack_require__(57);
	var QueryEvents_1 = __webpack_require__(47);
	var QueryStateModel_1 = __webpack_require__(90);
	var Utils_1 = __webpack_require__(18);
	var Initialization_1 = __webpack_require__(95);
	var QueryUtils_1 = __webpack_require__(23);
	var Globalize = __webpack_require__(4);
	/**
	 * This component uses the values of two fields (row and column) to display the results of the specified computed field in a table.<br/>
	 * The values to use for the columns are specified by the user while those for the rows are obtained by a `groupBy` operation performed at the same time as the main query (see {@link IGroupByRequest}).<br/>
	 * Like a {@link Facet}, selecting a cell allows the user to drill down inside results by restricting the row field and the column field to match the values of the selected cell.
	 */
	var Matrix = (function (_super) {
	    __extends(Matrix, _super);
	    /**
	     * Create a new matrix, check if the options are valid and makes sense. Bind query events.
	     * @param element
	     * @param options
	     * @param bindings
	     */
	    function Matrix(element, options, bindings) {
	        _super.call(this, element, Matrix.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.groupByIndex = [];
	        this.rowId = '';
	        this.columnId = '';
	        /**
	         * The currently selected row value, or undefined if nothing is selected.
	         */
	        this.selectedRowValue = undefined;
	        /**
	         * The currently selected column value, or undefined if nothing is selected.
	         */
	        this.selectedColumnValue = undefined;
	        this.numberOfRows = 0;
	        this.numberOfColumns = 0;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, Matrix, options);
	        if (!this.options.previewTemplate) {
	            this.options.previewTemplate = new DefaultMatrixResultPreviewTemplate_1.DefaultMatrixResultPreviewTemplate(this.options.computedField, this.options.computedFieldFormat);
	        }
	        if (!this.options.previewSortField) {
	            this.options.previewSortField = this.options.computedField;
	        }
	        if (this.options.columnFieldValues.length != this.options.columnLabels.length) {
	            this.options.columnLabels = this.options.columnFieldValues;
	        }
	        this.buildMatrix();
	        if (this.options.rowField == null) {
	            this.logger.error('\'rowField\' option is required in the Matrix component');
	        }
	        else if (this.options.columnField == null) {
	            this.logger.error('\'columnField\' option is required in the Matrix component');
	        }
	        else if (this.options.computedField == null) {
	            this.logger.error('\'computedField\' option is required in the Matrix component');
	        }
	        else {
	            this.bindEvents();
	            this.initQueryState();
	        }
	    }
	    /**
	     * Select a cell by its row and column number. Does not execute a query.
	     * @param rowNumber
	     * @param columnNumber
	     */
	    Matrix.prototype.selectCell = function (rowNumber, columnNumber) {
	        var rowValue, columnValue;
	        if (rowNumber !== 0 && rowNumber !== this.numberOfRows - 1) {
	            rowValue = this.getRowValue(rowNumber);
	        }
	        if (columnNumber !== 0 && columnNumber !== this.numberOfColumns - 1) {
	            columnValue = this.getColumnValue(columnNumber);
	        }
	        if (rowValue && this.isRowFacetPresent()) {
	            this.queryStateModel.set(this.rowId, [rowValue]);
	        }
	        else {
	            this.selectedRowValue = rowValue;
	            this.queryStateModel.set(this.rowId, []);
	        }
	        if (columnValue && this.isColumnFacetPresent()) {
	            this.queryStateModel.set(this.columnId, [columnValue]);
	        }
	        else {
	            this.selectedColumnValue = columnValue;
	            this.queryStateModel.set(this.columnId, []);
	        }
	    };
	    /**
	     * Return the currently selected column value.
	     */
	    Matrix.prototype.getSelectedColumnValue = function () {
	        return this.selectedColumnValue;
	    };
	    /**
	     * Return the currently selected row value.
	     */
	    Matrix.prototype.getSelectedRowValue = function () {
	        return this.selectedRowValue;
	    };
	    /**
	     * Get the HTMLElement associated to the desired cell.
	     * @param rowNumber
	     * @param columnNumber
	     * @returns {HTMLElement}
	     */
	    Matrix.prototype.getCellElement = function (rowNumber, columnNumber) {
	        return this.data[rowNumber][columnNumber].getHTML();
	    };
	    /**
	     * Get the string associated to the desired cell.
	     * @param rowNumber
	     * @param columnNumber
	     * @returns {string}
	     */
	    Matrix.prototype.getCellValue = function (rowNumber, columnNumber) {
	        var cell = this.getCellElement(rowNumber, columnNumber);
	        return Dom_1.$$(cell).text();
	    };
	    Matrix.prototype.drawMatrix = function () {
	        var _this = this;
	        var headerRow = Dom_1.$$('div', {
	            className: 'coveo-matrix-row matrix-header-row'
	        });
	        this.drawRow(headerRow.el, 0);
	        var numberOfRowsToDraw = this.options.enableColumnTotals ? this.numberOfRows - 1 : this.numberOfRows;
	        for (var i = 1; i < numberOfRowsToDraw; i++) {
	            var row = Dom_1.$$('div', {
	                className: 'coveo-matrix-row'
	            }).el;
	            this.drawRow(row, i);
	        }
	        if (this.options.enableColumnTotals) {
	            var totalRow = Dom_1.$$('div', {
	                className: 'coveo-matrix-row matrix-total-row'
	            }).el;
	            this.drawRow(totalRow, this.numberOfRows - 1);
	        }
	        if (this.options.cellFontSize !== '') {
	            var cells = Dom_1.$$(this.element).findAll('.coveo-matrix-cell');
	            _.each(cells, function (c) {
	                c.style.fontSize = _this.options.cellFontSize;
	            });
	        }
	    };
	    Matrix.prototype.bindEvents = function () {
	        var _this = this;
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.buildingQuery, function (args) { return _this.handleBuildingQuery(args); });
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.doneBuildingQuery, function (args) { return _this.handleDoneBuildingQuery(args); });
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.deferredQuerySuccess, function (args) { return _this.handleDeferredQuerySuccess(args); });
	    };
	    Matrix.prototype.initQueryState = function () {
	        this.rowId = QueryStateModel_1.QueryStateModel.getFacetId(this.options.rowField);
	        this.columnId = QueryStateModel_1.QueryStateModel.getFacetId(this.options.columnField);
	        this.queryStateModel.registerNewAttribute(this.rowId, []);
	        this.queryStateModel.registerNewAttribute(this.columnId, []);
	    };
	    Matrix.prototype.buildMatrix = function () {
	        this.buildTitle();
	        this.buildBody();
	        this.data = new Array();
	        this.addHeaderRow();
	    };
	    Matrix.prototype.buildTitle = function () {
	        var title = this.options.title ? this.options.title : '';
	        var titleHtml = Dom_1.$$('div', {
	            className: 'coveo-matrix-title'
	        }, title).el;
	        this.element.appendChild(titleHtml);
	    };
	    Matrix.prototype.buildBody = function () {
	        var body = Dom_1.$$('div', {
	            className: 'coveo-matrix'
	        }).el;
	        this.element.appendChild(body);
	    };
	    Matrix.prototype.handleBuildingQuery = function (args) {
	        if (!this.areFacetsPresent()) {
	            if (this.selectedRowValue && !this.isRowFacetPresent()) {
	                args.queryBuilder.advancedExpression.addFieldExpression(this.options.rowField, '=', [this.selectedRowValue]);
	            }
	            if (this.selectedColumnValue && !this.isColumnFacetPresent()) {
	                args.queryBuilder.advancedExpression.addFieldExpression(this.options.columnField, '=', [this.selectedColumnValue]);
	            }
	        }
	    };
	    Matrix.prototype.handleDoneBuildingQuery = function (args) {
	        this.groupByIndex = [];
	        this.addMainGroubByRequest(args.queryBuilder);
	        this.addColumnsGroupByRequests(args.queryBuilder);
	    };
	    Matrix.prototype.handleDeferredQuerySuccess = function (args) {
	        this.reset();
	        this.parseResults(args.results);
	        this.addTotals();
	        this.drawMatrix();
	        this.formatCells();
	        this.selectedRowValue = undefined;
	        this.selectedColumnValue = undefined;
	    };
	    Matrix.prototype.addMainGroubByRequest = function (queryBuilder) {
	        var groupBy = {
	            field: this.options.rowField,
	            sortCriteria: this.options.sortCriteria,
	            computedFields: this.getComputedFields(),
	            maximumNumberOfValues: this.options.maximumNumberOfRows
	        };
	        this.groupByIndex.push(queryBuilder.groupByRequests.length);
	        queryBuilder.groupByRequests.push(groupBy);
	    };
	    Matrix.prototype.addColumnsGroupByRequests = function (queryBuilder) {
	        for (var i = 0; i < this.options.columnFieldValues.length; i++) {
	            var groupBy = {
	                field: this.options.rowField,
	                sortCriteria: this.options.sortCriteria,
	                computedFields: this.getComputedFields(),
	                queryOverride: '(' + this.buildExpression(queryBuilder) + ')' + '(' + this.options.columnField + '=\'' + this.options.columnFieldValues[i] + '\')',
	                maximumNumberOfValues: this.options.maximumNumberOfValuesInGroupBy
	            };
	            this.groupByIndex.push(queryBuilder.groupByRequests.length);
	            queryBuilder.groupByRequests.push(groupBy);
	        }
	    };
	    Matrix.prototype.buildExpression = function (queryBuilder) {
	        var expression = queryBuilder.expression.build();
	        var advancedExpression = queryBuilder.advancedExpression.build();
	        var constantExpression = queryBuilder.constantExpression.build();
	        var totalQuery = '';
	        if (expression) {
	            totalQuery += ' ' + expression;
	        }
	        if (advancedExpression) {
	            totalQuery += ' ' + advancedExpression;
	        }
	        if (constantExpression) {
	            totalQuery += ' ' + constantExpression;
	        }
	        return totalQuery;
	    };
	    Matrix.prototype.getComputedFields = function () {
	        var computedFields = [{
	                field: this.options.computedField,
	                operation: this.options.computedFieldOperation
	            }];
	        return computedFields;
	    };
	    Matrix.prototype.getCellResult = function (results, rowNumber, columnNumber) {
	        var rowValue = this.getRowValue(rowNumber);
	        var columnValue = this.getColumnValue(columnNumber);
	        var cellResult = 0;
	        for (var i = 0; i < results.values.length; i++) {
	            if (results.values[i].value === rowValue) {
	                cellResult = results.values[i].computedFieldResults[0];
	                break;
	            }
	        }
	        if (this.isAColumnSelected() && !this.isColumnSelected(columnValue)) {
	            cellResult = 0;
	        }
	        return cellResult;
	    };
	    Matrix.prototype.addTotals = function () {
	        if (this.options.enableRowTotals) {
	            this.addRowTotals();
	        }
	        if (this.options.enableColumnTotals) {
	            this.addColumnTotals();
	        }
	    };
	    Matrix.prototype.addRowTotals = function () {
	        var _this = this;
	        this.addColumn();
	        this.setValue('Total', 0, this.numberOfColumns - 1);
	        for (var i = 1; i < this.numberOfRows; i++) {
	            var rowTotal = this.computeRowTotal(i);
	            this.setValue(rowTotal, i, this.numberOfColumns - 1);
	        }
	        // Fix sort ordering when not all columns field values are present.
	        if (this.options.sortCriteria.toLowerCase() == 'computedfielddescending') {
	            this.data.sort(function (a, b) {
	                return b[_this.numberOfColumns - 1].getValue() - a[_this.numberOfColumns - 1].getValue();
	            });
	        }
	        if (this.options.sortCriteria.toLowerCase() == 'computedfieldascending') {
	            this.data.sort(function (a, b) {
	                return a[_this.numberOfColumns - 1].getValue() - b[_this.numberOfColumns - 1].getValue();
	            });
	        }
	    };
	    Matrix.prototype.addColumnTotals = function () {
	        this.addRow();
	        this.setValue('Total', this.numberOfRows - 1, 0);
	        for (var i = 1; i < this.numberOfColumns; i++) {
	            var columnTotal = this.computeColumnTotal(i);
	            this.setValue(columnTotal, this.numberOfRows - 1, i);
	        }
	    };
	    Matrix.prototype.computeRowTotal = function (rowNumber) {
	        var total = 0;
	        for (var columnNumber = 1; columnNumber < this.numberOfColumns - 1; columnNumber++) {
	            total += parseInt(this.getCellValue(rowNumber, columnNumber));
	        }
	        return total;
	    };
	    Matrix.prototype.computeColumnTotal = function (columnNumber) {
	        var total = 0;
	        for (var rowNumber = 1; rowNumber < this.numberOfRows - 1; rowNumber++) {
	            total += parseInt(this.getCellValue(rowNumber, columnNumber));
	        }
	        return total;
	    };
	    Matrix.prototype.formatCells = function () {
	        for (var i = 1; i < this.numberOfRows; i++) {
	            for (var j = 1; j < this.numberOfColumns; j++) {
	                var cellValue = this.getCellValue(i, j);
	                cellValue = Globalize.format(parseInt(cellValue), this.options.computedFieldFormat);
	                this.setValue(cellValue, i, j);
	            }
	        }
	    };
	    Matrix.prototype.addHeaderRow = function () {
	        this.addRow();
	        this.addColumn();
	        this.setValue(this.options.columnHeader, 0, 0);
	        for (var i = 0; i < this.options.columnLabels.length; i++) {
	            this.addColumn();
	            this.setValue(this.options.columnLabels[i], 0, i + 1);
	        }
	    };
	    Matrix.prototype.addRow = function () {
	        this.data.push(new Array());
	        for (var i = 0; i < this.numberOfColumns; i++) {
	            this.addCellToRow(this.numberOfRows, i);
	        }
	        this.numberOfRows++;
	    };
	    Matrix.prototype.addColumn = function () {
	        for (var i = 0; i < this.numberOfRows; i++) {
	            this.addCellToRow(i, this.numberOfColumns);
	        }
	        this.numberOfColumns++;
	    };
	    Matrix.prototype.addCellToRow = function (rowNumber, columnNumber) {
	        var column = Dom_1.$$('div', {
	            className: 'coveo-matrix-cell'
	        });
	        if (columnNumber == 0) {
	            column.addClass('matrix-first-column');
	        }
	        this.data[rowNumber].push(new Cell_1.Cell(0, column.el));
	    };
	    Matrix.prototype.setValue = function (value, rowNumber, columnNumber) {
	        var cell = this.getCellElement(rowNumber, columnNumber);
	        if (!Utils_1.Utils.isNullOrUndefined(value)) {
	            Dom_1.$$(cell).text(value.toString());
	        }
	        if (this.isCellSelected(this.getRowValue(rowNumber), this.getColumnValue(columnNumber))) {
	            Dom_1.$$(cell).addClass('coveo-matrix-selected');
	        }
	        if (this.isAColumnSelected() && !this.isColumnSelected(this.getColumnValue(columnNumber))) {
	            if (columnNumber != 0 && rowNumber != 0) {
	                Dom_1.$$(cell).addClass('coveo-matrix-unimportant');
	            }
	        }
	        this.data[rowNumber][columnNumber].setValue(value);
	    };
	    Matrix.prototype.handleClick = function (rowNumber, columnNumber) {
	        this.selectCell(rowNumber, columnNumber);
	        this.queryController.executeQuery();
	    };
	    Matrix.prototype.getRowValue = function (rowNumber) {
	        return this.data[rowNumber][0].getValue();
	    };
	    Matrix.prototype.getColumnValue = function (columnNumber) {
	        return this.options.columnFieldValues[columnNumber - 1];
	    };
	    Matrix.prototype.isAColumnSelected = function () {
	        var selectedColumnValues = this.queryStateModel.get(this.columnId) || [];
	        return selectedColumnValues.length !== 0 || this.selectedColumnValue != undefined;
	    };
	    Matrix.prototype.isColumnSelected = function (columnValue) {
	        if (this.isAColumnSelected() && columnValue) {
	            var selectedColumnValues = this.queryStateModel.attributes[this.columnId] || [];
	            for (var i = 0; i < selectedColumnValues.length; i++) {
	                if (selectedColumnValues[i].toLowerCase() === columnValue.toLowerCase()) {
	                    return true;
	                }
	            }
	        }
	        return this.selectedColumnValue == columnValue;
	    };
	    Matrix.prototype.isARowSelected = function () {
	        var selectedRowValues = this.queryStateModel.get(this.rowId) || [];
	        return selectedRowValues.length !== 0 || this.selectedRowValue !== undefined;
	    };
	    Matrix.prototype.isRowSelected = function (rowValue) {
	        if (this.isARowSelected() && rowValue) {
	            var selectedRowValues = this.queryStateModel.get(this.rowId) || [];
	            for (var i = 0; i < selectedRowValues.length; i++) {
	                if (selectedRowValues[i].toLowerCase() === rowValue.toLowerCase()) {
	                    return true;
	                }
	            }
	        }
	        return this.selectedRowValue == rowValue;
	    };
	    Matrix.prototype.isCellSelected = function (rowValue, columnValue) {
	        if (this.isAColumnSelected() && this.isARowSelected()) {
	            return this.isRowSelected(rowValue) && this.isColumnSelected(columnValue);
	        }
	        else if (this.isAColumnSelected()) {
	            return this.isColumnSelected(columnValue);
	        }
	        return false;
	    };
	    Matrix.prototype.areFacetsPresent = function () {
	        return this.isRowFacetPresent() && this.isColumnFacetPresent();
	    };
	    Matrix.prototype.isRowFacetPresent = function () {
	        var facet = this.componentStateModel.get(this.rowId);
	        return facet && !facet[0].disabled;
	    };
	    Matrix.prototype.isColumnFacetPresent = function () {
	        var facet = this.componentStateModel.get(this.columnId);
	        return facet && !facet[0].disabled;
	    };
	    Matrix.prototype.reset = function () {
	        Dom_1.$$(this.element).empty();
	        this.numberOfRows = 0;
	        this.numberOfColumns = 0;
	        this.data = new Array();
	        this.buildMatrix();
	    };
	    Matrix.prototype.parseResults = function (results) {
	        if (results) {
	            var mainResults = results.groupByResults[this.groupByIndex[0]];
	            if (mainResults) {
	                for (var i = 0; i < mainResults.values.length; i++) {
	                    var value = mainResults.values[i].value;
	                    this.addRow();
	                    this.setValue(value, i + 1, 0);
	                }
	            }
	            for (var i = 1; i < this.numberOfRows; i++) {
	                for (var j = 1; j < this.numberOfColumns; j++) {
	                    var columnResult = results.groupByResults[this.groupByIndex[j]];
	                    var cellValue = this.getCellResult(columnResult, i, j);
	                    this.setValue(cellValue, i, j);
	                }
	            }
	        }
	    };
	    Matrix.prototype.drawRow = function (row, rowNumber) {
	        var _this = this;
	        var body = Dom_1.$$(this.element).find('.coveo-matrix');
	        var _loop_1 = function(i) {
	            var cell = this_1.data[rowNumber][i].getHTML();
	            Dom_1.$$(cell).on('click', function () {
	                var handler = function (num) {
	                    _this.handleClick(rowNumber, num);
	                };
	                handler(i);
	            });
	            if (this_1.options.enableHoverPreview) {
	                (function (num) {
	                    Dom_1.$$(cell).on('mouseover', function () { return _this.handleHoverIn(rowNumber, num); });
	                    Dom_1.$$(cell).on('mouseout', function () { return _this.handleHoverOut(rowNumber, num); });
	                })(i);
	            }
	            row.appendChild(cell);
	        };
	        var this_1 = this;
	        for (var i = 0; i < this.numberOfColumns; i++) {
	            _loop_1(i);
	        }
	        body.appendChild(row);
	    };
	    Matrix.prototype.handleHoverIn = function (rowNumber, columnNumber) {
	        var _this = this;
	        if (this.isHoverWorkingOnRow(rowNumber) && this.isHoverWorkingOnColumn(columnNumber)) {
	            this.previewTimeout = setTimeout(function () {
	                _this.displayResultsPreview(rowNumber, columnNumber);
	            }, this.options.previewDelay);
	        }
	    };
	    Matrix.prototype.handleHoverOut = function (rowNumber, columnNumber) {
	        clearTimeout(this.previewTimeout);
	        var cell = this.data[rowNumber][columnNumber];
	        cell.removePreview();
	    };
	    Matrix.prototype.displayResultsPreview = function (rowNumber, columnNumber) {
	        var _this = this;
	        var query = this.createPreviewQuery(rowNumber, columnNumber);
	        var cell = this.data[rowNumber][columnNumber];
	        cell.addPreview(this.options.previewMinWidth, this.options.previewMaxWidth);
	        var endpoint = this.queryController.getEndpoint();
	        endpoint.search(query).then(function (data) {
	            // During the time it take for the query to return, the matrix can change size depending
	            // on if another query was performed : Need to check for undefined before accessing the data
	            // we're trying to render;
	            if (!_this.isDataAvailable(rowNumber, columnNumber)) {
	                return;
	            }
	            var cell = _this.data[rowNumber][columnNumber];
	            var instantiatedResults = _.map(data.results, function (r) {
	                return _this.instantiateTemplate(r);
	            });
	            var html = '';
	            _.each(instantiatedResults, function (result) {
	                html += result.outerHTML;
	            });
	            cell.updatePreview(html);
	        });
	    };
	    Matrix.prototype.instantiateTemplate = function (result) {
	        var content = this.options.previewTemplate.instantiateToElement(result, false);
	        var initParameters = {
	            options: this.options,
	            bindings: this.getBindings(),
	            result: result
	        };
	        Initialization_1.Initialization.automaticallyCreateComponentsInside(content, initParameters);
	        return content;
	    };
	    Matrix.prototype.createPreviewQuery = function (rowNumber, columnNumber) {
	        var rowFieldExpression = '(' + QueryUtils_1.QueryUtils.buildFieldExpression(this.options.rowField, '=', [this.getRowValue(rowNumber)]) + ')';
	        var columnFieldExpression = '(' + QueryUtils_1.QueryUtils.buildFieldExpression(this.options.columnField, '=', [this.getColumnValue(columnNumber)]) + ')';
	        var query = this.queryController.getLastQuery();
	        query.aq = rowFieldExpression;
	        query.aq += columnFieldExpression;
	        query.sortCriteria = this.options.previewSortCriteria;
	        query.sortField = this.options.previewSortField;
	        var fieldSliced = this.options.computedField.slice(1);
	        var fieldExists = _.find(query.fieldsToInclude, function (field) {
	            return field == fieldSliced;
	        });
	        if (!fieldExists) {
	            query.fieldsToInclude.push(fieldSliced);
	        }
	        return query;
	    };
	    Matrix.prototype.isHoverWorkingOnRow = function (rowNumber) {
	        if (this.options.enableColumnTotals) {
	            return rowNumber !== 0 && rowNumber !== this.numberOfRows - 1;
	        }
	        return rowNumber !== 0;
	    };
	    Matrix.prototype.isHoverWorkingOnColumn = function (columnNumber) {
	        if (this.options.enableRowTotals) {
	            return columnNumber !== 0 && columnNumber !== this.numberOfColumns - 1;
	        }
	        return columnNumber !== 0;
	    };
	    Matrix.prototype.isDataAvailable = function (row, column) {
	        return this.data[row] !== undefined && this.data[row][column] !== undefined;
	    };
	    Matrix.ID = 'Matrix';
	    /**
	     * The possible options for the component
	     * @componentOptions
	     */
	    Matrix.options = {
	        /**
	         * Specifies the text to display at the top of the matrix.
	         */
	        title: ComponentOptions_1.ComponentOptions.buildStringOption(),
	        /**
	         * Specifies the field to use for the rows.<br/>
	         * Required options, otherwise the component will not work.
	         */
	        rowField: ComponentOptions_1.ComponentOptions.buildFieldOption({ required: true }),
	        /**
	         * Specifies the field to use for the columns.<br/>
	         * Required options, otherwise the component will not work.
	         */
	        columnField: ComponentOptions_1.ComponentOptions.buildFieldOption({ required: true }),
	        /**
	         * Specifies the criteria used to sort the rows. The available sort criteria are the same as those for the Group By parameter (see Group By Parameters - sortCriteria).<br/>
	         * The default value is 'ComputedFieldDescending'.
	         */
	        sortCriteria: ComponentOptions_1.ComponentOptions.buildStringOption({ defaultValue: 'ComputedFieldDescending' }),
	        /**
	         * Specifies the maximum number of rows to display in the matrix.<br/>
	         * The default value is 10.
	         */
	        maximumNumberOfRows: ComponentOptions_1.ComponentOptions.buildNumberOption({ defaultValue: 10, min: 0 }),
	        /**
	         * Specifies whether to add a total column which contains the total for each row.<br/>
	         * The default value is `true`.
	         */
	        enableRowTotals: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true }),
	        /**
	         * Specifies the field values to use for each column.<br/>
	         * If not specified, you will not generate any column except one for the 'Total' column.
	         */
	        columnFieldValues: ComponentOptions_1.ComponentOptions.buildListOption({ defaultValue: [] }),
	        /**
	         * Specifies the labels values to use for each column.<br/>
	         * The array should match the {@link Matrix.options.columnFieldValues}.
	         */
	        columnLabels: ComponentOptions_1.ComponentOptions.buildListOption({ defaultValue: [] }),
	        /**
	         * Specifies the label for the first column on the left, as a description of the `columnField`.
	         */
	        columnHeader: ComponentOptions_1.ComponentOptions.buildStringOption(),
	        /**
	         * Specifies the maximum number of results to include in the group by requests for the columns.<br/>
	         * This value should always be greater than {@link Matrix.options.maximumNumberOfRows}. If it is too small, some results will not be displayed in the matrix.<br/>
	         * The default value is 100.
	         */
	        maximumNumberOfValuesInGroupBy: ComponentOptions_1.ComponentOptions.buildNumberOption({ defaultValue: 100, min: 0 }),
	        /**
	         * Specifies whether to add a total row which contains the total for each column.<br/>
	         * The default value is `true`.
	         */
	        enableColumnTotals: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true }),
	        /**
	         * Specifies the field whose computed values are displayed in the cells.
	         */
	        computedField: ComponentOptions_1.ComponentOptions.buildFieldOption({ required: true }),
	        /**
	         * Specifies the type of aggregate operation to use on the computed field.<br/>
	         * The available values are the same as those for the {@link Facet.options.computedFieldOperation}.<br/>
	         * The available values are:
	         * <ul>
	         *   <li>sum - Computes the sum of the computed field values.</li>
	         *   <li>average - Computes the average of the computed field values.</li>
	         *   <li>minimum - Finds the minimum value of the computed field values.</li>
	         *   <li>maximum - Finds the maximum value of the computed field values.</li>
	         * </ul>
	         * The default value is `sum`.
	         */
	        computedFieldOperation: ComponentOptions_1.ComponentOptions.buildStringOption({ defaultValue: 'sum' }),
	        /**
	         * Specifies how to format the values resulting from a computed field operation.<br/>
	         * The available formats are the same as those for the {@link Facet.options.computedFieldFormat}.<br/>
	         * The formats available are defined by the Globalize library. The most common used formats are:
	         * <ul>
	         *   <li>c0 - Formats the value as a currency.</li>
	         *   <li>n0 - Formats the value as an integer.</li>
	         *   <li>n2 - Formats the value as a floating point with 2 decimal digits.</li>
	         * </ul>
	         * The default value is c0.
	         */
	        computedFieldFormat: ComponentOptions_1.ComponentOptions.buildStringOption({ defaultValue: 'c0' }),
	        /**
	         * Specifies the font-size of the cells.<br/>
	         * This option is mainly used to reduce the cell font-size when some values are cropped because there are too many columns in the matrix.<br/>
	         * Other options to fix this problem are to remove less important columns or modify the CSS to give more place to the matrix.
	         */
	        cellFontSize: ComponentOptions_1.ComponentOptions.buildStringOption({ defaultValue: '' }),
	        /**
	         * Specifies whether to show a preview popup of cell results on hover. The default value is `true`.
	         */
	        enableHoverPreview: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true }),
	        /**
	         * Specifies the criteria to use to sort the results of the hover preview.<br/>
	         * The available sort criteria values are the same as those of the {@link IQuery}.
	         * Possible values are :
	         * <ul>
	         *    <li> relevancy :  This uses all the configured ranking weights as well as any specified ranking expressions to rank results.</li>
	         *    <li> dateascending / datedescending : Sort using the value of the @date field, which is typically the last modification date of an item in the index.</li>
	         *    <li> qre : Sort using only the weights applied through ranking expressions. This is much like using Relevancy except that automatic weights based on keyword proximity etc., are not computed.<li/>
	         *    <li> nosort : Do not sort the results. The order in which items are returned is essentially random.</li>
	         *    <li> fieldascending / fielddescending : Sort using the value of a custom field.</li>
	         * </ul>
	         * The default value is 'FieldDescending'.
	         */
	        previewSortCriteria: ComponentOptions_1.ComponentOptions.buildStringOption({ defaultValue: 'FieldDescending' }),
	        /**
	         * Specifies the field to use when the previewSortCriteria option is FieldDescending or FieldAscending.<br/>
	         * By default, the value of the computedField option is used.
	         */
	        previewSortField: ComponentOptions_1.ComponentOptions.buildFieldOption(),
	        /**
	         * Specifies the maximum width of the preview pop-up.<br/>
	         * The default value is 500px.
	         */
	        previewMaxWidth: ComponentOptions_1.ComponentOptions.buildStringOption({ defaultValue: '500px' }),
	        /**
	         * Specifies the minimum width of the preview pop-up.<br/>
	         * The default value is 0.
	         */
	        previewMinWidth: ComponentOptions_1.ComponentOptions.buildStringOption({ defaultValue: '0' }),
	        /**
	         * Specifies the delay (in milliseconds) before the query used to get the preview results is sent.<br/>
	         * The default value is 500.
	         */
	        previewDelay: ComponentOptions_1.ComponentOptions.buildNumberOption({ defaultValue: 500 }),
	        /**
	         * Specifies the ID or CSS selector of the template to use to render the results of the hover preview.<br/>
	         * Eg : <code>data-template-id='TemplateId'</code> , <code>data-template-selector='.templateSelector'</code><br/>
	         *
	         */
	        previewTemplate: ComponentOptions_1.ComponentOptions.buildTemplateOption()
	    };
	    return Matrix;
	}(Component_1.Component));
	exports.Matrix = Matrix;
	Initialization_1.Initialization.registerAutoCreateComponent(Matrix);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var Dom_1 = __webpack_require__(57);
	/**
	 * Represent a single cell of data in the {@link Matrix} component.
	 */
	var Cell = (function () {
	    function Cell(value, el) {
	        if (value === void 0) { value = 0; }
	        this.previewActive = false;
	        this.element = el;
	        this.value = value;
	    }
	    /**
	     * Return the value of the cell.
	     * @returns {any}
	     */
	    Cell.prototype.getValue = function () {
	        return this.value;
	    };
	    /**
	     * Return the `HTMLElement` for the cell.
	     * @returns {HTMLElement}
	     */
	    Cell.prototype.getHTML = function () {
	        return this.element;
	    };
	    /**
	     * Set the value if the cell.
	     * @param value
	     */
	    Cell.prototype.setValue = function (value) {
	        this.value = value;
	    };
	    /**
	     * Set the `HTMLElement` for the cell.
	     * @param html
	     */
	    Cell.prototype.setHTML = function (html) {
	        this.element = html;
	    };
	    /**
	     * Show the preview of the cell.
	     * @param minWidth css minWidth property : eg 100px
	     * @param maxWidth css maxWidth property : eg 100px
	     */
	    Cell.prototype.addPreview = function (minWidth, maxWidth) {
	        this.previewActive = true;
	        var previewContainer = Dom_1.$$('div', {
	            className: 'matrix-results-preview-container'
	        });
	        previewContainer.el.style.minWidth = minWidth;
	        previewContainer.el.style.maxWidth = maxWidth;
	        previewContainer.on('click', function (e) {
	            e.stopPropagation();
	        });
	        this.element.appendChild(previewContainer.el);
	        var container = Dom_1.$$(this.element).findAll('.matrix-results-preview-container');
	        _.each(container, function (c) {
	            Dom_1.$$(c).hide();
	        });
	    };
	    /**
	     * Remove the preview of the cell
	     */
	    Cell.prototype.removePreview = function () {
	        this.previewActive = false;
	        var container = Dom_1.$$(this.element).find('.matrix-results-preview-container');
	        if (container) {
	            Dom_1.$$(container).detach();
	        }
	    };
	    /**
	     * Update the preview with a new template
	     * @param template
	     */
	    Cell.prototype.updatePreview = function (template) {
	        if (this.previewActive) {
	            var preview = Dom_1.$$(this.element).find('.matrix-results-preview-container');
	            preview.innerHTML += template;
	            Dom_1.$$(preview).show();
	        }
	    };
	    return Cell;
	}());
	exports.Cell = Cell;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Template_1 = __webpack_require__(100);
	var Dom_1 = __webpack_require__(57);
	var Globalize = __webpack_require__(4);
	var DefaultMatrixResultPreviewTemplate = (function (_super) {
	    __extends(DefaultMatrixResultPreviewTemplate, _super);
	    function DefaultMatrixResultPreviewTemplate(computedField, format) {
	        _super.call(this);
	        this.computedField = computedField;
	        this.format = format;
	    }
	    DefaultMatrixResultPreviewTemplate.prototype.instantiateToString = function (object, checkCondition) {
	        var preview = '<div class=\'coveo-result-frame\'>' +
	            '<div class=\'coveo-result-row\'>' +
	            '<div class=\'coveo-result-cell\' style=\'width: 40px; padding-right:5px;vertical-align: middle\'>' +
	            '<a class=\'CoveoIcon\' data-small=\'true\'></a>' +
	            '</div>' +
	            '<div class=\'coveo-result-cell\' style=\'font-size:13px;vertical-align: middle\'>' +
	            '<a class=\'CoveoResultLink\'></a>' +
	            '</div>' +
	            '<div class=\'coveo-result-cell\' style=\'width:80px; text-align:right; font-size:13px; padding-right: 5px;vertical-align: middle\'>' +
	            Globalize.format(parseInt(object.raw[this.computedField.slice(1)]), this.format) +
	            '</div>' +
	            '</div>' +
	            '</div>';
	        return preview;
	    };
	    DefaultMatrixResultPreviewTemplate.prototype.instantiateToElement = function (object, checkCondition) {
	        return Dom_1.$$('div', undefined, this.instantiateToString(object)).el;
	    };
	    return DefaultMatrixResultPreviewTemplate;
	}(Template_1.Template));
	exports.DefaultMatrixResultPreviewTemplate = DefaultMatrixResultPreviewTemplate;


/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var ResultLink_1 = __webpack_require__(178);
	var Initialization_1 = __webpack_require__(95);
	var DomUtils_1 = __webpack_require__(59);
	var Dom_1 = __webpack_require__(57);
	var ExternalModulesShim_1 = __webpack_require__(25);
	var YouTubeThumbnail = (function (_super) {
	    __extends(YouTubeThumbnail, _super);
	    function YouTubeThumbnail(element, options, bindings, result) {
	        var _this = this;
	        _super.call(this, element, YouTubeThumbnail.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.bindings = bindings;
	        this.result = result;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, YouTubeThumbnail, options);
	        var resultLink = Dom_1.$$('a');
	        resultLink.addClass(Component_1.Component.computeCssClassName(ResultLink_1.ResultLink));
	        var thumbnailDiv = Dom_1.$$('div');
	        thumbnailDiv.addClass('coveo-youtube-thumbnail-container');
	        resultLink.append(thumbnailDiv.el);
	        var img = Dom_1.$$('img');
	        img.el.style.width = this.options.width;
	        img.el.style.height = this.options.height;
	        img.setAttribute('src', result.raw['ytthumbnailurl']);
	        img.addClass('coveo-youtube-thumbnail-img');
	        thumbnailDiv.append(img.el);
	        var span = Dom_1.$$('span');
	        span.addClass('coveo-youtube-thumbnail-play-button');
	        thumbnailDiv.append(span.el);
	        Dom_1.$$(this.element).append(resultLink.el);
	        if (this.options.embed) {
	            this.options = _.extend(this.options, {
	                onClick: function () { return _this.handleOnClick(); }
	            });
	        }
	        var initOptions = this.searchInterface.options.originalOptionsObject;
	        var resultComponentBindings = _.extend({}, this.getBindings(), {
	            resultElement: element
	        });
	        var initParameters = {
	            options: _.extend({}, { initOptions: { ResultLink: options } }, initOptions),
	            bindings: resultComponentBindings,
	            result: result
	        };
	        Initialization_1.Initialization.automaticallyCreateComponentsInside(element, initParameters);
	    }
	    YouTubeThumbnail.prototype.handleOnClick = function () {
	        var _this = this;
	        // need to put iframe inside div : iframe with position absolute and left:0, right : 0 , bottom: 0 is not standard/supported
	        var iframe = Dom_1.$$('iframe'), div = Dom_1.$$('div');
	        iframe.setAttribute('src', 'https://www.youtube.com/embed/' + this.extractVideoId() + '?autoplay=1');
	        iframe.setAttribute('allowfullscreen', 'allowfullscreen');
	        iframe.setAttribute('webkitallowfullscreen', 'webkitallowfullscreen');
	        iframe.setAttribute('width', '100%');
	        iframe.setAttribute('height', '100%');
	        div.append(iframe.el);
	        this.modalbox = ExternalModulesShim_1.ModalBox.open(div.el, {
	            overlayClose: true,
	            title: DomUtils_1.DomUtils.getQuickviewHeader(this.result, { showDate: true, title: this.result.title }, this.bindings).el.outerHTML,
	            className: 'coveo-quick-view coveo-youtube-player',
	            validation: function () { return true; },
	            body: this.element.ownerDocument.body
	        });
	        Dom_1.$$(Dom_1.$$(this.modalbox.wrapper).find('.coveo-quickview-close-button')).on('click', function () {
	            _this.modalbox.close();
	        });
	    };
	    YouTubeThumbnail.prototype.extractVideoId = function () {
	        return this.result.clickUri.split('watch?v=')[1];
	    };
	    YouTubeThumbnail.ID = 'YouTubeThumbnail';
	    YouTubeThumbnail.options = {
	        width: ComponentOptions_1.ComponentOptions.buildStringOption({ defaultValue: '200px' }),
	        height: ComponentOptions_1.ComponentOptions.buildStringOption({ defaultValue: '112px' }),
	        embed: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true })
	    };
	    YouTubeThumbnail.fields = [
	        'ytthumbnailurl'
	    ];
	    return YouTubeThumbnail;
	}(Component_1.Component));
	exports.YouTubeThumbnail = YouTubeThumbnail;
	Initialization_1.Initialization.registerAutoCreateComponent(YouTubeThumbnail);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var DefaultResultAttachmentTemplate_1 = __webpack_require__(204);
	var Utils_1 = __webpack_require__(18);
	var QueryUtils_1 = __webpack_require__(23);
	var Initialization_1 = __webpack_require__(95);
	var Assert_1 = __webpack_require__(17);
	var Dom_1 = __webpack_require__(57);
	/**
	 * This component is used to render attachments in a result set, for example when displaying emails.<br/>
	 * It is intended to be used inside a result template when there is an active {@link Folding} component
	 * inside the page.
	 */
	var ResultAttachments = (function (_super) {
	    __extends(ResultAttachments, _super);
	    /**
	     * Build a new ResultAttachments component
	     * @param element
	     * @param options
	     * @param bindings
	     * @param result
	     * @param attachmentLevel
	     */
	    function ResultAttachments(element, options, bindings, result, attachmentLevel) {
	        if (attachmentLevel === void 0) { attachmentLevel = 0; }
	        _super.call(this, element, ResultAttachments.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.bindings = bindings;
	        this.attachmentLevel = attachmentLevel;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, ResultAttachments, options);
	        this.attachments = result.attachments;
	        if (Utils_1.Utils.isNonEmptyArray(this.attachments)) {
	            this.renderAttachments();
	        }
	    }
	    ResultAttachments.prototype.renderAttachments = function () {
	        var _this = this;
	        _.each(this.attachments, function (attachment) {
	            QueryUtils_1.QueryUtils.setStateObjectOnQueryResult(_this.queryStateModel.get(), attachment);
	            var container = _this.attachmentLevel > 0 ? _this.options.subResultTemplate.instantiateToElement(attachment) : _this.options.resultTemplate.instantiateToElement(attachment);
	            _this.autoCreateComponentsInsideResult(container, _.extend({}, attachment, { attachments: [] }));
	            Dom_1.$$(container).addClass('coveo-result-attachments-container');
	            _this.element.appendChild(container);
	            if (_this.attachmentHasSubAttachment(attachment) && _this.attachmentLevel < _this.options.maximumAttachmentLevel) {
	                var childAttachmentContainer = Dom_1.$$('div').el;
	                container.appendChild(childAttachmentContainer);
	                new ResultAttachments(childAttachmentContainer, _this.options, _this.bindings, attachment, _this.attachmentLevel + 1);
	            }
	        });
	    };
	    ResultAttachments.prototype.attachmentHasSubAttachment = function (attachment) {
	        if (Utils_1.Utils.isNonEmptyArray(attachment.attachments)) {
	            return true;
	        }
	        else if (Utils_1.Utils.isNonEmptyArray(attachment.childResults)) {
	            attachment.attachments = attachment.childResults;
	            return true;
	        }
	        else {
	            return false;
	        }
	    };
	    ResultAttachments.prototype.autoCreateComponentsInsideResult = function (element, result) {
	        Assert_1.Assert.exists(element);
	        var initOptions = this.searchInterface.options;
	        var initParameters = {
	            options: initOptions,
	            bindings: this.getBindings(),
	            result: result
	        };
	        Initialization_1.Initialization.automaticallyCreateComponentsInside(element, initParameters, [ResultAttachments.ID]);
	    };
	    ResultAttachments.ID = 'ResultAttachments';
	    /**
	     * The options for the component
	     * @componentOptions
	     */
	    ResultAttachments.options = {
	        /**
	         * Specifies the template to use to render each of the attachments for a top result.<br/>
	         * By default, it will use the template specified in a child element with a `<script>` tag.<br/>
	         * This can be specified directly as an attribute to the element, for example :
	         * ```html
	         * <div class="CoveoResultFolding" data-result-template-id="Foo"></div>
	         * ```
	         * which will use a previously registered template ID (see {@link TemplateCache})
	         */
	        resultTemplate: ComponentOptions_1.ComponentOptions.buildTemplateOption({ defaultFunction: function (e) { return new DefaultResultAttachmentTemplate_1.DefaultResultAttachmentTemplate(); } }),
	        /**
	         * Specifies the template to use to render sub-attachments, which are attachments within other attachments,
	         * for example multiple files embedded in a .zip attachment.<br/>
	         * Sub-attachments can also contain other sub-attachments.<br/>
	         * The template can be specified the same way as {@link ResultAttachments.options.resultTemplate resultTemplate}
	         */
	        subResultTemplate: ComponentOptions_1.ComponentOptions.buildTemplateOption({ postProcessing: function (value, options) { return value != null ? value : options.resultTemplate; } }),
	        /**
	         * Specifies the maximum nesting depth at which the component should stop rendering sub-attachments.<br/>
	         * The default value is 5.
	         */
	        maximumAttachmentLevel: ComponentOptions_1.ComponentOptions.buildNumberOption({ defaultValue: 5, min: 0 })
	    };
	    return ResultAttachments;
	}(Component_1.Component));
	exports.ResultAttachments = ResultAttachments;
	Initialization_1.Initialization.registerAutoCreateComponent(ResultAttachments);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Template_1 = __webpack_require__(100);
	var DefaultResultAttachmentTemplate = (function (_super) {
	    __extends(DefaultResultAttachmentTemplate, _super);
	    function DefaultResultAttachmentTemplate() {
	        _super.call(this);
	    }
	    DefaultResultAttachmentTemplate.prototype.instantiateToString = function (queryResult) {
	        return '<div><span class="CoveoIcon"></span> <a class="CoveoResultLink"></a> <span class="CoveoQuickview"></span></div>';
	    };
	    return DefaultResultAttachmentTemplate;
	}(Template_1.Template));
	exports.DefaultResultAttachmentTemplate = DefaultResultAttachmentTemplate;


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var DefaultFoldingTemplate_1 = __webpack_require__(206);
	var Utils_1 = __webpack_require__(18);
	var QueryUtils_1 = __webpack_require__(23);
	var Initialization_1 = __webpack_require__(95);
	var Assert_1 = __webpack_require__(17);
	var Dom_1 = __webpack_require__(57);
	var Strings_1 = __webpack_require__(34);
	/**
	 * This component is used to render folded result sets. It is intended to be used inside a
	 * <a href='https://developers.coveo.com/display/public/JsSearchV1/Result+Templates'>Result Template</a>
	 * when there is an active {@link Folding} component on the page. This component takes care of rendering
	 * the parent result and its child results in a coherent manner.
	 */
	var ResultFolding = (function (_super) {
	    __extends(ResultFolding, _super);
	    function ResultFolding(element, options, bindings, result) {
	        _super.call(this, element, ResultFolding.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.result = result;
	        this.showingMoreResults = false;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(this.element, ResultFolding, options);
	        Assert_1.Assert.exists(result);
	        this.buildElements();
	        this.displayThoseResults(this.result.childResults);
	        this.updateElementVisibility();
	        if (this.result.childResults.length == 0 && !this.result.moreResults) {
	            Dom_1.$$(this.element).hide();
	        }
	    }
	    ResultFolding.prototype.showMoreResults = function () {
	        var _this = this;
	        Assert_1.Assert.exists(this.result.moreResults);
	        this.cancelAnyPendingShowMore();
	        this.moreResultsPromise = this.result.moreResults();
	        this.waitAnimation = Dom_1.$$('div', { className: 'coveo-loading-spinner' }).el;
	        this.results.appendChild(this.waitAnimation);
	        this.updateElementVisibility();
	        this.moreResultsPromise
	            .then(function (results) {
	            _this.childResults = results;
	            _this.showingMoreResults = true;
	            _this.displayThoseResults(results);
	            _this.updateElementVisibility(results.length);
	            return results;
	        })
	            .finally(function (results) {
	            _this.moreResultsPromise = undefined;
	            Dom_1.$$(_this.waitAnimation).detach();
	            _this.waitAnimation = undefined;
	        });
	    };
	    ResultFolding.prototype.showLessResults = function () {
	        this.cancelAnyPendingShowMore();
	        this.showingMoreResults = false;
	        this.displayThoseResults(this.result.childResults);
	        this.updateElementVisibility();
	        this.scrollToResultElement();
	    };
	    ResultFolding.prototype.buildElements = function () {
	        this.buildHeader();
	        this.buildResults();
	        this.buildFooter();
	    };
	    ResultFolding.prototype.buildHeader = function () {
	        var header = Dom_1.$$('div', { className: 'coveo-folding-header' }).el;
	        this.element.appendChild(header);
	        if (this.options.normalCaption != undefined && this.options.expandedCaption != undefined) {
	            this.normalCaption = Dom_1.$$('div', { className: 'coveo-folding-normal-caption' }, this.options.normalCaption).el;
	            header.appendChild(this.normalCaption);
	            this.expandedCaption = Dom_1.$$('div', { className: 'coveo-folding-expanded-caption' }, this.options.expandedCaption).el;
	            header.appendChild(this.expandedCaption);
	        }
	        this.oneResultCaption = Dom_1.$$('div', { className: 'coveo-folding-oneresult-caption' }, this.options.oneResultCaption).el;
	        header.appendChild(this.oneResultCaption);
	    };
	    ResultFolding.prototype.buildResults = function () {
	        this.results = Dom_1.$$('div', { className: 'coveo-folding-results' }).el;
	        this.element.appendChild(this.results);
	    };
	    ResultFolding.prototype.buildFooter = function () {
	        var _this = this;
	        var footer = Dom_1.$$('div', { className: 'coveo-folding-footer' }).el;
	        this.element.parentElement.appendChild(footer);
	        if (this.result.moreResults) {
	            this.showMore = Dom_1.$$('div', { className: 'coveo-folding-footer-section-for-less' }).el;
	            Dom_1.$$(this.showMore).on('click', function () { return _this.showMoreResults(); });
	            footer.appendChild(this.showMore);
	            this.showLess = Dom_1.$$('div', { className: 'coveo-folding-footer-section-for-more' }).el;
	            Dom_1.$$(this.showLess).on('click', function () { return _this.showLessResults(); });
	            footer.appendChild(this.showLess);
	            var footerIconShowMore = Dom_1.$$('div', { className: 'coveo-more' }, Dom_1.$$('span', { className: 'coveo-folding-footer-icon' }).el).el;
	            var footerIconShowLess = Dom_1.$$('div', { className: 'coveo-less' }, Dom_1.$$('span', { className: 'coveo-folding-footer-icon' }).el).el;
	            var showMoreLink = Dom_1.$$('a', { className: 'coveo-folding-show-more' }, this.options.moreCaption).el;
	            var showLessLink = Dom_1.$$('a', { className: 'coveo-folding-show-less' }, this.options.lessCaption).el;
	            this.showMore.appendChild(showMoreLink);
	            this.showLess.appendChild(showLessLink);
	            this.showMore.appendChild(footerIconShowMore);
	            this.showLess.appendChild(footerIconShowLess);
	        }
	    };
	    ResultFolding.prototype.updateElementVisibility = function (subResultsLength) {
	        if (this.normalCaption) {
	            Dom_1.$$(this.normalCaption).toggle(!this.showingMoreResults && this.result.childResults.length > 0);
	        }
	        if (this.expandedCaption) {
	            Dom_1.$$(this.expandedCaption).toggle(this.showingMoreResults);
	        }
	        Dom_1.$$(this.oneResultCaption).toggleClass('coveo-hidden', !(subResultsLength && subResultsLength == 1));
	        if (this.showMore) {
	            Dom_1.$$(this.showMore).toggle(!this.showingMoreResults && !Utils_1.Utils.exists(this.moreResultsPromise));
	            Dom_1.$$(this.showLess).toggle(this.showingMoreResults);
	        }
	        var showIfNormal = Dom_1.$$(this.element).find('.coveo-show-if-normal');
	        if (showIfNormal) {
	            Dom_1.$$(showIfNormal).toggle(!this.showingMoreResults);
	        }
	        var showIfExpanded = Dom_1.$$(this.element).find('.coveo-show-if-expanded');
	        if (showIfExpanded) {
	            Dom_1.$$(showIfExpanded).toggle(this.showingMoreResults);
	        }
	    };
	    ResultFolding.prototype.scrollToResultElement = function () {
	        var resultElem = Dom_1.$$(this.element).closest('CoveoResult');
	        window.scrollTo(0, window.scrollY + resultElem.getBoundingClientRect().top);
	    };
	    ResultFolding.prototype.displayThoseResults = function (results) {
	        var _this = this;
	        Dom_1.$$(this.results).empty();
	        _.each(results, function (result) {
	            _this.renderChildResult(result);
	        });
	    };
	    ResultFolding.prototype.renderChildResult = function (childResult) {
	        QueryUtils_1.QueryUtils.setStateObjectOnQueryResult(this.queryStateModel.get(), childResult);
	        var oneChild = this.options.resultTemplate.instantiateToElement(childResult);
	        Dom_1.$$(oneChild).addClass('coveo-result-folding-child-result');
	        this.results.appendChild(oneChild);
	        Dom_1.$$(oneChild).toggleClass('coveo-normal-child-result', !this.showingMoreResults);
	        Dom_1.$$(oneChild).toggleClass('coveo-expanded-child-result', this.showingMoreResults);
	        this.autoCreateComponentsInsideResult(oneChild, childResult);
	    };
	    ResultFolding.prototype.autoCreateComponentsInsideResult = function (element, result) {
	        Assert_1.Assert.exists(element);
	        var initOptions = this.searchInterface.options;
	        var initParameters = { options: initOptions, bindings: this.getBindings(), result: result };
	        Initialization_1.Initialization.automaticallyCreateComponentsInside(element, initParameters);
	    };
	    ResultFolding.prototype.cancelAnyPendingShowMore = function () {
	        if (this.moreResultsPromise) {
	            this.moreResultsPromise = undefined;
	        }
	        Assert_1.Assert.doesNotExists(this.moreResultsPromise);
	        Assert_1.Assert.doesNotExists(this.waitAnimation);
	    };
	    ResultFolding.ID = 'ResultFolding';
	    /**
	     * The options for the component
	     * @componentOptions
	     */
	    ResultFolding.options = {
	        /**
	         * Specifies the template to use to render each of the child results for a top result.<br/>
	         * By default, it will use the template specified in a child element with a `<script>` tag.<br/>
	         * This can be specified directly as an attribute to the element, for example :
	         * ```html
	         * <div class='CoveoResultFolding' data-result-template-id='Foo'></div>
	         * ```
	         * which will use a previously registered template ID (see {@link TemplateCache})
	         */
	        resultTemplate: ComponentOptions_1.ComponentOptions.buildTemplateOption({ defaultFunction: function () { return new DefaultFoldingTemplate_1.DefaultFoldingTemplate(); } }),
	        /**
	         * Specifies the caption to show at the top of the child results when the conversation is not expanded.<br/>
	         * By default, the value is undefined, which doesn't show any caption.
	         */
	        normalCaption: ComponentOptions_1.ComponentOptions.buildLocalizedStringOption(),
	        /**
	         * Specifies the caption to show at the top of the child results when the conversation is expanded.<br/>
	         * By default, the value is undefined, which doesn't show any caption.
	         */
	        expandedCaption: ComponentOptions_1.ComponentOptions.buildLocalizedStringOption(),
	        /**
	         * Specifies the caption to show on the link to expand / show child results
	         * The default value is the localized version of <code>ShowMore</code>.
	         */
	        moreCaption: ComponentOptions_1.ComponentOptions.buildLocalizedStringOption({ postProcessing: function (value) { return value || Strings_1.l('ShowMore'); } }),
	        /**
	         * Specifies the caption to show on the link to shrink the loaded conversation back to only the top result.
	         * The default value is the localized version of <code>ShowLess</code>.
	         */
	        lessCaption: ComponentOptions_1.ComponentOptions.buildLocalizedStringOption({ postProcessing: function (value) { return value || Strings_1.l('ShowLess'); } }),
	        /**
	         * Specifies the caption to show when there is only one result in a conversation.
	         * The default value is the localized version of <code>DisplayingTheOnlyMessage</code>.
	         */
	        oneResultCaption: ComponentOptions_1.ComponentOptions.buildLocalizedStringOption({ postProcessing: function (value) { return value || Strings_1.l('DisplayingTheOnlyMessage'); } })
	    };
	    return ResultFolding;
	}(Component_1.Component));
	exports.ResultFolding = ResultFolding;
	Initialization_1.Initialization.registerAutoCreateComponent(ResultFolding);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Template_1 = __webpack_require__(100);
	var DefaultFoldingTemplate = (function (_super) {
	    __extends(DefaultFoldingTemplate, _super);
	    function DefaultFoldingTemplate() {
	        _super.call(this);
	    }
	    DefaultFoldingTemplate.prototype.instantiateToString = function (queryResult) {
	        return '<div class="coveo-child-result"><span class="CoveoIcon"></span> <a class="CoveoResultLink"></a> <span class="CoveoQuickview"></span></div>';
	    };
	    DefaultFoldingTemplate.prototype.getType = function () {
	        return 'DefaultFoldingTemplate';
	    };
	    return DefaultFoldingTemplate;
	}(Template_1.Template));
	exports.DefaultFoldingTemplate = DefaultFoldingTemplate;


/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var ComponentOptions_1 = __webpack_require__(98);
	var Initialization_1 = __webpack_require__(95);
	var FieldValue_1 = __webpack_require__(181);
	var StringUtils_1 = __webpack_require__(61);
	var Assert_1 = __webpack_require__(17);
	var Dom_1 = __webpack_require__(57);
	/**
	 * This component is used to easily output a field value with customizable colors and an icon preceding it.<br/>
	 * It extends {@link FieldValue}, so any option on that component can be used on `Badge`.<br/>
	 * It is possible to configure the default colors, but also to set colors specific to
	 * the current field value.
	 */
	var Badge = (function (_super) {
	    __extends(Badge, _super);
	    /**
	     * Build a new `Badge` component
	     * @param element
	     * @param options
	     * @param bindings
	     * @param result
	     */
	    function Badge(element, options, bindings, result) {
	        _super.call(this, element, ComponentOptions_1.ComponentOptions.initComponentOptions(element, Badge, options), bindings, result, Badge.ID);
	        this.options = options;
	        if (_.isString(this.options.colors)) {
	            // to support the old string options
	            this.options.colors = Badge.parseColors(this.options.colors);
	        }
	        if (this.options.colors.values == null) {
	            this.options.colors.values = {};
	        }
	    }
	    /**
	     * Parse the passed color string into a workable format.
	     * See {@link Badge.options.colors} for more info on defining colors.
	     * @param colorsOption The color string to parse.
	     */
	    Badge.parseColors = function (colorsOption) {
	        if (colorsOption) {
	            if (Badge.colorsRegex.test(colorsOption)) {
	                var badgeColors_1 = {
	                    values: {}
	                };
	                var colors = StringUtils_1.StringUtils.match(colorsOption, Badge.colorRegex);
	                _.each(colors, function (color) {
	                    var fieldValue = color[1], colorValue = color[2];
	                    if (fieldValue != null) {
	                        badgeColors_1.values[fieldValue.replace(/\\(:|;)/g, '$1')] = {
	                            icon: colorValue
	                        };
	                    }
	                    else {
	                        badgeColors_1.icon = colorValue;
	                    }
	                });
	                return badgeColors_1;
	            }
	            try {
	                return JSON.parse(colorsOption);
	            }
	            catch (e) {
	                Assert_1.Assert.fail("Invalid colors for badge '" + colorsOption + "'");
	            }
	        }
	        return {};
	    };
	    /**
	     * Get the icon and text color for the passed field value.<br/>
	     * Returns an object with the `icon` and `text` keys,
	     * representing their respective colors.
	     * @param value The field value for which the colors are returned.
	     */
	    Badge.prototype.getColor = function (value) {
	        if (value === void 0) { value = ''; }
	        var colorKey = _.find(_.keys(this.options.colors.values), function (key) { return value.toLowerCase() == key.toLowerCase(); });
	        var color = colorKey ? this.options.colors.values[colorKey] : {};
	        return {
	            icon: color.icon || this.options.colors.icon,
	            text: color.text || this.options.colors.text,
	        };
	    };
	    /**
	     * Render one string value with the appropriate colors and icon.<br/>
	     * Returns an HTML `span` containing the rendered value.
	     * @param value The field value to render.
	     */
	    Badge.prototype.renderOneValue = function (value) {
	        var valueDom = _super.prototype.renderOneValue.call(this, value);
	        Dom_1.$$(valueDom).addClass('coveo-value');
	        var color = this.getColor(value);
	        if (this.searchInterface.isNewDesign()) {
	            var icon = Dom_1.$$('span', { className: 'coveo-badge-icon' }).el;
	            if (color.icon != null) {
	                icon.style.color = color.icon;
	            }
	        }
	        else if (color.icon != null) {
	            valueDom.style.background = color.icon;
	        }
	        var label = Dom_1.$$('span', { className: 'coveo-badge-label' }, valueDom.innerHTML).el;
	        if (color.text != null) {
	            label.style.color = color.text;
	        }
	        Dom_1.$$(valueDom).empty();
	        if (this.searchInterface.isNewDesign()) {
	            valueDom.appendChild(icon);
	        }
	        valueDom.appendChild(label);
	        return valueDom;
	    };
	    Badge.ID = 'Badge';
	    /**
	     * The options for the component
	     * @componentOptions
	     */
	    Badge.options = {
	        /**
	         * Specifies the colors for the badge.
	         *
	         * Colors are specified in a a JSON format like the following:
	         * ```json
	         * {
	         *   "values":{
	         *     "foo":{
	         *       "icon":"blue",
	         *       "text":"#222"
	         *     },
	         *     "bar":{
	         *       "icon":"green",
	         *       "text":"lightgreen"
	         *     }
	         *   },
	         *   "icon":"red",
	         *   "text":"#9ab52b"
	         * }
	         * ```
	         * This format allows to customize both the icon and text colors for each
	         * field value as well as the default value.
	         *
	         * Colors can be specified in HTML or hexadecimal code format.
	         */
	        colors: ComponentOptions_1.ComponentOptions.buildCustomOption(function (value) { return Badge.parseColors(value); }, { defaultValue: { values: {} } })
	    };
	    Badge.parent = FieldValue_1.FieldValue;
	    // The following regexes are used to match the old color format:
	    // This one matches a single color, e.g. either "red" or "foo: blue".
	    // Its capture groups will be the following :
	    // 0:( 1:() 2:(red)) or 0:( 1:(foo) 2:(blue))
	    Badge.colorRegex = /(?:\s*((?:[^:;]|\\[;:])*)\s*:\s*)?(\w+|#[A-Fa-f0-9]{6}|#[A-Fa-f0-9]{3})/g;
	    // This one matches all colors, separated by semicolons, e.g. "red; foo: blue; bar: green".
	    // It wraps 'colorRegex' in other capture groups, such as the following:
	    // 0:(red) 1:(foo: blue;) 2:(bar: green)
	    Badge.colorsRegex = new RegExp('^(\\s*' + Badge.colorRegex.source + '\\s*;)*(\\s*' + Badge.colorRegex.source + ')?\\s*$');
	    return Badge;
	}(FieldValue_1.FieldValue));
	exports.Badge = Badge;
	Initialization_1.Initialization.registerAutoCreateComponent(Badge);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var Dom_1 = __webpack_require__(57);
	var Initialization_1 = __webpack_require__(95);
	var Utils_1 = __webpack_require__(18);
	(function (RatingValues) {
	    RatingValues[RatingValues["Undefined"] = 0] = "Undefined";
	    RatingValues[RatingValues["Lowest"] = 1] = "Lowest";
	    RatingValues[RatingValues["Low"] = 2] = "Low";
	    RatingValues[RatingValues["Average"] = 3] = "Average";
	    RatingValues[RatingValues["Good"] = 4] = "Good";
	    RatingValues[RatingValues["Best"] = 5] = "Best";
	})(exports.RatingValues || (exports.RatingValues = {}));
	var RatingValues = exports.RatingValues;
	;
	/**
	 * Component used to render document rating. Allows search users to rate a result with a 5-star representation.
	 * Interactive rating is possible if collaborative rating is enabled.
	 */
	var ResultRating = (function (_super) {
	    __extends(ResultRating, _super);
	    function ResultRating(element, options, bindings, result) {
	        _super.call(this, element, ResultRating.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.bindings = bindings;
	        this.result = result;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, ResultRating, options);
	        if (!Utils_1.Utils.isNullOrUndefined(result.rating)) {
	            this.renderComponent(element, result.rating);
	        }
	    }
	    ResultRating.prototype.renderComponent = function (element, rating) {
	        for (var starNumber = 1; starNumber <= 5; starNumber++) {
	            this.renderStar(element, starNumber <= rating, starNumber);
	        }
	    };
	    ResultRating.prototype.renderStar = function (element, isChecked, value) {
	        var _this = this;
	        var star;
	        var starElement = Dom_1.$$(element).find('a[rating-value="' + value + '"]');
	        if (starElement == null) {
	            star = Dom_1.$$('a');
	            element.appendChild(star.el);
	            if (this.bindings.searchInterface.options.enableCollaborativeRating) {
	                star.on('click', function (e) {
	                    var targetElement = e.currentTarget;
	                    _this.rateDocument(parseInt(targetElement.getAttribute('rating-value')));
	                });
	                star.on('mouseover', function (e) {
	                    var targetElement = e.currentTarget;
	                    _this.renderComponent(element, parseInt(targetElement.getAttribute('rating-value')));
	                });
	                star.on('mouseout', function () {
	                    _this.renderComponent(element, _this.result.rating);
	                });
	            }
	            star.el.setAttribute('rating-value', value.toString());
	        }
	        else {
	            star = Dom_1.$$(starElement);
	        }
	        var basePath = '';
	        if (this.searchInterface.isNewDesign()) {
	            basePath = 'coveo-sprites-';
	        }
	        else {
	            basePath = 'coveo-sprites-common-';
	        }
	        star.toggleClass(basePath + 'star_placeholder', !isChecked);
	        star.toggleClass(basePath + 'star_active', isChecked);
	    };
	    /**
	     * Rates a document with the specified rating value.
	     * @param rating The rating assigned to the document. Specified using the enum RatingValues.
	     * Possible values are: Undefined, Lowest, Low, Average, Good and Best.
	     */
	    ResultRating.prototype.rateDocument = function (rating) {
	        var _this = this;
	        var request = {
	            rating: RatingValues[rating],
	            uniqueId: this.result.uniqueId
	        };
	        this.queryController.getEndpoint().rateDocument(request)
	            .then(function () {
	            _this.result.rating = rating;
	            _this.renderComponent(_this.element, rating);
	        })
	            .catch(function () {
	            _this.logger.error('An error occurred while rating the document');
	        });
	    };
	    ResultRating.ID = 'ResultRating';
	    return ResultRating;
	}(Component_1.Component));
	exports.ResultRating = ResultRating;
	Initialization_1.Initialization.registerAutoCreateComponent(ResultRating);


/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var SettingsEvents_1 = __webpack_require__(50);
	var PreferencesPanelEvents_1 = __webpack_require__(46);
	var Initialization_1 = __webpack_require__(95);
	var Strings_1 = __webpack_require__(34);
	var Dom_1 = __webpack_require__(57);
	/**
	 * A panel that is displayed inside the {@link Settings} component, and allows end user to select some customizations for their interface, saved in local storage.
	 */
	var PreferencesPanel = (function (_super) {
	    __extends(PreferencesPanel, _super);
	    /**
	     * Create a new PreferencesPanel
	     * @param element
	     * @param options
	     * @param bindings
	     */
	    function PreferencesPanel(element, options, bindings) {
	        var _this = this;
	        _super.call(this, element, PreferencesPanel.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, PreferencesPanel, options);
	        this.buildCloseButton();
	        this.buildTitle();
	        this.bind.onRootElement(SettingsEvents_1.SettingsEvents.settingsPopulateMenu, function (args) {
	            args.menuData.push({
	                className: 'coveo-preferences-panel',
	                text: Strings_1.l('Preferences'),
	                onOpen: function () { return _this.open(); },
	                onClose: function () { return _this.close(); }
	            });
	        });
	    }
	    /**
	     * Open the PreferencesPanel
	     */
	    PreferencesPanel.prototype.open = function () {
	        Dom_1.$$(this.element).addClass('coveo-active');
	    };
	    /**
	     * Close the PreferencesPanel without saving changes
	     */
	    PreferencesPanel.prototype.close = function () {
	        Dom_1.$$(this.element).removeClass('coveo-active');
	        Dom_1.$$(this.element).trigger(PreferencesPanelEvents_1.PreferencesPanelEvents.exitPreferencesWithoutSave);
	    };
	    /**
	     * Save the changes
	     */
	    PreferencesPanel.prototype.save = function () {
	        Dom_1.$$(this.element).trigger(PreferencesPanelEvents_1.PreferencesPanelEvents.savePreferences);
	        this.queryController.executeQuery();
	    };
	    PreferencesPanel.prototype.buildCloseButton = function () {
	        var _this = this;
	        var closeButton = Dom_1.$$('div', { className: 'coveo-preferences-panel-close' }, Dom_1.$$('span', { className: 'coveo-icon' }).el);
	        closeButton.on('click', function () {
	            _this.close();
	        });
	        Dom_1.$$(this.element).prepend(closeButton.el);
	    };
	    PreferencesPanel.prototype.buildTitle = function () {
	        var title = Dom_1.$$('div', { className: 'coveo-preferences-panel-title' }, Strings_1.l('Preferences')).el;
	        Dom_1.$$(this.element).prepend(title);
	    };
	    PreferencesPanel.ID = 'PreferencesPanel';
	    PreferencesPanel.options = {};
	    return PreferencesPanel;
	}(Component_1.Component));
	exports.PreferencesPanel = PreferencesPanel;
	Initialization_1.Initialization.registerAutoCreateComponent(PreferencesPanel);


/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var LocalStorageUtils_1 = __webpack_require__(69);
	var KeyboardUtils_1 = __webpack_require__(68);
	var PreferencesPanel_1 = __webpack_require__(209);
	var PreferencesPanelItem_1 = __webpack_require__(211);
	var InitializationEvents_1 = __webpack_require__(44);
	var PreferencesPanelEvents_1 = __webpack_require__(46);
	var Model_1 = __webpack_require__(87);
	var QueryEvents_1 = __webpack_require__(47);
	var QueryStateModel_1 = __webpack_require__(90);
	var BreadcrumbEvents_1 = __webpack_require__(41);
	var AnalyticsActionListMeta_1 = __webpack_require__(110);
	var Initialization_1 = __webpack_require__(95);
	var Strings_1 = __webpack_require__(34);
	var Utils_1 = __webpack_require__(18);
	var Dom_1 = __webpack_require__(57);
	/**
	 * This component allows end-users to create their own customized filters to apply to their search.<br/>
	 * It is a feature meant for advanced user that understand the Coveo Query syntax.<br/>
	 * These preferences are saved in the localStorage of each user.<br/>
	 * This component is normally accessible visually using the {@link Settings} menu.<br/>
	 * It is usually located, in the DOM, inside the {@link PreferencesPanel} component.
	 */
	var ResultsFiltersPreferences = (function (_super) {
	    __extends(ResultsFiltersPreferences, _super);
	    function ResultsFiltersPreferences(element, options, bindings) {
	        var _this = this;
	        _super.call(this, element, ResultsFiltersPreferences.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.bindings = bindings;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, ResultsFiltersPreferences, options);
	        this.preferencePanel = Dom_1.$$(this.element).closest(Component_1.Component.computeCssClassName(PreferencesPanel_1.PreferencesPanel));
	        this.preferencePanelLocalStorage = new LocalStorageUtils_1.LocalStorageUtils(ResultsFiltersPreferences.ID);
	        this.mergeLocalPreferencesWithStaticPreferences();
	        this.bindPreferencePanelEvent();
	        this.bindBreadcrumbEvent();
	        this.bindQueryEvent();
	        // We need to wait after all components are initialized before building the dom, because this component interacts with Tab
	        // And we don't know if Tab(s) are initialized before or after this component.
	        this.bind.oneRootElement(InitializationEvents_1.InitializationEvents.afterComponentsInitialization, function () { return _this.createDom(); });
	        this.bind.oneQueryState(Model_1.MODEL_EVENTS.CHANGE_ONE, QueryStateModel_1.QUERY_STATE_ATTRIBUTES.T, function () { return _this.fromPreferencesToCheckboxInput(); });
	    }
	    ResultsFiltersPreferences.prototype.createDom = function () {
	        this.buildTitle();
	        this.buildCheckboxesInput();
	        if (this.options.showAdvancedFilters) {
	            this.buildAdvancedFilters();
	        }
	    };
	    ResultsFiltersPreferences.prototype.save = function () {
	        this.fromCheckboxInputToPreferences();
	        var toSave = _.omit(this.preferences, 'tab');
	        this.logger.info('Saving preferences', toSave);
	        this.preferencePanelLocalStorage.save(toSave);
	    };
	    ResultsFiltersPreferences.prototype.exitWithoutSave = function () {
	        this.fromPreferencesToCheckboxInput();
	    };
	    ResultsFiltersPreferences.prototype.bindPreferencePanelEvent = function () {
	        var _this = this;
	        this.bind.on(this.preferencePanel, PreferencesPanelEvents_1.PreferencesPanelEvents.savePreferences, function () { return _this.save(); });
	        this.bind.on(this.preferencePanel, PreferencesPanelEvents_1.PreferencesPanelEvents.exitPreferencesWithoutSave, function () { return _this.exitWithoutSave(); });
	    };
	    ResultsFiltersPreferences.prototype.bindBreadcrumbEvent = function () {
	        var _this = this;
	        if (this.options.includeInBreadcrumb) {
	            this.bind.onRootElement(BreadcrumbEvents_1.BreadcrumbEvents.populateBreadcrumb, function (args) { return _this.handlePopulateBreadcrumb(args); });
	            this.bind.onRootElement(BreadcrumbEvents_1.BreadcrumbEvents.clearBreadcrumb, function () { return _this.handleClearBreadcrumb(); });
	        }
	    };
	    ResultsFiltersPreferences.prototype.bindQueryEvent = function () {
	        var _this = this;
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.buildingQuery, function (args) { return _this.handleBuildingQuery(args); });
	    };
	    ResultsFiltersPreferences.prototype.handleBuildingQuery = function (args) {
	        _.each(this.getActiveFilters(), function (filter) {
	            args.queryBuilder.advancedExpression.add(filter.expression);
	        });
	    };
	    ResultsFiltersPreferences.prototype.handlePopulateBreadcrumb = function (args) {
	        var actives = this.getActiveFilters();
	        if (Utils_1.Utils.isNonEmptyArray(actives)) {
	            var container = Dom_1.$$('div', { className: 'coveo-results-filter-preferences-breadcrumb' });
	            var title = Dom_1.$$('span', { className: 'coveo-title' });
	            title.text(Strings_1.l('FiltersInYourPreferences') + ':');
	            container.el.appendChild(title.el);
	            var valuesContainer = Dom_1.$$('span', { className: 'coveo-values' });
	            container.el.appendChild(valuesContainer.el);
	            for (var i = 0; i < actives.length; i++) {
	                if (i != 0) {
	                    var separator = Dom_1.$$('span', {
	                        className: 'coveo-separator'
	                    });
	                    separator.text(', ');
	                    valuesContainer.el.appendChild(separator.el);
	                }
	                valuesContainer.el.appendChild(this.buildBreadcrumb(actives[i]));
	            }
	            args.breadcrumbs.push({ element: container.el });
	        }
	    };
	    ResultsFiltersPreferences.prototype.handleClearBreadcrumb = function () {
	        _.each(this.getActiveFilters(), function (filter) {
	            filter.selected = false;
	        });
	        this.fromPreferencesToCheckboxInput();
	    };
	    ResultsFiltersPreferences.prototype.buildTitle = function () {
	        this.element.appendChild(Dom_1.$$('div', {
	            className: 'coveo-title'
	        }, Strings_1.l('ResultsFilteringExpression')).el);
	    };
	    ResultsFiltersPreferences.prototype.buildAdvancedFilters = function () {
	        var _this = this;
	        this.advancedFilters = Dom_1.$$('div', { className: 'coveo-advanced-filters' }, Strings_1.l('Create')).el;
	        this.buildAdvancedFilterInput();
	        this.buildAdvancedFilterFormValidate();
	        this.advancedFiltersBuilder = Dom_1.$$('div', { className: 'coveo-advanced-filters-builder' }).el;
	        this.advancedFiltersBuilder.appendChild(this.advancedFilterFormValidate);
	        Dom_1.$$(this.advancedFilters).on('click', function () { return _this.openAdvancedFilterSectionOrSaveFilters(); });
	        var onlineHelp = Dom_1.$$('a', {
	            href: 'http://www.coveo.com/go?dest=adminhelp70&lcid=9&context=10006',
	            className: 'coveo-online-help'
	        }, '?');
	        var title = Dom_1.$$(this.element).find('.coveo-title');
	        onlineHelp.insertAfter(title);
	        Dom_1.$$(this.advancedFilters).insertAfter(title);
	        this.element.appendChild(this.advancedFiltersBuilder);
	    };
	    ResultsFiltersPreferences.prototype.buildAdvancedFilterInput = function () {
	        this.advancedFiltersTextInputCaption = new PreferencesPanelItem_1.PreferencesPanelTextAreaInput([{
	                label: Strings_1.l('Caption'),
	                placeholder: Strings_1.l('EnterExpressionName'),
	                otherAttribute: 'required'
	            }], ResultsFiltersPreferences.ID + '-advanced-caption');
	        this.advancedFiltersTextInputExpression = new PreferencesPanelItem_1.PreferencesPanelTextAreaInput([{
	                label: Strings_1.l('Expression'),
	                placeholder: Strings_1.l('EnterExpressionToFilterWith'),
	                otherAttribute: 'required'
	            }], ResultsFiltersPreferences.ID + '-advanced-expression');
	        this.advancedFiltersTabSelect = new PreferencesPanelItem_1.PreferencePanelMultiSelectInput({
	            label: Strings_1.l('Tab'),
	            placeholder: Strings_1.l('SelectTab')
	        }, this.getAllTabs(), ResultsFiltersPreferences.ID + '-multiselect');
	    };
	    ResultsFiltersPreferences.prototype.buildAdvancedFilterFormValidate = function () {
	        var _this = this;
	        this.advancedFilterFormValidate = Dom_1.$$('form').el;
	        var formSubmit = Dom_1.$$('input', {
	            type: 'submit'
	        });
	        var saveFormButton = Dom_1.$$('span', {
	            className: 'coveo-save'
	        });
	        var closeFormButton = Dom_1.$$('span', {
	            className: 'coveo-close'
	        });
	        var saveAndCloseContainer = Dom_1.$$('div', {
	            className: 'coveo-choice-container coveo-close-and-save'
	        });
	        saveAndCloseContainer.el.appendChild(saveFormButton.el);
	        saveAndCloseContainer.el.appendChild(closeFormButton.el);
	        var inputCaption = this.advancedFiltersTextInputCaption.build();
	        Dom_1.$$(inputCaption).addClass('coveo-caption');
	        var filtersTabSelect = this.advancedFiltersTabSelect.build();
	        Dom_1.$$(filtersTabSelect).addClass('coveo-tab');
	        var filtersExpression = this.advancedFiltersTextInputExpression.build();
	        Dom_1.$$(filtersExpression).addClass('coveo-expression');
	        _.each([inputCaption, filtersTabSelect, filtersExpression, saveAndCloseContainer.el, formSubmit.el], function (el) {
	            _this.advancedFilterFormValidate.appendChild(el);
	        });
	        saveFormButton.on('click', function () {
	            formSubmit.el.click();
	        });
	        closeFormButton.on('click', function () { return Dom_1.$$(_this.advancedFiltersBuilder).toggleClass('coveo-active'); });
	        Dom_1.$$(Dom_1.$$(this.advancedFilterFormValidate).find('textarea')).on('keyup', function (e) {
	            if (e.keyCode == KeyboardUtils_1.KEYBOARD.ENTER) {
	                formSubmit.trigger('click');
	            }
	        });
	        Dom_1.$$(this.advancedFilterFormValidate).on('submit', function (e) { return _this.validateAndSaveAdvancedFilter(e); });
	    };
	    ResultsFiltersPreferences.prototype.getAllTabs = function () {
	        var tabRef = Component_1.Component.getComponentRef('Tab');
	        if (tabRef) {
	            var tabsElement = Dom_1.$$(this.root).findAll('.' + Component_1.Component.computeCssClassName(tabRef));
	            return _.map(tabsElement, function (tabElement) {
	                var tab = Component_1.Component.get(tabElement);
	                return tab.options.id;
	            });
	        }
	    };
	    ResultsFiltersPreferences.prototype.getPreferencesBoxInputToBuild = function () {
	        return _.map(this.preferences, function (filter) {
	            return {
	                label: filter.caption,
	                tab: filter.tab,
	                expression: filter.expression
	            };
	        });
	    };
	    ResultsFiltersPreferences.prototype.buildCheckboxesInput = function () {
	        var _this = this;
	        if (this.preferenceContainer != undefined) {
	            this.preferenceContainer.remove();
	        }
	        var toBuild = this.getPreferencesBoxInputToBuild();
	        if (Utils_1.Utils.isNonEmptyArray(toBuild)) {
	            this.preferencePanelCheckboxInput = new PreferencesPanelItem_1.PreferencesPanelCheckboxInput(toBuild, ResultsFiltersPreferences.ID);
	            this.preferenceContainer = Dom_1.$$('div', {
	                className: 'coveo-choices-container'
	            }).el;
	            this.preferenceContainer.appendChild(this.preferencePanelCheckboxInput.build());
	            _.each(Dom_1.$$(this.preferenceContainer).findAll('.coveo-choice-container'), function (choiceContainer) {
	                choiceContainer.appendChild(Dom_1.$$('div', { className: 'coveo-section coveo-section-edit-delete' }).el);
	            });
	            Dom_1.$$(this.element).append(this.preferenceContainer);
	            this.buildEditAdvancedFilter();
	            this.buildDeleteAdvancedFilter();
	            this.fromPreferencesToCheckboxInput();
	            _.each(Dom_1.$$(this.preferenceContainer).findAll('input'), function (input) {
	                Dom_1.$$(input).on('change', function (e) {
	                    _this.save();
	                    var target = e.target;
	                    var filter = _this.preferences[target.value];
	                    _this.fromFilterToAnalyticsEvent(filter, filter.selected ? 'selected' : 'unselected');
	                    _this.queryController.executeQuery();
	                });
	            });
	        }
	    };
	    ResultsFiltersPreferences.prototype.buildDeleteAdvancedFilter = function () {
	        var _this = this;
	        _.each(this.preferences, function (filter) {
	            if (filter.custom) {
	                var deleteElement = Dom_1.$$('span', {
	                    className: 'coveo-delete'
	                }, Dom_1.$$('span', {
	                    className: 'coveo-icon'
	                }).el).el;
	                var filterElement = _this.getFilterElementByCaption(filter.caption);
	                var insertInto = Dom_1.$$(Dom_1.$$(filterElement).closest('coveo-section').parentElement).find('.coveo-section-edit-delete');
	                insertInto.appendChild(deleteElement);
	                Dom_1.$$(deleteElement).on('click', function () { return _this.confirmDelete(filter, filterElement); });
	            }
	        });
	    };
	    ResultsFiltersPreferences.prototype.buildEditAdvancedFilter = function () {
	        var _this = this;
	        _.each(this.preferences, function (filter) {
	            if (filter.custom) {
	                var editElement = Dom_1.$$('span', {
	                    className: 'coveo-edit'
	                }, Dom_1.$$('span', { className: 'coveo-icon' }));
	                var filterElement = _this.getFilterElementByCaption(filter.caption);
	                var insertInto = Dom_1.$$(Dom_1.$$(filterElement).closest('coveo-section').parentElement).find('.coveo-section-edit-delete');
	                insertInto.appendChild(editElement.el);
	                editElement.on('click', function () { return _this.editElement(filter, filterElement); });
	            }
	        });
	    };
	    ResultsFiltersPreferences.prototype.buildBreadcrumb = function (filter) {
	        var _this = this;
	        var elem = Dom_1.$$('span', { className: 'coveo-value' });
	        var caption = Dom_1.$$('span', { className: 'coveo-caption' });
	        caption.text(filter.caption);
	        elem.el.appendChild(caption.el);
	        var clear = Dom_1.$$('span', { className: 'coveo-clear' });
	        elem.el.appendChild(clear.el);
	        elem.on('click', function () {
	            filter.selected = false;
	            _this.fromFilterToAnalyticsEvent(filter, 'cleared from breadcrumb');
	            _this.fromPreferencesToCheckboxInput();
	            _this.queryController.executeQuery();
	        });
	        return elem.el;
	    };
	    ResultsFiltersPreferences.prototype.confirmDelete = function (filter, filterElement) {
	        if (confirm(Strings_1.l('AreYouSureDeleteFilter', filter.caption, filter.expression))) {
	            var isSelected = filter.selected;
	            this.deleteFilterPreference(filter, filterElement);
	            if (isSelected) {
	                this.fromFilterToAnalyticsEvent(filter, 'deleted');
	                this.queryController.executeQuery();
	            }
	        }
	    };
	    ResultsFiltersPreferences.prototype.editElement = function (filter, filterElement) {
	        var oldCaption = this.preferences[filter.caption].caption;
	        var oldTab = this.preferences[filter.caption].tab;
	        var oldExpression = this.preferences[filter.caption].expression;
	        this.deleteFilterPreference(filter, filterElement);
	        this.openAdvancedFilterSectionOrSaveFilters();
	        this.populateEditSection({ tab: oldTab, caption: oldCaption, expression: oldExpression });
	    };
	    ResultsFiltersPreferences.prototype.populateEditSection = function (toPopulate) {
	        if (toPopulate === void 0) { toPopulate = { tab: [''], caption: '', expression: '' }; }
	        this.advancedFiltersTextInputCaption.setValue(Strings_1.l('Caption'), toPopulate.caption);
	        this.advancedFiltersTextInputExpression.setValue(Strings_1.l('Expression'), toPopulate.expression);
	        this.advancedFiltersTabSelect.setValues(toPopulate.tab);
	    };
	    ResultsFiltersPreferences.prototype.deleteFilterPreference = function (filter, filterElement) {
	        this.preferencePanelLocalStorage.remove(filter.caption);
	        delete this.preferences[filter.caption];
	        Dom_1.$$(Dom_1.$$(filterElement).closest('.coveo-choice-container')).detach();
	    };
	    ResultsFiltersPreferences.prototype.openAdvancedFilterSectionOrSaveFilters = function () {
	        if (Dom_1.$$(this.advancedFiltersBuilder).hasClass('coveo-active')) {
	            Dom_1.$$(Dom_1.$$(this.advancedFilterFormValidate).find('input[type=submit]')).trigger('click');
	        }
	        else {
	            this.populateEditSection();
	            Dom_1.$$(this.advancedFiltersBuilder).toggleClass('coveo-active');
	        }
	    };
	    ResultsFiltersPreferences.prototype.validateAndSaveAdvancedFilter = function (e) {
	        e.preventDefault();
	        Dom_1.$$(this.advancedFiltersBuilder).removeClass('coveo-active');
	        var caption = this.advancedFiltersTextInputCaption.getValues()[0];
	        var expression = this.advancedFiltersTextInputExpression.getValues()[0];
	        var tabs = this.advancedFiltersTabSelect.getValues();
	        this.preferences[caption] = {
	            caption: caption,
	            custom: true,
	            expression: expression,
	            tab: tabs,
	            selected: true
	        };
	        this.buildCheckboxesInput();
	        this.save();
	        this.queryStateModel.set(QueryStateModel_1.QueryStateModel.attributesEnum.t, this.getActiveTab());
	        this.advancedFiltersTextInputCaption.reset();
	        this.advancedFiltersTextInputExpression.reset();
	        this.advancedFiltersTabSelect.reset();
	        this.element.appendChild(this.advancedFiltersBuilder);
	        this.fromFilterToAnalyticsEvent(this.preferences[caption], 'saved');
	        this.queryController.executeQuery();
	    };
	    ResultsFiltersPreferences.prototype.fromPreferencesToCheckboxInput = function () {
	        var _this = this;
	        _.each(this.getActiveFilters(), function (filter) {
	            _this.preferencePanelCheckboxInput.select(filter.caption);
	        });
	        _.each(this.getInactiveFilters(), function (filter) {
	            _this.preferencePanelCheckboxInput.unselect(filter.caption);
	        });
	        _.each(this.getDormantFilters(), function (filter) {
	            _this.preferencePanelCheckboxInput.select(filter.caption);
	        });
	    };
	    ResultsFiltersPreferences.prototype.fromCheckboxInputToPreferences = function () {
	        var selecteds = this.preferencePanelCheckboxInput.getSelecteds();
	        _.each(this.preferences, function (filter) {
	            if (_.contains(selecteds, filter.caption)) {
	                filter.selected = true;
	            }
	            else {
	                filter.selected = false;
	            }
	        });
	    };
	    ResultsFiltersPreferences.prototype.getDormantFilters = function () {
	        var _this = this;
	        var activeTab = this.getActiveTab();
	        return _.filter(this.preferences, function (filter) {
	            return filter.selected && !_this.filterIsInActiveTab(filter, activeTab);
	        });
	    };
	    ResultsFiltersPreferences.prototype.getActiveFilters = function () {
	        var _this = this;
	        var activeTab = this.getActiveTab();
	        return _.filter(this.preferences, function (filter) {
	            return filter.selected && _this.filterIsInActiveTab(filter, activeTab);
	        });
	    };
	    ResultsFiltersPreferences.prototype.getInactiveFilters = function () {
	        var _this = this;
	        var activeTab = this.getActiveTab();
	        return _.filter(this.preferences, function (filter) {
	            return !filter.selected || !_this.filterIsInActiveTab(filter, activeTab);
	        });
	    };
	    ResultsFiltersPreferences.prototype.getActiveTab = function () {
	        return this.queryStateModel.get(QueryStateModel_1.QueryStateModel.attributesEnum.t);
	    };
	    ResultsFiltersPreferences.prototype.filterIsInActiveTab = function (filter, tab) {
	        filter.tab = _.compact(filter.tab);
	        return _.contains(filter.tab, tab) || Utils_1.Utils.isEmptyArray(filter.tab);
	    };
	    ResultsFiltersPreferences.prototype.getFilterElementByCaption = function (caption) {
	        return Dom_1.$$(this.preferenceContainer).find('input[value=\'' + caption + '\']').parentElement;
	    };
	    ResultsFiltersPreferences.prototype.fromResultsFilterOptionToResultsPreferenceInterface = function () {
	        var ret = {};
	        _.each(this.options.filters, function (filter, caption) {
	            ret[caption] = {
	                expression: filter.expression,
	                tab: filter.tab,
	                selected: filter.selected ? filter.selected : false,
	                custom: false,
	                caption: caption
	            };
	        });
	        return ret;
	    };
	    ResultsFiltersPreferences.prototype.mergeLocalPreferencesWithStaticPreferences = function () {
	        var staticPreferences = this.fromResultsFilterOptionToResultsPreferenceInterface();
	        var localPreferences = this.preferencePanelLocalStorage.load();
	        var localPreferencesWithoutRemoved = _.filter(localPreferences, function (preference) {
	            var isCustom = preference.custom;
	            var existsInStatic = _.find(staticPreferences, function (staticPreference) {
	                return staticPreference.caption == preference.caption;
	            });
	            return isCustom || existsInStatic != undefined;
	        });
	        var localToMerge = {};
	        _.each(localPreferencesWithoutRemoved, function (filter) {
	            localToMerge[filter.caption] = {
	                expression: filter.expression,
	                tab: filter.tab,
	                selected: filter.selected,
	                custom: filter.custom,
	                caption: filter.caption
	            };
	        });
	        this.preferences = Utils_1.Utils.extendDeep(staticPreferences, localToMerge);
	    };
	    ResultsFiltersPreferences.prototype.fromFilterToAnalyticsEvent = function (filter, type) {
	        this.usageAnalytics.logSearchEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.customfiltersChange, {
	            customFilterName: filter.caption,
	            customFilterExpression: filter.expression,
	            customFilterType: type
	        });
	    };
	    ResultsFiltersPreferences.ID = 'ResultsFiltersPreferences';
	    /**
	     * The options for the component
	     * @componentOptions
	     */
	    ResultsFiltersPreferences.options = {
	        /**
	         * Specifies whether to include the active filter(s) in the breadcrumb.<br/>
	         * Default is <code>true</code>.
	         */
	        includeInBreadcrumb: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true }),
	        /**
	         * Specifies whether to show or hide the Create button to allow end-users to create their own filters.<br/>
	         * If set to false, only pre-populated filter created on initialization using js code will be available to the end user.
	         * Default is <code>true</code>.
	         */
	        showAdvancedFilters: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true }),
	        /**
	         * Specifies default filters that all users will see.
	         *
	         * End-users will not be able to modify or delete them, as they are not customized for each user, but instead created by the creator/developer of the search page.
	         *
	         * Filters should follow this definition :
	         *
	         * ```
	         *   filters: { [caption: string]: { expression: string; tab?: string[]; }};
	         * ```
	         *
	         * eg :
	         *
	         * ```javascript
	         * Coveo.init(root, {
	         *   ResultsFiltersPreferences : {
	         *     filters : {
	         *       'Only google drive stuff' : {
	         *         tab: ['Tab1', 'Tab2'],
	         *         expression : '@connectortype == 'GoogleDriveCrawler''
	         *       },
	         *       'Another filter' : {
	         *         expression : 'another expression''
	         *       }
	         *     }
	         *   }
	         * })
	         * ```
	         *
	         * This is optional, and by default this option is left 'empty'.
	         */
	        filters: ComponentOptions_1.ComponentOptions.buildJsonOption()
	    };
	    return ResultsFiltersPreferences;
	}(Component_1.Component));
	exports.ResultsFiltersPreferences = ResultsFiltersPreferences;
	Initialization_1.Initialization.registerAutoCreateComponent(ResultsFiltersPreferences);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Dom_1 = __webpack_require__(57);
	var Assert_1 = __webpack_require__(17);
	var Utils_1 = __webpack_require__(18);
	var PreferencesPanelBoxInput = (function () {
	    function PreferencesPanelBoxInput(boxInputToBuild, nameOfInput, type) {
	        this.boxInputToBuild = boxInputToBuild;
	        this.nameOfInput = nameOfInput;
	        this.type = type;
	        this.inputs = {};
	        this.inputTemplate = _.template('<div class=\'coveo-choice-container\'>\
	      <div class=\'coveo-section coveo-section-input\'>\
	        <input <%- otherAttribute %> class=\'coveo-<%- label %>\' id=\'coveo-<%- label %>\' type=\'<%- type %>\' name=\'<%- name%>\' value=\'<%- label %>\' ></input><span class=\'coveo-input-icon\'></span><label class=\'coveo-preferences-panel-item-label\' for=\'coveo-<%- label %>\'><%- label %></label>\
	      </div>\
	      <div class=\'coveo-section coveo-section-tab\'><%- tab %></div>\
	    <div class=\'coveo-section coveo-section-expression\'><%- expression %></div>\
	    </div>');
	    }
	    PreferencesPanelBoxInput.prototype.build = function () {
	        var _this = this;
	        return _.reduce(_.map(this.boxInputToBuild, function (toBuild) {
	            _this.inputs[toBuild.label] = Dom_1.$$('div', undefined, _this.inputTemplate({
	                label: toBuild.label,
	                name: _this.nameOfInput,
	                type: _this.type,
	                otherAttribute: toBuild.otherAttribute,
	                tab: toBuild.tab,
	                expression: toBuild.expression
	            })).el;
	            return _this.inputs[toBuild.label];
	        }), function (memo, input) {
	            memo.appendChild(input);
	            return memo;
	        }, Dom_1.$$('div').el);
	    };
	    PreferencesPanelBoxInput.prototype.select = function (toSelect) {
	        Assert_1.Assert.exists(this.inputs[toSelect]);
	        var input = Dom_1.$$(this.inputs[toSelect]).find('input');
	        input.checked = true;
	        Dom_1.$$(Dom_1.$$(this.inputs[toSelect]).find('.coveo-input-icon')).addClass('coveo-selected');
	    };
	    PreferencesPanelBoxInput.prototype.unselect = function (toUnselect) {
	        Assert_1.Assert.exists(this.inputs[toUnselect]);
	        var input = Dom_1.$$(this.inputs[toUnselect]).find('input');
	        input.checked = false;
	        Dom_1.$$(Dom_1.$$(this.inputs[toUnselect]).find('.coveo-input-icon')).removeClass('coveo-selected');
	    };
	    PreferencesPanelBoxInput.prototype.getSelected = function () {
	        var checked = _.find(this.inputs, function (el) {
	            var input = Dom_1.$$(el).find('input');
	            return input.checked;
	        });
	        return Dom_1.$$(checked).find('input').value;
	    };
	    PreferencesPanelBoxInput.prototype.getSelecteds = function () {
	        var checkeds = _.filter(this.inputs, function (el) {
	            var input = Dom_1.$$(el).find('input');
	            return input.checked;
	        });
	        return _.map(checkeds, function (checked) {
	            return Dom_1.$$(checked).find('input').value;
	        });
	    };
	    return PreferencesPanelBoxInput;
	}());
	exports.PreferencesPanelBoxInput = PreferencesPanelBoxInput;
	var PreferencesPanelRadioInput = (function (_super) {
	    __extends(PreferencesPanelRadioInput, _super);
	    function PreferencesPanelRadioInput(radioElementToBuild, name) {
	        _super.call(this, radioElementToBuild, name, 'radio');
	        this.radioElementToBuild = radioElementToBuild;
	        this.name = name;
	    }
	    return PreferencesPanelRadioInput;
	}(PreferencesPanelBoxInput));
	exports.PreferencesPanelRadioInput = PreferencesPanelRadioInput;
	var PreferencesPanelCheckboxInput = (function (_super) {
	    __extends(PreferencesPanelCheckboxInput, _super);
	    function PreferencesPanelCheckboxInput(checkboxElementToBuild, name) {
	        _super.call(this, checkboxElementToBuild, name, 'checkbox');
	        this.checkboxElementToBuild = checkboxElementToBuild;
	        this.name = name;
	    }
	    PreferencesPanelCheckboxInput.prototype.build = function () {
	        var build = _super.prototype.build.call(this);
	        var icons = Dom_1.$$(build).findAll('.coveo-input-icon');
	        _.each(icons, function (icon) {
	            var input = Dom_1.$$(icon.parentElement).find('input');
	            Dom_1.$$(input).on('change', function () {
	                var checked = input.checked;
	                Dom_1.$$(icon).toggleClass('coveo-selected', checked);
	            });
	            Dom_1.$$(icon).on('click', function () {
	                input.checked = !input.checked;
	                Dom_1.$$(input).trigger('change');
	            });
	        });
	        return build;
	    };
	    return PreferencesPanelCheckboxInput;
	}(PreferencesPanelBoxInput));
	exports.PreferencesPanelCheckboxInput = PreferencesPanelCheckboxInput;
	var PreferencesPanelTextInput = (function () {
	    function PreferencesPanelTextInput(textElementToBuild, name) {
	        this.textElementToBuild = textElementToBuild;
	        this.name = name;
	        this.inputs = {};
	        this.inputTemplate = _.template('<div class=\'coveo-choice-container\'><input <%- otherAttribute %> class=\'coveo-<%- label %>\' id=\'coveo-<%- label %>\' type=\'<%- type %>\' name=\'<%- name%>\' placeholder=\'<%- placeholder %>\' ></input></div>');
	    }
	    PreferencesPanelTextInput.prototype.build = function () {
	        var _this = this;
	        return _.reduce(_.map(this.textElementToBuild, function (toBuild) {
	            _this.inputs[toBuild.label] = Dom_1.$$('div', undefined, _this.inputTemplate({
	                label: toBuild.label,
	                name: _this.name,
	                type: 'text',
	                otherAttribute: toBuild.otherAttribute,
	                placeholder: toBuild.placeholder || toBuild.label
	            })).el;
	            return _this.inputs[toBuild.label];
	        }), function (memo, input) {
	            memo.appendChild(input);
	            return memo;
	        }, Dom_1.$$('div').el);
	    };
	    PreferencesPanelTextInput.prototype.getValues = function () {
	        var _this = this;
	        return _.map(this.inputs, function (input, key) {
	            return _this.getInput(key).value;
	        });
	    };
	    PreferencesPanelTextInput.prototype.setValue = function (input, value) {
	        Assert_1.Assert.exists(this.inputs[input]);
	        this.getInput(input).value = value;
	    };
	    PreferencesPanelTextInput.prototype.reset = function () {
	        _.each(this.inputs, function (input) {
	            var inputElement = Dom_1.$$(input).find('input');
	            if (!inputElement) {
	                inputElement = Dom_1.$$(input).find('textarea');
	            }
	            inputElement.value = '';
	        });
	    };
	    PreferencesPanelTextInput.prototype.getInput = function (input) {
	        Assert_1.Assert.exists(this.inputs[input]);
	        var found = Dom_1.$$(this.inputs[input]).find('input');
	        if (!found) {
	            found = Dom_1.$$(this.inputs[input]).find('textarea');
	        }
	        return found;
	    };
	    return PreferencesPanelTextInput;
	}());
	exports.PreferencesPanelTextInput = PreferencesPanelTextInput;
	var PreferencesPanelTextAreaInput = (function (_super) {
	    __extends(PreferencesPanelTextAreaInput, _super);
	    function PreferencesPanelTextAreaInput() {
	        _super.apply(this, arguments);
	        this.inputTemplate = _.template('<div class=\'coveo-choice-container\'><textarea <%- otherAttribute %> class=\'coveo-<%- label %>\' id=\'coveo-<%- label %>\' name=\'<%- name%>\' placeholder=\'<%- placeholder %>\' ></textarea></div>');
	    }
	    PreferencesPanelTextAreaInput.prototype.build = function () {
	        var _this = this;
	        return _.reduce(_.map(this.textElementToBuild, function (toBuild) {
	            _this.inputs[toBuild.label] = Dom_1.$$('div', undefined, _this.inputTemplate({
	                label: toBuild.label,
	                name: _this.name,
	                otherAttribute: toBuild.otherAttribute,
	                placeholder: toBuild.placeholder || toBuild.label
	            })).el;
	            return _this.inputs[toBuild.label];
	        }), function (memo, input) {
	            memo.appendChild(input);
	            return memo;
	        }, Dom_1.$$('div').el);
	    };
	    return PreferencesPanelTextAreaInput;
	}(PreferencesPanelTextInput));
	exports.PreferencesPanelTextAreaInput = PreferencesPanelTextAreaInput;
	var PreferencePanelMultiSelectInput = (function () {
	    function PreferencePanelMultiSelectInput(toBuild, options, name) {
	        this.toBuild = toBuild;
	        this.options = options;
	        this.name = name;
	        this.textInput = new PreferencesPanelTextAreaInput([{ label: toBuild.label, otherAttribute: 'readonly' }], name);
	    }
	    PreferencePanelMultiSelectInput.prototype.build = function () {
	        var _this = this;
	        this.select = Dom_1.$$('select').el;
	        this.select.setAttribute('multiple', 'multiple');
	        _.each(this.options, function (option) {
	            var optEl = Dom_1.$$('option', undefined, option).el;
	            _this.select.appendChild(optEl);
	        });
	        Dom_1.$$(this.select).on('change', function () {
	            var values = _.chain(_this.select.options)
	                .filter(function (opt) {
	                return opt.selected;
	            })
	                .map(function (opt) {
	                return opt.value;
	            })
	                .value();
	            if (!Utils_1.Utils.isNullOrUndefined(values) && !Utils_1.Utils.isEmptyArray(values)) {
	                _this.textInput.setValue(_this.toBuild.label, values.join(','));
	            }
	            else {
	                _this.reset();
	            }
	        });
	        var el = this.textInput.build();
	        el.appendChild(this.select);
	        return el;
	    };
	    PreferencePanelMultiSelectInput.prototype.getValues = function () {
	        return this.textInput.getValues()[0].split(',');
	    };
	    PreferencePanelMultiSelectInput.prototype.setValues = function (values) {
	        this.textInput.setValue(this.toBuild.label, values.join(','));
	    };
	    PreferencePanelMultiSelectInput.prototype.reset = function () {
	        this.textInput.setValue(this.toBuild.label, '');
	    };
	    return PreferencePanelMultiSelectInput;
	}());
	exports.PreferencePanelMultiSelectInput = PreferencePanelMultiSelectInput;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var QueryEvents_1 = __webpack_require__(47);
	var Assert_1 = __webpack_require__(17);
	var Dom_1 = __webpack_require__(57);
	var Strings_1 = __webpack_require__(34);
	var Initialization_1 = __webpack_require__(95);
	var Globalize = __webpack_require__(4);
	/**
	 * This component is used to display the time it took to execute the query.
	 * When a {@link QueryEvents.querySuccess} event is called, it shows itself and displays
	 * the global duration, the index duration, the proxy duration, and the client duration in a tooltip.<br/>
	 * If a {@link QueryEvents.queryError} event is called, it hides.
	 */
	var QueryDuration = (function (_super) {
	    __extends(QueryDuration, _super);
	    /**
	     * Create a new QueryDuration component.
	     * @param element
	     * @param options
	     * @param bindings
	     */
	    function QueryDuration(element, options, bindings) {
	        var _this = this;
	        _super.call(this, element, QueryDuration.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, QueryDuration, options);
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.querySuccess, function (data) { return _this.handleQuerySuccess(data); });
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.queryError, function () { return Dom_1.$$(_this.element).hide(); });
	        this.element.style.display = 'none';
	        this.textContainer = Dom_1.$$('span').el;
	        this.element.appendChild(this.textContainer);
	    }
	    QueryDuration.prototype.handleQuerySuccess = function (data) {
	        if (!this.disabled && data.results.results.length > 0) {
	            Assert_1.Assert.exists(data);
	            var tooltip = [
	                Strings_1.l('Duration', this.formatQueryDuration(data.results.duration)),
	                Strings_1.l('IndexDuration', this.formatQueryDuration(data.results.indexDuration)),
	                Strings_1.l('ProxyDuration', this.formatQueryDuration(data.results.proxyDuration)),
	                Strings_1.l('ClientDuration', this.formatQueryDuration(data.results.clientDuration))
	            ].join('\n');
	            this.textContainer.textContent = this.formatQueryDuration(data.results.duration);
	            this.element.setAttribute('title', tooltip);
	            this.element.style.display = 'inline';
	        }
	        else {
	            this.element.style.display = 'none';
	        }
	    };
	    QueryDuration.prototype.formatQueryDuration = function (durationInMillis) {
	        if (durationInMillis == undefined) {
	            return Strings_1.l('Unavailable');
	        }
	        else {
	            var seconds = Math.max(durationInMillis / 1000, 0.01);
	            if (String['locale'] === 'en') {
	                return Strings_1.l('Seconds', Globalize.format(seconds, 'n2'), seconds, true);
	            }
	            else {
	                return Strings_1.l('Seconds', Globalize.format(seconds, 'n2'), seconds);
	            }
	        }
	    };
	    QueryDuration.ID = 'QueryDuration';
	    /**
	     * The options for the component
	     * @componentOptions
	     */
	    QueryDuration.options = {};
	    return QueryDuration;
	}(Component_1.Component));
	exports.QueryDuration = QueryDuration;
	Initialization_1.Initialization.registerAutoCreateComponent(QueryDuration);


/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var QueryEvents_1 = __webpack_require__(47);
	var Dom_1 = __webpack_require__(57);
	var Assert_1 = __webpack_require__(17);
	var Strings_1 = __webpack_require__(34);
	var AnalyticsActionListMeta_1 = __webpack_require__(110);
	var Initialization_1 = __webpack_require__(95);
	var QueryStateModel_1 = __webpack_require__(90);
	var Globalize = __webpack_require__(4);
	var QuerySummaryEvents_1 = __webpack_require__(214);
	/**
	 * This component displays information about the current range of results being displayed (ex: 1-10 of 123).<br/>
	 * If the query matches no document, it will display advices and tip for the end user on how to remedy the problem.
	 */
	var QuerySummary = (function (_super) {
	    __extends(QuerySummary, _super);
	    function QuerySummary(element, options, bindings) {
	        var _this = this;
	        _super.call(this, element, QuerySummary.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, QuerySummary, options);
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.querySuccess, function (data) { return _this.handleQuerySuccess(data); });
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.queryError, function () { return _this.hide(); });
	        this.hide();
	        this.textContainer = Dom_1.$$('span').el;
	        this.element.appendChild(this.textContainer);
	    }
	    QuerySummary.prototype.hide = function () {
	        Dom_1.$$(this.element).addClass('coveo-hidden');
	    };
	    QuerySummary.prototype.show = function () {
	        Dom_1.$$(this.element).removeClass('coveo-hidden');
	    };
	    QuerySummary.prototype.handleQuerySuccess = function (data) {
	        Assert_1.Assert.exists(data);
	        Dom_1.$$(this.textContainer).empty();
	        this.show();
	        if (!this.options.onlyDisplaySearchTips) {
	            if (data.results.results.length > 0) {
	                var first = Globalize.format(data.query.firstResult + 1, 'n0');
	                var last = Globalize.format(data.query.firstResult + data.results.results.length, 'n0');
	                var totalCount = Globalize.format(data.results.totalCountFiltered, 'n0');
	                var highlightFirst = Dom_1.$$('span', { className: 'coveo-highlight' }, first).el;
	                var highlightLast = Dom_1.$$('span', { className: 'coveo-highlight' }, last).el;
	                var highlightTotal = Dom_1.$$('span', { className: 'coveo-highlight' }, totalCount).el;
	                this.textContainer.innerHTML = Strings_1.l('ShowingResultsOf', highlightFirst.outerHTML, highlightLast.outerHTML, highlightTotal.outerHTML, data.results.results.length);
	            }
	        }
	        if (data.results.exception != null && data.results.exception.code != null) {
	            var code = ('QueryException' + data.results.exception.code).toLocaleString();
	            this.textContainer.innerHTML = Strings_1.l('QueryException', code);
	        }
	        else if (data.results.results.length == 0) {
	            this.displayInfoOnNoResults();
	        }
	        else {
	            this.lastKnownGoodState = this.queryStateModel.getAttributes();
	        }
	    };
	    QuerySummary.prototype.displayInfoOnNoResults = function () {
	        var _this = this;
	        var queryEscaped = _.escape(this.queryStateModel.get(QueryStateModel_1.QueryStateModel.attributesEnum.q));
	        var noResultsForString;
	        if (queryEscaped != '') {
	            noResultsForString = Dom_1.$$('div', {
	                className: 'coveo-query-summary-no-results-string'
	            }, Strings_1.l('noResultFor', Dom_1.$$('span', { className: 'coveo-highlight' }, queryEscaped).el.outerHTML));
	        }
	        var cancelLastAction = Dom_1.$$('div', {
	            className: 'coveo-query-summary-cancel-last'
	        }, Strings_1.l('CancelLastAction'));
	        cancelLastAction.on('click', function () {
	            _this.usageAnalytics.logCustomEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.noResultsBack, {}, _this.root);
	            _this.usageAnalytics.logSearchEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.noResultsBack, {});
	            if (_this.lastKnownGoodState) {
	                _this.queryStateModel.reset();
	                _this.queryStateModel.setMultiple(_this.lastKnownGoodState);
	                Dom_1.$$(_this.root).trigger(QuerySummaryEvents_1.QuerySummaryEvents.cancelLastAction);
	                _this.queryController.executeQuery();
	            }
	            else {
	                history.back();
	            }
	        });
	        var searchTipsInfo = Dom_1.$$('div', {
	            className: 'coveo-query-summary-search-tips-info'
	        });
	        searchTipsInfo.text(Strings_1.l('SearchTips'));
	        var searchTips = Dom_1.$$('ul');
	        var checkSpelling = Dom_1.$$('li');
	        checkSpelling.text(Strings_1.l('CheckSpelling'));
	        var fewerKeywords = Dom_1.$$('li');
	        fewerKeywords.text(Strings_1.l('TryUsingFewerKeywords'));
	        searchTips.el.appendChild(checkSpelling.el);
	        searchTips.el.appendChild(fewerKeywords.el);
	        if (this.queryStateModel.atLeastOneFacetIsActive()) {
	            var fewerFilter = Dom_1.$$('li');
	            fewerFilter.text(Strings_1.l('SelectFewerFilters'));
	            searchTips.el.appendChild(fewerFilter.el);
	        }
	        if (this.options.enableSearchTips) {
	            if (noResultsForString) {
	                this.textContainer.appendChild(noResultsForString.el);
	            }
	            this.textContainer.appendChild(cancelLastAction.el);
	            this.textContainer.appendChild(searchTipsInfo.el);
	            this.textContainer.appendChild(searchTips.el);
	        }
	        else {
	            if (noResultsForString) {
	                this.textContainer.appendChild(noResultsForString.el);
	            }
	            this.textContainer.appendChild(cancelLastAction.el);
	        }
	    };
	    QuerySummary.ID = 'QuerySummary';
	    /**
	     * Options for the component
	     * @componentOptions
	     */
	    QuerySummary.options = {
	        /**
	         * Specifies whether the search tips are displayed to the end user when there are no search results.<br/>
	         * The default value is <code>true</code>.
	         */
	        enableSearchTips: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true }),
	        /**
	         * Specifies whether to hide the information about the current range of results being displayed and only display the search tips.<br/>
	         * The default value is <code>false</code>.
	         */
	        onlyDisplaySearchTips: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: false })
	    };
	    return QuerySummary;
	}(Component_1.Component));
	exports.QuerySummary = QuerySummary;
	Initialization_1.Initialization.registerAutoCreateComponent(QuerySummary);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 214 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * This static class is there to contains the different string definition for all the events related to the {@link AdvancedSearch} component.
	 */
	var QuerySummaryEvents = (function () {
	    function QuerySummaryEvents() {
	    }
	    /**
	     * Triggered when the last action is being cancelled by the query summary component
	     *
	     * Allows external code to revert their last action.
	     * @type {string}
	     */
	    QuerySummaryEvents.cancelLastAction = 'cancelLastAction';
	    return QuerySummaryEvents;
	}());
	exports.QuerySummaryEvents = QuerySummaryEvents;


/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var InitializationEvents_1 = __webpack_require__(44);
	var Dom_1 = __webpack_require__(57);
	var PopupUtils_1 = __webpack_require__(71);
	var SettingsEvents_1 = __webpack_require__(50);
	var Initialization_1 = __webpack_require__(95);
	/**
	 * The Settings component is comprised of a settings button (usually located
	 * on the right of the search box) which allows for some contextual actions.<br/>
	 * This component references other components to show in its menu, for example
	 * the {@link ShareQuery} component.
	 */
	var Settings = (function (_super) {
	    __extends(Settings, _super);
	    /**
	     * Create a new Settings component
	     * @param element
	     * @param options
	     * @param bindings
	     */
	    function Settings(element, options, bindings) {
	        var _this = this;
	        _super.call(this, element, Settings.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.isOpened = false;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, Settings, options);
	        this.bind.onRootElement(InitializationEvents_1.InitializationEvents.afterInitialization, function () { return _this.init(); });
	    }
	    /**
	     * Open the settings popup
	     */
	    Settings.prototype.open = function () {
	        var _this = this;
	        this.isOpened = true;
	        if (this.menu != null) {
	            Dom_1.$$(this.menu).detach();
	        }
	        this.menu = this.buildMenu();
	        Dom_1.$$(this.menu).on('mouseleave', function () { return _this.mouseleave(); });
	        Dom_1.$$(this.menu).on('mouseenter', function () { return _this.mouseenter(); });
	        PopupUtils_1.PopupUtils.positionPopup(this.menu, this.element, this.root, this.getPopupPositioning(), this.root);
	    };
	    /**
	     * Close the settings popup
	     */
	    Settings.prototype.close = function () {
	        this.isOpened = false;
	        if (this.menu != null) {
	            Dom_1.$$(this.menu).detach();
	            this.menu = null;
	        }
	    };
	    Settings.prototype.init = function () {
	        var _this = this;
	        if (this.searchInterface.isNewDesign()) {
	            var square = Dom_1.$$('span', { className: 'coveo-settings-square' }).el;
	            var squares = Dom_1.$$('span', { className: 'coveo-settings-squares' }).el;
	            _.times(3, function () { return squares.appendChild(square.cloneNode()); });
	            this.element.appendChild(squares);
	        }
	        else {
	            var icon = Dom_1.$$('span', { className: 'coveo-settings-icon' }).el;
	            this.element.appendChild(icon);
	        }
	        Dom_1.$$(this.element).on('click', function () {
	            if (_this.isOpened) {
	                _this.close();
	            }
	            else {
	                _this.open();
	            }
	        });
	        Dom_1.$$(this.element).on('mouseleave', function () { return _this.mouseleave(); });
	        Dom_1.$$(this.element).on('mouseenter', function () { return _this.mouseenter(); });
	    };
	    Settings.prototype.buildMenu = function () {
	        var _this = this;
	        var menu = Dom_1.$$('div', { className: 'coveo-settings-advanced-menu' }).el;
	        var settingsPopulateMenuArgs = {
	            settings: this,
	            menuData: []
	        };
	        Dom_1.$$(this.root).trigger(SettingsEvents_1.SettingsEvents.settingsPopulateMenu, settingsPopulateMenuArgs);
	        _.each(settingsPopulateMenuArgs.menuData, function (menuItem) {
	            var menuItemDom = Dom_1.$$('div', {
	                className: "coveo-settings-item " + menuItem.className,
	                title: _.escape(menuItem.tooltip || '')
	            }).el;
	            menuItemDom.appendChild(Dom_1.$$('div', { className: 'coveo-icon' }).el);
	            menuItemDom.appendChild(Dom_1.$$('div', { className: 'coveo-settings-text' }, _.escape(menuItem.text)).el);
	            Dom_1.$$(menuItemDom).on('click', function () {
	                _this.close();
	                _.each(settingsPopulateMenuArgs.menuData, function (menuItem) {
	                    menuItem.onClose && menuItem.onClose();
	                });
	                menuItem.onOpen();
	            });
	            menu.appendChild(menuItemDom);
	        });
	        return menu;
	    };
	    Settings.prototype.mouseleave = function () {
	        var _this = this;
	        clearTimeout(this.closeTimeout);
	        this.closeTimeout = setTimeout(function () {
	            _this.close();
	        }, this.options.menuDelay);
	    };
	    Settings.prototype.mouseenter = function () {
	        clearTimeout(this.closeTimeout);
	    };
	    Settings.prototype.getPopupPositioning = function () {
	        return {
	            horizontal: PopupUtils_1.HorizontalAlignment.INNERRIGHT,
	            vertical: PopupUtils_1.VerticalAlignment.BOTTOM,
	            verticalOffset: 8
	        };
	    };
	    Settings.ID = 'Settings';
	    /**
	     * The options for Settings
	     * @componentOptions
	     */
	    Settings.options = {
	        /**
	         * The delay before hiding the popup menu when the mouse leaves it.<br/>
	         * The default value is <code>300</code>.
	         */
	        menuDelay: ComponentOptions_1.ComponentOptions.buildNumberOption({ defaultValue: 300, min: 0 })
	    };
	    return Settings;
	}(Component_1.Component));
	exports.Settings = Settings;
	Initialization_1.Initialization.registerAutoCreateComponent(Settings);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var QueryEvents_1 = __webpack_require__(47);
	var SettingsEvents_1 = __webpack_require__(50);
	var Assert_1 = __webpack_require__(17);
	var Dom_1 = __webpack_require__(57);
	var Strings_1 = __webpack_require__(34);
	var Utils_1 = __webpack_require__(18);
	var Initialization_1 = __webpack_require__(95);
	/**
	 * ShareQuery shows 2 text boxes, one with a shareable link and the
	 * other with the complete query expression of the currently performed query.<br/>
	 * It populates the {@link Settings} components menu for easy access.
	 */
	var ShareQuery = (function (_super) {
	    __extends(ShareQuery, _super);
	    /**
	     * Create a new ShareQuery component.
	     * @param element
	     * @param options
	     * @param bindings
	     */
	    function ShareQuery(element, options, bindings) {
	        var _this = this;
	        _super.call(this, element, ShareQuery.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.dialogBoxContent = this.buildContent();
	        element.appendChild(this.dialogBoxContent);
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.querySuccess, function (args) { return _this.handleProcessNewQueryResults(args); });
	        this.bind.onRootElement(SettingsEvents_1.SettingsEvents.settingsPopulateMenu, function (args) {
	            args.menuData.push({
	                className: 'coveo-share-query',
	                text: Strings_1.l('ShareQuery'),
	                onOpen: function () { return _this.open(); },
	                onClose: function () { return _this.close(); }
	            });
	        });
	    }
	    /**
	     * Show the ShareQuery
	     */
	    ShareQuery.prototype.open = function () {
	        Dom_1.$$(this.element).addClass('coveo-share-query-opened');
	    };
	    /**
	     * Hide the ShareQuery
	     */
	    ShareQuery.prototype.close = function () {
	        Dom_1.$$(this.element).removeClass('coveo-share-query-opened');
	    };
	    /**
	     * Get the link to the current query
	     */
	    ShareQuery.prototype.getLinkToThisQuery = function () {
	        return this.linkToThisQuery.value;
	    };
	    /**
	     * Set the link to the current query
	     */
	    ShareQuery.prototype.setLinkToThisQuery = function (link) {
	        this.linkToThisQuery.value = link;
	    };
	    /**
	     * Get the complete query string
	     */
	    ShareQuery.prototype.getCompleteQuery = function () {
	        return this.completeQuery.value;
	    };
	    /**
	     * Set the complete query string
	     */
	    ShareQuery.prototype.setCompleteQuery = function (completeQuery) {
	        this.completeQuery.value = completeQuery;
	    };
	    ShareQuery.prototype.handleProcessNewQueryResults = function (args) {
	        Assert_1.Assert.exists(args);
	        Assert_1.Assert.exists(args.results);
	        var query = args.query;
	        this.linkToThisQuery.value = window.location.href;
	        this.completeQuery.value = Utils_1.Utils.trim(this.outputIfNotNull(query.q) + ' ' + this.outputIfNotNull(query.aq) + ' ' + this.outputIfNotNull(query.cq));
	        this.logger.trace('Received query results from new query', query);
	    };
	    ShareQuery.prototype.outputIfNotNull = function (value) {
	        if (value) {
	            return '(' + value + ')';
	        }
	        return '';
	    };
	    ShareQuery.prototype.buildContent = function () {
	        var _this = this;
	        var content = Dom_1.$$('div', { className: 'coveo-share-query-summary-info' }).el;
	        content.appendChild(Dom_1.$$('span', { className: 'coveo-query-summary-info-title' }, Strings_1.l('ShareQuery')).el);
	        var close = Dom_1.$$('div', { className: 'coveo-share-query-summary-info-close' }).el;
	        close.appendChild(Dom_1.$$('span').el);
	        Dom_1.$$(close).on('click', function () { return _this.close(); });
	        content.appendChild(close);
	        var boxes = Dom_1.$$('div', { className: 'coveo-share-query-summary-info-boxes' }).el;
	        this.linkToThisQuery = Dom_1.$$('input', {
	            'type': 'text',
	            className: 'coveo-share-query-summary-info-input'
	        }).el;
	        Dom_1.$$(this.linkToThisQuery).on('click', function () { return _this.linkToThisQuery.select(); });
	        this.completeQuery = Dom_1.$$('input').el;
	        this.completeQuery.setAttribute('type', 'text');
	        Dom_1.$$(this.completeQuery).addClass('coveo-share-query-summary-info-input');
	        boxes.appendChild(this.buildTextBoxWithLabel(Strings_1.l('Link') + ':', this.linkToThisQuery));
	        boxes.appendChild(this.buildTextBoxWithLabel(Strings_1.l('CompleteQuery') + ':', this.completeQuery));
	        content.appendChild(boxes);
	        Component_1.Component.pointElementsToDummyForm(content);
	        return content;
	    };
	    ShareQuery.prototype.buildTextBoxWithLabel = function (label, input) {
	        var labelElement = Dom_1.$$('span', { className: 'coveo-share-query-summary-info-label' });
	        labelElement.text(label);
	        var returnDiv = Dom_1.$$('div').el;
	        returnDiv.appendChild(labelElement.el);
	        returnDiv.appendChild(input);
	        return returnDiv;
	    };
	    ShareQuery.create = function (element, options, root) {
	        Assert_1.Assert.exists(element);
	        return new ShareQuery(element, options, root);
	    };
	    ShareQuery.ID = 'ShareQuery';
	    ShareQuery.options = {};
	    return ShareQuery;
	}(Component_1.Component));
	exports.ShareQuery = ShareQuery;
	Initialization_1.Initialization.registerAutoCreateComponent(ShareQuery);


/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var SortCriteria_ts_1 = __webpack_require__(187);
	var ComponentOptions_1 = __webpack_require__(98);
	var Assert_1 = __webpack_require__(17);
	var Utils_1 = __webpack_require__(18);
	var Dom_1 = __webpack_require__(57);
	var Model_1 = __webpack_require__(87);
	var QueryStateModel_1 = __webpack_require__(90);
	var QueryEvents_1 = __webpack_require__(47);
	var Initialization_1 = __webpack_require__(95);
	var AnalyticsActionListMeta_1 = __webpack_require__(110);
	var KeyboardUtils_1 = __webpack_require__(68);
	/**
	 * This component displays a sort criterion for searching.
	 */
	var Sort = (function (_super) {
	    __extends(Sort, _super);
	    /**
	     * Create a new Sort component.
	     * @param element
	     * @param options
	     * @param bindings
	     */
	    function Sort(element, options, bindings) {
	        var _this = this;
	        _super.call(this, element, Sort.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, Sort, options);
	        Assert_1.Assert.isLargerOrEqualsThan(1, this.options.sortCriteria.length);
	        var eventName = this.queryStateModel.getEventName(Model_1.Model.eventTypes.changeOne) + QueryStateModel_1.QueryStateModel.attributesEnum.sort;
	        this.bind.onRootElement(eventName, function (args) { return _this.handleQueryStateChanged(args); });
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.querySuccess, function (args) { return _this.handleQuerySuccess(args); });
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.buildingQuery, function (args) { return _this.handleBuildingQuery(args); });
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.queryError, function (args) { return _this.handleQueryError(args); });
	        var clickAction = function () { return _this.handleClick(); };
	        this.bind.on(this.element, 'click', clickAction);
	        this.bind.on(this.element, 'keyup', KeyboardUtils_1.KeyboardUtils.keypressAction(KeyboardUtils_1.KEYBOARD.ENTER, clickAction));
	        this.element.setAttribute('tabindex', '0');
	        if (Utils_1.Utils.isNonEmptyString(this.options.caption)) {
	            Dom_1.$$(this.element).text(this.options.caption);
	        }
	        if (this.isToggle()) {
	            this.element.innerHTML += '<span class="coveo-icon" />';
	        }
	        this.updateAppearance();
	    }
	    /**
	     * Select the Sort component.
	     * @param direction The sort direction (e.g. ascending, descending).
	     *
	     * Will trigger a query if the selection made the criteria change (if it was toggled).
	     */
	    Sort.prototype.select = function (direction) {
	        if (direction) {
	            this.currentCriteria = _.find(this.options.sortCriteria, function (criteria) {
	                return criteria.direction == direction;
	            });
	        }
	        else if (Utils_1.Utils.exists(this.currentCriteria)) {
	            var indexOfCurrentCriteria = _.indexOf(this.options.sortCriteria, this.currentCriteria);
	            Assert_1.Assert.check(indexOfCurrentCriteria >= 0);
	            this.currentCriteria = this.options.sortCriteria[(indexOfCurrentCriteria + 1) % this.options.sortCriteria.length];
	        }
	        else {
	            this.currentCriteria = this.options.sortCriteria[0];
	        }
	        this.queryStateModel.set(QueryStateModel_1.QueryStateModel.attributesEnum.sort, this.currentCriteria.toString());
	    };
	    Sort.prototype.enable = function () {
	        Dom_1.$$(this.element).removeClass('coveo-tab-disabled');
	        this.update();
	        _super.prototype.enable.call(this);
	    };
	    Sort.prototype.disable = function () {
	        Dom_1.$$(this.element).addClass('coveo-tab-disabled');
	        _super.prototype.disable.call(this);
	    };
	    /**
	     * Get the current SortCriteria.
	     */
	    Sort.prototype.getCurrentCriteria = function () {
	        return this.currentCriteria;
	    };
	    /**
	     * Returns true if one of the sort criterias matches the passed argument.
	     * @param sortId The sort criteria to verify with (e.g. 'date descending')
	     */
	    Sort.prototype.match = function (sortId) {
	        return _.any(this.options.sortCriteria, function (sortCriteria) { return sortId == sortCriteria.toString(); });
	    };
	    Sort.prototype.handleQueryStateChanged = function (data) {
	        this.update();
	    };
	    Sort.prototype.update = function () {
	        // Basically, if the criteria in the model fits with one of ours, it'll become our active criteria
	        var sortCriteria = this.queryStateModel.get(QueryStateModel_1.QueryStateModel.attributesEnum.sort);
	        if (Utils_1.Utils.isNonEmptyString(sortCriteria)) {
	            var criteriaFromModel = SortCriteria_ts_1.SortCriteria.parse(sortCriteria);
	            this.currentCriteria = _.find(this.options.sortCriteria, function (criteria) { return criteriaFromModel.equals(criteria); });
	        }
	        else {
	            this.currentCriteria = null;
	        }
	        this.updateAppearance();
	    };
	    Sort.prototype.handleBuildingQuery = function (data) {
	        Assert_1.Assert.exists(data);
	        var sort = this.queryStateModel.get(QueryStateModel_1.QueryStateModel.attributesEnum.sort);
	        if (sort == QueryStateModel_1.QueryStateModel.defaultAttributes.sort || this.isSelected()) {
	            if (this.currentCriteria) {
	                this.currentCriteria.putInQueryBuilder(data.queryBuilder);
	            }
	        }
	    };
	    Sort.prototype.handleQuerySuccess = function (data) {
	        if (data.results.results.length == 0) {
	            Dom_1.$$(this.element).addClass('coveo-sort-hidden');
	        }
	        else {
	            Dom_1.$$(this.element).removeClass('coveo-sort-hidden');
	        }
	    };
	    Sort.prototype.handleQueryError = function (data) {
	        Dom_1.$$(this.element).addClass('coveo-sort-hidden');
	    };
	    Sort.prototype.handleClick = function () {
	        var _this = this;
	        var oldCriteria = this.currentCriteria;
	        this.select();
	        if (oldCriteria != this.currentCriteria) {
	            this.queryController.deferExecuteQuery({
	                beforeExecuteQuery: function () { return _this.usageAnalytics.logSearchEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.resultsSort, { resultsSortBy: _this.currentCriteria.sort + _this.currentCriteria.direction }); }
	            });
	        }
	    };
	    Sort.prototype.isToggle = function () {
	        return this.options.sortCriteria.length > 1;
	    };
	    Sort.prototype.isSelected = function () {
	        return Utils_1.Utils.exists(this.currentCriteria);
	    };
	    Sort.prototype.updateAppearance = function () {
	        Dom_1.$$(this.element).toggleClass('coveo-selected', this.isSelected());
	        if (this.isToggle()) {
	            var direction = this.currentCriteria ? this.currentCriteria.direction : this.options.sortCriteria[0].direction;
	            Dom_1.$$(this.element).toggleClass('coveo-ascending', direction == 'ascending');
	        }
	    };
	    Sort.ID = 'Sort';
	    /**
	     * Options for the component
	     * @componentOptions
	     */
	    Sort.options = {
	        /**
	         * The criterion for sorting
	         *
	         * The available criteria are:
	         * - `relevancy`
	         * - `Date`
	         * - `qre`
	         * - `@fieldname` (replace fieldname with an actual field name (e.g. <code>@syssize</code>)
	         *
	         * A direction (ascending or descending) can be specified, for example "date ascending".
	         *
	         * A Sort component can have multiple criteria, passed as a list.
	         *
	         * This option is required.
	         */
	        sortCriteria: ComponentOptions_1.ComponentOptions.buildCustomListOption(function (values) {
	            return _.map(values, function (criteria) {
	                if (typeof criteria === 'string') {
	                    return SortCriteria_ts_1.SortCriteria.parse(criteria);
	                }
	                else {
	                    return criteria;
	                }
	            });
	        }, { required: true }),
	        /**
	         * The caption to display on the element.
	         *
	         * If not specified, the component will use the tag body.
	         */
	        caption: ComponentOptions_1.ComponentOptions.buildLocalizedStringOption({ required: true })
	    };
	    return Sort;
	}(Component_1.Component));
	exports.Sort = Sort;
	Initialization_1.Initialization.registerAutoCreateComponent(Sort);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var Assert_1 = __webpack_require__(17);
	var QueryEvents_1 = __webpack_require__(47);
	var Dom_1 = __webpack_require__(57);
	var AnalyticsActionListMeta_1 = __webpack_require__(110);
	var QueryStateModel_1 = __webpack_require__(90);
	var Initialization_1 = __webpack_require__(95);
	/**
	 * This component enables the use of triggers (<code>notify</code>, <code>execute</code>, <code>query</code>, <code>redirect</code>) generated by the Search API
	 * based on <a href='https://developers.coveo.com/display/public/SearchREST/Trigger'>Trigger statements</a>
	 * in the query pipeline (See <a href='https://developers.coveo.com/display/public/SearchREST/Managing+the+Query+Pipeline'>Managing the Query Pipeline</a>)
	 */
	var Triggers = (function (_super) {
	    __extends(Triggers, _super);
	    /**
	     * Build a new Triggers component
	     * @param element
	     * @param options
	     * @param bindings
	     * @param _window
	     */
	    function Triggers(element, options, bindings, _window) {
	        _super.call(this, element, Triggers.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.bindings = bindings;
	        this._window = _window;
	        this._window = this._window || window;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, Triggers, options);
	        Assert_1.Assert.exists(element);
	        Assert_1.Assert.exists(this.options);
	        this.notifications = [];
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.querySuccess, this.handleProcessNewQueryResults);
	    }
	    Triggers.prototype.handleProcessNewQueryResults = function (data) {
	        var _this = this;
	        Assert_1.Assert.exists(data);
	        Assert_1.Assert.exists(data.results);
	        Dom_1.$$(this.element).empty();
	        this.notifications.length = 0;
	        var showElement = false;
	        if (data.results.triggers === undefined) {
	            Dom_1.$$(this.element).toggleClass('coveo-visible', showElement);
	            return;
	        }
	        this.executeTriggers(data.results.triggers, 'notify', function (trigger) {
	            _this.usageAnalytics.logCustomEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.triggerNotify, {
	                notification: trigger.content
	            }, _this.element);
	            _this.notifications.push(trigger.content);
	            _this.element.appendChild(Dom_1.$$('div', { className: 'coveo-trigger-notify' }, trigger.content).el);
	            showElement = true;
	        });
	        this.executeTriggers(data.results.triggers, 'redirect', function (trigger) {
	            _this.usageAnalytics.logCustomEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.triggerRedirect, {
	                redirectedTo: trigger.content
	            }, _this.element);
	            _this._window.location.replace(trigger.content);
	        }, true);
	        this.executeTriggers(data.results.triggers, 'query', function (trigger) {
	            _this.queryStateModel.set(QueryStateModel_1.QueryStateModel.attributesEnum.q, trigger.content);
	            _this.queryController.executeQuery({
	                beforeExecuteQuery: function () {
	                    _this.usageAnalytics.logCustomEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.triggerQuery, {
	                        query: trigger.content
	                    }, _this.element);
	                }
	            });
	        }, true);
	        this.executeTriggers(data.results.triggers, 'execute', function (trigger) {
	            try {
	                var func = _this._window['' + trigger.content.name];
	                if (typeof func === 'function') {
	                    var params = _.object(_.map(trigger.content.params, function (value, index) {
	                        return ['param' + (index + 1), value];
	                    }));
	                    params['element'] = _this.element;
	                    _this.usageAnalytics.logCustomEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.triggerExecute, {
	                        executed: trigger.content.name
	                    }, _this.element);
	                    func.apply(_this._window, [params]);
	                }
	                else {
	                    _this.logger.error("A trigger tried to call the function '" + trigger.content.name + "', which doesn't exist.", _this, data.query, trigger);
	                }
	            }
	            catch (error) {
	                _this.logger.error("A trigger called the function '" + trigger.content.name + "', which threw an error.", _this, data.query, trigger);
	            }
	        });
	        Dom_1.$$(this.element).toggleClass('coveo-visible', showElement);
	    };
	    Triggers.prototype.executeTriggers = function (trigger, type, func, single) {
	        if (single === void 0) { single = false; }
	        var triggersOfType = _.filter(trigger, function (trigger) {
	            return trigger.type == type;
	        });
	        var oneOrAllTriggers = _.take(triggersOfType, single ? 1 : Number.MAX_VALUE);
	        _.each(oneOrAllTriggers, func);
	    };
	    Triggers.ID = 'Triggers';
	    Triggers.options = {};
	    return Triggers;
	}(Component_1.Component));
	exports.Triggers = Triggers;
	Initialization_1.Initialization.registerAutoCreateComponent(Triggers);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var Utils_1 = __webpack_require__(18);
	var QueryEvents_1 = __webpack_require__(47);
	var Initialization_1 = __webpack_require__(95);
	var Dom_1 = __webpack_require__(57);
	var RecommendationQuery = (function (_super) {
	    __extends(RecommendationQuery, _super);
	    function RecommendationQuery(element, options, bindings) {
	        _super.call(this, element, RecommendationQuery.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, RecommendationQuery, options);
	        if (this.element.tagName.toLowerCase() === 'script') {
	            try {
	                this.content = Utils_1.Utils.decodeHTMLEntities(Dom_1.$$(this.element).text());
	            }
	            catch (e) {
	                return;
	            }
	            if (!_.isUndefined(this.content) && this.content != '') {
	                this.bind.onRootElement(QueryEvents_1.QueryEvents.buildingQuery, this.handleBuildingQuery);
	            }
	        }
	    }
	    RecommendationQuery.prototype.handleBuildingQuery = function (data) {
	        data.queryBuilder.advancedExpression.add(this.content);
	    };
	    RecommendationQuery.ID = 'RecommendationQuery';
	    /**
	     * The options for the RecommendationQuery component
	     * @componentOptions
	     */
	    RecommendationQuery.options = {};
	    return RecommendationQuery;
	}(Component_1.Component));
	exports.RecommendationQuery = RecommendationQuery;
	Initialization_1.Initialization.registerAutoCreateComponent(RecommendationQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var Assert_1 = __webpack_require__(17);
	var Initialization_1 = __webpack_require__(95);
	var Dom_1 = __webpack_require__(57);
	var TemplateLoader = (function (_super) {
	    __extends(TemplateLoader, _super);
	    function TemplateLoader(element, options, bindings, result) {
	        _super.call(this, element, TemplateLoader.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.bindings = bindings;
	        this.result = result;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, TemplateLoader, options);
	        this.result = this.result || this.resolveResult();
	        Assert_1.Assert.exists(this.result);
	        if (this.options.condition != null) {
	            var conditionFunction = new Function('obj', 'with(obj||{}){return ' + this.options.condition + '}');
	            if (conditionFunction(this.result)) {
	                this.initialize();
	            }
	        }
	        else {
	            this.initialize();
	        }
	    }
	    TemplateLoader.prototype.initialize = function () {
	        var _this = this;
	        if (this.options.template != null) {
	            var initOptions = this.searchInterface.options;
	            var initParameters = {
	                options: initOptions,
	                bindings: this.bindings,
	                result: this.result
	            };
	            $(this.element);
	            var parents = Dom_1.$$(this.element).parents(Component_1.Component.computeCssClassName(TemplateLoader));
	            _.each(parents, function (parent) {
	                var clone = parent.cloneNode();
	                Dom_1.$$(clone).empty();
	                var outerHTMLParent = clone.outerHTML;
	                Assert_1.Assert.check(outerHTMLParent.indexOf(_this.element.outerHTML) === -1, 'TemplateLoader cannot load a template into itself.');
	            });
	            this.element.innerHTML = this.options.template.instantiateToString(this.result, false);
	            Initialization_1.Initialization.automaticallyCreateComponentsInside(this.element, initParameters);
	        }
	    };
	    TemplateLoader.ID = 'TemplateLoader';
	    TemplateLoader.options = {
	        template: ComponentOptions_1.ComponentOptions.buildTemplateOption(),
	        condition: ComponentOptions_1.ComponentOptions.buildStringOption()
	    };
	    return TemplateLoader;
	}(Component_1.Component));
	exports.TemplateLoader = TemplateLoader;
	Initialization_1.Initialization.registerAutoCreateComponent(TemplateLoader);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var DomUtils_1 = __webpack_require__(59);
	var Dom_1 = __webpack_require__(57);
	var SuggestionForOmnibox = (function () {
	    function SuggestionForOmnibox(structure, onSelect) {
	        this.structure = structure;
	        this.onSelect = onSelect;
	    }
	    SuggestionForOmnibox.prototype.buildOmniboxElement = function (results, args) {
	        var element;
	        if (results.length != 0) {
	            element = Dom_1.$$('div').el;
	            if (this.structure.header) {
	                var header = this.buildElementHeader();
	                element.appendChild(header);
	            }
	            var rows = this.buildRowElements(results, args);
	            _.each(rows, function (row) {
	                element.appendChild(row);
	            });
	        }
	        return element;
	    };
	    SuggestionForOmnibox.prototype.buildElementHeader = function () {
	        return Dom_1.$$('div', undefined, this.structure.header.template({
	            headerTitle: this.structure.header.title
	        })).el;
	    };
	    SuggestionForOmnibox.prototype.buildRowElements = function (results, args) {
	        var _this = this;
	        var ret = [];
	        _.each(results, function (result) {
	            var row = Dom_1.$$('div', undefined, _this.structure.row({
	                rawValue: result.value,
	                data: DomUtils_1.DomUtils.highlightElement(result.value, args.completeQueryExpression.word)
	            })).el;
	            Dom_1.$$(row).on('click', function () {
	                _this.onSelect.call(_this, result.value, args);
	            });
	            Dom_1.$$(row).on('keyboardSelect', function () {
	                _this.onSelect.call(_this, result.value, args);
	            });
	            ret.push(row);
	        });
	        return ret;
	    };
	    return SuggestionForOmnibox;
	}());
	exports.SuggestionForOmnibox = SuggestionForOmnibox;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var SuggestionForOmnibox_1 = __webpack_require__(221);
	var ComponentOptions_1 = __webpack_require__(98);
	var Component_1 = __webpack_require__(96);
	var Assert_1 = __webpack_require__(17);
	var OmniboxEvents_1 = __webpack_require__(45);
	var QueryEvents_1 = __webpack_require__(47);
	var Strings_1 = __webpack_require__(34);
	var QueryStateModel_1 = __webpack_require__(90);
	var AnalyticsActionListMeta_1 = __webpack_require__(110);
	var Initialization_1 = __webpack_require__(95);
	var Dom_1 = __webpack_require__(57);
	/**
	 * This component is used to provide query suggestions based on the most commonly logged queries by a Coveo Analytics service.
	 * In order to provide relevant suggestions, they are shown in order of successful document views: thus, queries resulting in no clicks from users or that require refinements are not suggested if better options exist.
	 * These suggestions appear in the Omnibox Component. This component is thus highly related to the {@link Analytics} Component.
	 * While a user is typing in a query box, he will be able to see and select the most commonly used queries.
	 */
	var AnalyticsSuggestions = (function (_super) {
	    __extends(AnalyticsSuggestions, _super);
	    function AnalyticsSuggestions(element, options, bindings) {
	        var _this = this;
	        _super.call(this, element, AnalyticsSuggestions.ID, bindings);
	        this.options = options;
	        this.partialQueries = [];
	        this.lastSuggestions = [];
	        this.resultsToBuildWith = [];
	        if (this.options && 'omniboxSuggestionOptions' in this.options) {
	            this.options = _.extend(this.options, this.options['omniboxSuggestionOptions']);
	        }
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, AnalyticsSuggestions, this.options);
	        var rowTemplate = _.template("<div class='magic-box-suggestion coveo-omnibox-selectable coveo-top-analytics-suggestion-row'><%= data %></div>");
	        this.options.onSelect = this.options.onSelect || this.onRowSelection;
	        var suggestionStructure;
	        if (this.searchInterface.isNewDesign()) {
	            suggestionStructure = {
	                row: rowTemplate
	            };
	        }
	        else {
	            var headerTemplate = _.template("<div class='coveo-top-analytics-suggestion-header'><span class='coveo-icon-top-analytics'></span><span class='coveo-caption'><%= headerTitle %></span></div>");
	            suggestionStructure = {
	                header: { template: headerTemplate, title: this.options.headerTitle },
	                row: rowTemplate
	            };
	        }
	        this.suggestionForOmnibox = new SuggestionForOmnibox_1.SuggestionForOmnibox(suggestionStructure, function (value, args) {
	            _this.options.onSelect.call(_this, value, args);
	        });
	        this.bind.onRootElement(OmniboxEvents_1.OmniboxEvents.populateOmnibox, function (args) { return _this.handlePopulateOmnibox(args); });
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.querySuccess, function () { return _this.partialQueries = []; });
	    }
	    AnalyticsSuggestions.prototype.selectSuggestion = function (suggestion) {
	        if (this.currentlyDisplayedSuggestions) {
	            if (isNaN(suggestion)) {
	                if (this.currentlyDisplayedSuggestions[suggestion]) {
	                    Dom_1.$$(this.currentlyDisplayedSuggestions[suggestion].element).trigger('click');
	                }
	            }
	            else {
	                var currentlySuggested = _.findWhere(this.currentlyDisplayedSuggestions, { pos: suggestion });
	                if (currentlySuggested) {
	                    Dom_1.$$(currentlySuggested.element).trigger('click');
	                }
	            }
	        }
	    };
	    AnalyticsSuggestions.prototype.handlePopulateOmnibox = function (args) {
	        var _this = this;
	        Assert_1.Assert.exists(args);
	        var promise = new Promise(function (resolve, reject) {
	            var searchPromise = _this.usageAnalytics.getTopQueries({
	                pageSize: _this.options.numberOfSuggestions,
	                queryText: args.completeQueryExpression.word
	            });
	            searchPromise.then(function (results) {
	                _this.resultsToBuildWith = _.map(results, function (result) {
	                    return {
	                        value: result
	                    };
	                });
	                _this.lastSuggestions = results;
	                if (!_.isEmpty(_this.resultsToBuildWith) && args.completeQueryExpression.word != '') {
	                    _this.partialQueries.push(args.completeQueryExpression.word);
	                }
	                var element = _this.suggestionForOmnibox.buildOmniboxElement(_this.resultsToBuildWith, args);
	                _this.currentlyDisplayedSuggestions = {};
	                _.map(Dom_1.$$(element).findAll('.coveo-omnibox-selectable'), function (selectable, i) {
	                    _this.currentlyDisplayedSuggestions[Dom_1.$$(selectable).text()] = {
	                        element: selectable,
	                        pos: i
	                    };
	                });
	                resolve({
	                    element: element,
	                    zIndex: _this.options.omniboxZIndex
	                });
	            });
	            searchPromise.catch(function () {
	                resolve({
	                    element: undefined
	                });
	            });
	        });
	        args.rows.push({ deferred: promise });
	    };
	    AnalyticsSuggestions.prototype.onRowSelection = function (value, args) {
	        args.clear();
	        args.closeOmnibox();
	        this.queryStateModel.set(QueryStateModel_1.QueryStateModel.attributesEnum.q, value);
	        this.usageAnalytics.logSearchEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.omniboxAnalytics, {
	            partialQueries: this.cleanCustomData(this.partialQueries),
	            suggestionRanking: _.indexOf(_.pluck(this.resultsToBuildWith, 'value'), value),
	            suggestions: this.cleanCustomData(this.lastSuggestions),
	            partialQuery: args.completeQueryExpression.word
	        });
	        this.queryController.executeQuery();
	    };
	    AnalyticsSuggestions.prototype.cleanCustomData = function (toClean, rejectLength) {
	        if (rejectLength === void 0) { rejectLength = 256; }
	        // Filter out only consecutive values that are the identical
	        toClean = _.filter(toClean, function (partial, pos, array) {
	            return pos === 0 || partial !== array[pos - 1];
	        });
	        // Custom dimensions cannot be an array in analytics service: Send a string joined by ; instead.
	        // Need to replace ;
	        toClean = _.map(toClean, function (partial) {
	            return partial.replace(/;/g, '');
	        });
	        // Reduce right to get the last X words that adds to less then rejectLength
	        var reducedToRejectLengthOrLess = [];
	        _.reduceRight(toClean, function (memo, partial) {
	            var totalSoFar = memo + partial.length;
	            if (totalSoFar <= rejectLength) {
	                reducedToRejectLengthOrLess.push(partial);
	            }
	            return totalSoFar;
	        }, 0);
	        toClean = reducedToRejectLengthOrLess.reverse();
	        var ret = toClean.join(';');
	        // analytics service can store max 256 char in a custom event
	        // if we're over that, call cleanup again with an arbitrary 10 less char accepted
	        if (ret.length >= 256) {
	            return this.cleanCustomData(toClean, rejectLength - 10);
	        }
	        return toClean.join(';');
	    };
	    AnalyticsSuggestions.ID = 'AnalyticsSuggestions';
	    /**
	     * The options for the component
	     * @componentOptions
	     */
	    AnalyticsSuggestions.options = {
	        /**
	         * The index at which the suggestions should render in the omnibox. Higher value = placed first.<br/>
	         * The default value is `52`.
	         */
	        omniboxZIndex: ComponentOptions_1.ComponentOptions.buildNumberOption({ defaultValue: 52, min: 0 }),
	        /**
	         * Specifies the title in the Omnibox for this group of suggestions. This option is not available when using the Lightning Friendly Theme, which is the default design.
	         */
	        headerTitle: ComponentOptions_1.ComponentOptions.buildLocalizedStringOption({ defaultValue: Strings_1.l('SuggestedQueries') }),
	        /**
	         * The number of suggestions that should be requested and displayed in the omnibox.<br/>
	         * The default value is `5`.
	         */
	        numberOfSuggestions: ComponentOptions_1.ComponentOptions.buildNumberOption({ defaultValue: 5, min: 1 })
	    };
	    return AnalyticsSuggestions;
	}(Component_1.Component));
	exports.AnalyticsSuggestions = AnalyticsSuggestions;
	Initialization_1.Initialization.registerAutoCreateComponent(AnalyticsSuggestions);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var SuggestionForOmnibox_1 = __webpack_require__(221);
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var Assert_1 = __webpack_require__(17);
	var Utils_1 = __webpack_require__(18);
	var OmniboxEvents_1 = __webpack_require__(45);
	var QueryStateModel_1 = __webpack_require__(90);
	var Initialization_1 = __webpack_require__(95);
	var AnalyticsActionListMeta_1 = __webpack_require__(110);
	var Strings_1 = __webpack_require__(34);
	var Dom_1 = __webpack_require__(57);
	/**
	 * This component provides query suggestions based on a particular facet field.
	 * For example, this can be used to provide auto-complete suggestions when you type in document titles.
	 */
	var FieldSuggestions = (function (_super) {
	    __extends(FieldSuggestions, _super);
	    /**
	     * Create a new `FieldSuggestions` component
	     * @param element
	     * @param options
	     * @param bindings
	     */
	    function FieldSuggestions(element, options, bindings) {
	        var _this = this;
	        _super.call(this, element, FieldSuggestions.ID, bindings);
	        this.options = options;
	        if (this.options && 'omniboxSuggestionOptions' in this.options) {
	            this.options = _.extend(this.options, this.options['omniboxSuggestionOptions']);
	        }
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, FieldSuggestions, options);
	        Assert_1.Assert.check(Utils_1.Utils.isCoveoField(this.options.field), this.options.field + ' is not a valid field');
	        this.options.onSelect = this.options.onSelect || this.onRowSelection;
	        var rowTemplate = _.template("<div class='magic-box-suggestion coveo-omnibox-selectable coveo-top-field-suggestion-row'><%= data %></div>");
	        var suggestionStructure;
	        if (this.searchInterface.isNewDesign()) {
	            suggestionStructure = {
	                row: rowTemplate
	            };
	        }
	        else {
	            var headerTemplate = _.template("<div class='coveo-top-field-suggestion-header'><span class='coveo-icon-top-field'></span><span class='coveo-caption'><%= headerTitle %></span></div>");
	            suggestionStructure = {
	                header: { template: headerTemplate, title: this.options.headerTitle },
	                row: rowTemplate
	            };
	        }
	        this.suggestionForOmnibox = new SuggestionForOmnibox_1.SuggestionForOmnibox(suggestionStructure, function (value, args) {
	            _this.options.onSelect.call(_this, value, args);
	        });
	        this.bind.onRootElement(OmniboxEvents_1.OmniboxEvents.populateOmnibox, function (args) { return _this.handlePopulateOmnibox(args); });
	    }
	    FieldSuggestions.prototype.selectSuggestion = function (suggestion) {
	        if (this.currentlyDisplayedSuggestions) {
	            if (isNaN(suggestion)) {
	                if (this.currentlyDisplayedSuggestions[suggestion]) {
	                    Dom_1.$$(this.currentlyDisplayedSuggestions[suggestion].element).trigger('click');
	                }
	            }
	            else {
	                var currentlySuggested = _.findWhere(this.currentlyDisplayedSuggestions, { pos: suggestion });
	                if (currentlySuggested) {
	                    Dom_1.$$(currentlySuggested.element).trigger('click');
	                }
	            }
	        }
	    };
	    FieldSuggestions.prototype.handlePopulateOmnibox = function (args) {
	        var _this = this;
	        Assert_1.Assert.exists(args);
	        var valueToSearch = args.completeQueryExpression.word;
	        var promise = new Promise(function (resolve) {
	            _this.queryController.getEndpoint().listFieldValues(_this.buildListFieldValueRequest(valueToSearch)).then(function (results) {
	                var element = _this.suggestionForOmnibox.buildOmniboxElement(results, args);
	                _this.currentlyDisplayedSuggestions = {};
	                _.map(Dom_1.$$(element).findAll('.coveo-omnibox-selectable'), function (selectable, i) {
	                    _this.currentlyDisplayedSuggestions[Dom_1.$$(selectable).text()] = {
	                        element: selectable,
	                        pos: i
	                    };
	                });
	                resolve({
	                    element: element,
	                    zIndex: _this.options.omniboxZIndex
	                });
	            }).catch(function () {
	                resolve({
	                    element: undefined
	                });
	            });
	        });
	        args.rows.push({
	            deferred: promise
	        });
	    };
	    FieldSuggestions.prototype.onRowSelection = function (value, args) {
	        args.clear();
	        args.closeOmnibox();
	        this.queryStateModel.set(QueryStateModel_1.QueryStateModel.attributesEnum.q, value);
	        this.usageAnalytics.logSearchEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.omniboxField, {});
	        this.queryController.executeQuery();
	    };
	    FieldSuggestions.prototype.buildListFieldValueRequest = function (valueToSearch) {
	        return {
	            field: this.options.field,
	            ignoreAccents: true,
	            sortCriteria: 'occurrences',
	            maximumNumberOfValues: this.options.numberOfSuggestions,
	            patternType: 'Wildcards',
	            pattern: '*' + valueToSearch + '*',
	            queryOverride: this.options.queryOverride
	        };
	    };
	    FieldSuggestions.ID = 'FieldSuggestions';
	    /**
	     * @componentOptions
	     */
	    FieldSuggestions.options = {
	        /**
	         * Specifies the field from which suggestions are provided.<br/>
	         * This is a required option.
	         */
	        field: ComponentOptions_1.ComponentOptions.buildFieldOption({ required: true }),
	        /**
	         * Specifies a query override (any query expression) which should be applied when retrieving suggestions.
	         */
	        queryOverride: ComponentOptions_1.ComponentOptions.buildStringOption({ defaultValue: '' }),
	        /**
	         * Specifies the position at which the suggestions should render when there are multiple suggestions providers. (eg : {@link Facet} or {@link AnalyticsSuggestions}).<br/>
	         * The default value is 51.
	         */
	        omniboxZIndex: ComponentOptions_1.ComponentOptions.buildNumberOption({ defaultValue: 51, min: 0 }),
	        /**
	         * Specifies the title in the Omnibox for this group of suggestions. This option is not available when using the Lightning Friendly Theme, which is the default design.
	         */
	        headerTitle: ComponentOptions_1.ComponentOptions.buildLocalizedStringOption({ defaultValue: Strings_1.l('SuggestedResults') }),
	        /**
	         * Specifies the number of suggestions that should be rendered in the omnibox.<br/>
	         * Default value is 5.
	         */
	        numberOfSuggestions: ComponentOptions_1.ComponentOptions.buildNumberOption({ defaultValue: 5, min: 1 }),
	        /**
	         * The event handler function to execute when a value is selected in the Omnibox. By default, the query box text is replaced by what was selected and a new query is executed. You can however replace this default text by providing a callback function to execute when the value is selected.
	         * For example:
	         *
	         * ```
	         * Coveo.init(document.querySelector('#search'), {
	         *    FieldSuggestions : {
	         *      omniboxSuggestionOptions : {
	         *        onSelect : function(valueSelected, populateOmniBoxEventArgs){
	         *          // Do something special when a value is selected.
	         *          // You receive the selected value as the first argument, and the Omnibox object as the second parameter.
	         *        }
	         *      }
	         *    }
	         * })
	         *
	         * // OR using the jQuery extension
	         *
	         * $('#mySearch').coveo('init', {
	         *    FieldSuggestions : {
	         *      omniboxSuggestionOptions : {
	         *        onSelect : function(valueSelected, populateOmniBoxEventArgs){
	         *          // Do something special when a value is selected.
	         *          // You receive the selected value as the first argument, and the Omnibox object as the second parameter.
	         *        }
	         *      }
	         *    }
	         * })
	         * ```
	         */
	        onSelect: ComponentOptions_1.ComponentOptions.buildCustomOption(function () {
	            return null;
	        })
	    };
	    return FieldSuggestions;
	}(Component_1.Component));
	exports.FieldSuggestions = FieldSuggestions;
	Initialization_1.Initialization.registerAutoCreateComponent(FieldSuggestions);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	/// <reference path='../../../node_modules/modal-box/bin/ModalBox.d.ts' />
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var Assert_1 = __webpack_require__(17);
	var QueryEvents_1 = __webpack_require__(47);
	var InitializationEvents_1 = __webpack_require__(44);
	var SettingsEvents_1 = __webpack_require__(50);
	var DomUtils_1 = __webpack_require__(59);
	var Dom_1 = __webpack_require__(57);
	var Initialization_1 = __webpack_require__(95);
	var Strings_1 = __webpack_require__(34);
	var ExternalModulesShim_1 = __webpack_require__(25);
	/**
	 * This component arranges for queries to be executed with an identity obtained
	 * using an Authentication Provider configured on the Coveo Search API
	 * (see [On-Premises SharePoint Claims Authentication](https://developers.coveo.com/display/public/SearchREST/On-Premises+SharePoint+Claims+Authentication)).
	 * When needed, the component will handle redirecting the browser to the address
	 * that starts the authentication process.
	 *
	 * Using the standard `data-tab` attribute, you can enable the
	 * `AuthenticationProvider` component only for tabs in which authentication is
	 * required (see {@link Tab}).
	 */
	var AuthenticationProvider = (function (_super) {
	    __extends(AuthenticationProvider, _super);
	    /**
	     * Build a new `AuthenticationProvider` component
	     * @param element
	     * @param options
	     * @param bindings
	     */
	    function AuthenticationProvider(element, options, bindings, _window) {
	        var _this = this;
	        if (options === void 0) { options = {}; }
	        _super.call(this, element, AuthenticationProvider.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this._window = _window;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, AuthenticationProvider, options);
	        Assert_1.Assert.exists(this.options.name);
	        this.handlers = [];
	        this._window = this._window || window;
	        this.redirectCount = 0;
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.buildingCallOptions, this.handleBuildingCallOptions);
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.queryError, this.handleQueryError);
	        this.bind.onRootElement(InitializationEvents_1.InitializationEvents.nuke, this.handleNuke);
	        this.bind.onRootElement(SettingsEvents_1.SettingsEvents.settingsPopulateMenu, function (args) {
	            args.menuData.push({
	                text: Strings_1.l('Reauthenticate', _this.options.caption),
	                className: 'coveo-authentication-provider',
	                onOpen: function () { return _this.authenticateWithProvider(); }
	            });
	        });
	    }
	    AuthenticationProvider.prototype.handleBuildingCallOptions = function (args) {
	        args.options.authentication.push(this.options.name);
	    };
	    AuthenticationProvider.prototype.handleQueryError = function (args) {
	        var missingAuthError = args.error;
	        if (missingAuthError.isMissingAuthentication && missingAuthError.provider === this.options.name && this.redirectCount < 2 && this.redirectCount !== -1) {
	            ++this.redirectCount;
	            this.authenticateWithProvider();
	        }
	        else {
	            this.logger.error('The AuthenticationProvider is in a redirect loop. This may be due to a back-end configuration problem.');
	            this.redirectCount = -1;
	        }
	    };
	    AuthenticationProvider.prototype.authenticateWithProvider = function () {
	        this.options.useIFrame ? this.authenticateWithIFrame() : this.redirectToAuthenticationProvider();
	    };
	    AuthenticationProvider.prototype.redirectToAuthenticationProvider = function () {
	        this.logger.info("Redirecting to authentication provider " + this.options.name);
	        this._window.location.href = this.getAuthenticationProviderUriForRedirect();
	    };
	    AuthenticationProvider.prototype.authenticateWithIFrame = function () {
	        this.logger.info("Using iframe to retrieve authentication for provider " + this.options.name);
	        var iframe = Dom_1.$$('iframe', {
	            'src': this.getAuthenticationProviderUriForIFrame()
	        }).el;
	        var modalbox;
	        modalbox = this.options.showIFrame ? this.createPopupForVisibleIFrame(iframe) : this.createPopupForWaitMessage(iframe);
	        var handler = this.createHandler(modalbox, iframe);
	        Dom_1.$$(this._window).one('message', handler);
	        this.handlers.push(handler);
	    };
	    AuthenticationProvider.prototype.createHandler = function (modalbox, iframe) {
	        var _this = this;
	        return function () {
	            modalbox.close();
	            Dom_1.$$(iframe).detach();
	            _this.logger.info("Got authentication for provider " + _this.options.name + "; retrying query.");
	            _this.queryController.executeQuery();
	        };
	    };
	    AuthenticationProvider.prototype.handleNuke = function () {
	        var _this = this;
	        _.each(this.handlers, function (handler) { return Dom_1.$$(_this._window).off('message', handler); });
	    };
	    AuthenticationProvider.prototype.createPopupForWaitMessage = function (iframe) {
	        var popup = Dom_1.$$('div', {
	            className: 'coveo-waiting-for-authentication-popup'
	        }, DomUtils_1.DomUtils.getBasicLoadingAnimation()).el;
	        Dom_1.$$(iframe).hide();
	        document.body.appendChild(iframe);
	        ExternalModulesShim_1.ModalBox.open(popup, {
	            title: Strings_1.l('Authenticating', this.options.caption)
	        });
	        return ExternalModulesShim_1.ModalBox;
	    };
	    AuthenticationProvider.prototype.createPopupForVisibleIFrame = function (iframe) {
	        Dom_1.$$(iframe).addClass('coveo-authentication-iframe');
	        var popup = Dom_1.$$('div', {}, iframe).el;
	        ExternalModulesShim_1.ModalBox.open(popup, {
	            title: Strings_1.l('Authenticating', this.options.caption),
	            className: 'coveo-authentication-popup'
	        });
	        return ExternalModulesShim_1.ModalBox;
	    };
	    AuthenticationProvider.prototype.getAuthenticationProviderUriForRedirect = function () {
	        return this.queryController.getEndpoint().getAuthenticationProviderUri(this.options.name, this._window.location.href, undefined);
	    };
	    AuthenticationProvider.prototype.getAuthenticationProviderUriForIFrame = function () {
	        return this.queryController.getEndpoint().getAuthenticationProviderUri(this.options.name, undefined, 'success');
	    };
	    AuthenticationProvider.ID = 'AuthenticationProvider';
	    /**
	     * The options for the component.
	     * @componentOptions
	     */
	    AuthenticationProvider.options = {
	        /**
	         * Specifies the name of the authentication provider as specified in the
	         * [Windows Service Configuration File](https://developers.coveo.com/display/public/SearchREST/Windows+Service+Configuration+File).
	         */
	        name: ComponentOptions_1.ComponentOptions.buildStringOption(),
	        /**
	         * Specifies the friendly name of the authentication provider that will be
	         * displayed in the user interface while logging in.<br/>
	         * If not specified, it will default to {@link options.name name}.
	         */
	        caption: ComponentOptions_1.ComponentOptions.buildStringOption({ postProcessing: function (value, options) { return value || options.name; } }),
	        /**
	         * Specifies whether an `<iframe>` will be used to host the chain of
	         * redirections that make up the authentication process.<br/>
	         * By default, this option is set to `false`.
	         *
	         * Using an `<iframe>` avoids leaving the search page as part of the authentication
	         * process, but some login providers will refuse to load in an `<iframe>`.
	         */
	        useIFrame: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: false, attrName: 'data-use-iframe' }),
	        /**
	         * Specifies whether the `<iframe>` used for authentication will be made
	         * visible to the user (inside a popup).<br/>
	         * By default, this option is set to `true`.
	         *
	         * When the underlying authentication provider requires no user interaction
	         * (for example, when Windows Authentication is used along with SharePoint Claims),
	         * using this option reduces the visual impact of the authentication process.
	         *
	         */
	        showIFrame: ComponentOptions_1.ComponentOptions.buildBooleanOption({
	            defaultValue: true,
	            attrName: 'data-show-iframe',
	            depend: 'useIFrame'
	        })
	    };
	    return AuthenticationProvider;
	}(Component_1.Component));
	exports.AuthenticationProvider = AuthenticationProvider;
	Initialization_1.Initialization.registerAutoCreateComponent(AuthenticationProvider);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var Assert_1 = __webpack_require__(17);
	var Utils_1 = __webpack_require__(18);
	var Initialization_1 = __webpack_require__(95);
	var StringUtils_1 = __webpack_require__(61);
	var Strings_1 = __webpack_require__(34);
	var KeyboardUtils_1 = __webpack_require__(68);
	var QueryStateModel_1 = __webpack_require__(90);
	var Dom_1 = __webpack_require__(57);
	var AnalyticsActionListMeta_1 = __webpack_require__(110);
	/**
	 * This component can be used as part of a result template to list the current tag field values for the search result.
	 * and display a control that allows end-users to add a value to a tag field.
	 */
	var ResultTagging = (function (_super) {
	    __extends(ResultTagging, _super);
	    function ResultTagging(element, options, bindings, result) {
	        _super.call(this, element, ResultTagging.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.result = result;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, ResultTagging, options);
	        this.result = result || this.resolveResult();
	        Assert_1.Assert.exists(this.componentOptionsModel);
	        Assert_1.Assert.exists(this.result);
	        if (!this.options.field) {
	            this.logger.error('You must specify a field to the ResultTagging component');
	            return;
	        }
	        var fieldValue = Utils_1.Utils.getFieldValue(this.result, this.options.field);
	        if (fieldValue) {
	            this.tags = fieldValue.split(';');
	            this.tags = _.map(this.tags, function (t) {
	                return t.trim();
	            });
	        }
	        else {
	            this.tags = [];
	        }
	        this.tagZone = Dom_1.$$('div', {
	            className: 'coveo-result-tagging-tag-zone'
	        }).el;
	        element.appendChild(this.tagZone);
	        element.appendChild(this.buildTagIcon());
	        this.autoCompleteZone = Dom_1.$$('div', {
	            className: 'coveo-result-tagging-auto-complete-zone'
	        }).el;
	        element.appendChild(this.autoCompleteZone);
	        this.autoCompleteZone.appendChild(this.buildTextBox());
	        this.autoCompleteZone.appendChild(this.buildAddIcon());
	        this.autoCompleteZone.appendChild(this.buildClearIcon());
	        this.buildExistingTags();
	    }
	    ResultTagging.prototype.buildExistingTags = function () {
	        var _this = this;
	        if (this.tags) {
	            _.each(this.tags, function (tag) {
	                _this.tagZone.appendChild(_this.buildTagValue(tag));
	            });
	        }
	    };
	    ResultTagging.prototype.buildTagIcon = function () {
	        var _this = this;
	        var tagZone = Dom_1.$$('div', {
	            className: 'coveo-result-tagging-add-tag'
	        });
	        var tagTextBox = Dom_1.$$('span', {
	            className: 'coveo-result-tagging-add-tag-text'
	        });
	        tagTextBox.text(Strings_1.l('EnterTag'));
	        var tagIcon = Dom_1.$$('span', {
	            className: 'coveo-result-tagging-add-tag-icon'
	        });
	        tagIcon.on('click', function () {
	            _.defer(function () {
	                _this.focusOnTextBox();
	            }, 20);
	        });
	        tagZone.el.appendChild(tagIcon.el);
	        tagZone.append(tagTextBox.el);
	        tagZone.setAttribute('title', Strings_1.l('EnterTag'));
	        return tagZone.el;
	    };
	    ResultTagging.prototype.focusOnTextBox = function () {
	        this.textBox.focus();
	    };
	    ResultTagging.prototype.buildTagValue = function (tagValue) {
	        var _this = this;
	        var tag = Dom_1.$$('div', {
	            className: 'coveo-result-tagging-coveo-tag'
	        });
	        tag.el.appendChild(this.buildShortenedTagWithTitle(tagValue));
	        var deleteIcon = Dom_1.$$('span', {
	            className: 'coveo-result-tagging-delete-icon'
	        });
	        tag.el.appendChild(deleteIcon.el);
	        deleteIcon.on('click', function () {
	            _this.doRemoveTag(tag.el, tagValue.toLowerCase());
	        });
	        return tag.el;
	    };
	    ResultTagging.prototype.buildShortenedTagWithTitle = function (tagValue) {
	        var shortenedTag = StringUtils_1.StringUtils.removeMiddle(tagValue, 16, '...');
	        var clickableValue = Dom_1.$$('a', {
	            title: tagValue,
	            href: 'javascript:void(0);'
	        });
	        clickableValue.text(shortenedTag);
	        this.bindFacetEventOnValue(clickableValue.el, tagValue);
	        return clickableValue.el;
	    };
	    ResultTagging.prototype.buildTextBox = function () {
	        var _this = this;
	        this.textBox = Dom_1.$$('input', {
	            type: 'text',
	            className: 'coveo-add-tag-textbox',
	            placeholder: Strings_1.l('EnterTag')
	        }).el;
	        this.autoCompletePopup = Dom_1.$$('div', {
	            className: ResultTagging.autoCompleteClass
	        }).el;
	        this.autoCompleteZone.appendChild(this.autoCompletePopup);
	        this.manageAutocompleteAutoHide();
	        Dom_1.$$(this.textBox).on('keyup', (function (e) {
	            if (e.keyCode == KeyboardUtils_1.KEYBOARD.UP_ARROW || e.keyCode == KeyboardUtils_1.KEYBOARD.DOWN_ARROW || e.keyCode == KeyboardUtils_1.KEYBOARD.ENTER) {
	                _this.manageUpDownEnter(e.keyCode);
	            }
	            else if (!KeyboardUtils_1.KeyboardUtils.isArrowKeyPushed(e.keyCode)) {
	                _this.populateSuggestions();
	            }
	            Dom_1.$$(_this.element).removeClass('coveo-error');
	        }));
	        Dom_1.$$(this.textBox).on('click', function () {
	            _this.populateSuggestions();
	        });
	        return this.textBox;
	    };
	    ResultTagging.prototype.buildAddIcon = function () {
	        var _this = this;
	        var icon = Dom_1.$$('div', {
	            className: 'coveo-result-tagging-add-tag-tick-icon'
	        });
	        var clickable = Dom_1.$$('span');
	        clickable.on('click', function () {
	            _this.doAddTag();
	        });
	        icon.el.appendChild(clickable.el);
	        return icon.el;
	    };
	    ResultTagging.prototype.buildClearIcon = function () {
	        var _this = this;
	        var icon = Dom_1.$$('div', {
	            className: 'coveo-result-tagging-clear-icon'
	        });
	        var clickable = Dom_1.$$('span');
	        clickable.on('click', function () {
	            _this.textBox.value = '';
	        });
	        icon.el.appendChild(clickable.el);
	        return icon.el;
	    };
	    ResultTagging.prototype.bindFacetEventOnValue = function (element, value) {
	        var _this = this;
	        var facetAttributeName = QueryStateModel_1.QueryStateModel.getFacetId(this.options.field);
	        var facetModel = this.queryStateModel.get(facetAttributeName);
	        var facets = this.componentStateModel.get(facetAttributeName);
	        var atLeastOneFacetIsEnabled = _.filter(facets, function (value) { return !value.disabled; }).length > 0;
	        if (facetModel != null && atLeastOneFacetIsEnabled) {
	            Dom_1.$$(element).on('click', function () {
	                if (_.contains(facetModel, value)) {
	                    _this.queryStateModel.set(facetAttributeName, _.without(facetModel, value));
	                }
	                else {
	                    _this.queryStateModel.set(facetAttributeName, _.union(facetModel, [value]));
	                }
	                _this.queryController.deferExecuteQuery({
	                    beforeExecuteQuery: function () { return _this.usageAnalytics.logSearchEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.documentTag, {
	                        facetId: _this.options.field,
	                        facetValue: value
	                    }); }
	                });
	            });
	            if (_.contains(facetModel, value)) {
	                Dom_1.$$(element).addClass('coveo-selected');
	            }
	            Dom_1.$$(element).addClass('coveo-clickable');
	        }
	    };
	    ResultTagging.prototype.clearPopup = function () {
	        Dom_1.$$(this.autoCompletePopup).hide();
	        Dom_1.$$(this.autoCompletePopup).empty();
	    };
	    ResultTagging.prototype.showPopup = function () {
	        Dom_1.$$(this.autoCompletePopup).show();
	    };
	    ResultTagging.prototype.populateSuggestions = function () {
	        var _this = this;
	        var endpoint = this.queryController.getEndpoint();
	        var searchText = this.textBox.value;
	        var searchOptions = {
	            field: this.options.field,
	            ignoreAccents: true,
	            sortCriteria: 'occurences',
	            maximumNumberOfValues: this.options.suggestBoxSize,
	            queryOverride: '@uri',
	            pattern: this.buildRegEx(searchText),
	            patternType: 'RegularExpression'
	        };
	        endpoint.listFieldValues(searchOptions).then(function (fieldValues) {
	            _this.clearPopup();
	            _.each(fieldValues, function (fieldValue) {
	                _this.autoCompletePopup.appendChild(_this.buildSelectableValue(fieldValue.lookupValue));
	            });
	            _this.showPopup();
	            _this.autoCompletePopup.style.width = _this.textBox.offsetWidth + ' px';
	        });
	    };
	    ResultTagging.prototype.manageAutocompleteAutoHide = function () {
	        var _this = this;
	        var timeout;
	        Dom_1.$$(this.textBox).on('mouseover', function () {
	            clearTimeout(timeout);
	        });
	        Dom_1.$$(this.autoCompletePopup).on('mouseout', (function (e) {
	            if (Dom_1.$$(e.target).hasClass(ResultTagging.autoCompleteClass)) {
	                timeout = setTimeout(function () {
	                    _this.clearPopup();
	                }, _this.options.autoCompleteTimer);
	            }
	        }));
	        Dom_1.$$(this.autoCompletePopup).on('mouseenter', (function () {
	            clearTimeout(timeout);
	        }));
	        Dom_1.$$(this.element).on('mouseenter', (function () {
	            _this.clearPopup();
	            Dom_1.$$(_this.element).addClass('coveo-opened');
	        }));
	        Dom_1.$$(Dom_1.$$(this.element).closest('.CoveoResult')).on('mouseleave', (function () {
	            _this.clearPopup();
	            if (_this.textBox.value == '') {
	                Dom_1.$$(_this.element).removeClass('coveo-opened');
	            }
	        }));
	        Dom_1.$$(Dom_1.$$(this.element).closest('.CoveoResult')).on('focusout', (function (e) {
	            if (_this.textBox.value != '' && (Dom_1.$$(e.target).closest('.CoveoResult') != Dom_1.$$(_this.element).closest('.CoveoResult'))) {
	                Dom_1.$$(_this.element).addClass('coveo-error');
	            }
	        }));
	        Dom_1.$$(Dom_1.$$(this.element).closest('.CoveoResult')).on('focusin', (function () {
	            Dom_1.$$(_this.element).removeClass('coveo-error');
	        }));
	    };
	    // Exclude tags that are already on the result (Since we can tag with the same value twice.
	    ResultTagging.prototype.buildRegEx = function (searchTerm) {
	        var _this = this;
	        return '(?=.*' + searchTerm + ')' + _.map(this.tags, function (tag) { return _this.buildTermToExclude(tag); }).join('') + '.*';
	    };
	    ResultTagging.prototype.buildTermToExclude = function (term) {
	        return '(?!^' + term + '$)';
	    };
	    ResultTagging.prototype.manageUpDownEnter = function (code) {
	        var selectableArray = Dom_1.$$(this.element).findAll('.coveo-selectable');
	        if (code == KeyboardUtils_1.KEYBOARD.ENTER) {
	            this.doAddTag();
	            return;
	        }
	        if (selectableArray.length > 0) {
	            var newIndex = this.computeNextIndex(code, selectableArray);
	            newIndex = Math.max(0, newIndex);
	            newIndex = Math.min(selectableArray.length - 1, newIndex);
	            var selected = Dom_1.$$(selectableArray[newIndex]);
	            selected.addClass('coveo-selected');
	            this.textBox.value = selected.text();
	        }
	    };
	    ResultTagging.prototype.computeNextIndex = function (code, selectableArray) {
	        var nextIndex = 0;
	        _.each(selectableArray, function (selectable, index) {
	            if (Dom_1.$$(selectable).hasClass('coveo-selected')) {
	                if (code == KeyboardUtils_1.KEYBOARD.UP_ARROW) {
	                    nextIndex = index - 1;
	                }
	                else if (code == KeyboardUtils_1.KEYBOARD.DOWN_ARROW) {
	                    nextIndex = index + 1;
	                }
	                Dom_1.$$(selectable).removeClass('coveo-selected');
	            }
	        });
	        return nextIndex;
	    };
	    ResultTagging.prototype.buildSelectableValue = function (lookupValue) {
	        var _this = this;
	        var line = Dom_1.$$('div', {
	            className: 'coveo-selectable'
	        });
	        line.el.appendChild(this.buildShortenedTagWithTitle(lookupValue));
	        line.on('click', function () {
	            _this.doAddTagWithValue(lookupValue);
	        });
	        return line.el;
	    };
	    ResultTagging.prototype.doRemoveTag = function (element, tagValue) {
	        var _this = this;
	        var request = {
	            fieldName: this.options.field,
	            fieldValue: tagValue,
	            doAdd: false,
	            uniqueId: this.result.uniqueId
	        };
	        this.queryController.getEndpoint().tagDocument(request).then(function () {
	            _this.tags.splice(_.indexOf(_this.tags, tagValue), 1);
	            Dom_1.$$(element).detach();
	        });
	    };
	    ResultTagging.prototype.doAddTagWithValue = function (tagValue) {
	        var _this = this;
	        _.each(tagValue.split(','), function (tag) {
	            _this.doAddSingleTagValue(tag);
	        });
	    };
	    ResultTagging.prototype.doAddSingleTagValue = function (tagValue) {
	        var _this = this;
	        this.clearPopup();
	        if (_.indexOf(this.tags, tagValue) > -1) {
	            Dom_1.$$(this.element).addClass('coveo-error');
	            return;
	        }
	        this.tags.push(tagValue);
	        var request = {
	            fieldName: this.options.field,
	            fieldValue: tagValue,
	            doAdd: true,
	            uniqueId: this.result.uniqueId
	        };
	        this.queryController.getEndpoint().tagDocument(request).then(function () {
	            _this.tagZone.appendChild(_this.buildTagValue(tagValue));
	            _this.textBox.value = '';
	            Dom_1.$$(_this.element).removeClass('coveo-error');
	        }).catch(function () {
	            // We do this otherwise it's possible to add the same tag while we wait for the server's response
	            _this.tags = _.without(_this.tags, _.findWhere(_this.tags, tagValue));
	        });
	    };
	    ResultTagging.prototype.doAddTag = function () {
	        var tagValue = Utils_1.Utils.trim(this.textBox.value.toLowerCase());
	        this.doAddTagWithValue(tagValue);
	    };
	    ResultTagging.ID = 'ResultTagging';
	    ResultTagging.autoCompleteClass = 'coveo-result-tagging-auto-complete';
	    /**
	     * @componentOptions
	     */
	    ResultTagging.options = {
	        /**
	         * Specifies the tag field used by the component.<br/>
	         * It is required, and if not specified, the component will not load.
	         */
	        field: ComponentOptions_1.ComponentOptions.buildFieldOption({
	            match: function (field) { return field.type == 'Tag'; },
	            required: true
	        }),
	        /**
	         * Specifies the number of items to show in the suggested item list.<br/>
	         * Default value is 5.
	         */
	        suggestBoxSize: ComponentOptions_1.ComponentOptions.buildNumberOption({ defaultValue: 5, min: 0 }),
	        /**
	         * Specifies how long to wait in milliseconds until the suggested item list disappears when you focus out.<br/>
	         * Default valus is 2000.
	         */
	        autoCompleteTimer: ComponentOptions_1.ComponentOptions.buildNumberOption({ defaultValue: 2000, min: 0 })
	    };
	    ResultTagging.AUTO_COMPLETE_CLASS = 'coveo-result-tagging-auto-complete';
	    return ResultTagging;
	}(Component_1.Component));
	exports.ResultTagging = ResultTagging;
	Initialization_1.Initialization.registerAutoCreateComponent(ResultTagging);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var ComponentOptionsModel_1 = __webpack_require__(91);
	var LocalStorageUtils_1 = __webpack_require__(69);
	var PreferencesPanel_1 = __webpack_require__(209);
	var PreferencesPanelItem_1 = __webpack_require__(211);
	var PreferencesPanelEvents_1 = __webpack_require__(46);
	var AnalyticsActionListMeta_1 = __webpack_require__(110);
	var Initialization_1 = __webpack_require__(95);
	var Assert_1 = __webpack_require__(17);
	var Strings_1 = __webpack_require__(34);
	var Dom_1 = __webpack_require__(57);
	/**
	 * This component allows users to select preferences related to their search results.<br/>
	 * These preferences are saved in the localStorage of each user.<br/>
	 * This component is normally accessible visually using the {@link Settings} menu.<br/>
	 * It is usually located, in the DOM, inside the {@link PreferencesPanel} component.
	 */
	var ResultsPreferences = (function (_super) {
	    __extends(ResultsPreferences, _super);
	    /**
	     * Create a new ResultsPreference component
	     * @param element
	     * @param options
	     * @param bindings
	     */
	    function ResultsPreferences(element, options, bindings) {
	        var _this = this;
	        _super.call(this, element, ResultsPreferences.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.bindings = bindings;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, ResultsPreferences, options);
	        this.preferencesPanel = Dom_1.$$(this.element).closest(Component_1.Component.computeCssClassName(PreferencesPanel_1.PreferencesPanel));
	        this.preferencePanelLocalStorage = new LocalStorageUtils_1.LocalStorageUtils(ResultsPreferences.ID);
	        Assert_1.Assert.exists(this.componentOptionsModel);
	        Assert_1.Assert.exists(window.localStorage);
	        Assert_1.Assert.exists(this.preferencesPanel);
	        this.preferences = this.preferencePanelLocalStorage.load() || {};
	        ComponentOptions_1.ComponentOptions.initComponentOptions(this.element, ResultsPreferences, this.preferences);
	        this.updateComponentOptionsModel();
	        this.bind.on(this.preferencesPanel, PreferencesPanelEvents_1.PreferencesPanelEvents.savePreferences, function () { return _this.save(); });
	        this.bind.on(this.preferencesPanel, PreferencesPanelEvents_1.PreferencesPanelEvents.exitPreferencesWithoutSave, function () { return _this.exitWithoutSave(); });
	        this.buildTitle();
	        this.buildCheckboxesInput();
	    }
	    /**
	     * Save the current state of the preferences to local storage
	     */
	    ResultsPreferences.prototype.save = function () {
	        this.fromCheckboxInputToPreferences();
	        this.logger.info('Saving preferences', this.preferences);
	        this.preferencePanelLocalStorage.save(this.preferences);
	        this.updateComponentOptionsModel();
	    };
	    ResultsPreferences.prototype.exitWithoutSave = function () {
	        this.fromPreferencesToCheckboxInput();
	    };
	    ResultsPreferences.prototype.updateComponentOptionsModel = function () {
	        this.componentOptionsModel.set(ComponentOptionsModel_1.ComponentOptionsModel.attributesEnum.resultLink, this.preferences);
	    };
	    ResultsPreferences.prototype.buildTitle = function () {
	        var title = Dom_1.$$('div', {
	            className: 'coveo-title'
	        }, Strings_1.l('LinkOpeningSettings'));
	        this.element.appendChild(title.el);
	    };
	    ResultsPreferences.prototype.buildCheckboxesInput = function () {
	        var _this = this;
	        var inputs = [];
	        if (this.options.enableOpenInOutlook) {
	            inputs.push({ label: Strings_1.l('OpenInOutlookWhenPossible') });
	        }
	        if (this.options.enableOpenInNewWindow) {
	            inputs.push({ label: Strings_1.l('AlwaysOpenInNewWindow') });
	        }
	        this.preferencePanelCheckboxInput = new PreferencesPanelItem_1.PreferencesPanelCheckboxInput(inputs, ResultsPreferences.ID);
	        var container = Dom_1.$$('div', {
	            className: 'coveo-choices-container'
	        });
	        container.el.appendChild(this.preferencePanelCheckboxInput.build());
	        var executeOnChange = container.findAll('input');
	        _.each(executeOnChange, function (toExec) {
	            Dom_1.$$(toExec).on('change', function (e) {
	                _this.fromPreferenceChangeEventToUsageAnalyticsLog(e);
	                _this.save();
	                _this.queryController.executeQuery();
	            });
	        });
	        this.element.appendChild(container.el);
	        this.fromPreferencesToCheckboxInput();
	    };
	    ResultsPreferences.prototype.fromCheckboxInputToPreferences = function () {
	        var selected = this.preferencePanelCheckboxInput.getSelecteds();
	        this.preferences = {
	            openInOutlook: false,
	            alwaysOpenInNewWindow: false
	        };
	        if (_.contains(selected, Strings_1.l('OpenInOutlookWhenPossible'))) {
	            this.preferences.openInOutlook = true;
	        }
	        if (_.contains(selected, Strings_1.l('AlwaysOpenInNewWindow'))) {
	            this.preferences.alwaysOpenInNewWindow = true;
	        }
	    };
	    ResultsPreferences.prototype.fromPreferencesToCheckboxInput = function () {
	        if (this.preferences.openInOutlook) {
	            this.preferencePanelCheckboxInput.select(Strings_1.l('OpenInOutlookWhenPossible'));
	        }
	        if (this.preferences.alwaysOpenInNewWindow) {
	            this.preferencePanelCheckboxInput.select(Strings_1.l('AlwaysOpenInNewWindow'));
	        }
	    };
	    ResultsPreferences.prototype.fromPreferenceChangeEventToUsageAnalyticsLog = function (e) {
	        var type = e.target.checked ? 'selected' : 'unselected';
	        var preference = e.target.value;
	        this.usageAnalytics.logCustomEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.preferencesChange, { preferenceName: preference, preferenceType: type }, this.element);
	        this.usageAnalytics.logSearchEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.preferencesChange, { preferenceName: preference, preferenceType: type });
	    };
	    ResultsPreferences.ID = 'ResultsPreferences';
	    /**
	     * The options for the component
	     * @componentOptions
	     */
	    ResultsPreferences.options = {
	        /**
	         * Enable or disable the options to open results in Outlook.<br/>
	         * Default value is <code>true</code>
	         */
	        enableOpenInOutlook: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true }),
	        /**
	         * Enable or disable the options to open results in a new window.<br/>
	         * Default value is <code>true</code>
	         */
	        enableOpenInNewWindow: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true })
	    };
	    return ResultsPreferences;
	}(Component_1.Component));
	exports.ResultsPreferences = ResultsPreferences;
	Initialization_1.Initialization.registerAutoCreateComponent(ResultsPreferences);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var Utils_1 = __webpack_require__(18);
	var QueryEvents_1 = __webpack_require__(47);
	var Dom_1 = __webpack_require__(57);
	var Initialization_1 = __webpack_require__(95);
	var PipelineContext = (function (_super) {
	    __extends(PipelineContext, _super);
	    function PipelineContext(element, options, bindings) {
	        var _this = this;
	        _super.call(this, element, PipelineContext.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.bindings = bindings;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, PipelineContext, options);
	        if (this.element.tagName.toLowerCase() == 'script') {
	            try {
	                // Content can be HTML encoded for special char ({!})
	                this.content = JSON.parse(Utils_1.Utils.decodeHTMLEntities($(this.element).text()));
	            }
	            catch (e) {
	                try {
	                    this.content = JSON.parse(Dom_1.$$(this.element).text());
	                }
	                catch (e) {
	                    return;
	                }
	            }
	        }
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.buildingQuery, function (args) { return _this.handleBuildingQuery(args); });
	    }
	    PipelineContext.prototype.handleBuildingQuery = function (args) {
	        var _this = this;
	        if (args.queryBuilder.context == null) {
	            args.queryBuilder.context = {};
	        }
	        var keys = this.getContextKeys();
	        _.each(keys, function (key) {
	            args.queryBuilder.context[key] = _this.getContextValue(key);
	        });
	    };
	    PipelineContext.prototype.getContextKeys = function () {
	        return this.content ? _.keys(this.content) : [];
	    };
	    PipelineContext.prototype.getContextValue = function (key) {
	        return this.content[key].replace(/\{\!([^\}]+)\}/g, function (all, contextKey) {
	            if (Coveo.context != null && contextKey in Coveo.context) {
	                return Coveo.context[contextKey];
	            }
	            else if (contextKey == PipelineContext.CURRENT_URL) {
	                return window.location.href;
	            }
	            return '';
	        });
	    };
	    PipelineContext.ID = 'PipelineContext';
	    PipelineContext.CURRENT_URL = 'CurrentUrl';
	    return PipelineContext;
	}(Component_1.Component));
	exports.PipelineContext = PipelineContext;
	Initialization_1.Initialization.registerAutoCreateComponent(PipelineContext);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var Dom_1 = __webpack_require__(57);
	var Strings_1 = __webpack_require__(34);
	var ResultList_1 = __webpack_require__(128);
	var OmniboxEvents_1 = __webpack_require__(45);
	var ComponentOptions_1 = __webpack_require__(98);
	var QueryEvents_1 = __webpack_require__(47);
	var AnalyticsActionListMeta_1 = __webpack_require__(110);
	var Assert_1 = __webpack_require__(17);
	var Utils_1 = __webpack_require__(18);
	var Initialization_1 = __webpack_require__(95);
	/**
	 * This component is exactly like a normal ResultList Component, except that it will render itself inside the Omnibox component.
	 * This will provide a kind of search as you type functionnality, allowing you to easily render complex Result Templates inside the Omnibox component.
	 *
	 * # Example
	 * ```
	 *     <div class="CoveoOmniboxResultList">
	 *         <script class="result-template" type="text/x-underscore">
	 *             <div>
	 *                 <a class='CoveoResultLink'></a>
	 *             </div>
	 *         </script>
	 *     </div>
	 * ```
	 */
	var OmniboxResultList = (function (_super) {
	    __extends(OmniboxResultList, _super);
	    function OmniboxResultList(element, options, bindings) {
	        var _this = this;
	        _super.call(this, element, options, bindings, OmniboxResultList.ID);
	        this.element = element;
	        this.options = options;
	        this.bindings = bindings;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, OmniboxResultList, options);
	        this.setupOptions();
	        this.bind.onRootElement(OmniboxEvents_1.OmniboxEvents.populateOmnibox, function (args) { return _this.handlePopulateOmnibox(args); });
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.buildingQuery, function (args) { return _this.handleQueryOverride(args); });
	    }
	    /**
	     * Build and return an array of `HTMLElement` with the given result set.
	     * @param results
	     */
	    OmniboxResultList.prototype.buildResults = function (results) {
	        var _this = this;
	        return _.map(results.results, function (result) {
	            var resultElement = _this.buildResult(result);
	            Dom_1.$$(resultElement).addClass('coveo-omnibox-selectable');
	            Dom_1.$$(resultElement).on('keyboardSelect', function () {
	                _this.options.onSelect.call(_this, result, resultElement, _this.lastOmniboxRequest.omniboxObject);
	            });
	            _this.autoCreateComponentsInsideResult(resultElement, result);
	            return resultElement;
	        });
	    };
	    OmniboxResultList.prototype.renderResults = function (resultsElement, append) {
	        var _this = this;
	        if (append === void 0) { append = false; }
	        if (this.lastOmniboxRequest) {
	            var content_1 = Dom_1.$$('div').el;
	            content_1.appendChild(Dom_1.$$('div', { className: 'coveo-omnibox-result-list-header' }, Dom_1.$$('span', { className: 'coveo-icon-omnibox-result-list' }).el, Dom_1.$$('span', { className: 'coveo-caption' }, (this.options.headerTitle || Strings_1.l('SuggestedResults'))).el).el);
	            _.each(resultsElement, function (resultElement) {
	                content_1.appendChild(resultElement);
	                _this.triggerNewResultDisplayed(Component_1.Component.getResult(resultElement), resultElement);
	            });
	            this.triggerNewResultsDisplayed();
	            this.lastOmniboxRequest.resolve({ element: content_1, zIndex: this.options.omniboxZIndex });
	        }
	    };
	    OmniboxResultList.prototype.setupOptions = function () {
	        this.logger.info('Disabling infinite scroll for OmniboxResultList', this);
	        this.options.enableInfiniteScroll = false;
	        this.options.onSelect = this.options.onSelect || this.onRowSelection;
	    };
	    OmniboxResultList.prototype.handlePopulateOmnibox = function (args) {
	        var _this = this;
	        var promise = new Promise(function (resolve, reject) {
	            _this.queryController.executeQuery({
	                beforeExecuteQuery: function () { return _this.usageAnalytics.logSearchAsYouType(AnalyticsActionListMeta_1.analyticsActionCauseList.searchboxSubmit, {}); },
	                searchAsYouType: true
	            });
	            _this.lastOmniboxRequest = { omniboxObject: args, resolve: resolve };
	        });
	        args.rows.push({
	            deferred: promise
	        });
	    };
	    OmniboxResultList.prototype.handleQueryOverride = function (args) {
	        Assert_1.Assert.exists(args);
	        if (Utils_1.Utils.isNonEmptyString(this.options.queryOverride)) {
	            args.queryBuilder.constantExpression.add(this.options.queryOverride);
	        }
	    };
	    OmniboxResultList.prototype.onRowSelection = function (result, resultElement, omniboxObject) {
	        this.usageAnalytics.logClickEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.documentOpen, { author: result.raw.author }, result, this.root);
	        window.location.href = result.clickUri;
	    };
	    OmniboxResultList.ID = 'OmniboxResultList';
	    /**
	     * The options for the component
	     * @componentOptions
	     */
	    OmniboxResultList.options = {
	        /**
	         * Specifies the index at which the result list should render itself inside the Omnibox.
	         *
	         * The default value is 51 (facets are at 50 by default).
	         */
	        omniboxZIndex: ComponentOptions_1.ComponentOptions.buildNumberOption({ defaultValue: 51, min: 16 }),
	        /**
	         * Specifies the title that you want for this section.
	         *
	         * By default this will be Suggested Results.
	         */
	        headerTitle: ComponentOptions_1.ComponentOptions.buildStringOption(),
	        /**
	         * Specifies the override you want to use on the query sent to the OmniboxResultList component.
	         *
	         * By default, there's no override applied.
	         */
	        queryOverride: ComponentOptions_1.ComponentOptions.buildStringOption(),
	        /**
	         * Specifies the function you wish to execute when a result suggestion is selected.
	         *
	         * By default, it will open the corresponding result URI in your browser.
	         *
	         * ```javascript
	         * Coveo.init(document.querySelector('#search'), {
	         *    OmniboxResultList : {
	         *        //Close the omnibox, change the selected HTMLElement background color and alert the result title.
	         *        onSelect:   function(result, resultElement, omniBoxObject) {
	         *            omniBoxObject.close();
	         *            resultElement.css('background-color', 'red');
	         *            alert(result.title);
	         *        }
	         *     }
	         * })
	         *
	         * // OR using the jQuery extention
	         *
	         * $("#search").coveo("init", {
	         *    OmniboxResultList : {
	         *        //Close the Omnibox, change the selected HTMLElement background color and alert the result title.
	         *        onSelect:   function(result, resultElement, omniBoxObject) {
	         *            omniBoxObject.close();
	         *            resultElement.css('background-color', 'red');
	         *            alert(result.title);
	         *        }
	         *     }
	         * })
	         * ```
	         */
	        onSelect: ComponentOptions_1.ComponentOptions.buildCustomOption(function () {
	            return null;
	        })
	    };
	    return OmniboxResultList;
	}(ResultList_1.ResultList));
	exports.OmniboxResultList = OmniboxResultList;
	Initialization_1.Initialization.registerAutoCreateComponent(OmniboxResultList);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var Model_1 = __webpack_require__(87);
	var QueryStateModel_1 = __webpack_require__(90);
	var Utils_1 = __webpack_require__(18);
	var Tab_1 = __webpack_require__(161);
	var Assert_1 = __webpack_require__(17);
	var Initialization_1 = __webpack_require__(95);
	var Dom_1 = __webpack_require__(57);
	/**
	 * This component is used to display the name of the currently selected tab.
	 * If no tabs are selected, this component is hidden.
	 */
	var CurrentTab = (function (_super) {
	    __extends(CurrentTab, _super);
	    function CurrentTab(element, options, bindings) {
	        var _this = this;
	        _super.call(this, element, CurrentTab.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, CurrentTab, options);
	        var eventName = this.queryStateModel.getEventName(Model_1.Model.eventTypes.changeOne + QueryStateModel_1.QueryStateModel.attributesEnum.t);
	        this.bind.onRootElement(eventName, this.handleTabChange);
	        if (this.options.tabSectionToOpen) {
	            var tabSection_1 = Dom_1.$$(this.root).find(this.options.tabSectionToOpen);
	            Dom_1.$$(tabSection_1).addClass('coveo-targeted-by-current-tab');
	            Dom_1.$$(this.element).addClass('coveo-targeting-tab-section');
	            this.bind.on(this.element, 'click', function () {
	                var glassElement = Dom_1.$$(_this.root).find('.coveo-glass');
	                if (glassElement) {
	                    var glass = Dom_1.$$(glassElement);
	                    glass.toggleClass('coveo-active-glass');
	                    glass.toggleClass('coveo-active-glass-for-current-tab');
	                }
	                Dom_1.$$(_this.element).toggleClass('coveo-opening-tab-section');
	                Dom_1.$$(tabSection_1).toggleClass('coveo-opened-by-current-tab');
	                if (Dom_1.$$(_this.element).hasClass('coveo-opening-tab-section')) {
	                    tabSection_1.style.zIndex = '1001';
	                    _this.element.style.zIndex = '1001';
	                }
	                else {
	                    tabSection_1.style.zIndex = undefined;
	                    _this.element.style.zIndex = undefined;
	                }
	            });
	        }
	    }
	    CurrentTab.prototype.handleTabChange = function () {
	        var _this = this;
	        var selectedTabId = this.queryStateModel.get(QueryStateModel_1.QueryStateModel.attributesEnum.t);
	        if (Utils_1.Utils.isNonEmptyString(selectedTabId)) {
	            var found_1 = false;
	            var tabs = Dom_1.$$(this.root).findAll(Component_1.Component.computeSelectorForType(Tab_1.Tab.ID));
	            _.each(tabs, function (elem) {
	                var tab = Component_1.Component.get(elem, Tab_1.Tab);
	                if (tab.options.id == selectedTabId) {
	                    _this.element.innerHTML = tab.element.innerHTML;
	                    found_1 = true;
	                }
	            });
	            Assert_1.Assert.check(found_1, 'Cannot find the currently active tab');
	        }
	        else {
	            Dom_1.$$(this.element).hide();
	        }
	    };
	    CurrentTab.ID = 'CurrentTab';
	    /**
	     * The options for the component
	     * @componentOptions
	     */
	    CurrentTab.options = {
	        /**
	         * Specifies the CSS selector to the section which contains the tab.
	         * Clicking this component will toggle between opening and closing this section.
	         */
	        tabSectionToOpen: ComponentOptions_1.ComponentOptions.buildStringOption()
	    };
	    return CurrentTab;
	}(Component_1.Component));
	exports.CurrentTab = CurrentTab;
	Initialization_1.Initialization.registerAutoCreateComponent(CurrentTab);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var ResultList_1 = __webpack_require__(128);
	var ComponentOptions_1 = __webpack_require__(98);
	var ImageResultListEvents_1 = __webpack_require__(43);
	var ResultListEvents_1 = __webpack_require__(48);
	var Initialization_1 = __webpack_require__(95);
	var InitializationEvents_1 = __webpack_require__(44);
	var Dom_1 = __webpack_require__(57);
	/**
	 * This component is an extension of the `ResultList` component to display image results.
	 */
	var ImageResultList = (function (_super) {
	    __extends(ImageResultList, _super);
	    function ImageResultList(element, options, bindings, elementClassId) {
	        if (elementClassId === void 0) { elementClassId = ResultList_1.ResultList.ID; }
	        _super.call(this, element, options, bindings, ImageResultList.ID);
	        this.element = element;
	        this.options = options;
	        this.columnResultsArray = [];
	        this.imagesInCurrentRow = [];
	        this.resultIndex = 0;
	        this.lastRowHeight = 0;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, ImageResultList, options);
	        this.lastRowHeight = this.options.heightThreshold;
	        this.bind.onRootElement(ResultListEvents_1.ResultListEvents.newResultsDisplayed, this.handleProcessNewResultsDisplayed);
	        this.bind.onRootElement(InitializationEvents_1.InitializationEvents.nuke, this.handleNuke);
	        this.bindWindowResizeEvent();
	    }
	    ImageResultList.prototype.getResultsElement = function () {
	        return Dom_1.$$(this.element).findAll('.CoveoResult');
	    };
	    ImageResultList.prototype.getResultsElementImages = function () {
	        return Dom_1.$$(this.element).findAll('.CoveoResult img');
	    };
	    ImageResultList.prototype.getResultsContainerDiv = function () {
	        return Dom_1.$$(this.element).find('div');
	    };
	    ImageResultList.prototype.bindWindowResizeEvent = function () {
	        window.addEventListener('resize', this.resize);
	    };
	    ImageResultList.prototype.handleNuke = function () {
	        window.removeEventListener('resize', this.resize);
	    };
	    ImageResultList.prototype.resize = function () {
	        var timeout;
	        clearTimeout(timeout);
	        timeout = setTimeout(this.retrieveLayoutMethod(), 250);
	    };
	    ImageResultList.prototype.handleProcessNewResultsDisplayed = function () {
	        if (this.disabled) {
	            Dom_1.$$(this.element).hide();
	        }
	        else {
	            Dom_1.$$(this.element).show();
	        }
	        this.onImageProxy(this.retrieveLayoutMethod());
	    };
	    ImageResultList.prototype.addTransitionAllToElement = function (elements) {
	        _.defer(function () {
	            _.each(elements, function (element) {
	                Dom_1.$$(element).addClass('coveo-transition-all');
	            });
	        });
	    };
	    ImageResultList.prototype.retrieveLayoutMethod = function () {
	        var _this = this;
	        if (!this.disabled) {
	            if (this.options.layoutType.toLowerCase() == ImageResultList.columnLayoutTypeStr) {
	                return function () { return _this.setupColumns(); };
	            }
	            else if (this.options.layoutType.toLowerCase() == ImageResultList.rowLayoutTypeStr) {
	                return function () { return _this.setupRows(); };
	            }
	        }
	        return function () {
	        };
	    };
	    ImageResultList.prototype.onImageProxy = function (callback) {
	        _.each(this.getResultsElement(), function (element) {
	            if (Dom_1.$$(element).findAll('img').length == 0) {
	                Dom_1.$$(element).detach();
	            }
	        });
	        var images = this.getResultsElementImages();
	        var loaded = 0;
	        var onImageLoad = function (image) {
	            if (Dom_1.$$(image).height() > 0) {
	                if (Dom_1.$$(image).getAttribute('width') == null && Dom_1.$$(image).getAttribute('height') == null) {
	                    Dom_1.$$(image).setAttribute('height', Dom_1.$$(image).height().toString());
	                    Dom_1.$$(image).setAttribute('width', Dom_1.$$(image).width().toString());
	                }
	                loaded++;
	                if (loaded == images.length) {
	                    callback();
	                }
	            }
	            else {
	                Dom_1.$$(image.parentElement).detach();
	                images = _.filter(images, function (img) {
	                    return !img.isEqualNode(image);
	                });
	                if (loaded == images.length) {
	                    callback();
	                }
	            }
	        };
	        _.each(images, function (e) {
	            if ((e.src && e.complete) || Dom_1.$$(e).height() > 0) {
	                onImageLoad(e);
	            }
	            else {
	                Dom_1.$$(e).one('load', function () { return onImageLoad(e); });
	            }
	        });
	    };
	    ImageResultList.prototype.getHorizontalMargin = function (element) {
	        var elementDom = Dom_1.$$(element);
	        return parseInt(elementDom.css('margin-left')) + parseInt(elementDom.css('margin-right'));
	    };
	    ImageResultList.prototype.getVerticalMargin = function (element) {
	        var elementDom = Dom_1.$$(element);
	        return parseInt(elementDom.css('margin-top')) + parseInt(elementDom.css('margin-bottom'));
	    };
	    ImageResultList.prototype.setupColumns = function () {
	        var containerWidth = Dom_1.$$(this.getResultsContainerDiv()).width();
	        var result = this.getResultsElement();
	        var colWidth = this.options.columnWidth;
	        var margin = this.getHorizontalMargin(result[0]);
	        var numberOfColumns = Math.floor(containerWidth / (colWidth + margin));
	        this.columnResultsArray = [];
	        for (var i = 0; i < numberOfColumns; i++) {
	            this.columnResultsArray.push(margin);
	        }
	        this.positionColumns(colWidth, margin);
	        Dom_1.$$(this.element).trigger(ImageResultListEvents_1.ImageResultListEvents.imageResultsLayoutComplete, {});
	        if (this.options.enableInfiniteScroll) {
	            this.adjustNumberOfResults();
	        }
	    };
	    ImageResultList.prototype.positionColumns = function (colWidth, margin) {
	        var _this = this;
	        var results = this.getResultsElement();
	        _.each(results, function (result) {
	            var minTopOffset = _.min(_this.columnResultsArray);
	            var resultIndex = _this.columnResultsArray.indexOf(minTopOffset);
	            var leftOffset = margin + (resultIndex * (colWidth + margin));
	            result.style.left = leftOffset + 'px';
	            result.style.top = minTopOffset + 'px';
	            result.style.width = colWidth + 'px';
	            _this.columnResultsArray[resultIndex] = minTopOffset + $(result).outerHeight() + margin;
	        });
	        this.setResultsContainerHeight(_.max(this.columnResultsArray));
	        this.addTransitionAllToElement(results);
	    };
	    ImageResultList.prototype.setResultsContainerHeight = function (height) {
	        Dom_1.$$(this.element).setAttribute('height', (Math.ceil(height).toString()));
	    };
	    ImageResultList.prototype.setupRows = function () {
	        var results = this.getResultsElement();
	        var containerWidth = Dom_1.$$(this.element).width();
	        this.resultIndex = 0;
	        var topOffset = 0;
	        while (this.resultIndex < results.length) {
	            this.imagesInCurrentRow = [];
	            var rowHeight = this.getCurrentRowHeight(results, containerWidth);
	            this.setCurrentRowImagesDimensions(results, rowHeight, topOffset);
	            topOffset += rowHeight;
	        }
	        this.setResultsContainerHeight(topOffset);
	        Dom_1.$$(this.element).trigger(ImageResultListEvents_1.ImageResultListEvents.imageResultsLayoutComplete, {});
	        this.addTransitionAllToElement(results);
	        if (this.options.enableInfiniteScroll) {
	            this.adjustNumberOfResults();
	        }
	    };
	    ImageResultList.prototype.getCurrentRowHeight = function (results, containerWidth) {
	        var divider = 0;
	        var height = null;
	        while ((this.resultIndex < results.length) && (height == null || height >= this.options.heightThreshold)) {
	            var imageDimensions = this.getImageDimensionsFromResult(results[this.resultIndex]);
	            if (imageDimensions != null) {
	                divider += imageDimensions.width / imageDimensions.height;
	                height = containerWidth / divider;
	            }
	            this.imagesInCurrentRow.push(this.resultIndex);
	            this.resultIndex++;
	        }
	        // correct height for last element if it can't be as wide as the container
	        if (height > this.options.heightThreshold) {
	            height = this.lastRowHeight;
	        }
	        this.lastRowHeight = height;
	        return height;
	    };
	    ImageResultList.prototype.getImageDimensionsFromResult = function (result) {
	        var image = Dom_1.$$(result).find('img');
	        var height = parseInt(image.getAttribute('height'));
	        var width = parseInt(image.getAttribute('width'));
	        return {
	            height: height,
	            width: width
	        };
	    };
	    ImageResultList.prototype.setCurrentRowImagesDimensions = function (images, height, top) {
	        var _this = this;
	        var leftOffset = 0;
	        _.each(this.imagesInCurrentRow, function (imageIndex) {
	            var image = Dom_1.$$(images[imageIndex]).find('img');
	            var oldWidth = parseInt(image.getAttribute('width'));
	            var oldHeight = parseInt(image.getAttribute('height'));
	            var width = oldWidth * height / oldHeight;
	            var widthMargin = _this.getHorizontalMargin(image);
	            var heightMargin = _this.getVerticalMargin(image);
	            image.setAttribute('height', Math.round(height - heightMargin).toString());
	            image.setAttribute('width', Math.round(width - widthMargin).toString());
	            image.setAttribute('left', Math.round(leftOffset).toString());
	            image.setAttribute('top', Math.round(top).toString());
	            leftOffset += width;
	        });
	    };
	    ImageResultList.prototype.adjustNumberOfResults = function () {
	        var elementHeight = Number(Dom_1.$$(this.element).getAttribute('data-height'));
	        if (_.isNumber(elementHeight) == false) {
	            elementHeight = Dom_1.$$(this.element).height();
	        }
	        if ((elementHeight < Dom_1.$$(this.options.infiniteScrollContainer).height()) && _super.prototype.hasPotentiallyMoreResultsToDisplay.call(this)) {
	            _super.prototype.displayMoreResults.call(this, this.options.infiniteScrollPageSize);
	        }
	    };
	    ImageResultList.ID = 'ImageResultList';
	    ImageResultList.rowLayoutTypeStr = 'row';
	    ImageResultList.columnLayoutTypeStr = 'column';
	    /**
	     * The options for the component
	     * This component inherits the options of the {@link ResultList} component.
	     * @componentOptions
	     */
	    ImageResultList.options = {
	        /**
	         * Specifies the type of layout used to display images results.
	         * The available values are:
	         *    row - Displays resized images that fit to the width of the container and have the same height for a row.
	         *    column - Displays the images in fixed-size columns.
	         * The default value is `row`.
	         */
	        layoutType: ComponentOptions_1.ComponentOptions.buildStringOption({
	            defaultValue: 'row',
	            postProcessing: function (value) { return value.toLowerCase(); }
	        }),
	        /**
	         * Specifies the maximum height of a row in a row layout.
	         * The default value is 250.
	         */
	        heightThreshold: ComponentOptions_1.ComponentOptions.buildNumberOption({ defaultValue: 250, min: 16 }),
	        /**
	         * Specifies the width of a column in a column layout.
	         * The default value is 170.
	         */
	        columnWidth: ComponentOptions_1.ComponentOptions.buildNumberOption({ defaultValue: 225, min: 16 })
	    };
	    return ImageResultList;
	}(ResultList_1.ResultList));
	exports.ImageResultList = ImageResultList;
	Initialization_1.Initialization.registerAutoCreateComponent(ImageResultList);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	exports.underscoreInstance = _;
	setCoveoUnderscore();
	function setCoveoUnderscore() {
	    if (window['Coveo'] == undefined) {
	        window['Coveo'] = {};
	    }
	    if (window['Coveo']['_'] == undefined) {
	        window['Coveo']['_'] = _;
	        exports.underscoreInstance = window['Coveo']['_'];
	    }
	}
	window['_'] = _;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var QueryEvents_1 = __webpack_require__(47);
	var AdvancedSearchEvents_1 = __webpack_require__(39);
	var SettingsEvents_1 = __webpack_require__(50);
	var Initialization_1 = __webpack_require__(95);
	var Strings_1 = __webpack_require__(34);
	var Dom_1 = __webpack_require__(57);
	var AdvancedSearchInputFactory_1 = __webpack_require__(233);
	var AnalyticsActionListMeta_1 = __webpack_require__(110);
	var QuerySummaryEvents_1 = __webpack_require__(214);
	/**
	 * The Advanced Search component allows the user to easily create a complex query to send to the index.
	 * The component also allows custom code to modify the content by using the {@link AdvancedSearchEvents.buildingAdvancedSearch} event.
	 */
	var AdvancedSearch = (function (_super) {
	    __extends(AdvancedSearch, _super);
	    function AdvancedSearch(element, options, bindings) {
	        _super.call(this, element, AdvancedSearch.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.inputs = [];
	        this.inputFactory = new AdvancedSearchInputFactory_1.AdvancedSearchInputFactory(this.queryController.getEndpoint());
	        this.externalSections = [];
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, AdvancedSearch, options);
	        this.bindEvents();
	        this.buildComponent();
	    }
	    /**
	     * Launch the advanced search query.
	     */
	    AdvancedSearch.prototype.executeAdvancedSearch = function () {
	        this.usageAnalytics.logSearchEvent(AnalyticsActionListMeta_1.analyticsActionCauseList.advancedSearch, {});
	        this.queryController.executeQuery();
	    };
	    /**
	     * Reset the state of all form input inside the advanced search component
	     */
	    AdvancedSearch.prototype.reset = function () {
	        _.each(this.inputs, function (input) {
	            input.reset();
	        });
	    };
	    AdvancedSearch.prototype.buildComponent = function () {
	        this.buildTitle();
	        this.buildCloseButton();
	        this.buildContent();
	        Dom_1.$$(this.element).hide();
	    };
	    AdvancedSearch.prototype.buildTitle = function () {
	        var title = Dom_1.$$('div', { className: 'coveo-advanced-search-panel-title' }, Strings_1.l('AdvancedSearch')).el;
	        Dom_1.$$(this.element).append(title);
	    };
	    AdvancedSearch.prototype.buildCloseButton = function () {
	        var _this = this;
	        var closeButton = Dom_1.$$('div', { className: 'coveo-advanced-search-panel-close' }, Dom_1.$$('span', { className: 'coveo-icon' }).el);
	        closeButton.on('click', function () { return _this.close(); });
	        Dom_1.$$(this.element).append(closeButton.el);
	    };
	    AdvancedSearch.prototype.buildContent = function () {
	        var _this = this;
	        var component = Dom_1.$$('div');
	        var inputSections = [];
	        if (this.options.includeKeywords) {
	            inputSections.push(this.getKeywordsSection());
	        }
	        if (this.options.includeDate) {
	            inputSections.push(this.getDateSection());
	        }
	        if (this.options.includeDocument) {
	            inputSections.push(this.getDocumentSection());
	        }
	        this.externalSections = [];
	        Dom_1.$$(this.root).trigger(AdvancedSearchEvents_1.AdvancedSearchEvents.buildingAdvancedSearch, {
	            sections: this.externalSections,
	            executeQuery: function (options) {
	                return _this.queryController.executeQuery(options);
	            }
	        });
	        _.each(this.externalSections, function (section) {
	            component.append(_this.buildExternalSection(section));
	        });
	        _.each(inputSections, function (section) {
	            component.append(_this.buildInternalSection(section));
	        });
	        Dom_1.$$(this.element).append(component.el);
	    };
	    AdvancedSearch.prototype.open = function () {
	        Dom_1.$$(this.element).show();
	    };
	    AdvancedSearch.prototype.close = function () {
	        Dom_1.$$(this.element).hide();
	    };
	    AdvancedSearch.prototype.getKeywordsSection = function () {
	        var sectionName = Strings_1.l('Keywords');
	        var keywordsInputs = [];
	        keywordsInputs.push(this.inputFactory.createAllKeywordsInput());
	        keywordsInputs.push(this.inputFactory.createExactKeywordsInput());
	        keywordsInputs.push(this.inputFactory.createAnyKeywordsInput());
	        keywordsInputs.push(this.inputFactory.createNoneKeywordsInput());
	        return { name: sectionName, inputs: keywordsInputs };
	    };
	    AdvancedSearch.prototype.getDateSection = function () {
	        var sectionName = Strings_1.l('Date');
	        var dateInputs = [];
	        dateInputs.push(this.inputFactory.createAnytimeDateInput());
	        dateInputs.push(this.inputFactory.createInTheLastDateInput());
	        dateInputs.push(this.inputFactory.createBetweenDateInput());
	        return { name: sectionName, inputs: dateInputs };
	    };
	    AdvancedSearch.prototype.getDocumentSection = function () {
	        var sectionName = Strings_1.l('Document');
	        var documentInputs = [];
	        documentInputs.push(this.inputFactory.createSimpleFieldInput(Strings_1.l('FileType'), '@filetype'));
	        documentInputs.push(this.inputFactory.createSimpleFieldInput(Strings_1.l('Language'), '@language'));
	        documentInputs.push(this.inputFactory.createSizeInput());
	        documentInputs.push(this.inputFactory.createAdvancedFieldInput(Strings_1.l('Title'), '@title'));
	        documentInputs.push(this.inputFactory.createAdvancedFieldInput(Strings_1.l('Author'), '@author'));
	        return { name: sectionName, inputs: documentInputs };
	    };
	    AdvancedSearch.prototype.buildExternalSection = function (section) {
	        var sectionHTML = this.buildSectionTitle(section);
	        this.inputs = _.union(this.inputs, section.inputs);
	        sectionHTML.appendChild(section.content);
	        return sectionHTML;
	    };
	    AdvancedSearch.prototype.buildInternalSection = function (section) {
	        var _this = this;
	        var sectionHTML = this.buildSectionTitle(section);
	        var sectionInputs = [];
	        _.each(section.inputs, function (input) {
	            sectionInputs.push(_this.buildDefaultInput(input));
	        });
	        this.inputs = _.union(this.inputs, sectionInputs);
	        _.each(sectionInputs, function (input) {
	            Dom_1.$$(sectionHTML).append(input.build());
	        });
	        return sectionHTML;
	    };
	    AdvancedSearch.prototype.buildSectionTitle = function (section) {
	        var sectionHTML = Dom_1.$$('div', { className: 'coveo-advanced-search-section' });
	        var title = Dom_1.$$('div', { className: 'coveo-advanced-search-section-title' });
	        title.text(section.name);
	        sectionHTML.append(title.el);
	        return sectionHTML.el;
	    };
	    AdvancedSearch.prototype.buildDefaultInput = function (input) {
	        if (this.isPrebuiltInput(input)) {
	            return this.inputFactory.create(input.name, input.parameters);
	        }
	        else {
	            return input;
	        }
	    };
	    AdvancedSearch.prototype.isPrebuiltInput = function (input) {
	        return input.name !== undefined;
	    };
	    AdvancedSearch.prototype.bindEvents = function () {
	        var _this = this;
	        this.bind.onRootElement(SettingsEvents_1.SettingsEvents.settingsPopulateMenu, function (args) {
	            args.menuData.push({
	                text: Strings_1.l('AdvancedSearch'),
	                className: 'coveo-advanced-search',
	                onOpen: function () { return _this.open(); },
	                onClose: function () { return _this.close(); }
	            });
	        });
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.buildingQuery, function (data) {
	            _.each(_this.externalSections, function (section) {
	                if (section.updateQuery) {
	                    section.updateQuery(section.inputs, data.queryBuilder);
	                }
	            });
	            _.each(_this.inputs, function (input) {
	                if (input.updateQuery) {
	                    input.updateQuery(data.queryBuilder);
	                }
	            });
	        });
	        this.bind.onRootElement(AdvancedSearchEvents_1.AdvancedSearchEvents.executeAdvancedSearch, function () {
	            _this.executeAdvancedSearch();
	        });
	        this.bind.onRootElement(QuerySummaryEvents_1.QuerySummaryEvents.cancelLastAction, function () {
	            _this.reset();
	        });
	    };
	    AdvancedSearch.ID = 'AdvancedSearch';
	    /**
	     * @componentOptions
	     */
	    AdvancedSearch.options = {
	        /**
	         * Specifies whether or not to include the built-in keywords section.
	         * Default is `true`
	         */
	        includeKeywords: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true }),
	        /**
	         * Specifies whether or not to include the built-in date section.
	         * Default is `true`
	         */
	        includeDate: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true }),
	        /**
	         * Specifies whether or not to include the built-in document section.
	         * Default is `true`
	         */
	        includeDocument: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true })
	    };
	    return AdvancedSearch;
	}(Component_1.Component));
	exports.AdvancedSearch = AdvancedSearch;
	Initialization_1.Initialization.registerAutoCreateComponent(AdvancedSearch);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var AllKeywordsInput_1 = __webpack_require__(234);
	var ExactKeywordsInput_1 = __webpack_require__(237);
	var AnyKeywordsInput_1 = __webpack_require__(238);
	var NoneKeywordsInput_1 = __webpack_require__(239);
	var AnytimeDateInput_1 = __webpack_require__(240);
	var InTheLastDateInput_1 = __webpack_require__(243);
	var BetweenDateInput_1 = __webpack_require__(246);
	var SimpleFieldInput_1 = __webpack_require__(360);
	var AdvancedFieldInput_1 = __webpack_require__(362);
	var SizeInput_1 = __webpack_require__(363);
	var AdvancedSearchInputFactory = (function () {
	    function AdvancedSearchInputFactory(endpoint) {
	        this.endpoint = endpoint;
	    }
	    AdvancedSearchInputFactory.prototype.create = function (name, options) {
	        switch (name) {
	            case 'keywords_all':
	                return this.createAllKeywordsInput();
	            case 'keywords_exact':
	                return this.createExactKeywordsInput();
	            case 'keywords_any':
	                return this.createAnyKeywordsInput();
	            case 'keywords_none':
	                return this.createNoneKeywordsInput();
	            case 'date_any':
	                return this.createAnytimeDateInput();
	            case 'date_last':
	                return this.createInTheLastDateInput();
	            case 'date_between':
	                return this.createBetweenDateInput();
	            case 'document_field':
	                return this.createSimpleFieldInput(options.name, options.field);
	            case 'document_advanced_field':
	                return this.createAdvancedFieldInput(options.name, options.field);
	            case 'document_size':
	                return this.createSizeInput();
	            default:
	                return null;
	        }
	    };
	    AdvancedSearchInputFactory.prototype.createAllKeywordsInput = function () {
	        return new AllKeywordsInput_1.AllKeywordsInput();
	    };
	    AdvancedSearchInputFactory.prototype.createExactKeywordsInput = function () {
	        return new ExactKeywordsInput_1.ExactKeywordsInput();
	    };
	    AdvancedSearchInputFactory.prototype.createAnyKeywordsInput = function () {
	        return new AnyKeywordsInput_1.AnyKeywordsInput();
	    };
	    AdvancedSearchInputFactory.prototype.createNoneKeywordsInput = function () {
	        return new NoneKeywordsInput_1.NoneKeywordsInput();
	    };
	    AdvancedSearchInputFactory.prototype.createAnytimeDateInput = function () {
	        return new AnytimeDateInput_1.AnytimeDateInput();
	    };
	    AdvancedSearchInputFactory.prototype.createInTheLastDateInput = function () {
	        return new InTheLastDateInput_1.InTheLastDateInput();
	    };
	    AdvancedSearchInputFactory.prototype.createBetweenDateInput = function () {
	        return new BetweenDateInput_1.BetweenDateInput();
	    };
	    AdvancedSearchInputFactory.prototype.createSimpleFieldInput = function (name, field) {
	        return new SimpleFieldInput_1.SimpleFieldInput(name, field, this.endpoint);
	    };
	    AdvancedSearchInputFactory.prototype.createAdvancedFieldInput = function (name, field) {
	        return new AdvancedFieldInput_1.AdvancedFieldInput(name, field);
	    };
	    AdvancedSearchInputFactory.prototype.createSizeInput = function () {
	        return new SizeInput_1.SizeInput();
	    };
	    return AdvancedSearchInputFactory;
	}());
	exports.AdvancedSearchInputFactory = AdvancedSearchInputFactory;


/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var KeywordsInput_1 = __webpack_require__(235);
	var Strings_1 = __webpack_require__(34);
	var AllKeywordsInput = (function (_super) {
	    __extends(AllKeywordsInput, _super);
	    function AllKeywordsInput() {
	        _super.call(this, Strings_1.l('AllTheseWords'));
	    }
	    return AllKeywordsInput;
	}(KeywordsInput_1.KeywordsInput));
	exports.AllKeywordsInput = AllKeywordsInput;


/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var TextInput_1 = __webpack_require__(236);
	var AdvancedSearchEvents_1 = __webpack_require__(39);
	var Dom_1 = __webpack_require__(57);
	var KeywordsInput = (function () {
	    function KeywordsInput(inputName) {
	        this.inputName = inputName;
	    }
	    KeywordsInput.prototype.reset = function () {
	        this.clear();
	    };
	    KeywordsInput.prototype.build = function () {
	        this.input = new TextInput_1.TextInput(this.onChange.bind(this), this.inputName);
	        return this.input.getElement();
	    };
	    KeywordsInput.prototype.setValue = function (value) {
	        this.input.setValue(value);
	    };
	    KeywordsInput.prototype.getValue = function () {
	        return this.input.getValue();
	    };
	    KeywordsInput.prototype.clear = function () {
	        this.input.setValue('');
	    };
	    KeywordsInput.prototype.updateQuery = function (queryBuilder) {
	        var value = this.getValue();
	        if (value) {
	            queryBuilder.advancedExpression.add(value);
	        }
	    };
	    KeywordsInput.prototype.onChange = function () {
	        if (this.input) {
	            Dom_1.$$(this.input.getElement()).trigger(AdvancedSearchEvents_1.AdvancedSearchEvents.executeAdvancedSearch);
	        }
	    };
	    return KeywordsInput;
	}());
	exports.KeywordsInput = KeywordsInput;


/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var Dom_1 = __webpack_require__(57);
	var KeyboardUtils_1 = __webpack_require__(68);
	/**
	 * This class will create a text input meant to be used inside the {@link AdvancedSearch} component.
	 *
	 * It can be, more specifically, used for external code using the {@link AdvancedSearchEvents.buildingAdvancedSearch}
	 */
	var TextInput = (function () {
	    /**
	     * Create a new text input.
	     * @param onChange will be called every time the text input change it's value. `this` will be the `TextInput` instance.
	     * @param name
	     */
	    function TextInput(onChange, name) {
	        if (onChange === void 0) { onChange = function () { }; }
	        this.onChange = onChange;
	        this.name = name;
	        this.lastQueryText = '';
	        this.buildContent();
	    }
	    /**
	     * Return the element on which the dropdown is bound.
	     * @returns {HTMLElement}
	     */
	    TextInput.prototype.getElement = function () {
	        return this.element;
	    };
	    /**
	     * Get the currently entered value in the text input.
	     * @returns {string}
	     */
	    TextInput.prototype.getValue = function () {
	        return Dom_1.$$(this.element).find('input').value;
	    };
	    /**
	     * Set the value in the text input.
	     * @param value
	     */
	    TextInput.prototype.setValue = function (value) {
	        Dom_1.$$(this.element).find('input').value = value;
	    };
	    /**
	     * Reset the text input
	     */
	    TextInput.prototype.reset = function () {
	        Dom_1.$$(this.element).find('input').value = '';
	    };
	    /**
	     * Return the element on which the dropdown is bound.
	     * @returns {HTMLElement}
	     */
	    TextInput.prototype.build = function () {
	        return this.element;
	    };
	    TextInput.prototype.buildContent = function () {
	        var _this = this;
	        var container = Dom_1.$$('div', { className: 'coveo-input' });
	        var input = Dom_1.$$('input', { type: 'text' });
	        input.on(['keydown', 'blur'], function (e) {
	            if (e.type == 'blur' || e.keyCode == KeyboardUtils_1.KEYBOARD.ENTER) {
	                _this.triggerChange();
	            }
	        });
	        input.el.required = true;
	        container.append(input.el);
	        if (this.name) {
	            var label = Dom_1.$$('label');
	            label.text(this.name);
	            container.append(label.el);
	        }
	        this.element = container.el;
	    };
	    TextInput.prototype.getInput = function () {
	        return Dom_1.$$(this.element).find('input');
	    };
	    TextInput.prototype.triggerChange = function () {
	        if (this.lastQueryText != this.getInput().value) {
	            this.onChange();
	            this.lastQueryText = this.getInput().value;
	        }
	    };
	    return TextInput;
	}());
	exports.TextInput = TextInput;


/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var KeywordsInput_1 = __webpack_require__(235);
	var Strings_1 = __webpack_require__(34);
	var ExactKeywordsInput = (function (_super) {
	    __extends(ExactKeywordsInput, _super);
	    function ExactKeywordsInput() {
	        _super.call(this, Strings_1.l('ExactPhrase'));
	    }
	    ExactKeywordsInput.prototype.getValue = function () {
	        var value = _super.prototype.getValue.call(this);
	        return value ? '\"' + value + '\"' : '';
	    };
	    return ExactKeywordsInput;
	}(KeywordsInput_1.KeywordsInput));
	exports.ExactKeywordsInput = ExactKeywordsInput;


/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var KeywordsInput_1 = __webpack_require__(235);
	var Strings_1 = __webpack_require__(34);
	var AnyKeywordsInput = (function (_super) {
	    __extends(AnyKeywordsInput, _super);
	    function AnyKeywordsInput() {
	        _super.call(this, Strings_1.l('AnyOfTheseWords'));
	    }
	    AnyKeywordsInput.prototype.getValue = function () {
	        var value = _super.prototype.getValue.call(this);
	        var splitValues = value.split(' ');
	        var generatedValue = '';
	        _.each(splitValues, function (splitValue) {
	            generatedValue += splitValue + ' OR ';
	        });
	        generatedValue = generatedValue.substr(0, generatedValue.length - 4);
	        return generatedValue;
	    };
	    return AnyKeywordsInput;
	}(KeywordsInput_1.KeywordsInput));
	exports.AnyKeywordsInput = AnyKeywordsInput;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var KeywordsInput_1 = __webpack_require__(235);
	var Strings_1 = __webpack_require__(34);
	var NoneKeywordsInput = (function (_super) {
	    __extends(NoneKeywordsInput, _super);
	    function NoneKeywordsInput() {
	        _super.call(this, Strings_1.l('NoneOfTheseWords'));
	    }
	    NoneKeywordsInput.prototype.getValue = function () {
	        var value = _super.prototype.getValue.call(this);
	        var generatedValue = '';
	        if (value) {
	            var splitValues = value.split(' ');
	            _.each(splitValues, function (splitValue) {
	                generatedValue += ' NOT ' + splitValue;
	            });
	            generatedValue = generatedValue.substr(1);
	        }
	        return generatedValue;
	    };
	    return NoneKeywordsInput;
	}(KeywordsInput_1.KeywordsInput));
	exports.NoneKeywordsInput = NoneKeywordsInput;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var DateInput_1 = __webpack_require__(241);
	var Strings_1 = __webpack_require__(34);
	var Dom_1 = __webpack_require__(57);
	var AdvancedSearchEvents_1 = __webpack_require__(39);
	var AnytimeDateInput = (function (_super) {
	    __extends(AnytimeDateInput, _super);
	    function AnytimeDateInput() {
	        _super.call(this, Strings_1.l('Anytime'));
	    }
	    AnytimeDateInput.prototype.build = function () {
	        var _this = this;
	        _super.prototype.build.call(this);
	        var radio = this.getRadio();
	        radio.checked = true;
	        Dom_1.$$(radio).on('change', function () {
	            Dom_1.$$(_this.element).trigger(AdvancedSearchEvents_1.AdvancedSearchEvents.executeAdvancedSearch);
	        });
	        return this.element;
	    };
	    return AnytimeDateInput;
	}(DateInput_1.DateInput));
	exports.AnytimeDateInput = AnytimeDateInput;


/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var AdvancedSearchEvents_1 = __webpack_require__(39);
	var Dom_1 = __webpack_require__(57);
	var RadioButton_1 = __webpack_require__(242);
	var DateInput = (function () {
	    function DateInput(inputName) {
	        this.inputName = inputName;
	        this.buildContent();
	    }
	    DateInput.prototype.reset = function () {
	        this.radio.reset();
	    };
	    DateInput.prototype.build = function () {
	        return this.element;
	    };
	    DateInput.prototype.getElement = function () {
	        return this.element;
	    };
	    DateInput.prototype.getValue = function () {
	        return '';
	    };
	    DateInput.prototype.isSelected = function () {
	        return this.getRadio().checked;
	    };
	    DateInput.prototype.updateQuery = function (queryBuilder) {
	        var value = this.getValue();
	        if (value) {
	            queryBuilder.advancedExpression.add(this.getValue());
	        }
	    };
	    DateInput.prototype.getRadio = function () {
	        return Dom_1.$$(this.element).find('input');
	    };
	    DateInput.prototype.buildContent = function () {
	        var _this = this;
	        this.radio = new RadioButton_1.RadioButton(function () {
	            _this.deactivateAllInputs();
	            _this.activateSelectedInput();
	        }, this.inputName);
	        this.element = this.radio.getElement();
	        Dom_1.$$(this.element).addClass('coveo-advanced-search-date-input-section');
	        Dom_1.$$(this.radio.getRadio()).addClass('coveo-advanced-search-date');
	        Dom_1.$$(this.radio.getLabel()).addClass('coveo-advanced-search-label');
	    };
	    DateInput.prototype.deactivateAllInputs = function () {
	        var elements = Dom_1.$$(this.element.parentElement).findAll('fieldset');
	        _.each(elements, function (element) {
	            element.disabled = true;
	        });
	    };
	    DateInput.prototype.activateSelectedInput = function () {
	        var elements = Dom_1.$$(this.element).findAll('fieldset');
	        _.each(elements, function (element) {
	            element.disabled = false;
	        });
	    };
	    DateInput.prototype.onChange = function () {
	        if (this.element) {
	            Dom_1.$$(this.element).trigger(AdvancedSearchEvents_1.AdvancedSearchEvents.executeAdvancedSearch);
	        }
	    };
	    return DateInput;
	}());
	exports.DateInput = DateInput;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var Dom_1 = __webpack_require__(57);
	/**
	 * This class will create a radio button meant to be used inside the {@link AdvancedSearch} component.
	 *
	 * It can be, more specifically, used for external code using the {@link AdvancedSearchEvents.buildingAdvancedSearch}
	 */
	var RadioButton = (function () {
	    /**
	     * Create a new Radio button.
	     * @param onChange will be called every time the radio button change it's value. `this` will be the `RadioButton` instance.
	     * @param label The label for the choice.
	     */
	    function RadioButton(onChange, label) {
	        if (onChange === void 0) { onChange = function () {
	        }; }
	        this.onChange = onChange;
	        this.label = label;
	        this.buildContent();
	    }
	    /**
	     * Reset the radio button
	     */
	    RadioButton.prototype.reset = function () {
	        this.element.checked = false;
	    };
	    /**
	     * Return the element on which the dropdown is bound.
	     * @returns {HTMLElement}
	     */
	    RadioButton.prototype.build = function () {
	        return this.element;
	    };
	    /**
	     * Return the element on which the dropdown is bound.
	     * @returns {HTMLElement}
	     */
	    RadioButton.prototype.getElement = function () {
	        return this.element;
	    };
	    RadioButton.prototype.getValue = function () {
	        return '';
	    };
	    /**
	     * Return true if the radio button is selected.
	     * @returns {boolean}
	     */
	    RadioButton.prototype.isSelected = function () {
	        return this.getRadio().checked;
	    };
	    /**
	     * Get the input element (the radio button itself).
	     * @returns {HTMLInputElement}
	     */
	    RadioButton.prototype.getRadio = function () {
	        return Dom_1.$$(this.element).find('input');
	    };
	    /**
	     * Get the label element.
	     * @returns {HTMLLabelElement}
	     */
	    RadioButton.prototype.getLabel = function () {
	        return Dom_1.$$(this.element).find('label');
	    };
	    RadioButton.prototype.buildContent = function () {
	        var _this = this;
	        var section = Dom_1.$$('div', { className: 'coveo-advanced-search-radio-section' });
	        var radioOption = Dom_1.$$('div', { className: 'coveo-radio' });
	        var radioInput = Dom_1.$$('input', { type: 'radio', name: 'coveo-advanced-search-radio-input', id: this.label });
	        var labelInput = Dom_1.$$('label', { className: 'coveo-advanced-search-radio-input-label', 'for': this.label });
	        labelInput.text(this.label);
	        radioInput.on('change', function () {
	            _this.onChange();
	        });
	        radioOption.append(radioInput.el);
	        radioOption.append(labelInput.el);
	        section.append(radioOption.el);
	        this.element = section.el;
	    };
	    return RadioButton;
	}());
	exports.RadioButton = RadioButton;


/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var DateInput_1 = __webpack_require__(241);
	var Dom_1 = __webpack_require__(57);
	var Strings_1 = __webpack_require__(34);
	var Dropdown_1 = __webpack_require__(244);
	var NumericSpinner_1 = __webpack_require__(245);
	var DateUtils_1 = __webpack_require__(56);
	var InTheLastDateInput = (function (_super) {
	    __extends(InTheLastDateInput, _super);
	    function InTheLastDateInput() {
	        _super.call(this, Strings_1.l('InTheLast'));
	    }
	    InTheLastDateInput.prototype.reset = function () {
	        this.dropdown.reset();
	        this.spinner.reset();
	    };
	    InTheLastDateInput.prototype.build = function () {
	        _super.prototype.build.call(this);
	        var input = Dom_1.$$('fieldset', { className: 'coveo-advanced-search-date-input' });
	        input.el.disabled = true;
	        this.spinner = new NumericSpinner_1.NumericSpinner(this.onChange.bind(this));
	        input.append(this.spinner.getElement());
	        this.dropdown = new Dropdown_1.Dropdown(this.onChange.bind(this), ['days', 'months']);
	        this.dropdown.setId('coveo-advanced-search-in-the-last-select');
	        input.append(this.dropdown.getElement());
	        this.element.appendChild(input.el);
	        return this.element;
	    };
	    InTheLastDateInput.prototype.getValue = function () {
	        var currentDate = new Date();
	        var time = this.spinner.getIntValue();
	        var size = this.dropdown.getValue().toLowerCase();
	        var date = new Date();
	        if (size == 'months') {
	            date.setMonth(currentDate.getMonth() - time);
	        }
	        else {
	            date.setDate(currentDate.getDate() - time);
	        }
	        return this.isSelected() && time ? '@date>=' + DateUtils_1.DateUtils.dateForQuery(date) : '';
	    };
	    return InTheLastDateInput;
	}(DateInput_1.DateInput));
	exports.InTheLastDateInput = InTheLastDateInput;


/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var Dom_1 = __webpack_require__(57);
	var Strings_1 = __webpack_require__(34);
	/**
	 * This class will create a dropdown meant to be used inside the {@link AdvancedSearch} component.
	 *
	 * It can be, more specifically, used for external code using the {@link AdvancedSearchEvents.buildingAdvancedSearch}
	 */
	var Dropdown = (function () {
	    /**
	     * Create a new dropdown.
	     * @param onChange will be called every time the dropdown change it's value. `this` will be the `Dropdown` instance.
	     * @param listOfValues will be the list of selectable values in the dropdown
	     * @param getDisplayValue An optional function that allow to modify the display value vs the actual value from the `listOfValues`
	     * @param label A label/title to display for this dropdown
	     */
	    function Dropdown(onChange, listOfValues, getDisplayValue, label) {
	        if (onChange === void 0) { onChange = function () {
	        }; }
	        if (getDisplayValue === void 0) { getDisplayValue = Strings_1.l; }
	        this.onChange = onChange;
	        this.listOfValues = listOfValues;
	        this.getDisplayValue = getDisplayValue;
	        this.label = label;
	        this.options = [];
	        this.buildContent();
	        this.select(0, false);
	        this.bindEvents();
	    }
	    /**
	     * Reset the dropdown
	     */
	    Dropdown.prototype.reset = function () {
	        this.select(0, false);
	    };
	    Dropdown.prototype.setId = function (id) {
	        Dom_1.$$(this.element).setAttribute('id', id);
	    };
	    /**
	     * Open the dropdown.
	     */
	    Dropdown.prototype.open = function () {
	        Dom_1.$$(this.element).addClass('coveo-open');
	    };
	    /**
	     * Close the dropdown.
	     */
	    Dropdown.prototype.close = function () {
	        Dom_1.$$(this.element).removeClass('coveo-open');
	    };
	    /**
	     * Return the element on which the dropdown is bound.
	     * @returns {HTMLElement}
	     */
	    Dropdown.prototype.getElement = function () {
	        return this.element;
	    };
	    /**
	     * Get the currently selected value in the dropdown.
	     * @returns {string}
	     */
	    Dropdown.prototype.getValue = function () {
	        return Dom_1.$$(this.element).find('.coveo-dropdown-selected-value').getAttribute('value');
	    };
	    /**
	     * Select a value from it's 0 based index in the {@link Dropdown.listOfValues}.
	     * @param index
	     */
	    Dropdown.prototype.select = function (index, executeOnChange) {
	        if (executeOnChange === void 0) { executeOnChange = true; }
	        this.selectOption(this.options[index], executeOnChange);
	    };
	    /**
	     * Return the element on which the dropdown is bound.
	     * @returns {HTMLElement}
	     */
	    Dropdown.prototype.build = function () {
	        return this.element;
	    };
	    Dropdown.prototype.buildContent = function () {
	        var dropdown = Dom_1.$$('div', { className: 'coveo-dropdown' });
	        var button = Dom_1.$$('button', { className: 'coveo-button coveo-dropdown-toggle', type: 'button' });
	        button.setAttribute('data-toggle', 'coveo-dropdown');
	        this.selected = Dom_1.$$('span', { className: 'coveo-dropdown-selected-value' });
	        button.append(this.selected.el);
	        button.append(Dom_1.$$('span', { className: 'coveo-dropdown-toggle-arrow' }).el);
	        dropdown.append(button.el);
	        dropdown.append(this.buildDropdownMenu(this.selected));
	        this.element = dropdown.el;
	    };
	    Dropdown.prototype.selectValue = function (value) {
	        var _this = this;
	        _.each(this.options, function (option) {
	            if (Dom_1.$$(option).getAttribute('value') == value) {
	                _this.selectOption(option);
	            }
	        });
	    };
	    Dropdown.prototype.selectOption = function (option, executeOnChange) {
	        if (executeOnChange === void 0) { executeOnChange = true; }
	        this.selectedIcon.detach();
	        var content = Dom_1.$$(option).find('span');
	        Dom_1.$$(content).prepend(this.selectedIcon.el);
	        var value = Dom_1.$$(option).getAttribute('value');
	        this.selected.setAttribute('value', value);
	        this.selected.text(this.getDisplayValue(value));
	        this.close();
	        if (executeOnChange) {
	            this.onChange();
	        }
	    };
	    Dropdown.prototype.buildDropdownMenu = function (selected) {
	        var _this = this;
	        var dropdownMenu = Dom_1.$$('ul', { className: 'coveo-dropdown-menu' });
	        this.selectedIcon = Dom_1.$$('span', { className: 'coveo-selected-icon coveo-sprites-facet-search-checkbox-hook-active' });
	        _.each(this.listOfValues, function (value) {
	            dropdownMenu.append(_this.buildOption(value));
	        });
	        return dropdownMenu.el;
	    };
	    Dropdown.prototype.buildOption = function (value) {
	        var _this = this;
	        var option = Dom_1.$$('li');
	        option.setAttribute('value', value);
	        var content = Dom_1.$$('span');
	        content.text(this.getDisplayValue(value));
	        option.append(content.el);
	        option.on('click', function () {
	            _this.selectOption(option.el);
	        });
	        this.options.push(option.el);
	        return option.el;
	    };
	    Dropdown.prototype.bindEvents = function () {
	        var _this = this;
	        var button = Dom_1.$$(this.element).find('button');
	        Dom_1.$$(this.element).on('mouseleave', function (e) {
	            setTimeout(function () {
	                if (e.target == _this.element && Dom_1.$$(_this.element).hasClass('coveo-open')) {
	                    _this.close();
	                }
	            }, 300);
	        });
	        Dom_1.$$(button).on('click', function () {
	            if (Dom_1.$$(_this.element).hasClass('coveo-open')) {
	                _this.close();
	            }
	            else {
	                _this.open();
	            }
	        });
	    };
	    return Dropdown;
	}());
	exports.Dropdown = Dropdown;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var Dom_1 = __webpack_require__(57);
	/**
	 * This class will create a numeric spinner meant to be used inside the {@link AdvancedSearch} component.
	 *
	 * It can be, more specifically, used for external code using the {@link AdvancedSearchEvents.buildingAdvancedSearch}
	 */
	var NumericSpinner = (function () {
	    /**
	     * Create a new numeric spinner.
	     *
	     * @param onChange will be called every time the numeric spinner change it's value. `this` will be the `NumericSpinner` instance.
	     * @param min will be the minimum value selectable by the spinner
	     * @param max will be the maximum value selectable by the spinner
	     */
	    function NumericSpinner(onChange, min, max) {
	        if (onChange === void 0) { onChange = function () {
	        }; }
	        if (min === void 0) { min = 0; }
	        this.onChange = onChange;
	        this.min = min;
	        this.max = max;
	        this.buildContent();
	        this.bindEvents();
	    }
	    /**
	     * Reset the spinner
	     */
	    NumericSpinner.prototype.reset = function () {
	        this.getSpinnerInput().value = '';
	    };
	    /**
	     * Return the element on which the spinner is bound.
	     * @returns {HTMLInputElement}
	     */
	    NumericSpinner.prototype.getElement = function () {
	        return this.element;
	    };
	    /**
	     * Return the current selected value in the spinner, as an int.
	     * @returns {number}
	     */
	    NumericSpinner.prototype.getIntValue = function () {
	        return this.getSpinnerInput().value ? parseInt(this.getSpinnerInput().value, 10) : this.min;
	    };
	    /**
	     * Return the current selected value in the spinner, as a float.
	     * @returns {number}
	     */
	    NumericSpinner.prototype.getFloatValue = function () {
	        return this.getSpinnerInput().value ? parseFloat(this.getSpinnerInput().value) : this.min;
	    };
	    /**
	     * Set the value in the spinner.
	     *
	     * @param value
	     */
	    NumericSpinner.prototype.setValue = function (value) {
	        if (this.max && value > this.max) {
	            value = this.max;
	        }
	        if (value < this.min) {
	            value = this.min;
	        }
	        this.getSpinnerInput().value = value.toString();
	        this.onChange();
	    };
	    /**
	     * Return the element on which the spinner is bound.
	     */
	    NumericSpinner.prototype.build = function () {
	        return this.element;
	    };
	    NumericSpinner.prototype.buildContent = function () {
	        var numericSpinner = Dom_1.$$('div', { className: 'coveo-numeric-spinner' });
	        var numberInput = Dom_1.$$('input', { className: 'coveo-advanced-search-number-input', type: 'text' });
	        var addOn = Dom_1.$$('span', { className: 'coveo-add-on' });
	        addOn.el.innerHTML = "<div class=\"coveo-spinner-up\">\n                              <i class=\"coveo-sprites-arrow-up\"></i>\n                          </div>\n                          <div class=\"coveo-spinner-down\">\n                              <i class=\"coveo-sprites-arrow-down\"></i>\n                          </div>";
	        numericSpinner.append(numberInput.el);
	        numericSpinner.append(addOn.el);
	        this.element = numericSpinner.el;
	    };
	    NumericSpinner.prototype.bindEvents = function () {
	        var _this = this;
	        var up = Dom_1.$$(this.element).find('.coveo-spinner-up');
	        Dom_1.$$(up).on('click', function () {
	            _this.setValue(_this.getFloatValue() + 1);
	        });
	        var down = Dom_1.$$(this.element).find('.coveo-spinner-down');
	        Dom_1.$$(down).on('click', function () {
	            _this.setValue(_this.getFloatValue() - 1);
	        });
	        var numberInput = Dom_1.$$(this.element).find('input');
	        Dom_1.$$(numberInput).on('input', function () {
	            if (numberInput.value.match(/[0-9]*/)) {
	                _this.onChange();
	            }
	        });
	    };
	    NumericSpinner.prototype.getSpinnerInput = function () {
	        return Dom_1.$$(this.element).find('.coveo-advanced-search-number-input');
	    };
	    return NumericSpinner;
	}());
	exports.NumericSpinner = NumericSpinner;


/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var DateInput_1 = __webpack_require__(241);
	var DatePicker_1 = __webpack_require__(247);
	var Strings_1 = __webpack_require__(34);
	var Dom_1 = __webpack_require__(57);
	var BetweenDateInput = (function (_super) {
	    __extends(BetweenDateInput, _super);
	    function BetweenDateInput() {
	        _super.call(this, Strings_1.l('Between'));
	        this.firstDatePicker = new DatePicker_1.DatePicker(this.onChange.bind(this));
	        this.secondDatePicker = new DatePicker_1.DatePicker(this.onChange.bind(this));
	    }
	    BetweenDateInput.prototype.reset = function () {
	        this.firstDatePicker.reset();
	        this.secondDatePicker.reset();
	    };
	    BetweenDateInput.prototype.build = function () {
	        _super.prototype.build.call(this);
	        var container = Dom_1.$$('fieldset', { className: 'coveo-advanced-search-date-input' });
	        container.el.disabled = true;
	        container.append(this.firstDatePicker.getElement());
	        container.append(this.buildAnd());
	        container.append(this.secondDatePicker.getElement());
	        this.element.appendChild(container.el);
	        return this.element;
	    };
	    BetweenDateInput.prototype.getValue = function () {
	        var firstDate = this.firstDatePicker.getValue();
	        var secondDate = this.secondDatePicker.getValue();
	        var query = '';
	        if (firstDate) {
	            query += "(@date>=" + firstDate + ")";
	        }
	        if (secondDate) {
	            query += "(@date<=" + secondDate + ")";
	        }
	        return this.isSelected() ? query : '';
	    };
	    BetweenDateInput.prototype.buildAnd = function () {
	        var and = Dom_1.$$('div', { className: 'coveo-advanced-search-and' });
	        and.text(Strings_1.l('And').toLowerCase());
	        return and.el;
	    };
	    return BetweenDateInput;
	}(DateInput_1.DateInput));
	exports.BetweenDateInput = BetweenDateInput;


/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var Dom_1 = __webpack_require__(57);
	var DateUtils_1 = __webpack_require__(56);
	var Pikaday = __webpack_require__(248);
	/**
	 * This class will create a date picker meant to be used inside the {@link AdvancedSearch} component.
	 *
	 * It can be, more specifically, used for external code using the {@link AdvancedSearchEvents.buildingAdvancedSearch}
	 */
	var DatePicker = (function () {
	    /**
	     * Create a new date picker.
	     * @param onChange will be called every time the date picker change it's value. `this` will be the `DatePicker` instance.
	     */
	    function DatePicker(onChange) {
	        if (onChange === void 0) { onChange = function () { }; }
	        this.onChange = onChange;
	        this.wasReset = false;
	        this.buildContent();
	    }
	    /**
	     * Reset the date picker
	     */
	    DatePicker.prototype.reset = function () {
	        this.picker.setDate(undefined);
	        this.wasReset = true;
	    };
	    /**
	     * Return the element on which the date picker is bound.
	     * @returns {HTMLInputElement}
	     */
	    DatePicker.prototype.getElement = function () {
	        return this.element;
	    };
	    /**
	     * Get the current value for the date picker.
	     * @returns {string}
	     */
	    DatePicker.prototype.getValue = function () {
	        if (this.wasReset) {
	            return '';
	        }
	        var date = this.picker.getDate();
	        return date ? DateUtils_1.DateUtils.dateForQuery(this.picker.getDate()) : '';
	    };
	    /**
	     * Set the current value for the date picker.
	     * @param date
	     */
	    DatePicker.prototype.setValue = function (date) {
	        this.picker.setDate(date);
	        this.wasReset = false;
	    };
	    /**
	     * Return the element on which the date picker is bound.
	     * @returns {HTMLInputElement}
	     */
	    DatePicker.prototype.build = function () {
	        return this.element;
	    };
	    DatePicker.prototype.buildContent = function () {
	        this.element = Dom_1.$$('input', { className: 'coveo-button' }).el;
	        this.element.readOnly = true;
	        this.picker = new Pikaday({
	            field: this.element,
	            onSelect: this.onChange
	        });
	    };
	    return DatePicker;
	}());
	exports.DatePicker = DatePicker;


/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * Pikaday
	 *
	 * Copyright © 2014 David Bushell | BSD & MIT license | https://github.com/dbushell/Pikaday
	 */
	
	(function (root, factory)
	{
	    'use strict';
	
	    var moment;
	    if (true) {
	        // CommonJS module
	        // Load moment.js as an optional dependency
	        try { moment = __webpack_require__(249); } catch (e) {}
	        module.exports = factory(moment);
	    } else if (typeof define === 'function' && define.amd) {
	        // AMD. Register as an anonymous module.
	        define(function (req)
	        {
	            // Load moment.js as an optional dependency
	            var id = 'moment';
	            try { moment = req(id); } catch (e) {}
	            return factory(moment);
	        });
	    } else {
	        root.Pikaday = factory(root.moment);
	    }
	}(this, function (moment)
	{
	    'use strict';
	
	    /**
	     * feature detection and helper functions
	     */
	    var hasMoment = typeof moment === 'function',
	
	    hasEventListeners = !!window.addEventListener,
	
	    document = window.document,
	
	    sto = window.setTimeout,
	
	    addEvent = function(el, e, callback, capture)
	    {
	        if (hasEventListeners) {
	            el.addEventListener(e, callback, !!capture);
	        } else {
	            el.attachEvent('on' + e, callback);
	        }
	    },
	
	    removeEvent = function(el, e, callback, capture)
	    {
	        if (hasEventListeners) {
	            el.removeEventListener(e, callback, !!capture);
	        } else {
	            el.detachEvent('on' + e, callback);
	        }
	    },
	
	    fireEvent = function(el, eventName, data)
	    {
	        var ev;
	
	        if (document.createEvent) {
	            ev = document.createEvent('HTMLEvents');
	            ev.initEvent(eventName, true, false);
	            ev = extend(ev, data);
	            el.dispatchEvent(ev);
	        } else if (document.createEventObject) {
	            ev = document.createEventObject();
	            ev = extend(ev, data);
	            el.fireEvent('on' + eventName, ev);
	        }
	    },
	
	    trim = function(str)
	    {
	        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g,'');
	    },
	
	    hasClass = function(el, cn)
	    {
	        return (' ' + el.className + ' ').indexOf(' ' + cn + ' ') !== -1;
	    },
	
	    addClass = function(el, cn)
	    {
	        if (!hasClass(el, cn)) {
	            el.className = (el.className === '') ? cn : el.className + ' ' + cn;
	        }
	    },
	
	    removeClass = function(el, cn)
	    {
	        el.className = trim((' ' + el.className + ' ').replace(' ' + cn + ' ', ' '));
	    },
	
	    isArray = function(obj)
	    {
	        return (/Array/).test(Object.prototype.toString.call(obj));
	    },
	
	    isDate = function(obj)
	    {
	        return (/Date/).test(Object.prototype.toString.call(obj)) && !isNaN(obj.getTime());
	    },
	
	    isWeekend = function(date)
	    {
	        var day = date.getDay();
	        return day === 0 || day === 6;
	    },
	
	    isLeapYear = function(year)
	    {
	        // solution by Matti Virkkunen: http://stackoverflow.com/a/4881951
	        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
	    },
	
	    getDaysInMonth = function(year, month)
	    {
	        return [31, isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
	    },
	
	    setToStartOfDay = function(date)
	    {
	        if (isDate(date)) date.setHours(0,0,0,0);
	    },
	
	    compareDates = function(a,b)
	    {
	        // weak date comparison (use setToStartOfDay(date) to ensure correct result)
	        return a.getTime() === b.getTime();
	    },
	
	    extend = function(to, from, overwrite)
	    {
	        var prop, hasProp;
	        for (prop in from) {
	            hasProp = to[prop] !== undefined;
	            if (hasProp && typeof from[prop] === 'object' && from[prop] !== null && from[prop].nodeName === undefined) {
	                if (isDate(from[prop])) {
	                    if (overwrite) {
	                        to[prop] = new Date(from[prop].getTime());
	                    }
	                }
	                else if (isArray(from[prop])) {
	                    if (overwrite) {
	                        to[prop] = from[prop].slice(0);
	                    }
	                } else {
	                    to[prop] = extend({}, from[prop], overwrite);
	                }
	            } else if (overwrite || !hasProp) {
	                to[prop] = from[prop];
	            }
	        }
	        return to;
	    },
	
	    adjustCalendar = function(calendar) {
	        if (calendar.month < 0) {
	            calendar.year -= Math.ceil(Math.abs(calendar.month)/12);
	            calendar.month += 12;
	        }
	        if (calendar.month > 11) {
	            calendar.year += Math.floor(Math.abs(calendar.month)/12);
	            calendar.month -= 12;
	        }
	        return calendar;
	    },
	
	    /**
	     * defaults and localisation
	     */
	    defaults = {
	
	        // bind the picker to a form field
	        field: null,
	
	        // automatically show/hide the picker on `field` focus (default `true` if `field` is set)
	        bound: undefined,
	
	        // position of the datepicker, relative to the field (default to bottom & left)
	        // ('bottom' & 'left' keywords are not used, 'top' & 'right' are modifier on the bottom/left position)
	        position: 'bottom left',
	
	        // automatically fit in the viewport even if it means repositioning from the position option
	        reposition: true,
	
	        // the default output format for `.toString()` and `field` value
	        format: 'YYYY-MM-DD',
	
	        // the initial date to view when first opened
	        defaultDate: null,
	
	        // make the `defaultDate` the initial selected value
	        setDefaultDate: false,
	
	        // first day of week (0: Sunday, 1: Monday etc)
	        firstDay: 0,
	
	        // the default flag for moment's strict date parsing
	        formatStrict: false,
	
	        // the minimum/earliest date that can be selected
	        minDate: null,
	        // the maximum/latest date that can be selected
	        maxDate: null,
	
	        // number of years either side, or array of upper/lower range
	        yearRange: 10,
	
	        // show week numbers at head of row
	        showWeekNumber: false,
	
	        // used internally (don't config outside)
	        minYear: 0,
	        maxYear: 9999,
	        minMonth: undefined,
	        maxMonth: undefined,
	
	        startRange: null,
	        endRange: null,
	
	        isRTL: false,
	
	        // Additional text to append to the year in the calendar title
	        yearSuffix: '',
	
	        // Render the month after year in the calendar title
	        showMonthAfterYear: false,
	
	        // Render days of the calendar grid that fall in the next or previous month
	        showDaysInNextAndPreviousMonths: false,
	
	        // how many months are visible
	        numberOfMonths: 1,
	
	        // when numberOfMonths is used, this will help you to choose where the main calendar will be (default `left`, can be set to `right`)
	        // only used for the first display or when a selected date is not visible
	        mainCalendar: 'left',
	
	        // Specify a DOM element to render the calendar in
	        container: undefined,
	
	        // internationalization
	        i18n: {
	            previousMonth : 'Previous Month',
	            nextMonth     : 'Next Month',
	            months        : ['January','February','March','April','May','June','July','August','September','October','November','December'],
	            weekdays      : ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
	            weekdaysShort : ['Sun','Mon','Tue','Wed','Thu','Fri','Sat']
	        },
	
	        // Theme Classname
	        theme: null,
	
	        // callback function
	        onSelect: null,
	        onOpen: null,
	        onClose: null,
	        onDraw: null
	    },
	
	
	    /**
	     * templating functions to abstract HTML rendering
	     */
	    renderDayName = function(opts, day, abbr)
	    {
	        day += opts.firstDay;
	        while (day >= 7) {
	            day -= 7;
	        }
	        return abbr ? opts.i18n.weekdaysShort[day] : opts.i18n.weekdays[day];
	    },
	
	    renderDay = function(opts)
	    {
	        var arr = [];
	        var ariaSelected = 'false';
	        if (opts.isEmpty) {
	            if (opts.showDaysInNextAndPreviousMonths) {
	                arr.push('is-outside-current-month');
	            } else {
	                return '<td class="is-empty"></td>';
	            }
	        }
	        if (opts.isDisabled) {
	            arr.push('is-disabled');
	        }
	        if (opts.isToday) {
	            arr.push('is-today');
	        }
	        if (opts.isSelected) {
	            arr.push('is-selected');
	            ariaSelected = 'true';
	        }
	        if (opts.isInRange) {
	            arr.push('is-inrange');
	        }
	        if (opts.isStartRange) {
	            arr.push('is-startrange');
	        }
	        if (opts.isEndRange) {
	            arr.push('is-endrange');
	        }
	        return '<td data-day="' + opts.day + '" class="' + arr.join(' ') + '" aria-selected="' + ariaSelected + '">' +
	                 '<button class="pika-button pika-day" type="button" ' +
	                    'data-pika-year="' + opts.year + '" data-pika-month="' + opts.month + '" data-pika-day="' + opts.day + '">' +
	                        opts.day +
	                 '</button>' +
	               '</td>';
	    },
	
	    renderWeek = function (d, m, y) {
	        // Lifted from http://javascript.about.com/library/blweekyear.htm, lightly modified.
	        var onejan = new Date(y, 0, 1),
	            weekNum = Math.ceil((((new Date(y, m, d) - onejan) / 86400000) + onejan.getDay()+1)/7);
	        return '<td class="pika-week">' + weekNum + '</td>';
	    },
	
	    renderRow = function(days, isRTL)
	    {
	        return '<tr>' + (isRTL ? days.reverse() : days).join('') + '</tr>';
	    },
	
	    renderBody = function(rows)
	    {
	        return '<tbody>' + rows.join('') + '</tbody>';
	    },
	
	    renderHead = function(opts)
	    {
	        var i, arr = [];
	        if (opts.showWeekNumber) {
	            arr.push('<th></th>');
	        }
	        for (i = 0; i < 7; i++) {
	            arr.push('<th scope="col"><abbr title="' + renderDayName(opts, i) + '">' + renderDayName(opts, i, true) + '</abbr></th>');
	        }
	        return '<thead><tr>' + (opts.isRTL ? arr.reverse() : arr).join('') + '</tr></thead>';
	    },
	
	    renderTitle = function(instance, c, year, month, refYear, randId)
	    {
	        var i, j, arr,
	            opts = instance._o,
	            isMinYear = year === opts.minYear,
	            isMaxYear = year === opts.maxYear,
	            html = '<div id="' + randId + '" class="pika-title" role="heading" aria-live="assertive">',
	            monthHtml,
	            yearHtml,
	            prev = true,
	            next = true;
	
	        for (arr = [], i = 0; i < 12; i++) {
	            arr.push('<option value="' + (year === refYear ? i - c : 12 + i - c) + '"' +
	                (i === month ? ' selected="selected"': '') +
	                ((isMinYear && i < opts.minMonth) || (isMaxYear && i > opts.maxMonth) ? 'disabled="disabled"' : '') + '>' +
	                opts.i18n.months[i] + '</option>');
	        }
	
	        monthHtml = '<div class="pika-label">' + opts.i18n.months[month] + '<select class="pika-select pika-select-month" tabindex="-1">' + arr.join('') + '</select></div>';
	
	        if (isArray(opts.yearRange)) {
	            i = opts.yearRange[0];
	            j = opts.yearRange[1] + 1;
	        } else {
	            i = year - opts.yearRange;
	            j = 1 + year + opts.yearRange;
	        }
	
	        for (arr = []; i < j && i <= opts.maxYear; i++) {
	            if (i >= opts.minYear) {
	                arr.push('<option value="' + i + '"' + (i === year ? ' selected="selected"': '') + '>' + (i) + '</option>');
	            }
	        }
	        yearHtml = '<div class="pika-label">' + year + opts.yearSuffix + '<select class="pika-select pika-select-year" tabindex="-1">' + arr.join('') + '</select></div>';
	
	        if (opts.showMonthAfterYear) {
	            html += yearHtml + monthHtml;
	        } else {
	            html += monthHtml + yearHtml;
	        }
	
	        if (isMinYear && (month === 0 || opts.minMonth >= month)) {
	            prev = false;
	        }
	
	        if (isMaxYear && (month === 11 || opts.maxMonth <= month)) {
	            next = false;
	        }
	
	        if (c === 0) {
	            html += '<button class="pika-prev' + (prev ? '' : ' is-disabled') + '" type="button">' + opts.i18n.previousMonth + '</button>';
	        }
	        if (c === (instance._o.numberOfMonths - 1) ) {
	            html += '<button class="pika-next' + (next ? '' : ' is-disabled') + '" type="button">' + opts.i18n.nextMonth + '</button>';
	        }
	
	        return html += '</div>';
	    },
	
	    renderTable = function(opts, data, randId)
	    {
	        return '<table cellpadding="0" cellspacing="0" class="pika-table" role="grid" aria-labelledby="' + randId + '">' + renderHead(opts) + renderBody(data) + '</table>';
	    },
	
	
	    /**
	     * Pikaday constructor
	     */
	    Pikaday = function(options)
	    {
	        var self = this,
	            opts = self.config(options);
	
	        self._onMouseDown = function(e)
	        {
	            if (!self._v) {
	                return;
	            }
	            e = e || window.event;
	            var target = e.target || e.srcElement;
	            if (!target) {
	                return;
	            }
	
	            if (!hasClass(target, 'is-disabled')) {
	                if (hasClass(target, 'pika-button') && !hasClass(target, 'is-empty') && !hasClass(target.parentNode, 'is-disabled')) {
	                    self.setDate(new Date(target.getAttribute('data-pika-year'), target.getAttribute('data-pika-month'), target.getAttribute('data-pika-day')));
	                    if (opts.bound) {
	                        sto(function() {
	                            self.hide();
	                            if (opts.field) {
	                                opts.field.blur();
	                            }
	                        }, 100);
	                    }
	                }
	                else if (hasClass(target, 'pika-prev')) {
	                    self.prevMonth();
	                }
	                else if (hasClass(target, 'pika-next')) {
	                    self.nextMonth();
	                }
	            }
	            if (!hasClass(target, 'pika-select')) {
	                // if this is touch event prevent mouse events emulation
	                if (e.preventDefault) {
	                    e.preventDefault();
	                } else {
	                    e.returnValue = false;
	                    return false;
	                }
	            } else {
	                self._c = true;
	            }
	        };
	
	        self._onChange = function(e)
	        {
	            e = e || window.event;
	            var target = e.target || e.srcElement;
	            if (!target) {
	                return;
	            }
	            if (hasClass(target, 'pika-select-month')) {
	                self.gotoMonth(target.value);
	            }
	            else if (hasClass(target, 'pika-select-year')) {
	                self.gotoYear(target.value);
	            }
	        };
	
	        self._onKeyChange = function(e)
	        {
	            e = e || window.event;
	
	            if (self.isVisible()) {
	
	                switch(e.keyCode){
	                    case 13:
	                    case 27:
	                        opts.field.blur();
	                        break;
	                    case 37:
	                        e.preventDefault();
	                        self.adjustDate('subtract', 1);
	                        break;
	                    case 38:
	                        self.adjustDate('subtract', 7);
	                        break;
	                    case 39:
	                        self.adjustDate('add', 1);
	                        break;
	                    case 40:
	                        self.adjustDate('add', 7);
	                        break;
	                }
	            }
	        };
	
	        self._onInputChange = function(e)
	        {
	            var date;
	
	            if (e.firedBy === self) {
	                return;
	            }
	            if (hasMoment) {
	                date = moment(opts.field.value, opts.format, opts.formatStrict);
	                date = (date && date.isValid()) ? date.toDate() : null;
	            }
	            else {
	                date = new Date(Date.parse(opts.field.value));
	            }
	            if (isDate(date)) {
	              self.setDate(date);
	            }
	            if (!self._v) {
	                self.show();
	            }
	        };
	
	        self._onInputFocus = function()
	        {
	            self.show();
	        };
	
	        self._onInputClick = function()
	        {
	            self.show();
	        };
	
	        self._onInputBlur = function()
	        {
	            // IE allows pika div to gain focus; catch blur the input field
	            var pEl = document.activeElement;
	            do {
	                if (hasClass(pEl, 'pika-single')) {
	                    return;
	                }
	            }
	            while ((pEl = pEl.parentNode));
	
	            if (!self._c) {
	                self._b = sto(function() {
	                    self.hide();
	                }, 50);
	            }
	            self._c = false;
	        };
	
	        self._onClick = function(e)
	        {
	            e = e || window.event;
	            var target = e.target || e.srcElement,
	                pEl = target;
	            if (!target) {
	                return;
	            }
	            if (!hasEventListeners && hasClass(target, 'pika-select')) {
	                if (!target.onchange) {
	                    target.setAttribute('onchange', 'return;');
	                    addEvent(target, 'change', self._onChange);
	                }
	            }
	            do {
	                if (hasClass(pEl, 'pika-single') || pEl === opts.trigger) {
	                    return;
	                }
	            }
	            while ((pEl = pEl.parentNode));
	            if (self._v && target !== opts.trigger && pEl !== opts.trigger) {
	                self.hide();
	            }
	        };
	
	        self.el = document.createElement('div');
	        self.el.className = 'pika-single' + (opts.isRTL ? ' is-rtl' : '') + (opts.theme ? ' ' + opts.theme : '');
	
	        addEvent(self.el, 'mousedown', self._onMouseDown, true);
	        addEvent(self.el, 'touchend', self._onMouseDown, true);
	        addEvent(self.el, 'change', self._onChange);
	        addEvent(document, 'keydown', self._onKeyChange);
	
	        if (opts.field) {
	            if (opts.container) {
	                opts.container.appendChild(self.el);
	            } else if (opts.bound) {
	                document.body.appendChild(self.el);
	            } else {
	                opts.field.parentNode.insertBefore(self.el, opts.field.nextSibling);
	            }
	            addEvent(opts.field, 'change', self._onInputChange);
	
	            if (!opts.defaultDate) {
	                if (hasMoment && opts.field.value) {
	                    opts.defaultDate = moment(opts.field.value, opts.format).toDate();
	                } else {
	                    opts.defaultDate = new Date(Date.parse(opts.field.value));
	                }
	                opts.setDefaultDate = true;
	            }
	        }
	
	        var defDate = opts.defaultDate;
	
	        if (isDate(defDate)) {
	            if (opts.setDefaultDate) {
	                self.setDate(defDate, true);
	            } else {
	                self.gotoDate(defDate);
	            }
	        } else {
	            self.gotoDate(new Date());
	        }
	
	        if (opts.bound) {
	            this.hide();
	            self.el.className += ' is-bound';
	            addEvent(opts.trigger, 'click', self._onInputClick);
	            addEvent(opts.trigger, 'focus', self._onInputFocus);
	            addEvent(opts.trigger, 'blur', self._onInputBlur);
	        } else {
	            this.show();
	        }
	    };
	
	
	    /**
	     * public Pikaday API
	     */
	    Pikaday.prototype = {
	
	
	        /**
	         * configure functionality
	         */
	        config: function(options)
	        {
	            if (!this._o) {
	                this._o = extend({}, defaults, true);
	            }
	
	            var opts = extend(this._o, options, true);
	
	            opts.isRTL = !!opts.isRTL;
	
	            opts.field = (opts.field && opts.field.nodeName) ? opts.field : null;
	
	            opts.theme = (typeof opts.theme) === 'string' && opts.theme ? opts.theme : null;
	
	            opts.bound = !!(opts.bound !== undefined ? opts.field && opts.bound : opts.field);
	
	            opts.trigger = (opts.trigger && opts.trigger.nodeName) ? opts.trigger : opts.field;
	
	            opts.disableWeekends = !!opts.disableWeekends;
	
	            opts.disableDayFn = (typeof opts.disableDayFn) === 'function' ? opts.disableDayFn : null;
	
	            var nom = parseInt(opts.numberOfMonths, 10) || 1;
	            opts.numberOfMonths = nom > 4 ? 4 : nom;
	
	            if (!isDate(opts.minDate)) {
	                opts.minDate = false;
	            }
	            if (!isDate(opts.maxDate)) {
	                opts.maxDate = false;
	            }
	            if ((opts.minDate && opts.maxDate) && opts.maxDate < opts.minDate) {
	                opts.maxDate = opts.minDate = false;
	            }
	            if (opts.minDate) {
	                this.setMinDate(opts.minDate);
	            }
	            if (opts.maxDate) {
	                this.setMaxDate(opts.maxDate);
	            }
	
	            if (isArray(opts.yearRange)) {
	                var fallback = new Date().getFullYear() - 10;
	                opts.yearRange[0] = parseInt(opts.yearRange[0], 10) || fallback;
	                opts.yearRange[1] = parseInt(opts.yearRange[1], 10) || fallback;
	            } else {
	                opts.yearRange = Math.abs(parseInt(opts.yearRange, 10)) || defaults.yearRange;
	                if (opts.yearRange > 100) {
	                    opts.yearRange = 100;
	                }
	            }
	
	            return opts;
	        },
	
	        /**
	         * return a formatted string of the current selection (using Moment.js if available)
	         */
	        toString: function(format)
	        {
	            return !isDate(this._d) ? '' : hasMoment ? moment(this._d).format(format || this._o.format) : this._d.toDateString();
	        },
	
	        /**
	         * return a Moment.js object of the current selection (if available)
	         */
	        getMoment: function()
	        {
	            return hasMoment ? moment(this._d) : null;
	        },
	
	        /**
	         * set the current selection from a Moment.js object (if available)
	         */
	        setMoment: function(date, preventOnSelect)
	        {
	            if (hasMoment && moment.isMoment(date)) {
	                this.setDate(date.toDate(), preventOnSelect);
	            }
	        },
	
	        /**
	         * return a Date object of the current selection with fallback for the current date
	         */
	        getDate: function()
	        {
	            return isDate(this._d) ? new Date(this._d.getTime()) : new Date();
	        },
	
	        /**
	         * set the current selection
	         */
	        setDate: function(date, preventOnSelect)
	        {
	            if (!date) {
	                this._d = null;
	
	                if (this._o.field) {
	                    this._o.field.value = '';
	                    fireEvent(this._o.field, 'change', { firedBy: this });
	                }
	
	                return this.draw();
	            }
	            if (typeof date === 'string') {
	                date = new Date(Date.parse(date));
	            }
	            if (!isDate(date)) {
	                return;
	            }
	
	            var min = this._o.minDate,
	                max = this._o.maxDate;
	
	            if (isDate(min) && date < min) {
	                date = min;
	            } else if (isDate(max) && date > max) {
	                date = max;
	            }
	
	            this._d = new Date(date.getTime());
	            setToStartOfDay(this._d);
	            this.gotoDate(this._d);
	
	            if (this._o.field) {
	                this._o.field.value = this.toString();
	                fireEvent(this._o.field, 'change', { firedBy: this });
	            }
	            if (!preventOnSelect && typeof this._o.onSelect === 'function') {
	                this._o.onSelect.call(this, this.getDate());
	            }
	        },
	
	        /**
	         * change view to a specific date
	         */
	        gotoDate: function(date)
	        {
	            var newCalendar = true;
	
	            if (!isDate(date)) {
	                return;
	            }
	
	            if (this.calendars) {
	                var firstVisibleDate = new Date(this.calendars[0].year, this.calendars[0].month, 1),
	                    lastVisibleDate = new Date(this.calendars[this.calendars.length-1].year, this.calendars[this.calendars.length-1].month, 1),
	                    visibleDate = date.getTime();
	                // get the end of the month
	                lastVisibleDate.setMonth(lastVisibleDate.getMonth()+1);
	                lastVisibleDate.setDate(lastVisibleDate.getDate()-1);
	                newCalendar = (visibleDate < firstVisibleDate.getTime() || lastVisibleDate.getTime() < visibleDate);
	            }
	
	            if (newCalendar) {
	                this.calendars = [{
	                    month: date.getMonth(),
	                    year: date.getFullYear()
	                }];
	                if (this._o.mainCalendar === 'right') {
	                    this.calendars[0].month += 1 - this._o.numberOfMonths;
	                }
	            }
	
	            this.adjustCalendars();
	        },
	
	        adjustDate: function(sign, days) {
	
	            var day = this.getDate();
	            var difference = parseInt(days)*24*60*60*1000;
	
	            var newDay;
	
	            if (sign === 'add') {
	                newDay = new Date(day.valueOf() + difference);
	            } else if (sign === 'subtract') {
	                newDay = new Date(day.valueOf() - difference);
	            }
	
	            if (hasMoment) {
	                if (sign === 'add') {
	                    newDay = moment(day).add(days, "days").toDate();
	                } else if (sign === 'subtract') {
	                    newDay = moment(day).subtract(days, "days").toDate();
	                }
	            }
	
	            this.setDate(newDay);
	        },
	
	        adjustCalendars: function() {
	            this.calendars[0] = adjustCalendar(this.calendars[0]);
	            for (var c = 1; c < this._o.numberOfMonths; c++) {
	                this.calendars[c] = adjustCalendar({
	                    month: this.calendars[0].month + c,
	                    year: this.calendars[0].year
	                });
	            }
	            this.draw();
	        },
	
	        gotoToday: function()
	        {
	            this.gotoDate(new Date());
	        },
	
	        /**
	         * change view to a specific month (zero-index, e.g. 0: January)
	         */
	        gotoMonth: function(month)
	        {
	            if (!isNaN(month)) {
	                this.calendars[0].month = parseInt(month, 10);
	                this.adjustCalendars();
	            }
	        },
	
	        nextMonth: function()
	        {
	            this.calendars[0].month++;
	            this.adjustCalendars();
	        },
	
	        prevMonth: function()
	        {
	            this.calendars[0].month--;
	            this.adjustCalendars();
	        },
	
	        /**
	         * change view to a specific full year (e.g. "2012")
	         */
	        gotoYear: function(year)
	        {
	            if (!isNaN(year)) {
	                this.calendars[0].year = parseInt(year, 10);
	                this.adjustCalendars();
	            }
	        },
	
	        /**
	         * change the minDate
	         */
	        setMinDate: function(value)
	        {
	            if(value instanceof Date) {
	                setToStartOfDay(value);
	                this._o.minDate = value;
	                this._o.minYear  = value.getFullYear();
	                this._o.minMonth = value.getMonth();
	            } else {
	                this._o.minDate = defaults.minDate;
	                this._o.minYear  = defaults.minYear;
	                this._o.minMonth = defaults.minMonth;
	                this._o.startRange = defaults.startRange;
	            }
	
	            this.draw();
	        },
	
	        /**
	         * change the maxDate
	         */
	        setMaxDate: function(value)
	        {
	            if(value instanceof Date) {
	                setToStartOfDay(value);
	                this._o.maxDate = value;
	                this._o.maxYear = value.getFullYear();
	                this._o.maxMonth = value.getMonth();
	            } else {
	                this._o.maxDate = defaults.maxDate;
	                this._o.maxYear = defaults.maxYear;
	                this._o.maxMonth = defaults.maxMonth;
	                this._o.endRange = defaults.endRange;
	            }
	
	            this.draw();
	        },
	
	        setStartRange: function(value)
	        {
	            this._o.startRange = value;
	        },
	
	        setEndRange: function(value)
	        {
	            this._o.endRange = value;
	        },
	
	        /**
	         * refresh the HTML
	         */
	        draw: function(force)
	        {
	            if (!this._v && !force) {
	                return;
	            }
	            var opts = this._o,
	                minYear = opts.minYear,
	                maxYear = opts.maxYear,
	                minMonth = opts.minMonth,
	                maxMonth = opts.maxMonth,
	                html = '',
	                randId;
	
	            if (this._y <= minYear) {
	                this._y = minYear;
	                if (!isNaN(minMonth) && this._m < minMonth) {
	                    this._m = minMonth;
	                }
	            }
	            if (this._y >= maxYear) {
	                this._y = maxYear;
	                if (!isNaN(maxMonth) && this._m > maxMonth) {
	                    this._m = maxMonth;
	                }
	            }
	
	            randId = 'pika-title-' + Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 2);
	
	            for (var c = 0; c < opts.numberOfMonths; c++) {
	                html += '<div class="pika-lendar">' + renderTitle(this, c, this.calendars[c].year, this.calendars[c].month, this.calendars[0].year, randId) + this.render(this.calendars[c].year, this.calendars[c].month, randId) + '</div>';
	            }
	
	            this.el.innerHTML = html;
	
	            if (opts.bound) {
	                if(opts.field.type !== 'hidden') {
	                    sto(function() {
	                        opts.trigger.focus();
	                    }, 1);
	                }
	            }
	
	            if (typeof this._o.onDraw === 'function') {
	                this._o.onDraw(this);
	            }
	            
	            if (opts.bound) {
	                // let the screen reader user know to use arrow keys
	                opts.field.setAttribute('aria-label', 'Use the arrow keys to pick a date');
	            }
	        },
	
	        adjustPosition: function()
	        {
	            var field, pEl, width, height, viewportWidth, viewportHeight, scrollTop, left, top, clientRect;
	
	            if (this._o.container) return;
	
	            this.el.style.position = 'absolute';
	
	            field = this._o.trigger;
	            pEl = field;
	            width = this.el.offsetWidth;
	            height = this.el.offsetHeight;
	            viewportWidth = window.innerWidth || document.documentElement.clientWidth;
	            viewportHeight = window.innerHeight || document.documentElement.clientHeight;
	            scrollTop = window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop;
	
	            if (typeof field.getBoundingClientRect === 'function') {
	                clientRect = field.getBoundingClientRect();
	                left = clientRect.left + window.pageXOffset;
	                top = clientRect.bottom + window.pageYOffset;
	            } else {
	                left = pEl.offsetLeft;
	                top  = pEl.offsetTop + pEl.offsetHeight;
	                while((pEl = pEl.offsetParent)) {
	                    left += pEl.offsetLeft;
	                    top  += pEl.offsetTop;
	                }
	            }
	
	            // default position is bottom & left
	            if ((this._o.reposition && left + width > viewportWidth) ||
	                (
	                    this._o.position.indexOf('right') > -1 &&
	                    left - width + field.offsetWidth > 0
	                )
	            ) {
	                left = left - width + field.offsetWidth;
	            }
	            if ((this._o.reposition && top + height > viewportHeight + scrollTop) ||
	                (
	                    this._o.position.indexOf('top') > -1 &&
	                    top - height - field.offsetHeight > 0
	                )
	            ) {
	                top = top - height - field.offsetHeight;
	            }
	
	            this.el.style.left = left + 'px';
	            this.el.style.top = top + 'px';
	        },
	
	        /**
	         * render HTML for a particular month
	         */
	        render: function(year, month, randId)
	        {
	            var opts   = this._o,
	                now    = new Date(),
	                days   = getDaysInMonth(year, month),
	                before = new Date(year, month, 1).getDay(),
	                data   = [],
	                row    = [];
	            setToStartOfDay(now);
	            if (opts.firstDay > 0) {
	                before -= opts.firstDay;
	                if (before < 0) {
	                    before += 7;
	                }
	            }
	            var previousMonth = month === 0 ? 11 : month - 1,
	                nextMonth = month === 11 ? 0 : month + 1,
	                yearOfPreviousMonth = month === 0 ? year - 1 : year,
	                yearOfNextMonth = month === 11 ? year + 1 : year,
	                daysInPreviousMonth = getDaysInMonth(yearOfPreviousMonth, previousMonth);
	            var cells = days + before,
	                after = cells;
	            while(after > 7) {
	                after -= 7;
	            }
	            cells += 7 - after;
	            for (var i = 0, r = 0; i < cells; i++)
	            {
	                var day = new Date(year, month, 1 + (i - before)),
	                    isSelected = isDate(this._d) ? compareDates(day, this._d) : false,
	                    isToday = compareDates(day, now),
	                    isEmpty = i < before || i >= (days + before),
	                    dayNumber = 1 + (i - before),
	                    monthNumber = month,
	                    yearNumber = year,
	                    isStartRange = opts.startRange && compareDates(opts.startRange, day),
	                    isEndRange = opts.endRange && compareDates(opts.endRange, day),
	                    isInRange = opts.startRange && opts.endRange && opts.startRange < day && day < opts.endRange,
	                    isDisabled = (opts.minDate && day < opts.minDate) ||
	                                 (opts.maxDate && day > opts.maxDate) ||
	                                 (opts.disableWeekends && isWeekend(day)) ||
	                                 (opts.disableDayFn && opts.disableDayFn(day));
	
	                if (isEmpty) {
	                    if (i < before) {
	                        dayNumber = daysInPreviousMonth + dayNumber;
	                        monthNumber = previousMonth;
	                        yearNumber = yearOfPreviousMonth;
	                    } else {
	                        dayNumber = dayNumber - days;
	                        monthNumber = nextMonth;
	                        yearNumber = yearOfNextMonth;
	                    }
	                }
	
	                var dayConfig = {
	                        day: dayNumber,
	                        month: monthNumber,
	                        year: yearNumber,
	                        isSelected: isSelected,
	                        isToday: isToday,
	                        isDisabled: isDisabled,
	                        isEmpty: isEmpty,
	                        isStartRange: isStartRange,
	                        isEndRange: isEndRange,
	                        isInRange: isInRange,
	                        showDaysInNextAndPreviousMonths: opts.showDaysInNextAndPreviousMonths
	                    };
	
	                row.push(renderDay(dayConfig));
	
	                if (++r === 7) {
	                    if (opts.showWeekNumber) {
	                        row.unshift(renderWeek(i - before, month, year));
	                    }
	                    data.push(renderRow(row, opts.isRTL));
	                    row = [];
	                    r = 0;
	                }
	            }
	            return renderTable(opts, data, randId);
	        },
	
	        isVisible: function()
	        {
	            return this._v;
	        },
	
	        show: function()
	        {
	            if (!this.isVisible()) {
	                removeClass(this.el, 'is-hidden');
	                this._v = true;
	                this.draw();
	                if (this._o.bound) {
	                    addEvent(document, 'click', this._onClick);
	                    this.adjustPosition();
	                }
	                if (typeof this._o.onOpen === 'function') {
	                    this._o.onOpen.call(this);
	                }
	            }
	        },
	
	        hide: function()
	        {
	            var v = this._v;
	            if (v !== false) {
	                if (this._o.bound) {
	                    removeEvent(document, 'click', this._onClick);
	                }
	                this.el.style.position = 'static'; // reset
	                this.el.style.left = 'auto';
	                this.el.style.top = 'auto';
	                addClass(this.el, 'is-hidden');
	                this._v = false;
	                if (v !== undefined && typeof this._o.onClose === 'function') {
	                    this._o.onClose.call(this);
	                }
	            }
	        },
	
	        /**
	         * GAME OVER
	         */
	        destroy: function()
	        {
	            this.hide();
	            removeEvent(this.el, 'mousedown', this._onMouseDown, true);
	            removeEvent(this.el, 'touchend', this._onMouseDown, true);
	            removeEvent(this.el, 'change', this._onChange);
	            if (this._o.field) {
	                removeEvent(this._o.field, 'change', this._onInputChange);
	                if (this._o.bound) {
	                    removeEvent(this._o.trigger, 'click', this._onInputClick);
	                    removeEvent(this._o.trigger, 'focus', this._onInputFocus);
	                    removeEvent(this._o.trigger, 'blur', this._onInputBlur);
	                }
	            }
	            if (this.el.parentNode) {
	                this.el.parentNode.removeChild(this.el);
	            }
	        }
	
	    };
	
	    return Pikaday;
	
	}));


/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.17.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	var hookCallback;
	
	function hooks () {
	    return hookCallback.apply(null, arguments);
	}
	
	// This is done to register the method called with moment()
	// without creating circular dependencies.
	function setHookCallback (callback) {
	    hookCallback = callback;
	}
	
	function isArray(input) {
	    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	}
	
	function isObject(input) {
	    // IE8 will treat undefined and null as object if it wasn't for
	    // input != null
	    return input != null && Object.prototype.toString.call(input) === '[object Object]';
	}
	
	function isObjectEmpty(obj) {
	    var k;
	    for (k in obj) {
	        // even if its not own property I'd still call it non-empty
	        return false;
	    }
	    return true;
	}
	
	function isNumber(input) {
	    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	}
	
	function isDate(input) {
	    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	}
	
	function map(arr, fn) {
	    var res = [], i;
	    for (i = 0; i < arr.length; ++i) {
	        res.push(fn(arr[i], i));
	    }
	    return res;
	}
	
	function hasOwnProp(a, b) {
	    return Object.prototype.hasOwnProperty.call(a, b);
	}
	
	function extend(a, b) {
	    for (var i in b) {
	        if (hasOwnProp(b, i)) {
	            a[i] = b[i];
	        }
	    }
	
	    if (hasOwnProp(b, 'toString')) {
	        a.toString = b.toString;
	    }
	
	    if (hasOwnProp(b, 'valueOf')) {
	        a.valueOf = b.valueOf;
	    }
	
	    return a;
	}
	
	function createUTC (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, true).utc();
	}
	
	function defaultParsingFlags() {
	    // We need to deep clone this object.
	    return {
	        empty           : false,
	        unusedTokens    : [],
	        unusedInput     : [],
	        overflow        : -2,
	        charsLeftOver   : 0,
	        nullInput       : false,
	        invalidMonth    : null,
	        invalidFormat   : false,
	        userInvalidated : false,
	        iso             : false,
	        parsedDateParts : [],
	        meridiem        : null
	    };
	}
	
	function getParsingFlags(m) {
	    if (m._pf == null) {
	        m._pf = defaultParsingFlags();
	    }
	    return m._pf;
	}
	
	var some;
	if (Array.prototype.some) {
	    some = Array.prototype.some;
	} else {
	    some = function (fun) {
	        var t = Object(this);
	        var len = t.length >>> 0;
	
	        for (var i = 0; i < len; i++) {
	            if (i in t && fun.call(this, t[i], i, t)) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	}
	
	var some$1 = some;
	
	function isValid(m) {
	    if (m._isValid == null) {
	        var flags = getParsingFlags(m);
	        var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
	            return i != null;
	        });
	        var isNowValid = !isNaN(m._d.getTime()) &&
	            flags.overflow < 0 &&
	            !flags.empty &&
	            !flags.invalidMonth &&
	            !flags.invalidWeekday &&
	            !flags.nullInput &&
	            !flags.invalidFormat &&
	            !flags.userInvalidated &&
	            (!flags.meridiem || (flags.meridiem && parsedParts));
	
	        if (m._strict) {
	            isNowValid = isNowValid &&
	                flags.charsLeftOver === 0 &&
	                flags.unusedTokens.length === 0 &&
	                flags.bigHour === undefined;
	        }
	
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        }
	        else {
	            return isNowValid;
	        }
	    }
	    return m._isValid;
	}
	
	function createInvalid (flags) {
	    var m = createUTC(NaN);
	    if (flags != null) {
	        extend(getParsingFlags(m), flags);
	    }
	    else {
	        getParsingFlags(m).userInvalidated = true;
	    }
	
	    return m;
	}
	
	function isUndefined(input) {
	    return input === void 0;
	}
	
	// Plugins that add properties should also add the key here (null value),
	// so we can properly clone ourselves.
	var momentProperties = hooks.momentProperties = [];
	
	function copyConfig(to, from) {
	    var i, prop, val;
	
	    if (!isUndefined(from._isAMomentObject)) {
	        to._isAMomentObject = from._isAMomentObject;
	    }
	    if (!isUndefined(from._i)) {
	        to._i = from._i;
	    }
	    if (!isUndefined(from._f)) {
	        to._f = from._f;
	    }
	    if (!isUndefined(from._l)) {
	        to._l = from._l;
	    }
	    if (!isUndefined(from._strict)) {
	        to._strict = from._strict;
	    }
	    if (!isUndefined(from._tzm)) {
	        to._tzm = from._tzm;
	    }
	    if (!isUndefined(from._isUTC)) {
	        to._isUTC = from._isUTC;
	    }
	    if (!isUndefined(from._offset)) {
	        to._offset = from._offset;
	    }
	    if (!isUndefined(from._pf)) {
	        to._pf = getParsingFlags(from);
	    }
	    if (!isUndefined(from._locale)) {
	        to._locale = from._locale;
	    }
	
	    if (momentProperties.length > 0) {
	        for (i in momentProperties) {
	            prop = momentProperties[i];
	            val = from[prop];
	            if (!isUndefined(val)) {
	                to[prop] = val;
	            }
	        }
	    }
	
	    return to;
	}
	
	var updateInProgress = false;
	
	// Moment prototype object
	function Moment(config) {
	    copyConfig(this, config);
	    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	    if (!this.isValid()) {
	        this._d = new Date(NaN);
	    }
	    // Prevent infinite loop in case updateOffset creates new moment
	    // objects.
	    if (updateInProgress === false) {
	        updateInProgress = true;
	        hooks.updateOffset(this);
	        updateInProgress = false;
	    }
	}
	
	function isMoment (obj) {
	    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	}
	
	function absFloor (number) {
	    if (number < 0) {
	        // -0 -> 0
	        return Math.ceil(number) || 0;
	    } else {
	        return Math.floor(number);
	    }
	}
	
	function toInt(argumentForCoercion) {
	    var coercedNumber = +argumentForCoercion,
	        value = 0;
	
	    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	        value = absFloor(coercedNumber);
	    }
	
	    return value;
	}
	
	// compare two arrays, return the number of differences
	function compareArrays(array1, array2, dontConvert) {
	    var len = Math.min(array1.length, array2.length),
	        lengthDiff = Math.abs(array1.length - array2.length),
	        diffs = 0,
	        i;
	    for (i = 0; i < len; i++) {
	        if ((dontConvert && array1[i] !== array2[i]) ||
	            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	            diffs++;
	        }
	    }
	    return diffs + lengthDiff;
	}
	
	function warn(msg) {
	    if (hooks.suppressDeprecationWarnings === false &&
	            (typeof console !==  'undefined') && console.warn) {
	        console.warn('Deprecation warning: ' + msg);
	    }
	}
	
	function deprecate(msg, fn) {
	    var firstTime = true;
	
	    return extend(function () {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(null, msg);
	        }
	        if (firstTime) {
	            var args = [];
	            var arg;
	            for (var i = 0; i < arguments.length; i++) {
	                arg = '';
	                if (typeof arguments[i] === 'object') {
	                    arg += '\n[' + i + '] ';
	                    for (var key in arguments[0]) {
	                        arg += key + ': ' + arguments[0][key] + ', ';
	                    }
	                    arg = arg.slice(0, -2); // Remove trailing comma and space
	                } else {
	                    arg = arguments[i];
	                }
	                args.push(arg);
	            }
	            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	            firstTime = false;
	        }
	        return fn.apply(this, arguments);
	    }, fn);
	}
	
	var deprecations = {};
	
	function deprecateSimple(name, msg) {
	    if (hooks.deprecationHandler != null) {
	        hooks.deprecationHandler(name, msg);
	    }
	    if (!deprecations[name]) {
	        warn(msg);
	        deprecations[name] = true;
	    }
	}
	
	hooks.suppressDeprecationWarnings = false;
	hooks.deprecationHandler = null;
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	function set (config) {
	    var prop, i;
	    for (i in config) {
	        prop = config[i];
	        if (isFunction(prop)) {
	            this[i] = prop;
	        } else {
	            this['_' + i] = prop;
	        }
	    }
	    this._config = config;
	    // Lenient ordinal parsing accepts just a number in addition to
	    // number + (possibly) stuff coming from _ordinalParseLenient.
	    this._ordinalParseLenient = new RegExp(this._ordinalParse.source + '|' + (/\d{1,2}/).source);
	}
	
	function mergeConfigs(parentConfig, childConfig) {
	    var res = extend({}, parentConfig), prop;
	    for (prop in childConfig) {
	        if (hasOwnProp(childConfig, prop)) {
	            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                res[prop] = {};
	                extend(res[prop], parentConfig[prop]);
	                extend(res[prop], childConfig[prop]);
	            } else if (childConfig[prop] != null) {
	                res[prop] = childConfig[prop];
	            } else {
	                delete res[prop];
	            }
	        }
	    }
	    for (prop in parentConfig) {
	        if (hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])) {
	            // make sure changes to properties don't modify parent config
	            res[prop] = extend({}, res[prop]);
	        }
	    }
	    return res;
	}
	
	function Locale(config) {
	    if (config != null) {
	        this.set(config);
	    }
	}
	
	var keys;
	
	if (Object.keys) {
	    keys = Object.keys;
	} else {
	    keys = function (obj) {
	        var i, res = [];
	        for (i in obj) {
	            if (hasOwnProp(obj, i)) {
	                res.push(i);
	            }
	        }
	        return res;
	    };
	}
	
	var keys$1 = keys;
	
	var defaultCalendar = {
	    sameDay : '[Today at] LT',
	    nextDay : '[Tomorrow at] LT',
	    nextWeek : 'dddd [at] LT',
	    lastDay : '[Yesterday at] LT',
	    lastWeek : '[Last] dddd [at] LT',
	    sameElse : 'L'
	};
	
	function calendar (key, mom, now) {
	    var output = this._calendar[key] || this._calendar['sameElse'];
	    return isFunction(output) ? output.call(mom, now) : output;
	}
	
	var defaultLongDateFormat = {
	    LTS  : 'h:mm:ss A',
	    LT   : 'h:mm A',
	    L    : 'MM/DD/YYYY',
	    LL   : 'MMMM D, YYYY',
	    LLL  : 'MMMM D, YYYY h:mm A',
	    LLLL : 'dddd, MMMM D, YYYY h:mm A'
	};
	
	function longDateFormat (key) {
	    var format = this._longDateFormat[key],
	        formatUpper = this._longDateFormat[key.toUpperCase()];
	
	    if (format || !formatUpper) {
	        return format;
	    }
	
	    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	        return val.slice(1);
	    });
	
	    return this._longDateFormat[key];
	}
	
	var defaultInvalidDate = 'Invalid date';
	
	function invalidDate () {
	    return this._invalidDate;
	}
	
	var defaultOrdinal = '%d';
	var defaultOrdinalParse = /\d{1,2}/;
	
	function ordinal (number) {
	    return this._ordinal.replace('%d', number);
	}
	
	var defaultRelativeTime = {
	    future : 'in %s',
	    past   : '%s ago',
	    s  : 'a few seconds',
	    m  : 'a minute',
	    mm : '%d minutes',
	    h  : 'an hour',
	    hh : '%d hours',
	    d  : 'a day',
	    dd : '%d days',
	    M  : 'a month',
	    MM : '%d months',
	    y  : 'a year',
	    yy : '%d years'
	};
	
	function relativeTime (number, withoutSuffix, string, isFuture) {
	    var output = this._relativeTime[string];
	    return (isFunction(output)) ?
	        output(number, withoutSuffix, string, isFuture) :
	        output.replace(/%d/i, number);
	}
	
	function pastFuture (diff, output) {
	    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	}
	
	var aliases = {};
	
	function addUnitAlias (unit, shorthand) {
	    var lowerCase = unit.toLowerCase();
	    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	}
	
	function normalizeUnits(units) {
	    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	}
	
	function normalizeObjectUnits(inputObject) {
	    var normalizedInput = {},
	        normalizedProp,
	        prop;
	
	    for (prop in inputObject) {
	        if (hasOwnProp(inputObject, prop)) {
	            normalizedProp = normalizeUnits(prop);
	            if (normalizedProp) {
	                normalizedInput[normalizedProp] = inputObject[prop];
	            }
	        }
	    }
	
	    return normalizedInput;
	}
	
	var priorities = {};
	
	function addUnitPriority(unit, priority) {
	    priorities[unit] = priority;
	}
	
	function getPrioritizedUnits(unitsObj) {
	    var units = [];
	    for (var u in unitsObj) {
	        units.push({unit: u, priority: priorities[u]});
	    }
	    units.sort(function (a, b) {
	        return a.priority - b.priority;
	    });
	    return units;
	}
	
	function makeGetSet (unit, keepTime) {
	    return function (value) {
	        if (value != null) {
	            set$1(this, unit, value);
	            hooks.updateOffset(this, keepTime);
	            return this;
	        } else {
	            return get(this, unit);
	        }
	    };
	}
	
	function get (mom, unit) {
	    return mom.isValid() ?
	        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	}
	
	function set$1 (mom, unit, value) {
	    if (mom.isValid()) {
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	    }
	}
	
	// MOMENTS
	
	function stringGet (units) {
	    units = normalizeUnits(units);
	    if (isFunction(this[units])) {
	        return this[units]();
	    }
	    return this;
	}
	
	
	function stringSet (units, value) {
	    if (typeof units === 'object') {
	        units = normalizeObjectUnits(units);
	        var prioritized = getPrioritizedUnits(units);
	        for (var i = 0; i < prioritized.length; i++) {
	            this[prioritized[i].unit](units[prioritized[i].unit]);
	        }
	    } else {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units](value);
	        }
	    }
	    return this;
	}
	
	function zeroFill(number, targetLength, forceSign) {
	    var absNumber = '' + Math.abs(number),
	        zerosToFill = targetLength - absNumber.length,
	        sign = number >= 0;
	    return (sign ? (forceSign ? '+' : '') : '-') +
	        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	}
	
	var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	var formatFunctions = {};
	
	var formatTokenFunctions = {};
	
	// token:    'M'
	// padded:   ['MM', 2]
	// ordinal:  'Mo'
	// callback: function () { this.month() + 1 }
	function addFormatToken (token, padded, ordinal, callback) {
	    var func = callback;
	    if (typeof callback === 'string') {
	        func = function () {
	            return this[callback]();
	        };
	    }
	    if (token) {
	        formatTokenFunctions[token] = func;
	    }
	    if (padded) {
	        formatTokenFunctions[padded[0]] = function () {
	            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	        };
	    }
	    if (ordinal) {
	        formatTokenFunctions[ordinal] = function () {
	            return this.localeData().ordinal(func.apply(this, arguments), token);
	        };
	    }
	}
	
	function removeFormattingTokens(input) {
	    if (input.match(/\[[\s\S]/)) {
	        return input.replace(/^\[|\]$/g, '');
	    }
	    return input.replace(/\\/g, '');
	}
	
	function makeFormatFunction(format) {
	    var array = format.match(formattingTokens), i, length;
	
	    for (i = 0, length = array.length; i < length; i++) {
	        if (formatTokenFunctions[array[i]]) {
	            array[i] = formatTokenFunctions[array[i]];
	        } else {
	            array[i] = removeFormattingTokens(array[i]);
	        }
	    }
	
	    return function (mom) {
	        var output = '', i;
	        for (i = 0; i < length; i++) {
	            output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
	        }
	        return output;
	    };
	}
	
	// format date using native date object
	function formatMoment(m, format) {
	    if (!m.isValid()) {
	        return m.localeData().invalidDate();
	    }
	
	    format = expandFormat(format, m.localeData());
	    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	    return formatFunctions[format](m);
	}
	
	function expandFormat(format, locale) {
	    var i = 5;
	
	    function replaceLongDateFormatTokens(input) {
	        return locale.longDateFormat(input) || input;
	    }
	
	    localFormattingTokens.lastIndex = 0;
	    while (i >= 0 && localFormattingTokens.test(format)) {
	        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	        localFormattingTokens.lastIndex = 0;
	        i -= 1;
	    }
	
	    return format;
	}
	
	var match1         = /\d/;            //       0 - 9
	var match2         = /\d\d/;          //      00 - 99
	var match3         = /\d{3}/;         //     000 - 999
	var match4         = /\d{4}/;         //    0000 - 9999
	var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	var match1to2      = /\d\d?/;         //       0 - 99
	var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	var match1to3      = /\d{1,3}/;       //       0 - 999
	var match1to4      = /\d{1,4}/;       //       0 - 9999
	var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	var matchUnsigned  = /\d+/;           //       0 - inf
	var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	// any word (or two) characters or numbers including two/three word month in arabic.
	// includes scottish gaelic two word and hyphenated months
	var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	
	var regexes = {};
	
	function addRegexToken (token, regex, strictRegex) {
	    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	        return (isStrict && strictRegex) ? strictRegex : regex;
	    };
	}
	
	function getParseRegexForToken (token, config) {
	    if (!hasOwnProp(regexes, token)) {
	        return new RegExp(unescapeFormat(token));
	    }
	
	    return regexes[token](config._strict, config._locale);
	}
	
	// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	function unescapeFormat(s) {
	    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	        return p1 || p2 || p3 || p4;
	    }));
	}
	
	function regexEscape(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	}
	
	var tokens = {};
	
	function addParseToken (token, callback) {
	    var i, func = callback;
	    if (typeof token === 'string') {
	        token = [token];
	    }
	    if (isNumber(callback)) {
	        func = function (input, array) {
	            array[callback] = toInt(input);
	        };
	    }
	    for (i = 0; i < token.length; i++) {
	        tokens[token[i]] = func;
	    }
	}
	
	function addWeekParseToken (token, callback) {
	    addParseToken(token, function (input, array, config, token) {
	        config._w = config._w || {};
	        callback(input, config._w, config, token);
	    });
	}
	
	function addTimeToArrayFromToken(token, input, config) {
	    if (input != null && hasOwnProp(tokens, token)) {
	        tokens[token](input, config._a, config, token);
	    }
	}
	
	var YEAR = 0;
	var MONTH = 1;
	var DATE = 2;
	var HOUR = 3;
	var MINUTE = 4;
	var SECOND = 5;
	var MILLISECOND = 6;
	var WEEK = 7;
	var WEEKDAY = 8;
	
	var indexOf;
	
	if (Array.prototype.indexOf) {
	    indexOf = Array.prototype.indexOf;
	} else {
	    indexOf = function (o) {
	        // I know
	        var i;
	        for (i = 0; i < this.length; ++i) {
	            if (this[i] === o) {
	                return i;
	            }
	        }
	        return -1;
	    };
	}
	
	var indexOf$1 = indexOf;
	
	function daysInMonth(year, month) {
	    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	}
	
	// FORMATTING
	
	addFormatToken('M', ['MM', 2], 'Mo', function () {
	    return this.month() + 1;
	});
	
	addFormatToken('MMM', 0, 0, function (format) {
	    return this.localeData().monthsShort(this, format);
	});
	
	addFormatToken('MMMM', 0, 0, function (format) {
	    return this.localeData().months(this, format);
	});
	
	// ALIASES
	
	addUnitAlias('month', 'M');
	
	// PRIORITY
	
	addUnitPriority('month', 8);
	
	// PARSING
	
	addRegexToken('M',    match1to2);
	addRegexToken('MM',   match1to2, match2);
	addRegexToken('MMM',  function (isStrict, locale) {
	    return locale.monthsShortRegex(isStrict);
	});
	addRegexToken('MMMM', function (isStrict, locale) {
	    return locale.monthsRegex(isStrict);
	});
	
	addParseToken(['M', 'MM'], function (input, array) {
	    array[MONTH] = toInt(input) - 1;
	});
	
	addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	    var month = config._locale.monthsParse(input, token, config._strict);
	    // if we didn't find a month name, mark the date as invalid.
	    if (month != null) {
	        array[MONTH] = month;
	    } else {
	        getParsingFlags(config).invalidMonth = input;
	    }
	});
	
	// LOCALES
	
	var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	function localeMonths (m, format) {
	    if (!m) {
	        return this._months;
	    }
	    return isArray(this._months) ? this._months[m.month()] :
	        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	function localeMonthsShort (m, format) {
	    if (!m) {
	        return this._monthsShort;
	    }
	    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	function handleStrictParse(monthName, format, strict) {
	    var i, ii, mom, llc = monthName.toLocaleLowerCase();
	    if (!this._monthsParse) {
	        // this is not used
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	        for (i = 0; i < 12; ++i) {
	            mom = createUTC([2000, i]);
	            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeMonthsParse (monthName, format, strict) {
	    var i, mom, regex;
	
	    if (this._monthsParseExact) {
	        return handleStrictParse.call(this, monthName, format, strict);
	    }
	
	    if (!this._monthsParse) {
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	    }
	
	    // TODO: add sorting
	    // Sorting makes sure if one month (or abbr) is a prefix of another
	    // see sorting in computeMonthsParse
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        if (strict && !this._longMonthsParse[i]) {
	            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	        }
	        if (!strict && !this._monthsParse[i]) {
	            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (!strict && this._monthsParse[i].test(monthName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function setMonth (mom, value) {
	    var dayOfMonth;
	
	    if (!mom.isValid()) {
	        // No op
	        return mom;
	    }
	
	    if (typeof value === 'string') {
	        if (/^\d+$/.test(value)) {
	            value = toInt(value);
	        } else {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (!isNumber(value)) {
	                return mom;
	            }
	        }
	    }
	
	    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	    return mom;
	}
	
	function getSetMonth (value) {
	    if (value != null) {
	        setMonth(this, value);
	        hooks.updateOffset(this, true);
	        return this;
	    } else {
	        return get(this, 'Month');
	    }
	}
	
	function getDaysInMonth () {
	    return daysInMonth(this.year(), this.month());
	}
	
	var defaultMonthsShortRegex = matchWord;
	function monthsShortRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsShortStrictRegex;
	        } else {
	            return this._monthsShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsShortRegex')) {
	            this._monthsShortRegex = defaultMonthsShortRegex;
	        }
	        return this._monthsShortStrictRegex && isStrict ?
	            this._monthsShortStrictRegex : this._monthsShortRegex;
	    }
	}
	
	var defaultMonthsRegex = matchWord;
	function monthsRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsStrictRegex;
	        } else {
	            return this._monthsRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            this._monthsRegex = defaultMonthsRegex;
	        }
	        return this._monthsStrictRegex && isStrict ?
	            this._monthsStrictRegex : this._monthsRegex;
	    }
	}
	
	function computeMonthsParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom;
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        shortPieces.push(this.monthsShort(mom, ''));
	        longPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.monthsShort(mom, ''));
	    }
	    // Sorting makes sure if one month (or abbr) is a prefix of another it
	    // will match the longer piece.
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 12; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	    }
	    for (i = 0; i < 24; i++) {
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._monthsShortRegex = this._monthsRegex;
	    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	addFormatToken('Y', 0, 0, function () {
	    var y = this.year();
	    return y <= 9999 ? '' + y : '+' + y;
	});
	
	addFormatToken(0, ['YY', 2], 0, function () {
	    return this.year() % 100;
	});
	
	addFormatToken(0, ['YYYY',   4],       0, 'year');
	addFormatToken(0, ['YYYYY',  5],       0, 'year');
	addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	// ALIASES
	
	addUnitAlias('year', 'y');
	
	// PRIORITIES
	
	addUnitPriority('year', 1);
	
	// PARSING
	
	addRegexToken('Y',      matchSigned);
	addRegexToken('YY',     match1to2, match2);
	addRegexToken('YYYY',   match1to4, match4);
	addRegexToken('YYYYY',  match1to6, match6);
	addRegexToken('YYYYYY', match1to6, match6);
	
	addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	addParseToken('YYYY', function (input, array) {
	    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	});
	addParseToken('YY', function (input, array) {
	    array[YEAR] = hooks.parseTwoDigitYear(input);
	});
	addParseToken('Y', function (input, array) {
	    array[YEAR] = parseInt(input, 10);
	});
	
	// HELPERS
	
	function daysInYear(year) {
	    return isLeapYear(year) ? 366 : 365;
	}
	
	function isLeapYear(year) {
	    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	}
	
	// HOOKS
	
	hooks.parseTwoDigitYear = function (input) {
	    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	};
	
	// MOMENTS
	
	var getSetYear = makeGetSet('FullYear', true);
	
	function getIsLeapYear () {
	    return isLeapYear(this.year());
	}
	
	function createDate (y, m, d, h, M, s, ms) {
	    //can't just apply() to create a date:
	    //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
	    var date = new Date(y, m, d, h, M, s, ms);
	
	    //the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	        date.setFullYear(y);
	    }
	    return date;
	}
	
	function createUTCDate (y) {
	    var date = new Date(Date.UTC.apply(null, arguments));
	
	    //the Date.UTC function remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	        date.setUTCFullYear(y);
	    }
	    return date;
	}
	
	// start-of-first-week - start-of-year
	function firstWeekOffset(year, dow, doy) {
	    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	        fwd = 7 + dow - doy,
	        // first-week day local weekday -- which local weekday is fwd
	        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	    return -fwdlw + fwd - 1;
	}
	
	//http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	    var localWeekday = (7 + weekday - dow) % 7,
	        weekOffset = firstWeekOffset(year, dow, doy),
	        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	        resYear, resDayOfYear;
	
	    if (dayOfYear <= 0) {
	        resYear = year - 1;
	        resDayOfYear = daysInYear(resYear) + dayOfYear;
	    } else if (dayOfYear > daysInYear(year)) {
	        resYear = year + 1;
	        resDayOfYear = dayOfYear - daysInYear(year);
	    } else {
	        resYear = year;
	        resDayOfYear = dayOfYear;
	    }
	
	    return {
	        year: resYear,
	        dayOfYear: resDayOfYear
	    };
	}
	
	function weekOfYear(mom, dow, doy) {
	    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	        resWeek, resYear;
	
	    if (week < 1) {
	        resYear = mom.year() - 1;
	        resWeek = week + weeksInYear(resYear, dow, doy);
	    } else if (week > weeksInYear(mom.year(), dow, doy)) {
	        resWeek = week - weeksInYear(mom.year(), dow, doy);
	        resYear = mom.year() + 1;
	    } else {
	        resYear = mom.year();
	        resWeek = week;
	    }
	
	    return {
	        week: resWeek,
	        year: resYear
	    };
	}
	
	function weeksInYear(year, dow, doy) {
	    var weekOffset = firstWeekOffset(year, dow, doy),
	        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	}
	
	// FORMATTING
	
	addFormatToken('w', ['ww', 2], 'wo', 'week');
	addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	// ALIASES
	
	addUnitAlias('week', 'w');
	addUnitAlias('isoWeek', 'W');
	
	// PRIORITIES
	
	addUnitPriority('week', 5);
	addUnitPriority('isoWeek', 5);
	
	// PARSING
	
	addRegexToken('w',  match1to2);
	addRegexToken('ww', match1to2, match2);
	addRegexToken('W',  match1to2);
	addRegexToken('WW', match1to2, match2);
	
	addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	    week[token.substr(0, 1)] = toInt(input);
	});
	
	// HELPERS
	
	// LOCALES
	
	function localeWeek (mom) {
	    return weekOfYear(mom, this._week.dow, this._week.doy).week;
	}
	
	var defaultLocaleWeek = {
	    dow : 0, // Sunday is the first day of the week.
	    doy : 6  // The week that contains Jan 1st is the first week of the year.
	};
	
	function localeFirstDayOfWeek () {
	    return this._week.dow;
	}
	
	function localeFirstDayOfYear () {
	    return this._week.doy;
	}
	
	// MOMENTS
	
	function getSetWeek (input) {
	    var week = this.localeData().week(this);
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	function getSetISOWeek (input) {
	    var week = weekOfYear(this, 1, 4).week;
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	// FORMATTING
	
	addFormatToken('d', 0, 'do', 'day');
	
	addFormatToken('dd', 0, 0, function (format) {
	    return this.localeData().weekdaysMin(this, format);
	});
	
	addFormatToken('ddd', 0, 0, function (format) {
	    return this.localeData().weekdaysShort(this, format);
	});
	
	addFormatToken('dddd', 0, 0, function (format) {
	    return this.localeData().weekdays(this, format);
	});
	
	addFormatToken('e', 0, 0, 'weekday');
	addFormatToken('E', 0, 0, 'isoWeekday');
	
	// ALIASES
	
	addUnitAlias('day', 'd');
	addUnitAlias('weekday', 'e');
	addUnitAlias('isoWeekday', 'E');
	
	// PRIORITY
	addUnitPriority('day', 11);
	addUnitPriority('weekday', 11);
	addUnitPriority('isoWeekday', 11);
	
	// PARSING
	
	addRegexToken('d',    match1to2);
	addRegexToken('e',    match1to2);
	addRegexToken('E',    match1to2);
	addRegexToken('dd',   function (isStrict, locale) {
	    return locale.weekdaysMinRegex(isStrict);
	});
	addRegexToken('ddd',   function (isStrict, locale) {
	    return locale.weekdaysShortRegex(isStrict);
	});
	addRegexToken('dddd',   function (isStrict, locale) {
	    return locale.weekdaysRegex(isStrict);
	});
	
	addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	    var weekday = config._locale.weekdaysParse(input, token, config._strict);
	    // if we didn't get a weekday name, mark the date as invalid
	    if (weekday != null) {
	        week.d = weekday;
	    } else {
	        getParsingFlags(config).invalidWeekday = input;
	    }
	});
	
	addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	    week[token] = toInt(input);
	});
	
	// HELPERS
	
	function parseWeekday(input, locale) {
	    if (typeof input !== 'string') {
	        return input;
	    }
	
	    if (!isNaN(input)) {
	        return parseInt(input, 10);
	    }
	
	    input = locale.weekdaysParse(input);
	    if (typeof input === 'number') {
	        return input;
	    }
	
	    return null;
	}
	
	function parseIsoWeekday(input, locale) {
	    if (typeof input === 'string') {
	        return locale.weekdaysParse(input) % 7 || 7;
	    }
	    return isNaN(input) ? null : input;
	}
	
	// LOCALES
	
	var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	function localeWeekdays (m, format) {
	    if (!m) {
	        return this._weekdays;
	    }
	    return isArray(this._weekdays) ? this._weekdays[m.day()] :
	        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	}
	
	var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	function localeWeekdaysShort (m) {
	    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	}
	
	var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	function localeWeekdaysMin (m) {
	    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	}
	
	function handleStrictParse$1(weekdayName, format, strict) {
	    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._minWeekdaysParse = [];
	
	        for (i = 0; i < 7; ++i) {
	            mom = createUTC([2000, 1]).day(i);
	            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeWeekdaysParse (weekdayName, format, strict) {
	    var i, mom, regex;
	
	    if (this._weekdaysParseExact) {
	        return handleStrictParse$1.call(this, weekdayName, format, strict);
	    }
	
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._minWeekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._fullWeekdaysParse = [];
	    }
	
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	
	        mom = createUTC([2000, 1]).day(i);
	        if (strict && !this._fullWeekdaysParse[i]) {
	            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	        }
	        if (!this._weekdaysParse[i]) {
	            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function getSetDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	    if (input != null) {
	        input = parseWeekday(input, this.localeData());
	        return this.add(input - day, 'd');
	    } else {
	        return day;
	    }
	}
	
	function getSetLocaleDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	    return input == null ? weekday : this.add(input - weekday, 'd');
	}
	
	function getSetISODayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	
	    // behaves the same as moment#day except
	    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	    // as a setter, sunday should belong to the previous week.
	
	    if (input != null) {
	        var weekday = parseIsoWeekday(input, this.localeData());
	        return this.day(this.day() % 7 ? weekday : weekday - 7);
	    } else {
	        return this.day() || 7;
	    }
	}
	
	var defaultWeekdaysRegex = matchWord;
	function weekdaysRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysStrictRegex;
	        } else {
	            return this._weekdaysRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            this._weekdaysRegex = defaultWeekdaysRegex;
	        }
	        return this._weekdaysStrictRegex && isStrict ?
	            this._weekdaysStrictRegex : this._weekdaysRegex;
	    }
	}
	
	var defaultWeekdaysShortRegex = matchWord;
	function weekdaysShortRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysShortStrictRegex;
	        } else {
	            return this._weekdaysShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	        }
	        return this._weekdaysShortStrictRegex && isStrict ?
	            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	    }
	}
	
	var defaultWeekdaysMinRegex = matchWord;
	function weekdaysMinRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysMinStrictRegex;
	        } else {
	            return this._weekdaysMinRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	        }
	        return this._weekdaysMinStrictRegex && isStrict ?
	            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	    }
	}
	
	
	function computeWeekdaysParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom, minp, shortp, longp;
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, 1]).day(i);
	        minp = this.weekdaysMin(mom, '');
	        shortp = this.weekdaysShort(mom, '');
	        longp = this.weekdays(mom, '');
	        minPieces.push(minp);
	        shortPieces.push(shortp);
	        longPieces.push(longp);
	        mixedPieces.push(minp);
	        mixedPieces.push(shortp);
	        mixedPieces.push(longp);
	    }
	    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	    // will match the longer piece.
	    minPieces.sort(cmpLenRev);
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 7; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._weekdaysShortRegex = this._weekdaysRegex;
	    this._weekdaysMinRegex = this._weekdaysRegex;
	
	    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	function hFormat() {
	    return this.hours() % 12 || 12;
	}
	
	function kFormat() {
	    return this.hours() || 24;
	}
	
	addFormatToken('H', ['HH', 2], 0, 'hour');
	addFormatToken('h', ['hh', 2], 0, hFormat);
	addFormatToken('k', ['kk', 2], 0, kFormat);
	
	addFormatToken('hmm', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('hmmss', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	addFormatToken('Hmm', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('Hmmss', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	function meridiem (token, lowercase) {
	    addFormatToken(token, 0, 0, function () {
	        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	    });
	}
	
	meridiem('a', true);
	meridiem('A', false);
	
	// ALIASES
	
	addUnitAlias('hour', 'h');
	
	// PRIORITY
	addUnitPriority('hour', 13);
	
	// PARSING
	
	function matchMeridiem (isStrict, locale) {
	    return locale._meridiemParse;
	}
	
	addRegexToken('a',  matchMeridiem);
	addRegexToken('A',  matchMeridiem);
	addRegexToken('H',  match1to2);
	addRegexToken('h',  match1to2);
	addRegexToken('HH', match1to2, match2);
	addRegexToken('hh', match1to2, match2);
	
	addRegexToken('hmm', match3to4);
	addRegexToken('hmmss', match5to6);
	addRegexToken('Hmm', match3to4);
	addRegexToken('Hmmss', match5to6);
	
	addParseToken(['H', 'HH'], HOUR);
	addParseToken(['a', 'A'], function (input, array, config) {
	    config._isPm = config._locale.isPM(input);
	    config._meridiem = input;
	});
	addParseToken(['h', 'hh'], function (input, array, config) {
	    array[HOUR] = toInt(input);
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('Hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	});
	addParseToken('Hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	});
	
	// LOCALES
	
	function localeIsPM (input) {
	    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	    // Using charAt should be more compatible.
	    return ((input + '').toLowerCase().charAt(0) === 'p');
	}
	
	var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	function localeMeridiem (hours, minutes, isLower) {
	    if (hours > 11) {
	        return isLower ? 'pm' : 'PM';
	    } else {
	        return isLower ? 'am' : 'AM';
	    }
	}
	
	
	// MOMENTS
	
	// Setting the hour should keep the time, because the user explicitly
	// specified which hour he wants. So trying to maintain the same hour (in
	// a new timezone) makes sense. Adding/subtracting hours does not follow
	// this rule.
	var getSetHour = makeGetSet('Hours', true);
	
	// months
	// week
	// weekdays
	// meridiem
	var baseConfig = {
	    calendar: defaultCalendar,
	    longDateFormat: defaultLongDateFormat,
	    invalidDate: defaultInvalidDate,
	    ordinal: defaultOrdinal,
	    ordinalParse: defaultOrdinalParse,
	    relativeTime: defaultRelativeTime,
	
	    months: defaultLocaleMonths,
	    monthsShort: defaultLocaleMonthsShort,
	
	    week: defaultLocaleWeek,
	
	    weekdays: defaultLocaleWeekdays,
	    weekdaysMin: defaultLocaleWeekdaysMin,
	    weekdaysShort: defaultLocaleWeekdaysShort,
	
	    meridiemParse: defaultLocaleMeridiemParse
	};
	
	// internal storage for locale config files
	var locales = {};
	var localeFamilies = {};
	var globalLocale;
	
	function normalizeLocale(key) {
	    return key ? key.toLowerCase().replace('_', '-') : key;
	}
	
	// pick the locale from the array
	// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	function chooseLocale(names) {
	    var i = 0, j, next, locale, split;
	
	    while (i < names.length) {
	        split = normalizeLocale(names[i]).split('-');
	        j = split.length;
	        next = normalizeLocale(names[i + 1]);
	        next = next ? next.split('-') : null;
	        while (j > 0) {
	            locale = loadLocale(split.slice(0, j).join('-'));
	            if (locale) {
	                return locale;
	            }
	            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                //the next array item is better than a shallower substring of this one
	                break;
	            }
	            j--;
	        }
	        i++;
	    }
	    return null;
	}
	
	function loadLocale(name) {
	    var oldLocale = null;
	    // TODO: Find a better way to register and load all the locales in Node
	    if (!locales[name] && (typeof module !== 'undefined') &&
	            module && module.exports) {
	        try {
	            oldLocale = globalLocale._abbr;
	            __webpack_require__(251)("./" + name);
	            // because defineLocale currently also sets the global locale, we
	            // want to undo that for lazy loaded locales
	            getSetGlobalLocale(oldLocale);
	        } catch (e) { }
	    }
	    return locales[name];
	}
	
	// This function will load locale and then set the global locale.  If
	// no arguments are passed in, it will simply return the current global
	// locale key.
	function getSetGlobalLocale (key, values) {
	    var data;
	    if (key) {
	        if (isUndefined(values)) {
	            data = getLocale(key);
	        }
	        else {
	            data = defineLocale(key, values);
	        }
	
	        if (data) {
	            // moment.duration._locale = moment._locale = data;
	            globalLocale = data;
	        }
	    }
	
	    return globalLocale._abbr;
	}
	
	function defineLocale (name, config) {
	    if (config !== null) {
	        var parentConfig = baseConfig;
	        config.abbr = name;
	        if (locales[name] != null) {
	            deprecateSimple('defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                    'an existing locale. moment.defineLocale(localeName, ' +
	                    'config) should only be used for creating a new locale ' +
	                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	            parentConfig = locales[name]._config;
	        } else if (config.parentLocale != null) {
	            if (locales[config.parentLocale] != null) {
	                parentConfig = locales[config.parentLocale]._config;
	            } else {
	                if (!localeFamilies[config.parentLocale]) {
	                    localeFamilies[config.parentLocale] = [];
	                }
	                localeFamilies[config.parentLocale].push({
	                    name: name,
	                    config: config
	                });
	                return null;
	            }
	        }
	        locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	        if (localeFamilies[name]) {
	            localeFamilies[name].forEach(function (x) {
	                defineLocale(x.name, x.config);
	            });
	        }
	
	        // backwards compat for now: also set the locale
	        // make sure we set the locale AFTER all child locales have been
	        // created, so we won't end up with the child locale set.
	        getSetGlobalLocale(name);
	
	
	        return locales[name];
	    } else {
	        // useful for testing
	        delete locales[name];
	        return null;
	    }
	}
	
	function updateLocale(name, config) {
	    if (config != null) {
	        var locale, parentConfig = baseConfig;
	        // MERGE
	        if (locales[name] != null) {
	            parentConfig = locales[name]._config;
	        }
	        config = mergeConfigs(parentConfig, config);
	        locale = new Locale(config);
	        locale.parentLocale = locales[name];
	        locales[name] = locale;
	
	        // backwards compat for now: also set the locale
	        getSetGlobalLocale(name);
	    } else {
	        // pass null for config to unupdate, useful for tests
	        if (locales[name] != null) {
	            if (locales[name].parentLocale != null) {
	                locales[name] = locales[name].parentLocale;
	            } else if (locales[name] != null) {
	                delete locales[name];
	            }
	        }
	    }
	    return locales[name];
	}
	
	// returns locale data
	function getLocale (key) {
	    var locale;
	
	    if (key && key._locale && key._locale._abbr) {
	        key = key._locale._abbr;
	    }
	
	    if (!key) {
	        return globalLocale;
	    }
	
	    if (!isArray(key)) {
	        //short-circuit everything else
	        locale = loadLocale(key);
	        if (locale) {
	            return locale;
	        }
	        key = [key];
	    }
	
	    return chooseLocale(key);
	}
	
	function listLocales() {
	    return keys$1(locales);
	}
	
	function checkOverflow (m) {
	    var overflow;
	    var a = m._a;
	
	    if (a && getParsingFlags(m).overflow === -2) {
	        overflow =
	            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	            -1;
	
	        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	            overflow = DATE;
	        }
	        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	            overflow = WEEK;
	        }
	        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	            overflow = WEEKDAY;
	        }
	
	        getParsingFlags(m).overflow = overflow;
	    }
	
	    return m;
	}
	
	// iso 8601 regex
	// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	var isoDates = [
	    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	    ['YYYY-DDD', /\d{4}-\d{3}/],
	    ['YYYY-MM', /\d{4}-\d\d/, false],
	    ['YYYYYYMMDD', /[+-]\d{10}/],
	    ['YYYYMMDD', /\d{8}/],
	    // YYYYMM is NOT allowed by the standard
	    ['GGGG[W]WWE', /\d{4}W\d{3}/],
	    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	    ['YYYYDDD', /\d{7}/]
	];
	
	// iso time formats and regexes
	var isoTimes = [
	    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	    ['HH:mm', /\d\d:\d\d/],
	    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	    ['HHmmss', /\d\d\d\d\d\d/],
	    ['HHmm', /\d\d\d\d/],
	    ['HH', /\d\d/]
	];
	
	var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	// date from iso format
	function configFromISO(config) {
	    var i, l,
	        string = config._i,
	        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	        allowTime, dateFormat, timeFormat, tzFormat;
	
	    if (match) {
	        getParsingFlags(config).iso = true;
	
	        for (i = 0, l = isoDates.length; i < l; i++) {
	            if (isoDates[i][1].exec(match[1])) {
	                dateFormat = isoDates[i][0];
	                allowTime = isoDates[i][2] !== false;
	                break;
	            }
	        }
	        if (dateFormat == null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[3]) {
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(match[3])) {
	                    // match[2] should be 'T' or space
	                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (timeFormat == null) {
	                config._isValid = false;
	                return;
	            }
	        }
	        if (!allowTime && timeFormat != null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[4]) {
	            if (tzRegex.exec(match[4])) {
	                tzFormat = 'Z';
	            } else {
	                config._isValid = false;
	                return;
	            }
	        }
	        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	        configFromStringAndFormat(config);
	    } else {
	        config._isValid = false;
	    }
	}
	
	// date from iso format or fallback
	function configFromString(config) {
	    var matched = aspNetJsonRegex.exec(config._i);
	
	    if (matched !== null) {
	        config._d = new Date(+matched[1]);
	        return;
	    }
	
	    configFromISO(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	        hooks.createFromInputFallback(config);
	    }
	}
	
	hooks.createFromInputFallback = deprecate(
	    'value provided is not in a recognized ISO format. moment construction falls back to js Date(), ' +
	    'which is not reliable across all browsers and versions. Non ISO date formats are ' +
	    'discouraged and will be removed in an upcoming major release. Please refer to ' +
	    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	    function (config) {
	        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	    }
	);
	
	// Pick the first defined of two or three arguments.
	function defaults(a, b, c) {
	    if (a != null) {
	        return a;
	    }
	    if (b != null) {
	        return b;
	    }
	    return c;
	}
	
	function currentDateArray(config) {
	    // hooks is actually the exported moment object
	    var nowValue = new Date(hooks.now());
	    if (config._useUTC) {
	        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	    }
	    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	}
	
	// convert an array to a date.
	// the array should mirror the parameters below
	// note: all values past the year are optional and will default to the lowest possible value.
	// [year, month, day , hour, minute, second, millisecond]
	function configFromArray (config) {
	    var i, date, input = [], currentDate, yearToUse;
	
	    if (config._d) {
	        return;
	    }
	
	    currentDate = currentDateArray(config);
	
	    //compute day of the year from weeks and weekdays
	    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	        dayOfYearFromWeekInfo(config);
	    }
	
	    //if the day of the year is set, figure out what it is
	    if (config._dayOfYear) {
	        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	        if (config._dayOfYear > daysInYear(yearToUse)) {
	            getParsingFlags(config)._overflowDayOfYear = true;
	        }
	
	        date = createUTCDate(yearToUse, 0, config._dayOfYear);
	        config._a[MONTH] = date.getUTCMonth();
	        config._a[DATE] = date.getUTCDate();
	    }
	
	    // Default to current date.
	    // * if no year, month, day of month are given, default to today
	    // * if day of month is given, default month and year
	    // * if month is given, default only year
	    // * if year is given, don't default anything
	    for (i = 0; i < 3 && config._a[i] == null; ++i) {
	        config._a[i] = input[i] = currentDate[i];
	    }
	
	    // Zero out whatever was not defaulted, including time
	    for (; i < 7; i++) {
	        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	    }
	
	    // Check for 24:00:00.000
	    if (config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0) {
	        config._nextDay = true;
	        config._a[HOUR] = 0;
	    }
	
	    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	    // Apply timezone offset from input. The actual utcOffset can be changed
	    // with parseZone.
	    if (config._tzm != null) {
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	    }
	
	    if (config._nextDay) {
	        config._a[HOUR] = 24;
	    }
	}
	
	function dayOfYearFromWeekInfo(config) {
	    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	    w = config._w;
	    if (w.GG != null || w.W != null || w.E != null) {
	        dow = 1;
	        doy = 4;
	
	        // TODO: We need to take the current isoWeekYear, but that depends on
	        // how we interpret now (local, utc, fixed offset). So create
	        // a now version of current config (take local/utc/offset flags, and
	        // create now).
	        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	        week = defaults(w.W, 1);
	        weekday = defaults(w.E, 1);
	        if (weekday < 1 || weekday > 7) {
	            weekdayOverflow = true;
	        }
	    } else {
	        dow = config._locale._week.dow;
	        doy = config._locale._week.doy;
	
	        var curWeek = weekOfYear(createLocal(), dow, doy);
	
	        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	        // Default to current week.
	        week = defaults(w.w, curWeek.week);
	
	        if (w.d != null) {
	            // weekday -- low day numbers are considered next week
	            weekday = w.d;
	            if (weekday < 0 || weekday > 6) {
	                weekdayOverflow = true;
	            }
	        } else if (w.e != null) {
	            // local weekday -- counting starts from begining of week
	            weekday = w.e + dow;
	            if (w.e < 0 || w.e > 6) {
	                weekdayOverflow = true;
	            }
	        } else {
	            // default to begining of week
	            weekday = dow;
	        }
	    }
	    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	        getParsingFlags(config)._overflowWeeks = true;
	    } else if (weekdayOverflow != null) {
	        getParsingFlags(config)._overflowWeekday = true;
	    } else {
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	}
	
	// constant that refers to the ISO standard
	hooks.ISO_8601 = function () {};
	
	// date from string and format string
	function configFromStringAndFormat(config) {
	    // TODO: Move this to another part of the creation flow to prevent circular deps
	    if (config._f === hooks.ISO_8601) {
	        configFromISO(config);
	        return;
	    }
	
	    config._a = [];
	    getParsingFlags(config).empty = true;
	
	    // This array is used to make a Date, either with `new Date` or `Date.UTC`
	    var string = '' + config._i,
	        i, parsedInput, tokens, token, skipped,
	        stringLength = string.length,
	        totalParsedInputLength = 0;
	
	    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	    for (i = 0; i < tokens.length; i++) {
	        token = tokens[i];
	        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	        // console.log('token', token, 'parsedInput', parsedInput,
	        //         'regex', getParseRegexForToken(token, config));
	        if (parsedInput) {
	            skipped = string.substr(0, string.indexOf(parsedInput));
	            if (skipped.length > 0) {
	                getParsingFlags(config).unusedInput.push(skipped);
	            }
	            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	            totalParsedInputLength += parsedInput.length;
	        }
	        // don't parse if it's not a known token
	        if (formatTokenFunctions[token]) {
	            if (parsedInput) {
	                getParsingFlags(config).empty = false;
	            }
	            else {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	            addTimeToArrayFromToken(token, parsedInput, config);
	        }
	        else if (config._strict && !parsedInput) {
	            getParsingFlags(config).unusedTokens.push(token);
	        }
	    }
	
	    // add remaining unparsed input length to the string
	    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	    if (string.length > 0) {
	        getParsingFlags(config).unusedInput.push(string);
	    }
	
	    // clear _12h flag if hour is <= 12
	    if (config._a[HOUR] <= 12 &&
	        getParsingFlags(config).bigHour === true &&
	        config._a[HOUR] > 0) {
	        getParsingFlags(config).bigHour = undefined;
	    }
	
	    getParsingFlags(config).parsedDateParts = config._a.slice(0);
	    getParsingFlags(config).meridiem = config._meridiem;
	    // handle meridiem
	    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	    configFromArray(config);
	    checkOverflow(config);
	}
	
	
	function meridiemFixWrap (locale, hour, meridiem) {
	    var isPm;
	
	    if (meridiem == null) {
	        // nothing to do
	        return hour;
	    }
	    if (locale.meridiemHour != null) {
	        return locale.meridiemHour(hour, meridiem);
	    } else if (locale.isPM != null) {
	        // Fallback
	        isPm = locale.isPM(meridiem);
	        if (isPm && hour < 12) {
	            hour += 12;
	        }
	        if (!isPm && hour === 12) {
	            hour = 0;
	        }
	        return hour;
	    } else {
	        // this is not supposed to happen
	        return hour;
	    }
	}
	
	// date from string and array of format strings
	function configFromStringAndArray(config) {
	    var tempConfig,
	        bestMoment,
	
	        scoreToBeat,
	        i,
	        currentScore;
	
	    if (config._f.length === 0) {
	        getParsingFlags(config).invalidFormat = true;
	        config._d = new Date(NaN);
	        return;
	    }
	
	    for (i = 0; i < config._f.length; i++) {
	        currentScore = 0;
	        tempConfig = copyConfig({}, config);
	        if (config._useUTC != null) {
	            tempConfig._useUTC = config._useUTC;
	        }
	        tempConfig._f = config._f[i];
	        configFromStringAndFormat(tempConfig);
	
	        if (!isValid(tempConfig)) {
	            continue;
	        }
	
	        // if there is any input that was not parsed add a penalty for that format
	        currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	        //or tokens
	        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	        getParsingFlags(tempConfig).score = currentScore;
	
	        if (scoreToBeat == null || currentScore < scoreToBeat) {
	            scoreToBeat = currentScore;
	            bestMoment = tempConfig;
	        }
	    }
	
	    extend(config, bestMoment || tempConfig);
	}
	
	function configFromObject(config) {
	    if (config._d) {
	        return;
	    }
	
	    var i = normalizeObjectUnits(config._i);
	    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	        return obj && parseInt(obj, 10);
	    });
	
	    configFromArray(config);
	}
	
	function createFromConfig (config) {
	    var res = new Moment(checkOverflow(prepareConfig(config)));
	    if (res._nextDay) {
	        // Adding is smart enough around DST
	        res.add(1, 'd');
	        res._nextDay = undefined;
	    }
	
	    return res;
	}
	
	function prepareConfig (config) {
	    var input = config._i,
	        format = config._f;
	
	    config._locale = config._locale || getLocale(config._l);
	
	    if (input === null || (format === undefined && input === '')) {
	        return createInvalid({nullInput: true});
	    }
	
	    if (typeof input === 'string') {
	        config._i = input = config._locale.preparse(input);
	    }
	
	    if (isMoment(input)) {
	        return new Moment(checkOverflow(input));
	    } else if (isDate(input)) {
	        config._d = input;
	    } else if (isArray(format)) {
	        configFromStringAndArray(config);
	    } else if (format) {
	        configFromStringAndFormat(config);
	    }  else {
	        configFromInput(config);
	    }
	
	    if (!isValid(config)) {
	        config._d = null;
	    }
	
	    return config;
	}
	
	function configFromInput(config) {
	    var input = config._i;
	    if (input === undefined) {
	        config._d = new Date(hooks.now());
	    } else if (isDate(input)) {
	        config._d = new Date(input.valueOf());
	    } else if (typeof input === 'string') {
	        configFromString(config);
	    } else if (isArray(input)) {
	        config._a = map(input.slice(0), function (obj) {
	            return parseInt(obj, 10);
	        });
	        configFromArray(config);
	    } else if (typeof(input) === 'object') {
	        configFromObject(config);
	    } else if (isNumber(input)) {
	        // from milliseconds
	        config._d = new Date(input);
	    } else {
	        hooks.createFromInputFallback(config);
	    }
	}
	
	function createLocalOrUTC (input, format, locale, strict, isUTC) {
	    var c = {};
	
	    if (locale === true || locale === false) {
	        strict = locale;
	        locale = undefined;
	    }
	
	    if ((isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)) {
	        input = undefined;
	    }
	    // object construction must be done this way.
	    // https://github.com/moment/moment/issues/1423
	    c._isAMomentObject = true;
	    c._useUTC = c._isUTC = isUTC;
	    c._l = locale;
	    c._i = input;
	    c._f = format;
	    c._strict = strict;
	
	    return createFromConfig(c);
	}
	
	function createLocal (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, false);
	}
	
	var prototypeMin = deprecate(
	    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other < this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	var prototypeMax = deprecate(
	    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other > this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	// Pick a moment m from moments so that m[fn](other) is true for all
	// other. This relies on the function fn to be transitive.
	//
	// moments should either be an array of moment objects or an array, whose
	// first element is an array of moment objects.
	function pickBy(fn, moments) {
	    var res, i;
	    if (moments.length === 1 && isArray(moments[0])) {
	        moments = moments[0];
	    }
	    if (!moments.length) {
	        return createLocal();
	    }
	    res = moments[0];
	    for (i = 1; i < moments.length; ++i) {
	        if (!moments[i].isValid() || moments[i][fn](res)) {
	            res = moments[i];
	        }
	    }
	    return res;
	}
	
	// TODO: Use [].sort instead?
	function min () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isBefore', args);
	}
	
	function max () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isAfter', args);
	}
	
	var now = function () {
	    return Date.now ? Date.now() : +(new Date());
	};
	
	function Duration (duration) {
	    var normalizedInput = normalizeObjectUnits(duration),
	        years = normalizedInput.year || 0,
	        quarters = normalizedInput.quarter || 0,
	        months = normalizedInput.month || 0,
	        weeks = normalizedInput.week || 0,
	        days = normalizedInput.day || 0,
	        hours = normalizedInput.hour || 0,
	        minutes = normalizedInput.minute || 0,
	        seconds = normalizedInput.second || 0,
	        milliseconds = normalizedInput.millisecond || 0;
	
	    // representation for dateAddRemove
	    this._milliseconds = +milliseconds +
	        seconds * 1e3 + // 1000
	        minutes * 6e4 + // 1000 * 60
	        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	    // Because of dateAddRemove treats 24 hours as different from a
	    // day when working around DST, we need to store them separately
	    this._days = +days +
	        weeks * 7;
	    // It is impossible translate months into days without knowing
	    // which months you are are talking about, so we have to store
	    // it separately.
	    this._months = +months +
	        quarters * 3 +
	        years * 12;
	
	    this._data = {};
	
	    this._locale = getLocale();
	
	    this._bubble();
	}
	
	function isDuration (obj) {
	    return obj instanceof Duration;
	}
	
	function absRound (number) {
	    if (number < 0) {
	        return Math.round(-1 * number) * -1;
	    } else {
	        return Math.round(number);
	    }
	}
	
	// FORMATTING
	
	function offset (token, separator) {
	    addFormatToken(token, 0, 0, function () {
	        var offset = this.utcOffset();
	        var sign = '+';
	        if (offset < 0) {
	            offset = -offset;
	            sign = '-';
	        }
	        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	    });
	}
	
	offset('Z', ':');
	offset('ZZ', '');
	
	// PARSING
	
	addRegexToken('Z',  matchShortOffset);
	addRegexToken('ZZ', matchShortOffset);
	addParseToken(['Z', 'ZZ'], function (input, array, config) {
	    config._useUTC = true;
	    config._tzm = offsetFromString(matchShortOffset, input);
	});
	
	// HELPERS
	
	// timezone chunker
	// '+10:00' > ['10',  '00']
	// '-1530'  > ['-15', '30']
	var chunkOffset = /([\+\-]|\d\d)/gi;
	
	function offsetFromString(matcher, string) {
	    var matches = (string || '').match(matcher);
	
	    if (matches === null) {
	        return null;
	    }
	
	    var chunk   = matches[matches.length - 1] || [];
	    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	    var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	    return minutes === 0 ?
	      0 :
	      parts[0] === '+' ? minutes : -minutes;
	}
	
	// Return a moment from input, that is local/utc/zone equivalent to model.
	function cloneWithOffset(input, model) {
	    var res, diff;
	    if (model._isUTC) {
	        res = model.clone();
	        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	        // Use low-level api, because this fn is low-level api.
	        res._d.setTime(res._d.valueOf() + diff);
	        hooks.updateOffset(res, false);
	        return res;
	    } else {
	        return createLocal(input).local();
	    }
	}
	
	function getDateOffset (m) {
	    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	    // https://github.com/moment/moment/pull/1871
	    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	}
	
	// HOOKS
	
	// This function will be called whenever a moment is mutated.
	// It is intended to keep the offset in sync with the timezone.
	hooks.updateOffset = function () {};
	
	// MOMENTS
	
	// keepLocalTime = true means only change the timezone, without
	// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	// +0200, so we adjust the time as needed, to be valid.
	//
	// Keeping the time actually adds/subtracts (one hour)
	// from the actual represented time. That is why we call updateOffset
	// a second time. In case it wants us to change the offset again
	// _changeInProgress == true case, then we have to adjust, because
	// there is no such time in the given timezone.
	function getSetOffset (input, keepLocalTime) {
	    var offset = this._offset || 0,
	        localAdjust;
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    if (input != null) {
	        if (typeof input === 'string') {
	            input = offsetFromString(matchShortOffset, input);
	            if (input === null) {
	                return this;
	            }
	        } else if (Math.abs(input) < 16) {
	            input = input * 60;
	        }
	        if (!this._isUTC && keepLocalTime) {
	            localAdjust = getDateOffset(this);
	        }
	        this._offset = input;
	        this._isUTC = true;
	        if (localAdjust != null) {
	            this.add(localAdjust, 'm');
	        }
	        if (offset !== input) {
	            if (!keepLocalTime || this._changeInProgress) {
	                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	            } else if (!this._changeInProgress) {
	                this._changeInProgress = true;
	                hooks.updateOffset(this, true);
	                this._changeInProgress = null;
	            }
	        }
	        return this;
	    } else {
	        return this._isUTC ? offset : getDateOffset(this);
	    }
	}
	
	function getSetZone (input, keepLocalTime) {
	    if (input != null) {
	        if (typeof input !== 'string') {
	            input = -input;
	        }
	
	        this.utcOffset(input, keepLocalTime);
	
	        return this;
	    } else {
	        return -this.utcOffset();
	    }
	}
	
	function setOffsetToUTC (keepLocalTime) {
	    return this.utcOffset(0, keepLocalTime);
	}
	
	function setOffsetToLocal (keepLocalTime) {
	    if (this._isUTC) {
	        this.utcOffset(0, keepLocalTime);
	        this._isUTC = false;
	
	        if (keepLocalTime) {
	            this.subtract(getDateOffset(this), 'm');
	        }
	    }
	    return this;
	}
	
	function setOffsetToParsedOffset () {
	    if (this._tzm != null) {
	        this.utcOffset(this._tzm);
	    } else if (typeof this._i === 'string') {
	        var tZone = offsetFromString(matchOffset, this._i);
	        if (tZone != null) {
	            this.utcOffset(tZone);
	        }
	        else {
	            this.utcOffset(0, true);
	        }
	    }
	    return this;
	}
	
	function hasAlignedHourOffset (input) {
	    if (!this.isValid()) {
	        return false;
	    }
	    input = input ? createLocal(input).utcOffset() : 0;
	
	    return (this.utcOffset() - input) % 60 === 0;
	}
	
	function isDaylightSavingTime () {
	    return (
	        this.utcOffset() > this.clone().month(0).utcOffset() ||
	        this.utcOffset() > this.clone().month(5).utcOffset()
	    );
	}
	
	function isDaylightSavingTimeShifted () {
	    if (!isUndefined(this._isDSTShifted)) {
	        return this._isDSTShifted;
	    }
	
	    var c = {};
	
	    copyConfig(c, this);
	    c = prepareConfig(c);
	
	    if (c._a) {
	        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	        this._isDSTShifted = this.isValid() &&
	            compareArrays(c._a, other.toArray()) > 0;
	    } else {
	        this._isDSTShifted = false;
	    }
	
	    return this._isDSTShifted;
	}
	
	function isLocal () {
	    return this.isValid() ? !this._isUTC : false;
	}
	
	function isUtcOffset () {
	    return this.isValid() ? this._isUTC : false;
	}
	
	function isUtc () {
	    return this.isValid() ? this._isUTC && this._offset === 0 : false;
	}
	
	// ASP.NET json date format regex
	var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	// and further modified to allow for strings containing both week and day
	var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;
	
	function createDuration (input, key) {
	    var duration = input,
	        // matching against regexp is expensive, do it on demand
	        match = null,
	        sign,
	        ret,
	        diffRes;
	
	    if (isDuration(input)) {
	        duration = {
	            ms : input._milliseconds,
	            d  : input._days,
	            M  : input._months
	        };
	    } else if (isNumber(input)) {
	        duration = {};
	        if (key) {
	            duration[key] = input;
	        } else {
	            duration.milliseconds = input;
	        }
	    } else if (!!(match = aspNetRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y  : 0,
	            d  : toInt(match[DATE])                         * sign,
	            h  : toInt(match[HOUR])                         * sign,
	            m  : toInt(match[MINUTE])                       * sign,
	            s  : toInt(match[SECOND])                       * sign,
	            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	        };
	    } else if (!!(match = isoRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y : parseIso(match[2], sign),
	            M : parseIso(match[3], sign),
	            w : parseIso(match[4], sign),
	            d : parseIso(match[5], sign),
	            h : parseIso(match[6], sign),
	            m : parseIso(match[7], sign),
	            s : parseIso(match[8], sign)
	        };
	    } else if (duration == null) {// checks for null or undefined
	        duration = {};
	    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	        duration = {};
	        duration.ms = diffRes.milliseconds;
	        duration.M = diffRes.months;
	    }
	
	    ret = new Duration(duration);
	
	    if (isDuration(input) && hasOwnProp(input, '_locale')) {
	        ret._locale = input._locale;
	    }
	
	    return ret;
	}
	
	createDuration.fn = Duration.prototype;
	
	function parseIso (inp, sign) {
	    // We'd normally use ~~inp for this, but unfortunately it also
	    // converts floats to ints.
	    // inp may be undefined, so careful calling replace on it.
	    var res = inp && parseFloat(inp.replace(',', '.'));
	    // apply sign while we're at it
	    return (isNaN(res) ? 0 : res) * sign;
	}
	
	function positiveMomentsDifference(base, other) {
	    var res = {milliseconds: 0, months: 0};
	
	    res.months = other.month() - base.month() +
	        (other.year() - base.year()) * 12;
	    if (base.clone().add(res.months, 'M').isAfter(other)) {
	        --res.months;
	    }
	
	    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	    return res;
	}
	
	function momentsDifference(base, other) {
	    var res;
	    if (!(base.isValid() && other.isValid())) {
	        return {milliseconds: 0, months: 0};
	    }
	
	    other = cloneWithOffset(other, base);
	    if (base.isBefore(other)) {
	        res = positiveMomentsDifference(base, other);
	    } else {
	        res = positiveMomentsDifference(other, base);
	        res.milliseconds = -res.milliseconds;
	        res.months = -res.months;
	    }
	
	    return res;
	}
	
	// TODO: remove 'name' arg after deprecation is removed
	function createAdder(direction, name) {
	    return function (val, period) {
	        var dur, tmp;
	        //invert the arguments, but complain about it
	        if (period !== null && !isNaN(+period)) {
	            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	            tmp = val; val = period; period = tmp;
	        }
	
	        val = typeof val === 'string' ? +val : val;
	        dur = createDuration(val, period);
	        addSubtract(this, dur, direction);
	        return this;
	    };
	}
	
	function addSubtract (mom, duration, isAdding, updateOffset) {
	    var milliseconds = duration._milliseconds,
	        days = absRound(duration._days),
	        months = absRound(duration._months);
	
	    if (!mom.isValid()) {
	        // No op
	        return;
	    }
	
	    updateOffset = updateOffset == null ? true : updateOffset;
	
	    if (milliseconds) {
	        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	    }
	    if (days) {
	        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	    }
	    if (months) {
	        setMonth(mom, get(mom, 'Month') + months * isAdding);
	    }
	    if (updateOffset) {
	        hooks.updateOffset(mom, days || months);
	    }
	}
	
	var add      = createAdder(1, 'add');
	var subtract = createAdder(-1, 'subtract');
	
	function getCalendarFormat(myMoment, now) {
	    var diff = myMoment.diff(now, 'days', true);
	    return diff < -6 ? 'sameElse' :
	            diff < -1 ? 'lastWeek' :
	            diff < 0 ? 'lastDay' :
	            diff < 1 ? 'sameDay' :
	            diff < 2 ? 'nextDay' :
	            diff < 7 ? 'nextWeek' : 'sameElse';
	}
	
	function calendar$1 (time, formats) {
	    // We want to compare the start of today, vs this.
	    // Getting start-of-today depends on whether we're local/utc/offset or not.
	    var now = time || createLocal(),
	        sod = cloneWithOffset(now, this).startOf('day'),
	        format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	}
	
	function clone () {
	    return new Moment(this);
	}
	
	function isAfter (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() > localInput.valueOf();
	    } else {
	        return localInput.valueOf() < this.clone().startOf(units).valueOf();
	    }
	}
	
	function isBefore (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() < localInput.valueOf();
	    } else {
	        return this.clone().endOf(units).valueOf() < localInput.valueOf();
	    }
	}
	
	function isBetween (from, to, units, inclusivity) {
	    inclusivity = inclusivity || '()';
	    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	}
	
	function isSame (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input),
	        inputMs;
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(units || 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() === localInput.valueOf();
	    } else {
	        inputMs = localInput.valueOf();
	        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	    }
	}
	
	function isSameOrAfter (input, units) {
	    return this.isSame(input, units) || this.isAfter(input,units);
	}
	
	function isSameOrBefore (input, units) {
	    return this.isSame(input, units) || this.isBefore(input,units);
	}
	
	function diff (input, units, asFloat) {
	    var that,
	        zoneDelta,
	        delta, output;
	
	    if (!this.isValid()) {
	        return NaN;
	    }
	
	    that = cloneWithOffset(input, this);
	
	    if (!that.isValid()) {
	        return NaN;
	    }
	
	    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	    units = normalizeUnits(units);
	
	    if (units === 'year' || units === 'month' || units === 'quarter') {
	        output = monthDiff(this, that);
	        if (units === 'quarter') {
	            output = output / 3;
	        } else if (units === 'year') {
	            output = output / 12;
	        }
	    } else {
	        delta = this - that;
	        output = units === 'second' ? delta / 1e3 : // 1000
	            units === 'minute' ? delta / 6e4 : // 1000 * 60
	            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
	            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
	            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
	            delta;
	    }
	    return asFloat ? output : absFloor(output);
	}
	
	function monthDiff (a, b) {
	    // difference in months
	    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	        // b is in (anchor - 1 month, anchor + 1 month)
	        anchor = a.clone().add(wholeMonthDiff, 'months'),
	        anchor2, adjust;
	
	    if (b - anchor < 0) {
	        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor - anchor2);
	    } else {
	        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor2 - anchor);
	    }
	
	    //check for negative zero, return zero if negative zero
	    return -(wholeMonthDiff + adjust) || 0;
	}
	
	hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	function toString () {
	    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	}
	
	function toISOString () {
	    var m = this.clone().utc();
	    if (0 < m.year() && m.year() <= 9999) {
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            return this.toDate().toISOString();
	        } else {
	            return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	        }
	    } else {
	        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	    }
	}
	
	/**
	 * Return a human readable representation of a moment that can
	 * also be evaluated to get a new moment which is the same
	 *
	 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	 */
	function inspect () {
	    if (!this.isValid()) {
	        return 'moment.invalid(/* ' + this._i + ' */)';
	    }
	    var func = 'moment';
	    var zone = '';
	    if (!this.isLocal()) {
	        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	        zone = 'Z';
	    }
	    var prefix = '[' + func + '("]';
	    var year = (0 < this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	    var suffix = zone + '[")]';
	
	    return this.format(prefix + year + datetime + suffix);
	}
	
	function format (inputString) {
	    if (!inputString) {
	        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	    }
	    var output = formatMoment(this, inputString);
	    return this.localeData().postformat(output);
	}
	
	function from (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function fromNow (withoutSuffix) {
	    return this.from(createLocal(), withoutSuffix);
	}
	
	function to (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function toNow (withoutSuffix) {
	    return this.to(createLocal(), withoutSuffix);
	}
	
	// If passed a locale key, it will set the locale for this
	// instance.  Otherwise, it will return the locale configuration
	// variables for this instance.
	function locale (key) {
	    var newLocaleData;
	
	    if (key === undefined) {
	        return this._locale._abbr;
	    } else {
	        newLocaleData = getLocale(key);
	        if (newLocaleData != null) {
	            this._locale = newLocaleData;
	        }
	        return this;
	    }
	}
	
	var lang = deprecate(
	    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	    function (key) {
	        if (key === undefined) {
	            return this.localeData();
	        } else {
	            return this.locale(key);
	        }
	    }
	);
	
	function localeData () {
	    return this._locale;
	}
	
	function startOf (units) {
	    units = normalizeUnits(units);
	    // the following switch intentionally omits break keywords
	    // to utilize falling through the cases.
	    switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	        case 'date':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	    }
	
	    // weeks are a special case
	    if (units === 'week') {
	        this.weekday(0);
	    }
	    if (units === 'isoWeek') {
	        this.isoWeekday(1);
	    }
	
	    // quarters are also special
	    if (units === 'quarter') {
	        this.month(Math.floor(this.month() / 3) * 3);
	    }
	
	    return this;
	}
	
	function endOf (units) {
	    units = normalizeUnits(units);
	    if (units === undefined || units === 'millisecond') {
	        return this;
	    }
	
	    // 'date' is an alias for 'day', so it should be considered as such.
	    if (units === 'date') {
	        units = 'day';
	    }
	
	    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	}
	
	function valueOf () {
	    return this._d.valueOf() - ((this._offset || 0) * 60000);
	}
	
	function unix () {
	    return Math.floor(this.valueOf() / 1000);
	}
	
	function toDate () {
	    return new Date(this.valueOf());
	}
	
	function toArray () {
	    var m = this;
	    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	}
	
	function toObject () {
	    var m = this;
	    return {
	        years: m.year(),
	        months: m.month(),
	        date: m.date(),
	        hours: m.hours(),
	        minutes: m.minutes(),
	        seconds: m.seconds(),
	        milliseconds: m.milliseconds()
	    };
	}
	
	function toJSON () {
	    // new Date(NaN).toJSON() === null
	    return this.isValid() ? this.toISOString() : null;
	}
	
	function isValid$1 () {
	    return isValid(this);
	}
	
	function parsingFlags () {
	    return extend({}, getParsingFlags(this));
	}
	
	function invalidAt () {
	    return getParsingFlags(this).overflow;
	}
	
	function creationData() {
	    return {
	        input: this._i,
	        format: this._f,
	        locale: this._locale,
	        isUTC: this._isUTC,
	        strict: this._strict
	    };
	}
	
	// FORMATTING
	
	addFormatToken(0, ['gg', 2], 0, function () {
	    return this.weekYear() % 100;
	});
	
	addFormatToken(0, ['GG', 2], 0, function () {
	    return this.isoWeekYear() % 100;
	});
	
	function addWeekYearFormatToken (token, getter) {
	    addFormatToken(0, [token, token.length], 0, getter);
	}
	
	addWeekYearFormatToken('gggg',     'weekYear');
	addWeekYearFormatToken('ggggg',    'weekYear');
	addWeekYearFormatToken('GGGG',  'isoWeekYear');
	addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	// ALIASES
	
	addUnitAlias('weekYear', 'gg');
	addUnitAlias('isoWeekYear', 'GG');
	
	// PRIORITY
	
	addUnitPriority('weekYear', 1);
	addUnitPriority('isoWeekYear', 1);
	
	
	// PARSING
	
	addRegexToken('G',      matchSigned);
	addRegexToken('g',      matchSigned);
	addRegexToken('GG',     match1to2, match2);
	addRegexToken('gg',     match1to2, match2);
	addRegexToken('GGGG',   match1to4, match4);
	addRegexToken('gggg',   match1to4, match4);
	addRegexToken('GGGGG',  match1to6, match6);
	addRegexToken('ggggg',  match1to6, match6);
	
	addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	    week[token.substr(0, 2)] = toInt(input);
	});
	
	addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	    week[token] = hooks.parseTwoDigitYear(input);
	});
	
	// MOMENTS
	
	function getSetWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy);
	}
	
	function getSetISOWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input, this.isoWeek(), this.isoWeekday(), 1, 4);
	}
	
	function getISOWeeksInYear () {
	    return weeksInYear(this.year(), 1, 4);
	}
	
	function getWeeksInYear () {
	    var weekInfo = this.localeData()._week;
	    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	}
	
	function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	    var weeksTarget;
	    if (input == null) {
	        return weekOfYear(this, dow, doy).year;
	    } else {
	        weeksTarget = weeksInYear(input, dow, doy);
	        if (week > weeksTarget) {
	            week = weeksTarget;
	        }
	        return setWeekAll.call(this, input, week, weekday, dow, doy);
	    }
	}
	
	function setWeekAll(weekYear, week, weekday, dow, doy) {
	    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	    this.year(date.getUTCFullYear());
	    this.month(date.getUTCMonth());
	    this.date(date.getUTCDate());
	    return this;
	}
	
	// FORMATTING
	
	addFormatToken('Q', 0, 'Qo', 'quarter');
	
	// ALIASES
	
	addUnitAlias('quarter', 'Q');
	
	// PRIORITY
	
	addUnitPriority('quarter', 7);
	
	// PARSING
	
	addRegexToken('Q', match1);
	addParseToken('Q', function (input, array) {
	    array[MONTH] = (toInt(input) - 1) * 3;
	});
	
	// MOMENTS
	
	function getSetQuarter (input) {
	    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	}
	
	// FORMATTING
	
	addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	// ALIASES
	
	addUnitAlias('date', 'D');
	
	// PRIOROITY
	addUnitPriority('date', 9);
	
	// PARSING
	
	addRegexToken('D',  match1to2);
	addRegexToken('DD', match1to2, match2);
	addRegexToken('Do', function (isStrict, locale) {
	    return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
	});
	
	addParseToken(['D', 'DD'], DATE);
	addParseToken('Do', function (input, array) {
	    array[DATE] = toInt(input.match(match1to2)[0], 10);
	});
	
	// MOMENTS
	
	var getSetDayOfMonth = makeGetSet('Date', true);
	
	// FORMATTING
	
	addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	// ALIASES
	
	addUnitAlias('dayOfYear', 'DDD');
	
	// PRIORITY
	addUnitPriority('dayOfYear', 4);
	
	// PARSING
	
	addRegexToken('DDD',  match1to3);
	addRegexToken('DDDD', match3);
	addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	    config._dayOfYear = toInt(input);
	});
	
	// HELPERS
	
	// MOMENTS
	
	function getSetDayOfYear (input) {
	    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	}
	
	// FORMATTING
	
	addFormatToken('m', ['mm', 2], 0, 'minute');
	
	// ALIASES
	
	addUnitAlias('minute', 'm');
	
	// PRIORITY
	
	addUnitPriority('minute', 14);
	
	// PARSING
	
	addRegexToken('m',  match1to2);
	addRegexToken('mm', match1to2, match2);
	addParseToken(['m', 'mm'], MINUTE);
	
	// MOMENTS
	
	var getSetMinute = makeGetSet('Minutes', false);
	
	// FORMATTING
	
	addFormatToken('s', ['ss', 2], 0, 'second');
	
	// ALIASES
	
	addUnitAlias('second', 's');
	
	// PRIORITY
	
	addUnitPriority('second', 15);
	
	// PARSING
	
	addRegexToken('s',  match1to2);
	addRegexToken('ss', match1to2, match2);
	addParseToken(['s', 'ss'], SECOND);
	
	// MOMENTS
	
	var getSetSecond = makeGetSet('Seconds', false);
	
	// FORMATTING
	
	addFormatToken('S', 0, 0, function () {
	    return ~~(this.millisecond() / 100);
	});
	
	addFormatToken(0, ['SS', 2], 0, function () {
	    return ~~(this.millisecond() / 10);
	});
	
	addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	addFormatToken(0, ['SSSS', 4], 0, function () {
	    return this.millisecond() * 10;
	});
	addFormatToken(0, ['SSSSS', 5], 0, function () {
	    return this.millisecond() * 100;
	});
	addFormatToken(0, ['SSSSSS', 6], 0, function () {
	    return this.millisecond() * 1000;
	});
	addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	    return this.millisecond() * 10000;
	});
	addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	    return this.millisecond() * 100000;
	});
	addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	    return this.millisecond() * 1000000;
	});
	
	
	// ALIASES
	
	addUnitAlias('millisecond', 'ms');
	
	// PRIORITY
	
	addUnitPriority('millisecond', 16);
	
	// PARSING
	
	addRegexToken('S',    match1to3, match1);
	addRegexToken('SS',   match1to3, match2);
	addRegexToken('SSS',  match1to3, match3);
	
	var token;
	for (token = 'SSSS'; token.length <= 9; token += 'S') {
	    addRegexToken(token, matchUnsigned);
	}
	
	function parseMs(input, array) {
	    array[MILLISECOND] = toInt(('0.' + input) * 1000);
	}
	
	for (token = 'S'; token.length <= 9; token += 'S') {
	    addParseToken(token, parseMs);
	}
	// MOMENTS
	
	var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	// FORMATTING
	
	addFormatToken('z',  0, 0, 'zoneAbbr');
	addFormatToken('zz', 0, 0, 'zoneName');
	
	// MOMENTS
	
	function getZoneAbbr () {
	    return this._isUTC ? 'UTC' : '';
	}
	
	function getZoneName () {
	    return this._isUTC ? 'Coordinated Universal Time' : '';
	}
	
	var proto = Moment.prototype;
	
	proto.add               = add;
	proto.calendar          = calendar$1;
	proto.clone             = clone;
	proto.diff              = diff;
	proto.endOf             = endOf;
	proto.format            = format;
	proto.from              = from;
	proto.fromNow           = fromNow;
	proto.to                = to;
	proto.toNow             = toNow;
	proto.get               = stringGet;
	proto.invalidAt         = invalidAt;
	proto.isAfter           = isAfter;
	proto.isBefore          = isBefore;
	proto.isBetween         = isBetween;
	proto.isSame            = isSame;
	proto.isSameOrAfter     = isSameOrAfter;
	proto.isSameOrBefore    = isSameOrBefore;
	proto.isValid           = isValid$1;
	proto.lang              = lang;
	proto.locale            = locale;
	proto.localeData        = localeData;
	proto.max               = prototypeMax;
	proto.min               = prototypeMin;
	proto.parsingFlags      = parsingFlags;
	proto.set               = stringSet;
	proto.startOf           = startOf;
	proto.subtract          = subtract;
	proto.toArray           = toArray;
	proto.toObject          = toObject;
	proto.toDate            = toDate;
	proto.toISOString       = toISOString;
	proto.inspect           = inspect;
	proto.toJSON            = toJSON;
	proto.toString          = toString;
	proto.unix              = unix;
	proto.valueOf           = valueOf;
	proto.creationData      = creationData;
	
	// Year
	proto.year       = getSetYear;
	proto.isLeapYear = getIsLeapYear;
	
	// Week Year
	proto.weekYear    = getSetWeekYear;
	proto.isoWeekYear = getSetISOWeekYear;
	
	// Quarter
	proto.quarter = proto.quarters = getSetQuarter;
	
	// Month
	proto.month       = getSetMonth;
	proto.daysInMonth = getDaysInMonth;
	
	// Week
	proto.week           = proto.weeks        = getSetWeek;
	proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	proto.weeksInYear    = getWeeksInYear;
	proto.isoWeeksInYear = getISOWeeksInYear;
	
	// Day
	proto.date       = getSetDayOfMonth;
	proto.day        = proto.days             = getSetDayOfWeek;
	proto.weekday    = getSetLocaleDayOfWeek;
	proto.isoWeekday = getSetISODayOfWeek;
	proto.dayOfYear  = getSetDayOfYear;
	
	// Hour
	proto.hour = proto.hours = getSetHour;
	
	// Minute
	proto.minute = proto.minutes = getSetMinute;
	
	// Second
	proto.second = proto.seconds = getSetSecond;
	
	// Millisecond
	proto.millisecond = proto.milliseconds = getSetMillisecond;
	
	// Offset
	proto.utcOffset            = getSetOffset;
	proto.utc                  = setOffsetToUTC;
	proto.local                = setOffsetToLocal;
	proto.parseZone            = setOffsetToParsedOffset;
	proto.hasAlignedHourOffset = hasAlignedHourOffset;
	proto.isDST                = isDaylightSavingTime;
	proto.isLocal              = isLocal;
	proto.isUtcOffset          = isUtcOffset;
	proto.isUtc                = isUtc;
	proto.isUTC                = isUtc;
	
	// Timezone
	proto.zoneAbbr = getZoneAbbr;
	proto.zoneName = getZoneName;
	
	// Deprecations
	proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	function createUnix (input) {
	    return createLocal(input * 1000);
	}
	
	function createInZone () {
	    return createLocal.apply(null, arguments).parseZone();
	}
	
	function preParsePostFormat (string) {
	    return string;
	}
	
	var proto$1 = Locale.prototype;
	
	proto$1.calendar        = calendar;
	proto$1.longDateFormat  = longDateFormat;
	proto$1.invalidDate     = invalidDate;
	proto$1.ordinal         = ordinal;
	proto$1.preparse        = preParsePostFormat;
	proto$1.postformat      = preParsePostFormat;
	proto$1.relativeTime    = relativeTime;
	proto$1.pastFuture      = pastFuture;
	proto$1.set             = set;
	
	// Month
	proto$1.months            =        localeMonths;
	proto$1.monthsShort       =        localeMonthsShort;
	proto$1.monthsParse       =        localeMonthsParse;
	proto$1.monthsRegex       = monthsRegex;
	proto$1.monthsShortRegex  = monthsShortRegex;
	
	// Week
	proto$1.week = localeWeek;
	proto$1.firstDayOfYear = localeFirstDayOfYear;
	proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	// Day of Week
	proto$1.weekdays       =        localeWeekdays;
	proto$1.weekdaysMin    =        localeWeekdaysMin;
	proto$1.weekdaysShort  =        localeWeekdaysShort;
	proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	proto$1.weekdaysRegex       =        weekdaysRegex;
	proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	// Hours
	proto$1.isPM = localeIsPM;
	proto$1.meridiem = localeMeridiem;
	
	function get$1 (format, index, field, setter) {
	    var locale = getLocale();
	    var utc = createUTC().set(setter, index);
	    return locale[field](utc, format);
	}
	
	function listMonthsImpl (format, index, field) {
	    if (isNumber(format)) {
	        index = format;
	        format = undefined;
	    }
	
	    format = format || '';
	
	    if (index != null) {
	        return get$1(format, index, field, 'month');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 12; i++) {
	        out[i] = get$1(format, i, field, 'month');
	    }
	    return out;
	}
	
	// ()
	// (5)
	// (fmt, 5)
	// (fmt)
	// (true)
	// (true, 5)
	// (true, fmt, 5)
	// (true, fmt)
	function listWeekdaysImpl (localeSorted, format, index, field) {
	    if (typeof localeSorted === 'boolean') {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    } else {
	        format = localeSorted;
	        index = format;
	        localeSorted = false;
	
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    }
	
	    var locale = getLocale(),
	        shift = localeSorted ? locale._week.dow : 0;
	
	    if (index != null) {
	        return get$1(format, (index + shift) % 7, field, 'day');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 7; i++) {
	        out[i] = get$1(format, (i + shift) % 7, field, 'day');
	    }
	    return out;
	}
	
	function listMonths (format, index) {
	    return listMonthsImpl(format, index, 'months');
	}
	
	function listMonthsShort (format, index) {
	    return listMonthsImpl(format, index, 'monthsShort');
	}
	
	function listWeekdays (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	}
	
	function listWeekdaysShort (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	}
	
	function listWeekdaysMin (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	}
	
	getSetGlobalLocale('en', {
	    ordinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (toInt(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	// Side effect imports
	hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	var mathAbs = Math.abs;
	
	function abs () {
	    var data           = this._data;
	
	    this._milliseconds = mathAbs(this._milliseconds);
	    this._days         = mathAbs(this._days);
	    this._months       = mathAbs(this._months);
	
	    data.milliseconds  = mathAbs(data.milliseconds);
	    data.seconds       = mathAbs(data.seconds);
	    data.minutes       = mathAbs(data.minutes);
	    data.hours         = mathAbs(data.hours);
	    data.months        = mathAbs(data.months);
	    data.years         = mathAbs(data.years);
	
	    return this;
	}
	
	function addSubtract$1 (duration, input, value, direction) {
	    var other = createDuration(input, value);
	
	    duration._milliseconds += direction * other._milliseconds;
	    duration._days         += direction * other._days;
	    duration._months       += direction * other._months;
	
	    return duration._bubble();
	}
	
	// supports only 2.0-style add(1, 's') or add(duration)
	function add$1 (input, value) {
	    return addSubtract$1(this, input, value, 1);
	}
	
	// supports only 2.0-style subtract(1, 's') or subtract(duration)
	function subtract$1 (input, value) {
	    return addSubtract$1(this, input, value, -1);
	}
	
	function absCeil (number) {
	    if (number < 0) {
	        return Math.floor(number);
	    } else {
	        return Math.ceil(number);
	    }
	}
	
	function bubble () {
	    var milliseconds = this._milliseconds;
	    var days         = this._days;
	    var months       = this._months;
	    var data         = this._data;
	    var seconds, minutes, hours, years, monthsFromDays;
	
	    // if we have a mix of positive and negative values, bubble down first
	    // check: https://github.com/moment/moment/issues/2166
	    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	            (milliseconds <= 0 && days <= 0 && months <= 0))) {
	        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	        days = 0;
	        months = 0;
	    }
	
	    // The following code bubbles up values, see the tests for
	    // examples of what that means.
	    data.milliseconds = milliseconds % 1000;
	
	    seconds           = absFloor(milliseconds / 1000);
	    data.seconds      = seconds % 60;
	
	    minutes           = absFloor(seconds / 60);
	    data.minutes      = minutes % 60;
	
	    hours             = absFloor(minutes / 60);
	    data.hours        = hours % 24;
	
	    days += absFloor(hours / 24);
	
	    // convert days to months
	    monthsFromDays = absFloor(daysToMonths(days));
	    months += monthsFromDays;
	    days -= absCeil(monthsToDays(monthsFromDays));
	
	    // 12 months -> 1 year
	    years = absFloor(months / 12);
	    months %= 12;
	
	    data.days   = days;
	    data.months = months;
	    data.years  = years;
	
	    return this;
	}
	
	function daysToMonths (days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    // 400 years have 12 months === 4800
	    return days * 4800 / 146097;
	}
	
	function monthsToDays (months) {
	    // the reverse of daysToMonths
	    return months * 146097 / 4800;
	}
	
	function as (units) {
	    var days;
	    var months;
	    var milliseconds = this._milliseconds;
	
	    units = normalizeUnits(units);
	
	    if (units === 'month' || units === 'year') {
	        days   = this._days   + milliseconds / 864e5;
	        months = this._months + daysToMonths(days);
	        return units === 'month' ? months : months / 12;
	    } else {
	        // handle milliseconds separately because of floating point math errors (issue #1867)
	        days = this._days + Math.round(monthsToDays(this._months));
	        switch (units) {
	            case 'week'   : return days / 7     + milliseconds / 6048e5;
	            case 'day'    : return days         + milliseconds / 864e5;
	            case 'hour'   : return days * 24    + milliseconds / 36e5;
	            case 'minute' : return days * 1440  + milliseconds / 6e4;
	            case 'second' : return days * 86400 + milliseconds / 1000;
	            // Math.floor prevents floating point math errors here
	            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	            default: throw new Error('Unknown unit ' + units);
	        }
	    }
	}
	
	// TODO: Use this.as('ms')?
	function valueOf$1 () {
	    return (
	        this._milliseconds +
	        this._days * 864e5 +
	        (this._months % 12) * 2592e6 +
	        toInt(this._months / 12) * 31536e6
	    );
	}
	
	function makeAs (alias) {
	    return function () {
	        return this.as(alias);
	    };
	}
	
	var asMilliseconds = makeAs('ms');
	var asSeconds      = makeAs('s');
	var asMinutes      = makeAs('m');
	var asHours        = makeAs('h');
	var asDays         = makeAs('d');
	var asWeeks        = makeAs('w');
	var asMonths       = makeAs('M');
	var asYears        = makeAs('y');
	
	function get$2 (units) {
	    units = normalizeUnits(units);
	    return this[units + 's']();
	}
	
	function makeGetter(name) {
	    return function () {
	        return this._data[name];
	    };
	}
	
	var milliseconds = makeGetter('milliseconds');
	var seconds      = makeGetter('seconds');
	var minutes      = makeGetter('minutes');
	var hours        = makeGetter('hours');
	var days         = makeGetter('days');
	var months       = makeGetter('months');
	var years        = makeGetter('years');
	
	function weeks () {
	    return absFloor(this.days() / 7);
	}
	
	var round = Math.round;
	var thresholds = {
	    s: 45,  // seconds to minute
	    m: 45,  // minutes to hour
	    h: 22,  // hours to day
	    d: 26,  // days to month
	    M: 11   // months to year
	};
	
	// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	}
	
	function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	    var duration = createDuration(posNegDuration).abs();
	    var seconds  = round(duration.as('s'));
	    var minutes  = round(duration.as('m'));
	    var hours    = round(duration.as('h'));
	    var days     = round(duration.as('d'));
	    var months   = round(duration.as('M'));
	    var years    = round(duration.as('y'));
	
	    var a = seconds < thresholds.s && ['s', seconds]  ||
	            minutes <= 1           && ['m']           ||
	            minutes < thresholds.m && ['mm', minutes] ||
	            hours   <= 1           && ['h']           ||
	            hours   < thresholds.h && ['hh', hours]   ||
	            days    <= 1           && ['d']           ||
	            days    < thresholds.d && ['dd', days]    ||
	            months  <= 1           && ['M']           ||
	            months  < thresholds.M && ['MM', months]  ||
	            years   <= 1           && ['y']           || ['yy', years];
	
	    a[2] = withoutSuffix;
	    a[3] = +posNegDuration > 0;
	    a[4] = locale;
	    return substituteTimeAgo.apply(null, a);
	}
	
	// This function allows you to set the rounding function for relative time strings
	function getSetRelativeTimeRounding (roundingFunction) {
	    if (roundingFunction === undefined) {
	        return round;
	    }
	    if (typeof(roundingFunction) === 'function') {
	        round = roundingFunction;
	        return true;
	    }
	    return false;
	}
	
	// This function allows you to set a threshold for relative time strings
	function getSetRelativeTimeThreshold (threshold, limit) {
	    if (thresholds[threshold] === undefined) {
	        return false;
	    }
	    if (limit === undefined) {
	        return thresholds[threshold];
	    }
	    thresholds[threshold] = limit;
	    return true;
	}
	
	function humanize (withSuffix) {
	    var locale = this.localeData();
	    var output = relativeTime$1(this, !withSuffix, locale);
	
	    if (withSuffix) {
	        output = locale.pastFuture(+this, output);
	    }
	
	    return locale.postformat(output);
	}
	
	var abs$1 = Math.abs;
	
	function toISOString$1() {
	    // for ISO strings we do not use the normal bubbling rules:
	    //  * milliseconds bubble up until they become hours
	    //  * days do not bubble at all
	    //  * months bubble up until they become years
	    // This is because there is no context-free conversion between hours and days
	    // (think of clock changes)
	    // and also not between days and months (28-31 days per month)
	    var seconds = abs$1(this._milliseconds) / 1000;
	    var days         = abs$1(this._days);
	    var months       = abs$1(this._months);
	    var minutes, hours, years;
	
	    // 3600 seconds -> 60 minutes -> 1 hour
	    minutes           = absFloor(seconds / 60);
	    hours             = absFloor(minutes / 60);
	    seconds %= 60;
	    minutes %= 60;
	
	    // 12 months -> 1 year
	    years  = absFloor(months / 12);
	    months %= 12;
	
	
	    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	    var Y = years;
	    var M = months;
	    var D = days;
	    var h = hours;
	    var m = minutes;
	    var s = seconds;
	    var total = this.asSeconds();
	
	    if (!total) {
	        // this is the same as C#'s (Noda) and python (isodate)...
	        // but not other JS (goog.date)
	        return 'P0D';
	    }
	
	    return (total < 0 ? '-' : '') +
	        'P' +
	        (Y ? Y + 'Y' : '') +
	        (M ? M + 'M' : '') +
	        (D ? D + 'D' : '') +
	        ((h || m || s) ? 'T' : '') +
	        (h ? h + 'H' : '') +
	        (m ? m + 'M' : '') +
	        (s ? s + 'S' : '');
	}
	
	var proto$2 = Duration.prototype;
	
	proto$2.abs            = abs;
	proto$2.add            = add$1;
	proto$2.subtract       = subtract$1;
	proto$2.as             = as;
	proto$2.asMilliseconds = asMilliseconds;
	proto$2.asSeconds      = asSeconds;
	proto$2.asMinutes      = asMinutes;
	proto$2.asHours        = asHours;
	proto$2.asDays         = asDays;
	proto$2.asWeeks        = asWeeks;
	proto$2.asMonths       = asMonths;
	proto$2.asYears        = asYears;
	proto$2.valueOf        = valueOf$1;
	proto$2._bubble        = bubble;
	proto$2.get            = get$2;
	proto$2.milliseconds   = milliseconds;
	proto$2.seconds        = seconds;
	proto$2.minutes        = minutes;
	proto$2.hours          = hours;
	proto$2.days           = days;
	proto$2.weeks          = weeks;
	proto$2.months         = months;
	proto$2.years          = years;
	proto$2.humanize       = humanize;
	proto$2.toISOString    = toISOString$1;
	proto$2.toString       = toISOString$1;
	proto$2.toJSON         = toISOString$1;
	proto$2.locale         = locale;
	proto$2.localeData     = localeData;
	
	// Deprecations
	proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	proto$2.lang = lang;
	
	// Side effect imports
	
	// FORMATTING
	
	addFormatToken('X', 0, 0, 'unix');
	addFormatToken('x', 0, 0, 'valueOf');
	
	// PARSING
	
	addRegexToken('x', matchSigned);
	addRegexToken('X', matchTimestamp);
	addParseToken('X', function (input, array, config) {
	    config._d = new Date(parseFloat(input, 10) * 1000);
	});
	addParseToken('x', function (input, array, config) {
	    config._d = new Date(toInt(input));
	});
	
	// Side effect imports
	
	
	hooks.version = '2.17.1';
	
	setHookCallback(createLocal);
	
	hooks.fn                    = proto;
	hooks.min                   = min;
	hooks.max                   = max;
	hooks.now                   = now;
	hooks.utc                   = createUTC;
	hooks.unix                  = createUnix;
	hooks.months                = listMonths;
	hooks.isDate                = isDate;
	hooks.locale                = getSetGlobalLocale;
	hooks.invalid               = createInvalid;
	hooks.duration              = createDuration;
	hooks.isMoment              = isMoment;
	hooks.weekdays              = listWeekdays;
	hooks.parseZone             = createInZone;
	hooks.localeData            = getLocale;
	hooks.isDuration            = isDuration;
	hooks.monthsShort           = listMonthsShort;
	hooks.weekdaysMin           = listWeekdaysMin;
	hooks.defineLocale          = defineLocale;
	hooks.updateLocale          = updateLocale;
	hooks.locales               = listLocales;
	hooks.weekdaysShort         = listWeekdaysShort;
	hooks.normalizeUnits        = normalizeUnits;
	hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	hooks.calendarFormat        = getCalendarFormat;
	hooks.prototype             = proto;
	
	return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(250)(module)))

/***/ },
/* 250 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 252,
		"./af.js": 252,
		"./ar": 253,
		"./ar-dz": 254,
		"./ar-dz.js": 254,
		"./ar-ly": 255,
		"./ar-ly.js": 255,
		"./ar-ma": 256,
		"./ar-ma.js": 256,
		"./ar-sa": 257,
		"./ar-sa.js": 257,
		"./ar-tn": 258,
		"./ar-tn.js": 258,
		"./ar.js": 253,
		"./az": 259,
		"./az.js": 259,
		"./be": 260,
		"./be.js": 260,
		"./bg": 261,
		"./bg.js": 261,
		"./bn": 262,
		"./bn.js": 262,
		"./bo": 263,
		"./bo.js": 263,
		"./br": 264,
		"./br.js": 264,
		"./bs": 265,
		"./bs.js": 265,
		"./ca": 266,
		"./ca.js": 266,
		"./cs": 267,
		"./cs.js": 267,
		"./cv": 268,
		"./cv.js": 268,
		"./cy": 269,
		"./cy.js": 269,
		"./da": 270,
		"./da.js": 270,
		"./de": 271,
		"./de-at": 272,
		"./de-at.js": 272,
		"./de.js": 271,
		"./dv": 273,
		"./dv.js": 273,
		"./el": 274,
		"./el.js": 274,
		"./en-au": 275,
		"./en-au.js": 275,
		"./en-ca": 276,
		"./en-ca.js": 276,
		"./en-gb": 277,
		"./en-gb.js": 277,
		"./en-ie": 278,
		"./en-ie.js": 278,
		"./en-nz": 279,
		"./en-nz.js": 279,
		"./eo": 280,
		"./eo.js": 280,
		"./es": 281,
		"./es-do": 282,
		"./es-do.js": 282,
		"./es.js": 281,
		"./et": 283,
		"./et.js": 283,
		"./eu": 284,
		"./eu.js": 284,
		"./fa": 285,
		"./fa.js": 285,
		"./fi": 286,
		"./fi.js": 286,
		"./fo": 287,
		"./fo.js": 287,
		"./fr": 288,
		"./fr-ca": 289,
		"./fr-ca.js": 289,
		"./fr-ch": 290,
		"./fr-ch.js": 290,
		"./fr.js": 288,
		"./fy": 291,
		"./fy.js": 291,
		"./gd": 292,
		"./gd.js": 292,
		"./gl": 293,
		"./gl.js": 293,
		"./he": 294,
		"./he.js": 294,
		"./hi": 295,
		"./hi.js": 295,
		"./hr": 296,
		"./hr.js": 296,
		"./hu": 297,
		"./hu.js": 297,
		"./hy-am": 298,
		"./hy-am.js": 298,
		"./id": 299,
		"./id.js": 299,
		"./is": 300,
		"./is.js": 300,
		"./it": 301,
		"./it.js": 301,
		"./ja": 302,
		"./ja.js": 302,
		"./jv": 303,
		"./jv.js": 303,
		"./ka": 304,
		"./ka.js": 304,
		"./kk": 305,
		"./kk.js": 305,
		"./km": 306,
		"./km.js": 306,
		"./ko": 307,
		"./ko.js": 307,
		"./ky": 308,
		"./ky.js": 308,
		"./lb": 309,
		"./lb.js": 309,
		"./lo": 310,
		"./lo.js": 310,
		"./lt": 311,
		"./lt.js": 311,
		"./lv": 312,
		"./lv.js": 312,
		"./me": 313,
		"./me.js": 313,
		"./mi": 314,
		"./mi.js": 314,
		"./mk": 315,
		"./mk.js": 315,
		"./ml": 316,
		"./ml.js": 316,
		"./mr": 317,
		"./mr.js": 317,
		"./ms": 318,
		"./ms-my": 319,
		"./ms-my.js": 319,
		"./ms.js": 318,
		"./my": 320,
		"./my.js": 320,
		"./nb": 321,
		"./nb.js": 321,
		"./ne": 322,
		"./ne.js": 322,
		"./nl": 323,
		"./nl-be": 324,
		"./nl-be.js": 324,
		"./nl.js": 323,
		"./nn": 325,
		"./nn.js": 325,
		"./pa-in": 326,
		"./pa-in.js": 326,
		"./pl": 327,
		"./pl.js": 327,
		"./pt": 328,
		"./pt-br": 329,
		"./pt-br.js": 329,
		"./pt.js": 328,
		"./ro": 330,
		"./ro.js": 330,
		"./ru": 331,
		"./ru.js": 331,
		"./se": 332,
		"./se.js": 332,
		"./si": 333,
		"./si.js": 333,
		"./sk": 334,
		"./sk.js": 334,
		"./sl": 335,
		"./sl.js": 335,
		"./sq": 336,
		"./sq.js": 336,
		"./sr": 337,
		"./sr-cyrl": 338,
		"./sr-cyrl.js": 338,
		"./sr.js": 337,
		"./ss": 339,
		"./ss.js": 339,
		"./sv": 340,
		"./sv.js": 340,
		"./sw": 341,
		"./sw.js": 341,
		"./ta": 342,
		"./ta.js": 342,
		"./te": 343,
		"./te.js": 343,
		"./tet": 344,
		"./tet.js": 344,
		"./th": 345,
		"./th.js": 345,
		"./tl-ph": 346,
		"./tl-ph.js": 346,
		"./tlh": 347,
		"./tlh.js": 347,
		"./tr": 348,
		"./tr.js": 348,
		"./tzl": 349,
		"./tzl.js": 349,
		"./tzm": 350,
		"./tzm-latn": 351,
		"./tzm-latn.js": 351,
		"./tzm.js": 350,
		"./uk": 352,
		"./uk.js": 352,
		"./uz": 353,
		"./uz.js": 353,
		"./vi": 354,
		"./vi.js": 354,
		"./x-pseudo": 355,
		"./x-pseudo.js": 355,
		"./yo": 356,
		"./yo.js": 356,
		"./zh-cn": 357,
		"./zh-cn.js": 357,
		"./zh-hk": 358,
		"./zh-hk.js": 358,
		"./zh-tw": 359,
		"./zh-tw.js": 359
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 251;


/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var af = moment.defineLocale('af', {
	    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	    meridiemParse: /vm|nm/i,
	    isPM : function (input) {
	        return /^nm$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'vm' : 'VM';
	        } else {
	            return isLower ? 'nm' : 'NM';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Vandag om] LT',
	        nextDay : '[Môre om] LT',
	        nextWeek : 'dddd [om] LT',
	        lastDay : '[Gister om] LT',
	        lastWeek : '[Laas] dddd [om] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'oor %s',
	        past : '%s gelede',
	        s : '\'n paar sekondes',
	        m : '\'n minuut',
	        mm : '%d minute',
	        h : '\'n uur',
	        hh : '%d ure',
	        d : '\'n dag',
	        dd : '%d dae',
	        M : '\'n maand',
	        MM : '%d maande',
	        y : '\'n jaar',
	        yy : '%d jaar'
	    },
	    ordinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	    },
	    week : {
	        dow : 1, // Maandag is die eerste dag van die week.
	        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	    }
	});
	
	return af;
	
	})));


/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'كانون الثاني يناير',
	    'شباط فبراير',
	    'آذار مارس',
	    'نيسان أبريل',
	    'أيار مايو',
	    'حزيران يونيو',
	    'تموز يوليو',
	    'آب أغسطس',
	    'أيلول سبتمبر',
	    'تشرين الأول أكتوبر',
	    'تشرين الثاني نوفمبر',
	    'كانون الأول ديسمبر'
	];
	
	var ar = moment.defineLocale('ar', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ar;
	
	})));


/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arDz = moment.defineLocale('ar-dz', {
	    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 4  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arDz;
	
	})));


/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '1',
	    '2': '2',
	    '3': '3',
	    '4': '4',
	    '5': '5',
	    '6': '6',
	    '7': '7',
	    '8': '8',
	    '9': '9',
	    '0': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'يناير',
	    'فبراير',
	    'مارس',
	    'أبريل',
	    'مايو',
	    'يونيو',
	    'يوليو',
	    'أغسطس',
	    'سبتمبر',
	    'أكتوبر',
	    'نوفمبر',
	    'ديسمبر'
	];
	
	var arLy = moment.defineLocale('ar-ly', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arLy;
	
	})));


/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arMa = moment.defineLocale('ar-ma', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arMa;
	
	})));


/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	
	var arSa = moment.defineLocale('ar-sa', {
	    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    preparse: function (string) {
	        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arSa;
	
	})));


/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arTn = moment.defineLocale('ar-tn', {
	    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'في %s',
	        past: 'منذ %s',
	        s: 'ثوان',
	        m: 'دقيقة',
	        mm: '%d دقائق',
	        h: 'ساعة',
	        hh: '%d ساعات',
	        d: 'يوم',
	        dd: '%d أيام',
	        M: 'شهر',
	        MM: '%d أشهر',
	        y: 'سنة',
	        yy: '%d سنوات'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return arTn;
	
	})));


/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '-inci',
	    5: '-inci',
	    8: '-inci',
	    70: '-inci',
	    80: '-inci',
	    2: '-nci',
	    7: '-nci',
	    20: '-nci',
	    50: '-nci',
	    3: '-üncü',
	    4: '-üncü',
	    100: '-üncü',
	    6: '-ncı',
	    9: '-uncu',
	    10: '-uncu',
	    30: '-uncu',
	    60: '-ıncı',
	    90: '-ıncı'
	};
	
	var az = moment.defineLocale('az', {
	    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[sabah saat] LT',
	        nextWeek : '[gələn həftə] dddd [saat] LT',
	        lastDay : '[dünən] LT',
	        lastWeek : '[keçən həftə] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s əvvəl',
	        s : 'birneçə saniyyə',
	        m : 'bir dəqiqə',
	        mm : '%d dəqiqə',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir il',
	        yy : '%d il'
	    },
	    meridiemParse: /gecə|səhər|gündüz|axşam/,
	    isPM : function (input) {
	        return /^(gündüz|axşam)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'gecə';
	        } else if (hour < 12) {
	            return 'səhər';
	        } else if (hour < 17) {
	            return 'gündüz';
	        } else {
	            return 'axşam';
	        }
	    },
	    ordinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '-ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return az;
	
	})));


/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	        'dd': 'дзень_дні_дзён',
	        'MM': 'месяц_месяцы_месяцаў',
	        'yy': 'год_гады_гадоў'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвіліна' : 'хвіліну';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'гадзіна' : 'гадзіну';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	
	var be = moment.defineLocale('be', {
	    months : {
	        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	    },
	    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	    weekdays : {
	        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
	    },
	    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сёння ў] LT',
	        nextDay: '[Заўтра ў] LT',
	        lastDay: '[Учора ў] LT',
	        nextWeek: function () {
	            return '[У] dddd [ў] LT';
	        },
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return '[У мінулую] dddd [ў] LT';
	                case 1:
	                case 2:
	                case 4:
	                    return '[У мінулы] dddd [ў] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'праз %s',
	        past : '%s таму',
	        s : 'некалькі секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithPlural,
	        hh : relativeTimeWithPlural,
	        d : 'дзень',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночы|раніцы|дня|вечара/,
	    isPM : function (input) {
	        return /^(дня|вечара)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночы';
	        } else if (hour < 12) {
	            return 'раніцы';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечара';
	        }
	    },
	    ordinalParse: /\d{1,2}-(і|ы|га)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	            case 'D':
	                return number + '-га';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return be;
	
	})));


/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var bg = moment.defineLocale('bg', {
	    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Днес в] LT',
	        nextDay : '[Утре в] LT',
	        nextWeek : 'dddd [в] LT',
	        lastDay : '[Вчера в] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[В изминалата] dddd [в] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[В изминалия] dddd [в] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'след %s',
	        past : 'преди %s',
	        s : 'няколко секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дни',
	        M : 'месец',
	        MM : '%d месеца',
	        y : 'година',
	        yy : '%d години'
	    },
	    ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bg;
	
	})));


/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '১',
	    '2': '২',
	    '3': '৩',
	    '4': '৪',
	    '5': '৫',
	    '6': '৬',
	    '7': '৭',
	    '8': '৮',
	    '9': '৯',
	    '0': '০'
	};
	var numberMap = {
	    '১': '1',
	    '২': '2',
	    '৩': '3',
	    '৪': '4',
	    '৫': '5',
	    '৬': '6',
	    '৭': '7',
	    '৮': '8',
	    '৯': '9',
	    '০': '0'
	};
	
	var bn = moment.defineLocale('bn', {
	    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm সময়',
	        LTS : 'A h:mm:ss সময়',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm সময়',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	    },
	    calendar : {
	        sameDay : '[আজ] LT',
	        nextDay : '[আগামীকাল] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[গতকাল] LT',
	        lastWeek : '[গত] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s পরে',
	        past : '%s আগে',
	        s : 'কয়েক সেকেন্ড',
	        m : 'এক মিনিট',
	        mm : '%d মিনিট',
	        h : 'এক ঘন্টা',
	        hh : '%d ঘন্টা',
	        d : 'এক দিন',
	        dd : '%d দিন',
	        M : 'এক মাস',
	        MM : '%d মাস',
	        y : 'এক বছর',
	        yy : '%d বছর'
	    },
	    preparse: function (string) {
	        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'রাত';
	        } else if (hour < 10) {
	            return 'সকাল';
	        } else if (hour < 17) {
	            return 'দুপুর';
	        } else if (hour < 20) {
	            return 'বিকাল';
	        } else {
	            return 'রাত';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bn;
	
	})));


/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '༡',
	    '2': '༢',
	    '3': '༣',
	    '4': '༤',
	    '5': '༥',
	    '6': '༦',
	    '7': '༧',
	    '8': '༨',
	    '9': '༩',
	    '0': '༠'
	};
	var numberMap = {
	    '༡': '1',
	    '༢': '2',
	    '༣': '3',
	    '༤': '4',
	    '༥': '5',
	    '༦': '6',
	    '༧': '7',
	    '༨': '8',
	    '༩': '9',
	    '༠': '0'
	};
	
	var bo = moment.defineLocale('bo', {
	    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[དི་རིང] LT',
	        nextDay : '[སང་ཉིན] LT',
	        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	        lastDay : '[ཁ་སང] LT',
	        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ལ་',
	        past : '%s སྔན་ལ',
	        s : 'ལམ་སང',
	        m : 'སྐར་མ་གཅིག',
	        mm : '%d སྐར་མ',
	        h : 'ཆུ་ཚོད་གཅིག',
	        hh : '%d ཆུ་ཚོད',
	        d : 'ཉིན་གཅིག',
	        dd : '%d ཉིན་',
	        M : 'ཟླ་བ་གཅིག',
	        MM : '%d ཟླ་བ',
	        y : 'ལོ་གཅིག',
	        yy : '%d ལོ'
	    },
	    preparse: function (string) {
	        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'མཚན་མོ';
	        } else if (hour < 10) {
	            return 'ཞོགས་ཀས';
	        } else if (hour < 17) {
	            return 'ཉིན་གུང';
	        } else if (hour < 20) {
	            return 'དགོང་དག';
	        } else {
	            return 'མཚན་མོ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bo;
	
	})));


/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithMutation(number, withoutSuffix, key) {
	    var format = {
	        'mm': 'munutenn',
	        'MM': 'miz',
	        'dd': 'devezh'
	    };
	    return number + ' ' + mutation(format[key], number);
	}
	function specialMutationForYears(number) {
	    switch (lastNumber(number)) {
	        case 1:
	        case 3:
	        case 4:
	        case 5:
	        case 9:
	            return number + ' bloaz';
	        default:
	            return number + ' vloaz';
	    }
	}
	function lastNumber(number) {
	    if (number > 9) {
	        return lastNumber(number % 10);
	    }
	    return number;
	}
	function mutation(text, number) {
	    if (number === 2) {
	        return softMutation(text);
	    }
	    return text;
	}
	function softMutation(text) {
	    var mutationTable = {
	        'm': 'v',
	        'b': 'v',
	        'd': 'z'
	    };
	    if (mutationTable[text.charAt(0)] === undefined) {
	        return text;
	    }
	    return mutationTable[text.charAt(0)] + text.substring(1);
	}
	
	var br = moment.defineLocale('br', {
	    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h[e]mm A',
	        LTS : 'h[e]mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [a viz] MMMM YYYY',
	        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	    },
	    calendar : {
	        sameDay : '[Hiziv da] LT',
	        nextDay : '[Warc\'hoazh da] LT',
	        nextWeek : 'dddd [da] LT',
	        lastDay : '[Dec\'h da] LT',
	        lastWeek : 'dddd [paset da] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'a-benn %s',
	        past : '%s \'zo',
	        s : 'un nebeud segondennoù',
	        m : 'ur vunutenn',
	        mm : relativeTimeWithMutation,
	        h : 'un eur',
	        hh : '%d eur',
	        d : 'un devezh',
	        dd : relativeTimeWithMutation,
	        M : 'ur miz',
	        MM : relativeTimeWithMutation,
	        y : 'ur bloaz',
	        yy : specialMutationForYears
	    },
	    ordinalParse: /\d{1,2}(añ|vet)/,
	    ordinal : function (number) {
	        var output = (number === 1) ? 'añ' : 'vet';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return br;
	
	})));


/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var bs = moment.defineLocale('bs', {
	    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bs;
	
	})));


/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ca = moment.defineLocale('ca', {
	    months : 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	    monthsShort : 'gen._febr._mar._abr._mai._jun._jul._ag._set._oct._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	    weekdaysMin : 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextDay : function () {
	            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastDay : function () {
	            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'd\'aquí %s',
	        past : 'fa %s',
	        s : 'uns segons',
	        m : 'un minut',
	        mm : '%d minuts',
	        h : 'una hora',
	        hh : '%d hores',
	        d : 'un dia',
	        dd : '%d dies',
	        M : 'un mes',
	        MM : '%d mesos',
	        y : 'un any',
	        yy : '%d anys'
	    },
	    ordinalParse: /\d{1,2}(r|n|t|è|a)/,
	    ordinal : function (number, period) {
	        var output = (number === 1) ? 'r' :
	            (number === 2) ? 'n' :
	            (number === 3) ? 'r' :
	            (number === 4) ? 't' : 'è';
	        if (period === 'w' || period === 'W') {
	            output = 'a';
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ca;
	
	})));


/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
	var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minuty' : 'minut');
	            } else {
	                return result + 'minutami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodin');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dny' : 'dní');
	            } else {
	                return result + 'dny';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'měsíce' : 'měsíců');
	            } else {
	                return result + 'měsíci';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'let');
	            } else {
	                return result + 'lety';
	            }
	            break;
	    }
	}
	
	var cs = moment.defineLocale('cs', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParse : (function (months, monthsShort) {
	        var i, _monthsParse = [];
	        for (i = 0; i < 12; i++) {
	            // use custom parser to solve problem with July (červenec)
	            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	        }
	        return _monthsParse;
	    }(months, monthsShort)),
	    shortMonthsParse : (function (monthsShort) {
	        var i, _shortMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	        }
	        return _shortMonthsParse;
	    }(monthsShort)),
	    longMonthsParse : (function (months) {
	        var i, _longMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	        }
	        return _longMonthsParse;
	    }(months)),
	    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm',
	        l : 'D. M. YYYY'
	    },
	    calendar : {
	        sameDay: '[dnes v] LT',
	        nextDay: '[zítra v] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v neděli v] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [v] LT';
	                case 3:
	                    return '[ve středu v] LT';
	                case 4:
	                    return '[ve čtvrtek v] LT';
	                case 5:
	                    return '[v pátek v] LT';
	                case 6:
	                    return '[v sobotu v] LT';
	            }
	        },
	        lastDay: '[včera v] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulou neděli v] LT';
	                case 1:
	                case 2:
	                    return '[minulé] dddd [v] LT';
	                case 3:
	                    return '[minulou středu v] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [v] LT';
	                case 6:
	                    return '[minulou sobotu v] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'před %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    ordinalParse : /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cs;
	
	})));


/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cv = moment.defineLocale('cv', {
	    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	    },
	    calendar : {
	        sameDay: '[Паян] LT [сехетре]',
	        nextDay: '[Ыран] LT [сехетре]',
	        lastDay: '[Ӗнер] LT [сехетре]',
	        nextWeek: '[Ҫитес] dddd LT [сехетре]',
	        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (output) {
	            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	            return output + affix;
	        },
	        past : '%s каялла',
	        s : 'пӗр-ик ҫеккунт',
	        m : 'пӗр минут',
	        mm : '%d минут',
	        h : 'пӗр сехет',
	        hh : '%d сехет',
	        d : 'пӗр кун',
	        dd : '%d кун',
	        M : 'пӗр уйӑх',
	        MM : '%d уйӑх',
	        y : 'пӗр ҫул',
	        yy : '%d ҫул'
	    },
	    ordinalParse: /\d{1,2}-мӗш/,
	    ordinal : '%d-мӗш',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return cv;
	
	})));


/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cy = moment.defineLocale('cy', {
	    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    // time formats are the same as en-gb
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[Heddiw am] LT',
	        nextDay: '[Yfory am] LT',
	        nextWeek: 'dddd [am] LT',
	        lastDay: '[Ddoe am] LT',
	        lastWeek: 'dddd [diwethaf am] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'mewn %s',
	        past: '%s yn ôl',
	        s: 'ychydig eiliadau',
	        m: 'munud',
	        mm: '%d munud',
	        h: 'awr',
	        hh: '%d awr',
	        d: 'diwrnod',
	        dd: '%d diwrnod',
	        M: 'mis',
	        MM: '%d mis',
	        y: 'blwyddyn',
	        yy: '%d flynedd'
	    },
	    ordinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	    ordinal: function (number) {
	        var b = number,
	            output = '',
	            lookup = [
	                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	            ];
	        if (b > 20) {
	            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                output = 'fed'; // not 30ain, 70ain or 90ain
	            } else {
	                output = 'ain';
	            }
	        } else if (b > 0) {
	            output = lookup[b];
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cy;
	
	})));


/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var da = moment.defineLocale('da', {
	    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd [d.] D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[I dag kl.] LT',
	        nextDay : '[I morgen kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[I går kl.] LT',
	        lastWeek : '[sidste] dddd [kl] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'få sekunder',
	        m : 'et minut',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dage',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'et år',
	        yy : '%d år'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return da;
	
	})));


/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var de = moment.defineLocale('de', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return de;
	
	})));


/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deAt = moment.defineLocale('de-at', {
	    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deAt;
	
	})));


/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'ޖެނުއަރީ',
	    'ފެބްރުއަރީ',
	    'މާރިޗު',
	    'އޭޕްރީލު',
	    'މޭ',
	    'ޖޫން',
	    'ޖުލައި',
	    'އޯގަސްޓު',
	    'ސެޕްޓެމްބަރު',
	    'އޮކްޓޯބަރު',
	    'ނޮވެމްބަރު',
	    'ޑިސެމްބަރު'
	];
	var weekdays = [
	    'އާދިއްތަ',
	    'ހޯމަ',
	    'އަންގާރަ',
	    'ބުދަ',
	    'ބުރާސްފަތި',
	    'ހުކުރު',
	    'ހޮނިހިރު'
	];
	
	var dv = moment.defineLocale('dv', {
	    months : months,
	    monthsShort : months,
	    weekdays : weekdays,
	    weekdaysShort : weekdays,
	    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	    longDateFormat : {
	
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/M/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /މކ|މފ/,
	    isPM : function (input) {
	        return 'މފ' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'މކ';
	        } else {
	            return 'މފ';
	        }
	    },
	    calendar : {
	        sameDay : '[މިއަދު] LT',
	        nextDay : '[މާދަމާ] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[އިއްޔެ] LT',
	        lastWeek : '[ފާއިތުވި] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ތެރޭގައި %s',
	        past : 'ކުރިން %s',
	        s : 'ސިކުންތުކޮޅެއް',
	        m : 'މިނިޓެއް',
	        mm : 'މިނިޓު %d',
	        h : 'ގަޑިއިރެއް',
	        hh : 'ގަޑިއިރު %d',
	        d : 'ދުވަހެއް',
	        dd : 'ދުވަސް %d',
	        M : 'މަހެއް',
	        MM : 'މަސް %d',
	        y : 'އަހަރެއް',
	        yy : 'އަހަރު %d'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 7,  // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return dv;
	
	})));


/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	
	var el = moment.defineLocale('el', {
	    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	    months : function (momentToFormat, format) {
	        if (/D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	            return this._monthsGenitiveEl[momentToFormat.month()];
	        } else {
	            return this._monthsNominativeEl[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'μμ' : 'ΜΜ';
	        } else {
	            return isLower ? 'πμ' : 'ΠΜ';
	        }
	    },
	    isPM : function (input) {
	        return ((input + '').toLowerCase()[0] === 'μ');
	    },
	    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendarEl : {
	        sameDay : '[Σήμερα {}] LT',
	        nextDay : '[Αύριο {}] LT',
	        nextWeek : 'dddd [{}] LT',
	        lastDay : '[Χθες {}] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 6:
	                    return '[το προηγούμενο] dddd [{}] LT';
	                default:
	                    return '[την προηγούμενη] dddd [{}] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    calendar : function (key, mom) {
	        var output = this._calendarEl[key],
	            hours = mom && mom.hours();
	        if (isFunction(output)) {
	            output = output.apply(mom);
	        }
	        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	    },
	    relativeTime : {
	        future : 'σε %s',
	        past : '%s πριν',
	        s : 'λίγα δευτερόλεπτα',
	        m : 'ένα λεπτό',
	        mm : '%d λεπτά',
	        h : 'μία ώρα',
	        hh : '%d ώρες',
	        d : 'μία μέρα',
	        dd : '%d μέρες',
	        M : 'ένας μήνας',
	        MM : '%d μήνες',
	        y : 'ένας χρόνος',
	        yy : '%d χρόνια'
	    },
	    ordinalParse: /\d{1,2}η/,
	    ordinal: '%dη',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4st is the first week of the year.
	    }
	});
	
	return el;
	
	})));


/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enAu = moment.defineLocale('en-au', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enAu;
	
	})));


/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enCa = moment.defineLocale('en-ca', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'YYYY-MM-DD',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	return enCa;
	
	})));


/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enGb = moment.defineLocale('en-gb', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enGb;
	
	})));


/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enIe = moment.defineLocale('en-ie', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enIe;
	
	})));


/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enNz = moment.defineLocale('en-nz', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enNz;
	
	})));


/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! komento: Mi estas malcerta se mi korekte traktis akuzativojn en tiu traduko.
	//!          Se ne, bonvolu korekti kaj avizi min por ke mi povas lerni!
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eo = moment.defineLocale('eo', {
	    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	    weekdays : 'Dimanĉo_Lundo_Mardo_Merkredo_Ĵaŭdo_Vendredo_Sabato'.split('_'),
	    weekdaysShort : 'Dim_Lun_Mard_Merk_Ĵaŭ_Ven_Sab'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Ĵa_Ve_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D[-an de] MMMM, YYYY',
	        LLL : 'D[-an de] MMMM, YYYY HH:mm',
	        LLLL : 'dddd, [la] D[-an de] MMMM, YYYY HH:mm'
	    },
	    meridiemParse: /[ap]\.t\.m/i,
	    isPM: function (input) {
	        return input.charAt(0).toLowerCase() === 'p';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'p.t.m.' : 'P.T.M.';
	        } else {
	            return isLower ? 'a.t.m.' : 'A.T.M.';
	        }
	    },
	    calendar : {
	        sameDay : '[Hodiaŭ je] LT',
	        nextDay : '[Morgaŭ je] LT',
	        nextWeek : 'dddd [je] LT',
	        lastDay : '[Hieraŭ je] LT',
	        lastWeek : '[pasinta] dddd [je] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'je %s',
	        past : 'antaŭ %s',
	        s : 'sekundoj',
	        m : 'minuto',
	        mm : '%d minutoj',
	        h : 'horo',
	        hh : '%d horoj',
	        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	        dd : '%d tagoj',
	        M : 'monato',
	        MM : '%d monatoj',
	        y : 'jaro',
	        yy : '%d jaroj'
	    },
	    ordinalParse: /\d{1,2}a/,
	    ordinal : '%da',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eo;
	
	})));


/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var es = moment.defineLocale('es', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    ordinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return es;
	
	})));


/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var esDo = moment.defineLocale('es-do', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY h:mm A',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    ordinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return esDo;
	
	})));


/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	        'm' : ['ühe minuti', 'üks minut'],
	        'mm': [number + ' minuti', number + ' minutit'],
	        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	        'hh': [number + ' tunni', number + ' tundi'],
	        'd' : ['ühe päeva', 'üks päev'],
	        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	        'MM': [number + ' kuu', number + ' kuud'],
	        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	        'yy': [number + ' aasta', number + ' aastat']
	    };
	    if (withoutSuffix) {
	        return format[key][2] ? format[key][2] : format[key][1];
	    }
	    return isFuture ? format[key][0] : format[key][1];
	}
	
	var et = moment.defineLocale('et', {
	    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	    longDateFormat : {
	        LT   : 'H:mm',
	        LTS : 'H:mm:ss',
	        L    : 'DD.MM.YYYY',
	        LL   : 'D. MMMM YYYY',
	        LLL  : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[Täna,] LT',
	        nextDay  : '[Homme,] LT',
	        nextWeek : '[Järgmine] dddd LT',
	        lastDay  : '[Eile,] LT',
	        lastWeek : '[Eelmine] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s pärast',
	        past   : '%s tagasi',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : '%d päeva',
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return et;
	
	})));


/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eu = moment.defineLocale('eu', {
	    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY[ko] MMMM[ren] D[a]',
	        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	        l : 'YYYY-M-D',
	        ll : 'YYYY[ko] MMM D[a]',
	        lll : 'YYYY[ko] MMM D[a] HH:mm',
	        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	    },
	    calendar : {
	        sameDay : '[gaur] LT[etan]',
	        nextDay : '[bihar] LT[etan]',
	        nextWeek : 'dddd LT[etan]',
	        lastDay : '[atzo] LT[etan]',
	        lastWeek : '[aurreko] dddd LT[etan]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s barru',
	        past : 'duela %s',
	        s : 'segundo batzuk',
	        m : 'minutu bat',
	        mm : '%d minutu',
	        h : 'ordu bat',
	        hh : '%d ordu',
	        d : 'egun bat',
	        dd : '%d egun',
	        M : 'hilabete bat',
	        MM : '%d hilabete',
	        y : 'urte bat',
	        yy : '%d urte'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eu;
	
	})));


/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '۱',
	    '2': '۲',
	    '3': '۳',
	    '4': '۴',
	    '5': '۵',
	    '6': '۶',
	    '7': '۷',
	    '8': '۸',
	    '9': '۹',
	    '0': '۰'
	};
	var numberMap = {
	    '۱': '1',
	    '۲': '2',
	    '۳': '3',
	    '۴': '4',
	    '۵': '5',
	    '۶': '6',
	    '۷': '7',
	    '۸': '8',
	    '۹': '9',
	    '۰': '0'
	};
	
	var fa = moment.defineLocale('fa', {
	    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /قبل از ظهر|بعد از ظهر/,
	    isPM: function (input) {
	        return /بعد از ظهر/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'قبل از ظهر';
	        } else {
	            return 'بعد از ظهر';
	        }
	    },
	    calendar : {
	        sameDay : '[امروز ساعت] LT',
	        nextDay : '[فردا ساعت] LT',
	        nextWeek : 'dddd [ساعت] LT',
	        lastDay : '[دیروز ساعت] LT',
	        lastWeek : 'dddd [پیش] [ساعت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'در %s',
	        past : '%s پیش',
	        s : 'چندین ثانیه',
	        m : 'یک دقیقه',
	        mm : '%d دقیقه',
	        h : 'یک ساعت',
	        hh : '%d ساعت',
	        d : 'یک روز',
	        dd : '%d روز',
	        M : 'یک ماه',
	        MM : '%d ماه',
	        y : 'یک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/[۰-۹]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    ordinalParse: /\d{1,2}م/,
	    ordinal : '%dم',
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return fa;
	
	})));


/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
	var numbersFuture = [
	        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	        numbersPast[7], numbersPast[8], numbersPast[9]
	    ];
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = '';
	    switch (key) {
	        case 's':
	            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	        case 'm':
	            return isFuture ? 'minuutin' : 'minuutti';
	        case 'mm':
	            result = isFuture ? 'minuutin' : 'minuuttia';
	            break;
	        case 'h':
	            return isFuture ? 'tunnin' : 'tunti';
	        case 'hh':
	            result = isFuture ? 'tunnin' : 'tuntia';
	            break;
	        case 'd':
	            return isFuture ? 'päivän' : 'päivä';
	        case 'dd':
	            result = isFuture ? 'päivän' : 'päivää';
	            break;
	        case 'M':
	            return isFuture ? 'kuukauden' : 'kuukausi';
	        case 'MM':
	            result = isFuture ? 'kuukauden' : 'kuukautta';
	            break;
	        case 'y':
	            return isFuture ? 'vuoden' : 'vuosi';
	        case 'yy':
	            result = isFuture ? 'vuoden' : 'vuotta';
	            break;
	    }
	    result = verbalNumber(number, isFuture) + ' ' + result;
	    return result;
	}
	function verbalNumber(number, isFuture) {
	    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	}
	
	var fi = moment.defineLocale('fi', {
	    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'Do MMMM[ta] YYYY',
	        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	        l : 'D.M.YYYY',
	        ll : 'Do MMM YYYY',
	        lll : 'Do MMM YYYY, [klo] HH.mm',
	        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	    },
	    calendar : {
	        sameDay : '[tänään] [klo] LT',
	        nextDay : '[huomenna] [klo] LT',
	        nextWeek : 'dddd [klo] LT',
	        lastDay : '[eilen] [klo] LT',
	        lastWeek : '[viime] dddd[na] [klo] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s päästä',
	        past : '%s sitten',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fi;
	
	})));


/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fo = moment.defineLocale('fo', {
	    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D. MMMM, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Í dag kl.] LT',
	        nextDay : '[Í morgin kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[Í gjár kl.] LT',
	        lastWeek : '[síðstu] dddd [kl] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'um %s',
	        past : '%s síðani',
	        s : 'fá sekund',
	        m : 'ein minutt',
	        mm : '%d minuttir',
	        h : 'ein tími',
	        hh : '%d tímar',
	        d : 'ein dagur',
	        dd : '%d dagar',
	        M : 'ein mánaði',
	        MM : '%d mánaðir',
	        y : 'eitt ár',
	        yy : '%d ár'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fo;
	
	})));


/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fr = moment.defineLocale('fr', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Aujourd\'hui à] LT',
	        nextDay: '[Demain à] LT',
	        nextWeek: 'dddd [à] LT',
	        lastDay: '[Hier à] LT',
	        lastWeek: 'dddd [dernier à] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    ordinalParse: /\d{1,2}(er|)/,
	    ordinal : function (number) {
	        return number + (number === 1 ? 'er' : '');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fr;
	
	})));


/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCa = moment.defineLocale('fr-ca', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Aujourd\'hui à] LT',
	        nextDay: '[Demain à] LT',
	        nextWeek: 'dddd [à] LT',
	        lastDay: '[Hier à] LT',
	        lastWeek: 'dddd [dernier à] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    ordinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number) {
	        return number + (number === 1 ? 'er' : 'e');
	    }
	});
	
	return frCa;
	
	})));


/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCh = moment.defineLocale('fr-ch', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Aujourd\'hui à] LT',
	        nextDay: '[Demain à] LT',
	        nextWeek: 'dddd [à] LT',
	        lastDay: '[Hier à] LT',
	        lastWeek: 'dddd [dernier à] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    ordinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number) {
	        return number + (number === 1 ? 'er' : 'e');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return frCh;
	
	})));


/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	var fy = moment.defineLocale('fy', {
	    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	    monthsShort : function (m, format) {
	        if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[hjoed om] LT',
	        nextDay: '[moarn om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[juster om] LT',
	        lastWeek: '[ôfrûne] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'oer %s',
	        past : '%s lyn',
	        s : 'in pear sekonden',
	        m : 'ien minút',
	        mm : '%d minuten',
	        h : 'ien oere',
	        hh : '%d oeren',
	        d : 'ien dei',
	        dd : '%d dagen',
	        M : 'ien moanne',
	        MM : '%d moannen',
	        y : 'ien jier',
	        yy : '%d jierren'
	    },
	    ordinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fy;
	
	})));


/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	];
	
	var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	var gd = moment.defineLocale('gd', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParseExact : true,
	    weekdays : weekdays,
	    weekdaysShort : weekdaysShort,
	    weekdaysMin : weekdaysMin,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[An-diugh aig] LT',
	        nextDay : '[A-màireach aig] LT',
	        nextWeek : 'dddd [aig] LT',
	        lastDay : '[An-dè aig] LT',
	        lastWeek : 'dddd [seo chaidh] [aig] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ann an %s',
	        past : 'bho chionn %s',
	        s : 'beagan diogan',
	        m : 'mionaid',
	        mm : '%d mionaidean',
	        h : 'uair',
	        hh : '%d uairean',
	        d : 'latha',
	        dd : '%d latha',
	        M : 'mìos',
	        MM : '%d mìosan',
	        y : 'bliadhna',
	        yy : '%d bliadhna'
	    },
	    ordinalParse : /\d{1,2}(d|na|mh)/,
	    ordinal : function (number) {
	        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gd;
	
	})));


/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var gl = moment.defineLocale('gl', {
	    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        lastDay : function () {
	            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	        },
	        lastWeek : function () {
	            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (str) {
	            if (str.indexOf('un') === 0) {
	                return 'n' + str;
	            }
	            return 'en ' + str;
	        },
	        past : 'hai %s',
	        s : 'uns segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'unha hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un ano',
	        yy : '%d anos'
	    },
	    ordinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gl;
	
	})));


/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var he = moment.defineLocale('he', {
	    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [ב]MMMM YYYY',
	        LLL : 'D [ב]MMMM YYYY HH:mm',
	        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	        l : 'D/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[היום ב־]LT',
	        nextDay : '[מחר ב־]LT',
	        nextWeek : 'dddd [בשעה] LT',
	        lastDay : '[אתמול ב־]LT',
	        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'בעוד %s',
	        past : 'לפני %s',
	        s : 'מספר שניות',
	        m : 'דקה',
	        mm : '%d דקות',
	        h : 'שעה',
	        hh : function (number) {
	            if (number === 2) {
	                return 'שעתיים';
	            }
	            return number + ' שעות';
	        },
	        d : 'יום',
	        dd : function (number) {
	            if (number === 2) {
	                return 'יומיים';
	            }
	            return number + ' ימים';
	        },
	        M : 'חודש',
	        MM : function (number) {
	            if (number === 2) {
	                return 'חודשיים';
	            }
	            return number + ' חודשים';
	        },
	        y : 'שנה',
	        yy : function (number) {
	            if (number === 2) {
	                return 'שנתיים';
	            } else if (number % 10 === 0 && number !== 10) {
	                return number + ' שנה';
	            }
	            return number + ' שנים';
	        }
	    },
	    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	    isPM : function (input) {
	        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 5) {
	            return 'לפנות בוקר';
	        } else if (hour < 10) {
	            return 'בבוקר';
	        } else if (hour < 12) {
	            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	        } else if (hour < 18) {
	            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	        } else {
	            return 'בערב';
	        }
	    }
	});
	
	return he;
	
	})));


/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var hi = moment.defineLocale('hi', {
	    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm बजे',
	        LTS : 'A h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[कल] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[कल] LT',
	        lastWeek : '[पिछले] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s में',
	        past : '%s पहले',
	        s : 'कुछ ही क्षण',
	        m : 'एक मिनट',
	        mm : '%d मिनट',
	        h : 'एक घंटा',
	        hh : '%d घंटे',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महीने',
	        MM : '%d महीने',
	        y : 'एक वर्ष',
	        yy : '%d वर्ष'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	    meridiemParse: /रात|सुबह|दोपहर|शाम/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सुबह') {
	            return hour;
	        } else if (meridiem === 'दोपहर') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'शाम') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात';
	        } else if (hour < 10) {
	            return 'सुबह';
	        } else if (hour < 17) {
	            return 'दोपहर';
	        } else if (hour < 20) {
	            return 'शाम';
	        } else {
	            return 'रात';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hi;
	
	})));


/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var hr = moment.defineLocale('hr', {
	    months : {
	        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	    },
	    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hr;
	
	})));


/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	function translate(number, withoutSuffix, key, isFuture) {
	    var num = number,
	        suffix;
	    switch (key) {
	        case 's':
	            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	        case 'm':
	            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'mm':
	            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'h':
	            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'hh':
	            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'd':
	            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'dd':
	            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'M':
	            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'MM':
	            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'y':
	            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	        case 'yy':
	            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	    }
	    return '';
	}
	function week(isFuture) {
	    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	}
	
	var hu = moment.defineLocale('hu', {
	    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'YYYY.MM.DD.',
	        LL : 'YYYY. MMMM D.',
	        LLL : 'YYYY. MMMM D. H:mm',
	        LLLL : 'YYYY. MMMM D., dddd H:mm'
	    },
	    meridiemParse: /de|du/i,
	    isPM: function (input) {
	        return input.charAt(1).toLowerCase() === 'u';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower === true ? 'de' : 'DE';
	        } else {
	            return isLower === true ? 'du' : 'DU';
	        }
	    },
	    calendar : {
	        sameDay : '[ma] LT[-kor]',
	        nextDay : '[holnap] LT[-kor]',
	        nextWeek : function () {
	            return week.call(this, true);
	        },
	        lastDay : '[tegnap] LT[-kor]',
	        lastWeek : function () {
	            return week.call(this, false);
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s múlva',
	        past : '%s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return hu;
	
	})));


/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var hyAm = moment.defineLocale('hy-am', {
	    months : {
	        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	    },
	    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY թ.',
	        LLL : 'D MMMM YYYY թ., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	    },
	    calendar : {
	        sameDay: '[այսօր] LT',
	        nextDay: '[վաղը] LT',
	        lastDay: '[երեկ] LT',
	        nextWeek: function () {
	            return 'dddd [օրը ժամը] LT';
	        },
	        lastWeek: function () {
	            return '[անցած] dddd [օրը ժամը] LT';
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s հետո',
	        past : '%s առաջ',
	        s : 'մի քանի վայրկյան',
	        m : 'րոպե',
	        mm : '%d րոպե',
	        h : 'ժամ',
	        hh : '%d ժամ',
	        d : 'օր',
	        dd : '%d օր',
	        M : 'ամիս',
	        MM : '%d ամիս',
	        y : 'տարի',
	        yy : '%d տարի'
	    },
	    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	    isPM: function (input) {
	        return /^(ցերեկվա|երեկոյան)$/.test(input);
	    },
	    meridiem : function (hour) {
	        if (hour < 4) {
	            return 'գիշերվա';
	        } else if (hour < 12) {
	            return 'առավոտվա';
	        } else if (hour < 17) {
	            return 'ցերեկվա';
	        } else {
	            return 'երեկոյան';
	        }
	    },
	    ordinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'DDD':
	            case 'w':
	            case 'W':
	            case 'DDDo':
	                if (number === 1) {
	                    return number + '-ին';
	                }
	                return number + '-րդ';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hyAm;
	
	})));


/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var id = moment.defineLocale('id', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|siang|sore|malam/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'siang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sore' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'siang';
	        } else if (hours < 19) {
	            return 'sore';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Besok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kemarin pukul] LT',
	        lastWeek : 'dddd [lalu pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lalu',
	        s : 'beberapa detik',
	        m : 'semenit',
	        mm : '%d menit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return id;
	
	})));


/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(n) {
	    if (n % 100 === 11) {
	        return true;
	    } else if (n % 10 === 1) {
	        return false;
	    }
	    return true;
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	        case 'm':
	            return withoutSuffix ? 'mínúta' : 'mínútu';
	        case 'mm':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	            } else if (withoutSuffix) {
	                return result + 'mínúta';
	            }
	            return result + 'mínútu';
	        case 'hh':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	            }
	            return result + 'klukkustund';
	        case 'd':
	            if (withoutSuffix) {
	                return 'dagur';
	            }
	            return isFuture ? 'dag' : 'degi';
	        case 'dd':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'dagar';
	                }
	                return result + (isFuture ? 'daga' : 'dögum');
	            } else if (withoutSuffix) {
	                return result + 'dagur';
	            }
	            return result + (isFuture ? 'dag' : 'degi');
	        case 'M':
	            if (withoutSuffix) {
	                return 'mánuður';
	            }
	            return isFuture ? 'mánuð' : 'mánuði';
	        case 'MM':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'mánuðir';
	                }
	                return result + (isFuture ? 'mánuði' : 'mánuðum');
	            } else if (withoutSuffix) {
	                return result + 'mánuður';
	            }
	            return result + (isFuture ? 'mánuð' : 'mánuði');
	        case 'y':
	            return withoutSuffix || isFuture ? 'ár' : 'ári';
	        case 'yy':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	            }
	            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	    }
	}
	
	var is = moment.defineLocale('is', {
	    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	    },
	    calendar : {
	        sameDay : '[í dag kl.] LT',
	        nextDay : '[á morgun kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[í gær kl.] LT',
	        lastWeek : '[síðasta] dddd [kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'eftir %s',
	        past : 'fyrir %s síðan',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : 'klukkustund',
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return is;
	
	})));


/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var it = moment.defineLocale('it', {
	    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	    weekdays : 'Domenica_Lunedì_Martedì_Mercoledì_Giovedì_Venerdì_Sabato'.split('_'),
	    weekdaysShort : 'Dom_Lun_Mar_Mer_Gio_Ven_Sab'.split('_'),
	    weekdaysMin : 'Do_Lu_Ma_Me_Gi_Ve_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Oggi alle] LT',
	        nextDay: '[Domani alle] LT',
	        nextWeek: 'dddd [alle] LT',
	        lastDay: '[Ieri alle] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[la scorsa] dddd [alle] LT';
	                default:
	                    return '[lo scorso] dddd [alle] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	        },
	        past : '%s fa',
	        s : 'alcuni secondi',
	        m : 'un minuto',
	        mm : '%d minuti',
	        h : 'un\'ora',
	        hh : '%d ore',
	        d : 'un giorno',
	        dd : '%d giorni',
	        M : 'un mese',
	        MM : '%d mesi',
	        y : 'un anno',
	        yy : '%d anni'
	    },
	    ordinalParse : /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return it;
	
	})));


/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ja = moment.defineLocale('ja', {
	    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	    longDateFormat : {
	        LT : 'Ah時m分',
	        LTS : 'Ah時m分s秒',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日Ah時m分',
	        LLLL : 'YYYY年M月D日Ah時m分 dddd'
	    },
	    meridiemParse: /午前|午後/i,
	    isPM : function (input) {
	        return input === '午後';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return '午前';
	        } else {
	            return '午後';
	        }
	    },
	    calendar : {
	        sameDay : '[今日] LT',
	        nextDay : '[明日] LT',
	        nextWeek : '[来週]dddd LT',
	        lastDay : '[昨日] LT',
	        lastWeek : '[前週]dddd LT',
	        sameElse : 'L'
	    },
	    ordinalParse : /\d{1,2}日/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s後',
	        past : '%s前',
	        s : '数秒',
	        m : '1分',
	        mm : '%d分',
	        h : '1時間',
	        hh : '%d時間',
	        d : '1日',
	        dd : '%d日',
	        M : '1ヶ月',
	        MM : '%dヶ月',
	        y : '1年',
	        yy : '%d年'
	    }
	});
	
	return ja;
	
	})));


/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var jv = moment.defineLocale('jv', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /enjing|siyang|sonten|ndalu/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'enjing') {
	            return hour;
	        } else if (meridiem === 'siyang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'enjing';
	        } else if (hours < 15) {
	            return 'siyang';
	        } else if (hours < 19) {
	            return 'sonten';
	        } else {
	            return 'ndalu';
	        }
	    },
	    calendar : {
	        sameDay : '[Dinten puniko pukul] LT',
	        nextDay : '[Mbenjang pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kala wingi pukul] LT',
	        lastWeek : 'dddd [kepengker pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'wonten ing %s',
	        past : '%s ingkang kepengker',
	        s : 'sawetawis detik',
	        m : 'setunggal menit',
	        mm : '%d menit',
	        h : 'setunggal jam',
	        hh : '%d jam',
	        d : 'sedinten',
	        dd : '%d dinten',
	        M : 'sewulan',
	        MM : '%d wulan',
	        y : 'setaun',
	        yy : '%d taun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return jv;
	
	})));


/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ka = moment.defineLocale('ka', {
	    months : {
	        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	    },
	    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	    weekdays : {
	        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	        isFormat: /(წინა|შემდეგ)/
	    },
	    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[დღეს] LT[-ზე]',
	        nextDay : '[ხვალ] LT[-ზე]',
	        lastDay : '[გუშინ] LT[-ზე]',
	        nextWeek : '[შემდეგ] dddd LT[-ზე]',
	        lastWeek : '[წინა] dddd LT-ზე',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                s.replace(/ი$/, 'ში') :
	                s + 'ში';
	        },
	        past : function (s) {
	            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                return s.replace(/(ი|ე)$/, 'ის წინ');
	            }
	            if ((/წელი/).test(s)) {
	                return s.replace(/წელი$/, 'წლის წინ');
	            }
	        },
	        s : 'რამდენიმე წამი',
	        m : 'წუთი',
	        mm : '%d წუთი',
	        h : 'საათი',
	        hh : '%d საათი',
	        d : 'დღე',
	        dd : '%d დღე',
	        M : 'თვე',
	        MM : '%d თვე',
	        y : 'წელი',
	        yy : '%d წელი'
	    },
	    ordinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	    ordinal : function (number) {
	        if (number === 0) {
	            return number;
	        }
	        if (number === 1) {
	            return number + '-ლი';
	        }
	        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	            return 'მე-' + number;
	        }
	        return number + '-ე';
	    },
	    week : {
	        dow : 1,
	        doy : 7
	    }
	});
	
	return ka;
	
	})));


/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    0: '-ші',
	    1: '-ші',
	    2: '-ші',
	    3: '-ші',
	    4: '-ші',
	    5: '-ші',
	    6: '-шы',
	    7: '-ші',
	    8: '-ші',
	    9: '-шы',
	    10: '-шы',
	    20: '-шы',
	    30: '-шы',
	    40: '-шы',
	    50: '-ші',
	    60: '-шы',
	    70: '-ші',
	    80: '-ші',
	    90: '-шы',
	    100: '-ші'
	};
	
	var kk = moment.defineLocale('kk', {
	    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгін сағат] LT',
	        nextDay : '[Ертең сағат] LT',
	        nextWeek : 'dddd [сағат] LT',
	        lastDay : '[Кеше сағат] LT',
	        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ішінде',
	        past : '%s бұрын',
	        s : 'бірнеше секунд',
	        m : 'бір минут',
	        mm : '%d минут',
	        h : 'бір сағат',
	        hh : '%d сағат',
	        d : 'бір күн',
	        dd : '%d күн',
	        M : 'бір ай',
	        MM : '%d ай',
	        y : 'бір жыл',
	        yy : '%d жыл'
	    },
	    ordinalParse: /\d{1,2}-(ші|шы)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kk;
	
	})));


/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var km = moment.defineLocale('km', {
	    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	        nextDay: '[ស្អែក ម៉ោង] LT',
	        nextWeek: 'dddd [ម៉ោង] LT',
	        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%sទៀត',
	        past: '%sមុន',
	        s: 'ប៉ុន្មានវិនាទី',
	        m: 'មួយនាទី',
	        mm: '%d នាទី',
	        h: 'មួយម៉ោង',
	        hh: '%d ម៉ោង',
	        d: 'មួយថ្ងៃ',
	        dd: '%d ថ្ងៃ',
	        M: 'មួយខែ',
	        MM: '%d ខែ',
	        y: 'មួយឆ្នាំ',
	        yy: '%d ឆ្នាំ'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return km;
	
	})));


/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ko = moment.defineLocale('ko', {
	    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	    longDateFormat : {
	        LT : 'A h시 m분',
	        LTS : 'A h시 m분 s초',
	        L : 'YYYY.MM.DD',
	        LL : 'YYYY년 MMMM D일',
	        LLL : 'YYYY년 MMMM D일 A h시 m분',
	        LLLL : 'YYYY년 MMMM D일 dddd A h시 m분'
	    },
	    calendar : {
	        sameDay : '오늘 LT',
	        nextDay : '내일 LT',
	        nextWeek : 'dddd LT',
	        lastDay : '어제 LT',
	        lastWeek : '지난주 dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s 후',
	        past : '%s 전',
	        s : '몇 초',
	        ss : '%d초',
	        m : '일분',
	        mm : '%d분',
	        h : '한 시간',
	        hh : '%d시간',
	        d : '하루',
	        dd : '%d일',
	        M : '한 달',
	        MM : '%d달',
	        y : '일 년',
	        yy : '%d년'
	    },
	    ordinalParse : /\d{1,2}일/,
	    ordinal : '%d일',
	    meridiemParse : /오전|오후/,
	    isPM : function (token) {
	        return token === '오후';
	    },
	    meridiem : function (hour, minute, isUpper) {
	        return hour < 12 ? '오전' : '오후';
	    }
	});
	
	return ko;
	
	})));


/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var suffixes = {
	    0: '-чү',
	    1: '-чи',
	    2: '-чи',
	    3: '-чү',
	    4: '-чү',
	    5: '-чи',
	    6: '-чы',
	    7: '-чи',
	    8: '-чи',
	    9: '-чу',
	    10: '-чу',
	    20: '-чы',
	    30: '-чу',
	    40: '-чы',
	    50: '-чү',
	    60: '-чы',
	    70: '-чи',
	    80: '-чи',
	    90: '-чу',
	    100: '-чү'
	};
	
	var ky = moment.defineLocale('ky', {
	    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгүн саат] LT',
	        nextDay : '[Эртең саат] LT',
	        nextWeek : 'dddd [саат] LT',
	        lastDay : '[Кече саат] LT',
	        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ичинде',
	        past : '%s мурун',
	        s : 'бирнече секунд',
	        m : 'бир мүнөт',
	        mm : '%d мүнөт',
	        h : 'бир саат',
	        hh : '%d саат',
	        d : 'бир күн',
	        dd : '%d күн',
	        M : 'бир ай',
	        MM : '%d ай',
	        y : 'бир жыл',
	        yy : '%d жыл'
	    },
	    ordinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ky;
	
	})));


/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eng Minutt', 'enger Minutt'],
	        'h': ['eng Stonn', 'enger Stonn'],
	        'd': ['een Dag', 'engem Dag'],
	        'M': ['ee Mount', 'engem Mount'],
	        'y': ['ee Joer', 'engem Joer']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	function processFutureTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'a ' + string;
	    }
	    return 'an ' + string;
	}
	function processPastTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'viru ' + string;
	    }
	    return 'virun ' + string;
	}
	/**
	 * Returns true if the word before the given number loses the '-n' ending.
	 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	 *
	 * @param number {integer}
	 * @returns {boolean}
	 */
	function eifelerRegelAppliesToNumber(number) {
	    number = parseInt(number, 10);
	    if (isNaN(number)) {
	        return false;
	    }
	    if (number < 0) {
	        // Negative Number --> always true
	        return true;
	    } else if (number < 10) {
	        // Only 1 digit
	        if (4 <= number && number <= 7) {
	            return true;
	        }
	        return false;
	    } else if (number < 100) {
	        // 2 digits
	        var lastDigit = number % 10, firstDigit = number / 10;
	        if (lastDigit === 0) {
	            return eifelerRegelAppliesToNumber(firstDigit);
	        }
	        return eifelerRegelAppliesToNumber(lastDigit);
	    } else if (number < 10000) {
	        // 3 or 4 digits --> recursively check first digit
	        while (number >= 10) {
	            number = number / 10;
	        }
	        return eifelerRegelAppliesToNumber(number);
	    } else {
	        // Anything larger than 4 digits: recursively check first n-3 digits
	        number = number / 1000;
	        return eifelerRegelAppliesToNumber(number);
	    }
	}
	
	var lb = moment.defineLocale('lb', {
	    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm [Auer]',
	        LTS: 'H:mm:ss [Auer]',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm [Auer]',
	        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	    },
	    calendar: {
	        sameDay: '[Haut um] LT',
	        sameElse: 'L',
	        nextDay: '[Muer um] LT',
	        nextWeek: 'dddd [um] LT',
	        lastDay: '[Gëschter um] LT',
	        lastWeek: function () {
	            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	            switch (this.day()) {
	                case 2:
	                case 4:
	                    return '[Leschten] dddd [um] LT';
	                default:
	                    return '[Leschte] dddd [um] LT';
	            }
	        }
	    },
	    relativeTime : {
	        future : processFutureTime,
	        past : processPastTime,
	        s : 'e puer Sekonnen',
	        m : processRelativeTime,
	        mm : '%d Minutten',
	        h : processRelativeTime,
	        hh : '%d Stonnen',
	        d : processRelativeTime,
	        dd : '%d Deeg',
	        M : processRelativeTime,
	        MM : '%d Méint',
	        y : processRelativeTime,
	        yy : '%d Joer'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lb;
	
	})));


/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var lo = moment.defineLocale('lo', {
	    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	    isPM: function (input) {
	        return input === 'ຕອນແລງ';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ຕອນເຊົ້າ';
	        } else {
	            return 'ຕອນແລງ';
	        }
	    },
	    calendar : {
	        sameDay : '[ມື້ນີ້ເວລາ] LT',
	        nextDay : '[ມື້ອື່ນເວລາ] LT',
	        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ອີກ %s',
	        past : '%sຜ່ານມາ',
	        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	        m : '1 ນາທີ',
	        mm : '%d ນາທີ',
	        h : '1 ຊົ່ວໂມງ',
	        hh : '%d ຊົ່ວໂມງ',
	        d : '1 ມື້',
	        dd : '%d ມື້',
	        M : '1 ເດືອນ',
	        MM : '%d ເດືອນ',
	        y : '1 ປີ',
	        yy : '%d ປີ'
	    },
	    ordinalParse: /(ທີ່)\d{1,2}/,
	    ordinal : function (number) {
	        return 'ທີ່' + number;
	    }
	});
	
	return lo;
	
	})));


/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm' : 'minutė_minutės_minutę',
	    'mm': 'minutės_minučių_minutes',
	    'h' : 'valanda_valandos_valandą',
	    'hh': 'valandos_valandų_valandas',
	    'd' : 'diena_dienos_dieną',
	    'dd': 'dienos_dienų_dienas',
	    'M' : 'mėnuo_mėnesio_mėnesį',
	    'MM': 'mėnesiai_mėnesių_mėnesius',
	    'y' : 'metai_metų_metus',
	    'yy': 'metai_metų_metus'
	};
	function translateSeconds(number, withoutSuffix, key, isFuture) {
	    if (withoutSuffix) {
	        return 'kelios sekundės';
	    } else {
	        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	    }
	}
	function translateSingular(number, withoutSuffix, key, isFuture) {
	    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	}
	function special(number) {
	    return number % 10 === 0 || (number > 10 && number < 20);
	}
	function forms(key) {
	    return units[key].split('_');
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    if (number === 1) {
	        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	    } else if (withoutSuffix) {
	        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	    } else {
	        if (isFuture) {
	            return result + forms(key)[1];
	        } else {
	            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	        }
	    }
	}
	var lt = moment.defineLocale('lt', {
	    months : {
	        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	    },
	    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	    weekdays : {
	        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	        isFormat: /dddd HH:mm/
	    },
	    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY [m.] MMMM D [d.]',
	        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	        l : 'YYYY-MM-DD',
	        ll : 'YYYY [m.] MMMM D [d.]',
	        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	    },
	    calendar : {
	        sameDay : '[Šiandien] LT',
	        nextDay : '[Rytoj] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[Vakar] LT',
	        lastWeek : '[Praėjusį] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'po %s',
	        past : 'prieš %s',
	        s : translateSeconds,
	        m : translateSingular,
	        mm : translate,
	        h : translateSingular,
	        hh : translate,
	        d : translateSingular,
	        dd : translate,
	        M : translateSingular,
	        MM : translate,
	        y : translateSingular,
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}-oji/,
	    ordinal : function (number) {
	        return number + '-oji';
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lt;
	
	})));


/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'h': 'stundas_stundām_stunda_stundas'.split('_'),
	    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	    'd': 'dienas_dienām_diena_dienas'.split('_'),
	    'dd': 'dienas_dienām_diena_dienas'.split('_'),
	    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'y': 'gada_gadiem_gads_gadi'.split('_'),
	    'yy': 'gada_gadiem_gads_gadi'.split('_')
	};
	/**
	 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	 */
	function format(forms, number, withoutSuffix) {
	    if (withoutSuffix) {
	        // E.g. "21 minūte", "3 minūtes".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	    } else {
	        // E.g. "21 minūtes" as in "pēc 21 minūtes".
	        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	    }
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    return number + ' ' + format(units[key], number, withoutSuffix);
	}
	function relativeTimeWithSingular(number, withoutSuffix, key) {
	    return format(units[key], number, withoutSuffix);
	}
	function relativeSeconds(number, withoutSuffix) {
	    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	}
	
	var lv = moment.defineLocale('lv', {
	    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY.',
	        LL : 'YYYY. [gada] D. MMMM',
	        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	    },
	    calendar : {
	        sameDay : '[Šodien pulksten] LT',
	        nextDay : '[Rīt pulksten] LT',
	        nextWeek : 'dddd [pulksten] LT',
	        lastDay : '[Vakar pulksten] LT',
	        lastWeek : '[Pagājušā] dddd [pulksten] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'pēc %s',
	        past : 'pirms %s',
	        s : relativeSeconds,
	        m : relativeTimeWithSingular,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithSingular,
	        hh : relativeTimeWithPlural,
	        d : relativeTimeWithSingular,
	        dd : relativeTimeWithPlural,
	        M : relativeTimeWithSingular,
	        MM : relativeTimeWithPlural,
	        y : relativeTimeWithSingular,
	        yy : relativeTimeWithPlural
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lv;
	
	})));


/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jednog minuta'],
	        mm: ['minut', 'minuta', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mjesec', 'mjeseca', 'mjeseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var me = moment.defineLocale('me', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sjutra u] LT',
	
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedjelje] [u] LT',
	                '[prošlog] [ponedjeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srijede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mjesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return me;
	
	})));


/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mi = moment.defineLocale('mi', {
	    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY [i] HH:mm',
	        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	    },
	    calendar: {
	        sameDay: '[i teie mahana, i] LT',
	        nextDay: '[apopo i] LT',
	        nextWeek: 'dddd [i] LT',
	        lastDay: '[inanahi i] LT',
	        lastWeek: 'dddd [whakamutunga i] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'i roto i %s',
	        past: '%s i mua',
	        s: 'te hēkona ruarua',
	        m: 'he meneti',
	        mm: '%d meneti',
	        h: 'te haora',
	        hh: '%d haora',
	        d: 'he ra',
	        dd: '%d ra',
	        M: 'he marama',
	        MM: '%d marama',
	        y: 'he tau',
	        yy: '%d tau'
	    },
	    ordinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return mi;
	
	})));


/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mk = moment.defineLocale('mk', {
	    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Денес во] LT',
	        nextDay : '[Утре во] LT',
	        nextWeek : '[Во] dddd [во] LT',
	        lastDay : '[Вчера во] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[Изминатата] dddd [во] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[Изминатиот] dddd [во] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'после %s',
	        past : 'пред %s',
	        s : 'неколку секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дена',
	        M : 'месец',
	        MM : '%d месеци',
	        y : 'година',
	        yy : '%d години'
	    },
	    ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mk;
	
	})));


/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ml = moment.defineLocale('ml', {
	    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm -നു',
	        LTS : 'A h:mm:ss -നു',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm -നു',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	    },
	    calendar : {
	        sameDay : '[ഇന്ന്] LT',
	        nextDay : '[നാളെ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ഇന്നലെ] LT',
	        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s കഴിഞ്ഞ്',
	        past : '%s മുൻപ്',
	        s : 'അൽപ നിമിഷങ്ങൾ',
	        m : 'ഒരു മിനിറ്റ്',
	        mm : '%d മിനിറ്റ്',
	        h : 'ഒരു മണിക്കൂർ',
	        hh : '%d മണിക്കൂർ',
	        d : 'ഒരു ദിവസം',
	        dd : '%d ദിവസം',
	        M : 'ഒരു മാസം',
	        MM : '%d മാസം',
	        y : 'ഒരു വർഷം',
	        yy : '%d വർഷം'
	    },
	    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'രാത്രി';
	        } else if (hour < 12) {
	            return 'രാവിലെ';
	        } else if (hour < 17) {
	            return 'ഉച്ച കഴിഞ്ഞ്';
	        } else if (hour < 20) {
	            return 'വൈകുന്നേരം';
	        } else {
	            return 'രാത്രി';
	        }
	    }
	});
	
	return ml;
	
	})));


/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	function relativeTimeMr(number, withoutSuffix, string, isFuture)
	{
	    var output = '';
	    if (withoutSuffix) {
	        switch (string) {
	            case 's': output = 'काही सेकंद'; break;
	            case 'm': output = 'एक मिनिट'; break;
	            case 'mm': output = '%d मिनिटे'; break;
	            case 'h': output = 'एक तास'; break;
	            case 'hh': output = '%d तास'; break;
	            case 'd': output = 'एक दिवस'; break;
	            case 'dd': output = '%d दिवस'; break;
	            case 'M': output = 'एक महिना'; break;
	            case 'MM': output = '%d महिने'; break;
	            case 'y': output = 'एक वर्ष'; break;
	            case 'yy': output = '%d वर्षे'; break;
	        }
	    }
	    else {
	        switch (string) {
	            case 's': output = 'काही सेकंदां'; break;
	            case 'm': output = 'एका मिनिटा'; break;
	            case 'mm': output = '%d मिनिटां'; break;
	            case 'h': output = 'एका तासा'; break;
	            case 'hh': output = '%d तासां'; break;
	            case 'd': output = 'एका दिवसा'; break;
	            case 'dd': output = '%d दिवसां'; break;
	            case 'M': output = 'एका महिन्या'; break;
	            case 'MM': output = '%d महिन्यां'; break;
	            case 'y': output = 'एका वर्षा'; break;
	            case 'yy': output = '%d वर्षां'; break;
	        }
	    }
	    return output.replace(/%d/i, number);
	}
	
	var mr = moment.defineLocale('mr', {
	    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm वाजता',
	        LTS : 'A h:mm:ss वाजता',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm वाजता',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[उद्या] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[काल] LT',
	        lastWeek: '[मागील] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future: '%sमध्ये',
	        past: '%sपूर्वी',
	        s: relativeTimeMr,
	        m: relativeTimeMr,
	        mm: relativeTimeMr,
	        h: relativeTimeMr,
	        hh: relativeTimeMr,
	        d: relativeTimeMr,
	        dd: relativeTimeMr,
	        M: relativeTimeMr,
	        MM: relativeTimeMr,
	        y: relativeTimeMr,
	        yy: relativeTimeMr
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात्री') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सकाळी') {
	            return hour;
	        } else if (meridiem === 'दुपारी') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'सायंकाळी') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात्री';
	        } else if (hour < 10) {
	            return 'सकाळी';
	        } else if (hour < 17) {
	            return 'दुपारी';
	        } else if (hour < 20) {
	            return 'सायंकाळी';
	        } else {
	            return 'रात्री';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mr;
	
	})));


/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ms = moment.defineLocale('ms', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ms;
	
	})));


/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var msMy = moment.defineLocale('ms-my', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return msMy;
	
	})));


/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '၁',
	    '2': '၂',
	    '3': '၃',
	    '4': '၄',
	    '5': '၅',
	    '6': '၆',
	    '7': '၇',
	    '8': '၈',
	    '9': '၉',
	    '0': '၀'
	};
	var numberMap = {
	    '၁': '1',
	    '၂': '2',
	    '၃': '3',
	    '၄': '4',
	    '၅': '5',
	    '၆': '6',
	    '၇': '7',
	    '၈': '8',
	    '၉': '9',
	    '၀': '0'
	};
	
	var my = moment.defineLocale('my', {
	    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ယနေ.] LT [မှာ]',
	        nextDay: '[မနက်ဖြန်] LT [မှာ]',
	        nextWeek: 'dddd LT [မှာ]',
	        lastDay: '[မနေ.က] LT [မှာ]',
	        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'လာမည့် %s မှာ',
	        past: 'လွန်ခဲ့သော %s က',
	        s: 'စက္ကန်.အနည်းငယ်',
	        m: 'တစ်မိနစ်',
	        mm: '%d မိနစ်',
	        h: 'တစ်နာရီ',
	        hh: '%d နာရီ',
	        d: 'တစ်ရက်',
	        dd: '%d ရက်',
	        M: 'တစ်လ',
	        MM: '%d လ',
	        y: 'တစ်နှစ်',
	        yy: '%d နှစ်'
	    },
	    preparse: function (string) {
	        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return my;
	
	})));


/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nb = moment.defineLocale('nb', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[i dag kl.] LT',
	        nextDay: '[i morgen kl.] LT',
	        nextWeek: 'dddd [kl.] LT',
	        lastDay: '[i går kl.] LT',
	        lastWeek: '[forrige] dddd [kl.] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'noen sekunder',
	        m : 'ett minutt',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dager',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nb;
	
	})));


/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var ne = moment.defineLocale('ne', {
	    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'Aको h:mm बजे',
	        LTS : 'Aको h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, Aको h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'राति') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'बिहान') {
	            return hour;
	        } else if (meridiem === 'दिउँसो') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'साँझ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 3) {
	            return 'राति';
	        } else if (hour < 12) {
	            return 'बिहान';
	        } else if (hour < 16) {
	            return 'दिउँसो';
	        } else if (hour < 20) {
	            return 'साँझ';
	        } else {
	            return 'राति';
	        }
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[भोलि] LT',
	        nextWeek : '[आउँदो] dddd[,] LT',
	        lastDay : '[हिजो] LT',
	        lastWeek : '[गएको] dddd[,] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sमा',
	        past : '%s अगाडि',
	        s : 'केही क्षण',
	        m : 'एक मिनेट',
	        mm : '%d मिनेट',
	        h : 'एक घण्टा',
	        hh : '%d घण्टा',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महिना',
	        MM : '%d महिना',
	        y : 'एक बर्ष',
	        yy : '%d बर्ष'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ne;
	
	})));


/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nl = moment.defineLocale('nl', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    ordinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nl;
	
	})));


/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nlBe = moment.defineLocale('nl-be', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    ordinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nlBe;
	
	})));


/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! author : https://github.com/mechuwind
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nn = moment.defineLocale('nn', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[I dag klokka] LT',
	        nextDay: '[I morgon klokka] LT',
	        nextWeek: 'dddd [klokka] LT',
	        lastDay: '[I går klokka] LT',
	        lastWeek: '[Føregåande] dddd [klokka] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s sidan',
	        s : 'nokre sekund',
	        m : 'eit minutt',
	        mm : '%d minutt',
	        h : 'ein time',
	        hh : '%d timar',
	        d : 'ein dag',
	        dd : '%d dagar',
	        M : 'ein månad',
	        MM : '%d månader',
	        y : 'eit år',
	        yy : '%d år'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nn;
	
	})));


/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '੧',
	    '2': '੨',
	    '3': '੩',
	    '4': '੪',
	    '5': '੫',
	    '6': '੬',
	    '7': '੭',
	    '8': '੮',
	    '9': '੯',
	    '0': '੦'
	};
	var numberMap = {
	    '੧': '1',
	    '੨': '2',
	    '੩': '3',
	    '੪': '4',
	    '੫': '5',
	    '੬': '6',
	    '੭': '7',
	    '੮': '8',
	    '੯': '9',
	    '੦': '0'
	};
	
	var paIn = moment.defineLocale('pa-in', {
	    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm ਵਜੇ',
	        LTS : 'A h:mm:ss ਵਜੇ',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	    },
	    calendar : {
	        sameDay : '[ਅਜ] LT',
	        nextDay : '[ਕਲ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ਕਲ] LT',
	        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ਵਿੱਚ',
	        past : '%s ਪਿਛਲੇ',
	        s : 'ਕੁਝ ਸਕਿੰਟ',
	        m : 'ਇਕ ਮਿੰਟ',
	        mm : '%d ਮਿੰਟ',
	        h : 'ਇੱਕ ਘੰਟਾ',
	        hh : '%d ਘੰਟੇ',
	        d : 'ਇੱਕ ਦਿਨ',
	        dd : '%d ਦਿਨ',
	        M : 'ਇੱਕ ਮਹੀਨਾ',
	        MM : '%d ਮਹੀਨੇ',
	        y : 'ਇੱਕ ਸਾਲ',
	        yy : '%d ਸਾਲ'
	    },
	    preparse: function (string) {
	        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ਰਾਤ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ਸਵੇਰ') {
	            return hour;
	        } else if (meridiem === 'ਦੁਪਹਿਰ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ਸ਼ਾਮ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ਰਾਤ';
	        } else if (hour < 10) {
	            return 'ਸਵੇਰ';
	        } else if (hour < 17) {
	            return 'ਦੁਪਹਿਰ';
	        } else if (hour < 20) {
	            return 'ਸ਼ਾਮ';
	        } else {
	            return 'ਰਾਤ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return paIn;
	
	})));


/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
	var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	function plural(n) {
	    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	}
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'minuta' : 'minutę';
	        case 'mm':
	            return result + (plural(number) ? 'minuty' : 'minut');
	        case 'h':
	            return withoutSuffix  ? 'godzina'  : 'godzinę';
	        case 'hh':
	            return result + (plural(number) ? 'godziny' : 'godzin');
	        case 'MM':
	            return result + (plural(number) ? 'miesiące' : 'miesięcy');
	        case 'yy':
	            return result + (plural(number) ? 'lata' : 'lat');
	    }
	}
	
	var pl = moment.defineLocale('pl', {
	    months : function (momentToFormat, format) {
	        if (format === '') {
	            // Hack: if format empty we know this is used to generate
	            // RegExp by moment. Give then back both valid forms of months
	            // in RegExp ready format.
	            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	        } else if (/D MMMM/.test(format)) {
	            return monthsSubjective[momentToFormat.month()];
	        } else {
	            return monthsNominative[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Dziś o] LT',
	        nextDay: '[Jutro o] LT',
	        nextWeek: '[W] dddd [o] LT',
	        lastDay: '[Wczoraj o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W zeszłą niedzielę o] LT';
	                case 3:
	                    return '[W zeszłą środę o] LT';
	                case 6:
	                    return '[W zeszłą sobotę o] LT';
	                default:
	                    return '[W zeszły] dddd [o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : '%s temu',
	        s : 'kilka sekund',
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : '1 dzień',
	        dd : '%d dni',
	        M : 'miesiąc',
	        MM : translate,
	        y : 'rok',
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pl;
	
	})));


/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var pt = moment.defineLocale('pt', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : 'há %s',
	        s : 'segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    ordinalParse: /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pt;
	
	})));


/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ptBr = moment.defineLocale('pt-br', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : '%s atrás',
	        s : 'poucos segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    ordinalParse: /\d{1,2}º/,
	    ordinal : '%dº'
	});
	
	return ptBr;
	
	})));


/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	            'mm': 'minute',
	            'hh': 'ore',
	            'dd': 'zile',
	            'MM': 'luni',
	            'yy': 'ani'
	        },
	        separator = ' ';
	    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	        separator = ' de ';
	    }
	    return number + separator + format[key];
	}
	
	var ro = moment.defineLocale('ro', {
	    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[azi la] LT',
	        nextDay: '[mâine la] LT',
	        nextWeek: 'dddd [la] LT',
	        lastDay: '[ieri la] LT',
	        lastWeek: '[fosta] dddd [la] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'peste %s',
	        past : '%s în urmă',
	        s : 'câteva secunde',
	        m : 'un minut',
	        mm : relativeTimeWithPlural,
	        h : 'o oră',
	        hh : relativeTimeWithPlural,
	        d : 'o zi',
	        dd : relativeTimeWithPlural,
	        M : 'o lună',
	        MM : relativeTimeWithPlural,
	        y : 'un an',
	        yy : relativeTimeWithPlural
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ro;
	
	})));


/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	        'hh': 'час_часа_часов',
	        'dd': 'день_дня_дней',
	        'MM': 'месяц_месяца_месяцев',
	        'yy': 'год_года_лет'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'минута' : 'минуту';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	// http://new.gramota.ru/spravka/rules/139-prop : § 103
	// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	var ru = moment.defineLocale('ru', {
	    months : {
	        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	    },
	    monthsShort : {
	        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	    },
	    weekdays : {
	        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	    },
	    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // копия предыдущего
	    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // полные названия с падежами
	    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	    // Выражение, которое соотвествует только сокращённым формам
	    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сегодня в] LT',
	        nextDay: '[Завтра в] LT',
	        lastDay: '[Вчера в] LT',
	        nextWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В следующее] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В следующий] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В следующую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        lastWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В прошлое] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В прошлый] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В прошлую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'через %s',
	        past : '%s назад',
	        s : 'несколько секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'час',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночи|утра|дня|вечера/i,
	    isPM : function (input) {
	        return /^(дня|вечера)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночи';
	        } else if (hour < 12) {
	            return 'утра';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечера';
	        }
	    },
	    ordinalParse: /\d{1,2}-(й|го|я)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            case 'w':
	            case 'W':
	                return number + '-я';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ru;
	
	})));


/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var se = moment.defineLocale('se', {
	    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'MMMM D. [b.] YYYY',
	        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[otne ti] LT',
	        nextDay: '[ihttin ti] LT',
	        nextWeek: 'dddd [ti] LT',
	        lastDay: '[ikte ti] LT',
	        lastWeek: '[ovddit] dddd [ti] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s geažes',
	        past : 'maŋit %s',
	        s : 'moadde sekunddat',
	        m : 'okta minuhta',
	        mm : '%d minuhtat',
	        h : 'okta diimmu',
	        hh : '%d diimmut',
	        d : 'okta beaivi',
	        dd : '%d beaivvit',
	        M : 'okta mánnu',
	        MM : '%d mánut',
	        y : 'okta jahki',
	        yy : '%d jagit'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return se;
	
	})));


/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	/*jshint -W100*/
	var si = moment.defineLocale('si', {
	    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'a h:mm',
	        LTS : 'a h:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY MMMM D',
	        LLL : 'YYYY MMMM D, a h:mm',
	        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	    },
	    calendar : {
	        sameDay : '[අද] LT[ට]',
	        nextDay : '[හෙට] LT[ට]',
	        nextWeek : 'dddd LT[ට]',
	        lastDay : '[ඊයේ] LT[ට]',
	        lastWeek : '[පසුගිය] dddd LT[ට]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sකින්',
	        past : '%sකට පෙර',
	        s : 'තත්පර කිහිපය',
	        m : 'මිනිත්තුව',
	        mm : 'මිනිත්තු %d',
	        h : 'පැය',
	        hh : 'පැය %d',
	        d : 'දිනය',
	        dd : 'දින %d',
	        M : 'මාසය',
	        MM : 'මාස %d',
	        y : 'වසර',
	        yy : 'වසර %d'
	    },
	    ordinalParse: /\d{1,2} වැනි/,
	    ordinal : function (number) {
	        return number + ' වැනි';
	    },
	    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	    isPM : function (input) {
	        return input === 'ප.ව.' || input === 'පස් වරු';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'ප.ව.' : 'පස් වරු';
	        } else {
	            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	        }
	    }
	});
	
	return si;
	
	})));


/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
	var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minúty' : 'minút');
	            } else {
	                return result + 'minútami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodín');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dni' : 'dní');
	            } else {
	                return result + 'dňami';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'mesiace' : 'mesiacov');
	            } else {
	                return result + 'mesiacmi';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'rokov');
	            } else {
	                return result + 'rokmi';
	            }
	            break;
	    }
	}
	
	var sk = moment.defineLocale('sk', {
	    months : months,
	    monthsShort : monthsShort,
	    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[dnes o] LT',
	        nextDay: '[zajtra o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [o] LT';
	                case 3:
	                    return '[v stredu o] LT';
	                case 4:
	                    return '[vo štvrtok o] LT';
	                case 5:
	                    return '[v piatok o] LT';
	                case 6:
	                    return '[v sobotu o] LT';
	            }
	        },
	        lastDay: '[včera o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulú nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[minulý] dddd [o] LT';
	                case 3:
	                    return '[minulú stredu o] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [o] LT';
	                case 6:
	                    return '[minulú sobotu o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'pred %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sk;
	
	})));


/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	        case 'm':
	            return withoutSuffix ? 'ena minuta' : 'eno minuto';
	        case 'mm':
	            if (number === 1) {
	                result += withoutSuffix ? 'minuta' : 'minuto';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	            } else {
	                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'ena ura' : 'eno uro';
	        case 'hh':
	            if (number === 1) {
	                result += withoutSuffix ? 'ura' : 'uro';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'uri' : 'urama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'ure' : 'urami';
	            } else {
	                result += withoutSuffix || isFuture ? 'ur' : 'urami';
	            }
	            return result;
	        case 'd':
	            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	        case 'dd':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	            } else {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	            }
	            return result;
	        case 'M':
	            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	        case 'MM':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	            } else {
	                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	            }
	            return result;
	        case 'y':
	            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	        case 'yy':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'leto' : 'letom';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'leta' : 'leti';
	            } else {
	                result += withoutSuffix || isFuture ? 'let' : 'leti';
	            }
	            return result;
	    }
	}
	
	var sl = moment.defineLocale('sl', {
	    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danes ob] LT',
	        nextDay  : '[jutri ob] LT',
	
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v] [nedeljo] [ob] LT';
	                case 3:
	                    return '[v] [sredo] [ob] LT';
	                case 6:
	                    return '[v] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[v] dddd [ob] LT';
	            }
	        },
	        lastDay  : '[včeraj ob] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[prejšnjo] [nedeljo] [ob] LT';
	                case 3:
	                    return '[prejšnjo] [sredo] [ob] LT';
	                case 6:
	                    return '[prejšnjo] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prejšnji] dddd [ob] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'čez %s',
	        past   : 'pred %s',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : processRelativeTime,
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sl;
	
	})));


/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sq = moment.defineLocale('sq', {
	    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /PD|MD/,
	    isPM: function (input) {
	        return input.charAt(0) === 'M';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        return hours < 12 ? 'PD' : 'MD';
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Sot në] LT',
	        nextDay : '[Nesër në] LT',
	        nextWeek : 'dddd [në] LT',
	        lastDay : '[Dje në] LT',
	        lastWeek : 'dddd [e kaluar në] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'në %s',
	        past : '%s më parë',
	        s : 'disa sekonda',
	        m : 'një minutë',
	        mm : '%d minuta',
	        h : 'një orë',
	        hh : '%d orë',
	        d : 'një ditë',
	        dd : '%d ditë',
	        M : 'një muaj',
	        MM : '%d muaj',
	        y : 'një vit',
	        yy : '%d vite'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sq;
	
	})));


/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jedne minute'],
	        mm: ['minut', 'minute', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mesec', 'meseca', 'meseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var sr = moment.defineLocale('sr', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sutra u] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedelju] [u] LT';
	                case 3:
	                    return '[u] [sredu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedelje] [u] LT',
	                '[prošlog] [ponedeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'pre %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sr;
	
	})));


/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['један минут', 'једне минуте'],
	        mm: ['минут', 'минуте', 'минута'],
	        h: ['један сат', 'једног сата'],
	        hh: ['сат', 'сата', 'сати'],
	        dd: ['дан', 'дана', 'дана'],
	        MM: ['месец', 'месеца', 'месеци'],
	        yy: ['година', 'године', 'година']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var srCyrl = moment.defineLocale('sr-cyrl', {
	    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[данас у] LT',
	        nextDay: '[сутра у] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[у] [недељу] [у] LT';
	                case 3:
	                    return '[у] [среду] [у] LT';
	                case 6:
	                    return '[у] [суботу] [у] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[у] dddd [у] LT';
	            }
	        },
	        lastDay  : '[јуче у] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[прошле] [недеље] [у] LT',
	                '[прошлог] [понедељка] [у] LT',
	                '[прошлог] [уторка] [у] LT',
	                '[прошле] [среде] [у] LT',
	                '[прошлог] [четвртка] [у] LT',
	                '[прошлог] [петка] [у] LT',
	                '[прошле] [суботе] [у] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past   : 'пре %s',
	        s      : 'неколико секунди',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'дан',
	        dd     : translator.translate,
	        M      : 'месец',
	        MM     : translator.translate,
	        y      : 'годину',
	        yy     : translator.translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return srCyrl;
	
	})));


/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var ss = moment.defineLocale('ss', {
	    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Namuhla nga] LT',
	        nextDay : '[Kusasa nga] LT',
	        nextWeek : 'dddd [nga] LT',
	        lastDay : '[Itolo nga] LT',
	        lastWeek : 'dddd [leliphelile] [nga] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'nga %s',
	        past : 'wenteka nga %s',
	        s : 'emizuzwana lomcane',
	        m : 'umzuzu',
	        mm : '%d emizuzu',
	        h : 'lihora',
	        hh : '%d emahora',
	        d : 'lilanga',
	        dd : '%d emalanga',
	        M : 'inyanga',
	        MM : '%d tinyanga',
	        y : 'umnyaka',
	        yy : '%d iminyaka'
	    },
	    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'ekuseni';
	        } else if (hours < 15) {
	            return 'emini';
	        } else if (hours < 19) {
	            return 'entsambama';
	        } else {
	            return 'ebusuku';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ekuseni') {
	            return hour;
	        } else if (meridiem === 'emini') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	            if (hour === 0) {
	                return 0;
	            }
	            return hour + 12;
	        }
	    },
	    ordinalParse: /\d{1,2}/,
	    ordinal : '%d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ss;
	
	})));


/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sv = moment.defineLocale('sv', {
	    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Idag] LT',
	        nextDay: '[Imorgon] LT',
	        lastDay: '[Igår] LT',
	        nextWeek: '[På] dddd LT',
	        lastWeek: '[I] dddd[s] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : 'för %s sedan',
	        s : 'några sekunder',
	        m : 'en minut',
	        mm : '%d minuter',
	        h : 'en timme',
	        hh : '%d timmar',
	        d : 'en dag',
	        dd : '%d dagar',
	        M : 'en månad',
	        MM : '%d månader',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    ordinalParse: /\d{1,2}(e|a)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'e' :
	            (b === 1) ? 'a' :
	            (b === 2) ? 'a' :
	            (b === 3) ? 'e' : 'e';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sv;
	
	})));


/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sw = moment.defineLocale('sw', {
	    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[leo saa] LT',
	        nextDay : '[kesho saa] LT',
	        nextWeek : '[wiki ijayo] dddd [saat] LT',
	        lastDay : '[jana] LT',
	        lastWeek : '[wiki iliyopita] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s baadaye',
	        past : 'tokea %s',
	        s : 'hivi punde',
	        m : 'dakika moja',
	        mm : 'dakika %d',
	        h : 'saa limoja',
	        hh : 'masaa %d',
	        d : 'siku moja',
	        dd : 'masiku %d',
	        M : 'mwezi mmoja',
	        MM : 'miezi %d',
	        y : 'mwaka mmoja',
	        yy : 'miaka %d'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sw;
	
	})));


/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '௧',
	    '2': '௨',
	    '3': '௩',
	    '4': '௪',
	    '5': '௫',
	    '6': '௬',
	    '7': '௭',
	    '8': '௮',
	    '9': '௯',
	    '0': '௦'
	};
	var numberMap = {
	    '௧': '1',
	    '௨': '2',
	    '௩': '3',
	    '௪': '4',
	    '௫': '5',
	    '௬': '6',
	    '௭': '7',
	    '௮': '8',
	    '௯': '9',
	    '௦': '0'
	};
	
	var ta = moment.defineLocale('ta', {
	    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, HH:mm',
	        LLLL : 'dddd, D MMMM YYYY, HH:mm'
	    },
	    calendar : {
	        sameDay : '[இன்று] LT',
	        nextDay : '[நாளை] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[நேற்று] LT',
	        lastWeek : '[கடந்த வாரம்] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s இல்',
	        past : '%s முன்',
	        s : 'ஒரு சில விநாடிகள்',
	        m : 'ஒரு நிமிடம்',
	        mm : '%d நிமிடங்கள்',
	        h : 'ஒரு மணி நேரம்',
	        hh : '%d மணி நேரம்',
	        d : 'ஒரு நாள்',
	        dd : '%d நாட்கள்',
	        M : 'ஒரு மாதம்',
	        MM : '%d மாதங்கள்',
	        y : 'ஒரு வருடம்',
	        yy : '%d ஆண்டுகள்'
	    },
	    ordinalParse: /\d{1,2}வது/,
	    ordinal : function (number) {
	        return number + 'வது';
	    },
	    preparse: function (string) {
	        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // refer http://ta.wikipedia.org/s/1er1
	    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 2) {
	            return ' யாமம்';
	        } else if (hour < 6) {
	            return ' வைகறை';  // வைகறை
	        } else if (hour < 10) {
	            return ' காலை'; // காலை
	        } else if (hour < 14) {
	            return ' நண்பகல்'; // நண்பகல்
	        } else if (hour < 18) {
	            return ' எற்பாடு'; // எற்பாடு
	        } else if (hour < 22) {
	            return ' மாலை'; // மாலை
	        } else {
	            return ' யாமம்';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'யாமம்') {
	            return hour < 2 ? hour : hour + 12;
	        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	            return hour;
	        } else if (meridiem === 'நண்பகல்') {
	            return hour >= 10 ? hour : hour + 12;
	        } else {
	            return hour + 12;
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ta;
	
	})));


/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var te = moment.defineLocale('te', {
	    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[నేడు] LT',
	        nextDay : '[రేపు] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[నిన్న] LT',
	        lastWeek : '[గత] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s లో',
	        past : '%s క్రితం',
	        s : 'కొన్ని క్షణాలు',
	        m : 'ఒక నిమిషం',
	        mm : '%d నిమిషాలు',
	        h : 'ఒక గంట',
	        hh : '%d గంటలు',
	        d : 'ఒక రోజు',
	        dd : '%d రోజులు',
	        M : 'ఒక నెల',
	        MM : '%d నెలలు',
	        y : 'ఒక సంవత్సరం',
	        yy : '%d సంవత్సరాలు'
	    },
	    ordinalParse : /\d{1,2}వ/,
	    ordinal : '%dవ',
	    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'రాత్రి') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ఉదయం') {
	            return hour;
	        } else if (meridiem === 'మధ్యాహ్నం') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'సాయంత్రం') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'రాత్రి';
	        } else if (hour < 10) {
	            return 'ఉదయం';
	        } else if (hour < 17) {
	            return 'మధ్యాహ్నం';
	        } else if (hour < 20) {
	            return 'సాయంత్రం';
	        } else {
	            return 'రాత్రి';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return te;
	
	})));


/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tet = moment.defineLocale('tet', {
	    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
	    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Ohin iha] LT',
	        nextDay: '[Aban iha] LT',
	        nextWeek: 'dddd [iha] LT',
	        lastDay: '[Horiseik iha] LT',
	        lastWeek: 'dddd [semana kotuk] [iha] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'iha %s',
	        past : '%s liuba',
	        s : 'minutu balun',
	        m : 'minutu ida',
	        mm : 'minutus %d',
	        h : 'horas ida',
	        hh : 'horas %d',
	        d : 'loron ida',
	        dd : 'loron %d',
	        M : 'fulan ida',
	        MM : 'fulan %d',
	        y : 'tinan ida',
	        yy : 'tinan %d'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tet;
	
	})));


/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var th = moment.defineLocale('th', {
	    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY เวลา H:mm',
	        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	    },
	    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	    isPM: function (input) {
	        return input === 'หลังเที่ยง';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ก่อนเที่ยง';
	        } else {
	            return 'หลังเที่ยง';
	        }
	    },
	    calendar : {
	        sameDay : '[วันนี้ เวลา] LT',
	        nextDay : '[พรุ่งนี้ เวลา] LT',
	        nextWeek : 'dddd[หน้า เวลา] LT',
	        lastDay : '[เมื่อวานนี้ เวลา] LT',
	        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'อีก %s',
	        past : '%sที่แล้ว',
	        s : 'ไม่กี่วินาที',
	        m : '1 นาที',
	        mm : '%d นาที',
	        h : '1 ชั่วโมง',
	        hh : '%d ชั่วโมง',
	        d : '1 วัน',
	        dd : '%d วัน',
	        M : '1 เดือน',
	        MM : '%d เดือน',
	        y : '1 ปี',
	        yy : '%d ปี'
	    }
	});
	
	return th;
	
	})));


/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tlPh = moment.defineLocale('tl-ph', {
	    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'MM/D/YYYY',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY HH:mm',
	        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: 'LT [ngayong araw]',
	        nextDay: '[Bukas ng] LT',
	        nextWeek: 'LT [sa susunod na] dddd',
	        lastDay: 'LT [kahapon]',
	        lastWeek: 'LT [noong nakaraang] dddd',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'sa loob ng %s',
	        past : '%s ang nakalipas',
	        s : 'ilang segundo',
	        m : 'isang minuto',
	        mm : '%d minuto',
	        h : 'isang oras',
	        hh : '%d oras',
	        d : 'isang araw',
	        dd : '%d araw',
	        M : 'isang buwan',
	        MM : '%d buwan',
	        y : 'isang taon',
	        yy : '%d taon'
	    },
	    ordinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlPh;
	
	})));


/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	function translateFuture(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'leS' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'waQ' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'nem' :
	    time + ' pIq';
	    return time;
	}
	
	function translatePast(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'Hu’' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'wen' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'ben' :
	    time + ' ret';
	    return time;
	}
	
	function translate(number, withoutSuffix, string, isFuture) {
	    var numberNoun = numberAsNoun(number);
	    switch (string) {
	        case 'mm':
	            return numberNoun + ' tup';
	        case 'hh':
	            return numberNoun + ' rep';
	        case 'dd':
	            return numberNoun + ' jaj';
	        case 'MM':
	            return numberNoun + ' jar';
	        case 'yy':
	            return numberNoun + ' DIS';
	    }
	}
	
	function numberAsNoun(number) {
	    var hundred = Math.floor((number % 1000) / 100),
	    ten = Math.floor((number % 100) / 10),
	    one = number % 10,
	    word = '';
	    if (hundred > 0) {
	        word += numbersNouns[hundred] + 'vatlh';
	    }
	    if (ten > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	    }
	    if (one > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	    }
	    return (word === '') ? 'pagh' : word;
	}
	
	var tlh = moment.defineLocale('tlh', {
	    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[DaHjaj] LT',
	        nextDay: '[wa’leS] LT',
	        nextWeek: 'LLL',
	        lastDay: '[wa’Hu’] LT',
	        lastWeek: 'LLL',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : translateFuture,
	        past : translatePast,
	        s : 'puS lup',
	        m : 'wa’ tup',
	        mm : translate,
	        h : 'wa’ rep',
	        hh : translate,
	        d : 'wa’ jaj',
	        dd : translate,
	        M : 'wa’ jar',
	        MM : translate,
	        y : 'wa’ DIS',
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlh;
	
	})));


/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '\'inci',
	    5: '\'inci',
	    8: '\'inci',
	    70: '\'inci',
	    80: '\'inci',
	    2: '\'nci',
	    7: '\'nci',
	    20: '\'nci',
	    50: '\'nci',
	    3: '\'üncü',
	    4: '\'üncü',
	    100: '\'üncü',
	    6: '\'ncı',
	    9: '\'uncu',
	    10: '\'uncu',
	    30: '\'uncu',
	    60: '\'ıncı',
	    90: '\'ıncı'
	};
	
	var tr = moment.defineLocale('tr', {
	    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[yarın saat] LT',
	        nextWeek : '[haftaya] dddd [saat] LT',
	        lastDay : '[dün] LT',
	        lastWeek : '[geçen hafta] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s önce',
	        s : 'birkaç saniye',
	        m : 'bir dakika',
	        mm : '%d dakika',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir yıl',
	        yy : '%d yıl'
	    },
	    ordinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '\'ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tr;
	
	})));


/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	// This is currently too difficult (maybe even impossible) to add.
	var tzl = moment.defineLocale('tzl', {
	    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM [dallas] YYYY',
	        LLL : 'D. MMMM [dallas] YYYY HH.mm',
	        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	    },
	    meridiemParse: /d\'o|d\'a/i,
	    isPM : function (input) {
	        return 'd\'o' === input.toLowerCase();
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'd\'o' : 'D\'O';
	        } else {
	            return isLower ? 'd\'a' : 'D\'A';
	        }
	    },
	    calendar : {
	        sameDay : '[oxhi à] LT',
	        nextDay : '[demà à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[ieiri à] LT',
	        lastWeek : '[sür el] dddd [lasteu à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'osprei %s',
	        past : 'ja%s',
	        s : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['viensas secunds', '\'iensas secunds'],
	        'm': ['\'n míut', '\'iens míut'],
	        'mm': [number + ' míuts', '' + number + ' míuts'],
	        'h': ['\'n þora', '\'iensa þora'],
	        'hh': [number + ' þoras', '' + number + ' þoras'],
	        'd': ['\'n ziua', '\'iensa ziua'],
	        'dd': [number + ' ziuas', '' + number + ' ziuas'],
	        'M': ['\'n mes', '\'iens mes'],
	        'MM': [number + ' mesen', '' + number + ' mesen'],
	        'y': ['\'n ar', '\'iens ar'],
	        'yy': [number + ' ars', '' + number + ' ars']
	    };
	    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	}
	
	return tzl;
	
	})));


/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzm = moment.defineLocale('tzm', {
	    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	        nextWeek: 'dddd [ⴴ] LT',
	        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	        lastWeek: 'dddd [ⴴ] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	        past : 'ⵢⴰⵏ %s',
	        s : 'ⵉⵎⵉⴽ',
	        m : 'ⵎⵉⵏⵓⴺ',
	        mm : '%d ⵎⵉⵏⵓⴺ',
	        h : 'ⵙⴰⵄⴰ',
	        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	        d : 'ⴰⵙⵙ',
	        dd : '%d oⵙⵙⴰⵏ',
	        M : 'ⴰⵢoⵓⵔ',
	        MM : '%d ⵉⵢⵢⵉⵔⵏ',
	        y : 'ⴰⵙⴳⴰⵙ',
	        yy : '%d ⵉⵙⴳⴰⵙⵏ'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzm;
	
	})));


/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzmLatn = moment.defineLocale('tzm-latn', {
	    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[asdkh g] LT',
	        nextDay: '[aska g] LT',
	        nextWeek: 'dddd [g] LT',
	        lastDay: '[assant g] LT',
	        lastWeek: 'dddd [g] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dadkh s yan %s',
	        past : 'yan %s',
	        s : 'imik',
	        m : 'minuḍ',
	        mm : '%d minuḍ',
	        h : 'saɛa',
	        hh : '%d tassaɛin',
	        d : 'ass',
	        dd : '%d ossan',
	        M : 'ayowr',
	        MM : '%d iyyirn',
	        y : 'asgas',
	        yy : '%d isgasn'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzmLatn;
	
	})));


/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	        'dd': 'день_дні_днів',
	        'MM': 'місяць_місяці_місяців',
	        'yy': 'рік_роки_років'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвилина' : 'хвилину';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'година' : 'годину';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	function weekdaysCaseReplace(m, format) {
	    var weekdays = {
	        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	    },
	    nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	        'accusative' :
	        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	            'genitive' :
	            'nominative');
	    return weekdays[nounCase][m.day()];
	}
	function processHoursFunction(str) {
	    return function () {
	        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	    };
	}
	
	var uk = moment.defineLocale('uk', {
	    months : {
	        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	    },
	    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	    weekdays : weekdaysCaseReplace,
	    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY р.',
	        LLL : 'D MMMM YYYY р., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	    },
	    calendar : {
	        sameDay: processHoursFunction('[Сьогодні '),
	        nextDay: processHoursFunction('[Завтра '),
	        lastDay: processHoursFunction('[Вчора '),
	        nextWeek: processHoursFunction('[У] dddd ['),
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return processHoursFunction('[Минулої] dddd [').call(this);
	                case 1:
	                case 2:
	                case 4:
	                    return processHoursFunction('[Минулого] dddd [').call(this);
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past : '%s тому',
	        s : 'декілька секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'годину',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'місяць',
	        MM : relativeTimeWithPlural,
	        y : 'рік',
	        yy : relativeTimeWithPlural
	    },
	    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	    meridiemParse: /ночі|ранку|дня|вечора/,
	    isPM: function (input) {
	        return /^(дня|вечора)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночі';
	        } else if (hour < 12) {
	            return 'ранку';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечора';
	        }
	    },
	    ordinalParse: /\d{1,2}-(й|го)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uk;
	
	})));


/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uz = moment.defineLocale('uz', {
	    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бугун соат] LT [да]',
	        nextDay : '[Эртага] LT [да]',
	        nextWeek : 'dddd [куни соат] LT [да]',
	        lastDay : '[Кеча соат] LT [да]',
	        lastWeek : '[Утган] dddd [куни соат] LT [да]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Якин %s ичида',
	        past : 'Бир неча %s олдин',
	        s : 'фурсат',
	        m : 'бир дакика',
	        mm : '%d дакика',
	        h : 'бир соат',
	        hh : '%d соат',
	        d : 'бир кун',
	        dd : '%d кун',
	        M : 'бир ой',
	        MM : '%d ой',
	        y : 'бир йил',
	        yy : '%d йил'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return uz;
	
	})));


/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var vi = moment.defineLocale('vi', {
	    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /sa|ch/i,
	    isPM : function (input) {
	        return /^ch$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'sa' : 'SA';
	        } else {
	            return isLower ? 'ch' : 'CH';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM [năm] YYYY',
	        LLL : 'D MMMM [năm] YYYY HH:mm',
	        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	        l : 'DD/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hôm nay lúc] LT',
	        nextDay: '[Ngày mai lúc] LT',
	        nextWeek: 'dddd [tuần tới lúc] LT',
	        lastDay: '[Hôm qua lúc] LT',
	        lastWeek: 'dddd [tuần rồi lúc] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s tới',
	        past : '%s trước',
	        s : 'vài giây',
	        m : 'một phút',
	        mm : '%d phút',
	        h : 'một giờ',
	        hh : '%d giờ',
	        d : 'một ngày',
	        dd : '%d ngày',
	        M : 'một tháng',
	        MM : '%d tháng',
	        y : 'một năm',
	        yy : '%d năm'
	    },
	    ordinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return vi;
	
	})));


/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var xPseudo = moment.defineLocale('x-pseudo', {
	    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[T~ódá~ý át] LT',
	        nextDay : '[T~ómó~rró~w át] LT',
	        nextWeek : 'dddd [át] LT',
	        lastDay : '[Ý~ést~érdá~ý át] LT',
	        lastWeek : '[L~ást] dddd [át] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'í~ñ %s',
	        past : '%s á~gó',
	        s : 'á ~féw ~sécó~ñds',
	        m : 'á ~míñ~úté',
	        mm : '%d m~íñú~tés',
	        h : 'á~ñ hó~úr',
	        hh : '%d h~óúrs',
	        d : 'á ~dáý',
	        dd : '%d d~áýs',
	        M : 'á ~móñ~th',
	        MM : '%d m~óñt~hs',
	        y : 'á ~ýéár',
	        yy : '%d ý~éárs'
	    },
	    ordinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return xPseudo;
	
	})));


/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var yo = moment.defineLocale('yo', {
	    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Ònì ni] LT',
	        nextDay : '[Ọ̀la ni] LT',
	        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	        lastDay : '[Àna ni] LT',
	        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ní %s',
	        past : '%s kọjá',
	        s : 'ìsẹjú aayá die',
	        m : 'ìsẹjú kan',
	        mm : 'ìsẹjú %d',
	        h : 'wákati kan',
	        hh : 'wákati %d',
	        d : 'ọjọ́ kan',
	        dd : 'ọjọ́ %d',
	        M : 'osù kan',
	        MM : 'osù %d',
	        y : 'ọdún kan',
	        yy : 'ọdún %d'
	    },
	    ordinalParse : /ọjọ́\s\d{1,2}/,
	    ordinal : 'ọjọ́ %d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return yo;
	
	})));


/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhCn = moment.defineLocale('zh-cn', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'Ah点mm分',
	        LTS : 'Ah点m分s秒',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日Ah点mm分',
	        LLLL : 'YYYY年MMMD日ddddAh点mm分',
	        l : 'YYYY-MM-DD',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日Ah点mm分',
	        llll : 'YYYY年MMMD日ddddAh点mm分'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' ||
	                meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        } else {
	            // '中午'
	            return hour >= 11 ? hour : hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : function () {
	            return this.minutes() === 0 ? '[今天]Ah[点整]' : '[今天]LT';
	        },
	        nextDay : function () {
	            return this.minutes() === 0 ? '[明天]Ah[点整]' : '[明天]LT';
	        },
	        lastDay : function () {
	            return this.minutes() === 0 ? '[昨天]Ah[点整]' : '[昨天]LT';
	        },
	        nextWeek : function () {
	            var startOfWeek, prefix;
	            startOfWeek = moment().startOf('week');
	            prefix = this.diff(startOfWeek, 'days') >= 7 ? '[下]' : '[本]';
	            return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
	        },
	        lastWeek : function () {
	            var startOfWeek, prefix;
	            startOfWeek = moment().startOf('week');
	            prefix = this.unix() < startOfWeek.unix()  ? '[上]' : '[本]';
	            return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
	        },
	        sameElse : 'LL'
	    },
	    ordinalParse: /\d{1,2}(日|月|周)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            case 'M':
	                return number + '月';
	            case 'w':
	            case 'W':
	                return number + '周';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s内',
	        past : '%s前',
	        s : '几秒',
	        m : '1 分钟',
	        mm : '%d 分钟',
	        h : '1 小时',
	        hh : '%d 小时',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 个月',
	        MM : '%d 个月',
	        y : '1 年',
	        yy : '%d 年'
	    },
	    week : {
	        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return zhCn;
	
	})));


/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhHk = moment.defineLocale('zh-hk', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'Ah點mm分',
	        LTS : 'Ah點m分s秒',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日Ah點mm分',
	        LLLL : 'YYYY年MMMD日ddddAh點mm分',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日Ah點mm分',
	        llll : 'YYYY年MMMD日ddddAh點mm分'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    ordinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhHk;
	
	})));


/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(249)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhTw = moment.defineLocale('zh-tw', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'Ah點mm分',
	        LTS : 'Ah點m分s秒',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日Ah點mm分',
	        LLLL : 'YYYY年MMMD日ddddAh點mm分',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日Ah點mm分',
	        llll : 'YYYY年MMMD日ddddAh點mm分'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    ordinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhTw;
	
	})));


/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Dropdown_1 = __webpack_require__(244);
	var FacetUtils_1 = __webpack_require__(82);
	var DocumentInput_1 = __webpack_require__(361);
	var Dom_1 = __webpack_require__(57);
	var SimpleFieldInput = (function (_super) {
	    __extends(SimpleFieldInput, _super);
	    function SimpleFieldInput(inputName, fieldName, endpoint) {
	        _super.call(this, inputName);
	        this.inputName = inputName;
	        this.fieldName = fieldName;
	        this.endpoint = endpoint;
	    }
	    SimpleFieldInput.prototype.reset = function () {
	        this.dropDown.reset();
	    };
	    SimpleFieldInput.prototype.build = function () {
	        var _this = this;
	        var fieldInput = Dom_1.$$(_super.prototype.build.call(this));
	        this.buildFieldSelect().then(function () {
	            fieldInput.append(_this.dropDown.getElement());
	        });
	        this.element = fieldInput.el;
	        return this.element;
	    };
	    SimpleFieldInput.prototype.getValue = function () {
	        var value = this.dropDown ? this.dropDown.getValue() : '';
	        return value ? this.fieldName + '==\"' + value + '\"' : '';
	    };
	    SimpleFieldInput.prototype.buildFieldSelect = function () {
	        var _this = this;
	        return this.endpoint.listFieldValues({ field: this.fieldName }).then(function (values) {
	            var options = [''];
	            _.each(values, function (value) {
	                options.push(value.value);
	            });
	            _this.dropDown = new Dropdown_1.Dropdown(_this.onChange.bind(_this), options, function (str) {
	                return FacetUtils_1.FacetUtils.tryToGetTranslatedCaption(_this.fieldName, str);
	            });
	        });
	    };
	    return SimpleFieldInput;
	}(DocumentInput_1.DocumentInput));
	exports.SimpleFieldInput = SimpleFieldInput;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var Dom_1 = __webpack_require__(57);
	var AdvancedSearchEvents_1 = __webpack_require__(39);
	var DocumentInput = (function () {
	    function DocumentInput(inputName) {
	        this.inputName = inputName;
	    }
	    DocumentInput.prototype.reset = function () {
	    };
	    DocumentInput.prototype.build = function () {
	        var documentInput = Dom_1.$$('div', { className: 'coveo-advanced-search-document-input-section' });
	        var label = Dom_1.$$('span', { className: 'coveo-advanced-search-label' });
	        label.text(this.inputName);
	        documentInput.append(label.el);
	        this.element = documentInput.el;
	        return this.element;
	    };
	    DocumentInput.prototype.getValue = function () {
	        return '';
	    };
	    DocumentInput.prototype.updateQuery = function (queryBuilder) {
	        var value = this.getValue();
	        if (value) {
	            queryBuilder.advancedExpression.add(this.getValue());
	        }
	    };
	    DocumentInput.prototype.onChange = function () {
	        if (this.element) {
	            Dom_1.$$(this.element).trigger(AdvancedSearchEvents_1.AdvancedSearchEvents.executeAdvancedSearch);
	        }
	    };
	    return DocumentInput;
	}());
	exports.DocumentInput = DocumentInput;


/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Dropdown_1 = __webpack_require__(244);
	var TextInput_1 = __webpack_require__(236);
	var Dom_1 = __webpack_require__(57);
	var DocumentInput_1 = __webpack_require__(361);
	var AdvancedFieldInput = (function (_super) {
	    __extends(AdvancedFieldInput, _super);
	    function AdvancedFieldInput(inputName, fieldName) {
	        _super.call(this, inputName);
	        this.inputName = inputName;
	        this.fieldName = fieldName;
	    }
	    AdvancedFieldInput.prototype.reset = function () {
	        this.mode.reset();
	        this.input.reset();
	    };
	    AdvancedFieldInput.prototype.build = function () {
	        var fieldInput = Dom_1.$$(_super.prototype.build.call(this));
	        this.mode = new Dropdown_1.Dropdown(this.onChange.bind(this), ['Contains', 'DoesNotContain', 'Matches']);
	        fieldInput.append(this.mode.getElement());
	        this.input = new TextInput_1.TextInput(this.onChange.bind(this), '');
	        fieldInput.append(this.input.getElement());
	        this.element = fieldInput.el;
	        return this.element;
	    };
	    AdvancedFieldInput.prototype.getValue = function () {
	        var inputValue = this.input.getValue();
	        if (inputValue) {
	            switch (this.mode.getValue()) {
	                case 'Contains':
	                    return this.fieldName + '=' + inputValue;
	                case 'DoesNotContain':
	                    return this.fieldName + '<>' + inputValue;
	                default:
	                    return this.fieldName + '==\"' + inputValue + '\"';
	            }
	        }
	        return '';
	    };
	    return AdvancedFieldInput;
	}(DocumentInput_1.DocumentInput));
	exports.AdvancedFieldInput = AdvancedFieldInput;


/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Dropdown_1 = __webpack_require__(244);
	var NumericSpinner_1 = __webpack_require__(245);
	var Dom_1 = __webpack_require__(57);
	var DocumentInput_1 = __webpack_require__(361);
	var SizeInput = (function (_super) {
	    __extends(SizeInput, _super);
	    function SizeInput() {
	        _super.call(this, 'Size');
	    }
	    SizeInput.prototype.reset = function () {
	        this.modeSelect.reset();
	        this.sizeInput.reset();
	    };
	    SizeInput.prototype.build = function () {
	        var sizeInput = Dom_1.$$(_super.prototype.build.call(this));
	        var sizeInputSection = Dom_1.$$('div', { className: 'coveo-size-input-mode-section' });
	        this.modeSelect = new Dropdown_1.Dropdown(this.onChange.bind(this), SizeInput.modes);
	        this.modeSelect.setId('coveo-size-input-mode');
	        sizeInputSection.append(this.modeSelect.getElement());
	        this.sizeInput = new NumericSpinner_1.NumericSpinner(this.onChange.bind(this));
	        sizeInputSection.append(this.sizeInput.getElement());
	        this.sizeSelect = new Dropdown_1.Dropdown(this.onChange.bind(this), SizeInput.sizes);
	        this.sizeSelect.setId('coveo-size-input-select');
	        sizeInputSection.append(this.sizeSelect.getElement());
	        sizeInput.append(sizeInputSection.el);
	        this.element = sizeInput.el;
	        return this.element;
	    };
	    SizeInput.prototype.getValue = function () {
	        var size = this.getSizeInBytes();
	        if (size) {
	            switch (this.modeSelect.getValue()) {
	                case 'AtLeast':
	                    return '@size>=' + this.getSizeInBytes();
	                default:
	                    return '@size<=' + this.getSizeInBytes();
	            }
	        }
	        return '';
	    };
	    SizeInput.prototype.getSizeInBytes = function () {
	        var size = this.sizeInput.getFloatValue();
	        switch (this.sizeSelect.getValue()) {
	            case 'KB':
	                return size * 1024;
	            case 'MB':
	                return size * Math.pow(1024, 2);
	            default:
	                return size;
	        }
	    };
	    SizeInput.modes = ['AtLeast', 'AtMost'];
	    SizeInput.sizes = ['KB', 'MB', 'Bytes'];
	    return SizeInput;
	}(DocumentInput_1.DocumentInput));
	exports.SizeInput = SizeInput;


/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var Assert_1 = __webpack_require__(17);
	var SearchAlertEvents_1 = __webpack_require__(49);
	var Subscription_1 = __webpack_require__(365);
	var Initialization_1 = __webpack_require__(95);
	var Strings_1 = __webpack_require__(34);
	var Dom_1 = __webpack_require__(57);
	/**
	 * This component allows the user to follow a particular result.
	 * By following a result, the user will receive emails informing him when the result has changed.
	 * A {@link SearchAlerts} component must be present in the page for this component to work.
	 */
	var FollowItem = (function (_super) {
	    __extends(FollowItem, _super);
	    function FollowItem(element, options, bindings, result) {
	        var _this = this;
	        _super.call(this, element, FollowItem.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.bindings = bindings;
	        this.result = result;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, FollowItem, options);
	        Assert_1.Assert.exists(this.result);
	        this.container = Dom_1.$$(this.element);
	        this.text = Dom_1.$$('span');
	        this.container.append(this.text.el);
	        this.container.on('click', function () { return _this.toggleFollow(); });
	        this.bind.onRootElement(SearchAlertEvents_1.SearchAlertsEvents.searchAlertsDeleted, function (args) { return _this.handleSubscriptionDeleted(args); });
	        this.bind.onRootElement(SearchAlertEvents_1.SearchAlertsEvents.searchAlertsCreated, function (args) { return _this.handleSubscriptionCreated(args); });
	        this.container.addClass('coveo-follow-item-loading');
	        this.updateIsFollowed();
	    }
	    FollowItem.prototype.updateIsFollowed = function () {
	        var _this = this;
	        this.queryController.getEndpoint()
	            .listSubscriptions()
	            .then(function (subscriptions) {
	            if (_.isArray(subscriptions)) {
	                var subscription = _.find(subscriptions, function (subscription) {
	                    var typeConfig = subscription.typeConfig;
	                    return typeConfig && typeConfig.id != null && typeConfig.id == _this.getId();
	                });
	                if (subscription != null) {
	                    _this.setFollowed(subscription);
	                }
	                else {
	                    _this.setNotFollowed();
	                }
	            }
	            else {
	                _this.remove();
	            }
	        })
	            .catch(function () {
	            _this.remove();
	        });
	    };
	    FollowItem.prototype.setFollowed = function (subscription) {
	        this.container.removeClass('coveo-follow-item-loading');
	        this.subscription = subscription;
	        this.container.addClass('coveo-follow-item-followed');
	        this.text.text(Strings_1.l('SearchAlerts_unFollowing'));
	    };
	    FollowItem.prototype.setNotFollowed = function () {
	        this.container.removeClass('coveo-follow-item-loading');
	        this.subscription = FollowItem.buildFollowRequest(this.getId(), this.result.title, this.options);
	        this.container.removeClass('coveo-follow-item-followed');
	        this.text.text(Strings_1.l('SearchAlerts_follow'));
	    };
	    FollowItem.prototype.getText = function () {
	        return this.text.text();
	    };
	    /**
	     * Follows the result if it was not followed and stops following the result if it was followed.
	     */
	    FollowItem.prototype.toggleFollow = function () {
	        var _this = this;
	        if (!this.container.hasClass('coveo-follow-item-loading')) {
	            this.container.removeClass('coveo-follow-item-followed');
	            this.container.addClass('coveo-follow-item-loading');
	            if (this.subscription.id) {
	                this.queryController.getEndpoint()
	                    .deleteSubscription(this.subscription)
	                    .then(function () {
	                    var eventArgs = {
	                        subscription: _this.subscription,
	                        dom: _this.element
	                    };
	                    Dom_1.$$(_this.root).trigger(SearchAlertEvents_1.SearchAlertsEvents.searchAlertsDeleted, eventArgs);
	                })
	                    .catch(function () {
	                    _this.container.removeClass('coveo-follow-item-loading');
	                    var eventArgs = {
	                        dom: _this.element
	                    };
	                    Dom_1.$$(_this.root).trigger(SearchAlertEvents_1.SearchAlertsEvents.searchAlertsFail, eventArgs);
	                });
	            }
	            else {
	                this.queryController.getEndpoint().follow(this.subscription)
	                    .then(function (subscription) {
	                    var eventArgs = {
	                        subscription: subscription,
	                        dom: _this.element
	                    };
	                    Dom_1.$$(_this.root).trigger(SearchAlertEvents_1.SearchAlertsEvents.searchAlertsCreated, eventArgs);
	                })
	                    .catch(function () {
	                    _this.container.removeClass('coveo-follow-item-loading');
	                    var eventArgs = {
	                        dom: _this.element
	                    };
	                    Dom_1.$$(_this.root).trigger(SearchAlertEvents_1.SearchAlertsEvents.searchAlertsFail, eventArgs);
	                });
	            }
	        }
	    };
	    FollowItem.prototype.handleSubscriptionDeleted = function (args) {
	        if (args.subscription.type == Subscription_1.SUBSCRIPTION_TYPE.followDocument) {
	            var typeConfig = args.subscription.typeConfig;
	            if (typeConfig.id == this.getId()) {
	                this.setNotFollowed();
	            }
	        }
	    };
	    FollowItem.prototype.handleSubscriptionCreated = function (args) {
	        if (args.subscription.type == Subscription_1.SUBSCRIPTION_TYPE.followDocument) {
	            var typeConfig = args.subscription.typeConfig;
	            if (typeConfig.id == this.getId()) {
	                this.setFollowed(args.subscription);
	            }
	        }
	    };
	    FollowItem.prototype.remove = function () {
	        this.element.parentElement && this.element.parentElement.removeChild(this.element);
	    };
	    FollowItem.prototype.getId = function () {
	        return this.result.raw.sysurihash || this.result.raw.urihash;
	    };
	    FollowItem.buildFollowRequest = function (id, title, options) {
	        var typeCofig = {
	            id: id,
	            title: title
	        };
	        if (options.modifiedDateField) {
	            typeCofig.modifiedDateField = options.modifiedDateField;
	        }
	        if (options.watchedFields) {
	            typeCofig.watchedFields = options.watchedFields;
	        }
	        return {
	            type: Subscription_1.SUBSCRIPTION_TYPE.followDocument,
	            typeConfig: typeCofig,
	            name: title
	        };
	    };
	    FollowItem.ID = 'FollowItem';
	    FollowItem.fields = [
	        'urihash'
	    ];
	    /**
	     * The options for the follow item component
	     * @componentOptions
	     */
	    FollowItem.options = {
	        /**
	         * Specifies the watchedFields to use when sending the follow query request.
	         * This default value is undefined.
	         */
	        watchedFields: ComponentOptions_1.ComponentOptions.buildFieldsOption(),
	        /**
	         * Specifies the modifiedDateField to use when sending the follow query request.
	         * This default value is undefined.
	         */
	        modifiedDateField: ComponentOptions_1.ComponentOptions.buildStringOption(),
	    };
	    return FollowItem;
	}(Component_1.Component));
	exports.FollowItem = FollowItem;
	Initialization_1.Initialization.registerAutoCreateComponent(FollowItem);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 365 */
/***/ function(module, exports) {

	"use strict";
	exports.SUBSCRIPTION_TYPE = {
	    followQuery: 'followQuery',
	    followDocument: 'followDocument',
	};


/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	/// <reference path='../../../node_modules/modal-box/bin/ModalBox.d.ts' />
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var SearchAlertsMessage_1 = __webpack_require__(367);
	var SettingsEvents_1 = __webpack_require__(50);
	var QueryEvents_1 = __webpack_require__(47);
	var Assert_1 = __webpack_require__(17);
	var Querybox_1 = __webpack_require__(131);
	var Omnibox_1 = __webpack_require__(135);
	var SearchAlertEvents_1 = __webpack_require__(49);
	var Subscription_1 = __webpack_require__(365);
	var Initialization_1 = __webpack_require__(95);
	var Strings_1 = __webpack_require__(34);
	var Dom_1 = __webpack_require__(57);
	var ExternalModulesShim_1 = __webpack_require__(25);
	/**
	 * This component allows the user to manage his search alerts and to follow queries by adding menu items in the {@link Settings} component.
	 * By following queries, the user will receive emails informing him when the results of the query have changed.
	 */
	var SearchAlerts = (function (_super) {
	    __extends(SearchAlerts, _super);
	    function SearchAlerts(element, options, bindings) {
	        var _this = this;
	        _super.call(this, element, SearchAlerts.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, SearchAlerts, options);
	        if (this.options.enableMessage) {
	            this.message = new SearchAlertsMessage_1.SearchAlertsMessage(element, { closeDelay: this.options.messageCloseDelay }, this.getBindings());
	        }
	        this.bind.onRootElement(SettingsEvents_1.SettingsEvents.settingsPopulateMenu, function (args) {
	            if (_this.options.enableManagePanel) {
	                args.menuData.push({
	                    text: Strings_1.l('SearchAlerts_Panel'),
	                    className: 'coveo-subscriptions-panel',
	                    onOpen: function () { return _this.openPanel(); },
	                    onClose: function () { return _this.close(); }
	                });
	            }
	        });
	        var once = false;
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.querySuccess, function () {
	            if (!once) {
	                once = true;
	                _this.queryController.getEndpoint().listSubscriptions()
	                    .then(function () {
	                    _this.bind.onRootElement(SettingsEvents_1.SettingsEvents.settingsPopulateMenu, function (args) {
	                        if (_this.options.enableFollowQuery) {
	                            args.menuData.push({
	                                text: Strings_1.l('SearchAlerts_followQuery'),
	                                className: 'coveo-follow-query',
	                                tooltip: Strings_1.l('FollowQueryDescription'),
	                                onOpen: function () { return _this.followQuery(); },
	                                onClose: function () {
	                                }
	                            });
	                        }
	                    });
	                })
	                    .catch(function (e) {
	                    // Trap 503 error, as the listSubscription call is called on every page initialization
	                    // to check for current subscriptions. By default, the search alert service is not enabled for most organization
	                    // Don't want to pollute the console with un-needed noise and confusion
	                    if (e.status != 503) {
	                        throw e;
	                    }
	                });
	            }
	        });
	    }
	    /**
	     * Follow the last query.
	     * The user will start to receive emails when the results from that query changes.
	     */
	    SearchAlerts.prototype.followQuery = function () {
	        var _this = this;
	        var queryBuilder = this.queryController.createQueryBuilder({});
	        var request = this.buildFollowQueryRequest(queryBuilder.build(), this.options);
	        this.queryController.getEndpoint().follow(request)
	            .then(function (subscription) {
	            if (subscription) {
	                var eventArgs = {
	                    subscription: subscription,
	                    dom: _this.findQueryBoxDom()
	                };
	                Dom_1.$$(_this.root).trigger(SearchAlertEvents_1.SearchAlertsEvents.searchAlertsCreated, eventArgs);
	            }
	            else {
	                _this.triggerSearchAlertsFail();
	            }
	        })
	            .catch(function () {
	            _this.triggerSearchAlertsFail();
	        });
	    };
	    /**
	     * Opens the search alerts manage panel.
	     * This panel allows the user to stop following queries or documents.
	     * It also allows the user to change the frequency at which he will receive emails.
	     */
	    SearchAlerts.prototype.openPanel = function () {
	        var _this = this;
	        var title = Dom_1.$$('div');
	        var close = Dom_1.$$('div', {
	            className: 'coveo-subscriptions-panel-close'
	        }, Dom_1.$$('span', {
	            className: 'coveo-icon'
	        }));
	        var titleInfo = Dom_1.$$('div', {
	            className: 'coveo-subscriptions-panel-title'
	        }, Strings_1.l('SearchAlerts_Panel'));
	        title.append(close.el);
	        title.append(titleInfo.el);
	        var container = Dom_1.$$('div');
	        container.el.innerHTML = "\n      <table class='coveo-subscriptions-panel-content' cellspacing='0'>\n        <thead>\n          <tr>\n            <th class='coveo-subscriptions-panel-content-type'>" + Strings_1.l('SearchAlerts_Type') + "</th>\n            <th>" + Strings_1.l('SearchAlerts_Content') + "</th>\n            <th>" + Strings_1.l('SearchAlerts_Frequency') + "</th>\n            <th class='coveo-subscriptions-panel-content-actions'>" + Strings_1.l('SearchAlerts_Actions') + "</th>\n          </tr>\n        </thead>\n        <tbody class='coveo-subscriptions-panel-spacer'>\n          <tr>\n            <td colsspan='3'></td>\n          </tr>\n        </tbody>\n        <tbody class='coveo-subscriptions-panel-subscriptions'>\n          <tr class='coveo-subscriptions-panel-no-subscriptions'>\n            <td colsspan='3'>" + Strings_1.l('SearchAlerts_PanelNoSearchAlerts') + "</td>\n          </tr>\n        </tbody>\n      </table>";
	        return this.queryController.getEndpoint().listSubscriptions()
	            .then(function (subscriptions) {
	            _.each(subscriptions, function (subscription) {
	                _this.addSearchAlert(subscription, container);
	            });
	        })
	            .catch(function () {
	            container.el.innerHTML = '<div class=\'coveo-subscriptions-panel-fail\'>' + Strings_1.l('SearchAlerts_Fail') + '</div>';
	        })
	            .finally(function () {
	            _this.modal = ExternalModulesShim_1.ModalBox.open(container.el, {
	                titleClose: false,
	                overlayClose: true,
	                title: title.el.outerHTML,
	                className: 'coveo-subscriptions-panel'
	            });
	            Dom_1.$$(Dom_1.$$(_this.modal.modalBox).find('.coveo-subscriptions-panel-close')).on('click', function () {
	                _this.close();
	            });
	        });
	    };
	    SearchAlerts.prototype.handleSearchAlertsFail = function () {
	        this.close();
	        if (this.modal != null) {
	            this.modal.content.innerHTML = '<div class=\'coveo-subscriptions-panel-fail\'>' + Strings_1.l('SearchAlerts_Fail') + '</div>';
	        }
	    };
	    SearchAlerts.prototype.close = function () {
	        if (this.modal) {
	            this.modal.close();
	            this.modal = null;
	        }
	    };
	    SearchAlerts.prototype.addSearchAlert = function (subscription, container) {
	        var _this = this;
	        var frequencies = [
	            { value: 'monthly', label: Strings_1.l('Monthly') },
	            { value: 'daily', label: Strings_1.l('Daily') },
	            { value: 'monday', label: Strings_1.l('Monday') },
	            { value: 'tuesday', label: Strings_1.l('Tuesday') },
	            { value: 'wednesday', label: Strings_1.l('Wednesday') },
	            { value: 'thursday', label: Strings_1.l('Thursday') },
	            { value: 'friday', label: Strings_1.l('Friday') },
	            { value: 'saturday', label: Strings_1.l('Saturday') },
	            { value: 'sunday', label: Strings_1.l('Sunday') }
	        ];
	        var context;
	        if (subscription.name) {
	            context = _.escape(subscription.name);
	        }
	        else if (subscription.type == Subscription_1.SUBSCRIPTION_TYPE.followQuery) {
	            var typeConfig = subscription.typeConfig;
	            context = _.escape(typeConfig.query.q) || Strings_1.l('EmptyQuery');
	        }
	        else {
	            var typeConfig = subscription.typeConfig;
	            context = _.escape(typeConfig.title || typeConfig.id);
	        }
	        var element = Dom_1.$$('tr');
	        element.addClass('coveo-subscriptions-panel-subscription');
	        element.el.innerHTML = "\n      <td class='coveo-subscriptions-panel-content-type'>" + Strings_1.l('SearchAlerts_Type_' + subscription.type) + "</td>\n      <td>\n        <div class='coveo-subscriptions-panel-context' title='" + context + "'>\n          " + context + "\n        </div>\n      </td>\n      <td>\n        <div class='coveo-subscriptions-panel-frequency'>\n          <select>\n            " + _.map(frequencies, function (frequency) { return ("<option value='" + frequency.value + "'>" + frequency.label + "</option>"); }) + "\n          </select>\n        </div>\n      </td>\n      <td class='coveo-subscriptions-panel-content-actions'>\n        <div class='coveo-subscriptions-panel-action coveo-subscriptions-panel-action-unfollow'>" + Strings_1.l('SearchAlerts_unFollowing') + "</div>\n        <div class='coveo-subscriptions-panel-action coveo-subscriptions-panel-action-follow'>" + Strings_1.l('SearchAlerts_follow') + "</div>\n      </td>";
	        var noSearchAlerts = container.find('.coveo-subscriptions-panel-no-subscriptions');
	        element.insertBefore(noSearchAlerts);
	        var frequencyInput = element.find('.coveo-subscriptions-panel-frequency select');
	        frequencyInput.value = subscription.frequency;
	        Dom_1.$$(frequencyInput).on('change', function (event) {
	            subscription.frequency = frequencyInput.value;
	            _this.updateAndSyncSearchAlert(subscription);
	        });
	        Dom_1.$$(element.find('.coveo-subscriptions-panel-action-unfollow')).on('click', function () {
	            element.addClass('coveo-subscription-unfollowed');
	            _this.queryController.getEndpoint()
	                .deleteSubscription(subscription)
	                .then(function () {
	                delete subscription.id;
	                var eventArgs = { subscription: subscription };
	                Dom_1.$$(_this.root).trigger(SearchAlertEvents_1.SearchAlertsEvents.searchAlertsDeleted, eventArgs);
	            })
	                .catch(function () {
	                _this.handleSearchAlertsFail();
	            });
	        });
	        Dom_1.$$(element.find('.coveo-subscriptions-panel-action-follow')).on('click', function () {
	            element.removeClass('coveo-subscription-unfollowed');
	            _this.queryController.getEndpoint()
	                .follow(subscription)
	                .then(function (updatedSearchAlert) {
	                subscription.id = updatedSearchAlert.id;
	                var eventArgs = { subscription: subscription };
	                Dom_1.$$(_this.root).trigger(SearchAlertEvents_1.SearchAlertsEvents.searchAlertsCreated, eventArgs);
	            })
	                .catch(function () {
	                _this.handleSearchAlertsFail();
	            });
	        });
	    };
	    SearchAlerts.prototype.updateAndSyncSearchAlert = function (subscription) {
	        var _this = this;
	        this.queryController.getEndpoint()
	            .updateSubscription(subscription)
	            .then(function (updated) { return _.extend(subscription, updated); })
	            .catch(function () {
	            _this.handleSearchAlertsFail();
	        });
	    };
	    SearchAlerts.prototype.triggerSearchAlertsFail = function () {
	        var eventArgs = {
	            dom: this.findQueryBoxDom()
	        };
	        Dom_1.$$(this.root).trigger(SearchAlertEvents_1.SearchAlertsEvents.searchAlertsFail, eventArgs);
	    };
	    SearchAlerts.prototype.findQueryBoxDom = function () {
	        var dom;
	        var components = this.searchInterface.getComponents(Querybox_1.Querybox.ID);
	        if (components && components.length > 0) {
	            dom = _.first(components).element;
	        }
	        else {
	            var components_1 = this.searchInterface.getComponents(Omnibox_1.Omnibox.ID);
	            if (components_1 && components_1.length > 0) {
	                dom = _.first(components_1).element;
	            }
	        }
	        return dom;
	    };
	    SearchAlerts.prototype.buildFollowQueryRequest = function (query, options) {
	        var typeConfig = {
	            query: query
	        };
	        if (options.modifiedDateField) {
	            typeConfig.modifiedDateField = options.modifiedDateField;
	        }
	        return {
	            type: Subscription_1.SUBSCRIPTION_TYPE.followQuery,
	            typeConfig: typeConfig,
	            name: this.message.getFollowQueryMessage(query.q)
	        };
	    };
	    SearchAlerts.create = function (element, options, root) {
	        Assert_1.Assert.exists(element);
	        return new SearchAlerts(element, options, root);
	    };
	    SearchAlerts.ID = 'SearchAlerts';
	    /**
	     * The options for the search alerts
	     * @componentOptions
	     */
	    SearchAlerts.options = {
	        /**
	         * Specifies whether to add a menu item in the {@link Settings} component to allow the user to manage his search alerts.
	         * The default value is true.
	         */
	        enableManagePanel: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true }),
	        /**
	         * Specifies whether to add a menu item in the {@link Settings} component to allow the user to follow the last query.
	         * The default value is true.
	         */
	        enableFollowQuery: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true }),
	        /**
	         * Specifies the modifiedDateField to use when sending the follow query request.
	         * This default value is undefined.
	         */
	        modifiedDateField: ComponentOptions_1.ComponentOptions.buildStringOption(),
	        /**
	         * Specifies whether to display info and error messages when search alerts actions are performed.
	         * This default value is true.
	         */
	        enableMessage: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true }),
	        /**
	         * Specifies how long to display the search alerts messages (in ms).
	         * This default value is 3000.
	         */
	        messageCloseDelay: ComponentOptions_1.ComponentOptions.buildNumberOption({ defaultValue: 3000 }),
	    };
	    return SearchAlerts;
	}(Component_1.Component));
	exports.SearchAlerts = SearchAlerts;
	Initialization_1.Initialization.registerAutoCreateComponent(SearchAlerts);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var SearchAlertEvents_1 = __webpack_require__(49);
	var QueryEvents_1 = __webpack_require__(47);
	var Subscription_1 = __webpack_require__(365);
	var PopupUtils_1 = __webpack_require__(71);
	var Strings_1 = __webpack_require__(34);
	var Dom_1 = __webpack_require__(57);
	/**
	 * This component allows the {@link SearchAlerts} component to display messages.
	 * This component should not be included in a web page. Instead, use a {@link SearchAlerts} component and access its message attribute.
	 */
	var SearchAlertsMessage = (function (_super) {
	    __extends(SearchAlertsMessage, _super);
	    function SearchAlertsMessage(element, options, bindings) {
	        var _this = this;
	        _super.call(this, element, SearchAlertsMessage.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.bindings = bindings;
	        this.bind.onRootElement(SearchAlertEvents_1.SearchAlertsEvents.searchAlertsCreated, function (args) { return _this.handleSubscriptionCreated(args); });
	        this.bind.oneRootElement(SearchAlertEvents_1.SearchAlertsEvents.searchAlertsFail, function (args) { return _this.handleSearchAlertsFail(args); });
	        this.bind.oneRootElement(SearchAlertEvents_1.SearchAlertsEvents.searchAlertsDeleted, function () { return _this.close(); });
	        this.bind.oneRootElement(QueryEvents_1.QueryEvents.newQuery, function () { return _this.close(); });
	    }
	    SearchAlertsMessage.prototype.getCssClass = function () {
	        return 'coveo-subscriptions-messages';
	    };
	    SearchAlertsMessage.prototype.getFollowQueryMessage = function (query, htmlFormatted) {
	        if (htmlFormatted === void 0) { htmlFormatted = false; }
	        var populateMessageArguments = {
	            text: []
	        };
	        var getAdditionalTextFormatted = function () {
	            return _.map(populateMessageArguments.text, function (text) {
	                return "" + (htmlFormatted ? '<li>' : '(') + _.escape(text) + (htmlFormatted ? '</li>' : ')');
	            }).join(' ');
	        };
	        Dom_1.$$(this.root).trigger(SearchAlertEvents_1.SearchAlertsEvents.searchAlertsPopulateMessage, populateMessageArguments);
	        var additionalMessage = "" + (htmlFormatted ? '<ul>' : '') + getAdditionalTextFormatted() + (htmlFormatted ? '</ul>' : '');
	        var automaticallyBuiltMessage;
	        if (query && populateMessageArguments.text.length != 0) {
	            automaticallyBuiltMessage = _.escape(query) + " " + additionalMessage;
	        }
	        if (query && populateMessageArguments.text.length == 0) {
	            automaticallyBuiltMessage = "" + _.escape(query);
	        }
	        if (!query && populateMessageArguments.text.length != 0) {
	            automaticallyBuiltMessage = "" + additionalMessage;
	        }
	        if (!query && populateMessageArguments.text.length == 0) {
	            automaticallyBuiltMessage = htmlFormatted ? Strings_1.l('EmptyQuery') : _.unescape(Strings_1.l('EmptyQuery'));
	        }
	        return automaticallyBuiltMessage;
	    };
	    /**
	     * Displays a message near the dom attribute.
	     * @param dom Specifies where to display the message.
	     * @param message The message.
	     * @param error Specifies whether this is an error message or not.
	     */
	    SearchAlertsMessage.prototype.showMessage = function (dom, message, error) {
	        var _this = this;
	        this.message = Dom_1.$$('div');
	        this.message.el.innerHTML = "\n      <div class='coveo-subscriptions-messages-message'>\n        <div class='coveo-subscriptions-messages-info-close'></div>\n        <div class='coveo-subscriptions-messages-content' title='" + message + "'>" + message + "</div>\n      </div>";
	        this.message.toggleClass('coveo-subscriptions-messages-error', error);
	        var closeButton = this.message.find('.coveo-subscriptions-messages-info-close');
	        Dom_1.$$(closeButton).on('click', function () { return _this.close(); });
	        PopupUtils_1.PopupUtils.positionPopup(this.message.el, dom.el, this.root, {
	            horizontal: PopupUtils_1.HorizontalAlignment.INNERLEFT,
	            vertical: PopupUtils_1.VerticalAlignment.BOTTOM,
	            verticalOffset: 12,
	            horizontalClip: true
	        }, this.root);
	        this.startCloseDelay();
	        this.message.on('mouseleave', function () {
	            _this.startCloseDelay();
	        });
	        this.message.on('mouseenter', function () {
	            _this.stopCloseDelay();
	        });
	    };
	    SearchAlertsMessage.prototype.handleSubscriptionCreated = function (args) {
	        this.close();
	        if (args.dom != null) {
	            if (args.subscription.type == Subscription_1.SUBSCRIPTION_TYPE.followQuery) {
	                var typeConfig = args.subscription.typeConfig;
	                this.showMessage(Dom_1.$$(args.dom), Strings_1.l('SubscriptionsMessageFollowQuery', this.getFollowQueryMessage(typeConfig.query.q, true)), false);
	            }
	            else {
	                var typeConfig = args.subscription.typeConfig;
	                this.showMessage(Dom_1.$$(args.dom), Strings_1.l('SubscriptionsMessageFollow', _.escape(typeConfig.title)), false);
	            }
	        }
	    };
	    SearchAlertsMessage.prototype.handleSearchAlertsFail = function (args) {
	        this.close();
	        if (args.dom != null) {
	            this.showMessage(Dom_1.$$(args.dom), Strings_1.l('SearchAlerts_Fail'), true);
	        }
	    };
	    SearchAlertsMessage.prototype.startCloseDelay = function () {
	        var _this = this;
	        clearTimeout(this.closeTimeout);
	        this.closeTimeout = setTimeout(function () {
	            _this.close();
	        }, this.options.closeDelay);
	    };
	    SearchAlertsMessage.prototype.stopCloseDelay = function () {
	        clearTimeout(this.closeTimeout);
	    };
	    SearchAlertsMessage.prototype.close = function () {
	        if (this.message != null) {
	            clearTimeout(this.closeTimeout);
	            this.message.remove();
	            this.message = null;
	        }
	    };
	    SearchAlertsMessage.ID = 'SubscriptionsMessages';
	    /**
	     * The options for the SearchAlertsMessage component
	     * @componentOptions
	     */
	    SearchAlertsMessage.options = {
	        /**
	         * Specifies how long to display the search alerts messages (in ms).
	         * This default value is 3000.
	         */
	        closeDelay: ComponentOptions_1.ComponentOptions.buildNumberOption({ defaultValue: 3000 }),
	    };
	    return SearchAlertsMessage;
	}(Component_1.Component));
	exports.SearchAlertsMessage = SearchAlertsMessage;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var ComponentOptions_1 = __webpack_require__(98);
	var Component_1 = __webpack_require__(96);
	var Initialization_1 = __webpack_require__(95);
	var Dom_1 = __webpack_require__(57);
	/**
	 * This component only role is to be embedded in a result template and to output a simple text value.<br/>
	 * Thus, the only purpose is to be able to easily add different text value with the interface editor.<br/>
	 * If you are not designing a search using the interface editor, the usage of this component is not pertinent.
	 */
	var Text = (function (_super) {
	    __extends(Text, _super);
	    function Text(element, options, bindings) {
	        _super.call(this, element, Text.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, Text, options);
	        Dom_1.$$(this.element).text(this.options.value);
	        this.element.style.fontSize = this.options.size;
	        this.element.style.fontStyle = this.options.style;
	        this.element.style.fontWeight = this.options.weight;
	        this.element.style.textAlign = this.options.textAlign;
	        this.element.style.marginTop = this.options.marginTop;
	        this.element.style.marginBottom = this.options.marginBottom;
	        this.element.style.marginRight = this.options.marginRight;
	        this.element.style.marginLeft = this.options.marginLeft;
	        this.element.style.paddingTop = this.options.paddingTop;
	        this.element.style.paddingBottom = this.options.paddingBottom;
	        this.element.style.paddingLeft = this.options.paddingLeft;
	        this.element.style.paddingRight = this.options.paddingRight;
	    }
	    Text.ID = 'Text';
	    /**
	     * @componentOptions
	     */
	    Text.options = {
	        /**
	         * The localized string value that the component should render
	         */
	        value: ComponentOptions_1.ComponentOptions.buildLocalizedStringOption(),
	        /**
	         * The size of the text (set as the font-size css property)
	         */
	        size: ComponentOptions_1.ComponentOptions.buildStringOption(),
	        /**
	         * The style of the text (set as the font-style css property)
	         */
	        style: ComponentOptions_1.ComponentOptions.buildStringOption(),
	        /**
	         * The weight of the text (set as the font-weight css property)
	         */
	        weight: ComponentOptions_1.ComponentOptions.buildStringOption(),
	        /**
	         * The alignment of the text (set as the text-align css property)
	         */
	        textAlign: ComponentOptions_1.ComponentOptions.buildStringOption(),
	        /**
	         * The margin top of the text (set as the margin-top css property)
	         */
	        marginTop: ComponentOptions_1.ComponentOptions.buildStringOption(),
	        /**
	         * The margin bottom of the text (set as the margin-bottom css property)
	         */
	        marginBottom: ComponentOptions_1.ComponentOptions.buildStringOption(),
	        /**
	         * The margin left of the text (set as the margin-left css property)
	         */
	        marginLeft: ComponentOptions_1.ComponentOptions.buildStringOption(),
	        /**
	         * The margin right of the text (set as the margin-right css property)
	         */
	        marginRight: ComponentOptions_1.ComponentOptions.buildStringOption(),
	        /**
	         * The padding top of the text (set as the padding-top css property)
	         */
	        paddingTop: ComponentOptions_1.ComponentOptions.buildStringOption(),
	        /**
	         * The padding bottom of the text (set as the padding-bottom css property)
	         */
	        paddingBottom: ComponentOptions_1.ComponentOptions.buildStringOption(),
	        /**
	         * The padding left of the text (set as the padding-left css property)
	         */
	        paddingLeft: ComponentOptions_1.ComponentOptions.buildStringOption(),
	        /**
	         * The padding right of the text (set as the padding-right css property)
	         */
	        paddingRight: ComponentOptions_1.ComponentOptions.buildStringOption()
	    };
	    return Text;
	}(Component_1.Component));
	exports.Text = Text;
	Initialization_1.Initialization.registerAutoCreateComponent(Text);


/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Folding_1 = __webpack_require__(186);
	var Initialization_1 = __webpack_require__(95);
	/**
	 * This component inherits from the {@link Folding} component.
	 * Folding conversations and threads requires different processing.
	 * When you need to fold children under a parent item, use this component.<br/>
	 * <b>This component works well with Chatter and Lithium.</b>
	 */
	var FoldingForThread = (function (_super) {
	    __extends(FoldingForThread, _super);
	    /**
	     * Create a new FoldingForThread component
	     * @param element
	     * @param options
	     * @param bindings
	     */
	    function FoldingForThread(element, options, bindings) {
	        _super.call(this, element, options, bindings);
	        this.element = element;
	        this.options = options;
	        this.options.getMoreResults = function (results) {
	            return Folding_1.Folding.foldWithParent(results)[0].attachments;
	        };
	        this.options.getResult = function (result) {
	            var defaultResult = Folding_1.Folding.defaultGetResult(result);
	            defaultResult.childResults = defaultResult.attachments;
	            defaultResult.attachments = [];
	            return defaultResult;
	        };
	    }
	    FoldingForThread.ID = 'FoldingForThread';
	    return FoldingForThread;
	}(Folding_1.Folding));
	exports.FoldingForThread = FoldingForThread;
	Initialization_1.Initialization.registerAutoCreateComponent(FoldingForThread);


/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Initialization_1 = __webpack_require__(95);
	var ComponentOptions_1 = __webpack_require__(98);
	var Component_1 = __webpack_require__(96);
	var Utils_1 = __webpack_require__(18);
	var Dom_1 = __webpack_require__(57);
	var Strings_1 = __webpack_require__(34);
	var ChatterUtils_1 = __webpack_require__(371);
	var ChatterLikedBy = (function (_super) {
	    __extends(ChatterLikedBy, _super);
	    function ChatterLikedBy(element, options, bindings, result) {
	        _super.call(this, element, ChatterLikedBy.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.bindings = bindings;
	        this.result = result;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, ChatterLikedBy, options);
	        if (!Utils_1.Utils.isNullOrUndefined(result.raw.sflikedby) && !Utils_1.Utils.isNullOrUndefined(result.raw.sflikedbyid)) {
	            var likeNames = result.raw.sflikedby.split(';');
	            var likeIds = result.raw.sflikedbyid.split(';');
	            var rootElement = Dom_1.$$('div', {
	                className: 'coveo-chatter-result-box-row'
	            });
	            Dom_1.$$(element).append(rootElement.el);
	            var thumbIcon = Dom_1.$$('div', {
	                className: 'coveo-sprites-common-thumbup_inactive coveo-chatter-result-box-icon'
	            });
	            rootElement.append(thumbIcon.el);
	            var fullListElement = Dom_1.$$('div', {
	                className: 'coveo-chatter-result-likes'
	            });
	            rootElement.append(fullListElement.el);
	            this.renderLikesList(fullListElement.el, result, likeNames, likeIds, this.options.nbLikesToRender);
	        }
	    }
	    ChatterLikedBy.prototype.renderLikesList = function (element, result, likeNames, likeIds, nbLikesToRender) {
	        var _this = this;
	        var tempElement = Dom_1.$$('div');
	        for (var i = 0; i < likeIds.length - 1 && (nbLikesToRender == 0 || i < nbLikesToRender); i++) {
	            tempElement.append(this.renderLikeLink(result, likeNames[i], likeIds[i]));
	            if ((nbLikesToRender == 0 || i < nbLikesToRender - 1) && i < likeIds.length - 2) {
	                tempElement.append(Dom_1.$$('span', {}, ', ').el);
	            }
	            else if (i < likeIds.length - 1) {
	                tempElement.append(Dom_1.$$('span', {}, " " + Strings_1.l('And').toLowerCase() + " ").el);
	            }
	        }
	        if (nbLikesToRender == 0 || likeIds.length <= nbLikesToRender) {
	            tempElement.append(this.renderLikeLink(result, likeNames[likeIds.length - 1], likeIds[likeIds.length - 1]));
	        }
	        else {
	            var othersCount = likeIds.length - nbLikesToRender;
	            var clickableLink = Dom_1.$$('a');
	            clickableLink.text(" " + Strings_1.l('Others', othersCount.toString(), othersCount));
	            clickableLink.on('click', function (e) {
	                e.preventDefault();
	                Dom_1.$$(element).empty();
	                _this.renderLikesList(element, result, likeNames, likeIds, 0);
	            });
	            tempElement.append(clickableLink.el);
	        }
	        if (likeIds.length > 0) {
	            var name_1 = Dom_1.$$('span');
	            name_1.el.innerHTML = Strings_1.l('LikesThis', tempElement.el.innerHTML, likeIds.length);
	            Dom_1.$$(element).append(name_1.el);
	        }
	    };
	    ChatterLikedBy.prototype.renderLikeLink = function (result, likeName, likeId) {
	        var link = Dom_1.$$('a', {
	            href: ChatterUtils_1.ChatterUtils.buildURI(result.clickUri, result.raw.sffeeditemid, likeId)
	        });
	        link.text(likeName);
	        return link.el;
	    };
	    ChatterLikedBy.ID = 'ChatterLikedBy';
	    ChatterLikedBy.options = {
	        nbLikesToRender: ComponentOptions_1.ComponentOptions.buildNumberOption({ defaultValue: 2, min: 0 }),
	        openInPrimaryTab: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: false }),
	        openInSubTab: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true })
	    };
	    ChatterLikedBy.fields = [
	        'sflikedby',
	        'sflikedbyid',
	        'clickableuri',
	        'sffeeditemid'
	    ];
	    return ChatterLikedBy;
	}(Component_1.Component));
	exports.ChatterLikedBy = ChatterLikedBy;
	Initialization_1.Initialization.registerAutoCreateComponent(ChatterLikedBy);


/***/ },
/* 371 */
/***/ function(module, exports) {

	"use strict";
	var ChatterUtils = (function () {
	    function ChatterUtils() {
	    }
	    ChatterUtils.buildURI = function (objectURI, objectId, newObjectId) {
	        return objectURI.replace(objectId, newObjectId);
	    };
	    ChatterUtils.bindClickEventToElement = function (element, openInPrimaryTab, openInSubTab) {
	        return element;
	    };
	    return ChatterUtils;
	}());
	exports.ChatterUtils = ChatterUtils;


/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var Utils_1 = __webpack_require__(18);
	var ChatterUtils_1 = __webpack_require__(371);
	var Strings_1 = __webpack_require__(34);
	var Initialization_1 = __webpack_require__(95);
	var Dom_1 = __webpack_require__(57);
	var ChatterPostAttachment = (function (_super) {
	    __extends(ChatterPostAttachment, _super);
	    function ChatterPostAttachment(element, options, bindings, result) {
	        _super.call(this, element, ChatterPostAttachment.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.bindings = bindings;
	        this.result = result;
	        if (!Utils_1.Utils.isNullOrUndefined(result.raw.sfcontentversionid)) {
	            var rootElement = Dom_1.$$('div', {
	                className: 'coveo-chatter-result-box-row'
	            });
	            Dom_1.$$(element).append(rootElement.el);
	            var icon = Dom_1.$$('div', {
	                className: 'coveo-sprites-common-system coveo-chatter-result-box-icon'
	            });
	            rootElement.append(icon.el);
	            var linkElement = Dom_1.$$('a', {
	                href: ChatterUtils_1.ChatterUtils.buildURI(result.clickUri, result.raw.sffeeditemid, result.raw.sfcontentversionid)
	            });
	            rootElement.append(linkElement.el);
	            if (!Utils_1.Utils.isNullOrUndefined(result.raw.sfcontentfilename)) {
	                linkElement.text(result.raw.sfcontentfilename);
	            }
	            else {
	                linkElement.text(Strings_1.l('ShowAttachment'));
	            }
	        }
	    }
	    ChatterPostAttachment.ID = 'ChatterPostAttachment';
	    ChatterPostAttachment.fields = [
	        'sfcontentversionid',
	        'sffeeditemid',
	        'sfcontentfilename'
	    ];
	    return ChatterPostAttachment;
	}(Component_1.Component));
	exports.ChatterPostAttachment = ChatterPostAttachment;
	Initialization_1.Initialization.registerAutoCreateComponent(ChatterPostAttachment);


/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var ChatterUtils_1 = __webpack_require__(371);
	var Initialization_1 = __webpack_require__(95);
	var Strings_1 = __webpack_require__(34);
	var Utils_1 = __webpack_require__(18);
	var Dom_1 = __webpack_require__(57);
	var ChatterPostedBy = (function (_super) {
	    __extends(ChatterPostedBy, _super);
	    function ChatterPostedBy(element, options, bindings, result) {
	        _super.call(this, element, ChatterPostedBy.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.bindings = bindings;
	        this.result = result;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, ChatterPostedBy, options);
	        if (result.raw.sfcreatedby != null) {
	            var from = Dom_1.$$('span');
	            from.text((this.options.useFromInstead ? Strings_1.l('From') : Strings_1.l('PostedBy')) + " ");
	            Dom_1.$$(element).append(from.el);
	            Dom_1.$$(element).append(this.renderLink(result.raw.sfcreatedby, result.raw.sfcreatedbyid));
	            if (this.options.enablePostedOn && !Utils_1.Utils.isNullOrUndefined(result.raw.sfparentname) && !Utils_1.Utils.isNullOrUndefined(result.raw.sfparentid)) {
	                // Post on user's wall
	                if (!Utils_1.Utils.isNullOrUndefined(result.raw.sfuserid) && result.raw.sfuserid != result.raw.sfinsertedbyid) {
	                    var onFeed = Dom_1.$$('span');
	                    var content = " " + Strings_1.l('OnFeed', this.renderLink(result.raw.sfparentname, result.raw.sfparentid).outerHTML);
	                    onFeed.el.innerHTML = content;
	                    Dom_1.$$(element).append(onFeed.el);
	                }
	                else if (Utils_1.Utils.isNullOrUndefined(result.raw.sfuserid)) {
	                    var onUser = Dom_1.$$('span');
	                    onUser.text(" " + Strings_1.l('On').toLowerCase() + " ");
	                    Dom_1.$$(element).append(onUser.el);
	                    Dom_1.$$(element).append(this.renderLink(result.raw.sfparentname, result.raw.sfparentid));
	                }
	            }
	        }
	    }
	    ChatterPostedBy.prototype.renderLink = function (text, id) {
	        var link = Dom_1.$$('a', {
	            href: ChatterUtils_1.ChatterUtils.buildURI(this.result.clickUri, this.result.raw.sffeeditemid, id)
	        });
	        link.text(text);
	        return ChatterUtils_1.ChatterUtils.bindClickEventToElement(link.el, this.options.openInPrimaryTab, this.options.openInSubTab);
	    };
	    ChatterPostedBy.ID = 'ChatterPostedBy';
	    ChatterPostedBy.options = {
	        enablePostedOn: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true }),
	        useFromInstead: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: false }),
	        openInPrimaryTab: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: false }),
	        openInSubTab: ComponentOptions_1.ComponentOptions.buildBooleanOption({ defaultValue: true }),
	    };
	    ChatterPostedBy.fields = [
	        'sfcreatedby',
	        'sfcreatedbyid',
	        'sffeeditemid',
	        'sfuserid',
	        'sfinsertedbyid',
	        'sfparentid',
	        'sfparentname'
	    ];
	    return ChatterPostedBy;
	}(Component_1.Component));
	exports.ChatterPostedBy = ChatterPostedBy;
	Initialization_1.Initialization.registerAutoCreateComponent(ChatterPostedBy);


/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var Utils_1 = __webpack_require__(18);
	var Initialization_1 = __webpack_require__(95);
	var Dom_1 = __webpack_require__(57);
	var ChatterTopic = (function (_super) {
	    __extends(ChatterTopic, _super);
	    function ChatterTopic(element, options, bindings, result) {
	        _super.call(this, element, ChatterTopic.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.bindings = bindings;
	        this.result = result;
	        if (!Utils_1.Utils.isNullOrUndefined(result.raw.coveochatterfeedtopics)) {
	            var rootElement = Dom_1.$$('div', {
	                className: 'coveo-chatter-result-box-row'
	            });
	            var topics = result.raw.coveochatterfeedtopics.split(';');
	            var icon = Dom_1.$$('div', {
	                className: 'coveo-sprites-common-tagging_tag coveo-chatter-result-box-icon'
	            });
	            rootElement.append(icon.el);
	            for (var i = 0; i < topics.length; i++) {
	                var topic = Dom_1.$$('span');
	                topic.text(topics[i]);
	                rootElement.append(topic.el);
	                if (i < topics.length - 1) {
	                    var separator = Dom_1.$$('span');
	                    separator.text(', ');
	                    rootElement.append(separator.el);
	                }
	            }
	            Dom_1.$$(element).append(rootElement.el);
	        }
	    }
	    ChatterTopic.ID = 'ChatterTopic';
	    ChatterTopic.fields = [
	        'coveochatterfeedtopics'
	    ];
	    return ChatterTopic;
	}(Component_1.Component));
	exports.ChatterTopic = ChatterTopic;
	Initialization_1.Initialization.registerAutoCreateComponent(ChatterTopic);


/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Component_1 = __webpack_require__(96);
	var ComponentOptions_1 = __webpack_require__(98);
	var Initialization_1 = __webpack_require__(95);
	var Dom_1 = __webpack_require__(57);
	var QueryEvents_1 = __webpack_require__(47);
	/**
	 * Add a clickable Coveo logo in the interface.
	 */
	var Logo = (function (_super) {
	    __extends(Logo, _super);
	    function Logo(element, options, bindings) {
	        var _this = this;
	        _super.call(this, element, Logo.ID, bindings);
	        this.element = element;
	        this.options = options;
	        this.options = ComponentOptions_1.ComponentOptions.initComponentOptions(element, Logo, options);
	        var link = Dom_1.$$('a', {
	            className: 'coveo-powered-by coveo-footer-logo',
	            href: 'http://www.coveo.com/'
	        });
	        this.element.appendChild(link.el);
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.noResults, function () { return _this.hide(); });
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.querySuccess, function (data) {
	            if (data.results.results.length > 0) {
	                _this.show();
	            }
	            else {
	                _this.hide();
	            }
	        });
	        this.bind.onRootElement(QueryEvents_1.QueryEvents.queryError, function () { return _this.hide(); });
	    }
	    Logo.prototype.hide = function () {
	        Dom_1.$$(this.element).addClass('coveo-hidden');
	    };
	    Logo.prototype.show = function () {
	        Dom_1.$$(this.element).removeClass('coveo-hidden');
	    };
	    Logo.ID = 'Logo';
	    Logo.options = {};
	    return Logo;
	}(Component_1.Component));
	exports.Logo = Logo;
	Initialization_1.Initialization.registerAutoCreateComponent(Logo);


/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	var CoreHelpers_1 = __webpack_require__(123);
	// Webpack output a library target with a temporary name.
	// This is to allow end user to put CoveoJsSearch.Dependencie.js before or after the main CoveoJsSearch.js, without breaking
	// This code swap the current module to the "real" Coveo variable.
	function swapVar(scope) {
	    if (window['Coveo'] == undefined) {
	        window['Coveo'] = scope;
	    }
	    else {
	        _.each(_.keys(scope), function (k) {
	            window['Coveo'][k] = scope[k];
	        });
	    }
	    CoreHelpers_1.CoreHelpers.exportAllHelpersGlobally(window['Coveo']);
	    if (window['__extends'] == undefined) {
	        var __extends = function (d, b) {
	            for (var p in b) {
	                if (b.hasOwnProperty(p)) {
	                    d[p] = b[p];
	                }
	            }
	            function __() {
	                this.constructor = d;
	            }
	            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	        };
	        window['__extends'] = __extends;
	    }
	}
	exports.swapVar = swapVar;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ }
/******/ ])
});
;


// WEBPACK FOOTER //
// CoveoJsSearch.min.js